// Auto-generated HH.ru cities dictionary
// Generated: 2025-08-16T09:32:25.801Z
// Total locations: 10249

export const HH_CITIES = {
  "1": {
    "id": "1",
    "name": "Москва",
    "path": "Россия / Москва",
    "country": "Россия",
    "searchString": "москва россия / москва"
  },
  "2": {
    "id": "2",
    "name": "Санкт-Петербург",
    "path": "Россия / Санкт-Петербург",
    "country": "Россия",
    "searchString": "санкт-петербург россия / санкт-петербург"
  },
  "3": {
    "id": "3",
    "name": "Екатеринбург",
    "path": "Россия / Свердловская область / Екатеринбург",
    "country": "Россия",
    "searchString": "екатеринбург россия / свердловская область / екатеринбург"
  },
  "4": {
    "id": "4",
    "name": "Новосибирск",
    "path": "Россия / Новосибирская область / Новосибирск",
    "country": "Россия",
    "searchString": "новосибирск россия / новосибирская область / новосибирск"
  },
  "5": {
    "id": "5",
    "name": "Украина",
    "path": "Украина",
    "country": "Украина",
    "searchString": "украина украина"
  },
  "6": {
    "id": "6",
    "name": "Австралия",
    "path": "Другие регионы / Австралия",
    "country": "Другие регионы",
    "searchString": "австралия другие регионы / австралия"
  },
  "7": {
    "id": "7",
    "name": "Австрия",
    "path": "Другие регионы / Австрия",
    "country": "Другие регионы",
    "searchString": "австрия другие регионы / австрия"
  },
  "8": {
    "id": "8",
    "name": "Майкоп",
    "path": "Россия / Республика Адыгея / Майкоп",
    "country": "Россия",
    "searchString": "майкоп россия / республика адыгея / майкоп"
  },
  "9": {
    "id": "9",
    "name": "Азербайджан",
    "path": "Азербайджан",
    "country": "Азербайджан",
    "searchString": "азербайджан азербайджан"
  },
  "10": {
    "id": "10",
    "name": "Горно-Алтайск",
    "path": "Россия / Республика Алтай / Горно-Алтайск",
    "country": "Россия",
    "searchString": "горно-алтайск россия / республика алтай / горно-алтайск"
  },
  "11": {
    "id": "11",
    "name": "Барнаул",
    "path": "Россия / Алтайский край / Барнаул",
    "country": "Россия",
    "searchString": "барнаул россия / алтайский край / барнаул"
  },
  "12": {
    "id": "12",
    "name": "Благовещенск (Амурская область)",
    "path": "Россия / Амурская область / Благовещенск (Амурская область)",
    "country": "Россия",
    "searchString": "благовещенск (амурская область) россия / амурская область / благовещенск (амурская область)"
  },
  "13": {
    "id": "13",
    "name": "Армения",
    "path": "Другие регионы / Армения",
    "country": "Другие регионы",
    "searchString": "армения другие регионы / армения"
  },
  "14": {
    "id": "14",
    "name": "Архангельск",
    "path": "Россия / Архангельская область / Архангельск",
    "country": "Россия",
    "searchString": "архангельск россия / архангельская область / архангельск"
  },
  "15": {
    "id": "15",
    "name": "Астрахань",
    "path": "Россия / Астраханская область / Астрахань",
    "country": "Россия",
    "searchString": "астрахань россия / астраханская область / астрахань"
  },
  "16": {
    "id": "16",
    "name": "Беларусь",
    "path": "Беларусь",
    "country": "Беларусь",
    "searchString": "беларусь беларусь"
  },
  "17": {
    "id": "17",
    "name": "Белгород",
    "path": "Россия / Белгородская область / Белгород",
    "country": "Россия",
    "searchString": "белгород россия / белгородская область / белгород"
  },
  "18": {
    "id": "18",
    "name": "Бельгия",
    "path": "Другие регионы / Бельгия",
    "country": "Другие регионы",
    "searchString": "бельгия другие регионы / бельгия"
  },
  "19": {
    "id": "19",
    "name": "Брянск",
    "path": "Россия / Брянская область / Брянск",
    "country": "Россия",
    "searchString": "брянск россия / брянская область / брянск"
  },
  "20": {
    "id": "20",
    "name": "Улан-Удэ",
    "path": "Россия / Республика Бурятия / Улан-Удэ",
    "country": "Россия",
    "searchString": "улан-удэ россия / республика бурятия / улан-удэ"
  },
  "21": {
    "id": "21",
    "name": "Великобритания",
    "path": "Другие регионы / Великобритания",
    "country": "Другие регионы",
    "searchString": "великобритания другие регионы / великобритания"
  },
  "22": {
    "id": "22",
    "name": "Владивосток",
    "path": "Россия / Приморский край / Владивосток",
    "country": "Россия",
    "searchString": "владивосток россия / приморский край / владивосток"
  },
  "23": {
    "id": "23",
    "name": "Владимир",
    "path": "Россия / Владимирская область / Владимир",
    "country": "Россия",
    "searchString": "владимир россия / владимирская область / владимир"
  },
  "24": {
    "id": "24",
    "name": "Волгоград",
    "path": "Россия / Волгоградская область / Волгоград",
    "country": "Россия",
    "searchString": "волгоград россия / волгоградская область / волгоград"
  },
  "25": {
    "id": "25",
    "name": "Вологда",
    "path": "Россия / Вологодская область / Вологда",
    "country": "Россия",
    "searchString": "вологда россия / вологодская область / вологда"
  },
  "26": {
    "id": "26",
    "name": "Воронеж",
    "path": "Россия / Воронежская область / Воронеж",
    "country": "Россия",
    "searchString": "воронеж россия / воронежская область / воронеж"
  },
  "27": {
    "id": "27",
    "name": "Германия",
    "path": "Другие регионы / Германия",
    "country": "Другие регионы",
    "searchString": "германия другие регионы / германия"
  },
  "28": {
    "id": "28",
    "name": "Грузия",
    "path": "Грузия",
    "country": "Грузия",
    "searchString": "грузия грузия"
  },
  "29": {
    "id": "29",
    "name": "Махачкала",
    "path": "Россия / Республика Дагестан / Махачкала",
    "country": "Россия",
    "searchString": "махачкала россия / республика дагестан / махачкала"
  },
  "30": {
    "id": "30",
    "name": "Дания",
    "path": "Другие регионы / Дания",
    "country": "Другие регионы",
    "searchString": "дания другие регионы / дания"
  },
  "31": {
    "id": "31",
    "name": "Биробиджан",
    "path": "Россия / Еврейская АО / Биробиджан",
    "country": "Россия",
    "searchString": "биробиджан россия / еврейская ао / биробиджан"
  },
  "32": {
    "id": "32",
    "name": "Иваново (Ивановская область)",
    "path": "Россия / Ивановская область / Иваново (Ивановская область)",
    "country": "Россия",
    "searchString": "иваново (ивановская область) россия / ивановская область / иваново (ивановская область)"
  },
  "33": {
    "id": "33",
    "name": "Израиль",
    "path": "Другие регионы / Израиль",
    "country": "Другие регионы",
    "searchString": "израиль другие регионы / израиль"
  },
  "34": {
    "id": "34",
    "name": "Магас",
    "path": "Россия / Республика Ингушетия / Магас",
    "country": "Россия",
    "searchString": "магас россия / республика ингушетия / магас"
  },
  "35": {
    "id": "35",
    "name": "Иркутск",
    "path": "Россия / Иркутская область / Иркутск",
    "country": "Россия",
    "searchString": "иркутск россия / иркутская область / иркутск"
  },
  "36": {
    "id": "36",
    "name": "Ирландия",
    "path": "Другие регионы / Ирландия",
    "country": "Другие регионы",
    "searchString": "ирландия другие регионы / ирландия"
  },
  "37": {
    "id": "37",
    "name": "Испания",
    "path": "Другие регионы / Испания",
    "country": "Другие регионы",
    "searchString": "испания другие регионы / испания"
  },
  "38": {
    "id": "38",
    "name": "Италия",
    "path": "Другие регионы / Италия",
    "country": "Другие регионы",
    "searchString": "италия другие регионы / италия"
  },
  "39": {
    "id": "39",
    "name": "Нальчик",
    "path": "Россия / Кабардино-Балкарская республика / Нальчик",
    "country": "Россия",
    "searchString": "нальчик россия / кабардино-балкарская республика / нальчик"
  },
  "40": {
    "id": "40",
    "name": "Казахстан",
    "path": "Казахстан",
    "country": "Казахстан",
    "searchString": "казахстан казахстан"
  },
  "41": {
    "id": "41",
    "name": "Калининград",
    "path": "Россия / Калининградская область / Калининград",
    "country": "Россия",
    "searchString": "калининград россия / калининградская область / калининград"
  },
  "42": {
    "id": "42",
    "name": "Элиста",
    "path": "Россия / Республика Калмыкия / Элиста",
    "country": "Россия",
    "searchString": "элиста россия / республика калмыкия / элиста"
  },
  "43": {
    "id": "43",
    "name": "Калуга",
    "path": "Россия / Калужская область / Калуга",
    "country": "Россия",
    "searchString": "калуга россия / калужская область / калуга"
  },
  "44": {
    "id": "44",
    "name": "Петропавловск-Камчатский",
    "path": "Россия / Камчатский край / Петропавловск-Камчатский",
    "country": "Россия",
    "searchString": "петропавловск-камчатский россия / камчатский край / петропавловск-камчатский"
  },
  "45": {
    "id": "45",
    "name": "Канада",
    "path": "Другие регионы / Канада",
    "country": "Другие регионы",
    "searchString": "канада другие регионы / канада"
  },
  "46": {
    "id": "46",
    "name": "Черкесск",
    "path": "Россия / Карачаево-Черкесская Республика / Черкесск",
    "country": "Россия",
    "searchString": "черкесск россия / карачаево-черкесская республика / черкесск"
  },
  "47": {
    "id": "47",
    "name": "Кемерово",
    "path": "Россия / Кемеровская область / Кемерово",
    "country": "Россия",
    "searchString": "кемерово россия / кемеровская область / кемерово"
  },
  "48": {
    "id": "48",
    "name": "Кыргызстан",
    "path": "Кыргызстан",
    "country": "Кыргызстан",
    "searchString": "кыргызстан кыргызстан"
  },
  "49": {
    "id": "49",
    "name": "Киров (Кировская область)",
    "path": "Россия / Кировская область / Киров (Кировская область)",
    "country": "Россия",
    "searchString": "киров (кировская область) россия / кировская область / киров (кировская область)"
  },
  "50": {
    "id": "50",
    "name": "Китай",
    "path": "Другие регионы / Китай",
    "country": "Другие регионы",
    "searchString": "китай другие регионы / китай"
  },
  "51": {
    "id": "51",
    "name": "Сыктывкар",
    "path": "Россия / Республика Коми / Сыктывкар",
    "country": "Россия",
    "searchString": "сыктывкар россия / республика коми / сыктывкар"
  },
  "52": {
    "id": "52",
    "name": "Кострома",
    "path": "Россия / Костромская область / Кострома",
    "country": "Россия",
    "searchString": "кострома россия / костромская область / кострома"
  },
  "53": {
    "id": "53",
    "name": "Краснодар",
    "path": "Россия / Краснодарский край / Краснодар",
    "country": "Россия",
    "searchString": "краснодар россия / краснодарский край / краснодар"
  },
  "54": {
    "id": "54",
    "name": "Красноярск",
    "path": "Россия / Красноярский край / Красноярск",
    "country": "Россия",
    "searchString": "красноярск россия / красноярский край / красноярск"
  },
  "55": {
    "id": "55",
    "name": "Курган",
    "path": "Россия / Курганская область / Курган",
    "country": "Россия",
    "searchString": "курган россия / курганская область / курган"
  },
  "56": {
    "id": "56",
    "name": "Курск",
    "path": "Россия / Курская область / Курск",
    "country": "Россия",
    "searchString": "курск россия / курская область / курск"
  },
  "57": {
    "id": "57",
    "name": "Латвия",
    "path": "Другие регионы / Латвия",
    "country": "Другие регионы",
    "searchString": "латвия другие регионы / латвия"
  },
  "58": {
    "id": "58",
    "name": "Липецк",
    "path": "Россия / Липецкая область / Липецк",
    "country": "Россия",
    "searchString": "липецк россия / липецкая область / липецк"
  },
  "59": {
    "id": "59",
    "name": "Литва",
    "path": "Другие регионы / Литва",
    "country": "Другие регионы",
    "searchString": "литва другие регионы / литва"
  },
  "60": {
    "id": "60",
    "name": "Магадан",
    "path": "Россия / Магаданская область / Магадан",
    "country": "Россия",
    "searchString": "магадан россия / магаданская область / магадан"
  },
  "61": {
    "id": "61",
    "name": "Йошкар-Ола",
    "path": "Россия / Республика Марий Эл / Йошкар-Ола",
    "country": "Россия",
    "searchString": "йошкар-ола россия / республика марий эл / йошкар-ола"
  },
  "62": {
    "id": "62",
    "name": "Молдова",
    "path": "Другие регионы / Молдова",
    "country": "Другие регионы",
    "searchString": "молдова другие регионы / молдова"
  },
  "63": {
    "id": "63",
    "name": "Саранск",
    "path": "Россия / Республика Мордовия / Саранск",
    "country": "Россия",
    "searchString": "саранск россия / республика мордовия / саранск"
  },
  "64": {
    "id": "64",
    "name": "Мурманск",
    "path": "Россия / Мурманская область / Мурманск",
    "country": "Россия",
    "searchString": "мурманск россия / мурманская область / мурманск"
  },
  "65": {
    "id": "65",
    "name": "Нидерланды",
    "path": "Другие регионы / Нидерланды",
    "country": "Другие регионы",
    "searchString": "нидерланды другие регионы / нидерланды"
  },
  "66": {
    "id": "66",
    "name": "Нижний Новгород",
    "path": "Россия / Нижегородская область / Нижний Новгород",
    "country": "Россия",
    "searchString": "нижний новгород россия / нижегородская область / нижний новгород"
  },
  "67": {
    "id": "67",
    "name": "Великий Новгород",
    "path": "Россия / Новгородская область / Великий Новгород",
    "country": "Россия",
    "searchString": "великий новгород россия / новгородская область / великий новгород"
  },
  "68": {
    "id": "68",
    "name": "Омск",
    "path": "Россия / Омская область / Омск",
    "country": "Россия",
    "searchString": "омск россия / омская область / омск"
  },
  "69": {
    "id": "69",
    "name": "Орел",
    "path": "Россия / Орловская область / Орел",
    "country": "Россия",
    "searchString": "орел россия / орловская область / орел"
  },
  "70": {
    "id": "70",
    "name": "Оренбург",
    "path": "Россия / Оренбургская область / Оренбург",
    "country": "Россия",
    "searchString": "оренбург россия / оренбургская область / оренбург"
  },
  "71": {
    "id": "71",
    "name": "Пенза",
    "path": "Россия / Пензенская область / Пенза",
    "country": "Россия",
    "searchString": "пенза россия / пензенская область / пенза"
  },
  "72": {
    "id": "72",
    "name": "Пермь",
    "path": "Россия / Пермский край / Пермь",
    "country": "Россия",
    "searchString": "пермь россия / пермский край / пермь"
  },
  "73": {
    "id": "73",
    "name": "Петрозаводск",
    "path": "Россия / Республика Карелия / Петрозаводск",
    "country": "Россия",
    "searchString": "петрозаводск россия / республика карелия / петрозаводск"
  },
  "74": {
    "id": "74",
    "name": "Польша",
    "path": "Другие регионы / Польша",
    "country": "Другие регионы",
    "searchString": "польша другие регионы / польша"
  },
  "75": {
    "id": "75",
    "name": "Псков",
    "path": "Россия / Псковская область / Псков",
    "country": "Россия",
    "searchString": "псков россия / псковская область / псков"
  },
  "76": {
    "id": "76",
    "name": "Ростов-на-Дону",
    "path": "Россия / Ростовская область / Ростов-на-Дону",
    "country": "Россия",
    "searchString": "ростов-на-дону россия / ростовская область / ростов-на-дону"
  },
  "77": {
    "id": "77",
    "name": "Рязань",
    "path": "Россия / Рязанская область / Рязань",
    "country": "Россия",
    "searchString": "рязань россия / рязанская область / рязань"
  },
  "78": {
    "id": "78",
    "name": "Самара",
    "path": "Россия / Самарская область / Самара",
    "country": "Россия",
    "searchString": "самара россия / самарская область / самара"
  },
  "79": {
    "id": "79",
    "name": "Саратов",
    "path": "Россия / Саратовская область / Саратов",
    "country": "Россия",
    "searchString": "саратов россия / саратовская область / саратов"
  },
  "80": {
    "id": "80",
    "name": "Якутск",
    "path": "Россия / Республика Саха (Якутия) / Якутск",
    "country": "Россия",
    "searchString": "якутск россия / республика саха (якутия) / якутск"
  },
  "81": {
    "id": "81",
    "name": "Южно-Сахалинск",
    "path": "Россия / Сахалинская область / Южно-Сахалинск",
    "country": "Россия",
    "searchString": "южно-сахалинск россия / сахалинская область / южно-сахалинск"
  },
  "82": {
    "id": "82",
    "name": "Владикавказ",
    "path": "Россия / Республика Северная Осетия-Алания / Владикавказ",
    "country": "Россия",
    "searchString": "владикавказ россия / республика северная осетия-алания / владикавказ"
  },
  "83": {
    "id": "83",
    "name": "Смоленск",
    "path": "Россия / Смоленская область / Смоленск",
    "country": "Россия",
    "searchString": "смоленск россия / смоленская область / смоленск"
  },
  "84": {
    "id": "84",
    "name": "Ставрополь",
    "path": "Россия / Ставропольский край / Ставрополь",
    "country": "Россия",
    "searchString": "ставрополь россия / ставропольский край / ставрополь"
  },
  "85": {
    "id": "85",
    "name": "США",
    "path": "Другие регионы / США",
    "country": "Другие регионы",
    "searchString": "сша другие регионы / сша"
  },
  "86": {
    "id": "86",
    "name": "Таджикистан",
    "path": "Другие регионы / Таджикистан",
    "country": "Другие регионы",
    "searchString": "таджикистан другие регионы / таджикистан"
  },
  "87": {
    "id": "87",
    "name": "Тамбов",
    "path": "Россия / Тамбовская область / Тамбов",
    "country": "Россия",
    "searchString": "тамбов россия / тамбовская область / тамбов"
  },
  "88": {
    "id": "88",
    "name": "Казань",
    "path": "Россия / Республика Татарстан / Казань",
    "country": "Россия",
    "searchString": "казань россия / республика татарстан / казань"
  },
  "89": {
    "id": "89",
    "name": "Тверь",
    "path": "Россия / Тверская область / Тверь",
    "country": "Россия",
    "searchString": "тверь россия / тверская область / тверь"
  },
  "90": {
    "id": "90",
    "name": "Томск",
    "path": "Россия / Томская область / Томск",
    "country": "Россия",
    "searchString": "томск россия / томская область / томск"
  },
  "91": {
    "id": "91",
    "name": "Кызыл",
    "path": "Россия / Республика Тыва / Кызыл",
    "country": "Россия",
    "searchString": "кызыл россия / республика тыва / кызыл"
  },
  "92": {
    "id": "92",
    "name": "Тула",
    "path": "Россия / Тульская область / Тула",
    "country": "Россия",
    "searchString": "тула россия / тульская область / тула"
  },
  "93": {
    "id": "93",
    "name": "Туркменистан",
    "path": "Другие регионы / Туркменистан",
    "country": "Другие регионы",
    "searchString": "туркменистан другие регионы / туркменистан"
  },
  "94": {
    "id": "94",
    "name": "Турция",
    "path": "Другие регионы / Турция",
    "country": "Другие регионы",
    "searchString": "турция другие регионы / турция"
  },
  "95": {
    "id": "95",
    "name": "Тюмень",
    "path": "Россия / Тюменская область / Тюмень",
    "country": "Россия",
    "searchString": "тюмень россия / тюменская область / тюмень"
  },
  "96": {
    "id": "96",
    "name": "Ижевск",
    "path": "Россия / Удмуртская Республика / Ижевск",
    "country": "Россия",
    "searchString": "ижевск россия / удмуртская республика / ижевск"
  },
  "97": {
    "id": "97",
    "name": "Узбекистан",
    "path": "Узбекистан",
    "country": "Узбекистан",
    "searchString": "узбекистан узбекистан"
  },
  "98": {
    "id": "98",
    "name": "Ульяновск",
    "path": "Россия / Ульяновская область / Ульяновск",
    "country": "Россия",
    "searchString": "ульяновск россия / ульяновская область / ульяновск"
  },
  "99": {
    "id": "99",
    "name": "Уфа",
    "path": "Россия / Республика Башкортостан / Уфа",
    "country": "Россия",
    "searchString": "уфа россия / республика башкортостан / уфа"
  },
  "100": {
    "id": "100",
    "name": "Финляндия",
    "path": "Другие регионы / Финляндия",
    "country": "Другие регионы",
    "searchString": "финляндия другие регионы / финляндия"
  },
  "101": {
    "id": "101",
    "name": "Франция",
    "path": "Другие регионы / Франция",
    "country": "Другие регионы",
    "searchString": "франция другие регионы / франция"
  },
  "102": {
    "id": "102",
    "name": "Хабаровск",
    "path": "Россия / Хабаровский край / Хабаровск",
    "country": "Россия",
    "searchString": "хабаровск россия / хабаровский край / хабаровск"
  },
  "103": {
    "id": "103",
    "name": "Абакан",
    "path": "Россия / Республика Хакасия / Абакан",
    "country": "Россия",
    "searchString": "абакан россия / республика хакасия / абакан"
  },
  "104": {
    "id": "104",
    "name": "Челябинск",
    "path": "Россия / Челябинская область / Челябинск",
    "country": "Россия",
    "searchString": "челябинск россия / челябинская область / челябинск"
  },
  "105": {
    "id": "105",
    "name": "Грозный",
    "path": "Россия / Чеченская республика / Грозный",
    "country": "Россия",
    "searchString": "грозный россия / чеченская республика / грозный"
  },
  "106": {
    "id": "106",
    "name": "Чита",
    "path": "Россия / Забайкальский край / Чита",
    "country": "Россия",
    "searchString": "чита россия / забайкальский край / чита"
  },
  "107": {
    "id": "107",
    "name": "Чебоксары",
    "path": "Россия / Чувашская Республика / Чебоксары",
    "country": "Россия",
    "searchString": "чебоксары россия / чувашская республика / чебоксары"
  },
  "108": {
    "id": "108",
    "name": "Швейцария",
    "path": "Другие регионы / Швейцария",
    "country": "Другие регионы",
    "searchString": "швейцария другие регионы / швейцария"
  },
  "109": {
    "id": "109",
    "name": "Эстония",
    "path": "Другие регионы / Эстония",
    "country": "Другие регионы",
    "searchString": "эстония другие регионы / эстония"
  },
  "110": {
    "id": "110",
    "name": "Южная Корея",
    "path": "Другие регионы / Южная Корея",
    "country": "Другие регионы",
    "searchString": "южная корея другие регионы / южная корея"
  },
  "111": {
    "id": "111",
    "name": "Япония",
    "path": "Другие регионы / Япония",
    "country": "Другие регионы",
    "searchString": "япония другие регионы / япония"
  },
  "112": {
    "id": "112",
    "name": "Ярославль",
    "path": "Россия / Ярославская область / Ярославль",
    "country": "Россия",
    "searchString": "ярославль россия / ярославская область / ярославль"
  },
  "113": {
    "id": "113",
    "name": "Россия",
    "path": "Россия",
    "country": "Россия",
    "searchString": "россия россия"
  },
  "114": {
    "id": "114",
    "name": "Венгрия",
    "path": "Другие регионы / Венгрия",
    "country": "Другие регионы",
    "searchString": "венгрия другие регионы / венгрия"
  },
  "115": {
    "id": "115",
    "name": "Киев",
    "path": "Украина / Киев",
    "country": "Украина",
    "searchString": "киев украина / киев"
  },
  "116": {
    "id": "116",
    "name": "Винница",
    "path": "Украина / Винницкая область / Винница",
    "country": "Украина",
    "searchString": "винница украина / винницкая область / винница"
  },
  "117": {
    "id": "117",
    "name": "Днепр (Днепропетровск)",
    "path": "Украина / Днепропетровская область / Днепр (Днепропетровск)",
    "country": "Украина",
    "searchString": "днепр (днепропетровск) украина / днепропетровская область / днепр (днепропетровск)"
  },
  "118": {
    "id": "118",
    "name": "Донецк",
    "path": "Россия / Донецкая Народная Республика / Донецк",
    "country": "Россия",
    "searchString": "донецк россия / донецкая народная республика / донецк"
  },
  "119": {
    "id": "119",
    "name": "Житомир",
    "path": "Украина / Житомирская область / Житомир",
    "country": "Украина",
    "searchString": "житомир украина / житомирская область / житомир"
  },
  "120": {
    "id": "120",
    "name": "Запорожье",
    "path": "Россия / Запорожская область / Запорожье",
    "country": "Россия",
    "searchString": "запорожье россия / запорожская область / запорожье"
  },
  "121": {
    "id": "121",
    "name": "Ивано-Франковск",
    "path": "Украина / Ивано-Франковская область / Ивано-Франковск",
    "country": "Украина",
    "searchString": "ивано-франковск украина / ивано-франковская область / ивано-франковск"
  },
  "122": {
    "id": "122",
    "name": "Кировоград",
    "path": "Украина / Кировоградская область / Кировоград",
    "country": "Украина",
    "searchString": "кировоград украина / кировоградская область / кировоград"
  },
  "123": {
    "id": "123",
    "name": "Луганск",
    "path": "Россия / Луганская Народная Республика / Луганск",
    "country": "Россия",
    "searchString": "луганск россия / луганская народная республика / луганск"
  },
  "124": {
    "id": "124",
    "name": "Луцк",
    "path": "Украина / Волынская область / Луцк",
    "country": "Украина",
    "searchString": "луцк украина / волынская область / луцк"
  },
  "125": {
    "id": "125",
    "name": "Львов",
    "path": "Украина / Львовская область / Львов",
    "country": "Украина",
    "searchString": "львов украина / львовская область / львов"
  },
  "126": {
    "id": "126",
    "name": "Николаев",
    "path": "Украина / Николаевская область / Николаев",
    "country": "Украина",
    "searchString": "николаев украина / николаевская область / николаев"
  },
  "127": {
    "id": "127",
    "name": "Одесса",
    "path": "Украина / Одесская область / Одесса",
    "country": "Украина",
    "searchString": "одесса украина / одесская область / одесса"
  },
  "128": {
    "id": "128",
    "name": "Полтава",
    "path": "Украина / Полтавская область / Полтава",
    "country": "Украина",
    "searchString": "полтава украина / полтавская область / полтава"
  },
  "129": {
    "id": "129",
    "name": "Ровно",
    "path": "Украина / Ровненская область / Ровно",
    "country": "Украина",
    "searchString": "ровно украина / ровненская область / ровно"
  },
  "130": {
    "id": "130",
    "name": "Севастополь",
    "path": "Россия / Республика Крым / Севастополь",
    "country": "Россия",
    "searchString": "севастополь россия / республика крым / севастополь"
  },
  "131": {
    "id": "131",
    "name": "Симферополь",
    "path": "Россия / Республика Крым / Симферополь",
    "country": "Россия",
    "searchString": "симферополь россия / республика крым / симферополь"
  },
  "132": {
    "id": "132",
    "name": "Сумы",
    "path": "Украина / Сумская область / Сумы",
    "country": "Украина",
    "searchString": "сумы украина / сумская область / сумы"
  },
  "133": {
    "id": "133",
    "name": "Тернополь",
    "path": "Украина / Тернопольская область / Тернополь",
    "country": "Украина",
    "searchString": "тернополь украина / тернопольская область / тернополь"
  },
  "134": {
    "id": "134",
    "name": "Ужгород",
    "path": "Украина / Закарпатская область / Ужгород",
    "country": "Украина",
    "searchString": "ужгород украина / закарпатская область / ужгород"
  },
  "135": {
    "id": "135",
    "name": "Харьков",
    "path": "Украина / Харьковская область / Харьков",
    "country": "Украина",
    "searchString": "харьков украина / харьковская область / харьков"
  },
  "136": {
    "id": "136",
    "name": "Херсон",
    "path": "Россия / Херсонская область / Херсон",
    "country": "Россия",
    "searchString": "херсон россия / херсонская область / херсон"
  },
  "137": {
    "id": "137",
    "name": "Хмельницкий",
    "path": "Украина / Хмельницкая область / Хмельницкий",
    "country": "Украина",
    "searchString": "хмельницкий украина / хмельницкая область / хмельницкий"
  },
  "138": {
    "id": "138",
    "name": "Черкассы",
    "path": "Украина / Черкасская область / Черкассы",
    "country": "Украина",
    "searchString": "черкассы украина / черкасская область / черкассы"
  },
  "139": {
    "id": "139",
    "name": "Черновцы",
    "path": "Украина / Черновицкая область / Черновцы",
    "country": "Украина",
    "searchString": "черновцы украина / черновицкая область / черновцы"
  },
  "140": {
    "id": "140",
    "name": "Чернигов",
    "path": "Украина / Черниговская область / Чернигов",
    "country": "Украина",
    "searchString": "чернигов украина / черниговская область / чернигов"
  },
  "144": {
    "id": "144",
    "name": "Автополигон (Дмитровский городской округ, Московская область)",
    "path": "Россия / Московская область / Автополигон (Дмитровский городской округ, Московская область)",
    "country": "Россия",
    "searchString": "автополигон (дмитровский городской округ, московская область) россия / московская область / автополигон (дмитровский городской округ, московская область)"
  },
  "145": {
    "id": "145",
    "name": "Ленинградская область",
    "path": "Россия / Ленинградская область",
    "country": "Россия",
    "searchString": "ленинградская область россия / ленинградская область"
  },
  "146": {
    "id": "146",
    "name": "Сербия",
    "path": "Другие регионы / Сербия",
    "country": "Другие регионы",
    "searchString": "сербия другие регионы / сербия"
  },
  "147": {
    "id": "147",
    "name": "Ханты-Мансийск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Ханты-Мансийск",
    "country": "Россия",
    "searchString": "ханты-мансийск россия / ханты-мансийский ао - югра / ханты-мансийск"
  },
  "148": {
    "id": "148",
    "name": "Тайвань",
    "path": "Другие регионы / Тайвань",
    "country": "Другие регионы",
    "searchString": "тайвань другие регионы / тайвань"
  },
  "149": {
    "id": "149",
    "name": "Швеция",
    "path": "Другие регионы / Швеция",
    "country": "Другие регионы",
    "searchString": "швеция другие регионы / швеция"
  },
  "150": {
    "id": "150",
    "name": "Аксай (Казахстан)",
    "path": "Казахстан / Аксай (Казахстан)",
    "country": "Казахстан",
    "searchString": "аксай (казахстан) казахстан / аксай (казахстан)"
  },
  "151": {
    "id": "151",
    "name": "Аксу (Павлодар.обл)",
    "path": "Казахстан / Аксу (Павлодар.обл)",
    "country": "Казахстан",
    "searchString": "аксу (павлодар.обл) казахстан / аксу (павлодар.обл)"
  },
  "152": {
    "id": "152",
    "name": "Актау",
    "path": "Казахстан / Актау",
    "country": "Казахстан",
    "searchString": "актау казахстан / актау"
  },
  "153": {
    "id": "153",
    "name": "Атырау",
    "path": "Казахстан / Атырау",
    "country": "Казахстан",
    "searchString": "атырау казахстан / атырау"
  },
  "154": {
    "id": "154",
    "name": "Актобе",
    "path": "Казахстан / Актобе",
    "country": "Казахстан",
    "searchString": "актобе казахстан / актобе"
  },
  "155": {
    "id": "155",
    "name": "Арысь (ЮКО)",
    "path": "Казахстан / Арысь (ЮКО)",
    "country": "Казахстан",
    "searchString": "арысь (юко) казахстан / арысь (юко)"
  },
  "156": {
    "id": "156",
    "name": "Алга (Актюбинская обл)",
    "path": "Казахстан / Алга (Актюбинская обл)",
    "country": "Казахстан",
    "searchString": "алга (актюбинская обл) казахстан / алга (актюбинская обл)"
  },
  "157": {
    "id": "157",
    "name": "Аягоз (ВКО)",
    "path": "Казахстан / Аягоз (ВКО)",
    "country": "Казахстан",
    "searchString": "аягоз (вко) казахстан / аягоз (вко)"
  },
  "158": {
    "id": "158",
    "name": "Аральск",
    "path": "Казахстан / Аральск",
    "country": "Казахстан",
    "searchString": "аральск казахстан / аральск"
  },
  "159": {
    "id": "159",
    "name": "Астана",
    "path": "Казахстан / Астана",
    "country": "Казахстан",
    "searchString": "астана казахстан / астана"
  },
  "160": {
    "id": "160",
    "name": "Алматы",
    "path": "Казахстан / Алматы",
    "country": "Казахстан",
    "searchString": "алматы казахстан / алматы"
  },
  "161": {
    "id": "161",
    "name": "Аркалык",
    "path": "Казахстан / Аркалык",
    "country": "Казахстан",
    "searchString": "аркалык казахстан / аркалык"
  },
  "162": {
    "id": "162",
    "name": "Баутино",
    "path": "Казахстан / Баутино",
    "country": "Казахстан",
    "searchString": "баутино казахстан / баутино"
  },
  "163": {
    "id": "163",
    "name": "Бейнеу (Мангистауская обл)",
    "path": "Казахстан / Бейнеу (Мангистауская обл)",
    "country": "Казахстан",
    "searchString": "бейнеу (мангистауская обл) казахстан / бейнеу (мангистауская обл)"
  },
  "164": {
    "id": "164",
    "name": "Балхаш",
    "path": "Казахстан / Балхаш",
    "country": "Казахстан",
    "searchString": "балхаш казахстан / балхаш"
  },
  "165": {
    "id": "165",
    "name": "Ерейментау (Акмол.обл)",
    "path": "Казахстан / Ерейментау (Акмол.обл)",
    "country": "Казахстан",
    "searchString": "ерейментау (акмол.обл) казахстан / ерейментау (акмол.обл)"
  },
  "166": {
    "id": "166",
    "name": "Жезказган",
    "path": "Казахстан / Жезказган",
    "country": "Казахстан",
    "searchString": "жезказган казахстан / жезказган"
  },
  "167": {
    "id": "167",
    "name": "Жанатас",
    "path": "Казахстан / Жанатас",
    "country": "Казахстан",
    "searchString": "жанатас казахстан / жанатас"
  },
  "168": {
    "id": "168",
    "name": "Зайсан",
    "path": "Казахстан / Зайсан",
    "country": "Казахстан",
    "searchString": "зайсан казахстан / зайсан"
  },
  "169": {
    "id": "169",
    "name": "Алтай (Зыряновск)",
    "path": "Казахстан / Алтай (Зыряновск)",
    "country": "Казахстан",
    "searchString": "алтай (зыряновск) казахстан / алтай (зыряновск)"
  },
  "171": {
    "id": "171",
    "name": "Конаев",
    "path": "Казахстан / Конаев",
    "country": "Казахстан",
    "searchString": "конаев казахстан / конаев"
  },
  "172": {
    "id": "172",
    "name": "Костанай",
    "path": "Казахстан / Костанай",
    "country": "Казахстан",
    "searchString": "костанай казахстан / костанай"
  },
  "173": {
    "id": "173",
    "name": "Кентау (ЮКО)",
    "path": "Казахстан / Кентау (ЮКО)",
    "country": "Казахстан",
    "searchString": "кентау (юко) казахстан / кентау (юко)"
  },
  "174": {
    "id": "174",
    "name": "Кызылорда",
    "path": "Казахстан / Кызылорда",
    "country": "Казахстан",
    "searchString": "кызылорда казахстан / кызылорда"
  },
  "175": {
    "id": "175",
    "name": "Казалы (Кызылорд. обл)",
    "path": "Казахстан / Казалы (Кызылорд. обл)",
    "country": "Казахстан",
    "searchString": "казалы (кызылорд. обл) казахстан / казалы (кызылорд. обл)"
  },
  "176": {
    "id": "176",
    "name": "Кокшетау",
    "path": "Казахстан / Кокшетау",
    "country": "Казахстан",
    "searchString": "кокшетау казахстан / кокшетау"
  },
  "177": {
    "id": "177",
    "name": "Караганда",
    "path": "Казахстан / Караганда",
    "country": "Казахстан",
    "searchString": "караганда казахстан / караганда"
  },
  "178": {
    "id": "178",
    "name": "Каратау",
    "path": "Казахстан / Каратау",
    "country": "Казахстан",
    "searchString": "каратау казахстан / каратау"
  },
  "179": {
    "id": "179",
    "name": "Ленгер (ЮКО)",
    "path": "Казахстан / Ленгер (ЮКО)",
    "country": "Казахстан",
    "searchString": "ленгер (юко) казахстан / ленгер (юко)"
  },
  "180": {
    "id": "180",
    "name": "Петропавловск",
    "path": "Казахстан / Петропавловск",
    "country": "Казахстан",
    "searchString": "петропавловск казахстан / петропавловск"
  },
  "181": {
    "id": "181",
    "name": "Павлодар",
    "path": "Казахстан / Павлодар",
    "country": "Казахстан",
    "searchString": "павлодар казахстан / павлодар"
  },
  "182": {
    "id": "182",
    "name": "Рудный",
    "path": "Казахстан / Рудный",
    "country": "Казахстан",
    "searchString": "рудный казахстан / рудный"
  },
  "183": {
    "id": "183",
    "name": "Риддер (ВКО)",
    "path": "Казахстан / Риддер (ВКО)",
    "country": "Казахстан",
    "searchString": "риддер (вко) казахстан / риддер (вко)"
  },
  "184": {
    "id": "184",
    "name": "Сатпаев",
    "path": "Казахстан / Сатпаев",
    "country": "Казахстан",
    "searchString": "сатпаев казахстан / сатпаев"
  },
  "185": {
    "id": "185",
    "name": "Семей",
    "path": "Казахстан / Семей",
    "country": "Казахстан",
    "searchString": "семей казахстан / семей"
  },
  "186": {
    "id": "186",
    "name": "Солнечный (ПГТ, Павлодарская обл)",
    "path": "Казахстан / Солнечный (ПГТ, Павлодарская обл)",
    "country": "Казахстан",
    "searchString": "солнечный (пгт, павлодарская обл) казахстан / солнечный (пгт, павлодарская обл)"
  },
  "187": {
    "id": "187",
    "name": "Тараз",
    "path": "Казахстан / Тараз",
    "country": "Казахстан",
    "searchString": "тараз казахстан / тараз"
  },
  "188": {
    "id": "188",
    "name": "Талдыкорган",
    "path": "Казахстан / Талдыкорган",
    "country": "Казахстан",
    "searchString": "талдыкорган казахстан / талдыкорган"
  },
  "189": {
    "id": "189",
    "name": "Текели",
    "path": "Казахстан / Текели",
    "country": "Казахстан",
    "searchString": "текели казахстан / текели"
  },
  "190": {
    "id": "190",
    "name": "Темиртау",
    "path": "Казахстан / Темиртау",
    "country": "Казахстан",
    "searchString": "темиртау казахстан / темиртау"
  },
  "191": {
    "id": "191",
    "name": "Торгай",
    "path": "Казахстан / Торгай",
    "country": "Казахстан",
    "searchString": "торгай казахстан / торгай"
  },
  "192": {
    "id": "192",
    "name": "Туркестан",
    "path": "Казахстан / Туркестан",
    "country": "Казахстан",
    "searchString": "туркестан казахстан / туркестан"
  },
  "193": {
    "id": "193",
    "name": "Уральск",
    "path": "Казахстан / Уральск",
    "country": "Казахстан",
    "searchString": "уральск казахстан / уральск"
  },
  "194": {
    "id": "194",
    "name": "Усть-Каменогорск",
    "path": "Казахстан / Усть-Каменогорск",
    "country": "Казахстан",
    "searchString": "усть-каменогорск казахстан / усть-каменогорск"
  },
  "195": {
    "id": "195",
    "name": "Хромтау",
    "path": "Казахстан / Хромтау",
    "country": "Казахстан",
    "searchString": "хромтау казахстан / хромтау"
  },
  "196": {
    "id": "196",
    "name": "Шемонаиха (ВКО)",
    "path": "Казахстан / Шемонаиха (ВКО)",
    "country": "Казахстан",
    "searchString": "шемонаиха (вко) казахстан / шемонаиха (вко)"
  },
  "197": {
    "id": "197",
    "name": "Щучинск",
    "path": "Казахстан / Щучинск",
    "country": "Казахстан",
    "searchString": "щучинск казахстан / щучинск"
  },
  "198": {
    "id": "198",
    "name": "Экибастуз",
    "path": "Казахстан / Экибастуз",
    "country": "Казахстан",
    "searchString": "экибастуз казахстан / экибастуз"
  },
  "199": {
    "id": "199",
    "name": "Чехия",
    "path": "Другие регионы / Чехия",
    "country": "Другие регионы",
    "searchString": "чехия другие регионы / чехия"
  },
  "200": {
    "id": "200",
    "name": "Болгария",
    "path": "Другие регионы / Болгария",
    "country": "Другие регионы",
    "searchString": "болгария другие регионы / болгария"
  },
  "202": {
    "id": "202",
    "name": "Гвинея",
    "path": "Другие регионы / Гвинея",
    "country": "Другие регионы",
    "searchString": "гвинея другие регионы / гвинея"
  },
  "203": {
    "id": "203",
    "name": "Вьетнам",
    "path": "Другие регионы / Вьетнам",
    "country": "Другие регионы",
    "searchString": "вьетнам другие регионы / вьетнам"
  },
  "204": {
    "id": "204",
    "name": "Новая Зеландия",
    "path": "Другие регионы / Новая Зеландия",
    "country": "Другие регионы",
    "searchString": "новая зеландия другие регионы / новая зеландия"
  },
  "205": {
    "id": "205",
    "name": "Шымкент",
    "path": "Казахстан / Шымкент",
    "country": "Казахстан",
    "searchString": "шымкент казахстан / шымкент"
  },
  "206": {
    "id": "206",
    "name": "Люксембург",
    "path": "Другие регионы / Люксембург",
    "country": "Другие регионы",
    "searchString": "люксембург другие регионы / люксембург"
  },
  "207": {
    "id": "207",
    "name": "Норвегия",
    "path": "Другие регионы / Норвегия",
    "country": "Другие регионы",
    "searchString": "норвегия другие регионы / норвегия"
  },
  "208": {
    "id": "208",
    "name": "ОАЭ",
    "path": "Другие регионы / ОАЭ",
    "country": "Другие регионы",
    "searchString": "оаэ другие регионы / оаэ"
  },
  "209": {
    "id": "209",
    "name": "Индия",
    "path": "Другие регионы / Индия",
    "country": "Другие регионы",
    "searchString": "индия другие регионы / индия"
  },
  "210": {
    "id": "210",
    "name": "Катар",
    "path": "Другие регионы / Катар",
    "country": "Другие регионы",
    "searchString": "катар другие регионы / катар"
  },
  "211": {
    "id": "211",
    "name": "ЮАР",
    "path": "Другие регионы / ЮАР",
    "country": "Другие регионы",
    "searchString": "юар другие регионы / юар"
  },
  "212": {
    "id": "212",
    "name": "Тольятти",
    "path": "Россия / Самарская область / Тольятти",
    "country": "Россия",
    "searchString": "тольятти россия / самарская область / тольятти"
  },
  "213": {
    "id": "213",
    "name": "Греция",
    "path": "Другие регионы / Греция",
    "country": "Другие регионы",
    "searchString": "греция другие регионы / греция"
  },
  "214": {
    "id": "214",
    "name": "Дудинка (Красноярский край)",
    "path": "Россия / Красноярский край / Дудинка (Красноярский край)",
    "country": "Россия",
    "searchString": "дудинка (красноярский край) россия / красноярский край / дудинка (красноярский край)"
  },
  "215": {
    "id": "215",
    "name": "Тура (Красноярский край)",
    "path": "Россия / Красноярский край / Тура (Красноярский край)",
    "country": "Россия",
    "searchString": "тура (красноярский край) россия / красноярский край / тура (красноярский край)"
  },
  "216": {
    "id": "216",
    "name": "Агинское (Забайкальский АО)",
    "path": "Россия / Забайкальский край / Агинское (Забайкальский АО)",
    "country": "Россия",
    "searchString": "агинское (забайкальский ао) россия / забайкальский край / агинское (забайкальский ао)"
  },
  "217": {
    "id": "217",
    "name": "Усть-Ордынский",
    "path": "Россия / Иркутская область / Усть-Ордынский",
    "country": "Россия",
    "searchString": "усть-ордынский россия / иркутская область / усть-ордынский"
  },
  "218": {
    "id": "218",
    "name": "Палана",
    "path": "Россия / Камчатский край / Палана",
    "country": "Россия",
    "searchString": "палана россия / камчатский край / палана"
  },
  "219": {
    "id": "219",
    "name": "Анадырь",
    "path": "Россия / Чукотский АО / Анадырь",
    "country": "Россия",
    "searchString": "анадырь россия / чукотский ао / анадырь"
  },
  "233": {
    "id": "233",
    "name": "Сингапур",
    "path": "Другие регионы / Сингапур",
    "country": "Другие регионы",
    "searchString": "сингапур другие регионы / сингапур"
  },
  "234": {
    "id": "234",
    "name": "Румыния",
    "path": "Другие регионы / Румыния",
    "country": "Другие регионы",
    "searchString": "румыния другие регионы / румыния"
  },
  "235": {
    "id": "235",
    "name": "Аргентина",
    "path": "Другие регионы / Аргентина",
    "country": "Другие регионы",
    "searchString": "аргентина другие регионы / аргентина"
  },
  "236": {
    "id": "236",
    "name": "Кипр",
    "path": "Другие регионы / Кипр",
    "country": "Другие регионы",
    "searchString": "кипр другие регионы / кипр"
  },
  "237": {
    "id": "237",
    "name": "Сочи",
    "path": "Россия / Краснодарский край / Сочи",
    "country": "Россия",
    "searchString": "сочи россия / краснодарский край / сочи"
  },
  "238": {
    "id": "238",
    "name": "Малайзия",
    "path": "Другие регионы / Малайзия",
    "country": "Другие регионы",
    "searchString": "малайзия другие регионы / малайзия"
  },
  "239": {
    "id": "239",
    "name": "Шотландия",
    "path": "Другие регионы / Шотландия",
    "country": "Другие регионы",
    "searchString": "шотландия другие регионы / шотландия"
  },
  "240": {
    "id": "240",
    "name": "Нигерия",
    "path": "Другие регионы / Нигерия",
    "country": "Другие регионы",
    "searchString": "нигерия другие регионы / нигерия"
  },
  "241": {
    "id": "241",
    "name": "Португалия",
    "path": "Другие регионы / Португалия",
    "country": "Другие регионы",
    "searchString": "португалия другие регионы / португалия"
  },
  "242": {
    "id": "242",
    "name": "Эквадор",
    "path": "Другие регионы / Эквадор",
    "country": "Другие регионы",
    "searchString": "эквадор другие регионы / эквадор"
  },
  "243": {
    "id": "243",
    "name": "Бразилия",
    "path": "Другие регионы / Бразилия",
    "country": "Другие регионы",
    "searchString": "бразилия другие регионы / бразилия"
  },
  "244": {
    "id": "244",
    "name": "Тунис",
    "path": "Другие регионы / Тунис",
    "country": "Другие регионы",
    "searchString": "тунис другие регионы / тунис"
  },
  "245": {
    "id": "245",
    "name": "Камбоджа",
    "path": "Другие регионы / Камбоджа",
    "country": "Другие регионы",
    "searchString": "камбоджа другие регионы / камбоджа"
  },
  "246": {
    "id": "246",
    "name": "Норильск",
    "path": "Россия / Красноярский край / Норильск",
    "country": "Россия",
    "searchString": "норильск россия / красноярский край / норильск"
  },
  "247": {
    "id": "247",
    "name": "Дзержинск (Нижегородская область)",
    "path": "Россия / Нижегородская область / Дзержинск (Нижегородская область)",
    "country": "Россия",
    "searchString": "дзержинск (нижегородская область) россия / нижегородская область / дзержинск (нижегородская область)"
  },
  "248": {
    "id": "248",
    "name": "Арзамас",
    "path": "Россия / Нижегородская область / Арзамас",
    "country": "Россия",
    "searchString": "арзамас россия / нижегородская область / арзамас"
  },
  "249": {
    "id": "249",
    "name": "Саров",
    "path": "Россия / Нижегородская область / Саров",
    "country": "Россия",
    "searchString": "саров россия / нижегородская область / саров"
  },
  "300": {
    "id": "300",
    "name": "Таиланд",
    "path": "Другие регионы / Таиланд",
    "country": "Другие регионы",
    "searchString": "таиланд другие регионы / таиланд"
  },
  "301": {
    "id": "301",
    "name": "Обнинск",
    "path": "Россия / Калужская область / Обнинск",
    "country": "Россия",
    "searchString": "обнинск россия / калужская область / обнинск"
  },
  "302": {
    "id": "302",
    "name": "Исландия",
    "path": "Другие регионы / Исландия",
    "country": "Другие регионы",
    "searchString": "исландия другие регионы / исландия"
  },
  "303": {
    "id": "303",
    "name": "Бангладеш",
    "path": "Другие регионы / Бангладеш",
    "country": "Другие регионы",
    "searchString": "бангладеш другие регионы / бангладеш"
  },
  "304": {
    "id": "304",
    "name": "Салехард",
    "path": "Россия / Ямало-Ненецкий АО / Салехард",
    "country": "Россия",
    "searchString": "салехард россия / ямало-ненецкий ао / салехард"
  },
  "305": {
    "id": "305",
    "name": "Египет",
    "path": "Другие регионы / Египет",
    "country": "Другие регионы",
    "searchString": "египет другие регионы / египет"
  },
  "306": {
    "id": "306",
    "name": "Буркина Фасо",
    "path": "Другие регионы / Буркина Фасо",
    "country": "Другие регионы",
    "searchString": "буркина фасо другие регионы / буркина фасо"
  },
  "311": {
    "id": "311",
    "name": "Демократическая Республика Конго",
    "path": "Другие регионы / Демократическая Республика Конго",
    "country": "Другие регионы",
    "searchString": "демократическая республика конго другие регионы / демократическая республика конго"
  },
  "312": {
    "id": "312",
    "name": "Республика Конго",
    "path": "Другие регионы / Республика Конго",
    "country": "Другие регионы",
    "searchString": "республика конго другие регионы / республика конго"
  },
  "316": {
    "id": "316",
    "name": "Пакистан",
    "path": "Другие регионы / Пакистан",
    "country": "Другие регионы",
    "searchString": "пакистан другие регионы / пакистан"
  },
  "317": {
    "id": "317",
    "name": "Сирия",
    "path": "Другие регионы / Сирия",
    "country": "Другие регионы",
    "searchString": "сирия другие регионы / сирия"
  },
  "318": {
    "id": "318",
    "name": "Словакия",
    "path": "Другие регионы / Словакия",
    "country": "Другие регионы",
    "searchString": "словакия другие регионы / словакия"
  },
  "1001": {
    "id": "1001",
    "name": "Другие регионы",
    "path": "Другие регионы",
    "country": "Другие регионы",
    "searchString": "другие регионы другие регионы"
  },
  "1002": {
    "id": "1002",
    "name": "Минск",
    "path": "Беларусь / Минск",
    "country": "Беларусь",
    "searchString": "минск беларусь / минск"
  },
  "1003": {
    "id": "1003",
    "name": "Гомель",
    "path": "Беларусь / Гомель",
    "country": "Беларусь",
    "searchString": "гомель беларусь / гомель"
  },
  "1004": {
    "id": "1004",
    "name": "Могилев",
    "path": "Беларусь / Могилев",
    "country": "Беларусь",
    "searchString": "могилев беларусь / могилев"
  },
  "1005": {
    "id": "1005",
    "name": "Витебск",
    "path": "Беларусь / Витебск",
    "country": "Беларусь",
    "searchString": "витебск беларусь / витебск"
  },
  "1006": {
    "id": "1006",
    "name": "Гродно",
    "path": "Беларусь / Гродно",
    "country": "Беларусь",
    "searchString": "гродно беларусь / гродно"
  },
  "1007": {
    "id": "1007",
    "name": "Брест",
    "path": "Беларусь / Брест",
    "country": "Беларусь",
    "searchString": "брест беларусь / брест"
  },
  "1008": {
    "id": "1008",
    "name": "Архангельская область",
    "path": "Россия / Архангельская область",
    "country": "Россия",
    "searchString": "архангельская область россия / архангельская область"
  },
  "1009": {
    "id": "1009",
    "name": "Каргополь",
    "path": "Россия / Архангельская область / Каргополь",
    "country": "Россия",
    "searchString": "каргополь россия / архангельская область / каргополь"
  },
  "1010": {
    "id": "1010",
    "name": "Коряжма",
    "path": "Россия / Архангельская область / Коряжма",
    "country": "Россия",
    "searchString": "коряжма россия / архангельская область / коряжма"
  },
  "1011": {
    "id": "1011",
    "name": "Котлас",
    "path": "Россия / Архангельская область / Котлас",
    "country": "Россия",
    "searchString": "котлас россия / архангельская область / котлас"
  },
  "1012": {
    "id": "1012",
    "name": "Мезень",
    "path": "Россия / Архангельская область / Мезень",
    "country": "Россия",
    "searchString": "мезень россия / архангельская область / мезень"
  },
  "1013": {
    "id": "1013",
    "name": "Мирный (Архангельская область)",
    "path": "Россия / Архангельская область / Мирный (Архангельская область)",
    "country": "Россия",
    "searchString": "мирный (архангельская область) россия / архангельская область / мирный (архангельская область)"
  },
  "1014": {
    "id": "1014",
    "name": "Новодвинск",
    "path": "Россия / Архангельская область / Новодвинск",
    "country": "Россия",
    "searchString": "новодвинск россия / архангельская область / новодвинск"
  },
  "1015": {
    "id": "1015",
    "name": "Няндома",
    "path": "Россия / Архангельская область / Няндома",
    "country": "Россия",
    "searchString": "няндома россия / архангельская область / няндома"
  },
  "1016": {
    "id": "1016",
    "name": "Онега",
    "path": "Россия / Архангельская область / Онега",
    "country": "Россия",
    "searchString": "онега россия / архангельская область / онега"
  },
  "1017": {
    "id": "1017",
    "name": "Северодвинск",
    "path": "Россия / Архангельская область / Северодвинск",
    "country": "Россия",
    "searchString": "северодвинск россия / архангельская область / северодвинск"
  },
  "1018": {
    "id": "1018",
    "name": "Сольвычегодск",
    "path": "Россия / Архангельская область / Сольвычегодск",
    "country": "Россия",
    "searchString": "сольвычегодск россия / архангельская область / сольвычегодск"
  },
  "1019": {
    "id": "1019",
    "name": "Шенкурск",
    "path": "Россия / Архангельская область / Шенкурск",
    "country": "Россия",
    "searchString": "шенкурск россия / архангельская область / шенкурск"
  },
  "1020": {
    "id": "1020",
    "name": "Калининградская область",
    "path": "Россия / Калининградская область",
    "country": "Россия",
    "searchString": "калининградская область россия / калининградская область"
  },
  "1021": {
    "id": "1021",
    "name": "Багратионовск",
    "path": "Россия / Калининградская область / Багратионовск",
    "country": "Россия",
    "searchString": "багратионовск россия / калининградская область / багратионовск"
  },
  "1022": {
    "id": "1022",
    "name": "Балтийск",
    "path": "Россия / Калининградская область / Балтийск",
    "country": "Россия",
    "searchString": "балтийск россия / калининградская область / балтийск"
  },
  "1023": {
    "id": "1023",
    "name": "Гвардейск",
    "path": "Россия / Калининградская область / Гвардейск",
    "country": "Россия",
    "searchString": "гвардейск россия / калининградская область / гвардейск"
  },
  "1024": {
    "id": "1024",
    "name": "Гурьевск (Калининградская область)",
    "path": "Россия / Калининградская область / Гурьевск (Калининградская область)",
    "country": "Россия",
    "searchString": "гурьевск (калининградская область) россия / калининградская область / гурьевск (калининградская область)"
  },
  "1025": {
    "id": "1025",
    "name": "Гусев",
    "path": "Россия / Калининградская область / Гусев",
    "country": "Россия",
    "searchString": "гусев россия / калининградская область / гусев"
  },
  "1026": {
    "id": "1026",
    "name": "Зеленоградск",
    "path": "Россия / Калининградская область / Зеленоградск",
    "country": "Россия",
    "searchString": "зеленоградск россия / калининградская область / зеленоградск"
  },
  "1027": {
    "id": "1027",
    "name": "Краснознаменск (Калининградская область)",
    "path": "Россия / Калининградская область / Краснознаменск (Калининградская область)",
    "country": "Россия",
    "searchString": "краснознаменск (калининградская область) россия / калининградская область / краснознаменск (калининградская область)"
  },
  "1028": {
    "id": "1028",
    "name": "Ладушкин",
    "path": "Россия / Калининградская область / Ладушкин",
    "country": "Россия",
    "searchString": "ладушкин россия / калининградская область / ладушкин"
  },
  "1029": {
    "id": "1029",
    "name": "Мамоново",
    "path": "Россия / Калининградская область / Мамоново",
    "country": "Россия",
    "searchString": "мамоново россия / калининградская область / мамоново"
  },
  "1030": {
    "id": "1030",
    "name": "Неман",
    "path": "Россия / Калининградская область / Неман",
    "country": "Россия",
    "searchString": "неман россия / калининградская область / неман"
  },
  "1031": {
    "id": "1031",
    "name": "Нестеров",
    "path": "Россия / Калининградская область / Нестеров",
    "country": "Россия",
    "searchString": "нестеров россия / калининградская область / нестеров"
  },
  "1032": {
    "id": "1032",
    "name": "Озерск (Калининградская область)",
    "path": "Россия / Калининградская область / Озерск (Калининградская область)",
    "country": "Россия",
    "searchString": "озерск (калининградская область) россия / калининградская область / озерск (калининградская область)"
  },
  "1033": {
    "id": "1033",
    "name": "Пионерский",
    "path": "Россия / Калининградская область / Пионерский",
    "country": "Россия",
    "searchString": "пионерский россия / калининградская область / пионерский"
  },
  "1034": {
    "id": "1034",
    "name": "Полесск",
    "path": "Россия / Калининградская область / Полесск",
    "country": "Россия",
    "searchString": "полесск россия / калининградская область / полесск"
  },
  "1035": {
    "id": "1035",
    "name": "Правдинск (Калининградская область)",
    "path": "Россия / Калининградская область / Правдинск (Калининградская область)",
    "country": "Россия",
    "searchString": "правдинск (калининградская область) россия / калининградская область / правдинск (калининградская область)"
  },
  "1036": {
    "id": "1036",
    "name": "Светлогорск (Калининградская область)",
    "path": "Россия / Калининградская область / Светлогорск (Калининградская область)",
    "country": "Россия",
    "searchString": "светлогорск (калининградская область) россия / калининградская область / светлогорск (калининградская область)"
  },
  "1037": {
    "id": "1037",
    "name": "Светлый",
    "path": "Россия / Калининградская область / Светлый",
    "country": "Россия",
    "searchString": "светлый россия / калининградская область / светлый"
  },
  "1038": {
    "id": "1038",
    "name": "Славск",
    "path": "Россия / Калининградская область / Славск",
    "country": "Россия",
    "searchString": "славск россия / калининградская область / славск"
  },
  "1039": {
    "id": "1039",
    "name": "Советск (Калининградская область)",
    "path": "Россия / Калининградская область / Советск (Калининградская область)",
    "country": "Россия",
    "searchString": "советск (калининградская область) россия / калининградская область / советск (калининградская область)"
  },
  "1040": {
    "id": "1040",
    "name": "Черняховск",
    "path": "Россия / Калининградская область / Черняховск",
    "country": "Россия",
    "searchString": "черняховск россия / калининградская область / черняховск"
  },
  "1041": {
    "id": "1041",
    "name": "Республика Коми",
    "path": "Россия / Республика Коми",
    "country": "Россия",
    "searchString": "республика коми россия / республика коми"
  },
  "1042": {
    "id": "1042",
    "name": "Воркута",
    "path": "Россия / Республика Коми / Воркута",
    "country": "Россия",
    "searchString": "воркута россия / республика коми / воркута"
  },
  "1043": {
    "id": "1043",
    "name": "Вуктыл",
    "path": "Россия / Республика Коми / Вуктыл",
    "country": "Россия",
    "searchString": "вуктыл россия / республика коми / вуктыл"
  },
  "1044": {
    "id": "1044",
    "name": "Емва",
    "path": "Россия / Республика Коми / Емва",
    "country": "Россия",
    "searchString": "емва россия / республика коми / емва"
  },
  "1045": {
    "id": "1045",
    "name": "Инта",
    "path": "Россия / Республика Коми / Инта",
    "country": "Россия",
    "searchString": "инта россия / республика коми / инта"
  },
  "1046": {
    "id": "1046",
    "name": "Микунь",
    "path": "Россия / Республика Коми / Микунь",
    "country": "Россия",
    "searchString": "микунь россия / республика коми / микунь"
  },
  "1047": {
    "id": "1047",
    "name": "Печора",
    "path": "Россия / Республика Коми / Печора",
    "country": "Россия",
    "searchString": "печора россия / республика коми / печора"
  },
  "1048": {
    "id": "1048",
    "name": "Сосногорск",
    "path": "Россия / Республика Коми / Сосногорск",
    "country": "Россия",
    "searchString": "сосногорск россия / республика коми / сосногорск"
  },
  "1049": {
    "id": "1049",
    "name": "Усинск",
    "path": "Россия / Республика Коми / Усинск",
    "country": "Россия",
    "searchString": "усинск россия / республика коми / усинск"
  },
  "1050": {
    "id": "1050",
    "name": "Ухта",
    "path": "Россия / Республика Коми / Ухта",
    "country": "Россия",
    "searchString": "ухта россия / республика коми / ухта"
  },
  "1051": {
    "id": "1051",
    "name": "Новгородская область",
    "path": "Россия / Новгородская область",
    "country": "Россия",
    "searchString": "новгородская область россия / новгородская область"
  },
  "1052": {
    "id": "1052",
    "name": "Боровичи",
    "path": "Россия / Новгородская область / Боровичи",
    "country": "Россия",
    "searchString": "боровичи россия / новгородская область / боровичи"
  },
  "1053": {
    "id": "1053",
    "name": "Валдай",
    "path": "Россия / Новгородская область / Валдай",
    "country": "Россия",
    "searchString": "валдай россия / новгородская область / валдай"
  },
  "1054": {
    "id": "1054",
    "name": "Малая Вишера",
    "path": "Россия / Новгородская область / Малая Вишера",
    "country": "Россия",
    "searchString": "малая вишера россия / новгородская область / малая вишера"
  },
  "1055": {
    "id": "1055",
    "name": "Окуловка",
    "path": "Россия / Новгородская область / Окуловка",
    "country": "Россия",
    "searchString": "окуловка россия / новгородская область / окуловка"
  },
  "1056": {
    "id": "1056",
    "name": "Пестово",
    "path": "Россия / Новгородская область / Пестово",
    "country": "Россия",
    "searchString": "пестово россия / новгородская область / пестово"
  },
  "1057": {
    "id": "1057",
    "name": "Сольцы",
    "path": "Россия / Новгородская область / Сольцы",
    "country": "Россия",
    "searchString": "сольцы россия / новгородская область / сольцы"
  },
  "1058": {
    "id": "1058",
    "name": "Старая Русса",
    "path": "Россия / Новгородская область / Старая Русса",
    "country": "Россия",
    "searchString": "старая русса россия / новгородская область / старая русса"
  },
  "1059": {
    "id": "1059",
    "name": "Холм",
    "path": "Россия / Новгородская область / Холм",
    "country": "Россия",
    "searchString": "холм россия / новгородская область / холм"
  },
  "1060": {
    "id": "1060",
    "name": "Чудово",
    "path": "Россия / Новгородская область / Чудово",
    "country": "Россия",
    "searchString": "чудово россия / новгородская область / чудово"
  },
  "1061": {
    "id": "1061",
    "name": "Мурманская область",
    "path": "Россия / Мурманская область",
    "country": "Россия",
    "searchString": "мурманская область россия / мурманская область"
  },
  "1062": {
    "id": "1062",
    "name": "Апатиты",
    "path": "Россия / Мурманская область / Апатиты",
    "country": "Россия",
    "searchString": "апатиты россия / мурманская область / апатиты"
  },
  "1063": {
    "id": "1063",
    "name": "Гаджиево",
    "path": "Россия / Мурманская область / Гаджиево",
    "country": "Россия",
    "searchString": "гаджиево россия / мурманская область / гаджиево"
  },
  "1064": {
    "id": "1064",
    "name": "Заозерск",
    "path": "Россия / Мурманская область / Заозерск",
    "country": "Россия",
    "searchString": "заозерск россия / мурманская область / заозерск"
  },
  "1065": {
    "id": "1065",
    "name": "Заполярный",
    "path": "Россия / Мурманская область / Заполярный",
    "country": "Россия",
    "searchString": "заполярный россия / мурманская область / заполярный"
  },
  "1066": {
    "id": "1066",
    "name": "Кандалакша",
    "path": "Россия / Мурманская область / Кандалакша",
    "country": "Россия",
    "searchString": "кандалакша россия / мурманская область / кандалакша"
  },
  "1067": {
    "id": "1067",
    "name": "Кировск (Мурманская область)",
    "path": "Россия / Мурманская область / Кировск (Мурманская область)",
    "country": "Россия",
    "searchString": "кировск (мурманская область) россия / мурманская область / кировск (мурманская область)"
  },
  "1068": {
    "id": "1068",
    "name": "Ковдор",
    "path": "Россия / Мурманская область / Ковдор",
    "country": "Россия",
    "searchString": "ковдор россия / мурманская область / ковдор"
  },
  "1069": {
    "id": "1069",
    "name": "Кола",
    "path": "Россия / Мурманская область / Кола",
    "country": "Россия",
    "searchString": "кола россия / мурманская область / кола"
  },
  "1070": {
    "id": "1070",
    "name": "Мончегорск",
    "path": "Россия / Мурманская область / Мончегорск",
    "country": "Россия",
    "searchString": "мончегорск россия / мурманская область / мончегорск"
  },
  "1071": {
    "id": "1071",
    "name": "Оленегорск",
    "path": "Россия / Мурманская область / Оленегорск",
    "country": "Россия",
    "searchString": "оленегорск россия / мурманская область / оленегорск"
  },
  "1072": {
    "id": "1072",
    "name": "Островной",
    "path": "Россия / Мурманская область / Островной",
    "country": "Россия",
    "searchString": "островной россия / мурманская область / островной"
  },
  "1073": {
    "id": "1073",
    "name": "Полярные Зори",
    "path": "Россия / Мурманская область / Полярные Зори",
    "country": "Россия",
    "searchString": "полярные зори россия / мурманская область / полярные зори"
  },
  "1074": {
    "id": "1074",
    "name": "Полярный",
    "path": "Россия / Мурманская область / Полярный",
    "country": "Россия",
    "searchString": "полярный россия / мурманская область / полярный"
  },
  "1075": {
    "id": "1075",
    "name": "Североморск",
    "path": "Россия / Мурманская область / Североморск",
    "country": "Россия",
    "searchString": "североморск россия / мурманская область / североморск"
  },
  "1076": {
    "id": "1076",
    "name": "Снежногорск",
    "path": "Россия / Мурманская область / Снежногорск",
    "country": "Россия",
    "searchString": "снежногорск россия / мурманская область / снежногорск"
  },
  "1077": {
    "id": "1077",
    "name": "Республика Карелия",
    "path": "Россия / Республика Карелия",
    "country": "Россия",
    "searchString": "республика карелия россия / республика карелия"
  },
  "1078": {
    "id": "1078",
    "name": "Беломорск",
    "path": "Россия / Республика Карелия / Беломорск",
    "country": "Россия",
    "searchString": "беломорск россия / республика карелия / беломорск"
  },
  "1079": {
    "id": "1079",
    "name": "Кемь",
    "path": "Россия / Республика Карелия / Кемь",
    "country": "Россия",
    "searchString": "кемь россия / республика карелия / кемь"
  },
  "1080": {
    "id": "1080",
    "name": "Кондопога",
    "path": "Россия / Республика Карелия / Кондопога",
    "country": "Россия",
    "searchString": "кондопога россия / республика карелия / кондопога"
  },
  "1081": {
    "id": "1081",
    "name": "Костомукша",
    "path": "Россия / Республика Карелия / Костомукша",
    "country": "Россия",
    "searchString": "костомукша россия / республика карелия / костомукша"
  },
  "1082": {
    "id": "1082",
    "name": "Лахденпохья",
    "path": "Россия / Республика Карелия / Лахденпохья",
    "country": "Россия",
    "searchString": "лахденпохья россия / республика карелия / лахденпохья"
  },
  "1083": {
    "id": "1083",
    "name": "Медвежьегорск",
    "path": "Россия / Республика Карелия / Медвежьегорск",
    "country": "Россия",
    "searchString": "медвежьегорск россия / республика карелия / медвежьегорск"
  },
  "1084": {
    "id": "1084",
    "name": "Олонец",
    "path": "Россия / Республика Карелия / Олонец",
    "country": "Россия",
    "searchString": "олонец россия / республика карелия / олонец"
  },
  "1085": {
    "id": "1085",
    "name": "Питкяранта",
    "path": "Россия / Республика Карелия / Питкяранта",
    "country": "Россия",
    "searchString": "питкяранта россия / республика карелия / питкяранта"
  },
  "1086": {
    "id": "1086",
    "name": "Пудож",
    "path": "Россия / Республика Карелия / Пудож",
    "country": "Россия",
    "searchString": "пудож россия / республика карелия / пудож"
  },
  "1087": {
    "id": "1087",
    "name": "Сегежа",
    "path": "Россия / Республика Карелия / Сегежа",
    "country": "Россия",
    "searchString": "сегежа россия / республика карелия / сегежа"
  },
  "1088": {
    "id": "1088",
    "name": "Сортавала",
    "path": "Россия / Республика Карелия / Сортавала",
    "country": "Россия",
    "searchString": "сортавала россия / республика карелия / сортавала"
  },
  "1089": {
    "id": "1089",
    "name": "Суоярви",
    "path": "Россия / Республика Карелия / Суоярви",
    "country": "Россия",
    "searchString": "суоярви россия / республика карелия / суоярви"
  },
  "1090": {
    "id": "1090",
    "name": "Псковская область",
    "path": "Россия / Псковская область",
    "country": "Россия",
    "searchString": "псковская область россия / псковская область"
  },
  "1091": {
    "id": "1091",
    "name": "Великие Луки",
    "path": "Россия / Псковская область / Великие Луки",
    "country": "Россия",
    "searchString": "великие луки россия / псковская область / великие луки"
  },
  "1092": {
    "id": "1092",
    "name": "Гдов",
    "path": "Россия / Псковская область / Гдов",
    "country": "Россия",
    "searchString": "гдов россия / псковская область / гдов"
  },
  "1093": {
    "id": "1093",
    "name": "Дно",
    "path": "Россия / Псковская область / Дно",
    "country": "Россия",
    "searchString": "дно россия / псковская область / дно"
  },
  "1094": {
    "id": "1094",
    "name": "Невель",
    "path": "Россия / Псковская область / Невель",
    "country": "Россия",
    "searchString": "невель россия / псковская область / невель"
  },
  "1095": {
    "id": "1095",
    "name": "Новоржев",
    "path": "Россия / Псковская область / Новоржев",
    "country": "Россия",
    "searchString": "новоржев россия / псковская область / новоржев"
  },
  "1096": {
    "id": "1096",
    "name": "Новосокольники",
    "path": "Россия / Псковская область / Новосокольники",
    "country": "Россия",
    "searchString": "новосокольники россия / псковская область / новосокольники"
  },
  "1097": {
    "id": "1097",
    "name": "Опочка",
    "path": "Россия / Псковская область / Опочка",
    "country": "Россия",
    "searchString": "опочка россия / псковская область / опочка"
  },
  "1098": {
    "id": "1098",
    "name": "Остров",
    "path": "Россия / Псковская область / Остров",
    "country": "Россия",
    "searchString": "остров россия / псковская область / остров"
  },
  "1099": {
    "id": "1099",
    "name": "Печоры",
    "path": "Россия / Псковская область / Печоры",
    "country": "Россия",
    "searchString": "печоры россия / псковская область / печоры"
  },
  "1100": {
    "id": "1100",
    "name": "Порхов",
    "path": "Россия / Псковская область / Порхов",
    "country": "Россия",
    "searchString": "порхов россия / псковская область / порхов"
  },
  "1101": {
    "id": "1101",
    "name": "Пустошка",
    "path": "Россия / Псковская область / Пустошка",
    "country": "Россия",
    "searchString": "пустошка россия / псковская область / пустошка"
  },
  "1102": {
    "id": "1102",
    "name": "Пыталово",
    "path": "Россия / Псковская область / Пыталово",
    "country": "Россия",
    "searchString": "пыталово россия / псковская область / пыталово"
  },
  "1103": {
    "id": "1103",
    "name": "Смоленская область",
    "path": "Россия / Смоленская область",
    "country": "Россия",
    "searchString": "смоленская область россия / смоленская область"
  },
  "1104": {
    "id": "1104",
    "name": "Велиж",
    "path": "Россия / Смоленская область / Велиж",
    "country": "Россия",
    "searchString": "велиж россия / смоленская область / велиж"
  },
  "1105": {
    "id": "1105",
    "name": "Вязьма",
    "path": "Россия / Смоленская область / Вязьма",
    "country": "Россия",
    "searchString": "вязьма россия / смоленская область / вязьма"
  },
  "1106": {
    "id": "1106",
    "name": "Гагарин",
    "path": "Россия / Смоленская область / Гагарин",
    "country": "Россия",
    "searchString": "гагарин россия / смоленская область / гагарин"
  },
  "1107": {
    "id": "1107",
    "name": "Демидов",
    "path": "Россия / Смоленская область / Демидов",
    "country": "Россия",
    "searchString": "демидов россия / смоленская область / демидов"
  },
  "1108": {
    "id": "1108",
    "name": "Десногорск",
    "path": "Россия / Смоленская область / Десногорск",
    "country": "Россия",
    "searchString": "десногорск россия / смоленская область / десногорск"
  },
  "1109": {
    "id": "1109",
    "name": "Дорогобуж",
    "path": "Россия / Смоленская область / Дорогобуж",
    "country": "Россия",
    "searchString": "дорогобуж россия / смоленская область / дорогобуж"
  },
  "1110": {
    "id": "1110",
    "name": "Духовщина",
    "path": "Россия / Смоленская область / Духовщина",
    "country": "Россия",
    "searchString": "духовщина россия / смоленская область / духовщина"
  },
  "1111": {
    "id": "1111",
    "name": "Ельня",
    "path": "Россия / Смоленская область / Ельня",
    "country": "Россия",
    "searchString": "ельня россия / смоленская область / ельня"
  },
  "1112": {
    "id": "1112",
    "name": "Починок",
    "path": "Россия / Смоленская область / Починок",
    "country": "Россия",
    "searchString": "починок россия / смоленская область / починок"
  },
  "1113": {
    "id": "1113",
    "name": "Рославль",
    "path": "Россия / Смоленская область / Рославль",
    "country": "Россия",
    "searchString": "рославль россия / смоленская область / рославль"
  },
  "1114": {
    "id": "1114",
    "name": "Рудня",
    "path": "Россия / Смоленская область / Рудня",
    "country": "Россия",
    "searchString": "рудня россия / смоленская область / рудня"
  },
  "1115": {
    "id": "1115",
    "name": "Сафоново",
    "path": "Россия / Смоленская область / Сафоново",
    "country": "Россия",
    "searchString": "сафоново россия / смоленская область / сафоново"
  },
  "1116": {
    "id": "1116",
    "name": "Сычевка",
    "path": "Россия / Смоленская область / Сычевка",
    "country": "Россия",
    "searchString": "сычевка россия / смоленская область / сычевка"
  },
  "1117": {
    "id": "1117",
    "name": "Ярцево",
    "path": "Россия / Смоленская область / Ярцево",
    "country": "Россия",
    "searchString": "ярцево россия / смоленская область / ярцево"
  },
  "1118": {
    "id": "1118",
    "name": "Республика Бурятия",
    "path": "Россия / Республика Бурятия",
    "country": "Россия",
    "searchString": "республика бурятия россия / республика бурятия"
  },
  "1119": {
    "id": "1119",
    "name": "Бабушкин",
    "path": "Россия / Республика Бурятия / Бабушкин",
    "country": "Россия",
    "searchString": "бабушкин россия / республика бурятия / бабушкин"
  },
  "1120": {
    "id": "1120",
    "name": "Гусиноозерск",
    "path": "Россия / Республика Бурятия / Гусиноозерск",
    "country": "Россия",
    "searchString": "гусиноозерск россия / республика бурятия / гусиноозерск"
  },
  "1121": {
    "id": "1121",
    "name": "Закаменск",
    "path": "Россия / Республика Бурятия / Закаменск",
    "country": "Россия",
    "searchString": "закаменск россия / республика бурятия / закаменск"
  },
  "1122": {
    "id": "1122",
    "name": "Кяхта",
    "path": "Россия / Республика Бурятия / Кяхта",
    "country": "Россия",
    "searchString": "кяхта россия / республика бурятия / кяхта"
  },
  "1123": {
    "id": "1123",
    "name": "Северобайкальск",
    "path": "Россия / Республика Бурятия / Северобайкальск",
    "country": "Россия",
    "searchString": "северобайкальск россия / республика бурятия / северобайкальск"
  },
  "1124": {
    "id": "1124",
    "name": "Иркутская область",
    "path": "Россия / Иркутская область",
    "country": "Россия",
    "searchString": "иркутская область россия / иркутская область"
  },
  "1125": {
    "id": "1125",
    "name": "Алзамай",
    "path": "Россия / Иркутская область / Алзамай",
    "country": "Россия",
    "searchString": "алзамай россия / иркутская область / алзамай"
  },
  "1126": {
    "id": "1126",
    "name": "Ангарск",
    "path": "Россия / Иркутская область / Ангарск",
    "country": "Россия",
    "searchString": "ангарск россия / иркутская область / ангарск"
  },
  "1127": {
    "id": "1127",
    "name": "Байкальск",
    "path": "Россия / Иркутская область / Байкальск",
    "country": "Россия",
    "searchString": "байкальск россия / иркутская область / байкальск"
  },
  "1128": {
    "id": "1128",
    "name": "Бирюсинск",
    "path": "Россия / Иркутская область / Бирюсинск",
    "country": "Россия",
    "searchString": "бирюсинск россия / иркутская область / бирюсинск"
  },
  "1129": {
    "id": "1129",
    "name": "Бодайбо",
    "path": "Россия / Иркутская область / Бодайбо",
    "country": "Россия",
    "searchString": "бодайбо россия / иркутская область / бодайбо"
  },
  "1130": {
    "id": "1130",
    "name": "Братск",
    "path": "Россия / Иркутская область / Братск",
    "country": "Россия",
    "searchString": "братск россия / иркутская область / братск"
  },
  "1131": {
    "id": "1131",
    "name": "Вихоревка",
    "path": "Россия / Иркутская область / Вихоревка",
    "country": "Россия",
    "searchString": "вихоревка россия / иркутская область / вихоревка"
  },
  "1132": {
    "id": "1132",
    "name": "Железногорск-Илимский",
    "path": "Россия / Иркутская область / Железногорск-Илимский",
    "country": "Россия",
    "searchString": "железногорск-илимский россия / иркутская область / железногорск-илимский"
  },
  "1133": {
    "id": "1133",
    "name": "Зима",
    "path": "Россия / Иркутская область / Зима",
    "country": "Россия",
    "searchString": "зима россия / иркутская область / зима"
  },
  "1134": {
    "id": "1134",
    "name": "Киренск",
    "path": "Россия / Иркутская область / Киренск",
    "country": "Россия",
    "searchString": "киренск россия / иркутская область / киренск"
  },
  "1135": {
    "id": "1135",
    "name": "Нижнеудинск",
    "path": "Россия / Иркутская область / Нижнеудинск",
    "country": "Россия",
    "searchString": "нижнеудинск россия / иркутская область / нижнеудинск"
  },
  "1136": {
    "id": "1136",
    "name": "Саянск",
    "path": "Россия / Иркутская область / Саянск",
    "country": "Россия",
    "searchString": "саянск россия / иркутская область / саянск"
  },
  "1137": {
    "id": "1137",
    "name": "Свирск",
    "path": "Россия / Иркутская область / Свирск",
    "country": "Россия",
    "searchString": "свирск россия / иркутская область / свирск"
  },
  "1138": {
    "id": "1138",
    "name": "Слюдянка",
    "path": "Россия / Иркутская область / Слюдянка",
    "country": "Россия",
    "searchString": "слюдянка россия / иркутская область / слюдянка"
  },
  "1139": {
    "id": "1139",
    "name": "Тайшет",
    "path": "Россия / Иркутская область / Тайшет",
    "country": "Россия",
    "searchString": "тайшет россия / иркутская область / тайшет"
  },
  "1140": {
    "id": "1140",
    "name": "Тулун",
    "path": "Россия / Иркутская область / Тулун",
    "country": "Россия",
    "searchString": "тулун россия / иркутская область / тулун"
  },
  "1141": {
    "id": "1141",
    "name": "Усолье-Сибирское",
    "path": "Россия / Иркутская область / Усолье-Сибирское",
    "country": "Россия",
    "searchString": "усолье-сибирское россия / иркутская область / усолье-сибирское"
  },
  "1142": {
    "id": "1142",
    "name": "Усть-Илимск",
    "path": "Россия / Иркутская область / Усть-Илимск",
    "country": "Россия",
    "searchString": "усть-илимск россия / иркутская область / усть-илимск"
  },
  "1143": {
    "id": "1143",
    "name": "Усть-Кут",
    "path": "Россия / Иркутская область / Усть-Кут",
    "country": "Россия",
    "searchString": "усть-кут россия / иркутская область / усть-кут"
  },
  "1144": {
    "id": "1144",
    "name": "Черемхово",
    "path": "Россия / Иркутская область / Черемхово",
    "country": "Россия",
    "searchString": "черемхово россия / иркутская область / черемхово"
  },
  "1145": {
    "id": "1145",
    "name": "Шелехов",
    "path": "Россия / Иркутская область / Шелехов",
    "country": "Россия",
    "searchString": "шелехов россия / иркутская область / шелехов"
  },
  "1146": {
    "id": "1146",
    "name": "Красноярский край",
    "path": "Россия / Красноярский край",
    "country": "Россия",
    "searchString": "красноярский край россия / красноярский край"
  },
  "1147": {
    "id": "1147",
    "name": "Артемовск (Красноярский край)",
    "path": "Россия / Красноярский край / Артемовск (Красноярский край)",
    "country": "Россия",
    "searchString": "артемовск (красноярский край) россия / красноярский край / артемовск (красноярский край)"
  },
  "1148": {
    "id": "1148",
    "name": "Ачинск",
    "path": "Россия / Красноярский край / Ачинск",
    "country": "Россия",
    "searchString": "ачинск россия / красноярский край / ачинск"
  },
  "1149": {
    "id": "1149",
    "name": "Боготол",
    "path": "Россия / Красноярский край / Боготол",
    "country": "Россия",
    "searchString": "боготол россия / красноярский край / боготол"
  },
  "1150": {
    "id": "1150",
    "name": "Бородино",
    "path": "Россия / Красноярский край / Бородино",
    "country": "Россия",
    "searchString": "бородино россия / красноярский край / бородино"
  },
  "1151": {
    "id": "1151",
    "name": "Дивногорск",
    "path": "Россия / Красноярский край / Дивногорск",
    "country": "Россия",
    "searchString": "дивногорск россия / красноярский край / дивногорск"
  },
  "1152": {
    "id": "1152",
    "name": "Диксон",
    "path": "Россия / Красноярский край / Диксон",
    "country": "Россия",
    "searchString": "диксон россия / красноярский край / диксон"
  },
  "1153": {
    "id": "1153",
    "name": "Енисейск",
    "path": "Россия / Красноярский край / Енисейск",
    "country": "Россия",
    "searchString": "енисейск россия / красноярский край / енисейск"
  },
  "1154": {
    "id": "1154",
    "name": "Железногорск (Красноярский край)",
    "path": "Россия / Красноярский край / Железногорск (Красноярский край)",
    "country": "Россия",
    "searchString": "железногорск (красноярский край) россия / красноярский край / железногорск (красноярский край)"
  },
  "1155": {
    "id": "1155",
    "name": "Заозерный",
    "path": "Россия / Красноярский край / Заозерный",
    "country": "Россия",
    "searchString": "заозерный россия / красноярский край / заозерный"
  },
  "1156": {
    "id": "1156",
    "name": "Зеленогорск (Красноярский край)",
    "path": "Россия / Красноярский край / Зеленогорск (Красноярский край)",
    "country": "Россия",
    "searchString": "зеленогорск (красноярский край) россия / красноярский край / зеленогорск (красноярский край)"
  },
  "1157": {
    "id": "1157",
    "name": "Игарка",
    "path": "Россия / Красноярский край / Игарка",
    "country": "Россия",
    "searchString": "игарка россия / красноярский край / игарка"
  },
  "1158": {
    "id": "1158",
    "name": "Иланский",
    "path": "Россия / Красноярский край / Иланский",
    "country": "Россия",
    "searchString": "иланский россия / красноярский край / иланский"
  },
  "1159": {
    "id": "1159",
    "name": "Канск",
    "path": "Россия / Красноярский край / Канск",
    "country": "Россия",
    "searchString": "канск россия / красноярский край / канск"
  },
  "1160": {
    "id": "1160",
    "name": "Кодинск",
    "path": "Россия / Красноярский край / Кодинск",
    "country": "Россия",
    "searchString": "кодинск россия / красноярский край / кодинск"
  },
  "1161": {
    "id": "1161",
    "name": "Лесосибирск",
    "path": "Россия / Красноярский край / Лесосибирск",
    "country": "Россия",
    "searchString": "лесосибирск россия / красноярский край / лесосибирск"
  },
  "1162": {
    "id": "1162",
    "name": "Минусинск",
    "path": "Россия / Красноярский край / Минусинск",
    "country": "Россия",
    "searchString": "минусинск россия / красноярский край / минусинск"
  },
  "1163": {
    "id": "1163",
    "name": "Назарово",
    "path": "Россия / Красноярский край / Назарово",
    "country": "Россия",
    "searchString": "назарово россия / красноярский край / назарово"
  },
  "1164": {
    "id": "1164",
    "name": "Сосновоборск",
    "path": "Россия / Красноярский край / Сосновоборск",
    "country": "Россия",
    "searchString": "сосновоборск россия / красноярский край / сосновоборск"
  },
  "1165": {
    "id": "1165",
    "name": "Ужур",
    "path": "Россия / Красноярский край / Ужур",
    "country": "Россия",
    "searchString": "ужур россия / красноярский край / ужур"
  },
  "1166": {
    "id": "1166",
    "name": "Уяр",
    "path": "Россия / Красноярский край / Уяр",
    "country": "Россия",
    "searchString": "уяр россия / красноярский край / уяр"
  },
  "1167": {
    "id": "1167",
    "name": "Хатанга",
    "path": "Россия / Красноярский край / Хатанга",
    "country": "Россия",
    "searchString": "хатанга россия / красноярский край / хатанга"
  },
  "1168": {
    "id": "1168",
    "name": "Шарыпово",
    "path": "Россия / Красноярский край / Шарыпово",
    "country": "Россия",
    "searchString": "шарыпово россия / красноярский край / шарыпово"
  },
  "1169": {
    "id": "1169",
    "name": "Республика Тыва",
    "path": "Россия / Республика Тыва",
    "country": "Россия",
    "searchString": "республика тыва россия / республика тыва"
  },
  "1170": {
    "id": "1170",
    "name": "Ак-Довурак",
    "path": "Россия / Республика Тыва / Ак-Довурак",
    "country": "Россия",
    "searchString": "ак-довурак россия / республика тыва / ак-довурак"
  },
  "1171": {
    "id": "1171",
    "name": "Туран",
    "path": "Россия / Республика Тыва / Туран",
    "country": "Россия",
    "searchString": "туран россия / республика тыва / туран"
  },
  "1172": {
    "id": "1172",
    "name": "Чадан",
    "path": "Россия / Республика Тыва / Чадан",
    "country": "Россия",
    "searchString": "чадан россия / республика тыва / чадан"
  },
  "1173": {
    "id": "1173",
    "name": "Шагонар",
    "path": "Россия / Республика Тыва / Шагонар",
    "country": "Россия",
    "searchString": "шагонар россия / республика тыва / шагонар"
  },
  "1174": {
    "id": "1174",
    "name": "Республика Саха (Якутия)",
    "path": "Россия / Республика Саха (Якутия)",
    "country": "Россия",
    "searchString": "республика саха (якутия) россия / республика саха (якутия)"
  },
  "1175": {
    "id": "1175",
    "name": "Алдан",
    "path": "Россия / Республика Саха (Якутия) / Алдан",
    "country": "Россия",
    "searchString": "алдан россия / республика саха (якутия) / алдан"
  },
  "1176": {
    "id": "1176",
    "name": "Верхоянск",
    "path": "Россия / Республика Саха (Якутия) / Верхоянск",
    "country": "Россия",
    "searchString": "верхоянск россия / республика саха (якутия) / верхоянск"
  },
  "1177": {
    "id": "1177",
    "name": "Вилюйск",
    "path": "Россия / Республика Саха (Якутия) / Вилюйск",
    "country": "Россия",
    "searchString": "вилюйск россия / республика саха (якутия) / вилюйск"
  },
  "1178": {
    "id": "1178",
    "name": "Ленск",
    "path": "Россия / Республика Саха (Якутия) / Ленск",
    "country": "Россия",
    "searchString": "ленск россия / республика саха (якутия) / ленск"
  },
  "1179": {
    "id": "1179",
    "name": "Мирный (Республика Саха (Якутия))",
    "path": "Россия / Республика Саха (Якутия) / Мирный (Республика Саха (Якутия))",
    "country": "Россия",
    "searchString": "мирный (республика саха (якутия)) россия / республика саха (якутия) / мирный (республика саха (якутия))"
  },
  "1180": {
    "id": "1180",
    "name": "Нерюнгри",
    "path": "Россия / Республика Саха (Якутия) / Нерюнгри",
    "country": "Россия",
    "searchString": "нерюнгри россия / республика саха (якутия) / нерюнгри"
  },
  "1181": {
    "id": "1181",
    "name": "Нюрба",
    "path": "Россия / Республика Саха (Якутия) / Нюрба",
    "country": "Россия",
    "searchString": "нюрба россия / республика саха (якутия) / нюрба"
  },
  "1182": {
    "id": "1182",
    "name": "Олекминск",
    "path": "Россия / Республика Саха (Якутия) / Олекминск",
    "country": "Россия",
    "searchString": "олекминск россия / республика саха (якутия) / олекминск"
  },
  "1183": {
    "id": "1183",
    "name": "Покровск (Якутия)",
    "path": "Россия / Республика Саха (Якутия) / Покровск (Якутия)",
    "country": "Россия",
    "searchString": "покровск (якутия) россия / республика саха (якутия) / покровск (якутия)"
  },
  "1184": {
    "id": "1184",
    "name": "Среднеколымск",
    "path": "Россия / Республика Саха (Якутия) / Среднеколымск",
    "country": "Россия",
    "searchString": "среднеколымск россия / республика саха (якутия) / среднеколымск"
  },
  "1185": {
    "id": "1185",
    "name": "Томмот",
    "path": "Россия / Республика Саха (Якутия) / Томмот",
    "country": "Россия",
    "searchString": "томмот россия / республика саха (якутия) / томмот"
  },
  "1186": {
    "id": "1186",
    "name": "Удачный",
    "path": "Россия / Республика Саха (Якутия) / Удачный",
    "country": "Россия",
    "searchString": "удачный россия / республика саха (якутия) / удачный"
  },
  "1187": {
    "id": "1187",
    "name": "Республика Хакасия",
    "path": "Россия / Республика Хакасия",
    "country": "Россия",
    "searchString": "республика хакасия россия / республика хакасия"
  },
  "1188": {
    "id": "1188",
    "name": "Абаза",
    "path": "Россия / Республика Хакасия / Абаза",
    "country": "Россия",
    "searchString": "абаза россия / республика хакасия / абаза"
  },
  "1189": {
    "id": "1189",
    "name": "Саяногорск",
    "path": "Россия / Республика Хакасия / Саяногорск",
    "country": "Россия",
    "searchString": "саяногорск россия / республика хакасия / саяногорск"
  },
  "1190": {
    "id": "1190",
    "name": "Сорск",
    "path": "Россия / Республика Хакасия / Сорск",
    "country": "Россия",
    "searchString": "сорск россия / республика хакасия / сорск"
  },
  "1191": {
    "id": "1191",
    "name": "Черногорск",
    "path": "Россия / Республика Хакасия / Черногорск",
    "country": "Россия",
    "searchString": "черногорск россия / республика хакасия / черногорск"
  },
  "1192": {
    "id": "1192",
    "name": "Забайкальский край",
    "path": "Россия / Забайкальский край",
    "country": "Россия",
    "searchString": "забайкальский край россия / забайкальский край"
  },
  "1193": {
    "id": "1193",
    "name": "Балей",
    "path": "Россия / Забайкальский край / Балей",
    "country": "Россия",
    "searchString": "балей россия / забайкальский край / балей"
  },
  "1194": {
    "id": "1194",
    "name": "Борзя",
    "path": "Россия / Забайкальский край / Борзя",
    "country": "Россия",
    "searchString": "борзя россия / забайкальский край / борзя"
  },
  "1195": {
    "id": "1195",
    "name": "Краснокаменск",
    "path": "Россия / Забайкальский край / Краснокаменск",
    "country": "Россия",
    "searchString": "краснокаменск россия / забайкальский край / краснокаменск"
  },
  "1196": {
    "id": "1196",
    "name": "Могоча",
    "path": "Россия / Забайкальский край / Могоча",
    "country": "Россия",
    "searchString": "могоча россия / забайкальский край / могоча"
  },
  "1197": {
    "id": "1197",
    "name": "Нерчинск",
    "path": "Россия / Забайкальский край / Нерчинск",
    "country": "Россия",
    "searchString": "нерчинск россия / забайкальский край / нерчинск"
  },
  "1198": {
    "id": "1198",
    "name": "Петровск-Забайкальский",
    "path": "Россия / Забайкальский край / Петровск-Забайкальский",
    "country": "Россия",
    "searchString": "петровск-забайкальский россия / забайкальский край / петровск-забайкальский"
  },
  "1199": {
    "id": "1199",
    "name": "Сретенск",
    "path": "Россия / Забайкальский край / Сретенск",
    "country": "Россия",
    "searchString": "сретенск россия / забайкальский край / сретенск"
  },
  "1200": {
    "id": "1200",
    "name": "Хилок",
    "path": "Россия / Забайкальский край / Хилок",
    "country": "Россия",
    "searchString": "хилок россия / забайкальский край / хилок"
  },
  "1201": {
    "id": "1201",
    "name": "Шилка",
    "path": "Россия / Забайкальский край / Шилка",
    "country": "Россия",
    "searchString": "шилка россия / забайкальский край / шилка"
  },
  "1202": {
    "id": "1202",
    "name": "Новосибирская область",
    "path": "Россия / Новосибирская область",
    "country": "Россия",
    "searchString": "новосибирская область россия / новосибирская область"
  },
  "1203": {
    "id": "1203",
    "name": "Барабинск",
    "path": "Россия / Новосибирская область / Барабинск",
    "country": "Россия",
    "searchString": "барабинск россия / новосибирская область / барабинск"
  },
  "1204": {
    "id": "1204",
    "name": "Бердск",
    "path": "Россия / Новосибирская область / Бердск",
    "country": "Россия",
    "searchString": "бердск россия / новосибирская область / бердск"
  },
  "1205": {
    "id": "1205",
    "name": "Болотное",
    "path": "Россия / Новосибирская область / Болотное",
    "country": "Россия",
    "searchString": "болотное россия / новосибирская область / болотное"
  },
  "1206": {
    "id": "1206",
    "name": "Искитим",
    "path": "Россия / Новосибирская область / Искитим",
    "country": "Россия",
    "searchString": "искитим россия / новосибирская область / искитим"
  },
  "1207": {
    "id": "1207",
    "name": "Карасук",
    "path": "Россия / Новосибирская область / Карасук",
    "country": "Россия",
    "searchString": "карасук россия / новосибирская область / карасук"
  },
  "1208": {
    "id": "1208",
    "name": "Каргат",
    "path": "Россия / Новосибирская область / Каргат",
    "country": "Россия",
    "searchString": "каргат россия / новосибирская область / каргат"
  },
  "1209": {
    "id": "1209",
    "name": "Куйбышев",
    "path": "Россия / Новосибирская область / Куйбышев",
    "country": "Россия",
    "searchString": "куйбышев россия / новосибирская область / куйбышев"
  },
  "1210": {
    "id": "1210",
    "name": "Купино",
    "path": "Россия / Новосибирская область / Купино",
    "country": "Россия",
    "searchString": "купино россия / новосибирская область / купино"
  },
  "1211": {
    "id": "1211",
    "name": "Обь",
    "path": "Россия / Новосибирская область / Обь",
    "country": "Россия",
    "searchString": "обь россия / новосибирская область / обь"
  },
  "1212": {
    "id": "1212",
    "name": "Татарск",
    "path": "Россия / Новосибирская область / Татарск",
    "country": "Россия",
    "searchString": "татарск россия / новосибирская область / татарск"
  },
  "1213": {
    "id": "1213",
    "name": "Тогучин",
    "path": "Россия / Новосибирская область / Тогучин",
    "country": "Россия",
    "searchString": "тогучин россия / новосибирская область / тогучин"
  },
  "1214": {
    "id": "1214",
    "name": "Черепаново",
    "path": "Россия / Новосибирская область / Черепаново",
    "country": "Россия",
    "searchString": "черепаново россия / новосибирская область / черепаново"
  },
  "1215": {
    "id": "1215",
    "name": "Чулым",
    "path": "Россия / Новосибирская область / Чулым",
    "country": "Россия",
    "searchString": "чулым россия / новосибирская область / чулым"
  },
  "1216": {
    "id": "1216",
    "name": "Республика Алтай",
    "path": "Россия / Республика Алтай",
    "country": "Россия",
    "searchString": "республика алтай россия / республика алтай"
  },
  "1217": {
    "id": "1217",
    "name": "Алтайский край",
    "path": "Россия / Алтайский край",
    "country": "Россия",
    "searchString": "алтайский край россия / алтайский край"
  },
  "1218": {
    "id": "1218",
    "name": "Алейск",
    "path": "Россия / Алтайский край / Алейск",
    "country": "Россия",
    "searchString": "алейск россия / алтайский край / алейск"
  },
  "1219": {
    "id": "1219",
    "name": "Белокуриха",
    "path": "Россия / Алтайский край / Белокуриха",
    "country": "Россия",
    "searchString": "белокуриха россия / алтайский край / белокуриха"
  },
  "1220": {
    "id": "1220",
    "name": "Бийск",
    "path": "Россия / Алтайский край / Бийск",
    "country": "Россия",
    "searchString": "бийск россия / алтайский край / бийск"
  },
  "1221": {
    "id": "1221",
    "name": "Горняк",
    "path": "Россия / Алтайский край / Горняк",
    "country": "Россия",
    "searchString": "горняк россия / алтайский край / горняк"
  },
  "1222": {
    "id": "1222",
    "name": "Заринск",
    "path": "Россия / Алтайский край / Заринск",
    "country": "Россия",
    "searchString": "заринск россия / алтайский край / заринск"
  },
  "1223": {
    "id": "1223",
    "name": "Змеиногорск",
    "path": "Россия / Алтайский край / Змеиногорск",
    "country": "Россия",
    "searchString": "змеиногорск россия / алтайский край / змеиногорск"
  },
  "1224": {
    "id": "1224",
    "name": "Камень-на-Оби",
    "path": "Россия / Алтайский край / Камень-на-Оби",
    "country": "Россия",
    "searchString": "камень-на-оби россия / алтайский край / камень-на-оби"
  },
  "1225": {
    "id": "1225",
    "name": "Новоалтайск",
    "path": "Россия / Алтайский край / Новоалтайск",
    "country": "Россия",
    "searchString": "новоалтайск россия / алтайский край / новоалтайск"
  },
  "1226": {
    "id": "1226",
    "name": "Рубцовск",
    "path": "Россия / Алтайский край / Рубцовск",
    "country": "Россия",
    "searchString": "рубцовск россия / алтайский край / рубцовск"
  },
  "1227": {
    "id": "1227",
    "name": "Славгород (Алтайский край)",
    "path": "Россия / Алтайский край / Славгород (Алтайский край)",
    "country": "Россия",
    "searchString": "славгород (алтайский край) россия / алтайский край / славгород (алтайский край)"
  },
  "1228": {
    "id": "1228",
    "name": "Яровое",
    "path": "Россия / Алтайский край / Яровое",
    "country": "Россия",
    "searchString": "яровое россия / алтайский край / яровое"
  },
  "1229": {
    "id": "1229",
    "name": "Кемеровская область",
    "path": "Россия / Кемеровская область",
    "country": "Россия",
    "searchString": "кемеровская область россия / кемеровская область"
  },
  "1230": {
    "id": "1230",
    "name": "Анжеро-Судженск",
    "path": "Россия / Кемеровская область / Анжеро-Судженск",
    "country": "Россия",
    "searchString": "анжеро-судженск россия / кемеровская область / анжеро-судженск"
  },
  "1231": {
    "id": "1231",
    "name": "Белово",
    "path": "Россия / Кемеровская область / Белово",
    "country": "Россия",
    "searchString": "белово россия / кемеровская область / белово"
  },
  "1232": {
    "id": "1232",
    "name": "Березовский (Кемеровская область)",
    "path": "Россия / Кемеровская область / Березовский (Кемеровская область)",
    "country": "Россия",
    "searchString": "березовский (кемеровская область) россия / кемеровская область / березовский (кемеровская область)"
  },
  "1233": {
    "id": "1233",
    "name": "Гурьевск (Кемеровская область)",
    "path": "Россия / Кемеровская область / Гурьевск (Кемеровская область)",
    "country": "Россия",
    "searchString": "гурьевск (кемеровская область) россия / кемеровская область / гурьевск (кемеровская область)"
  },
  "1234": {
    "id": "1234",
    "name": "Калтан",
    "path": "Россия / Кемеровская область / Калтан",
    "country": "Россия",
    "searchString": "калтан россия / кемеровская область / калтан"
  },
  "1235": {
    "id": "1235",
    "name": "Киселевск",
    "path": "Россия / Кемеровская область / Киселевск",
    "country": "Россия",
    "searchString": "киселевск россия / кемеровская область / киселевск"
  },
  "1236": {
    "id": "1236",
    "name": "Ленинск-Кузнецкий",
    "path": "Россия / Кемеровская область / Ленинск-Кузнецкий",
    "country": "Россия",
    "searchString": "ленинск-кузнецкий россия / кемеровская область / ленинск-кузнецкий"
  },
  "1237": {
    "id": "1237",
    "name": "Мариинск",
    "path": "Россия / Кемеровская область / Мариинск",
    "country": "Россия",
    "searchString": "мариинск россия / кемеровская область / мариинск"
  },
  "1238": {
    "id": "1238",
    "name": "Междуреченск",
    "path": "Россия / Кемеровская область / Междуреченск",
    "country": "Россия",
    "searchString": "междуреченск россия / кемеровская область / междуреченск"
  },
  "1239": {
    "id": "1239",
    "name": "Мыски",
    "path": "Россия / Кемеровская область / Мыски",
    "country": "Россия",
    "searchString": "мыски россия / кемеровская область / мыски"
  },
  "1240": {
    "id": "1240",
    "name": "Новокузнецк",
    "path": "Россия / Кемеровская область / Новокузнецк",
    "country": "Россия",
    "searchString": "новокузнецк россия / кемеровская область / новокузнецк"
  },
  "1241": {
    "id": "1241",
    "name": "Осинники",
    "path": "Россия / Кемеровская область / Осинники",
    "country": "Россия",
    "searchString": "осинники россия / кемеровская область / осинники"
  },
  "1242": {
    "id": "1242",
    "name": "Полысаево",
    "path": "Россия / Кемеровская область / Полысаево",
    "country": "Россия",
    "searchString": "полысаево россия / кемеровская область / полысаево"
  },
  "1243": {
    "id": "1243",
    "name": "Прокопьевск",
    "path": "Россия / Кемеровская область / Прокопьевск",
    "country": "Россия",
    "searchString": "прокопьевск россия / кемеровская область / прокопьевск"
  },
  "1244": {
    "id": "1244",
    "name": "Салаир",
    "path": "Россия / Кемеровская область / Салаир",
    "country": "Россия",
    "searchString": "салаир россия / кемеровская область / салаир"
  },
  "1245": {
    "id": "1245",
    "name": "Тайга",
    "path": "Россия / Кемеровская область / Тайга",
    "country": "Россия",
    "searchString": "тайга россия / кемеровская область / тайга"
  },
  "1246": {
    "id": "1246",
    "name": "Таштагол",
    "path": "Россия / Кемеровская область / Таштагол",
    "country": "Россия",
    "searchString": "таштагол россия / кемеровская область / таштагол"
  },
  "1247": {
    "id": "1247",
    "name": "Топки",
    "path": "Россия / Кемеровская область / Топки",
    "country": "Россия",
    "searchString": "топки россия / кемеровская область / топки"
  },
  "1248": {
    "id": "1248",
    "name": "Юрга",
    "path": "Россия / Кемеровская область / Юрга",
    "country": "Россия",
    "searchString": "юрга россия / кемеровская область / юрга"
  },
  "1249": {
    "id": "1249",
    "name": "Омская область",
    "path": "Россия / Омская область",
    "country": "Россия",
    "searchString": "омская область россия / омская область"
  },
  "1250": {
    "id": "1250",
    "name": "Исилькуль",
    "path": "Россия / Омская область / Исилькуль",
    "country": "Россия",
    "searchString": "исилькуль россия / омская область / исилькуль"
  },
  "1251": {
    "id": "1251",
    "name": "Калачинск",
    "path": "Россия / Омская область / Калачинск",
    "country": "Россия",
    "searchString": "калачинск россия / омская область / калачинск"
  },
  "1252": {
    "id": "1252",
    "name": "Называевск",
    "path": "Россия / Омская область / Называевск",
    "country": "Россия",
    "searchString": "называевск россия / омская область / называевск"
  },
  "1253": {
    "id": "1253",
    "name": "Тара",
    "path": "Россия / Омская область / Тара",
    "country": "Россия",
    "searchString": "тара россия / омская область / тара"
  },
  "1254": {
    "id": "1254",
    "name": "Тюкалинск",
    "path": "Россия / Омская область / Тюкалинск",
    "country": "Россия",
    "searchString": "тюкалинск россия / омская область / тюкалинск"
  },
  "1255": {
    "id": "1255",
    "name": "Томская область",
    "path": "Россия / Томская область",
    "country": "Россия",
    "searchString": "томская область россия / томская область"
  },
  "1256": {
    "id": "1256",
    "name": "Асино",
    "path": "Россия / Томская область / Асино",
    "country": "Россия",
    "searchString": "асино россия / томская область / асино"
  },
  "1257": {
    "id": "1257",
    "name": "Кедровый",
    "path": "Россия / Томская область / Кедровый",
    "country": "Россия",
    "searchString": "кедровый россия / томская область / кедровый"
  },
  "1258": {
    "id": "1258",
    "name": "Колпашево",
    "path": "Россия / Томская область / Колпашево",
    "country": "Россия",
    "searchString": "колпашево россия / томская область / колпашево"
  },
  "1259": {
    "id": "1259",
    "name": "Северск (Томская область)",
    "path": "Россия / Томская область / Северск (Томская область)",
    "country": "Россия",
    "searchString": "северск (томская область) россия / томская область / северск (томская область)"
  },
  "1260": {
    "id": "1260",
    "name": "Стрежевой",
    "path": "Россия / Томская область / Стрежевой",
    "country": "Россия",
    "searchString": "стрежевой россия / томская область / стрежевой"
  },
  "1261": {
    "id": "1261",
    "name": "Свердловская область",
    "path": "Россия / Свердловская область",
    "country": "Россия",
    "searchString": "свердловская область россия / свердловская область"
  },
  "1262": {
    "id": "1262",
    "name": "Алапаевск",
    "path": "Россия / Свердловская область / Алапаевск",
    "country": "Россия",
    "searchString": "алапаевск россия / свердловская область / алапаевск"
  },
  "1263": {
    "id": "1263",
    "name": "Арамиль",
    "path": "Россия / Свердловская область / Арамиль",
    "country": "Россия",
    "searchString": "арамиль россия / свердловская область / арамиль"
  },
  "1264": {
    "id": "1264",
    "name": "Артемовский (Свердловская область)",
    "path": "Россия / Свердловская область / Артемовский (Свердловская область)",
    "country": "Россия",
    "searchString": "артемовский (свердловская область) россия / свердловская область / артемовский (свердловская область)"
  },
  "1265": {
    "id": "1265",
    "name": "Асбест",
    "path": "Россия / Свердловская область / Асбест",
    "country": "Россия",
    "searchString": "асбест россия / свердловская область / асбест"
  },
  "1266": {
    "id": "1266",
    "name": "Березовский (Свердловская область)",
    "path": "Россия / Свердловская область / Березовский (Свердловская область)",
    "country": "Россия",
    "searchString": "березовский (свердловская область) россия / свердловская область / березовский (свердловская область)"
  },
  "1267": {
    "id": "1267",
    "name": "Богданович",
    "path": "Россия / Свердловская область / Богданович",
    "country": "Россия",
    "searchString": "богданович россия / свердловская область / богданович"
  },
  "1268": {
    "id": "1268",
    "name": "Верхний Тагил",
    "path": "Россия / Свердловская область / Верхний Тагил",
    "country": "Россия",
    "searchString": "верхний тагил россия / свердловская область / верхний тагил"
  },
  "1269": {
    "id": "1269",
    "name": "Верхняя Пышма",
    "path": "Россия / Свердловская область / Верхняя Пышма",
    "country": "Россия",
    "searchString": "верхняя пышма россия / свердловская область / верхняя пышма"
  },
  "1270": {
    "id": "1270",
    "name": "Верхняя Салда",
    "path": "Россия / Свердловская область / Верхняя Салда",
    "country": "Россия",
    "searchString": "верхняя салда россия / свердловская область / верхняя салда"
  },
  "1271": {
    "id": "1271",
    "name": "Верхняя Тура",
    "path": "Россия / Свердловская область / Верхняя Тура",
    "country": "Россия",
    "searchString": "верхняя тура россия / свердловская область / верхняя тура"
  },
  "1272": {
    "id": "1272",
    "name": "Верхотурье",
    "path": "Россия / Свердловская область / Верхотурье",
    "country": "Россия",
    "searchString": "верхотурье россия / свердловская область / верхотурье"
  },
  "1273": {
    "id": "1273",
    "name": "Волчанск (Свердловская область)",
    "path": "Россия / Свердловская область / Волчанск (Свердловская область)",
    "country": "Россия",
    "searchString": "волчанск (свердловская область) россия / свердловская область / волчанск (свердловская область)"
  },
  "1274": {
    "id": "1274",
    "name": "Дегтярск",
    "path": "Россия / Свердловская область / Дегтярск",
    "country": "Россия",
    "searchString": "дегтярск россия / свердловская область / дегтярск"
  },
  "1275": {
    "id": "1275",
    "name": "Заречный (Свердловская область)",
    "path": "Россия / Свердловская область / Заречный (Свердловская область)",
    "country": "Россия",
    "searchString": "заречный (свердловская область) россия / свердловская область / заречный (свердловская область)"
  },
  "1276": {
    "id": "1276",
    "name": "Ивдель",
    "path": "Россия / Свердловская область / Ивдель",
    "country": "Россия",
    "searchString": "ивдель россия / свердловская область / ивдель"
  },
  "1277": {
    "id": "1277",
    "name": "Ирбит",
    "path": "Россия / Свердловская область / Ирбит",
    "country": "Россия",
    "searchString": "ирбит россия / свердловская область / ирбит"
  },
  "1278": {
    "id": "1278",
    "name": "Каменск-Уральский",
    "path": "Россия / Свердловская область / Каменск-Уральский",
    "country": "Россия",
    "searchString": "каменск-уральский россия / свердловская область / каменск-уральский"
  },
  "1279": {
    "id": "1279",
    "name": "Камышлов",
    "path": "Россия / Свердловская область / Камышлов",
    "country": "Россия",
    "searchString": "камышлов россия / свердловская область / камышлов"
  },
  "1280": {
    "id": "1280",
    "name": "Карпинск",
    "path": "Россия / Свердловская область / Карпинск",
    "country": "Россия",
    "searchString": "карпинск россия / свердловская область / карпинск"
  },
  "1281": {
    "id": "1281",
    "name": "Качканар",
    "path": "Россия / Свердловская область / Качканар",
    "country": "Россия",
    "searchString": "качканар россия / свердловская область / качканар"
  },
  "1282": {
    "id": "1282",
    "name": "Кировград",
    "path": "Россия / Свердловская область / Кировград",
    "country": "Россия",
    "searchString": "кировград россия / свердловская область / кировград"
  },
  "1283": {
    "id": "1283",
    "name": "Краснотурьинск",
    "path": "Россия / Свердловская область / Краснотурьинск",
    "country": "Россия",
    "searchString": "краснотурьинск россия / свердловская область / краснотурьинск"
  },
  "1284": {
    "id": "1284",
    "name": "Красноуральск",
    "path": "Россия / Свердловская область / Красноуральск",
    "country": "Россия",
    "searchString": "красноуральск россия / свердловская область / красноуральск"
  },
  "1285": {
    "id": "1285",
    "name": "Красноуфимск",
    "path": "Россия / Свердловская область / Красноуфимск",
    "country": "Россия",
    "searchString": "красноуфимск россия / свердловская область / красноуфимск"
  },
  "1286": {
    "id": "1286",
    "name": "Кушва",
    "path": "Россия / Свердловская область / Кушва",
    "country": "Россия",
    "searchString": "кушва россия / свердловская область / кушва"
  },
  "1287": {
    "id": "1287",
    "name": "Лесной",
    "path": "Россия / Свердловская область / Лесной",
    "country": "Россия",
    "searchString": "лесной россия / свердловская область / лесной"
  },
  "1288": {
    "id": "1288",
    "name": "Михайловск (Свердловская область)",
    "path": "Россия / Свердловская область / Михайловск (Свердловская область)",
    "country": "Россия",
    "searchString": "михайловск (свердловская область) россия / свердловская область / михайловск (свердловская область)"
  },
  "1289": {
    "id": "1289",
    "name": "Невьянск",
    "path": "Россия / Свердловская область / Невьянск",
    "country": "Россия",
    "searchString": "невьянск россия / свердловская область / невьянск"
  },
  "1290": {
    "id": "1290",
    "name": "Нижние Серги",
    "path": "Россия / Свердловская область / Нижние Серги",
    "country": "Россия",
    "searchString": "нижние серги россия / свердловская область / нижние серги"
  },
  "1291": {
    "id": "1291",
    "name": "Нижний Тагил",
    "path": "Россия / Свердловская область / Нижний Тагил",
    "country": "Россия",
    "searchString": "нижний тагил россия / свердловская область / нижний тагил"
  },
  "1292": {
    "id": "1292",
    "name": "Нижняя Салда",
    "path": "Россия / Свердловская область / Нижняя Салда",
    "country": "Россия",
    "searchString": "нижняя салда россия / свердловская область / нижняя салда"
  },
  "1293": {
    "id": "1293",
    "name": "Нижняя Тура",
    "path": "Россия / Свердловская область / Нижняя Тура",
    "country": "Россия",
    "searchString": "нижняя тура россия / свердловская область / нижняя тура"
  },
  "1294": {
    "id": "1294",
    "name": "Новая Ляля",
    "path": "Россия / Свердловская область / Новая Ляля",
    "country": "Россия",
    "searchString": "новая ляля россия / свердловская область / новая ляля"
  },
  "1295": {
    "id": "1295",
    "name": "Новоуральск",
    "path": "Россия / Свердловская область / Новоуральск",
    "country": "Россия",
    "searchString": "новоуральск россия / свердловская область / новоуральск"
  },
  "1296": {
    "id": "1296",
    "name": "Первоуральск",
    "path": "Россия / Свердловская область / Первоуральск",
    "country": "Россия",
    "searchString": "первоуральск россия / свердловская область / первоуральск"
  },
  "1297": {
    "id": "1297",
    "name": "Полевской",
    "path": "Россия / Свердловская область / Полевской",
    "country": "Россия",
    "searchString": "полевской россия / свердловская область / полевской"
  },
  "1298": {
    "id": "1298",
    "name": "Ревда (Свердловская область)",
    "path": "Россия / Свердловская область / Ревда (Свердловская область)",
    "country": "Россия",
    "searchString": "ревда (свердловская область) россия / свердловская область / ревда (свердловская область)"
  },
  "1299": {
    "id": "1299",
    "name": "Реж",
    "path": "Россия / Свердловская область / Реж",
    "country": "Россия",
    "searchString": "реж россия / свердловская область / реж"
  },
  "1300": {
    "id": "1300",
    "name": "Североуральск",
    "path": "Россия / Свердловская область / Североуральск",
    "country": "Россия",
    "searchString": "североуральск россия / свердловская область / североуральск"
  },
  "1301": {
    "id": "1301",
    "name": "Серов",
    "path": "Россия / Свердловская область / Серов",
    "country": "Россия",
    "searchString": "серов россия / свердловская область / серов"
  },
  "1302": {
    "id": "1302",
    "name": "Среднеуральск",
    "path": "Россия / Свердловская область / Среднеуральск",
    "country": "Россия",
    "searchString": "среднеуральск россия / свердловская область / среднеуральск"
  },
  "1303": {
    "id": "1303",
    "name": "Сухой Лог",
    "path": "Россия / Свердловская область / Сухой Лог",
    "country": "Россия",
    "searchString": "сухой лог россия / свердловская область / сухой лог"
  },
  "1304": {
    "id": "1304",
    "name": "Сысерть",
    "path": "Россия / Свердловская область / Сысерть",
    "country": "Россия",
    "searchString": "сысерть россия / свердловская область / сысерть"
  },
  "1305": {
    "id": "1305",
    "name": "Тавда",
    "path": "Россия / Свердловская область / Тавда",
    "country": "Россия",
    "searchString": "тавда россия / свердловская область / тавда"
  },
  "1306": {
    "id": "1306",
    "name": "Талица",
    "path": "Россия / Свердловская область / Талица",
    "country": "Россия",
    "searchString": "талица россия / свердловская область / талица"
  },
  "1307": {
    "id": "1307",
    "name": "Туринск",
    "path": "Россия / Свердловская область / Туринск",
    "country": "Россия",
    "searchString": "туринск россия / свердловская область / туринск"
  },
  "1308": {
    "id": "1308",
    "name": "Курганская область",
    "path": "Россия / Курганская область",
    "country": "Россия",
    "searchString": "курганская область россия / курганская область"
  },
  "1309": {
    "id": "1309",
    "name": "Далматово",
    "path": "Россия / Курганская область / Далматово",
    "country": "Россия",
    "searchString": "далматово россия / курганская область / далматово"
  },
  "1310": {
    "id": "1310",
    "name": "Катайск",
    "path": "Россия / Курганская область / Катайск",
    "country": "Россия",
    "searchString": "катайск россия / курганская область / катайск"
  },
  "1311": {
    "id": "1311",
    "name": "Куртамыш",
    "path": "Россия / Курганская область / Куртамыш",
    "country": "Россия",
    "searchString": "куртамыш россия / курганская область / куртамыш"
  },
  "1312": {
    "id": "1312",
    "name": "Макушино",
    "path": "Россия / Курганская область / Макушино",
    "country": "Россия",
    "searchString": "макушино россия / курганская область / макушино"
  },
  "1313": {
    "id": "1313",
    "name": "Петухово",
    "path": "Россия / Курганская область / Петухово",
    "country": "Россия",
    "searchString": "петухово россия / курганская область / петухово"
  },
  "1314": {
    "id": "1314",
    "name": "Шадринск",
    "path": "Россия / Курганская область / Шадринск",
    "country": "Россия",
    "searchString": "шадринск россия / курганская область / шадринск"
  },
  "1315": {
    "id": "1315",
    "name": "Шумиха",
    "path": "Россия / Курганская область / Шумиха",
    "country": "Россия",
    "searchString": "шумиха россия / курганская область / шумиха"
  },
  "1316": {
    "id": "1316",
    "name": "Щучье",
    "path": "Россия / Курганская область / Щучье",
    "country": "Россия",
    "searchString": "щучье россия / курганская область / щучье"
  },
  "1317": {
    "id": "1317",
    "name": "Пермский край",
    "path": "Россия / Пермский край",
    "country": "Россия",
    "searchString": "пермский край россия / пермский край"
  },
  "1318": {
    "id": "1318",
    "name": "Александровск (Пермский край)",
    "path": "Россия / Пермский край / Александровск (Пермский край)",
    "country": "Россия",
    "searchString": "александровск (пермский край) россия / пермский край / александровск (пермский край)"
  },
  "1319": {
    "id": "1319",
    "name": "Березники",
    "path": "Россия / Пермский край / Березники",
    "country": "Россия",
    "searchString": "березники россия / пермский край / березники"
  },
  "1320": {
    "id": "1320",
    "name": "Верещагино",
    "path": "Россия / Пермский край / Верещагино",
    "country": "Россия",
    "searchString": "верещагино россия / пермский край / верещагино"
  },
  "1321": {
    "id": "1321",
    "name": "Горнозаводск",
    "path": "Россия / Пермский край / Горнозаводск",
    "country": "Россия",
    "searchString": "горнозаводск россия / пермский край / горнозаводск"
  },
  "1322": {
    "id": "1322",
    "name": "Гремячинск",
    "path": "Россия / Пермский край / Гремячинск",
    "country": "Россия",
    "searchString": "гремячинск россия / пермский край / гремячинск"
  },
  "1323": {
    "id": "1323",
    "name": "Губаха",
    "path": "Россия / Пермский край / Губаха",
    "country": "Россия",
    "searchString": "губаха россия / пермский край / губаха"
  },
  "1324": {
    "id": "1324",
    "name": "Добрянка",
    "path": "Россия / Пермский край / Добрянка",
    "country": "Россия",
    "searchString": "добрянка россия / пермский край / добрянка"
  },
  "1325": {
    "id": "1325",
    "name": "Кизел",
    "path": "Россия / Пермский край / Кизел",
    "country": "Россия",
    "searchString": "кизел россия / пермский край / кизел"
  },
  "1326": {
    "id": "1326",
    "name": "Красновишерск",
    "path": "Россия / Пермский край / Красновишерск",
    "country": "Россия",
    "searchString": "красновишерск россия / пермский край / красновишерск"
  },
  "1327": {
    "id": "1327",
    "name": "Краснокамск",
    "path": "Россия / Пермский край / Краснокамск",
    "country": "Россия",
    "searchString": "краснокамск россия / пермский край / краснокамск"
  },
  "1328": {
    "id": "1328",
    "name": "Кудымкар",
    "path": "Россия / Пермский край / Кудымкар",
    "country": "Россия",
    "searchString": "кудымкар россия / пермский край / кудымкар"
  },
  "1329": {
    "id": "1329",
    "name": "Кунгур",
    "path": "Россия / Пермский край / Кунгур",
    "country": "Россия",
    "searchString": "кунгур россия / пермский край / кунгур"
  },
  "1330": {
    "id": "1330",
    "name": "Лысьва",
    "path": "Россия / Пермский край / Лысьва",
    "country": "Россия",
    "searchString": "лысьва россия / пермский край / лысьва"
  },
  "1331": {
    "id": "1331",
    "name": "Нытва",
    "path": "Россия / Пермский край / Нытва",
    "country": "Россия",
    "searchString": "нытва россия / пермский край / нытва"
  },
  "1332": {
    "id": "1332",
    "name": "Оса",
    "path": "Россия / Пермский край / Оса",
    "country": "Россия",
    "searchString": "оса россия / пермский край / оса"
  },
  "1333": {
    "id": "1333",
    "name": "Оханск",
    "path": "Россия / Пермский край / Оханск",
    "country": "Россия",
    "searchString": "оханск россия / пермский край / оханск"
  },
  "1334": {
    "id": "1334",
    "name": "Очер",
    "path": "Россия / Пермский край / Очер",
    "country": "Россия",
    "searchString": "очер россия / пермский край / очер"
  },
  "1335": {
    "id": "1335",
    "name": "Соликамск",
    "path": "Россия / Пермский край / Соликамск",
    "country": "Россия",
    "searchString": "соликамск россия / пермский край / соликамск"
  },
  "1336": {
    "id": "1336",
    "name": "Усолье",
    "path": "Россия / Пермский край / Усолье",
    "country": "Россия",
    "searchString": "усолье россия / пермский край / усолье"
  },
  "1337": {
    "id": "1337",
    "name": "Чайковский",
    "path": "Россия / Пермский край / Чайковский",
    "country": "Россия",
    "searchString": "чайковский россия / пермский край / чайковский"
  },
  "1338": {
    "id": "1338",
    "name": "Чердынь",
    "path": "Россия / Пермский край / Чердынь",
    "country": "Россия",
    "searchString": "чердынь россия / пермский край / чердынь"
  },
  "1339": {
    "id": "1339",
    "name": "Чермоз",
    "path": "Россия / Пермский край / Чермоз",
    "country": "Россия",
    "searchString": "чермоз россия / пермский край / чермоз"
  },
  "1340": {
    "id": "1340",
    "name": "Чернушка",
    "path": "Россия / Пермский край / Чернушка",
    "country": "Россия",
    "searchString": "чернушка россия / пермский край / чернушка"
  },
  "1341": {
    "id": "1341",
    "name": "Чусовой",
    "path": "Россия / Пермский край / Чусовой",
    "country": "Россия",
    "searchString": "чусовой россия / пермский край / чусовой"
  },
  "1342": {
    "id": "1342",
    "name": "Тюменская область",
    "path": "Россия / Тюменская область",
    "country": "Россия",
    "searchString": "тюменская область россия / тюменская область"
  },
  "1343": {
    "id": "1343",
    "name": "Заводоуковск",
    "path": "Россия / Тюменская область / Заводоуковск",
    "country": "Россия",
    "searchString": "заводоуковск россия / тюменская область / заводоуковск"
  },
  "1344": {
    "id": "1344",
    "name": "Ишим",
    "path": "Россия / Тюменская область / Ишим",
    "country": "Россия",
    "searchString": "ишим россия / тюменская область / ишим"
  },
  "1345": {
    "id": "1345",
    "name": "Тобольск",
    "path": "Россия / Тюменская область / Тобольск",
    "country": "Россия",
    "searchString": "тобольск россия / тюменская область / тобольск"
  },
  "1346": {
    "id": "1346",
    "name": "Ялуторовск",
    "path": "Россия / Тюменская область / Ялуторовск",
    "country": "Россия",
    "searchString": "ялуторовск россия / тюменская область / ялуторовск"
  },
  "1347": {
    "id": "1347",
    "name": "Республика Башкортостан",
    "path": "Россия / Республика Башкортостан",
    "country": "Россия",
    "searchString": "республика башкортостан россия / республика башкортостан"
  },
  "1348": {
    "id": "1348",
    "name": "Агидель",
    "path": "Россия / Республика Башкортостан / Агидель",
    "country": "Россия",
    "searchString": "агидель россия / республика башкортостан / агидель"
  },
  "1349": {
    "id": "1349",
    "name": "Баймак",
    "path": "Россия / Республика Башкортостан / Баймак",
    "country": "Россия",
    "searchString": "баймак россия / республика башкортостан / баймак"
  },
  "1350": {
    "id": "1350",
    "name": "Белебей",
    "path": "Россия / Республика Башкортостан / Белебей",
    "country": "Россия",
    "searchString": "белебей россия / республика башкортостан / белебей"
  },
  "1351": {
    "id": "1351",
    "name": "Белорецк",
    "path": "Россия / Республика Башкортостан / Белорецк",
    "country": "Россия",
    "searchString": "белорецк россия / республика башкортостан / белорецк"
  },
  "1352": {
    "id": "1352",
    "name": "Бирск",
    "path": "Россия / Республика Башкортостан / Бирск",
    "country": "Россия",
    "searchString": "бирск россия / республика башкортостан / бирск"
  },
  "1353": {
    "id": "1353",
    "name": "Благовещенск (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Благовещенск (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "благовещенск (республика башкортостан) россия / республика башкортостан / благовещенск (республика башкортостан)"
  },
  "1354": {
    "id": "1354",
    "name": "Давлеканово",
    "path": "Россия / Республика Башкортостан / Давлеканово",
    "country": "Россия",
    "searchString": "давлеканово россия / республика башкортостан / давлеканово"
  },
  "1355": {
    "id": "1355",
    "name": "Дюртюли",
    "path": "Россия / Республика Башкортостан / Дюртюли",
    "country": "Россия",
    "searchString": "дюртюли россия / республика башкортостан / дюртюли"
  },
  "1356": {
    "id": "1356",
    "name": "Ишимбай",
    "path": "Россия / Республика Башкортостан / Ишимбай",
    "country": "Россия",
    "searchString": "ишимбай россия / республика башкортостан / ишимбай"
  },
  "1357": {
    "id": "1357",
    "name": "Кумертау",
    "path": "Россия / Республика Башкортостан / Кумертау",
    "country": "Россия",
    "searchString": "кумертау россия / республика башкортостан / кумертау"
  },
  "1358": {
    "id": "1358",
    "name": "Межгорье (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Межгорье (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "межгорье (республика башкортостан) россия / республика башкортостан / межгорье (республика башкортостан)"
  },
  "1359": {
    "id": "1359",
    "name": "Мелеуз",
    "path": "Россия / Республика Башкортостан / Мелеуз",
    "country": "Россия",
    "searchString": "мелеуз россия / республика башкортостан / мелеуз"
  },
  "1360": {
    "id": "1360",
    "name": "Нефтекамск",
    "path": "Россия / Республика Башкортостан / Нефтекамск",
    "country": "Россия",
    "searchString": "нефтекамск россия / республика башкортостан / нефтекамск"
  },
  "1361": {
    "id": "1361",
    "name": "Октябрьский (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Октябрьский (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "октябрьский (республика башкортостан) россия / республика башкортостан / октябрьский (республика башкортостан)"
  },
  "1362": {
    "id": "1362",
    "name": "Салават",
    "path": "Россия / Республика Башкортостан / Салават",
    "country": "Россия",
    "searchString": "салават россия / республика башкортостан / салават"
  },
  "1363": {
    "id": "1363",
    "name": "Сибай",
    "path": "Россия / Республика Башкортостан / Сибай",
    "country": "Россия",
    "searchString": "сибай россия / республика башкортостан / сибай"
  },
  "1364": {
    "id": "1364",
    "name": "Стерлитамак",
    "path": "Россия / Республика Башкортостан / Стерлитамак",
    "country": "Россия",
    "searchString": "стерлитамак россия / республика башкортостан / стерлитамак"
  },
  "1365": {
    "id": "1365",
    "name": "Туймазы",
    "path": "Россия / Республика Башкортостан / Туймазы",
    "country": "Россия",
    "searchString": "туймазы россия / республика башкортостан / туймазы"
  },
  "1366": {
    "id": "1366",
    "name": "Учалы",
    "path": "Россия / Республика Башкортостан / Учалы",
    "country": "Россия",
    "searchString": "учалы россия / республика башкортостан / учалы"
  },
  "1367": {
    "id": "1367",
    "name": "Янаул",
    "path": "Россия / Республика Башкортостан / Янаул",
    "country": "Россия",
    "searchString": "янаул россия / республика башкортостан / янаул"
  },
  "1368": {
    "id": "1368",
    "name": "Ханты-Мансийский АО - Югра",
    "path": "Россия / Ханты-Мансийский АО - Югра",
    "country": "Россия",
    "searchString": "ханты-мансийский ао - югра россия / ханты-мансийский ао - югра"
  },
  "1369": {
    "id": "1369",
    "name": "Белоярский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Белоярский",
    "country": "Россия",
    "searchString": "белоярский россия / ханты-мансийский ао - югра / белоярский"
  },
  "1370": {
    "id": "1370",
    "name": "Когалым",
    "path": "Россия / Ханты-Мансийский АО - Югра / Когалым",
    "country": "Россия",
    "searchString": "когалым россия / ханты-мансийский ао - югра / когалым"
  },
  "1371": {
    "id": "1371",
    "name": "Лангепас",
    "path": "Россия / Ханты-Мансийский АО - Югра / Лангепас",
    "country": "Россия",
    "searchString": "лангепас россия / ханты-мансийский ао - югра / лангепас"
  },
  "1372": {
    "id": "1372",
    "name": "Лянтор",
    "path": "Россия / Ханты-Мансийский АО - Югра / Лянтор",
    "country": "Россия",
    "searchString": "лянтор россия / ханты-мансийский ао - югра / лянтор"
  },
  "1373": {
    "id": "1373",
    "name": "Мегион",
    "path": "Россия / Ханты-Мансийский АО - Югра / Мегион",
    "country": "Россия",
    "searchString": "мегион россия / ханты-мансийский ао - югра / мегион"
  },
  "1374": {
    "id": "1374",
    "name": "Нефтеюганск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Нефтеюганск",
    "country": "Россия",
    "searchString": "нефтеюганск россия / ханты-мансийский ао - югра / нефтеюганск"
  },
  "1375": {
    "id": "1375",
    "name": "Нижневартовск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Нижневартовск",
    "country": "Россия",
    "searchString": "нижневартовск россия / ханты-мансийский ао - югра / нижневартовск"
  },
  "1376": {
    "id": "1376",
    "name": "Нягань",
    "path": "Россия / Ханты-Мансийский АО - Югра / Нягань",
    "country": "Россия",
    "searchString": "нягань россия / ханты-мансийский ао - югра / нягань"
  },
  "1377": {
    "id": "1377",
    "name": "Покачи",
    "path": "Россия / Ханты-Мансийский АО - Югра / Покачи",
    "country": "Россия",
    "searchString": "покачи россия / ханты-мансийский ао - югра / покачи"
  },
  "1378": {
    "id": "1378",
    "name": "Пыть-Ях",
    "path": "Россия / Ханты-Мансийский АО - Югра / Пыть-Ях",
    "country": "Россия",
    "searchString": "пыть-ях россия / ханты-мансийский ао - югра / пыть-ях"
  },
  "1379": {
    "id": "1379",
    "name": "Радужный (Ханты-Мансийский АО - Югра)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Радужный (Ханты-Мансийский АО - Югра)",
    "country": "Россия",
    "searchString": "радужный (ханты-мансийский ао - югра) россия / ханты-мансийский ао - югра / радужный (ханты-мансийский ао - югра)"
  },
  "1380": {
    "id": "1380",
    "name": "Советский (Ханты-Мансийский АО)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Советский (Ханты-Мансийский АО)",
    "country": "Россия",
    "searchString": "советский (ханты-мансийский ао) россия / ханты-мансийский ао - югра / советский (ханты-мансийский ао)"
  },
  "1381": {
    "id": "1381",
    "name": "Сургут",
    "path": "Россия / Ханты-Мансийский АО - Югра / Сургут",
    "country": "Россия",
    "searchString": "сургут россия / ханты-мансийский ао - югра / сургут"
  },
  "1382": {
    "id": "1382",
    "name": "Урай",
    "path": "Россия / Ханты-Мансийский АО - Югра / Урай",
    "country": "Россия",
    "searchString": "урай россия / ханты-мансийский ао - югра / урай"
  },
  "1383": {
    "id": "1383",
    "name": "Югорск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Югорск",
    "country": "Россия",
    "searchString": "югорск россия / ханты-мансийский ао - югра / югорск"
  },
  "1384": {
    "id": "1384",
    "name": "Челябинская область",
    "path": "Россия / Челябинская область",
    "country": "Россия",
    "searchString": "челябинская область россия / челябинская область"
  },
  "1385": {
    "id": "1385",
    "name": "Аша",
    "path": "Россия / Челябинская область / Аша",
    "country": "Россия",
    "searchString": "аша россия / челябинская область / аша"
  },
  "1386": {
    "id": "1386",
    "name": "Бакал",
    "path": "Россия / Челябинская область / Бакал",
    "country": "Россия",
    "searchString": "бакал россия / челябинская область / бакал"
  },
  "1387": {
    "id": "1387",
    "name": "Верхнеуральск",
    "path": "Россия / Челябинская область / Верхнеуральск",
    "country": "Россия",
    "searchString": "верхнеуральск россия / челябинская область / верхнеуральск"
  },
  "1388": {
    "id": "1388",
    "name": "Верхний Уфалей",
    "path": "Россия / Челябинская область / Верхний Уфалей",
    "country": "Россия",
    "searchString": "верхний уфалей россия / челябинская область / верхний уфалей"
  },
  "1389": {
    "id": "1389",
    "name": "Еманжелинск",
    "path": "Россия / Челябинская область / Еманжелинск",
    "country": "Россия",
    "searchString": "еманжелинск россия / челябинская область / еманжелинск"
  },
  "1390": {
    "id": "1390",
    "name": "Златоуст",
    "path": "Россия / Челябинская область / Златоуст",
    "country": "Россия",
    "searchString": "златоуст россия / челябинская область / златоуст"
  },
  "1391": {
    "id": "1391",
    "name": "Карабаш (Челябинская область)",
    "path": "Россия / Челябинская область / Карабаш (Челябинская область)",
    "country": "Россия",
    "searchString": "карабаш (челябинская область) россия / челябинская область / карабаш (челябинская область)"
  },
  "1392": {
    "id": "1392",
    "name": "Карталы",
    "path": "Россия / Челябинская область / Карталы",
    "country": "Россия",
    "searchString": "карталы россия / челябинская область / карталы"
  },
  "1393": {
    "id": "1393",
    "name": "Касли",
    "path": "Россия / Челябинская область / Касли",
    "country": "Россия",
    "searchString": "касли россия / челябинская область / касли"
  },
  "1394": {
    "id": "1394",
    "name": "Катав-Ивановск",
    "path": "Россия / Челябинская область / Катав-Ивановск",
    "country": "Россия",
    "searchString": "катав-ивановск россия / челябинская область / катав-ивановск"
  },
  "1395": {
    "id": "1395",
    "name": "Копейск",
    "path": "Россия / Челябинская область / Копейск",
    "country": "Россия",
    "searchString": "копейск россия / челябинская область / копейск"
  },
  "1396": {
    "id": "1396",
    "name": "Коркино",
    "path": "Россия / Челябинская область / Коркино",
    "country": "Россия",
    "searchString": "коркино россия / челябинская область / коркино"
  },
  "1397": {
    "id": "1397",
    "name": "Куса",
    "path": "Россия / Челябинская область / Куса",
    "country": "Россия",
    "searchString": "куса россия / челябинская область / куса"
  },
  "1398": {
    "id": "1398",
    "name": "Кыштым",
    "path": "Россия / Челябинская область / Кыштым",
    "country": "Россия",
    "searchString": "кыштым россия / челябинская область / кыштым"
  },
  "1399": {
    "id": "1399",
    "name": "Магнитогорск",
    "path": "Россия / Челябинская область / Магнитогорск",
    "country": "Россия",
    "searchString": "магнитогорск россия / челябинская область / магнитогорск"
  },
  "1400": {
    "id": "1400",
    "name": "Миасс",
    "path": "Россия / Челябинская область / Миасс",
    "country": "Россия",
    "searchString": "миасс россия / челябинская область / миасс"
  },
  "1401": {
    "id": "1401",
    "name": "Миньяр",
    "path": "Россия / Челябинская область / Миньяр",
    "country": "Россия",
    "searchString": "миньяр россия / челябинская область / миньяр"
  },
  "1402": {
    "id": "1402",
    "name": "Нязепетровск",
    "path": "Россия / Челябинская область / Нязепетровск",
    "country": "Россия",
    "searchString": "нязепетровск россия / челябинская область / нязепетровск"
  },
  "1403": {
    "id": "1403",
    "name": "Озерск (Челябинская область)",
    "path": "Россия / Челябинская область / Озерск (Челябинская область)",
    "country": "Россия",
    "searchString": "озерск (челябинская область) россия / челябинская область / озерск (челябинская область)"
  },
  "1404": {
    "id": "1404",
    "name": "Пласт",
    "path": "Россия / Челябинская область / Пласт",
    "country": "Россия",
    "searchString": "пласт россия / челябинская область / пласт"
  },
  "1405": {
    "id": "1405",
    "name": "Сатка",
    "path": "Россия / Челябинская область / Сатка",
    "country": "Россия",
    "searchString": "сатка россия / челябинская область / сатка"
  },
  "1406": {
    "id": "1406",
    "name": "Сим",
    "path": "Россия / Челябинская область / Сим",
    "country": "Россия",
    "searchString": "сим россия / челябинская область / сим"
  },
  "1407": {
    "id": "1407",
    "name": "Снежинск",
    "path": "Россия / Челябинская область / Снежинск",
    "country": "Россия",
    "searchString": "снежинск россия / челябинская область / снежинск"
  },
  "1408": {
    "id": "1408",
    "name": "Трехгорный",
    "path": "Россия / Челябинская область / Трехгорный",
    "country": "Россия",
    "searchString": "трехгорный россия / челябинская область / трехгорный"
  },
  "1409": {
    "id": "1409",
    "name": "Троицк (Челябинская область)",
    "path": "Россия / Челябинская область / Троицк (Челябинская область)",
    "country": "Россия",
    "searchString": "троицк (челябинская область) россия / челябинская область / троицк (челябинская область)"
  },
  "1410": {
    "id": "1410",
    "name": "Усть-Катав",
    "path": "Россия / Челябинская область / Усть-Катав",
    "country": "Россия",
    "searchString": "усть-катав россия / челябинская область / усть-катав"
  },
  "1411": {
    "id": "1411",
    "name": "Чебаркуль",
    "path": "Россия / Челябинская область / Чебаркуль",
    "country": "Россия",
    "searchString": "чебаркуль россия / челябинская область / чебаркуль"
  },
  "1412": {
    "id": "1412",
    "name": "Южноуральск",
    "path": "Россия / Челябинская область / Южноуральск",
    "country": "Россия",
    "searchString": "южноуральск россия / челябинская область / южноуральск"
  },
  "1413": {
    "id": "1413",
    "name": "Юрюзань",
    "path": "Россия / Челябинская область / Юрюзань",
    "country": "Россия",
    "searchString": "юрюзань россия / челябинская область / юрюзань"
  },
  "1414": {
    "id": "1414",
    "name": "Ямало-Ненецкий АО",
    "path": "Россия / Ямало-Ненецкий АО",
    "country": "Россия",
    "searchString": "ямало-ненецкий ао россия / ямало-ненецкий ао"
  },
  "1415": {
    "id": "1415",
    "name": "Губкинский",
    "path": "Россия / Ямало-Ненецкий АО / Губкинский",
    "country": "Россия",
    "searchString": "губкинский россия / ямало-ненецкий ао / губкинский"
  },
  "1416": {
    "id": "1416",
    "name": "Лабытнанги",
    "path": "Россия / Ямало-Ненецкий АО / Лабытнанги",
    "country": "Россия",
    "searchString": "лабытнанги россия / ямало-ненецкий ао / лабытнанги"
  },
  "1417": {
    "id": "1417",
    "name": "Муравленко",
    "path": "Россия / Ямало-Ненецкий АО / Муравленко",
    "country": "Россия",
    "searchString": "муравленко россия / ямало-ненецкий ао / муравленко"
  },
  "1418": {
    "id": "1418",
    "name": "Надым",
    "path": "Россия / Ямало-Ненецкий АО / Надым",
    "country": "Россия",
    "searchString": "надым россия / ямало-ненецкий ао / надым"
  },
  "1419": {
    "id": "1419",
    "name": "Новый Уренгой",
    "path": "Россия / Ямало-Ненецкий АО / Новый Уренгой",
    "country": "Россия",
    "searchString": "новый уренгой россия / ямало-ненецкий ао / новый уренгой"
  },
  "1420": {
    "id": "1420",
    "name": "Ноябрьск",
    "path": "Россия / Ямало-Ненецкий АО / Ноябрьск",
    "country": "Россия",
    "searchString": "ноябрьск россия / ямало-ненецкий ао / ноябрьск"
  },
  "1421": {
    "id": "1421",
    "name": "Тарко-Сале",
    "path": "Россия / Ямало-Ненецкий АО / Тарко-Сале",
    "country": "Россия",
    "searchString": "тарко-сале россия / ямало-ненецкий ао / тарко-сале"
  },
  "1422": {
    "id": "1422",
    "name": "Республика Адыгея",
    "path": "Россия / Республика Адыгея",
    "country": "Россия",
    "searchString": "республика адыгея россия / республика адыгея"
  },
  "1423": {
    "id": "1423",
    "name": "Адыгейск",
    "path": "Россия / Республика Адыгея / Адыгейск",
    "country": "Россия",
    "searchString": "адыгейск россия / республика адыгея / адыгейск"
  },
  "1424": {
    "id": "1424",
    "name": "Республика Дагестан",
    "path": "Россия / Республика Дагестан",
    "country": "Россия",
    "searchString": "республика дагестан россия / республика дагестан"
  },
  "1425": {
    "id": "1425",
    "name": "Буйнакск",
    "path": "Россия / Республика Дагестан / Буйнакск",
    "country": "Россия",
    "searchString": "буйнакск россия / республика дагестан / буйнакск"
  },
  "1426": {
    "id": "1426",
    "name": "Дагестанские Огни",
    "path": "Россия / Республика Дагестан / Дагестанские Огни",
    "country": "Россия",
    "searchString": "дагестанские огни россия / республика дагестан / дагестанские огни"
  },
  "1427": {
    "id": "1427",
    "name": "Дербент",
    "path": "Россия / Республика Дагестан / Дербент",
    "country": "Россия",
    "searchString": "дербент россия / республика дагестан / дербент"
  },
  "1428": {
    "id": "1428",
    "name": "Избербаш",
    "path": "Россия / Республика Дагестан / Избербаш",
    "country": "Россия",
    "searchString": "избербаш россия / республика дагестан / избербаш"
  },
  "1429": {
    "id": "1429",
    "name": "Каспийск",
    "path": "Россия / Республика Дагестан / Каспийск",
    "country": "Россия",
    "searchString": "каспийск россия / республика дагестан / каспийск"
  },
  "1430": {
    "id": "1430",
    "name": "Кизилюрт",
    "path": "Россия / Республика Дагестан / Кизилюрт",
    "country": "Россия",
    "searchString": "кизилюрт россия / республика дагестан / кизилюрт"
  },
  "1431": {
    "id": "1431",
    "name": "Кизляр",
    "path": "Россия / Республика Дагестан / Кизляр",
    "country": "Россия",
    "searchString": "кизляр россия / республика дагестан / кизляр"
  },
  "1432": {
    "id": "1432",
    "name": "Хасавюрт",
    "path": "Россия / Республика Дагестан / Хасавюрт",
    "country": "Россия",
    "searchString": "хасавюрт россия / республика дагестан / хасавюрт"
  },
  "1433": {
    "id": "1433",
    "name": "Южно-Сухокумск",
    "path": "Россия / Республика Дагестан / Южно-Сухокумск",
    "country": "Россия",
    "searchString": "южно-сухокумск россия / республика дагестан / южно-сухокумск"
  },
  "1434": {
    "id": "1434",
    "name": "Республика Ингушетия",
    "path": "Россия / Республика Ингушетия",
    "country": "Россия",
    "searchString": "республика ингушетия россия / республика ингушетия"
  },
  "1435": {
    "id": "1435",
    "name": "Карабулак",
    "path": "Россия / Республика Ингушетия / Карабулак",
    "country": "Россия",
    "searchString": "карабулак россия / республика ингушетия / карабулак"
  },
  "1436": {
    "id": "1436",
    "name": "Малгобек",
    "path": "Россия / Республика Ингушетия / Малгобек",
    "country": "Россия",
    "searchString": "малгобек россия / республика ингушетия / малгобек"
  },
  "1437": {
    "id": "1437",
    "name": "Назрань",
    "path": "Россия / Республика Ингушетия / Назрань",
    "country": "Россия",
    "searchString": "назрань россия / республика ингушетия / назрань"
  },
  "1438": {
    "id": "1438",
    "name": "Краснодарский край",
    "path": "Россия / Краснодарский край",
    "country": "Россия",
    "searchString": "краснодарский край россия / краснодарский край"
  },
  "1439": {
    "id": "1439",
    "name": "Абинск",
    "path": "Россия / Краснодарский край / Абинск",
    "country": "Россия",
    "searchString": "абинск россия / краснодарский край / абинск"
  },
  "1440": {
    "id": "1440",
    "name": "Анапа",
    "path": "Россия / Краснодарский край / Анапа",
    "country": "Россия",
    "searchString": "анапа россия / краснодарский край / анапа"
  },
  "1441": {
    "id": "1441",
    "name": "Апшеронск",
    "path": "Россия / Краснодарский край / Апшеронск",
    "country": "Россия",
    "searchString": "апшеронск россия / краснодарский край / апшеронск"
  },
  "1442": {
    "id": "1442",
    "name": "Армавир",
    "path": "Россия / Краснодарский край / Армавир",
    "country": "Россия",
    "searchString": "армавир россия / краснодарский край / армавир"
  },
  "1443": {
    "id": "1443",
    "name": "Белореченск",
    "path": "Россия / Краснодарский край / Белореченск",
    "country": "Россия",
    "searchString": "белореченск россия / краснодарский край / белореченск"
  },
  "1444": {
    "id": "1444",
    "name": "Геленджик",
    "path": "Россия / Краснодарский край / Геленджик",
    "country": "Россия",
    "searchString": "геленджик россия / краснодарский край / геленджик"
  },
  "1445": {
    "id": "1445",
    "name": "Горячий Ключ",
    "path": "Россия / Краснодарский край / Горячий Ключ",
    "country": "Россия",
    "searchString": "горячий ключ россия / краснодарский край / горячий ключ"
  },
  "1446": {
    "id": "1446",
    "name": "Гулькевичи",
    "path": "Россия / Краснодарский край / Гулькевичи",
    "country": "Россия",
    "searchString": "гулькевичи россия / краснодарский край / гулькевичи"
  },
  "1447": {
    "id": "1447",
    "name": "Ейск",
    "path": "Россия / Краснодарский край / Ейск",
    "country": "Россия",
    "searchString": "ейск россия / краснодарский край / ейск"
  },
  "1448": {
    "id": "1448",
    "name": "Кореновск",
    "path": "Россия / Краснодарский край / Кореновск",
    "country": "Россия",
    "searchString": "кореновск россия / краснодарский край / кореновск"
  },
  "1449": {
    "id": "1449",
    "name": "Кропоткин",
    "path": "Россия / Краснодарский край / Кропоткин",
    "country": "Россия",
    "searchString": "кропоткин россия / краснодарский край / кропоткин"
  },
  "1450": {
    "id": "1450",
    "name": "Крымск",
    "path": "Россия / Краснодарский край / Крымск",
    "country": "Россия",
    "searchString": "крымск россия / краснодарский край / крымск"
  },
  "1451": {
    "id": "1451",
    "name": "Курганинск",
    "path": "Россия / Краснодарский край / Курганинск",
    "country": "Россия",
    "searchString": "курганинск россия / краснодарский край / курганинск"
  },
  "1452": {
    "id": "1452",
    "name": "Лабинск",
    "path": "Россия / Краснодарский край / Лабинск",
    "country": "Россия",
    "searchString": "лабинск россия / краснодарский край / лабинск"
  },
  "1453": {
    "id": "1453",
    "name": "Новокубанск",
    "path": "Россия / Краснодарский край / Новокубанск",
    "country": "Россия",
    "searchString": "новокубанск россия / краснодарский край / новокубанск"
  },
  "1454": {
    "id": "1454",
    "name": "Новороссийск",
    "path": "Россия / Краснодарский край / Новороссийск",
    "country": "Россия",
    "searchString": "новороссийск россия / краснодарский край / новороссийск"
  },
  "1455": {
    "id": "1455",
    "name": "Приморско-Ахтарск",
    "path": "Россия / Краснодарский край / Приморско-Ахтарск",
    "country": "Россия",
    "searchString": "приморско-ахтарск россия / краснодарский край / приморско-ахтарск"
  },
  "1456": {
    "id": "1456",
    "name": "Славянск-на-Кубани",
    "path": "Россия / Краснодарский край / Славянск-на-Кубани",
    "country": "Россия",
    "searchString": "славянск-на-кубани россия / краснодарский край / славянск-на-кубани"
  },
  "1457": {
    "id": "1457",
    "name": "Темрюк",
    "path": "Россия / Краснодарский край / Темрюк",
    "country": "Россия",
    "searchString": "темрюк россия / краснодарский край / темрюк"
  },
  "1458": {
    "id": "1458",
    "name": "Тимашевск",
    "path": "Россия / Краснодарский край / Тимашевск",
    "country": "Россия",
    "searchString": "тимашевск россия / краснодарский край / тимашевск"
  },
  "1459": {
    "id": "1459",
    "name": "Тихорецк",
    "path": "Россия / Краснодарский край / Тихорецк",
    "country": "Россия",
    "searchString": "тихорецк россия / краснодарский край / тихорецк"
  },
  "1460": {
    "id": "1460",
    "name": "Туапсе",
    "path": "Россия / Краснодарский край / Туапсе",
    "country": "Россия",
    "searchString": "туапсе россия / краснодарский край / туапсе"
  },
  "1461": {
    "id": "1461",
    "name": "Усть-Лабинск",
    "path": "Россия / Краснодарский край / Усть-Лабинск",
    "country": "Россия",
    "searchString": "усть-лабинск россия / краснодарский край / усть-лабинск"
  },
  "1462": {
    "id": "1462",
    "name": "Хадыженск",
    "path": "Россия / Краснодарский край / Хадыженск",
    "country": "Россия",
    "searchString": "хадыженск россия / краснодарский край / хадыженск"
  },
  "1463": {
    "id": "1463",
    "name": "Кабардино-Балкарская республика",
    "path": "Россия / Кабардино-Балкарская республика",
    "country": "Россия",
    "searchString": "кабардино-балкарская республика россия / кабардино-балкарская республика"
  },
  "1464": {
    "id": "1464",
    "name": "Баксан",
    "path": "Россия / Кабардино-Балкарская республика / Баксан",
    "country": "Россия",
    "searchString": "баксан россия / кабардино-балкарская республика / баксан"
  },
  "1465": {
    "id": "1465",
    "name": "Майский",
    "path": "Россия / Кабардино-Балкарская республика / Майский",
    "country": "Россия",
    "searchString": "майский россия / кабардино-балкарская республика / майский"
  },
  "1466": {
    "id": "1466",
    "name": "Нарткала",
    "path": "Россия / Кабардино-Балкарская республика / Нарткала",
    "country": "Россия",
    "searchString": "нарткала россия / кабардино-балкарская республика / нарткала"
  },
  "1467": {
    "id": "1467",
    "name": "Прохладный",
    "path": "Россия / Кабардино-Балкарская республика / Прохладный",
    "country": "Россия",
    "searchString": "прохладный россия / кабардино-балкарская республика / прохладный"
  },
  "1468": {
    "id": "1468",
    "name": "Терек",
    "path": "Россия / Кабардино-Балкарская республика / Терек",
    "country": "Россия",
    "searchString": "терек россия / кабардино-балкарская республика / терек"
  },
  "1469": {
    "id": "1469",
    "name": "Тырныауз",
    "path": "Россия / Кабардино-Балкарская республика / Тырныауз",
    "country": "Россия",
    "searchString": "тырныауз россия / кабардино-балкарская республика / тырныауз"
  },
  "1470": {
    "id": "1470",
    "name": "Чегем",
    "path": "Россия / Кабардино-Балкарская республика / Чегем",
    "country": "Россия",
    "searchString": "чегем россия / кабардино-балкарская республика / чегем"
  },
  "1471": {
    "id": "1471",
    "name": "Карачаево-Черкесская Республика",
    "path": "Россия / Карачаево-Черкесская Республика",
    "country": "Россия",
    "searchString": "карачаево-черкесская республика россия / карачаево-черкесская республика"
  },
  "1472": {
    "id": "1472",
    "name": "Карачаевск",
    "path": "Россия / Карачаево-Черкесская Республика / Карачаевск",
    "country": "Россия",
    "searchString": "карачаевск россия / карачаево-черкесская республика / карачаевск"
  },
  "1473": {
    "id": "1473",
    "name": "Теберда",
    "path": "Россия / Карачаево-Черкесская Республика / Теберда",
    "country": "Россия",
    "searchString": "теберда россия / карачаево-черкесская республика / теберда"
  },
  "1474": {
    "id": "1474",
    "name": "Усть-Джегута",
    "path": "Россия / Карачаево-Черкесская Республика / Усть-Джегута",
    "country": "Россия",
    "searchString": "усть-джегута россия / карачаево-черкесская республика / усть-джегута"
  },
  "1475": {
    "id": "1475",
    "name": "Республика Северная Осетия-Алания",
    "path": "Россия / Республика Северная Осетия-Алания",
    "country": "Россия",
    "searchString": "республика северная осетия-алания россия / республика северная осетия-алания"
  },
  "1476": {
    "id": "1476",
    "name": "Алагир",
    "path": "Россия / Республика Северная Осетия-Алания / Алагир",
    "country": "Россия",
    "searchString": "алагир россия / республика северная осетия-алания / алагир"
  },
  "1477": {
    "id": "1477",
    "name": "Ардон",
    "path": "Россия / Республика Северная Осетия-Алания / Ардон",
    "country": "Россия",
    "searchString": "ардон россия / республика северная осетия-алания / ардон"
  },
  "1478": {
    "id": "1478",
    "name": "Беслан",
    "path": "Россия / Республика Северная Осетия-Алания / Беслан",
    "country": "Россия",
    "searchString": "беслан россия / республика северная осетия-алания / беслан"
  },
  "1479": {
    "id": "1479",
    "name": "Дигора",
    "path": "Россия / Республика Северная Осетия-Алания / Дигора",
    "country": "Россия",
    "searchString": "дигора россия / республика северная осетия-алания / дигора"
  },
  "1480": {
    "id": "1480",
    "name": "Моздок",
    "path": "Россия / Республика Северная Осетия-Алания / Моздок",
    "country": "Россия",
    "searchString": "моздок россия / республика северная осетия-алания / моздок"
  },
  "1481": {
    "id": "1481",
    "name": "Ставропольский край",
    "path": "Россия / Ставропольский край",
    "country": "Россия",
    "searchString": "ставропольский край россия / ставропольский край"
  },
  "1482": {
    "id": "1482",
    "name": "Благодарный",
    "path": "Россия / Ставропольский край / Благодарный",
    "country": "Россия",
    "searchString": "благодарный россия / ставропольский край / благодарный"
  },
  "1483": {
    "id": "1483",
    "name": "Буденновск",
    "path": "Россия / Ставропольский край / Буденновск",
    "country": "Россия",
    "searchString": "буденновск россия / ставропольский край / буденновск"
  },
  "1484": {
    "id": "1484",
    "name": "Георгиевск",
    "path": "Россия / Ставропольский край / Георгиевск",
    "country": "Россия",
    "searchString": "георгиевск россия / ставропольский край / георгиевск"
  },
  "1485": {
    "id": "1485",
    "name": "Ессентуки",
    "path": "Россия / Ставропольский край / Ессентуки",
    "country": "Россия",
    "searchString": "ессентуки россия / ставропольский край / ессентуки"
  },
  "1486": {
    "id": "1486",
    "name": "Железноводск",
    "path": "Россия / Ставропольский край / Железноводск",
    "country": "Россия",
    "searchString": "железноводск россия / ставропольский край / железноводск"
  },
  "1487": {
    "id": "1487",
    "name": "Зеленокумск",
    "path": "Россия / Ставропольский край / Зеленокумск",
    "country": "Россия",
    "searchString": "зеленокумск россия / ставропольский край / зеленокумск"
  },
  "1488": {
    "id": "1488",
    "name": "Изобильный",
    "path": "Россия / Ставропольский край / Изобильный",
    "country": "Россия",
    "searchString": "изобильный россия / ставропольский край / изобильный"
  },
  "1489": {
    "id": "1489",
    "name": "Ипатово",
    "path": "Россия / Ставропольский край / Ипатово",
    "country": "Россия",
    "searchString": "ипатово россия / ставропольский край / ипатово"
  },
  "1490": {
    "id": "1490",
    "name": "Кисловодск",
    "path": "Россия / Ставропольский край / Кисловодск",
    "country": "Россия",
    "searchString": "кисловодск россия / ставропольский край / кисловодск"
  },
  "1491": {
    "id": "1491",
    "name": "Лермонтов",
    "path": "Россия / Ставропольский край / Лермонтов",
    "country": "Россия",
    "searchString": "лермонтов россия / ставропольский край / лермонтов"
  },
  "1492": {
    "id": "1492",
    "name": "Минеральные Воды",
    "path": "Россия / Ставропольский край / Минеральные Воды",
    "country": "Россия",
    "searchString": "минеральные воды россия / ставропольский край / минеральные воды"
  },
  "1493": {
    "id": "1493",
    "name": "Михайловск (Ставропольский край)",
    "path": "Россия / Ставропольский край / Михайловск (Ставропольский край)",
    "country": "Россия",
    "searchString": "михайловск (ставропольский край) россия / ставропольский край / михайловск (ставропольский край)"
  },
  "1494": {
    "id": "1494",
    "name": "Невинномысск",
    "path": "Россия / Ставропольский край / Невинномысск",
    "country": "Россия",
    "searchString": "невинномысск россия / ставропольский край / невинномысск"
  },
  "1495": {
    "id": "1495",
    "name": "Нефтекумск",
    "path": "Россия / Ставропольский край / Нефтекумск",
    "country": "Россия",
    "searchString": "нефтекумск россия / ставропольский край / нефтекумск"
  },
  "1496": {
    "id": "1496",
    "name": "Новоалександровск",
    "path": "Россия / Ставропольский край / Новоалександровск",
    "country": "Россия",
    "searchString": "новоалександровск россия / ставропольский край / новоалександровск"
  },
  "1497": {
    "id": "1497",
    "name": "Новопавловск",
    "path": "Россия / Ставропольский край / Новопавловск",
    "country": "Россия",
    "searchString": "новопавловск россия / ставропольский край / новопавловск"
  },
  "1498": {
    "id": "1498",
    "name": "Пятигорск",
    "path": "Россия / Ставропольский край / Пятигорск",
    "country": "Россия",
    "searchString": "пятигорск россия / ставропольский край / пятигорск"
  },
  "1499": {
    "id": "1499",
    "name": "Светлоград",
    "path": "Россия / Ставропольский край / Светлоград",
    "country": "Россия",
    "searchString": "светлоград россия / ставропольский край / светлоград"
  },
  "1500": {
    "id": "1500",
    "name": "Чеченская республика",
    "path": "Россия / Чеченская республика",
    "country": "Россия",
    "searchString": "чеченская республика россия / чеченская республика"
  },
  "1501": {
    "id": "1501",
    "name": "Аргун",
    "path": "Россия / Чеченская республика / Аргун",
    "country": "Россия",
    "searchString": "аргун россия / чеченская республика / аргун"
  },
  "1502": {
    "id": "1502",
    "name": "Гудермес",
    "path": "Россия / Чеченская республика / Гудермес",
    "country": "Россия",
    "searchString": "гудермес россия / чеченская республика / гудермес"
  },
  "1503": {
    "id": "1503",
    "name": "Урус-Мартан",
    "path": "Россия / Чеченская республика / Урус-Мартан",
    "country": "Россия",
    "searchString": "урус-мартан россия / чеченская республика / урус-мартан"
  },
  "1504": {
    "id": "1504",
    "name": "Шали",
    "path": "Россия / Чеченская республика / Шали",
    "country": "Россия",
    "searchString": "шали россия / чеченская республика / шали"
  },
  "1505": {
    "id": "1505",
    "name": "Астраханская область",
    "path": "Россия / Астраханская область",
    "country": "Россия",
    "searchString": "астраханская область россия / астраханская область"
  },
  "1506": {
    "id": "1506",
    "name": "Ахтубинск",
    "path": "Россия / Астраханская область / Ахтубинск",
    "country": "Россия",
    "searchString": "ахтубинск россия / астраханская область / ахтубинск"
  },
  "1507": {
    "id": "1507",
    "name": "Знаменск",
    "path": "Россия / Астраханская область / Знаменск",
    "country": "Россия",
    "searchString": "знаменск россия / астраханская область / знаменск"
  },
  "1508": {
    "id": "1508",
    "name": "Камызяк",
    "path": "Россия / Астраханская область / Камызяк",
    "country": "Россия",
    "searchString": "камызяк россия / астраханская область / камызяк"
  },
  "1509": {
    "id": "1509",
    "name": "Нариманов",
    "path": "Россия / Астраханская область / Нариманов",
    "country": "Россия",
    "searchString": "нариманов россия / астраханская область / нариманов"
  },
  "1510": {
    "id": "1510",
    "name": "Харабали",
    "path": "Россия / Астраханская область / Харабали",
    "country": "Россия",
    "searchString": "харабали россия / астраханская область / харабали"
  },
  "1511": {
    "id": "1511",
    "name": "Волгоградская область",
    "path": "Россия / Волгоградская область",
    "country": "Россия",
    "searchString": "волгоградская область россия / волгоградская область"
  },
  "1512": {
    "id": "1512",
    "name": "Волжский (Волгоградская область)",
    "path": "Россия / Волгоградская область / Волжский (Волгоградская область)",
    "country": "Россия",
    "searchString": "волжский (волгоградская область) россия / волгоградская область / волжский (волгоградская область)"
  },
  "1513": {
    "id": "1513",
    "name": "Дубовка",
    "path": "Россия / Волгоградская область / Дубовка",
    "country": "Россия",
    "searchString": "дубовка россия / волгоградская область / дубовка"
  },
  "1514": {
    "id": "1514",
    "name": "Жирновск",
    "path": "Россия / Волгоградская область / Жирновск",
    "country": "Россия",
    "searchString": "жирновск россия / волгоградская область / жирновск"
  },
  "1515": {
    "id": "1515",
    "name": "Калач-на-Дону",
    "path": "Россия / Волгоградская область / Калач-на-Дону",
    "country": "Россия",
    "searchString": "калач-на-дону россия / волгоградская область / калач-на-дону"
  },
  "1516": {
    "id": "1516",
    "name": "Камышин",
    "path": "Россия / Волгоградская область / Камышин",
    "country": "Россия",
    "searchString": "камышин россия / волгоградская область / камышин"
  },
  "1517": {
    "id": "1517",
    "name": "Котельниково",
    "path": "Россия / Волгоградская область / Котельниково",
    "country": "Россия",
    "searchString": "котельниково россия / волгоградская область / котельниково"
  },
  "1518": {
    "id": "1518",
    "name": "Котово",
    "path": "Россия / Волгоградская область / Котово",
    "country": "Россия",
    "searchString": "котово россия / волгоградская область / котово"
  },
  "1519": {
    "id": "1519",
    "name": "Краснослободск (Волгоградская область)",
    "path": "Россия / Волгоградская область / Краснослободск (Волгоградская область)",
    "country": "Россия",
    "searchString": "краснослободск (волгоградская область) россия / волгоградская область / краснослободск (волгоградская область)"
  },
  "1520": {
    "id": "1520",
    "name": "Ленинск",
    "path": "Россия / Волгоградская область / Ленинск",
    "country": "Россия",
    "searchString": "ленинск россия / волгоградская область / ленинск"
  },
  "1521": {
    "id": "1521",
    "name": "Михайловка (Волгоградская область)",
    "path": "Россия / Волгоградская область / Михайловка (Волгоградская область)",
    "country": "Россия",
    "searchString": "михайловка (волгоградская область) россия / волгоградская область / михайловка (волгоградская область)"
  },
  "1522": {
    "id": "1522",
    "name": "Николаевск",
    "path": "Россия / Волгоградская область / Николаевск",
    "country": "Россия",
    "searchString": "николаевск россия / волгоградская область / николаевск"
  },
  "1523": {
    "id": "1523",
    "name": "Новоаннинский",
    "path": "Россия / Волгоградская область / Новоаннинский",
    "country": "Россия",
    "searchString": "новоаннинский россия / волгоградская область / новоаннинский"
  },
  "1524": {
    "id": "1524",
    "name": "Палласовка",
    "path": "Россия / Волгоградская область / Палласовка",
    "country": "Россия",
    "searchString": "палласовка россия / волгоградская область / палласовка"
  },
  "1525": {
    "id": "1525",
    "name": "Петров Вал",
    "path": "Россия / Волгоградская область / Петров Вал",
    "country": "Россия",
    "searchString": "петров вал россия / волгоградская область / петров вал"
  },
  "1526": {
    "id": "1526",
    "name": "Серафимович",
    "path": "Россия / Волгоградская область / Серафимович",
    "country": "Россия",
    "searchString": "серафимович россия / волгоградская область / серафимович"
  },
  "1527": {
    "id": "1527",
    "name": "Суровикино",
    "path": "Россия / Волгоградская область / Суровикино",
    "country": "Россия",
    "searchString": "суровикино россия / волгоградская область / суровикино"
  },
  "1528": {
    "id": "1528",
    "name": "Урюпинск",
    "path": "Россия / Волгоградская область / Урюпинск",
    "country": "Россия",
    "searchString": "урюпинск россия / волгоградская область / урюпинск"
  },
  "1529": {
    "id": "1529",
    "name": "Фролово",
    "path": "Россия / Волгоградская область / Фролово",
    "country": "Россия",
    "searchString": "фролово россия / волгоградская область / фролово"
  },
  "1530": {
    "id": "1530",
    "name": "Ростовская область",
    "path": "Россия / Ростовская область",
    "country": "Россия",
    "searchString": "ростовская область россия / ростовская область"
  },
  "1531": {
    "id": "1531",
    "name": "Азов",
    "path": "Россия / Ростовская область / Азов",
    "country": "Россия",
    "searchString": "азов россия / ростовская область / азов"
  },
  "1532": {
    "id": "1532",
    "name": "Аксай (Ростовская область)",
    "path": "Россия / Ростовская область / Аксай (Ростовская область)",
    "country": "Россия",
    "searchString": "аксай (ростовская область) россия / ростовская область / аксай (ростовская область)"
  },
  "1533": {
    "id": "1533",
    "name": "Батайск",
    "path": "Россия / Ростовская область / Батайск",
    "country": "Россия",
    "searchString": "батайск россия / ростовская область / батайск"
  },
  "1534": {
    "id": "1534",
    "name": "Белая Калитва",
    "path": "Россия / Ростовская область / Белая Калитва",
    "country": "Россия",
    "searchString": "белая калитва россия / ростовская область / белая калитва"
  },
  "1535": {
    "id": "1535",
    "name": "Волгодонск",
    "path": "Россия / Ростовская область / Волгодонск",
    "country": "Россия",
    "searchString": "волгодонск россия / ростовская область / волгодонск"
  },
  "1536": {
    "id": "1536",
    "name": "Гуково",
    "path": "Россия / Ростовская область / Гуково",
    "country": "Россия",
    "searchString": "гуково россия / ростовская область / гуково"
  },
  "1537": {
    "id": "1537",
    "name": "Донецк (Ростовская область)",
    "path": "Россия / Ростовская область / Донецк (Ростовская область)",
    "country": "Россия",
    "searchString": "донецк (ростовская область) россия / ростовская область / донецк (ростовская область)"
  },
  "1538": {
    "id": "1538",
    "name": "Зверево",
    "path": "Россия / Ростовская область / Зверево",
    "country": "Россия",
    "searchString": "зверево россия / ростовская область / зверево"
  },
  "1539": {
    "id": "1539",
    "name": "Зерноград",
    "path": "Россия / Ростовская область / Зерноград",
    "country": "Россия",
    "searchString": "зерноград россия / ростовская область / зерноград"
  },
  "1540": {
    "id": "1540",
    "name": "Каменск-Шахтинский",
    "path": "Россия / Ростовская область / Каменск-Шахтинский",
    "country": "Россия",
    "searchString": "каменск-шахтинский россия / ростовская область / каменск-шахтинский"
  },
  "1541": {
    "id": "1541",
    "name": "Константиновск",
    "path": "Россия / Ростовская область / Константиновск",
    "country": "Россия",
    "searchString": "константиновск россия / ростовская область / константиновск"
  },
  "1542": {
    "id": "1542",
    "name": "Красный Сулин",
    "path": "Россия / Ростовская область / Красный Сулин",
    "country": "Россия",
    "searchString": "красный сулин россия / ростовская область / красный сулин"
  },
  "1543": {
    "id": "1543",
    "name": "Миллерово",
    "path": "Россия / Ростовская область / Миллерово",
    "country": "Россия",
    "searchString": "миллерово россия / ростовская область / миллерово"
  },
  "1544": {
    "id": "1544",
    "name": "Морозовск",
    "path": "Россия / Ростовская область / Морозовск",
    "country": "Россия",
    "searchString": "морозовск россия / ростовская область / морозовск"
  },
  "1545": {
    "id": "1545",
    "name": "Новочеркасск",
    "path": "Россия / Ростовская область / Новочеркасск",
    "country": "Россия",
    "searchString": "новочеркасск россия / ростовская область / новочеркасск"
  },
  "1546": {
    "id": "1546",
    "name": "Новошахтинск",
    "path": "Россия / Ростовская область / Новошахтинск",
    "country": "Россия",
    "searchString": "новошахтинск россия / ростовская область / новошахтинск"
  },
  "1547": {
    "id": "1547",
    "name": "Пролетарск",
    "path": "Россия / Ростовская область / Пролетарск",
    "country": "Россия",
    "searchString": "пролетарск россия / ростовская область / пролетарск"
  },
  "1548": {
    "id": "1548",
    "name": "Сальск",
    "path": "Россия / Ростовская область / Сальск",
    "country": "Россия",
    "searchString": "сальск россия / ростовская область / сальск"
  },
  "1549": {
    "id": "1549",
    "name": "Семикаракорск",
    "path": "Россия / Ростовская область / Семикаракорск",
    "country": "Россия",
    "searchString": "семикаракорск россия / ростовская область / семикаракорск"
  },
  "1550": {
    "id": "1550",
    "name": "Таганрог",
    "path": "Россия / Ростовская область / Таганрог",
    "country": "Россия",
    "searchString": "таганрог россия / ростовская область / таганрог"
  },
  "1551": {
    "id": "1551",
    "name": "Цимлянск",
    "path": "Россия / Ростовская область / Цимлянск",
    "country": "Россия",
    "searchString": "цимлянск россия / ростовская область / цимлянск"
  },
  "1552": {
    "id": "1552",
    "name": "Шахты",
    "path": "Россия / Ростовская область / Шахты",
    "country": "Россия",
    "searchString": "шахты россия / ростовская область / шахты"
  },
  "1553": {
    "id": "1553",
    "name": "Республика Калмыкия",
    "path": "Россия / Республика Калмыкия",
    "country": "Россия",
    "searchString": "республика калмыкия россия / республика калмыкия"
  },
  "1554": {
    "id": "1554",
    "name": "Городовиковск",
    "path": "Россия / Республика Калмыкия / Городовиковск",
    "country": "Россия",
    "searchString": "городовиковск россия / республика калмыкия / городовиковск"
  },
  "1555": {
    "id": "1555",
    "name": "Лагань",
    "path": "Россия / Республика Калмыкия / Лагань",
    "country": "Россия",
    "searchString": "лагань россия / республика калмыкия / лагань"
  },
  "1556": {
    "id": "1556",
    "name": "Республика Мордовия",
    "path": "Россия / Республика Мордовия",
    "country": "Россия",
    "searchString": "республика мордовия россия / республика мордовия"
  },
  "1557": {
    "id": "1557",
    "name": "Ардатов",
    "path": "Россия / Республика Мордовия / Ардатов",
    "country": "Россия",
    "searchString": "ардатов россия / республика мордовия / ардатов"
  },
  "1558": {
    "id": "1558",
    "name": "Инсар",
    "path": "Россия / Республика Мордовия / Инсар",
    "country": "Россия",
    "searchString": "инсар россия / республика мордовия / инсар"
  },
  "1559": {
    "id": "1559",
    "name": "Ковылкино",
    "path": "Россия / Республика Мордовия / Ковылкино",
    "country": "Россия",
    "searchString": "ковылкино россия / республика мордовия / ковылкино"
  },
  "1560": {
    "id": "1560",
    "name": "Краснослободск (Республика Мордовия)",
    "path": "Россия / Республика Мордовия / Краснослободск (Республика Мордовия)",
    "country": "Россия",
    "searchString": "краснослободск (республика мордовия) россия / республика мордовия / краснослободск (республика мордовия)"
  },
  "1561": {
    "id": "1561",
    "name": "Рузаевка",
    "path": "Россия / Республика Мордовия / Рузаевка",
    "country": "Россия",
    "searchString": "рузаевка россия / республика мордовия / рузаевка"
  },
  "1562": {
    "id": "1562",
    "name": "Темников",
    "path": "Россия / Республика Мордовия / Темников",
    "country": "Россия",
    "searchString": "темников россия / республика мордовия / темников"
  },
  "1563": {
    "id": "1563",
    "name": "Оренбургская область",
    "path": "Россия / Оренбургская область",
    "country": "Россия",
    "searchString": "оренбургская область россия / оренбургская область"
  },
  "1564": {
    "id": "1564",
    "name": "Абдулино",
    "path": "Россия / Оренбургская область / Абдулино",
    "country": "Россия",
    "searchString": "абдулино россия / оренбургская область / абдулино"
  },
  "1565": {
    "id": "1565",
    "name": "Бугуруслан",
    "path": "Россия / Оренбургская область / Бугуруслан",
    "country": "Россия",
    "searchString": "бугуруслан россия / оренбургская область / бугуруслан"
  },
  "1566": {
    "id": "1566",
    "name": "Бузулук",
    "path": "Россия / Оренбургская область / Бузулук",
    "country": "Россия",
    "searchString": "бузулук россия / оренбургская область / бузулук"
  },
  "1567": {
    "id": "1567",
    "name": "Гай",
    "path": "Россия / Оренбургская область / Гай",
    "country": "Россия",
    "searchString": "гай россия / оренбургская область / гай"
  },
  "1568": {
    "id": "1568",
    "name": "Кувандык",
    "path": "Россия / Оренбургская область / Кувандык",
    "country": "Россия",
    "searchString": "кувандык россия / оренбургская область / кувандык"
  },
  "1569": {
    "id": "1569",
    "name": "Медногорск",
    "path": "Россия / Оренбургская область / Медногорск",
    "country": "Россия",
    "searchString": "медногорск россия / оренбургская область / медногорск"
  },
  "1570": {
    "id": "1570",
    "name": "Новотроицк (Оренбургская область)",
    "path": "Россия / Оренбургская область / Новотроицк (Оренбургская область)",
    "country": "Россия",
    "searchString": "новотроицк (оренбургская область) россия / оренбургская область / новотроицк (оренбургская область)"
  },
  "1571": {
    "id": "1571",
    "name": "Орск",
    "path": "Россия / Оренбургская область / Орск",
    "country": "Россия",
    "searchString": "орск россия / оренбургская область / орск"
  },
  "1572": {
    "id": "1572",
    "name": "Соль-Илецк",
    "path": "Россия / Оренбургская область / Соль-Илецк",
    "country": "Россия",
    "searchString": "соль-илецк россия / оренбургская область / соль-илецк"
  },
  "1573": {
    "id": "1573",
    "name": "Сорочинск",
    "path": "Россия / Оренбургская область / Сорочинск",
    "country": "Россия",
    "searchString": "сорочинск россия / оренбургская область / сорочинск"
  },
  "1574": {
    "id": "1574",
    "name": "Ясный",
    "path": "Россия / Оренбургская область / Ясный",
    "country": "Россия",
    "searchString": "ясный россия / оренбургская область / ясный"
  },
  "1575": {
    "id": "1575",
    "name": "Пензенская область",
    "path": "Россия / Пензенская область",
    "country": "Россия",
    "searchString": "пензенская область россия / пензенская область"
  },
  "1576": {
    "id": "1576",
    "name": "Белинский",
    "path": "Россия / Пензенская область / Белинский",
    "country": "Россия",
    "searchString": "белинский россия / пензенская область / белинский"
  },
  "1577": {
    "id": "1577",
    "name": "Городище (Пензенская область)",
    "path": "Россия / Пензенская область / Городище (Пензенская область)",
    "country": "Россия",
    "searchString": "городище (пензенская область) россия / пензенская область / городище (пензенская область)"
  },
  "1578": {
    "id": "1578",
    "name": "Заречный (Пензенская область)",
    "path": "Россия / Пензенская область / Заречный (Пензенская область)",
    "country": "Россия",
    "searchString": "заречный (пензенская область) россия / пензенская область / заречный (пензенская область)"
  },
  "1579": {
    "id": "1579",
    "name": "Каменка (Пензенская область)",
    "path": "Россия / Пензенская область / Каменка (Пензенская область)",
    "country": "Россия",
    "searchString": "каменка (пензенская область) россия / пензенская область / каменка (пензенская область)"
  },
  "1580": {
    "id": "1580",
    "name": "Кузнецк",
    "path": "Россия / Пензенская область / Кузнецк",
    "country": "Россия",
    "searchString": "кузнецк россия / пензенская область / кузнецк"
  },
  "1581": {
    "id": "1581",
    "name": "Нижний Ломов",
    "path": "Россия / Пензенская область / Нижний Ломов",
    "country": "Россия",
    "searchString": "нижний ломов россия / пензенская область / нижний ломов"
  },
  "1582": {
    "id": "1582",
    "name": "Никольск (Пензенская область)",
    "path": "Россия / Пензенская область / Никольск (Пензенская область)",
    "country": "Россия",
    "searchString": "никольск (пензенская область) россия / пензенская область / никольск (пензенская область)"
  },
  "1583": {
    "id": "1583",
    "name": "Сердобск",
    "path": "Россия / Пензенская область / Сердобск",
    "country": "Россия",
    "searchString": "сердобск россия / пензенская область / сердобск"
  },
  "1584": {
    "id": "1584",
    "name": "Спасск",
    "path": "Россия / Пензенская область / Спасск",
    "country": "Россия",
    "searchString": "спасск россия / пензенская область / спасск"
  },
  "1585": {
    "id": "1585",
    "name": "Сурск",
    "path": "Россия / Пензенская область / Сурск",
    "country": "Россия",
    "searchString": "сурск россия / пензенская область / сурск"
  },
  "1586": {
    "id": "1586",
    "name": "Самарская область",
    "path": "Россия / Самарская область",
    "country": "Россия",
    "searchString": "самарская область россия / самарская область"
  },
  "1587": {
    "id": "1587",
    "name": "Жигулевск",
    "path": "Россия / Самарская область / Жигулевск",
    "country": "Россия",
    "searchString": "жигулевск россия / самарская область / жигулевск"
  },
  "1588": {
    "id": "1588",
    "name": "Кинель",
    "path": "Россия / Самарская область / Кинель",
    "country": "Россия",
    "searchString": "кинель россия / самарская область / кинель"
  },
  "1589": {
    "id": "1589",
    "name": "Нефтегорск (Самарская область)",
    "path": "Россия / Самарская область / Нефтегорск (Самарская область)",
    "country": "Россия",
    "searchString": "нефтегорск (самарская область) россия / самарская область / нефтегорск (самарская область)"
  },
  "1590": {
    "id": "1590",
    "name": "Новокуйбышевск",
    "path": "Россия / Самарская область / Новокуйбышевск",
    "country": "Россия",
    "searchString": "новокуйбышевск россия / самарская область / новокуйбышевск"
  },
  "1591": {
    "id": "1591",
    "name": "Октябрьск",
    "path": "Россия / Самарская область / Октябрьск",
    "country": "Россия",
    "searchString": "октябрьск россия / самарская область / октябрьск"
  },
  "1592": {
    "id": "1592",
    "name": "Отрадный (Самарская область)",
    "path": "Россия / Самарская область / Отрадный (Самарская область)",
    "country": "Россия",
    "searchString": "отрадный (самарская область) россия / самарская область / отрадный (самарская область)"
  },
  "1593": {
    "id": "1593",
    "name": "Похвистнево",
    "path": "Россия / Самарская область / Похвистнево",
    "country": "Россия",
    "searchString": "похвистнево россия / самарская область / похвистнево"
  },
  "1594": {
    "id": "1594",
    "name": "Сызрань",
    "path": "Россия / Самарская область / Сызрань",
    "country": "Россия",
    "searchString": "сызрань россия / самарская область / сызрань"
  },
  "1595": {
    "id": "1595",
    "name": "Чапаевск",
    "path": "Россия / Самарская область / Чапаевск",
    "country": "Россия",
    "searchString": "чапаевск россия / самарская область / чапаевск"
  },
  "1596": {
    "id": "1596",
    "name": "Саратовская область",
    "path": "Россия / Саратовская область",
    "country": "Россия",
    "searchString": "саратовская область россия / саратовская область"
  },
  "1597": {
    "id": "1597",
    "name": "Аркадак",
    "path": "Россия / Саратовская область / Аркадак",
    "country": "Россия",
    "searchString": "аркадак россия / саратовская область / аркадак"
  },
  "1598": {
    "id": "1598",
    "name": "Аткарск",
    "path": "Россия / Саратовская область / Аткарск",
    "country": "Россия",
    "searchString": "аткарск россия / саратовская область / аткарск"
  },
  "1599": {
    "id": "1599",
    "name": "Балаково",
    "path": "Россия / Саратовская область / Балаково",
    "country": "Россия",
    "searchString": "балаково россия / саратовская область / балаково"
  },
  "1600": {
    "id": "1600",
    "name": "Балашов",
    "path": "Россия / Саратовская область / Балашов",
    "country": "Россия",
    "searchString": "балашов россия / саратовская область / балашов"
  },
  "1601": {
    "id": "1601",
    "name": "Вольск",
    "path": "Россия / Саратовская область / Вольск",
    "country": "Россия",
    "searchString": "вольск россия / саратовская область / вольск"
  },
  "1602": {
    "id": "1602",
    "name": "Ершов",
    "path": "Россия / Саратовская область / Ершов",
    "country": "Россия",
    "searchString": "ершов россия / саратовская область / ершов"
  },
  "1603": {
    "id": "1603",
    "name": "Калининск",
    "path": "Россия / Саратовская область / Калининск",
    "country": "Россия",
    "searchString": "калининск россия / саратовская область / калининск"
  },
  "1604": {
    "id": "1604",
    "name": "Красноармейск (Саратовская область)",
    "path": "Россия / Саратовская область / Красноармейск (Саратовская область)",
    "country": "Россия",
    "searchString": "красноармейск (саратовская область) россия / саратовская область / красноармейск (саратовская область)"
  },
  "1605": {
    "id": "1605",
    "name": "Красный Кут",
    "path": "Россия / Саратовская область / Красный Кут",
    "country": "Россия",
    "searchString": "красный кут россия / саратовская область / красный кут"
  },
  "1606": {
    "id": "1606",
    "name": "Маркс",
    "path": "Россия / Саратовская область / Маркс",
    "country": "Россия",
    "searchString": "маркс россия / саратовская область / маркс"
  },
  "1607": {
    "id": "1607",
    "name": "Новоузенск",
    "path": "Россия / Саратовская область / Новоузенск",
    "country": "Россия",
    "searchString": "новоузенск россия / саратовская область / новоузенск"
  },
  "1608": {
    "id": "1608",
    "name": "Петровск",
    "path": "Россия / Саратовская область / Петровск",
    "country": "Россия",
    "searchString": "петровск россия / саратовская область / петровск"
  },
  "1609": {
    "id": "1609",
    "name": "Пугачев",
    "path": "Россия / Саратовская область / Пугачев",
    "country": "Россия",
    "searchString": "пугачев россия / саратовская область / пугачев"
  },
  "1610": {
    "id": "1610",
    "name": "Ртищево",
    "path": "Россия / Саратовская область / Ртищево",
    "country": "Россия",
    "searchString": "ртищево россия / саратовская область / ртищево"
  },
  "1611": {
    "id": "1611",
    "name": "Хвалынск",
    "path": "Россия / Саратовская область / Хвалынск",
    "country": "Россия",
    "searchString": "хвалынск россия / саратовская область / хвалынск"
  },
  "1612": {
    "id": "1612",
    "name": "Шиханы",
    "path": "Россия / Саратовская область / Шиханы",
    "country": "Россия",
    "searchString": "шиханы россия / саратовская область / шиханы"
  },
  "1613": {
    "id": "1613",
    "name": "Энгельс",
    "path": "Россия / Саратовская область / Энгельс",
    "country": "Россия",
    "searchString": "энгельс россия / саратовская область / энгельс"
  },
  "1614": {
    "id": "1614",
    "name": "Ульяновская область",
    "path": "Россия / Ульяновская область",
    "country": "Россия",
    "searchString": "ульяновская область россия / ульяновская область"
  },
  "1615": {
    "id": "1615",
    "name": "Барыш",
    "path": "Россия / Ульяновская область / Барыш",
    "country": "Россия",
    "searchString": "барыш россия / ульяновская область / барыш"
  },
  "1616": {
    "id": "1616",
    "name": "Димитровград",
    "path": "Россия / Ульяновская область / Димитровград",
    "country": "Россия",
    "searchString": "димитровград россия / ульяновская область / димитровград"
  },
  "1617": {
    "id": "1617",
    "name": "Инза",
    "path": "Россия / Ульяновская область / Инза",
    "country": "Россия",
    "searchString": "инза россия / ульяновская область / инза"
  },
  "1618": {
    "id": "1618",
    "name": "Новоульяновск",
    "path": "Россия / Ульяновская область / Новоульяновск",
    "country": "Россия",
    "searchString": "новоульяновск россия / ульяновская область / новоульяновск"
  },
  "1619": {
    "id": "1619",
    "name": "Сенгилей",
    "path": "Россия / Ульяновская область / Сенгилей",
    "country": "Россия",
    "searchString": "сенгилей россия / ульяновская область / сенгилей"
  },
  "1620": {
    "id": "1620",
    "name": "Республика Марий Эл",
    "path": "Россия / Республика Марий Эл",
    "country": "Россия",
    "searchString": "республика марий эл россия / республика марий эл"
  },
  "1621": {
    "id": "1621",
    "name": "Волжск",
    "path": "Россия / Республика Марий Эл / Волжск",
    "country": "Россия",
    "searchString": "волжск россия / республика марий эл / волжск"
  },
  "1622": {
    "id": "1622",
    "name": "Звенигово",
    "path": "Россия / Республика Марий Эл / Звенигово",
    "country": "Россия",
    "searchString": "звенигово россия / республика марий эл / звенигово"
  },
  "1623": {
    "id": "1623",
    "name": "Козьмодемьянск",
    "path": "Россия / Республика Марий Эл / Козьмодемьянск",
    "country": "Россия",
    "searchString": "козьмодемьянск россия / республика марий эл / козьмодемьянск"
  },
  "1624": {
    "id": "1624",
    "name": "Республика Татарстан",
    "path": "Россия / Республика Татарстан",
    "country": "Россия",
    "searchString": "республика татарстан россия / республика татарстан"
  },
  "1625": {
    "id": "1625",
    "name": "Агрыз",
    "path": "Россия / Республика Татарстан / Агрыз",
    "country": "Россия",
    "searchString": "агрыз россия / республика татарстан / агрыз"
  },
  "1626": {
    "id": "1626",
    "name": "Азнакаево",
    "path": "Россия / Республика Татарстан / Азнакаево",
    "country": "Россия",
    "searchString": "азнакаево россия / республика татарстан / азнакаево"
  },
  "1627": {
    "id": "1627",
    "name": "Альметьевск",
    "path": "Россия / Республика Татарстан / Альметьевск",
    "country": "Россия",
    "searchString": "альметьевск россия / республика татарстан / альметьевск"
  },
  "1628": {
    "id": "1628",
    "name": "Арск",
    "path": "Россия / Республика Татарстан / Арск",
    "country": "Россия",
    "searchString": "арск россия / республика татарстан / арск"
  },
  "1629": {
    "id": "1629",
    "name": "Бавлы",
    "path": "Россия / Республика Татарстан / Бавлы",
    "country": "Россия",
    "searchString": "бавлы россия / республика татарстан / бавлы"
  },
  "1630": {
    "id": "1630",
    "name": "Болгар",
    "path": "Россия / Республика Татарстан / Болгар",
    "country": "Россия",
    "searchString": "болгар россия / республика татарстан / болгар"
  },
  "1631": {
    "id": "1631",
    "name": "Бугульма",
    "path": "Россия / Республика Татарстан / Бугульма",
    "country": "Россия",
    "searchString": "бугульма россия / республика татарстан / бугульма"
  },
  "1632": {
    "id": "1632",
    "name": "Буинск",
    "path": "Россия / Республика Татарстан / Буинск",
    "country": "Россия",
    "searchString": "буинск россия / республика татарстан / буинск"
  },
  "1633": {
    "id": "1633",
    "name": "Елабуга",
    "path": "Россия / Республика Татарстан / Елабуга",
    "country": "Россия",
    "searchString": "елабуга россия / республика татарстан / елабуга"
  },
  "1634": {
    "id": "1634",
    "name": "Заинск",
    "path": "Россия / Республика Татарстан / Заинск",
    "country": "Россия",
    "searchString": "заинск россия / республика татарстан / заинск"
  },
  "1635": {
    "id": "1635",
    "name": "Зеленодольск (Республика Татарстан)",
    "path": "Россия / Республика Татарстан / Зеленодольск (Республика Татарстан)",
    "country": "Россия",
    "searchString": "зеленодольск (республика татарстан) россия / республика татарстан / зеленодольск (республика татарстан)"
  },
  "1636": {
    "id": "1636",
    "name": "Лаишево",
    "path": "Россия / Республика Татарстан / Лаишево",
    "country": "Россия",
    "searchString": "лаишево россия / республика татарстан / лаишево"
  },
  "1637": {
    "id": "1637",
    "name": "Лениногорск",
    "path": "Россия / Республика Татарстан / Лениногорск",
    "country": "Россия",
    "searchString": "лениногорск россия / республика татарстан / лениногорск"
  },
  "1638": {
    "id": "1638",
    "name": "Мамадыш",
    "path": "Россия / Республика Татарстан / Мамадыш",
    "country": "Россия",
    "searchString": "мамадыш россия / республика татарстан / мамадыш"
  },
  "1639": {
    "id": "1639",
    "name": "Менделеевск",
    "path": "Россия / Республика Татарстан / Менделеевск",
    "country": "Россия",
    "searchString": "менделеевск россия / республика татарстан / менделеевск"
  },
  "1640": {
    "id": "1640",
    "name": "Мензелинск",
    "path": "Россия / Республика Татарстан / Мензелинск",
    "country": "Россия",
    "searchString": "мензелинск россия / республика татарстан / мензелинск"
  },
  "1641": {
    "id": "1641",
    "name": "Набережные Челны",
    "path": "Россия / Республика Татарстан / Набережные Челны",
    "country": "Россия",
    "searchString": "набережные челны россия / республика татарстан / набережные челны"
  },
  "1642": {
    "id": "1642",
    "name": "Нижнекамск",
    "path": "Россия / Республика Татарстан / Нижнекамск",
    "country": "Россия",
    "searchString": "нижнекамск россия / республика татарстан / нижнекамск"
  },
  "1643": {
    "id": "1643",
    "name": "Нурлат",
    "path": "Россия / Республика Татарстан / Нурлат",
    "country": "Россия",
    "searchString": "нурлат россия / республика татарстан / нурлат"
  },
  "1644": {
    "id": "1644",
    "name": "Тетюши",
    "path": "Россия / Республика Татарстан / Тетюши",
    "country": "Россия",
    "searchString": "тетюши россия / республика татарстан / тетюши"
  },
  "1645": {
    "id": "1645",
    "name": "Чистополь",
    "path": "Россия / Республика Татарстан / Чистополь",
    "country": "Россия",
    "searchString": "чистополь россия / республика татарстан / чистополь"
  },
  "1646": {
    "id": "1646",
    "name": "Удмуртская Республика",
    "path": "Россия / Удмуртская Республика",
    "country": "Россия",
    "searchString": "удмуртская республика россия / удмуртская республика"
  },
  "1647": {
    "id": "1647",
    "name": "Воткинск",
    "path": "Россия / Удмуртская Республика / Воткинск",
    "country": "Россия",
    "searchString": "воткинск россия / удмуртская республика / воткинск"
  },
  "1648": {
    "id": "1648",
    "name": "Глазов",
    "path": "Россия / Удмуртская Республика / Глазов",
    "country": "Россия",
    "searchString": "глазов россия / удмуртская республика / глазов"
  },
  "1649": {
    "id": "1649",
    "name": "Камбарка",
    "path": "Россия / Удмуртская Республика / Камбарка",
    "country": "Россия",
    "searchString": "камбарка россия / удмуртская республика / камбарка"
  },
  "1650": {
    "id": "1650",
    "name": "Можга",
    "path": "Россия / Удмуртская Республика / Можга",
    "country": "Россия",
    "searchString": "можга россия / удмуртская республика / можга"
  },
  "1651": {
    "id": "1651",
    "name": "Сарапул",
    "path": "Россия / Удмуртская Республика / Сарапул",
    "country": "Россия",
    "searchString": "сарапул россия / удмуртская республика / сарапул"
  },
  "1652": {
    "id": "1652",
    "name": "Чувашская Республика",
    "path": "Россия / Чувашская Республика",
    "country": "Россия",
    "searchString": "чувашская республика россия / чувашская республика"
  },
  "1653": {
    "id": "1653",
    "name": "Алатырь",
    "path": "Россия / Чувашская Республика / Алатырь",
    "country": "Россия",
    "searchString": "алатырь россия / чувашская республика / алатырь"
  },
  "1654": {
    "id": "1654",
    "name": "Канаш",
    "path": "Россия / Чувашская Республика / Канаш",
    "country": "Россия",
    "searchString": "канаш россия / чувашская республика / канаш"
  },
  "1655": {
    "id": "1655",
    "name": "Козловка",
    "path": "Россия / Чувашская Республика / Козловка",
    "country": "Россия",
    "searchString": "козловка россия / чувашская республика / козловка"
  },
  "1656": {
    "id": "1656",
    "name": "Мариинский Посад",
    "path": "Россия / Чувашская Республика / Мариинский Посад",
    "country": "Россия",
    "searchString": "мариинский посад россия / чувашская республика / мариинский посад"
  },
  "1657": {
    "id": "1657",
    "name": "Новочебоксарск",
    "path": "Россия / Чувашская Республика / Новочебоксарск",
    "country": "Россия",
    "searchString": "новочебоксарск россия / чувашская республика / новочебоксарск"
  },
  "1658": {
    "id": "1658",
    "name": "Цивильск",
    "path": "Россия / Чувашская Республика / Цивильск",
    "country": "Россия",
    "searchString": "цивильск россия / чувашская республика / цивильск"
  },
  "1659": {
    "id": "1659",
    "name": "Шумерля",
    "path": "Россия / Чувашская Республика / Шумерля",
    "country": "Россия",
    "searchString": "шумерля россия / чувашская республика / шумерля"
  },
  "1660": {
    "id": "1660",
    "name": "Ядрин",
    "path": "Россия / Чувашская Республика / Ядрин",
    "country": "Россия",
    "searchString": "ядрин россия / чувашская республика / ядрин"
  },
  "1661": {
    "id": "1661",
    "name": "Кировская область",
    "path": "Россия / Кировская область",
    "country": "Россия",
    "searchString": "кировская область россия / кировская область"
  },
  "1662": {
    "id": "1662",
    "name": "Белая Холуница",
    "path": "Россия / Кировская область / Белая Холуница",
    "country": "Россия",
    "searchString": "белая холуница россия / кировская область / белая холуница"
  },
  "1663": {
    "id": "1663",
    "name": "Вятские Поляны",
    "path": "Россия / Кировская область / Вятские Поляны",
    "country": "Россия",
    "searchString": "вятские поляны россия / кировская область / вятские поляны"
  },
  "1664": {
    "id": "1664",
    "name": "Зуевка",
    "path": "Россия / Кировская область / Зуевка",
    "country": "Россия",
    "searchString": "зуевка россия / кировская область / зуевка"
  },
  "1665": {
    "id": "1665",
    "name": "Кирово-Чепецк",
    "path": "Россия / Кировская область / Кирово-Чепецк",
    "country": "Россия",
    "searchString": "кирово-чепецк россия / кировская область / кирово-чепецк"
  },
  "1666": {
    "id": "1666",
    "name": "Кирс",
    "path": "Россия / Кировская область / Кирс",
    "country": "Россия",
    "searchString": "кирс россия / кировская область / кирс"
  },
  "1667": {
    "id": "1667",
    "name": "Котельнич",
    "path": "Россия / Кировская область / Котельнич",
    "country": "Россия",
    "searchString": "котельнич россия / кировская область / котельнич"
  },
  "1668": {
    "id": "1668",
    "name": "Луза",
    "path": "Россия / Кировская область / Луза",
    "country": "Россия",
    "searchString": "луза россия / кировская область / луза"
  },
  "1669": {
    "id": "1669",
    "name": "Малмыж",
    "path": "Россия / Кировская область / Малмыж",
    "country": "Россия",
    "searchString": "малмыж россия / кировская область / малмыж"
  },
  "1670": {
    "id": "1670",
    "name": "Мураши",
    "path": "Россия / Кировская область / Мураши",
    "country": "Россия",
    "searchString": "мураши россия / кировская область / мураши"
  },
  "1671": {
    "id": "1671",
    "name": "Нолинск",
    "path": "Россия / Кировская область / Нолинск",
    "country": "Россия",
    "searchString": "нолинск россия / кировская область / нолинск"
  },
  "1672": {
    "id": "1672",
    "name": "Омутнинск",
    "path": "Россия / Кировская область / Омутнинск",
    "country": "Россия",
    "searchString": "омутнинск россия / кировская область / омутнинск"
  },
  "1673": {
    "id": "1673",
    "name": "Орлов",
    "path": "Россия / Кировская область / Орлов",
    "country": "Россия",
    "searchString": "орлов россия / кировская область / орлов"
  },
  "1674": {
    "id": "1674",
    "name": "Слободской",
    "path": "Россия / Кировская область / Слободской",
    "country": "Россия",
    "searchString": "слободской россия / кировская область / слободской"
  },
  "1675": {
    "id": "1675",
    "name": "Советск (Кировская область)",
    "path": "Россия / Кировская область / Советск (Кировская область)",
    "country": "Россия",
    "searchString": "советск (кировская область) россия / кировская область / советск (кировская область)"
  },
  "1676": {
    "id": "1676",
    "name": "Сосновка",
    "path": "Россия / Кировская область / Сосновка",
    "country": "Россия",
    "searchString": "сосновка россия / кировская область / сосновка"
  },
  "1677": {
    "id": "1677",
    "name": "Уржум",
    "path": "Россия / Кировская область / Уржум",
    "country": "Россия",
    "searchString": "уржум россия / кировская область / уржум"
  },
  "1678": {
    "id": "1678",
    "name": "Яранск",
    "path": "Россия / Кировская область / Яранск",
    "country": "Россия",
    "searchString": "яранск россия / кировская область / яранск"
  },
  "1679": {
    "id": "1679",
    "name": "Нижегородская область",
    "path": "Россия / Нижегородская область",
    "country": "Россия",
    "searchString": "нижегородская область россия / нижегородская область"
  },
  "1680": {
    "id": "1680",
    "name": "Балахна",
    "path": "Россия / Нижегородская область / Балахна",
    "country": "Россия",
    "searchString": "балахна россия / нижегородская область / балахна"
  },
  "1681": {
    "id": "1681",
    "name": "Богородск",
    "path": "Россия / Нижегородская область / Богородск",
    "country": "Россия",
    "searchString": "богородск россия / нижегородская область / богородск"
  },
  "1682": {
    "id": "1682",
    "name": "Бор",
    "path": "Россия / Нижегородская область / Бор",
    "country": "Россия",
    "searchString": "бор россия / нижегородская область / бор"
  },
  "1683": {
    "id": "1683",
    "name": "Ветлуга",
    "path": "Россия / Нижегородская область / Ветлуга",
    "country": "Россия",
    "searchString": "ветлуга россия / нижегородская область / ветлуга"
  },
  "1684": {
    "id": "1684",
    "name": "Володарск",
    "path": "Россия / Нижегородская область / Володарск",
    "country": "Россия",
    "searchString": "володарск россия / нижегородская область / володарск"
  },
  "1685": {
    "id": "1685",
    "name": "Ворсма",
    "path": "Россия / Нижегородская область / Ворсма",
    "country": "Россия",
    "searchString": "ворсма россия / нижегородская область / ворсма"
  },
  "1686": {
    "id": "1686",
    "name": "Выкса",
    "path": "Россия / Нижегородская область / Выкса",
    "country": "Россия",
    "searchString": "выкса россия / нижегородская область / выкса"
  },
  "1687": {
    "id": "1687",
    "name": "Горбатов",
    "path": "Россия / Нижегородская область / Горбатов",
    "country": "Россия",
    "searchString": "горбатов россия / нижегородская область / горбатов"
  },
  "1688": {
    "id": "1688",
    "name": "Городец",
    "path": "Россия / Нижегородская область / Городец",
    "country": "Россия",
    "searchString": "городец россия / нижегородская область / городец"
  },
  "1689": {
    "id": "1689",
    "name": "Заволжье",
    "path": "Россия / Нижегородская область / Заволжье",
    "country": "Россия",
    "searchString": "заволжье россия / нижегородская область / заволжье"
  },
  "1690": {
    "id": "1690",
    "name": "Княгинино",
    "path": "Россия / Нижегородская область / Княгинино",
    "country": "Россия",
    "searchString": "княгинино россия / нижегородская область / княгинино"
  },
  "1691": {
    "id": "1691",
    "name": "Кстово",
    "path": "Россия / Нижегородская область / Кстово",
    "country": "Россия",
    "searchString": "кстово россия / нижегородская область / кстово"
  },
  "1692": {
    "id": "1692",
    "name": "Кулебаки",
    "path": "Россия / Нижегородская область / Кулебаки",
    "country": "Россия",
    "searchString": "кулебаки россия / нижегородская область / кулебаки"
  },
  "1693": {
    "id": "1693",
    "name": "Лукоянов",
    "path": "Россия / Нижегородская область / Лукоянов",
    "country": "Россия",
    "searchString": "лукоянов россия / нижегородская область / лукоянов"
  },
  "1694": {
    "id": "1694",
    "name": "Лысково",
    "path": "Россия / Нижегородская область / Лысково",
    "country": "Россия",
    "searchString": "лысково россия / нижегородская область / лысково"
  },
  "1695": {
    "id": "1695",
    "name": "Навашино",
    "path": "Россия / Нижегородская область / Навашино",
    "country": "Россия",
    "searchString": "навашино россия / нижегородская область / навашино"
  },
  "1696": {
    "id": "1696",
    "name": "Павлово",
    "path": "Россия / Нижегородская область / Павлово",
    "country": "Россия",
    "searchString": "павлово россия / нижегородская область / павлово"
  },
  "1697": {
    "id": "1697",
    "name": "Первомайск (Нижегородская область)",
    "path": "Россия / Нижегородская область / Первомайск (Нижегородская область)",
    "country": "Россия",
    "searchString": "первомайск (нижегородская область) россия / нижегородская область / первомайск (нижегородская область)"
  },
  "1698": {
    "id": "1698",
    "name": "Перевоз",
    "path": "Россия / Нижегородская область / Перевоз",
    "country": "Россия",
    "searchString": "перевоз россия / нижегородская область / перевоз"
  },
  "1699": {
    "id": "1699",
    "name": "Семенов",
    "path": "Россия / Нижегородская область / Семенов",
    "country": "Россия",
    "searchString": "семенов россия / нижегородская область / семенов"
  },
  "1700": {
    "id": "1700",
    "name": "Сергач",
    "path": "Россия / Нижегородская область / Сергач",
    "country": "Россия",
    "searchString": "сергач россия / нижегородская область / сергач"
  },
  "1701": {
    "id": "1701",
    "name": "Урень",
    "path": "Россия / Нижегородская область / Урень",
    "country": "Россия",
    "searchString": "урень россия / нижегородская область / урень"
  },
  "1702": {
    "id": "1702",
    "name": "Чкаловск",
    "path": "Россия / Нижегородская область / Чкаловск",
    "country": "Россия",
    "searchString": "чкаловск россия / нижегородская область / чкаловск"
  },
  "1703": {
    "id": "1703",
    "name": "Шахунья",
    "path": "Россия / Нижегородская область / Шахунья",
    "country": "Россия",
    "searchString": "шахунья россия / нижегородская область / шахунья"
  },
  "1704": {
    "id": "1704",
    "name": "Рязанская область",
    "path": "Россия / Рязанская область",
    "country": "Россия",
    "searchString": "рязанская область россия / рязанская область"
  },
  "1705": {
    "id": "1705",
    "name": "Касимов",
    "path": "Россия / Рязанская область / Касимов",
    "country": "Россия",
    "searchString": "касимов россия / рязанская область / касимов"
  },
  "1706": {
    "id": "1706",
    "name": "Кораблино",
    "path": "Россия / Рязанская область / Кораблино",
    "country": "Россия",
    "searchString": "кораблино россия / рязанская область / кораблино"
  },
  "1707": {
    "id": "1707",
    "name": "Михайлов",
    "path": "Россия / Рязанская область / Михайлов",
    "country": "Россия",
    "searchString": "михайлов россия / рязанская область / михайлов"
  },
  "1708": {
    "id": "1708",
    "name": "Новомичуринск",
    "path": "Россия / Рязанская область / Новомичуринск",
    "country": "Россия",
    "searchString": "новомичуринск россия / рязанская область / новомичуринск"
  },
  "1709": {
    "id": "1709",
    "name": "Рыбное",
    "path": "Россия / Рязанская область / Рыбное",
    "country": "Россия",
    "searchString": "рыбное россия / рязанская область / рыбное"
  },
  "1710": {
    "id": "1710",
    "name": "Ряжск",
    "path": "Россия / Рязанская область / Ряжск",
    "country": "Россия",
    "searchString": "ряжск россия / рязанская область / ряжск"
  },
  "1711": {
    "id": "1711",
    "name": "Сасово",
    "path": "Россия / Рязанская область / Сасово",
    "country": "Россия",
    "searchString": "сасово россия / рязанская область / сасово"
  },
  "1712": {
    "id": "1712",
    "name": "Скопин",
    "path": "Россия / Рязанская область / Скопин",
    "country": "Россия",
    "searchString": "скопин россия / рязанская область / скопин"
  },
  "1713": {
    "id": "1713",
    "name": "Спас-Клепики",
    "path": "Россия / Рязанская область / Спас-Клепики",
    "country": "Россия",
    "searchString": "спас-клепики россия / рязанская область / спас-клепики"
  },
  "1714": {
    "id": "1714",
    "name": "Спасск-Рязанский",
    "path": "Россия / Рязанская область / Спасск-Рязанский",
    "country": "Россия",
    "searchString": "спасск-рязанский россия / рязанская область / спасск-рязанский"
  },
  "1715": {
    "id": "1715",
    "name": "Шацк (Рязанская область)",
    "path": "Россия / Рязанская область / Шацк (Рязанская область)",
    "country": "Россия",
    "searchString": "шацк (рязанская область) россия / рязанская область / шацк (рязанская область)"
  },
  "1716": {
    "id": "1716",
    "name": "Владимирская область",
    "path": "Россия / Владимирская область",
    "country": "Россия",
    "searchString": "владимирская область россия / владимирская область"
  },
  "1717": {
    "id": "1717",
    "name": "Александров",
    "path": "Россия / Владимирская область / Александров",
    "country": "Россия",
    "searchString": "александров россия / владимирская область / александров"
  },
  "1718": {
    "id": "1718",
    "name": "Вязники",
    "path": "Россия / Владимирская область / Вязники",
    "country": "Россия",
    "searchString": "вязники россия / владимирская область / вязники"
  },
  "1719": {
    "id": "1719",
    "name": "Гороховец",
    "path": "Россия / Владимирская область / Гороховец",
    "country": "Россия",
    "searchString": "гороховец россия / владимирская область / гороховец"
  },
  "1720": {
    "id": "1720",
    "name": "Гусь-Хрустальный",
    "path": "Россия / Владимирская область / Гусь-Хрустальный",
    "country": "Россия",
    "searchString": "гусь-хрустальный россия / владимирская область / гусь-хрустальный"
  },
  "1721": {
    "id": "1721",
    "name": "Камешково",
    "path": "Россия / Владимирская область / Камешково",
    "country": "Россия",
    "searchString": "камешково россия / владимирская область / камешково"
  },
  "1722": {
    "id": "1722",
    "name": "Карабаново",
    "path": "Россия / Владимирская область / Карабаново",
    "country": "Россия",
    "searchString": "карабаново россия / владимирская область / карабаново"
  },
  "1723": {
    "id": "1723",
    "name": "Киржач",
    "path": "Россия / Владимирская область / Киржач",
    "country": "Россия",
    "searchString": "киржач россия / владимирская область / киржач"
  },
  "1724": {
    "id": "1724",
    "name": "Ковров",
    "path": "Россия / Владимирская область / Ковров",
    "country": "Россия",
    "searchString": "ковров россия / владимирская область / ковров"
  },
  "1725": {
    "id": "1725",
    "name": "Кольчугино",
    "path": "Россия / Владимирская область / Кольчугино",
    "country": "Россия",
    "searchString": "кольчугино россия / владимирская область / кольчугино"
  },
  "1726": {
    "id": "1726",
    "name": "Костерево",
    "path": "Россия / Владимирская область / Костерево",
    "country": "Россия",
    "searchString": "костерево россия / владимирская область / костерево"
  },
  "1727": {
    "id": "1727",
    "name": "Курлово",
    "path": "Россия / Владимирская область / Курлово",
    "country": "Россия",
    "searchString": "курлово россия / владимирская область / курлово"
  },
  "1728": {
    "id": "1728",
    "name": "Лакинск",
    "path": "Россия / Владимирская область / Лакинск",
    "country": "Россия",
    "searchString": "лакинск россия / владимирская область / лакинск"
  },
  "1729": {
    "id": "1729",
    "name": "Меленки",
    "path": "Россия / Владимирская область / Меленки",
    "country": "Россия",
    "searchString": "меленки россия / владимирская область / меленки"
  },
  "1730": {
    "id": "1730",
    "name": "Муром",
    "path": "Россия / Владимирская область / Муром",
    "country": "Россия",
    "searchString": "муром россия / владимирская область / муром"
  },
  "1731": {
    "id": "1731",
    "name": "Петушки",
    "path": "Россия / Владимирская область / Петушки",
    "country": "Россия",
    "searchString": "петушки россия / владимирская область / петушки"
  },
  "1732": {
    "id": "1732",
    "name": "Покров",
    "path": "Россия / Владимирская область / Покров",
    "country": "Россия",
    "searchString": "покров россия / владимирская область / покров"
  },
  "1733": {
    "id": "1733",
    "name": "Радужный (Владимирская область)",
    "path": "Россия / Владимирская область / Радужный (Владимирская область)",
    "country": "Россия",
    "searchString": "радужный (владимирская область) россия / владимирская область / радужный (владимирская область)"
  },
  "1734": {
    "id": "1734",
    "name": "Собинка",
    "path": "Россия / Владимирская область / Собинка",
    "country": "Россия",
    "searchString": "собинка россия / владимирская область / собинка"
  },
  "1735": {
    "id": "1735",
    "name": "Струнино",
    "path": "Россия / Владимирская область / Струнино",
    "country": "Россия",
    "searchString": "струнино россия / владимирская область / струнино"
  },
  "1736": {
    "id": "1736",
    "name": "Судогда",
    "path": "Россия / Владимирская область / Судогда",
    "country": "Россия",
    "searchString": "судогда россия / владимирская область / судогда"
  },
  "1737": {
    "id": "1737",
    "name": "Суздаль",
    "path": "Россия / Владимирская область / Суздаль",
    "country": "Россия",
    "searchString": "суздаль россия / владимирская область / суздаль"
  },
  "1738": {
    "id": "1738",
    "name": "Юрьев-Польский",
    "path": "Россия / Владимирская область / Юрьев-Польский",
    "country": "Россия",
    "searchString": "юрьев-польский россия / владимирская область / юрьев-польский"
  },
  "1739": {
    "id": "1739",
    "name": "Вологодская область",
    "path": "Россия / Вологодская область",
    "country": "Россия",
    "searchString": "вологодская область россия / вологодская область"
  },
  "1740": {
    "id": "1740",
    "name": "Бабаево",
    "path": "Россия / Вологодская область / Бабаево",
    "country": "Россия",
    "searchString": "бабаево россия / вологодская область / бабаево"
  },
  "1741": {
    "id": "1741",
    "name": "Белозерск",
    "path": "Россия / Вологодская область / Белозерск",
    "country": "Россия",
    "searchString": "белозерск россия / вологодская область / белозерск"
  },
  "1742": {
    "id": "1742",
    "name": "Великий Устюг",
    "path": "Россия / Вологодская область / Великий Устюг",
    "country": "Россия",
    "searchString": "великий устюг россия / вологодская область / великий устюг"
  },
  "1743": {
    "id": "1743",
    "name": "Вытегра",
    "path": "Россия / Вологодская область / Вытегра",
    "country": "Россия",
    "searchString": "вытегра россия / вологодская область / вытегра"
  },
  "1744": {
    "id": "1744",
    "name": "Грязовец",
    "path": "Россия / Вологодская область / Грязовец",
    "country": "Россия",
    "searchString": "грязовец россия / вологодская область / грязовец"
  },
  "1745": {
    "id": "1745",
    "name": "Кадников",
    "path": "Россия / Вологодская область / Кадников",
    "country": "Россия",
    "searchString": "кадников россия / вологодская область / кадников"
  },
  "1746": {
    "id": "1746",
    "name": "Кириллов",
    "path": "Россия / Вологодская область / Кириллов",
    "country": "Россия",
    "searchString": "кириллов россия / вологодская область / кириллов"
  },
  "1747": {
    "id": "1747",
    "name": "Красавино",
    "path": "Россия / Вологодская область / Красавино",
    "country": "Россия",
    "searchString": "красавино россия / вологодская область / красавино"
  },
  "1748": {
    "id": "1748",
    "name": "Никольск (Вологодская область)",
    "path": "Россия / Вологодская область / Никольск (Вологодская область)",
    "country": "Россия",
    "searchString": "никольск (вологодская область) россия / вологодская область / никольск (вологодская область)"
  },
  "1749": {
    "id": "1749",
    "name": "Сокол",
    "path": "Россия / Вологодская область / Сокол",
    "country": "Россия",
    "searchString": "сокол россия / вологодская область / сокол"
  },
  "1750": {
    "id": "1750",
    "name": "Тотьма",
    "path": "Россия / Вологодская область / Тотьма",
    "country": "Россия",
    "searchString": "тотьма россия / вологодская область / тотьма"
  },
  "1751": {
    "id": "1751",
    "name": "Устюжна",
    "path": "Россия / Вологодская область / Устюжна",
    "country": "Россия",
    "searchString": "устюжна россия / вологодская область / устюжна"
  },
  "1752": {
    "id": "1752",
    "name": "Харовск",
    "path": "Россия / Вологодская область / Харовск",
    "country": "Россия",
    "searchString": "харовск россия / вологодская область / харовск"
  },
  "1753": {
    "id": "1753",
    "name": "Череповец",
    "path": "Россия / Вологодская область / Череповец",
    "country": "Россия",
    "searchString": "череповец россия / вологодская область / череповец"
  },
  "1754": {
    "id": "1754",
    "name": "Ивановская область",
    "path": "Россия / Ивановская область",
    "country": "Россия",
    "searchString": "ивановская область россия / ивановская область"
  },
  "1755": {
    "id": "1755",
    "name": "Вичуга",
    "path": "Россия / Ивановская область / Вичуга",
    "country": "Россия",
    "searchString": "вичуга россия / ивановская область / вичуга"
  },
  "1756": {
    "id": "1756",
    "name": "Гаврилов Посад",
    "path": "Россия / Ивановская область / Гаврилов Посад",
    "country": "Россия",
    "searchString": "гаврилов посад россия / ивановская область / гаврилов посад"
  },
  "1757": {
    "id": "1757",
    "name": "Заволжск",
    "path": "Россия / Ивановская область / Заволжск",
    "country": "Россия",
    "searchString": "заволжск россия / ивановская область / заволжск"
  },
  "1758": {
    "id": "1758",
    "name": "Кинешма",
    "path": "Россия / Ивановская область / Кинешма",
    "country": "Россия",
    "searchString": "кинешма россия / ивановская область / кинешма"
  },
  "1759": {
    "id": "1759",
    "name": "Комсомольск (Ивановская область)",
    "path": "Россия / Ивановская область / Комсомольск (Ивановская область)",
    "country": "Россия",
    "searchString": "комсомольск (ивановская область) россия / ивановская область / комсомольск (ивановская область)"
  },
  "1760": {
    "id": "1760",
    "name": "Кохма",
    "path": "Россия / Ивановская область / Кохма",
    "country": "Россия",
    "searchString": "кохма россия / ивановская область / кохма"
  },
  "1761": {
    "id": "1761",
    "name": "Наволоки",
    "path": "Россия / Ивановская область / Наволоки",
    "country": "Россия",
    "searchString": "наволоки россия / ивановская область / наволоки"
  },
  "1762": {
    "id": "1762",
    "name": "Плес",
    "path": "Россия / Ивановская область / Плес",
    "country": "Россия",
    "searchString": "плес россия / ивановская область / плес"
  },
  "1763": {
    "id": "1763",
    "name": "Приволжск",
    "path": "Россия / Ивановская область / Приволжск",
    "country": "Россия",
    "searchString": "приволжск россия / ивановская область / приволжск"
  },
  "1764": {
    "id": "1764",
    "name": "Пучеж",
    "path": "Россия / Ивановская область / Пучеж",
    "country": "Россия",
    "searchString": "пучеж россия / ивановская область / пучеж"
  },
  "1765": {
    "id": "1765",
    "name": "Родники (Ивановская область)",
    "path": "Россия / Ивановская область / Родники (Ивановская область)",
    "country": "Россия",
    "searchString": "родники (ивановская область) россия / ивановская область / родники (ивановская область)"
  },
  "1766": {
    "id": "1766",
    "name": "Тейково",
    "path": "Россия / Ивановская область / Тейково",
    "country": "Россия",
    "searchString": "тейково россия / ивановская область / тейково"
  },
  "1767": {
    "id": "1767",
    "name": "Фурманов",
    "path": "Россия / Ивановская область / Фурманов",
    "country": "Россия",
    "searchString": "фурманов россия / ивановская область / фурманов"
  },
  "1768": {
    "id": "1768",
    "name": "Шуя",
    "path": "Россия / Ивановская область / Шуя",
    "country": "Россия",
    "searchString": "шуя россия / ивановская область / шуя"
  },
  "1769": {
    "id": "1769",
    "name": "Южа",
    "path": "Россия / Ивановская область / Южа",
    "country": "Россия",
    "searchString": "южа россия / ивановская область / южа"
  },
  "1770": {
    "id": "1770",
    "name": "Юрьевец",
    "path": "Россия / Ивановская область / Юрьевец",
    "country": "Россия",
    "searchString": "юрьевец россия / ивановская область / юрьевец"
  },
  "1771": {
    "id": "1771",
    "name": "Костромская область",
    "path": "Россия / Костромская область",
    "country": "Россия",
    "searchString": "костромская область россия / костромская область"
  },
  "1772": {
    "id": "1772",
    "name": "Буй",
    "path": "Россия / Костромская область / Буй",
    "country": "Россия",
    "searchString": "буй россия / костромская область / буй"
  },
  "1773": {
    "id": "1773",
    "name": "Волгореченск",
    "path": "Россия / Костромская область / Волгореченск",
    "country": "Россия",
    "searchString": "волгореченск россия / костромская область / волгореченск"
  },
  "1774": {
    "id": "1774",
    "name": "Галич (Костромская область)",
    "path": "Россия / Костромская область / Галич (Костромская область)",
    "country": "Россия",
    "searchString": "галич (костромская область) россия / костромская область / галич (костромская область)"
  },
  "1775": {
    "id": "1775",
    "name": "Кологрив",
    "path": "Россия / Костромская область / Кологрив",
    "country": "Россия",
    "searchString": "кологрив россия / костромская область / кологрив"
  },
  "1776": {
    "id": "1776",
    "name": "Макарьев",
    "path": "Россия / Костромская область / Макарьев",
    "country": "Россия",
    "searchString": "макарьев россия / костромская область / макарьев"
  },
  "1777": {
    "id": "1777",
    "name": "Мантурово",
    "path": "Россия / Костромская область / Мантурово",
    "country": "Россия",
    "searchString": "мантурово россия / костромская область / мантурово"
  },
  "1778": {
    "id": "1778",
    "name": "Нерехта",
    "path": "Россия / Костромская область / Нерехта",
    "country": "Россия",
    "searchString": "нерехта россия / костромская область / нерехта"
  },
  "1779": {
    "id": "1779",
    "name": "Нея",
    "path": "Россия / Костромская область / Нея",
    "country": "Россия",
    "searchString": "нея россия / костромская область / нея"
  },
  "1780": {
    "id": "1780",
    "name": "Солигалич",
    "path": "Россия / Костромская область / Солигалич",
    "country": "Россия",
    "searchString": "солигалич россия / костромская область / солигалич"
  },
  "1781": {
    "id": "1781",
    "name": "Чухлома",
    "path": "Россия / Костромская область / Чухлома",
    "country": "Россия",
    "searchString": "чухлома россия / костромская область / чухлома"
  },
  "1782": {
    "id": "1782",
    "name": "Шарья",
    "path": "Россия / Костромская область / Шарья",
    "country": "Россия",
    "searchString": "шарья россия / костромская область / шарья"
  },
  "1783": {
    "id": "1783",
    "name": "Тверская область",
    "path": "Россия / Тверская область",
    "country": "Россия",
    "searchString": "тверская область россия / тверская область"
  },
  "1784": {
    "id": "1784",
    "name": "Андреаполь",
    "path": "Россия / Тверская область / Андреаполь",
    "country": "Россия",
    "searchString": "андреаполь россия / тверская область / андреаполь"
  },
  "1785": {
    "id": "1785",
    "name": "Бежецк",
    "path": "Россия / Тверская область / Бежецк",
    "country": "Россия",
    "searchString": "бежецк россия / тверская область / бежецк"
  },
  "1786": {
    "id": "1786",
    "name": "Белый",
    "path": "Россия / Тверская область / Белый",
    "country": "Россия",
    "searchString": "белый россия / тверская область / белый"
  },
  "1787": {
    "id": "1787",
    "name": "Бологое",
    "path": "Россия / Тверская область / Бологое",
    "country": "Россия",
    "searchString": "бологое россия / тверская область / бологое"
  },
  "1788": {
    "id": "1788",
    "name": "Весьегонск",
    "path": "Россия / Тверская область / Весьегонск",
    "country": "Россия",
    "searchString": "весьегонск россия / тверская область / весьегонск"
  },
  "1789": {
    "id": "1789",
    "name": "Вышний Волочек",
    "path": "Россия / Тверская область / Вышний Волочек",
    "country": "Россия",
    "searchString": "вышний волочек россия / тверская область / вышний волочек"
  },
  "1790": {
    "id": "1790",
    "name": "Западная Двина",
    "path": "Россия / Тверская область / Западная Двина",
    "country": "Россия",
    "searchString": "западная двина россия / тверская область / западная двина"
  },
  "1791": {
    "id": "1791",
    "name": "Зубцов",
    "path": "Россия / Тверская область / Зубцов",
    "country": "Россия",
    "searchString": "зубцов россия / тверская область / зубцов"
  },
  "1792": {
    "id": "1792",
    "name": "Калязин",
    "path": "Россия / Тверская область / Калязин",
    "country": "Россия",
    "searchString": "калязин россия / тверская область / калязин"
  },
  "1793": {
    "id": "1793",
    "name": "Кашин",
    "path": "Россия / Тверская область / Кашин",
    "country": "Россия",
    "searchString": "кашин россия / тверская область / кашин"
  },
  "1794": {
    "id": "1794",
    "name": "Кимры",
    "path": "Россия / Тверская область / Кимры",
    "country": "Россия",
    "searchString": "кимры россия / тверская область / кимры"
  },
  "1795": {
    "id": "1795",
    "name": "Конаково",
    "path": "Россия / Тверская область / Конаково",
    "country": "Россия",
    "searchString": "конаково россия / тверская область / конаково"
  },
  "1796": {
    "id": "1796",
    "name": "Красный Холм",
    "path": "Россия / Тверская область / Красный Холм",
    "country": "Россия",
    "searchString": "красный холм россия / тверская область / красный холм"
  },
  "1797": {
    "id": "1797",
    "name": "Кувшиново",
    "path": "Россия / Тверская область / Кувшиново",
    "country": "Россия",
    "searchString": "кувшиново россия / тверская область / кувшиново"
  },
  "1798": {
    "id": "1798",
    "name": "Лихославль",
    "path": "Россия / Тверская область / Лихославль",
    "country": "Россия",
    "searchString": "лихославль россия / тверская область / лихославль"
  },
  "1799": {
    "id": "1799",
    "name": "Нелидово",
    "path": "Россия / Тверская область / Нелидово",
    "country": "Россия",
    "searchString": "нелидово россия / тверская область / нелидово"
  },
  "1800": {
    "id": "1800",
    "name": "Осташков",
    "path": "Россия / Тверская область / Осташков",
    "country": "Россия",
    "searchString": "осташков россия / тверская область / осташков"
  },
  "1801": {
    "id": "1801",
    "name": "Ржев",
    "path": "Россия / Тверская область / Ржев",
    "country": "Россия",
    "searchString": "ржев россия / тверская область / ржев"
  },
  "1802": {
    "id": "1802",
    "name": "Старица",
    "path": "Россия / Тверская область / Старица",
    "country": "Россия",
    "searchString": "старица россия / тверская область / старица"
  },
  "1803": {
    "id": "1803",
    "name": "Торжок",
    "path": "Россия / Тверская область / Торжок",
    "country": "Россия",
    "searchString": "торжок россия / тверская область / торжок"
  },
  "1804": {
    "id": "1804",
    "name": "Торопец",
    "path": "Россия / Тверская область / Торопец",
    "country": "Россия",
    "searchString": "торопец россия / тверская область / торопец"
  },
  "1805": {
    "id": "1805",
    "name": "Удомля",
    "path": "Россия / Тверская область / Удомля",
    "country": "Россия",
    "searchString": "удомля россия / тверская область / удомля"
  },
  "1806": {
    "id": "1806",
    "name": "Ярославская область",
    "path": "Россия / Ярославская область",
    "country": "Россия",
    "searchString": "ярославская область россия / ярославская область"
  },
  "1807": {
    "id": "1807",
    "name": "Гаврилов-Ям",
    "path": "Россия / Ярославская область / Гаврилов-Ям",
    "country": "Россия",
    "searchString": "гаврилов-ям россия / ярославская область / гаврилов-ям"
  },
  "1808": {
    "id": "1808",
    "name": "Данилов",
    "path": "Россия / Ярославская область / Данилов",
    "country": "Россия",
    "searchString": "данилов россия / ярославская область / данилов"
  },
  "1809": {
    "id": "1809",
    "name": "Любим",
    "path": "Россия / Ярославская область / Любим",
    "country": "Россия",
    "searchString": "любим россия / ярославская область / любим"
  },
  "1810": {
    "id": "1810",
    "name": "Мышкин",
    "path": "Россия / Ярославская область / Мышкин",
    "country": "Россия",
    "searchString": "мышкин россия / ярославская область / мышкин"
  },
  "1811": {
    "id": "1811",
    "name": "Переславль-Залесский",
    "path": "Россия / Ярославская область / Переславль-Залесский",
    "country": "Россия",
    "searchString": "переславль-залесский россия / ярославская область / переславль-залесский"
  },
  "1812": {
    "id": "1812",
    "name": "Пошехонье",
    "path": "Россия / Ярославская область / Пошехонье",
    "country": "Россия",
    "searchString": "пошехонье россия / ярославская область / пошехонье"
  },
  "1813": {
    "id": "1813",
    "name": "Ростов (Ярославская область)",
    "path": "Россия / Ярославская область / Ростов (Ярославская область)",
    "country": "Россия",
    "searchString": "ростов (ярославская область) россия / ярославская область / ростов (ярославская область)"
  },
  "1814": {
    "id": "1814",
    "name": "Рыбинск",
    "path": "Россия / Ярославская область / Рыбинск",
    "country": "Россия",
    "searchString": "рыбинск россия / ярославская область / рыбинск"
  },
  "1815": {
    "id": "1815",
    "name": "Тутаев",
    "path": "Россия / Ярославская область / Тутаев",
    "country": "Россия",
    "searchString": "тутаев россия / ярославская область / тутаев"
  },
  "1816": {
    "id": "1816",
    "name": "Углич",
    "path": "Россия / Ярославская область / Углич",
    "country": "Россия",
    "searchString": "углич россия / ярославская область / углич"
  },
  "1817": {
    "id": "1817",
    "name": "Белгородская область",
    "path": "Россия / Белгородская область",
    "country": "Россия",
    "searchString": "белгородская область россия / белгородская область"
  },
  "1818": {
    "id": "1818",
    "name": "Алексеевка",
    "path": "Россия / Белгородская область / Алексеевка",
    "country": "Россия",
    "searchString": "алексеевка россия / белгородская область / алексеевка"
  },
  "1819": {
    "id": "1819",
    "name": "Бирюч",
    "path": "Россия / Белгородская область / Бирюч",
    "country": "Россия",
    "searchString": "бирюч россия / белгородская область / бирюч"
  },
  "1820": {
    "id": "1820",
    "name": "Валуйки",
    "path": "Россия / Белгородская область / Валуйки",
    "country": "Россия",
    "searchString": "валуйки россия / белгородская область / валуйки"
  },
  "1821": {
    "id": "1821",
    "name": "Грайворон",
    "path": "Россия / Белгородская область / Грайворон",
    "country": "Россия",
    "searchString": "грайворон россия / белгородская область / грайворон"
  },
  "1822": {
    "id": "1822",
    "name": "Губкин",
    "path": "Россия / Белгородская область / Губкин",
    "country": "Россия",
    "searchString": "губкин россия / белгородская область / губкин"
  },
  "1823": {
    "id": "1823",
    "name": "Короча",
    "path": "Россия / Белгородская область / Короча",
    "country": "Россия",
    "searchString": "короча россия / белгородская область / короча"
  },
  "1824": {
    "id": "1824",
    "name": "Новый Оскол",
    "path": "Россия / Белгородская область / Новый Оскол",
    "country": "Россия",
    "searchString": "новый оскол россия / белгородская область / новый оскол"
  },
  "1825": {
    "id": "1825",
    "name": "Старый Оскол",
    "path": "Россия / Белгородская область / Старый Оскол",
    "country": "Россия",
    "searchString": "старый оскол россия / белгородская область / старый оскол"
  },
  "1826": {
    "id": "1826",
    "name": "Строитель (Белгородская область)",
    "path": "Россия / Белгородская область / Строитель (Белгородская область)",
    "country": "Россия",
    "searchString": "строитель (белгородская область) россия / белгородская область / строитель (белгородская область)"
  },
  "1827": {
    "id": "1827",
    "name": "Шебекино",
    "path": "Россия / Белгородская область / Шебекино",
    "country": "Россия",
    "searchString": "шебекино россия / белгородская область / шебекино"
  },
  "1828": {
    "id": "1828",
    "name": "Брянская область",
    "path": "Россия / Брянская область",
    "country": "Россия",
    "searchString": "брянская область россия / брянская область"
  },
  "1829": {
    "id": "1829",
    "name": "Дятьково",
    "path": "Россия / Брянская область / Дятьково",
    "country": "Россия",
    "searchString": "дятьково россия / брянская область / дятьково"
  },
  "1830": {
    "id": "1830",
    "name": "Жуковка (Брянская область)",
    "path": "Россия / Брянская область / Жуковка (Брянская область)",
    "country": "Россия",
    "searchString": "жуковка (брянская область) россия / брянская область / жуковка (брянская область)"
  },
  "1831": {
    "id": "1831",
    "name": "Злынка",
    "path": "Россия / Брянская область / Злынка",
    "country": "Россия",
    "searchString": "злынка россия / брянская область / злынка"
  },
  "1832": {
    "id": "1832",
    "name": "Карачев",
    "path": "Россия / Брянская область / Карачев",
    "country": "Россия",
    "searchString": "карачев россия / брянская область / карачев"
  },
  "1833": {
    "id": "1833",
    "name": "Клинцы",
    "path": "Россия / Брянская область / Клинцы",
    "country": "Россия",
    "searchString": "клинцы россия / брянская область / клинцы"
  },
  "1834": {
    "id": "1834",
    "name": "Мглин",
    "path": "Россия / Брянская область / Мглин",
    "country": "Россия",
    "searchString": "мглин россия / брянская область / мглин"
  },
  "1835": {
    "id": "1835",
    "name": "Новозыбков",
    "path": "Россия / Брянская область / Новозыбков",
    "country": "Россия",
    "searchString": "новозыбков россия / брянская область / новозыбков"
  },
  "1836": {
    "id": "1836",
    "name": "Почеп",
    "path": "Россия / Брянская область / Почеп",
    "country": "Россия",
    "searchString": "почеп россия / брянская область / почеп"
  },
  "1837": {
    "id": "1837",
    "name": "Севск",
    "path": "Россия / Брянская область / Севск",
    "country": "Россия",
    "searchString": "севск россия / брянская область / севск"
  },
  "1838": {
    "id": "1838",
    "name": "Сельцо",
    "path": "Россия / Брянская область / Сельцо",
    "country": "Россия",
    "searchString": "сельцо россия / брянская область / сельцо"
  },
  "1839": {
    "id": "1839",
    "name": "Стародуб",
    "path": "Россия / Брянская область / Стародуб",
    "country": "Россия",
    "searchString": "стародуб россия / брянская область / стародуб"
  },
  "1840": {
    "id": "1840",
    "name": "Сураж",
    "path": "Россия / Брянская область / Сураж",
    "country": "Россия",
    "searchString": "сураж россия / брянская область / сураж"
  },
  "1841": {
    "id": "1841",
    "name": "Трубчевск",
    "path": "Россия / Брянская область / Трубчевск",
    "country": "Россия",
    "searchString": "трубчевск россия / брянская область / трубчевск"
  },
  "1842": {
    "id": "1842",
    "name": "Унеча",
    "path": "Россия / Брянская область / Унеча",
    "country": "Россия",
    "searchString": "унеча россия / брянская область / унеча"
  },
  "1843": {
    "id": "1843",
    "name": "Фокино (Брянская область)",
    "path": "Россия / Брянская область / Фокино (Брянская область)",
    "country": "Россия",
    "searchString": "фокино (брянская область) россия / брянская область / фокино (брянская область)"
  },
  "1844": {
    "id": "1844",
    "name": "Воронежская область",
    "path": "Россия / Воронежская область",
    "country": "Россия",
    "searchString": "воронежская область россия / воронежская область"
  },
  "1845": {
    "id": "1845",
    "name": "Бобров",
    "path": "Россия / Воронежская область / Бобров",
    "country": "Россия",
    "searchString": "бобров россия / воронежская область / бобров"
  },
  "1846": {
    "id": "1846",
    "name": "Богучар",
    "path": "Россия / Воронежская область / Богучар",
    "country": "Россия",
    "searchString": "богучар россия / воронежская область / богучар"
  },
  "1847": {
    "id": "1847",
    "name": "Борисоглебск",
    "path": "Россия / Воронежская область / Борисоглебск",
    "country": "Россия",
    "searchString": "борисоглебск россия / воронежская область / борисоглебск"
  },
  "1848": {
    "id": "1848",
    "name": "Бутурлиновка",
    "path": "Россия / Воронежская область / Бутурлиновка",
    "country": "Россия",
    "searchString": "бутурлиновка россия / воронежская область / бутурлиновка"
  },
  "1849": {
    "id": "1849",
    "name": "Калач",
    "path": "Россия / Воронежская область / Калач",
    "country": "Россия",
    "searchString": "калач россия / воронежская область / калач"
  },
  "1850": {
    "id": "1850",
    "name": "Лиски",
    "path": "Россия / Воронежская область / Лиски",
    "country": "Россия",
    "searchString": "лиски россия / воронежская область / лиски"
  },
  "1851": {
    "id": "1851",
    "name": "Нововоронеж",
    "path": "Россия / Воронежская область / Нововоронеж",
    "country": "Россия",
    "searchString": "нововоронеж россия / воронежская область / нововоронеж"
  },
  "1852": {
    "id": "1852",
    "name": "Новохоперск",
    "path": "Россия / Воронежская область / Новохоперск",
    "country": "Россия",
    "searchString": "новохоперск россия / воронежская область / новохоперск"
  },
  "1853": {
    "id": "1853",
    "name": "Острогожск",
    "path": "Россия / Воронежская область / Острогожск",
    "country": "Россия",
    "searchString": "острогожск россия / воронежская область / острогожск"
  },
  "1854": {
    "id": "1854",
    "name": "Павловск (Воронежская область)",
    "path": "Россия / Воронежская область / Павловск (Воронежская область)",
    "country": "Россия",
    "searchString": "павловск (воронежская область) россия / воронежская область / павловск (воронежская область)"
  },
  "1855": {
    "id": "1855",
    "name": "Поворино",
    "path": "Россия / Воронежская область / Поворино",
    "country": "Россия",
    "searchString": "поворино россия / воронежская область / поворино"
  },
  "1856": {
    "id": "1856",
    "name": "Россошь",
    "path": "Россия / Воронежская область / Россошь",
    "country": "Россия",
    "searchString": "россошь россия / воронежская область / россошь"
  },
  "1857": {
    "id": "1857",
    "name": "Семилуки",
    "path": "Россия / Воронежская область / Семилуки",
    "country": "Россия",
    "searchString": "семилуки россия / воронежская область / семилуки"
  },
  "1858": {
    "id": "1858",
    "name": "Эртиль",
    "path": "Россия / Воронежская область / Эртиль",
    "country": "Россия",
    "searchString": "эртиль россия / воронежская область / эртиль"
  },
  "1859": {
    "id": "1859",
    "name": "Калужская область",
    "path": "Россия / Калужская область",
    "country": "Россия",
    "searchString": "калужская область россия / калужская область"
  },
  "1860": {
    "id": "1860",
    "name": "Балабаново",
    "path": "Россия / Калужская область / Балабаново",
    "country": "Россия",
    "searchString": "балабаново россия / калужская область / балабаново"
  },
  "1861": {
    "id": "1861",
    "name": "Белоусово",
    "path": "Россия / Калужская область / Белоусово",
    "country": "Россия",
    "searchString": "белоусово россия / калужская область / белоусово"
  },
  "1862": {
    "id": "1862",
    "name": "Боровск",
    "path": "Россия / Калужская область / Боровск",
    "country": "Россия",
    "searchString": "боровск россия / калужская область / боровск"
  },
  "1863": {
    "id": "1863",
    "name": "Ермолино (Калужская область)",
    "path": "Россия / Калужская область / Ермолино (Калужская область)",
    "country": "Россия",
    "searchString": "ермолино (калужская область) россия / калужская область / ермолино (калужская область)"
  },
  "1864": {
    "id": "1864",
    "name": "Жиздра",
    "path": "Россия / Калужская область / Жиздра",
    "country": "Россия",
    "searchString": "жиздра россия / калужская область / жиздра"
  },
  "1865": {
    "id": "1865",
    "name": "Жуков",
    "path": "Россия / Калужская область / Жуков",
    "country": "Россия",
    "searchString": "жуков россия / калужская область / жуков"
  },
  "1866": {
    "id": "1866",
    "name": "Киров (Калужская область)",
    "path": "Россия / Калужская область / Киров (Калужская область)",
    "country": "Россия",
    "searchString": "киров (калужская область) россия / калужская область / киров (калужская область)"
  },
  "1867": {
    "id": "1867",
    "name": "Козельск",
    "path": "Россия / Калужская область / Козельск",
    "country": "Россия",
    "searchString": "козельск россия / калужская область / козельск"
  },
  "1868": {
    "id": "1868",
    "name": "Кондрово",
    "path": "Россия / Калужская область / Кондрово",
    "country": "Россия",
    "searchString": "кондрово россия / калужская область / кондрово"
  },
  "1869": {
    "id": "1869",
    "name": "Кременки",
    "path": "Россия / Калужская область / Кременки",
    "country": "Россия",
    "searchString": "кременки россия / калужская область / кременки"
  },
  "1870": {
    "id": "1870",
    "name": "Людиново",
    "path": "Россия / Калужская область / Людиново",
    "country": "Россия",
    "searchString": "людиново россия / калужская область / людиново"
  },
  "1871": {
    "id": "1871",
    "name": "Малоярославец",
    "path": "Россия / Калужская область / Малоярославец",
    "country": "Россия",
    "searchString": "малоярославец россия / калужская область / малоярославец"
  },
  "1872": {
    "id": "1872",
    "name": "Медынь",
    "path": "Россия / Калужская область / Медынь",
    "country": "Россия",
    "searchString": "медынь россия / калужская область / медынь"
  },
  "1873": {
    "id": "1873",
    "name": "Мещовск",
    "path": "Россия / Калужская область / Мещовск",
    "country": "Россия",
    "searchString": "мещовск россия / калужская область / мещовск"
  },
  "1874": {
    "id": "1874",
    "name": "Мосальск",
    "path": "Россия / Калужская область / Мосальск",
    "country": "Россия",
    "searchString": "мосальск россия / калужская область / мосальск"
  },
  "1875": {
    "id": "1875",
    "name": "Сосенский",
    "path": "Россия / Калужская область / Сосенский",
    "country": "Россия",
    "searchString": "сосенский россия / калужская область / сосенский"
  },
  "1876": {
    "id": "1876",
    "name": "Спас-Деменск",
    "path": "Россия / Калужская область / Спас-Деменск",
    "country": "Россия",
    "searchString": "спас-деменск россия / калужская область / спас-деменск"
  },
  "1877": {
    "id": "1877",
    "name": "Сухиничи",
    "path": "Россия / Калужская область / Сухиничи",
    "country": "Россия",
    "searchString": "сухиничи россия / калужская область / сухиничи"
  },
  "1878": {
    "id": "1878",
    "name": "Таруса",
    "path": "Россия / Калужская область / Таруса",
    "country": "Россия",
    "searchString": "таруса россия / калужская область / таруса"
  },
  "1879": {
    "id": "1879",
    "name": "Юхнов",
    "path": "Россия / Калужская область / Юхнов",
    "country": "Россия",
    "searchString": "юхнов россия / калужская область / юхнов"
  },
  "1880": {
    "id": "1880",
    "name": "Курская область",
    "path": "Россия / Курская область",
    "country": "Россия",
    "searchString": "курская область россия / курская область"
  },
  "1881": {
    "id": "1881",
    "name": "Дмитриев-Льговский",
    "path": "Россия / Курская область / Дмитриев-Льговский",
    "country": "Россия",
    "searchString": "дмитриев-льговский россия / курская область / дмитриев-льговский"
  },
  "1882": {
    "id": "1882",
    "name": "Железногорск (Курская область)",
    "path": "Россия / Курская область / Железногорск (Курская область)",
    "country": "Россия",
    "searchString": "железногорск (курская область) россия / курская область / железногорск (курская область)"
  },
  "1883": {
    "id": "1883",
    "name": "Курчатов",
    "path": "Россия / Курская область / Курчатов",
    "country": "Россия",
    "searchString": "курчатов россия / курская область / курчатов"
  },
  "1884": {
    "id": "1884",
    "name": "Льгов",
    "path": "Россия / Курская область / Льгов",
    "country": "Россия",
    "searchString": "льгов россия / курская область / льгов"
  },
  "1885": {
    "id": "1885",
    "name": "Обоянь",
    "path": "Россия / Курская область / Обоянь",
    "country": "Россия",
    "searchString": "обоянь россия / курская область / обоянь"
  },
  "1886": {
    "id": "1886",
    "name": "Рыльск",
    "path": "Россия / Курская область / Рыльск",
    "country": "Россия",
    "searchString": "рыльск россия / курская область / рыльск"
  },
  "1887": {
    "id": "1887",
    "name": "Суджа",
    "path": "Россия / Курская область / Суджа",
    "country": "Россия",
    "searchString": "суджа россия / курская область / суджа"
  },
  "1888": {
    "id": "1888",
    "name": "Фатеж",
    "path": "Россия / Курская область / Фатеж",
    "country": "Россия",
    "searchString": "фатеж россия / курская область / фатеж"
  },
  "1889": {
    "id": "1889",
    "name": "Щигры",
    "path": "Россия / Курская область / Щигры",
    "country": "Россия",
    "searchString": "щигры россия / курская область / щигры"
  },
  "1890": {
    "id": "1890",
    "name": "Липецкая область",
    "path": "Россия / Липецкая область",
    "country": "Россия",
    "searchString": "липецкая область россия / липецкая область"
  },
  "1891": {
    "id": "1891",
    "name": "Грязи",
    "path": "Россия / Липецкая область / Грязи",
    "country": "Россия",
    "searchString": "грязи россия / липецкая область / грязи"
  },
  "1892": {
    "id": "1892",
    "name": "Данков",
    "path": "Россия / Липецкая область / Данков",
    "country": "Россия",
    "searchString": "данков россия / липецкая область / данков"
  },
  "1893": {
    "id": "1893",
    "name": "Елец",
    "path": "Россия / Липецкая область / Елец",
    "country": "Россия",
    "searchString": "елец россия / липецкая область / елец"
  },
  "1894": {
    "id": "1894",
    "name": "Задонск",
    "path": "Россия / Липецкая область / Задонск",
    "country": "Россия",
    "searchString": "задонск россия / липецкая область / задонск"
  },
  "1895": {
    "id": "1895",
    "name": "Лебедянь",
    "path": "Россия / Липецкая область / Лебедянь",
    "country": "Россия",
    "searchString": "лебедянь россия / липецкая область / лебедянь"
  },
  "1896": {
    "id": "1896",
    "name": "Усмань",
    "path": "Россия / Липецкая область / Усмань",
    "country": "Россия",
    "searchString": "усмань россия / липецкая область / усмань"
  },
  "1897": {
    "id": "1897",
    "name": "Чаплыгин",
    "path": "Россия / Липецкая область / Чаплыгин",
    "country": "Россия",
    "searchString": "чаплыгин россия / липецкая область / чаплыгин"
  },
  "1898": {
    "id": "1898",
    "name": "Орловская область",
    "path": "Россия / Орловская область",
    "country": "Россия",
    "searchString": "орловская область россия / орловская область"
  },
  "1899": {
    "id": "1899",
    "name": "Болхов",
    "path": "Россия / Орловская область / Болхов",
    "country": "Россия",
    "searchString": "болхов россия / орловская область / болхов"
  },
  "1900": {
    "id": "1900",
    "name": "Дмитровск",
    "path": "Россия / Орловская область / Дмитровск",
    "country": "Россия",
    "searchString": "дмитровск россия / орловская область / дмитровск"
  },
  "1901": {
    "id": "1901",
    "name": "Ливны",
    "path": "Россия / Орловская область / Ливны",
    "country": "Россия",
    "searchString": "ливны россия / орловская область / ливны"
  },
  "1902": {
    "id": "1902",
    "name": "Малоархангельск",
    "path": "Россия / Орловская область / Малоархангельск",
    "country": "Россия",
    "searchString": "малоархангельск россия / орловская область / малоархангельск"
  },
  "1903": {
    "id": "1903",
    "name": "Мценск",
    "path": "Россия / Орловская область / Мценск",
    "country": "Россия",
    "searchString": "мценск россия / орловская область / мценск"
  },
  "1904": {
    "id": "1904",
    "name": "Новосиль",
    "path": "Россия / Орловская область / Новосиль",
    "country": "Россия",
    "searchString": "новосиль россия / орловская область / новосиль"
  },
  "1905": {
    "id": "1905",
    "name": "Тамбовская область",
    "path": "Россия / Тамбовская область",
    "country": "Россия",
    "searchString": "тамбовская область россия / тамбовская область"
  },
  "1906": {
    "id": "1906",
    "name": "Жердевка",
    "path": "Россия / Тамбовская область / Жердевка",
    "country": "Россия",
    "searchString": "жердевка россия / тамбовская область / жердевка"
  },
  "1907": {
    "id": "1907",
    "name": "Кирсанов",
    "path": "Россия / Тамбовская область / Кирсанов",
    "country": "Россия",
    "searchString": "кирсанов россия / тамбовская область / кирсанов"
  },
  "1908": {
    "id": "1908",
    "name": "Котовск (Тамбовская область)",
    "path": "Россия / Тамбовская область / Котовск (Тамбовская область)",
    "country": "Россия",
    "searchString": "котовск (тамбовская область) россия / тамбовская область / котовск (тамбовская область)"
  },
  "1909": {
    "id": "1909",
    "name": "Мичуринск",
    "path": "Россия / Тамбовская область / Мичуринск",
    "country": "Россия",
    "searchString": "мичуринск россия / тамбовская область / мичуринск"
  },
  "1910": {
    "id": "1910",
    "name": "Моршанск",
    "path": "Россия / Тамбовская область / Моршанск",
    "country": "Россия",
    "searchString": "моршанск россия / тамбовская область / моршанск"
  },
  "1911": {
    "id": "1911",
    "name": "Рассказово",
    "path": "Россия / Тамбовская область / Рассказово",
    "country": "Россия",
    "searchString": "рассказово россия / тамбовская область / рассказово"
  },
  "1912": {
    "id": "1912",
    "name": "Уварово",
    "path": "Россия / Тамбовская область / Уварово",
    "country": "Россия",
    "searchString": "уварово россия / тамбовская область / уварово"
  },
  "1913": {
    "id": "1913",
    "name": "Тульская область",
    "path": "Россия / Тульская область",
    "country": "Россия",
    "searchString": "тульская область россия / тульская область"
  },
  "1914": {
    "id": "1914",
    "name": "Алексин",
    "path": "Россия / Тульская область / Алексин",
    "country": "Россия",
    "searchString": "алексин россия / тульская область / алексин"
  },
  "1915": {
    "id": "1915",
    "name": "Белев",
    "path": "Россия / Тульская область / Белев",
    "country": "Россия",
    "searchString": "белев россия / тульская область / белев"
  },
  "1916": {
    "id": "1916",
    "name": "Богородицк",
    "path": "Россия / Тульская область / Богородицк",
    "country": "Россия",
    "searchString": "богородицк россия / тульская область / богородицк"
  },
  "1917": {
    "id": "1917",
    "name": "Болохово",
    "path": "Россия / Тульская область / Болохово",
    "country": "Россия",
    "searchString": "болохово россия / тульская область / болохово"
  },
  "1918": {
    "id": "1918",
    "name": "Венев",
    "path": "Россия / Тульская область / Венев",
    "country": "Россия",
    "searchString": "венев россия / тульская область / венев"
  },
  "1919": {
    "id": "1919",
    "name": "Донской",
    "path": "Россия / Тульская область / Донской",
    "country": "Россия",
    "searchString": "донской россия / тульская область / донской"
  },
  "1920": {
    "id": "1920",
    "name": "Ефремов",
    "path": "Россия / Тульская область / Ефремов",
    "country": "Россия",
    "searchString": "ефремов россия / тульская область / ефремов"
  },
  "1921": {
    "id": "1921",
    "name": "Кимовск",
    "path": "Россия / Тульская область / Кимовск",
    "country": "Россия",
    "searchString": "кимовск россия / тульская область / кимовск"
  },
  "1922": {
    "id": "1922",
    "name": "Киреевск",
    "path": "Россия / Тульская область / Киреевск",
    "country": "Россия",
    "searchString": "киреевск россия / тульская область / киреевск"
  },
  "1923": {
    "id": "1923",
    "name": "Липки",
    "path": "Россия / Тульская область / Липки",
    "country": "Россия",
    "searchString": "липки россия / тульская область / липки"
  },
  "1924": {
    "id": "1924",
    "name": "Новомосковск (Тульская область)",
    "path": "Россия / Тульская область / Новомосковск (Тульская область)",
    "country": "Россия",
    "searchString": "новомосковск (тульская область) россия / тульская область / новомосковск (тульская область)"
  },
  "1925": {
    "id": "1925",
    "name": "Плавск",
    "path": "Россия / Тульская область / Плавск",
    "country": "Россия",
    "searchString": "плавск россия / тульская область / плавск"
  },
  "1926": {
    "id": "1926",
    "name": "Советск (Тульская область)",
    "path": "Россия / Тульская область / Советск (Тульская область)",
    "country": "Россия",
    "searchString": "советск (тульская область) россия / тульская область / советск (тульская область)"
  },
  "1927": {
    "id": "1927",
    "name": "Суворов",
    "path": "Россия / Тульская область / Суворов",
    "country": "Россия",
    "searchString": "суворов россия / тульская область / суворов"
  },
  "1928": {
    "id": "1928",
    "name": "Узловая",
    "path": "Россия / Тульская область / Узловая",
    "country": "Россия",
    "searchString": "узловая россия / тульская область / узловая"
  },
  "1929": {
    "id": "1929",
    "name": "Чекалин",
    "path": "Россия / Тульская область / Чекалин",
    "country": "Россия",
    "searchString": "чекалин россия / тульская область / чекалин"
  },
  "1930": {
    "id": "1930",
    "name": "Щекино",
    "path": "Россия / Тульская область / Щекино",
    "country": "Россия",
    "searchString": "щекино россия / тульская область / щекино"
  },
  "1931": {
    "id": "1931",
    "name": "Ясногорск",
    "path": "Россия / Тульская область / Ясногорск",
    "country": "Россия",
    "searchString": "ясногорск россия / тульская область / ясногорск"
  },
  "1932": {
    "id": "1932",
    "name": "Амурская область",
    "path": "Россия / Амурская область",
    "country": "Россия",
    "searchString": "амурская область россия / амурская область"
  },
  "1933": {
    "id": "1933",
    "name": "Белогорск",
    "path": "Россия / Амурская область / Белогорск",
    "country": "Россия",
    "searchString": "белогорск россия / амурская область / белогорск"
  },
  "1934": {
    "id": "1934",
    "name": "Завитинск",
    "path": "Россия / Амурская область / Завитинск",
    "country": "Россия",
    "searchString": "завитинск россия / амурская область / завитинск"
  },
  "1935": {
    "id": "1935",
    "name": "Зея",
    "path": "Россия / Амурская область / Зея",
    "country": "Россия",
    "searchString": "зея россия / амурская область / зея"
  },
  "1936": {
    "id": "1936",
    "name": "Райчихинск",
    "path": "Россия / Амурская область / Райчихинск",
    "country": "Россия",
    "searchString": "райчихинск россия / амурская область / райчихинск"
  },
  "1937": {
    "id": "1937",
    "name": "Свободный",
    "path": "Россия / Амурская область / Свободный",
    "country": "Россия",
    "searchString": "свободный россия / амурская область / свободный"
  },
  "1938": {
    "id": "1938",
    "name": "Сковородино",
    "path": "Россия / Амурская область / Сковородино",
    "country": "Россия",
    "searchString": "сковородино россия / амурская область / сковородино"
  },
  "1939": {
    "id": "1939",
    "name": "Тында",
    "path": "Россия / Амурская область / Тында",
    "country": "Россия",
    "searchString": "тында россия / амурская область / тында"
  },
  "1940": {
    "id": "1940",
    "name": "Шимановск",
    "path": "Россия / Амурская область / Шимановск",
    "country": "Россия",
    "searchString": "шимановск россия / амурская область / шимановск"
  },
  "1941": {
    "id": "1941",
    "name": "Еврейская АО",
    "path": "Россия / Еврейская АО",
    "country": "Россия",
    "searchString": "еврейская ао россия / еврейская ао"
  },
  "1942": {
    "id": "1942",
    "name": "Облучье",
    "path": "Россия / Еврейская АО / Облучье",
    "country": "Россия",
    "searchString": "облучье россия / еврейская ао / облучье"
  },
  "1943": {
    "id": "1943",
    "name": "Камчатский край",
    "path": "Россия / Камчатский край",
    "country": "Россия",
    "searchString": "камчатский край россия / камчатский край"
  },
  "1944": {
    "id": "1944",
    "name": "Вилючинск",
    "path": "Россия / Камчатский край / Вилючинск",
    "country": "Россия",
    "searchString": "вилючинск россия / камчатский край / вилючинск"
  },
  "1945": {
    "id": "1945",
    "name": "Елизово",
    "path": "Россия / Камчатский край / Елизово",
    "country": "Россия",
    "searchString": "елизово россия / камчатский край / елизово"
  },
  "1946": {
    "id": "1946",
    "name": "Магаданская область",
    "path": "Россия / Магаданская область",
    "country": "Россия",
    "searchString": "магаданская область россия / магаданская область"
  },
  "1947": {
    "id": "1947",
    "name": "Сусуман",
    "path": "Россия / Магаданская область / Сусуман",
    "country": "Россия",
    "searchString": "сусуман россия / магаданская область / сусуман"
  },
  "1948": {
    "id": "1948",
    "name": "Приморский край",
    "path": "Россия / Приморский край",
    "country": "Россия",
    "searchString": "приморский край россия / приморский край"
  },
  "1949": {
    "id": "1949",
    "name": "Арсеньев",
    "path": "Россия / Приморский край / Арсеньев",
    "country": "Россия",
    "searchString": "арсеньев россия / приморский край / арсеньев"
  },
  "1950": {
    "id": "1950",
    "name": "Артем",
    "path": "Россия / Приморский край / Артем",
    "country": "Россия",
    "searchString": "артем россия / приморский край / артем"
  },
  "1951": {
    "id": "1951",
    "name": "Большой Камень",
    "path": "Россия / Приморский край / Большой Камень",
    "country": "Россия",
    "searchString": "большой камень россия / приморский край / большой камень"
  },
  "1952": {
    "id": "1952",
    "name": "Дальнегорск",
    "path": "Россия / Приморский край / Дальнегорск",
    "country": "Россия",
    "searchString": "дальнегорск россия / приморский край / дальнегорск"
  },
  "1953": {
    "id": "1953",
    "name": "Дальнереченск",
    "path": "Россия / Приморский край / Дальнереченск",
    "country": "Россия",
    "searchString": "дальнереченск россия / приморский край / дальнереченск"
  },
  "1954": {
    "id": "1954",
    "name": "Лесозаводск",
    "path": "Россия / Приморский край / Лесозаводск",
    "country": "Россия",
    "searchString": "лесозаводск россия / приморский край / лесозаводск"
  },
  "1955": {
    "id": "1955",
    "name": "Находка",
    "path": "Россия / Приморский край / Находка",
    "country": "Россия",
    "searchString": "находка россия / приморский край / находка"
  },
  "1956": {
    "id": "1956",
    "name": "Партизанск",
    "path": "Россия / Приморский край / Партизанск",
    "country": "Россия",
    "searchString": "партизанск россия / приморский край / партизанск"
  },
  "1957": {
    "id": "1957",
    "name": "Спасск-Дальний",
    "path": "Россия / Приморский край / Спасск-Дальний",
    "country": "Россия",
    "searchString": "спасск-дальний россия / приморский край / спасск-дальний"
  },
  "1958": {
    "id": "1958",
    "name": "Уссурийск",
    "path": "Россия / Приморский край / Уссурийск",
    "country": "Россия",
    "searchString": "уссурийск россия / приморский край / уссурийск"
  },
  "1959": {
    "id": "1959",
    "name": "Фокино (Приморский край)",
    "path": "Россия / Приморский край / Фокино (Приморский край)",
    "country": "Россия",
    "searchString": "фокино (приморский край) россия / приморский край / фокино (приморский край)"
  },
  "1960": {
    "id": "1960",
    "name": "Сахалинская область",
    "path": "Россия / Сахалинская область",
    "country": "Россия",
    "searchString": "сахалинская область россия / сахалинская область"
  },
  "1961": {
    "id": "1961",
    "name": "Александровск-Сахалинский",
    "path": "Россия / Сахалинская область / Александровск-Сахалинский",
    "country": "Россия",
    "searchString": "александровск-сахалинский россия / сахалинская область / александровск-сахалинский"
  },
  "1962": {
    "id": "1962",
    "name": "Анива",
    "path": "Россия / Сахалинская область / Анива",
    "country": "Россия",
    "searchString": "анива россия / сахалинская область / анива"
  },
  "1963": {
    "id": "1963",
    "name": "Долинск",
    "path": "Россия / Сахалинская область / Долинск",
    "country": "Россия",
    "searchString": "долинск россия / сахалинская область / долинск"
  },
  "1964": {
    "id": "1964",
    "name": "Корсаков",
    "path": "Россия / Сахалинская область / Корсаков",
    "country": "Россия",
    "searchString": "корсаков россия / сахалинская область / корсаков"
  },
  "1965": {
    "id": "1965",
    "name": "Курильск",
    "path": "Россия / Сахалинская область / Курильск",
    "country": "Россия",
    "searchString": "курильск россия / сахалинская область / курильск"
  },
  "1966": {
    "id": "1966",
    "name": "Макаров (Сахалинская область)",
    "path": "Россия / Сахалинская область / Макаров (Сахалинская область)",
    "country": "Россия",
    "searchString": "макаров (сахалинская область) россия / сахалинская область / макаров (сахалинская область)"
  },
  "1967": {
    "id": "1967",
    "name": "Невельск",
    "path": "Россия / Сахалинская область / Невельск",
    "country": "Россия",
    "searchString": "невельск россия / сахалинская область / невельск"
  },
  "1968": {
    "id": "1968",
    "name": "Оха",
    "path": "Россия / Сахалинская область / Оха",
    "country": "Россия",
    "searchString": "оха россия / сахалинская область / оха"
  },
  "1969": {
    "id": "1969",
    "name": "Поронайск",
    "path": "Россия / Сахалинская область / Поронайск",
    "country": "Россия",
    "searchString": "поронайск россия / сахалинская область / поронайск"
  },
  "1970": {
    "id": "1970",
    "name": "Северо-Курильск",
    "path": "Россия / Сахалинская область / Северо-Курильск",
    "country": "Россия",
    "searchString": "северо-курильск россия / сахалинская область / северо-курильск"
  },
  "1971": {
    "id": "1971",
    "name": "Томари",
    "path": "Россия / Сахалинская область / Томари",
    "country": "Россия",
    "searchString": "томари россия / сахалинская область / томари"
  },
  "1972": {
    "id": "1972",
    "name": "Углегорск",
    "path": "Россия / Сахалинская область / Углегорск",
    "country": "Россия",
    "searchString": "углегорск россия / сахалинская область / углегорск"
  },
  "1973": {
    "id": "1973",
    "name": "Холмск",
    "path": "Россия / Сахалинская область / Холмск",
    "country": "Россия",
    "searchString": "холмск россия / сахалинская область / холмск"
  },
  "1974": {
    "id": "1974",
    "name": "Шахтерск (Сахалинская область)",
    "path": "Россия / Сахалинская область / Шахтерск (Сахалинская область)",
    "country": "Россия",
    "searchString": "шахтерск (сахалинская область) россия / сахалинская область / шахтерск (сахалинская область)"
  },
  "1975": {
    "id": "1975",
    "name": "Хабаровский край",
    "path": "Россия / Хабаровский край",
    "country": "Россия",
    "searchString": "хабаровский край россия / хабаровский край"
  },
  "1976": {
    "id": "1976",
    "name": "Амурск",
    "path": "Россия / Хабаровский край / Амурск",
    "country": "Россия",
    "searchString": "амурск россия / хабаровский край / амурск"
  },
  "1977": {
    "id": "1977",
    "name": "Бикин",
    "path": "Россия / Хабаровский край / Бикин",
    "country": "Россия",
    "searchString": "бикин россия / хабаровский край / бикин"
  },
  "1978": {
    "id": "1978",
    "name": "Вяземский",
    "path": "Россия / Хабаровский край / Вяземский",
    "country": "Россия",
    "searchString": "вяземский россия / хабаровский край / вяземский"
  },
  "1979": {
    "id": "1979",
    "name": "Комсомольск-на-Амуре",
    "path": "Россия / Хабаровский край / Комсомольск-на-Амуре",
    "country": "Россия",
    "searchString": "комсомольск-на-амуре россия / хабаровский край / комсомольск-на-амуре"
  },
  "1980": {
    "id": "1980",
    "name": "Николаевск-на-Амуре",
    "path": "Россия / Хабаровский край / Николаевск-на-Амуре",
    "country": "Россия",
    "searchString": "николаевск-на-амуре россия / хабаровский край / николаевск-на-амуре"
  },
  "1981": {
    "id": "1981",
    "name": "Советская Гавань",
    "path": "Россия / Хабаровский край / Советская Гавань",
    "country": "Россия",
    "searchString": "советская гавань россия / хабаровский край / советская гавань"
  },
  "1982": {
    "id": "1982",
    "name": "Чукотский АО",
    "path": "Россия / Чукотский АО",
    "country": "Россия",
    "searchString": "чукотский ао россия / чукотский ао"
  },
  "1983": {
    "id": "1983",
    "name": "Билибино",
    "path": "Россия / Чукотский АО / Билибино",
    "country": "Россия",
    "searchString": "билибино россия / чукотский ао / билибино"
  },
  "1984": {
    "id": "1984",
    "name": "Певек",
    "path": "Россия / Чукотский АО / Певек",
    "country": "Россия",
    "searchString": "певек россия / чукотский ао / певек"
  },
  "1985": {
    "id": "1985",
    "name": "Ненецкий АО",
    "path": "Россия / Ненецкий АО",
    "country": "Россия",
    "searchString": "ненецкий ао россия / ненецкий ао"
  },
  "1986": {
    "id": "1986",
    "name": "Нарьян-Мар",
    "path": "Россия / Ненецкий АО / Нарьян-Мар",
    "country": "Россия",
    "searchString": "нарьян-мар россия / ненецкий ао / нарьян-мар"
  },
  "1987": {
    "id": "1987",
    "name": "Волосово",
    "path": "Россия / Ленинградская область / Волосово",
    "country": "Россия",
    "searchString": "волосово россия / ленинградская область / волосово"
  },
  "1988": {
    "id": "1988",
    "name": "Бокситогорск",
    "path": "Россия / Ленинградская область / Бокситогорск",
    "country": "Россия",
    "searchString": "бокситогорск россия / ленинградская область / бокситогорск"
  },
  "1989": {
    "id": "1989",
    "name": "Волхов",
    "path": "Россия / Ленинградская область / Волхов",
    "country": "Россия",
    "searchString": "волхов россия / ленинградская область / волхов"
  },
  "1990": {
    "id": "1990",
    "name": "Всеволожск",
    "path": "Россия / Ленинградская область / Всеволожск",
    "country": "Россия",
    "searchString": "всеволожск россия / ленинградская область / всеволожск"
  },
  "1991": {
    "id": "1991",
    "name": "Выборг",
    "path": "Россия / Ленинградская область / Выборг",
    "country": "Россия",
    "searchString": "выборг россия / ленинградская область / выборг"
  },
  "1992": {
    "id": "1992",
    "name": "Высоцк",
    "path": "Россия / Ленинградская область / Высоцк",
    "country": "Россия",
    "searchString": "высоцк россия / ленинградская область / высоцк"
  },
  "1993": {
    "id": "1993",
    "name": "Гатчина",
    "path": "Россия / Ленинградская область / Гатчина",
    "country": "Россия",
    "searchString": "гатчина россия / ленинградская область / гатчина"
  },
  "1994": {
    "id": "1994",
    "name": "Ивангород",
    "path": "Россия / Ленинградская область / Ивангород",
    "country": "Россия",
    "searchString": "ивангород россия / ленинградская область / ивангород"
  },
  "1995": {
    "id": "1995",
    "name": "Каменногорск",
    "path": "Россия / Ленинградская область / Каменногорск",
    "country": "Россия",
    "searchString": "каменногорск россия / ленинградская область / каменногорск"
  },
  "1996": {
    "id": "1996",
    "name": "Кингисепп",
    "path": "Россия / Ленинградская область / Кингисепп",
    "country": "Россия",
    "searchString": "кингисепп россия / ленинградская область / кингисепп"
  },
  "1997": {
    "id": "1997",
    "name": "Кириши",
    "path": "Россия / Ленинградская область / Кириши",
    "country": "Россия",
    "searchString": "кириши россия / ленинградская область / кириши"
  },
  "1998": {
    "id": "1998",
    "name": "Кировск (Ленинградская область)",
    "path": "Россия / Ленинградская область / Кировск (Ленинградская область)",
    "country": "Россия",
    "searchString": "кировск (ленинградская область) россия / ленинградская область / кировск (ленинградская область)"
  },
  "1999": {
    "id": "1999",
    "name": "Коммунар",
    "path": "Россия / Ленинградская область / Коммунар",
    "country": "Россия",
    "searchString": "коммунар россия / ленинградская область / коммунар"
  },
  "2000": {
    "id": "2000",
    "name": "Лодейное Поле",
    "path": "Россия / Ленинградская область / Лодейное Поле",
    "country": "Россия",
    "searchString": "лодейное поле россия / ленинградская область / лодейное поле"
  },
  "2001": {
    "id": "2001",
    "name": "Ломоносов",
    "path": "Россия / Ленинградская область / Ломоносов",
    "country": "Россия",
    "searchString": "ломоносов россия / ленинградская область / ломоносов"
  },
  "2002": {
    "id": "2002",
    "name": "Луга",
    "path": "Россия / Ленинградская область / Луга",
    "country": "Россия",
    "searchString": "луга россия / ленинградская область / луга"
  },
  "2003": {
    "id": "2003",
    "name": "Любань (Ленинградская область)",
    "path": "Россия / Ленинградская область / Любань (Ленинградская область)",
    "country": "Россия",
    "searchString": "любань (ленинградская область) россия / ленинградская область / любань (ленинградская область)"
  },
  "2004": {
    "id": "2004",
    "name": "Никольское",
    "path": "Россия / Ленинградская область / Никольское",
    "country": "Россия",
    "searchString": "никольское россия / ленинградская область / никольское"
  },
  "2005": {
    "id": "2005",
    "name": "Новая Ладога",
    "path": "Россия / Ленинградская область / Новая Ладога",
    "country": "Россия",
    "searchString": "новая ладога россия / ленинградская область / новая ладога"
  },
  "2006": {
    "id": "2006",
    "name": "Отрадное (Ленинградская область)",
    "path": "Россия / Ленинградская область / Отрадное (Ленинградская область)",
    "country": "Россия",
    "searchString": "отрадное (ленинградская область) россия / ленинградская область / отрадное (ленинградская область)"
  },
  "2007": {
    "id": "2007",
    "name": "Пикалево",
    "path": "Россия / Ленинградская область / Пикалево",
    "country": "Россия",
    "searchString": "пикалево россия / ленинградская область / пикалево"
  },
  "2008": {
    "id": "2008",
    "name": "Подпорожье",
    "path": "Россия / Ленинградская область / Подпорожье",
    "country": "Россия",
    "searchString": "подпорожье россия / ленинградская область / подпорожье"
  },
  "2009": {
    "id": "2009",
    "name": "Приморск (Ленинградская область)",
    "path": "Россия / Ленинградская область / Приморск (Ленинградская область)",
    "country": "Россия",
    "searchString": "приморск (ленинградская область) россия / ленинградская область / приморск (ленинградская область)"
  },
  "2010": {
    "id": "2010",
    "name": "Приозерск",
    "path": "Россия / Ленинградская область / Приозерск",
    "country": "Россия",
    "searchString": "приозерск россия / ленинградская область / приозерск"
  },
  "2011": {
    "id": "2011",
    "name": "Светогорск",
    "path": "Россия / Ленинградская область / Светогорск",
    "country": "Россия",
    "searchString": "светогорск россия / ленинградская область / светогорск"
  },
  "2012": {
    "id": "2012",
    "name": "Сертолово",
    "path": "Россия / Ленинградская область / Сертолово",
    "country": "Россия",
    "searchString": "сертолово россия / ленинградская область / сертолово"
  },
  "2013": {
    "id": "2013",
    "name": "Сланцы",
    "path": "Россия / Ленинградская область / Сланцы",
    "country": "Россия",
    "searchString": "сланцы россия / ленинградская область / сланцы"
  },
  "2014": {
    "id": "2014",
    "name": "Сосновый Бор (Ленинградская область)",
    "path": "Россия / Ленинградская область / Сосновый Бор (Ленинградская область)",
    "country": "Россия",
    "searchString": "сосновый бор (ленинградская область) россия / ленинградская область / сосновый бор (ленинградская область)"
  },
  "2015": {
    "id": "2015",
    "name": "Сясьстрой",
    "path": "Россия / Ленинградская область / Сясьстрой",
    "country": "Россия",
    "searchString": "сясьстрой россия / ленинградская область / сясьстрой"
  },
  "2016": {
    "id": "2016",
    "name": "Тихвин",
    "path": "Россия / Ленинградская область / Тихвин",
    "country": "Россия",
    "searchString": "тихвин россия / ленинградская область / тихвин"
  },
  "2017": {
    "id": "2017",
    "name": "Тосно",
    "path": "Россия / Ленинградская область / Тосно",
    "country": "Россия",
    "searchString": "тосно россия / ленинградская область / тосно"
  },
  "2018": {
    "id": "2018",
    "name": "Шлиссельбург",
    "path": "Россия / Ленинградская область / Шлиссельбург",
    "country": "Россия",
    "searchString": "шлиссельбург россия / ленинградская область / шлиссельбург"
  },
  "2019": {
    "id": "2019",
    "name": "Московская область",
    "path": "Россия / Московская область",
    "country": "Россия",
    "searchString": "московская область россия / московская область"
  },
  "2020": {
    "id": "2020",
    "name": "Балашиха (Московская область)",
    "path": "Россия / Московская область / Балашиха (Московская область)",
    "country": "Россия",
    "searchString": "балашиха (московская область) россия / московская область / балашиха (московская область)"
  },
  "2021": {
    "id": "2021",
    "name": "Волоколамск  (Московская область)",
    "path": "Россия / Московская область / Волоколамск  (Московская область)",
    "country": "Россия",
    "searchString": "волоколамск  (московская область) россия / московская область / волоколамск  (московская область)"
  },
  "2022": {
    "id": "2022",
    "name": "Воскресенск (Московская область)",
    "path": "Россия / Московская область / Воскресенск (Московская область)",
    "country": "Россия",
    "searchString": "воскресенск (московская область) россия / московская область / воскресенск (московская область)"
  },
  "2023": {
    "id": "2023",
    "name": "Дмитров (Московская область)",
    "path": "Россия / Московская область / Дмитров (Московская область)",
    "country": "Россия",
    "searchString": "дмитров (московская область) россия / московская область / дмитров (московская область)"
  },
  "2024": {
    "id": "2024",
    "name": "Яхрома (Московская область)",
    "path": "Россия / Московская область / Яхрома (Московская область)",
    "country": "Россия",
    "searchString": "яхрома (московская область) россия / московская область / яхрома (московская область)"
  },
  "2025": {
    "id": "2025",
    "name": "Домодедово (Московская область)",
    "path": "Россия / Московская область / Домодедово (Московская область)",
    "country": "Россия",
    "searchString": "домодедово (московская область) россия / московская область / домодедово (московская область)"
  },
  "2026": {
    "id": "2026",
    "name": "Егорьевск (Московская область)",
    "path": "Россия / Московская область / Егорьевск (Московская область)",
    "country": "Россия",
    "searchString": "егорьевск (московская область) россия / московская область / егорьевск (московская область)"
  },
  "2027": {
    "id": "2027",
    "name": "Зарайск (Московская область)",
    "path": "Россия / Московская область / Зарайск (Московская область)",
    "country": "Россия",
    "searchString": "зарайск (московская область) россия / московская область / зарайск (московская область)"
  },
  "2028": {
    "id": "2028",
    "name": "Истра (Московская область)",
    "path": "Россия / Московская область / Истра (Московская область)",
    "country": "Россия",
    "searchString": "истра (московская область) россия / московская область / истра (московская область)"
  },
  "2029": {
    "id": "2029",
    "name": "Кашира (Московская область)",
    "path": "Россия / Московская область / Кашира (Московская область)",
    "country": "Россия",
    "searchString": "кашира (московская область) россия / московская область / кашира (московская область)"
  },
  "2030": {
    "id": "2030",
    "name": "Ожерелье (Московская область)",
    "path": "Россия / Московская область / Ожерелье (Московская область)",
    "country": "Россия",
    "searchString": "ожерелье (московская область) россия / московская область / ожерелье (московская область)"
  },
  "2031": {
    "id": "2031",
    "name": "Высоковск (Московская область)",
    "path": "Россия / Московская область / Высоковск (Московская область)",
    "country": "Россия",
    "searchString": "высоковск (московская область) россия / московская область / высоковск (московская область)"
  },
  "2032": {
    "id": "2032",
    "name": "Клин (Московская область)",
    "path": "Россия / Московская область / Клин (Московская область)",
    "country": "Россия",
    "searchString": "клин (московская область) россия / московская область / клин (московская область)"
  },
  "2033": {
    "id": "2033",
    "name": "Коломна (Московская область)",
    "path": "Россия / Московская область / Коломна (Московская область)",
    "country": "Россия",
    "searchString": "коломна (московская область) россия / московская область / коломна (московская область)"
  },
  "2034": {
    "id": "2034",
    "name": "Красногорск (Московская область)",
    "path": "Россия / Московская область / Красногорск (Московская область)",
    "country": "Россия",
    "searchString": "красногорск (московская область) россия / московская область / красногорск (московская область)"
  },
  "2035": {
    "id": "2035",
    "name": "Видное (Московская область)",
    "path": "Россия / Московская область / Видное (Московская область)",
    "country": "Россия",
    "searchString": "видное (московская область) россия / московская область / видное (московская область)"
  },
  "2036": {
    "id": "2036",
    "name": "Московский (Московская область)",
    "path": "Россия / Московская область / Московский (Московская область)",
    "country": "Россия",
    "searchString": "московский (московская область) россия / московская область / московский (московская область)"
  },
  "2037": {
    "id": "2037",
    "name": "Луховицы  (Московская область)",
    "path": "Россия / Московская область / Луховицы  (Московская область)",
    "country": "Россия",
    "searchString": "луховицы  (московская область) россия / московская область / луховицы  (московская область)"
  },
  "2038": {
    "id": "2038",
    "name": "Котельники  (Московская область)",
    "path": "Россия / Московская область / Котельники  (Московская область)",
    "country": "Россия",
    "searchString": "котельники  (московская область) россия / московская область / котельники  (московская область)"
  },
  "2039": {
    "id": "2039",
    "name": "Люберцы  (Московская область)",
    "path": "Россия / Московская область / Люберцы  (Московская область)",
    "country": "Россия",
    "searchString": "люберцы  (московская область) россия / московская область / люберцы  (московская область)"
  },
  "2040": {
    "id": "2040",
    "name": "Можайск (Московская область)",
    "path": "Россия / Московская область / Можайск (Московская область)",
    "country": "Россия",
    "searchString": "можайск (московская область) россия / московская область / можайск (московская область)"
  },
  "2041": {
    "id": "2041",
    "name": "Мытищи (Московская область)",
    "path": "Россия / Московская область / Мытищи (Московская область)",
    "country": "Россия",
    "searchString": "мытищи (московская область) россия / московская область / мытищи (московская область)"
  },
  "2042": {
    "id": "2042",
    "name": "Апрелевка (Московская область)",
    "path": "Россия / Московская область / Апрелевка (Московская область)",
    "country": "Россия",
    "searchString": "апрелевка (московская область) россия / московская область / апрелевка (московская область)"
  },
  "2043": {
    "id": "2043",
    "name": "Верея (Московская область)",
    "path": "Россия / Московская область / Верея (Московская область)",
    "country": "Россия",
    "searchString": "верея (московская область) россия / московская область / верея (московская область)"
  },
  "2044": {
    "id": "2044",
    "name": "Наро-Фоминск (Московская область)",
    "path": "Россия / Московская область / Наро-Фоминск (Московская область)",
    "country": "Россия",
    "searchString": "наро-фоминск (московская область) россия / московская область / наро-фоминск (московская область)"
  },
  "2045": {
    "id": "2045",
    "name": "Ногинск (Московская область)",
    "path": "Россия / Московская область / Ногинск (Московская область)",
    "country": "Россия",
    "searchString": "ногинск (московская область) россия / московская область / ногинск (московская область)"
  },
  "2046": {
    "id": "2046",
    "name": "Старая Купавна (Московская область)",
    "path": "Россия / Московская область / Старая Купавна (Московская область)",
    "country": "Россия",
    "searchString": "старая купавна (московская область) россия / московская область / старая купавна (московская область)"
  },
  "2047": {
    "id": "2047",
    "name": "Черноголовка (Московская область)",
    "path": "Россия / Московская область / Черноголовка (Московская область)",
    "country": "Россия",
    "searchString": "черноголовка (московская область) россия / московская область / черноголовка (московская область)"
  },
  "2048": {
    "id": "2048",
    "name": "Электроугли (Московская область)",
    "path": "Россия / Московская область / Электроугли (Московская область)",
    "country": "Россия",
    "searchString": "электроугли (московская область) россия / московская область / электроугли (московская область)"
  },
  "2049": {
    "id": "2049",
    "name": "Голицыно  (Московская область)",
    "path": "Россия / Московская область / Голицыно  (Московская область)",
    "country": "Россия",
    "searchString": "голицыно  (московская область) россия / московская область / голицыно  (московская область)"
  },
  "2050": {
    "id": "2050",
    "name": "Звенигород (Московская область)",
    "path": "Россия / Московская область / Звенигород (Московская область)",
    "country": "Россия",
    "searchString": "звенигород (московская область) россия / московская область / звенигород (московская область)"
  },
  "2051": {
    "id": "2051",
    "name": "Краснознаменск (Московская область)",
    "path": "Россия / Московская область / Краснознаменск (Московская область)",
    "country": "Россия",
    "searchString": "краснознаменск (московская область) россия / московская область / краснознаменск (московская область)"
  },
  "2052": {
    "id": "2052",
    "name": "Кубинка (Московская область)",
    "path": "Россия / Московская область / Кубинка (Московская область)",
    "country": "Россия",
    "searchString": "кубинка (московская область) россия / московская область / кубинка (московская область)"
  },
  "2053": {
    "id": "2053",
    "name": "Одинцово (Московская область)",
    "path": "Россия / Московская область / Одинцово (Московская область)",
    "country": "Россия",
    "searchString": "одинцово (московская область) россия / московская область / одинцово (московская область)"
  },
  "2054": {
    "id": "2054",
    "name": "Озеры (Московская область)",
    "path": "Россия / Московская область / Озеры (Московская область)",
    "country": "Россия",
    "searchString": "озеры (московская область) россия / московская область / озеры (московская область)"
  },
  "2055": {
    "id": "2055",
    "name": "Дрезна  (Московская область)",
    "path": "Россия / Московская область / Дрезна  (Московская область)",
    "country": "Россия",
    "searchString": "дрезна  (московская область) россия / московская область / дрезна  (московская область)"
  },
  "2056": {
    "id": "2056",
    "name": "Куровское  (Московская область)",
    "path": "Россия / Московская область / Куровское  (Московская область)",
    "country": "Россия",
    "searchString": "куровское  (московская область) россия / московская область / куровское  (московская область)"
  },
  "2057": {
    "id": "2057",
    "name": "Ликино-Дулево  (Московская область)",
    "path": "Россия / Московская область / Ликино-Дулево  (Московская область)",
    "country": "Россия",
    "searchString": "ликино-дулево  (московская область) россия / московская область / ликино-дулево  (московская область)"
  },
  "2058": {
    "id": "2058",
    "name": "Орехово-Зуево (Московская область)",
    "path": "Россия / Московская область / Орехово-Зуево (Московская область)",
    "country": "Россия",
    "searchString": "орехово-зуево (московская область) россия / московская область / орехово-зуево (московская область)"
  },
  "2059": {
    "id": "2059",
    "name": "Павловский Посад (Московская область)",
    "path": "Россия / Московская область / Павловский Посад (Московская область)",
    "country": "Россия",
    "searchString": "павловский посад (московская область) россия / московская область / павловский посад (московская область)"
  },
  "2060": {
    "id": "2060",
    "name": "Климовск (Московская область)",
    "path": "Россия / Московская область / Климовск (Московская область)",
    "country": "Россия",
    "searchString": "климовск (московская область) россия / московская область / климовск (московская область)"
  },
  "2061": {
    "id": "2061",
    "name": "Подольск (Московская область)",
    "path": "Россия / Московская область / Подольск (Московская область)",
    "country": "Россия",
    "searchString": "подольск (московская область) россия / московская область / подольск (московская область)"
  },
  "2062": {
    "id": "2062",
    "name": "Пушкино (Московская область)",
    "path": "Россия / Московская область / Пушкино (Московская область)",
    "country": "Россия",
    "searchString": "пушкино (московская область) россия / московская область / пушкино (московская область)"
  },
  "2063": {
    "id": "2063",
    "name": "Бронницы (Московская область)",
    "path": "Россия / Московская область / Бронницы (Московская область)",
    "country": "Россия",
    "searchString": "бронницы (московская область) россия / московская область / бронницы (московская область)"
  },
  "2064": {
    "id": "2064",
    "name": "Жуковский  (Московская область)",
    "path": "Россия / Московская область / Жуковский  (Московская область)",
    "country": "Россия",
    "searchString": "жуковский  (московская область) россия / московская область / жуковский  (московская область)"
  },
  "2065": {
    "id": "2065",
    "name": "Раменское (Московская область)",
    "path": "Россия / Московская область / Раменское (Московская область)",
    "country": "Россия",
    "searchString": "раменское (московская область) россия / московская область / раменское (московская область)"
  },
  "2066": {
    "id": "2066",
    "name": "Руза (Московская область)",
    "path": "Россия / Московская область / Руза (Московская область)",
    "country": "Россия",
    "searchString": "руза (московская область) россия / московская область / руза (московская область)"
  },
  "2067": {
    "id": "2067",
    "name": "Краснозаводск (Московская область)",
    "path": "Россия / Московская область / Краснозаводск (Московская область)",
    "country": "Россия",
    "searchString": "краснозаводск (московская область) россия / московская область / краснозаводск (московская область)"
  },
  "2068": {
    "id": "2068",
    "name": "Пересвет (Московская область)",
    "path": "Россия / Московская область / Пересвет (Московская область)",
    "country": "Россия",
    "searchString": "пересвет (московская область) россия / московская область / пересвет (московская область)"
  },
  "2069": {
    "id": "2069",
    "name": "Сергиев Посад (Московская область)",
    "path": "Россия / Московская область / Сергиев Посад (Московская область)",
    "country": "Россия",
    "searchString": "сергиев посад (московская область) россия / московская область / сергиев посад (московская область)"
  },
  "2070": {
    "id": "2070",
    "name": "Хотьково (Московская область)",
    "path": "Россия / Московская область / Хотьково (Московская область)",
    "country": "Россия",
    "searchString": "хотьково (московская область) россия / московская область / хотьково (московская область)"
  },
  "2071": {
    "id": "2071",
    "name": "Протвино (Московская область)",
    "path": "Россия / Московская область / Протвино (Московская область)",
    "country": "Россия",
    "searchString": "протвино (московская область) россия / московская область / протвино (московская область)"
  },
  "2072": {
    "id": "2072",
    "name": "Пущино (Московская область)",
    "path": "Россия / Московская область / Пущино (Московская область)",
    "country": "Россия",
    "searchString": "пущино (московская область) россия / московская область / пущино (московская область)"
  },
  "2073": {
    "id": "2073",
    "name": "Серпухов (Московская область)",
    "path": "Россия / Московская область / Серпухов (Московская область)",
    "country": "Россия",
    "searchString": "серпухов (московская область) россия / московская область / серпухов (московская область)"
  },
  "2074": {
    "id": "2074",
    "name": "Солнечногорск (Московская область)",
    "path": "Россия / Московская область / Солнечногорск (Московская область)",
    "country": "Россия",
    "searchString": "солнечногорск (московская область) россия / московская область / солнечногорск (московская область)"
  },
  "2075": {
    "id": "2075",
    "name": "Ступино (Московская область)",
    "path": "Россия / Московская область / Ступино (Московская область)",
    "country": "Россия",
    "searchString": "ступино (московская область) россия / московская область / ступино (московская область)"
  },
  "2076": {
    "id": "2076",
    "name": "Талдом (Московская область)",
    "path": "Россия / Московская область / Талдом (Московская область)",
    "country": "Россия",
    "searchString": "талдом (московская область) россия / московская область / талдом (московская область)"
  },
  "2077": {
    "id": "2077",
    "name": "Химки (Московская область)",
    "path": "Россия / Московская область / Химки (Московская область)",
    "country": "Россия",
    "searchString": "химки (московская область) россия / московская область / химки (московская область)"
  },
  "2078": {
    "id": "2078",
    "name": "Чехов (Московская область)",
    "path": "Россия / Московская область / Чехов (Московская область)",
    "country": "Россия",
    "searchString": "чехов (московская область) россия / московская область / чехов (московская область)"
  },
  "2079": {
    "id": "2079",
    "name": "Рошаль (Московская область)",
    "path": "Россия / Московская область / Рошаль (Московская область)",
    "country": "Россия",
    "searchString": "рошаль (московская область) россия / московская область / рошаль (московская область)"
  },
  "2080": {
    "id": "2080",
    "name": "Шатура (Московская область)",
    "path": "Россия / Московская область / Шатура (Московская область)",
    "country": "Россия",
    "searchString": "шатура (московская область) россия / московская область / шатура (московская область)"
  },
  "2081": {
    "id": "2081",
    "name": "Лосино-Петровский  (Московская область)",
    "path": "Россия / Московская область / Лосино-Петровский  (Московская область)",
    "country": "Россия",
    "searchString": "лосино-петровский  (московская область) россия / московская область / лосино-петровский  (московская область)"
  },
  "2082": {
    "id": "2082",
    "name": "Фрязино (Московская область)",
    "path": "Россия / Московская область / Фрязино (Московская область)",
    "country": "Россия",
    "searchString": "фрязино (московская область) россия / московская область / фрязино (московская область)"
  },
  "2083": {
    "id": "2083",
    "name": "Щелково (Московская область)",
    "path": "Россия / Московская область / Щелково (Московская область)",
    "country": "Россия",
    "searchString": "щелково (московская область) россия / московская область / щелково (московская область)"
  },
  "2084": {
    "id": "2084",
    "name": "Дзержинский  (Московская область)",
    "path": "Россия / Московская область / Дзержинский  (Московская область)",
    "country": "Россия",
    "searchString": "дзержинский  (московская область) россия / московская область / дзержинский  (московская область)"
  },
  "2085": {
    "id": "2085",
    "name": "Долгопрудный (Московская область)",
    "path": "Россия / Московская область / Долгопрудный (Московская область)",
    "country": "Россия",
    "searchString": "долгопрудный (московская область) россия / московская область / долгопрудный (московская область)"
  },
  "2086": {
    "id": "2086",
    "name": "Дубна (Московская область)",
    "path": "Россия / Московская область / Дубна (Московская область)",
    "country": "Россия",
    "searchString": "дубна (московская область) россия / московская область / дубна (московская область)"
  },
  "2087": {
    "id": "2087",
    "name": "Железнодорожный  (Московская область)",
    "path": "Россия / Московская область / Железнодорожный  (Московская область)",
    "country": "Россия",
    "searchString": "железнодорожный  (московская область) россия / московская область / железнодорожный  (московская область)"
  },
  "2088": {
    "id": "2088",
    "name": "Зеленоград",
    "path": "Россия / Московская область / Зеленоград",
    "country": "Россия",
    "searchString": "зеленоград россия / московская область / зеленоград"
  },
  "2089": {
    "id": "2089",
    "name": "Ивантеевка (Московская область)",
    "path": "Россия / Московская область / Ивантеевка (Московская область)",
    "country": "Россия",
    "searchString": "ивантеевка (московская область) россия / московская область / ивантеевка (московская область)"
  },
  "2090": {
    "id": "2090",
    "name": "Королев (Московская область)",
    "path": "Россия / Московская область / Королев (Московская область)",
    "country": "Россия",
    "searchString": "королев (московская область) россия / московская область / королев (московская область)"
  },
  "2091": {
    "id": "2091",
    "name": "Красноармейск (Московская область)",
    "path": "Россия / Московская область / Красноармейск (Московская область)",
    "country": "Россия",
    "searchString": "красноармейск (московская область) россия / московская область / красноармейск (московская область)"
  },
  "2092": {
    "id": "2092",
    "name": "Лобня (Московская область)",
    "path": "Россия / Московская область / Лобня (Московская область)",
    "country": "Россия",
    "searchString": "лобня (московская область) россия / московская область / лобня (московская область)"
  },
  "2093": {
    "id": "2093",
    "name": "Лыткарино  (Московская область)",
    "path": "Россия / Московская область / Лыткарино  (Московская область)",
    "country": "Россия",
    "searchString": "лыткарино  (московская область) россия / московская область / лыткарино  (московская область)"
  },
  "2094": {
    "id": "2094",
    "name": "Реутов (Московская область)",
    "path": "Россия / Московская область / Реутов (Московская область)",
    "country": "Россия",
    "searchString": "реутов (московская область) россия / московская область / реутов (московская область)"
  },
  "2095": {
    "id": "2095",
    "name": "Троицк (Москва)",
    "path": "Россия / Московская область / Троицк (Москва)",
    "country": "Россия",
    "searchString": "троицк (москва) россия / московская область / троицк (москва)"
  },
  "2096": {
    "id": "2096",
    "name": "Щербинка (Московская область)",
    "path": "Россия / Московская область / Щербинка (Московская область)",
    "country": "Россия",
    "searchString": "щербинка (московская область) россия / московская область / щербинка (московская область)"
  },
  "2097": {
    "id": "2097",
    "name": "Электрогорск (Московская область)",
    "path": "Россия / Московская область / Электрогорск (Московская область)",
    "country": "Россия",
    "searchString": "электрогорск (московская область) россия / московская область / электрогорск (московская область)"
  },
  "2098": {
    "id": "2098",
    "name": "Электросталь (Московская область)",
    "path": "Россия / Московская область / Электросталь (Московская область)",
    "country": "Россия",
    "searchString": "электросталь (московская область) россия / московская область / электросталь (московская область)"
  },
  "2099": {
    "id": "2099",
    "name": "Юбилейный (Московская область)",
    "path": "Россия / Московская область / Юбилейный (Московская область)",
    "country": "Россия",
    "searchString": "юбилейный (московская область) россия / московская область / юбилейный (московская область)"
  },
  "2100": {
    "id": "2100",
    "name": "Дедовск  (Московская область)",
    "path": "Россия / Московская область / Дедовск  (Московская область)",
    "country": "Россия",
    "searchString": "дедовск  (московская область) россия / московская область / дедовск  (московская область)"
  },
  "2101": {
    "id": "2101",
    "name": "Кривой Рог",
    "path": "Украина / Днепропетровская область / Кривой Рог",
    "country": "Украина",
    "searchString": "кривой рог украина / днепропетровская область / кривой рог"
  },
  "2102": {
    "id": "2102",
    "name": "Рамешки",
    "path": "Россия / Тверская область / Рамешки",
    "country": "Россия",
    "searchString": "рамешки россия / тверская область / рамешки"
  },
  "2103": {
    "id": "2103",
    "name": "Хорватия",
    "path": "Другие регионы / Хорватия",
    "country": "Другие регионы",
    "searchString": "хорватия другие регионы / хорватия"
  },
  "2104": {
    "id": "2104",
    "name": "Мариуполь",
    "path": "Россия / Донецкая Народная Республика / Мариуполь",
    "country": "Россия",
    "searchString": "мариуполь россия / донецкая народная республика / мариуполь"
  },
  "2105": {
    "id": "2105",
    "name": "Словения",
    "path": "Другие регионы / Словения",
    "country": "Другие регионы",
    "searchString": "словения другие регионы / словения"
  },
  "2106": {
    "id": "2106",
    "name": "Ливия",
    "path": "Другие регионы / Ливия",
    "country": "Другие регионы",
    "searchString": "ливия другие регионы / ливия"
  },
  "2107": {
    "id": "2107",
    "name": "Кременчуг",
    "path": "Украина / Полтавская область / Кременчуг",
    "country": "Украина",
    "searchString": "кременчуг украина / полтавская область / кременчуг"
  },
  "2108": {
    "id": "2108",
    "name": "Индонезия",
    "path": "Другие регионы / Индонезия",
    "country": "Другие регионы",
    "searchString": "индонезия другие регионы / индонезия"
  },
  "2109": {
    "id": "2109",
    "name": "Йемен",
    "path": "Другие регионы / Йемен",
    "country": "Другие регионы",
    "searchString": "йемен другие регионы / йемен"
  },
  "2110": {
    "id": "2110",
    "name": "Афганистан",
    "path": "Другие регионы / Афганистан",
    "country": "Другие регионы",
    "searchString": "афганистан другие регионы / афганистан"
  },
  "2111": {
    "id": "2111",
    "name": "Ливан",
    "path": "Другие регионы / Ливан",
    "country": "Другие регионы",
    "searchString": "ливан другие регионы / ливан"
  },
  "2112": {
    "id": "2112",
    "name": "Абхазия",
    "path": "Другие регионы / Абхазия",
    "country": "Другие регионы",
    "searchString": "абхазия другие регионы / абхазия"
  },
  "2113": {
    "id": "2113",
    "name": "Колумбия",
    "path": "Другие регионы / Колумбия",
    "country": "Другие регионы",
    "searchString": "колумбия другие регионы / колумбия"
  },
  "2114": {
    "id": "2114",
    "name": "Республика Крым",
    "path": "Россия / Республика Крым",
    "country": "Россия",
    "searchString": "республика крым россия / республика крым"
  },
  "2115": {
    "id": "2115",
    "name": "Евпатория",
    "path": "Россия / Республика Крым / Евпатория",
    "country": "Россия",
    "searchString": "евпатория россия / республика крым / евпатория"
  },
  "2116": {
    "id": "2116",
    "name": "Керчь",
    "path": "Россия / Республика Крым / Керчь",
    "country": "Россия",
    "searchString": "керчь россия / республика крым / керчь"
  },
  "2119": {
    "id": "2119",
    "name": "Феодосия",
    "path": "Россия / Республика Крым / Феодосия",
    "country": "Россия",
    "searchString": "феодосия россия / республика крым / феодосия"
  },
  "2120": {
    "id": "2120",
    "name": "Ялта",
    "path": "Россия / Республика Крым / Ялта",
    "country": "Россия",
    "searchString": "ялта россия / республика крым / ялта"
  },
  "2121": {
    "id": "2121",
    "name": "Винницкая область",
    "path": "Украина / Винницкая область",
    "country": "Украина",
    "searchString": "винницкая область украина / винницкая область"
  },
  "2123": {
    "id": "2123",
    "name": "Волынская область",
    "path": "Украина / Волынская область",
    "country": "Украина",
    "searchString": "волынская область украина / волынская область"
  },
  "2124": {
    "id": "2124",
    "name": "Ковель",
    "path": "Украина / Волынская область / Ковель",
    "country": "Украина",
    "searchString": "ковель украина / волынская область / ковель"
  },
  "2126": {
    "id": "2126",
    "name": "Днепропетровская область",
    "path": "Украина / Днепропетровская область",
    "country": "Украина",
    "searchString": "днепропетровская область украина / днепропетровская область"
  },
  "2127": {
    "id": "2127",
    "name": "Каменское",
    "path": "Украина / Днепропетровская область / Каменское",
    "country": "Украина",
    "searchString": "каменское украина / днепропетровская область / каменское"
  },
  "2129": {
    "id": "2129",
    "name": "Желтые Воды",
    "path": "Украина / Днепропетровская область / Желтые Воды",
    "country": "Украина",
    "searchString": "желтые воды украина / днепропетровская область / желтые воды"
  },
  "2131": {
    "id": "2131",
    "name": "Никополь",
    "path": "Украина / Днепропетровская область / Никополь",
    "country": "Украина",
    "searchString": "никополь украина / днепропетровская область / никополь"
  },
  "2132": {
    "id": "2132",
    "name": "Новомосковск (Днепропетровская область)",
    "path": "Украина / Днепропетровская область / Новомосковск (Днепропетровская область)",
    "country": "Украина",
    "searchString": "новомосковск (днепропетровская область) украина / днепропетровская область / новомосковск (днепропетровская область)"
  },
  "2133": {
    "id": "2133",
    "name": "Павлоград",
    "path": "Украина / Днепропетровская область / Павлоград",
    "country": "Украина",
    "searchString": "павлоград украина / днепропетровская область / павлоград"
  },
  "2134": {
    "id": "2134",
    "name": "Донецкая Народная Республика",
    "path": "Россия / Донецкая Народная Республика",
    "country": "Россия",
    "searchString": "донецкая народная республика россия / донецкая народная республика"
  },
  "2135": {
    "id": "2135",
    "name": "Артемовск (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Артемовск (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "артемовск (донецкая народная республика) россия / донецкая народная республика / артемовск (донецкая народная республика)"
  },
  "2136": {
    "id": "2136",
    "name": "Горловка",
    "path": "Россия / Донецкая Народная Республика / Горловка",
    "country": "Россия",
    "searchString": "горловка россия / донецкая народная республика / горловка"
  },
  "2138": {
    "id": "2138",
    "name": "Енакиево",
    "path": "Россия / Донецкая Народная Республика / Енакиево",
    "country": "Россия",
    "searchString": "енакиево россия / донецкая народная республика / енакиево"
  },
  "2139": {
    "id": "2139",
    "name": "Краматорск",
    "path": "Россия / Донецкая Народная Республика / Краматорск",
    "country": "Россия",
    "searchString": "краматорск россия / донецкая народная республика / краматорск"
  },
  "2140": {
    "id": "2140",
    "name": "Макеевка",
    "path": "Россия / Донецкая Народная Республика / Макеевка",
    "country": "Россия",
    "searchString": "макеевка россия / донецкая народная республика / макеевка"
  },
  "2142": {
    "id": "2142",
    "name": "Славянск",
    "path": "Россия / Донецкая Народная Республика / Славянск",
    "country": "Россия",
    "searchString": "славянск россия / донецкая народная республика / славянск"
  },
  "2143": {
    "id": "2143",
    "name": "Снежное",
    "path": "Россия / Донецкая Народная Республика / Снежное",
    "country": "Россия",
    "searchString": "снежное россия / донецкая народная республика / снежное"
  },
  "2144": {
    "id": "2144",
    "name": "Торез",
    "path": "Россия / Донецкая Народная Республика / Торез",
    "country": "Россия",
    "searchString": "торез россия / донецкая народная республика / торез"
  },
  "2145": {
    "id": "2145",
    "name": "Харцызск",
    "path": "Россия / Донецкая Народная Республика / Харцызск",
    "country": "Россия",
    "searchString": "харцызск россия / донецкая народная республика / харцызск"
  },
  "2146": {
    "id": "2146",
    "name": "Шахтерск (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Шахтерск (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "шахтерск (донецкая народная республика) россия / донецкая народная республика / шахтерск (донецкая народная республика)"
  },
  "2147": {
    "id": "2147",
    "name": "Житомирская область",
    "path": "Украина / Житомирская область",
    "country": "Украина",
    "searchString": "житомирская область украина / житомирская область"
  },
  "2148": {
    "id": "2148",
    "name": "Бердичев",
    "path": "Украина / Житомирская область / Бердичев",
    "country": "Украина",
    "searchString": "бердичев украина / житомирская область / бердичев"
  },
  "2150": {
    "id": "2150",
    "name": "Коростень",
    "path": "Украина / Житомирская область / Коростень",
    "country": "Украина",
    "searchString": "коростень украина / житомирская область / коростень"
  },
  "2151": {
    "id": "2151",
    "name": "Новоград-Волынский",
    "path": "Украина / Житомирская область / Новоград-Волынский",
    "country": "Украина",
    "searchString": "новоград-волынский украина / житомирская область / новоград-волынский"
  },
  "2152": {
    "id": "2152",
    "name": "Закарпатская область",
    "path": "Украина / Закарпатская область",
    "country": "Украина",
    "searchString": "закарпатская область украина / закарпатская область"
  },
  "2153": {
    "id": "2153",
    "name": "Мукачево",
    "path": "Украина / Закарпатская область / Мукачево",
    "country": "Украина",
    "searchString": "мукачево украина / закарпатская область / мукачево"
  },
  "2155": {
    "id": "2155",
    "name": "Запорожская область",
    "path": "Россия / Запорожская область",
    "country": "Россия",
    "searchString": "запорожская область россия / запорожская область"
  },
  "2156": {
    "id": "2156",
    "name": "Бердянск",
    "path": "Россия / Запорожская область / Бердянск",
    "country": "Россия",
    "searchString": "бердянск россия / запорожская область / бердянск"
  },
  "2158": {
    "id": "2158",
    "name": "Мелитополь",
    "path": "Россия / Запорожская область / Мелитополь",
    "country": "Россия",
    "searchString": "мелитополь россия / запорожская область / мелитополь"
  },
  "2159": {
    "id": "2159",
    "name": "Энергодар",
    "path": "Россия / Запорожская область / Энергодар",
    "country": "Россия",
    "searchString": "энергодар россия / запорожская область / энергодар"
  },
  "2160": {
    "id": "2160",
    "name": "Ивано-Франковская область",
    "path": "Украина / Ивано-Франковская область",
    "country": "Украина",
    "searchString": "ивано-франковская область украина / ивано-франковская область"
  },
  "2162": {
    "id": "2162",
    "name": "Калуш",
    "path": "Украина / Ивано-Франковская область / Калуш",
    "country": "Украина",
    "searchString": "калуш украина / ивано-франковская область / калуш"
  },
  "2163": {
    "id": "2163",
    "name": "Коломыя",
    "path": "Украина / Ивано-Франковская область / Коломыя",
    "country": "Украина",
    "searchString": "коломыя украина / ивано-франковская область / коломыя"
  },
  "2164": {
    "id": "2164",
    "name": "Киевская область",
    "path": "Украина / Киевская область",
    "country": "Украина",
    "searchString": "киевская область украина / киевская область"
  },
  "2165": {
    "id": "2165",
    "name": "Белая Церковь",
    "path": "Украина / Киевская область / Белая Церковь",
    "country": "Украина",
    "searchString": "белая церковь украина / киевская область / белая церковь"
  },
  "2166": {
    "id": "2166",
    "name": "Борисполь",
    "path": "Украина / Киевская область / Борисполь",
    "country": "Украина",
    "searchString": "борисполь украина / киевская область / борисполь"
  },
  "2167": {
    "id": "2167",
    "name": "Бровары",
    "path": "Украина / Киевская область / Бровары",
    "country": "Украина",
    "searchString": "бровары украина / киевская область / бровары"
  },
  "2168": {
    "id": "2168",
    "name": "Фастов",
    "path": "Украина / Киевская область / Фастов",
    "country": "Украина",
    "searchString": "фастов украина / киевская область / фастов"
  },
  "2169": {
    "id": "2169",
    "name": "Кировоградская область",
    "path": "Украина / Кировоградская область",
    "country": "Украина",
    "searchString": "кировоградская область украина / кировоградская область"
  },
  "2170": {
    "id": "2170",
    "name": "Александрия (Кировоградская область)",
    "path": "Украина / Кировоградская область / Александрия (Кировоградская область)",
    "country": "Украина",
    "searchString": "александрия (кировоградская область) украина / кировоградская область / александрия (кировоградская область)"
  },
  "2172": {
    "id": "2172",
    "name": "Светловодск",
    "path": "Украина / Кировоградская область / Светловодск",
    "country": "Украина",
    "searchString": "светловодск украина / кировоградская область / светловодск"
  },
  "2173": {
    "id": "2173",
    "name": "Луганская Народная Республика",
    "path": "Россия / Луганская Народная Республика",
    "country": "Россия",
    "searchString": "луганская народная республика россия / луганская народная республика"
  },
  "2174": {
    "id": "2174",
    "name": "Алчевск",
    "path": "Россия / Луганская Народная Республика / Алчевск",
    "country": "Россия",
    "searchString": "алчевск россия / луганская народная республика / алчевск"
  },
  "2175": {
    "id": "2175",
    "name": "Красный Луч",
    "path": "Россия / Луганская Народная Республика / Красный Луч",
    "country": "Россия",
    "searchString": "красный луч россия / луганская народная республика / красный луч"
  },
  "2176": {
    "id": "2176",
    "name": "Лисичанск",
    "path": "Россия / Луганская Народная Республика / Лисичанск",
    "country": "Россия",
    "searchString": "лисичанск россия / луганская народная республика / лисичанск"
  },
  "2178": {
    "id": "2178",
    "name": "Северодонецк",
    "path": "Россия / Луганская Народная Республика / Северодонецк",
    "country": "Россия",
    "searchString": "северодонецк россия / луганская народная республика / северодонецк"
  },
  "2179": {
    "id": "2179",
    "name": "Стаханов",
    "path": "Россия / Луганская Народная Республика / Стаханов",
    "country": "Россия",
    "searchString": "стаханов россия / луганская народная республика / стаханов"
  },
  "2180": {
    "id": "2180",
    "name": "Львовская область",
    "path": "Украина / Львовская область",
    "country": "Украина",
    "searchString": "львовская область украина / львовская область"
  },
  "2181": {
    "id": "2181",
    "name": "Дрогобыч",
    "path": "Украина / Львовская область / Дрогобыч",
    "country": "Украина",
    "searchString": "дрогобыч украина / львовская область / дрогобыч"
  },
  "2183": {
    "id": "2183",
    "name": "Стрый",
    "path": "Украина / Львовская область / Стрый",
    "country": "Украина",
    "searchString": "стрый украина / львовская область / стрый"
  },
  "2184": {
    "id": "2184",
    "name": "Червоноград",
    "path": "Украина / Львовская область / Червоноград",
    "country": "Украина",
    "searchString": "червоноград украина / львовская область / червоноград"
  },
  "2185": {
    "id": "2185",
    "name": "Николаевская область",
    "path": "Украина / Николаевская область",
    "country": "Украина",
    "searchString": "николаевская область украина / николаевская область"
  },
  "2187": {
    "id": "2187",
    "name": "Первомайск (Украина)",
    "path": "Украина / Николаевская область / Первомайск (Украина)",
    "country": "Украина",
    "searchString": "первомайск (украина) украина / николаевская область / первомайск (украина)"
  },
  "2188": {
    "id": "2188",
    "name": "Одесская область",
    "path": "Украина / Одесская область",
    "country": "Украина",
    "searchString": "одесская область украина / одесская область"
  },
  "2189": {
    "id": "2189",
    "name": "Белгород-Днестровский",
    "path": "Украина / Одесская область / Белгород-Днестровский",
    "country": "Украина",
    "searchString": "белгород-днестровский украина / одесская область / белгород-днестровский"
  },
  "2190": {
    "id": "2190",
    "name": "Измаил",
    "path": "Украина / Одесская область / Измаил",
    "country": "Украина",
    "searchString": "измаил украина / одесская область / измаил"
  },
  "2191": {
    "id": "2191",
    "name": "Ильичевск",
    "path": "Украина / Одесская область / Ильичевск",
    "country": "Украина",
    "searchString": "ильичевск украина / одесская область / ильичевск"
  },
  "2193": {
    "id": "2193",
    "name": "Полтавская область",
    "path": "Украина / Полтавская область",
    "country": "Украина",
    "searchString": "полтавская область украина / полтавская область"
  },
  "2194": {
    "id": "2194",
    "name": "Горишние Плавни (Комсомольск)",
    "path": "Украина / Полтавская область / Горишние Плавни (Комсомольск)",
    "country": "Украина",
    "searchString": "горишние плавни (комсомольск) украина / полтавская область / горишние плавни (комсомольск)"
  },
  "2196": {
    "id": "2196",
    "name": "Лубны",
    "path": "Украина / Полтавская область / Лубны",
    "country": "Украина",
    "searchString": "лубны украина / полтавская область / лубны"
  },
  "2198": {
    "id": "2198",
    "name": "Ровненская область",
    "path": "Украина / Ровненская область",
    "country": "Украина",
    "searchString": "ровненская область украина / ровненская область"
  },
  "2200": {
    "id": "2200",
    "name": "Сумская область",
    "path": "Украина / Сумская область",
    "country": "Украина",
    "searchString": "сумская область украина / сумская область"
  },
  "2201": {
    "id": "2201",
    "name": "Конотоп",
    "path": "Украина / Сумская область / Конотоп",
    "country": "Украина",
    "searchString": "конотоп украина / сумская область / конотоп"
  },
  "2203": {
    "id": "2203",
    "name": "Шостка",
    "path": "Украина / Сумская область / Шостка",
    "country": "Украина",
    "searchString": "шостка украина / сумская область / шостка"
  },
  "2204": {
    "id": "2204",
    "name": "Тернопольская область",
    "path": "Украина / Тернопольская область",
    "country": "Украина",
    "searchString": "тернопольская область украина / тернопольская область"
  },
  "2206": {
    "id": "2206",
    "name": "Харьковская область",
    "path": "Украина / Харьковская область",
    "country": "Украина",
    "searchString": "харьковская область украина / харьковская область"
  },
  "2207": {
    "id": "2207",
    "name": "Изюм",
    "path": "Украина / Харьковская область / Изюм",
    "country": "Украина",
    "searchString": "изюм украина / харьковская область / изюм"
  },
  "2209": {
    "id": "2209",
    "name": "Херсонская область",
    "path": "Россия / Херсонская область",
    "country": "Россия",
    "searchString": "херсонская область россия / херсонская область"
  },
  "2210": {
    "id": "2210",
    "name": "Новая Каховка",
    "path": "Россия / Херсонская область / Новая Каховка",
    "country": "Россия",
    "searchString": "новая каховка россия / херсонская область / новая каховка"
  },
  "2212": {
    "id": "2212",
    "name": "Хмельницкая область",
    "path": "Украина / Хмельницкая область",
    "country": "Украина",
    "searchString": "хмельницкая область украина / хмельницкая область"
  },
  "2213": {
    "id": "2213",
    "name": "Каменец-Подольский",
    "path": "Украина / Хмельницкая область / Каменец-Подольский",
    "country": "Украина",
    "searchString": "каменец-подольский украина / хмельницкая область / каменец-подольский"
  },
  "2215": {
    "id": "2215",
    "name": "Шепетовка",
    "path": "Украина / Хмельницкая область / Шепетовка",
    "country": "Украина",
    "searchString": "шепетовка украина / хмельницкая область / шепетовка"
  },
  "2216": {
    "id": "2216",
    "name": "Черкасская область",
    "path": "Украина / Черкасская область",
    "country": "Украина",
    "searchString": "черкасская область украина / черкасская область"
  },
  "2217": {
    "id": "2217",
    "name": "Смела",
    "path": "Украина / Черкасская область / Смела",
    "country": "Украина",
    "searchString": "смела украина / черкасская область / смела"
  },
  "2218": {
    "id": "2218",
    "name": "Умань",
    "path": "Украина / Черкасская область / Умань",
    "country": "Украина",
    "searchString": "умань украина / черкасская область / умань"
  },
  "2220": {
    "id": "2220",
    "name": "Черниговская область",
    "path": "Украина / Черниговская область",
    "country": "Украина",
    "searchString": "черниговская область украина / черниговская область"
  },
  "2221": {
    "id": "2221",
    "name": "Нежин",
    "path": "Украина / Черниговская область / Нежин",
    "country": "Украина",
    "searchString": "нежин украина / черниговская область / нежин"
  },
  "2222": {
    "id": "2222",
    "name": "Прилуки",
    "path": "Украина / Черниговская область / Прилуки",
    "country": "Украина",
    "searchString": "прилуки украина / черниговская область / прилуки"
  },
  "2224": {
    "id": "2224",
    "name": "Черновицкая область",
    "path": "Украина / Черновицкая область",
    "country": "Украина",
    "searchString": "черновицкая область украина / черновицкая область"
  },
  "2226": {
    "id": "2226",
    "name": "Байконур (Кызылорд. обл)",
    "path": "Казахстан / Байконур (Кызылорд. обл)",
    "country": "Казахстан",
    "searchString": "байконур (кызылорд. обл) казахстан / байконур (кызылорд. обл)"
  },
  "2227": {
    "id": "2227",
    "name": "Иран",
    "path": "Другие регионы / Иран",
    "country": "Другие регионы",
    "searchString": "иран другие регионы / иран"
  },
  "2228": {
    "id": "2228",
    "name": "Боливия",
    "path": "Другие регионы / Боливия",
    "country": "Другие регионы",
    "searchString": "боливия другие регионы / боливия"
  },
  "2229": {
    "id": "2229",
    "name": "Мексика",
    "path": "Другие регионы / Мексика",
    "country": "Другие регионы",
    "searchString": "мексика другие регионы / мексика"
  },
  "2230": {
    "id": "2230",
    "name": "Зеленогорск (Ленинградская обл)",
    "path": "Россия / Ленинградская область / Зеленогорск (Ленинградская обл)",
    "country": "Россия",
    "searchString": "зеленогорск (ленинградская обл) россия / ленинградская область / зеленогорск (ленинградская обл)"
  },
  "2231": {
    "id": "2231",
    "name": "Монголия",
    "path": "Другие регионы / Монголия",
    "country": "Другие регионы",
    "searchString": "монголия другие регионы / монголия"
  },
  "2232": {
    "id": "2232",
    "name": "Ирак",
    "path": "Другие регионы / Ирак",
    "country": "Другие регионы",
    "searchString": "ирак другие регионы / ирак"
  },
  "2233": {
    "id": "2233",
    "name": "Брестская область",
    "path": "Беларусь / Брестская область",
    "country": "Беларусь",
    "searchString": "брестская область беларусь / брестская область"
  },
  "2234": {
    "id": "2234",
    "name": "Витебская область",
    "path": "Беларусь / Витебская область",
    "country": "Беларусь",
    "searchString": "витебская область беларусь / витебская область"
  },
  "2235": {
    "id": "2235",
    "name": "Гомельская область",
    "path": "Беларусь / Гомельская область",
    "country": "Беларусь",
    "searchString": "гомельская область беларусь / гомельская область"
  },
  "2236": {
    "id": "2236",
    "name": "Гродненская область",
    "path": "Беларусь / Гродненская область",
    "country": "Беларусь",
    "searchString": "гродненская область беларусь / гродненская область"
  },
  "2237": {
    "id": "2237",
    "name": "Минская область",
    "path": "Беларусь / Минская область",
    "country": "Беларусь",
    "searchString": "минская область беларусь / минская область"
  },
  "2238": {
    "id": "2238",
    "name": "Могилевская область",
    "path": "Беларусь / Могилевская область",
    "country": "Беларусь",
    "searchString": "могилевская область беларусь / могилевская область"
  },
  "2239": {
    "id": "2239",
    "name": "Барановичи",
    "path": "Беларусь / Брестская область / Барановичи",
    "country": "Беларусь",
    "searchString": "барановичи беларусь / брестская область / барановичи"
  },
  "2240": {
    "id": "2240",
    "name": "Береза",
    "path": "Беларусь / Брестская область / Береза",
    "country": "Беларусь",
    "searchString": "береза беларусь / брестская область / береза"
  },
  "2241": {
    "id": "2241",
    "name": "Ганцевичи",
    "path": "Беларусь / Брестская область / Ганцевичи",
    "country": "Беларусь",
    "searchString": "ганцевичи беларусь / брестская область / ганцевичи"
  },
  "2242": {
    "id": "2242",
    "name": "Дрогичин",
    "path": "Беларусь / Брестская область / Дрогичин",
    "country": "Беларусь",
    "searchString": "дрогичин беларусь / брестская область / дрогичин"
  },
  "2243": {
    "id": "2243",
    "name": "Жабинка",
    "path": "Беларусь / Брестская область / Жабинка",
    "country": "Беларусь",
    "searchString": "жабинка беларусь / брестская область / жабинка"
  },
  "2245": {
    "id": "2245",
    "name": "Ивацевичи",
    "path": "Беларусь / Брестская область / Ивацевичи",
    "country": "Беларусь",
    "searchString": "ивацевичи беларусь / брестская область / ивацевичи"
  },
  "2246": {
    "id": "2246",
    "name": "Каменец",
    "path": "Беларусь / Брестская область / Каменец",
    "country": "Беларусь",
    "searchString": "каменец беларусь / брестская область / каменец"
  },
  "2247": {
    "id": "2247",
    "name": "Кобрин",
    "path": "Беларусь / Брестская область / Кобрин",
    "country": "Беларусь",
    "searchString": "кобрин беларусь / брестская область / кобрин"
  },
  "2248": {
    "id": "2248",
    "name": "Лунинец",
    "path": "Беларусь / Брестская область / Лунинец",
    "country": "Беларусь",
    "searchString": "лунинец беларусь / брестская область / лунинец"
  },
  "2249": {
    "id": "2249",
    "name": "Ляховичи",
    "path": "Беларусь / Брестская область / Ляховичи",
    "country": "Беларусь",
    "searchString": "ляховичи беларусь / брестская область / ляховичи"
  },
  "2250": {
    "id": "2250",
    "name": "Малорита",
    "path": "Беларусь / Брестская область / Малорита",
    "country": "Беларусь",
    "searchString": "малорита беларусь / брестская область / малорита"
  },
  "2251": {
    "id": "2251",
    "name": "Пинск",
    "path": "Беларусь / Брестская область / Пинск",
    "country": "Беларусь",
    "searchString": "пинск беларусь / брестская область / пинск"
  },
  "2252": {
    "id": "2252",
    "name": "Пружаны",
    "path": "Беларусь / Брестская область / Пружаны",
    "country": "Беларусь",
    "searchString": "пружаны беларусь / брестская область / пружаны"
  },
  "2253": {
    "id": "2253",
    "name": "Столин",
    "path": "Беларусь / Брестская область / Столин",
    "country": "Беларусь",
    "searchString": "столин беларусь / брестская область / столин"
  },
  "2254": {
    "id": "2254",
    "name": "Бешенковичи",
    "path": "Беларусь / Витебская область / Бешенковичи",
    "country": "Беларусь",
    "searchString": "бешенковичи беларусь / витебская область / бешенковичи"
  },
  "2255": {
    "id": "2255",
    "name": "Браслав",
    "path": "Беларусь / Витебская область / Браслав",
    "country": "Беларусь",
    "searchString": "браслав беларусь / витебская область / браслав"
  },
  "2256": {
    "id": "2256",
    "name": "Верхнедвинск",
    "path": "Беларусь / Витебская область / Верхнедвинск",
    "country": "Беларусь",
    "searchString": "верхнедвинск беларусь / витебская область / верхнедвинск"
  },
  "2257": {
    "id": "2257",
    "name": "Глубокое",
    "path": "Беларусь / Витебская область / Глубокое",
    "country": "Беларусь",
    "searchString": "глубокое беларусь / витебская область / глубокое"
  },
  "2258": {
    "id": "2258",
    "name": "Городок (Витебская область)",
    "path": "Беларусь / Витебская область / Городок (Витебская область)",
    "country": "Беларусь",
    "searchString": "городок (витебская область) беларусь / витебская область / городок (витебская область)"
  },
  "2259": {
    "id": "2259",
    "name": "Докшицы",
    "path": "Беларусь / Витебская область / Докшицы",
    "country": "Беларусь",
    "searchString": "докшицы беларусь / витебская область / докшицы"
  },
  "2260": {
    "id": "2260",
    "name": "Дубровно",
    "path": "Беларусь / Витебская область / Дубровно",
    "country": "Беларусь",
    "searchString": "дубровно беларусь / витебская область / дубровно"
  },
  "2261": {
    "id": "2261",
    "name": "Лепель",
    "path": "Беларусь / Витебская область / Лепель",
    "country": "Беларусь",
    "searchString": "лепель беларусь / витебская область / лепель"
  },
  "2262": {
    "id": "2262",
    "name": "Лиозно",
    "path": "Беларусь / Витебская область / Лиозно",
    "country": "Беларусь",
    "searchString": "лиозно беларусь / витебская область / лиозно"
  },
  "2263": {
    "id": "2263",
    "name": "Миоры",
    "path": "Беларусь / Витебская область / Миоры",
    "country": "Беларусь",
    "searchString": "миоры беларусь / витебская область / миоры"
  },
  "2264": {
    "id": "2264",
    "name": "Орша",
    "path": "Беларусь / Витебская область / Орша",
    "country": "Беларусь",
    "searchString": "орша беларусь / витебская область / орша"
  },
  "2265": {
    "id": "2265",
    "name": "Полоцк",
    "path": "Беларусь / Витебская область / Полоцк",
    "country": "Беларусь",
    "searchString": "полоцк беларусь / витебская область / полоцк"
  },
  "2266": {
    "id": "2266",
    "name": "Поставы",
    "path": "Беларусь / Витебская область / Поставы",
    "country": "Беларусь",
    "searchString": "поставы беларусь / витебская область / поставы"
  },
  "2267": {
    "id": "2267",
    "name": "Россоны",
    "path": "Беларусь / Витебская область / Россоны",
    "country": "Беларусь",
    "searchString": "россоны беларусь / витебская область / россоны"
  },
  "2268": {
    "id": "2268",
    "name": "Сенно",
    "path": "Беларусь / Витебская область / Сенно",
    "country": "Беларусь",
    "searchString": "сенно беларусь / витебская область / сенно"
  },
  "2269": {
    "id": "2269",
    "name": "Толочин",
    "path": "Беларусь / Витебская область / Толочин",
    "country": "Беларусь",
    "searchString": "толочин беларусь / витебская область / толочин"
  },
  "2270": {
    "id": "2270",
    "name": "Ушачи",
    "path": "Беларусь / Витебская область / Ушачи",
    "country": "Беларусь",
    "searchString": "ушачи беларусь / витебская область / ушачи"
  },
  "2271": {
    "id": "2271",
    "name": "Чашники",
    "path": "Беларусь / Витебская область / Чашники",
    "country": "Беларусь",
    "searchString": "чашники беларусь / витебская область / чашники"
  },
  "2272": {
    "id": "2272",
    "name": "Шарковщина",
    "path": "Беларусь / Витебская область / Шарковщина",
    "country": "Беларусь",
    "searchString": "шарковщина беларусь / витебская область / шарковщина"
  },
  "2273": {
    "id": "2273",
    "name": "Шумилино",
    "path": "Беларусь / Витебская область / Шумилино",
    "country": "Беларусь",
    "searchString": "шумилино беларусь / витебская область / шумилино"
  },
  "2274": {
    "id": "2274",
    "name": "Брагин",
    "path": "Беларусь / Гомельская область / Брагин",
    "country": "Беларусь",
    "searchString": "брагин беларусь / гомельская область / брагин"
  },
  "2275": {
    "id": "2275",
    "name": "Буда-Кошелево",
    "path": "Беларусь / Гомельская область / Буда-Кошелево",
    "country": "Беларусь",
    "searchString": "буда-кошелево беларусь / гомельская область / буда-кошелево"
  },
  "2276": {
    "id": "2276",
    "name": "Ветка",
    "path": "Беларусь / Гомельская область / Ветка",
    "country": "Беларусь",
    "searchString": "ветка беларусь / гомельская область / ветка"
  },
  "2277": {
    "id": "2277",
    "name": "Добруш",
    "path": "Беларусь / Гомельская область / Добруш",
    "country": "Беларусь",
    "searchString": "добруш беларусь / гомельская область / добруш"
  },
  "2278": {
    "id": "2278",
    "name": "Ельск",
    "path": "Беларусь / Гомельская область / Ельск",
    "country": "Беларусь",
    "searchString": "ельск беларусь / гомельская область / ельск"
  },
  "2279": {
    "id": "2279",
    "name": "Житковичи",
    "path": "Беларусь / Гомельская область / Житковичи",
    "country": "Беларусь",
    "searchString": "житковичи беларусь / гомельская область / житковичи"
  },
  "2280": {
    "id": "2280",
    "name": "Жлобин",
    "path": "Беларусь / Гомельская область / Жлобин",
    "country": "Беларусь",
    "searchString": "жлобин беларусь / гомельская область / жлобин"
  },
  "2281": {
    "id": "2281",
    "name": "Калинковичи",
    "path": "Беларусь / Гомельская область / Калинковичи",
    "country": "Беларусь",
    "searchString": "калинковичи беларусь / гомельская область / калинковичи"
  },
  "2282": {
    "id": "2282",
    "name": "Корма",
    "path": "Беларусь / Гомельская область / Корма",
    "country": "Беларусь",
    "searchString": "корма беларусь / гомельская область / корма"
  },
  "2283": {
    "id": "2283",
    "name": "Лельчицы",
    "path": "Беларусь / Гомельская область / Лельчицы",
    "country": "Беларусь",
    "searchString": "лельчицы беларусь / гомельская область / лельчицы"
  },
  "2284": {
    "id": "2284",
    "name": "Лоев",
    "path": "Беларусь / Гомельская область / Лоев",
    "country": "Беларусь",
    "searchString": "лоев беларусь / гомельская область / лоев"
  },
  "2285": {
    "id": "2285",
    "name": "Мозырь",
    "path": "Беларусь / Гомельская область / Мозырь",
    "country": "Беларусь",
    "searchString": "мозырь беларусь / гомельская область / мозырь"
  },
  "2286": {
    "id": "2286",
    "name": "Наровля",
    "path": "Беларусь / Гомельская область / Наровля",
    "country": "Беларусь",
    "searchString": "наровля беларусь / гомельская область / наровля"
  },
  "2288": {
    "id": "2288",
    "name": "Петриков",
    "path": "Беларусь / Гомельская область / Петриков",
    "country": "Беларусь",
    "searchString": "петриков беларусь / гомельская область / петриков"
  },
  "2289": {
    "id": "2289",
    "name": "Речица",
    "path": "Беларусь / Гомельская область / Речица",
    "country": "Беларусь",
    "searchString": "речица беларусь / гомельская область / речица"
  },
  "2290": {
    "id": "2290",
    "name": "Рогачев",
    "path": "Беларусь / Гомельская область / Рогачев",
    "country": "Беларусь",
    "searchString": "рогачев беларусь / гомельская область / рогачев"
  },
  "2291": {
    "id": "2291",
    "name": "Светлогорск (Беларусь)",
    "path": "Беларусь / Гомельская область / Светлогорск (Беларусь)",
    "country": "Беларусь",
    "searchString": "светлогорск (беларусь) беларусь / гомельская область / светлогорск (беларусь)"
  },
  "2292": {
    "id": "2292",
    "name": "Хойники",
    "path": "Беларусь / Гомельская область / Хойники",
    "country": "Беларусь",
    "searchString": "хойники беларусь / гомельская область / хойники"
  },
  "2293": {
    "id": "2293",
    "name": "Чечерск",
    "path": "Беларусь / Гомельская область / Чечерск",
    "country": "Беларусь",
    "searchString": "чечерск беларусь / гомельская область / чечерск"
  },
  "2294": {
    "id": "2294",
    "name": "Берестовица",
    "path": "Беларусь / Гродненская область / Берестовица",
    "country": "Беларусь",
    "searchString": "берестовица беларусь / гродненская область / берестовица"
  },
  "2295": {
    "id": "2295",
    "name": "Волковыск",
    "path": "Беларусь / Гродненская область / Волковыск",
    "country": "Беларусь",
    "searchString": "волковыск беларусь / гродненская область / волковыск"
  },
  "2296": {
    "id": "2296",
    "name": "Вороново (Республика Беларусь)",
    "path": "Беларусь / Гродненская область / Вороново (Республика Беларусь)",
    "country": "Беларусь",
    "searchString": "вороново (республика беларусь) беларусь / гродненская область / вороново (республика беларусь)"
  },
  "2297": {
    "id": "2297",
    "name": "Дятлово",
    "path": "Беларусь / Гродненская область / Дятлово",
    "country": "Беларусь",
    "searchString": "дятлово беларусь / гродненская область / дятлово"
  },
  "2298": {
    "id": "2298",
    "name": "Зельва",
    "path": "Беларусь / Гродненская область / Зельва",
    "country": "Беларусь",
    "searchString": "зельва беларусь / гродненская область / зельва"
  },
  "2299": {
    "id": "2299",
    "name": "Ивье",
    "path": "Беларусь / Гродненская область / Ивье",
    "country": "Беларусь",
    "searchString": "ивье беларусь / гродненская область / ивье"
  },
  "2300": {
    "id": "2300",
    "name": "Кореличи",
    "path": "Беларусь / Гродненская область / Кореличи",
    "country": "Беларусь",
    "searchString": "кореличи беларусь / гродненская область / кореличи"
  },
  "2301": {
    "id": "2301",
    "name": "Лида",
    "path": "Беларусь / Гродненская область / Лида",
    "country": "Беларусь",
    "searchString": "лида беларусь / гродненская область / лида"
  },
  "2302": {
    "id": "2302",
    "name": "Мосты",
    "path": "Беларусь / Гродненская область / Мосты",
    "country": "Беларусь",
    "searchString": "мосты беларусь / гродненская область / мосты"
  },
  "2303": {
    "id": "2303",
    "name": "Новогрудок",
    "path": "Беларусь / Гродненская область / Новогрудок",
    "country": "Беларусь",
    "searchString": "новогрудок беларусь / гродненская область / новогрудок"
  },
  "2304": {
    "id": "2304",
    "name": "Островец",
    "path": "Беларусь / Гродненская область / Островец",
    "country": "Беларусь",
    "searchString": "островец беларусь / гродненская область / островец"
  },
  "2305": {
    "id": "2305",
    "name": "Ошмяны",
    "path": "Беларусь / Гродненская область / Ошмяны",
    "country": "Беларусь",
    "searchString": "ошмяны беларусь / гродненская область / ошмяны"
  },
  "2306": {
    "id": "2306",
    "name": "Свислочь",
    "path": "Беларусь / Гродненская область / Свислочь",
    "country": "Беларусь",
    "searchString": "свислочь беларусь / гродненская область / свислочь"
  },
  "2307": {
    "id": "2307",
    "name": "Слоним",
    "path": "Беларусь / Гродненская область / Слоним",
    "country": "Беларусь",
    "searchString": "слоним беларусь / гродненская область / слоним"
  },
  "2308": {
    "id": "2308",
    "name": "Сморгонь",
    "path": "Беларусь / Гродненская область / Сморгонь",
    "country": "Беларусь",
    "searchString": "сморгонь беларусь / гродненская область / сморгонь"
  },
  "2309": {
    "id": "2309",
    "name": "Щучин",
    "path": "Беларусь / Гродненская область / Щучин",
    "country": "Беларусь",
    "searchString": "щучин беларусь / гродненская область / щучин"
  },
  "2310": {
    "id": "2310",
    "name": "Березино",
    "path": "Беларусь / Минская область / Березино",
    "country": "Беларусь",
    "searchString": "березино беларусь / минская область / березино"
  },
  "2311": {
    "id": "2311",
    "name": "Борисов",
    "path": "Беларусь / Минская область / Борисов",
    "country": "Беларусь",
    "searchString": "борисов беларусь / минская область / борисов"
  },
  "2312": {
    "id": "2312",
    "name": "Вилейка",
    "path": "Беларусь / Минская область / Вилейка",
    "country": "Беларусь",
    "searchString": "вилейка беларусь / минская область / вилейка"
  },
  "2313": {
    "id": "2313",
    "name": "Воложин",
    "path": "Беларусь / Минская область / Воложин",
    "country": "Беларусь",
    "searchString": "воложин беларусь / минская область / воложин"
  },
  "2314": {
    "id": "2314",
    "name": "Дзержинск (Беларусь)",
    "path": "Беларусь / Минская область / Дзержинск (Беларусь)",
    "country": "Беларусь",
    "searchString": "дзержинск (беларусь) беларусь / минская область / дзержинск (беларусь)"
  },
  "2315": {
    "id": "2315",
    "name": "Жодино",
    "path": "Беларусь / Минская область / Жодино",
    "country": "Беларусь",
    "searchString": "жодино беларусь / минская область / жодино"
  },
  "2316": {
    "id": "2316",
    "name": "Заславль",
    "path": "Беларусь / Минская область / Заславль",
    "country": "Беларусь",
    "searchString": "заславль беларусь / минская область / заславль"
  },
  "2317": {
    "id": "2317",
    "name": "Клецк",
    "path": "Беларусь / Минская область / Клецк",
    "country": "Беларусь",
    "searchString": "клецк беларусь / минская область / клецк"
  },
  "2318": {
    "id": "2318",
    "name": "Копыль",
    "path": "Беларусь / Минская область / Копыль",
    "country": "Беларусь",
    "searchString": "копыль беларусь / минская область / копыль"
  },
  "2319": {
    "id": "2319",
    "name": "Крупки",
    "path": "Беларусь / Минская область / Крупки",
    "country": "Беларусь",
    "searchString": "крупки беларусь / минская область / крупки"
  },
  "2320": {
    "id": "2320",
    "name": "Логойск",
    "path": "Беларусь / Минская область / Логойск",
    "country": "Беларусь",
    "searchString": "логойск беларусь / минская область / логойск"
  },
  "2322": {
    "id": "2322",
    "name": "Марьина Горка",
    "path": "Беларусь / Минская область / Марьина Горка",
    "country": "Беларусь",
    "searchString": "марьина горка беларусь / минская область / марьина горка"
  },
  "2323": {
    "id": "2323",
    "name": "Молодечно",
    "path": "Беларусь / Минская область / Молодечно",
    "country": "Беларусь",
    "searchString": "молодечно беларусь / минская область / молодечно"
  },
  "2324": {
    "id": "2324",
    "name": "Мядель",
    "path": "Беларусь / Минская область / Мядель",
    "country": "Беларусь",
    "searchString": "мядель беларусь / минская область / мядель"
  },
  "2325": {
    "id": "2325",
    "name": "Несвиж",
    "path": "Беларусь / Минская область / Несвиж",
    "country": "Беларусь",
    "searchString": "несвиж беларусь / минская область / несвиж"
  },
  "2326": {
    "id": "2326",
    "name": "Слуцк",
    "path": "Беларусь / Минская область / Слуцк",
    "country": "Беларусь",
    "searchString": "слуцк беларусь / минская область / слуцк"
  },
  "2327": {
    "id": "2327",
    "name": "Смолевичи",
    "path": "Беларусь / Минская область / Смолевичи",
    "country": "Беларусь",
    "searchString": "смолевичи беларусь / минская область / смолевичи"
  },
  "2328": {
    "id": "2328",
    "name": "Солигорск",
    "path": "Беларусь / Минская область / Солигорск",
    "country": "Беларусь",
    "searchString": "солигорск беларусь / минская область / солигорск"
  },
  "2330": {
    "id": "2330",
    "name": "Столбцы",
    "path": "Беларусь / Минская область / Столбцы",
    "country": "Беларусь",
    "searchString": "столбцы беларусь / минская область / столбцы"
  },
  "2331": {
    "id": "2331",
    "name": "Узда",
    "path": "Беларусь / Минская область / Узда",
    "country": "Беларусь",
    "searchString": "узда беларусь / минская область / узда"
  },
  "2332": {
    "id": "2332",
    "name": "Червень",
    "path": "Беларусь / Минская область / Червень",
    "country": "Беларусь",
    "searchString": "червень беларусь / минская область / червень"
  },
  "2333": {
    "id": "2333",
    "name": "Белыничи",
    "path": "Беларусь / Могилевская область / Белыничи",
    "country": "Беларусь",
    "searchString": "белыничи беларусь / могилевская область / белыничи"
  },
  "2334": {
    "id": "2334",
    "name": "Бобруйск",
    "path": "Беларусь / Могилевская область / Бобруйск",
    "country": "Беларусь",
    "searchString": "бобруйск беларусь / могилевская область / бобруйск"
  },
  "2335": {
    "id": "2335",
    "name": "Быхов",
    "path": "Беларусь / Могилевская область / Быхов",
    "country": "Беларусь",
    "searchString": "быхов беларусь / могилевская область / быхов"
  },
  "2336": {
    "id": "2336",
    "name": "Глуск",
    "path": "Беларусь / Могилевская область / Глуск",
    "country": "Беларусь",
    "searchString": "глуск беларусь / могилевская область / глуск"
  },
  "2337": {
    "id": "2337",
    "name": "Горки (Республика Беларусь)",
    "path": "Беларусь / Могилевская область / Горки (Республика Беларусь)",
    "country": "Беларусь",
    "searchString": "горки (республика беларусь) беларусь / могилевская область / горки (республика беларусь)"
  },
  "2338": {
    "id": "2338",
    "name": "Дрибин",
    "path": "Беларусь / Могилевская область / Дрибин",
    "country": "Беларусь",
    "searchString": "дрибин беларусь / могилевская область / дрибин"
  },
  "2340": {
    "id": "2340",
    "name": "Климовичи",
    "path": "Беларусь / Могилевская область / Климовичи",
    "country": "Беларусь",
    "searchString": "климовичи беларусь / могилевская область / климовичи"
  },
  "2341": {
    "id": "2341",
    "name": "Кличев",
    "path": "Беларусь / Могилевская область / Кличев",
    "country": "Беларусь",
    "searchString": "кличев беларусь / могилевская область / кличев"
  },
  "2342": {
    "id": "2342",
    "name": "Костюковичи",
    "path": "Беларусь / Могилевская область / Костюковичи",
    "country": "Беларусь",
    "searchString": "костюковичи беларусь / могилевская область / костюковичи"
  },
  "2343": {
    "id": "2343",
    "name": "Краснополье (Могилевская область)",
    "path": "Беларусь / Могилевская область / Краснополье (Могилевская область)",
    "country": "Беларусь",
    "searchString": "краснополье (могилевская область) беларусь / могилевская область / краснополье (могилевская область)"
  },
  "2344": {
    "id": "2344",
    "name": "Кричев",
    "path": "Беларусь / Могилевская область / Кричев",
    "country": "Беларусь",
    "searchString": "кричев беларусь / могилевская область / кричев"
  },
  "2345": {
    "id": "2345",
    "name": "Круглое",
    "path": "Беларусь / Могилевская область / Круглое",
    "country": "Беларусь",
    "searchString": "круглое беларусь / могилевская область / круглое"
  },
  "2346": {
    "id": "2346",
    "name": "Мстиславль",
    "path": "Беларусь / Могилевская область / Мстиславль",
    "country": "Беларусь",
    "searchString": "мстиславль беларусь / могилевская область / мстиславль"
  },
  "2347": {
    "id": "2347",
    "name": "Осиповичи",
    "path": "Беларусь / Могилевская область / Осиповичи",
    "country": "Беларусь",
    "searchString": "осиповичи беларусь / могилевская область / осиповичи"
  },
  "2349": {
    "id": "2349",
    "name": "Хотимск",
    "path": "Беларусь / Могилевская область / Хотимск",
    "country": "Беларусь",
    "searchString": "хотимск беларусь / могилевская область / хотимск"
  },
  "2350": {
    "id": "2350",
    "name": "Чаусы",
    "path": "Беларусь / Могилевская область / Чаусы",
    "country": "Беларусь",
    "searchString": "чаусы беларусь / могилевская область / чаусы"
  },
  "2351": {
    "id": "2351",
    "name": "Чериков",
    "path": "Беларусь / Могилевская область / Чериков",
    "country": "Беларусь",
    "searchString": "чериков беларусь / могилевская область / чериков"
  },
  "2352": {
    "id": "2352",
    "name": "Шклов",
    "path": "Беларусь / Могилевская область / Шклов",
    "country": "Беларусь",
    "searchString": "шклов беларусь / могилевская область / шклов"
  },
  "2353": {
    "id": "2353",
    "name": "Мальта",
    "path": "Другие регионы / Мальта",
    "country": "Другие регионы",
    "searchString": "мальта другие регионы / мальта"
  },
  "2354": {
    "id": "2354",
    "name": "Андорра",
    "path": "Другие регионы / Андорра",
    "country": "Другие регионы",
    "searchString": "андорра другие регионы / андорра"
  },
  "2355": {
    "id": "2355",
    "name": "Лихтенштейн",
    "path": "Другие регионы / Лихтенштейн",
    "country": "Другие регионы",
    "searchString": "лихтенштейн другие регионы / лихтенштейн"
  },
  "2356": {
    "id": "2356",
    "name": "Монако",
    "path": "Другие регионы / Монако",
    "country": "Другие регионы",
    "searchString": "монако другие регионы / монако"
  },
  "2357": {
    "id": "2357",
    "name": "Албания",
    "path": "Другие регионы / Албания",
    "country": "Другие регионы",
    "searchString": "албания другие регионы / албания"
  },
  "2358": {
    "id": "2358",
    "name": "Босния и Герцеговина",
    "path": "Другие регионы / Босния и Герцеговина",
    "country": "Другие регионы",
    "searchString": "босния и герцеговина другие регионы / босния и герцеговина"
  },
  "2359": {
    "id": "2359",
    "name": "Македония",
    "path": "Другие регионы / Македония",
    "country": "Другие регионы",
    "searchString": "македония другие регионы / македония"
  },
  "2360": {
    "id": "2360",
    "name": "Филиппины",
    "path": "Другие регионы / Филиппины",
    "country": "Другие регионы",
    "searchString": "филиппины другие регионы / филиппины"
  },
  "2361": {
    "id": "2361",
    "name": "Бахрейн",
    "path": "Другие регионы / Бахрейн",
    "country": "Другие регионы",
    "searchString": "бахрейн другие регионы / бахрейн"
  },
  "2362": {
    "id": "2362",
    "name": "Королевство Саудовская Аравия",
    "path": "Другие регионы / Королевство Саудовская Аравия",
    "country": "Другие регионы",
    "searchString": "королевство саудовская аравия другие регионы / королевство саудовская аравия"
  },
  "2363": {
    "id": "2363",
    "name": "Кувейт",
    "path": "Другие регионы / Кувейт",
    "country": "Другие регионы",
    "searchString": "кувейт другие регионы / кувейт"
  },
  "2364": {
    "id": "2364",
    "name": "Оман",
    "path": "Другие регионы / Оман",
    "country": "Другие регионы",
    "searchString": "оман другие регионы / оман"
  },
  "2365": {
    "id": "2365",
    "name": "Иордания",
    "path": "Другие регионы / Иордания",
    "country": "Другие регионы",
    "searchString": "иордания другие регионы / иордания"
  },
  "2366": {
    "id": "2366",
    "name": "Новополоцк",
    "path": "Беларусь / Витебская область / Новополоцк",
    "country": "Беларусь",
    "searchString": "новополоцк беларусь / витебская область / новополоцк"
  },
  "2367": {
    "id": "2367",
    "name": "Республика Сейшельские острова",
    "path": "Другие регионы / Республика Сейшельские острова",
    "country": "Другие регионы",
    "searchString": "республика сейшельские острова другие регионы / республика сейшельские острова"
  },
  "2368": {
    "id": "2368",
    "name": "Алжир",
    "path": "Другие регионы / Алжир",
    "country": "Другие регионы",
    "searchString": "алжир другие регионы / алжир"
  },
  "2369": {
    "id": "2369",
    "name": "Реюньон",
    "path": "Другие регионы / Реюньон",
    "country": "Другие регионы",
    "searchString": "реюньон другие регионы / реюньон"
  },
  "2370": {
    "id": "2370",
    "name": "Республика Маврикий",
    "path": "Другие регионы / Республика Маврикий",
    "country": "Другие регионы",
    "searchString": "республика маврикий другие регионы / республика маврикий"
  },
  "2371": {
    "id": "2371",
    "name": "Венесуэла",
    "path": "Другие регионы / Венесуэла",
    "country": "Другие регионы",
    "searchString": "венесуэла другие регионы / венесуэла"
  },
  "2372": {
    "id": "2372",
    "name": "Марокко",
    "path": "Другие регионы / Марокко",
    "country": "Другие регионы",
    "searchString": "марокко другие регионы / марокко"
  },
  "2374": {
    "id": "2374",
    "name": "Республика Сенегал",
    "path": "Другие регионы / Республика Сенегал",
    "country": "Другие регионы",
    "searchString": "республика сенегал другие регионы / республика сенегал"
  },
  "2375": {
    "id": "2375",
    "name": "Намибия",
    "path": "Другие регионы / Намибия",
    "country": "Другие регионы",
    "searchString": "намибия другие регионы / намибия"
  },
  "2376": {
    "id": "2376",
    "name": "Ангола",
    "path": "Другие регионы / Ангола",
    "country": "Другие регионы",
    "searchString": "ангола другие регионы / ангола"
  },
  "2377": {
    "id": "2377",
    "name": "Адлер",
    "path": "Россия / Краснодарский край / Адлер",
    "country": "Россия",
    "searchString": "адлер россия / краснодарский край / адлер"
  },
  "2378": {
    "id": "2378",
    "name": "Республика Нигер",
    "path": "Другие регионы / Республика Нигер",
    "country": "Другие регионы",
    "searchString": "республика нигер другие регионы / республика нигер"
  },
  "2380": {
    "id": "2380",
    "name": "Кооперативная Республика Гайана",
    "path": "Другие регионы / Кооперативная Республика Гайана",
    "country": "Другие регионы",
    "searchString": "кооперативная республика гайана другие регионы / кооперативная республика гайана"
  },
  "2381": {
    "id": "2381",
    "name": "Алушта",
    "path": "Россия / Республика Крым / Алушта",
    "country": "Россия",
    "searchString": "алушта россия / республика крым / алушта"
  },
  "2382": {
    "id": "2382",
    "name": "Гурзуф",
    "path": "Россия / Республика Крым / Гурзуф",
    "country": "Россия",
    "searchString": "гурзуф россия / республика крым / гурзуф"
  },
  "2383": {
    "id": "2383",
    "name": "Судак",
    "path": "Россия / Республика Крым / Судак",
    "country": "Россия",
    "searchString": "судак россия / республика крым / судак"
  },
  "2384": {
    "id": "2384",
    "name": "Коктебель",
    "path": "Россия / Республика Крым / Коктебель",
    "country": "Россия",
    "searchString": "коктебель россия / республика крым / коктебель"
  },
  "2385": {
    "id": "2385",
    "name": "Саки",
    "path": "Россия / Республика Крым / Саки",
    "country": "Россия",
    "searchString": "саки россия / республика крым / саки"
  },
  "2386": {
    "id": "2386",
    "name": "Джанкой",
    "path": "Россия / Республика Крым / Джанкой",
    "country": "Россия",
    "searchString": "джанкой россия / республика крым / джанкой"
  },
  "2387": {
    "id": "2387",
    "name": "Форос",
    "path": "Россия / Республика Крым / Форос",
    "country": "Россия",
    "searchString": "форос россия / республика крым / форос"
  },
  "2388": {
    "id": "2388",
    "name": "Инкерман",
    "path": "Россия / Республика Крым / Инкерман",
    "country": "Россия",
    "searchString": "инкерман россия / республика крым / инкерман"
  },
  "2389": {
    "id": "2389",
    "name": "Белогорск (Крым)",
    "path": "Россия / Республика Крым / Белогорск (Крым)",
    "country": "Россия",
    "searchString": "белогорск (крым) россия / республика крым / белогорск (крым)"
  },
  "2390": {
    "id": "2390",
    "name": "Черноморское",
    "path": "Россия / Республика Крым / Черноморское",
    "country": "Россия",
    "searchString": "черноморское россия / республика крым / черноморское"
  },
  "2391": {
    "id": "2391",
    "name": "Красноперекопск",
    "path": "Россия / Республика Крым / Красноперекопск",
    "country": "Россия",
    "searchString": "красноперекопск россия / республика крым / красноперекопск"
  },
  "2392": {
    "id": "2392",
    "name": "Красногвардейское",
    "path": "Россия / Республика Крым / Красногвардейское",
    "country": "Россия",
    "searchString": "красногвардейское россия / республика крым / красногвардейское"
  },
  "2393": {
    "id": "2393",
    "name": "Первомайское (Республика Крым)",
    "path": "Россия / Республика Крым / Первомайское (Республика Крым)",
    "country": "Россия",
    "searchString": "первомайское (республика крым) россия / республика крым / первомайское (республика крым)"
  },
  "2394": {
    "id": "2394",
    "name": "Фаниполь",
    "path": "Беларусь / Минская область / Фаниполь",
    "country": "Беларусь",
    "searchString": "фаниполь беларусь / минская область / фаниполь"
  },
  "2395": {
    "id": "2395",
    "name": "Перу",
    "path": "Другие регионы / Перу",
    "country": "Другие регионы",
    "searchString": "перу другие регионы / перу"
  },
  "2396": {
    "id": "2396",
    "name": "Чили",
    "path": "Другие регионы / Чили",
    "country": "Другие регионы",
    "searchString": "чили другие регионы / чили"
  },
  "2397": {
    "id": "2397",
    "name": "Каменка (Воронежская область)",
    "path": "Россия / Воронежская область / Каменка (Воронежская область)",
    "country": "Россия",
    "searchString": "каменка (воронежская область) россия / воронежская область / каменка (воронежская область)"
  },
  "2398": {
    "id": "2398",
    "name": "Республика Либерия",
    "path": "Другие регионы / Республика Либерия",
    "country": "Другие регионы",
    "searchString": "республика либерия другие регионы / республика либерия"
  },
  "2399": {
    "id": "2399",
    "name": "Забайкальск",
    "path": "Россия / Забайкальский край / Забайкальск",
    "country": "Россия",
    "searchString": "забайкальск россия / забайкальский край / забайкальск"
  },
  "2432": {
    "id": "2432",
    "name": "Каневская",
    "path": "Россия / Краснодарский край / Каневская",
    "country": "Россия",
    "searchString": "каневская россия / краснодарский край / каневская"
  },
  "2433": {
    "id": "2433",
    "name": "Верхняя Хава",
    "path": "Россия / Воронежская область / Верхняя Хава",
    "country": "Россия",
    "searchString": "верхняя хава россия / воронежская область / верхняя хава"
  },
  "2434": {
    "id": "2434",
    "name": "Гостомель",
    "path": "Украина / Киевская область / Гостомель",
    "country": "Украина",
    "searchString": "гостомель украина / киевская область / гостомель"
  },
  "2435": {
    "id": "2435",
    "name": "Государство Палестина",
    "path": "Другие регионы / Государство Палестина",
    "country": "Другие регионы",
    "searchString": "государство палестина другие регионы / государство палестина"
  },
  "2436": {
    "id": "2436",
    "name": "Вельск",
    "path": "Россия / Архангельская область / Вельск",
    "country": "Россия",
    "searchString": "вельск россия / архангельская область / вельск"
  },
  "2437": {
    "id": "2437",
    "name": "Степногорск",
    "path": "Казахстан / Степногорск",
    "country": "Казахстан",
    "searchString": "степногорск казахстан / степногорск"
  },
  "2438": {
    "id": "2438",
    "name": "Анна",
    "path": "Россия / Воронежская область / Анна",
    "country": "Россия",
    "searchString": "анна россия / воронежская область / анна"
  },
  "2439": {
    "id": "2439",
    "name": "Дивеево",
    "path": "Россия / Нижегородская область / Дивеево",
    "country": "Россия",
    "searchString": "дивеево россия / нижегородская область / дивеево"
  },
  "2440": {
    "id": "2440",
    "name": "Ямайка",
    "path": "Другие регионы / Ямайка",
    "country": "Другие регионы",
    "searchString": "ямайка другие регионы / ямайка"
  },
  "2441": {
    "id": "2441",
    "name": "Монино (Московская область)",
    "path": "Россия / Московская область / Монино (Московская область)",
    "country": "Россия",
    "searchString": "монино (московская область) россия / московская область / монино (московская область)"
  },
  "2442": {
    "id": "2442",
    "name": "Эвенск",
    "path": "Россия / Магаданская область / Эвенск",
    "country": "Россия",
    "searchString": "эвенск россия / магаданская область / эвенск"
  },
  "2443": {
    "id": "2443",
    "name": "Ахтырка",
    "path": "Украина / Сумская область / Ахтырка",
    "country": "Украина",
    "searchString": "ахтырка украина / сумская область / ахтырка"
  },
  "2444": {
    "id": "2444",
    "name": "Мостовской",
    "path": "Россия / Краснодарский край / Мостовской",
    "country": "Россия",
    "searchString": "мостовской россия / краснодарский край / мостовской"
  },
  "2445": {
    "id": "2445",
    "name": "Боярка",
    "path": "Украина / Киевская область / Боярка",
    "country": "Украина",
    "searchString": "боярка украина / киевская область / боярка"
  },
  "2446": {
    "id": "2446",
    "name": "Республика Северный Судан",
    "path": "Другие регионы / Республика Северный Судан",
    "country": "Другие регионы",
    "searchString": "республика северный судан другие регионы / республика северный судан"
  },
  "2447": {
    "id": "2447",
    "name": "Ленинградская станица",
    "path": "Россия / Краснодарский край / Ленинградская станица",
    "country": "Россия",
    "searchString": "ленинградская станица россия / краснодарский край / ленинградская станица"
  },
  "2448": {
    "id": "2448",
    "name": "Динская станица",
    "path": "Россия / Краснодарский край / Динская станица",
    "country": "Россия",
    "searchString": "динская станица россия / краснодарский край / динская станица"
  },
  "2449": {
    "id": "2449",
    "name": "Балтаси",
    "path": "Россия / Республика Татарстан / Балтаси",
    "country": "Россия",
    "searchString": "балтаси россия / республика татарстан / балтаси"
  },
  "2450": {
    "id": "2450",
    "name": "Пластун",
    "path": "Россия / Приморский край / Пластун",
    "country": "Россия",
    "searchString": "пластун россия / приморский край / пластун"
  },
  "2451": {
    "id": "2451",
    "name": "Ноглики",
    "path": "Россия / Сахалинская область / Ноглики",
    "country": "Россия",
    "searchString": "ноглики россия / сахалинская область / ноглики"
  },
  "2452": {
    "id": "2452",
    "name": "Медвежье Озеро",
    "path": "Россия / Курганская область / Медвежье Озеро",
    "country": "Россия",
    "searchString": "медвежье озеро россия / курганская область / медвежье озеро"
  },
  "2453": {
    "id": "2453",
    "name": "Республика Кения",
    "path": "Другие регионы / Республика Кения",
    "country": "Другие регионы",
    "searchString": "республика кения другие регионы / республика кения"
  },
  "2454": {
    "id": "2454",
    "name": "Республика Кот-д’Ивуар",
    "path": "Другие регионы / Республика Кот-д’Ивуар",
    "country": "Другие регионы",
    "searchString": "республика кот-д’ивуар другие регионы / республика кот-д’ивуар"
  },
  "2484": {
    "id": "2484",
    "name": "Новолукомль",
    "path": "Беларусь / Витебская область / Новолукомль",
    "country": "Беларусь",
    "searchString": "новолукомль беларусь / витебская область / новолукомль"
  },
  "2485": {
    "id": "2485",
    "name": "Миргород",
    "path": "Украина / Полтавская область / Миргород",
    "country": "Украина",
    "searchString": "миргород украина / полтавская область / миргород"
  },
  "2486": {
    "id": "2486",
    "name": "Кокошкино (Московская область)",
    "path": "Россия / Московская область / Кокошкино (Московская область)",
    "country": "Россия",
    "searchString": "кокошкино (московская область) россия / московская область / кокошкино (московская область)"
  },
  "2487": {
    "id": "2487",
    "name": "Мьянма",
    "path": "Другие регионы / Мьянма",
    "country": "Другие регионы",
    "searchString": "мьянма другие регионы / мьянма"
  },
  "2488": {
    "id": "2488",
    "name": "Республика Мадагаскар",
    "path": "Другие регионы / Республика Мадагаскар",
    "country": "Другие регионы",
    "searchString": "республика мадагаскар другие регионы / республика мадагаскар"
  },
  "2489": {
    "id": "2489",
    "name": "Хохольский",
    "path": "Россия / Воронежская область / Хохольский",
    "country": "Россия",
    "searchString": "хохольский россия / воронежская область / хохольский"
  },
  "2490": {
    "id": "2490",
    "name": "Пушкин",
    "path": "Россия / Ленинградская область / Пушкин",
    "country": "Россия",
    "searchString": "пушкин россия / ленинградская область / пушкин"
  },
  "2491": {
    "id": "2491",
    "name": "Республика Гана",
    "path": "Другие регионы / Республика Гана",
    "country": "Другие регионы",
    "searchString": "республика гана другие регионы / республика гана"
  },
  "2492": {
    "id": "2492",
    "name": "Баку",
    "path": "Азербайджан / Баку",
    "country": "Азербайджан",
    "searchString": "баку азербайджан / баку"
  },
  "2493": {
    "id": "2493",
    "name": "Габала",
    "path": "Азербайджан / Габала",
    "country": "Азербайджан",
    "searchString": "габала азербайджан / габала"
  },
  "2494": {
    "id": "2494",
    "name": "Гянджа",
    "path": "Азербайджан / Гянджа",
    "country": "Азербайджан",
    "searchString": "гянджа азербайджан / гянджа"
  },
  "2495": {
    "id": "2495",
    "name": "Сумгаит",
    "path": "Азербайджан / Сумгаит",
    "country": "Азербайджан",
    "searchString": "сумгаит азербайджан / сумгаит"
  },
  "2496": {
    "id": "2496",
    "name": "Закаталы",
    "path": "Азербайджан / Закаталы",
    "country": "Азербайджан",
    "searchString": "закаталы азербайджан / закаталы"
  },
  "2497": {
    "id": "2497",
    "name": "Куба (Азербайджан)",
    "path": "Азербайджан / Куба (Азербайджан)",
    "country": "Азербайджан",
    "searchString": "куба (азербайджан) азербайджан / куба (азербайджан)"
  },
  "2498": {
    "id": "2498",
    "name": "Ленкорань",
    "path": "Азербайджан / Ленкорань",
    "country": "Азербайджан",
    "searchString": "ленкорань азербайджан / ленкорань"
  },
  "2499": {
    "id": "2499",
    "name": "Мингечаур",
    "path": "Азербайджан / Мингечаур",
    "country": "Азербайджан",
    "searchString": "мингечаур азербайджан / мингечаур"
  },
  "2500": {
    "id": "2500",
    "name": "Нахичевань",
    "path": "Азербайджан / Нахичевань",
    "country": "Азербайджан",
    "searchString": "нахичевань азербайджан / нахичевань"
  },
  "2501": {
    "id": "2501",
    "name": "Ордубад",
    "path": "Азербайджан / Ордубад",
    "country": "Азербайджан",
    "searchString": "ордубад азербайджан / ордубад"
  },
  "2502": {
    "id": "2502",
    "name": "Шеки",
    "path": "Азербайджан / Шеки",
    "country": "Азербайджан",
    "searchString": "шеки азербайджан / шеки"
  },
  "2503": {
    "id": "2503",
    "name": "Шемаха",
    "path": "Азербайджан / Шемаха",
    "country": "Азербайджан",
    "searchString": "шемаха азербайджан / шемаха"
  },
  "2504": {
    "id": "2504",
    "name": "Республика Зимбабве",
    "path": "Другие регионы / Республика Зимбабве",
    "country": "Другие регионы",
    "searchString": "республика зимбабве другие регионы / республика зимбабве"
  },
  "2505": {
    "id": "2505",
    "name": "Брюховецкая станица",
    "path": "Россия / Краснодарский край / Брюховецкая станица",
    "country": "Россия",
    "searchString": "брюховецкая станица россия / краснодарский край / брюховецкая станица"
  },
  "2506": {
    "id": "2506",
    "name": "Богучаны",
    "path": "Россия / Красноярский край / Богучаны",
    "country": "Россия",
    "searchString": "богучаны россия / красноярский край / богучаны"
  },
  "2507": {
    "id": "2507",
    "name": "Сестрорецк",
    "path": "Россия / Ленинградская область / Сестрорецк",
    "country": "Россия",
    "searchString": "сестрорецк россия / ленинградская область / сестрорецк"
  },
  "2508": {
    "id": "2508",
    "name": "Дружковка",
    "path": "Россия / Донецкая Народная Республика / Дружковка",
    "country": "Россия",
    "searchString": "дружковка россия / донецкая народная республика / дружковка"
  },
  "2509": {
    "id": "2509",
    "name": "Ясиноватая",
    "path": "Россия / Донецкая Народная Республика / Ясиноватая",
    "country": "Россия",
    "searchString": "ясиноватая россия / донецкая народная республика / ясиноватая"
  },
  "2510": {
    "id": "2510",
    "name": "Жанаозен",
    "path": "Казахстан / Жанаозен",
    "country": "Казахстан",
    "searchString": "жанаозен казахстан / жанаозен"
  },
  "2511": {
    "id": "2511",
    "name": "Шри-Ланка",
    "path": "Другие регионы / Шри-Ланка",
    "country": "Другие регионы",
    "searchString": "шри-ланка другие регионы / шри-ланка"
  },
  "2512": {
    "id": "2512",
    "name": "Чаны",
    "path": "Россия / Новосибирская область / Чаны",
    "country": "Россия",
    "searchString": "чаны россия / новосибирская область / чаны"
  },
  "2513": {
    "id": "2513",
    "name": "Рубежное",
    "path": "Россия / Луганская Народная Республика / Рубежное",
    "country": "Россия",
    "searchString": "рубежное россия / луганская народная республика / рубежное"
  },
  "2520": {
    "id": "2520",
    "name": "Эфиопия",
    "path": "Другие регионы / Эфиопия",
    "country": "Другие регионы",
    "searchString": "эфиопия другие регионы / эфиопия"
  },
  "2521": {
    "id": "2521",
    "name": "Кинель-Черкассы",
    "path": "Россия / Самарская область / Кинель-Черкассы",
    "country": "Россия",
    "searchString": "кинель-черкассы россия / самарская область / кинель-черкассы"
  },
  "2522": {
    "id": "2522",
    "name": "Красное Село",
    "path": "Россия / Ленинградская область / Красное Село",
    "country": "Россия",
    "searchString": "красное село россия / ленинградская область / красное село"
  },
  "2523": {
    "id": "2523",
    "name": "Туров",
    "path": "Беларусь / Гомельская область / Туров",
    "country": "Беларусь",
    "searchString": "туров беларусь / гомельская область / туров"
  },
  "2524": {
    "id": "2524",
    "name": "Южная Осетия",
    "path": "Другие регионы / Южная Осетия",
    "country": "Другие регионы",
    "searchString": "южная осетия другие регионы / южная осетия"
  },
  "2525": {
    "id": "2525",
    "name": "Цхинвал",
    "path": "Другие регионы / Южная Осетия / Цхинвал",
    "country": "Другие регионы",
    "searchString": "цхинвал другие регионы / южная осетия / цхинвал"
  },
  "2553": {
    "id": "2553",
    "name": "Таловая",
    "path": "Россия / Воронежская область / Таловая",
    "country": "Россия",
    "searchString": "таловая россия / воронежская область / таловая"
  },
  "2554": {
    "id": "2554",
    "name": "Колпино",
    "path": "Россия / Ленинградская область / Колпино",
    "country": "Россия",
    "searchString": "колпино россия / ленинградская область / колпино"
  },
  "2586": {
    "id": "2586",
    "name": "Габон",
    "path": "Другие регионы / Габон",
    "country": "Другие регионы",
    "searchString": "габон другие регионы / габон"
  },
  "2587": {
    "id": "2587",
    "name": "Панама",
    "path": "Другие регионы / Панама",
    "country": "Другие регионы",
    "searchString": "панама другие регионы / панама"
  },
  "2588": {
    "id": "2588",
    "name": "Березовка (Гродненская область)",
    "path": "Беларусь / Гродненская область / Березовка (Гродненская область)",
    "country": "Беларусь",
    "searchString": "березовка (гродненская область) беларусь / гродненская область / березовка (гродненская область)"
  },
  "2589": {
    "id": "2589",
    "name": "Скидель",
    "path": "Беларусь / Гродненская область / Скидель",
    "country": "Беларусь",
    "searchString": "скидель беларусь / гродненская область / скидель"
  },
  "2590": {
    "id": "2590",
    "name": "Высокое",
    "path": "Беларусь / Брестская область / Высокое",
    "country": "Беларусь",
    "searchString": "высокое беларусь / брестская область / высокое"
  },
  "2621": {
    "id": "2621",
    "name": "Исмаиллы",
    "path": "Азербайджан / Исмаиллы",
    "country": "Азербайджан",
    "searchString": "исмаиллы азербайджан / исмаиллы"
  },
  "2622": {
    "id": "2622",
    "name": "Тертер",
    "path": "Азербайджан / Тертер",
    "country": "Азербайджан",
    "searchString": "тертер азербайджан / тертер"
  },
  "2623": {
    "id": "2623",
    "name": "Геранбой",
    "path": "Азербайджан / Геранбой",
    "country": "Азербайджан",
    "searchString": "геранбой азербайджан / геранбой"
  },
  "2624": {
    "id": "2624",
    "name": "Газах",
    "path": "Азербайджан / Газах",
    "country": "Азербайджан",
    "searchString": "газах азербайджан / газах"
  },
  "2625": {
    "id": "2625",
    "name": "Барда",
    "path": "Азербайджан / Барда",
    "country": "Азербайджан",
    "searchString": "барда азербайджан / барда"
  },
  "2626": {
    "id": "2626",
    "name": "Агсу",
    "path": "Азербайджан / Агсу",
    "country": "Азербайджан",
    "searchString": "агсу азербайджан / агсу"
  },
  "2627": {
    "id": "2627",
    "name": "Гёйчай",
    "path": "Азербайджан / Гёйчай",
    "country": "Азербайджан",
    "searchString": "гёйчай азербайджан / гёйчай"
  },
  "2628": {
    "id": "2628",
    "name": "Кукмор",
    "path": "Россия / Республика Татарстан / Кукмор",
    "country": "Россия",
    "searchString": "кукмор россия / республика татарстан / кукмор"
  },
  "2629": {
    "id": "2629",
    "name": "Шексна",
    "path": "Россия / Вологодская область / Шексна",
    "country": "Россия",
    "searchString": "шексна россия / вологодская область / шексна"
  },
  "2630": {
    "id": "2630",
    "name": "Белоозерск",
    "path": "Беларусь / Брестская область / Белоозерск",
    "country": "Беларусь",
    "searchString": "белоозерск беларусь / брестская область / белоозерск"
  },
  "2631": {
    "id": "2631",
    "name": "Мир (Гродненская область)",
    "path": "Беларусь / Гродненская область / Мир (Гродненская область)",
    "country": "Беларусь",
    "searchString": "мир (гродненская область) беларусь / гродненская область / мир (гродненская область)"
  },
  "2632": {
    "id": "2632",
    "name": "Барань",
    "path": "Беларусь / Витебская область / Барань",
    "country": "Беларусь",
    "searchString": "барань беларусь / витебская область / барань"
  },
  "2633": {
    "id": "2633",
    "name": "Октябрьский (Московская область, Люберецкий район)",
    "path": "Россия / Московская область / Октябрьский (Московская область, Люберецкий район)",
    "country": "Россия",
    "searchString": "октябрьский (московская область, люберецкий район) россия / московская область / октябрьский (московская область, люберецкий район)"
  },
  "2634": {
    "id": "2634",
    "name": "Нахабино (Московская область)",
    "path": "Россия / Московская область / Нахабино (Московская область)",
    "country": "Россия",
    "searchString": "нахабино (московская область) россия / московская область / нахабино (московская область)"
  },
  "2635": {
    "id": "2635",
    "name": "Республика Куба",
    "path": "Другие регионы / Республика Куба",
    "country": "Другие регионы",
    "searchString": "республика куба другие регионы / республика куба"
  },
  "2636": {
    "id": "2636",
    "name": "Республика Коста-Рика",
    "path": "Другие регионы / Республика Коста-Рика",
    "country": "Другие регионы",
    "searchString": "республика коста-рика другие регионы / республика коста-рика"
  },
  "2637": {
    "id": "2637",
    "name": "Карачи",
    "path": "Другие регионы / Пакистан / Карачи",
    "country": "Другие регионы",
    "searchString": "карачи другие регионы / пакистан / карачи"
  },
  "2638": {
    "id": "2638",
    "name": "Орловский",
    "path": "Россия / Ростовская область / Орловский",
    "country": "Россия",
    "searchString": "орловский россия / ростовская область / орловский"
  },
  "2639": {
    "id": "2639",
    "name": "Павловская",
    "path": "Россия / Краснодарский край / Павловская",
    "country": "Россия",
    "searchString": "павловская россия / краснодарский край / павловская"
  },
  "2640": {
    "id": "2640",
    "name": "Выселки",
    "path": "Россия / Краснодарский край / Выселки",
    "country": "Россия",
    "searchString": "выселки россия / краснодарский край / выселки"
  },
  "2641": {
    "id": "2641",
    "name": "Кабардинка",
    "path": "Россия / Краснодарский край / Кабардинка",
    "country": "Россия",
    "searchString": "кабардинка россия / краснодарский край / кабардинка"
  },
  "2642": {
    "id": "2642",
    "name": "Староминская",
    "path": "Россия / Краснодарский край / Староминская",
    "country": "Россия",
    "searchString": "староминская россия / краснодарский край / староминская"
  },
  "2643": {
    "id": "2643",
    "name": "Дивноморское",
    "path": "Россия / Краснодарский край / Дивноморское",
    "country": "Россия",
    "searchString": "дивноморское россия / краснодарский край / дивноморское"
  },
  "2644": {
    "id": "2644",
    "name": "Кусары",
    "path": "Азербайджан / Кусары",
    "country": "Азербайджан",
    "searchString": "кусары азербайджан / кусары"
  },
  "2645": {
    "id": "2645",
    "name": "Чекмагуш",
    "path": "Россия / Республика Башкортостан / Чекмагуш",
    "country": "Россия",
    "searchString": "чекмагуш россия / республика башкортостан / чекмагуш"
  },
  "2646": {
    "id": "2646",
    "name": "Клетня",
    "path": "Россия / Брянская область / Клетня",
    "country": "Россия",
    "searchString": "клетня россия / брянская область / клетня"
  },
  "2647": {
    "id": "2647",
    "name": "Новая Усмань",
    "path": "Россия / Воронежская область / Новая Усмань",
    "country": "Россия",
    "searchString": "новая усмань россия / воронежская область / новая усмань"
  },
  "2648": {
    "id": "2648",
    "name": "Таксимо",
    "path": "Россия / Республика Бурятия / Таксимо",
    "country": "Россия",
    "searchString": "таксимо россия / республика бурятия / таксимо"
  },
  "2649": {
    "id": "2649",
    "name": "Южно-Курильск",
    "path": "Россия / Сахалинская область / Южно-Курильск",
    "country": "Россия",
    "searchString": "южно-курильск россия / сахалинская область / южно-курильск"
  },
  "2650": {
    "id": "2650",
    "name": "Микашевичи",
    "path": "Беларусь / Брестская область / Микашевичи",
    "country": "Беларусь",
    "searchString": "микашевичи беларусь / брестская область / микашевичи"
  },
  "2651": {
    "id": "2651",
    "name": "Светлый Яр",
    "path": "Россия / Волгоградская область / Светлый Яр",
    "country": "Россия",
    "searchString": "светлый яр россия / волгоградская область / светлый яр"
  },
  "2652": {
    "id": "2652",
    "name": "Крыловская станица (Крыловский район)",
    "path": "Россия / Краснодарский край / Крыловская станица (Крыловский район)",
    "country": "Россия",
    "searchString": "крыловская станица (крыловский район) россия / краснодарский край / крыловская станица (крыловский район)"
  },
  "2653": {
    "id": "2653",
    "name": "Каскелен",
    "path": "Казахстан / Каскелен",
    "country": "Казахстан",
    "searchString": "каскелен казахстан / каскелен"
  },
  "2654": {
    "id": "2654",
    "name": "Кущевская станица",
    "path": "Россия / Краснодарский край / Кущевская станица",
    "country": "Россия",
    "searchString": "кущевская станица россия / краснодарский край / кущевская станица"
  },
  "2655": {
    "id": "2655",
    "name": "Усть-Калманка",
    "path": "Россия / Алтайский край / Усть-Калманка",
    "country": "Россия",
    "searchString": "усть-калманка россия / алтайский край / усть-калманка"
  },
  "2656": {
    "id": "2656",
    "name": "Константиновка",
    "path": "Россия / Донецкая Народная Республика / Константиновка",
    "country": "Россия",
    "searchString": "константиновка россия / донецкая народная республика / константиновка"
  },
  "2657": {
    "id": "2657",
    "name": "Софрино (Московская область)",
    "path": "Россия / Московская область / Софрино (Московская область)",
    "country": "Россия",
    "searchString": "софрино (московская область) россия / московская область / софрино (московская область)"
  },
  "2658": {
    "id": "2658",
    "name": "Северская станица",
    "path": "Россия / Краснодарский край / Северская станица",
    "country": "Россия",
    "searchString": "северская станица россия / краснодарский край / северская станица"
  },
  "2659": {
    "id": "2659",
    "name": "Подгоренский",
    "path": "Россия / Воронежская область / Подгоренский",
    "country": "Россия",
    "searchString": "подгоренский россия / воронежская область / подгоренский"
  },
  "2660": {
    "id": "2660",
    "name": "Кантемировка",
    "path": "Россия / Воронежская область / Кантемировка",
    "country": "Россия",
    "searchString": "кантемировка россия / воронежская область / кантемировка"
  },
  "2661": {
    "id": "2661",
    "name": "Грибановский",
    "path": "Россия / Воронежская область / Грибановский",
    "country": "Россия",
    "searchString": "грибановский россия / воронежская область / грибановский"
  },
  "2662": {
    "id": "2662",
    "name": "Рамонь",
    "path": "Россия / Воронежская область / Рамонь",
    "country": "Россия",
    "searchString": "рамонь россия / воронежская область / рамонь"
  },
  "2663": {
    "id": "2663",
    "name": "Ольховатка",
    "path": "Россия / Воронежская область / Ольховатка",
    "country": "Россия",
    "searchString": "ольховатка россия / воронежская область / ольховатка"
  },
  "2664": {
    "id": "2664",
    "name": "Павловск (Ленинградская область)",
    "path": "Россия / Ленинградская область / Павловск (Ленинградская область)",
    "country": "Россия",
    "searchString": "павловск (ленинградская область) россия / ленинградская область / павловск (ленинградская область)"
  },
  "2665": {
    "id": "2665",
    "name": "Довольное",
    "path": "Россия / Новосибирская область / Довольное",
    "country": "Россия",
    "searchString": "довольное россия / новосибирская область / довольное"
  },
  "2666": {
    "id": "2666",
    "name": "Мишкино",
    "path": "Россия / Курганская область / Мишкино",
    "country": "Россия",
    "searchString": "мишкино россия / курганская область / мишкино"
  },
  "2667": {
    "id": "2667",
    "name": "Атяшево",
    "path": "Россия / Республика Мордовия / Атяшево",
    "country": "Россия",
    "searchString": "атяшево россия / республика мордовия / атяшево"
  },
  "2668": {
    "id": "2668",
    "name": "Думиничи",
    "path": "Россия / Калужская область / Думиничи",
    "country": "Россия",
    "searchString": "думиничи россия / калужская область / думиничи"
  },
  "2669": {
    "id": "2669",
    "name": "Республика Камерун",
    "path": "Другие регионы / Республика Камерун",
    "country": "Другие регионы",
    "searchString": "республика камерун другие регионы / республика камерун"
  },
  "2670": {
    "id": "2670",
    "name": "Бижбуляк",
    "path": "Россия / Республика Башкортостан / Бижбуляк",
    "country": "Россия",
    "searchString": "бижбуляк россия / республика башкортостан / бижбуляк"
  },
  "2671": {
    "id": "2671",
    "name": "Еткуль",
    "path": "Россия / Челябинская область / Еткуль",
    "country": "Россия",
    "searchString": "еткуль россия / челябинская область / еткуль"
  },
  "2672": {
    "id": "2672",
    "name": "Юргамыш",
    "path": "Россия / Курганская область / Юргамыш",
    "country": "Россия",
    "searchString": "юргамыш россия / курганская область / юргамыш"
  },
  "2673": {
    "id": "2673",
    "name": "Обухов",
    "path": "Украина / Киевская область / Обухов",
    "country": "Украина",
    "searchString": "обухов украина / киевская область / обухов"
  },
  "2674": {
    "id": "2674",
    "name": "Украинка",
    "path": "Украина / Киевская область / Украинка",
    "country": "Украина",
    "searchString": "украинка украина / киевская область / украинка"
  },
  "2675": {
    "id": "2675",
    "name": "Ржищев",
    "path": "Украина / Киевская область / Ржищев",
    "country": "Украина",
    "searchString": "ржищев украина / киевская область / ржищев"
  },
  "2676": {
    "id": "2676",
    "name": "Кагарлык",
    "path": "Украина / Киевская область / Кагарлык",
    "country": "Украина",
    "searchString": "кагарлык украина / киевская область / кагарлык"
  },
  "2677": {
    "id": "2677",
    "name": "Рогачево (Московская область)",
    "path": "Россия / Московская область / Рогачево (Московская область)",
    "country": "Россия",
    "searchString": "рогачево (московская область) россия / московская область / рогачево (московская область)"
  },
  "2678": {
    "id": "2678",
    "name": "Старовеличковская",
    "path": "Россия / Краснодарский край / Старовеличковская",
    "country": "Россия",
    "searchString": "старовеличковская россия / краснодарский край / старовеличковская"
  },
  "2679": {
    "id": "2679",
    "name": "Чишмы",
    "path": "Россия / Республика Башкортостан / Чишмы",
    "country": "Россия",
    "searchString": "чишмы россия / республика башкортостан / чишмы"
  },
  "2680": {
    "id": "2680",
    "name": "Приютово",
    "path": "Россия / Республика Башкортостан / Приютово",
    "country": "Россия",
    "searchString": "приютово россия / республика башкортостан / приютово"
  },
  "2681": {
    "id": "2681",
    "name": "Шушары",
    "path": "Россия / Ленинградская область / Шушары",
    "country": "Россия",
    "searchString": "шушары россия / ленинградская область / шушары"
  },
  "2682": {
    "id": "2682",
    "name": "Ульяновка (Ленинградская область)",
    "path": "Россия / Ленинградская область / Ульяновка (Ленинградская область)",
    "country": "Россия",
    "searchString": "ульяновка (ленинградская область) россия / ленинградская область / ульяновка (ленинградская область)"
  },
  "2683": {
    "id": "2683",
    "name": "Каргаполье",
    "path": "Россия / Курганская область / Каргаполье",
    "country": "Россия",
    "searchString": "каргаполье россия / курганская область / каргаполье"
  },
  "2684": {
    "id": "2684",
    "name": "Барда (Пермский край)",
    "path": "Россия / Пермский край / Барда (Пермский край)",
    "country": "Россия",
    "searchString": "барда (пермский край) россия / пермский край / барда (пермский край)"
  },
  "2685": {
    "id": "2685",
    "name": "Федоровский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Федоровский",
    "country": "Россия",
    "searchString": "федоровский россия / ханты-мансийский ао - югра / федоровский"
  },
  "2686": {
    "id": "2686",
    "name": "Излучинск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Излучинск",
    "country": "Россия",
    "searchString": "излучинск россия / ханты-мансийский ао - югра / излучинск"
  },
  "2687": {
    "id": "2687",
    "name": "Харп",
    "path": "Россия / Ямало-Ненецкий АО / Харп",
    "country": "Россия",
    "searchString": "харп россия / ямало-ненецкий ао / харп"
  },
  "2688": {
    "id": "2688",
    "name": "Уренгой",
    "path": "Россия / Ямало-Ненецкий АО / Уренгой",
    "country": "Россия",
    "searchString": "уренгой россия / ямало-ненецкий ао / уренгой"
  },
  "2689": {
    "id": "2689",
    "name": "Новотитаровская",
    "path": "Россия / Краснодарский край / Новотитаровская",
    "country": "Россия",
    "searchString": "новотитаровская россия / краснодарский край / новотитаровская"
  },
  "2690": {
    "id": "2690",
    "name": "Ванино",
    "path": "Россия / Хабаровский край / Ванино",
    "country": "Россия",
    "searchString": "ванино россия / хабаровский край / ванино"
  },
  "2691": {
    "id": "2691",
    "name": "Новая Чара",
    "path": "Россия / Забайкальский край / Новая Чара",
    "country": "Россия",
    "searchString": "новая чара россия / забайкальский край / новая чара"
  },
  "2692": {
    "id": "2692",
    "name": "Ставрово",
    "path": "Россия / Владимирская область / Ставрово",
    "country": "Россия",
    "searchString": "ставрово россия / владимирская область / ставрово"
  },
  "2693": {
    "id": "2693",
    "name": "Курсавка",
    "path": "Россия / Ставропольский край / Курсавка",
    "country": "Россия",
    "searchString": "курсавка россия / ставропольский край / курсавка"
  },
  "2694": {
    "id": "2694",
    "name": "Тбилисская",
    "path": "Россия / Краснодарский край / Тбилисская",
    "country": "Россия",
    "searchString": "тбилисская россия / краснодарский край / тбилисская"
  },
  "2695": {
    "id": "2695",
    "name": "Алексеевское",
    "path": "Россия / Республика Татарстан / Алексеевское",
    "country": "Россия",
    "searchString": "алексеевское россия / республика татарстан / алексеевское"
  },
  "2697": {
    "id": "2697",
    "name": "Нарышкино",
    "path": "Россия / Орловская область / Нарышкино",
    "country": "Россия",
    "searchString": "нарышкино россия / орловская область / нарышкино"
  },
  "2698": {
    "id": "2698",
    "name": "Алупка",
    "path": "Россия / Республика Крым / Алупка",
    "country": "Россия",
    "searchString": "алупка россия / республика крым / алупка"
  },
  "2699": {
    "id": "2699",
    "name": "Армянск",
    "path": "Россия / Республика Крым / Армянск",
    "country": "Россия",
    "searchString": "армянск россия / республика крым / армянск"
  },
  "2700": {
    "id": "2700",
    "name": "Бахчисарай",
    "path": "Россия / Республика Крым / Бахчисарай",
    "country": "Россия",
    "searchString": "бахчисарай россия / республика крым / бахчисарай"
  },
  "2701": {
    "id": "2701",
    "name": "Кировское (Республика Крым)",
    "path": "Россия / Республика Крым / Кировское (Республика Крым)",
    "country": "Россия",
    "searchString": "кировское (республика крым) россия / республика крым / кировское (республика крым)"
  },
  "2702": {
    "id": "2702",
    "name": "Ленино",
    "path": "Россия / Республика Крым / Ленино",
    "country": "Россия",
    "searchString": "ленино россия / республика крым / ленино"
  },
  "2703": {
    "id": "2703",
    "name": "Раздольное",
    "path": "Россия / Республика Крым / Раздольное",
    "country": "Россия",
    "searchString": "раздольное россия / республика крым / раздольное"
  },
  "2705": {
    "id": "2705",
    "name": "Старый Крым",
    "path": "Россия / Республика Крым / Старый Крым",
    "country": "Россия",
    "searchString": "старый крым россия / республика крым / старый крым"
  },
  "2707": {
    "id": "2707",
    "name": "Базарный Карабулак",
    "path": "Россия / Саратовская область / Базарный Карабулак",
    "country": "Россия",
    "searchString": "базарный карабулак россия / саратовская область / базарный карабулак"
  },
  "2708": {
    "id": "2708",
    "name": "Афипский",
    "path": "Россия / Краснодарский край / Афипский",
    "country": "Россия",
    "searchString": "афипский россия / краснодарский край / афипский"
  },
  "2709": {
    "id": "2709",
    "name": "Рудня (Волгоградская область)",
    "path": "Россия / Волгоградская область / Рудня (Волгоградская область)",
    "country": "Россия",
    "searchString": "рудня (волгоградская область) россия / волгоградская область / рудня (волгоградская область)"
  },
  "2710": {
    "id": "2710",
    "name": "Иловля",
    "path": "Россия / Волгоградская область / Иловля",
    "country": "Россия",
    "searchString": "иловля россия / волгоградская область / иловля"
  },
  "2711": {
    "id": "2711",
    "name": "Жашков",
    "path": "Украина / Черкасская область / Жашков",
    "country": "Украина",
    "searchString": "жашков украина / черкасская область / жашков"
  },
  "2712": {
    "id": "2712",
    "name": "Славута",
    "path": "Украина / Хмельницкая область / Славута",
    "country": "Украина",
    "searchString": "славута украина / хмельницкая область / славута"
  },
  "2713": {
    "id": "2713",
    "name": "Радомышль",
    "path": "Украина / Житомирская область / Радомышль",
    "country": "Украина",
    "searchString": "радомышль украина / житомирская область / радомышль"
  },
  "2714": {
    "id": "2714",
    "name": "Каменка-Бугская",
    "path": "Украина / Львовская область / Каменка-Бугская",
    "country": "Украина",
    "searchString": "каменка-бугская украина / львовская область / каменка-бугская"
  },
  "2715": {
    "id": "2715",
    "name": "Знаменка",
    "path": "Украина / Кировоградская область / Знаменка",
    "country": "Украина",
    "searchString": "знаменка украина / кировоградская область / знаменка"
  },
  "2716": {
    "id": "2716",
    "name": "Вольногорск",
    "path": "Украина / Днепропетровская область / Вольногорск",
    "country": "Украина",
    "searchString": "вольногорск украина / днепропетровская область / вольногорск"
  },
  "2717": {
    "id": "2717",
    "name": "Верхнеднепровск",
    "path": "Украина / Днепропетровская область / Верхнеднепровск",
    "country": "Украина",
    "searchString": "верхнеднепровск украина / днепропетровская область / верхнеднепровск"
  },
  "2718": {
    "id": "2718",
    "name": "Куйбышево",
    "path": "Россия / Запорожская область / Куйбышево",
    "country": "Россия",
    "searchString": "куйбышево россия / запорожская область / куйбышево"
  },
  "2719": {
    "id": "2719",
    "name": "Новониколаевка",
    "path": "Россия / Запорожская область / Новониколаевка",
    "country": "Россия",
    "searchString": "новониколаевка россия / запорожская область / новониколаевка"
  },
  "2720": {
    "id": "2720",
    "name": "Гуляйполе",
    "path": "Россия / Запорожская область / Гуляйполе",
    "country": "Россия",
    "searchString": "гуляйполе россия / запорожская область / гуляйполе"
  },
  "2721": {
    "id": "2721",
    "name": "Розовка",
    "path": "Россия / Запорожская область / Розовка",
    "country": "Россия",
    "searchString": "розовка россия / запорожская область / розовка"
  },
  "2722": {
    "id": "2722",
    "name": "Бережаны",
    "path": "Украина / Тернопольская область / Бережаны",
    "country": "Украина",
    "searchString": "бережаны украина / тернопольская область / бережаны"
  },
  "2723": {
    "id": "2723",
    "name": "Борщев",
    "path": "Украина / Тернопольская область / Борщев",
    "country": "Украина",
    "searchString": "борщев украина / тернопольская область / борщев"
  },
  "2724": {
    "id": "2724",
    "name": "Еланец",
    "path": "Украина / Николаевская область / Еланец",
    "country": "Украина",
    "searchString": "еланец украина / николаевская область / еланец"
  },
  "2725": {
    "id": "2725",
    "name": "Пестрецы",
    "path": "Россия / Республика Татарстан / Пестрецы",
    "country": "Россия",
    "searchString": "пестрецы россия / республика татарстан / пестрецы"
  },
  "2726": {
    "id": "2726",
    "name": "Камское Устье",
    "path": "Россия / Республика Татарстан / Камское Устье",
    "country": "Россия",
    "searchString": "камское устье россия / республика татарстан / камское устье"
  },
  "2727": {
    "id": "2727",
    "name": "Апастово",
    "path": "Россия / Республика Татарстан / Апастово",
    "country": "Россия",
    "searchString": "апастово россия / республика татарстан / апастово"
  },
  "2728": {
    "id": "2728",
    "name": "Акколь",
    "path": "Казахстан / Акколь",
    "country": "Казахстан",
    "searchString": "акколь казахстан / акколь"
  },
  "2729": {
    "id": "2729",
    "name": "Шу",
    "path": "Казахстан / Шу",
    "country": "Казахстан",
    "searchString": "шу казахстан / шу"
  },
  "2730": {
    "id": "2730",
    "name": "Доминиканская Республика",
    "path": "Другие регионы / Доминиканская Республика",
    "country": "Другие регионы",
    "searchString": "доминиканская республика другие регионы / доминиканская республика"
  },
  "2731": {
    "id": "2731",
    "name": "Красково  (Московская область)",
    "path": "Россия / Московская область / Красково  (Московская область)",
    "country": "Россия",
    "searchString": "красково  (московская область) россия / московская область / красково  (московская область)"
  },
  "2732": {
    "id": "2732",
    "name": "Суксун",
    "path": "Россия / Пермский край / Суксун",
    "country": "Россия",
    "searchString": "суксун россия / пермский край / суксун"
  },
  "2733": {
    "id": "2733",
    "name": "Заокский",
    "path": "Россия / Тульская область / Заокский",
    "country": "Россия",
    "searchString": "заокский россия / тульская область / заокский"
  },
  "2734": {
    "id": "2734",
    "name": "Иннополис",
    "path": "Россия / Республика Татарстан / Иннополис",
    "country": "Россия",
    "searchString": "иннополис россия / республика татарстан / иннополис"
  },
  "2735": {
    "id": "2735",
    "name": "Рефтинский",
    "path": "Россия / Свердловская область / Рефтинский",
    "country": "Россия",
    "searchString": "рефтинский россия / свердловская область / рефтинский"
  },
  "2736": {
    "id": "2736",
    "name": "Приволжский",
    "path": "Россия / Саратовская область / Приволжский",
    "country": "Россия",
    "searchString": "приволжский россия / саратовская область / приволжский"
  },
  "2737": {
    "id": "2737",
    "name": "Щёлкино",
    "path": "Россия / Республика Крым / Щёлкино",
    "country": "Россия",
    "searchString": "щёлкино россия / республика крым / щёлкино"
  },
  "2738": {
    "id": "2738",
    "name": "Нижнегорский",
    "path": "Россия / Республика Крым / Нижнегорский",
    "country": "Россия",
    "searchString": "нижнегорский россия / республика крым / нижнегорский"
  },
  "2739": {
    "id": "2739",
    "name": "Советский (Республика Крым)",
    "path": "Россия / Республика Крым / Советский (Республика Крым)",
    "country": "Россия",
    "searchString": "советский (республика крым) россия / республика крым / советский (республика крым)"
  },
  "2740": {
    "id": "2740",
    "name": "Большая Берестовица",
    "path": "Беларусь / Гродненская область / Большая Берестовица",
    "country": "Беларусь",
    "searchString": "большая берестовица беларусь / гродненская область / большая берестовица"
  },
  "2741": {
    "id": "2741",
    "name": "Давид-Городок",
    "path": "Беларусь / Брестская область / Давид-Городок",
    "country": "Беларусь",
    "searchString": "давид-городок беларусь / брестская область / давид-городок"
  },
  "2742": {
    "id": "2742",
    "name": "Дисна",
    "path": "Беларусь / Витебская область / Дисна",
    "country": "Беларусь",
    "searchString": "дисна беларусь / витебская область / дисна"
  },
  "2743": {
    "id": "2743",
    "name": "Иваново (Брестская область)",
    "path": "Беларусь / Брестская область / Иваново (Брестская область)",
    "country": "Беларусь",
    "searchString": "иваново (брестская область) беларусь / брестская область / иваново (брестская область)"
  },
  "2744": {
    "id": "2744",
    "name": "Кировск (Могилевская область)",
    "path": "Беларусь / Могилевская область / Кировск (Могилевская область)",
    "country": "Беларусь",
    "searchString": "кировск (могилевская область) беларусь / могилевская область / кировск (могилевская область)"
  },
  "2745": {
    "id": "2745",
    "name": "Коссово",
    "path": "Беларусь / Брестская область / Коссово",
    "country": "Беларусь",
    "searchString": "коссово беларусь / брестская область / коссово"
  },
  "2746": {
    "id": "2746",
    "name": "Любань",
    "path": "Беларусь / Минская область / Любань",
    "country": "Беларусь",
    "searchString": "любань беларусь / минская область / любань"
  },
  "2747": {
    "id": "2747",
    "name": "Октябрьский (Гомельская область)",
    "path": "Беларусь / Гомельская область / Октябрьский (Гомельская область)",
    "country": "Беларусь",
    "searchString": "октябрьский (гомельская область) беларусь / гомельская область / октябрьский (гомельская область)"
  },
  "2748": {
    "id": "2748",
    "name": "Славгород",
    "path": "Беларусь / Могилевская область / Славгород",
    "country": "Беларусь",
    "searchString": "славгород беларусь / могилевская область / славгород"
  },
  "2749": {
    "id": "2749",
    "name": "Старые Дороги",
    "path": "Беларусь / Минская область / Старые Дороги",
    "country": "Беларусь",
    "searchString": "старые дороги беларусь / минская область / старые дороги"
  },
  "2750": {
    "id": "2750",
    "name": "Петергоф",
    "path": "Россия / Ленинградская область / Петергоф",
    "country": "Россия",
    "searchString": "петергоф россия / ленинградская область / петергоф"
  },
  "2751": {
    "id": "2751",
    "name": "Оболенск (Московская область)",
    "path": "Россия / Московская область / Оболенск (Московская область)",
    "country": "Россия",
    "searchString": "оболенск (московская область) россия / московская область / оболенск (московская область)"
  },
  "2752": {
    "id": "2752",
    "name": "Республика Бенин",
    "path": "Другие регионы / Республика Бенин",
    "country": "Другие регионы",
    "searchString": "республика бенин другие регионы / республика бенин"
  },
  "2753": {
    "id": "2753",
    "name": "Энем",
    "path": "Россия / Республика Адыгея / Энем",
    "country": "Россия",
    "searchString": "энем россия / республика адыгея / энем"
  },
  "2754": {
    "id": "2754",
    "name": "Архипо-Осиповка",
    "path": "Россия / Краснодарский край / Архипо-Осиповка",
    "country": "Россия",
    "searchString": "архипо-осиповка россия / краснодарский край / архипо-осиповка"
  },
  "2755": {
    "id": "2755",
    "name": "Серебрянск",
    "path": "Казахстан / Серебрянск",
    "country": "Казахстан",
    "searchString": "серебрянск казахстан / серебрянск"
  },
  "2756": {
    "id": "2756",
    "name": "Себеж",
    "path": "Россия / Псковская область / Себеж",
    "country": "Россия",
    "searchString": "себеж россия / псковская область / себеж"
  },
  "2757": {
    "id": "2757",
    "name": "Колпна",
    "path": "Россия / Орловская область / Колпна",
    "country": "Россия",
    "searchString": "колпна россия / орловская область / колпна"
  },
  "2758": {
    "id": "2758",
    "name": "Тбилиси",
    "path": "Грузия / Тбилиси",
    "country": "Грузия",
    "searchString": "тбилиси грузия / тбилиси"
  },
  "2759": {
    "id": "2759",
    "name": "Ташкент",
    "path": "Узбекистан / Ташкент",
    "country": "Узбекистан",
    "searchString": "ташкент узбекистан / ташкент"
  },
  "2760": {
    "id": "2760",
    "name": "Бишкек",
    "path": "Кыргызстан / Бишкек",
    "country": "Кыргызстан",
    "searchString": "бишкек кыргызстан / бишкек"
  },
  "2761": {
    "id": "2761",
    "name": "Селятино (Московская область)",
    "path": "Россия / Московская область / Селятино (Московская область)",
    "country": "Россия",
    "searchString": "селятино (московская область) россия / московская область / селятино (московская область)"
  },
  "2762": {
    "id": "2762",
    "name": "Безенчук",
    "path": "Россия / Самарская область / Безенчук",
    "country": "Россия",
    "searchString": "безенчук россия / самарская область / безенчук"
  },
  "2763": {
    "id": "2763",
    "name": "Аккурган",
    "path": "Узбекистан / Аккурган",
    "country": "Узбекистан",
    "searchString": "аккурган узбекистан / аккурган"
  },
  "2764": {
    "id": "2764",
    "name": "Акташ (Узбекистан)",
    "path": "Узбекистан / Акташ (Узбекистан)",
    "country": "Узбекистан",
    "searchString": "акташ (узбекистан) узбекистан / акташ (узбекистан)"
  },
  "2765": {
    "id": "2765",
    "name": "Алат (Узбекистан)",
    "path": "Узбекистан / Алат (Узбекистан)",
    "country": "Узбекистан",
    "searchString": "алат (узбекистан) узбекистан / алат (узбекистан)"
  },
  "2766": {
    "id": "2766",
    "name": "Алмалык",
    "path": "Узбекистан / Алмалык",
    "country": "Узбекистан",
    "searchString": "алмалык узбекистан / алмалык"
  },
  "2767": {
    "id": "2767",
    "name": "Ангрен",
    "path": "Узбекистан / Ангрен",
    "country": "Узбекистан",
    "searchString": "ангрен узбекистан / ангрен"
  },
  "2768": {
    "id": "2768",
    "name": "Андижан",
    "path": "Узбекистан / Андижан",
    "country": "Узбекистан",
    "searchString": "андижан узбекистан / андижан"
  },
  "2769": {
    "id": "2769",
    "name": "Асака",
    "path": "Узбекистан / Асака",
    "country": "Узбекистан",
    "searchString": "асака узбекистан / асака"
  },
  "2770": {
    "id": "2770",
    "name": "Ахангаран",
    "path": "Узбекистан / Ахангаран",
    "country": "Узбекистан",
    "searchString": "ахангаран узбекистан / ахангаран"
  },
  "2771": {
    "id": "2771",
    "name": "Ахунбабаев",
    "path": "Узбекистан / Ахунбабаев",
    "country": "Узбекистан",
    "searchString": "ахунбабаев узбекистан / ахунбабаев"
  },
  "2772": {
    "id": "2772",
    "name": "Байсун",
    "path": "Узбекистан / Байсун",
    "country": "Узбекистан",
    "searchString": "байсун узбекистан / байсун"
  },
  "2773": {
    "id": "2773",
    "name": "Бахт",
    "path": "Узбекистан / Бахт",
    "country": "Узбекистан",
    "searchString": "бахт узбекистан / бахт"
  },
  "2774": {
    "id": "2774",
    "name": "Бекабад",
    "path": "Узбекистан / Бекабад",
    "country": "Узбекистан",
    "searchString": "бекабад узбекистан / бекабад"
  },
  "2775": {
    "id": "2775",
    "name": "Беруни",
    "path": "Узбекистан / Беруни",
    "country": "Узбекистан",
    "searchString": "беруни узбекистан / беруни"
  },
  "2776": {
    "id": "2776",
    "name": "Бешарык",
    "path": "Узбекистан / Бешарык",
    "country": "Узбекистан",
    "searchString": "бешарык узбекистан / бешарык"
  },
  "2777": {
    "id": "2777",
    "name": "Бешкент",
    "path": "Узбекистан / Бешкент",
    "country": "Узбекистан",
    "searchString": "бешкент узбекистан / бешкент"
  },
  "2778": {
    "id": "2778",
    "name": "Самарканд",
    "path": "Узбекистан / Самарканд",
    "country": "Узбекистан",
    "searchString": "самарканд узбекистан / самарканд"
  },
  "2779": {
    "id": "2779",
    "name": "Наманган",
    "path": "Узбекистан / Наманган",
    "country": "Узбекистан",
    "searchString": "наманган узбекистан / наманган"
  },
  "2780": {
    "id": "2780",
    "name": "Нукус",
    "path": "Узбекистан / Нукус",
    "country": "Узбекистан",
    "searchString": "нукус узбекистан / нукус"
  },
  "2781": {
    "id": "2781",
    "name": "Бухара",
    "path": "Узбекистан / Бухара",
    "country": "Узбекистан",
    "searchString": "бухара узбекистан / бухара"
  },
  "2782": {
    "id": "2782",
    "name": "Фергана",
    "path": "Узбекистан / Фергана",
    "country": "Узбекистан",
    "searchString": "фергана узбекистан / фергана"
  },
  "2783": {
    "id": "2783",
    "name": "Карши",
    "path": "Узбекистан / Карши",
    "country": "Узбекистан",
    "searchString": "карши узбекистан / карши"
  },
  "2784": {
    "id": "2784",
    "name": "Коканд",
    "path": "Узбекистан / Коканд",
    "country": "Узбекистан",
    "searchString": "коканд узбекистан / коканд"
  },
  "2785": {
    "id": "2785",
    "name": "Маргилан",
    "path": "Узбекистан / Маргилан",
    "country": "Узбекистан",
    "searchString": "маргилан узбекистан / маргилан"
  },
  "2786": {
    "id": "2786",
    "name": "Джизак",
    "path": "Узбекистан / Джизак",
    "country": "Узбекистан",
    "searchString": "джизак узбекистан / джизак"
  },
  "2787": {
    "id": "2787",
    "name": "Чирчик",
    "path": "Узбекистан / Чирчик",
    "country": "Узбекистан",
    "searchString": "чирчик узбекистан / чирчик"
  },
  "2788": {
    "id": "2788",
    "name": "Ургенч",
    "path": "Узбекистан / Ургенч",
    "country": "Узбекистан",
    "searchString": "ургенч узбекистан / ургенч"
  },
  "2789": {
    "id": "2789",
    "name": "Термез",
    "path": "Узбекистан / Термез",
    "country": "Узбекистан",
    "searchString": "термез узбекистан / термез"
  },
  "2790": {
    "id": "2790",
    "name": "Навои",
    "path": "Узбекистан / Навои",
    "country": "Узбекистан",
    "searchString": "навои узбекистан / навои"
  },
  "2791": {
    "id": "2791",
    "name": "Шахрисабз",
    "path": "Узбекистан / Шахрисабз",
    "country": "Узбекистан",
    "searchString": "шахрисабз узбекистан / шахрисабз"
  },
  "2792": {
    "id": "2792",
    "name": "Каракол",
    "path": "Кыргызстан / Каракол",
    "country": "Кыргызстан",
    "searchString": "каракол кыргызстан / каракол"
  },
  "2793": {
    "id": "2793",
    "name": "Талас",
    "path": "Кыргызстан / Талас",
    "country": "Кыргызстан",
    "searchString": "талас кыргызстан / талас"
  },
  "2794": {
    "id": "2794",
    "name": "Нарын",
    "path": "Кыргызстан / Нарын",
    "country": "Кыргызстан",
    "searchString": "нарын кыргызстан / нарын"
  },
  "2795": {
    "id": "2795",
    "name": "Джалал-Абад",
    "path": "Кыргызстан / Джалал-Абад",
    "country": "Кыргызстан",
    "searchString": "джалал-абад кыргызстан / джалал-абад"
  },
  "2796": {
    "id": "2796",
    "name": "Ош",
    "path": "Кыргызстан / Ош",
    "country": "Кыргызстан",
    "searchString": "ош кыргызстан / ош"
  },
  "2797": {
    "id": "2797",
    "name": "Баткен",
    "path": "Кыргызстан / Баткен",
    "country": "Кыргызстан",
    "searchString": "баткен кыргызстан / баткен"
  },
  "2798": {
    "id": "2798",
    "name": "Мальдивская Республика",
    "path": "Другие регионы / Мальдивская Республика",
    "country": "Другие регионы",
    "searchString": "мальдивская республика другие регионы / мальдивская республика"
  },
  "2799": {
    "id": "2799",
    "name": "Бондари",
    "path": "Россия / Тамбовская область / Бондари",
    "country": "Россия",
    "searchString": "бондари россия / тамбовская область / бондари"
  },
  "2800": {
    "id": "2800",
    "name": "Верховье",
    "path": "Россия / Орловская область / Верховье",
    "country": "Россия",
    "searchString": "верховье россия / орловская область / верховье"
  },
  "2801": {
    "id": "2801",
    "name": "Вольгинский",
    "path": "Россия / Владимирская область / Вольгинский",
    "country": "Россия",
    "searchString": "вольгинский россия / владимирская область / вольгинский"
  },
  "2802": {
    "id": "2802",
    "name": "Глазуновка",
    "path": "Россия / Орловская область / Глазуновка",
    "country": "Россия",
    "searchString": "глазуновка россия / орловская область / глазуновка"
  },
  "2803": {
    "id": "2803",
    "name": "Инжавино",
    "path": "Россия / Тамбовская область / Инжавино",
    "country": "Россия",
    "searchString": "инжавино россия / тамбовская область / инжавино"
  },
  "2804": {
    "id": "2804",
    "name": "Первомайский (Тамбовская область)",
    "path": "Россия / Тамбовская область / Первомайский (Тамбовская область)",
    "country": "Россия",
    "searchString": "первомайский (тамбовская область) россия / тамбовская область / первомайский (тамбовская область)"
  },
  "2805": {
    "id": "2805",
    "name": "Красная Поляна",
    "path": "Россия / Краснодарский край / Красная Поляна",
    "country": "Россия",
    "searchString": "красная поляна россия / краснодарский край / красная поляна"
  },
  "2806": {
    "id": "2806",
    "name": "Коноша",
    "path": "Россия / Архангельская область / Коноша",
    "country": "Россия",
    "searchString": "коноша россия / архангельская область / коноша"
  },
  "2807": {
    "id": "2807",
    "name": "Хачмаз",
    "path": "Азербайджан / Хачмаз",
    "country": "Азербайджан",
    "searchString": "хачмаз азербайджан / хачмаз"
  },
  "2808": {
    "id": "2808",
    "name": "Сонково",
    "path": "Россия / Тверская область / Сонково",
    "country": "Россия",
    "searchString": "сонково россия / тверская область / сонково"
  },
  "2809": {
    "id": "2809",
    "name": "Егорлыкская",
    "path": "Россия / Ростовская область / Егорлыкская",
    "country": "Россия",
    "searchString": "егорлыкская россия / ростовская область / егорлыкская"
  },
  "2810": {
    "id": "2810",
    "name": "Уругвай",
    "path": "Другие регионы / Уругвай",
    "country": "Другие регионы",
    "searchString": "уругвай другие регионы / уругвай"
  },
  "2811": {
    "id": "2811",
    "name": "Голышманово",
    "path": "Россия / Тюменская область / Голышманово",
    "country": "Россия",
    "searchString": "голышманово россия / тюменская область / голышманово"
  },
  "2812": {
    "id": "2812",
    "name": "Ферзиково",
    "path": "Россия / Калужская область / Ферзиково",
    "country": "Россия",
    "searchString": "ферзиково россия / калужская область / ферзиково"
  },
  "2813": {
    "id": "2813",
    "name": "Кутаиси",
    "path": "Грузия / Кутаиси",
    "country": "Грузия",
    "searchString": "кутаиси грузия / кутаиси"
  },
  "2814": {
    "id": "2814",
    "name": "Батуми",
    "path": "Грузия / Батуми",
    "country": "Грузия",
    "searchString": "батуми грузия / батуми"
  },
  "2815": {
    "id": "2815",
    "name": "Рустави",
    "path": "Грузия / Рустави",
    "country": "Грузия",
    "searchString": "рустави грузия / рустави"
  },
  "2816": {
    "id": "2816",
    "name": "Евлах",
    "path": "Азербайджан / Евлах",
    "country": "Азербайджан",
    "searchString": "евлах азербайджан / евлах"
  },
  "2817": {
    "id": "2817",
    "name": "Тацинская",
    "path": "Россия / Ростовская область / Тацинская",
    "country": "Россия",
    "searchString": "тацинская россия / ростовская область / тацинская"
  },
  "2818": {
    "id": "2818",
    "name": "Вербилки (Московская область)",
    "path": "Россия / Московская область / Вербилки (Московская область)",
    "country": "Россия",
    "searchString": "вербилки (московская область) россия / московская область / вербилки (московская область)"
  },
  "2819": {
    "id": "2819",
    "name": "Надвоицы",
    "path": "Россия / Республика Карелия / Надвоицы",
    "country": "Россия",
    "searchString": "надвоицы россия / республика карелия / надвоицы"
  },
  "2820": {
    "id": "2820",
    "name": "Ахалцихе",
    "path": "Грузия / Ахалцихе",
    "country": "Грузия",
    "searchString": "ахалцихе грузия / ахалцихе"
  },
  "2821": {
    "id": "2821",
    "name": "Болниси",
    "path": "Грузия / Болниси",
    "country": "Грузия",
    "searchString": "болниси грузия / болниси"
  },
  "2822": {
    "id": "2822",
    "name": "Боржоми",
    "path": "Грузия / Боржоми",
    "country": "Грузия",
    "searchString": "боржоми грузия / боржоми"
  },
  "2823": {
    "id": "2823",
    "name": "Гардабани",
    "path": "Грузия / Гардабани",
    "country": "Грузия",
    "searchString": "гардабани грузия / гардабани"
  },
  "2824": {
    "id": "2824",
    "name": "Гори",
    "path": "Грузия / Гори",
    "country": "Грузия",
    "searchString": "гори грузия / гори"
  },
  "2825": {
    "id": "2825",
    "name": "Зестафони",
    "path": "Грузия / Зестафони",
    "country": "Грузия",
    "searchString": "зестафони грузия / зестафони"
  },
  "2826": {
    "id": "2826",
    "name": "Зугдиди",
    "path": "Грузия / Зугдиди",
    "country": "Грузия",
    "searchString": "зугдиди грузия / зугдиди"
  },
  "2827": {
    "id": "2827",
    "name": "Каспи",
    "path": "Грузия / Каспи",
    "country": "Грузия",
    "searchString": "каспи грузия / каспи"
  },
  "2828": {
    "id": "2828",
    "name": "Кобулети",
    "path": "Грузия / Кобулети",
    "country": "Грузия",
    "searchString": "кобулети грузия / кобулети"
  },
  "2829": {
    "id": "2829",
    "name": "Марнеули",
    "path": "Грузия / Марнеули",
    "country": "Грузия",
    "searchString": "марнеули грузия / марнеули"
  },
  "2830": {
    "id": "2830",
    "name": "Мцхета",
    "path": "Грузия / Мцхета",
    "country": "Грузия",
    "searchString": "мцхета грузия / мцхета"
  },
  "2831": {
    "id": "2831",
    "name": "Озургети",
    "path": "Грузия / Озургети",
    "country": "Грузия",
    "searchString": "озургети грузия / озургети"
  },
  "2832": {
    "id": "2832",
    "name": "Поти",
    "path": "Грузия / Поти",
    "country": "Грузия",
    "searchString": "поти грузия / поти"
  },
  "2833": {
    "id": "2833",
    "name": "Сагареджо",
    "path": "Грузия / Сагареджо",
    "country": "Грузия",
    "searchString": "сагареджо грузия / сагареджо"
  },
  "2834": {
    "id": "2834",
    "name": "Самтредиа",
    "path": "Грузия / Самтредиа",
    "country": "Грузия",
    "searchString": "самтредиа грузия / самтредиа"
  },
  "2835": {
    "id": "2835",
    "name": "Сенаки",
    "path": "Грузия / Сенаки",
    "country": "Грузия",
    "searchString": "сенаки грузия / сенаки"
  },
  "2836": {
    "id": "2836",
    "name": "Телави",
    "path": "Грузия / Телави",
    "country": "Грузия",
    "searchString": "телави грузия / телави"
  },
  "2837": {
    "id": "2837",
    "name": "Ткибули",
    "path": "Грузия / Ткибули",
    "country": "Грузия",
    "searchString": "ткибули грузия / ткибули"
  },
  "2838": {
    "id": "2838",
    "name": "Хашури",
    "path": "Грузия / Хашури",
    "country": "Грузия",
    "searchString": "хашури грузия / хашури"
  },
  "2839": {
    "id": "2839",
    "name": "Хони",
    "path": "Грузия / Хони",
    "country": "Грузия",
    "searchString": "хони грузия / хони"
  },
  "2840": {
    "id": "2840",
    "name": "Цхалтубо",
    "path": "Грузия / Цхалтубо",
    "country": "Грузия",
    "searchString": "цхалтубо грузия / цхалтубо"
  },
  "2841": {
    "id": "2841",
    "name": "Чиатура",
    "path": "Грузия / Чиатура",
    "country": "Грузия",
    "searchString": "чиатура грузия / чиатура"
  },
  "2842": {
    "id": "2842",
    "name": "Балыкчы",
    "path": "Кыргызстан / Балыкчы",
    "country": "Кыргызстан",
    "searchString": "балыкчы кыргызстан / балыкчы"
  },
  "2843": {
    "id": "2843",
    "name": "Исфана",
    "path": "Кыргызстан / Исфана",
    "country": "Кыргызстан",
    "searchString": "исфана кыргызстан / исфана"
  },
  "2844": {
    "id": "2844",
    "name": "Кант",
    "path": "Кыргызстан / Кант",
    "country": "Кыргызстан",
    "searchString": "кант кыргызстан / кант"
  },
  "2845": {
    "id": "2845",
    "name": "Кара-Балта",
    "path": "Кыргызстан / Кара-Балта",
    "country": "Кыргызстан",
    "searchString": "кара-балта кыргызстан / кара-балта"
  },
  "2846": {
    "id": "2846",
    "name": "Кара-Куль",
    "path": "Кыргызстан / Кара-Куль",
    "country": "Кыргызстан",
    "searchString": "кара-куль кыргызстан / кара-куль"
  },
  "2847": {
    "id": "2847",
    "name": "Кара-Суу",
    "path": "Кыргызстан / Кара-Суу",
    "country": "Кыргызстан",
    "searchString": "кара-суу кыргызстан / кара-суу"
  },
  "2848": {
    "id": "2848",
    "name": "Кербен",
    "path": "Кыргызстан / Кербен",
    "country": "Кыргызстан",
    "searchString": "кербен кыргызстан / кербен"
  },
  "2849": {
    "id": "2849",
    "name": "Кочкор-Ата",
    "path": "Кыргызстан / Кочкор-Ата",
    "country": "Кыргызстан",
    "searchString": "кочкор-ата кыргызстан / кочкор-ата"
  },
  "2850": {
    "id": "2850",
    "name": "Кызыл-Кия",
    "path": "Кыргызстан / Кызыл-Кия",
    "country": "Кыргызстан",
    "searchString": "кызыл-кия кыргызстан / кызыл-кия"
  },
  "2851": {
    "id": "2851",
    "name": "Майлуу-Суу",
    "path": "Кыргызстан / Майлуу-Суу",
    "country": "Кыргызстан",
    "searchString": "майлуу-суу кыргызстан / майлуу-суу"
  },
  "2852": {
    "id": "2852",
    "name": "Ноокат",
    "path": "Кыргызстан / Ноокат",
    "country": "Кыргызстан",
    "searchString": "ноокат кыргызстан / ноокат"
  },
  "2853": {
    "id": "2853",
    "name": "Сулюкта",
    "path": "Кыргызстан / Сулюкта",
    "country": "Кыргызстан",
    "searchString": "сулюкта кыргызстан / сулюкта"
  },
  "2854": {
    "id": "2854",
    "name": "Таш-Кумыр",
    "path": "Кыргызстан / Таш-Кумыр",
    "country": "Кыргызстан",
    "searchString": "таш-кумыр кыргызстан / таш-кумыр"
  },
  "2855": {
    "id": "2855",
    "name": "Токмок",
    "path": "Кыргызстан / Токмок",
    "country": "Кыргызстан",
    "searchString": "токмок кыргызстан / токмок"
  },
  "2856": {
    "id": "2856",
    "name": "Токтогул",
    "path": "Кыргызстан / Токтогул",
    "country": "Кыргызстан",
    "searchString": "токтогул кыргызстан / токтогул"
  },
  "2857": {
    "id": "2857",
    "name": "Узген",
    "path": "Кыргызстан / Узген",
    "country": "Кыргызстан",
    "searchString": "узген кыргызстан / узген"
  },
  "2858": {
    "id": "2858",
    "name": "Чолпон-Ата",
    "path": "Кыргызстан / Чолпон-Ата",
    "country": "Кыргызстан",
    "searchString": "чолпон-ата кыргызстан / чолпон-ата"
  },
  "2859": {
    "id": "2859",
    "name": "Бука",
    "path": "Узбекистан / Бука",
    "country": "Узбекистан",
    "searchString": "бука узбекистан / бука"
  },
  "2860": {
    "id": "2860",
    "name": "Булунгур",
    "path": "Узбекистан / Булунгур",
    "country": "Узбекистан",
    "searchString": "булунгур узбекистан / булунгур"
  },
  "2861": {
    "id": "2861",
    "name": "Бустан",
    "path": "Узбекистан / Бустан",
    "country": "Узбекистан",
    "searchString": "бустан узбекистан / бустан"
  },
  "2862": {
    "id": "2862",
    "name": "Вабкент",
    "path": "Узбекистан / Вабкент",
    "country": "Узбекистан",
    "searchString": "вабкент узбекистан / вабкент"
  },
  "2863": {
    "id": "2863",
    "name": "Гагарин (Узбекистан)",
    "path": "Узбекистан / Гагарин (Узбекистан)",
    "country": "Узбекистан",
    "searchString": "гагарин (узбекистан) узбекистан / гагарин (узбекистан)"
  },
  "2864": {
    "id": "2864",
    "name": "Газалкент",
    "path": "Узбекистан / Газалкент",
    "country": "Узбекистан",
    "searchString": "газалкент узбекистан / газалкент"
  },
  "2865": {
    "id": "2865",
    "name": "Газли",
    "path": "Узбекистан / Газли",
    "country": "Узбекистан",
    "searchString": "газли узбекистан / газли"
  },
  "2866": {
    "id": "2866",
    "name": "Галаасия",
    "path": "Узбекистан / Галаасия",
    "country": "Узбекистан",
    "searchString": "галаасия узбекистан / галаасия"
  },
  "2867": {
    "id": "2867",
    "name": "Галляарал",
    "path": "Узбекистан / Галляарал",
    "country": "Узбекистан",
    "searchString": "галляарал узбекистан / галляарал"
  },
  "2868": {
    "id": "2868",
    "name": "Гиждуван",
    "path": "Узбекистан / Гиждуван",
    "country": "Узбекистан",
    "searchString": "гиждуван узбекистан / гиждуван"
  },
  "2869": {
    "id": "2869",
    "name": "Гузар",
    "path": "Узбекистан / Гузар",
    "country": "Узбекистан",
    "searchString": "гузар узбекистан / гузар"
  },
  "2870": {
    "id": "2870",
    "name": "Гулистан",
    "path": "Узбекистан / Гулистан",
    "country": "Узбекистан",
    "searchString": "гулистан узбекистан / гулистан"
  },
  "2871": {
    "id": "2871",
    "name": "Даштабад",
    "path": "Узбекистан / Даштабад",
    "country": "Узбекистан",
    "searchString": "даштабад узбекистан / даштабад"
  },
  "2872": {
    "id": "2872",
    "name": "Денау",
    "path": "Узбекистан / Денау",
    "country": "Узбекистан",
    "searchString": "денау узбекистан / денау"
  },
  "2873": {
    "id": "2873",
    "name": "Джамбай",
    "path": "Узбекистан / Джамбай",
    "country": "Узбекистан",
    "searchString": "джамбай узбекистан / джамбай"
  },
  "2874": {
    "id": "2874",
    "name": "Джаркурган",
    "path": "Узбекистан / Джаркурган",
    "country": "Узбекистан",
    "searchString": "джаркурган узбекистан / джаркурган"
  },
  "2875": {
    "id": "2875",
    "name": "Джума",
    "path": "Узбекистан / Джума",
    "country": "Узбекистан",
    "searchString": "джума узбекистан / джума"
  },
  "2876": {
    "id": "2876",
    "name": "Дустабад",
    "path": "Узбекистан / Дустабад",
    "country": "Узбекистан",
    "searchString": "дустабад узбекистан / дустабад"
  },
  "2877": {
    "id": "2877",
    "name": "Дустлик",
    "path": "Узбекистан / Дустлик",
    "country": "Узбекистан",
    "searchString": "дустлик узбекистан / дустлик"
  },
  "2878": {
    "id": "2878",
    "name": "Зарафшан",
    "path": "Узбекистан / Зарафшан",
    "country": "Узбекистан",
    "searchString": "зарафшан узбекистан / зарафшан"
  },
  "2879": {
    "id": "2879",
    "name": "Иштыхан",
    "path": "Узбекистан / Иштыхан",
    "country": "Узбекистан",
    "searchString": "иштыхан узбекистан / иштыхан"
  },
  "2880": {
    "id": "2880",
    "name": "Каган",
    "path": "Узбекистан / Каган",
    "country": "Узбекистан",
    "searchString": "каган узбекистан / каган"
  },
  "2881": {
    "id": "2881",
    "name": "Камаши",
    "path": "Узбекистан / Камаши",
    "country": "Узбекистан",
    "searchString": "камаши узбекистан / камаши"
  },
  "2882": {
    "id": "2882",
    "name": "Каракуль",
    "path": "Узбекистан / Каракуль",
    "country": "Узбекистан",
    "searchString": "каракуль узбекистан / каракуль"
  },
  "2883": {
    "id": "2883",
    "name": "Карасу",
    "path": "Узбекистан / Карасу",
    "country": "Узбекистан",
    "searchString": "карасу узбекистан / карасу"
  },
  "2884": {
    "id": "2884",
    "name": "Касан",
    "path": "Узбекистан / Касан",
    "country": "Узбекистан",
    "searchString": "касан узбекистан / касан"
  },
  "2885": {
    "id": "2885",
    "name": "Касансай",
    "path": "Узбекистан / Касансай",
    "country": "Узбекистан",
    "searchString": "касансай узбекистан / касансай"
  },
  "2886": {
    "id": "2886",
    "name": "Каттакурган",
    "path": "Узбекистан / Каттакурган",
    "country": "Узбекистан",
    "searchString": "каттакурган узбекистан / каттакурган"
  },
  "2887": {
    "id": "2887",
    "name": "Келес",
    "path": "Узбекистан / Келес",
    "country": "Узбекистан",
    "searchString": "келес узбекистан / келес"
  },
  "2888": {
    "id": "2888",
    "name": "Китаб",
    "path": "Узбекистан / Китаб",
    "country": "Узбекистан",
    "searchString": "китаб узбекистан / китаб"
  },
  "2889": {
    "id": "2889",
    "name": "Кува",
    "path": "Узбекистан / Кува",
    "country": "Узбекистан",
    "searchString": "кува узбекистан / кува"
  },
  "2890": {
    "id": "2890",
    "name": "Кувасай",
    "path": "Узбекистан / Кувасай",
    "country": "Узбекистан",
    "searchString": "кувасай узбекистан / кувасай"
  },
  "2891": {
    "id": "2891",
    "name": "Кумкурган",
    "path": "Узбекистан / Кумкурган",
    "country": "Узбекистан",
    "searchString": "кумкурган узбекистан / кумкурган"
  },
  "2892": {
    "id": "2892",
    "name": "Кунград",
    "path": "Узбекистан / Кунград",
    "country": "Узбекистан",
    "searchString": "кунград узбекистан / кунград"
  },
  "2893": {
    "id": "2893",
    "name": "Кургантепа",
    "path": "Узбекистан / Кургантепа",
    "country": "Узбекистан",
    "searchString": "кургантепа узбекистан / кургантепа"
  },
  "2894": {
    "id": "2894",
    "name": "Кызылтепа",
    "path": "Узбекистан / Кызылтепа",
    "country": "Узбекистан",
    "searchString": "кызылтепа узбекистан / кызылтепа"
  },
  "2895": {
    "id": "2895",
    "name": "Мангит",
    "path": "Узбекистан / Мангит",
    "country": "Узбекистан",
    "searchString": "мангит узбекистан / мангит"
  },
  "2896": {
    "id": "2896",
    "name": "Мархамат",
    "path": "Узбекистан / Мархамат",
    "country": "Узбекистан",
    "searchString": "мархамат узбекистан / мархамат"
  },
  "2897": {
    "id": "2897",
    "name": "Мубарек",
    "path": "Узбекистан / Мубарек",
    "country": "Узбекистан",
    "searchString": "мубарек узбекистан / мубарек"
  },
  "2898": {
    "id": "2898",
    "name": "Муйнак",
    "path": "Узбекистан / Муйнак",
    "country": "Узбекистан",
    "searchString": "муйнак узбекистан / муйнак"
  },
  "2899": {
    "id": "2899",
    "name": "Нурабад",
    "path": "Узбекистан / Нурабад",
    "country": "Узбекистан",
    "searchString": "нурабад узбекистан / нурабад"
  },
  "2900": {
    "id": "2900",
    "name": "Нурата",
    "path": "Узбекистан / Нурата",
    "country": "Узбекистан",
    "searchString": "нурата узбекистан / нурата"
  },
  "2901": {
    "id": "2901",
    "name": "Пайарык",
    "path": "Узбекистан / Пайарык",
    "country": "Узбекистан",
    "searchString": "пайарык узбекистан / пайарык"
  },
  "2902": {
    "id": "2902",
    "name": "Пайтуг",
    "path": "Узбекистан / Пайтуг",
    "country": "Узбекистан",
    "searchString": "пайтуг узбекистан / пайтуг"
  },
  "2903": {
    "id": "2903",
    "name": "Пап",
    "path": "Узбекистан / Пап",
    "country": "Узбекистан",
    "searchString": "пап узбекистан / пап"
  },
  "2904": {
    "id": "2904",
    "name": "Паркент",
    "path": "Узбекистан / Паркент",
    "country": "Узбекистан",
    "searchString": "паркент узбекистан / паркент"
  },
  "2905": {
    "id": "2905",
    "name": "Пахтаабад",
    "path": "Узбекистан / Пахтаабад",
    "country": "Узбекистан",
    "searchString": "пахтаабад узбекистан / пахтаабад"
  },
  "2906": {
    "id": "2906",
    "name": "Пахтакор",
    "path": "Узбекистан / Пахтакор",
    "country": "Узбекистан",
    "searchString": "пахтакор узбекистан / пахтакор"
  },
  "2907": {
    "id": "2907",
    "name": "Питнак",
    "path": "Узбекистан / Питнак",
    "country": "Узбекистан",
    "searchString": "питнак узбекистан / питнак"
  },
  "2908": {
    "id": "2908",
    "name": "Пскент",
    "path": "Узбекистан / Пскент",
    "country": "Узбекистан",
    "searchString": "пскент узбекистан / пскент"
  },
  "2909": {
    "id": "2909",
    "name": "Риштан",
    "path": "Узбекистан / Риштан",
    "country": "Узбекистан",
    "searchString": "риштан узбекистан / риштан"
  },
  "2910": {
    "id": "2910",
    "name": "Ромитан",
    "path": "Узбекистан / Ромитан",
    "country": "Узбекистан",
    "searchString": "ромитан узбекистан / ромитан"
  },
  "2911": {
    "id": "2911",
    "name": "Сырдарья",
    "path": "Узбекистан / Сырдарья",
    "country": "Узбекистан",
    "searchString": "сырдарья узбекистан / сырдарья"
  },
  "2912": {
    "id": "2912",
    "name": "Тахиаташ",
    "path": "Узбекистан / Тахиаташ",
    "country": "Узбекистан",
    "searchString": "тахиаташ узбекистан / тахиаташ"
  },
  "2913": {
    "id": "2913",
    "name": "Тинчлик",
    "path": "Узбекистан / Тинчлик",
    "country": "Узбекистан",
    "searchString": "тинчлик узбекистан / тинчлик"
  },
  "2914": {
    "id": "2914",
    "name": "Нурафшон",
    "path": "Узбекистан / Нурафшон",
    "country": "Узбекистан",
    "searchString": "нурафшон узбекистан / нурафшон"
  },
  "2915": {
    "id": "2915",
    "name": "Туракурган",
    "path": "Узбекистан / Туракурган",
    "country": "Узбекистан",
    "searchString": "туракурган узбекистан / туракурган"
  },
  "2916": {
    "id": "2916",
    "name": "Турткуль",
    "path": "Узбекистан / Турткуль",
    "country": "Узбекистан",
    "searchString": "турткуль узбекистан / турткуль"
  },
  "2917": {
    "id": "2917",
    "name": "Ургут",
    "path": "Узбекистан / Ургут",
    "country": "Узбекистан",
    "searchString": "ургут узбекистан / ургут"
  },
  "2918": {
    "id": "2918",
    "name": "Учкудук",
    "path": "Узбекистан / Учкудук",
    "country": "Узбекистан",
    "searchString": "учкудук узбекистан / учкудук"
  },
  "2919": {
    "id": "2919",
    "name": "Учкурган",
    "path": "Узбекистан / Учкурган",
    "country": "Узбекистан",
    "searchString": "учкурган узбекистан / учкурган"
  },
  "2920": {
    "id": "2920",
    "name": "Хаккулабад",
    "path": "Узбекистан / Хаккулабад",
    "country": "Узбекистан",
    "searchString": "хаккулабад узбекистан / хаккулабад"
  },
  "2921": {
    "id": "2921",
    "name": "Ханабад",
    "path": "Узбекистан / Ханабад",
    "country": "Узбекистан",
    "searchString": "ханабад узбекистан / ханабад"
  },
  "2922": {
    "id": "2922",
    "name": "Хива",
    "path": "Узбекистан / Хива",
    "country": "Узбекистан",
    "searchString": "хива узбекистан / хива"
  },
  "2923": {
    "id": "2923",
    "name": "Ходжаабад",
    "path": "Узбекистан / Ходжаабад",
    "country": "Узбекистан",
    "searchString": "ходжаабад узбекистан / ходжаабад"
  },
  "2924": {
    "id": "2924",
    "name": "Ходжейли",
    "path": "Узбекистан / Ходжейли",
    "country": "Узбекистан",
    "searchString": "ходжейли узбекистан / ходжейли"
  },
  "2925": {
    "id": "2925",
    "name": "Чартак",
    "path": "Узбекистан / Чартак",
    "country": "Узбекистан",
    "searchString": "чартак узбекистан / чартак"
  },
  "2926": {
    "id": "2926",
    "name": "Челек",
    "path": "Узбекистан / Челек",
    "country": "Узбекистан",
    "searchString": "челек узбекистан / челек"
  },
  "2927": {
    "id": "2927",
    "name": "Чимбай",
    "path": "Узбекистан / Чимбай",
    "country": "Узбекистан",
    "searchString": "чимбай узбекистан / чимбай"
  },
  "2928": {
    "id": "2928",
    "name": "Чиназ",
    "path": "Узбекистан / Чиназ",
    "country": "Узбекистан",
    "searchString": "чиназ узбекистан / чиназ"
  },
  "2929": {
    "id": "2929",
    "name": "Чиракчи",
    "path": "Узбекистан / Чиракчи",
    "country": "Узбекистан",
    "searchString": "чиракчи узбекистан / чиракчи"
  },
  "2930": {
    "id": "2930",
    "name": "Чуст",
    "path": "Узбекистан / Чуст",
    "country": "Узбекистан",
    "searchString": "чуст узбекистан / чуст"
  },
  "2931": {
    "id": "2931",
    "name": "Шаргунь",
    "path": "Узбекистан / Шаргунь",
    "country": "Узбекистан",
    "searchString": "шаргунь узбекистан / шаргунь"
  },
  "2932": {
    "id": "2932",
    "name": "Шафиркан",
    "path": "Узбекистан / Шафиркан",
    "country": "Узбекистан",
    "searchString": "шафиркан узбекистан / шафиркан"
  },
  "2933": {
    "id": "2933",
    "name": "Шахрихан",
    "path": "Узбекистан / Шахрихан",
    "country": "Узбекистан",
    "searchString": "шахрихан узбекистан / шахрихан"
  },
  "2934": {
    "id": "2934",
    "name": "Шерабад",
    "path": "Узбекистан / Шерабад",
    "country": "Узбекистан",
    "searchString": "шерабад узбекистан / шерабад"
  },
  "2935": {
    "id": "2935",
    "name": "Ширин",
    "path": "Узбекистан / Ширин",
    "country": "Узбекистан",
    "searchString": "ширин узбекистан / ширин"
  },
  "2936": {
    "id": "2936",
    "name": "Шуманай",
    "path": "Узбекистан / Шуманай",
    "country": "Узбекистан",
    "searchString": "шуманай узбекистан / шуманай"
  },
  "2937": {
    "id": "2937",
    "name": "Шурчи",
    "path": "Узбекистан / Шурчи",
    "country": "Узбекистан",
    "searchString": "шурчи узбекистан / шурчи"
  },
  "2938": {
    "id": "2938",
    "name": "Яйпан",
    "path": "Узбекистан / Яйпан",
    "country": "Узбекистан",
    "searchString": "яйпан узбекистан / яйпан"
  },
  "2939": {
    "id": "2939",
    "name": "Яккабаг",
    "path": "Узбекистан / Яккабаг",
    "country": "Узбекистан",
    "searchString": "яккабаг узбекистан / яккабаг"
  },
  "2940": {
    "id": "2940",
    "name": "Янгиер",
    "path": "Узбекистан / Янгиер",
    "country": "Узбекистан",
    "searchString": "янгиер узбекистан / янгиер"
  },
  "2941": {
    "id": "2941",
    "name": "Янги-Нишан",
    "path": "Узбекистан / Янги-Нишан",
    "country": "Узбекистан",
    "searchString": "янги-нишан узбекистан / янги-нишан"
  },
  "2942": {
    "id": "2942",
    "name": "Янгирабад",
    "path": "Узбекистан / Янгирабад",
    "country": "Узбекистан",
    "searchString": "янгирабад узбекистан / янгирабад"
  },
  "2943": {
    "id": "2943",
    "name": "Янгиюль",
    "path": "Узбекистан / Янгиюль",
    "country": "Узбекистан",
    "searchString": "янгиюль узбекистан / янгиюль"
  },
  "2944": {
    "id": "2944",
    "name": "Вараш",
    "path": "Украина / Ровненская область / Вараш",
    "country": "Украина",
    "searchString": "вараш украина / ровненская область / вараш"
  },
  "2945": {
    "id": "2945",
    "name": "Краснозёрское",
    "path": "Россия / Новосибирская область / Краснозёрское",
    "country": "Россия",
    "searchString": "краснозёрское россия / новосибирская область / краснозёрское"
  },
  "2946": {
    "id": "2946",
    "name": "Сузун",
    "path": "Россия / Новосибирская область / Сузун",
    "country": "Россия",
    "searchString": "сузун россия / новосибирская область / сузун"
  },
  "2947": {
    "id": "2947",
    "name": "Максатиха",
    "path": "Россия / Тверская область / Максатиха",
    "country": "Россия",
    "searchString": "максатиха россия / тверская область / максатиха"
  },
  "2948": {
    "id": "2948",
    "name": "Октябрьский (Архангельская область)",
    "path": "Россия / Архангельская область / Октябрьский (Архангельская область)",
    "country": "Россия",
    "searchString": "октябрьский (архангельская область) россия / архангельская область / октябрьский (архангельская область)"
  },
  "2949": {
    "id": "2949",
    "name": "Южноукраинск",
    "path": "Украина / Николаевская область / Южноукраинск",
    "country": "Украина",
    "searchString": "южноукраинск украина / николаевская область / южноукраинск"
  },
  "2950": {
    "id": "2950",
    "name": "Макинск",
    "path": "Казахстан / Макинск",
    "country": "Казахстан",
    "searchString": "макинск казахстан / макинск"
  },
  "2951": {
    "id": "2951",
    "name": "Сарыагаш",
    "path": "Казахстан / Сарыагаш",
    "country": "Казахстан",
    "searchString": "сарыагаш казахстан / сарыагаш"
  },
  "2952": {
    "id": "2952",
    "name": "Жетысай",
    "path": "Казахстан / Жетысай",
    "country": "Казахстан",
    "searchString": "жетысай казахстан / жетысай"
  },
  "2953": {
    "id": "2953",
    "name": "Уруссу",
    "path": "Россия / Республика Татарстан / Уруссу",
    "country": "Россия",
    "searchString": "уруссу россия / республика татарстан / уруссу"
  },
  "2954": {
    "id": "2954",
    "name": "Яблоновский (Республика Адыгея)",
    "path": "Россия / Республика Адыгея / Яблоновский (Республика Адыгея)",
    "country": "Россия",
    "searchString": "яблоновский (республика адыгея) россия / республика адыгея / яблоновский (республика адыгея)"
  },
  "2955": {
    "id": "2955",
    "name": "Малые Вязёмы (Московская область)",
    "path": "Россия / Московская область / Малые Вязёмы (Московская область)",
    "country": "Россия",
    "searchString": "малые вязёмы (московская область) россия / московская область / малые вязёмы (московская область)"
  },
  "2956": {
    "id": "2956",
    "name": "Солнечный",
    "path": "Россия / Хабаровский край / Солнечный",
    "country": "Россия",
    "searchString": "солнечный россия / хабаровский край / солнечный"
  },
  "2957": {
    "id": "2957",
    "name": "Колывань",
    "path": "Россия / Новосибирская область / Колывань",
    "country": "Россия",
    "searchString": "колывань россия / новосибирская область / колывань"
  },
  "2958": {
    "id": "2958",
    "name": "Свердловск",
    "path": "Россия / Луганская Народная Республика / Свердловск",
    "country": "Россия",
    "searchString": "свердловск россия / луганская народная республика / свердловск"
  },
  "2959": {
    "id": "2959",
    "name": "Ува",
    "path": "Россия / Удмуртская Республика / Ува",
    "country": "Россия",
    "searchString": "ува россия / удмуртская республика / ува"
  },
  "2961": {
    "id": "2961",
    "name": "Кронштадт",
    "path": "Россия / Ленинградская область / Кронштадт",
    "country": "Россия",
    "searchString": "кронштадт россия / ленинградская область / кронштадт"
  },
  "2962": {
    "id": "2962",
    "name": "Чагода",
    "path": "Россия / Вологодская область / Чагода",
    "country": "Россия",
    "searchString": "чагода россия / вологодская область / чагода"
  },
  "2963": {
    "id": "2963",
    "name": "Хырдалан",
    "path": "Азербайджан / Хырдалан",
    "country": "Азербайджан",
    "searchString": "хырдалан азербайджан / хырдалан"
  },
  "2964": {
    "id": "2964",
    "name": "Ширван",
    "path": "Азербайджан / Ширван",
    "country": "Азербайджан",
    "searchString": "ширван азербайджан / ширван"
  },
  "2965": {
    "id": "2965",
    "name": "Джалилабад",
    "path": "Азербайджан / Джалилабад",
    "country": "Азербайджан",
    "searchString": "джалилабад азербайджан / джалилабад"
  },
  "2966": {
    "id": "2966",
    "name": "Агджабеди",
    "path": "Азербайджан / Агджабеди",
    "country": "Азербайджан",
    "searchString": "агджабеди азербайджан / агджабеди"
  },
  "2967": {
    "id": "2967",
    "name": "Шамкир",
    "path": "Азербайджан / Шамкир",
    "country": "Азербайджан",
    "searchString": "шамкир азербайджан / шамкир"
  },
  "2968": {
    "id": "2968",
    "name": "Сальяны",
    "path": "Азербайджан / Сальяны",
    "country": "Азербайджан",
    "searchString": "сальяны азербайджан / сальяны"
  },
  "2969": {
    "id": "2969",
    "name": "Имишли",
    "path": "Азербайджан / Имишли",
    "country": "Азербайджан",
    "searchString": "имишли азербайджан / имишли"
  },
  "2970": {
    "id": "2970",
    "name": "Агдаш",
    "path": "Азербайджан / Агдаш",
    "country": "Азербайджан",
    "searchString": "агдаш азербайджан / агдаш"
  },
  "2971": {
    "id": "2971",
    "name": "Сабирабад",
    "path": "Азербайджан / Сабирабад",
    "country": "Азербайджан",
    "searchString": "сабирабад азербайджан / сабирабад"
  },
  "2972": {
    "id": "2972",
    "name": "Аджигабул",
    "path": "Азербайджан / Аджигабул",
    "country": "Азербайджан",
    "searchString": "аджигабул азербайджан / аджигабул"
  },
  "2973": {
    "id": "2973",
    "name": "Сиазань",
    "path": "Азербайджан / Сиазань",
    "country": "Азербайджан",
    "searchString": "сиазань азербайджан / сиазань"
  },
  "2974": {
    "id": "2974",
    "name": "Шабран",
    "path": "Азербайджан / Шабран",
    "country": "Азербайджан",
    "searchString": "шабран азербайджан / шабран"
  },
  "2975": {
    "id": "2975",
    "name": "Казах",
    "path": "Азербайджан / Казах",
    "country": "Азербайджан",
    "searchString": "казах азербайджан / казах"
  },
  "2976": {
    "id": "2976",
    "name": "Нефтечала",
    "path": "Азербайджан / Нефтечала",
    "country": "Азербайджан",
    "searchString": "нефтечала азербайджан / нефтечала"
  },
  "2977": {
    "id": "2977",
    "name": "Билясувар",
    "path": "Азербайджан / Билясувар",
    "country": "Азербайджан",
    "searchString": "билясувар азербайджан / билясувар"
  },
  "2978": {
    "id": "2978",
    "name": "Кюрдамир",
    "path": "Азербайджан / Кюрдамир",
    "country": "Азербайджан",
    "searchString": "кюрдамир азербайджан / кюрдамир"
  },
  "2979": {
    "id": "2979",
    "name": "Саатлы",
    "path": "Азербайджан / Саатлы",
    "country": "Азербайджан",
    "searchString": "саатлы азербайджан / саатлы"
  },
  "2980": {
    "id": "2980",
    "name": "Гёйгёль",
    "path": "Азербайджан / Гёйгёль",
    "country": "Азербайджан",
    "searchString": "гёйгёль азербайджан / гёйгёль"
  },
  "2981": {
    "id": "2981",
    "name": "Уджары",
    "path": "Азербайджан / Уджары",
    "country": "Азербайджан",
    "searchString": "уджары азербайджан / уджары"
  },
  "2982": {
    "id": "2982",
    "name": "Астара",
    "path": "Азербайджан / Астара",
    "country": "Азербайджан",
    "searchString": "астара азербайджан / астара"
  },
  "2983": {
    "id": "2983",
    "name": "Худат",
    "path": "Азербайджан / Худат",
    "country": "Азербайджан",
    "searchString": "худат азербайджан / худат"
  },
  "2984": {
    "id": "2984",
    "name": "Бейлаган",
    "path": "Азербайджан / Бейлаган",
    "country": "Азербайджан",
    "searchString": "бейлаган азербайджан / бейлаган"
  },
  "2985": {
    "id": "2985",
    "name": "Гёйтепе",
    "path": "Азербайджан / Гёйтепе",
    "country": "Азербайджан",
    "searchString": "гёйтепе азербайджан / гёйтепе"
  },
  "2986": {
    "id": "2986",
    "name": "Тауз",
    "path": "Азербайджан / Тауз",
    "country": "Азербайджан",
    "searchString": "тауз азербайджан / тауз"
  },
  "2987": {
    "id": "2987",
    "name": "Кахи",
    "path": "Азербайджан / Кахи",
    "country": "Азербайджан",
    "searchString": "кахи азербайджан / кахи"
  },
  "2988": {
    "id": "2988",
    "name": "Акстафа",
    "path": "Азербайджан / Акстафа",
    "country": "Азербайджан",
    "searchString": "акстафа азербайджан / акстафа"
  },
  "2989": {
    "id": "2989",
    "name": "Джульфа",
    "path": "Азербайджан / Джульфа",
    "country": "Азербайджан",
    "searchString": "джульфа азербайджан / джульфа"
  },
  "2990": {
    "id": "2990",
    "name": "Лиман",
    "path": "Азербайджан / Лиман",
    "country": "Азербайджан",
    "searchString": "лиман азербайджан / лиман"
  },
  "2991": {
    "id": "2991",
    "name": "Дашкесан",
    "path": "Азербайджан / Дашкесан",
    "country": "Азербайджан",
    "searchString": "дашкесан азербайджан / дашкесан"
  },
  "2992": {
    "id": "2992",
    "name": "Кедабек",
    "path": "Азербайджан / Кедабек",
    "country": "Азербайджан",
    "searchString": "кедабек азербайджан / кедабек"
  },
  "2993": {
    "id": "2993",
    "name": "Зардоб",
    "path": "Азербайджан / Зардоб",
    "country": "Азербайджан",
    "searchString": "зардоб азербайджан / зардоб"
  },
  "2994": {
    "id": "2994",
    "name": "Ромны",
    "path": "Украина / Сумская область / Ромны",
    "country": "Украина",
    "searchString": "ромны украина / сумская область / ромны"
  },
  "2995": {
    "id": "2995",
    "name": "Озинки",
    "path": "Россия / Саратовская область / Озинки",
    "country": "Россия",
    "searchString": "озинки россия / саратовская область / озинки"
  },
  "2996": {
    "id": "2996",
    "name": "Белоозёрский (Московская область)",
    "path": "Россия / Московская область / Белоозёрский (Московская область)",
    "country": "Россия",
    "searchString": "белоозёрский (московская область) россия / московская область / белоозёрский (московская область)"
  },
  "3029": {
    "id": "3029",
    "name": "Пестравка",
    "path": "Россия / Самарская область / Пестравка",
    "country": "Россия",
    "searchString": "пестравка россия / самарская область / пестравка"
  },
  "3030": {
    "id": "3030",
    "name": "Борское (Самарская область)",
    "path": "Россия / Самарская область / Борское (Самарская область)",
    "country": "Россия",
    "searchString": "борское (самарская область) россия / самарская область / борское (самарская область)"
  },
  "3031": {
    "id": "3031",
    "name": "Шентала",
    "path": "Россия / Самарская область / Шентала",
    "country": "Россия",
    "searchString": "шентала россия / самарская область / шентала"
  },
  "3032": {
    "id": "3032",
    "name": "Челно-Вершины",
    "path": "Россия / Самарская область / Челно-Вершины",
    "country": "Россия",
    "searchString": "челно-вершины россия / самарская область / челно-вершины"
  },
  "3033": {
    "id": "3033",
    "name": "Большая Глушица",
    "path": "Россия / Самарская область / Большая Глушица",
    "country": "Россия",
    "searchString": "большая глушица россия / самарская область / большая глушица"
  },
  "3034": {
    "id": "3034",
    "name": "Кульсары",
    "path": "Казахстан / Кульсары",
    "country": "Казахстан",
    "searchString": "кульсары казахстан / кульсары"
  },
  "3035": {
    "id": "3035",
    "name": "Большая Черниговка",
    "path": "Россия / Самарская область / Большая Черниговка",
    "country": "Россия",
    "searchString": "большая черниговка россия / самарская область / большая черниговка"
  },
  "3036": {
    "id": "3036",
    "name": "Красноармейское (Самарская область)",
    "path": "Россия / Самарская область / Красноармейское (Самарская область)",
    "country": "Россия",
    "searchString": "красноармейское (самарская область) россия / самарская область / красноармейское (самарская область)"
  },
  "3037": {
    "id": "3037",
    "name": "Приволжье (Самарская область)",
    "path": "Россия / Самарская область / Приволжье (Самарская область)",
    "country": "Россия",
    "searchString": "приволжье (самарская область) россия / самарская область / приволжье (самарская область)"
  },
  "3038": {
    "id": "3038",
    "name": "Хворостянка (Самарская область)",
    "path": "Россия / Самарская область / Хворостянка (Самарская область)",
    "country": "Россия",
    "searchString": "хворостянка (самарская область) россия / самарская область / хворостянка (самарская область)"
  },
  "3039": {
    "id": "3039",
    "name": "Алексеевка (Самарская область)",
    "path": "Россия / Самарская область / Алексеевка (Самарская область)",
    "country": "Россия",
    "searchString": "алексеевка (самарская область) россия / самарская область / алексеевка (самарская область)"
  },
  "3040": {
    "id": "3040",
    "name": "Богатое (Самарская область)",
    "path": "Россия / Самарская область / Богатое (Самарская область)",
    "country": "Россия",
    "searchString": "богатое (самарская область) россия / самарская область / богатое (самарская область)"
  },
  "3041": {
    "id": "3041",
    "name": "Камышла (Самарская область)",
    "path": "Россия / Самарская область / Камышла (Самарская область)",
    "country": "Россия",
    "searchString": "камышла (самарская область) россия / самарская область / камышла (самарская область)"
  },
  "3042": {
    "id": "3042",
    "name": "Клявлино",
    "path": "Россия / Самарская область / Клявлино",
    "country": "Россия",
    "searchString": "клявлино россия / самарская область / клявлино"
  },
  "3043": {
    "id": "3043",
    "name": "Исаклы",
    "path": "Россия / Самарская область / Исаклы",
    "country": "Россия",
    "searchString": "исаклы россия / самарская область / исаклы"
  },
  "3044": {
    "id": "3044",
    "name": "Сергиевск",
    "path": "Россия / Самарская область / Сергиевск",
    "country": "Россия",
    "searchString": "сергиевск россия / самарская область / сергиевск"
  },
  "3045": {
    "id": "3045",
    "name": "Кошки (Самарская область)",
    "path": "Россия / Самарская область / Кошки (Самарская область)",
    "country": "Россия",
    "searchString": "кошки (самарская область) россия / самарская область / кошки (самарская область)"
  },
  "3046": {
    "id": "3046",
    "name": "Красный Яр (Самарская область)",
    "path": "Россия / Самарская область / Красный Яр (Самарская область)",
    "country": "Россия",
    "searchString": "красный яр (самарская область) россия / самарская область / красный яр (самарская область)"
  },
  "3047": {
    "id": "3047",
    "name": "Сосновка (Тамбовская область)",
    "path": "Россия / Тамбовская область / Сосновка (Тамбовская область)",
    "country": "Россия",
    "searchString": "сосновка (тамбовская область) россия / тамбовская область / сосновка (тамбовская область)"
  },
  "3048": {
    "id": "3048",
    "name": "Талгар",
    "path": "Казахстан / Талгар",
    "country": "Казахстан",
    "searchString": "талгар казахстан / талгар"
  },
  "3049": {
    "id": "3049",
    "name": "Серебряные Пруды (Московская область)",
    "path": "Россия / Московская область / Серебряные Пруды (Московская область)",
    "country": "Россия",
    "searchString": "серебряные пруды (московская область) россия / московская область / серебряные пруды (московская область)"
  },
  "3050": {
    "id": "3050",
    "name": "Лазаревское",
    "path": "Россия / Краснодарский край / Лазаревское",
    "country": "Россия",
    "searchString": "лазаревское россия / краснодарский край / лазаревское"
  },
  "3051": {
    "id": "3051",
    "name": "Бреды",
    "path": "Россия / Челябинская область / Бреды",
    "country": "Россия",
    "searchString": "бреды россия / челябинская область / бреды"
  },
  "3052": {
    "id": "3052",
    "name": "Ракитное (Белгородская область)",
    "path": "Россия / Белгородская область / Ракитное (Белгородская область)",
    "country": "Россия",
    "searchString": "ракитное (белгородская область) россия / белгородская область / ракитное (белгородская область)"
  },
  "3053": {
    "id": "3053",
    "name": "Пролетарский",
    "path": "Россия / Белгородская область / Пролетарский",
    "country": "Россия",
    "searchString": "пролетарский россия / белгородская область / пролетарский"
  },
  "3054": {
    "id": "3054",
    "name": "Красная Яруга",
    "path": "Россия / Белгородская область / Красная Яруга",
    "country": "Россия",
    "searchString": "красная яруга россия / белгородская область / красная яруга"
  },
  "3055": {
    "id": "3055",
    "name": "Томаровка",
    "path": "Россия / Белгородская область / Томаровка",
    "country": "Россия",
    "searchString": "томаровка россия / белгородская область / томаровка"
  },
  "3056": {
    "id": "3056",
    "name": "Кольцово (Новосибирская область)",
    "path": "Россия / Новосибирская область / Кольцово (Новосибирская область)",
    "country": "Россия",
    "searchString": "кольцово (новосибирская область) россия / новосибирская область / кольцово (новосибирская область)"
  },
  "3057": {
    "id": "3057",
    "name": "Одоев",
    "path": "Россия / Тульская область / Одоев",
    "country": "Россия",
    "searchString": "одоев россия / тульская область / одоев"
  },
  "3058": {
    "id": "3058",
    "name": "Калининская",
    "path": "Россия / Краснодарский край / Калининская",
    "country": "Россия",
    "searchString": "калининская россия / краснодарский край / калининская"
  },
  "3059": {
    "id": "3059",
    "name": "Александровское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Александровское (Ставропольский край)",
    "country": "Россия",
    "searchString": "александровское (ставропольский край) россия / ставропольский край / александровское (ставропольский край)"
  },
  "3060": {
    "id": "3060",
    "name": "Борисовка",
    "path": "Россия / Белгородская область / Борисовка",
    "country": "Россия",
    "searchString": "борисовка россия / белгородская область / борисовка"
  },
  "3061": {
    "id": "3061",
    "name": "Ивня",
    "path": "Россия / Белгородская область / Ивня",
    "country": "Россия",
    "searchString": "ивня россия / белгородская область / ивня"
  },
  "3062": {
    "id": "3062",
    "name": "Вознесенское (Нижегородская область)",
    "path": "Россия / Нижегородская область / Вознесенское (Нижегородская область)",
    "country": "Россия",
    "searchString": "вознесенское (нижегородская область) россия / нижегородская область / вознесенское (нижегородская область)"
  },
  "3063": {
    "id": "3063",
    "name": "Венгерово",
    "path": "Россия / Новосибирская область / Венгерово",
    "country": "Россия",
    "searchString": "венгерово россия / новосибирская область / венгерово"
  },
  "3064": {
    "id": "3064",
    "name": "Ордынское",
    "path": "Россия / Новосибирская область / Ордынское",
    "country": "Россия",
    "searchString": "ордынское россия / новосибирская область / ордынское"
  },
  "3065": {
    "id": "3065",
    "name": "Казанское",
    "path": "Россия / Тюменская область / Казанское",
    "country": "Россия",
    "searchString": "казанское россия / тюменская область / казанское"
  },
  "3066": {
    "id": "3066",
    "name": "Черлак (Омская область)",
    "path": "Россия / Омская область / Черлак (Омская область)",
    "country": "Россия",
    "searchString": "черлак (омская область) россия / омская область / черлак (омская область)"
  },
  "3067": {
    "id": "3067",
    "name": "Малин",
    "path": "Украина / Житомирская область / Малин",
    "country": "Украина",
    "searchString": "малин украина / житомирская область / малин"
  },
  "3068": {
    "id": "3068",
    "name": "Износки",
    "path": "Россия / Калужская область / Износки",
    "country": "Россия",
    "searchString": "износки россия / калужская область / износки"
  },
  "3069": {
    "id": "3069",
    "name": "Сарны",
    "path": "Украина / Ровненская область / Сарны",
    "country": "Украина",
    "searchString": "сарны украина / ровненская область / сарны"
  },
  "3070": {
    "id": "3070",
    "name": "Чарышское",
    "path": "Россия / Алтайский край / Чарышское",
    "country": "Россия",
    "searchString": "чарышское россия / алтайский край / чарышское"
  },
  "3071": {
    "id": "3071",
    "name": "Чистоозерное",
    "path": "Россия / Новосибирская область / Чистоозерное",
    "country": "Россия",
    "searchString": "чистоозерное россия / новосибирская область / чистоозерное"
  },
  "3072": {
    "id": "3072",
    "name": "Першотравенск",
    "path": "Украина / Днепропетровская область / Першотравенск",
    "country": "Украина",
    "searchString": "першотравенск украина / днепропетровская область / першотравенск"
  },
  "3073": {
    "id": "3073",
    "name": "Тальменка",
    "path": "Россия / Алтайский край / Тальменка",
    "country": "Россия",
    "searchString": "тальменка россия / алтайский край / тальменка"
  },
  "3074": {
    "id": "3074",
    "name": "Кандыагаш",
    "path": "Казахстан / Кандыагаш",
    "country": "Казахстан",
    "searchString": "кандыагаш казахстан / кандыагаш"
  },
  "3075": {
    "id": "3075",
    "name": "Раевский (Альшеевский район)",
    "path": "Россия / Республика Башкортостан / Раевский (Альшеевский район)",
    "country": "Россия",
    "searchString": "раевский (альшеевский район) россия / республика башкортостан / раевский (альшеевский район)"
  },
  "3076": {
    "id": "3076",
    "name": "Большое Болдино",
    "path": "Россия / Нижегородская область / Большое Болдино",
    "country": "Россия",
    "searchString": "большое болдино россия / нижегородская область / большое болдино"
  },
  "3077": {
    "id": "3077",
    "name": "Нижние Вязовые",
    "path": "Россия / Республика Татарстан / Нижние Вязовые",
    "country": "Россия",
    "searchString": "нижние вязовые россия / республика татарстан / нижние вязовые"
  },
  "3078": {
    "id": "3078",
    "name": "Барышевка",
    "path": "Украина / Киевская область / Барышевка",
    "country": "Украина",
    "searchString": "барышевка украина / киевская область / барышевка"
  },
  "3079": {
    "id": "3079",
    "name": "Белогородка",
    "path": "Украина / Киевская область / Белогородка",
    "country": "Украина",
    "searchString": "белогородка украина / киевская область / белогородка"
  },
  "3080": {
    "id": "3080",
    "name": "Березань",
    "path": "Украина / Киевская область / Березань",
    "country": "Украина",
    "searchString": "березань украина / киевская область / березань"
  },
  "3081": {
    "id": "3081",
    "name": "Богуслав",
    "path": "Украина / Киевская область / Богуслав",
    "country": "Украина",
    "searchString": "богуслав украина / киевская область / богуслав"
  },
  "3082": {
    "id": "3082",
    "name": "Бородянка",
    "path": "Украина / Киевская область / Бородянка",
    "country": "Украина",
    "searchString": "бородянка украина / киевская область / бородянка"
  },
  "3083": {
    "id": "3083",
    "name": "Буча",
    "path": "Украина / Киевская область / Буча",
    "country": "Украина",
    "searchString": "буча украина / киевская область / буча"
  },
  "3084": {
    "id": "3084",
    "name": "Васильков",
    "path": "Украина / Киевская область / Васильков",
    "country": "Украина",
    "searchString": "васильков украина / киевская область / васильков"
  },
  "3085": {
    "id": "3085",
    "name": "Вишневое",
    "path": "Украина / Киевская область / Вишневое",
    "country": "Украина",
    "searchString": "вишневое украина / киевская область / вишневое"
  },
  "3086": {
    "id": "3086",
    "name": "Володарка",
    "path": "Украина / Киевская область / Володарка",
    "country": "Украина",
    "searchString": "володарка украина / киевская область / володарка"
  },
  "3087": {
    "id": "3087",
    "name": "Ворзель",
    "path": "Украина / Киевская область / Ворзель",
    "country": "Украина",
    "searchString": "ворзель украина / киевская область / ворзель"
  },
  "3088": {
    "id": "3088",
    "name": "Вышгород",
    "path": "Украина / Киевская область / Вышгород",
    "country": "Украина",
    "searchString": "вышгород украина / киевская область / вышгород"
  },
  "3089": {
    "id": "3089",
    "name": "Гнедин",
    "path": "Украина / Киевская область / Гнедин",
    "country": "Украина",
    "searchString": "гнедин украина / киевская область / гнедин"
  },
  "3090": {
    "id": "3090",
    "name": "Згуровка",
    "path": "Украина / Киевская область / Згуровка",
    "country": "Украина",
    "searchString": "згуровка украина / киевская область / згуровка"
  },
  "3091": {
    "id": "3091",
    "name": "Иванков",
    "path": "Украина / Киевская область / Иванков",
    "country": "Украина",
    "searchString": "иванков украина / киевская область / иванков"
  },
  "3092": {
    "id": "3092",
    "name": "Ирпень",
    "path": "Украина / Киевская область / Ирпень",
    "country": "Украина",
    "searchString": "ирпень украина / киевская область / ирпень"
  },
  "3093": {
    "id": "3093",
    "name": "Макаров (Киевская область)",
    "path": "Украина / Киевская область / Макаров (Киевская область)",
    "country": "Украина",
    "searchString": "макаров (киевская область) украина / киевская область / макаров (киевская область)"
  },
  "3094": {
    "id": "3094",
    "name": "Мироновка",
    "path": "Украина / Киевская область / Мироновка",
    "country": "Украина",
    "searchString": "мироновка украина / киевская область / мироновка"
  },
  "3095": {
    "id": "3095",
    "name": "Переяслав-Хмельницкий",
    "path": "Украина / Киевская область / Переяслав-Хмельницкий",
    "country": "Украина",
    "searchString": "переяслав-хмельницкий украина / киевская область / переяслав-хмельницкий"
  },
  "3096": {
    "id": "3096",
    "name": "Петровское",
    "path": "Украина / Киевская область / Петровское",
    "country": "Украина",
    "searchString": "петровское украина / киевская область / петровское"
  },
  "3097": {
    "id": "3097",
    "name": "Полесское",
    "path": "Украина / Киевская область / Полесское",
    "country": "Украина",
    "searchString": "полесское украина / киевская область / полесское"
  },
  "3098": {
    "id": "3098",
    "name": "Ракитное (Киевская область)",
    "path": "Украина / Киевская область / Ракитное (Киевская область)",
    "country": "Украина",
    "searchString": "ракитное (киевская область) украина / киевская область / ракитное (киевская область)"
  },
  "3099": {
    "id": "3099",
    "name": "Сквира",
    "path": "Украина / Киевская область / Сквира",
    "country": "Украина",
    "searchString": "сквира украина / киевская область / сквира"
  },
  "3100": {
    "id": "3100",
    "name": "Славутич",
    "path": "Украина / Киевская область / Славутич",
    "country": "Украина",
    "searchString": "славутич украина / киевская область / славутич"
  },
  "3101": {
    "id": "3101",
    "name": "Ставище",
    "path": "Украина / Киевская область / Ставище",
    "country": "Украина",
    "searchString": "ставище украина / киевская область / ставище"
  },
  "3102": {
    "id": "3102",
    "name": "Стоянка",
    "path": "Украина / Киевская область / Стоянка",
    "country": "Украина",
    "searchString": "стоянка украина / киевская область / стоянка"
  },
  "3103": {
    "id": "3103",
    "name": "Тараща",
    "path": "Украина / Киевская область / Тараща",
    "country": "Украина",
    "searchString": "тараща украина / киевская область / тараща"
  },
  "3104": {
    "id": "3104",
    "name": "Тетиев",
    "path": "Украина / Киевская область / Тетиев",
    "country": "Украина",
    "searchString": "тетиев украина / киевская область / тетиев"
  },
  "3105": {
    "id": "3105",
    "name": "Узин",
    "path": "Украина / Киевская область / Узин",
    "country": "Украина",
    "searchString": "узин украина / киевская область / узин"
  },
  "3106": {
    "id": "3106",
    "name": "Чабаны",
    "path": "Украина / Киевская область / Чабаны",
    "country": "Украина",
    "searchString": "чабаны украина / киевская область / чабаны"
  },
  "3107": {
    "id": "3107",
    "name": "Яготин",
    "path": "Украина / Киевская область / Яготин",
    "country": "Украина",
    "searchString": "яготин украина / киевская область / яготин"
  },
  "3108": {
    "id": "3108",
    "name": "Балаклея",
    "path": "Украина / Харьковская область / Балаклея",
    "country": "Украина",
    "searchString": "балаклея украина / харьковская область / балаклея"
  },
  "3109": {
    "id": "3109",
    "name": "Близнюки",
    "path": "Украина / Харьковская область / Близнюки",
    "country": "Украина",
    "searchString": "близнюки украина / харьковская область / близнюки"
  },
  "3110": {
    "id": "3110",
    "name": "Богодухов",
    "path": "Украина / Харьковская область / Богодухов",
    "country": "Украина",
    "searchString": "богодухов украина / харьковская область / богодухов"
  },
  "3111": {
    "id": "3111",
    "name": "Великий Бурлук",
    "path": "Украина / Харьковская область / Великий Бурлук",
    "country": "Украина",
    "searchString": "великий бурлук украина / харьковская область / великий бурлук"
  },
  "3112": {
    "id": "3112",
    "name": "Волчанск (Харьковская область)",
    "path": "Украина / Харьковская область / Волчанск (Харьковская область)",
    "country": "Украина",
    "searchString": "волчанск (харьковская область) украина / харьковская область / волчанск (харьковская область)"
  },
  "3113": {
    "id": "3113",
    "name": "Двуречная",
    "path": "Украина / Харьковская область / Двуречная",
    "country": "Украина",
    "searchString": "двуречная украина / харьковская область / двуречная"
  },
  "3114": {
    "id": "3114",
    "name": "Дергачи",
    "path": "Украина / Харьковская область / Дергачи",
    "country": "Украина",
    "searchString": "дергачи украина / харьковская область / дергачи"
  },
  "3115": {
    "id": "3115",
    "name": "Зачепиловка",
    "path": "Украина / Харьковская область / Зачепиловка",
    "country": "Украина",
    "searchString": "зачепиловка украина / харьковская область / зачепиловка"
  },
  "3116": {
    "id": "3116",
    "name": "Змиев",
    "path": "Украина / Харьковская область / Змиев",
    "country": "Украина",
    "searchString": "змиев украина / харьковская область / змиев"
  },
  "3117": {
    "id": "3117",
    "name": "Золочев (Харьковская область)",
    "path": "Украина / Харьковская область / Золочев (Харьковская область)",
    "country": "Украина",
    "searchString": "золочев (харьковская область) украина / харьковская область / золочев (харьковская область)"
  },
  "3118": {
    "id": "3118",
    "name": "Кегичевка",
    "path": "Украина / Харьковская область / Кегичевка",
    "country": "Украина",
    "searchString": "кегичевка украина / харьковская область / кегичевка"
  },
  "3119": {
    "id": "3119",
    "name": "Коломак",
    "path": "Украина / Харьковская область / Коломак",
    "country": "Украина",
    "searchString": "коломак украина / харьковская область / коломак"
  },
  "3120": {
    "id": "3120",
    "name": "Комсомольское",
    "path": "Украина / Харьковская область / Комсомольское",
    "country": "Украина",
    "searchString": "комсомольское украина / харьковская область / комсомольское"
  },
  "3121": {
    "id": "3121",
    "name": "Краснокутск",
    "path": "Украина / Харьковская область / Краснокутск",
    "country": "Украина",
    "searchString": "краснокутск украина / харьковская область / краснокутск"
  },
  "3122": {
    "id": "3122",
    "name": "Купянск",
    "path": "Украина / Харьковская область / Купянск",
    "country": "Украина",
    "searchString": "купянск украина / харьковская область / купянск"
  },
  "3123": {
    "id": "3123",
    "name": "Лозовая",
    "path": "Украина / Харьковская область / Лозовая",
    "country": "Украина",
    "searchString": "лозовая украина / харьковская область / лозовая"
  },
  "3124": {
    "id": "3124",
    "name": "Малая Даниловка",
    "path": "Украина / Харьковская область / Малая Даниловка",
    "country": "Украина",
    "searchString": "малая даниловка украина / харьковская область / малая даниловка"
  },
  "3125": {
    "id": "3125",
    "name": "Мерефа",
    "path": "Украина / Харьковская область / Мерефа",
    "country": "Украина",
    "searchString": "мерефа украина / харьковская область / мерефа"
  },
  "3126": {
    "id": "3126",
    "name": "Новая Водолага",
    "path": "Украина / Харьковская область / Новая Водолага",
    "country": "Украина",
    "searchString": "новая водолага украина / харьковская область / новая водолага"
  },
  "3127": {
    "id": "3127",
    "name": "Первомайский (Харьковская область)",
    "path": "Украина / Харьковская область / Первомайский (Харьковская область)",
    "country": "Украина",
    "searchString": "первомайский (харьковская область) украина / харьковская область / первомайский (харьковская область)"
  },
  "3128": {
    "id": "3128",
    "name": "Печенеги",
    "path": "Украина / Харьковская область / Печенеги",
    "country": "Украина",
    "searchString": "печенеги украина / харьковская область / печенеги"
  },
  "3129": {
    "id": "3129",
    "name": "Сахновщина",
    "path": "Украина / Харьковская область / Сахновщина",
    "country": "Украина",
    "searchString": "сахновщина украина / харьковская область / сахновщина"
  },
  "3130": {
    "id": "3130",
    "name": "Чугуев",
    "path": "Украина / Харьковская область / Чугуев",
    "country": "Украина",
    "searchString": "чугуев украина / харьковская область / чугуев"
  },
  "3131": {
    "id": "3131",
    "name": "Шевченково",
    "path": "Украина / Харьковская область / Шевченково",
    "country": "Украина",
    "searchString": "шевченково украина / харьковская область / шевченково"
  },
  "3132": {
    "id": "3132",
    "name": "Апостолово",
    "path": "Украина / Днепропетровская область / Апостолово",
    "country": "Украина",
    "searchString": "апостолово украина / днепропетровская область / апостолово"
  },
  "3133": {
    "id": "3133",
    "name": "Васильковка",
    "path": "Украина / Днепропетровская область / Васильковка",
    "country": "Украина",
    "searchString": "васильковка украина / днепропетровская область / васильковка"
  },
  "3134": {
    "id": "3134",
    "name": "Зеленодольск (Днепропетровская область)",
    "path": "Украина / Днепропетровская область / Зеленодольск (Днепропетровская область)",
    "country": "Украина",
    "searchString": "зеленодольск (днепропетровская область) украина / днепропетровская область / зеленодольск (днепропетровская область)"
  },
  "3135": {
    "id": "3135",
    "name": "Кринички",
    "path": "Украина / Днепропетровская область / Кринички",
    "country": "Украина",
    "searchString": "кринички украина / днепропетровская область / кринички"
  },
  "3136": {
    "id": "3136",
    "name": "Магдалиновка",
    "path": "Украина / Днепропетровская область / Магдалиновка",
    "country": "Украина",
    "searchString": "магдалиновка украина / днепропетровская область / магдалиновка"
  },
  "3137": {
    "id": "3137",
    "name": "Марганец",
    "path": "Украина / Днепропетровская область / Марганец",
    "country": "Украина",
    "searchString": "марганец украина / днепропетровская область / марганец"
  },
  "3138": {
    "id": "3138",
    "name": "Межевая",
    "path": "Украина / Днепропетровская область / Межевая",
    "country": "Украина",
    "searchString": "межевая украина / днепропетровская область / межевая"
  },
  "3139": {
    "id": "3139",
    "name": "Покров (Днепропетровская область)",
    "path": "Украина / Днепропетровская область / Покров (Днепропетровская область)",
    "country": "Украина",
    "searchString": "покров (днепропетровская область) украина / днепропетровская область / покров (днепропетровская область)"
  },
  "3140": {
    "id": "3140",
    "name": "Красноград",
    "path": "Украина / Харьковская область / Красноград",
    "country": "Украина",
    "searchString": "красноград украина / харьковская область / красноград"
  },
  "3141": {
    "id": "3141",
    "name": "Петриковка",
    "path": "Украина / Днепропетровская область / Петриковка",
    "country": "Украина",
    "searchString": "петриковка украина / днепропетровская область / петриковка"
  },
  "3142": {
    "id": "3142",
    "name": "Петропавловка",
    "path": "Украина / Днепропетровская область / Петропавловка",
    "country": "Украина",
    "searchString": "петропавловка украина / днепропетровская область / петропавловка"
  },
  "3143": {
    "id": "3143",
    "name": "Покровское ( Днепропетровская область)",
    "path": "Украина / Днепропетровская область / Покровское ( Днепропетровская область)",
    "country": "Украина",
    "searchString": "покровское ( днепропетровская область) украина / днепропетровская область / покровское ( днепропетровская область)"
  },
  "3144": {
    "id": "3144",
    "name": "Пятихатки",
    "path": "Украина / Днепропетровская область / Пятихатки",
    "country": "Украина",
    "searchString": "пятихатки украина / днепропетровская область / пятихатки"
  },
  "3145": {
    "id": "3145",
    "name": "Синельниково",
    "path": "Украина / Днепропетровская область / Синельниково",
    "country": "Украина",
    "searchString": "синельниково украина / днепропетровская область / синельниково"
  },
  "3146": {
    "id": "3146",
    "name": "Соленое",
    "path": "Украина / Днепропетровская область / Соленое",
    "country": "Украина",
    "searchString": "соленое украина / днепропетровская область / соленое"
  },
  "3147": {
    "id": "3147",
    "name": "Софиевка",
    "path": "Украина / Днепропетровская область / Софиевка",
    "country": "Украина",
    "searchString": "софиевка украина / днепропетровская область / софиевка"
  },
  "3148": {
    "id": "3148",
    "name": "Терновка",
    "path": "Украина / Днепропетровская область / Терновка",
    "country": "Украина",
    "searchString": "терновка украина / днепропетровская область / терновка"
  },
  "3149": {
    "id": "3149",
    "name": "Томаковка",
    "path": "Украина / Днепропетровская область / Томаковка",
    "country": "Украина",
    "searchString": "томаковка украина / днепропетровская область / томаковка"
  },
  "3150": {
    "id": "3150",
    "name": "Царичанка",
    "path": "Украина / Днепропетровская область / Царичанка",
    "country": "Украина",
    "searchString": "царичанка украина / днепропетровская область / царичанка"
  },
  "3151": {
    "id": "3151",
    "name": "Широкое",
    "path": "Украина / Днепропетровская область / Широкое",
    "country": "Украина",
    "searchString": "широкое украина / днепропетровская область / широкое"
  },
  "3152": {
    "id": "3152",
    "name": "Юрьевка",
    "path": "Украина / Днепропетровская область / Юрьевка",
    "country": "Украина",
    "searchString": "юрьевка украина / днепропетровская область / юрьевка"
  },
  "3153": {
    "id": "3153",
    "name": "Ананьев",
    "path": "Украина / Одесская область / Ананьев",
    "country": "Украина",
    "searchString": "ананьев украина / одесская область / ананьев"
  },
  "3154": {
    "id": "3154",
    "name": "Арциз",
    "path": "Украина / Одесская область / Арциз",
    "country": "Украина",
    "searchString": "арциз украина / одесская область / арциз"
  },
  "3155": {
    "id": "3155",
    "name": "Балта",
    "path": "Украина / Одесская область / Балта",
    "country": "Украина",
    "searchString": "балта украина / одесская область / балта"
  },
  "3156": {
    "id": "3156",
    "name": "Беляевка",
    "path": "Украина / Одесская область / Беляевка",
    "country": "Украина",
    "searchString": "беляевка украина / одесская область / беляевка"
  },
  "3157": {
    "id": "3157",
    "name": "Березовка (Одесская область)",
    "path": "Украина / Одесская область / Березовка (Одесская область)",
    "country": "Украина",
    "searchString": "березовка (одесская область) украина / одесская область / березовка (одесская область)"
  },
  "3158": {
    "id": "3158",
    "name": "Болград",
    "path": "Украина / Одесская область / Болград",
    "country": "Украина",
    "searchString": "болград украина / одесская область / болград"
  },
  "3159": {
    "id": "3159",
    "name": "Великая Михайловка",
    "path": "Украина / Одесская область / Великая Михайловка",
    "country": "Украина",
    "searchString": "великая михайловка украина / одесская область / великая михайловка"
  },
  "3160": {
    "id": "3160",
    "name": "Ивановка (Одесская область)",
    "path": "Украина / Одесская область / Ивановка (Одесская область)",
    "country": "Украина",
    "searchString": "ивановка (одесская область) украина / одесская область / ивановка (одесская область)"
  },
  "3161": {
    "id": "3161",
    "name": "Килия",
    "path": "Украина / Одесская область / Килия",
    "country": "Украина",
    "searchString": "килия украина / одесская область / килия"
  },
  "3162": {
    "id": "3162",
    "name": "Кодыма",
    "path": "Украина / Одесская область / Кодыма",
    "country": "Украина",
    "searchString": "кодыма украина / одесская область / кодыма"
  },
  "3163": {
    "id": "3163",
    "name": "Коминтерновское",
    "path": "Украина / Одесская область / Коминтерновское",
    "country": "Украина",
    "searchString": "коминтерновское украина / одесская область / коминтерновское"
  },
  "3164": {
    "id": "3164",
    "name": "Котовск (Одесская область)",
    "path": "Украина / Одесская область / Котовск (Одесская область)",
    "country": "Украина",
    "searchString": "котовск (одесская область) украина / одесская область / котовск (одесская область)"
  },
  "3165": {
    "id": "3165",
    "name": "Красные Окны",
    "path": "Украина / Одесская область / Красные Окны",
    "country": "Украина",
    "searchString": "красные окны украина / одесская область / красные окны"
  },
  "3166": {
    "id": "3166",
    "name": "Любашевка",
    "path": "Украина / Одесская область / Любашевка",
    "country": "Украина",
    "searchString": "любашевка украина / одесская область / любашевка"
  },
  "3167": {
    "id": "3167",
    "name": "Николаевка",
    "path": "Россия / Республика Крым / Николаевка",
    "country": "Россия",
    "searchString": "николаевка россия / республика крым / николаевка"
  },
  "3168": {
    "id": "3168",
    "name": "Овидиополь",
    "path": "Украина / Одесская область / Овидиополь",
    "country": "Украина",
    "searchString": "овидиополь украина / одесская область / овидиополь"
  },
  "3169": {
    "id": "3169",
    "name": "Раздельная",
    "path": "Украина / Одесская область / Раздельная",
    "country": "Украина",
    "searchString": "раздельная украина / одесская область / раздельная"
  },
  "3170": {
    "id": "3170",
    "name": "Рени",
    "path": "Украина / Одесская область / Рени",
    "country": "Украина",
    "searchString": "рени украина / одесская область / рени"
  },
  "3171": {
    "id": "3171",
    "name": "Саврань",
    "path": "Украина / Одесская область / Саврань",
    "country": "Украина",
    "searchString": "саврань украина / одесская область / саврань"
  },
  "3172": {
    "id": "3172",
    "name": "Сарата",
    "path": "Украина / Одесская область / Сарата",
    "country": "Украина",
    "searchString": "сарата украина / одесская область / сарата"
  },
  "3173": {
    "id": "3173",
    "name": "Тарутино",
    "path": "Украина / Одесская область / Тарутино",
    "country": "Украина",
    "searchString": "тарутино украина / одесская область / тарутино"
  },
  "3174": {
    "id": "3174",
    "name": "Татарбунары",
    "path": "Украина / Одесская область / Татарбунары",
    "country": "Украина",
    "searchString": "татарбунары украина / одесская область / татарбунары"
  },
  "3175": {
    "id": "3175",
    "name": "Фрунзовка",
    "path": "Украина / Одесская область / Фрунзовка",
    "country": "Украина",
    "searchString": "фрунзовка украина / одесская область / фрунзовка"
  },
  "3176": {
    "id": "3176",
    "name": "Ширяево",
    "path": "Украина / Одесская область / Ширяево",
    "country": "Украина",
    "searchString": "ширяево украина / одесская область / ширяево"
  },
  "3177": {
    "id": "3177",
    "name": "Южный (Одесская область)",
    "path": "Украина / Одесская область / Южный (Одесская область)",
    "country": "Украина",
    "searchString": "южный (одесская область) украина / одесская область / южный (одесская область)"
  },
  "3178": {
    "id": "3178",
    "name": "Борислав",
    "path": "Украина / Львовская область / Борислав",
    "country": "Украина",
    "searchString": "борислав украина / львовская область / борислав"
  },
  "3179": {
    "id": "3179",
    "name": "Броды",
    "path": "Украина / Львовская область / Броды",
    "country": "Украина",
    "searchString": "броды украина / львовская область / броды"
  },
  "3180": {
    "id": "3180",
    "name": "Буск",
    "path": "Украина / Львовская область / Буск",
    "country": "Украина",
    "searchString": "буск украина / львовская область / буск"
  },
  "3181": {
    "id": "3181",
    "name": "Городок (Львовская область)",
    "path": "Украина / Львовская область / Городок (Львовская область)",
    "country": "Украина",
    "searchString": "городок (львовская область) украина / львовская область / городок (львовская область)"
  },
  "3182": {
    "id": "3182",
    "name": "Добромиль",
    "path": "Украина / Львовская область / Добромиль",
    "country": "Украина",
    "searchString": "добромиль украина / львовская область / добромиль"
  },
  "3183": {
    "id": "3183",
    "name": "Жидачов",
    "path": "Украина / Львовская область / Жидачов",
    "country": "Украина",
    "searchString": "жидачов украина / львовская область / жидачов"
  },
  "3184": {
    "id": "3184",
    "name": "Жолква",
    "path": "Украина / Львовская область / Жолква",
    "country": "Украина",
    "searchString": "жолква украина / львовская область / жолква"
  },
  "3185": {
    "id": "3185",
    "name": "Золочев (Львовская область)",
    "path": "Украина / Львовская область / Золочев (Львовская область)",
    "country": "Украина",
    "searchString": "золочев (львовская область) украина / львовская область / золочев (львовская область)"
  },
  "3186": {
    "id": "3186",
    "name": "Моршин",
    "path": "Украина / Львовская область / Моршин",
    "country": "Украина",
    "searchString": "моршин украина / львовская область / моршин"
  },
  "3187": {
    "id": "3187",
    "name": "Мостиска",
    "path": "Украина / Львовская область / Мостиска",
    "country": "Украина",
    "searchString": "мостиска украина / львовская область / мостиска"
  },
  "3188": {
    "id": "3188",
    "name": "Новояворовск",
    "path": "Украина / Львовская область / Новояворовск",
    "country": "Украина",
    "searchString": "новояворовск украина / львовская область / новояворовск"
  },
  "3189": {
    "id": "3189",
    "name": "Перемышляны",
    "path": "Украина / Львовская область / Перемышляны",
    "country": "Украина",
    "searchString": "перемышляны украина / львовская область / перемышляны"
  },
  "3190": {
    "id": "3190",
    "name": "Пустомыты",
    "path": "Украина / Львовская область / Пустомыты",
    "country": "Украина",
    "searchString": "пустомыты украина / львовская область / пустомыты"
  },
  "3191": {
    "id": "3191",
    "name": "Рава-Русская",
    "path": "Украина / Львовская область / Рава-Русская",
    "country": "Украина",
    "searchString": "рава-русская украина / львовская область / рава-русская"
  },
  "3192": {
    "id": "3192",
    "name": "Радехов",
    "path": "Украина / Львовская область / Радехов",
    "country": "Украина",
    "searchString": "радехов украина / львовская область / радехов"
  },
  "3193": {
    "id": "3193",
    "name": "Роздол",
    "path": "Украина / Львовская область / Роздол",
    "country": "Украина",
    "searchString": "роздол украина / львовская область / роздол"
  },
  "3194": {
    "id": "3194",
    "name": "Самбор",
    "path": "Украина / Львовская область / Самбор",
    "country": "Украина",
    "searchString": "самбор украина / львовская область / самбор"
  },
  "3195": {
    "id": "3195",
    "name": "Сколе",
    "path": "Украина / Львовская область / Сколе",
    "country": "Украина",
    "searchString": "сколе украина / львовская область / сколе"
  },
  "3196": {
    "id": "3196",
    "name": "Сокаль",
    "path": "Украина / Львовская область / Сокаль",
    "country": "Украина",
    "searchString": "сокаль украина / львовская область / сокаль"
  },
  "3197": {
    "id": "3197",
    "name": "Старый Самбор",
    "path": "Украина / Львовская область / Старый Самбор",
    "country": "Украина",
    "searchString": "старый самбор украина / львовская область / старый самбор"
  },
  "3198": {
    "id": "3198",
    "name": "Трускавец",
    "path": "Украина / Львовская область / Трускавец",
    "country": "Украина",
    "searchString": "трускавец украина / львовская область / трускавец"
  },
  "3199": {
    "id": "3199",
    "name": "Турка",
    "path": "Украина / Львовская область / Турка",
    "country": "Украина",
    "searchString": "турка украина / львовская область / турка"
  },
  "3200": {
    "id": "3200",
    "name": "Яворов",
    "path": "Украина / Львовская область / Яворов",
    "country": "Украина",
    "searchString": "яворов украина / львовская область / яворов"
  },
  "3201": {
    "id": "3201",
    "name": "Акимовка",
    "path": "Россия / Запорожская область / Акимовка",
    "country": "Россия",
    "searchString": "акимовка россия / запорожская область / акимовка"
  },
  "3202": {
    "id": "3202",
    "name": "Большая Белозерка",
    "path": "Россия / Запорожская область / Большая Белозерка",
    "country": "Россия",
    "searchString": "большая белозерка россия / запорожская область / большая белозерка"
  },
  "3203": {
    "id": "3203",
    "name": "Васильевка",
    "path": "Россия / Запорожская область / Васильевка",
    "country": "Россия",
    "searchString": "васильевка россия / запорожская область / васильевка"
  },
  "3204": {
    "id": "3204",
    "name": "Воротынец",
    "path": "Россия / Нижегородская область / Воротынец",
    "country": "Россия",
    "searchString": "воротынец россия / нижегородская область / воротынец"
  },
  "3205": {
    "id": "3205",
    "name": "Веселое",
    "path": "Россия / Запорожская область / Веселое",
    "country": "Россия",
    "searchString": "веселое россия / запорожская область / веселое"
  },
  "3206": {
    "id": "3206",
    "name": "Вольнянск",
    "path": "Россия / Запорожская область / Вольнянск",
    "country": "Россия",
    "searchString": "вольнянск россия / запорожская область / вольнянск"
  },
  "3207": {
    "id": "3207",
    "name": "Днепрорудное",
    "path": "Россия / Запорожская область / Днепрорудное",
    "country": "Россия",
    "searchString": "днепрорудное россия / запорожская область / днепрорудное"
  },
  "3208": {
    "id": "3208",
    "name": "Каменка-Днепровская",
    "path": "Россия / Запорожская область / Каменка-Днепровская",
    "country": "Россия",
    "searchString": "каменка-днепровская россия / запорожская область / каменка-днепровская"
  },
  "3209": {
    "id": "3209",
    "name": "Кирилловка",
    "path": "Россия / Запорожская область / Кирилловка",
    "country": "Россия",
    "searchString": "кирилловка россия / запорожская область / кирилловка"
  },
  "3210": {
    "id": "3210",
    "name": "Михайловка (Запорожская область)",
    "path": "Россия / Запорожская область / Михайловка (Запорожская область)",
    "country": "Россия",
    "searchString": "михайловка (запорожская область) россия / запорожская область / михайловка (запорожская область)"
  },
  "3211": {
    "id": "3211",
    "name": "Орехов",
    "path": "Россия / Запорожская область / Орехов",
    "country": "Россия",
    "searchString": "орехов россия / запорожская область / орехов"
  },
  "3212": {
    "id": "3212",
    "name": "Пологи",
    "path": "Россия / Запорожская область / Пологи",
    "country": "Россия",
    "searchString": "пологи россия / запорожская область / пологи"
  },
  "3213": {
    "id": "3213",
    "name": "Приазовское",
    "path": "Россия / Запорожская область / Приазовское",
    "country": "Россия",
    "searchString": "приазовское россия / запорожская область / приазовское"
  },
  "3214": {
    "id": "3214",
    "name": "Приморск (Запорожская область)",
    "path": "Россия / Запорожская область / Приморск (Запорожская область)",
    "country": "Россия",
    "searchString": "приморск (запорожская область) россия / запорожская область / приморск (запорожская область)"
  },
  "3215": {
    "id": "3215",
    "name": "Токмак",
    "path": "Россия / Запорожская область / Токмак",
    "country": "Россия",
    "searchString": "токмак россия / запорожская область / токмак"
  },
  "3216": {
    "id": "3216",
    "name": "Черниговка",
    "path": "Россия / Запорожская область / Черниговка",
    "country": "Россия",
    "searchString": "черниговка россия / запорожская область / черниговка"
  },
  "3217": {
    "id": "3217",
    "name": "Великая Багачка",
    "path": "Украина / Полтавская область / Великая Багачка",
    "country": "Украина",
    "searchString": "великая багачка украина / полтавская область / великая багачка"
  },
  "3218": {
    "id": "3218",
    "name": "Гадяч",
    "path": "Украина / Полтавская область / Гадяч",
    "country": "Украина",
    "searchString": "гадяч украина / полтавская область / гадяч"
  },
  "3219": {
    "id": "3219",
    "name": "Глобино",
    "path": "Украина / Полтавская область / Глобино",
    "country": "Украина",
    "searchString": "глобино украина / полтавская область / глобино"
  },
  "3220": {
    "id": "3220",
    "name": "Гребенка",
    "path": "Украина / Полтавская область / Гребенка",
    "country": "Украина",
    "searchString": "гребенка украина / полтавская область / гребенка"
  },
  "3221": {
    "id": "3221",
    "name": "Диканька",
    "path": "Украина / Полтавская область / Диканька",
    "country": "Украина",
    "searchString": "диканька украина / полтавская область / диканька"
  },
  "3222": {
    "id": "3222",
    "name": "Зеньков",
    "path": "Украина / Полтавская область / Зеньков",
    "country": "Украина",
    "searchString": "зеньков украина / полтавская область / зеньков"
  },
  "3223": {
    "id": "3223",
    "name": "Карловка",
    "path": "Украина / Полтавская область / Карловка",
    "country": "Украина",
    "searchString": "карловка украина / полтавская область / карловка"
  },
  "3224": {
    "id": "3224",
    "name": "Кобеляки",
    "path": "Украина / Полтавская область / Кобеляки",
    "country": "Украина",
    "searchString": "кобеляки украина / полтавская область / кобеляки"
  },
  "3225": {
    "id": "3225",
    "name": "Козельщина",
    "path": "Украина / Полтавская область / Козельщина",
    "country": "Украина",
    "searchString": "козельщина украина / полтавская область / козельщина"
  },
  "3226": {
    "id": "3226",
    "name": "Котельва",
    "path": "Украина / Полтавская область / Котельва",
    "country": "Украина",
    "searchString": "котельва украина / полтавская область / котельва"
  },
  "3227": {
    "id": "3227",
    "name": "Лохвица",
    "path": "Украина / Полтавская область / Лохвица",
    "country": "Украина",
    "searchString": "лохвица украина / полтавская область / лохвица"
  },
  "3228": {
    "id": "3228",
    "name": "Машевка",
    "path": "Украина / Полтавская область / Машевка",
    "country": "Украина",
    "searchString": "машевка украина / полтавская область / машевка"
  },
  "3229": {
    "id": "3229",
    "name": "Новые Санжары",
    "path": "Украина / Полтавская область / Новые Санжары",
    "country": "Украина",
    "searchString": "новые санжары украина / полтавская область / новые санжары"
  },
  "3230": {
    "id": "3230",
    "name": "Оржица",
    "path": "Украина / Полтавская область / Оржица",
    "country": "Украина",
    "searchString": "оржица украина / полтавская область / оржица"
  },
  "3231": {
    "id": "3231",
    "name": "Пирятин",
    "path": "Украина / Полтавская область / Пирятин",
    "country": "Украина",
    "searchString": "пирятин украина / полтавская область / пирятин"
  },
  "3232": {
    "id": "3232",
    "name": "Решетиловка",
    "path": "Украина / Полтавская область / Решетиловка",
    "country": "Украина",
    "searchString": "решетиловка украина / полтавская область / решетиловка"
  },
  "3233": {
    "id": "3233",
    "name": "Семеновка (Полтавская область)",
    "path": "Украина / Полтавская область / Семеновка (Полтавская область)",
    "country": "Украина",
    "searchString": "семеновка (полтавская область) украина / полтавская область / семеновка (полтавская область)"
  },
  "3234": {
    "id": "3234",
    "name": "Хорол",
    "path": "Украина / Полтавская область / Хорол",
    "country": "Украина",
    "searchString": "хорол украина / полтавская область / хорол"
  },
  "3235": {
    "id": "3235",
    "name": "Чернухи",
    "path": "Украина / Полтавская область / Чернухи",
    "country": "Украина",
    "searchString": "чернухи украина / полтавская область / чернухи"
  },
  "3236": {
    "id": "3236",
    "name": "Чутово",
    "path": "Украина / Полтавская область / Чутово",
    "country": "Украина",
    "searchString": "чутово украина / полтавская область / чутово"
  },
  "3237": {
    "id": "3237",
    "name": "Шишаки",
    "path": "Украина / Полтавская область / Шишаки",
    "country": "Украина",
    "searchString": "шишаки украина / полтавская область / шишаки"
  },
  "3238": {
    "id": "3238",
    "name": "Авдеевка",
    "path": "Россия / Донецкая Народная Республика / Авдеевка",
    "country": "Россия",
    "searchString": "авдеевка россия / донецкая народная республика / авдеевка"
  },
  "3239": {
    "id": "3239",
    "name": "Александровка (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Александровка (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "александровка (донецкая народная республика) россия / донецкая народная республика / александровка (донецкая народная республика)"
  },
  "3240": {
    "id": "3240",
    "name": "Амвросиевка",
    "path": "Россия / Донецкая Народная Республика / Амвросиевка",
    "country": "Россия",
    "searchString": "амвросиевка россия / донецкая народная республика / амвросиевка"
  },
  "3241": {
    "id": "3241",
    "name": "Светлодарск",
    "path": "Россия / Донецкая Народная Республика / Светлодарск",
    "country": "Россия",
    "searchString": "светлодарск россия / донецкая народная республика / светлодарск"
  },
  "3242": {
    "id": "3242",
    "name": "Белозерское",
    "path": "Россия / Донецкая Народная Республика / Белозерское",
    "country": "Россия",
    "searchString": "белозерское россия / донецкая народная республика / белозерское"
  },
  "3243": {
    "id": "3243",
    "name": "Великая Новоселка",
    "path": "Россия / Донецкая Народная Республика / Великая Новоселка",
    "country": "Россия",
    "searchString": "великая новоселка россия / донецкая народная республика / великая новоселка"
  },
  "3244": {
    "id": "3244",
    "name": "Волноваха",
    "path": "Россия / Донецкая Народная Республика / Волноваха",
    "country": "Россия",
    "searchString": "волноваха россия / донецкая народная республика / волноваха"
  },
  "3245": {
    "id": "3245",
    "name": "Володарское (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Володарское (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "володарское (донецкая народная республика) россия / донецкая народная республика / володарское (донецкая народная республика)"
  },
  "3246": {
    "id": "3246",
    "name": "Дебальцево",
    "path": "Россия / Донецкая Народная Республика / Дебальцево",
    "country": "Россия",
    "searchString": "дебальцево россия / донецкая народная республика / дебальцево"
  },
  "3247": {
    "id": "3247",
    "name": "Дзержинск (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Дзержинск (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "дзержинск (донецкая народная республика) россия / донецкая народная республика / дзержинск (донецкая народная республика)"
  },
  "3248": {
    "id": "3248",
    "name": "Димитров",
    "path": "Россия / Донецкая Народная Республика / Димитров",
    "country": "Россия",
    "searchString": "димитров россия / донецкая народная республика / димитров"
  },
  "3249": {
    "id": "3249",
    "name": "Доброполье",
    "path": "Россия / Донецкая Народная Республика / Доброполье",
    "country": "Россия",
    "searchString": "доброполье россия / донецкая народная республика / доброполье"
  },
  "3250": {
    "id": "3250",
    "name": "Докучаевск",
    "path": "Россия / Донецкая Народная Республика / Докучаевск",
    "country": "Россия",
    "searchString": "докучаевск россия / донецкая народная республика / докучаевск"
  },
  "3251": {
    "id": "3251",
    "name": "Зугрэс",
    "path": "Россия / Донецкая Народная Республика / Зугрэс",
    "country": "Россия",
    "searchString": "зугрэс россия / донецкая народная республика / зугрэс"
  },
  "3252": {
    "id": "3252",
    "name": "Ахтырский",
    "path": "Россия / Краснодарский край / Ахтырский",
    "country": "Россия",
    "searchString": "ахтырский россия / краснодарский край / ахтырский"
  },
  "3253": {
    "id": "3253",
    "name": "Кировское (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Кировское (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "кировское (донецкая народная республика) россия / донецкая народная республика / кировское (донецкая народная республика)"
  },
  "3254": {
    "id": "3254",
    "name": "Покровск (Донецкая область)",
    "path": "Россия / Донецкая Народная Республика / Покровск (Донецкая область)",
    "country": "Россия",
    "searchString": "покровск (донецкая область) россия / донецкая народная республика / покровск (донецкая область)"
  },
  "3255": {
    "id": "3255",
    "name": "Красный Лиман",
    "path": "Россия / Донецкая Народная Республика / Красный Лиман",
    "country": "Россия",
    "searchString": "красный лиман россия / донецкая народная республика / красный лиман"
  },
  "3256": {
    "id": "3256",
    "name": "Мангуш",
    "path": "Россия / Донецкая Народная Республика / Мангуш",
    "country": "Россия",
    "searchString": "мангуш россия / донецкая народная республика / мангуш"
  },
  "3257": {
    "id": "3257",
    "name": "Белая Глина",
    "path": "Россия / Краснодарский край / Белая Глина",
    "country": "Россия",
    "searchString": "белая глина россия / краснодарский край / белая глина"
  },
  "3258": {
    "id": "3258",
    "name": "Марьинка",
    "path": "Россия / Донецкая Народная Республика / Марьинка",
    "country": "Россия",
    "searchString": "марьинка россия / донецкая народная республика / марьинка"
  },
  "3259": {
    "id": "3259",
    "name": "Моспино",
    "path": "Россия / Донецкая Народная Республика / Моспино",
    "country": "Россия",
    "searchString": "моспино россия / донецкая народная республика / моспино"
  },
  "3260": {
    "id": "3260",
    "name": "Новоазовск",
    "path": "Россия / Донецкая Народная Республика / Новоазовск",
    "country": "Россия",
    "searchString": "новоазовск россия / донецкая народная республика / новоазовск"
  },
  "3261": {
    "id": "3261",
    "name": "Белозерный",
    "path": "Россия / Краснодарский край / Белозерный",
    "country": "Россия",
    "searchString": "белозерный россия / краснодарский край / белозерный"
  },
  "3262": {
    "id": "3262",
    "name": "Новогродовка",
    "path": "Россия / Донецкая Народная Республика / Новогродовка",
    "country": "Россия",
    "searchString": "новогродовка россия / донецкая народная республика / новогродовка"
  },
  "3263": {
    "id": "3263",
    "name": "Родинское",
    "path": "Россия / Донецкая Народная Республика / Родинское",
    "country": "Россия",
    "searchString": "родинское россия / донецкая народная республика / родинское"
  },
  "3264": {
    "id": "3264",
    "name": "Селидово",
    "path": "Россия / Донецкая Народная Республика / Селидово",
    "country": "Россия",
    "searchString": "селидово россия / донецкая народная республика / селидово"
  },
  "3265": {
    "id": "3265",
    "name": "Соледар",
    "path": "Россия / Донецкая Народная Республика / Соледар",
    "country": "Россия",
    "searchString": "соледар россия / донецкая народная республика / соледар"
  },
  "3266": {
    "id": "3266",
    "name": "Старобешево",
    "path": "Россия / Донецкая Народная Республика / Старобешево",
    "country": "Россия",
    "searchString": "старобешево россия / донецкая народная республика / старобешево"
  },
  "3267": {
    "id": "3267",
    "name": "Березанская",
    "path": "Россия / Краснодарский край / Березанская",
    "country": "Россия",
    "searchString": "березанская россия / краснодарский край / березанская"
  },
  "3268": {
    "id": "3268",
    "name": "Тельманово",
    "path": "Россия / Донецкая Народная Республика / Тельманово",
    "country": "Россия",
    "searchString": "тельманово россия / донецкая народная республика / тельманово"
  },
  "3269": {
    "id": "3269",
    "name": "Угледар",
    "path": "Россия / Донецкая Народная Республика / Угледар",
    "country": "Россия",
    "searchString": "угледар россия / донецкая народная республика / угледар"
  },
  "3270": {
    "id": "3270",
    "name": "Васюринская",
    "path": "Россия / Краснодарский край / Васюринская",
    "country": "Россия",
    "searchString": "васюринская россия / краснодарский край / васюринская"
  },
  "3271": {
    "id": "3271",
    "name": "Дагомыс",
    "path": "Россия / Краснодарский край / Дагомыс",
    "country": "Россия",
    "searchString": "дагомыс россия / краснодарский край / дагомыс"
  },
  "3272": {
    "id": "3272",
    "name": "Джубга",
    "path": "Россия / Краснодарский край / Джубга",
    "country": "Россия",
    "searchString": "джубга россия / краснодарский край / джубга"
  },
  "3273": {
    "id": "3273",
    "name": "Ивановская",
    "path": "Россия / Краснодарский край / Ивановская",
    "country": "Россия",
    "searchString": "ивановская россия / краснодарский край / ивановская"
  },
  "3274": {
    "id": "3274",
    "name": "Ильинская",
    "path": "Россия / Краснодарский край / Ильинская",
    "country": "Россия",
    "searchString": "ильинская россия / краснодарский край / ильинская"
  },
  "3275": {
    "id": "3275",
    "name": "Ильский",
    "path": "Россия / Краснодарский край / Ильский",
    "country": "Россия",
    "searchString": "ильский россия / краснодарский край / ильский"
  },
  "3276": {
    "id": "3276",
    "name": "Кавказская",
    "path": "Россия / Краснодарский край / Кавказская",
    "country": "Россия",
    "searchString": "кавказская россия / краснодарский край / кавказская"
  },
  "3277": {
    "id": "3277",
    "name": "Коноково",
    "path": "Россия / Краснодарский край / Коноково",
    "country": "Россия",
    "searchString": "коноково россия / краснодарский край / коноково"
  },
  "3278": {
    "id": "3278",
    "name": "Ладожская",
    "path": "Россия / Краснодарский край / Ладожская",
    "country": "Россия",
    "searchString": "ладожская россия / краснодарский край / ладожская"
  },
  "3279": {
    "id": "3279",
    "name": "Львовское",
    "path": "Россия / Краснодарский край / Львовское",
    "country": "Россия",
    "searchString": "львовское россия / краснодарский край / львовское"
  },
  "3280": {
    "id": "3280",
    "name": "Медведовская",
    "path": "Россия / Краснодарский край / Медведовская",
    "country": "Россия",
    "searchString": "медведовская россия / краснодарский край / медведовская"
  },
  "3281": {
    "id": "3281",
    "name": "Нижнебаканская",
    "path": "Россия / Краснодарский край / Нижнебаканская",
    "country": "Россия",
    "searchString": "нижнебаканская россия / краснодарский край / нижнебаканская"
  },
  "3282": {
    "id": "3282",
    "name": "Нововеличковская",
    "path": "Россия / Краснодарский край / Нововеличковская",
    "country": "Россия",
    "searchString": "нововеличковская россия / краснодарский край / нововеличковская"
  },
  "3283": {
    "id": "3283",
    "name": "Новопокровская",
    "path": "Россия / Краснодарский край / Новопокровская",
    "country": "Россия",
    "searchString": "новопокровская россия / краснодарский край / новопокровская"
  },
  "3284": {
    "id": "3284",
    "name": "Новорождественская",
    "path": "Россия / Краснодарский край / Новорождественская",
    "country": "Россия",
    "searchString": "новорождественская россия / краснодарский край / новорождественская"
  },
  "3285": {
    "id": "3285",
    "name": "Октябрьская (Крыловский район,Краснодарский край)",
    "path": "Россия / Краснодарский край / Октябрьская (Крыловский район,Краснодарский край)",
    "country": "Россия",
    "searchString": "октябрьская (крыловский район,краснодарский край) россия / краснодарский край / октябрьская (крыловский район,краснодарский край)"
  },
  "3286": {
    "id": "3286",
    "name": "Отрадная",
    "path": "Россия / Краснодарский край / Отрадная",
    "country": "Россия",
    "searchString": "отрадная россия / краснодарский край / отрадная"
  },
  "3287": {
    "id": "3287",
    "name": "Платнировская",
    "path": "Россия / Краснодарский край / Платнировская",
    "country": "Россия",
    "searchString": "платнировская россия / краснодарский край / платнировская"
  },
  "3288": {
    "id": "3288",
    "name": "Полтавская",
    "path": "Россия / Краснодарский край / Полтавская",
    "country": "Россия",
    "searchString": "полтавская россия / краснодарский край / полтавская"
  },
  "3289": {
    "id": "3289",
    "name": "Псебай",
    "path": "Россия / Краснодарский край / Псебай",
    "country": "Россия",
    "searchString": "псебай россия / краснодарский край / псебай"
  },
  "3290": {
    "id": "3290",
    "name": "Рязанская",
    "path": "Россия / Краснодарский край / Рязанская",
    "country": "Россия",
    "searchString": "рязанская россия / краснодарский край / рязанская"
  },
  "3291": {
    "id": "3291",
    "name": "Смоленская",
    "path": "Россия / Краснодарский край / Смоленская",
    "country": "Россия",
    "searchString": "смоленская россия / краснодарский край / смоленская"
  },
  "3292": {
    "id": "3292",
    "name": "Советская",
    "path": "Россия / Краснодарский край / Советская",
    "country": "Россия",
    "searchString": "советская россия / краснодарский край / советская"
  },
  "3293": {
    "id": "3293",
    "name": "Ставропольская",
    "path": "Россия / Краснодарский край / Ставропольская",
    "country": "Россия",
    "searchString": "ставропольская россия / краснодарский край / ставропольская"
  },
  "3294": {
    "id": "3294",
    "name": "Стародеревянковская",
    "path": "Россия / Краснодарский край / Стародеревянковская",
    "country": "Россия",
    "searchString": "стародеревянковская россия / краснодарский край / стародеревянковская"
  },
  "3295": {
    "id": "3295",
    "name": "Старотитаровская",
    "path": "Россия / Краснодарский край / Старотитаровская",
    "country": "Россия",
    "searchString": "старотитаровская россия / краснодарский край / старотитаровская"
  },
  "3296": {
    "id": "3296",
    "name": "Старомышастовская",
    "path": "Россия / Краснодарский край / Старомышастовская",
    "country": "Россия",
    "searchString": "старомышастовская россия / краснодарский край / старомышастовская"
  },
  "3297": {
    "id": "3297",
    "name": "Старощербиновская",
    "path": "Россия / Краснодарский край / Старощербиновская",
    "country": "Россия",
    "searchString": "старощербиновская россия / краснодарский край / старощербиновская"
  },
  "3298": {
    "id": "3298",
    "name": "Терновская",
    "path": "Россия / Краснодарский край / Терновская",
    "country": "Россия",
    "searchString": "терновская россия / краснодарский край / терновская"
  },
  "3299": {
    "id": "3299",
    "name": "Троицкая",
    "path": "Россия / Краснодарский край / Троицкая",
    "country": "Россия",
    "searchString": "троицкая россия / краснодарский край / троицкая"
  },
  "3300": {
    "id": "3300",
    "name": "Трудобеликовский",
    "path": "Россия / Краснодарский край / Трудобеликовский",
    "country": "Россия",
    "searchString": "трудобеликовский россия / краснодарский край / трудобеликовский"
  },
  "3301": {
    "id": "3301",
    "name": "Успенское (Краснодарский край)",
    "path": "Россия / Краснодарский край / Успенское (Краснодарский край)",
    "country": "Россия",
    "searchString": "успенское (краснодарский край) россия / краснодарский край / успенское (краснодарский край)"
  },
  "3302": {
    "id": "3302",
    "name": "Холмская",
    "path": "Россия / Краснодарский край / Холмская",
    "country": "Россия",
    "searchString": "холмская россия / краснодарский край / холмская"
  },
  "3303": {
    "id": "3303",
    "name": "Абрау-Дюрсо",
    "path": "Россия / Краснодарский край / Абрау-Дюрсо",
    "country": "Россия",
    "searchString": "абрау-дюрсо россия / краснодарский край / абрау-дюрсо"
  },
  "3304": {
    "id": "3304",
    "name": "Азовская",
    "path": "Россия / Краснодарский край / Азовская",
    "country": "Россия",
    "searchString": "азовская россия / краснодарский край / азовская"
  },
  "3305": {
    "id": "3305",
    "name": "Анапская",
    "path": "Россия / Краснодарский край / Анапская",
    "country": "Россия",
    "searchString": "анапская россия / краснодарский край / анапская"
  },
  "3306": {
    "id": "3306",
    "name": "Анастасиевская",
    "path": "Россия / Краснодарский край / Анастасиевская",
    "country": "Россия",
    "searchString": "анастасиевская россия / краснодарский край / анастасиевская"
  },
  "3307": {
    "id": "3307",
    "name": "Архангельская",
    "path": "Россия / Краснодарский край / Архангельская",
    "country": "Россия",
    "searchString": "архангельская россия / краснодарский край / архангельская"
  },
  "3308": {
    "id": "3308",
    "name": "Атаманская",
    "path": "Россия / Краснодарский край / Атаманская",
    "country": "Россия",
    "searchString": "атаманская россия / краснодарский край / атаманская"
  },
  "3310": {
    "id": "3310",
    "name": "Бесскорбная",
    "path": "Россия / Краснодарский край / Бесскорбная",
    "country": "Россия",
    "searchString": "бесскорбная россия / краснодарский край / бесскорбная"
  },
  "3311": {
    "id": "3311",
    "name": "Бриньковская",
    "path": "Россия / Краснодарский край / Бриньковская",
    "country": "Россия",
    "searchString": "бриньковская россия / краснодарский край / бриньковская"
  },
  "3312": {
    "id": "3312",
    "name": "Варениковская",
    "path": "Россия / Краснодарский край / Варениковская",
    "country": "Россия",
    "searchString": "варениковская россия / краснодарский край / варениковская"
  },
  "3313": {
    "id": "3313",
    "name": "Великовечное",
    "path": "Россия / Краснодарский край / Великовечное",
    "country": "Россия",
    "searchString": "великовечное россия / краснодарский край / великовечное"
  },
  "3314": {
    "id": "3314",
    "name": "Верхнебаканский",
    "path": "Россия / Краснодарский край / Верхнебаканский",
    "country": "Россия",
    "searchString": "верхнебаканский россия / краснодарский край / верхнебаканский"
  },
  "3315": {
    "id": "3315",
    "name": "Витязево",
    "path": "Россия / Краснодарский край / Витязево",
    "country": "Россия",
    "searchString": "витязево россия / краснодарский край / витязево"
  },
  "3316": {
    "id": "3316",
    "name": "Гайдук",
    "path": "Россия / Краснодарский край / Гайдук",
    "country": "Россия",
    "searchString": "гайдук россия / краснодарский край / гайдук"
  },
  "3317": {
    "id": "3317",
    "name": "Голубицкая",
    "path": "Россия / Краснодарский край / Голубицкая",
    "country": "Россия",
    "searchString": "голубицкая россия / краснодарский край / голубицкая"
  },
  "3318": {
    "id": "3318",
    "name": "Гостагаевская",
    "path": "Россия / Краснодарский край / Гостагаевская",
    "country": "Россия",
    "searchString": "гостагаевская россия / краснодарский край / гостагаевская"
  },
  "3319": {
    "id": "3319",
    "name": "Гривенская",
    "path": "Россия / Краснодарский край / Гривенская",
    "country": "Россия",
    "searchString": "гривенская россия / краснодарский край / гривенская"
  },
  "3320": {
    "id": "3320",
    "name": "Двубратский",
    "path": "Россия / Краснодарский край / Двубратский",
    "country": "Россия",
    "searchString": "двубратский россия / краснодарский край / двубратский"
  },
  "3321": {
    "id": "3321",
    "name": "Должанская",
    "path": "Россия / Краснодарский край / Должанская",
    "country": "Россия",
    "searchString": "должанская россия / краснодарский край / должанская"
  },
  "3322": {
    "id": "3322",
    "name": "Елизаветинская",
    "path": "Россия / Краснодарский край / Елизаветинская",
    "country": "Россия",
    "searchString": "елизаветинская россия / краснодарский край / елизаветинская"
  },
  "3323": {
    "id": "3323",
    "name": "Казанская",
    "path": "Россия / Краснодарский край / Казанская",
    "country": "Россия",
    "searchString": "казанская россия / краснодарский край / казанская"
  },
  "3324": {
    "id": "3324",
    "name": "Камышеватская",
    "path": "Россия / Краснодарский край / Камышеватская",
    "country": "Россия",
    "searchString": "камышеватская россия / краснодарский край / камышеватская"
  },
  "3325": {
    "id": "3325",
    "name": "Кирпильская",
    "path": "Россия / Краснодарский край / Кирпильская",
    "country": "Россия",
    "searchString": "кирпильская россия / краснодарский край / кирпильская"
  },
  "3326": {
    "id": "3326",
    "name": "Кисляковская",
    "path": "Россия / Краснодарский край / Кисляковская",
    "country": "Россия",
    "searchString": "кисляковская россия / краснодарский край / кисляковская"
  },
  "3327": {
    "id": "3327",
    "name": "Марьянская",
    "path": "Россия / Краснодарский край / Марьянская",
    "country": "Россия",
    "searchString": "марьянская россия / краснодарский край / марьянская"
  },
  "3328": {
    "id": "3328",
    "name": "Мингрельская",
    "path": "Россия / Краснодарский край / Мингрельская",
    "country": "Россия",
    "searchString": "мингрельская россия / краснодарский край / мингрельская"
  },
  "3329": {
    "id": "3329",
    "name": "Михайловская",
    "path": "Россия / Краснодарский край / Михайловская",
    "country": "Россия",
    "searchString": "михайловская россия / краснодарский край / михайловская"
  },
  "3330": {
    "id": "3330",
    "name": "Некрасовская",
    "path": "Россия / Краснодарский край / Некрасовская",
    "country": "Россия",
    "searchString": "некрасовская россия / краснодарский край / некрасовская"
  },
  "3331": {
    "id": "3331",
    "name": "Бар",
    "path": "Украина / Винницкая область / Бар",
    "country": "Украина",
    "searchString": "бар украина / винницкая область / бар"
  },
  "3332": {
    "id": "3332",
    "name": "Бершадь",
    "path": "Украина / Винницкая область / Бершадь",
    "country": "Украина",
    "searchString": "бершадь украина / винницкая область / бершадь"
  },
  "3333": {
    "id": "3333",
    "name": "Гайсин",
    "path": "Украина / Винницкая область / Гайсин",
    "country": "Украина",
    "searchString": "гайсин украина / винницкая область / гайсин"
  },
  "3334": {
    "id": "3334",
    "name": "Жмеринка",
    "path": "Украина / Винницкая область / Жмеринка",
    "country": "Украина",
    "searchString": "жмеринка украина / винницкая область / жмеринка"
  },
  "3335": {
    "id": "3335",
    "name": "Ильинцы",
    "path": "Украина / Винницкая область / Ильинцы",
    "country": "Украина",
    "searchString": "ильинцы украина / винницкая область / ильинцы"
  },
  "3336": {
    "id": "3336",
    "name": "Казатин",
    "path": "Украина / Винницкая область / Казатин",
    "country": "Украина",
    "searchString": "казатин украина / винницкая область / казатин"
  },
  "3337": {
    "id": "3337",
    "name": "Калиновка",
    "path": "Украина / Винницкая область / Калиновка",
    "country": "Украина",
    "searchString": "калиновка украина / винницкая область / калиновка"
  },
  "3338": {
    "id": "3338",
    "name": "Крыжополь",
    "path": "Украина / Винницкая область / Крыжополь",
    "country": "Украина",
    "searchString": "крыжополь украина / винницкая область / крыжополь"
  },
  "3339": {
    "id": "3339",
    "name": "Ладыжин",
    "path": "Украина / Винницкая область / Ладыжин",
    "country": "Украина",
    "searchString": "ладыжин украина / винницкая область / ладыжин"
  },
  "3340": {
    "id": "3340",
    "name": "Липовец",
    "path": "Украина / Винницкая область / Липовец",
    "country": "Украина",
    "searchString": "липовец украина / винницкая область / липовец"
  },
  "3341": {
    "id": "3341",
    "name": "Литин",
    "path": "Украина / Винницкая область / Литин",
    "country": "Украина",
    "searchString": "литин украина / винницкая область / литин"
  },
  "3342": {
    "id": "3342",
    "name": "Могилев-Подольский",
    "path": "Украина / Винницкая область / Могилев-Подольский",
    "country": "Украина",
    "searchString": "могилев-подольский украина / винницкая область / могилев-подольский"
  },
  "3343": {
    "id": "3343",
    "name": "Мурованые Куриловцы",
    "path": "Украина / Винницкая область / Мурованые Куриловцы",
    "country": "Украина",
    "searchString": "мурованые куриловцы украина / винницкая область / мурованые куриловцы"
  },
  "3344": {
    "id": "3344",
    "name": "Немиров",
    "path": "Украина / Винницкая область / Немиров",
    "country": "Украина",
    "searchString": "немиров украина / винницкая область / немиров"
  },
  "3345": {
    "id": "3345",
    "name": "Оратов",
    "path": "Украина / Винницкая область / Оратов",
    "country": "Украина",
    "searchString": "оратов украина / винницкая область / оратов"
  },
  "3346": {
    "id": "3346",
    "name": "Песчанка",
    "path": "Украина / Винницкая область / Песчанка",
    "country": "Украина",
    "searchString": "песчанка украина / винницкая область / песчанка"
  },
  "3347": {
    "id": "3347",
    "name": "Погребище",
    "path": "Украина / Винницкая область / Погребище",
    "country": "Украина",
    "searchString": "погребище украина / винницкая область / погребище"
  },
  "3348": {
    "id": "3348",
    "name": "Теплик",
    "path": "Украина / Винницкая область / Теплик",
    "country": "Украина",
    "searchString": "теплик украина / винницкая область / теплик"
  },
  "3349": {
    "id": "3349",
    "name": "Томашполь",
    "path": "Украина / Винницкая область / Томашполь",
    "country": "Украина",
    "searchString": "томашполь украина / винницкая область / томашполь"
  },
  "3350": {
    "id": "3350",
    "name": "Тростянец (Винницкая область)",
    "path": "Украина / Винницкая область / Тростянец (Винницкая область)",
    "country": "Украина",
    "searchString": "тростянец (винницкая область) украина / винницкая область / тростянец (винницкая область)"
  },
  "3351": {
    "id": "3351",
    "name": "Тульчин",
    "path": "Украина / Винницкая область / Тульчин",
    "country": "Украина",
    "searchString": "тульчин украина / винницкая область / тульчин"
  },
  "3352": {
    "id": "3352",
    "name": "Тывров",
    "path": "Украина / Винницкая область / Тывров",
    "country": "Украина",
    "searchString": "тывров украина / винницкая область / тывров"
  },
  "3353": {
    "id": "3353",
    "name": "Хмельник",
    "path": "Украина / Винницкая область / Хмельник",
    "country": "Украина",
    "searchString": "хмельник украина / винницкая область / хмельник"
  },
  "3354": {
    "id": "3354",
    "name": "Чечельник",
    "path": "Украина / Винницкая область / Чечельник",
    "country": "Украина",
    "searchString": "чечельник украина / винницкая область / чечельник"
  },
  "3355": {
    "id": "3355",
    "name": "Шаргород",
    "path": "Украина / Винницкая область / Шаргород",
    "country": "Украина",
    "searchString": "шаргород украина / винницкая область / шаргород"
  },
  "3356": {
    "id": "3356",
    "name": "Ямполь (Винницкая область)",
    "path": "Украина / Винницкая область / Ямполь (Винницкая область)",
    "country": "Украина",
    "searchString": "ямполь (винницкая область) украина / винницкая область / ямполь (винницкая область)"
  },
  "3357": {
    "id": "3357",
    "name": "Ватутино",
    "path": "Украина / Черкасская область / Ватутино",
    "country": "Украина",
    "searchString": "ватутино украина / черкасская область / ватутино"
  },
  "3358": {
    "id": "3358",
    "name": "Городище (Черкасская область)",
    "path": "Украина / Черкасская область / Городище (Черкасская область)",
    "country": "Украина",
    "searchString": "городище (черкасская область) украина / черкасская область / городище (черкасская область)"
  },
  "3359": {
    "id": "3359",
    "name": "Драбов",
    "path": "Украина / Черкасская область / Драбов",
    "country": "Украина",
    "searchString": "драбов украина / черкасская область / драбов"
  },
  "3360": {
    "id": "3360",
    "name": "Звенигородка",
    "path": "Украина / Черкасская область / Звенигородка",
    "country": "Украина",
    "searchString": "звенигородка украина / черкасская область / звенигородка"
  },
  "3361": {
    "id": "3361",
    "name": "Золотоноша",
    "path": "Украина / Черкасская область / Золотоноша",
    "country": "Украина",
    "searchString": "золотоноша украина / черкасская область / золотоноша"
  },
  "3362": {
    "id": "3362",
    "name": "Каменка (Черкасская область)",
    "path": "Украина / Черкасская область / Каменка (Черкасская область)",
    "country": "Украина",
    "searchString": "каменка (черкасская область) украина / черкасская область / каменка (черкасская область)"
  },
  "3363": {
    "id": "3363",
    "name": "Канев",
    "path": "Украина / Черкасская область / Канев",
    "country": "Украина",
    "searchString": "канев украина / черкасская область / канев"
  },
  "3364": {
    "id": "3364",
    "name": "Катеринополь",
    "path": "Украина / Черкасская область / Катеринополь",
    "country": "Украина",
    "searchString": "катеринополь украина / черкасская область / катеринополь"
  },
  "3365": {
    "id": "3365",
    "name": "Корсунь-Шевченковский",
    "path": "Украина / Черкасская область / Корсунь-Шевченковский",
    "country": "Украина",
    "searchString": "корсунь-шевченковский украина / черкасская область / корсунь-шевченковский"
  },
  "3366": {
    "id": "3366",
    "name": "Лысянка",
    "path": "Украина / Черкасская область / Лысянка",
    "country": "Украина",
    "searchString": "лысянка украина / черкасская область / лысянка"
  },
  "3367": {
    "id": "3367",
    "name": "Маньковка",
    "path": "Украина / Черкасская область / Маньковка",
    "country": "Украина",
    "searchString": "маньковка украина / черкасская область / маньковка"
  },
  "3368": {
    "id": "3368",
    "name": "Монастырище",
    "path": "Украина / Черкасская область / Монастырище",
    "country": "Украина",
    "searchString": "монастырище украина / черкасская область / монастырище"
  },
  "3369": {
    "id": "3369",
    "name": "Тальное",
    "path": "Украина / Черкасская область / Тальное",
    "country": "Украина",
    "searchString": "тальное украина / черкасская область / тальное"
  },
  "3370": {
    "id": "3370",
    "name": "Христиновка",
    "path": "Украина / Черкасская область / Христиновка",
    "country": "Украина",
    "searchString": "христиновка украина / черкасская область / христиновка"
  },
  "3371": {
    "id": "3371",
    "name": "Чернобай",
    "path": "Украина / Черкасская область / Чернобай",
    "country": "Украина",
    "searchString": "чернобай украина / черкасская область / чернобай"
  },
  "3372": {
    "id": "3372",
    "name": "Чигирин",
    "path": "Украина / Черкасская область / Чигирин",
    "country": "Украина",
    "searchString": "чигирин украина / черкасская область / чигирин"
  },
  "3373": {
    "id": "3373",
    "name": "Шпола",
    "path": "Украина / Черкасская область / Шпола",
    "country": "Украина",
    "searchString": "шпола украина / черкасская область / шпола"
  },
  "3374": {
    "id": "3374",
    "name": "Антрацит",
    "path": "Россия / Луганская Народная Республика / Антрацит",
    "country": "Россия",
    "searchString": "антрацит россия / луганская народная республика / антрацит"
  },
  "3375": {
    "id": "3375",
    "name": "Беловодск",
    "path": "Россия / Луганская Народная Республика / Беловодск",
    "country": "Россия",
    "searchString": "беловодск россия / луганская народная республика / беловодск"
  },
  "3376": {
    "id": "3376",
    "name": "Белокуракино",
    "path": "Россия / Луганская Народная Республика / Белокуракино",
    "country": "Россия",
    "searchString": "белокуракино россия / луганская народная республика / белокуракино"
  },
  "3377": {
    "id": "3377",
    "name": "Брянка",
    "path": "Россия / Луганская Народная Республика / Брянка",
    "country": "Россия",
    "searchString": "брянка россия / луганская народная республика / брянка"
  },
  "3378": {
    "id": "3378",
    "name": "Кировск",
    "path": "Россия / Луганская Народная Республика / Кировск",
    "country": "Россия",
    "searchString": "кировск россия / луганская народная республика / кировск"
  },
  "3379": {
    "id": "3379",
    "name": "Краснодон",
    "path": "Россия / Луганская Народная Республика / Краснодон",
    "country": "Россия",
    "searchString": "краснодон россия / луганская народная республика / краснодон"
  },
  "3380": {
    "id": "3380",
    "name": "Кременная",
    "path": "Россия / Луганская Народная Республика / Кременная",
    "country": "Россия",
    "searchString": "кременная россия / луганская народная республика / кременная"
  },
  "3381": {
    "id": "3381",
    "name": "Лутугино",
    "path": "Россия / Луганская Народная Республика / Лутугино",
    "country": "Россия",
    "searchString": "лутугино россия / луганская народная республика / лутугино"
  },
  "3382": {
    "id": "3382",
    "name": "Марковка",
    "path": "Россия / Луганская Народная Республика / Марковка",
    "country": "Россия",
    "searchString": "марковка россия / луганская народная республика / марковка"
  },
  "3383": {
    "id": "3383",
    "name": "Меловое",
    "path": "Россия / Луганская Народная Республика / Меловое",
    "country": "Россия",
    "searchString": "меловое россия / луганская народная республика / меловое"
  },
  "3384": {
    "id": "3384",
    "name": "Новоайдар",
    "path": "Россия / Луганская Народная Республика / Новоайдар",
    "country": "Россия",
    "searchString": "новоайдар россия / луганская народная республика / новоайдар"
  },
  "3385": {
    "id": "3385",
    "name": "Новопсков",
    "path": "Россия / Луганская Народная Республика / Новопсков",
    "country": "Россия",
    "searchString": "новопсков россия / луганская народная республика / новопсков"
  },
  "3386": {
    "id": "3386",
    "name": "Перевальск",
    "path": "Россия / Луганская Народная Республика / Перевальск",
    "country": "Россия",
    "searchString": "перевальск россия / луганская народная республика / перевальск"
  },
  "3387": {
    "id": "3387",
    "name": "Попасная",
    "path": "Россия / Луганская Народная Республика / Попасная",
    "country": "Россия",
    "searchString": "попасная россия / луганская народная республика / попасная"
  },
  "3388": {
    "id": "3388",
    "name": "Ровеньки",
    "path": "Россия / Луганская Народная Республика / Ровеньки",
    "country": "Россия",
    "searchString": "ровеньки россия / луганская народная республика / ровеньки"
  },
  "3389": {
    "id": "3389",
    "name": "Сватово",
    "path": "Россия / Луганская Народная Республика / Сватово",
    "country": "Россия",
    "searchString": "сватово россия / луганская народная республика / сватово"
  },
  "3390": {
    "id": "3390",
    "name": "Славяносербск",
    "path": "Россия / Луганская Народная Республика / Славяносербск",
    "country": "Россия",
    "searchString": "славяносербск россия / луганская народная республика / славяносербск"
  },
  "3391": {
    "id": "3391",
    "name": "Станица Луганская",
    "path": "Россия / Луганская Народная Республика / Станица Луганская",
    "country": "Россия",
    "searchString": "станица луганская россия / луганская народная республика / станица луганская"
  },
  "3392": {
    "id": "3392",
    "name": "Старобельск",
    "path": "Россия / Луганская Народная Республика / Старобельск",
    "country": "Россия",
    "searchString": "старобельск россия / луганская народная республика / старобельск"
  },
  "3393": {
    "id": "3393",
    "name": "Троицкое",
    "path": "Россия / Луганская Народная Республика / Троицкое",
    "country": "Россия",
    "searchString": "троицкое россия / луганская народная республика / троицкое"
  },
  "3394": {
    "id": "3394",
    "name": "Арбузинка",
    "path": "Украина / Николаевская область / Арбузинка",
    "country": "Украина",
    "searchString": "арбузинка украина / николаевская область / арбузинка"
  },
  "3395": {
    "id": "3395",
    "name": "Баштанка",
    "path": "Украина / Николаевская область / Баштанка",
    "country": "Украина",
    "searchString": "баштанка украина / николаевская область / баштанка"
  },
  "3396": {
    "id": "3396",
    "name": "Березанка",
    "path": "Украина / Николаевская область / Березанка",
    "country": "Украина",
    "searchString": "березанка украина / николаевская область / березанка"
  },
  "3397": {
    "id": "3397",
    "name": "Березнеговатое",
    "path": "Украина / Николаевская область / Березнеговатое",
    "country": "Украина",
    "searchString": "березнеговатое украина / николаевская область / березнеговатое"
  },
  "3398": {
    "id": "3398",
    "name": "Братское",
    "path": "Украина / Николаевская область / Братское",
    "country": "Украина",
    "searchString": "братское украина / николаевская область / братское"
  },
  "3399": {
    "id": "3399",
    "name": "Веселиново",
    "path": "Украина / Николаевская область / Веселиново",
    "country": "Украина",
    "searchString": "веселиново украина / николаевская область / веселиново"
  },
  "3400": {
    "id": "3400",
    "name": "Вознесенск (Николаевская область)",
    "path": "Украина / Николаевская область / Вознесенск (Николаевская область)",
    "country": "Украина",
    "searchString": "вознесенск (николаевская область) украина / николаевская область / вознесенск (николаевская область)"
  },
  "3401": {
    "id": "3401",
    "name": "Врадиевка",
    "path": "Украина / Николаевская область / Врадиевка",
    "country": "Украина",
    "searchString": "врадиевка украина / николаевская область / врадиевка"
  },
  "3402": {
    "id": "3402",
    "name": "Доманевка",
    "path": "Украина / Николаевская область / Доманевка",
    "country": "Украина",
    "searchString": "доманевка украина / николаевская область / доманевка"
  },
  "3403": {
    "id": "3403",
    "name": "Казанка",
    "path": "Украина / Николаевская область / Казанка",
    "country": "Украина",
    "searchString": "казанка украина / николаевская область / казанка"
  },
  "3404": {
    "id": "3404",
    "name": "Кривое Озеро",
    "path": "Украина / Николаевская область / Кривое Озеро",
    "country": "Украина",
    "searchString": "кривое озеро украина / николаевская область / кривое озеро"
  },
  "3405": {
    "id": "3405",
    "name": "Новая Одесса",
    "path": "Украина / Николаевская область / Новая Одесса",
    "country": "Украина",
    "searchString": "новая одесса украина / николаевская область / новая одесса"
  },
  "3406": {
    "id": "3406",
    "name": "Новый Буг",
    "path": "Украина / Николаевская область / Новый Буг",
    "country": "Украина",
    "searchString": "новый буг украина / николаевская область / новый буг"
  },
  "3407": {
    "id": "3407",
    "name": "Очаков",
    "path": "Украина / Николаевская область / Очаков",
    "country": "Украина",
    "searchString": "очаков украина / николаевская область / очаков"
  },
  "3408": {
    "id": "3408",
    "name": "Снигиревка",
    "path": "Украина / Николаевская область / Снигиревка",
    "country": "Украина",
    "searchString": "снигиревка украина / николаевская область / снигиревка"
  },
  "3409": {
    "id": "3409",
    "name": "Белогорье",
    "path": "Украина / Хмельницкая область / Белогорье",
    "country": "Украина",
    "searchString": "белогорье украина / хмельницкая область / белогорье"
  },
  "3410": {
    "id": "3410",
    "name": "Виньковцы",
    "path": "Украина / Хмельницкая область / Виньковцы",
    "country": "Украина",
    "searchString": "виньковцы украина / хмельницкая область / виньковцы"
  },
  "3411": {
    "id": "3411",
    "name": "Волочиск",
    "path": "Украина / Хмельницкая область / Волочиск",
    "country": "Украина",
    "searchString": "волочиск украина / хмельницкая область / волочиск"
  },
  "3412": {
    "id": "3412",
    "name": "Городок (Хмельницкая область)",
    "path": "Украина / Хмельницкая область / Городок (Хмельницкая область)",
    "country": "Украина",
    "searchString": "городок (хмельницкая область) украина / хмельницкая область / городок (хмельницкая область)"
  },
  "3413": {
    "id": "3413",
    "name": "Деражня",
    "path": "Украина / Хмельницкая область / Деражня",
    "country": "Украина",
    "searchString": "деражня украина / хмельницкая область / деражня"
  },
  "3414": {
    "id": "3414",
    "name": "Дунаевцы",
    "path": "Украина / Хмельницкая область / Дунаевцы",
    "country": "Украина",
    "searchString": "дунаевцы украина / хмельницкая область / дунаевцы"
  },
  "3415": {
    "id": "3415",
    "name": "Изяслав",
    "path": "Украина / Хмельницкая область / Изяслав",
    "country": "Украина",
    "searchString": "изяслав украина / хмельницкая область / изяслав"
  },
  "3416": {
    "id": "3416",
    "name": "Красилов",
    "path": "Украина / Хмельницкая область / Красилов",
    "country": "Украина",
    "searchString": "красилов украина / хмельницкая область / красилов"
  },
  "3417": {
    "id": "3417",
    "name": "Летичев",
    "path": "Украина / Хмельницкая область / Летичев",
    "country": "Украина",
    "searchString": "летичев украина / хмельницкая область / летичев"
  },
  "3418": {
    "id": "3418",
    "name": "Нетешин",
    "path": "Украина / Хмельницкая область / Нетешин",
    "country": "Украина",
    "searchString": "нетешин украина / хмельницкая область / нетешин"
  },
  "3419": {
    "id": "3419",
    "name": "Новая Ушица",
    "path": "Украина / Хмельницкая область / Новая Ушица",
    "country": "Украина",
    "searchString": "новая ушица украина / хмельницкая область / новая ушица"
  },
  "3420": {
    "id": "3420",
    "name": "Полонное",
    "path": "Украина / Хмельницкая область / Полонное",
    "country": "Украина",
    "searchString": "полонное украина / хмельницкая область / полонное"
  },
  "3421": {
    "id": "3421",
    "name": "Старая Синява",
    "path": "Украина / Хмельницкая область / Старая Синява",
    "country": "Украина",
    "searchString": "старая синява украина / хмельницкая область / старая синява"
  },
  "3422": {
    "id": "3422",
    "name": "Староконстантинов",
    "path": "Украина / Хмельницкая область / Староконстантинов",
    "country": "Украина",
    "searchString": "староконстантинов украина / хмельницкая область / староконстантинов"
  },
  "3423": {
    "id": "3423",
    "name": "Теофиполь",
    "path": "Украина / Хмельницкая область / Теофиполь",
    "country": "Украина",
    "searchString": "теофиполь украина / хмельницкая область / теофиполь"
  },
  "3424": {
    "id": "3424",
    "name": "Чемеровцы",
    "path": "Украина / Хмельницкая область / Чемеровцы",
    "country": "Украина",
    "searchString": "чемеровцы украина / хмельницкая область / чемеровцы"
  },
  "3425": {
    "id": "3425",
    "name": "Ярмолинцы",
    "path": "Украина / Хмельницкая область / Ярмолинцы",
    "country": "Украина",
    "searchString": "ярмолинцы украина / хмельницкая область / ярмолинцы"
  },
  "3426": {
    "id": "3426",
    "name": "Новодеревянковская",
    "path": "Россия / Краснодарский край / Новодеревянковская",
    "country": "Россия",
    "searchString": "новодеревянковская россия / краснодарский край / новодеревянковская"
  },
  "3427": {
    "id": "3427",
    "name": "Новоджерелиевская",
    "path": "Россия / Краснодарский край / Новоджерелиевская",
    "country": "Россия",
    "searchString": "новоджерелиевская россия / краснодарский край / новоджерелиевская"
  },
  "3428": {
    "id": "3428",
    "name": "Новодмитриевская",
    "path": "Россия / Краснодарский край / Новодмитриевская",
    "country": "Россия",
    "searchString": "новодмитриевская россия / краснодарский край / новодмитриевская"
  },
  "3429": {
    "id": "3429",
    "name": "Новокорсунская",
    "path": "Россия / Краснодарский край / Новокорсунская",
    "country": "Россия",
    "searchString": "новокорсунская россия / краснодарский край / новокорсунская"
  },
  "3430": {
    "id": "3430",
    "name": "Новолеушковская",
    "path": "Россия / Краснодарский край / Новолеушковская",
    "country": "Россия",
    "searchString": "новолеушковская россия / краснодарский край / новолеушковская"
  },
  "3431": {
    "id": "3431",
    "name": "Новоминская",
    "path": "Россия / Краснодарский край / Новоминская",
    "country": "Россия",
    "searchString": "новоминская россия / краснодарский край / новоминская"
  },
  "3432": {
    "id": "3432",
    "name": "Новомихайловский",
    "path": "Россия / Краснодарский край / Новомихайловский",
    "country": "Россия",
    "searchString": "новомихайловский россия / краснодарский край / новомихайловский"
  },
  "3433": {
    "id": "3433",
    "name": "Новомышастовская",
    "path": "Россия / Краснодарский край / Новомышастовская",
    "country": "Россия",
    "searchString": "новомышастовская россия / краснодарский край / новомышастовская"
  },
  "3434": {
    "id": "3434",
    "name": "Новощербиновская",
    "path": "Россия / Краснодарский край / Новощербиновская",
    "country": "Россия",
    "searchString": "новощербиновская россия / краснодарский край / новощербиновская"
  },
  "3435": {
    "id": "3435",
    "name": "Петровская",
    "path": "Россия / Краснодарский край / Петровская",
    "country": "Россия",
    "searchString": "петровская россия / краснодарский край / петровская"
  },
  "3436": {
    "id": "3436",
    "name": "Раевская",
    "path": "Россия / Краснодарский край / Раевская",
    "country": "Россия",
    "searchString": "раевская россия / краснодарский край / раевская"
  },
  "3437": {
    "id": "3437",
    "name": "Роговская",
    "path": "Россия / Краснодарский край / Роговская",
    "country": "Россия",
    "searchString": "роговская россия / краснодарский край / роговская"
  },
  "3438": {
    "id": "3438",
    "name": "Родниковская",
    "path": "Россия / Краснодарский край / Родниковская",
    "country": "Россия",
    "searchString": "родниковская россия / краснодарский край / родниковская"
  },
  "3439": {
    "id": "3439",
    "name": "Спокойная",
    "path": "Россия / Краснодарский край / Спокойная",
    "country": "Россия",
    "searchString": "спокойная россия / краснодарский край / спокойная"
  },
  "3440": {
    "id": "3440",
    "name": "Старокорсунская",
    "path": "Россия / Краснодарский край / Старокорсунская",
    "country": "Россия",
    "searchString": "старокорсунская россия / краснодарский край / старокорсунская"
  },
  "3441": {
    "id": "3441",
    "name": "Старолеушковская",
    "path": "Россия / Краснодарский край / Старолеушковская",
    "country": "Россия",
    "searchString": "старолеушковская россия / краснодарский край / старолеушковская"
  },
  "3442": {
    "id": "3442",
    "name": "Стрелка",
    "path": "Россия / Краснодарский край / Стрелка",
    "country": "Россия",
    "searchString": "стрелка россия / краснодарский край / стрелка"
  },
  "3443": {
    "id": "3443",
    "name": "Темижбекская",
    "path": "Россия / Краснодарский край / Темижбекская",
    "country": "Россия",
    "searchString": "темижбекская россия / краснодарский край / темижбекская"
  },
  "3444": {
    "id": "3444",
    "name": "Удобная",
    "path": "Россия / Краснодарский край / Удобная",
    "country": "Россия",
    "searchString": "удобная россия / краснодарский край / удобная"
  },
  "3445": {
    "id": "3445",
    "name": "Фастовецкая",
    "path": "Россия / Краснодарский край / Фастовецкая",
    "country": "Россия",
    "searchString": "фастовецкая россия / краснодарский край / фастовецкая"
  },
  "3446": {
    "id": "3446",
    "name": "Ярославская",
    "path": "Россия / Краснодарский край / Ярославская",
    "country": "Россия",
    "searchString": "ярославская россия / краснодарский край / ярославская"
  },
  "3447": {
    "id": "3447",
    "name": "Богородчаны",
    "path": "Украина / Ивано-Франковская область / Богородчаны",
    "country": "Украина",
    "searchString": "богородчаны украина / ивано-франковская область / богородчаны"
  },
  "3448": {
    "id": "3448",
    "name": "Болехов",
    "path": "Украина / Ивано-Франковская область / Болехов",
    "country": "Украина",
    "searchString": "болехов украина / ивано-франковская область / болехов"
  },
  "3449": {
    "id": "3449",
    "name": "Бурштын",
    "path": "Украина / Ивано-Франковская область / Бурштын",
    "country": "Украина",
    "searchString": "бурштын украина / ивано-франковская область / бурштын"
  },
  "3450": {
    "id": "3450",
    "name": "Верховина",
    "path": "Украина / Ивано-Франковская область / Верховина",
    "country": "Украина",
    "searchString": "верховина украина / ивано-франковская область / верховина"
  },
  "3451": {
    "id": "3451",
    "name": "Галич (Ивано-Франковская область)",
    "path": "Украина / Ивано-Франковская область / Галич (Ивано-Франковская область)",
    "country": "Украина",
    "searchString": "галич (ивано-франковская область) украина / ивано-франковская область / галич (ивано-франковская область)"
  },
  "3452": {
    "id": "3452",
    "name": "Городенка",
    "path": "Украина / Ивано-Франковская область / Городенка",
    "country": "Украина",
    "searchString": "городенка украина / ивано-франковская область / городенка"
  },
  "3453": {
    "id": "3453",
    "name": "Долина",
    "path": "Украина / Ивано-Франковская область / Долина",
    "country": "Украина",
    "searchString": "долина украина / ивано-франковская область / долина"
  },
  "3454": {
    "id": "3454",
    "name": "Косов",
    "path": "Украина / Ивано-Франковская область / Косов",
    "country": "Украина",
    "searchString": "косов украина / ивано-франковская область / косов"
  },
  "3455": {
    "id": "3455",
    "name": "Надворная",
    "path": "Украина / Ивано-Франковская область / Надворная",
    "country": "Украина",
    "searchString": "надворная украина / ивано-франковская область / надворная"
  },
  "3456": {
    "id": "3456",
    "name": "Перегинское",
    "path": "Украина / Ивано-Франковская область / Перегинское",
    "country": "Украина",
    "searchString": "перегинское украина / ивано-франковская область / перегинское"
  },
  "3457": {
    "id": "3457",
    "name": "Поляница",
    "path": "Украина / Ивано-Франковская область / Поляница",
    "country": "Украина",
    "searchString": "поляница украина / ивано-франковская область / поляница"
  },
  "3458": {
    "id": "3458",
    "name": "Рогатин",
    "path": "Украина / Ивано-Франковская область / Рогатин",
    "country": "Украина",
    "searchString": "рогатин украина / ивано-франковская область / рогатин"
  },
  "3459": {
    "id": "3459",
    "name": "Рожнятов",
    "path": "Украина / Ивано-Франковская область / Рожнятов",
    "country": "Украина",
    "searchString": "рожнятов украина / ивано-франковская область / рожнятов"
  },
  "3460": {
    "id": "3460",
    "name": "Снятын",
    "path": "Украина / Ивано-Франковская область / Снятын",
    "country": "Украина",
    "searchString": "снятын украина / ивано-франковская область / снятын"
  },
  "3461": {
    "id": "3461",
    "name": "Тлумач",
    "path": "Украина / Ивано-Франковская область / Тлумач",
    "country": "Украина",
    "searchString": "тлумач украина / ивано-франковская область / тлумач"
  },
  "3462": {
    "id": "3462",
    "name": "Тысменица",
    "path": "Украина / Ивано-Франковская область / Тысменица",
    "country": "Украина",
    "searchString": "тысменица украина / ивано-франковская область / тысменица"
  },
  "3463": {
    "id": "3463",
    "name": "Яремче",
    "path": "Украина / Ивано-Франковская область / Яремче",
    "country": "Украина",
    "searchString": "яремче украина / ивано-франковская область / яремче"
  },
  "3464": {
    "id": "3464",
    "name": "Белополье",
    "path": "Украина / Сумская область / Белополье",
    "country": "Украина",
    "searchString": "белополье украина / сумская область / белополье"
  },
  "3465": {
    "id": "3465",
    "name": "Бурынь",
    "path": "Украина / Сумская область / Бурынь",
    "country": "Украина",
    "searchString": "бурынь украина / сумская область / бурынь"
  },
  "3466": {
    "id": "3466",
    "name": "Великая Писаревка",
    "path": "Украина / Сумская область / Великая Писаревка",
    "country": "Украина",
    "searchString": "великая писаревка украина / сумская область / великая писаревка"
  },
  "3467": {
    "id": "3467",
    "name": "Глухов",
    "path": "Украина / Сумская область / Глухов",
    "country": "Украина",
    "searchString": "глухов украина / сумская область / глухов"
  },
  "3468": {
    "id": "3468",
    "name": "Краснополье (Сумская область)",
    "path": "Украина / Сумская область / Краснополье (Сумская область)",
    "country": "Украина",
    "searchString": "краснополье (сумская область) украина / сумская область / краснополье (сумская область)"
  },
  "3469": {
    "id": "3469",
    "name": "Кролевец",
    "path": "Украина / Сумская область / Кролевец",
    "country": "Украина",
    "searchString": "кролевец украина / сумская область / кролевец"
  },
  "3470": {
    "id": "3470",
    "name": "Лебедин",
    "path": "Украина / Сумская область / Лебедин",
    "country": "Украина",
    "searchString": "лебедин украина / сумская область / лебедин"
  },
  "3471": {
    "id": "3471",
    "name": "Липовая Долина",
    "path": "Украина / Сумская область / Липовая Долина",
    "country": "Украина",
    "searchString": "липовая долина украина / сумская область / липовая долина"
  },
  "3472": {
    "id": "3472",
    "name": "Недригайлов",
    "path": "Украина / Сумская область / Недригайлов",
    "country": "Украина",
    "searchString": "недригайлов украина / сумская область / недригайлов"
  },
  "3473": {
    "id": "3473",
    "name": "Путивль",
    "path": "Украина / Сумская область / Путивль",
    "country": "Украина",
    "searchString": "путивль украина / сумская область / путивль"
  },
  "3474": {
    "id": "3474",
    "name": "Середина-Буда",
    "path": "Украина / Сумская область / Середина-Буда",
    "country": "Украина",
    "searchString": "середина-буда украина / сумская область / середина-буда"
  },
  "3475": {
    "id": "3475",
    "name": "Тростянец (Сумская область)",
    "path": "Украина / Сумская область / Тростянец (Сумская область)",
    "country": "Украина",
    "searchString": "тростянец (сумская область) украина / сумская область / тростянец (сумская область)"
  },
  "3476": {
    "id": "3476",
    "name": "Ямполь (Сумская область)",
    "path": "Украина / Сумская область / Ямполь (Сумская область)",
    "country": "Украина",
    "searchString": "ямполь (сумская область) украина / сумская область / ямполь (сумская область)"
  },
  "3477": {
    "id": "3477",
    "name": "Бучач",
    "path": "Украина / Тернопольская область / Бучач",
    "country": "Украина",
    "searchString": "бучач украина / тернопольская область / бучач"
  },
  "3478": {
    "id": "3478",
    "name": "Гусятин",
    "path": "Украина / Тернопольская область / Гусятин",
    "country": "Украина",
    "searchString": "гусятин украина / тернопольская область / гусятин"
  },
  "3479": {
    "id": "3479",
    "name": "Залещики",
    "path": "Украина / Тернопольская область / Залещики",
    "country": "Украина",
    "searchString": "залещики украина / тернопольская область / залещики"
  },
  "3480": {
    "id": "3480",
    "name": "Збараж",
    "path": "Украина / Тернопольская область / Збараж",
    "country": "Украина",
    "searchString": "збараж украина / тернопольская область / збараж"
  },
  "3481": {
    "id": "3481",
    "name": "Зборов",
    "path": "Украина / Тернопольская область / Зборов",
    "country": "Украина",
    "searchString": "зборов украина / тернопольская область / зборов"
  },
  "3482": {
    "id": "3482",
    "name": "Козова",
    "path": "Украина / Тернопольская область / Козова",
    "country": "Украина",
    "searchString": "козова украина / тернопольская область / козова"
  },
  "3483": {
    "id": "3483",
    "name": "Кременец",
    "path": "Украина / Тернопольская область / Кременец",
    "country": "Украина",
    "searchString": "кременец украина / тернопольская область / кременец"
  },
  "3484": {
    "id": "3484",
    "name": "Лановцы",
    "path": "Украина / Тернопольская область / Лановцы",
    "country": "Украина",
    "searchString": "лановцы украина / тернопольская область / лановцы"
  },
  "3485": {
    "id": "3485",
    "name": "Монастыриска",
    "path": "Украина / Тернопольская область / Монастыриска",
    "country": "Украина",
    "searchString": "монастыриска украина / тернопольская область / монастыриска"
  },
  "3486": {
    "id": "3486",
    "name": "Подволочиск",
    "path": "Украина / Тернопольская область / Подволочиск",
    "country": "Украина",
    "searchString": "подволочиск украина / тернопольская область / подволочиск"
  },
  "3487": {
    "id": "3487",
    "name": "Подгайцы",
    "path": "Украина / Тернопольская область / Подгайцы",
    "country": "Украина",
    "searchString": "подгайцы украина / тернопольская область / подгайцы"
  },
  "3488": {
    "id": "3488",
    "name": "Почаев",
    "path": "Украина / Тернопольская область / Почаев",
    "country": "Украина",
    "searchString": "почаев украина / тернопольская область / почаев"
  },
  "3489": {
    "id": "3489",
    "name": "Теребовля",
    "path": "Украина / Тернопольская область / Теребовля",
    "country": "Украина",
    "searchString": "теребовля украина / тернопольская область / теребовля"
  },
  "3490": {
    "id": "3490",
    "name": "Чортков",
    "path": "Украина / Тернопольская область / Чортков",
    "country": "Украина",
    "searchString": "чортков украина / тернопольская область / чортков"
  },
  "3491": {
    "id": "3491",
    "name": "Шумск",
    "path": "Украина / Тернопольская область / Шумск",
    "country": "Украина",
    "searchString": "шумск украина / тернопольская область / шумск"
  },
  "3492": {
    "id": "3492",
    "name": "Березно",
    "path": "Украина / Ровненская область / Березно",
    "country": "Украина",
    "searchString": "березно украина / ровненская область / березно"
  },
  "3493": {
    "id": "3493",
    "name": "Владимирец",
    "path": "Украина / Ровненская область / Владимирец",
    "country": "Украина",
    "searchString": "владимирец украина / ровненская область / владимирец"
  },
  "3494": {
    "id": "3494",
    "name": "Гоща",
    "path": "Украина / Ровненская область / Гоща",
    "country": "Украина",
    "searchString": "гоща украина / ровненская область / гоща"
  },
  "3495": {
    "id": "3495",
    "name": "Демидовка",
    "path": "Украина / Ровненская область / Демидовка",
    "country": "Украина",
    "searchString": "демидовка украина / ровненская область / демидовка"
  },
  "3496": {
    "id": "3496",
    "name": "Дубно",
    "path": "Украина / Ровненская область / Дубно",
    "country": "Украина",
    "searchString": "дубно украина / ровненская область / дубно"
  },
  "3497": {
    "id": "3497",
    "name": "Дубровица",
    "path": "Украина / Ровненская область / Дубровица",
    "country": "Украина",
    "searchString": "дубровица украина / ровненская область / дубровица"
  },
  "3498": {
    "id": "3498",
    "name": "Заречное",
    "path": "Украина / Ровненская область / Заречное",
    "country": "Украина",
    "searchString": "заречное украина / ровненская область / заречное"
  },
  "3499": {
    "id": "3499",
    "name": "Здолбунов",
    "path": "Украина / Ровненская область / Здолбунов",
    "country": "Украина",
    "searchString": "здолбунов украина / ровненская область / здолбунов"
  },
  "3500": {
    "id": "3500",
    "name": "Корец",
    "path": "Украина / Ровненская область / Корец",
    "country": "Украина",
    "searchString": "корец украина / ровненская область / корец"
  },
  "3501": {
    "id": "3501",
    "name": "Костополь",
    "path": "Украина / Ровненская область / Костополь",
    "country": "Украина",
    "searchString": "костополь украина / ровненская область / костополь"
  },
  "3502": {
    "id": "3502",
    "name": "Млинов",
    "path": "Украина / Ровненская область / Млинов",
    "country": "Украина",
    "searchString": "млинов украина / ровненская область / млинов"
  },
  "3503": {
    "id": "3503",
    "name": "Острог",
    "path": "Украина / Ровненская область / Острог",
    "country": "Украина",
    "searchString": "острог украина / ровненская область / острог"
  },
  "3504": {
    "id": "3504",
    "name": "Радивилов",
    "path": "Украина / Ровненская область / Радивилов",
    "country": "Украина",
    "searchString": "радивилов украина / ровненская область / радивилов"
  },
  "3505": {
    "id": "3505",
    "name": "Рокитное",
    "path": "Украина / Ровненская область / Рокитное",
    "country": "Украина",
    "searchString": "рокитное украина / ровненская область / рокитное"
  },
  "3506": {
    "id": "3506",
    "name": "Белозерка",
    "path": "Россия / Херсонская область / Белозерка",
    "country": "Россия",
    "searchString": "белозерка россия / херсонская область / белозерка"
  },
  "3507": {
    "id": "3507",
    "name": "Берислав",
    "path": "Россия / Херсонская область / Берислав",
    "country": "Россия",
    "searchString": "берислав россия / херсонская область / берислав"
  },
  "3508": {
    "id": "3508",
    "name": "Великая Александровка",
    "path": "Россия / Херсонская область / Великая Александровка",
    "country": "Россия",
    "searchString": "великая александровка россия / херсонская область / великая александровка"
  },
  "3509": {
    "id": "3509",
    "name": "Великая Лепетиха",
    "path": "Россия / Херсонская область / Великая Лепетиха",
    "country": "Россия",
    "searchString": "великая лепетиха россия / херсонская область / великая лепетиха"
  },
  "3510": {
    "id": "3510",
    "name": "Великие Копани",
    "path": "Россия / Херсонская область / Великие Копани",
    "country": "Россия",
    "searchString": "великие копани россия / херсонская область / великие копани"
  },
  "3511": {
    "id": "3511",
    "name": "Верхний Рогачик",
    "path": "Россия / Херсонская область / Верхний Рогачик",
    "country": "Россия",
    "searchString": "верхний рогачик россия / херсонская область / верхний рогачик"
  },
  "3512": {
    "id": "3512",
    "name": "Высокополье",
    "path": "Россия / Херсонская область / Высокополье",
    "country": "Россия",
    "searchString": "высокополье россия / херсонская область / высокополье"
  },
  "3513": {
    "id": "3513",
    "name": "Геническ",
    "path": "Россия / Херсонская область / Геническ",
    "country": "Россия",
    "searchString": "геническ россия / херсонская область / геническ"
  },
  "3514": {
    "id": "3514",
    "name": "Голая Пристань",
    "path": "Россия / Херсонская область / Голая Пристань",
    "country": "Россия",
    "searchString": "голая пристань россия / херсонская область / голая пристань"
  },
  "3515": {
    "id": "3515",
    "name": "Горностаевка",
    "path": "Россия / Херсонская область / Горностаевка",
    "country": "Россия",
    "searchString": "горностаевка россия / херсонская область / горностаевка"
  },
  "3516": {
    "id": "3516",
    "name": "Ивановка (Херсонская область)",
    "path": "Россия / Херсонская область / Ивановка (Херсонская область)",
    "country": "Россия",
    "searchString": "ивановка (херсонская область) россия / херсонская область / ивановка (херсонская область)"
  },
  "3517": {
    "id": "3517",
    "name": "Каланчак",
    "path": "Россия / Херсонская область / Каланчак",
    "country": "Россия",
    "searchString": "каланчак россия / херсонская область / каланчак"
  },
  "3518": {
    "id": "3518",
    "name": "Каховка",
    "path": "Россия / Херсонская область / Каховка",
    "country": "Россия",
    "searchString": "каховка россия / херсонская область / каховка"
  },
  "3519": {
    "id": "3519",
    "name": "Нижние Серогозы",
    "path": "Россия / Херсонская область / Нижние Серогозы",
    "country": "Россия",
    "searchString": "нижние серогозы россия / херсонская область / нижние серогозы"
  },
  "3520": {
    "id": "3520",
    "name": "Нововоронцовка",
    "path": "Россия / Херсонская область / Нововоронцовка",
    "country": "Россия",
    "searchString": "нововоронцовка россия / херсонская область / нововоронцовка"
  },
  "3521": {
    "id": "3521",
    "name": "Новотроицкое",
    "path": "Россия / Херсонская область / Новотроицкое",
    "country": "Россия",
    "searchString": "новотроицкое россия / херсонская область / новотроицкое"
  },
  "3522": {
    "id": "3522",
    "name": "Скадовск",
    "path": "Россия / Херсонская область / Скадовск",
    "country": "Россия",
    "searchString": "скадовск россия / херсонская область / скадовск"
  },
  "3523": {
    "id": "3523",
    "name": "Цюрупинск",
    "path": "Россия / Херсонская область / Цюрупинск",
    "country": "Россия",
    "searchString": "цюрупинск россия / херсонская область / цюрупинск"
  },
  "3524": {
    "id": "3524",
    "name": "Чаплинка",
    "path": "Россия / Херсонская область / Чаплинка",
    "country": "Россия",
    "searchString": "чаплинка россия / херсонская область / чаплинка"
  },
  "3525": {
    "id": "3525",
    "name": "Александровка (Кировоградская область)",
    "path": "Украина / Кировоградская область / Александровка (Кировоградская область)",
    "country": "Украина",
    "searchString": "александровка (кировоградская область) украина / кировоградская область / александровка (кировоградская область)"
  },
  "3526": {
    "id": "3526",
    "name": "Бобринец",
    "path": "Украина / Кировоградская область / Бобринец",
    "country": "Украина",
    "searchString": "бобринец украина / кировоградская область / бобринец"
  },
  "3527": {
    "id": "3527",
    "name": "Гайворон",
    "path": "Украина / Кировоградская область / Гайворон",
    "country": "Украина",
    "searchString": "гайворон украина / кировоградская область / гайворон"
  },
  "3528": {
    "id": "3528",
    "name": "Голованевск",
    "path": "Украина / Кировоградская область / Голованевск",
    "country": "Украина",
    "searchString": "голованевск украина / кировоградская область / голованевск"
  },
  "3529": {
    "id": "3529",
    "name": "Добровеличковка",
    "path": "Украина / Кировоградская область / Добровеличковка",
    "country": "Украина",
    "searchString": "добровеличковка украина / кировоградская область / добровеличковка"
  },
  "3530": {
    "id": "3530",
    "name": "Долинская",
    "path": "Украина / Кировоградская область / Долинская",
    "country": "Украина",
    "searchString": "долинская украина / кировоградская область / долинская"
  },
  "3531": {
    "id": "3531",
    "name": "Компанеевка",
    "path": "Украина / Кировоградская область / Компанеевка",
    "country": "Украина",
    "searchString": "компанеевка украина / кировоградская область / компанеевка"
  },
  "3532": {
    "id": "3532",
    "name": "Малая Виска",
    "path": "Украина / Кировоградская область / Малая Виска",
    "country": "Украина",
    "searchString": "малая виска украина / кировоградская область / малая виска"
  },
  "3533": {
    "id": "3533",
    "name": "Новгородка",
    "path": "Украина / Кировоградская область / Новгородка",
    "country": "Украина",
    "searchString": "новгородка украина / кировоградская область / новгородка"
  },
  "3534": {
    "id": "3534",
    "name": "Новоархангельск",
    "path": "Украина / Кировоградская область / Новоархангельск",
    "country": "Украина",
    "searchString": "новоархангельск украина / кировоградская область / новоархангельск"
  },
  "3535": {
    "id": "3535",
    "name": "Новомиргород",
    "path": "Украина / Кировоградская область / Новомиргород",
    "country": "Украина",
    "searchString": "новомиргород украина / кировоградская область / новомиргород"
  },
  "3536": {
    "id": "3536",
    "name": "Новоукраинка",
    "path": "Украина / Кировоградская область / Новоукраинка",
    "country": "Украина",
    "searchString": "новоукраинка украина / кировоградская область / новоукраинка"
  },
  "3537": {
    "id": "3537",
    "name": "Ольшанка",
    "path": "Украина / Кировоградская область / Ольшанка",
    "country": "Украина",
    "searchString": "ольшанка украина / кировоградская область / ольшанка"
  },
  "3538": {
    "id": "3538",
    "name": "Онуфриевка",
    "path": "Украина / Кировоградская область / Онуфриевка",
    "country": "Украина",
    "searchString": "онуфриевка украина / кировоградская область / онуфриевка"
  },
  "3539": {
    "id": "3539",
    "name": "Петрово",
    "path": "Украина / Кировоградская область / Петрово",
    "country": "Украина",
    "searchString": "петрово украина / кировоградская область / петрово"
  },
  "3540": {
    "id": "3540",
    "name": "Ульяновка (Кировоградская область)",
    "path": "Украина / Кировоградская область / Ульяновка (Кировоградская область)",
    "country": "Украина",
    "searchString": "ульяновка (кировоградская область) украина / кировоградская область / ульяновка (кировоградская область)"
  },
  "3541": {
    "id": "3541",
    "name": "Устиновка",
    "path": "Украина / Кировоградская область / Устиновка",
    "country": "Украина",
    "searchString": "устиновка украина / кировоградская область / устиновка"
  },
  "3542": {
    "id": "3542",
    "name": "Вижница",
    "path": "Украина / Черновицкая область / Вижница",
    "country": "Украина",
    "searchString": "вижница украина / черновицкая область / вижница"
  },
  "3543": {
    "id": "3543",
    "name": "Герца",
    "path": "Украина / Черновицкая область / Герца",
    "country": "Украина",
    "searchString": "герца украина / черновицкая область / герца"
  },
  "3544": {
    "id": "3544",
    "name": "Глыбокая",
    "path": "Украина / Черновицкая область / Глыбокая",
    "country": "Украина",
    "searchString": "глыбокая украина / черновицкая область / глыбокая"
  },
  "3545": {
    "id": "3545",
    "name": "Заставна",
    "path": "Украина / Черновицкая область / Заставна",
    "country": "Украина",
    "searchString": "заставна украина / черновицкая область / заставна"
  },
  "3546": {
    "id": "3546",
    "name": "Кельменцы",
    "path": "Украина / Черновицкая область / Кельменцы",
    "country": "Украина",
    "searchString": "кельменцы украина / черновицкая область / кельменцы"
  },
  "3547": {
    "id": "3547",
    "name": "Кицмань",
    "path": "Украина / Черновицкая область / Кицмань",
    "country": "Украина",
    "searchString": "кицмань украина / черновицкая область / кицмань"
  },
  "3548": {
    "id": "3548",
    "name": "Новоднестровск",
    "path": "Украина / Черновицкая область / Новоднестровск",
    "country": "Украина",
    "searchString": "новоднестровск украина / черновицкая область / новоднестровск"
  },
  "3549": {
    "id": "3549",
    "name": "Новоселица",
    "path": "Украина / Черновицкая область / Новоселица",
    "country": "Украина",
    "searchString": "новоселица украина / черновицкая область / новоселица"
  },
  "3550": {
    "id": "3550",
    "name": "Путила",
    "path": "Украина / Черновицкая область / Путила",
    "country": "Украина",
    "searchString": "путила украина / черновицкая область / путила"
  },
  "3551": {
    "id": "3551",
    "name": "Сокиряны",
    "path": "Украина / Черновицкая область / Сокиряны",
    "country": "Украина",
    "searchString": "сокиряны украина / черновицкая область / сокиряны"
  },
  "3552": {
    "id": "3552",
    "name": "Сторожинец",
    "path": "Украина / Черновицкая область / Сторожинец",
    "country": "Украина",
    "searchString": "сторожинец украина / черновицкая область / сторожинец"
  },
  "3553": {
    "id": "3553",
    "name": "Хотин",
    "path": "Украина / Черновицкая область / Хотин",
    "country": "Украина",
    "searchString": "хотин украина / черновицкая область / хотин"
  },
  "3554": {
    "id": "3554",
    "name": "Андрушевка",
    "path": "Украина / Житомирская область / Андрушевка",
    "country": "Украина",
    "searchString": "андрушевка украина / житомирская область / андрушевка"
  },
  "3555": {
    "id": "3555",
    "name": "Барановка",
    "path": "Украина / Житомирская область / Барановка",
    "country": "Украина",
    "searchString": "барановка украина / житомирская область / барановка"
  },
  "3556": {
    "id": "3556",
    "name": "Брусилов",
    "path": "Украина / Житомирская область / Брусилов",
    "country": "Украина",
    "searchString": "брусилов украина / житомирская область / брусилов"
  },
  "3557": {
    "id": "3557",
    "name": "Володарск-Волынский",
    "path": "Украина / Житомирская область / Володарск-Волынский",
    "country": "Украина",
    "searchString": "володарск-волынский украина / житомирская область / володарск-волынский"
  },
  "3558": {
    "id": "3558",
    "name": "Дзержинск (Житомирская область)",
    "path": "Украина / Житомирская область / Дзержинск (Житомирская область)",
    "country": "Украина",
    "searchString": "дзержинск (житомирская область) украина / житомирская область / дзержинск (житомирская область)"
  },
  "3559": {
    "id": "3559",
    "name": "Емильчино",
    "path": "Украина / Житомирская область / Емильчино",
    "country": "Украина",
    "searchString": "емильчино украина / житомирская область / емильчино"
  },
  "3560": {
    "id": "3560",
    "name": "Иршанск",
    "path": "Украина / Житомирская область / Иршанск",
    "country": "Украина",
    "searchString": "иршанск украина / житомирская область / иршанск"
  },
  "3561": {
    "id": "3561",
    "name": "Коростышев",
    "path": "Украина / Житомирская область / Коростышев",
    "country": "Украина",
    "searchString": "коростышев украина / житомирская область / коростышев"
  },
  "3562": {
    "id": "3562",
    "name": "Лугины",
    "path": "Украина / Житомирская область / Лугины",
    "country": "Украина",
    "searchString": "лугины украина / житомирская область / лугины"
  },
  "3563": {
    "id": "3563",
    "name": "Любар",
    "path": "Украина / Житомирская область / Любар",
    "country": "Украина",
    "searchString": "любар украина / житомирская область / любар"
  },
  "3564": {
    "id": "3564",
    "name": "Народичи",
    "path": "Украина / Житомирская область / Народичи",
    "country": "Украина",
    "searchString": "народичи украина / житомирская область / народичи"
  },
  "3565": {
    "id": "3565",
    "name": "Овруч",
    "path": "Украина / Житомирская область / Овруч",
    "country": "Украина",
    "searchString": "овруч украина / житомирская область / овруч"
  },
  "3566": {
    "id": "3566",
    "name": "Олевск",
    "path": "Украина / Житомирская область / Олевск",
    "country": "Украина",
    "searchString": "олевск украина / житомирская область / олевск"
  },
  "3567": {
    "id": "3567",
    "name": "Попельня",
    "path": "Украина / Житомирская область / Попельня",
    "country": "Украина",
    "searchString": "попельня украина / житомирская область / попельня"
  },
  "3568": {
    "id": "3568",
    "name": "Романов",
    "path": "Украина / Житомирская область / Романов",
    "country": "Украина",
    "searchString": "романов украина / житомирская область / романов"
  },
  "3569": {
    "id": "3569",
    "name": "Ружин",
    "path": "Украина / Житомирская область / Ружин",
    "country": "Украина",
    "searchString": "ружин украина / житомирская область / ружин"
  },
  "3570": {
    "id": "3570",
    "name": "Червоноармейск",
    "path": "Украина / Житомирская область / Червоноармейск",
    "country": "Украина",
    "searchString": "червоноармейск украина / житомирская область / червоноармейск"
  },
  "3571": {
    "id": "3571",
    "name": "Черняхов",
    "path": "Украина / Житомирская область / Черняхов",
    "country": "Украина",
    "searchString": "черняхов украина / житомирская область / черняхов"
  },
  "3572": {
    "id": "3572",
    "name": "Чуднов",
    "path": "Украина / Житомирская область / Чуднов",
    "country": "Украина",
    "searchString": "чуднов украина / житомирская область / чуднов"
  },
  "3573": {
    "id": "3573",
    "name": "Бахмач",
    "path": "Украина / Черниговская область / Бахмач",
    "country": "Украина",
    "searchString": "бахмач украина / черниговская область / бахмач"
  },
  "3574": {
    "id": "3574",
    "name": "Бобровица",
    "path": "Украина / Черниговская область / Бобровица",
    "country": "Украина",
    "searchString": "бобровица украина / черниговская область / бобровица"
  },
  "3575": {
    "id": "3575",
    "name": "Борзна",
    "path": "Украина / Черниговская область / Борзна",
    "country": "Украина",
    "searchString": "борзна украина / черниговская область / борзна"
  },
  "3576": {
    "id": "3576",
    "name": "Варва",
    "path": "Украина / Черниговская область / Варва",
    "country": "Украина",
    "searchString": "варва украина / черниговская область / варва"
  },
  "3577": {
    "id": "3577",
    "name": "Городня",
    "path": "Украина / Черниговская область / Городня",
    "country": "Украина",
    "searchString": "городня украина / черниговская область / городня"
  },
  "3578": {
    "id": "3578",
    "name": "Ичня",
    "path": "Украина / Черниговская область / Ичня",
    "country": "Украина",
    "searchString": "ичня украина / черниговская область / ичня"
  },
  "3579": {
    "id": "3579",
    "name": "Козелец",
    "path": "Украина / Черниговская область / Козелец",
    "country": "Украина",
    "searchString": "козелец украина / черниговская область / козелец"
  },
  "3580": {
    "id": "3580",
    "name": "Короп",
    "path": "Украина / Черниговская область / Короп",
    "country": "Украина",
    "searchString": "короп украина / черниговская область / короп"
  },
  "3581": {
    "id": "3581",
    "name": "Корюковка",
    "path": "Украина / Черниговская область / Корюковка",
    "country": "Украина",
    "searchString": "корюковка украина / черниговская область / корюковка"
  },
  "3582": {
    "id": "3582",
    "name": "Куликовка",
    "path": "Украина / Черниговская область / Куликовка",
    "country": "Украина",
    "searchString": "куликовка украина / черниговская область / куликовка"
  },
  "3583": {
    "id": "3583",
    "name": "Мена",
    "path": "Украина / Черниговская область / Мена",
    "country": "Украина",
    "searchString": "мена украина / черниговская область / мена"
  },
  "3584": {
    "id": "3584",
    "name": "Новгород-Северский",
    "path": "Украина / Черниговская область / Новгород-Северский",
    "country": "Украина",
    "searchString": "новгород-северский украина / черниговская область / новгород-северский"
  },
  "3585": {
    "id": "3585",
    "name": "Носовка",
    "path": "Украина / Черниговская область / Носовка",
    "country": "Украина",
    "searchString": "носовка украина / черниговская область / носовка"
  },
  "3586": {
    "id": "3586",
    "name": "Репки",
    "path": "Украина / Черниговская область / Репки",
    "country": "Украина",
    "searchString": "репки украина / черниговская область / репки"
  },
  "3587": {
    "id": "3587",
    "name": "Семеновка (Черниговская область)",
    "path": "Украина / Черниговская область / Семеновка (Черниговская область)",
    "country": "Украина",
    "searchString": "семеновка (черниговская область) украина / черниговская область / семеновка (черниговская область)"
  },
  "3588": {
    "id": "3588",
    "name": "Сосница",
    "path": "Украина / Черниговская область / Сосница",
    "country": "Украина",
    "searchString": "сосница украина / черниговская область / сосница"
  },
  "3589": {
    "id": "3589",
    "name": "Сребное",
    "path": "Украина / Черниговская область / Сребное",
    "country": "Украина",
    "searchString": "сребное украина / черниговская область / сребное"
  },
  "3590": {
    "id": "3590",
    "name": "Талалаевка",
    "path": "Украина / Черниговская область / Талалаевка",
    "country": "Украина",
    "searchString": "талалаевка украина / черниговская область / талалаевка"
  },
  "3591": {
    "id": "3591",
    "name": "Щорс",
    "path": "Украина / Черниговская область / Щорс",
    "country": "Украина",
    "searchString": "щорс украина / черниговская область / щорс"
  },
  "3592": {
    "id": "3592",
    "name": "Берегово",
    "path": "Украина / Закарпатская область / Берегово",
    "country": "Украина",
    "searchString": "берегово украина / закарпатская область / берегово"
  },
  "3593": {
    "id": "3593",
    "name": "Великий Березный",
    "path": "Украина / Закарпатская область / Великий Березный",
    "country": "Украина",
    "searchString": "великий березный украина / закарпатская область / великий березный"
  },
  "3594": {
    "id": "3594",
    "name": "Виноградов",
    "path": "Украина / Закарпатская область / Виноградов",
    "country": "Украина",
    "searchString": "виноградов украина / закарпатская область / виноградов"
  },
  "3595": {
    "id": "3595",
    "name": "Воловец",
    "path": "Украина / Закарпатская область / Воловец",
    "country": "Украина",
    "searchString": "воловец украина / закарпатская область / воловец"
  },
  "3596": {
    "id": "3596",
    "name": "Иршава",
    "path": "Украина / Закарпатская область / Иршава",
    "country": "Украина",
    "searchString": "иршава украина / закарпатская область / иршава"
  },
  "3597": {
    "id": "3597",
    "name": "Межгорье (Закарпатская область)",
    "path": "Украина / Закарпатская область / Межгорье (Закарпатская область)",
    "country": "Украина",
    "searchString": "межгорье (закарпатская область) украина / закарпатская область / межгорье (закарпатская область)"
  },
  "3598": {
    "id": "3598",
    "name": "Перечин",
    "path": "Украина / Закарпатская область / Перечин",
    "country": "Украина",
    "searchString": "перечин украина / закарпатская область / перечин"
  },
  "3599": {
    "id": "3599",
    "name": "Рахов",
    "path": "Украина / Закарпатская область / Рахов",
    "country": "Украина",
    "searchString": "рахов украина / закарпатская область / рахов"
  },
  "3600": {
    "id": "3600",
    "name": "Свалява",
    "path": "Украина / Закарпатская область / Свалява",
    "country": "Украина",
    "searchString": "свалява украина / закарпатская область / свалява"
  },
  "3601": {
    "id": "3601",
    "name": "Тячев",
    "path": "Украина / Закарпатская область / Тячев",
    "country": "Украина",
    "searchString": "тячев украина / закарпатская область / тячев"
  },
  "3602": {
    "id": "3602",
    "name": "Хуст",
    "path": "Украина / Закарпатская область / Хуст",
    "country": "Украина",
    "searchString": "хуст украина / закарпатская область / хуст"
  },
  "3603": {
    "id": "3603",
    "name": "Чоп",
    "path": "Украина / Закарпатская область / Чоп",
    "country": "Украина",
    "searchString": "чоп украина / закарпатская область / чоп"
  },
  "3604": {
    "id": "3604",
    "name": "Владимир-Волынский",
    "path": "Украина / Волынская область / Владимир-Волынский",
    "country": "Украина",
    "searchString": "владимир-волынский украина / волынская область / владимир-волынский"
  },
  "3605": {
    "id": "3605",
    "name": "Горохов",
    "path": "Украина / Волынская область / Горохов",
    "country": "Украина",
    "searchString": "горохов украина / волынская область / горохов"
  },
  "3606": {
    "id": "3606",
    "name": "Иваничи",
    "path": "Украина / Волынская область / Иваничи",
    "country": "Украина",
    "searchString": "иваничи украина / волынская область / иваничи"
  },
  "3607": {
    "id": "3607",
    "name": "Камень-Каширский",
    "path": "Украина / Волынская область / Камень-Каширский",
    "country": "Украина",
    "searchString": "камень-каширский украина / волынская область / камень-каширский"
  },
  "3608": {
    "id": "3608",
    "name": "Киверцы",
    "path": "Украина / Волынская область / Киверцы",
    "country": "Украина",
    "searchString": "киверцы украина / волынская область / киверцы"
  },
  "3609": {
    "id": "3609",
    "name": "Локачи",
    "path": "Украина / Волынская область / Локачи",
    "country": "Украина",
    "searchString": "локачи украина / волынская область / локачи"
  },
  "3610": {
    "id": "3610",
    "name": "Любешов",
    "path": "Украина / Волынская область / Любешов",
    "country": "Украина",
    "searchString": "любешов украина / волынская область / любешов"
  },
  "3611": {
    "id": "3611",
    "name": "Любомль",
    "path": "Украина / Волынская область / Любомль",
    "country": "Украина",
    "searchString": "любомль украина / волынская область / любомль"
  },
  "3612": {
    "id": "3612",
    "name": "Маневичи",
    "path": "Украина / Волынская область / Маневичи",
    "country": "Украина",
    "searchString": "маневичи украина / волынская область / маневичи"
  },
  "3613": {
    "id": "3613",
    "name": "Нововолынск",
    "path": "Украина / Волынская область / Нововолынск",
    "country": "Украина",
    "searchString": "нововолынск украина / волынская область / нововолынск"
  },
  "3614": {
    "id": "3614",
    "name": "Ратно",
    "path": "Украина / Волынская область / Ратно",
    "country": "Украина",
    "searchString": "ратно украина / волынская область / ратно"
  },
  "3615": {
    "id": "3615",
    "name": "Рожище",
    "path": "Украина / Волынская область / Рожище",
    "country": "Украина",
    "searchString": "рожище украина / волынская область / рожище"
  },
  "3616": {
    "id": "3616",
    "name": "Старая Выжевка",
    "path": "Украина / Волынская область / Старая Выжевка",
    "country": "Украина",
    "searchString": "старая выжевка украина / волынская область / старая выжевка"
  },
  "3617": {
    "id": "3617",
    "name": "Турийск",
    "path": "Украина / Волынская область / Турийск",
    "country": "Украина",
    "searchString": "турийск украина / волынская область / турийск"
  },
  "3618": {
    "id": "3618",
    "name": "Шацк (Волынская область)",
    "path": "Украина / Волынская область / Шацк (Волынская область)",
    "country": "Украина",
    "searchString": "шацк (волынская область) украина / волынская область / шацк (волынская область)"
  },
  "3619": {
    "id": "3619",
    "name": "Курахово",
    "path": "Россия / Донецкая Народная Республика / Курахово",
    "country": "Россия",
    "searchString": "курахово россия / донецкая народная республика / курахово"
  },
  "3620": {
    "id": "3620",
    "name": "Барвенково",
    "path": "Украина / Харьковская область / Барвенково",
    "country": "Украина",
    "searchString": "барвенково украина / харьковская область / барвенково"
  },
  "3621": {
    "id": "3621",
    "name": "Верховцево",
    "path": "Украина / Днепропетровская область / Верховцево",
    "country": "Украина",
    "searchString": "верховцево украина / днепропетровская область / верховцево"
  },
  "3622": {
    "id": "3622",
    "name": "Винники",
    "path": "Украина / Львовская область / Винники",
    "country": "Украина",
    "searchString": "винники украина / львовская область / винники"
  },
  "3623": {
    "id": "3623",
    "name": "Люботин",
    "path": "Украина / Харьковская область / Люботин",
    "country": "Украина",
    "searchString": "люботин украина / харьковская область / люботин"
  },
  "3624": {
    "id": "3624",
    "name": "Валки",
    "path": "Украина / Харьковская область / Валки",
    "country": "Украина",
    "searchString": "валки украина / харьковская область / валки"
  },
  "3625": {
    "id": "3625",
    "name": "Копычинцы",
    "path": "Украина / Тернопольская область / Копычинцы",
    "country": "Украина",
    "searchString": "копычинцы украина / тернопольская область / копычинцы"
  },
  "3626": {
    "id": "3626",
    "name": "Святогорск",
    "path": "Россия / Донецкая Народная Республика / Святогорск",
    "country": "Россия",
    "searchString": "святогорск россия / донецкая народная республика / святогорск"
  },
  "3627": {
    "id": "3627",
    "name": "Счастье",
    "path": "Россия / Луганская Народная Республика / Счастье",
    "country": "Россия",
    "searchString": "счастье россия / луганская народная республика / счастье"
  },
  "3628": {
    "id": "3628",
    "name": "Александровск (Луганская Народная Республика)",
    "path": "Россия / Луганская Народная Республика / Александровск (Луганская Народная Республика)",
    "country": "Россия",
    "searchString": "александровск (луганская народная республика) россия / луганская народная республика / александровск (луганская народная республика)"
  },
  "3629": {
    "id": "3629",
    "name": "Алмазная",
    "path": "Россия / Луганская Народная Республика / Алмазная",
    "country": "Россия",
    "searchString": "алмазная россия / луганская народная республика / алмазная"
  },
  "3630": {
    "id": "3630",
    "name": "Артемово",
    "path": "Россия / Донецкая Народная Республика / Артемово",
    "country": "Россия",
    "searchString": "артемово россия / донецкая народная республика / артемово"
  },
  "3631": {
    "id": "3631",
    "name": "Батурин",
    "path": "Украина / Черновицкая область / Батурин",
    "country": "Украина",
    "searchString": "батурин украина / черновицкая область / батурин"
  },
  "3632": {
    "id": "3632",
    "name": "Белз",
    "path": "Украина / Львовская область / Белз",
    "country": "Украина",
    "searchString": "белз украина / львовская область / белз"
  },
  "3633": {
    "id": "3633",
    "name": "Белицкое",
    "path": "Россия / Донецкая Народная Республика / Белицкое",
    "country": "Россия",
    "searchString": "белицкое россия / донецкая народная республика / белицкое"
  },
  "3634": {
    "id": "3634",
    "name": "Берестечко",
    "path": "Украина / Волынская область / Берестечко",
    "country": "Украина",
    "searchString": "берестечко украина / волынская область / берестечко"
  },
  "3635": {
    "id": "3635",
    "name": "Бобрка",
    "path": "Украина / Львовская область / Бобрка",
    "country": "Украина",
    "searchString": "бобрка украина / львовская область / бобрка"
  },
  "3636": {
    "id": "3636",
    "name": "Вашковцы",
    "path": "Украина / Черновицкая область / Вашковцы",
    "country": "Украина",
    "searchString": "вашковцы украина / черновицкая область / вашковцы"
  },
  "3637": {
    "id": "3637",
    "name": "Великие Мосты",
    "path": "Украина / Львовская область / Великие Мосты",
    "country": "Украина",
    "searchString": "великие мосты украина / львовская область / великие мосты"
  },
  "3638": {
    "id": "3638",
    "name": "Вилково",
    "path": "Украина / Одесская область / Вилково",
    "country": "Украина",
    "searchString": "вилково украина / одесская область / вилково"
  },
  "3639": {
    "id": "3639",
    "name": "Ворожба",
    "path": "Украина / Сумская область / Ворожба",
    "country": "Украина",
    "searchString": "ворожба украина / сумская область / ворожба"
  },
  "3640": {
    "id": "3640",
    "name": "Глиняны",
    "path": "Украина / Львовская область / Глиняны",
    "country": "Украина",
    "searchString": "глиняны украина / львовская область / глиняны"
  },
  "3641": {
    "id": "3641",
    "name": "Гнивань",
    "path": "Украина / Винницкая область / Гнивань",
    "country": "Украина",
    "searchString": "гнивань украина / винницкая область / гнивань"
  },
  "3642": {
    "id": "3642",
    "name": "Дружба",
    "path": "Украина / Сумская область / Дружба",
    "country": "Украина",
    "searchString": "дружба украина / сумская область / дружба"
  },
  "3643": {
    "id": "3643",
    "name": "Дубляны",
    "path": "Украина / Львовская область / Дубляны",
    "country": "Украина",
    "searchString": "дубляны украина / львовская область / дубляны"
  },
  "3644": {
    "id": "3644",
    "name": "Молочанск",
    "path": "Россия / Запорожская область / Молочанск",
    "country": "Россия",
    "searchString": "молочанск россия / запорожская область / молочанск"
  },
  "3645": {
    "id": "3645",
    "name": "Перещепино",
    "path": "Украина / Днепропетровская область / Перещепино",
    "country": "Украина",
    "searchString": "перещепино украина / днепропетровская область / перещепино"
  },
  "3646": {
    "id": "3646",
    "name": "Подгородное",
    "path": "Украина / Днепропетровская область / Подгородное",
    "country": "Украина",
    "searchString": "подгородное украина / днепропетровская область / подгородное"
  },
  "3647": {
    "id": "3647",
    "name": "Седнев",
    "path": "Украина / Черниговская область / Седнев",
    "country": "Украина",
    "searchString": "седнев украина / черниговская область / седнев"
  },
  "3648": {
    "id": "3648",
    "name": "Скалат",
    "path": "Украина / Тернопольская область / Скалат",
    "country": "Украина",
    "searchString": "скалат украина / тернопольская область / скалат"
  },
  "3649": {
    "id": "3649",
    "name": "Таврийск",
    "path": "Россия / Херсонская область / Таврийск",
    "country": "Россия",
    "searchString": "таврийск россия / херсонская область / таврийск"
  },
  "3650": {
    "id": "3650",
    "name": "Теплодар",
    "path": "Украина / Одесская область / Теплодар",
    "country": "Украина",
    "searchString": "теплодар украина / одесская область / теплодар"
  },
  "3651": {
    "id": "3651",
    "name": "Угнев",
    "path": "Украина / Львовская область / Угнев",
    "country": "Украина",
    "searchString": "угнев украина / львовская область / угнев"
  },
  "3652": {
    "id": "3652",
    "name": "Устилуг",
    "path": "Украина / Волынская область / Устилуг",
    "country": "Украина",
    "searchString": "устилуг украина / волынская область / устилуг"
  },
  "3653": {
    "id": "3653",
    "name": "Хыров",
    "path": "Украина / Львовская область / Хыров",
    "country": "Украина",
    "searchString": "хыров украина / львовская область / хыров"
  },
  "3654": {
    "id": "3654",
    "name": "Червонозаводское",
    "path": "Украина / Полтавская область / Червонозаводское",
    "country": "Украина",
    "searchString": "червонозаводское украина / полтавская область / червонозаводское"
  },
  "3655": {
    "id": "3655",
    "name": "Червонопартизанск",
    "path": "Россия / Луганская Народная Республика / Червонопартизанск",
    "country": "Россия",
    "searchString": "червонопартизанск россия / луганская народная республика / червонопартизанск"
  },
  "3656": {
    "id": "3656",
    "name": "Рудки",
    "path": "Украина / Львовская область / Рудки",
    "country": "Украина",
    "searchString": "рудки украина / львовская область / рудки"
  },
  "3657": {
    "id": "3657",
    "name": "Бакалы",
    "path": "Россия / Республика Башкортостан / Бакалы",
    "country": "Россия",
    "searchString": "бакалы россия / республика башкортостан / бакалы"
  },
  "3658": {
    "id": "3658",
    "name": "Актаныш",
    "path": "Россия / Республика Татарстан / Актаныш",
    "country": "Россия",
    "searchString": "актаныш россия / республика татарстан / актаныш"
  },
  "3659": {
    "id": "3659",
    "name": "Прибрежный",
    "path": "Россия / Самарская область / Прибрежный",
    "country": "Россия",
    "searchString": "прибрежный россия / самарская область / прибрежный"
  },
  "3660": {
    "id": "3660",
    "name": "Мучкапский",
    "path": "Россия / Тамбовская область / Мучкапский",
    "country": "Россия",
    "searchString": "мучкапский россия / тамбовская область / мучкапский"
  },
  "3661": {
    "id": "3661",
    "name": "Буздяк",
    "path": "Россия / Республика Башкортостан / Буздяк",
    "country": "Россия",
    "searchString": "буздяк россия / республика башкортостан / буздяк"
  },
  "3662": {
    "id": "3662",
    "name": "Южный (Краснодарский край)",
    "path": "Россия / Краснодарский край / Южный (Краснодарский край)",
    "country": "Россия",
    "searchString": "южный (краснодарский край) россия / краснодарский край / южный (краснодарский край)"
  },
  "3663": {
    "id": "3663",
    "name": "Атбасар",
    "path": "Казахстан / Атбасар",
    "country": "Казахстан",
    "searchString": "атбасар казахстан / атбасар"
  },
  "3664": {
    "id": "3664",
    "name": "Балахта (Красноярский край)",
    "path": "Россия / Красноярский край / Балахта (Красноярский край)",
    "country": "Россия",
    "searchString": "балахта (красноярский край) россия / красноярский край / балахта (красноярский край)"
  },
  "3665": {
    "id": "3665",
    "name": "Тамань",
    "path": "Россия / Краснодарский край / Тамань",
    "country": "Россия",
    "searchString": "тамань россия / краснодарский край / тамань"
  },
  "3666": {
    "id": "3666",
    "name": "Республика Никарагуа",
    "path": "Другие регионы / Республика Никарагуа",
    "country": "Другие регионы",
    "searchString": "республика никарагуа другие регионы / республика никарагуа"
  },
  "3667": {
    "id": "3667",
    "name": "Морки",
    "path": "Россия / Республика Марий Эл / Морки",
    "country": "Россия",
    "searchString": "морки россия / республика марий эл / морки"
  },
  "3668": {
    "id": "3668",
    "name": "Кадамжай",
    "path": "Кыргызстан / Кадамжай",
    "country": "Кыргызстан",
    "searchString": "кадамжай кыргызстан / кадамжай"
  },
  "3669": {
    "id": "3669",
    "name": "Шипуново",
    "path": "Россия / Алтайский край / Шипуново",
    "country": "Россия",
    "searchString": "шипуново россия / алтайский край / шипуново"
  },
  "3670": {
    "id": "3670",
    "name": "Родино",
    "path": "Россия / Алтайский край / Родино",
    "country": "Россия",
    "searchString": "родино россия / алтайский край / родино"
  },
  "3671": {
    "id": "3671",
    "name": "Троицкое (Алтайский край)",
    "path": "Россия / Алтайский край / Троицкое (Алтайский край)",
    "country": "Россия",
    "searchString": "троицкое (алтайский край) россия / алтайский край / троицкое (алтайский край)"
  },
  "3672": {
    "id": "3672",
    "name": "Мамонтово",
    "path": "Россия / Алтайский край / Мамонтово",
    "country": "Россия",
    "searchString": "мамонтово россия / алтайский край / мамонтово"
  },
  "3673": {
    "id": "3673",
    "name": "Кадуй",
    "path": "Россия / Вологодская область / Кадуй",
    "country": "Россия",
    "searchString": "кадуй россия / вологодская область / кадуй"
  },
  "3674": {
    "id": "3674",
    "name": "Яльчики",
    "path": "Россия / Чувашская Республика / Яльчики",
    "country": "Россия",
    "searchString": "яльчики россия / чувашская республика / яльчики"
  },
  "3675": {
    "id": "3675",
    "name": "Моргауши",
    "path": "Россия / Чувашская Республика / Моргауши",
    "country": "Россия",
    "searchString": "моргауши россия / чувашская республика / моргауши"
  },
  "3676": {
    "id": "3676",
    "name": "Вурнары",
    "path": "Россия / Чувашская Республика / Вурнары",
    "country": "Россия",
    "searchString": "вурнары россия / чувашская республика / вурнары"
  },
  "3677": {
    "id": "3677",
    "name": "Комсомольское (Чувашская Республика)",
    "path": "Россия / Чувашская Республика / Комсомольское (Чувашская Республика)",
    "country": "Россия",
    "searchString": "комсомольское (чувашская республика) россия / чувашская республика / комсомольское (чувашская республика)"
  },
  "3678": {
    "id": "3678",
    "name": "Батырево",
    "path": "Россия / Чувашская Республика / Батырево",
    "country": "Россия",
    "searchString": "батырево россия / чувашская республика / батырево"
  },
  "3679": {
    "id": "3679",
    "name": "Урмары",
    "path": "Россия / Чувашская Республика / Урмары",
    "country": "Россия",
    "searchString": "урмары россия / чувашская республика / урмары"
  },
  "3680": {
    "id": "3680",
    "name": "Большой Сундырь",
    "path": "Россия / Чувашская Республика / Большой Сундырь",
    "country": "Россия",
    "searchString": "большой сундырь россия / чувашская республика / большой сундырь"
  },
  "3681": {
    "id": "3681",
    "name": "Красноармейское",
    "path": "Россия / Чувашская Республика / Красноармейское",
    "country": "Россия",
    "searchString": "красноармейское россия / чувашская республика / красноармейское"
  },
  "3682": {
    "id": "3682",
    "name": "Волоконовка",
    "path": "Россия / Белгородская область / Волоконовка",
    "country": "Россия",
    "searchString": "волоконовка россия / белгородская область / волоконовка"
  },
  "3683": {
    "id": "3683",
    "name": "Чернянка",
    "path": "Россия / Белгородская область / Чернянка",
    "country": "Россия",
    "searchString": "чернянка россия / белгородская область / чернянка"
  },
  "3684": {
    "id": "3684",
    "name": "Вейделевка",
    "path": "Россия / Белгородская область / Вейделевка",
    "country": "Россия",
    "searchString": "вейделевка россия / белгородская область / вейделевка"
  },
  "3685": {
    "id": "3685",
    "name": "Разумное",
    "path": "Россия / Белгородская область / Разумное",
    "country": "Россия",
    "searchString": "разумное россия / белгородская область / разумное"
  },
  "3686": {
    "id": "3686",
    "name": "Пестяки",
    "path": "Россия / Ивановская область / Пестяки",
    "country": "Россия",
    "searchString": "пестяки россия / ивановская область / пестяки"
  },
  "3687": {
    "id": "3687",
    "name": "Русский Камешкир",
    "path": "Россия / Пензенская область / Русский Камешкир",
    "country": "Россия",
    "searchString": "русский камешкир россия / пензенская область / русский камешкир"
  },
  "3688": {
    "id": "3688",
    "name": "Средняя Елюзань",
    "path": "Россия / Пензенская область / Средняя Елюзань",
    "country": "Россия",
    "searchString": "средняя елюзань россия / пензенская область / средняя елюзань"
  },
  "3689": {
    "id": "3689",
    "name": "Неверкино",
    "path": "Россия / Пензенская область / Неверкино",
    "country": "Россия",
    "searchString": "неверкино россия / пензенская область / неверкино"
  },
  "3690": {
    "id": "3690",
    "name": "Краснообск",
    "path": "Россия / Новосибирская область / Краснообск",
    "country": "Россия",
    "searchString": "краснообск россия / новосибирская область / краснообск"
  },
  "3691": {
    "id": "3691",
    "name": "Кармаскалы",
    "path": "Россия / Республика Башкортостан / Кармаскалы",
    "country": "Россия",
    "searchString": "кармаскалы россия / республика башкортостан / кармаскалы"
  },
  "3692": {
    "id": "3692",
    "name": "Старое Дрожжаное",
    "path": "Россия / Республика Татарстан / Старое Дрожжаное",
    "country": "Россия",
    "searchString": "старое дрожжаное россия / республика татарстан / старое дрожжаное"
  },
  "3693": {
    "id": "3693",
    "name": "Частые",
    "path": "Россия / Пермский край / Частые",
    "country": "Россия",
    "searchString": "частые россия / пермский край / частые"
  },
  "3694": {
    "id": "3694",
    "name": "Яр-Сале",
    "path": "Россия / Ямало-Ненецкий АО / Яр-Сале",
    "country": "Россия",
    "searchString": "яр-сале россия / ямало-ненецкий ао / яр-сале"
  },
  "3695": {
    "id": "3695",
    "name": "Промышленная",
    "path": "Россия / Кемеровская область / Промышленная",
    "country": "Россия",
    "searchString": "промышленная россия / кемеровская область / промышленная"
  },
  "3696": {
    "id": "3696",
    "name": "Фалёнки",
    "path": "Россия / Кировская область / Фалёнки",
    "country": "Россия",
    "searchString": "фалёнки россия / кировская область / фалёнки"
  },
  "3697": {
    "id": "3697",
    "name": "Новая Адыгея",
    "path": "Россия / Республика Адыгея / Новая Адыгея",
    "country": "Россия",
    "searchString": "новая адыгея россия / республика адыгея / новая адыгея"
  },
  "3698": {
    "id": "3698",
    "name": "Кугеси",
    "path": "Россия / Чувашская Республика / Кугеси",
    "country": "Россия",
    "searchString": "кугеси россия / чувашская республика / кугеси"
  },
  "3699": {
    "id": "3699",
    "name": "Кагальницкая",
    "path": "Россия / Ростовская область / Кагальницкая",
    "country": "Россия",
    "searchString": "кагальницкая россия / ростовская область / кагальницкая"
  },
  "3700": {
    "id": "3700",
    "name": "Трудармейский",
    "path": "Россия / Кемеровская область / Трудармейский",
    "country": "Россия",
    "searchString": "трудармейский россия / кемеровская область / трудармейский"
  },
  "3701": {
    "id": "3701",
    "name": "Парголово",
    "path": "Россия / Ленинградская область / Парголово",
    "country": "Россия",
    "searchString": "парголово россия / ленинградская область / парголово"
  },
  "3702": {
    "id": "3702",
    "name": "Кавалерово",
    "path": "Россия / Приморский край / Кавалерово",
    "country": "Россия",
    "searchString": "кавалерово россия / приморский край / кавалерово"
  },
  "3703": {
    "id": "3703",
    "name": "Шилово",
    "path": "Россия / Рязанская область / Шилово",
    "country": "Россия",
    "searchString": "шилово россия / рязанская область / шилово"
  },
  "3704": {
    "id": "3704",
    "name": "Чарск (Шар)",
    "path": "Казахстан / Чарск (Шар)",
    "country": "Казахстан",
    "searchString": "чарск (шар) казахстан / чарск (шар)"
  },
  "3705": {
    "id": "3705",
    "name": "Федяково (Нижегородская область)",
    "path": "Россия / Нижегородская область / Федяково (Нижегородская область)",
    "country": "Россия",
    "searchString": "федяково (нижегородская область) россия / нижегородская область / федяково (нижегородская область)"
  },
  "3706": {
    "id": "3706",
    "name": "Юрья",
    "path": "Россия / Кировская область / Юрья",
    "country": "Россия",
    "searchString": "юрья россия / кировская область / юрья"
  },
  "3707": {
    "id": "3707",
    "name": "Прохоровка",
    "path": "Россия / Белгородская область / Прохоровка",
    "country": "Россия",
    "searchString": "прохоровка россия / белгородская область / прохоровка"
  },
  "3708": {
    "id": "3708",
    "name": "Усть-Нера",
    "path": "Россия / Республика Саха (Якутия) / Усть-Нера",
    "country": "Россия",
    "searchString": "усть-нера россия / республика саха (якутия) / усть-нера"
  },
  "3709": {
    "id": "3709",
    "name": "Мошково",
    "path": "Россия / Новосибирская область / Мошково",
    "country": "Россия",
    "searchString": "мошково россия / новосибирская область / мошково"
  },
  "3710": {
    "id": "3710",
    "name": "Иглино",
    "path": "Россия / Республика Башкортостан / Иглино",
    "country": "Россия",
    "searchString": "иглино россия / республика башкортостан / иглино"
  },
  "3711": {
    "id": "3711",
    "name": "Северо-Енисейский",
    "path": "Россия / Краснодарский край / Северо-Енисейский",
    "country": "Россия",
    "searchString": "северо-енисейский россия / краснодарский край / северо-енисейский"
  },
  "3712": {
    "id": "3712",
    "name": "Коченево",
    "path": "Россия / Новосибирская область / Коченево",
    "country": "Россия",
    "searchString": "коченево россия / новосибирская область / коченево"
  },
  "3713": {
    "id": "3713",
    "name": "Беково",
    "path": "Россия / Пензенская область / Беково",
    "country": "Россия",
    "searchString": "беково россия / пензенская область / беково"
  },
  "3714": {
    "id": "3714",
    "name": "Гиагинская",
    "path": "Россия / Республика Адыгея / Гиагинская",
    "country": "Россия",
    "searchString": "гиагинская россия / республика адыгея / гиагинская"
  },
  "3715": {
    "id": "3715",
    "name": "Камские Поляны",
    "path": "Россия / Республика Татарстан / Камские Поляны",
    "country": "Россия",
    "searchString": "камские поляны россия / республика татарстан / камские поляны"
  },
  "3716": {
    "id": "3716",
    "name": "Залари",
    "path": "Россия / Иркутская область / Залари",
    "country": "Россия",
    "searchString": "залари россия / иркутская область / залари"
  },
  "3717": {
    "id": "3717",
    "name": "Игра",
    "path": "Россия / Удмуртская Республика / Игра",
    "country": "Россия",
    "searchString": "игра россия / удмуртская республика / игра"
  },
  "3718": {
    "id": "3718",
    "name": "Верхний Мамон",
    "path": "Россия / Воронежская область / Верхний Мамон",
    "country": "Россия",
    "searchString": "верхний мамон россия / воронежская область / верхний мамон"
  },
  "3719": {
    "id": "3719",
    "name": "Берёзово",
    "path": "Россия / Ханты-Мансийский АО - Югра / Берёзово",
    "country": "Россия",
    "searchString": "берёзово россия / ханты-мансийский ао - югра / берёзово"
  },
  "3720": {
    "id": "3720",
    "name": "Петропавловка (Воронежская область)",
    "path": "Россия / Воронежская область / Петропавловка (Воронежская область)",
    "country": "Россия",
    "searchString": "петропавловка (воронежская область) россия / воронежская область / петропавловка (воронежская область)"
  },
  "3721": {
    "id": "3721",
    "name": "Пластуновская",
    "path": "Россия / Краснодарский край / Пластуновская",
    "country": "Россия",
    "searchString": "пластуновская россия / краснодарский край / пластуновская"
  },
  "3722": {
    "id": "3722",
    "name": "Торбеево",
    "path": "Россия / Республика Мордовия / Торбеево",
    "country": "Россия",
    "searchString": "торбеево россия / республика мордовия / торбеево"
  },
  "3723": {
    "id": "3723",
    "name": "Атюрьево",
    "path": "Россия / Республика Мордовия / Атюрьево",
    "country": "Россия",
    "searchString": "атюрьево россия / республика мордовия / атюрьево"
  },
  "3724": {
    "id": "3724",
    "name": "Явас",
    "path": "Россия / Республика Мордовия / Явас",
    "country": "Россия",
    "searchString": "явас россия / республика мордовия / явас"
  },
  "3725": {
    "id": "3725",
    "name": "Зубова-Поляна",
    "path": "Россия / Республика Мордовия / Зубова-Поляна",
    "country": "Россия",
    "searchString": "зубова-поляна россия / республика мордовия / зубова-поляна"
  },
  "3726": {
    "id": "3726",
    "name": "Кунашак",
    "path": "Россия / Челябинская область / Кунашак",
    "country": "Россия",
    "searchString": "кунашак россия / челябинская область / кунашак"
  },
  "3727": {
    "id": "3727",
    "name": "Томилино (Московская область)",
    "path": "Россия / Московская область / Томилино (Московская область)",
    "country": "Россия",
    "searchString": "томилино (московская область) россия / московская область / томилино (московская область)"
  },
  "3728": {
    "id": "3728",
    "name": "Пушкинские Горы",
    "path": "Россия / Псковская область / Пушкинские Горы",
    "country": "Россия",
    "searchString": "пушкинские горы россия / псковская область / пушкинские горы"
  },
  "3729": {
    "id": "3729",
    "name": "Пристень",
    "path": "Россия / Курская область / Пристень",
    "country": "Россия",
    "searchString": "пристень россия / курская область / пристень"
  },
  "3730": {
    "id": "3730",
    "name": "Глушково",
    "path": "Россия / Курская область / Глушково",
    "country": "Россия",
    "searchString": "глушково россия / курская область / глушково"
  },
  "3731": {
    "id": "3731",
    "name": "Кочубеевское",
    "path": "Россия / Ставропольский край / Кочубеевское",
    "country": "Россия",
    "searchString": "кочубеевское россия / ставропольский край / кочубеевское"
  },
  "3732": {
    "id": "3732",
    "name": "Средняя Ахтуба",
    "path": "Россия / Волгоградская область / Средняя Ахтуба",
    "country": "Россия",
    "searchString": "средняя ахтуба россия / волгоградская область / средняя ахтуба"
  },
  "3733": {
    "id": "3733",
    "name": "Старая Полтавка",
    "path": "Россия / Волгоградская область / Старая Полтавка",
    "country": "Россия",
    "searchString": "старая полтавка россия / волгоградская область / старая полтавка"
  },
  "3734": {
    "id": "3734",
    "name": "Павловская Слобода (Московская область)",
    "path": "Россия / Московская область / Павловская Слобода (Московская область)",
    "country": "Россия",
    "searchString": "павловская слобода (московская область) россия / московская область / павловская слобода (московская область)"
  },
  "3735": {
    "id": "3735",
    "name": "Кулунда",
    "path": "Россия / Алтайский край / Кулунда",
    "country": "Россия",
    "searchString": "кулунда россия / алтайский край / кулунда"
  },
  "3736": {
    "id": "3736",
    "name": "Строитель (Тамбовская область)",
    "path": "Россия / Тамбовская область / Строитель (Тамбовская область)",
    "country": "Россия",
    "searchString": "строитель (тамбовская область) россия / тамбовская область / строитель (тамбовская область)"
  },
  "3737": {
    "id": "3737",
    "name": "Кадошкино",
    "path": "Россия / Республика Мордовия / Кадошкино",
    "country": "Россия",
    "searchString": "кадошкино россия / республика мордовия / кадошкино"
  },
  "3738": {
    "id": "3738",
    "name": "Потьма",
    "path": "Россия / Республика Мордовия / Потьма",
    "country": "Россия",
    "searchString": "потьма россия / республика мордовия / потьма"
  },
  "3739": {
    "id": "3739",
    "name": "Теньгушево",
    "path": "Россия / Республика Мордовия / Теньгушево",
    "country": "Россия",
    "searchString": "теньгушево россия / республика мордовия / теньгушево"
  },
  "3740": {
    "id": "3740",
    "name": "Ромоданово",
    "path": "Россия / Республика Мордовия / Ромоданово",
    "country": "Россия",
    "searchString": "ромоданово россия / республика мордовия / ромоданово"
  },
  "3741": {
    "id": "3741",
    "name": "Атемар",
    "path": "Россия / Республика Мордовия / Атемар",
    "country": "Россия",
    "searchString": "атемар россия / республика мордовия / атемар"
  },
  "3742": {
    "id": "3742",
    "name": "Александрийская",
    "path": "Россия / Ставропольский край / Александрийская",
    "country": "Россия",
    "searchString": "александрийская россия / ставропольский край / александрийская"
  },
  "3743": {
    "id": "3743",
    "name": "Александрия (Ставропольский край)",
    "path": "Россия / Ставропольский край / Александрия (Ставропольский край)",
    "country": "Россия",
    "searchString": "александрия (ставропольский край) россия / ставропольский край / александрия (ставропольский край)"
  },
  "3744": {
    "id": "3744",
    "name": "Арзгир",
    "path": "Россия / Ставропольский край / Арзгир",
    "country": "Россия",
    "searchString": "арзгир россия / ставропольский край / арзгир"
  },
  "3745": {
    "id": "3745",
    "name": "Ачикулак",
    "path": "Россия / Ставропольский край / Ачикулак",
    "country": "Россия",
    "searchString": "ачикулак россия / ставропольский край / ачикулак"
  },
  "3746": {
    "id": "3746",
    "name": "Балахоновское",
    "path": "Россия / Ставропольский край / Балахоновское",
    "country": "Россия",
    "searchString": "балахоновское россия / ставропольский край / балахоновское"
  },
  "3747": {
    "id": "3747",
    "name": "Барсуковская",
    "path": "Россия / Ставропольский край / Барсуковская",
    "country": "Россия",
    "searchString": "барсуковская россия / ставропольский край / барсуковская"
  },
  "3748": {
    "id": "3748",
    "name": "Безопасное",
    "path": "Россия / Ставропольский край / Безопасное",
    "country": "Россия",
    "searchString": "безопасное россия / ставропольский край / безопасное"
  },
  "3749": {
    "id": "3749",
    "name": "Бекешевская",
    "path": "Россия / Ставропольский край / Бекешевская",
    "country": "Россия",
    "searchString": "бекешевская россия / ставропольский край / бекешевская"
  },
  "3750": {
    "id": "3750",
    "name": "Бешпагир",
    "path": "Россия / Ставропольский край / Бешпагир",
    "country": "Россия",
    "searchString": "бешпагир россия / ставропольский край / бешпагир"
  },
  "3751": {
    "id": "3751",
    "name": "Благодатное",
    "path": "Россия / Ставропольский край / Благодатное",
    "country": "Россия",
    "searchString": "благодатное россия / ставропольский край / благодатное"
  },
  "3752": {
    "id": "3752",
    "name": "Боргустанская",
    "path": "Россия / Ставропольский край / Боргустанская",
    "country": "Россия",
    "searchString": "боргустанская россия / ставропольский край / боргустанская"
  },
  "3753": {
    "id": "3753",
    "name": "Величаевское",
    "path": "Россия / Ставропольский край / Величаевское",
    "country": "Россия",
    "searchString": "величаевское россия / ставропольский край / величаевское"
  },
  "3754": {
    "id": "3754",
    "name": "Верхнерусское",
    "path": "Россия / Ставропольский край / Верхнерусское",
    "country": "Россия",
    "searchString": "верхнерусское россия / ставропольский край / верхнерусское"
  },
  "3755": {
    "id": "3755",
    "name": "Винсады",
    "path": "Россия / Ставропольский край / Винсады",
    "country": "Россия",
    "searchString": "винсады россия / ставропольский край / винсады"
  },
  "3756": {
    "id": "3756",
    "name": "Галюгаевская",
    "path": "Россия / Ставропольский край / Галюгаевская",
    "country": "Россия",
    "searchString": "галюгаевская россия / ставропольский край / галюгаевская"
  },
  "3757": {
    "id": "3757",
    "name": "Георгиевская",
    "path": "Россия / Ставропольский край / Георгиевская",
    "country": "Россия",
    "searchString": "георгиевская россия / ставропольский край / георгиевская"
  },
  "3758": {
    "id": "3758",
    "name": "Горячеводский",
    "path": "Россия / Ставропольский край / Горячеводский",
    "country": "Россия",
    "searchString": "горячеводский россия / ставропольский край / горячеводский"
  },
  "3759": {
    "id": "3759",
    "name": "Грачевка",
    "path": "Россия / Ставропольский край / Грачевка",
    "country": "Россия",
    "searchString": "грачевка россия / ставропольский край / грачевка"
  },
  "3760": {
    "id": "3760",
    "name": "Григорополисская",
    "path": "Россия / Ставропольский край / Григорополисская",
    "country": "Россия",
    "searchString": "григорополисская россия / ставропольский край / григорополисская"
  },
  "3761": {
    "id": "3761",
    "name": "Демино (Ставропольский край)",
    "path": "Россия / Ставропольский край / Демино (Ставропольский край)",
    "country": "Россия",
    "searchString": "демино (ставропольский край) россия / ставропольский край / демино (ставропольский край)"
  },
  "3762": {
    "id": "3762",
    "name": "Дивное (Ставропольский край)",
    "path": "Россия / Ставропольский край / Дивное (Ставропольский край)",
    "country": "Россия",
    "searchString": "дивное (ставропольский край) россия / ставропольский край / дивное (ставропольский край)"
  },
  "3763": {
    "id": "3763",
    "name": "Дмитриевское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Дмитриевское (Ставропольский край)",
    "country": "Россия",
    "searchString": "дмитриевское (ставропольский край) россия / ставропольский край / дмитриевское (ставропольский край)"
  },
  "3764": {
    "id": "3764",
    "name": "Донское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Донское (Ставропольский край)",
    "country": "Россия",
    "searchString": "донское (ставропольский край) россия / ставропольский край / донское (ставропольский край)"
  },
  "3765": {
    "id": "3765",
    "name": "Елизаветинское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Елизаветинское (Ставропольский край)",
    "country": "Россия",
    "searchString": "елизаветинское (ставропольский край) россия / ставропольский край / елизаветинское (ставропольский край)"
  },
  "3766": {
    "id": "3766",
    "name": "Ессентукская",
    "path": "Россия / Ставропольский край / Ессентукская",
    "country": "Россия",
    "searchString": "ессентукская россия / ставропольский край / ессентукская"
  },
  "3767": {
    "id": "3767",
    "name": "Заветное (Ставропольский край)",
    "path": "Россия / Ставропольский край / Заветное (Ставропольский край)",
    "country": "Россия",
    "searchString": "заветное (ставропольский край) россия / ставропольский край / заветное (ставропольский край)"
  },
  "3768": {
    "id": "3768",
    "name": "Балезино",
    "path": "Россия / Удмуртская Республика / Балезино",
    "country": "Россия",
    "searchString": "балезино россия / удмуртская республика / балезино"
  },
  "3769": {
    "id": "3769",
    "name": "Айхал",
    "path": "Россия / Республика Саха (Якутия) / Айхал",
    "country": "Россия",
    "searchString": "айхал россия / республика саха (якутия) / айхал"
  },
  "3770": {
    "id": "3770",
    "name": "Верхнеяркеево",
    "path": "Россия / Республика Башкортостан / Верхнеяркеево",
    "country": "Россия",
    "searchString": "верхнеяркеево россия / республика башкортостан / верхнеяркеево"
  },
  "3771": {
    "id": "3771",
    "name": "Оричи",
    "path": "Россия / Кировская область / Оричи",
    "country": "Россия",
    "searchString": "оричи россия / кировская область / оричи"
  },
  "3772": {
    "id": "3772",
    "name": "Затеречный",
    "path": "Россия / Ставропольский край / Затеречный",
    "country": "Россия",
    "searchString": "затеречный россия / ставропольский край / затеречный"
  },
  "3773": {
    "id": "3773",
    "name": "Зольская",
    "path": "Россия / Ставропольский край / Зольская",
    "country": "Россия",
    "searchString": "зольская россия / ставропольский край / зольская"
  },
  "3774": {
    "id": "3774",
    "name": "Ивановское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Ивановское (Ставропольский край)",
    "country": "Россия",
    "searchString": "ивановское (ставропольский край) россия / ставропольский край / ивановское (ставропольский край)"
  },
  "3775": {
    "id": "3775",
    "name": "Иноземцево",
    "path": "Россия / Ставропольский край / Иноземцево",
    "country": "Россия",
    "searchString": "иноземцево россия / ставропольский край / иноземцево"
  },
  "3776": {
    "id": "3776",
    "name": "Иргаклы",
    "path": "Россия / Ставропольский край / Иргаклы",
    "country": "Россия",
    "searchString": "иргаклы россия / ставропольский край / иргаклы"
  },
  "3777": {
    "id": "3777",
    "name": "Казьминское",
    "path": "Россия / Ставропольский край / Казьминское",
    "country": "Россия",
    "searchString": "казьминское россия / ставропольский край / казьминское"
  },
  "3778": {
    "id": "3778",
    "name": "Канглы (Ставропольский край)",
    "path": "Россия / Ставропольский край / Канглы (Ставропольский край)",
    "country": "Россия",
    "searchString": "канглы (ставропольский край) россия / ставропольский край / канглы (ставропольский край)"
  },
  "3779": {
    "id": "3779",
    "name": "Кевсала",
    "path": "Россия / Ставропольский край / Кевсала",
    "country": "Россия",
    "searchString": "кевсала россия / ставропольский край / кевсала"
  },
  "3780": {
    "id": "3780",
    "name": "Комсомолец (Ставропольский край)",
    "path": "Россия / Ставропольский край / Комсомолец (Ставропольский край)",
    "country": "Россия",
    "searchString": "комсомолец (ставропольский край) россия / ставропольский край / комсомолец (ставропольский край)"
  },
  "3781": {
    "id": "3781",
    "name": "Константиновская",
    "path": "Россия / Ставропольский край / Константиновская",
    "country": "Россия",
    "searchString": "константиновская россия / ставропольский край / константиновская"
  },
  "3782": {
    "id": "3782",
    "name": "Константиновское",
    "path": "Россия / Ставропольский край / Константиновское",
    "country": "Россия",
    "searchString": "константиновское россия / ставропольский край / константиновское"
  },
  "3783": {
    "id": "3783",
    "name": "Красногвардейское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Красногвардейское (Ставропольский край)",
    "country": "Россия",
    "searchString": "красногвардейское (ставропольский край) россия / ставропольский край / красногвардейское (ставропольский край)"
  },
  "3784": {
    "id": "3784",
    "name": "Северск (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Северск (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "северск (донецкая народная республика) россия / донецкая народная республика / северск (донецкая народная республика)"
  },
  "3785": {
    "id": "3785",
    "name": "Краснокумское",
    "path": "Россия / Ставропольский край / Краснокумское",
    "country": "Россия",
    "searchString": "краснокумское россия / ставропольский край / краснокумское"
  },
  "3786": {
    "id": "3786",
    "name": "Круглолесское",
    "path": "Россия / Ставропольский край / Круглолесское",
    "country": "Россия",
    "searchString": "круглолесское россия / ставропольский край / круглолесское"
  },
  "3787": {
    "id": "3787",
    "name": "Кугульта (Ставропольский край)",
    "path": "Россия / Ставропольский край / Кугульта (Ставропольский край)",
    "country": "Россия",
    "searchString": "кугульта (ставропольский край) россия / ставропольский край / кугульта (ставропольский край)"
  },
  "3788": {
    "id": "3788",
    "name": "Курская (Ставропольский край)",
    "path": "Россия / Ставропольский край / Курская (Ставропольский край)",
    "country": "Россия",
    "searchString": "курская (ставропольский край) россия / ставропольский край / курская (ставропольский край)"
  },
  "3789": {
    "id": "3789",
    "name": "Левокумское",
    "path": "Россия / Ставропольский край / Левокумское",
    "country": "Россия",
    "searchString": "левокумское россия / ставропольский край / левокумское"
  },
  "3790": {
    "id": "3790",
    "name": "Летняя Ставка",
    "path": "Россия / Ставропольский край / Летняя Ставка",
    "country": "Россия",
    "searchString": "летняя ставка россия / ставропольский край / летняя ставка"
  },
  "3791": {
    "id": "3791",
    "name": "Лысогорская",
    "path": "Россия / Ставропольский край / Лысогорская",
    "country": "Россия",
    "searchString": "лысогорская россия / ставропольский край / лысогорская"
  },
  "3792": {
    "id": "3792",
    "name": "Марьинская (Ставропольский край)",
    "path": "Россия / Ставропольский край / Марьинская (Ставропольский край)",
    "country": "Россия",
    "searchString": "марьинская (ставропольский край) россия / ставропольский край / марьинская (ставропольский край)"
  },
  "3793": {
    "id": "3793",
    "name": "Московское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Московское (Ставропольский край)",
    "country": "Россия",
    "searchString": "московское (ставропольский край) россия / ставропольский край / московское (ставропольский край)"
  },
  "3794": {
    "id": "3794",
    "name": "Надежда (Ставропольский край)",
    "path": "Россия / Ставропольский край / Надежда (Ставропольский край)",
    "country": "Россия",
    "searchString": "надежда (ставропольский край) россия / ставропольский край / надежда (ставропольский край)"
  },
  "3795": {
    "id": "3795",
    "name": "Абрамовка",
    "path": "Россия / Воронежская область / Абрамовка",
    "country": "Россия",
    "searchString": "абрамовка россия / воронежская область / абрамовка"
  },
  "3796": {
    "id": "3796",
    "name": "Воля",
    "path": "Россия / Воронежская область / Воля",
    "country": "Россия",
    "searchString": "воля россия / воронежская область / воля"
  },
  "3797": {
    "id": "3797",
    "name": "Воробьёвка",
    "path": "Россия / Воронежская область / Воробьёвка",
    "country": "Россия",
    "searchString": "воробьёвка россия / воронежская область / воробьёвка"
  },
  "3798": {
    "id": "3798",
    "name": "Воронцовка (Воронежская область)",
    "path": "Россия / Воронежская область / Воронцовка (Воронежская область)",
    "country": "Россия",
    "searchString": "воронцовка (воронежская область) россия / воронежская область / воронцовка (воронежская область)"
  },
  "3799": {
    "id": "3799",
    "name": "Гремячье",
    "path": "Россия / Воронежская область / Гремячье",
    "country": "Россия",
    "searchString": "гремячье россия / воронежская область / гремячье"
  },
  "3800": {
    "id": "3800",
    "name": "Давыдовка",
    "path": "Россия / Воронежская область / Давыдовка",
    "country": "Россия",
    "searchString": "давыдовка россия / воронежская область / давыдовка"
  },
  "3801": {
    "id": "3801",
    "name": "Девица (Семилукский район)",
    "path": "Россия / Воронежская область / Девица (Семилукский район)",
    "country": "Россия",
    "searchString": "девица (семилукский район) россия / воронежская область / девица (семилукский район)"
  },
  "3802": {
    "id": "3802",
    "name": "Елань-Колено",
    "path": "Россия / Воронежская область / Елань-Колено",
    "country": "Россия",
    "searchString": "елань-колено россия / воронежская область / елань-колено"
  },
  "3803": {
    "id": "3803",
    "name": "Землянск",
    "path": "Россия / Воронежская область / Землянск",
    "country": "Россия",
    "searchString": "землянск россия / воронежская область / землянск"
  },
  "3804": {
    "id": "3804",
    "name": "Каширское",
    "path": "Россия / Воронежская область / Каширское",
    "country": "Россия",
    "searchString": "каширское россия / воронежская область / каширское"
  },
  "3805": {
    "id": "3805",
    "name": "Колодезный",
    "path": "Россия / Воронежская область / Колодезный",
    "country": "Россия",
    "searchString": "колодезный россия / воронежская область / колодезный"
  },
  "3806": {
    "id": "3806",
    "name": "Латная",
    "path": "Россия / Воронежская область / Латная",
    "country": "Россия",
    "searchString": "латная россия / воронежская область / латная"
  },
  "3807": {
    "id": "3807",
    "name": "Лосево",
    "path": "Россия / Воронежская область / Лосево",
    "country": "Россия",
    "searchString": "лосево россия / воронежская область / лосево"
  },
  "3808": {
    "id": "3808",
    "name": "Митрофановка",
    "path": "Россия / Воронежская область / Митрофановка",
    "country": "Россия",
    "searchString": "митрофановка россия / воронежская область / митрофановка"
  },
  "3809": {
    "id": "3809",
    "name": "Нижнедевицк",
    "path": "Россия / Воронежская область / Нижнедевицк",
    "country": "Россия",
    "searchString": "нижнедевицк россия / воронежская область / нижнедевицк"
  },
  "3810": {
    "id": "3810",
    "name": "Нижний Кисляй",
    "path": "Россия / Воронежская область / Нижний Кисляй",
    "country": "Россия",
    "searchString": "нижний кисляй россия / воронежская область / нижний кисляй"
  },
  "3811": {
    "id": "3811",
    "name": "Никольское (Воронежская область)",
    "path": "Россия / Воронежская область / Никольское (Воронежская область)",
    "country": "Россия",
    "searchString": "никольское (воронежская область) россия / воронежская область / никольское (воронежская область)"
  },
  "3812": {
    "id": "3812",
    "name": "Новохопёрск",
    "path": "Россия / Воронежская область / Новохопёрск",
    "country": "Россия",
    "searchString": "новохопёрск россия / воронежская область / новохопёрск"
  },
  "3813": {
    "id": "3813",
    "name": "Орлово",
    "path": "Россия / Воронежская область / Орлово",
    "country": "Россия",
    "searchString": "орлово россия / воронежская область / орлово"
  },
  "3814": {
    "id": "3814",
    "name": "Отрадное (Воронежская область)",
    "path": "Россия / Воронежская область / Отрадное (Воронежская область)",
    "country": "Россия",
    "searchString": "отрадное (воронежская область) россия / воронежская область / отрадное (воронежская область)"
  },
  "3815": {
    "id": "3815",
    "name": "Панино",
    "path": "Россия / Воронежская область / Панино",
    "country": "Россия",
    "searchString": "панино россия / воронежская область / панино"
  },
  "3816": {
    "id": "3816",
    "name": "Пески",
    "path": "Россия / Воронежская область / Пески",
    "country": "Россия",
    "searchString": "пески россия / воронежская область / пески"
  },
  "3817": {
    "id": "3817",
    "name": "Репьевка",
    "path": "Россия / Воронежская область / Репьевка",
    "country": "Россия",
    "searchString": "репьевка россия / воронежская область / репьевка"
  },
  "3818": {
    "id": "3818",
    "name": "Солнечный (Воронежская область)",
    "path": "Россия / Воронежская область / Солнечный (Воронежская область)",
    "country": "Россия",
    "searchString": "солнечный (воронежская область) россия / воронежская область / солнечный (воронежская область)"
  },
  "3819": {
    "id": "3819",
    "name": "Сомово",
    "path": "Россия / Воронежская область / Сомово",
    "country": "Россия",
    "searchString": "сомово россия / воронежская область / сомово"
  },
  "3820": {
    "id": "3820",
    "name": "Средний Икорец",
    "path": "Россия / Воронежская область / Средний Икорец",
    "country": "Россия",
    "searchString": "средний икорец россия / воронежская область / средний икорец"
  },
  "3821": {
    "id": "3821",
    "name": "Стрелица",
    "path": "Россия / Воронежская область / Стрелица",
    "country": "Россия",
    "searchString": "стрелица россия / воронежская область / стрелица"
  },
  "3822": {
    "id": "3822",
    "name": "Терновка (Воронежская область)",
    "path": "Россия / Воронежская область / Терновка (Воронежская область)",
    "country": "Россия",
    "searchString": "терновка (воронежская область) россия / воронежская область / терновка (воронежская область)"
  },
  "3823": {
    "id": "3823",
    "name": "Углянец",
    "path": "Россия / Воронежская область / Углянец",
    "country": "Россия",
    "searchString": "углянец россия / воронежская область / углянец"
  },
  "3824": {
    "id": "3824",
    "name": "Белая",
    "path": "Россия / Курская область / Белая",
    "country": "Россия",
    "searchString": "белая россия / курская область / белая"
  },
  "3825": {
    "id": "3825",
    "name": "Большое Солдатское",
    "path": "Россия / Курская область / Большое Солдатское",
    "country": "Россия",
    "searchString": "большое солдатское россия / курская область / большое солдатское"
  },
  "3826": {
    "id": "3826",
    "name": "Ворошнево",
    "path": "Россия / Курская область / Ворошнево",
    "country": "Россия",
    "searchString": "ворошнево россия / курская область / ворошнево"
  },
  "3827": {
    "id": "3827",
    "name": "Горшечное",
    "path": "Россия / Курская область / Горшечное",
    "country": "Россия",
    "searchString": "горшечное россия / курская область / горшечное"
  },
  "3828": {
    "id": "3828",
    "name": "Золотухино",
    "path": "Россия / Курская область / Золотухино",
    "country": "Россия",
    "searchString": "золотухино россия / курская область / золотухино"
  },
  "3829": {
    "id": "3829",
    "name": "Касторное",
    "path": "Россия / Курская область / Касторное",
    "country": "Россия",
    "searchString": "касторное россия / курская область / касторное"
  },
  "3830": {
    "id": "3830",
    "name": "Кировский",
    "path": "Россия / Курская область / Кировский",
    "country": "Россия",
    "searchString": "кировский россия / курская область / кировский"
  },
  "3831": {
    "id": "3831",
    "name": "Конышевка",
    "path": "Россия / Курская область / Конышевка",
    "country": "Россия",
    "searchString": "конышевка россия / курская область / конышевка"
  },
  "3832": {
    "id": "3832",
    "name": "Коренево",
    "path": "Россия / Курская область / Коренево",
    "country": "Россия",
    "searchString": "коренево россия / курская область / коренево"
  },
  "3833": {
    "id": "3833",
    "name": "Кшенский",
    "path": "Россия / Курская область / Кшенский",
    "country": "Россия",
    "searchString": "кшенский россия / курская область / кшенский"
  },
  "3834": {
    "id": "3834",
    "name": "Медвенка",
    "path": "Россия / Курская область / Медвенка",
    "country": "Россия",
    "searchString": "медвенка россия / курская область / медвенка"
  },
  "3835": {
    "id": "3835",
    "name": "Поныри",
    "path": "Россия / Курская область / Поныри",
    "country": "Россия",
    "searchString": "поныри россия / курская область / поныри"
  },
  "3836": {
    "id": "3836",
    "name": "Посёлок имени Карла Либкнехта",
    "path": "Россия / Курская область / Посёлок имени Карла Либкнехта",
    "country": "Россия",
    "searchString": "посёлок имени карла либкнехта россия / курская область / посёлок имени карла либкнехта"
  },
  "3837": {
    "id": "3837",
    "name": "Прямицыно",
    "path": "Россия / Курская область / Прямицыно",
    "country": "Россия",
    "searchString": "прямицыно россия / курская область / прямицыно"
  },
  "3838": {
    "id": "3838",
    "name": "Солнцево (Курская область)",
    "path": "Россия / Курская область / Солнцево (Курская область)",
    "country": "Россия",
    "searchString": "солнцево (курская область) россия / курская область / солнцево (курская область)"
  },
  "3839": {
    "id": "3839",
    "name": "Тёткино",
    "path": "Россия / Курская область / Тёткино",
    "country": "Россия",
    "searchString": "тёткино россия / курская область / тёткино"
  },
  "3840": {
    "id": "3840",
    "name": "Тим",
    "path": "Россия / Курская область / Тим",
    "country": "Россия",
    "searchString": "тим россия / курская область / тим"
  },
  "3841": {
    "id": "3841",
    "name": "Хомутовка",
    "path": "Россия / Курская область / Хомутовка",
    "country": "Россия",
    "searchString": "хомутовка россия / курская область / хомутовка"
  },
  "3842": {
    "id": "3842",
    "name": "Черемисиново",
    "path": "Россия / Курская область / Черемисиново",
    "country": "Россия",
    "searchString": "черемисиново россия / курская область / черемисиново"
  },
  "3843": {
    "id": "3843",
    "name": "Боринское",
    "path": "Россия / Липецкая область / Боринское",
    "country": "Россия",
    "searchString": "боринское россия / липецкая область / боринское"
  },
  "3844": {
    "id": "3844",
    "name": "Волово",
    "path": "Россия / Липецкая область / Волово",
    "country": "Россия",
    "searchString": "волово россия / липецкая область / волово"
  },
  "3845": {
    "id": "3845",
    "name": "Добринка",
    "path": "Россия / Липецкая область / Добринка",
    "country": "Россия",
    "searchString": "добринка россия / липецкая область / добринка"
  },
  "3846": {
    "id": "3846",
    "name": "Доброе",
    "path": "Россия / Липецкая область / Доброе",
    "country": "Россия",
    "searchString": "доброе россия / липецкая область / доброе"
  },
  "3847": {
    "id": "3847",
    "name": "Долгоруково",
    "path": "Россия / Липецкая область / Долгоруково",
    "country": "Россия",
    "searchString": "долгоруково россия / липецкая область / долгоруково"
  },
  "3848": {
    "id": "3848",
    "name": "Донское",
    "path": "Россия / Липецкая область / Донское",
    "country": "Россия",
    "searchString": "донское россия / липецкая область / донское"
  },
  "3849": {
    "id": "3849",
    "name": "Измалково",
    "path": "Россия / Липецкая область / Измалково",
    "country": "Россия",
    "searchString": "измалково россия / липецкая область / измалково"
  },
  "3850": {
    "id": "3850",
    "name": "Ильино",
    "path": "Россия / Липецкая область / Ильино",
    "country": "Россия",
    "searchString": "ильино россия / липецкая область / ильино"
  },
  "3851": {
    "id": "3851",
    "name": "Каликино",
    "path": "Россия / Липецкая область / Каликино",
    "country": "Россия",
    "searchString": "каликино россия / липецкая область / каликино"
  },
  "3852": {
    "id": "3852",
    "name": "Красное (Липецкая область)",
    "path": "Россия / Липецкая область / Красное (Липецкая область)",
    "country": "Россия",
    "searchString": "красное (липецкая область) россия / липецкая область / красное (липецкая область)"
  },
  "3853": {
    "id": "3853",
    "name": "поселок Лев Толстой",
    "path": "Россия / Липецкая область / поселок Лев Толстой",
    "country": "Россия",
    "searchString": "поселок лев толстой россия / липецкая область / поселок лев толстой"
  },
  "3854": {
    "id": "3854",
    "name": "Плавица",
    "path": "Россия / Липецкая область / Плавица",
    "country": "Россия",
    "searchString": "плавица россия / липецкая область / плавица"
  },
  "3855": {
    "id": "3855",
    "name": "Становое",
    "path": "Россия / Липецкая область / Становое",
    "country": "Россия",
    "searchString": "становое россия / липецкая область / становое"
  },
  "3856": {
    "id": "3856",
    "name": "Тербуны",
    "path": "Россия / Липецкая область / Тербуны",
    "country": "Россия",
    "searchString": "тербуны россия / липецкая область / тербуны"
  },
  "3857": {
    "id": "3857",
    "name": "Хлевное",
    "path": "Россия / Липецкая область / Хлевное",
    "country": "Россия",
    "searchString": "хлевное россия / липецкая область / хлевное"
  },
  "3858": {
    "id": "3858",
    "name": "Головчино",
    "path": "Россия / Белгородская область / Головчино",
    "country": "Россия",
    "searchString": "головчино россия / белгородская область / головчино"
  },
  "3859": {
    "id": "3859",
    "name": "Дубовое",
    "path": "Россия / Белгородская область / Дубовое",
    "country": "Россия",
    "searchString": "дубовое россия / белгородская область / дубовое"
  },
  "3860": {
    "id": "3860",
    "name": "Северный",
    "path": "Россия / Белгородская область / Северный",
    "country": "Россия",
    "searchString": "северный россия / белгородская область / северный"
  },
  "3861": {
    "id": "3861",
    "name": "Скородное",
    "path": "Россия / Белгородская область / Скородное",
    "country": "Россия",
    "searchString": "скородное россия / белгородская область / скородное"
  },
  "3862": {
    "id": "3862",
    "name": "Стрелецкое",
    "path": "Россия / Белгородская область / Стрелецкое",
    "country": "Россия",
    "searchString": "стрелецкое россия / белгородская область / стрелецкое"
  },
  "3863": {
    "id": "3863",
    "name": "Троицкий",
    "path": "Россия / Белгородская область / Троицкий",
    "country": "Россия",
    "searchString": "троицкий россия / белгородская область / троицкий"
  },
  "3864": {
    "id": "3864",
    "name": "Уразово",
    "path": "Россия / Белгородская область / Уразово",
    "country": "Россия",
    "searchString": "уразово россия / белгородская область / уразово"
  },
  "3865": {
    "id": "3865",
    "name": "Бессоновка",
    "path": "Россия / Белгородская область / Бессоновка",
    "country": "Россия",
    "searchString": "бессоновка россия / белгородская область / бессоновка"
  },
  "3866": {
    "id": "3866",
    "name": "Ливенка",
    "path": "Россия / Белгородская область / Ливенка",
    "country": "Россия",
    "searchString": "ливенка россия / белгородская область / ливенка"
  },
  "3867": {
    "id": "3867",
    "name": "Маслова Пристань",
    "path": "Россия / Белгородская область / Маслова Пристань",
    "country": "Россия",
    "searchString": "маслова пристань россия / белгородская область / маслова пристань"
  },
  "3868": {
    "id": "3868",
    "name": "Дмитриевка",
    "path": "Россия / Тамбовская область / Дмитриевка",
    "country": "Россия",
    "searchString": "дмитриевка россия / тамбовская область / дмитриевка"
  },
  "3869": {
    "id": "3869",
    "name": "Мордово",
    "path": "Россия / Тамбовская область / Мордово",
    "country": "Россия",
    "searchString": "мордово россия / тамбовская область / мордово"
  },
  "3870": {
    "id": "3870",
    "name": "Пичаево",
    "path": "Россия / Тамбовская область / Пичаево",
    "country": "Россия",
    "searchString": "пичаево россия / тамбовская область / пичаево"
  },
  "3871": {
    "id": "3871",
    "name": "Ржакса",
    "path": "Россия / Тамбовская область / Ржакса",
    "country": "Россия",
    "searchString": "ржакса россия / тамбовская область / ржакса"
  },
  "3872": {
    "id": "3872",
    "name": "Сатинка",
    "path": "Россия / Тамбовская область / Сатинка",
    "country": "Россия",
    "searchString": "сатинка россия / тамбовская область / сатинка"
  },
  "3873": {
    "id": "3873",
    "name": "Староюрьево",
    "path": "Россия / Тамбовская область / Староюрьево",
    "country": "Россия",
    "searchString": "староюрьево россия / тамбовская область / староюрьево"
  },
  "3874": {
    "id": "3874",
    "name": "Строитель",
    "path": "Россия / Тамбовская область / Строитель",
    "country": "Россия",
    "searchString": "строитель россия / тамбовская область / строитель"
  },
  "3875": {
    "id": "3875",
    "name": "Токаревка",
    "path": "Россия / Тамбовская область / Токаревка",
    "country": "Россия",
    "searchString": "токаревка россия / тамбовская область / токаревка"
  },
  "3876": {
    "id": "3876",
    "name": "Агеево (Тамбовская область)",
    "path": "Россия / Тамбовская область / Агеево (Тамбовская область)",
    "country": "Россия",
    "searchString": "агеево (тамбовская область) россия / тамбовская область / агеево (тамбовская область)"
  },
  "3877": {
    "id": "3877",
    "name": "Нежинский (Ставропольский край)",
    "path": "Россия / Ставропольский край / Нежинский (Ставропольский край)",
    "country": "Россия",
    "searchString": "нежинский (ставропольский край) россия / ставропольский край / нежинский (ставропольский край)"
  },
  "3878": {
    "id": "3878",
    "name": "Незлобная",
    "path": "Россия / Ставропольский край / Незлобная",
    "country": "Россия",
    "searchString": "незлобная россия / ставропольский край / незлобная"
  },
  "3879": {
    "id": "3879",
    "name": "Нины",
    "path": "Россия / Ставропольский край / Нины",
    "country": "Россия",
    "searchString": "нины россия / ставропольский край / нины"
  },
  "3880": {
    "id": "3880",
    "name": "Новоблагодарное",
    "path": "Россия / Ставропольский край / Новоблагодарное",
    "country": "Россия",
    "searchString": "новоблагодарное россия / ставропольский край / новоблагодарное"
  },
  "3881": {
    "id": "3881",
    "name": "Новозаведенное",
    "path": "Россия / Ставропольский край / Новозаведенное",
    "country": "Россия",
    "searchString": "новозаведенное россия / ставропольский край / новозаведенное"
  },
  "3882": {
    "id": "3882",
    "name": "Новоселицкое",
    "path": "Россия / Ставропольский край / Новоселицкое",
    "country": "Россия",
    "searchString": "новоселицкое россия / ставропольский край / новоселицкое"
  },
  "3883": {
    "id": "3883",
    "name": "Новотроицкая (Ставропольский край)",
    "path": "Россия / Ставропольский край / Новотроицкая (Ставропольский край)",
    "country": "Россия",
    "searchString": "новотроицкая (ставропольский край) россия / ставропольский край / новотроицкая (ставропольский край)"
  },
  "3884": {
    "id": "3884",
    "name": "Обильное (Ставропольский край)",
    "path": "Россия / Ставропольский край / Обильное (Ставропольский край)",
    "country": "Россия",
    "searchString": "обильное (ставропольский край) россия / ставропольский край / обильное (ставропольский край)"
  },
  "3885": {
    "id": "3885",
    "name": "Октябрьское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Октябрьское (Ставропольский край)",
    "country": "Россия",
    "searchString": "октябрьское (ставропольский край) россия / ставропольский край / октябрьское (ставропольский край)"
  },
  "3886": {
    "id": "3886",
    "name": "Орловка (Ставропольский край)",
    "path": "Россия / Ставропольский край / Орловка (Ставропольский край)",
    "country": "Россия",
    "searchString": "орловка (ставропольский край) россия / ставропольский край / орловка (ставропольский край)"
  },
  "3887": {
    "id": "3887",
    "name": "Отказное",
    "path": "Россия / Ставропольский край / Отказное",
    "country": "Россия",
    "searchString": "отказное россия / ставропольский край / отказное"
  },
  "3888": {
    "id": "3888",
    "name": "Пелагиада",
    "path": "Россия / Ставропольский край / Пелагиада",
    "country": "Россия",
    "searchString": "пелагиада россия / ставропольский край / пелагиада"
  },
  "3889": {
    "id": "3889",
    "name": "Подкумок",
    "path": "Россия / Ставропольский край / Подкумок",
    "country": "Россия",
    "searchString": "подкумок россия / ставропольский край / подкумок"
  },
  "3890": {
    "id": "3890",
    "name": "Покойное",
    "path": "Россия / Ставропольский край / Покойное",
    "country": "Россия",
    "searchString": "покойное россия / ставропольский край / покойное"
  },
  "3891": {
    "id": "3891",
    "name": "Правокумское",
    "path": "Россия / Ставропольский край / Правокумское",
    "country": "Россия",
    "searchString": "правокумское россия / ставропольский край / правокумское"
  },
  "3892": {
    "id": "3892",
    "name": "Преградное",
    "path": "Россия / Ставропольский край / Преградное",
    "country": "Россия",
    "searchString": "преградное россия / ставропольский край / преградное"
  },
  "3893": {
    "id": "3893",
    "name": "Птичье (Ставропольский край)",
    "path": "Россия / Ставропольский край / Птичье (Ставропольский край)",
    "country": "Россия",
    "searchString": "птичье (ставропольский край) россия / ставропольский край / птичье (ставропольский край)"
  },
  "3894": {
    "id": "3894",
    "name": "Пятигорский",
    "path": "Россия / Ставропольский край / Пятигорский",
    "country": "Россия",
    "searchString": "пятигорский россия / ставропольский край / пятигорский"
  },
  "3895": {
    "id": "3895",
    "name": "Расшеватская",
    "path": "Россия / Ставропольский край / Расшеватская",
    "country": "Россия",
    "searchString": "расшеватская россия / ставропольский край / расшеватская"
  },
  "3896": {
    "id": "3896",
    "name": "Русское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Русское (Ставропольский край)",
    "country": "Россия",
    "searchString": "русское (ставропольский край) россия / ставропольский край / русское (ставропольский край)"
  },
  "3897": {
    "id": "3897",
    "name": "Рыздвяный",
    "path": "Россия / Ставропольский край / Рыздвяный",
    "country": "Россия",
    "searchString": "рыздвяный россия / ставропольский край / рыздвяный"
  },
  "3898": {
    "id": "3898",
    "name": "Свободы",
    "path": "Россия / Ставропольский край / Свободы",
    "country": "Россия",
    "searchString": "свободы россия / ставропольский край / свободы"
  },
  "3899": {
    "id": "3899",
    "name": "Советская (Ставропольский край)",
    "path": "Россия / Ставропольский край / Советская (Ставропольский край)",
    "country": "Россия",
    "searchString": "советская (ставропольский край) россия / ставропольский край / советская (ставропольский край)"
  },
  "3900": {
    "id": "3900",
    "name": "Солдато-Александровское",
    "path": "Россия / Ставропольский край / Солдато-Александровское",
    "country": "Россия",
    "searchString": "солдато-александровское россия / ставропольский край / солдато-александровское"
  },
  "3901": {
    "id": "3901",
    "name": "Солнечнодольск",
    "path": "Россия / Ставропольский край / Солнечнодольск",
    "country": "Россия",
    "searchString": "солнечнодольск россия / ставропольский край / солнечнодольск"
  },
  "3902": {
    "id": "3902",
    "name": "Соломенское",
    "path": "Россия / Ставропольский край / Соломенское",
    "country": "Россия",
    "searchString": "соломенское россия / ставропольский край / соломенское"
  },
  "3903": {
    "id": "3903",
    "name": "Спицевка",
    "path": "Россия / Ставропольский край / Спицевка",
    "country": "Россия",
    "searchString": "спицевка россия / ставропольский край / спицевка"
  },
  "3904": {
    "id": "3904",
    "name": "Стародубское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Стародубское (Ставропольский край)",
    "country": "Россия",
    "searchString": "стародубское (ставропольский край) россия / ставропольский край / стародубское (ставропольский край)"
  },
  "3905": {
    "id": "3905",
    "name": "Старопавловская",
    "path": "Россия / Ставропольский край / Старопавловская",
    "country": "Россия",
    "searchString": "старопавловская россия / ставропольский край / старопавловская"
  },
  "3906": {
    "id": "3906",
    "name": "Степное (Ставропольский край)",
    "path": "Россия / Ставропольский край / Степное (Ставропольский край)",
    "country": "Россия",
    "searchString": "степное (ставропольский край) россия / ставропольский край / степное (ставропольский край)"
  },
  "3907": {
    "id": "3907",
    "name": "Суворовская (Ставропольский край)",
    "path": "Россия / Ставропольский край / Суворовская (Ставропольский край)",
    "country": "Россия",
    "searchString": "суворовская (ставропольский край) россия / ставропольский край / суворовская (ставропольский край)"
  },
  "3908": {
    "id": "3908",
    "name": "Сухая Буйвола",
    "path": "Россия / Ставропольский край / Сухая Буйвола",
    "country": "Россия",
    "searchString": "сухая буйвола россия / ставропольский край / сухая буйвола"
  },
  "3909": {
    "id": "3909",
    "name": "Татарка (Ставропольский край)",
    "path": "Россия / Ставропольский край / Татарка (Ставропольский край)",
    "country": "Россия",
    "searchString": "татарка (ставропольский край) россия / ставропольский край / татарка (ставропольский край)"
  },
  "3910": {
    "id": "3910",
    "name": "Труновское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Труновское (Ставропольский край)",
    "country": "Россия",
    "searchString": "труновское (ставропольский край) россия / ставропольский край / труновское (ставропольский край)"
  },
  "3911": {
    "id": "3911",
    "name": "Урожайное (Ставропольский край)",
    "path": "Россия / Ставропольский край / Урожайное (Ставропольский край)",
    "country": "Россия",
    "searchString": "урожайное (ставропольский край) россия / ставропольский край / урожайное (ставропольский край)"
  },
  "3912": {
    "id": "3912",
    "name": "Чернолесское",
    "path": "Россия / Ставропольский край / Чернолесское",
    "country": "Россия",
    "searchString": "чернолесское россия / ставропольский край / чернолесское"
  },
  "3913": {
    "id": "3913",
    "name": "Эдиссия",
    "path": "Россия / Ставропольский край / Эдиссия",
    "country": "Россия",
    "searchString": "эдиссия россия / ставропольский край / эдиссия"
  },
  "3914": {
    "id": "3914",
    "name": "Этока",
    "path": "Россия / Ставропольский край / Этока",
    "country": "Россия",
    "searchString": "этока россия / ставропольский край / этока"
  },
  "3915": {
    "id": "3915",
    "name": "Юца",
    "path": "Россия / Ставропольский край / Юца",
    "country": "Россия",
    "searchString": "юца россия / ставропольский край / юца"
  },
  "3916": {
    "id": "3916",
    "name": "Ясная Поляна (Ставропольский край)",
    "path": "Россия / Ставропольский край / Ясная Поляна (Ставропольский край)",
    "country": "Россия",
    "searchString": "ясная поляна (ставропольский край) россия / ставропольский край / ясная поляна (ставропольский край)"
  },
  "3917": {
    "id": "3917",
    "name": "Гофицкое (Ставропольский край)",
    "path": "Россия / Ставропольский край / Гофицкое (Ставропольский край)",
    "country": "Россия",
    "searchString": "гофицкое (ставропольский край) россия / ставропольский край / гофицкое (ставропольский край)"
  },
  "3918": {
    "id": "3918",
    "name": "Каясула",
    "path": "Россия / Ставропольский край / Каясула",
    "country": "Россия",
    "searchString": "каясула россия / ставропольский край / каясула"
  },
  "3919": {
    "id": "3919",
    "name": "Красный Пахарь (Ставропольский край)",
    "path": "Россия / Ставропольский край / Красный Пахарь (Ставропольский край)",
    "country": "Россия",
    "searchString": "красный пахарь (ставропольский край) россия / ставропольский край / красный пахарь (ставропольский край)"
  },
  "3920": {
    "id": "3920",
    "name": "Крымгиреевское",
    "path": "Россия / Ставропольский край / Крымгиреевское",
    "country": "Россия",
    "searchString": "крымгиреевское россия / ставропольский край / крымгиреевское"
  },
  "3921": {
    "id": "3921",
    "name": "Левокумка",
    "path": "Россия / Ставропольский край / Левокумка",
    "country": "Россия",
    "searchString": "левокумка россия / ставропольский край / левокумка"
  },
  "3922": {
    "id": "3922",
    "name": "Гаспра",
    "path": "Россия / Республика Крым / Гаспра",
    "country": "Россия",
    "searchString": "гаспра россия / республика крым / гаспра"
  },
  "3923": {
    "id": "3923",
    "name": "Гвардейское (Республика Крым)",
    "path": "Россия / Республика Крым / Гвардейское (Республика Крым)",
    "country": "Россия",
    "searchString": "гвардейское (республика крым) россия / республика крым / гвардейское (республика крым)"
  },
  "3924": {
    "id": "3924",
    "name": "Мирное (Республика Крым)",
    "path": "Россия / Республика Крым / Мирное (Республика Крым)",
    "country": "Россия",
    "searchString": "мирное (республика крым) россия / республика крым / мирное (республика крым)"
  },
  "3925": {
    "id": "3925",
    "name": "Новый Свет (Республика Крым)",
    "path": "Россия / Республика Крым / Новый Свет (Республика Крым)",
    "country": "Россия",
    "searchString": "новый свет (республика крым) россия / республика крым / новый свет (республика крым)"
  },
  "3926": {
    "id": "3926",
    "name": "Чистенькое",
    "path": "Россия / Республика Крым / Чистенькое",
    "country": "Россия",
    "searchString": "чистенькое россия / республика крым / чистенькое"
  },
  "3927": {
    "id": "3927",
    "name": "Морское (Республика Крым)",
    "path": "Россия / Республика Крым / Морское (Республика Крым)",
    "country": "Россия",
    "searchString": "морское (республика крым) россия / республика крым / морское (республика крым)"
  },
  "3928": {
    "id": "3928",
    "name": "Октябрьское (Республика Крым)",
    "path": "Россия / Республика Крым / Октябрьское (Республика Крым)",
    "country": "Россия",
    "searchString": "октябрьское (республика крым) россия / республика крым / октябрьское (республика крым)"
  },
  "3929": {
    "id": "3929",
    "name": "Приморский (Республика Крым)",
    "path": "Россия / Республика Крым / Приморский (Республика Крым)",
    "country": "Россия",
    "searchString": "приморский (республика крым) россия / республика крым / приморский (республика крым)"
  },
  "3930": {
    "id": "3930",
    "name": "Балаклава",
    "path": "Россия / Республика Крым / Балаклава",
    "country": "Россия",
    "searchString": "балаклава россия / республика крым / балаклава"
  },
  "3931": {
    "id": "3931",
    "name": "Бабынино (Калужская область)",
    "path": "Россия / Калужская область / Бабынино (Калужская область)",
    "country": "Россия",
    "searchString": "бабынино (калужская область) россия / калужская область / бабынино (калужская область)"
  },
  "3932": {
    "id": "3932",
    "name": "Барятино (Калужская область)",
    "path": "Россия / Калужская область / Барятино (Калужская область)",
    "country": "Россия",
    "searchString": "барятино (калужская область) россия / калужская область / барятино (калужская область)"
  },
  "3933": {
    "id": "3933",
    "name": "Бетлица",
    "path": "Россия / Калужская область / Бетлица",
    "country": "Россия",
    "searchString": "бетлица россия / калужская область / бетлица"
  },
  "3934": {
    "id": "3934",
    "name": "Воротынск",
    "path": "Россия / Калужская область / Воротынск",
    "country": "Россия",
    "searchString": "воротынск россия / калужская область / воротынск"
  },
  "3935": {
    "id": "3935",
    "name": "Ворсино (Калужская область)",
    "path": "Россия / Калужская область / Ворсино (Калужская область)",
    "country": "Россия",
    "searchString": "ворсино (калужская область) россия / калужская область / ворсино (калужская область)"
  },
  "3936": {
    "id": "3936",
    "name": "Детчино",
    "path": "Россия / Калужская область / Детчино",
    "country": "Россия",
    "searchString": "детчино россия / калужская область / детчино"
  },
  "3937": {
    "id": "3937",
    "name": "Жилетово",
    "path": "Россия / Калужская область / Жилетово",
    "country": "Россия",
    "searchString": "жилетово россия / калужская область / жилетово"
  },
  "3938": {
    "id": "3938",
    "name": "Перемышль",
    "path": "Россия / Калужская область / Перемышль",
    "country": "Россия",
    "searchString": "перемышль россия / калужская область / перемышль"
  },
  "3939": {
    "id": "3939",
    "name": "Полотняный Завод",
    "path": "Россия / Калужская область / Полотняный Завод",
    "country": "Россия",
    "searchString": "полотняный завод россия / калужская область / полотняный завод"
  },
  "3940": {
    "id": "3940",
    "name": "Пятовский",
    "path": "Россия / Калужская область / Пятовский",
    "country": "Россия",
    "searchString": "пятовский россия / калужская область / пятовский"
  },
  "3941": {
    "id": "3941",
    "name": "Товарково (Калужская область)",
    "path": "Россия / Калужская область / Товарково (Калужская область)",
    "country": "Россия",
    "searchString": "товарково (калужская область) россия / калужская область / товарково (калужская область)"
  },
  "3942": {
    "id": "3942",
    "name": "Ульяново (Калужская область)",
    "path": "Россия / Калужская область / Ульяново (Калужская область)",
    "country": "Россия",
    "searchString": "ульяново (калужская область) россия / калужская область / ульяново (калужская область)"
  },
  "3943": {
    "id": "3943",
    "name": "Хвастовичи (Калужская область)",
    "path": "Россия / Калужская область / Хвастовичи (Калужская область)",
    "country": "Россия",
    "searchString": "хвастовичи (калужская область) россия / калужская область / хвастовичи (калужская область)"
  },
  "3944": {
    "id": "3944",
    "name": "Долгое",
    "path": "Россия / Орловская область / Долгое",
    "country": "Россия",
    "searchString": "долгое россия / орловская область / долгое"
  },
  "3945": {
    "id": "3945",
    "name": "Залегощь",
    "path": "Россия / Орловская область / Залегощь",
    "country": "Россия",
    "searchString": "залегощь россия / орловская область / залегощь"
  },
  "3946": {
    "id": "3946",
    "name": "Змиевка",
    "path": "Россия / Орловская область / Змиевка",
    "country": "Россия",
    "searchString": "змиевка россия / орловская область / змиевка"
  },
  "3947": {
    "id": "3947",
    "name": "Знаменка (Орловская область)",
    "path": "Россия / Орловская область / Знаменка (Орловская область)",
    "country": "Россия",
    "searchString": "знаменка (орловская область) россия / орловская область / знаменка (орловская область)"
  },
  "3948": {
    "id": "3948",
    "name": "Корсаково",
    "path": "Россия / Орловская область / Корсаково",
    "country": "Россия",
    "searchString": "корсаково россия / орловская область / корсаково"
  },
  "3949": {
    "id": "3949",
    "name": "Красная Заря",
    "path": "Россия / Орловская область / Красная Заря",
    "country": "Россия",
    "searchString": "красная заря россия / орловская область / красная заря"
  },
  "3950": {
    "id": "3950",
    "name": "Кромы",
    "path": "Россия / Орловская область / Кромы",
    "country": "Россия",
    "searchString": "кромы россия / орловская область / кромы"
  },
  "3951": {
    "id": "3951",
    "name": "Тросна",
    "path": "Россия / Орловская область / Тросна",
    "country": "Россия",
    "searchString": "тросна россия / орловская область / тросна"
  },
  "3952": {
    "id": "3952",
    "name": "Хомутово",
    "path": "Россия / Орловская область / Хомутово",
    "country": "Россия",
    "searchString": "хомутово россия / орловская область / хомутово"
  },
  "3953": {
    "id": "3953",
    "name": "Хотынец",
    "path": "Россия / Орловская область / Хотынец",
    "country": "Россия",
    "searchString": "хотынец россия / орловская область / хотынец"
  },
  "3954": {
    "id": "3954",
    "name": "Отрадинское",
    "path": "Россия / Орловская область / Отрадинское",
    "country": "Россия",
    "searchString": "отрадинское россия / орловская область / отрадинское"
  },
  "3955": {
    "id": "3955",
    "name": "Колпны",
    "path": "Россия / Орловская область / Колпны",
    "country": "Россия",
    "searchString": "колпны россия / орловская область / колпны"
  },
  "3956": {
    "id": "3956",
    "name": "Мантурово (Курская область)",
    "path": "Россия / Курская область / Мантурово (Курская область)",
    "country": "Россия",
    "searchString": "мантурово (курская область) россия / курская область / мантурово (курская область)"
  },
  "3957": {
    "id": "3957",
    "name": "поселок Карла Либкнехта",
    "path": "Россия / Курская область / поселок Карла Либкнехта",
    "country": "Россия",
    "searchString": "поселок карла либкнехта россия / курская область / поселок карла либкнехта"
  },
  "3958": {
    "id": "3958",
    "name": "Веселое (Курская область)",
    "path": "Россия / Курская область / Веселое (Курская область)",
    "country": "Россия",
    "searchString": "веселое (курская область) россия / курская область / веселое (курская область)"
  },
  "3959": {
    "id": "3959",
    "name": "Дьяконово",
    "path": "Россия / Курская область / Дьяконово",
    "country": "Россия",
    "searchString": "дьяконово россия / курская область / дьяконово"
  },
  "3960": {
    "id": "3960",
    "name": "поселок Маршала Жукова",
    "path": "Россия / Курская область / поселок Маршала Жукова",
    "country": "Россия",
    "searchString": "поселок маршала жукова россия / курская область / поселок маршала жукова"
  },
  "3961": {
    "id": "3961",
    "name": "Черницыно",
    "path": "Россия / Курская область / Черницыно",
    "country": "Россия",
    "searchString": "черницыно россия / курская область / черницыно"
  },
  "3962": {
    "id": "3962",
    "name": "Тамбовка",
    "path": "Россия / Воронежская область / Тамбовка",
    "country": "Россия",
    "searchString": "тамбовка россия / воронежская область / тамбовка"
  },
  "3963": {
    "id": "3963",
    "name": "Хохол",
    "path": "Россия / Воронежская область / Хохол",
    "country": "Россия",
    "searchString": "хохол россия / воронежская область / хохол"
  },
  "3964": {
    "id": "3964",
    "name": "Агой",
    "path": "Россия / Краснодарский край / Агой",
    "country": "Россия",
    "searchString": "агой россия / краснодарский край / агой"
  },
  "3965": {
    "id": "3965",
    "name": "Агроном (Краснодарский край)",
    "path": "Россия / Краснодарский край / Агроном (Краснодарский край)",
    "country": "Россия",
    "searchString": "агроном (краснодарский край) россия / краснодарский край / агроном (краснодарский край)"
  },
  "3966": {
    "id": "3966",
    "name": "Ахтанизовская",
    "path": "Россия / Краснодарский край / Ахтанизовская",
    "country": "Россия",
    "searchString": "ахтанизовская россия / краснодарский край / ахтанизовская"
  },
  "3967": {
    "id": "3967",
    "name": "Батуринская",
    "path": "Россия / Краснодарский край / Батуринская",
    "country": "Россия",
    "searchString": "батуринская россия / краснодарский край / батуринская"
  },
  "3968": {
    "id": "3968",
    "name": "Венцы (Краснодарский край)",
    "path": "Россия / Краснодарский край / Венцы (Краснодарский край)",
    "country": "Россия",
    "searchString": "венцы (краснодарский край) россия / краснодарский край / венцы (краснодарский край)"
  },
  "3969": {
    "id": "3969",
    "name": "Вознесенская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Вознесенская (Краснодарский край)",
    "country": "Россия",
    "searchString": "вознесенская (краснодарский край) россия / краснодарский край / вознесенская (краснодарский край)"
  },
  "3970": {
    "id": "3970",
    "name": "Воронежская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Воронежская (Краснодарский край)",
    "country": "Россия",
    "searchString": "воронежская (краснодарский край) россия / краснодарский край / воронежская (краснодарский край)"
  },
  "3971": {
    "id": "3971",
    "name": "Вышестеблиевская",
    "path": "Россия / Краснодарский край / Вышестеблиевская",
    "country": "Россия",
    "searchString": "вышестеблиевская россия / краснодарский край / вышестеблиевская"
  },
  "3972": {
    "id": "3972",
    "name": "Гирей",
    "path": "Россия / Краснодарский край / Гирей",
    "country": "Россия",
    "searchString": "гирей россия / краснодарский край / гирей"
  },
  "3973": {
    "id": "3973",
    "name": "Горное Лоо",
    "path": "Россия / Краснодарский край / Горное Лоо",
    "country": "Россия",
    "searchString": "горное лоо россия / краснодарский край / горное лоо"
  },
  "3974": {
    "id": "3974",
    "name": "Губская",
    "path": "Россия / Краснодарский край / Губская",
    "country": "Россия",
    "searchString": "губская россия / краснодарский край / губская"
  },
  "3975": {
    "id": "3975",
    "name": "Калниболотская",
    "path": "Россия / Краснодарский край / Калниболотская",
    "country": "Россия",
    "searchString": "калниболотская россия / краснодарский край / калниболотская"
  },
  "3976": {
    "id": "3976",
    "name": "Киевское (Краснодарский край)",
    "path": "Россия / Краснодарский край / Киевское (Краснодарский край)",
    "country": "Россия",
    "searchString": "киевское (краснодарский край) россия / краснодарский край / киевское (краснодарский край)"
  },
  "3977": {
    "id": "3977",
    "name": "Константиновская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Константиновская (Краснодарский край)",
    "country": "Россия",
    "searchString": "константиновская (краснодарский край) россия / краснодарский край / константиновская (краснодарский край)"
  },
  "3978": {
    "id": "3978",
    "name": "Красное (Краснодарский край)",
    "path": "Россия / Краснодарский край / Красное (Краснодарский край)",
    "country": "Россия",
    "searchString": "красное (краснодарский край) россия / краснодарский край / красное (краснодарский край)"
  },
  "3979": {
    "id": "3979",
    "name": "Красносельский (Краснодарский край)",
    "path": "Россия / Краснодарский край / Красносельский (Краснодарский край)",
    "country": "Россия",
    "searchString": "красносельский (краснодарский край) россия / краснодарский край / красносельский (краснодарский край)"
  },
  "3980": {
    "id": "3980",
    "name": "Курчанская",
    "path": "Россия / Краснодарский край / Курчанская",
    "country": "Россия",
    "searchString": "курчанская россия / краснодарский край / курчанская"
  },
  "3981": {
    "id": "3981",
    "name": "Майкопское",
    "path": "Россия / Краснодарский край / Майкопское",
    "country": "Россия",
    "searchString": "майкопское россия / краснодарский край / майкопское"
  },
  "3982": {
    "id": "3982",
    "name": "Мысхако",
    "path": "Россия / Краснодарский край / Мысхако",
    "country": "Россия",
    "searchString": "мысхако россия / краснодарский край / мысхако"
  },
  "3983": {
    "id": "3983",
    "name": "Небуг",
    "path": "Россия / Краснодарский край / Небуг",
    "country": "Россия",
    "searchString": "небуг россия / краснодарский край / небуг"
  },
  "3984": {
    "id": "3984",
    "name": "Незамаевская",
    "path": "Россия / Краснодарский край / Незамаевская",
    "country": "Россия",
    "searchString": "незамаевская россия / краснодарский край / незамаевская"
  },
  "3985": {
    "id": "3985",
    "name": "Новолабинская",
    "path": "Россия / Краснодарский край / Новолабинская",
    "country": "Россия",
    "searchString": "новолабинская россия / краснодарский край / новолабинская"
  },
  "3986": {
    "id": "3986",
    "name": "Новомалороссийская",
    "path": "Россия / Краснодарский край / Новомалороссийская",
    "country": "Россия",
    "searchString": "новомалороссийская россия / краснодарский край / новомалороссийская"
  },
  "3987": {
    "id": "3987",
    "name": "Новоплатнировская",
    "path": "Россия / Краснодарский край / Новоплатнировская",
    "country": "Россия",
    "searchString": "новоплатнировская россия / краснодарский край / новоплатнировская"
  },
  "3988": {
    "id": "3988",
    "name": "Новоукраинское",
    "path": "Россия / Краснодарский край / Новоукраинское",
    "country": "Россия",
    "searchString": "новоукраинское россия / краснодарский край / новоукраинское"
  },
  "3989": {
    "id": "3989",
    "name": "Ольгинская",
    "path": "Россия / Краснодарский край / Ольгинская",
    "country": "Россия",
    "searchString": "ольгинская россия / краснодарский край / ольгинская"
  },
  "3990": {
    "id": "3990",
    "name": "Отрадо-Кубанское",
    "path": "Россия / Краснодарский край / Отрадо-Кубанское",
    "country": "Россия",
    "searchString": "отрадо-кубанское россия / краснодарский край / отрадо-кубанское"
  },
  "3991": {
    "id": "3991",
    "name": "Парковый",
    "path": "Россия / Краснодарский край / Парковый",
    "country": "Россия",
    "searchString": "парковый россия / краснодарский край / парковый"
  },
  "3992": {
    "id": "3992",
    "name": "Передовая (Краснодарский край)",
    "path": "Россия / Краснодарский край / Передовая (Краснодарский край)",
    "country": "Россия",
    "searchString": "передовая (краснодарский край) россия / краснодарский край / передовая (краснодарский край)"
  },
  "3993": {
    "id": "3993",
    "name": "Переправная",
    "path": "Россия / Краснодарский край / Переправная",
    "country": "Россия",
    "searchString": "переправная россия / краснодарский край / переправная"
  },
  "3994": {
    "id": "3994",
    "name": "Переясловская",
    "path": "Россия / Краснодарский край / Переясловская",
    "country": "Россия",
    "searchString": "переясловская россия / краснодарский край / переясловская"
  },
  "3995": {
    "id": "3995",
    "name": "Петропавловская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Петропавловская (Краснодарский край)",
    "country": "Россия",
    "searchString": "петропавловская (краснодарский край) россия / краснодарский край / петропавловская (краснодарский край)"
  },
  "3996": {
    "id": "3996",
    "name": "Попутная",
    "path": "Россия / Краснодарский край / Попутная",
    "country": "Россия",
    "searchString": "попутная россия / краснодарский край / попутная"
  },
  "3997": {
    "id": "3997",
    "name": "Привольная (Краснодарский край)",
    "path": "Россия / Краснодарский край / Привольная (Краснодарский край)",
    "country": "Россия",
    "searchString": "привольная (краснодарский край) россия / краснодарский край / привольная (краснодарский край)"
  },
  "3998": {
    "id": "3998",
    "name": "Прикубанский",
    "path": "Россия / Краснодарский край / Прикубанский",
    "country": "Россия",
    "searchString": "прикубанский россия / краснодарский край / прикубанский"
  },
  "3999": {
    "id": "3999",
    "name": "Прочноокопская",
    "path": "Россия / Краснодарский край / Прочноокопская",
    "country": "Россия",
    "searchString": "прочноокопская россия / краснодарский край / прочноокопская"
  },
  "4000": {
    "id": "4000",
    "name": "Пшехская",
    "path": "Россия / Краснодарский край / Пшехская",
    "country": "Россия",
    "searchString": "пшехская россия / краснодарский край / пшехская"
  },
  "4001": {
    "id": "4001",
    "name": "Саратовская",
    "path": "Россия / Краснодарский край / Саратовская",
    "country": "Россия",
    "searchString": "саратовская россия / краснодарский край / саратовская"
  },
  "4002": {
    "id": "4002",
    "name": "Сенной (Краснодарский край)",
    "path": "Россия / Краснодарский край / Сенной (Краснодарский край)",
    "country": "Россия",
    "searchString": "сенной (краснодарский край) россия / краснодарский край / сенной (краснодарский край)"
  },
  "4003": {
    "id": "4003",
    "name": "Совхозный (Краснодарский край)",
    "path": "Россия / Краснодарский край / Совхозный (Краснодарский край)",
    "country": "Россия",
    "searchString": "совхозный (краснодарский край) россия / краснодарский край / совхозный (краснодарский край)"
  },
  "4004": {
    "id": "4004",
    "name": "Старая Станица (Краснодарский край)",
    "path": "Россия / Краснодарский край / Старая Станица (Краснодарский край)",
    "country": "Россия",
    "searchString": "старая станица (краснодарский край) россия / краснодарский край / старая станица (краснодарский край)"
  },
  "4005": {
    "id": "4005",
    "name": "Староджерелиевская",
    "path": "Россия / Краснодарский край / Староджерелиевская",
    "country": "Россия",
    "searchString": "староджерелиевская россия / краснодарский край / староджерелиевская"
  },
  "4006": {
    "id": "4006",
    "name": "Старонижестеблиевская",
    "path": "Россия / Краснодарский край / Старонижестеблиевская",
    "country": "Россия",
    "searchString": "старонижестеблиевская россия / краснодарский край / старонижестеблиевская"
  },
  "4007": {
    "id": "4007",
    "name": "Супсех",
    "path": "Россия / Краснодарский край / Супсех",
    "country": "Россия",
    "searchString": "супсех россия / краснодарский край / супсех"
  },
  "4008": {
    "id": "4008",
    "name": "Темиргоевская",
    "path": "Россия / Краснодарский край / Темиргоевская",
    "country": "Россия",
    "searchString": "темиргоевская россия / краснодарский край / темиргоевская"
  },
  "4009": {
    "id": "4009",
    "name": "Чамлыкская",
    "path": "Россия / Краснодарский край / Чамлыкская",
    "country": "Россия",
    "searchString": "чамлыкская россия / краснодарский край / чамлыкская"
  },
  "4010": {
    "id": "4010",
    "name": "Челбасская",
    "path": "Россия / Краснодарский край / Челбасская",
    "country": "Россия",
    "searchString": "челбасская россия / краснодарский край / челбасская"
  },
  "4011": {
    "id": "4011",
    "name": "Черноерковская",
    "path": "Россия / Краснодарский край / Черноерковская",
    "country": "Россия",
    "searchString": "черноерковская россия / краснодарский край / черноерковская"
  },
  "4012": {
    "id": "4012",
    "name": "Черноморский",
    "path": "Россия / Краснодарский край / Черноморский",
    "country": "Россия",
    "searchString": "черноморский россия / краснодарский край / черноморский"
  },
  "4013": {
    "id": "4013",
    "name": "Шедок",
    "path": "Россия / Краснодарский край / Шедок",
    "country": "Россия",
    "searchString": "шедок россия / краснодарский край / шедок"
  },
  "4014": {
    "id": "4014",
    "name": "Шепси",
    "path": "Россия / Краснодарский край / Шепси",
    "country": "Россия",
    "searchString": "шепси россия / краснодарский край / шепси"
  },
  "4015": {
    "id": "4015",
    "name": "Широчанка",
    "path": "Россия / Краснодарский край / Широчанка",
    "country": "Россия",
    "searchString": "широчанка россия / краснодарский край / широчанка"
  },
  "4016": {
    "id": "4016",
    "name": "Шкуринская",
    "path": "Россия / Краснодарский край / Шкуринская",
    "country": "Россия",
    "searchString": "шкуринская россия / краснодарский край / шкуринская"
  },
  "4017": {
    "id": "4017",
    "name": "Юровка (Краснодарский край)",
    "path": "Россия / Краснодарский край / Юровка (Краснодарский край)",
    "country": "Россия",
    "searchString": "юровка (краснодарский край) россия / краснодарский край / юровка (краснодарский край)"
  },
  "4018": {
    "id": "4018",
    "name": "Ясенская",
    "path": "Россия / Краснодарский край / Ясенская",
    "country": "Россия",
    "searchString": "ясенская россия / краснодарский край / ясенская"
  },
  "4019": {
    "id": "4019",
    "name": "Мга",
    "path": "Россия / Ленинградская область / Мга",
    "country": "Россия",
    "searchString": "мга россия / ленинградская область / мга"
  },
  "4020": {
    "id": "4020",
    "name": "посёлок имени Морозова",
    "path": "Россия / Ленинградская область / посёлок имени Морозова",
    "country": "Россия",
    "searchString": "посёлок имени морозова россия / ленинградская область / посёлок имени морозова"
  },
  "4021": {
    "id": "4021",
    "name": "Старая (Ленинградская область)",
    "path": "Россия / Ленинградская область / Старая (Ленинградская область)",
    "country": "Россия",
    "searchString": "старая (ленинградская область) россия / ленинградская область / старая (ленинградская область)"
  },
  "4022": {
    "id": "4022",
    "name": "Сосново",
    "path": "Россия / Ленинградская область / Сосново",
    "country": "Россия",
    "searchString": "сосново россия / ленинградская область / сосново"
  },
  "4023": {
    "id": "4023",
    "name": "Рощино (Ленинградская область)",
    "path": "Россия / Ленинградская область / Рощино (Ленинградская область)",
    "country": "Россия",
    "searchString": "рощино (ленинградская область) россия / ленинградская область / рощино (ленинградская область)"
  },
  "4024": {
    "id": "4024",
    "name": "Кузьмоловский",
    "path": "Россия / Ленинградская область / Кузьмоловский",
    "country": "Россия",
    "searchString": "кузьмоловский россия / ленинградская область / кузьмоловский"
  },
  "4025": {
    "id": "4025",
    "name": "Вырица",
    "path": "Россия / Ленинградская область / Вырица",
    "country": "Россия",
    "searchString": "вырица россия / ленинградская область / вырица"
  },
  "4026": {
    "id": "4026",
    "name": "Сиверский",
    "path": "Россия / Ленинградская область / Сиверский",
    "country": "Россия",
    "searchString": "сиверский россия / ленинградская область / сиверский"
  },
  "4027": {
    "id": "4027",
    "name": "Металлострой",
    "path": "Россия / Ленинградская область / Металлострой",
    "country": "Россия",
    "searchString": "металлострой россия / ленинградская область / металлострой"
  },
  "4028": {
    "id": "4028",
    "name": "Дедовичи",
    "path": "Россия / Псковская область / Дедовичи",
    "country": "Россия",
    "searchString": "дедовичи россия / псковская область / дедовичи"
  },
  "4029": {
    "id": "4029",
    "name": "Струги Красные",
    "path": "Россия / Псковская область / Струги Красные",
    "country": "Россия",
    "searchString": "струги красные россия / псковская область / струги красные"
  },
  "4030": {
    "id": "4030",
    "name": "Плюсса",
    "path": "Россия / Псковская область / Плюсса",
    "country": "Россия",
    "searchString": "плюсса россия / псковская область / плюсса"
  },
  "4031": {
    "id": "4031",
    "name": "Палкино (Псковская область)",
    "path": "Россия / Псковская область / Палкино (Псковская область)",
    "country": "Россия",
    "searchString": "палкино (псковская область) россия / псковская область / палкино (псковская область)"
  },
  "4033": {
    "id": "4033",
    "name": "Красногородск",
    "path": "Россия / Псковская область / Красногородск",
    "country": "Россия",
    "searchString": "красногородск россия / псковская область / красногородск"
  },
  "4034": {
    "id": "4034",
    "name": "Агеево (Тульская область)",
    "path": "Россия / Тульская область / Агеево (Тульская область)",
    "country": "Россия",
    "searchString": "агеево (тульская область) россия / тульская область / агеево (тульская область)"
  },
  "4035": {
    "id": "4035",
    "name": "Бежаницы",
    "path": "Россия / Псковская область / Бежаницы",
    "country": "Россия",
    "searchString": "бежаницы россия / псковская область / бежаницы"
  },
  "4036": {
    "id": "4036",
    "name": "Свень",
    "path": "Россия / Брянская область / Свень",
    "country": "Россия",
    "searchString": "свень россия / брянская область / свень"
  },
  "4037": {
    "id": "4037",
    "name": "Арсеньево",
    "path": "Россия / Тульская область / Арсеньево",
    "country": "Россия",
    "searchString": "арсеньево россия / тульская область / арсеньево"
  },
  "4038": {
    "id": "4038",
    "name": "Локня (Псковская область)",
    "path": "Россия / Псковская область / Локня (Псковская область)",
    "country": "Россия",
    "searchString": "локня (псковская область) россия / псковская область / локня (псковская область)"
  },
  "4039": {
    "id": "4039",
    "name": "Барсуки",
    "path": "Россия / Тульская область / Барсуки",
    "country": "Россия",
    "searchString": "барсуки россия / тульская область / барсуки"
  },
  "4040": {
    "id": "4040",
    "name": "Супонево",
    "path": "Россия / Брянская область / Супонево",
    "country": "Россия",
    "searchString": "супонево россия / брянская область / супонево"
  },
  "4041": {
    "id": "4041",
    "name": "Бородинский",
    "path": "Россия / Тульская область / Бородинский",
    "country": "Россия",
    "searchString": "бородинский россия / тульская область / бородинский"
  },
  "4042": {
    "id": "4042",
    "name": "Ржаница",
    "path": "Россия / Брянская область / Ржаница",
    "country": "Россия",
    "searchString": "ржаница россия / брянская область / ржаница"
  },
  "4043": {
    "id": "4043",
    "name": "Брусянский",
    "path": "Россия / Тульская область / Брусянский",
    "country": "Россия",
    "searchString": "брусянский россия / тульская область / брусянский"
  },
  "4044": {
    "id": "4044",
    "name": "Любохна",
    "path": "Россия / Брянская область / Любохна",
    "country": "Россия",
    "searchString": "любохна россия / брянская область / любохна"
  },
  "4045": {
    "id": "4045",
    "name": "Волово (Тульская область)",
    "path": "Россия / Тульская область / Волово (Тульская область)",
    "country": "Россия",
    "searchString": "волово (тульская область) россия / тульская область / волово (тульская область)"
  },
  "4046": {
    "id": "4046",
    "name": "Грицовский",
    "path": "Россия / Тульская область / Грицовский",
    "country": "Россия",
    "searchString": "грицовский россия / тульская область / грицовский"
  },
  "4047": {
    "id": "4047",
    "name": "Добрунь",
    "path": "Россия / Брянская область / Добрунь",
    "country": "Россия",
    "searchString": "добрунь россия / брянская область / добрунь"
  },
  "4048": {
    "id": "4048",
    "name": "Глинищево",
    "path": "Россия / Брянская область / Глинищево",
    "country": "Россия",
    "searchString": "глинищево россия / брянская область / глинищево"
  },
  "4049": {
    "id": "4049",
    "name": "Дубна (Тульская область)",
    "path": "Россия / Тульская область / Дубна (Тульская область)",
    "country": "Россия",
    "searchString": "дубна (тульская область) россия / тульская область / дубна (тульская область)"
  },
  "4050": {
    "id": "4050",
    "name": "Бытошь",
    "path": "Россия / Брянская область / Бытошь",
    "country": "Россия",
    "searchString": "бытошь россия / брянская область / бытошь"
  },
  "4051": {
    "id": "4051",
    "name": "Дубовка (Тульская область)",
    "path": "Россия / Тульская область / Дубовка (Тульская область)",
    "country": "Россия",
    "searchString": "дубовка (тульская область) россия / тульская область / дубовка (тульская область)"
  },
  "4052": {
    "id": "4052",
    "name": "Суземка",
    "path": "Россия / Брянская область / Суземка",
    "country": "Россия",
    "searchString": "суземка россия / брянская область / суземка"
  },
  "4053": {
    "id": "4053",
    "name": "Куркино",
    "path": "Россия / Тульская область / Куркино",
    "country": "Россия",
    "searchString": "куркино россия / тульская область / куркино"
  },
  "4054": {
    "id": "4054",
    "name": "Старь",
    "path": "Россия / Брянская область / Старь",
    "country": "Россия",
    "searchString": "старь россия / брянская область / старь"
  },
  "4055": {
    "id": "4055",
    "name": "Ленинский (Тульская область)",
    "path": "Россия / Тульская область / Ленинский (Тульская область)",
    "country": "Россия",
    "searchString": "ленинский (тульская область) россия / тульская область / ленинский (тульская область)"
  },
  "4056": {
    "id": "4056",
    "name": "Сеща",
    "path": "Россия / Брянская область / Сеща",
    "country": "Россия",
    "searchString": "сеща россия / брянская область / сеща"
  },
  "4057": {
    "id": "4057",
    "name": "Ломинцевский",
    "path": "Россия / Тульская область / Ломинцевский",
    "country": "Россия",
    "searchString": "ломинцевский россия / тульская область / ломинцевский"
  },
  "4058": {
    "id": "4058",
    "name": "Рогнедино",
    "path": "Россия / Брянская область / Рогнедино",
    "country": "Россия",
    "searchString": "рогнедино россия / брянская область / рогнедино"
  },
  "4059": {
    "id": "4059",
    "name": "Новогуровский",
    "path": "Россия / Тульская область / Новогуровский",
    "country": "Россия",
    "searchString": "новогуровский россия / тульская область / новогуровский"
  },
  "4060": {
    "id": "4060",
    "name": "Погар",
    "path": "Россия / Брянская область / Погар",
    "country": "Россия",
    "searchString": "погар россия / брянская область / погар"
  },
  "4061": {
    "id": "4061",
    "name": "Навля",
    "path": "Россия / Брянская область / Навля",
    "country": "Россия",
    "searchString": "навля россия / брянская область / навля"
  },
  "4062": {
    "id": "4062",
    "name": "Октябрьский (Тульская область)",
    "path": "Россия / Тульская область / Октябрьский (Тульская область)",
    "country": "Россия",
    "searchString": "октябрьский (тульская область) россия / тульская область / октябрьский (тульская область)"
  },
  "4063": {
    "id": "4063",
    "name": "Локоть",
    "path": "Россия / Брянская область / Локоть",
    "country": "Россия",
    "searchString": "локоть россия / брянская область / локоть"
  },
  "4064": {
    "id": "4064",
    "name": "Красная Гора",
    "path": "Россия / Брянская область / Красная Гора",
    "country": "Россия",
    "searchString": "красная гора россия / брянская область / красная гора"
  },
  "4065": {
    "id": "4065",
    "name": "Комаричи",
    "path": "Россия / Брянская область / Комаричи",
    "country": "Россия",
    "searchString": "комаричи россия / брянская область / комаричи"
  },
  "4066": {
    "id": "4066",
    "name": "Кокино",
    "path": "Россия / Брянская область / Кокино",
    "country": "Россия",
    "searchString": "кокино россия / брянская область / кокино"
  },
  "4067": {
    "id": "4067",
    "name": "Климово (Брянская область)",
    "path": "Россия / Брянская область / Климово (Брянская область)",
    "country": "Россия",
    "searchString": "климово (брянская область) россия / брянская область / климово (брянская область)"
  },
  "4068": {
    "id": "4068",
    "name": "Печенга",
    "path": "Россия / Мурманская область / Печенга",
    "country": "Россия",
    "searchString": "печенга россия / мурманская область / печенга"
  },
  "4069": {
    "id": "4069",
    "name": "Никель (Мурманская область)",
    "path": "Россия / Мурманская область / Никель (Мурманская область)",
    "country": "Россия",
    "searchString": "никель (мурманская область) россия / мурманская область / никель (мурманская область)"
  },
  "4070": {
    "id": "4070",
    "name": "Ревда (Мурманская область)",
    "path": "Россия / Мурманская область / Ревда (Мурманская область)",
    "country": "Россия",
    "searchString": "ревда (мурманская область) россия / мурманская область / ревда (мурманская область)"
  },
  "4071": {
    "id": "4071",
    "name": "Калевала",
    "path": "Россия / Республика Карелия / Калевала",
    "country": "Россия",
    "searchString": "калевала россия / республика карелия / калевала"
  },
  "4072": {
    "id": "4072",
    "name": "Муезерский",
    "path": "Россия / Республика Карелия / Муезерский",
    "country": "Россия",
    "searchString": "муезерский россия / республика карелия / муезерский"
  },
  "4073": {
    "id": "4073",
    "name": "Ивот",
    "path": "Россия / Брянская область / Ивот",
    "country": "Россия",
    "searchString": "ивот россия / брянская область / ивот"
  },
  "4074": {
    "id": "4074",
    "name": "Жирятино",
    "path": "Россия / Брянская область / Жирятино",
    "country": "Россия",
    "searchString": "жирятино россия / брянская область / жирятино"
  },
  "4075": {
    "id": "4075",
    "name": "Дубровка",
    "path": "Россия / Брянская область / Дубровка",
    "country": "Россия",
    "searchString": "дубровка россия / брянская область / дубровка"
  },
  "4076": {
    "id": "4076",
    "name": "Гордеевка",
    "path": "Россия / Брянская область / Гордеевка",
    "country": "Россия",
    "searchString": "гордеевка россия / брянская область / гордеевка"
  },
  "4077": {
    "id": "4077",
    "name": "Выгоничи",
    "path": "Россия / Брянская область / Выгоничи",
    "country": "Россия",
    "searchString": "выгоничи россия / брянская область / выгоничи"
  },
  "4078": {
    "id": "4078",
    "name": "Белые Берега",
    "path": "Россия / Брянская область / Белые Берега",
    "country": "Россия",
    "searchString": "белые берега россия / брянская область / белые берега"
  },
  "4079": {
    "id": "4079",
    "name": "Белая Берёзка",
    "path": "Россия / Брянская область / Белая Берёзка",
    "country": "Россия",
    "searchString": "белая берёзка россия / брянская область / белая берёзка"
  },
  "4080": {
    "id": "4080",
    "name": "Осиновая Гора",
    "path": "Россия / Тульская область / Осиновая Гора",
    "country": "Россия",
    "searchString": "осиновая гора россия / тульская область / осиновая гора"
  },
  "4081": {
    "id": "4081",
    "name": "Первомайский (Тульская область)",
    "path": "Россия / Тульская область / Первомайский (Тульская область)",
    "country": "Россия",
    "searchString": "первомайский (тульская область) россия / тульская область / первомайский (тульская область)"
  },
  "4082": {
    "id": "4082",
    "name": "Плеханово",
    "path": "Россия / Тульская область / Плеханово",
    "country": "Россия",
    "searchString": "плеханово россия / тульская область / плеханово"
  },
  "4083": {
    "id": "4083",
    "name": "Приупский",
    "path": "Россия / Тульская область / Приупский",
    "country": "Россия",
    "searchString": "приупский россия / тульская область / приупский"
  },
  "4084": {
    "id": "4084",
    "name": "Ревякино",
    "path": "Россия / Тульская область / Ревякино",
    "country": "Россия",
    "searchString": "ревякино россия / тульская область / ревякино"
  },
  "4085": {
    "id": "4085",
    "name": "Северо-Задонск",
    "path": "Россия / Тульская область / Северо-Задонск",
    "country": "Россия",
    "searchString": "северо-задонск россия / тульская область / северо-задонск"
  },
  "4086": {
    "id": "4086",
    "name": "Сокольники",
    "path": "Россия / Тульская область / Сокольники",
    "country": "Россия",
    "searchString": "сокольники россия / тульская область / сокольники"
  },
  "4087": {
    "id": "4087",
    "name": "Теплое",
    "path": "Россия / Тульская область / Теплое",
    "country": "Россия",
    "searchString": "теплое россия / тульская область / теплое"
  },
  "4088": {
    "id": "4088",
    "name": "Товарковский",
    "path": "Россия / Тульская область / Товарковский",
    "country": "Россия",
    "searchString": "товарковский россия / тульская область / товарковский"
  },
  "4089": {
    "id": "4089",
    "name": "Хрущево",
    "path": "Россия / Тульская область / Хрущево",
    "country": "Россия",
    "searchString": "хрущево россия / тульская область / хрущево"
  },
  "4090": {
    "id": "4090",
    "name": "Чернь",
    "path": "Россия / Тульская область / Чернь",
    "country": "Россия",
    "searchString": "чернь россия / тульская область / чернь"
  },
  "4091": {
    "id": "4091",
    "name": "Шварцевский",
    "path": "Россия / Тульская область / Шварцевский",
    "country": "Россия",
    "searchString": "шварцевский россия / тульская область / шварцевский"
  },
  "4092": {
    "id": "4092",
    "name": "Лоухи",
    "path": "Россия / Республика Карелия / Лоухи",
    "country": "Россия",
    "searchString": "лоухи россия / республика карелия / лоухи"
  },
  "4093": {
    "id": "4093",
    "name": "Пряжа",
    "path": "Россия / Республика Карелия / Пряжа",
    "country": "Россия",
    "searchString": "пряжа россия / республика карелия / пряжа"
  },
  "4094": {
    "id": "4094",
    "name": "Азанка",
    "path": "Россия / Свердловская область / Азанка",
    "country": "Россия",
    "searchString": "азанка россия / свердловская область / азанка"
  },
  "4095": {
    "id": "4095",
    "name": "Арти",
    "path": "Россия / Свердловская область / Арти",
    "country": "Россия",
    "searchString": "арти россия / свердловская область / арти"
  },
  "4096": {
    "id": "4096",
    "name": "Атиг",
    "path": "Россия / Свердловская область / Атиг",
    "country": "Россия",
    "searchString": "атиг россия / свердловская область / атиг"
  },
  "4097": {
    "id": "4097",
    "name": "Ачит",
    "path": "Россия / Свердловская область / Ачит",
    "country": "Россия",
    "searchString": "ачит россия / свердловская область / ачит"
  },
  "4098": {
    "id": "4098",
    "name": "Байкалово",
    "path": "Россия / Республика Башкортостан / Байкалово",
    "country": "Россия",
    "searchString": "байкалово россия / республика башкортостан / байкалово"
  },
  "4099": {
    "id": "4099",
    "name": "Вангурей",
    "path": "Россия / Ненецкий АО / Вангурей",
    "country": "Россия",
    "searchString": "вангурей россия / ненецкий ао / вангурей"
  },
  "4100": {
    "id": "4100",
    "name": "Баранчинский",
    "path": "Россия / Свердловская область / Баранчинский",
    "country": "Россия",
    "searchString": "баранчинский россия / свердловская область / баранчинский"
  },
  "4101": {
    "id": "4101",
    "name": "Варандей",
    "path": "Россия / Ненецкий АО / Варандей",
    "country": "Россия",
    "searchString": "варандей россия / ненецкий ао / варандей"
  },
  "4102": {
    "id": "4102",
    "name": "Белоярский (Свердловская область)",
    "path": "Россия / Свердловская область / Белоярский (Свердловская область)",
    "country": "Россия",
    "searchString": "белоярский (свердловская область) россия / свердловская область / белоярский (свердловская область)"
  },
  "4103": {
    "id": "4103",
    "name": "Нарыга",
    "path": "Россия / Ненецкий АО / Нарыга",
    "country": "Россия",
    "searchString": "нарыга россия / ненецкий ао / нарыга"
  },
  "4104": {
    "id": "4104",
    "name": "Носовая",
    "path": "Россия / Ненецкий АО / Носовая",
    "country": "Россия",
    "searchString": "носовая россия / ненецкий ао / носовая"
  },
  "4105": {
    "id": "4105",
    "name": "Билимбай",
    "path": "Россия / Свердловская область / Билимбай",
    "country": "Россия",
    "searchString": "билимбай россия / свердловская область / билимбай"
  },
  "4106": {
    "id": "4106",
    "name": "Бисерть",
    "path": "Россия / Свердловская область / Бисерть",
    "country": "Россия",
    "searchString": "бисерть россия / свердловская область / бисерть"
  },
  "4107": {
    "id": "4107",
    "name": "Бобровский",
    "path": "Россия / Свердловская область / Бобровский",
    "country": "Россия",
    "searchString": "бобровский россия / свердловская область / бобровский"
  },
  "4108": {
    "id": "4108",
    "name": "Верхнетуломский",
    "path": "Россия / Мурманская область / Верхнетуломский",
    "country": "Россия",
    "searchString": "верхнетуломский россия / мурманская область / верхнетуломский"
  },
  "4109": {
    "id": "4109",
    "name": "Зеленоборский",
    "path": "Россия / Мурманская область / Зеленоборский",
    "country": "Россия",
    "searchString": "зеленоборский россия / мурманская область / зеленоборский"
  },
  "4110": {
    "id": "4110",
    "name": "Кильдинстрой",
    "path": "Россия / Мурманская область / Кильдинстрой",
    "country": "Россия",
    "searchString": "кильдинстрой россия / мурманская область / кильдинстрой"
  },
  "4111": {
    "id": "4111",
    "name": "Молочный",
    "path": "Россия / Мурманская область / Молочный",
    "country": "Россия",
    "searchString": "молочный россия / мурманская область / молочный"
  },
  "4112": {
    "id": "4112",
    "name": "Мурмаши",
    "path": "Россия / Мурманская область / Мурмаши",
    "country": "Россия",
    "searchString": "мурмаши россия / мурманская область / мурмаши"
  },
  "4113": {
    "id": "4113",
    "name": "Туманный",
    "path": "Россия / Мурманская область / Туманный",
    "country": "Россия",
    "searchString": "туманный россия / мурманская область / туманный"
  },
  "4114": {
    "id": "4114",
    "name": "Сафоново (Мурманская область)",
    "path": "Россия / Мурманская область / Сафоново (Мурманская область)",
    "country": "Россия",
    "searchString": "сафоново (мурманская область) россия / мурманская область / сафоново (мурманская область)"
  },
  "4115": {
    "id": "4115",
    "name": "Умба",
    "path": "Россия / Мурманская область / Умба",
    "country": "Россия",
    "searchString": "умба россия / мурманская область / умба"
  },
  "4116": {
    "id": "4116",
    "name": "Приморск",
    "path": "Россия / Калининградская область / Приморск",
    "country": "Россия",
    "searchString": "приморск россия / калининградская область / приморск"
  },
  "4117": {
    "id": "4117",
    "name": "Идрица",
    "path": "Россия / Псковская область / Идрица",
    "country": "Россия",
    "searchString": "идрица россия / псковская область / идрица"
  },
  "4118": {
    "id": "4118",
    "name": "Кунья",
    "path": "Россия / Псковская область / Кунья",
    "country": "Россия",
    "searchString": "кунья россия / псковская область / кунья"
  },
  "4119": {
    "id": "4119",
    "name": "Сосновый Бор (Псковская область)",
    "path": "Россия / Псковская область / Сосновый Бор (Псковская область)",
    "country": "Россия",
    "searchString": "сосновый бор (псковская область) россия / псковская область / сосновый бор (псковская область)"
  },
  "4120": {
    "id": "4120",
    "name": "Усвяты",
    "path": "Россия / Псковская область / Усвяты",
    "country": "Россия",
    "searchString": "усвяты россия / псковская область / усвяты"
  },
  "4121": {
    "id": "4121",
    "name": "Заплюсье",
    "path": "Россия / Псковская область / Заплюсье",
    "country": "Россия",
    "searchString": "заплюсье россия / псковская область / заплюсье"
  },
  "4122": {
    "id": "4122",
    "name": "Красный Луч (Псковская область)",
    "path": "Россия / Псковская область / Красный Луч (Псковская область)",
    "country": "Россия",
    "searchString": "красный луч (псковская область) россия / псковская область / красный луч (псковская область)"
  },
  "4123": {
    "id": "4123",
    "name": "Крестцы",
    "path": "Россия / Новгородская область / Крестцы",
    "country": "Россия",
    "searchString": "крестцы россия / новгородская область / крестцы"
  },
  "4124": {
    "id": "4124",
    "name": "Кулотино",
    "path": "Россия / Новгородская область / Кулотино",
    "country": "Россия",
    "searchString": "кулотино россия / новгородская область / кулотино"
  },
  "4125": {
    "id": "4125",
    "name": "Любытино",
    "path": "Россия / Новгородская область / Любытино",
    "country": "Россия",
    "searchString": "любытино россия / новгородская область / любытино"
  },
  "4126": {
    "id": "4126",
    "name": "Неболчи",
    "path": "Россия / Новгородская область / Неболчи",
    "country": "Россия",
    "searchString": "неболчи россия / новгородская область / неболчи"
  },
  "4127": {
    "id": "4127",
    "name": "Демянск",
    "path": "Россия / Новгородская область / Демянск",
    "country": "Россия",
    "searchString": "демянск россия / новгородская область / демянск"
  },
  "4128": {
    "id": "4128",
    "name": "Панковка",
    "path": "Россия / Новгородская область / Панковка",
    "country": "Россия",
    "searchString": "панковка россия / новгородская область / панковка"
  },
  "4129": {
    "id": "4129",
    "name": "Парфино",
    "path": "Россия / Новгородская область / Парфино",
    "country": "Россия",
    "searchString": "парфино россия / новгородская область / парфино"
  },
  "4130": {
    "id": "4130",
    "name": "Пролетарий",
    "path": "Россия / Новгородская область / Пролетарий",
    "country": "Россия",
    "searchString": "пролетарий россия / новгородская область / пролетарий"
  },
  "4131": {
    "id": "4131",
    "name": "Угловка",
    "path": "Россия / Новгородская область / Угловка",
    "country": "Россия",
    "searchString": "угловка россия / новгородская область / угловка"
  },
  "4132": {
    "id": "4132",
    "name": "Хвойная",
    "path": "Россия / Новгородская область / Хвойная",
    "country": "Россия",
    "searchString": "хвойная россия / новгородская область / хвойная"
  },
  "4133": {
    "id": "4133",
    "name": "Шимск",
    "path": "Россия / Новгородская область / Шимск",
    "country": "Россия",
    "searchString": "шимск россия / новгородская область / шимск"
  },
  "4134": {
    "id": "4134",
    "name": "Белушья Губа",
    "path": "Россия / Архангельская область / Белушья Губа",
    "country": "Россия",
    "searchString": "белушья губа россия / архангельская область / белушья губа"
  },
  "4135": {
    "id": "4135",
    "name": "Березник",
    "path": "Россия / Архангельская область / Березник",
    "country": "Россия",
    "searchString": "березник россия / архангельская область / березник"
  },
  "4136": {
    "id": "4136",
    "name": "Вычегодский",
    "path": "Россия / Архангельская область / Вычегодский",
    "country": "Россия",
    "searchString": "вычегодский россия / архангельская область / вычегодский"
  },
  "4137": {
    "id": "4137",
    "name": "Емца",
    "path": "Россия / Архангельская область / Емца",
    "country": "Россия",
    "searchString": "емца россия / архангельская область / емца"
  },
  "4138": {
    "id": "4138",
    "name": "Каменка (Архангельская область)",
    "path": "Россия / Архангельская область / Каменка (Архангельская область)",
    "country": "Россия",
    "searchString": "каменка (архангельская область) россия / архангельская область / каменка (архангельская область)"
  },
  "4139": {
    "id": "4139",
    "name": "Кулой",
    "path": "Россия / Архангельская область / Кулой",
    "country": "Россия",
    "searchString": "кулой россия / архангельская область / кулой"
  },
  "4140": {
    "id": "4140",
    "name": "Малошуйка",
    "path": "Россия / Архангельская область / Малошуйка",
    "country": "Россия",
    "searchString": "малошуйка россия / архангельская область / малошуйка"
  },
  "4141": {
    "id": "4141",
    "name": "Обозерский",
    "path": "Россия / Архангельская область / Обозерский",
    "country": "Россия",
    "searchString": "обозерский россия / архангельская область / обозерский"
  },
  "4142": {
    "id": "4142",
    "name": "Оксовский",
    "path": "Россия / Архангельская область / Оксовский",
    "country": "Россия",
    "searchString": "оксовский россия / архангельская область / оксовский"
  },
  "4143": {
    "id": "4143",
    "name": "Плесецк",
    "path": "Россия / Архангельская область / Плесецк",
    "country": "Россия",
    "searchString": "плесецк россия / архангельская область / плесецк"
  },
  "4144": {
    "id": "4144",
    "name": "Приводино",
    "path": "Россия / Архангельская область / Приводино",
    "country": "Россия",
    "searchString": "приводино россия / архангельская область / приводино"
  },
  "4145": {
    "id": "4145",
    "name": "Пуксоозера",
    "path": "Россия / Архангельская область / Пуксоозера",
    "country": "Россия",
    "searchString": "пуксоозера россия / архангельская область / пуксоозера"
  },
  "4146": {
    "id": "4146",
    "name": "Самодед",
    "path": "Россия / Архангельская область / Самодед",
    "country": "Россия",
    "searchString": "самодед россия / архангельская область / самодед"
  },
  "4147": {
    "id": "4147",
    "name": "Савинский",
    "path": "Россия / Архангельская область / Савинский",
    "country": "Россия",
    "searchString": "савинский россия / архангельская область / савинский"
  },
  "4148": {
    "id": "4148",
    "name": "Североонежск",
    "path": "Россия / Архангельская область / Североонежск",
    "country": "Россия",
    "searchString": "североонежск россия / архангельская область / североонежск"
  },
  "4149": {
    "id": "4149",
    "name": "Урдома",
    "path": "Россия / Архангельская область / Урдома",
    "country": "Россия",
    "searchString": "урдома россия / архангельская область / урдома"
  },
  "4150": {
    "id": "4150",
    "name": "Шипицыно",
    "path": "Россия / Архангельская область / Шипицыно",
    "country": "Россия",
    "searchString": "шипицыно россия / архангельская область / шипицыно"
  },
  "4151": {
    "id": "4151",
    "name": "Новое Девяткино",
    "path": "Россия / Ленинградская область / Новое Девяткино",
    "country": "Россия",
    "searchString": "новое девяткино россия / ленинградская область / новое девяткино"
  },
  "4152": {
    "id": "4152",
    "name": "пгт имени Свердлова",
    "path": "Россия / Ленинградская область / пгт имени Свердлова",
    "country": "Россия",
    "searchString": "пгт имени свердлова россия / ленинградская область / пгт имени свердлова"
  },
  "4153": {
    "id": "4153",
    "name": "Горбунки",
    "path": "Россия / Ленинградская область / Горбунки",
    "country": "Россия",
    "searchString": "горбунки россия / ленинградская область / горбунки"
  },
  "4154": {
    "id": "4154",
    "name": "Советский (Ленинградская область)",
    "path": "Россия / Ленинградская область / Советский (Ленинградская область)",
    "country": "Россия",
    "searchString": "советский (ленинградская область) россия / ленинградская область / советский (ленинградская область)"
  },
  "4155": {
    "id": "4155",
    "name": "Лебяжье",
    "path": "Россия / Ленинградская область / Лебяжье",
    "country": "Россия",
    "searchString": "лебяжье россия / ленинградская область / лебяжье"
  },
  "4156": {
    "id": "4156",
    "name": "Романовка",
    "path": "Россия / Ленинградская область / Романовка",
    "country": "Россия",
    "searchString": "романовка россия / ленинградская область / романовка"
  },
  "4157": {
    "id": "4157",
    "name": "Каменка (Ленинградская область)",
    "path": "Россия / Ленинградская область / Каменка (Ленинградская область)",
    "country": "Россия",
    "searchString": "каменка (ленинградская область) россия / ленинградская область / каменка (ленинградская область)"
  },
  "4158": {
    "id": "4158",
    "name": "Токсово",
    "path": "Россия / Ленинградская область / Токсово",
    "country": "Россия",
    "searchString": "токсово россия / ленинградская область / токсово"
  },
  "4159": {
    "id": "4159",
    "name": "Новый Свет",
    "path": "Россия / Ленинградская область / Новый Свет",
    "country": "Россия",
    "searchString": "новый свет россия / ленинградская область / новый свет"
  },
  "4160": {
    "id": "4160",
    "name": "Тельмана",
    "path": "Россия / Ленинградская область / Тельмана",
    "country": "Россия",
    "searchString": "тельмана россия / ленинградская область / тельмана"
  },
  "4161": {
    "id": "4161",
    "name": "Дубровка (Ленинградская область)",
    "path": "Россия / Ленинградская область / Дубровка (Ленинградская область)",
    "country": "Россия",
    "searchString": "дубровка (ленинградская область) россия / ленинградская область / дубровка (ленинградская область)"
  },
  "4162": {
    "id": "4162",
    "name": "Приладожский",
    "path": "Россия / Ленинградская область / Приладожский",
    "country": "Россия",
    "searchString": "приладожский россия / ленинградская область / приладожский"
  },
  "4163": {
    "id": "4163",
    "name": "Бугры",
    "path": "Россия / Ленинградская область / Бугры",
    "country": "Россия",
    "searchString": "бугры россия / ленинградская область / бугры"
  },
  "4164": {
    "id": "4164",
    "name": "Синявино",
    "path": "Россия / Ленинградская область / Синявино",
    "country": "Россия",
    "searchString": "синявино россия / ленинградская область / синявино"
  },
  "4165": {
    "id": "4165",
    "name": "Будогощь",
    "path": "Россия / Ленинградская область / Будогощь",
    "country": "Россия",
    "searchString": "будогощь россия / ленинградская область / будогощь"
  },
  "4166": {
    "id": "4166",
    "name": "Большая Ижора",
    "path": "Россия / Ленинградская область / Большая Ижора",
    "country": "Россия",
    "searchString": "большая ижора россия / ленинградская область / большая ижора"
  },
  "4167": {
    "id": "4167",
    "name": "Айша",
    "path": "Россия / Республика Татарстан / Айша",
    "country": "Россия",
    "searchString": "айша россия / республика татарстан / айша"
  },
  "4168": {
    "id": "4168",
    "name": "Аксубаево",
    "path": "Россия / Республика Татарстан / Аксубаево",
    "country": "Россия",
    "searchString": "аксубаево россия / республика татарстан / аксубаево"
  },
  "4169": {
    "id": "4169",
    "name": "Актюбинский",
    "path": "Россия / Республика Татарстан / Актюбинский",
    "country": "Россия",
    "searchString": "актюбинский россия / республика татарстан / актюбинский"
  },
  "4170": {
    "id": "4170",
    "name": "Базарные Матаки",
    "path": "Россия / Республика Татарстан / Базарные Матаки",
    "country": "Россия",
    "searchString": "базарные матаки россия / республика татарстан / базарные матаки"
  },
  "4171": {
    "id": "4171",
    "name": "Бетьки",
    "path": "Россия / Республика Татарстан / Бетьки",
    "country": "Россия",
    "searchString": "бетьки россия / республика татарстан / бетьки"
  },
  "4172": {
    "id": "4172",
    "name": "Богатые Сабы",
    "path": "Россия / Республика Татарстан / Богатые Сабы",
    "country": "Россия",
    "searchString": "богатые сабы россия / республика татарстан / богатые сабы"
  },
  "4173": {
    "id": "4173",
    "name": "Большая Атня",
    "path": "Россия / Республика Татарстан / Большая Атня",
    "country": "Россия",
    "searchString": "большая атня россия / республика татарстан / большая атня"
  },
  "4174": {
    "id": "4174",
    "name": "Большие Кайбицы",
    "path": "Россия / Республика Татарстан / Большие Кайбицы",
    "country": "Россия",
    "searchString": "большие кайбицы россия / республика татарстан / большие кайбицы"
  },
  "4175": {
    "id": "4175",
    "name": "Верхний Услон",
    "path": "Россия / Республика Татарстан / Верхний Услон",
    "country": "Россия",
    "searchString": "верхний услон россия / республика татарстан / верхний услон"
  },
  "4176": {
    "id": "4176",
    "name": "Высокая Гора",
    "path": "Россия / Республика Татарстан / Высокая Гора",
    "country": "Россия",
    "searchString": "высокая гора россия / республика татарстан / высокая гора"
  },
  "4177": {
    "id": "4177",
    "name": "Джалиль",
    "path": "Россия / Республика Татарстан / Джалиль",
    "country": "Россия",
    "searchString": "джалиль россия / республика татарстан / джалиль"
  },
  "4178": {
    "id": "4178",
    "name": "Карабаш (Республика Татарстан)",
    "path": "Россия / Республика Татарстан / Карабаш (Республика Татарстан)",
    "country": "Россия",
    "searchString": "карабаш (республика татарстан) россия / республика татарстан / карабаш (республика татарстан)"
  },
  "4179": {
    "id": "4179",
    "name": "Куйбышевский Затон",
    "path": "Россия / Республика Татарстан / Куйбышевский Затон",
    "country": "Россия",
    "searchString": "куйбышевский затон россия / республика татарстан / куйбышевский затон"
  },
  "4180": {
    "id": "4180",
    "name": "Муслюмово",
    "path": "Россия / Республика Татарстан / Муслюмово",
    "country": "Россия",
    "searchString": "муслюмово россия / республика татарстан / муслюмово"
  },
  "4181": {
    "id": "4181",
    "name": "Нижняя Мактама",
    "path": "Россия / Республика Татарстан / Нижняя Мактама",
    "country": "Россия",
    "searchString": "нижняя мактама россия / республика татарстан / нижняя мактама"
  },
  "4182": {
    "id": "4182",
    "name": "Новошешминск",
    "path": "Россия / Республика Татарстан / Новошешминск",
    "country": "Россия",
    "searchString": "новошешминск россия / республика татарстан / новошешминск"
  },
  "4183": {
    "id": "4183",
    "name": "Осиново",
    "path": "Россия / Республика Татарстан / Осиново",
    "country": "Россия",
    "searchString": "осиново россия / республика татарстан / осиново"
  },
  "4184": {
    "id": "4184",
    "name": "Русский Акташ",
    "path": "Россия / Республика Татарстан / Русский Акташ",
    "country": "Россия",
    "searchString": "русский акташ россия / республика татарстан / русский акташ"
  },
  "4185": {
    "id": "4185",
    "name": "Рыбная Слобода",
    "path": "Россия / Республика Татарстан / Рыбная Слобода",
    "country": "Россия",
    "searchString": "рыбная слобода россия / республика татарстан / рыбная слобода"
  },
  "4186": {
    "id": "4186",
    "name": "Сарманово",
    "path": "Россия / Республика Татарстан / Сарманово",
    "country": "Россия",
    "searchString": "сарманово россия / республика татарстан / сарманово"
  },
  "4187": {
    "id": "4187",
    "name": "Тюлячи",
    "path": "Россия / Республика Татарстан / Тюлячи",
    "country": "Россия",
    "searchString": "тюлячи россия / республика татарстан / тюлячи"
  },
  "4188": {
    "id": "4188",
    "name": "Убей",
    "path": "Россия / Республика Татарстан / Убей",
    "country": "Россия",
    "searchString": "убей россия / республика татарстан / убей"
  },
  "4189": {
    "id": "4189",
    "name": "Черемшан",
    "path": "Россия / Республика Татарстан / Черемшан",
    "country": "Россия",
    "searchString": "черемшан россия / республика татарстан / черемшан"
  },
  "4190": {
    "id": "4190",
    "name": "Чувашское Дрожжаное",
    "path": "Россия / Республика Татарстан / Чувашское Дрожжаное",
    "country": "Россия",
    "searchString": "чувашское дрожжаное россия / республика татарстан / чувашское дрожжаное"
  },
  "4191": {
    "id": "4191",
    "name": "Шемордан",
    "path": "Россия / Республика Татарстан / Шемордан",
    "country": "Россия",
    "searchString": "шемордан россия / республика татарстан / шемордан"
  },
  "4192": {
    "id": "4192",
    "name": "Алнаши",
    "path": "Россия / Удмуртская Республика / Алнаши",
    "country": "Россия",
    "searchString": "алнаши россия / удмуртская республика / алнаши"
  },
  "4193": {
    "id": "4193",
    "name": "Большой Зетым",
    "path": "Россия / Удмуртская Республика / Большой Зетым",
    "country": "Россия",
    "searchString": "большой зетым россия / удмуртская республика / большой зетым"
  },
  "4194": {
    "id": "4194",
    "name": "Вавож",
    "path": "Россия / Удмуртская Республика / Вавож",
    "country": "Россия",
    "searchString": "вавож россия / удмуртская республика / вавож"
  },
  "4195": {
    "id": "4195",
    "name": "Грахово",
    "path": "Россия / Удмуртская Республика / Грахово",
    "country": "Россия",
    "searchString": "грахово россия / удмуртская республика / грахово"
  },
  "4196": {
    "id": "4196",
    "name": "Дебёсы",
    "path": "Россия / Удмуртская Республика / Дебёсы",
    "country": "Россия",
    "searchString": "дебёсы россия / удмуртская республика / дебёсы"
  },
  "4197": {
    "id": "4197",
    "name": "Ершовка",
    "path": "Россия / Удмуртская Республика / Ершовка",
    "country": "Россия",
    "searchString": "ершовка россия / удмуртская республика / ершовка"
  },
  "4198": {
    "id": "4198",
    "name": "Завьялово",
    "path": "Россия / Удмуртская Республика / Завьялово",
    "country": "Россия",
    "searchString": "завьялово россия / удмуртская республика / завьялово"
  },
  "4199": {
    "id": "4199",
    "name": "Засеково",
    "path": "Россия / Удмуртская Республика / Засеково",
    "country": "Россия",
    "searchString": "засеково россия / удмуртская республика / засеково"
  },
  "4200": {
    "id": "4200",
    "name": "Каракулино",
    "path": "Россия / Удмуртская Республика / Каракулино",
    "country": "Россия",
    "searchString": "каракулино россия / удмуртская республика / каракулино"
  },
  "4201": {
    "id": "4201",
    "name": "Кез",
    "path": "Россия / Удмуртская Республика / Кез",
    "country": "Россия",
    "searchString": "кез россия / удмуртская республика / кез"
  },
  "4202": {
    "id": "4202",
    "name": "Кизнер",
    "path": "Россия / Удмуртская Республика / Кизнер",
    "country": "Россия",
    "searchString": "кизнер россия / удмуртская республика / кизнер"
  },
  "4203": {
    "id": "4203",
    "name": "Кильмезь",
    "path": "Россия / Удмуртская Республика / Кильмезь",
    "country": "Россия",
    "searchString": "кильмезь россия / удмуртская республика / кильмезь"
  },
  "4204": {
    "id": "4204",
    "name": "Киясово",
    "path": "Россия / Удмуртская Республика / Киясово",
    "country": "Россия",
    "searchString": "киясово россия / удмуртская республика / киясово"
  },
  "4205": {
    "id": "4205",
    "name": "Красногорское",
    "path": "Россия / Удмуртская Республика / Красногорское",
    "country": "Россия",
    "searchString": "красногорское россия / удмуртская республика / красногорское"
  },
  "4206": {
    "id": "4206",
    "name": "Малая Пурга",
    "path": "Россия / Удмуртская Республика / Малая Пурга",
    "country": "Россия",
    "searchString": "малая пурга россия / удмуртская республика / малая пурга"
  },
  "4207": {
    "id": "4207",
    "name": "Пирогово",
    "path": "Россия / Удмуртская Республика / Пирогово",
    "country": "Россия",
    "searchString": "пирогово россия / удмуртская республика / пирогово"
  },
  "4208": {
    "id": "4208",
    "name": "Селты",
    "path": "Россия / Удмуртская Республика / Селты",
    "country": "Россия",
    "searchString": "селты россия / удмуртская республика / селты"
  },
  "4209": {
    "id": "4209",
    "name": "Сигаево",
    "path": "Россия / Удмуртская Республика / Сигаево",
    "country": "Россия",
    "searchString": "сигаево россия / удмуртская республика / сигаево"
  },
  "4210": {
    "id": "4210",
    "name": "Сюмси",
    "path": "Россия / Удмуртская Республика / Сюмси",
    "country": "Россия",
    "searchString": "сюмси россия / удмуртская республика / сюмси"
  },
  "4211": {
    "id": "4211",
    "name": "Хохряки",
    "path": "Россия / Удмуртская Республика / Хохряки",
    "country": "Россия",
    "searchString": "хохряки россия / удмуртская республика / хохряки"
  },
  "4212": {
    "id": "4212",
    "name": "Шаркан",
    "path": "Россия / Удмуртская Республика / Шаркан",
    "country": "Россия",
    "searchString": "шаркан россия / удмуртская республика / шаркан"
  },
  "4213": {
    "id": "4213",
    "name": "Юкаменское",
    "path": "Россия / Удмуртская Республика / Юкаменское",
    "country": "Россия",
    "searchString": "юкаменское россия / удмуртская республика / юкаменское"
  },
  "4214": {
    "id": "4214",
    "name": "Якшур-Бодья",
    "path": "Россия / Удмуртская Республика / Якшур-Бодья",
    "country": "Россия",
    "searchString": "якшур-бодья россия / удмуртская республика / якшур-бодья"
  },
  "4215": {
    "id": "4215",
    "name": "Яр",
    "path": "Россия / Удмуртская Республика / Яр",
    "country": "Россия",
    "searchString": "яр россия / удмуртская республика / яр"
  },
  "4216": {
    "id": "4216",
    "name": "Аликово",
    "path": "Россия / Чувашская Республика / Аликово",
    "country": "Россия",
    "searchString": "аликово россия / чувашская республика / аликово"
  },
  "4217": {
    "id": "4217",
    "name": "Ибреси",
    "path": "Россия / Чувашская Республика / Ибреси",
    "country": "Россия",
    "searchString": "ибреси россия / чувашская республика / ибреси"
  },
  "4218": {
    "id": "4218",
    "name": "Ишлеи",
    "path": "Россия / Чувашская Республика / Ишлеи",
    "country": "Россия",
    "searchString": "ишлеи россия / чувашская республика / ишлеи"
  },
  "4219": {
    "id": "4219",
    "name": "Красные Четаи",
    "path": "Россия / Чувашская Республика / Красные Четаи",
    "country": "Россия",
    "searchString": "красные четаи россия / чувашская республика / красные четаи"
  },
  "4220": {
    "id": "4220",
    "name": "Новое Атлашево",
    "path": "Россия / Чувашская Республика / Новое Атлашево",
    "country": "Россия",
    "searchString": "новое атлашево россия / чувашская республика / новое атлашево"
  },
  "4221": {
    "id": "4221",
    "name": "Новые Лапсары",
    "path": "Россия / Чувашская Республика / Новые Лапсары",
    "country": "Россия",
    "searchString": "новые лапсары россия / чувашская республика / новые лапсары"
  },
  "4222": {
    "id": "4222",
    "name": "Порецкое",
    "path": "Россия / Чувашская Республика / Порецкое",
    "country": "Россия",
    "searchString": "порецкое россия / чувашская республика / порецкое"
  },
  "4223": {
    "id": "4223",
    "name": "Шемурша",
    "path": "Россия / Чувашская Республика / Шемурша",
    "country": "Россия",
    "searchString": "шемурша россия / чувашская республика / шемурша"
  },
  "4224": {
    "id": "4224",
    "name": "Шихазаны",
    "path": "Россия / Чувашская Республика / Шихазаны",
    "country": "Россия",
    "searchString": "шихазаны россия / чувашская республика / шихазаны"
  },
  "4225": {
    "id": "4225",
    "name": "Шыгырдан",
    "path": "Россия / Чувашская Республика / Шыгырдан",
    "country": "Россия",
    "searchString": "шыгырдан россия / чувашская республика / шыгырдан"
  },
  "4226": {
    "id": "4226",
    "name": "Юськасы",
    "path": "Россия / Чувашская Республика / Юськасы",
    "country": "Россия",
    "searchString": "юськасы россия / чувашская республика / юськасы"
  },
  "4227": {
    "id": "4227",
    "name": "Янтиково",
    "path": "Россия / Чувашская Республика / Янтиково",
    "country": "Россия",
    "searchString": "янтиково россия / чувашская республика / янтиково"
  },
  "4228": {
    "id": "4228",
    "name": "Виловатово",
    "path": "Россия / Республика Марий Эл / Виловатово",
    "country": "Россия",
    "searchString": "виловатово россия / республика марий эл / виловатово"
  },
  "4229": {
    "id": "4229",
    "name": "Знаменский",
    "path": "Россия / Республика Марий Эл / Знаменский",
    "country": "Россия",
    "searchString": "знаменский россия / республика марий эл / знаменский"
  },
  "4230": {
    "id": "4230",
    "name": "Кельмаксола",
    "path": "Россия / Республика Марий Эл / Кельмаксола",
    "country": "Россия",
    "searchString": "кельмаксола россия / республика марий эл / кельмаксола"
  },
  "4231": {
    "id": "4231",
    "name": "Килемары",
    "path": "Россия / Республика Марий Эл / Килемары",
    "country": "Россия",
    "searchString": "килемары россия / республика марий эл / килемары"
  },
  "4232": {
    "id": "4232",
    "name": "Красногорский (Республика Марий Эл)",
    "path": "Россия / Республика Марий Эл / Красногорский (Республика Марий Эл)",
    "country": "Россия",
    "searchString": "красногорский (республика марий эл) россия / республика марий эл / красногорский (республика марий эл)"
  },
  "4233": {
    "id": "4233",
    "name": "Краснооктябрьский",
    "path": "Россия / Республика Марий Эл / Краснооктябрьский",
    "country": "Россия",
    "searchString": "краснооктябрьский россия / республика марий эл / краснооктябрьский"
  },
  "4234": {
    "id": "4234",
    "name": "Куженер",
    "path": "Россия / Республика Марий Эл / Куженер",
    "country": "Россия",
    "searchString": "куженер россия / республика марий эл / куженер"
  },
  "4235": {
    "id": "4235",
    "name": "Мари-Турек",
    "path": "Россия / Республика Марий Эл / Мари-Турек",
    "country": "Россия",
    "searchString": "мари-турек россия / республика марий эл / мари-турек"
  },
  "4236": {
    "id": "4236",
    "name": "Медведево",
    "path": "Россия / Республика Марий Эл / Медведево",
    "country": "Россия",
    "searchString": "медведево россия / республика марий эл / медведево"
  },
  "4237": {
    "id": "4237",
    "name": "Новый Торъял",
    "path": "Россия / Республика Марий Эл / Новый Торъял",
    "country": "Россия",
    "searchString": "новый торъял россия / республика марий эл / новый торъял"
  },
  "4238": {
    "id": "4238",
    "name": "Оршанка",
    "path": "Россия / Республика Марий Эл / Оршанка",
    "country": "Россия",
    "searchString": "оршанка россия / республика марий эл / оршанка"
  },
  "4239": {
    "id": "4239",
    "name": "Параньга",
    "path": "Россия / Республика Марий Эл / Параньга",
    "country": "Россия",
    "searchString": "параньга россия / республика марий эл / параньга"
  },
  "4240": {
    "id": "4240",
    "name": "Приволжский (Республика Марий Эл)",
    "path": "Россия / Республика Марий Эл / Приволжский (Республика Марий Эл)",
    "country": "Россия",
    "searchString": "приволжский (республика марий эл) россия / республика марий эл / приволжский (республика марий эл)"
  },
  "4241": {
    "id": "4241",
    "name": "Сернур",
    "path": "Россия / Республика Марий Эл / Сернур",
    "country": "Россия",
    "searchString": "сернур россия / республика марий эл / сернур"
  },
  "4242": {
    "id": "4242",
    "name": "Советский (Республика Марий Эл)",
    "path": "Россия / Республика Марий Эл / Советский (Республика Марий Эл)",
    "country": "Россия",
    "searchString": "советский (республика марий эл) россия / республика марий эл / советский (республика марий эл)"
  },
  "4243": {
    "id": "4243",
    "name": "Юрино",
    "path": "Россия / Республика Марий Эл / Юрино",
    "country": "Россия",
    "searchString": "юрино россия / республика марий эл / юрино"
  },
  "4244": {
    "id": "4244",
    "name": "Акбулак",
    "path": "Россия / Оренбургская область / Акбулак",
    "country": "Россия",
    "searchString": "акбулак россия / оренбургская область / акбулак"
  },
  "4245": {
    "id": "4245",
    "name": "Адамовка",
    "path": "Россия / Оренбургская область / Адамовка",
    "country": "Россия",
    "searchString": "адамовка россия / оренбургская область / адамовка"
  },
  "4246": {
    "id": "4246",
    "name": "Александровка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Александровка (Оренбургская область)",
    "country": "Россия",
    "searchString": "александровка (оренбургская область) россия / оренбургская область / александровка (оренбургская область)"
  },
  "4247": {
    "id": "4247",
    "name": "Беляевка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Беляевка (Оренбургская область)",
    "country": "Россия",
    "searchString": "беляевка (оренбургская область) россия / оренбургская область / беляевка (оренбургская область)"
  },
  "4248": {
    "id": "4248",
    "name": "Грачевка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Грачевка (Оренбургская область)",
    "country": "Россия",
    "searchString": "грачевка (оренбургская область) россия / оренбургская область / грачевка (оренбургская область)"
  },
  "4249": {
    "id": "4249",
    "name": "Домбаровский",
    "path": "Россия / Оренбургская область / Домбаровский",
    "country": "Россия",
    "searchString": "домбаровский россия / оренбургская область / домбаровский"
  },
  "4250": {
    "id": "4250",
    "name": "Илек",
    "path": "Россия / Оренбургская область / Илек",
    "country": "Россия",
    "searchString": "илек россия / оренбургская область / илек"
  },
  "4251": {
    "id": "4251",
    "name": "Кваркено",
    "path": "Россия / Оренбургская область / Кваркено",
    "country": "Россия",
    "searchString": "кваркено россия / оренбургская область / кваркено"
  },
  "4252": {
    "id": "4252",
    "name": "Большой Исток",
    "path": "Россия / Свердловская область / Большой Исток",
    "country": "Россия",
    "searchString": "большой исток россия / свердловская область / большой исток"
  },
  "4253": {
    "id": "4253",
    "name": "Буланаш",
    "path": "Россия / Свердловская область / Буланаш",
    "country": "Россия",
    "searchString": "буланаш россия / свердловская область / буланаш"
  },
  "4254": {
    "id": "4254",
    "name": "Бутка",
    "path": "Россия / Свердловская область / Бутка",
    "country": "Россия",
    "searchString": "бутка россия / свердловская область / бутка"
  },
  "4255": {
    "id": "4255",
    "name": "Верхнее Дуброво",
    "path": "Россия / Свердловская область / Верхнее Дуброво",
    "country": "Россия",
    "searchString": "верхнее дуброво россия / свердловская область / верхнее дуброво"
  },
  "4256": {
    "id": "4256",
    "name": "Верх-Нейвинский",
    "path": "Россия / Свердловская область / Верх-Нейвинский",
    "country": "Россия",
    "searchString": "верх-нейвинский россия / свердловская область / верх-нейвинский"
  },
  "4257": {
    "id": "4257",
    "name": "Верхние Серги",
    "path": "Россия / Свердловская область / Верхние Серги",
    "country": "Россия",
    "searchString": "верхние серги россия / свердловская область / верхние серги"
  },
  "4258": {
    "id": "4258",
    "name": "Верхняя Синячиха",
    "path": "Россия / Свердловская область / Верхняя Синячиха",
    "country": "Россия",
    "searchString": "верхняя синячиха россия / свердловская область / верхняя синячиха"
  },
  "4259": {
    "id": "4259",
    "name": "Восточный",
    "path": "Россия / Свердловская область / Восточный",
    "country": "Россия",
    "searchString": "восточный россия / свердловская область / восточный"
  },
  "4260": {
    "id": "4260",
    "name": "Горноуральский",
    "path": "Россия / Свердловская область / Горноуральский",
    "country": "Россия",
    "searchString": "горноуральский россия / свердловская область / горноуральский"
  },
  "4261": {
    "id": "4261",
    "name": "Двуреченск",
    "path": "Россия / Свердловская область / Двуреченск",
    "country": "Россия",
    "searchString": "двуреченск россия / свердловская область / двуреченск"
  },
  "4262": {
    "id": "4262",
    "name": "Дружинино",
    "path": "Россия / Свердловская область / Дружинино",
    "country": "Россия",
    "searchString": "дружинино россия / свердловская область / дружинино"
  },
  "4263": {
    "id": "4263",
    "name": "Еланский",
    "path": "Россия / Свердловская область / Еланский",
    "country": "Россия",
    "searchString": "еланский россия / свердловская область / еланский"
  },
  "4264": {
    "id": "4264",
    "name": "Ис",
    "path": "Россия / Свердловская область / Ис",
    "country": "Россия",
    "searchString": "ис россия / свердловская область / ис"
  },
  "4265": {
    "id": "4265",
    "name": "Исеть",
    "path": "Россия / Свердловская область / Исеть",
    "country": "Россия",
    "searchString": "исеть россия / свердловская область / исеть"
  },
  "4266": {
    "id": "4266",
    "name": "Исток",
    "path": "Россия / Свердловская область / Исток",
    "country": "Россия",
    "searchString": "исток россия / свердловская область / исток"
  },
  "4267": {
    "id": "4267",
    "name": "Кузино",
    "path": "Россия / Свердловская область / Кузино",
    "country": "Россия",
    "searchString": "кузино россия / свердловская область / кузино"
  },
  "4268": {
    "id": "4268",
    "name": "Краснохолм",
    "path": "Россия / Оренбургская область / Краснохолм",
    "country": "Россия",
    "searchString": "краснохолм россия / оренбургская область / краснохолм"
  },
  "4269": {
    "id": "4269",
    "name": "Колтубановский",
    "path": "Россия / Оренбургская область / Колтубановский",
    "country": "Россия",
    "searchString": "колтубановский россия / оренбургская область / колтубановский"
  },
  "4270": {
    "id": "4270",
    "name": "Красногвардеец",
    "path": "Россия / Оренбургская область / Красногвардеец",
    "country": "Россия",
    "searchString": "красногвардеец россия / оренбургская область / красногвардеец"
  },
  "4271": {
    "id": "4271",
    "name": "Красноярский",
    "path": "Россия / Оренбургская область / Красноярский",
    "country": "Россия",
    "searchString": "красноярский россия / оренбургская область / красноярский"
  },
  "4272": {
    "id": "4272",
    "name": "Курманаевка",
    "path": "Россия / Оренбургская область / Курманаевка",
    "country": "Россия",
    "searchString": "курманаевка россия / оренбургская область / курманаевка"
  },
  "4273": {
    "id": "4273",
    "name": "Матвеевка",
    "path": "Россия / Оренбургская область / Матвеевка",
    "country": "Россия",
    "searchString": "матвеевка россия / оренбургская область / матвеевка"
  },
  "4274": {
    "id": "4274",
    "name": "Нежинка",
    "path": "Россия / Оренбургская область / Нежинка",
    "country": "Россия",
    "searchString": "нежинка россия / оренбургская область / нежинка"
  },
  "4275": {
    "id": "4275",
    "name": "Новоорск",
    "path": "Россия / Оренбургская область / Новоорск",
    "country": "Россия",
    "searchString": "новоорск россия / оренбургская область / новоорск"
  },
  "4276": {
    "id": "4276",
    "name": "Новосергиевка",
    "path": "Россия / Оренбургская область / Новосергиевка",
    "country": "Россия",
    "searchString": "новосергиевка россия / оренбургская область / новосергиевка"
  },
  "4277": {
    "id": "4277",
    "name": "Октябрьское",
    "path": "Россия / Оренбургская область / Октябрьское",
    "country": "Россия",
    "searchString": "октябрьское россия / оренбургская область / октябрьское"
  },
  "4278": {
    "id": "4278",
    "name": "Первомайский (Оренбургская область)",
    "path": "Россия / Оренбургская область / Первомайский (Оренбургская область)",
    "country": "Россия",
    "searchString": "первомайский (оренбургская область) россия / оренбургская область / первомайский (оренбургская область)"
  },
  "4279": {
    "id": "4279",
    "name": "Переволоцкий",
    "path": "Россия / Оренбургская область / Переволоцкий",
    "country": "Россия",
    "searchString": "переволоцкий россия / оренбургская область / переволоцкий"
  },
  "4280": {
    "id": "4280",
    "name": "Плешаново",
    "path": "Россия / Оренбургская область / Плешаново",
    "country": "Россия",
    "searchString": "плешаново россия / оренбургская область / плешаново"
  },
  "4281": {
    "id": "4281",
    "name": "Подгородняя Покровка",
    "path": "Россия / Оренбургская область / Подгородняя Покровка",
    "country": "Россия",
    "searchString": "подгородняя покровка россия / оренбургская область / подгородняя покровка"
  },
  "4282": {
    "id": "4282",
    "name": "Пономарёвка",
    "path": "Россия / Оренбургская область / Пономарёвка",
    "country": "Россия",
    "searchString": "пономарёвка россия / оренбургская область / пономарёвка"
  },
  "4283": {
    "id": "4283",
    "name": "Пригородный",
    "path": "Россия / Оренбургская область / Пригородный",
    "country": "Россия",
    "searchString": "пригородный россия / оренбургская область / пригородный"
  },
  "4284": {
    "id": "4284",
    "name": "Сакмара",
    "path": "Россия / Оренбургская область / Сакмара",
    "country": "Россия",
    "searchString": "сакмара россия / оренбургская область / сакмара"
  },
  "4285": {
    "id": "4285",
    "name": "Саракташ",
    "path": "Россия / Оренбургская область / Саракташ",
    "country": "Россия",
    "searchString": "саракташ россия / оренбургская область / саракташ"
  },
  "4286": {
    "id": "4286",
    "name": "Светлый (Оренбургская область)",
    "path": "Россия / Оренбургская область / Светлый (Оренбургская область)",
    "country": "Россия",
    "searchString": "светлый (оренбургская область) россия / оренбургская область / светлый (оренбургская область)"
  },
  "4287": {
    "id": "4287",
    "name": "Северное (Оренбургская область)",
    "path": "Россия / Оренбургская область / Северное (Оренбургская область)",
    "country": "Россия",
    "searchString": "северное (оренбургская область) россия / оренбургская область / северное (оренбургская область)"
  },
  "4288": {
    "id": "4288",
    "name": "Татарская Каргала",
    "path": "Россия / Оренбургская область / Татарская Каргала",
    "country": "Россия",
    "searchString": "татарская каргала россия / оренбургская область / татарская каргала"
  },
  "4289": {
    "id": "4289",
    "name": "Ташла",
    "path": "Россия / Оренбургская область / Ташла",
    "country": "Россия",
    "searchString": "ташла россия / оренбургская область / ташла"
  },
  "4290": {
    "id": "4290",
    "name": "Тоцкое",
    "path": "Россия / Оренбургская область / Тоцкое",
    "country": "Россия",
    "searchString": "тоцкое россия / оренбургская область / тоцкое"
  },
  "4291": {
    "id": "4291",
    "name": "Тоцкое Второе",
    "path": "Россия / Оренбургская область / Тоцкое Второе",
    "country": "Россия",
    "searchString": "тоцкое второе россия / оренбургская область / тоцкое второе"
  },
  "4292": {
    "id": "4292",
    "name": "Тюльган",
    "path": "Россия / Оренбургская область / Тюльган",
    "country": "Россия",
    "searchString": "тюльган россия / оренбургская область / тюльган"
  },
  "4293": {
    "id": "4293",
    "name": "Чебеньки",
    "path": "Россия / Оренбургская область / Чебеньки",
    "country": "Россия",
    "searchString": "чебеньки россия / оренбургская область / чебеньки"
  },
  "4294": {
    "id": "4294",
    "name": "Шарлык",
    "path": "Россия / Оренбургская область / Шарлык",
    "country": "Россия",
    "searchString": "шарлык россия / оренбургская область / шарлык"
  },
  "4295": {
    "id": "4295",
    "name": "Энергетик",
    "path": "Россия / Оренбургская область / Энергетик",
    "country": "Россия",
    "searchString": "энергетик россия / оренбургская область / энергетик"
  },
  "4296": {
    "id": "4296",
    "name": "Ясный (Оренбургская область)",
    "path": "Россия / Оренбургская область / Ясный (Оренбургская область)",
    "country": "Россия",
    "searchString": "ясный (оренбургская область) россия / оренбургская область / ясный (оренбургская область)"
  },
  "4297": {
    "id": "4297",
    "name": "Вахрушево (Челябинская область)",
    "path": "Россия / Челябинская область / Вахрушево (Челябинская область)",
    "country": "Россия",
    "searchString": "вахрушево (челябинская область) россия / челябинская область / вахрушево (челябинская область)"
  },
  "4298": {
    "id": "4298",
    "name": "Долгодеревенское",
    "path": "Россия / Челябинская область / Долгодеревенское",
    "country": "Россия",
    "searchString": "долгодеревенское россия / челябинская область / долгодеревенское"
  },
  "4299": {
    "id": "4299",
    "name": "Ключи",
    "path": "Россия / Челябинская область / Ключи",
    "country": "Россия",
    "searchString": "ключи россия / челябинская область / ключи"
  },
  "4300": {
    "id": "4300",
    "name": "Красная Горбатка",
    "path": "Россия / Владимирская область / Красная Горбатка",
    "country": "Россия",
    "searchString": "красная горбатка россия / владимирская область / красная горбатка"
  },
  "4301": {
    "id": "4301",
    "name": "Шишкин Лес (Московская область)",
    "path": "Россия / Московская область / Шишкин Лес (Московская область)",
    "country": "Россия",
    "searchString": "шишкин лес (московская область) россия / московская область / шишкин лес (московская область)"
  },
  "4302": {
    "id": "4302",
    "name": "Коммунарка (Московская область)",
    "path": "Россия / Московская область / Коммунарка (Московская область)",
    "country": "Россия",
    "searchString": "коммунарка (московская область) россия / московская область / коммунарка (московская область)"
  },
  "4303": {
    "id": "4303",
    "name": "Николаевка (Ульяновская область)",
    "path": "Россия / Ульяновская область / Николаевка (Ульяновская область)",
    "country": "Россия",
    "searchString": "николаевка (ульяновская область) россия / ульяновская область / николаевка (ульяновская область)"
  },
  "4304": {
    "id": "4304",
    "name": "Сарканд",
    "path": "Казахстан / Сарканд",
    "country": "Казахстан",
    "searchString": "сарканд казахстан / сарканд"
  },
  "4305": {
    "id": "4305",
    "name": "Красноусольский",
    "path": "Россия / Республика Башкортостан / Красноусольский",
    "country": "Россия",
    "searchString": "красноусольский россия / республика башкортостан / красноусольский"
  },
  "4306": {
    "id": "4306",
    "name": "Большое Село",
    "path": "Россия / Ярославская область / Большое Село",
    "country": "Россия",
    "searchString": "большое село россия / ярославская область / большое село"
  },
  "4307": {
    "id": "4307",
    "name": "Борисоглебский",
    "path": "Россия / Ярославская область / Борисоглебский",
    "country": "Россия",
    "searchString": "борисоглебский россия / ярославская область / борисоглебский"
  },
  "4308": {
    "id": "4308",
    "name": "Брейтово",
    "path": "Россия / Ярославская область / Брейтово",
    "country": "Россия",
    "searchString": "брейтово россия / ярославская область / брейтово"
  },
  "4309": {
    "id": "4309",
    "name": "Константиновский",
    "path": "Россия / Ярославская область / Константиновский",
    "country": "Россия",
    "searchString": "константиновский россия / ярославская область / константиновский"
  },
  "4310": {
    "id": "4310",
    "name": "Нагорный",
    "path": "Россия / Ярославская область / Нагорный",
    "country": "Россия",
    "searchString": "нагорный россия / ярославская область / нагорный"
  },
  "4311": {
    "id": "4311",
    "name": "Некрасовское",
    "path": "Россия / Ярославская область / Некрасовское",
    "country": "Россия",
    "searchString": "некрасовское россия / ярославская область / некрасовское"
  },
  "4312": {
    "id": "4312",
    "name": "Новый Некоуз",
    "path": "Россия / Ярославская область / Новый Некоуз",
    "country": "Россия",
    "searchString": "новый некоуз россия / ярославская область / новый некоуз"
  },
  "4313": {
    "id": "4313",
    "name": "Петровское (Ярославская область)",
    "path": "Россия / Ярославская область / Петровское (Ярославская область)",
    "country": "Россия",
    "searchString": "петровское (ярославская область) россия / ярославская область / петровское (ярославская область)"
  },
  "4314": {
    "id": "4314",
    "name": "Пречистое",
    "path": "Россия / Ярославская область / Пречистое",
    "country": "Россия",
    "searchString": "пречистое россия / ярославская область / пречистое"
  },
  "4315": {
    "id": "4315",
    "name": "Семибратово",
    "path": "Россия / Ярославская область / Семибратово",
    "country": "Россия",
    "searchString": "семибратово россия / ярославская область / семибратово"
  },
  "4316": {
    "id": "4316",
    "name": "Щедрино",
    "path": "Россия / Ярославская область / Щедрино",
    "country": "Россия",
    "searchString": "щедрино россия / ярославская область / щедрино"
  },
  "4317": {
    "id": "4317",
    "name": "Балакирево",
    "path": "Россия / Владимирская область / Балакирево",
    "country": "Россия",
    "searchString": "балакирево россия / владимирская область / балакирево"
  },
  "4318": {
    "id": "4318",
    "name": "Красный Октябрь",
    "path": "Россия / Владимирская область / Красный Октябрь",
    "country": "Россия",
    "searchString": "красный октябрь россия / владимирская область / красный октябрь"
  },
  "4319": {
    "id": "4319",
    "name": "Анненский Мост",
    "path": "Россия / Вологодская область / Анненский Мост",
    "country": "Россия",
    "searchString": "анненский мост россия / вологодская область / анненский мост"
  },
  "4320": {
    "id": "4320",
    "name": "Верховажье",
    "path": "Россия / Вологодская область / Верховажье",
    "country": "Россия",
    "searchString": "верховажье россия / вологодская область / верховажье"
  },
  "4321": {
    "id": "4321",
    "name": "Вожега",
    "path": "Россия / Вологодская область / Вожега",
    "country": "Россия",
    "searchString": "вожега россия / вологодская область / вожега"
  },
  "4322": {
    "id": "4322",
    "name": "Вохтога",
    "path": "Россия / Вологодская область / Вохтога",
    "country": "Россия",
    "searchString": "вохтога россия / вологодская область / вохтога"
  },
  "4323": {
    "id": "4323",
    "name": "Депо",
    "path": "Россия / Вологодская область / Депо",
    "country": "Россия",
    "searchString": "депо россия / вологодская область / депо"
  },
  "4324": {
    "id": "4324",
    "name": "Кадниковский",
    "path": "Россия / Вологодская область / Кадниковский",
    "country": "Россия",
    "searchString": "кадниковский россия / вологодская область / кадниковский"
  },
  "4325": {
    "id": "4325",
    "name": "Климовское",
    "path": "Россия / Вологодская область / Климовское",
    "country": "Россия",
    "searchString": "климовское россия / вологодская область / климовское"
  },
  "4326": {
    "id": "4326",
    "name": "Кубенское",
    "path": "Россия / Вологодская область / Кубенское",
    "country": "Россия",
    "searchString": "кубенское россия / вологодская область / кубенское"
  },
  "4327": {
    "id": "4327",
    "name": "Липин Бор",
    "path": "Россия / Вологодская область / Липин Бор",
    "country": "Россия",
    "searchString": "липин бор россия / вологодская область / липин бор"
  },
  "4328": {
    "id": "4328",
    "name": "Малечкино",
    "path": "Россия / Вологодская область / Малечкино",
    "country": "Россия",
    "searchString": "малечкино россия / вологодская область / малечкино"
  },
  "4329": {
    "id": "4329",
    "name": "Молочное (Вологодская область)",
    "path": "Россия / Вологодская область / Молочное (Вологодская область)",
    "country": "Россия",
    "searchString": "молочное (вологодская область) россия / вологодская область / молочное (вологодская область)"
  },
  "4330": {
    "id": "4330",
    "name": "Новатор",
    "path": "Россия / Вологодская область / Новатор",
    "country": "Россия",
    "searchString": "новатор россия / вологодская область / новатор"
  },
  "4331": {
    "id": "4331",
    "name": "Нюксеница",
    "path": "Россия / Вологодская область / Нюксеница",
    "country": "Россия",
    "searchString": "нюксеница россия / вологодская область / нюксеница"
  },
  "4332": {
    "id": "4332",
    "name": "Сямжа",
    "path": "Россия / Вологодская область / Сямжа",
    "country": "Россия",
    "searchString": "сямжа россия / вологодская область / сямжа"
  },
  "4333": {
    "id": "4333",
    "name": "Верхнеднепровский",
    "path": "Россия / Смоленская область / Верхнеднепровский",
    "country": "Россия",
    "searchString": "верхнеднепровский россия / смоленская область / верхнеднепровский"
  },
  "4334": {
    "id": "4334",
    "name": "Тарногский Городок",
    "path": "Россия / Вологодская область / Тарногский Городок",
    "country": "Россия",
    "searchString": "тарногский городок россия / вологодская область / тарногский городок"
  },
  "4335": {
    "id": "4335",
    "name": "Голынки",
    "path": "Россия / Смоленская область / Голынки",
    "country": "Россия",
    "searchString": "голынки россия / смоленская область / голынки"
  },
  "4336": {
    "id": "4336",
    "name": "Тоншалово",
    "path": "Россия / Вологодская область / Тоншалово",
    "country": "Россия",
    "searchString": "тоншалово россия / вологодская область / тоншалово"
  },
  "4337": {
    "id": "4337",
    "name": "Федотово",
    "path": "Россия / Вологодская область / Федотово",
    "country": "Россия",
    "searchString": "федотово россия / вологодская область / федотово"
  },
  "4338": {
    "id": "4338",
    "name": "Шуйское",
    "path": "Россия / Вологодская область / Шуйское",
    "country": "Россия",
    "searchString": "шуйское россия / вологодская область / шуйское"
  },
  "4339": {
    "id": "4339",
    "name": "Городок",
    "path": "Россия / Смоленская область / Городок",
    "country": "Россия",
    "searchString": "городок россия / смоленская область / городок"
  },
  "4340": {
    "id": "4340",
    "name": "Антропово",
    "path": "Россия / Костромская область / Антропово",
    "country": "Россия",
    "searchString": "антропово россия / костромская область / антропово"
  },
  "4341": {
    "id": "4341",
    "name": "Боговарово",
    "path": "Россия / Костромская область / Боговарово",
    "country": "Россия",
    "searchString": "боговарово россия / костромская область / боговарово"
  },
  "4342": {
    "id": "4342",
    "name": "Гусино",
    "path": "Россия / Смоленская область / Гусино",
    "country": "Россия",
    "searchString": "гусино россия / смоленская область / гусино"
  },
  "4343": {
    "id": "4343",
    "name": "Ветлужский",
    "path": "Россия / Костромская область / Ветлужский",
    "country": "Россия",
    "searchString": "ветлужский россия / костромская область / ветлужский"
  },
  "4344": {
    "id": "4344",
    "name": "Ершичи",
    "path": "Россия / Смоленская область / Ершичи",
    "country": "Россия",
    "searchString": "ершичи россия / смоленская область / ершичи"
  },
  "4345": {
    "id": "4345",
    "name": "Вохма",
    "path": "Россия / Костромская область / Вохма",
    "country": "Россия",
    "searchString": "вохма россия / костромская область / вохма"
  },
  "4346": {
    "id": "4346",
    "name": "Кадый",
    "path": "Россия / Костромская область / Кадый",
    "country": "Россия",
    "searchString": "кадый россия / костромская область / кадый"
  },
  "4347": {
    "id": "4347",
    "name": "Кардымово",
    "path": "Россия / Смоленская область / Кардымово",
    "country": "Россия",
    "searchString": "кардымово россия / смоленская область / кардымово"
  },
  "4348": {
    "id": "4348",
    "name": "Караваево",
    "path": "Россия / Костромская область / Караваево",
    "country": "Россия",
    "searchString": "караваево россия / костромская область / караваево"
  },
  "4349": {
    "id": "4349",
    "name": "Красный",
    "path": "Россия / Смоленская область / Красный",
    "country": "Россия",
    "searchString": "красный россия / смоленская область / красный"
  },
  "4350": {
    "id": "4350",
    "name": "Красное-на-Волге",
    "path": "Россия / Костромская область / Красное-на-Волге",
    "country": "Россия",
    "searchString": "красное-на-волге россия / костромская область / красное-на-волге"
  },
  "4351": {
    "id": "4351",
    "name": "Монастырщина",
    "path": "Россия / Смоленская область / Монастырщина",
    "country": "Россия",
    "searchString": "монастырщина россия / смоленская область / монастырщина"
  },
  "4352": {
    "id": "4352",
    "name": "Никольское (Костромская область)",
    "path": "Россия / Костромская область / Никольское (Костромская область)",
    "country": "Россия",
    "searchString": "никольское (костромская область) россия / костромская область / никольское (костромская область)"
  },
  "4353": {
    "id": "4353",
    "name": "Новодугино",
    "path": "Россия / Смоленская область / Новодугино",
    "country": "Россия",
    "searchString": "новодугино россия / смоленская область / новодугино"
  },
  "4354": {
    "id": "4354",
    "name": "Островское",
    "path": "Россия / Костромская область / Островское",
    "country": "Россия",
    "searchString": "островское россия / костромская область / островское"
  },
  "4355": {
    "id": "4355",
    "name": "Озерный",
    "path": "Россия / Смоленская область / Озерный",
    "country": "Россия",
    "searchString": "озерный россия / смоленская область / озерный"
  },
  "4356": {
    "id": "4356",
    "name": "Павино",
    "path": "Россия / Костромская область / Павино",
    "country": "Россия",
    "searchString": "павино россия / костромская область / павино"
  },
  "4357": {
    "id": "4357",
    "name": "Парфеньево",
    "path": "Россия / Костромская область / Парфеньево",
    "country": "Россия",
    "searchString": "парфеньево россия / костромская область / парфеньево"
  },
  "4358": {
    "id": "4358",
    "name": "Поназырево",
    "path": "Россия / Костромская область / Поназырево",
    "country": "Россия",
    "searchString": "поназырево россия / костромская область / поназырево"
  },
  "4359": {
    "id": "4359",
    "name": "Печерск",
    "path": "Россия / Смоленская область / Печерск",
    "country": "Россия",
    "searchString": "печерск россия / смоленская область / печерск"
  },
  "4360": {
    "id": "4360",
    "name": "Пыщуг",
    "path": "Россия / Костромская область / Пыщуг",
    "country": "Россия",
    "searchString": "пыщуг россия / костромская область / пыщуг"
  },
  "4361": {
    "id": "4361",
    "name": "Судиславль",
    "path": "Россия / Костромская область / Судиславль",
    "country": "Россия",
    "searchString": "судиславль россия / костромская область / судиславль"
  },
  "4362": {
    "id": "4362",
    "name": "Стодолище",
    "path": "Россия / Смоленская область / Стодолище",
    "country": "Россия",
    "searchString": "стодолище россия / смоленская область / стодолище"
  },
  "4363": {
    "id": "4363",
    "name": "Сусанино",
    "path": "Россия / Костромская область / Сусанино",
    "country": "Россия",
    "searchString": "сусанино россия / костромская область / сусанино"
  },
  "4364": {
    "id": "4364",
    "name": "Угра",
    "path": "Россия / Смоленская область / Угра",
    "country": "Россия",
    "searchString": "угра россия / смоленская область / угра"
  },
  "4365": {
    "id": "4365",
    "name": "Чистые Боры",
    "path": "Россия / Костромская область / Чистые Боры",
    "country": "Россия",
    "searchString": "чистые боры россия / костромская область / чистые боры"
  },
  "4366": {
    "id": "4366",
    "name": "Хиславичи",
    "path": "Россия / Смоленская область / Хиславичи",
    "country": "Россия",
    "searchString": "хиславичи россия / смоленская область / хиславичи"
  },
  "4367": {
    "id": "4367",
    "name": "Холм-Жирковский",
    "path": "Россия / Смоленская область / Холм-Жирковский",
    "country": "Россия",
    "searchString": "холм-жирковский россия / смоленская область / холм-жирковский"
  },
  "4368": {
    "id": "4368",
    "name": "Ильинское-Хованское",
    "path": "Россия / Ивановская область / Ильинское-Хованское",
    "country": "Россия",
    "searchString": "ильинское-хованское россия / ивановская область / ильинское-хованское"
  },
  "4369": {
    "id": "4369",
    "name": "Шаталово",
    "path": "Россия / Смоленская область / Шаталово",
    "country": "Россия",
    "searchString": "шаталово россия / смоленская область / шаталово"
  },
  "4370": {
    "id": "4370",
    "name": "Шумячи",
    "path": "Россия / Смоленская область / Шумячи",
    "country": "Россия",
    "searchString": "шумячи россия / смоленская область / шумячи"
  },
  "4371": {
    "id": "4371",
    "name": "Лежнево",
    "path": "Россия / Ивановская область / Лежнево",
    "country": "Россия",
    "searchString": "лежнево россия / ивановская область / лежнево"
  },
  "4372": {
    "id": "4372",
    "name": "Савино",
    "path": "Россия / Ивановская область / Савино",
    "country": "Россия",
    "searchString": "савино россия / ивановская область / савино"
  },
  "4373": {
    "id": "4373",
    "name": "Выползово",
    "path": "Россия / Ивановская область / Выползово",
    "country": "Россия",
    "searchString": "выползово россия / ивановская область / выползово"
  },
  "4374": {
    "id": "4374",
    "name": "Жарковский",
    "path": "Россия / Ивановская область / Жарковский",
    "country": "Россия",
    "searchString": "жарковский россия / ивановская область / жарковский"
  },
  "4375": {
    "id": "4375",
    "name": "Калашниково",
    "path": "Россия / Ивановская область / Калашниково",
    "country": "Россия",
    "searchString": "калашниково россия / ивановская область / калашниково"
  },
  "4376": {
    "id": "4376",
    "name": "Лесное",
    "path": "Россия / Ивановская область / Лесное",
    "country": "Россия",
    "searchString": "лесное россия / ивановская область / лесное"
  },
  "4377": {
    "id": "4377",
    "name": "Медное",
    "path": "Россия / Ивановская область / Медное",
    "country": "Россия",
    "searchString": "медное россия / ивановская область / медное"
  },
  "4378": {
    "id": "4378",
    "name": "Оленино",
    "path": "Россия / Ивановская область / Оленино",
    "country": "Россия",
    "searchString": "оленино россия / ивановская область / оленино"
  },
  "4379": {
    "id": "4379",
    "name": "Пено",
    "path": "Россия / Тверская область / Пено",
    "country": "Россия",
    "searchString": "пено россия / тверская область / пено"
  },
  "4380": {
    "id": "4380",
    "name": "Редкино",
    "path": "Россия / Ивановская область / Редкино",
    "country": "Россия",
    "searchString": "редкино россия / ивановская область / редкино"
  },
  "4381": {
    "id": "4381",
    "name": "Селижарово",
    "path": "Россия / Тверская область / Селижарово",
    "country": "Россия",
    "searchString": "селижарово россия / тверская область / селижарово"
  },
  "4382": {
    "id": "4382",
    "name": "Спирово (Ивановская область)",
    "path": "Россия / Ивановская область / Спирово (Ивановская область)",
    "country": "Россия",
    "searchString": "спирово (ивановская область) россия / ивановская область / спирово (ивановская область)"
  },
  "4383": {
    "id": "4383",
    "name": "Ардатов (Нижегородская область)",
    "path": "Россия / Нижегородская область / Ардатов (Нижегородская область)",
    "country": "Россия",
    "searchString": "ардатов (нижегородская область) россия / нижегородская область / ардатов (нижегородская область)"
  },
  "4384": {
    "id": "4384",
    "name": "Арья",
    "path": "Россия / Нижегородская область / Арья",
    "country": "Россия",
    "searchString": "арья россия / нижегородская область / арья"
  },
  "4385": {
    "id": "4385",
    "name": "Афанасьево",
    "path": "Россия / Нижегородская область / Афанасьево",
    "country": "Россия",
    "searchString": "афанасьево россия / нижегородская область / афанасьево"
  },
  "4386": {
    "id": "4386",
    "name": "Афонино",
    "path": "Россия / Нижегородская область / Афонино",
    "country": "Россия",
    "searchString": "афонино россия / нижегородская область / афонино"
  },
  "4387": {
    "id": "4387",
    "name": "Большое Козино",
    "path": "Россия / Нижегородская область / Большое Козино",
    "country": "Россия",
    "searchString": "большое козино россия / нижегородская область / большое козино"
  },
  "4388": {
    "id": "4388",
    "name": "Большое Мурашкино",
    "path": "Россия / Нижегородская область / Большое Мурашкино",
    "country": "Россия",
    "searchString": "большое мурашкино россия / нижегородская область / большое мурашкино"
  },
  "4389": {
    "id": "4389",
    "name": "Буревестник",
    "path": "Россия / Нижегородская область / Буревестник",
    "country": "Россия",
    "searchString": "буревестник россия / нижегородская область / буревестник"
  },
  "4390": {
    "id": "4390",
    "name": "Бутурлино",
    "path": "Россия / Нижегородская область / Бутурлино",
    "country": "Россия",
    "searchString": "бутурлино россия / нижегородская область / бутурлино"
  },
  "4391": {
    "id": "4391",
    "name": "Вад",
    "path": "Россия / Нижегородская область / Вад",
    "country": "Россия",
    "searchString": "вад россия / нижегородская область / вад"
  },
  "4392": {
    "id": "4392",
    "name": "Варнавино",
    "path": "Россия / Нижегородская область / Варнавино",
    "country": "Россия",
    "searchString": "варнавино россия / нижегородская область / варнавино"
  },
  "4393": {
    "id": "4393",
    "name": "Вахтан",
    "path": "Россия / Нижегородская область / Вахтан",
    "country": "Россия",
    "searchString": "вахтан россия / нижегородская область / вахтан"
  },
  "4394": {
    "id": "4394",
    "name": "Вача",
    "path": "Россия / Нижегородская область / Вача",
    "country": "Россия",
    "searchString": "вача россия / нижегородская область / вача"
  },
  "4395": {
    "id": "4395",
    "name": "Виля",
    "path": "Россия / Нижегородская область / Виля",
    "country": "Россия",
    "searchString": "виля россия / нижегородская область / виля"
  },
  "4396": {
    "id": "4396",
    "name": "Воскресенское",
    "path": "Россия / Нижегородская область / Воскресенское",
    "country": "Россия",
    "searchString": "воскресенское россия / нижегородская область / воскресенское"
  },
  "4397": {
    "id": "4397",
    "name": "Выездное",
    "path": "Россия / Нижегородская область / Выездное",
    "country": "Россия",
    "searchString": "выездное россия / нижегородская область / выездное"
  },
  "4398": {
    "id": "4398",
    "name": "Гагино",
    "path": "Россия / Нижегородская область / Гагино",
    "country": "Россия",
    "searchString": "гагино россия / нижегородская область / гагино"
  },
  "4399": {
    "id": "4399",
    "name": "Гидроторф",
    "path": "Россия / Нижегородская область / Гидроторф",
    "country": "Россия",
    "searchString": "гидроторф россия / нижегородская область / гидроторф"
  },
  "4400": {
    "id": "4400",
    "name": "Горбатовка",
    "path": "Россия / Нижегородская область / Горбатовка",
    "country": "Россия",
    "searchString": "горбатовка россия / нижегородская область / горбатовка"
  },
  "4401": {
    "id": "4401",
    "name": "Гремячево",
    "path": "Россия / Нижегородская область / Гремячево",
    "country": "Россия",
    "searchString": "гремячево россия / нижегородская область / гремячево"
  },
  "4402": {
    "id": "4402",
    "name": "Дальнее Константиново",
    "path": "Россия / Нижегородская область / Дальнее Константиново",
    "country": "Россия",
    "searchString": "дальнее константиново россия / нижегородская область / дальнее константиново"
  },
  "4403": {
    "id": "4403",
    "name": "Досчатое",
    "path": "Россия / Нижегородская область / Досчатое",
    "country": "Россия",
    "searchString": "досчатое россия / нижегородская область / досчатое"
  },
  "4404": {
    "id": "4404",
    "name": "Дружба (Нижегородская область)",
    "path": "Россия / Нижегородская область / Дружба (Нижегородская область)",
    "country": "Россия",
    "searchString": "дружба (нижегородская область) россия / нижегородская область / дружба (нижегородская область)"
  },
  "4405": {
    "id": "4405",
    "name": "Ждановский",
    "path": "Россия / Нижегородская область / Ждановский",
    "country": "Россия",
    "searchString": "ждановский россия / нижегородская область / ждановский"
  },
  "4406": {
    "id": "4406",
    "name": "Ильиногорск",
    "path": "Россия / Нижегородская область / Ильиногорск",
    "country": "Россия",
    "searchString": "ильиногорск россия / нижегородская область / ильиногорск"
  },
  "4407": {
    "id": "4407",
    "name": "Ковернино",
    "path": "Россия / Нижегородская область / Ковернино",
    "country": "Россия",
    "searchString": "ковернино россия / нижегородская область / ковернино"
  },
  "4408": {
    "id": "4408",
    "name": "Красные Баки",
    "path": "Россия / Нижегородская область / Красные Баки",
    "country": "Россия",
    "searchString": "красные баки россия / нижегородская область / красные баки"
  },
  "4409": {
    "id": "4409",
    "name": "Линда",
    "path": "Россия / Нижегородская область / Линда",
    "country": "Россия",
    "searchString": "линда россия / нижегородская область / линда"
  },
  "4410": {
    "id": "4410",
    "name": "Лукино",
    "path": "Россия / Нижегородская область / Лукино",
    "country": "Россия",
    "searchString": "лукино россия / нижегородская область / лукино"
  },
  "4411": {
    "id": "4411",
    "name": "Мулино",
    "path": "Россия / Нижегородская область / Мулино",
    "country": "Россия",
    "searchString": "мулино россия / нижегородская область / мулино"
  },
  "4412": {
    "id": "4412",
    "name": "Мухтолово",
    "path": "Россия / Нижегородская область / Мухтолово",
    "country": "Россия",
    "searchString": "мухтолово россия / нижегородская область / мухтолово"
  },
  "4413": {
    "id": "4413",
    "name": "Новосмолинский",
    "path": "Россия / Нижегородская область / Новосмолинский",
    "country": "Россия",
    "searchString": "новосмолинский россия / нижегородская область / новосмолинский"
  },
  "4414": {
    "id": "4414",
    "name": "посёлок Память Парижской Коммуны",
    "path": "Россия / Нижегородская область / посёлок Память Парижской Коммуны",
    "country": "Россия",
    "searchString": "посёлок память парижской коммуны россия / нижегородская область / посёлок память парижской коммуны"
  },
  "4415": {
    "id": "4415",
    "name": "Пижма",
    "path": "Россия / Нижегородская область / Пижма",
    "country": "Россия",
    "searchString": "пижма россия / нижегородская область / пижма"
  },
  "4416": {
    "id": "4416",
    "name": "Пильна",
    "path": "Россия / Нижегородская область / Пильна",
    "country": "Россия",
    "searchString": "пильна россия / нижегородская область / пильна"
  },
  "4417": {
    "id": "4417",
    "name": "Починки  ( Нижегородская область)",
    "path": "Россия / Нижегородская область / Починки  ( Нижегородская область)",
    "country": "Россия",
    "searchString": "починки  ( нижегородская область) россия / нижегородская область / починки  ( нижегородская область)"
  },
  "4418": {
    "id": "4418",
    "name": "Решетиха",
    "path": "Россия / Нижегородская область / Решетиха",
    "country": "Россия",
    "searchString": "решетиха россия / нижегородская область / решетиха"
  },
  "4419": {
    "id": "4419",
    "name": "Саваслейка",
    "path": "Россия / Нижегородская область / Саваслейка",
    "country": "Россия",
    "searchString": "саваслейка россия / нижегородская область / саваслейка"
  },
  "4420": {
    "id": "4420",
    "name": "Сатис",
    "path": "Россия / Нижегородская область / Сатис",
    "country": "Россия",
    "searchString": "сатис россия / нижегородская область / сатис"
  },
  "4421": {
    "id": "4421",
    "name": "Сеченово",
    "path": "Россия / Нижегородская область / Сеченово",
    "country": "Россия",
    "searchString": "сеченово россия / нижегородская область / сеченово"
  },
  "4422": {
    "id": "4422",
    "name": "Сокольское",
    "path": "Россия / Нижегородская область / Сокольское",
    "country": "Россия",
    "searchString": "сокольское россия / нижегородская область / сокольское"
  },
  "4423": {
    "id": "4423",
    "name": "Сосновское",
    "path": "Россия / Нижегородская область / Сосновское",
    "country": "Россия",
    "searchString": "сосновское россия / нижегородская область / сосновское"
  },
  "4424": {
    "id": "4424",
    "name": "Спасское",
    "path": "Россия / Нижегородская область / Спасское",
    "country": "Россия",
    "searchString": "спасское россия / нижегородская область / спасское"
  },
  "4425": {
    "id": "4425",
    "name": "поселок Степана Разина",
    "path": "Россия / Нижегородская область / поселок Степана Разина",
    "country": "Россия",
    "searchString": "поселок степана разина россия / нижегородская область / поселок степана разина"
  },
  "4426": {
    "id": "4426",
    "name": "Суроватиха",
    "path": "Россия / Нижегородская область / Суроватиха",
    "country": "Россия",
    "searchString": "суроватиха россия / нижегородская область / суроватиха"
  },
  "4427": {
    "id": "4427",
    "name": "Сухобезводное",
    "path": "Россия / Нижегородская область / Сухобезводное",
    "country": "Россия",
    "searchString": "сухобезводное россия / нижегородская область / сухобезводное"
  },
  "4428": {
    "id": "4428",
    "name": "Сява",
    "path": "Россия / Нижегородская область / Сява",
    "country": "Россия",
    "searchString": "сява россия / нижегородская область / сява"
  },
  "4429": {
    "id": "4429",
    "name": "Тонкино",
    "path": "Россия / Нижегородская область / Тонкино",
    "country": "Россия",
    "searchString": "тонкино россия / нижегородская область / тонкино"
  },
  "4430": {
    "id": "4430",
    "name": "Тоншаево",
    "path": "Россия / Нижегородская область / Тоншаево",
    "country": "Россия",
    "searchString": "тоншаево россия / нижегородская область / тоншаево"
  },
  "4431": {
    "id": "4431",
    "name": "Тумботино",
    "path": "Россия / Нижегородская область / Тумботино",
    "country": "Россия",
    "searchString": "тумботино россия / нижегородская область / тумботино"
  },
  "4432": {
    "id": "4432",
    "name": "Центральный",
    "path": "Россия / Нижегородская область / Центральный",
    "country": "Россия",
    "searchString": "центральный россия / нижегородская область / центральный"
  },
  "4433": {
    "id": "4433",
    "name": "Чернуха",
    "path": "Россия / Нижегородская область / Чернуха",
    "country": "Россия",
    "searchString": "чернуха россия / нижегородская область / чернуха"
  },
  "4434": {
    "id": "4434",
    "name": "Шаранга",
    "path": "Россия / Нижегородская область / Шаранга",
    "country": "Россия",
    "searchString": "шаранга россия / нижегородская область / шаранга"
  },
  "4435": {
    "id": "4435",
    "name": "Шатки",
    "path": "Россия / Нижегородская область / Шатки",
    "country": "Россия",
    "searchString": "шатки россия / нижегородская область / шатки"
  },
  "4436": {
    "id": "4436",
    "name": "Шиморское",
    "path": "Россия / Нижегородская область / Шиморское",
    "country": "Россия",
    "searchString": "шиморское россия / нижегородская область / шиморское"
  },
  "4437": {
    "id": "4437",
    "name": "Юганец",
    "path": "Россия / Нижегородская область / Юганец",
    "country": "Россия",
    "searchString": "юганец россия / нижегородская область / юганец"
  },
  "4438": {
    "id": "4438",
    "name": "Арбаж",
    "path": "Россия / Кировская область / Арбаж",
    "country": "Россия",
    "searchString": "арбаж россия / кировская область / арбаж"
  },
  "4439": {
    "id": "4439",
    "name": "Афанасьево (Кировская область)",
    "path": "Россия / Кировская область / Афанасьево (Кировская область)",
    "country": "Россия",
    "searchString": "афанасьево (кировская область) россия / кировская область / афанасьево (кировская область)"
  },
  "4440": {
    "id": "4440",
    "name": "Богородское",
    "path": "Россия / Кировская область / Богородское",
    "country": "Россия",
    "searchString": "богородское россия / кировская область / богородское"
  },
  "4441": {
    "id": "4441",
    "name": "Вахруши",
    "path": "Россия / Кировская область / Вахруши",
    "country": "Россия",
    "searchString": "вахруши россия / кировская область / вахруши"
  },
  "4442": {
    "id": "4442",
    "name": "Верхошижемье",
    "path": "Россия / Кировская область / Верхошижемье",
    "country": "Россия",
    "searchString": "верхошижемье россия / кировская область / верхошижемье"
  },
  "4443": {
    "id": "4443",
    "name": "Восточный (Кировская область)",
    "path": "Россия / Кировская область / Восточный (Кировская область)",
    "country": "Россия",
    "searchString": "восточный (кировская область) россия / кировская область / восточный (кировская область)"
  },
  "4444": {
    "id": "4444",
    "name": "Даровской",
    "path": "Россия / Кировская область / Даровской",
    "country": "Россия",
    "searchString": "даровской россия / кировская область / даровской"
  },
  "4445": {
    "id": "4445",
    "name": "Демьяново",
    "path": "Россия / Кировская область / Демьяново",
    "country": "Россия",
    "searchString": "демьяново россия / кировская область / демьяново"
  },
  "4446": {
    "id": "4446",
    "name": "Кикнур",
    "path": "Россия / Кировская область / Кикнур",
    "country": "Россия",
    "searchString": "кикнур россия / кировская область / кикнур"
  },
  "4447": {
    "id": "4447",
    "name": "Кильмезь (Кировская область)",
    "path": "Россия / Кировская область / Кильмезь (Кировская область)",
    "country": "Россия",
    "searchString": "кильмезь (кировская область) россия / кировская область / кильмезь (кировская область)"
  },
  "4448": {
    "id": "4448",
    "name": "Красная Поляна (Кировская область)",
    "path": "Россия / Кировская область / Красная Поляна (Кировская область)",
    "country": "Россия",
    "searchString": "красная поляна (кировская область) россия / кировская область / красная поляна (кировская область)"
  },
  "4449": {
    "id": "4449",
    "name": "Кумены",
    "path": "Россия / Кировская область / Кумены",
    "country": "Россия",
    "searchString": "кумены россия / кировская область / кумены"
  },
  "4450": {
    "id": "4450",
    "name": "Лальск",
    "path": "Россия / Кировская область / Лальск",
    "country": "Россия",
    "searchString": "лальск россия / кировская область / лальск"
  },
  "4451": {
    "id": "4451",
    "name": "Лебяжье (Кировская область)",
    "path": "Россия / Кировская область / Лебяжье (Кировская область)",
    "country": "Россия",
    "searchString": "лебяжье (кировская область) россия / кировская область / лебяжье (кировская область)"
  },
  "4452": {
    "id": "4452",
    "name": "Ленинское",
    "path": "Россия / Кировская область / Ленинское",
    "country": "Россия",
    "searchString": "ленинское россия / кировская область / ленинское"
  },
  "4453": {
    "id": "4453",
    "name": "Лесной (Кировская область)",
    "path": "Россия / Кировская область / Лесной (Кировская область)",
    "country": "Россия",
    "searchString": "лесной (кировская область) россия / кировская область / лесной (кировская область)"
  },
  "4454": {
    "id": "4454",
    "name": "Лойно",
    "path": "Россия / Кировская область / Лойно",
    "country": "Россия",
    "searchString": "лойно россия / кировская область / лойно"
  },
  "4455": {
    "id": "4455",
    "name": "Мирный (Кировская область)",
    "path": "Россия / Кировская область / Мирный (Кировская область)",
    "country": "Россия",
    "searchString": "мирный (кировская область) россия / кировская область / мирный (кировская область)"
  },
  "4456": {
    "id": "4456",
    "name": "Мурыгино",
    "path": "Россия / Кировская область / Мурыгино",
    "country": "Россия",
    "searchString": "мурыгино россия / кировская область / мурыгино"
  },
  "4457": {
    "id": "4457",
    "name": "Нагорск",
    "path": "Россия / Кировская область / Нагорск",
    "country": "Россия",
    "searchString": "нагорск россия / кировская область / нагорск"
  },
  "4458": {
    "id": "4458",
    "name": "Нема",
    "path": "Россия / Кировская область / Нема",
    "country": "Россия",
    "searchString": "нема россия / кировская область / нема"
  },
  "4459": {
    "id": "4459",
    "name": "Опарино",
    "path": "Россия / Кировская область / Опарино",
    "country": "Россия",
    "searchString": "опарино россия / кировская область / опарино"
  },
  "4460": {
    "id": "4460",
    "name": "Первомайский (Кировская область)",
    "path": "Россия / Кировская область / Первомайский (Кировская область)",
    "country": "Россия",
    "searchString": "первомайский (кировская область) россия / кировская область / первомайский (кировская область)"
  },
  "4461": {
    "id": "4461",
    "name": "Песковка",
    "path": "Россия / Кировская область / Песковка",
    "country": "Россия",
    "searchString": "песковка россия / кировская область / песковка"
  },
  "4462": {
    "id": "4462",
    "name": "Пижанка",
    "path": "Россия / Кировская область / Пижанка",
    "country": "Россия",
    "searchString": "пижанка россия / кировская область / пижанка"
  },
  "4463": {
    "id": "4463",
    "name": "Подосиновец",
    "path": "Россия / Кировская область / Подосиновец",
    "country": "Россия",
    "searchString": "подосиновец россия / кировская область / подосиновец"
  },
  "4464": {
    "id": "4464",
    "name": "Рудничный",
    "path": "Россия / Кировская область / Рудничный",
    "country": "Россия",
    "searchString": "рудничный россия / кировская область / рудничный"
  },
  "4465": {
    "id": "4465",
    "name": "Санчурск",
    "path": "Россия / Кировская область / Санчурск",
    "country": "Россия",
    "searchString": "санчурск россия / кировская область / санчурск"
  },
  "4466": {
    "id": "4466",
    "name": "Светлополянск",
    "path": "Россия / Кировская область / Светлополянск",
    "country": "Россия",
    "searchString": "светлополянск россия / кировская область / светлополянск"
  },
  "4467": {
    "id": "4467",
    "name": "Свеча",
    "path": "Россия / Кировская область / Свеча",
    "country": "Россия",
    "searchString": "свеча россия / кировская область / свеча"
  },
  "4468": {
    "id": "4468",
    "name": "Стрижи",
    "path": "Россия / Кировская область / Стрижи",
    "country": "Россия",
    "searchString": "стрижи россия / кировская область / стрижи"
  },
  "4469": {
    "id": "4469",
    "name": "Тужа",
    "path": "Россия / Кировская область / Тужа",
    "country": "Россия",
    "searchString": "тужа россия / кировская область / тужа"
  },
  "4470": {
    "id": "4470",
    "name": "Уни",
    "path": "Россия / Кировская область / Уни",
    "country": "Россия",
    "searchString": "уни россия / кировская область / уни"
  },
  "4471": {
    "id": "4471",
    "name": "Александро-Невский",
    "path": "Россия / Рязанская область / Александро-Невский",
    "country": "Россия",
    "searchString": "александро-невский россия / рязанская область / александро-невский"
  },
  "4472": {
    "id": "4472",
    "name": "Елатьма",
    "path": "Россия / Рязанская область / Елатьма",
    "country": "Россия",
    "searchString": "елатьма россия / рязанская область / елатьма"
  },
  "4473": {
    "id": "4473",
    "name": "Ермишь",
    "path": "Россия / Рязанская область / Ермишь",
    "country": "Россия",
    "searchString": "ермишь россия / рязанская область / ермишь"
  },
  "4474": {
    "id": "4474",
    "name": "Захарово",
    "path": "Россия / Рязанская область / Захарово",
    "country": "Россия",
    "searchString": "захарово россия / рязанская область / захарово"
  },
  "4475": {
    "id": "4475",
    "name": "Ижевское",
    "path": "Россия / Рязанская область / Ижевское",
    "country": "Россия",
    "searchString": "ижевское россия / рязанская область / ижевское"
  },
  "4476": {
    "id": "4476",
    "name": "Кадом",
    "path": "Россия / Рязанская область / Кадом",
    "country": "Россия",
    "searchString": "кадом россия / рязанская область / кадом"
  },
  "4477": {
    "id": "4477",
    "name": "Лесной (Рязанская область)",
    "path": "Россия / Рязанская область / Лесной (Рязанская область)",
    "country": "Россия",
    "searchString": "лесной (рязанская область) россия / рязанская область / лесной (рязанская область)"
  },
  "4478": {
    "id": "4478",
    "name": "Милославское",
    "path": "Россия / Рязанская область / Милославское",
    "country": "Россия",
    "searchString": "милославское россия / рязанская область / милославское"
  },
  "4479": {
    "id": "4479",
    "name": "Мурмино",
    "path": "Россия / Рязанская область / Мурмино",
    "country": "Россия",
    "searchString": "мурмино россия / рязанская область / мурмино"
  },
  "4480": {
    "id": "4480",
    "name": "Октябрьский (Рязанская область)",
    "path": "Россия / Рязанская область / Октябрьский (Рязанская область)",
    "country": "Россия",
    "searchString": "октябрьский (рязанская область) россия / рязанская область / октябрьский (рязанская область)"
  },
  "4481": {
    "id": "4481",
    "name": "Поляны",
    "path": "Россия / Рязанская область / Поляны",
    "country": "Россия",
    "searchString": "поляны россия / рязанская область / поляны"
  },
  "4482": {
    "id": "4482",
    "name": "Пронск",
    "path": "Россия / Рязанская область / Пронск",
    "country": "Россия",
    "searchString": "пронск россия / рязанская область / пронск"
  },
  "4483": {
    "id": "4483",
    "name": "Путятино",
    "path": "Россия / Рязанская область / Путятино",
    "country": "Россия",
    "searchString": "путятино россия / рязанская область / путятино"
  },
  "4484": {
    "id": "4484",
    "name": "Сапожок",
    "path": "Россия / Рязанская область / Сапожок",
    "country": "Россия",
    "searchString": "сапожок россия / рязанская область / сапожок"
  },
  "4485": {
    "id": "4485",
    "name": "Сараи",
    "path": "Россия / Рязанская область / Сараи",
    "country": "Россия",
    "searchString": "сараи россия / рязанская область / сараи"
  },
  "4486": {
    "id": "4486",
    "name": "Старожилово",
    "path": "Россия / Рязанская область / Старожилово",
    "country": "Россия",
    "searchString": "старожилово россия / рязанская область / старожилово"
  },
  "4487": {
    "id": "4487",
    "name": "Тума",
    "path": "Россия / Рязанская область / Тума",
    "country": "Россия",
    "searchString": "тума россия / рязанская область / тума"
  },
  "4488": {
    "id": "4488",
    "name": "Ухолово",
    "path": "Россия / Рязанская область / Ухолово",
    "country": "Россия",
    "searchString": "ухолово россия / рязанская область / ухолово"
  },
  "4489": {
    "id": "4489",
    "name": "Ухолово (Рязанская область)",
    "path": "Россия / Рязанская область / Ухолово (Рязанская область)",
    "country": "Россия",
    "searchString": "ухолово (рязанская область) россия / рязанская область / ухолово (рязанская область)"
  },
  "4490": {
    "id": "4490",
    "name": "Чучково",
    "path": "Россия / Рязанская область / Чучково",
    "country": "Россия",
    "searchString": "чучково россия / рязанская область / чучково"
  },
  "4491": {
    "id": "4491",
    "name": "Кордай",
    "path": "Казахстан / Кордай",
    "country": "Казахстан",
    "searchString": "кордай казахстан / кордай"
  },
  "4492": {
    "id": "4492",
    "name": "Александровка (Ростовская область)",
    "path": "Россия / Ростовская область / Александровка (Ростовская область)",
    "country": "Россия",
    "searchString": "александровка (ростовская область) россия / ростовская область / александровка (ростовская область)"
  },
  "4493": {
    "id": "4493",
    "name": "Арпачин",
    "path": "Россия / Ростовская область / Арпачин",
    "country": "Россия",
    "searchString": "арпачин россия / ростовская область / арпачин"
  },
  "4494": {
    "id": "4494",
    "name": "Багаевская",
    "path": "Россия / Ростовская область / Багаевская",
    "country": "Россия",
    "searchString": "багаевская россия / ростовская область / багаевская"
  },
  "4495": {
    "id": "4495",
    "name": "Боковская",
    "path": "Россия / Ростовская область / Боковская",
    "country": "Россия",
    "searchString": "боковская россия / ростовская область / боковская"
  },
  "4496": {
    "id": "4496",
    "name": "Большая Мартыновка",
    "path": "Россия / Ростовская область / Большая Мартыновка",
    "country": "Россия",
    "searchString": "большая мартыновка россия / ростовская область / большая мартыновка"
  },
  "4497": {
    "id": "4497",
    "name": "Большая Орловка",
    "path": "Россия / Ростовская область / Большая Орловка",
    "country": "Россия",
    "searchString": "большая орловка россия / ростовская область / большая орловка"
  },
  "4498": {
    "id": "4498",
    "name": "Большие Салы",
    "path": "Россия / Ростовская область / Большие Салы",
    "country": "Россия",
    "searchString": "большие салы россия / ростовская область / большие салы"
  },
  "4499": {
    "id": "4499",
    "name": "Большой Лог",
    "path": "Россия / Ростовская область / Большой Лог",
    "country": "Россия",
    "searchString": "большой лог россия / ростовская область / большой лог"
  },
  "4500": {
    "id": "4500",
    "name": "Быстрогорский",
    "path": "Россия / Ростовская область / Быстрогорский",
    "country": "Россия",
    "searchString": "быстрогорский россия / ростовская область / быстрогорский"
  },
  "4501": {
    "id": "4501",
    "name": "Веселый",
    "path": "Россия / Ростовская область / Веселый",
    "country": "Россия",
    "searchString": "веселый россия / ростовская область / веселый"
  },
  "4502": {
    "id": "4502",
    "name": "Вешенская",
    "path": "Россия / Ростовская область / Вешенская",
    "country": "Россия",
    "searchString": "вешенская россия / ростовская область / вешенская"
  },
  "4503": {
    "id": "4503",
    "name": "Гигант",
    "path": "Россия / Ростовская область / Гигант",
    "country": "Россия",
    "searchString": "гигант россия / ростовская область / гигант"
  },
  "4504": {
    "id": "4504",
    "name": "Глубокий",
    "path": "Россия / Ростовская область / Глубокий",
    "country": "Россия",
    "searchString": "глубокий россия / ростовская область / глубокий"
  },
  "4505": {
    "id": "4505",
    "name": "Горняцкий",
    "path": "Россия / Ростовская область / Горняцкий",
    "country": "Россия",
    "searchString": "горняцкий россия / ростовская область / горняцкий"
  },
  "4506": {
    "id": "4506",
    "name": "Грушевская",
    "path": "Россия / Ростовская область / Грушевская",
    "country": "Россия",
    "searchString": "грушевская россия / ростовская область / грушевская"
  },
  "4507": {
    "id": "4507",
    "name": "Дубовское",
    "path": "Россия / Ростовская область / Дубовское",
    "country": "Россия",
    "searchString": "дубовское россия / ростовская область / дубовское"
  },
  "4508": {
    "id": "4508",
    "name": "Елкин",
    "path": "Россия / Ростовская область / Елкин",
    "country": "Россия",
    "searchString": "елкин россия / ростовская область / елкин"
  },
  "4509": {
    "id": "4509",
    "name": "Жирнов",
    "path": "Россия / Ростовская область / Жирнов",
    "country": "Россия",
    "searchString": "жирнов россия / ростовская область / жирнов"
  },
  "4510": {
    "id": "4510",
    "name": "Заветное",
    "path": "Россия / Ростовская область / Заветное",
    "country": "Россия",
    "searchString": "заветное россия / ростовская область / заветное"
  },
  "4511": {
    "id": "4511",
    "name": "Зимовники",
    "path": "Россия / Ростовская область / Зимовники",
    "country": "Россия",
    "searchString": "зимовники россия / ростовская область / зимовники"
  },
  "4512": {
    "id": "4512",
    "name": "Кагальник",
    "path": "Россия / Ростовская область / Кагальник",
    "country": "Россия",
    "searchString": "кагальник россия / ростовская область / кагальник"
  },
  "4513": {
    "id": "4513",
    "name": "Казанская (Ростовская область)",
    "path": "Россия / Ростовская область / Казанская (Ростовская область)",
    "country": "Россия",
    "searchString": "казанская (ростовская область) россия / ростовская область / казанская (ростовская область)"
  },
  "4514": {
    "id": "4514",
    "name": "Калинин",
    "path": "Россия / Ростовская область / Калинин",
    "country": "Россия",
    "searchString": "калинин россия / ростовская область / калинин"
  },
  "4515": {
    "id": "4515",
    "name": "Каменоломни",
    "path": "Россия / Ростовская область / Каменоломни",
    "country": "Россия",
    "searchString": "каменоломни россия / ростовская область / каменоломни"
  },
  "4516": {
    "id": "4516",
    "name": "Кашары",
    "path": "Россия / Ростовская область / Кашары",
    "country": "Россия",
    "searchString": "кашары россия / ростовская область / кашары"
  },
  "4517": {
    "id": "4517",
    "name": "Кировская",
    "path": "Россия / Ростовская область / Кировская",
    "country": "Россия",
    "searchString": "кировская россия / ростовская область / кировская"
  },
  "4518": {
    "id": "4518",
    "name": "Коксовый",
    "path": "Россия / Ростовская область / Коксовый",
    "country": "Россия",
    "searchString": "коксовый россия / ростовская область / коксовый"
  },
  "4519": {
    "id": "4519",
    "name": "Красная Поляна (Ростовская область)",
    "path": "Россия / Ростовская область / Красная Поляна (Ростовская область)",
    "country": "Россия",
    "searchString": "красная поляна (ростовская область) россия / ростовская область / красная поляна (ростовская область)"
  },
  "4520": {
    "id": "4520",
    "name": "Красноармейский",
    "path": "Россия / Ростовская область / Красноармейский",
    "country": "Россия",
    "searchString": "красноармейский россия / ростовская область / красноармейский"
  },
  "4521": {
    "id": "4521",
    "name": "Красновка",
    "path": "Россия / Ростовская область / Красновка",
    "country": "Россия",
    "searchString": "красновка россия / ростовская область / красновка"
  },
  "4522": {
    "id": "4522",
    "name": "Красюковская",
    "path": "Россия / Ростовская область / Красюковская",
    "country": "Россия",
    "searchString": "красюковская россия / ростовская область / красюковская"
  },
  "4523": {
    "id": "4523",
    "name": "Кривянская",
    "path": "Россия / Ростовская область / Кривянская",
    "country": "Россия",
    "searchString": "кривянская россия / ростовская область / кривянская"
  },
  "4524": {
    "id": "4524",
    "name": "Куйбышево (Ростовская область)",
    "path": "Россия / Ростовская область / Куйбышево (Ростовская область)",
    "country": "Россия",
    "searchString": "куйбышево (ростовская область) россия / ростовская область / куйбышево (ростовская область)"
  },
  "4525": {
    "id": "4525",
    "name": "Кулешовка",
    "path": "Россия / Ростовская область / Кулешовка",
    "country": "Россия",
    "searchString": "кулешовка россия / ростовская область / кулешовка"
  },
  "4526": {
    "id": "4526",
    "name": "Летник",
    "path": "Россия / Ростовская область / Летник",
    "country": "Россия",
    "searchString": "летник россия / ростовская область / летник"
  },
  "4527": {
    "id": "4527",
    "name": "Лихой",
    "path": "Россия / Ростовская область / Лихой",
    "country": "Россия",
    "searchString": "лихой россия / ростовская область / лихой"
  },
  "4528": {
    "id": "4528",
    "name": "Мальчевская",
    "path": "Россия / Ростовская область / Мальчевская",
    "country": "Россия",
    "searchString": "мальчевская россия / ростовская область / мальчевская"
  },
  "4529": {
    "id": "4529",
    "name": "Маньково-Калитвенская",
    "path": "Россия / Ростовская область / Маньково-Калитвенская",
    "country": "Россия",
    "searchString": "маньково-калитвенская россия / ростовская область / маньково-калитвенская"
  },
  "4530": {
    "id": "4530",
    "name": "Матвеев-Курган",
    "path": "Россия / Ростовская область / Матвеев-Курган",
    "country": "Россия",
    "searchString": "матвеев-курган россия / ростовская область / матвеев-курган"
  },
  "4531": {
    "id": "4531",
    "name": "Мелиховская",
    "path": "Россия / Ростовская область / Мелиховская",
    "country": "Россия",
    "searchString": "мелиховская россия / ростовская область / мелиховская"
  },
  "4532": {
    "id": "4532",
    "name": "Мечетинская",
    "path": "Россия / Ростовская область / Мечетинская",
    "country": "Россия",
    "searchString": "мечетинская россия / ростовская область / мечетинская"
  },
  "4533": {
    "id": "4533",
    "name": "Милютинская",
    "path": "Россия / Ростовская область / Милютинская",
    "country": "Россия",
    "searchString": "милютинская россия / ростовская область / милютинская"
  },
  "4534": {
    "id": "4534",
    "name": "Николаевка (Ростовская область)",
    "path": "Россия / Ростовская область / Николаевка (Ростовская область)",
    "country": "Россия",
    "searchString": "николаевка (ростовская область) россия / ростовская область / николаевка (ростовская область)"
  },
  "4535": {
    "id": "4535",
    "name": "Николаевская",
    "path": "Россия / Ростовская область / Николаевская",
    "country": "Россия",
    "searchString": "николаевская россия / ростовская область / николаевская"
  },
  "4536": {
    "id": "4536",
    "name": "Новониколаевский",
    "path": "Россия / Ростовская область / Новониколаевский",
    "country": "Россия",
    "searchString": "новониколаевский россия / ростовская область / новониколаевский"
  },
  "4537": {
    "id": "4537",
    "name": "Новобатайск",
    "path": "Россия / Ростовская область / Новобатайск",
    "country": "Россия",
    "searchString": "новобатайск россия / ростовская область / новобатайск"
  },
  "4538": {
    "id": "4538",
    "name": "Новобессергеневка",
    "path": "Россия / Ростовская область / Новобессергеневка",
    "country": "Россия",
    "searchString": "новобессергеневка россия / ростовская область / новобессергеневка"
  },
  "4539": {
    "id": "4539",
    "name": "Новый Егорлык",
    "path": "Россия / Ростовская область / Новый Егорлык",
    "country": "Россия",
    "searchString": "новый егорлык россия / ростовская область / новый егорлык"
  },
  "4540": {
    "id": "4540",
    "name": "Обливская",
    "path": "Россия / Ростовская область / Обливская",
    "country": "Россия",
    "searchString": "обливская россия / ростовская область / обливская"
  },
  "4541": {
    "id": "4541",
    "name": "Ольгинская (Ростовская область)",
    "path": "Россия / Ростовская область / Ольгинская (Ростовская область)",
    "country": "Россия",
    "searchString": "ольгинская (ростовская область) россия / ростовская область / ольгинская (ростовская область)"
  },
  "4542": {
    "id": "4542",
    "name": "Персиановский",
    "path": "Россия / Ростовская область / Персиановский",
    "country": "Россия",
    "searchString": "персиановский россия / ростовская область / персиановский"
  },
  "4543": {
    "id": "4543",
    "name": "Песчанокопское",
    "path": "Россия / Ростовская область / Песчанокопское",
    "country": "Россия",
    "searchString": "песчанокопское россия / ростовская область / песчанокопское"
  },
  "4544": {
    "id": "4544",
    "name": "Пешково",
    "path": "Россия / Ростовская область / Пешково",
    "country": "Россия",
    "searchString": "пешково россия / ростовская область / пешково"
  },
  "4545": {
    "id": "4545",
    "name": "Покровское (Ростовская область)",
    "path": "Россия / Ростовская область / Покровское (Ростовская область)",
    "country": "Россия",
    "searchString": "покровское (ростовская область) россия / ростовская область / покровское (ростовская область)"
  },
  "4546": {
    "id": "4546",
    "name": "Приморка",
    "path": "Россия / Ростовская область / Приморка",
    "country": "Россия",
    "searchString": "приморка россия / ростовская область / приморка"
  },
  "4547": {
    "id": "4547",
    "name": "Развильное",
    "path": "Россия / Ростовская область / Развильное",
    "country": "Россия",
    "searchString": "развильное россия / ростовская область / развильное"
  },
  "4548": {
    "id": "4548",
    "name": "Рассвет",
    "path": "Россия / Ростовская область / Рассвет",
    "country": "Россия",
    "searchString": "рассвет россия / ростовская область / рассвет"
  },
  "4549": {
    "id": "4549",
    "name": "Ремонтное",
    "path": "Россия / Ростовская область / Ремонтное",
    "country": "Россия",
    "searchString": "ремонтное россия / ростовская область / ремонтное"
  },
  "4550": {
    "id": "4550",
    "name": "Родионово-Несветайская",
    "path": "Россия / Ростовская область / Родионово-Несветайская",
    "country": "Россия",
    "searchString": "родионово-несветайская россия / ростовская область / родионово-несветайская"
  },
  "4551": {
    "id": "4551",
    "name": "Романовская",
    "path": "Россия / Ростовская область / Романовская",
    "country": "Россия",
    "searchString": "романовская россия / ростовская область / романовская"
  },
  "4552": {
    "id": "4552",
    "name": "Самарское",
    "path": "Россия / Ростовская область / Самарское",
    "country": "Россия",
    "searchString": "самарское россия / ростовская область / самарское"
  },
  "4553": {
    "id": "4553",
    "name": "Сандата",
    "path": "Россия / Ростовская область / Сандата",
    "country": "Россия",
    "searchString": "сандата россия / ростовская область / сандата"
  },
  "4554": {
    "id": "4554",
    "name": "Синегорский",
    "path": "Россия / Ростовская область / Синегорский",
    "country": "Россия",
    "searchString": "синегорский россия / ростовская область / синегорский"
  },
  "4555": {
    "id": "4555",
    "name": "Синявское",
    "path": "Россия / Ростовская область / Синявское",
    "country": "Россия",
    "searchString": "синявское россия / ростовская область / синявское"
  },
  "4556": {
    "id": "4556",
    "name": "Старая Станица",
    "path": "Россия / Ростовская область / Старая Станица",
    "country": "Россия",
    "searchString": "старая станица россия / ростовская область / старая станица"
  },
  "4557": {
    "id": "4557",
    "name": "Тарасовский",
    "path": "Россия / Ростовская область / Тарасовский",
    "country": "Россия",
    "searchString": "тарасовский россия / ростовская область / тарасовский"
  },
  "4558": {
    "id": "4558",
    "name": "Углеродовский",
    "path": "Россия / Ростовская область / Углеродовский",
    "country": "Россия",
    "searchString": "углеродовский россия / ростовская область / углеродовский"
  },
  "4559": {
    "id": "4559",
    "name": "Усть-Донецкий",
    "path": "Россия / Ростовская область / Усть-Донецкий",
    "country": "Россия",
    "searchString": "усть-донецкий россия / ростовская область / усть-донецкий"
  },
  "4560": {
    "id": "4560",
    "name": "Целина",
    "path": "Россия / Ростовская область / Целина",
    "country": "Россия",
    "searchString": "целина россия / ростовская область / целина"
  },
  "4561": {
    "id": "4561",
    "name": "Чалтырь",
    "path": "Россия / Ростовская область / Чалтырь",
    "country": "Россия",
    "searchString": "чалтырь россия / ростовская область / чалтырь"
  },
  "4562": {
    "id": "4562",
    "name": "Чертково",
    "path": "Россия / Ростовская область / Чертково",
    "country": "Россия",
    "searchString": "чертково россия / ростовская область / чертково"
  },
  "4563": {
    "id": "4563",
    "name": "Шолоховский",
    "path": "Россия / Ростовская область / Шолоховский",
    "country": "Россия",
    "searchString": "шолоховский россия / ростовская область / шолоховский"
  },
  "4564": {
    "id": "4564",
    "name": "Яблоновский",
    "path": "Россия / Ростовская область / Яблоновский",
    "country": "Россия",
    "searchString": "яблоновский россия / ростовская область / яблоновский"
  },
  "4565": {
    "id": "4565",
    "name": "Александровка",
    "path": "Россия / Волгоградская область / Александровка",
    "country": "Россия",
    "searchString": "александровка россия / волгоградская область / александровка"
  },
  "4566": {
    "id": "4566",
    "name": "Алексеевская",
    "path": "Россия / Волгоградская область / Алексеевская",
    "country": "Россия",
    "searchString": "алексеевская россия / волгоградская область / алексеевская"
  },
  "4567": {
    "id": "4567",
    "name": "Антиповка",
    "path": "Россия / Волгоградская область / Антиповка",
    "country": "Россия",
    "searchString": "антиповка россия / волгоградская область / антиповка"
  },
  "4568": {
    "id": "4568",
    "name": "Береславка",
    "path": "Россия / Волгоградская область / Береславка",
    "country": "Россия",
    "searchString": "береславка россия / волгоградская область / береславка"
  },
  "4569": {
    "id": "4569",
    "name": "Большие Чапурники",
    "path": "Россия / Волгоградская область / Большие Чапурники",
    "country": "Россия",
    "searchString": "большие чапурники россия / волгоградская область / большие чапурники"
  },
  "4570": {
    "id": "4570",
    "name": "Быково",
    "path": "Россия / Волгоградская область / Быково",
    "country": "Россия",
    "searchString": "быково россия / волгоградская область / быково"
  },
  "4571": {
    "id": "4571",
    "name": "Городище",
    "path": "Россия / Волгоградская область / Городище",
    "country": "Россия",
    "searchString": "городище россия / волгоградская область / городище"
  },
  "4572": {
    "id": "4572",
    "name": "Даниловка",
    "path": "Россия / Волгоградская область / Даниловка",
    "country": "Россия",
    "searchString": "даниловка россия / волгоградская область / даниловка"
  },
  "4573": {
    "id": "4573",
    "name": "Елань",
    "path": "Россия / Волгоградская область / Елань",
    "country": "Россия",
    "searchString": "елань россия / волгоградская область / елань"
  },
  "4574": {
    "id": "4574",
    "name": "Ерзовка",
    "path": "Россия / Волгоградская область / Ерзовка",
    "country": "Россия",
    "searchString": "ерзовка россия / волгоградская область / ерзовка"
  },
  "4575": {
    "id": "4575",
    "name": "Заплавное",
    "path": "Россия / Волгоградская область / Заплавное",
    "country": "Россия",
    "searchString": "заплавное россия / волгоградская область / заплавное"
  },
  "4576": {
    "id": "4576",
    "name": "Кислово",
    "path": "Россия / Волгоградская область / Кислово",
    "country": "Россия",
    "searchString": "кислово россия / волгоградская область / кислово"
  },
  "4577": {
    "id": "4577",
    "name": "Клетская",
    "path": "Россия / Волгоградская область / Клетская",
    "country": "Россия",
    "searchString": "клетская россия / волгоградская область / клетская"
  },
  "4578": {
    "id": "4578",
    "name": "Краснооктябрьский (Волгоградская область)",
    "path": "Россия / Волгоградская область / Краснооктябрьский (Волгоградская область)",
    "country": "Россия",
    "searchString": "краснооктябрьский (волгоградская область) россия / волгоградская область / краснооктябрьский (волгоградская область)"
  },
  "4579": {
    "id": "4579",
    "name": "Красный Яр",
    "path": "Россия / Волгоградская область / Красный Яр",
    "country": "Россия",
    "searchString": "красный яр россия / волгоградская область / красный яр"
  },
  "4580": {
    "id": "4580",
    "name": "Кумылженская",
    "path": "Россия / Волгоградская область / Кумылженская",
    "country": "Россия",
    "searchString": "кумылженская россия / волгоградская область / кумылженская"
  },
  "4581": {
    "id": "4581",
    "name": "Линево",
    "path": "Россия / Волгоградская область / Линево",
    "country": "Россия",
    "searchString": "линево россия / волгоградская область / линево"
  },
  "4582": {
    "id": "4582",
    "name": "Лог",
    "path": "Россия / Волгоградская область / Лог",
    "country": "Россия",
    "searchString": "лог россия / волгоградская область / лог"
  },
  "4583": {
    "id": "4583",
    "name": "Нехаевская",
    "path": "Россия / Волгоградская область / Нехаевская",
    "country": "Россия",
    "searchString": "нехаевская россия / волгоградская область / нехаевская"
  },
  "4584": {
    "id": "4584",
    "name": "Нижний Чир",
    "path": "Россия / Волгоградская область / Нижний Чир",
    "country": "Россия",
    "searchString": "нижний чир россия / волгоградская область / нижний чир"
  },
  "4585": {
    "id": "4585",
    "name": "Новониколаевский (Волгоградская область)",
    "path": "Россия / Волгоградская область / Новониколаевский (Волгоградская область)",
    "country": "Россия",
    "searchString": "новониколаевский (волгоградская область) россия / волгоградская область / новониколаевский (волгоградская область)"
  },
  "4586": {
    "id": "4586",
    "name": "Новый Рогачик",
    "path": "Россия / Волгоградская область / Новый Рогачик",
    "country": "Россия",
    "searchString": "новый рогачик россия / волгоградская область / новый рогачик"
  },
  "4587": {
    "id": "4587",
    "name": "Октябрьский (Волгоградская область)",
    "path": "Россия / Волгоградская область / Октябрьский (Волгоградская область)",
    "country": "Россия",
    "searchString": "октябрьский (волгоградская область) россия / волгоградская область / октябрьский (волгоградская область)"
  },
  "4588": {
    "id": "4588",
    "name": "Ольховка",
    "path": "Россия / Волгоградская область / Ольховка",
    "country": "Россия",
    "searchString": "ольховка россия / волгоградская область / ольховка"
  },
  "4589": {
    "id": "4589",
    "name": "Преображенская",
    "path": "Россия / Волгоградская область / Преображенская",
    "country": "Россия",
    "searchString": "преображенская россия / волгоградская область / преображенская"
  },
  "4590": {
    "id": "4590",
    "name": "Приморск (Волгоградская область)",
    "path": "Россия / Волгоградская область / Приморск (Волгоградская область)",
    "country": "Россия",
    "searchString": "приморск (волгоградская область) россия / волгоградская область / приморск (волгоградская область)"
  },
  "4591": {
    "id": "4591",
    "name": "Савинка",
    "path": "Россия / Волгоградская область / Савинка",
    "country": "Россия",
    "searchString": "савинка россия / волгоградская область / савинка"
  },
  "4592": {
    "id": "4592",
    "name": "Себрово",
    "path": "Россия / Волгоградская область / Себрово",
    "country": "Россия",
    "searchString": "себрово россия / волгоградская область / себрово"
  },
  "4593": {
    "id": "4593",
    "name": "Чернышковский",
    "path": "Россия / Волгоградская область / Чернышковский",
    "country": "Россия",
    "searchString": "чернышковский россия / волгоградская область / чернышковский"
  },
  "4594": {
    "id": "4594",
    "name": "Красные Баррикады",
    "path": "Россия / Астраханская область / Красные Баррикады",
    "country": "Россия",
    "searchString": "красные баррикады россия / астраханская область / красные баррикады"
  },
  "4595": {
    "id": "4595",
    "name": "Троицкое (Республика Калмыкия)",
    "path": "Россия / Республика Калмыкия / Троицкое (Республика Калмыкия)",
    "country": "Россия",
    "searchString": "троицкое (республика калмыкия) россия / республика калмыкия / троицкое (республика калмыкия)"
  },
  "4596": {
    "id": "4596",
    "name": "Уват (Тюменская область)",
    "path": "Россия / Тюменская область / Уват (Тюменская область)",
    "country": "Россия",
    "searchString": "уват (тюменская область) россия / тюменская область / уват (тюменская область)"
  },
  "4597": {
    "id": "4597",
    "name": "Большая Мурта",
    "path": "Россия / Красноярский край / Большая Мурта",
    "country": "Россия",
    "searchString": "большая мурта россия / красноярский край / большая мурта"
  },
  "4598": {
    "id": "4598",
    "name": "Перелюб",
    "path": "Россия / Саратовская область / Перелюб",
    "country": "Россия",
    "searchString": "перелюб россия / саратовская область / перелюб"
  },
  "4599": {
    "id": "4599",
    "name": "Киевский (Московская область)",
    "path": "Россия / Московская область / Киевский (Московская область)",
    "country": "Россия",
    "searchString": "киевский (московская область) россия / московская область / киевский (московская область)"
  },
  "4600": {
    "id": "4600",
    "name": "Алабино (Московская область)",
    "path": "Россия / Московская область / Алабино (Московская область)",
    "country": "Россия",
    "searchString": "алабино (московская область) россия / московская область / алабино (московская область)"
  },
  "4601": {
    "id": "4601",
    "name": "Солнцево (Московская область)",
    "path": "Россия / Московская область / Солнцево (Московская область)",
    "country": "Россия",
    "searchString": "солнцево (московская область) россия / московская область / солнцево (московская область)"
  },
  "4602": {
    "id": "4602",
    "name": "Ново-Переделкино (Московская область)",
    "path": "Россия / Московская область / Ново-Переделкино (Московская область)",
    "country": "Россия",
    "searchString": "ново-переделкино (московская область) россия / московская область / ново-переделкино (московская область)"
  },
  "4603": {
    "id": "4603",
    "name": "Переделкино (Московская область)",
    "path": "Россия / Московская область / Переделкино (Московская область)",
    "country": "Россия",
    "searchString": "переделкино (московская область) россия / московская область / переделкино (московская область)"
  },
  "4604": {
    "id": "4604",
    "name": "Куркино (Московская область)",
    "path": "Россия / Московская область / Куркино (Московская область)",
    "country": "Россия",
    "searchString": "куркино (московская область) россия / московская область / куркино (московская область)"
  },
  "4605": {
    "id": "4605",
    "name": "Рублево (Московская область)",
    "path": "Россия / Московская область / Рублево (Московская область)",
    "country": "Россия",
    "searchString": "рублево (московская область) россия / московская область / рублево (московская область)"
  },
  "4606": {
    "id": "4606",
    "name": "Ивановское (Московская область)",
    "path": "Россия / Московская область / Ивановское (Московская область)",
    "country": "Россия",
    "searchString": "ивановское (московская область) россия / московская область / ивановское (московская область)"
  },
  "4607": {
    "id": "4607",
    "name": "Новый (Московская область)",
    "path": "Россия / Московская область / Новый (Московская область)",
    "country": "Россия",
    "searchString": "новый (московская область) россия / московская область / новый (московская область)"
  },
  "4608": {
    "id": "4608",
    "name": "Воронки  (Московская область)",
    "path": "Россия / Московская область / Воронки  (Московская область)",
    "country": "Россия",
    "searchString": "воронки  (московская область) россия / московская область / воронки  (московская область)"
  },
  "4609": {
    "id": "4609",
    "name": "Барвиха  (Московская область)",
    "path": "Россия / Московская область / Барвиха  (Московская область)",
    "country": "Россия",
    "searchString": "барвиха  (московская область) россия / московская область / барвиха  (московская область)"
  },
  "4610": {
    "id": "4610",
    "name": "Жуковка (Московская область)",
    "path": "Россия / Московская область / Жуковка (Московская область)",
    "country": "Россия",
    "searchString": "жуковка (московская область) россия / московская область / жуковка (московская область)"
  },
  "4611": {
    "id": "4611",
    "name": "Калчуга (Московская область)",
    "path": "Россия / Московская область / Калчуга (Московская область)",
    "country": "Россия",
    "searchString": "калчуга (московская область) россия / московская область / калчуга (московская область)"
  },
  "4612": {
    "id": "4612",
    "name": "Горки-2  (Московская область)",
    "path": "Россия / Московская область / Горки-2  (Московская область)",
    "country": "Россия",
    "searchString": "горки-2  (московская область) россия / московская область / горки-2  (московская область)"
  },
  "4613": {
    "id": "4613",
    "name": "Большое Сареево  (Московская область)",
    "path": "Россия / Московская область / Большое Сареево  (Московская область)",
    "country": "Россия",
    "searchString": "большое сареево  (московская область) россия / московская область / большое сареево  (московская область)"
  },
  "4614": {
    "id": "4614",
    "name": "Лайково (Московская область)",
    "path": "Россия / Московская область / Лайково (Московская область)",
    "country": "Россия",
    "searchString": "лайково (московская область) россия / московская область / лайково (московская область)"
  },
  "4615": {
    "id": "4615",
    "name": "Власиха  (Московская область)",
    "path": "Россия / Московская область / Власиха  (Московская область)",
    "country": "Россия",
    "searchString": "власиха  (московская область) россия / московская область / власиха  (московская область)"
  },
  "4616": {
    "id": "4616",
    "name": "Лапино (Московская область)",
    "path": "Россия / Московская область / Лапино (Московская область)",
    "country": "Россия",
    "searchString": "лапино (московская область) россия / московская область / лапино (московская область)"
  },
  "4617": {
    "id": "4617",
    "name": "Мечниково (Московская область)",
    "path": "Россия / Московская область / Мечниково (Московская область)",
    "country": "Россия",
    "searchString": "мечниково (московская область) россия / московская область / мечниково (московская область)"
  },
  "4618": {
    "id": "4618",
    "name": "Знаменское  (Московская область)",
    "path": "Россия / Московская область / Знаменское  (Московская область)",
    "country": "Россия",
    "searchString": "знаменское  (московская область) россия / московская область / знаменское  (московская область)"
  },
  "4619": {
    "id": "4619",
    "name": "Ильинское  (Московская область)",
    "path": "Россия / Московская область / Ильинское  (Московская область)",
    "country": "Россия",
    "searchString": "ильинское  (московская область) россия / московская область / ильинское  (московская область)"
  },
  "4620": {
    "id": "4620",
    "name": "Глухово  (Московская область)",
    "path": "Россия / Московская область / Глухово  (Московская область)",
    "country": "Россия",
    "searchString": "глухово  (московская область) россия / московская область / глухово  (московская область)"
  },
  "4621": {
    "id": "4621",
    "name": "Подушкино (Московская область)",
    "path": "Россия / Московская область / Подушкино (Московская область)",
    "country": "Россия",
    "searchString": "подушкино (московская область) россия / московская область / подушкино (московская область)"
  },
  "4622": {
    "id": "4622",
    "name": "посёлок ВНИИССОК  (Московская область)",
    "path": "Россия / Московская область / посёлок ВНИИССОК  (Московская область)",
    "country": "Россия",
    "searchString": "посёлок внииссок  (московская область) россия / московская область / посёлок внииссок  (московская область)"
  },
  "4623": {
    "id": "4623",
    "name": "Жаворонки  (Московская область)",
    "path": "Россия / Московская область / Жаворонки  (Московская область)",
    "country": "Россия",
    "searchString": "жаворонки  (московская область) россия / московская область / жаворонки  (московская область)"
  },
  "4624": {
    "id": "4624",
    "name": "Лесной Городок",
    "path": "Россия / Московская область / Лесной Городок",
    "country": "Россия",
    "searchString": "лесной городок россия / московская область / лесной городок"
  },
  "4625": {
    "id": "4625",
    "name": "Мамоново (Московская область)",
    "path": "Россия / Московская область / Мамоново (Московская область)",
    "country": "Россия",
    "searchString": "мамоново (московская область) россия / московская область / мамоново (московская область)"
  },
  "4626": {
    "id": "4626",
    "name": "Немчиновка (Московская область)",
    "path": "Россия / Московская область / Немчиновка (Московская область)",
    "country": "Россия",
    "searchString": "немчиновка (московская область) россия / московская область / немчиновка (московская область)"
  },
  "4627": {
    "id": "4627",
    "name": "Новоивановское (Московская область)",
    "path": "Россия / Московская область / Новоивановское (Московская область)",
    "country": "Россия",
    "searchString": "новоивановское (московская область) россия / московская область / новоивановское (московская область)"
  },
  "4628": {
    "id": "4628",
    "name": "Баковка  (Московская область)",
    "path": "Россия / Московская область / Баковка  (Московская область)",
    "country": "Россия",
    "searchString": "баковка  (московская область) россия / московская область / баковка  (московская область)"
  },
  "4629": {
    "id": "4629",
    "name": "ДСК Мичуринец  (Московская область)",
    "path": "Россия / Московская область / ДСК Мичуринец  (Московская область)",
    "country": "Россия",
    "searchString": "дск мичуринец  (московская область) россия / московская область / дск мичуринец  (московская область)"
  },
  "4630": {
    "id": "4630",
    "name": "Дмитровское  (Московская область)",
    "path": "Россия / Московская область / Дмитровское  (Московская область)",
    "country": "Россия",
    "searchString": "дмитровское  (московская область) россия / московская область / дмитровское  (московская область)"
  },
  "4631": {
    "id": "4631",
    "name": "Карымское",
    "path": "Россия / Забайкальский край / Карымское",
    "country": "Россия",
    "searchString": "карымское россия / забайкальский край / карымское"
  },
  "4633": {
    "id": "4633",
    "name": "Октябрьский (Пермский край)",
    "path": "Россия / Пермский край / Октябрьский (Пермский край)",
    "country": "Россия",
    "searchString": "октябрьский (пермский край) россия / пермский край / октябрьский (пермский край)"
  },
  "4634": {
    "id": "4634",
    "name": "Усть-Кишерть",
    "path": "Россия / Пермский край / Усть-Кишерть",
    "country": "Россия",
    "searchString": "усть-кишерть россия / пермский край / усть-кишерть"
  },
  "4635": {
    "id": "4635",
    "name": "Уганда",
    "path": "Другие регионы / Уганда",
    "country": "Другие регионы",
    "searchString": "уганда другие регионы / уганда"
  },
  "4636": {
    "id": "4636",
    "name": "Сабетта",
    "path": "Россия / Ненецкий АО / Сабетта",
    "country": "Россия",
    "searchString": "сабетта россия / ненецкий ао / сабетта"
  },
  "4637": {
    "id": "4637",
    "name": "Чунджа",
    "path": "Казахстан / Чунджа",
    "country": "Казахстан",
    "searchString": "чунджа казахстан / чунджа"
  },
  "4638": {
    "id": "4638",
    "name": "Байкалово (Свердловская область)",
    "path": "Россия / Свердловская область / Байкалово (Свердловская область)",
    "country": "Россия",
    "searchString": "байкалово (свердловская область) россия / свердловская область / байкалово (свердловская область)"
  },
  "4639": {
    "id": "4639",
    "name": "Лобва",
    "path": "Россия / Свердловская область / Лобва",
    "country": "Россия",
    "searchString": "лобва россия / свердловская область / лобва"
  },
  "4640": {
    "id": "4640",
    "name": "Багдарин",
    "path": "Россия / Республика Бурятия / Багдарин",
    "country": "Россия",
    "searchString": "багдарин россия / республика бурятия / багдарин"
  },
  "4641": {
    "id": "4641",
    "name": "Баргузин",
    "path": "Россия / Республика Бурятия / Баргузин",
    "country": "Россия",
    "searchString": "баргузин россия / республика бурятия / баргузин"
  },
  "4642": {
    "id": "4642",
    "name": "Бичура",
    "path": "Россия / Республика Бурятия / Бичура",
    "country": "Россия",
    "searchString": "бичура россия / республика бурятия / бичура"
  },
  "4643": {
    "id": "4643",
    "name": "Заиграево",
    "path": "Россия / Республика Бурятия / Заиграево",
    "country": "Россия",
    "searchString": "заиграево россия / республика бурятия / заиграево"
  },
  "4644": {
    "id": "4644",
    "name": "Иволгинск",
    "path": "Россия / Республика Бурятия / Иволгинск",
    "country": "Россия",
    "searchString": "иволгинск россия / республика бурятия / иволгинск"
  },
  "4645": {
    "id": "4645",
    "name": "Кабанск",
    "path": "Россия / Республика Бурятия / Кабанск",
    "country": "Россия",
    "searchString": "кабанск россия / республика бурятия / кабанск"
  },
  "4646": {
    "id": "4646",
    "name": "Каменск",
    "path": "Россия / Республика Бурятия / Каменск",
    "country": "Россия",
    "searchString": "каменск россия / республика бурятия / каменск"
  },
  "4647": {
    "id": "4647",
    "name": "Кижинга",
    "path": "Россия / Республика Бурятия / Кижинга",
    "country": "Россия",
    "searchString": "кижинга россия / республика бурятия / кижинга"
  },
  "4648": {
    "id": "4648",
    "name": "Курумкан",
    "path": "Россия / Республика Бурятия / Курумкан",
    "country": "Россия",
    "searchString": "курумкан россия / республика бурятия / курумкан"
  },
  "4649": {
    "id": "4649",
    "name": "Кырен",
    "path": "Россия / Республика Бурятия / Кырен",
    "country": "Россия",
    "searchString": "кырен россия / республика бурятия / кырен"
  },
  "4650": {
    "id": "4650",
    "name": "Мухоршибирь",
    "path": "Россия / Республика Бурятия / Мухоршибирь",
    "country": "Россия",
    "searchString": "мухоршибирь россия / республика бурятия / мухоршибирь"
  },
  "4651": {
    "id": "4651",
    "name": "Нижнеангарск",
    "path": "Россия / Республика Бурятия / Нижнеангарск",
    "country": "Россия",
    "searchString": "нижнеангарск россия / республика бурятия / нижнеангарск"
  },
  "4652": {
    "id": "4652",
    "name": "Новоильинск",
    "path": "Россия / Республика Бурятия / Новоильинск",
    "country": "Россия",
    "searchString": "новоильинск россия / республика бурятия / новоильинск"
  },
  "4653": {
    "id": "4653",
    "name": "Онохой",
    "path": "Россия / Республика Бурятия / Онохой",
    "country": "Россия",
    "searchString": "онохой россия / республика бурятия / онохой"
  },
  "4654": {
    "id": "4654",
    "name": "Петропавловка (Республика Бурятия)",
    "path": "Россия / Республика Бурятия / Петропавловка (Республика Бурятия)",
    "country": "Россия",
    "searchString": "петропавловка (республика бурятия) россия / республика бурятия / петропавловка (республика бурятия)"
  },
  "4655": {
    "id": "4655",
    "name": "Селенгинск",
    "path": "Россия / Республика Бурятия / Селенгинск",
    "country": "Россия",
    "searchString": "селенгинск россия / республика бурятия / селенгинск"
  },
  "4656": {
    "id": "4656",
    "name": "Сосново-Озерское",
    "path": "Россия / Республика Бурятия / Сосново-Озерское",
    "country": "Россия",
    "searchString": "сосново-озерское россия / республика бурятия / сосново-озерское"
  },
  "4657": {
    "id": "4657",
    "name": "Турунтаево",
    "path": "Россия / Республика Бурятия / Турунтаево",
    "country": "Россия",
    "searchString": "турунтаево россия / республика бурятия / турунтаево"
  },
  "4658": {
    "id": "4658",
    "name": "Усть-Баргузин",
    "path": "Россия / Республика Бурятия / Усть-Баргузин",
    "country": "Россия",
    "searchString": "усть-баргузин россия / республика бурятия / усть-баргузин"
  },
  "4659": {
    "id": "4659",
    "name": "Хоринск",
    "path": "Россия / Республика Бурятия / Хоринск",
    "country": "Россия",
    "searchString": "хоринск россия / республика бурятия / хоринск"
  },
  "4660": {
    "id": "4660",
    "name": "Кичера",
    "path": "Россия / Республика Бурятия / Кичера",
    "country": "Россия",
    "searchString": "кичера россия / республика бурятия / кичера"
  },
  "4661": {
    "id": "4661",
    "name": "Северомуйск",
    "path": "Россия / Республика Бурятия / Северомуйск",
    "country": "Россия",
    "searchString": "северомуйск россия / республика бурятия / северомуйск"
  },
  "4662": {
    "id": "4662",
    "name": "Янчукан",
    "path": "Россия / Республика Бурятия / Янчукан",
    "country": "Россия",
    "searchString": "янчукан россия / республика бурятия / янчукан"
  },
  "4663": {
    "id": "4663",
    "name": "Александровское (Томская область)",
    "path": "Россия / Томская область / Александровское (Томская область)",
    "country": "Россия",
    "searchString": "александровское (томская область) россия / томская область / александровское (томская область)"
  },
  "4664": {
    "id": "4664",
    "name": "Бакчар",
    "path": "Россия / Томская область / Бакчар",
    "country": "Россия",
    "searchString": "бакчар россия / томская область / бакчар"
  },
  "4665": {
    "id": "4665",
    "name": "Белый Яр",
    "path": "Россия / Томская область / Белый Яр",
    "country": "Россия",
    "searchString": "белый яр россия / томская область / белый яр"
  },
  "4666": {
    "id": "4666",
    "name": "Богашёво",
    "path": "Россия / Томская область / Богашёво",
    "country": "Россия",
    "searchString": "богашёво россия / томская область / богашёво"
  },
  "4667": {
    "id": "4667",
    "name": "Зоркальцево",
    "path": "Россия / Томская область / Зоркальцево",
    "country": "Россия",
    "searchString": "зоркальцево россия / томская область / зоркальцево"
  },
  "4668": {
    "id": "4668",
    "name": "Зырянское",
    "path": "Россия / Томская область / Зырянское",
    "country": "Россия",
    "searchString": "зырянское россия / томская область / зырянское"
  },
  "4669": {
    "id": "4669",
    "name": "Зональная Станция",
    "path": "Россия / Томская область / Зональная Станция",
    "country": "Россия",
    "searchString": "зональная станция россия / томская область / зональная станция"
  },
  "4670": {
    "id": "4670",
    "name": "Каргала",
    "path": "Россия / Томская область / Каргала",
    "country": "Россия",
    "searchString": "каргала россия / томская область / каргала"
  },
  "4671": {
    "id": "4671",
    "name": "Каргасок",
    "path": "Россия / Томская область / Каргасок",
    "country": "Россия",
    "searchString": "каргасок россия / томская область / каргасок"
  },
  "4672": {
    "id": "4672",
    "name": "Кисловка",
    "path": "Россия / Томская область / Кисловка",
    "country": "Россия",
    "searchString": "кисловка россия / томская область / кисловка"
  },
  "4673": {
    "id": "4673",
    "name": "Кожевниково",
    "path": "Россия / Томская область / Кожевниково",
    "country": "Россия",
    "searchString": "кожевниково россия / томская область / кожевниково"
  },
  "4674": {
    "id": "4674",
    "name": "Копылово",
    "path": "Россия / Томская область / Копылово",
    "country": "Россия",
    "searchString": "копылово россия / томская область / копылово"
  },
  "4675": {
    "id": "4675",
    "name": "Кривошеино",
    "path": "Россия / Томская область / Кривошеино",
    "country": "Россия",
    "searchString": "кривошеино россия / томская область / кривошеино"
  },
  "4676": {
    "id": "4676",
    "name": "Курлек",
    "path": "Россия / Томская область / Курлек",
    "country": "Россия",
    "searchString": "курлек россия / томская область / курлек"
  },
  "4677": {
    "id": "4677",
    "name": "Мельниково",
    "path": "Россия / Томская область / Мельниково",
    "country": "Россия",
    "searchString": "мельниково россия / томская область / мельниково"
  },
  "4678": {
    "id": "4678",
    "name": "Могочино",
    "path": "Россия / Томская область / Могочино",
    "country": "Россия",
    "searchString": "могочино россия / томская область / могочино"
  },
  "4679": {
    "id": "4679",
    "name": "Молчаново",
    "path": "Россия / Томская область / Молчаново",
    "country": "Россия",
    "searchString": "молчаново россия / томская область / молчаново"
  },
  "4680": {
    "id": "4680",
    "name": "Моряковский Затон",
    "path": "Россия / Томская область / Моряковский Затон",
    "country": "Россия",
    "searchString": "моряковский затон россия / томская область / моряковский затон"
  },
  "4681": {
    "id": "4681",
    "name": "Новый Васюган",
    "path": "Россия / Томская область / Новый Васюган",
    "country": "Россия",
    "searchString": "новый васюган россия / томская область / новый васюган"
  },
  "4682": {
    "id": "4682",
    "name": "Парабель",
    "path": "Россия / Томская область / Парабель",
    "country": "Россия",
    "searchString": "парабель россия / томская область / парабель"
  },
  "4683": {
    "id": "4683",
    "name": "Парбиг",
    "path": "Россия / Томская область / Парбиг",
    "country": "Россия",
    "searchString": "парбиг россия / томская область / парбиг"
  },
  "4684": {
    "id": "4684",
    "name": "Первомайское (Томская область)",
    "path": "Россия / Томская область / Первомайское (Томская область)",
    "country": "Россия",
    "searchString": "первомайское (томская область) россия / томская область / первомайское (томская область)"
  },
  "4685": {
    "id": "4685",
    "name": "Подгорное",
    "path": "Россия / Томская область / Подгорное",
    "country": "Россия",
    "searchString": "подгорное россия / томская область / подгорное"
  },
  "4686": {
    "id": "4686",
    "name": "Рыбалово",
    "path": "Россия / Томская область / Рыбалово",
    "country": "Россия",
    "searchString": "рыбалово россия / томская область / рыбалово"
  },
  "4687": {
    "id": "4687",
    "name": "Самусь",
    "path": "Россия / Томская область / Самусь",
    "country": "Россия",
    "searchString": "самусь россия / томская область / самусь"
  },
  "4688": {
    "id": "4688",
    "name": "Светлый (Томская область)",
    "path": "Россия / Томская область / Светлый (Томская область)",
    "country": "Россия",
    "searchString": "светлый (томская область) россия / томская область / светлый (томская область)"
  },
  "4689": {
    "id": "4689",
    "name": "Средний Васюган",
    "path": "Россия / Томская область / Средний Васюган",
    "country": "Россия",
    "searchString": "средний васюган россия / томская область / средний васюган"
  },
  "4690": {
    "id": "4690",
    "name": "Тегульдет",
    "path": "Россия / Томская область / Тегульдет",
    "country": "Россия",
    "searchString": "тегульдет россия / томская область / тегульдет"
  },
  "4691": {
    "id": "4691",
    "name": "Тогур",
    "path": "Россия / Томская область / Тогур",
    "country": "Россия",
    "searchString": "тогур россия / томская область / тогур"
  },
  "4692": {
    "id": "4692",
    "name": "Чажемто",
    "path": "Россия / Томская область / Чажемто",
    "country": "Россия",
    "searchString": "чажемто россия / томская область / чажемто"
  },
  "4693": {
    "id": "4693",
    "name": "Луговской",
    "path": "Россия / Свердловская область / Луговской",
    "country": "Россия",
    "searchString": "луговской россия / свердловская область / луговской"
  },
  "4694": {
    "id": "4694",
    "name": "Малышева",
    "path": "Россия / Свердловская область / Малышева",
    "country": "Россия",
    "searchString": "малышева россия / свердловская область / малышева"
  },
  "4695": {
    "id": "4695",
    "name": "Азово",
    "path": "Россия / Омская область / Азово",
    "country": "Россия",
    "searchString": "азово россия / омская область / азово"
  },
  "4696": {
    "id": "4696",
    "name": "Монетный",
    "path": "Россия / Свердловская область / Монетный",
    "country": "Россия",
    "searchString": "монетный россия / свердловская область / монетный"
  },
  "4697": {
    "id": "4697",
    "name": "Большегривское",
    "path": "Россия / Омская область / Большегривское",
    "country": "Россия",
    "searchString": "большегривское россия / омская область / большегривское"
  },
  "4698": {
    "id": "4698",
    "name": "Николо-Павловское",
    "path": "Россия / Свердловская область / Николо-Павловское",
    "country": "Россия",
    "searchString": "николо-павловское россия / свердловская область / николо-павловское"
  },
  "4699": {
    "id": "4699",
    "name": "Большеречье",
    "path": "Россия / Омская область / Большеречье",
    "country": "Россия",
    "searchString": "большеречье россия / омская область / большеречье"
  },
  "4700": {
    "id": "4700",
    "name": "Большие Уки",
    "path": "Россия / Омская область / Большие Уки",
    "country": "Россия",
    "searchString": "большие уки россия / омская область / большие уки"
  },
  "4701": {
    "id": "4701",
    "name": "Горьковское",
    "path": "Россия / Омская область / Горьковское",
    "country": "Россия",
    "searchString": "горьковское россия / омская область / горьковское"
  },
  "4702": {
    "id": "4702",
    "name": "Знаменское (Омская область)",
    "path": "Россия / Омская область / Знаменское (Омская область)",
    "country": "Россия",
    "searchString": "знаменское (омская область) россия / омская область / знаменское (омская область)"
  },
  "4703": {
    "id": "4703",
    "name": "Колосовка",
    "path": "Россия / Омская область / Колосовка",
    "country": "Россия",
    "searchString": "колосовка россия / омская область / колосовка"
  },
  "4704": {
    "id": "4704",
    "name": "Кормиловка",
    "path": "Россия / Омская область / Кормиловка",
    "country": "Россия",
    "searchString": "кормиловка россия / омская область / кормиловка"
  },
  "4705": {
    "id": "4705",
    "name": "Красноярка",
    "path": "Россия / Омская область / Красноярка",
    "country": "Россия",
    "searchString": "красноярка россия / омская область / красноярка"
  },
  "4706": {
    "id": "4706",
    "name": "Красный Яр (Омская область)",
    "path": "Россия / Омская область / Красный Яр (Омская область)",
    "country": "Россия",
    "searchString": "красный яр (омская область) россия / омская область / красный яр (омская область)"
  },
  "4707": {
    "id": "4707",
    "name": "Крутинка",
    "path": "Россия / Омская область / Крутинка",
    "country": "Россия",
    "searchString": "крутинка россия / омская область / крутинка"
  },
  "4708": {
    "id": "4708",
    "name": "Лузино",
    "path": "Россия / Омская область / Лузино",
    "country": "Россия",
    "searchString": "лузино россия / омская область / лузино"
  },
  "4709": {
    "id": "4709",
    "name": "Любинский",
    "path": "Россия / Омская область / Любинский",
    "country": "Россия",
    "searchString": "любинский россия / омская область / любинский"
  },
  "4710": {
    "id": "4710",
    "name": "Марьяновка",
    "path": "Россия / Омская область / Марьяновка",
    "country": "Россия",
    "searchString": "марьяновка россия / омская область / марьяновка"
  },
  "4711": {
    "id": "4711",
    "name": "Москаленки",
    "path": "Россия / Омская область / Москаленки",
    "country": "Россия",
    "searchString": "москаленки россия / омская область / москаленки"
  },
  "4712": {
    "id": "4712",
    "name": "Муромцево",
    "path": "Россия / Омская область / Муромцево",
    "country": "Россия",
    "searchString": "муромцево россия / омская область / муромцево"
  },
  "4713": {
    "id": "4713",
    "name": "Нижняя Омка",
    "path": "Россия / Омская область / Нижняя Омка",
    "country": "Россия",
    "searchString": "нижняя омка россия / омская область / нижняя омка"
  },
  "4714": {
    "id": "4714",
    "name": "Нововаршавка",
    "path": "Россия / Омская область / Нововаршавка",
    "country": "Россия",
    "searchString": "нововаршавка россия / омская область / нововаршавка"
  },
  "4715": {
    "id": "4715",
    "name": "Новоомский",
    "path": "Россия / Омская область / Новоомский",
    "country": "Россия",
    "searchString": "новоомский россия / омская область / новоомский"
  },
  "4716": {
    "id": "4716",
    "name": "Новоуткинск",
    "path": "Россия / Свердловская область / Новоуткинск",
    "country": "Россия",
    "searchString": "новоуткинск россия / свердловская область / новоуткинск"
  },
  "4717": {
    "id": "4717",
    "name": "Новотроицкое (Омская область)",
    "path": "Россия / Омская область / Новотроицкое (Омская область)",
    "country": "Россия",
    "searchString": "новотроицкое (омская область) россия / омская область / новотроицкое (омская область)"
  },
  "4718": {
    "id": "4718",
    "name": "Пелым",
    "path": "Россия / Свердловская область / Пелым",
    "country": "Россия",
    "searchString": "пелым россия / свердловская область / пелым"
  },
  "4719": {
    "id": "4719",
    "name": "Одесское",
    "path": "Россия / Омская область / Одесское",
    "country": "Россия",
    "searchString": "одесское россия / омская область / одесское"
  },
  "4720": {
    "id": "4720",
    "name": "Оконешниково",
    "path": "Россия / Омская область / Оконешниково",
    "country": "Россия",
    "searchString": "оконешниково россия / омская область / оконешниково"
  },
  "4721": {
    "id": "4721",
    "name": "Павлоградка",
    "path": "Россия / Омская область / Павлоградка",
    "country": "Россия",
    "searchString": "павлоградка россия / омская область / павлоградка"
  },
  "4722": {
    "id": "4722",
    "name": "Петрокаменское",
    "path": "Россия / Свердловская область / Петрокаменское",
    "country": "Россия",
    "searchString": "петрокаменское россия / свердловская область / петрокаменское"
  },
  "4723": {
    "id": "4723",
    "name": "Полтавка",
    "path": "Россия / Омская область / Полтавка",
    "country": "Россия",
    "searchString": "полтавка россия / омская область / полтавка"
  },
  "4724": {
    "id": "4724",
    "name": "Ростовка",
    "path": "Россия / Омская область / Ростовка",
    "country": "Россия",
    "searchString": "ростовка россия / омская область / ростовка"
  },
  "4725": {
    "id": "4725",
    "name": "Пионерский (Свердловская область)",
    "path": "Россия / Свердловская область / Пионерский (Свердловская область)",
    "country": "Россия",
    "searchString": "пионерский (свердловская область) россия / свердловская область / пионерский (свердловская область)"
  },
  "4726": {
    "id": "4726",
    "name": "Покровское (Свердловская область)",
    "path": "Россия / Свердловская область / Покровское (Свердловская область)",
    "country": "Россия",
    "searchString": "покровское (свердловская область) россия / свердловская область / покровское (свердловская область)"
  },
  "4727": {
    "id": "4727",
    "name": "Пышма",
    "path": "Россия / Свердловская область / Пышма",
    "country": "Россия",
    "searchString": "пышма россия / свердловская область / пышма"
  },
  "4728": {
    "id": "4728",
    "name": "Русская Поляна",
    "path": "Россия / Омская область / Русская Поляна",
    "country": "Россия",
    "searchString": "русская поляна россия / омская область / русская поляна"
  },
  "4729": {
    "id": "4729",
    "name": "Саргатское",
    "path": "Россия / Омская область / Саргатское",
    "country": "Россия",
    "searchString": "саргатское россия / омская область / саргатское"
  },
  "4730": {
    "id": "4730",
    "name": "Седельниково",
    "path": "Россия / Омская область / Седельниково",
    "country": "Россия",
    "searchString": "седельниково россия / омская область / седельниково"
  },
  "4731": {
    "id": "4731",
    "name": "Свободный (Свердловская область)",
    "path": "Россия / Свердловская область / Свободный (Свердловская область)",
    "country": "Россия",
    "searchString": "свободный (свердловская область) россия / свердловская область / свободный (свердловская область)"
  },
  "4732": {
    "id": "4732",
    "name": "Таврическое",
    "path": "Россия / Омская область / Таврическое",
    "country": "Россия",
    "searchString": "таврическое россия / омская область / таврическое"
  },
  "4733": {
    "id": "4733",
    "name": "Совхозный",
    "path": "Россия / Свердловская область / Совхозный",
    "country": "Россия",
    "searchString": "совхозный россия / свердловская область / совхозный"
  },
  "4734": {
    "id": "4734",
    "name": "Сосьва",
    "path": "Россия / Свердловская область / Сосьва",
    "country": "Россия",
    "searchString": "сосьва россия / свердловская область / сосьва"
  },
  "4735": {
    "id": "4735",
    "name": "Тевриз",
    "path": "Россия / Омская область / Тевриз",
    "country": "Россия",
    "searchString": "тевриз россия / омская область / тевриз"
  },
  "4736": {
    "id": "4736",
    "name": "Усть-Ишим",
    "path": "Россия / Омская область / Усть-Ишим",
    "country": "Россия",
    "searchString": "усть-ишим россия / омская область / усть-ишим"
  },
  "4737": {
    "id": "4737",
    "name": "Троицкий (Свердловская область)",
    "path": "Россия / Свердловская область / Троицкий (Свердловская область)",
    "country": "Россия",
    "searchString": "троицкий (свердловская область) россия / свердловская область / троицкий (свердловская область)"
  },
  "4738": {
    "id": "4738",
    "name": "Шербакуль",
    "path": "Россия / Омская область / Шербакуль",
    "country": "Россия",
    "searchString": "шербакуль россия / омская область / шербакуль"
  },
  "4739": {
    "id": "4739",
    "name": "Тугулым",
    "path": "Россия / Свердловская область / Тугулым",
    "country": "Россия",
    "searchString": "тугулым россия / свердловская область / тугулым"
  },
  "4740": {
    "id": "4740",
    "name": "Туринская Слобода",
    "path": "Россия / Свердловская область / Туринская Слобода",
    "country": "Россия",
    "searchString": "туринская слобода россия / свердловская область / туринская слобода"
  },
  "4741": {
    "id": "4741",
    "name": "Абан",
    "path": "Россия / Красноярский край / Абан",
    "country": "Россия",
    "searchString": "абан россия / красноярский край / абан"
  },
  "4742": {
    "id": "4742",
    "name": "Агинское",
    "path": "Россия / Красноярский край / Агинское",
    "country": "Россия",
    "searchString": "агинское россия / красноярский край / агинское"
  },
  "4743": {
    "id": "4743",
    "name": "Байкит",
    "path": "Россия / Красноярский край / Байкит",
    "country": "Россия",
    "searchString": "байкит россия / красноярский край / байкит"
  },
  "4744": {
    "id": "4744",
    "name": "Березовка (Красноярский край)",
    "path": "Россия / Красноярский край / Березовка (Красноярский край)",
    "country": "Россия",
    "searchString": "березовка (красноярский край) россия / красноярский край / березовка (красноярский край)"
  },
  "4745": {
    "id": "4745",
    "name": "Большая Ирба",
    "path": "Россия / Красноярский край / Большая Ирба",
    "country": "Россия",
    "searchString": "большая ирба россия / красноярский край / большая ирба"
  },
  "4746": {
    "id": "4746",
    "name": "Большой Улуй",
    "path": "Россия / Красноярский край / Большой Улуй",
    "country": "Россия",
    "searchString": "большой улуй россия / красноярский край / большой улуй"
  },
  "4747": {
    "id": "4747",
    "name": "Дзержинское",
    "path": "Россия / Красноярский край / Дзержинское",
    "country": "Россия",
    "searchString": "дзержинское россия / красноярский край / дзержинское"
  },
  "4748": {
    "id": "4748",
    "name": "Дубинино",
    "path": "Россия / Красноярский край / Дубинино",
    "country": "Россия",
    "searchString": "дубинино россия / красноярский край / дубинино"
  },
  "4749": {
    "id": "4749",
    "name": "Емельяново",
    "path": "Россия / Красноярский край / Емельяново",
    "country": "Россия",
    "searchString": "емельяново россия / красноярский край / емельяново"
  },
  "4750": {
    "id": "4750",
    "name": "Ермаковское",
    "path": "Россия / Красноярский край / Ермаковское",
    "country": "Россия",
    "searchString": "ермаковское россия / красноярский край / ермаковское"
  },
  "4751": {
    "id": "4751",
    "name": "Зыково",
    "path": "Россия / Красноярский край / Зыково",
    "country": "Россия",
    "searchString": "зыково россия / красноярский край / зыково"
  },
  "4752": {
    "id": "4752",
    "name": "Идринское",
    "path": "Россия / Красноярский край / Идринское",
    "country": "Россия",
    "searchString": "идринское россия / красноярский край / идринское"
  },
  "4753": {
    "id": "4753",
    "name": "Ирбейское",
    "path": "Россия / Красноярский край / Ирбейское",
    "country": "Россия",
    "searchString": "ирбейское россия / красноярский край / ирбейское"
  },
  "4754": {
    "id": "4754",
    "name": "Казачинское",
    "path": "Россия / Красноярский край / Казачинское",
    "country": "Россия",
    "searchString": "казачинское россия / красноярский край / казачинское"
  },
  "4755": {
    "id": "4755",
    "name": "Кайеркан",
    "path": "Россия / Красноярский край / Кайеркан",
    "country": "Россия",
    "searchString": "кайеркан россия / красноярский край / кайеркан"
  },
  "4756": {
    "id": "4756",
    "name": "Каратузское",
    "path": "Россия / Красноярский край / Каратузское",
    "country": "Россия",
    "searchString": "каратузское россия / красноярский край / каратузское"
  },
  "4757": {
    "id": "4757",
    "name": "Кедровый (Красноярский край)",
    "path": "Россия / Красноярский край / Кедровый (Красноярский край)",
    "country": "Россия",
    "searchString": "кедровый (красноярский край) россия / красноярский край / кедровый (красноярский край)"
  },
  "4758": {
    "id": "4758",
    "name": "Козулька",
    "path": "Россия / Красноярский край / Козулька",
    "country": "Россия",
    "searchString": "козулька россия / красноярский край / козулька"
  },
  "4759": {
    "id": "4759",
    "name": "Кошурниково",
    "path": "Россия / Красноярский край / Кошурниково",
    "country": "Россия",
    "searchString": "кошурниково россия / красноярский край / кошурниково"
  },
  "4760": {
    "id": "4760",
    "name": "Краснокаменск (Красноярский край)",
    "path": "Россия / Красноярский край / Краснокаменск (Красноярский край)",
    "country": "Россия",
    "searchString": "краснокаменск (красноярский край) россия / красноярский край / краснокаменск (красноярский край)"
  },
  "4761": {
    "id": "4761",
    "name": "Краснотуранск",
    "path": "Россия / Красноярский край / Краснотуранск",
    "country": "Россия",
    "searchString": "краснотуранск россия / красноярский край / краснотуранск"
  },
  "4762": {
    "id": "4762",
    "name": "Курагино",
    "path": "Россия / Красноярский край / Курагино",
    "country": "Россия",
    "searchString": "курагино россия / красноярский край / курагино"
  },
  "4763": {
    "id": "4763",
    "name": "Мотыгино",
    "path": "Россия / Красноярский край / Мотыгино",
    "country": "Россия",
    "searchString": "мотыгино россия / красноярский край / мотыгино"
  },
  "4764": {
    "id": "4764",
    "name": "Нижний Ингаш",
    "path": "Россия / Красноярский край / Нижний Ингаш",
    "country": "Россия",
    "searchString": "нижний ингаш россия / красноярский край / нижний ингаш"
  },
  "4765": {
    "id": "4765",
    "name": "Нижняя Пойма",
    "path": "Россия / Красноярский край / Нижняя Пойма",
    "country": "Россия",
    "searchString": "нижняя пойма россия / красноярский край / нижняя пойма"
  },
  "4766": {
    "id": "4766",
    "name": "Новобирилюссы",
    "path": "Россия / Красноярский край / Новобирилюссы",
    "country": "Россия",
    "searchString": "новобирилюссы россия / красноярский край / новобирилюссы"
  },
  "4767": {
    "id": "4767",
    "name": "Новосёлово",
    "path": "Россия / Красноярский край / Новосёлово",
    "country": "Россия",
    "searchString": "новосёлово россия / красноярский край / новосёлово"
  },
  "4768": {
    "id": "4768",
    "name": "Новочернореченский",
    "path": "Россия / Красноярский край / Новочернореченский",
    "country": "Россия",
    "searchString": "новочернореченский россия / красноярский край / новочернореченский"
  },
  "4769": {
    "id": "4769",
    "name": "Октябрьский (Красноярский край)",
    "path": "Россия / Красноярский край / Октябрьский (Красноярский край)",
    "country": "Россия",
    "searchString": "октябрьский (красноярский край) россия / красноярский край / октябрьский (красноярский край)"
  },
  "4770": {
    "id": "4770",
    "name": "Партизанское",
    "path": "Россия / Красноярский край / Партизанское",
    "country": "Россия",
    "searchString": "партизанское россия / красноярский край / партизанское"
  },
  "4771": {
    "id": "4771",
    "name": "Саянский",
    "path": "Россия / Красноярский край / Саянский",
    "country": "Россия",
    "searchString": "саянский россия / красноярский край / саянский"
  },
  "4772": {
    "id": "4772",
    "name": "Северо-Енисейский (Красноярский край)",
    "path": "Россия / Красноярский край / Северо-Енисейский (Красноярский край)",
    "country": "Россия",
    "searchString": "северо-енисейский (красноярский край) россия / красноярский край / северо-енисейский (красноярский край)"
  },
  "4773": {
    "id": "4773",
    "name": "Сухобузимское",
    "path": "Россия / Красноярский край / Сухобузимское",
    "country": "Россия",
    "searchString": "сухобузимское россия / красноярский край / сухобузимское"
  },
  "4774": {
    "id": "4774",
    "name": "Таежный",
    "path": "Россия / Красноярский край / Таежный",
    "country": "Россия",
    "searchString": "таежный россия / красноярский край / таежный"
  },
  "4775": {
    "id": "4775",
    "name": "Тасеево",
    "path": "Россия / Красноярский край / Тасеево",
    "country": "Россия",
    "searchString": "тасеево россия / красноярский край / тасеево"
  },
  "4776": {
    "id": "4776",
    "name": "Туруханск",
    "path": "Россия / Красноярский край / Туруханск",
    "country": "Россия",
    "searchString": "туруханск россия / красноярский край / туруханск"
  },
  "4777": {
    "id": "4777",
    "name": "Тюхтет",
    "path": "Россия / Красноярский край / Тюхтет",
    "country": "Россия",
    "searchString": "тюхтет россия / красноярский край / тюхтет"
  },
  "4778": {
    "id": "4778",
    "name": "Чунояр",
    "path": "Россия / Красноярский край / Чунояр",
    "country": "Россия",
    "searchString": "чунояр россия / красноярский край / чунояр"
  },
  "4779": {
    "id": "4779",
    "name": "Шалинское",
    "path": "Россия / Красноярский край / Шалинское",
    "country": "Россия",
    "searchString": "шалинское россия / красноярский край / шалинское"
  },
  "4780": {
    "id": "4780",
    "name": "Шушенское",
    "path": "Россия / Красноярский край / Шушенское",
    "country": "Россия",
    "searchString": "шушенское россия / красноярский край / шушенское"
  },
  "4781": {
    "id": "4781",
    "name": "Черемухово",
    "path": "Россия / Свердловская область / Черемухово",
    "country": "Россия",
    "searchString": "черемухово россия / свердловская область / черемухово"
  },
  "4782": {
    "id": "4782",
    "name": "Черноисточинск",
    "path": "Россия / Свердловская область / Черноисточинск",
    "country": "Россия",
    "searchString": "черноисточинск россия / свердловская область / черноисточинск"
  },
  "4783": {
    "id": "4783",
    "name": "Шабровский",
    "path": "Россия / Свердловская область / Шабровский",
    "country": "Россия",
    "searchString": "шабровский россия / свердловская область / шабровский"
  },
  "4784": {
    "id": "4784",
    "name": "Шаля",
    "path": "Россия / Свердловская область / Шаля",
    "country": "Россия",
    "searchString": "шаля россия / свердловская область / шаля"
  },
  "4785": {
    "id": "4785",
    "name": "Юшала",
    "path": "Россия / Свердловская область / Юшала",
    "country": "Россия",
    "searchString": "юшала россия / свердловская область / юшала"
  },
  "4786": {
    "id": "4786",
    "name": "Артышта (Кемеровская область, Прокопьевский район)",
    "path": "Россия / Кемеровская область / Артышта (Кемеровская область, Прокопьевский район)",
    "country": "Россия",
    "searchString": "артышта (кемеровская область, прокопьевский район) россия / кемеровская область / артышта (кемеровская область, прокопьевский район)"
  },
  "4787": {
    "id": "4787",
    "name": "Бачатский",
    "path": "Россия / Кемеровская область / Бачатский",
    "country": "Россия",
    "searchString": "бачатский россия / кемеровская область / бачатский"
  },
  "4788": {
    "id": "4788",
    "name": "Белогорск (Кемеровская область)",
    "path": "Россия / Кемеровская область / Белогорск (Кемеровская область)",
    "country": "Россия",
    "searchString": "белогорск (кемеровская область) россия / кемеровская область / белогорск (кемеровская область)"
  },
  "4789": {
    "id": "4789",
    "name": "Верх-Чебула",
    "path": "Россия / Кемеровская область / Верх-Чебула",
    "country": "Россия",
    "searchString": "верх-чебула россия / кемеровская область / верх-чебула"
  },
  "4790": {
    "id": "4790",
    "name": "Грамотеино",
    "path": "Россия / Кемеровская область / Грамотеино",
    "country": "Россия",
    "searchString": "грамотеино россия / кемеровская область / грамотеино"
  },
  "4791": {
    "id": "4791",
    "name": "Зеленогорский",
    "path": "Россия / Кемеровская область / Зеленогорский",
    "country": "Россия",
    "searchString": "зеленогорский россия / кемеровская область / зеленогорский"
  },
  "4792": {
    "id": "4792",
    "name": "Ижморский",
    "path": "Россия / Кемеровская область / Ижморский",
    "country": "Россия",
    "searchString": "ижморский россия / кемеровская область / ижморский"
  },
  "4793": {
    "id": "4793",
    "name": "Инской",
    "path": "Россия / Кемеровская область / Инской",
    "country": "Россия",
    "searchString": "инской россия / кемеровская область / инской"
  },
  "4794": {
    "id": "4794",
    "name": "Итатский",
    "path": "Россия / Кемеровская область / Итатский",
    "country": "Россия",
    "searchString": "итатский россия / кемеровская область / итатский"
  },
  "4795": {
    "id": "4795",
    "name": "Каз",
    "path": "Россия / Кемеровская область / Каз",
    "country": "Россия",
    "searchString": "каз россия / кемеровская область / каз"
  },
  "4796": {
    "id": "4796",
    "name": "Краснобродский",
    "path": "Россия / Кемеровская область / Краснобродский",
    "country": "Россия",
    "searchString": "краснобродский россия / кемеровская область / краснобродский"
  },
  "4797": {
    "id": "4797",
    "name": "Карагайлинский",
    "path": "Россия / Кемеровская область / Карагайлинский",
    "country": "Россия",
    "searchString": "карагайлинский россия / кемеровская область / карагайлинский"
  },
  "4798": {
    "id": "4798",
    "name": "Кедровка",
    "path": "Россия / Кемеровская область / Кедровка",
    "country": "Россия",
    "searchString": "кедровка россия / кемеровская область / кедровка"
  },
  "4799": {
    "id": "4799",
    "name": "Крапивинский",
    "path": "Россия / Кемеровская область / Крапивинский",
    "country": "Россия",
    "searchString": "крапивинский россия / кемеровская область / крапивинский"
  },
  "4800": {
    "id": "4800",
    "name": "Красногорский (Кемеровская область)",
    "path": "Россия / Кемеровская область / Красногорский (Кемеровская область)",
    "country": "Россия",
    "searchString": "красногорский (кемеровская область) россия / кемеровская область / красногорский (кемеровская область)"
  },
  "4801": {
    "id": "4801",
    "name": "Кузедеево",
    "path": "Россия / Кемеровская область / Кузедеево",
    "country": "Россия",
    "searchString": "кузедеево россия / кемеровская область / кузедеево"
  },
  "4802": {
    "id": "4802",
    "name": "Новый Городок",
    "path": "Россия / Кемеровская область / Новый Городок",
    "country": "Россия",
    "searchString": "новый городок россия / кемеровская область / новый городок"
  },
  "4803": {
    "id": "4803",
    "name": "Малиновка",
    "path": "Россия / Кемеровская область / Малиновка",
    "country": "Россия",
    "searchString": "малиновка россия / кемеровская область / малиновка"
  },
  "4804": {
    "id": "4804",
    "name": "Мундыбаш",
    "path": "Россия / Кемеровская область / Мундыбаш",
    "country": "Россия",
    "searchString": "мундыбаш россия / кемеровская область / мундыбаш"
  },
  "4805": {
    "id": "4805",
    "name": "Солнечный (Кемеровская область)",
    "path": "Россия / Кемеровская область / Солнечный (Кемеровская область)",
    "country": "Россия",
    "searchString": "солнечный (кемеровская область) россия / кемеровская область / солнечный (кемеровская область)"
  },
  "4806": {
    "id": "4806",
    "name": "Плотниково",
    "path": "Россия / Кемеровская область / Плотниково",
    "country": "Россия",
    "searchString": "плотниково россия / кемеровская область / плотниково"
  },
  "4807": {
    "id": "4807",
    "name": "Старобачаты",
    "path": "Россия / Кемеровская область / Старобачаты",
    "country": "Россия",
    "searchString": "старобачаты россия / кемеровская область / старобачаты"
  },
  "4808": {
    "id": "4808",
    "name": "Старопестерево",
    "path": "Россия / Кемеровская область / Старопестерево",
    "country": "Россия",
    "searchString": "старопестерево россия / кемеровская область / старопестерево"
  },
  "4809": {
    "id": "4809",
    "name": "Тисуль",
    "path": "Россия / Кемеровская область / Тисуль",
    "country": "Россия",
    "searchString": "тисуль россия / кемеровская область / тисуль"
  },
  "4810": {
    "id": "4810",
    "name": "Тайжина",
    "path": "Россия / Кемеровская область / Тайжина",
    "country": "Россия",
    "searchString": "тайжина россия / кемеровская область / тайжина"
  },
  "4811": {
    "id": "4811",
    "name": "Темиртау (Кемеровская область)",
    "path": "Россия / Кемеровская область / Темиртау (Кемеровская область)",
    "country": "Россия",
    "searchString": "темиртау (кемеровская область) россия / кемеровская область / темиртау (кемеровская область)"
  },
  "4812": {
    "id": "4812",
    "name": "Тяжинский",
    "path": "Россия / Кемеровская область / Тяжинский",
    "country": "Россия",
    "searchString": "тяжинский россия / кемеровская область / тяжинский"
  },
  "4813": {
    "id": "4813",
    "name": "Чистогорский",
    "path": "Россия / Кемеровская область / Чистогорский",
    "country": "Россия",
    "searchString": "чистогорский россия / кемеровская область / чистогорский"
  },
  "4814": {
    "id": "4814",
    "name": "Шерегеш",
    "path": "Россия / Кемеровская область / Шерегеш",
    "country": "Россия",
    "searchString": "шерегеш россия / кемеровская область / шерегеш"
  },
  "4815": {
    "id": "4815",
    "name": "Ясногорский",
    "path": "Россия / Кемеровская область / Ясногорский",
    "country": "Россия",
    "searchString": "ясногорский россия / кемеровская область / ясногорский"
  },
  "4816": {
    "id": "4816",
    "name": "Яшкино",
    "path": "Россия / Кемеровская область / Яшкино",
    "country": "Россия",
    "searchString": "яшкино россия / кемеровская область / яшкино"
  },
  "4817": {
    "id": "4817",
    "name": "Яя",
    "path": "Россия / Кемеровская область / Яя",
    "country": "Россия",
    "searchString": "яя россия / кемеровская область / яя"
  },
  "4818": {
    "id": "4818",
    "name": "Кош-Агач",
    "path": "Россия / Республика Алтай / Кош-Агач",
    "country": "Россия",
    "searchString": "кош-агач россия / республика алтай / кош-агач"
  },
  "4819": {
    "id": "4819",
    "name": "Майма",
    "path": "Россия / Республика Алтай / Майма",
    "country": "Россия",
    "searchString": "майма россия / республика алтай / майма"
  },
  "4820": {
    "id": "4820",
    "name": "Онгудай",
    "path": "Россия / Республика Алтай / Онгудай",
    "country": "Россия",
    "searchString": "онгудай россия / республика алтай / онгудай"
  },
  "4821": {
    "id": "4821",
    "name": "Турочак",
    "path": "Россия / Республика Алтай / Турочак",
    "country": "Россия",
    "searchString": "турочак россия / республика алтай / турочак"
  },
  "4822": {
    "id": "4822",
    "name": "Улаган",
    "path": "Россия / Республика Алтай / Улаган",
    "country": "Россия",
    "searchString": "улаган россия / республика алтай / улаган"
  },
  "4823": {
    "id": "4823",
    "name": "Усть-Кан",
    "path": "Россия / Республика Алтай / Усть-Кан",
    "country": "Россия",
    "searchString": "усть-кан россия / республика алтай / усть-кан"
  },
  "4824": {
    "id": "4824",
    "name": "Усть-Кокса",
    "path": "Россия / Республика Алтай / Усть-Кокса",
    "country": "Россия",
    "searchString": "усть-кокса россия / республика алтай / усть-кокса"
  },
  "4825": {
    "id": "4825",
    "name": "Чемал",
    "path": "Россия / Республика Алтай / Чемал",
    "country": "Россия",
    "searchString": "чемал россия / республика алтай / чемал"
  },
  "4826": {
    "id": "4826",
    "name": "Чоя",
    "path": "Россия / Республика Алтай / Чоя",
    "country": "Россия",
    "searchString": "чоя россия / республика алтай / чоя"
  },
  "4827": {
    "id": "4827",
    "name": "Шебалино",
    "path": "Россия / Республика Алтай / Шебалино",
    "country": "Россия",
    "searchString": "шебалино россия / республика алтай / шебалино"
  },
  "4828": {
    "id": "4828",
    "name": "Альменево",
    "path": "Россия / Курганская область / Альменево",
    "country": "Россия",
    "searchString": "альменево россия / курганская область / альменево"
  },
  "4829": {
    "id": "4829",
    "name": "Баган",
    "path": "Россия / Новосибирская область / Баган",
    "country": "Россия",
    "searchString": "баган россия / новосибирская область / баган"
  },
  "4830": {
    "id": "4830",
    "name": "Верх-Ирмень",
    "path": "Россия / Новосибирская область / Верх-Ирмень",
    "country": "Россия",
    "searchString": "верх-ирмень россия / новосибирская область / верх-ирмень"
  },
  "4831": {
    "id": "4831",
    "name": "Верх-Тула",
    "path": "Россия / Новосибирская область / Верх-Тула",
    "country": "Россия",
    "searchString": "верх-тула россия / новосибирская область / верх-тула"
  },
  "4832": {
    "id": "4832",
    "name": "Горный",
    "path": "Россия / Новосибирская область / Горный",
    "country": "Россия",
    "searchString": "горный россия / новосибирская область / горный"
  },
  "4833": {
    "id": "4833",
    "name": "Дорогино",
    "path": "Россия / Новосибирская область / Дорогино",
    "country": "Россия",
    "searchString": "дорогино россия / новосибирская область / дорогино"
  },
  "4834": {
    "id": "4834",
    "name": "Здвинск",
    "path": "Россия / Новосибирская область / Здвинск",
    "country": "Россия",
    "searchString": "здвинск россия / новосибирская область / здвинск"
  },
  "4835": {
    "id": "4835",
    "name": "Кирза",
    "path": "Россия / Новосибирская область / Кирза",
    "country": "Россия",
    "searchString": "кирза россия / новосибирская область / кирза"
  },
  "4836": {
    "id": "4836",
    "name": "Кочки",
    "path": "Россия / Новосибирская область / Кочки",
    "country": "Россия",
    "searchString": "кочки россия / новосибирская область / кочки"
  },
  "4837": {
    "id": "4837",
    "name": "Краснозерское",
    "path": "Россия / Новосибирская область / Краснозерское",
    "country": "Россия",
    "searchString": "краснозерское россия / новосибирская область / краснозерское"
  },
  "4838": {
    "id": "4838",
    "name": "Криводановка",
    "path": "Россия / Новосибирская область / Криводановка",
    "country": "Россия",
    "searchString": "криводановка россия / новосибирская область / криводановка"
  },
  "4839": {
    "id": "4839",
    "name": "Кудряшовский",
    "path": "Россия / Новосибирская область / Кудряшовский",
    "country": "Россия",
    "searchString": "кудряшовский россия / новосибирская область / кудряшовский"
  },
  "4840": {
    "id": "4840",
    "name": "Кыштовка",
    "path": "Россия / Новосибирская область / Кыштовка",
    "country": "Россия",
    "searchString": "кыштовка россия / новосибирская область / кыштовка"
  },
  "4841": {
    "id": "4841",
    "name": "Линево (Новосибирская область)",
    "path": "Россия / Новосибирская область / Линево (Новосибирская область)",
    "country": "Россия",
    "searchString": "линево (новосибирская область) россия / новосибирская область / линево (новосибирская область)"
  },
  "4842": {
    "id": "4842",
    "name": "Листвянский",
    "path": "Россия / Новосибирская область / Листвянский",
    "country": "Россия",
    "searchString": "листвянский россия / новосибирская область / листвянский"
  },
  "4843": {
    "id": "4843",
    "name": "Маслянино",
    "path": "Россия / Новосибирская область / Маслянино",
    "country": "Россия",
    "searchString": "маслянино россия / новосибирская область / маслянино"
  },
  "4844": {
    "id": "4844",
    "name": "Ленинское (Новосибирская область)",
    "path": "Россия / Новосибирская область / Ленинское (Новосибирская область)",
    "country": "Россия",
    "searchString": "ленинское (новосибирская область) россия / новосибирская область / ленинское (новосибирская область)"
  },
  "4845": {
    "id": "4845",
    "name": "Новолуговое",
    "path": "Россия / Новосибирская область / Новолуговое",
    "country": "Россия",
    "searchString": "новолуговое россия / новосибирская область / новолуговое"
  },
  "4846": {
    "id": "4846",
    "name": "Посевная",
    "path": "Россия / Новосибирская область / Посевная",
    "country": "Россия",
    "searchString": "посевная россия / новосибирская область / посевная"
  },
  "4847": {
    "id": "4847",
    "name": "Северное (Новосибирская область)",
    "path": "Россия / Новосибирская область / Северное (Новосибирская область)",
    "country": "Россия",
    "searchString": "северное (новосибирская область) россия / новосибирская область / северное (новосибирская область)"
  },
  "4848": {
    "id": "4848",
    "name": "Сокур (Новосибирская область)",
    "path": "Россия / Новосибирская область / Сокур (Новосибирская область)",
    "country": "Россия",
    "searchString": "сокур (новосибирская область) россия / новосибирская область / сокур (новосибирская область)"
  },
  "4849": {
    "id": "4849",
    "name": "Ташара",
    "path": "Россия / Новосибирская область / Ташара",
    "country": "Россия",
    "searchString": "ташара россия / новосибирская область / ташара"
  },
  "4850": {
    "id": "4850",
    "name": "Толмачево",
    "path": "Россия / Новосибирская область / Толмачево",
    "country": "Россия",
    "searchString": "толмачево россия / новосибирская область / толмачево"
  },
  "4851": {
    "id": "4851",
    "name": "Чик",
    "path": "Россия / Новосибирская область / Чик",
    "country": "Россия",
    "searchString": "чик россия / новосибирская область / чик"
  },
  "4852": {
    "id": "4852",
    "name": "Чумаково",
    "path": "Россия / Новосибирская область / Чумаково",
    "country": "Россия",
    "searchString": "чумаково россия / новосибирская область / чумаково"
  },
  "4853": {
    "id": "4853",
    "name": "Ярково",
    "path": "Россия / Новосибирская область / Ярково",
    "country": "Россия",
    "searchString": "ярково россия / новосибирская область / ярково"
  },
  "4854": {
    "id": "4854",
    "name": "Алексеевск",
    "path": "Россия / Иркутская область / Алексеевск",
    "country": "Россия",
    "searchString": "алексеевск россия / иркутская область / алексеевск"
  },
  "4855": {
    "id": "4855",
    "name": "Балаганск",
    "path": "Россия / Иркутская область / Балаганск",
    "country": "Россия",
    "searchString": "балаганск россия / иркутская область / балаганск"
  },
  "4856": {
    "id": "4856",
    "name": "Белореченский",
    "path": "Россия / Иркутская область / Белореченский",
    "country": "Россия",
    "searchString": "белореченский россия / иркутская область / белореченский"
  },
  "4857": {
    "id": "4857",
    "name": "Большой Луг",
    "path": "Россия / Иркутская область / Большой Луг",
    "country": "Россия",
    "searchString": "большой луг россия / иркутская область / большой луг"
  },
  "4858": {
    "id": "4858",
    "name": "Бохан",
    "path": "Россия / Иркутская область / Бохан",
    "country": "Россия",
    "searchString": "бохан россия / иркутская область / бохан"
  },
  "4859": {
    "id": "4859",
    "name": "Еланцы",
    "path": "Россия / Иркутская область / Еланцы",
    "country": "Россия",
    "searchString": "еланцы россия / иркутская область / еланцы"
  },
  "4860": {
    "id": "4860",
    "name": "Железнодорожный (Иркутская область)",
    "path": "Россия / Иркутская область / Железнодорожный (Иркутская область)",
    "country": "Россия",
    "searchString": "железнодорожный (иркутская область) россия / иркутская область / железнодорожный (иркутская область)"
  },
  "4861": {
    "id": "4861",
    "name": "Жигалово",
    "path": "Россия / Иркутская область / Жигалово",
    "country": "Россия",
    "searchString": "жигалово россия / иркутская область / жигалово"
  },
  "4862": {
    "id": "4862",
    "name": "Качуг",
    "path": "Россия / Иркутская область / Качуг",
    "country": "Россия",
    "searchString": "качуг россия / иркутская область / качуг"
  },
  "4863": {
    "id": "4863",
    "name": "Квиток",
    "path": "Россия / Иркутская область / Квиток",
    "country": "Россия",
    "searchString": "квиток россия / иркутская область / квиток"
  },
  "4864": {
    "id": "4864",
    "name": "Гидростроитель",
    "path": "Россия / Иркутская область / Гидростроитель",
    "country": "Россия",
    "searchString": "гидростроитель россия / иркутская область / гидростроитель"
  },
  "4865": {
    "id": "4865",
    "name": "Куйтун",
    "path": "Россия / Иркутская область / Куйтун",
    "country": "Россия",
    "searchString": "куйтун россия / иркутская область / куйтун"
  },
  "4866": {
    "id": "4866",
    "name": "Култук",
    "path": "Россия / Иркутская область / Култук",
    "country": "Россия",
    "searchString": "култук россия / иркутская область / култук"
  },
  "4867": {
    "id": "4867",
    "name": "Кутулик",
    "path": "Россия / Иркутская область / Кутулик",
    "country": "Россия",
    "searchString": "кутулик россия / иркутская область / кутулик"
  },
  "4868": {
    "id": "4868",
    "name": "Лесогорск",
    "path": "Россия / Иркутская область / Лесогорск",
    "country": "Россия",
    "searchString": "лесогорск россия / иркутская область / лесогорск"
  },
  "4869": {
    "id": "4869",
    "name": "Магистральный",
    "path": "Россия / Иркутская область / Магистральный",
    "country": "Россия",
    "searchString": "магистральный россия / иркутская область / магистральный"
  },
  "4870": {
    "id": "4870",
    "name": "Мама",
    "path": "Россия / Иркутская область / Мама",
    "country": "Россия",
    "searchString": "мама россия / иркутская область / мама"
  },
  "4871": {
    "id": "4871",
    "name": "Маркова",
    "path": "Россия / Иркутская область / Маркова",
    "country": "Россия",
    "searchString": "маркова россия / иркутская область / маркова"
  },
  "4872": {
    "id": "4872",
    "name": "Мегет",
    "path": "Россия / Иркутская область / Мегет",
    "country": "Россия",
    "searchString": "мегет россия / иркутская область / мегет"
  },
  "4873": {
    "id": "4873",
    "name": "Михайловка (Иркутская область)",
    "path": "Россия / Иркутская область / Михайловка (Иркутская область)",
    "country": "Россия",
    "searchString": "михайловка (иркутская область) россия / иркутская область / михайловка (иркутская область)"
  },
  "4874": {
    "id": "4874",
    "name": "Мишелевка",
    "path": "Россия / Иркутская область / Мишелевка",
    "country": "Россия",
    "searchString": "мишелевка россия / иркутская область / мишелевка"
  },
  "4875": {
    "id": "4875",
    "name": "Новая Игирма",
    "path": "Россия / Иркутская область / Новая Игирма",
    "country": "Россия",
    "searchString": "новая игирма россия / иркутская область / новая игирма"
  },
  "4876": {
    "id": "4876",
    "name": "Новобирюсинский",
    "path": "Россия / Иркутская область / Новобирюсинский",
    "country": "Россия",
    "searchString": "новобирюсинский россия / иркутская область / новобирюсинский"
  },
  "4877": {
    "id": "4877",
    "name": "Новонукутский",
    "path": "Россия / Иркутская область / Новонукутский",
    "country": "Россия",
    "searchString": "новонукутский россия / иркутская область / новонукутский"
  },
  "4878": {
    "id": "4878",
    "name": "Оек",
    "path": "Россия / Иркутская область / Оек",
    "country": "Россия",
    "searchString": "оек россия / иркутская область / оек"
  },
  "4879": {
    "id": "4879",
    "name": "Октябрьский (Иркутская область)",
    "path": "Россия / Иркутская область / Октябрьский (Иркутская область)",
    "country": "Россия",
    "searchString": "октябрьский (иркутская область) россия / иркутская область / октябрьский (иркутская область)"
  },
  "4880": {
    "id": "4880",
    "name": "Оса (Иркутская область)",
    "path": "Россия / Иркутская область / Оса (Иркутская область)",
    "country": "Россия",
    "searchString": "оса (иркутская область) россия / иркутская область / оса (иркутская область)"
  },
  "4881": {
    "id": "4881",
    "name": "Рудногорск",
    "path": "Россия / Иркутская область / Рудногорск",
    "country": "Россия",
    "searchString": "рудногорск россия / иркутская область / рудногорск"
  },
  "4882": {
    "id": "4882",
    "name": "Средний",
    "path": "Россия / Иркутская область / Средний",
    "country": "Россия",
    "searchString": "средний россия / иркутская область / средний"
  },
  "4883": {
    "id": "4883",
    "name": "Тайтурка",
    "path": "Россия / Иркутская область / Тайтурка",
    "country": "Россия",
    "searchString": "тайтурка россия / иркутская область / тайтурка"
  },
  "4884": {
    "id": "4884",
    "name": "Тельма",
    "path": "Россия / Иркутская область / Тельма",
    "country": "Россия",
    "searchString": "тельма россия / иркутская область / тельма"
  },
  "4885": {
    "id": "4885",
    "name": "Тыреть 1-я",
    "path": "Россия / Иркутская область / Тыреть 1-я",
    "country": "Россия",
    "searchString": "тыреть 1-я россия / иркутская область / тыреть 1-я"
  },
  "4886": {
    "id": "4886",
    "name": "Улькан",
    "path": "Россия / Иркутская область / Улькан",
    "country": "Россия",
    "searchString": "улькан россия / иркутская область / улькан"
  },
  "4887": {
    "id": "4887",
    "name": "Усть-Уда",
    "path": "Россия / Иркутская область / Усть-Уда",
    "country": "Россия",
    "searchString": "усть-уда россия / иркутская область / усть-уда"
  },
  "4888": {
    "id": "4888",
    "name": "Хомутово (Иркутская область)",
    "path": "Россия / Иркутская область / Хомутово (Иркутская область)",
    "country": "Россия",
    "searchString": "хомутово (иркутская область) россия / иркутская область / хомутово (иркутская область)"
  },
  "4889": {
    "id": "4889",
    "name": "Чунский",
    "path": "Россия / Иркутская область / Чунский",
    "country": "Россия",
    "searchString": "чунский россия / иркутская область / чунский"
  },
  "4890": {
    "id": "4890",
    "name": "Юрты",
    "path": "Россия / Иркутская область / Юрты",
    "country": "Россия",
    "searchString": "юрты россия / иркутская область / юрты"
  },
  "4891": {
    "id": "4891",
    "name": "Черемушки",
    "path": "Россия / Иркутская область / Черемушки",
    "country": "Россия",
    "searchString": "черемушки россия / иркутская область / черемушки"
  },
  "4892": {
    "id": "4892",
    "name": "Алтайское",
    "path": "Россия / Алтайский край / Алтайское",
    "country": "Россия",
    "searchString": "алтайское россия / алтайский край / алтайское"
  },
  "4893": {
    "id": "4893",
    "name": "Баево",
    "path": "Россия / Алтайский край / Баево",
    "country": "Россия",
    "searchString": "баево россия / алтайский край / баево"
  },
  "4894": {
    "id": "4894",
    "name": "Белоярск",
    "path": "Россия / Алтайский край / Белоярск",
    "country": "Россия",
    "searchString": "белоярск россия / алтайский край / белоярск"
  },
  "4895": {
    "id": "4895",
    "name": "Березовка (Алтайский край)",
    "path": "Россия / Алтайский край / Березовка (Алтайский край)",
    "country": "Россия",
    "searchString": "березовка (алтайский край) россия / алтайский край / березовка (алтайский край)"
  },
  "4896": {
    "id": "4896",
    "name": "Благовещенка",
    "path": "Россия / Алтайский край / Благовещенка",
    "country": "Россия",
    "searchString": "благовещенка россия / алтайский край / благовещенка"
  },
  "4897": {
    "id": "4897",
    "name": "Боровиха",
    "path": "Россия / Алтайский край / Боровиха",
    "country": "Россия",
    "searchString": "боровиха россия / алтайский край / боровиха"
  },
  "4898": {
    "id": "4898",
    "name": "Бурла",
    "path": "Россия / Алтайский край / Бурла",
    "country": "Россия",
    "searchString": "бурла россия / алтайский край / бурла"
  },
  "4899": {
    "id": "4899",
    "name": "Быстрый Исток",
    "path": "Россия / Алтайский край / Быстрый Исток",
    "country": "Россия",
    "searchString": "быстрый исток россия / алтайский край / быстрый исток"
  },
  "4900": {
    "id": "4900",
    "name": "Верх-Катунское",
    "path": "Россия / Алтайский край / Верх-Катунское",
    "country": "Россия",
    "searchString": "верх-катунское россия / алтайский край / верх-катунское"
  },
  "4901": {
    "id": "4901",
    "name": "Власиха (Алтайский край)",
    "path": "Россия / Алтайский край / Власиха (Алтайский край)",
    "country": "Россия",
    "searchString": "власиха (алтайский край) россия / алтайский край / власиха (алтайский край)"
  },
  "4902": {
    "id": "4902",
    "name": "Волчиха",
    "path": "Россия / Алтайский край / Волчиха",
    "country": "Россия",
    "searchString": "волчиха россия / алтайский край / волчиха"
  },
  "4903": {
    "id": "4903",
    "name": "Ельцовка",
    "path": "Россия / Алтайский край / Ельцовка",
    "country": "Россия",
    "searchString": "ельцовка россия / алтайский край / ельцовка"
  },
  "4904": {
    "id": "4904",
    "name": "Завьялово (Алтайский край)",
    "path": "Россия / Алтайский край / Завьялово (Алтайский край)",
    "country": "Россия",
    "searchString": "завьялово (алтайский край) россия / алтайский край / завьялово (алтайский край)"
  },
  "4905": {
    "id": "4905",
    "name": "Залесово",
    "path": "Россия / Алтайский край / Залесово",
    "country": "Россия",
    "searchString": "залесово россия / алтайский край / залесово"
  },
  "4906": {
    "id": "4906",
    "name": "Зелёная Дубрава",
    "path": "Россия / Алтайский край / Зелёная Дубрава",
    "country": "Россия",
    "searchString": "зелёная дубрава россия / алтайский край / зелёная дубрава"
  },
  "4907": {
    "id": "4907",
    "name": "Зональное",
    "path": "Россия / Алтайский край / Зональное",
    "country": "Россия",
    "searchString": "зональное россия / алтайский край / зональное"
  },
  "4908": {
    "id": "4908",
    "name": "Зудилово",
    "path": "Россия / Алтайский край / Зудилово",
    "country": "Россия",
    "searchString": "зудилово россия / алтайский край / зудилово"
  },
  "4909": {
    "id": "4909",
    "name": "Калманка",
    "path": "Россия / Алтайский край / Калманка",
    "country": "Россия",
    "searchString": "калманка россия / алтайский край / калманка"
  },
  "4910": {
    "id": "4910",
    "name": "Ключи (Алтайский край)",
    "path": "Россия / Алтайский край / Ключи (Алтайский край)",
    "country": "Россия",
    "searchString": "ключи (алтайский край) россия / алтайский край / ключи (алтайский край)"
  },
  "4911": {
    "id": "4911",
    "name": "Косиха",
    "path": "Россия / Алтайский край / Косиха",
    "country": "Россия",
    "searchString": "косиха россия / алтайский край / косиха"
  },
  "4912": {
    "id": "4912",
    "name": "Красногорское (Алтайский край)",
    "path": "Россия / Алтайский край / Красногорское (Алтайский край)",
    "country": "Россия",
    "searchString": "красногорское (алтайский край) россия / алтайский край / красногорское (алтайский край)"
  },
  "4913": {
    "id": "4913",
    "name": "Краснощёково",
    "path": "Россия / Алтайский край / Краснощёково",
    "country": "Россия",
    "searchString": "краснощёково россия / алтайский край / краснощёково"
  },
  "4914": {
    "id": "4914",
    "name": "Крутиха",
    "path": "Россия / Алтайский край / Крутиха",
    "country": "Россия",
    "searchString": "крутиха россия / алтайский край / крутиха"
  },
  "4915": {
    "id": "4915",
    "name": "Курья",
    "path": "Россия / Алтайский край / Курья",
    "country": "Россия",
    "searchString": "курья россия / алтайский край / курья"
  },
  "4916": {
    "id": "4916",
    "name": "Кытманово",
    "path": "Россия / Алтайский край / Кытманово",
    "country": "Россия",
    "searchString": "кытманово россия / алтайский край / кытманово"
  },
  "4917": {
    "id": "4917",
    "name": "Лебяжье (Алтайский край)",
    "path": "Россия / Алтайский край / Лебяжье (Алтайский край)",
    "country": "Россия",
    "searchString": "лебяжье (алтайский край) россия / алтайский край / лебяжье (алтайский край)"
  },
  "4918": {
    "id": "4918",
    "name": "Леньки",
    "path": "Россия / Алтайский край / Леньки",
    "country": "Россия",
    "searchString": "леньки россия / алтайский край / леньки"
  },
  "4919": {
    "id": "4919",
    "name": "Малиновое Озеро",
    "path": "Россия / Алтайский край / Малиновое Озеро",
    "country": "Россия",
    "searchString": "малиновое озеро россия / алтайский край / малиновое озеро"
  },
  "4920": {
    "id": "4920",
    "name": "Михайловское",
    "path": "Россия / Алтайский край / Михайловское",
    "country": "Россия",
    "searchString": "михайловское россия / алтайский край / михайловское"
  },
  "4921": {
    "id": "4921",
    "name": "Налобиха",
    "path": "Россия / Алтайский край / Налобиха",
    "country": "Россия",
    "searchString": "налобиха россия / алтайский край / налобиха"
  },
  "4922": {
    "id": "4922",
    "name": "Новичиха",
    "path": "Россия / Алтайский край / Новичиха",
    "country": "Россия",
    "searchString": "новичиха россия / алтайский край / новичиха"
  },
  "4923": {
    "id": "4923",
    "name": "Новоегорьевское",
    "path": "Россия / Алтайский край / Новоегорьевское",
    "country": "Россия",
    "searchString": "новоегорьевское россия / алтайский край / новоегорьевское"
  },
  "4924": {
    "id": "4924",
    "name": "Новые Зори",
    "path": "Россия / Алтайский край / Новые Зори",
    "country": "Россия",
    "searchString": "новые зори россия / алтайский край / новые зори"
  },
  "4925": {
    "id": "4925",
    "name": "Озерки (Алтайский край)",
    "path": "Россия / Алтайский край / Озерки (Алтайский край)",
    "country": "Россия",
    "searchString": "озерки (алтайский край) россия / алтайский край / озерки (алтайский край)"
  },
  "4926": {
    "id": "4926",
    "name": "Павловск (Алтайский край)",
    "path": "Россия / Алтайский край / Павловск (Алтайский край)",
    "country": "Россия",
    "searchString": "павловск (алтайский край) россия / алтайский край / павловск (алтайский край)"
  },
  "4927": {
    "id": "4927",
    "name": "Панкрушиха",
    "path": "Россия / Алтайский край / Панкрушиха",
    "country": "Россия",
    "searchString": "панкрушиха россия / алтайский край / панкрушиха"
  },
  "4928": {
    "id": "4928",
    "name": "Первомайское (Алтайский край)",
    "path": "Россия / Алтайский край / Первомайское (Алтайский край)",
    "country": "Россия",
    "searchString": "первомайское (алтайский край) россия / алтайский край / первомайское (алтайский край)"
  },
  "4929": {
    "id": "4929",
    "name": "Петропавловское",
    "path": "Россия / Алтайский край / Петропавловское",
    "country": "Россия",
    "searchString": "петропавловское россия / алтайский край / петропавловское"
  },
  "4930": {
    "id": "4930",
    "name": "Поспелиха",
    "path": "Россия / Алтайский край / Поспелиха",
    "country": "Россия",
    "searchString": "поспелиха россия / алтайский край / поспелиха"
  },
  "4931": {
    "id": "4931",
    "name": "Ребриха",
    "path": "Россия / Алтайский край / Ребриха",
    "country": "Россия",
    "searchString": "ребриха россия / алтайский край / ребриха"
  },
  "4932": {
    "id": "4932",
    "name": "Романово",
    "path": "Россия / Алтайский край / Романово",
    "country": "Россия",
    "searchString": "романово россия / алтайский край / романово"
  },
  "4933": {
    "id": "4933",
    "name": "Сибирский",
    "path": "Россия / Алтайский край / Сибирский",
    "country": "Россия",
    "searchString": "сибирский россия / алтайский край / сибирский"
  },
  "4934": {
    "id": "4934",
    "name": "Славгородское",
    "path": "Россия / Алтайский край / Славгородское",
    "country": "Россия",
    "searchString": "славгородское россия / алтайский край / славгородское"
  },
  "4935": {
    "id": "4935",
    "name": "Смоленское",
    "path": "Россия / Алтайский край / Смоленское",
    "country": "Россия",
    "searchString": "смоленское россия / алтайский край / смоленское"
  },
  "4936": {
    "id": "4936",
    "name": "Соколово",
    "path": "Россия / Алтайский край / Соколово",
    "country": "Россия",
    "searchString": "соколово россия / алтайский край / соколово"
  },
  "4937": {
    "id": "4937",
    "name": "Солонешное",
    "path": "Россия / Алтайский край / Солонешное",
    "country": "Россия",
    "searchString": "солонешное россия / алтайский край / солонешное"
  },
  "4938": {
    "id": "4938",
    "name": "Солтон",
    "path": "Россия / Алтайский край / Солтон",
    "country": "Россия",
    "searchString": "солтон россия / алтайский край / солтон"
  },
  "4939": {
    "id": "4939",
    "name": "Сростки",
    "path": "Россия / Алтайский край / Сростки",
    "country": "Россия",
    "searchString": "сростки россия / алтайский край / сростки"
  },
  "4940": {
    "id": "4940",
    "name": "Староалейское",
    "path": "Россия / Алтайский край / Староалейское",
    "country": "Россия",
    "searchString": "староалейское россия / алтайский край / староалейское"
  },
  "4941": {
    "id": "4941",
    "name": "Степное Озеро",
    "path": "Россия / Алтайский край / Степное Озеро",
    "country": "Россия",
    "searchString": "степное озеро россия / алтайский край / степное озеро"
  },
  "4942": {
    "id": "4942",
    "name": "Табуны",
    "path": "Россия / Алтайский край / Табуны",
    "country": "Россия",
    "searchString": "табуны россия / алтайский край / табуны"
  },
  "4943": {
    "id": "4943",
    "name": "Тогул",
    "path": "Россия / Алтайский край / Тогул",
    "country": "Россия",
    "searchString": "тогул россия / алтайский край / тогул"
  },
  "4944": {
    "id": "4944",
    "name": "Топчиха",
    "path": "Россия / Алтайский край / Топчиха",
    "country": "Россия",
    "searchString": "топчиха россия / алтайский край / топчиха"
  },
  "4945": {
    "id": "4945",
    "name": "Тюменцево",
    "path": "Россия / Алтайский край / Тюменцево",
    "country": "Россия",
    "searchString": "тюменцево россия / алтайский край / тюменцево"
  },
  "4946": {
    "id": "4946",
    "name": "Угловское",
    "path": "Россия / Алтайский край / Угловское",
    "country": "Россия",
    "searchString": "угловское россия / алтайский край / угловское"
  },
  "4947": {
    "id": "4947",
    "name": "Усть-Чарышская Пристань",
    "path": "Россия / Алтайский край / Усть-Чарышская Пристань",
    "country": "Россия",
    "searchString": "усть-чарышская пристань россия / алтайский край / усть-чарышская пристань"
  },
  "4948": {
    "id": "4948",
    "name": "Хабары",
    "path": "Россия / Алтайский край / Хабары",
    "country": "Россия",
    "searchString": "хабары россия / алтайский край / хабары"
  },
  "4949": {
    "id": "4949",
    "name": "Целинное",
    "path": "Россия / Алтайский край / Целинное",
    "country": "Россия",
    "searchString": "целинное россия / алтайский край / целинное"
  },
  "4950": {
    "id": "4950",
    "name": "Черемное",
    "path": "Россия / Алтайский край / Черемное",
    "country": "Россия",
    "searchString": "черемное россия / алтайский край / черемное"
  },
  "4951": {
    "id": "4951",
    "name": "Шелаболиха",
    "path": "Россия / Алтайский край / Шелаболиха",
    "country": "Россия",
    "searchString": "шелаболиха россия / алтайский край / шелаболиха"
  },
  "4952": {
    "id": "4952",
    "name": "Южный (Алтайский край)",
    "path": "Россия / Алтайский край / Южный (Алтайский край)",
    "country": "Россия",
    "searchString": "южный (алтайский край) россия / алтайский край / южный (алтайский край)"
  },
  "4953": {
    "id": "4953",
    "name": "Белозерское (Курганская область)",
    "path": "Россия / Курганская область / Белозерское (Курганская область)",
    "country": "Россия",
    "searchString": "белозерское (курганская область) россия / курганская область / белозерское (курганская область)"
  },
  "4954": {
    "id": "4954",
    "name": "Варгаши",
    "path": "Россия / Курганская область / Варгаши",
    "country": "Россия",
    "searchString": "варгаши россия / курганская область / варгаши"
  },
  "4955": {
    "id": "4955",
    "name": "Введенское",
    "path": "Россия / Курганская область / Введенское",
    "country": "Россия",
    "searchString": "введенское россия / курганская область / введенское"
  },
  "4956": {
    "id": "4956",
    "name": "Глядянское",
    "path": "Россия / Курганская область / Глядянское",
    "country": "Россия",
    "searchString": "глядянское россия / курганская область / глядянское"
  },
  "4957": {
    "id": "4957",
    "name": "Звериноголовское",
    "path": "Россия / Курганская область / Звериноголовское",
    "country": "Россия",
    "searchString": "звериноголовское россия / курганская область / звериноголовское"
  },
  "4958": {
    "id": "4958",
    "name": "Иковка",
    "path": "Россия / Курганская область / Иковка",
    "country": "Россия",
    "searchString": "иковка россия / курганская область / иковка"
  },
  "4959": {
    "id": "4959",
    "name": "Кетово",
    "path": "Россия / Курганская область / Кетово",
    "country": "Россия",
    "searchString": "кетово россия / курганская область / кетово"
  },
  "4960": {
    "id": "4960",
    "name": "Красный Октябрь (Курганская область)",
    "path": "Россия / Курганская область / Красный Октябрь (Курганская область)",
    "country": "Россия",
    "searchString": "красный октябрь (курганская область) россия / курганская область / красный октябрь (курганская область)"
  },
  "4961": {
    "id": "4961",
    "name": "Лебяжье (Курганская область)",
    "path": "Россия / Курганская область / Лебяжье (Курганская область)",
    "country": "Россия",
    "searchString": "лебяжье (курганская область) россия / курганская область / лебяжье (курганская область)"
  },
  "4962": {
    "id": "4962",
    "name": "Лесниково",
    "path": "Россия / Курганская область / Лесниково",
    "country": "Россия",
    "searchString": "лесниково россия / курганская область / лесниково"
  },
  "4963": {
    "id": "4963",
    "name": "Мокроусово",
    "path": "Россия / Курганская область / Мокроусово",
    "country": "Россия",
    "searchString": "мокроусово россия / курганская область / мокроусово"
  },
  "4964": {
    "id": "4964",
    "name": "Половинное",
    "path": "Россия / Курганская область / Половинное",
    "country": "Россия",
    "searchString": "половинное россия / курганская область / половинное"
  },
  "4965": {
    "id": "4965",
    "name": "Сафакулево",
    "path": "Россия / Курганская область / Сафакулево",
    "country": "Россия",
    "searchString": "сафакулево россия / курганская область / сафакулево"
  },
  "4966": {
    "id": "4966",
    "name": "Уксянское",
    "path": "Россия / Курганская область / Уксянское",
    "country": "Россия",
    "searchString": "уксянское россия / курганская область / уксянское"
  },
  "4967": {
    "id": "4967",
    "name": "Целинное (Курганская область)",
    "path": "Россия / Курганская область / Целинное (Курганская область)",
    "country": "Россия",
    "searchString": "целинное (курганская область) россия / курганская область / целинное (курганская область)"
  },
  "4968": {
    "id": "4968",
    "name": "Частоозерье",
    "path": "Россия / Курганская область / Частоозерье",
    "country": "Россия",
    "searchString": "частоозерье россия / курганская область / частоозерье"
  },
  "4969": {
    "id": "4969",
    "name": "Шатрово",
    "path": "Россия / Курганская область / Шатрово",
    "country": "Россия",
    "searchString": "шатрово россия / курганская область / шатрово"
  },
  "4970": {
    "id": "4970",
    "name": "Абатское",
    "path": "Россия / Тюменская область / Абатское",
    "country": "Россия",
    "searchString": "абатское россия / тюменская область / абатское"
  },
  "4971": {
    "id": "4971",
    "name": "Антипино",
    "path": "Россия / Тюменская область / Антипино",
    "country": "Россия",
    "searchString": "антипино россия / тюменская область / антипино"
  },
  "4972": {
    "id": "4972",
    "name": "Армизонское",
    "path": "Россия / Тюменская область / Армизонское",
    "country": "Россия",
    "searchString": "армизонское россия / тюменская область / армизонское"
  },
  "4973": {
    "id": "4973",
    "name": "Аромашево",
    "path": "Россия / Тюменская область / Аромашево",
    "country": "Россия",
    "searchString": "аромашево россия / тюменская область / аромашево"
  },
  "4974": {
    "id": "4974",
    "name": "Бердюжье",
    "path": "Россия / Тюменская область / Бердюжье",
    "country": "Россия",
    "searchString": "бердюжье россия / тюменская область / бердюжье"
  },
  "4975": {
    "id": "4975",
    "name": "Богандинский",
    "path": "Россия / Тюменская область / Богандинский",
    "country": "Россия",
    "searchString": "богандинский россия / тюменская область / богандинский"
  },
  "4976": {
    "id": "4976",
    "name": "Большое",
    "path": "Россия / Тюменская область / Большое",
    "country": "Россия",
    "searchString": "большое россия / тюменская область / большое"
  },
  "4977": {
    "id": "4977",
    "name": "Большое Сорокино",
    "path": "Россия / Тюменская область / Большое Сорокино",
    "country": "Россия",
    "searchString": "большое сорокино россия / тюменская область / большое сорокино"
  },
  "4978": {
    "id": "4978",
    "name": "Боровский",
    "path": "Россия / Тюменская область / Боровский",
    "country": "Россия",
    "searchString": "боровский россия / тюменская область / боровский"
  },
  "4979": {
    "id": "4979",
    "name": "Вагай",
    "path": "Россия / Тюменская область / Вагай",
    "country": "Россия",
    "searchString": "вагай россия / тюменская область / вагай"
  },
  "4980": {
    "id": "4980",
    "name": "Викулово",
    "path": "Россия / Тюменская область / Викулово",
    "country": "Россия",
    "searchString": "викулово россия / тюменская область / викулово"
  },
  "4981": {
    "id": "4981",
    "name": "Винзили",
    "path": "Россия / Тюменская область / Винзили",
    "country": "Россия",
    "searchString": "винзили россия / тюменская область / винзили"
  },
  "4982": {
    "id": "4982",
    "name": "Исетское",
    "path": "Россия / Тюменская область / Исетское",
    "country": "Россия",
    "searchString": "исетское россия / тюменская область / исетское"
  },
  "4983": {
    "id": "4983",
    "name": "Каскара",
    "path": "Россия / Тюменская область / Каскара",
    "country": "Россия",
    "searchString": "каскара россия / тюменская область / каскара"
  },
  "4984": {
    "id": "4984",
    "name": "Московский (Тюменская область)",
    "path": "Россия / Тюменская область / Московский (Тюменская область)",
    "country": "Россия",
    "searchString": "московский (тюменская область) россия / тюменская область / московский (тюменская область)"
  },
  "4985": {
    "id": "4985",
    "name": "Нижняя Тавда",
    "path": "Россия / Тюменская область / Нижняя Тавда",
    "country": "Россия",
    "searchString": "нижняя тавда россия / тюменская область / нижняя тавда"
  },
  "4986": {
    "id": "4986",
    "name": "Омутинское",
    "path": "Россия / Тюменская область / Омутинское",
    "country": "Россия",
    "searchString": "омутинское россия / тюменская область / омутинское"
  },
  "4987": {
    "id": "4987",
    "name": "Онохино",
    "path": "Россия / Тюменская область / Онохино",
    "country": "Россия",
    "searchString": "онохино россия / тюменская область / онохино"
  },
  "4988": {
    "id": "4988",
    "name": "Сладково",
    "path": "Россия / Тюменская область / Сладково",
    "country": "Россия",
    "searchString": "сладково россия / тюменская область / сладково"
  },
  "4989": {
    "id": "4989",
    "name": "Туртас",
    "path": "Россия / Тюменская область / Туртас",
    "country": "Россия",
    "searchString": "туртас россия / тюменская область / туртас"
  },
  "4990": {
    "id": "4990",
    "name": "Уват",
    "path": "Россия / Тюменская область / Уват",
    "country": "Россия",
    "searchString": "уват россия / тюменская область / уват"
  },
  "4991": {
    "id": "4991",
    "name": "Упорово",
    "path": "Россия / Тюменская область / Упорово",
    "country": "Россия",
    "searchString": "упорово россия / тюменская область / упорово"
  },
  "4992": {
    "id": "4992",
    "name": "Успенка",
    "path": "Россия / Тюменская область / Успенка",
    "country": "Россия",
    "searchString": "успенка россия / тюменская область / успенка"
  },
  "4993": {
    "id": "4993",
    "name": "Червишево",
    "path": "Россия / Тюменская область / Червишево",
    "country": "Россия",
    "searchString": "червишево россия / тюменская область / червишево"
  },
  "4994": {
    "id": "4994",
    "name": "Юргинское",
    "path": "Россия / Тюменская область / Юргинское",
    "country": "Россия",
    "searchString": "юргинское россия / тюменская область / юргинское"
  },
  "4995": {
    "id": "4995",
    "name": "Ярково (Тюменская область)",
    "path": "Россия / Тюменская область / Ярково (Тюменская область)",
    "country": "Россия",
    "searchString": "ярково (тюменская область) россия / тюменская область / ярково (тюменская область)"
  },
  "4996": {
    "id": "4996",
    "name": "Агириш",
    "path": "Россия / Ханты-Мансийский АО - Югра / Агириш",
    "country": "Россия",
    "searchString": "агириш россия / ханты-мансийский ао - югра / агириш"
  },
  "4997": {
    "id": "4997",
    "name": "Андра",
    "path": "Россия / Ханты-Мансийский АО - Югра / Андра",
    "country": "Россия",
    "searchString": "андра россия / ханты-мансийский ао - югра / андра"
  },
  "4998": {
    "id": "4998",
    "name": "Барсово",
    "path": "Россия / Ханты-Мансийский АО - Югра / Барсово",
    "country": "Россия",
    "searchString": "барсово россия / ханты-мансийский ао - югра / барсово"
  },
  "4999": {
    "id": "4999",
    "name": "Белый Яр (Ханты-Мансийский АО)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Белый Яр (Ханты-Мансийский АО)",
    "country": "Россия",
    "searchString": "белый яр (ханты-мансийский ао) россия / ханты-мансийский ао - югра / белый яр (ханты-мансийский ао)"
  },
  "5000": {
    "id": "5000",
    "name": "Высокий",
    "path": "Россия / Ханты-Мансийский АО - Югра / Высокий",
    "country": "Россия",
    "searchString": "высокий россия / ханты-мансийский ао - югра / высокий"
  },
  "5001": {
    "id": "5001",
    "name": "Горноправдинск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Горноправдинск",
    "country": "Россия",
    "searchString": "горноправдинск россия / ханты-мансийский ао - югра / горноправдинск"
  },
  "5002": {
    "id": "5002",
    "name": "Зеленоборск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Зеленоборск",
    "country": "Россия",
    "searchString": "зеленоборск россия / ханты-мансийский ао - югра / зеленоборск"
  },
  "5003": {
    "id": "5003",
    "name": "Игрим",
    "path": "Россия / Ханты-Мансийский АО - Югра / Игрим",
    "country": "Россия",
    "searchString": "игрим россия / ханты-мансийский ао - югра / игрим"
  },
  "5004": {
    "id": "5004",
    "name": "Коммунистический",
    "path": "Россия / Ханты-Мансийский АО - Югра / Коммунистический",
    "country": "Россия",
    "searchString": "коммунистический россия / ханты-мансийский ао - югра / коммунистический"
  },
  "5005": {
    "id": "5005",
    "name": "Кондинское",
    "path": "Россия / Ханты-Мансийский АО - Югра / Кондинское",
    "country": "Россия",
    "searchString": "кондинское россия / ханты-мансийский ао - югра / кондинское"
  },
  "5006": {
    "id": "5006",
    "name": "Куминский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Куминский",
    "country": "Россия",
    "searchString": "куминский россия / ханты-мансийский ао - югра / куминский"
  },
  "5007": {
    "id": "5007",
    "name": "Луговой",
    "path": "Россия / Ханты-Мансийский АО - Югра / Луговой",
    "country": "Россия",
    "searchString": "луговой россия / ханты-мансийский ао - югра / луговой"
  },
  "5008": {
    "id": "5008",
    "name": "Малиновский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Малиновский",
    "country": "Россия",
    "searchString": "малиновский россия / ханты-мансийский ао - югра / малиновский"
  },
  "5009": {
    "id": "5009",
    "name": "Междуреченский (Ханты-Мансийский АО)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Междуреченский (Ханты-Мансийский АО)",
    "country": "Россия",
    "searchString": "междуреченский (ханты-мансийский ао) россия / ханты-мансийский ао - югра / междуреченский (ханты-мансийский ао)"
  },
  "5010": {
    "id": "5010",
    "name": "Мортка",
    "path": "Россия / Ханты-Мансийский АО - Югра / Мортка",
    "country": "Россия",
    "searchString": "мортка россия / ханты-мансийский ао - югра / мортка"
  },
  "5011": {
    "id": "5011",
    "name": "Нижнесортымский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Нижнесортымский",
    "country": "Россия",
    "searchString": "нижнесортымский россия / ханты-мансийский ао - югра / нижнесортымский"
  },
  "5012": {
    "id": "5012",
    "name": "Новоаганск",
    "path": "Россия / Ханты-Мансийский АО - Югра / Новоаганск",
    "country": "Россия",
    "searchString": "новоаганск россия / ханты-мансийский ао - югра / новоаганск"
  },
  "5013": {
    "id": "5013",
    "name": "Октябрьское (Ханты-Мансийский АО)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Октябрьское (Ханты-Мансийский АО)",
    "country": "Россия",
    "searchString": "октябрьское (ханты-мансийский ао) россия / ханты-мансийский ао - югра / октябрьское (ханты-мансийский ао)"
  },
  "5014": {
    "id": "5014",
    "name": "Пионерский (Ханты-Мансийский АО)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Пионерский (Ханты-Мансийский АО)",
    "country": "Россия",
    "searchString": "пионерский (ханты-мансийский ао) россия / ханты-мансийский ао - югра / пионерский (ханты-мансийский ао)"
  },
  "5015": {
    "id": "5015",
    "name": "Пойковский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Пойковский",
    "country": "Россия",
    "searchString": "пойковский россия / ханты-мансийский ао - югра / пойковский"
  },
  "5016": {
    "id": "5016",
    "name": "Приобье",
    "path": "Россия / Ханты-Мансийский АО - Югра / Приобье",
    "country": "Россия",
    "searchString": "приобье россия / ханты-мансийский ао - югра / приобье"
  },
  "5017": {
    "id": "5017",
    "name": "Салым",
    "path": "Россия / Ханты-Мансийский АО - Югра / Салым",
    "country": "Россия",
    "searchString": "салым россия / ханты-мансийский ао - югра / салым"
  },
  "5018": {
    "id": "5018",
    "name": "Сентябрьский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Сентябрьский",
    "country": "Россия",
    "searchString": "сентябрьский россия / ханты-мансийский ао - югра / сентябрьский"
  },
  "5019": {
    "id": "5019",
    "name": "Солнечный (Ханты-Мансийский АО)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Солнечный (Ханты-Мансийский АО)",
    "country": "Россия",
    "searchString": "солнечный (ханты-мансийский ао) россия / ханты-мансийский ао - югра / солнечный (ханты-мансийский ао)"
  },
  "5020": {
    "id": "5020",
    "name": "Таёжный",
    "path": "Россия / Ханты-Мансийский АО - Югра / Таёжный",
    "country": "Россия",
    "searchString": "таёжный россия / ханты-мансийский ао - югра / таёжный"
  },
  "5021": {
    "id": "5021",
    "name": "Талинка",
    "path": "Россия / Ханты-Мансийский АО - Югра / Талинка",
    "country": "Россия",
    "searchString": "талинка россия / ханты-мансийский ао - югра / талинка"
  },
  "5022": {
    "id": "5022",
    "name": "Унъюган",
    "path": "Россия / Ханты-Мансийский АО - Югра / Унъюган",
    "country": "Россия",
    "searchString": "унъюган россия / ханты-мансийский ао - югра / унъюган"
  },
  "5023": {
    "id": "5023",
    "name": "Аксарка",
    "path": "Россия / Ямало-Ненецкий АО / Аксарка",
    "country": "Россия",
    "searchString": "аксарка россия / ямало-ненецкий ао / аксарка"
  },
  "5024": {
    "id": "5024",
    "name": "Вынгапуровский",
    "path": "Россия / Ямало-Ненецкий АО / Вынгапуровский",
    "country": "Россия",
    "searchString": "вынгапуровский россия / ямало-ненецкий ао / вынгапуровский"
  },
  "5025": {
    "id": "5025",
    "name": "Заполярный (Ямало-Ненецкий АО)",
    "path": "Россия / Ямало-Ненецкий АО / Заполярный (Ямало-Ненецкий АО)",
    "country": "Россия",
    "searchString": "заполярный (ямало-ненецкий ао) россия / ямало-ненецкий ао / заполярный (ямало-ненецкий ао)"
  },
  "5026": {
    "id": "5026",
    "name": "Коротчаево",
    "path": "Россия / Ямало-Ненецкий АО / Коротчаево",
    "country": "Россия",
    "searchString": "коротчаево россия / ямало-ненецкий ао / коротчаево"
  },
  "5027": {
    "id": "5027",
    "name": "Красноселькуп",
    "path": "Россия / Ямало-Ненецкий АО / Красноселькуп",
    "country": "Россия",
    "searchString": "красноселькуп россия / ямало-ненецкий ао / красноселькуп"
  },
  "5028": {
    "id": "5028",
    "name": "Мужи",
    "path": "Россия / Ямало-Ненецкий АО / Мужи",
    "country": "Россия",
    "searchString": "мужи россия / ямало-ненецкий ао / мужи"
  },
  "5029": {
    "id": "5029",
    "name": "Пангоды",
    "path": "Россия / Ямало-Ненецкий АО / Пангоды",
    "country": "Россия",
    "searchString": "пангоды россия / ямало-ненецкий ао / пангоды"
  },
  "5030": {
    "id": "5030",
    "name": "Приозёрный",
    "path": "Россия / Ямало-Ненецкий АО / Приозёрный",
    "country": "Россия",
    "searchString": "приозёрный россия / ямало-ненецкий ао / приозёрный"
  },
  "5031": {
    "id": "5031",
    "name": "Пурпе",
    "path": "Россия / Ямало-Ненецкий АО / Пурпе",
    "country": "Россия",
    "searchString": "пурпе россия / ямало-ненецкий ао / пурпе"
  },
  "5032": {
    "id": "5032",
    "name": "Тазовский",
    "path": "Россия / Ямало-Ненецкий АО / Тазовский",
    "country": "Россия",
    "searchString": "тазовский россия / ямало-ненецкий ао / тазовский"
  },
  "5033": {
    "id": "5033",
    "name": "Ханымей",
    "path": "Россия / Ямало-Ненецкий АО / Ханымей",
    "country": "Россия",
    "searchString": "ханымей россия / ямало-ненецкий ао / ханымей"
  },
  "5034": {
    "id": "5034",
    "name": "Ильинско-Подомское",
    "path": "Россия / Архангельская область / Ильинско-Подомское",
    "country": "Россия",
    "searchString": "ильинско-подомское россия / архангельская область / ильинско-подомское"
  },
  "5035": {
    "id": "5035",
    "name": "Чердаклы",
    "path": "Россия / Ульяновская область / Чердаклы",
    "country": "Россия",
    "searchString": "чердаклы россия / ульяновская область / чердаклы"
  },
  "5037": {
    "id": "5037",
    "name": "Эстосадок",
    "path": "Россия / Краснодарский край / Эстосадок",
    "country": "Россия",
    "searchString": "эстосадок россия / краснодарский край / эстосадок"
  },
  "5038": {
    "id": "5038",
    "name": "Верхнетемерницкий",
    "path": "Россия / Ростовская область / Верхнетемерницкий",
    "country": "Россия",
    "searchString": "верхнетемерницкий россия / ростовская область / верхнетемерницкий"
  },
  "5039": {
    "id": "5039",
    "name": "Холбон",
    "path": "Россия / Забайкальский край / Холбон",
    "country": "Россия",
    "searchString": "холбон россия / забайкальский край / холбон"
  },
  "5040": {
    "id": "5040",
    "name": "Ильинский (Раменский район)",
    "path": "Россия / Московская область / Ильинский (Раменский район)",
    "country": "Россия",
    "searchString": "ильинский (раменский район) россия / московская область / ильинский (раменский район)"
  },
  "5041": {
    "id": "5041",
    "name": "посёлок Володарского (Московская область)",
    "path": "Россия / Московская область / посёлок Володарского (Московская область)",
    "country": "Россия",
    "searchString": "посёлок володарского (московская область) россия / московская область / посёлок володарского (московская область)"
  },
  "5042": {
    "id": "5042",
    "name": "Тайынша",
    "path": "Казахстан / Тайынша",
    "country": "Казахстан",
    "searchString": "тайынша казахстан / тайынша"
  },
  "5043": {
    "id": "5043",
    "name": "Звёздный Городок (Московская область)",
    "path": "Россия / Московская область / Звёздный Городок (Московская область)",
    "country": "Россия",
    "searchString": "звёздный городок (московская область) россия / московская область / звёздный городок (московская область)"
  },
  "5044": {
    "id": "5044",
    "name": "Родники (Московская область)",
    "path": "Россия / Московская область / Родники (Московская область)",
    "country": "Россия",
    "searchString": "родники (московская область) россия / московская область / родники (московская область)"
  },
  "5045": {
    "id": "5045",
    "name": "Быково (Московская область)",
    "path": "Россия / Московская область / Быково (Московская область)",
    "country": "Россия",
    "searchString": "быково (московская область) россия / московская область / быково (московская область)"
  },
  "5046": {
    "id": "5046",
    "name": "Черногория",
    "path": "Другие регионы / Черногория",
    "country": "Другие регионы",
    "searchString": "черногория другие регионы / черногория"
  },
  "5047": {
    "id": "5047",
    "name": "Белиз",
    "path": "Другие регионы / Белиз",
    "country": "Другие регионы",
    "searchString": "белиз другие регионы / белиз"
  },
  "5048": {
    "id": "5048",
    "name": "Сент-Винсент и Гренадины",
    "path": "Другие регионы / Сент-Винсент и Гренадины",
    "country": "Другие регионы",
    "searchString": "сент-винсент и гренадины другие регионы / сент-винсент и гренадины"
  },
  "5049": {
    "id": "5049",
    "name": "Кишинёв",
    "path": "Другие регионы / Молдова / Кишинёв",
    "country": "Другие регионы",
    "searchString": "кишинёв другие регионы / молдова / кишинёв"
  },
  "5050": {
    "id": "5050",
    "name": "Шигоны",
    "path": "Россия / Самарская область / Шигоны",
    "country": "Россия",
    "searchString": "шигоны россия / самарская область / шигоны"
  },
  "5051": {
    "id": "5051",
    "name": "Курчатов (Казахстан)",
    "path": "Казахстан / Курчатов (Казахстан)",
    "country": "Казахстан",
    "searchString": "курчатов (казахстан) казахстан / курчатов (казахстан)"
  },
  "5052": {
    "id": "5052",
    "name": "Качар",
    "path": "Казахстан / Качар",
    "country": "Казахстан",
    "searchString": "качар казахстан / качар"
  },
  "5053": {
    "id": "5053",
    "name": "Аулиеколь",
    "path": "Казахстан / Аулиеколь",
    "country": "Казахстан",
    "searchString": "аулиеколь казахстан / аулиеколь"
  },
  "5054": {
    "id": "5054",
    "name": "Карабалык",
    "path": "Казахстан / Карабалык",
    "country": "Казахстан",
    "searchString": "карабалык казахстан / карабалык"
  },
  "5055": {
    "id": "5055",
    "name": "Бесколь",
    "path": "Казахстан / Бесколь",
    "country": "Казахстан",
    "searchString": "бесколь казахстан / бесколь"
  },
  "5056": {
    "id": "5056",
    "name": "Новоишимское",
    "path": "Казахстан / Новоишимское",
    "country": "Казахстан",
    "searchString": "новоишимское казахстан / новоишимское"
  },
  "5057": {
    "id": "5057",
    "name": "Тучково (Московская область)",
    "path": "Россия / Московская область / Тучково (Московская область)",
    "country": "Россия",
    "searchString": "тучково (московская область) россия / московская область / тучково (московская область)"
  },
  "5058": {
    "id": "5058",
    "name": "Баянгол",
    "path": "Россия / Республика Бурятия / Баянгол",
    "country": "Россия",
    "searchString": "баянгол россия / республика бурятия / баянгол"
  },
  "5059": {
    "id": "5059",
    "name": "Итанца",
    "path": "Россия / Республика Бурятия / Итанца",
    "country": "Россия",
    "searchString": "итанца россия / республика бурятия / итанца"
  },
  "5060": {
    "id": "5060",
    "name": "Джида",
    "path": "Россия / Республика Бурятия / Джида",
    "country": "Россия",
    "searchString": "джида россия / республика бурятия / джида"
  },
  "5061": {
    "id": "5061",
    "name": "Новая Брянь",
    "path": "Россия / Республика Бурятия / Новая Брянь",
    "country": "Россия",
    "searchString": "новая брянь россия / республика бурятия / новая брянь"
  },
  "5062": {
    "id": "5062",
    "name": "Илька",
    "path": "Россия / Республика Бурятия / Илька",
    "country": "Россия",
    "searchString": "илька россия / республика бурятия / илька"
  },
  "5063": {
    "id": "5063",
    "name": "Горхон",
    "path": "Россия / Республика Бурятия / Горхон",
    "country": "Россия",
    "searchString": "горхон россия / республика бурятия / горхон"
  },
  "5064": {
    "id": "5064",
    "name": "Тарбагатай",
    "path": "Россия / Республика Бурятия / Тарбагатай",
    "country": "Россия",
    "searchString": "тарбагатай россия / республика бурятия / тарбагатай"
  },
  "5065": {
    "id": "5065",
    "name": "Куйтун (Республика Бурятия)",
    "path": "Россия / Республика Бурятия / Куйтун (Республика Бурятия)",
    "country": "Россия",
    "searchString": "куйтун (республика бурятия) россия / республика бурятия / куйтун (республика бурятия)"
  },
  "5066": {
    "id": "5066",
    "name": "Шаралдай",
    "path": "Россия / Республика Бурятия / Шаралдай",
    "country": "Россия",
    "searchString": "шаралдай россия / республика бурятия / шаралдай"
  },
  "5067": {
    "id": "5067",
    "name": "Подлопатки",
    "path": "Россия / Республика Бурятия / Подлопатки",
    "country": "Россия",
    "searchString": "подлопатки россия / республика бурятия / подлопатки"
  },
  "5068": {
    "id": "5068",
    "name": "Хонхолой",
    "path": "Россия / Республика Бурятия / Хонхолой",
    "country": "Россия",
    "searchString": "хонхолой россия / республика бурятия / хонхолой"
  },
  "5069": {
    "id": "5069",
    "name": "Никольск",
    "path": "Россия / Республика Бурятия / Никольск",
    "country": "Россия",
    "searchString": "никольск россия / республика бурятия / никольск"
  },
  "5070": {
    "id": "5070",
    "name": "Цолга",
    "path": "Россия / Республика Бурятия / Цолга",
    "country": "Россия",
    "searchString": "цолга россия / республика бурятия / цолга"
  },
  "5071": {
    "id": "5071",
    "name": "Тугнуй",
    "path": "Россия / Республика Бурятия / Тугнуй",
    "country": "Россия",
    "searchString": "тугнуй россия / республика бурятия / тугнуй"
  },
  "5072": {
    "id": "5072",
    "name": "Саган-Нур",
    "path": "Россия / Республика Бурятия / Саган-Нур",
    "country": "Россия",
    "searchString": "саган-нур россия / республика бурятия / саган-нур"
  },
  "5073": {
    "id": "5073",
    "name": "Выдрино",
    "path": "Россия / Республика Бурятия / Выдрино",
    "country": "Россия",
    "searchString": "выдрино россия / республика бурятия / выдрино"
  },
  "5074": {
    "id": "5074",
    "name": "Кудара",
    "path": "Россия / Республика Бурятия / Кудара",
    "country": "Россия",
    "searchString": "кудара россия / республика бурятия / кудара"
  },
  "5075": {
    "id": "5075",
    "name": "Таловка",
    "path": "Россия / Республика Бурятия / Таловка",
    "country": "Россия",
    "searchString": "таловка россия / республика бурятия / таловка"
  },
  "5076": {
    "id": "5076",
    "name": "Ильинка",
    "path": "Россия / Республика Бурятия / Ильинка",
    "country": "Россия",
    "searchString": "ильинка россия / республика бурятия / ильинка"
  },
  "5077": {
    "id": "5077",
    "name": "Новоселенгинск",
    "path": "Россия / Республика Бурятия / Новоселенгинск",
    "country": "Россия",
    "searchString": "новоселенгинск россия / республика бурятия / новоселенгинск"
  },
  "5078": {
    "id": "5078",
    "name": "Селендум",
    "path": "Россия / Республика Бурятия / Селендум",
    "country": "Россия",
    "searchString": "селендум россия / республика бурятия / селендум"
  },
  "5079": {
    "id": "5079",
    "name": "Нижний Торей",
    "path": "Россия / Республика Бурятия / Нижний Торей",
    "country": "Россия",
    "searchString": "нижний торей россия / республика бурятия / нижний торей"
  },
  "5080": {
    "id": "5080",
    "name": "Кудара-Сомон",
    "path": "Россия / Республика Бурятия / Кудара-Сомон",
    "country": "Россия",
    "searchString": "кудара-сомон россия / республика бурятия / кудара-сомон"
  },
  "5081": {
    "id": "5081",
    "name": "Шарагол",
    "path": "Россия / Республика Бурятия / Шарагол",
    "country": "Россия",
    "searchString": "шарагол россия / республика бурятия / шарагол"
  },
  "5082": {
    "id": "5082",
    "name": "Наушки",
    "path": "Россия / Республика Бурятия / Наушки",
    "country": "Россия",
    "searchString": "наушки россия / республика бурятия / наушки"
  },
  "5083": {
    "id": "5083",
    "name": "Новый Уоян",
    "path": "Россия / Республика Бурятия / Новый Уоян",
    "country": "Россия",
    "searchString": "новый уоян россия / республика бурятия / новый уоян"
  },
  "5084": {
    "id": "5084",
    "name": "Мурино",
    "path": "Россия / Ленинградская область / Мурино",
    "country": "Россия",
    "searchString": "мурино россия / ленинградская область / мурино"
  },
  "5085": {
    "id": "5085",
    "name": "Крекшино (Московская область)",
    "path": "Россия / Московская область / Крекшино (Московская область)",
    "country": "Россия",
    "searchString": "крекшино (московская область) россия / московская область / крекшино (московская область)"
  },
  "5086": {
    "id": "5086",
    "name": "Месягутово",
    "path": "Россия / Республика Башкортостан / Месягутово",
    "country": "Россия",
    "searchString": "месягутово россия / республика башкортостан / месягутово"
  },
  "5087": {
    "id": "5087",
    "name": "Некрасовка (Хабаровский край)",
    "path": "Россия / Хабаровский край / Некрасовка (Хабаровский край)",
    "country": "Россия",
    "searchString": "некрасовка (хабаровский край) россия / хабаровский край / некрасовка (хабаровский край)"
  },
  "5088": {
    "id": "5088",
    "name": "Акша (Забайкальский край)",
    "path": "Россия / Забайкальский край / Акша (Забайкальский край)",
    "country": "Россия",
    "searchString": "акша (забайкальский край) россия / забайкальский край / акша (забайкальский край)"
  },
  "5089": {
    "id": "5089",
    "name": "Александровский Завод",
    "path": "Россия / Забайкальский край / Александровский Завод",
    "country": "Россия",
    "searchString": "александровский завод россия / забайкальский край / александровский завод"
  },
  "5090": {
    "id": "5090",
    "name": "Газимурский Завод",
    "path": "Россия / Забайкальский край / Газимурский Завод",
    "country": "Россия",
    "searchString": "газимурский завод россия / забайкальский край / газимурский завод"
  },
  "5091": {
    "id": "5091",
    "name": "Калга",
    "path": "Россия / Забайкальский край / Калга",
    "country": "Россия",
    "searchString": "калга россия / забайкальский край / калга"
  },
  "5092": {
    "id": "5092",
    "name": "Красный Чикой",
    "path": "Россия / Забайкальский край / Красный Чикой",
    "country": "Россия",
    "searchString": "красный чикой россия / забайкальский край / красный чикой"
  },
  "5093": {
    "id": "5093",
    "name": "Кыра",
    "path": "Россия / Забайкальский край / Кыра",
    "country": "Россия",
    "searchString": "кыра россия / забайкальский край / кыра"
  },
  "5094": {
    "id": "5094",
    "name": "Могойтуй",
    "path": "Россия / Забайкальский край / Могойтуй",
    "country": "Россия",
    "searchString": "могойтуй россия / забайкальский край / могойтуй"
  },
  "5095": {
    "id": "5095",
    "name": "Нерчинский Завод",
    "path": "Россия / Забайкальский край / Нерчинский Завод",
    "country": "Россия",
    "searchString": "нерчинский завод россия / забайкальский край / нерчинский завод"
  },
  "5096": {
    "id": "5096",
    "name": "Оловянная",
    "path": "Россия / Забайкальский край / Оловянная",
    "country": "Россия",
    "searchString": "оловянная россия / забайкальский край / оловянная"
  },
  "5097": {
    "id": "5097",
    "name": "Нижний Цасучей",
    "path": "Россия / Забайкальский край / Нижний Цасучей",
    "country": "Россия",
    "searchString": "нижний цасучей россия / забайкальский край / нижний цасучей"
  },
  "5098": {
    "id": "5098",
    "name": "Приаргунск",
    "path": "Россия / Забайкальский край / Приаргунск",
    "country": "Россия",
    "searchString": "приаргунск россия / забайкальский край / приаргунск"
  },
  "5099": {
    "id": "5099",
    "name": "Верх-Усугли",
    "path": "Россия / Забайкальский край / Верх-Усугли",
    "country": "Россия",
    "searchString": "верх-усугли россия / забайкальский край / верх-усугли"
  },
  "5100": {
    "id": "5100",
    "name": "Улёты",
    "path": "Россия / Забайкальский край / Улёты",
    "country": "Россия",
    "searchString": "улёты россия / забайкальский край / улёты"
  },
  "5101": {
    "id": "5101",
    "name": "Чернышевск",
    "path": "Россия / Забайкальский край / Чернышевск",
    "country": "Россия",
    "searchString": "чернышевск россия / забайкальский край / чернышевск"
  },
  "5102": {
    "id": "5102",
    "name": "Шелопугино (Забайкальский край)",
    "path": "Россия / Забайкальский край / Шелопугино (Забайкальский край)",
    "country": "Россия",
    "searchString": "шелопугино (забайкальский край) россия / забайкальский край / шелопугино (забайкальский край)"
  },
  "5103": {
    "id": "5103",
    "name": "Шерловая Гора",
    "path": "Россия / Забайкальский край / Шерловая Гора",
    "country": "Россия",
    "searchString": "шерловая гора россия / забайкальский край / шерловая гора"
  },
  "5104": {
    "id": "5104",
    "name": "Горный (Забайкальский край)",
    "path": "Россия / Забайкальский край / Горный (Забайкальский край)",
    "country": "Россия",
    "searchString": "горный (забайкальский край) россия / забайкальский край / горный (забайкальский край)"
  },
  "5105": {
    "id": "5105",
    "name": "Первомайский (Забайкальский край)",
    "path": "Россия / Забайкальский край / Первомайский (Забайкальский край)",
    "country": "Россия",
    "searchString": "первомайский (забайкальский край) россия / забайкальский край / первомайский (забайкальский край)"
  },
  "5106": {
    "id": "5106",
    "name": "Атамановка (Читинский район)",
    "path": "Россия / Забайкальский край / Атамановка (Читинский район)",
    "country": "Россия",
    "searchString": "атамановка (читинский район) россия / забайкальский край / атамановка (читинский район)"
  },
  "5107": {
    "id": "5107",
    "name": "Новокручининский",
    "path": "Россия / Забайкальский край / Новокручининский",
    "country": "Россия",
    "searchString": "новокручининский россия / забайкальский край / новокручининский"
  },
  "5108": {
    "id": "5108",
    "name": "Ясногорск (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ясногорск (Забайкальский край)",
    "country": "Россия",
    "searchString": "ясногорск (забайкальский край) россия / забайкальский край / ясногорск (забайкальский край)"
  },
  "5109": {
    "id": "5109",
    "name": "Ясная (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ясная (Забайкальский край)",
    "country": "Россия",
    "searchString": "ясная (забайкальский край) россия / забайкальский край / ясная (забайкальский край)"
  },
  "5110": {
    "id": "5110",
    "name": "Кокуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Кокуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "кокуй (забайкальский край) россия / забайкальский край / кокуй (забайкальский край)"
  },
  "5111": {
    "id": "5111",
    "name": "Домна (Забайкальский край)",
    "path": "Россия / Забайкальский край / Домна (Забайкальский край)",
    "country": "Россия",
    "searchString": "домна (забайкальский край) россия / забайкальский край / домна (забайкальский край)"
  },
  "5112": {
    "id": "5112",
    "name": "Вершино-Дарасунский",
    "path": "Россия / Забайкальский край / Вершино-Дарасунский",
    "country": "Россия",
    "searchString": "вершино-дарасунский россия / забайкальский край / вершино-дарасунский"
  },
  "5113": {
    "id": "5113",
    "name": "Дарасун (Забайкальский край)",
    "path": "Россия / Забайкальский край / Дарасун (Забайкальский край)",
    "country": "Россия",
    "searchString": "дарасун (забайкальский край) россия / забайкальский край / дарасун (забайкальский край)"
  },
  "5114": {
    "id": "5114",
    "name": "Дульдурга",
    "path": "Россия / Забайкальский край / Дульдурга",
    "country": "Россия",
    "searchString": "дульдурга россия / забайкальский край / дульдурга"
  },
  "5115": {
    "id": "5115",
    "name": "Тимяшево",
    "path": "Россия / Республика Татарстан / Тимяшево",
    "country": "Россия",
    "searchString": "тимяшево россия / республика татарстан / тимяшево"
  },
  "5116": {
    "id": "5116",
    "name": "Обухово (Московская область)",
    "path": "Россия / Московская область / Обухово (Московская область)",
    "country": "Россия",
    "searchString": "обухово (московская область) россия / московская область / обухово (московская область)"
  },
  "5117": {
    "id": "5117",
    "name": "Осакаровка",
    "path": "Казахстан / Осакаровка",
    "country": "Казахстан",
    "searchString": "осакаровка казахстан / осакаровка"
  },
  "5118": {
    "id": "5118",
    "name": "Батпак",
    "path": "Казахстан / Батпак",
    "country": "Казахстан",
    "searchString": "батпак казахстан / батпак"
  },
  "5119": {
    "id": "5119",
    "name": "Холмогоры",
    "path": "Россия / Архангельская область / Холмогоры",
    "country": "Россия",
    "searchString": "холмогоры россия / архангельская область / холмогоры"
  },
  "5120": {
    "id": "5120",
    "name": "Софьино (Наро-Фоминский район)",
    "path": "Россия / Московская область / Софьино (Наро-Фоминский район)",
    "country": "Россия",
    "searchString": "софьино (наро-фоминский район) россия / московская область / софьино (наро-фоминский район)"
  },
  "5121": {
    "id": "5121",
    "name": "Красноборск",
    "path": "Россия / Архангельская область / Красноборск",
    "country": "Россия",
    "searchString": "красноборск россия / архангельская область / красноборск"
  },
  "5122": {
    "id": "5122",
    "name": "Двинской",
    "path": "Россия / Архангельская область / Двинской",
    "country": "Россия",
    "searchString": "двинской россия / архангельская область / двинской"
  },
  "5123": {
    "id": "5123",
    "name": "Большая Соснова",
    "path": "Россия / Пермский край / Большая Соснова",
    "country": "Россия",
    "searchString": "большая соснова россия / пермский край / большая соснова"
  },
  "5124": {
    "id": "5124",
    "name": "Жаксы",
    "path": "Казахстан / Жаксы",
    "country": "Казахстан",
    "searchString": "жаксы казахстан / жаксы"
  },
  "5125": {
    "id": "5125",
    "name": "свх Масловский",
    "path": "Россия / Воронежская область / свх Масловский",
    "country": "Россия",
    "searchString": "свх масловский россия / воронежская область / свх масловский"
  },
  "5126": {
    "id": "5126",
    "name": "Саксаульский",
    "path": "Казахстан / Саксаульский",
    "country": "Казахстан",
    "searchString": "саксаульский казахстан / саксаульский"
  },
  "5127": {
    "id": "5127",
    "name": "Дмитриевский",
    "path": "Россия / Республика Адыгея / Дмитриевский",
    "country": "Россия",
    "searchString": "дмитриевский россия / республика адыгея / дмитриевский"
  },
  "5128": {
    "id": "5128",
    "name": "Некрасовский (Московская область)",
    "path": "Россия / Московская область / Некрасовский (Московская область)",
    "country": "Россия",
    "searchString": "некрасовский (московская область) россия / московская область / некрасовский (московская область)"
  },
  "5129": {
    "id": "5129",
    "name": "Бурабай",
    "path": "Казахстан / Бурабай",
    "country": "Казахстан",
    "searchString": "бурабай казахстан / бурабай"
  },
  "5130": {
    "id": "5130",
    "name": "Татаново",
    "path": "Россия / Тамбовская область / Татаново",
    "country": "Россия",
    "searchString": "татаново россия / тамбовская область / татаново"
  },
  "5131": {
    "id": "5131",
    "name": "Республика Гватемала",
    "path": "Другие регионы / Республика Гватемала",
    "country": "Другие регионы",
    "searchString": "республика гватемала другие регионы / республика гватемала"
  },
  "5132": {
    "id": "5132",
    "name": "Бураево",
    "path": "Россия / Республика Башкортостан / Бураево",
    "country": "Россия",
    "searchString": "бураево россия / республика башкортостан / бураево"
  },
  "5133": {
    "id": "5133",
    "name": "Серафимовский",
    "path": "Россия / Республика Башкортостан / Серафимовский",
    "country": "Россия",
    "searchString": "серафимовский россия / республика башкортостан / серафимовский"
  },
  "5134": {
    "id": "5134",
    "name": "Кандры",
    "path": "Россия / Республика Башкортостан / Кандры",
    "country": "Россия",
    "searchString": "кандры россия / республика башкортостан / кандры"
  },
  "5135": {
    "id": "5135",
    "name": "Кушнаренково",
    "path": "Россия / Республика Башкортостан / Кушнаренково",
    "country": "Россия",
    "searchString": "кушнаренково россия / республика башкортостан / кушнаренково"
  },
  "5136": {
    "id": "5136",
    "name": "Улукулево",
    "path": "Россия / Республика Башкортостан / Улукулево",
    "country": "Россия",
    "searchString": "улукулево россия / республика башкортостан / улукулево"
  },
  "5137": {
    "id": "5137",
    "name": "Аскарово",
    "path": "Россия / Республика Башкортостан / Аскарово",
    "country": "Россия",
    "searchString": "аскарово россия / республика башкортостан / аскарово"
  },
  "5138": {
    "id": "5138",
    "name": "Исянгулово",
    "path": "Россия / Республика Башкортостан / Исянгулово",
    "country": "Россия",
    "searchString": "исянгулово россия / республика башкортостан / исянгулово"
  },
  "5139": {
    "id": "5139",
    "name": "Шаран",
    "path": "Россия / Республика Башкортостан / Шаран",
    "country": "Россия",
    "searchString": "шаран россия / республика башкортостан / шаран"
  },
  "5140": {
    "id": "5140",
    "name": "Зирган",
    "path": "Россия / Республика Башкортостан / Зирган",
    "country": "Россия",
    "searchString": "зирган россия / республика башкортостан / зирган"
  },
  "5141": {
    "id": "5141",
    "name": "Прибельский",
    "path": "Россия / Республика Башкортостан / Прибельский",
    "country": "Россия",
    "searchString": "прибельский россия / республика башкортостан / прибельский"
  },
  "5142": {
    "id": "5142",
    "name": "Языково",
    "path": "Россия / Республика Башкортостан / Языково",
    "country": "Россия",
    "searchString": "языково россия / республика башкортостан / языково"
  },
  "5143": {
    "id": "5143",
    "name": "Зилаир",
    "path": "Россия / Республика Башкортостан / Зилаир",
    "country": "Россия",
    "searchString": "зилаир россия / республика башкортостан / зилаир"
  },
  "5144": {
    "id": "5144",
    "name": "Старобалтачево",
    "path": "Россия / Республика Башкортостан / Старобалтачево",
    "country": "Россия",
    "searchString": "старобалтачево россия / республика башкортостан / старобалтачево"
  },
  "5145": {
    "id": "5145",
    "name": "Краснохолмский",
    "path": "Россия / Республика Башкортостан / Краснохолмский",
    "country": "Россия",
    "searchString": "краснохолмский россия / республика башкортостан / краснохолмский"
  },
  "5146": {
    "id": "5146",
    "name": "Мраково",
    "path": "Россия / Республика Башкортостан / Мраково",
    "country": "Россия",
    "searchString": "мраково россия / республика башкортостан / мраково"
  },
  "5147": {
    "id": "5147",
    "name": "Павловка",
    "path": "Россия / Республика Башкортостан / Павловка",
    "country": "Россия",
    "searchString": "павловка россия / республика башкортостан / павловка"
  },
  "5148": {
    "id": "5148",
    "name": "Малояз",
    "path": "Россия / Республика Башкортостан / Малояз",
    "country": "Россия",
    "searchString": "малояз россия / республика башкортостан / малояз"
  },
  "5149": {
    "id": "5149",
    "name": "Толбазы",
    "path": "Россия / Республика Башкортостан / Толбазы",
    "country": "Россия",
    "searchString": "толбазы россия / республика башкортостан / толбазы"
  },
  "5150": {
    "id": "5150",
    "name": "Верхние Киги",
    "path": "Россия / Республика Башкортостан / Верхние Киги",
    "country": "Россия",
    "searchString": "верхние киги россия / республика башкортостан / верхние киги"
  },
  "5151": {
    "id": "5151",
    "name": "Новобелокатай",
    "path": "Россия / Республика Башкортостан / Новобелокатай",
    "country": "Россия",
    "searchString": "новобелокатай россия / республика башкортостан / новобелокатай"
  },
  "5152": {
    "id": "5152",
    "name": "Стерлибашево",
    "path": "Россия / Республика Башкортостан / Стерлибашево",
    "country": "Россия",
    "searchString": "стерлибашево россия / республика башкортостан / стерлибашево"
  },
  "5153": {
    "id": "5153",
    "name": "Аскино",
    "path": "Россия / Республика Башкортостан / Аскино",
    "country": "Россия",
    "searchString": "аскино россия / республика башкортостан / аскино"
  },
  "5154": {
    "id": "5154",
    "name": "Красный Коммунар",
    "path": "Россия / Республика Башкортостан / Красный Коммунар",
    "country": "Россия",
    "searchString": "красный коммунар россия / республика башкортостан / красный коммунар"
  },
  "5155": {
    "id": "5155",
    "name": "Киргиз-Мияки",
    "path": "Россия / Республика Башкортостан / Киргиз-Мияки",
    "country": "Россия",
    "searchString": "киргиз-мияки россия / республика башкортостан / киргиз-мияки"
  },
  "5156": {
    "id": "5156",
    "name": "Караидель",
    "path": "Россия / Республика Башкортостан / Караидель",
    "country": "Россия",
    "searchString": "караидель россия / республика башкортостан / караидель"
  },
  "5157": {
    "id": "5157",
    "name": "Булгаково",
    "path": "Россия / Республика Башкортостан / Булгаково",
    "country": "Россия",
    "searchString": "булгаково россия / республика башкортостан / булгаково"
  },
  "5158": {
    "id": "5158",
    "name": "Большеустьикинское",
    "path": "Россия / Республика Башкортостан / Большеустьикинское",
    "country": "Россия",
    "searchString": "большеустьикинское россия / республика башкортостан / большеустьикинское"
  },
  "5159": {
    "id": "5159",
    "name": "Семилетка",
    "path": "Россия / Республика Башкортостан / Семилетка",
    "country": "Россия",
    "searchString": "семилетка россия / республика башкортостан / семилетка"
  },
  "5160": {
    "id": "5160",
    "name": "Федоровка (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Федоровка (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "федоровка (республика башкортостан) россия / республика башкортостан / федоровка (республика башкортостан)"
  },
  "5161": {
    "id": "5161",
    "name": "Верхние Татышлы",
    "path": "Россия / Республика Башкортостан / Верхние Татышлы",
    "country": "Россия",
    "searchString": "верхние татышлы россия / республика башкортостан / верхние татышлы"
  },
  "5162": {
    "id": "5162",
    "name": "Инзер",
    "path": "Россия / Республика Башкортостан / Инзер",
    "country": "Россия",
    "searchString": "инзер россия / республика башкортостан / инзер"
  },
  "5163": {
    "id": "5163",
    "name": "Архангельское (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Архангельское (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "архангельское (республика башкортостан) россия / республика башкортостан / архангельское (республика башкортостан)"
  },
  "5164": {
    "id": "5164",
    "name": "Степняк",
    "path": "Казахстан / Степняк",
    "country": "Казахстан",
    "searchString": "степняк казахстан / степняк"
  },
  "5165": {
    "id": "5165",
    "name": "Аксарайский",
    "path": "Россия / Астраханская область / Аксарайский",
    "country": "Россия",
    "searchString": "аксарайский россия / астраханская область / аксарайский"
  },
  "5166": {
    "id": "5166",
    "name": "Верхний Баскунчак",
    "path": "Россия / Астраханская область / Верхний Баскунчак",
    "country": "Россия",
    "searchString": "верхний баскунчак россия / астраханская область / верхний баскунчак"
  },
  "5167": {
    "id": "5167",
    "name": "Володарский",
    "path": "Россия / Астраханская область / Володарский",
    "country": "Россия",
    "searchString": "володарский россия / астраханская область / володарский"
  },
  "5168": {
    "id": "5168",
    "name": "Енотаевка",
    "path": "Россия / Астраханская область / Енотаевка",
    "country": "Россия",
    "searchString": "енотаевка россия / астраханская область / енотаевка"
  },
  "5169": {
    "id": "5169",
    "name": "Зензели",
    "path": "Россия / Астраханская область / Зензели",
    "country": "Россия",
    "searchString": "зензели россия / астраханская область / зензели"
  },
  "5170": {
    "id": "5170",
    "name": "Икряное",
    "path": "Россия / Астраханская область / Икряное",
    "country": "Россия",
    "searchString": "икряное россия / астраханская область / икряное"
  },
  "5171": {
    "id": "5171",
    "name": "Ильинка (Икрянинский район)",
    "path": "Россия / Астраханская область / Ильинка (Икрянинский район)",
    "country": "Россия",
    "searchString": "ильинка (икрянинский район) россия / астраханская область / ильинка (икрянинский район)"
  },
  "5172": {
    "id": "5172",
    "name": "Капустин Яр",
    "path": "Россия / Астраханская область / Капустин Яр",
    "country": "Россия",
    "searchString": "капустин яр россия / астраханская область / капустин яр"
  },
  "5174": {
    "id": "5174",
    "name": "Красный Яр (Астраханская область)",
    "path": "Россия / Астраханская область / Красный Яр (Астраханская область)",
    "country": "Россия",
    "searchString": "красный яр (астраханская область) россия / астраханская область / красный яр (астраханская область)"
  },
  "5175": {
    "id": "5175",
    "name": "Лиман (Астраханская область)",
    "path": "Россия / Астраханская область / Лиман (Астраханская область)",
    "country": "Россия",
    "searchString": "лиман (астраханская область) россия / астраханская область / лиман (астраханская область)"
  },
  "5176": {
    "id": "5176",
    "name": "Марфино (Астраханская область)",
    "path": "Россия / Астраханская область / Марфино (Астраханская область)",
    "country": "Россия",
    "searchString": "марфино (астраханская область) россия / астраханская область / марфино (астраханская область)"
  },
  "5177": {
    "id": "5177",
    "name": "Началово",
    "path": "Россия / Астраханская область / Началово",
    "country": "Россия",
    "searchString": "началово россия / астраханская область / началово"
  },
  "5178": {
    "id": "5178",
    "name": "Нижний Баскунчак",
    "path": "Россия / Астраханская область / Нижний Баскунчак",
    "country": "Россия",
    "searchString": "нижний баскунчак россия / астраханская область / нижний баскунчак"
  },
  "5179": {
    "id": "5179",
    "name": "Никольское (Астраханская область)",
    "path": "Россия / Астраханская область / Никольское (Астраханская область)",
    "country": "Россия",
    "searchString": "никольское (астраханская область) россия / астраханская область / никольское (астраханская область)"
  },
  "5180": {
    "id": "5180",
    "name": "Оранжереи",
    "path": "Россия / Астраханская область / Оранжереи",
    "country": "Россия",
    "searchString": "оранжереи россия / астраханская область / оранжереи"
  },
  "5181": {
    "id": "5181",
    "name": "Сасыколи",
    "path": "Россия / Астраханская область / Сасыколи",
    "country": "Россия",
    "searchString": "сасыколи россия / астраханская область / сасыколи"
  },
  "5182": {
    "id": "5182",
    "name": "Солянка",
    "path": "Россия / Астраханская область / Солянка",
    "country": "Россия",
    "searchString": "солянка россия / астраханская область / солянка"
  },
  "5183": {
    "id": "5183",
    "name": "Старокучергановка",
    "path": "Россия / Астраханская область / Старокучергановка",
    "country": "Россия",
    "searchString": "старокучергановка россия / астраханская область / старокучергановка"
  },
  "5184": {
    "id": "5184",
    "name": "Тамбовка (Астраханская область)",
    "path": "Россия / Астраханская область / Тамбовка (Астраханская область)",
    "country": "Россия",
    "searchString": "тамбовка (астраханская область) россия / астраханская область / тамбовка (астраханская область)"
  },
  "5185": {
    "id": "5185",
    "name": "Черный Яр",
    "path": "Россия / Астраханская область / Черный Яр",
    "country": "Россия",
    "searchString": "черный яр россия / астраханская область / черный яр"
  },
  "5186": {
    "id": "5186",
    "name": "Яксатово",
    "path": "Россия / Астраханская область / Яксатово",
    "country": "Россия",
    "searchString": "яксатово россия / астраханская область / яксатово"
  },
  "5187": {
    "id": "5187",
    "name": "Яндыки",
    "path": "Россия / Астраханская область / Яндыки",
    "country": "Россия",
    "searchString": "яндыки россия / астраханская область / яндыки"
  },
  "5188": {
    "id": "5188",
    "name": "Большой Царын",
    "path": "Россия / Республика Калмыкия / Большой Царын",
    "country": "Россия",
    "searchString": "большой царын россия / республика калмыкия / большой царын"
  },
  "5189": {
    "id": "5189",
    "name": "Ики-Бурул",
    "path": "Россия / Республика Калмыкия / Ики-Бурул",
    "country": "Россия",
    "searchString": "ики-бурул россия / республика калмыкия / ики-бурул"
  },
  "5190": {
    "id": "5190",
    "name": "Кетченеры",
    "path": "Россия / Республика Калмыкия / Кетченеры",
    "country": "Россия",
    "searchString": "кетченеры россия / республика калмыкия / кетченеры"
  },
  "5191": {
    "id": "5191",
    "name": "Комсомольский",
    "path": "Россия / Республика Калмыкия / Комсомольский",
    "country": "Россия",
    "searchString": "комсомольский россия / республика калмыкия / комсомольский"
  },
  "5192": {
    "id": "5192",
    "name": "Коробкин",
    "path": "Россия / Республика Калмыкия / Коробкин",
    "country": "Россия",
    "searchString": "коробкин россия / республика калмыкия / коробкин"
  },
  "5193": {
    "id": "5193",
    "name": "Малые Дербеты",
    "path": "Россия / Республика Калмыкия / Малые Дербеты",
    "country": "Россия",
    "searchString": "малые дербеты россия / республика калмыкия / малые дербеты"
  },
  "5194": {
    "id": "5194",
    "name": "Приютное",
    "path": "Россия / Республика Калмыкия / Приютное",
    "country": "Россия",
    "searchString": "приютное россия / республика калмыкия / приютное"
  },
  "5195": {
    "id": "5195",
    "name": "Садовое",
    "path": "Россия / Республика Калмыкия / Садовое",
    "country": "Россия",
    "searchString": "садовое россия / республика калмыкия / садовое"
  },
  "5196": {
    "id": "5196",
    "name": "Цаган Аман",
    "path": "Россия / Республика Калмыкия / Цаган Аман",
    "country": "Россия",
    "searchString": "цаган аман россия / республика калмыкия / цаган аман"
  },
  "5197": {
    "id": "5197",
    "name": "Шатта (Кетченеровский район)",
    "path": "Россия / Республика Калмыкия / Шатта (Кетченеровский район)",
    "country": "Россия",
    "searchString": "шатта (кетченеровский район) россия / республика калмыкия / шатта (кетченеровский район)"
  },
  "5198": {
    "id": "5198",
    "name": "Яшалта",
    "path": "Россия / Республика Калмыкия / Яшалта",
    "country": "Россия",
    "searchString": "яшалта россия / республика калмыкия / яшалта"
  },
  "5199": {
    "id": "5199",
    "name": "Яшкуль",
    "path": "Россия / Республика Калмыкия / Яшкуль",
    "country": "Россия",
    "searchString": "яшкуль россия / республика калмыкия / яшкуль"
  },
  "5200": {
    "id": "5200",
    "name": "Прогресс (Амурская область)",
    "path": "Россия / Амурская область / Прогресс (Амурская область)",
    "country": "Россия",
    "searchString": "прогресс (амурская область) россия / амурская область / прогресс (амурская область)"
  },
  "5201": {
    "id": "5201",
    "name": "Магдагачи",
    "path": "Россия / Амурская область / Магдагачи",
    "country": "Россия",
    "searchString": "магдагачи россия / амурская область / магдагачи"
  },
  "5202": {
    "id": "5202",
    "name": "Серышево",
    "path": "Россия / Амурская область / Серышево",
    "country": "Россия",
    "searchString": "серышево россия / амурская область / серышево"
  },
  "5203": {
    "id": "5203",
    "name": "Екатеринославка (Амурская область)",
    "path": "Россия / Амурская область / Екатеринославка (Амурская область)",
    "country": "Россия",
    "searchString": "екатеринославка (амурская область) россия / амурская область / екатеринославка (амурская область)"
  },
  "5204": {
    "id": "5204",
    "name": "Архара",
    "path": "Россия / Амурская область / Архара",
    "country": "Россия",
    "searchString": "архара россия / амурская область / архара"
  },
  "5205": {
    "id": "5205",
    "name": "Чигири (Амурская область)",
    "path": "Россия / Амурская область / Чигири (Амурская область)",
    "country": "Россия",
    "searchString": "чигири (амурская область) россия / амурская область / чигири (амурская область)"
  },
  "5206": {
    "id": "5206",
    "name": "Новобурейский",
    "path": "Россия / Амурская область / Новобурейский",
    "country": "Россия",
    "searchString": "новобурейский россия / амурская область / новобурейский"
  },
  "5207": {
    "id": "5207",
    "name": "Тамбовка (Амурская область)",
    "path": "Россия / Амурская область / Тамбовка (Амурская область)",
    "country": "Россия",
    "searchString": "тамбовка (амурская область) россия / амурская область / тамбовка (амурская область)"
  },
  "5208": {
    "id": "5208",
    "name": "Поярково (Амурская область)",
    "path": "Россия / Амурская область / Поярково (Амурская область)",
    "country": "Россия",
    "searchString": "поярково (амурская область) россия / амурская область / поярково (амурская область)"
  },
  "5209": {
    "id": "5209",
    "name": "Ивановка (Ивановский район, Амурская область)",
    "path": "Россия / Амурская область / Ивановка (Ивановский район, Амурская область)",
    "country": "Россия",
    "searchString": "ивановка (ивановский район, амурская область) россия / амурская область / ивановка (ивановский район, амурская область)"
  },
  "5210": {
    "id": "5210",
    "name": "Циолковский",
    "path": "Россия / Амурская область / Циолковский",
    "country": "Россия",
    "searchString": "циолковский россия / амурская область / циолковский"
  },
  "5211": {
    "id": "5211",
    "name": "Константиновка (Амурская область)",
    "path": "Россия / Амурская область / Константиновка (Амурская область)",
    "country": "Россия",
    "searchString": "константиновка (амурская область) россия / амурская область / константиновка (амурская область)"
  },
  "5212": {
    "id": "5212",
    "name": "Возжаевка",
    "path": "Россия / Амурская область / Возжаевка",
    "country": "Россия",
    "searchString": "возжаевка россия / амурская область / возжаевка"
  },
  "5213": {
    "id": "5213",
    "name": "Февральск (Амурская область)",
    "path": "Россия / Амурская область / Февральск (Амурская область)",
    "country": "Россия",
    "searchString": "февральск (амурская область) россия / амурская область / февральск (амурская область)"
  },
  "5214": {
    "id": "5214",
    "name": "Ерофей Павлович",
    "path": "Россия / Амурская область / Ерофей Павлович",
    "country": "Россия",
    "searchString": "ерофей павлович россия / амурская область / ерофей павлович"
  },
  "5215": {
    "id": "5215",
    "name": "Талакан (Амурская область)",
    "path": "Россия / Амурская область / Талакан (Амурская область)",
    "country": "Россия",
    "searchString": "талакан (амурская область) россия / амурская область / талакан (амурская область)"
  },
  "5216": {
    "id": "5216",
    "name": "Бурея (Амурская область)",
    "path": "Россия / Амурская область / Бурея (Амурская область)",
    "country": "Россия",
    "searchString": "бурея (амурская область) россия / амурская область / бурея (амурская область)"
  },
  "5217": {
    "id": "5217",
    "name": "Николаевка (Еврейская АО)",
    "path": "Россия / Еврейская АО / Николаевка (Еврейская АО)",
    "country": "Россия",
    "searchString": "николаевка (еврейская ао) россия / еврейская ао / николаевка (еврейская ао)"
  },
  "5218": {
    "id": "5218",
    "name": "Ленинское (Еврейская АО)",
    "path": "Россия / Еврейская АО / Ленинское (Еврейская АО)",
    "country": "Россия",
    "searchString": "ленинское (еврейская ао) россия / еврейская ао / ленинское (еврейская ао)"
  },
  "5219": {
    "id": "5219",
    "name": "Амурзет",
    "path": "Россия / Еврейская АО / Амурзет",
    "country": "Россия",
    "searchString": "амурзет россия / еврейская ао / амурзет"
  },
  "5220": {
    "id": "5220",
    "name": "Смидович (Еврейская АО)",
    "path": "Россия / Еврейская АО / Смидович (Еврейская АО)",
    "country": "Россия",
    "searchString": "смидович (еврейская ао) россия / еврейская ао / смидович (еврейская ао)"
  },
  "5221": {
    "id": "5221",
    "name": "Бабстово",
    "path": "Россия / Еврейская АО / Бабстово",
    "country": "Россия",
    "searchString": "бабстово россия / еврейская ао / бабстово"
  },
  "5222": {
    "id": "5222",
    "name": "Теплоозёрск",
    "path": "Россия / Еврейская АО / Теплоозёрск",
    "country": "Россия",
    "searchString": "теплоозёрск россия / еврейская ао / теплоозёрск"
  },
  "5223": {
    "id": "5223",
    "name": "Приамурский",
    "path": "Россия / Еврейская АО / Приамурский",
    "country": "Россия",
    "searchString": "приамурский россия / еврейская ао / приамурский"
  },
  "5224": {
    "id": "5224",
    "name": "Птичник (Еврейская АО)",
    "path": "Россия / Еврейская АО / Птичник (Еврейская АО)",
    "country": "Россия",
    "searchString": "птичник (еврейская ао) россия / еврейская ао / птичник (еврейская ао)"
  },
  "5225": {
    "id": "5225",
    "name": "Биракан",
    "path": "Россия / Еврейская АО / Биракан",
    "country": "Россия",
    "searchString": "биракан россия / еврейская ао / биракан"
  },
  "5226": {
    "id": "5226",
    "name": "Мильково (Камчатский край)",
    "path": "Россия / Камчатский край / Мильково (Камчатский край)",
    "country": "Россия",
    "searchString": "мильково (камчатский край) россия / камчатский край / мильково (камчатский край)"
  },
  "5227": {
    "id": "5227",
    "name": "Ключи (Камчатский край)",
    "path": "Россия / Камчатский край / Ключи (Камчатский край)",
    "country": "Россия",
    "searchString": "ключи (камчатский край) россия / камчатский край / ключи (камчатский край)"
  },
  "5228": {
    "id": "5228",
    "name": "Усть-Камчатск",
    "path": "Россия / Камчатский край / Усть-Камчатск",
    "country": "Россия",
    "searchString": "усть-камчатск россия / камчатский край / усть-камчатск"
  },
  "5229": {
    "id": "5229",
    "name": "Пионерский (Камчатский край)",
    "path": "Россия / Камчатский край / Пионерский (Камчатский край)",
    "country": "Россия",
    "searchString": "пионерский (камчатский край) россия / камчатский край / пионерский (камчатский край)"
  },
  "5230": {
    "id": "5230",
    "name": "Коряки (Камчатский край)",
    "path": "Россия / Камчатский край / Коряки (Камчатский край)",
    "country": "Россия",
    "searchString": "коряки (камчатский край) россия / камчатский край / коряки (камчатский край)"
  },
  "5231": {
    "id": "5231",
    "name": "Раздольный (Камчатский край)",
    "path": "Россия / Камчатский край / Раздольный (Камчатский край)",
    "country": "Россия",
    "searchString": "раздольный (камчатский край) россия / камчатский край / раздольный (камчатский край)"
  },
  "5232": {
    "id": "5232",
    "name": "Оссора",
    "path": "Россия / Камчатский край / Оссора",
    "country": "Россия",
    "searchString": "оссора россия / камчатский край / оссора"
  },
  "5233": {
    "id": "5233",
    "name": "Термальный",
    "path": "Россия / Камчатский край / Термальный",
    "country": "Россия",
    "searchString": "термальный россия / камчатский край / термальный"
  },
  "5234": {
    "id": "5234",
    "name": "Усть-Большерецк",
    "path": "Россия / Камчатский край / Усть-Большерецк",
    "country": "Россия",
    "searchString": "усть-большерецк россия / камчатский край / усть-большерецк"
  },
  "5235": {
    "id": "5235",
    "name": "Эссо",
    "path": "Россия / Камчатский край / Эссо",
    "country": "Россия",
    "searchString": "эссо россия / камчатский край / эссо"
  },
  "5236": {
    "id": "5236",
    "name": "Николаевка (Камчатский край)",
    "path": "Россия / Камчатский край / Николаевка (Камчатский край)",
    "country": "Россия",
    "searchString": "николаевка (камчатский край) россия / камчатский край / николаевка (камчатский край)"
  },
  "5237": {
    "id": "5237",
    "name": "Озерновский",
    "path": "Россия / Камчатский край / Озерновский",
    "country": "Россия",
    "searchString": "озерновский россия / камчатский край / озерновский"
  },
  "5238": {
    "id": "5238",
    "name": "Соболево (Камчатский край)",
    "path": "Россия / Камчатский край / Соболево (Камчатский край)",
    "country": "Россия",
    "searchString": "соболево (камчатский край) россия / камчатский край / соболево (камчатский край)"
  },
  "5239": {
    "id": "5239",
    "name": "Октябрьский (Камчатский край)",
    "path": "Россия / Камчатский край / Октябрьский (Камчатский край)",
    "country": "Россия",
    "searchString": "октябрьский (камчатский край) россия / камчатский край / октябрьский (камчатский край)"
  },
  "5240": {
    "id": "5240",
    "name": "Паратунка",
    "path": "Россия / Камчатский край / Паратунка",
    "country": "Россия",
    "searchString": "паратунка россия / камчатский край / паратунка"
  },
  "5241": {
    "id": "5241",
    "name": "Тигиль",
    "path": "Россия / Камчатский край / Тигиль",
    "country": "Россия",
    "searchString": "тигиль россия / камчатский край / тигиль"
  },
  "5242": {
    "id": "5242",
    "name": "Вулканный",
    "path": "Россия / Камчатский край / Вулканный",
    "country": "Россия",
    "searchString": "вулканный россия / камчатский край / вулканный"
  },
  "5243": {
    "id": "5243",
    "name": "Тиличики",
    "path": "Россия / Камчатский край / Тиличики",
    "country": "Россия",
    "searchString": "тиличики россия / камчатский край / тиличики"
  },
  "5244": {
    "id": "5244",
    "name": "Козыревск",
    "path": "Россия / Камчатский край / Козыревск",
    "country": "Россия",
    "searchString": "козыревск россия / камчатский край / козыревск"
  },
  "5245": {
    "id": "5245",
    "name": "Новый (Камчатский край)",
    "path": "Россия / Камчатский край / Новый (Камчатский край)",
    "country": "Россия",
    "searchString": "новый (камчатский край) россия / камчатский край / новый (камчатский край)"
  },
  "5246": {
    "id": "5246",
    "name": "Ола (Магаданская область)",
    "path": "Россия / Магаданская область / Ола (Магаданская область)",
    "country": "Россия",
    "searchString": "ола (магаданская область) россия / магаданская область / ола (магаданская область)"
  },
  "5247": {
    "id": "5247",
    "name": "Сокол (Магаданская область)",
    "path": "Россия / Магаданская область / Сокол (Магаданская область)",
    "country": "Россия",
    "searchString": "сокол (магаданская область) россия / магаданская область / сокол (магаданская область)"
  },
  "5248": {
    "id": "5248",
    "name": "Палатка (Магаданская область)",
    "path": "Россия / Магаданская область / Палатка (Магаданская область)",
    "country": "Россия",
    "searchString": "палатка (магаданская область) россия / магаданская область / палатка (магаданская область)"
  },
  "5249": {
    "id": "5249",
    "name": "Ягодное (Магаданская область)",
    "path": "Россия / Магаданская область / Ягодное (Магаданская область)",
    "country": "Россия",
    "searchString": "ягодное (магаданская область) россия / магаданская область / ягодное (магаданская область)"
  },
  "5250": {
    "id": "5250",
    "name": "Омсукчан",
    "path": "Россия / Магаданская область / Омсукчан",
    "country": "Россия",
    "searchString": "омсукчан россия / магаданская область / омсукчан"
  },
  "5251": {
    "id": "5251",
    "name": "Усть-Омчуг",
    "path": "Россия / Магаданская область / Усть-Омчуг",
    "country": "Россия",
    "searchString": "усть-омчуг россия / магаданская область / усть-омчуг"
  },
  "5252": {
    "id": "5252",
    "name": "Синегорье (Магаданская область)",
    "path": "Россия / Магаданская область / Синегорье (Магаданская область)",
    "country": "Россия",
    "searchString": "синегорье (магаданская область) россия / магаданская область / синегорье (магаданская область)"
  },
  "5253": {
    "id": "5253",
    "name": "Сеймчан",
    "path": "Россия / Магаданская область / Сеймчан",
    "country": "Россия",
    "searchString": "сеймчан россия / магаданская область / сеймчан"
  },
  "5254": {
    "id": "5254",
    "name": "Стекольный",
    "path": "Россия / Магаданская область / Стекольный",
    "country": "Россия",
    "searchString": "стекольный россия / магаданская область / стекольный"
  },
  "5255": {
    "id": "5255",
    "name": "Уптар",
    "path": "Россия / Магаданская область / Уптар",
    "country": "Россия",
    "searchString": "уптар россия / магаданская область / уптар"
  },
  "5256": {
    "id": "5256",
    "name": "Мяунджа",
    "path": "Россия / Магаданская область / Мяунджа",
    "country": "Россия",
    "searchString": "мяунджа россия / магаданская область / мяунджа"
  },
  "5257": {
    "id": "5257",
    "name": "Дукат (Магаданская область)",
    "path": "Россия / Магаданская область / Дукат (Магаданская область)",
    "country": "Россия",
    "searchString": "дукат (магаданская область) россия / магаданская область / дукат (магаданская область)"
  },
  "5258": {
    "id": "5258",
    "name": "Оротукан",
    "path": "Россия / Магаданская область / Оротукан",
    "country": "Россия",
    "searchString": "оротукан россия / магаданская область / оротукан"
  },
  "5259": {
    "id": "5259",
    "name": "Лучегорск",
    "path": "Россия / Приморский край / Лучегорск",
    "country": "Россия",
    "searchString": "лучегорск россия / приморский край / лучегорск"
  },
  "5260": {
    "id": "5260",
    "name": "Трудовое (Приморский край)",
    "path": "Россия / Приморский край / Трудовое (Приморский край)",
    "country": "Россия",
    "searchString": "трудовое (приморский край) россия / приморский край / трудовое (приморский край)"
  },
  "5261": {
    "id": "5261",
    "name": "Славянка (Приморский край)",
    "path": "Россия / Приморский край / Славянка (Приморский край)",
    "country": "Россия",
    "searchString": "славянка (приморский край) россия / приморский край / славянка (приморский край)"
  },
  "5262": {
    "id": "5262",
    "name": "Черниговка (Приморский край)",
    "path": "Россия / Приморский край / Черниговка (Приморский край)",
    "country": "Россия",
    "searchString": "черниговка (приморский край) россия / приморский край / черниговка (приморский край)"
  },
  "5263": {
    "id": "5263",
    "name": "Чугуевка",
    "path": "Россия / Приморский край / Чугуевка",
    "country": "Россия",
    "searchString": "чугуевка россия / приморский край / чугуевка"
  },
  "5264": {
    "id": "5264",
    "name": "Камень-Рыболов",
    "path": "Россия / Приморский край / Камень-Рыболов",
    "country": "Россия",
    "searchString": "камень-рыболов россия / приморский край / камень-рыболов"
  },
  "5265": {
    "id": "5265",
    "name": "Хороль",
    "path": "Россия / Приморский край / Хороль",
    "country": "Россия",
    "searchString": "хороль россия / приморский край / хороль"
  },
  "5266": {
    "id": "5266",
    "name": "Покровка (Октябрьский район, Приморский край)",
    "path": "Россия / Приморский край / Покровка (Октябрьский район, Приморский край)",
    "country": "Россия",
    "searchString": "покровка (октябрьский район, приморский край) россия / приморский край / покровка (октябрьский район, приморский край)"
  },
  "5267": {
    "id": "5267",
    "name": "Пограничный (Приморский край)",
    "path": "Россия / Приморский край / Пограничный (Приморский край)",
    "country": "Россия",
    "searchString": "пограничный (приморский край) россия / приморский край / пограничный (приморский край)"
  },
  "5268": {
    "id": "5268",
    "name": "Тымовское",
    "path": "Россия / Сахалинская область / Тымовское",
    "country": "Россия",
    "searchString": "тымовское россия / сахалинская область / тымовское"
  },
  "5269": {
    "id": "5269",
    "name": "Смирных",
    "path": "Россия / Сахалинская область / Смирных",
    "country": "Россия",
    "searchString": "смирных россия / сахалинская область / смирных"
  },
  "5270": {
    "id": "5270",
    "name": "Троицкое (Сахалинская область)",
    "path": "Россия / Сахалинская область / Троицкое (Сахалинская область)",
    "country": "Россия",
    "searchString": "троицкое (сахалинская область) россия / сахалинская область / троицкое (сахалинская область)"
  },
  "5271": {
    "id": "5271",
    "name": "Горнозаводск (Сахалинская область)",
    "path": "Россия / Сахалинская область / Горнозаводск (Сахалинская область)",
    "country": "Россия",
    "searchString": "горнозаводск (сахалинская область) россия / сахалинская область / горнозаводск (сахалинская область)"
  },
  "5272": {
    "id": "5272",
    "name": "Быков (Сахалинская область)",
    "path": "Россия / Сахалинская область / Быков (Сахалинская область)",
    "country": "Россия",
    "searchString": "быков (сахалинская область) россия / сахалинская область / быков (сахалинская область)"
  },
  "5273": {
    "id": "5273",
    "name": "Сокол (Сахалинская область)",
    "path": "Россия / Сахалинская область / Сокол (Сахалинская область)",
    "country": "Россия",
    "searchString": "сокол (сахалинская область) россия / сахалинская область / сокол (сахалинская область)"
  },
  "5274": {
    "id": "5274",
    "name": "Чехов (Сахалинская область)",
    "path": "Россия / Сахалинская область / Чехов (Сахалинская область)",
    "country": "Россия",
    "searchString": "чехов (сахалинская область) россия / сахалинская область / чехов (сахалинская область)"
  },
  "5275": {
    "id": "5275",
    "name": "Чегдомын",
    "path": "Россия / Хабаровский край / Чегдомын",
    "country": "Россия",
    "searchString": "чегдомын россия / хабаровский край / чегдомын"
  },
  "5276": {
    "id": "5276",
    "name": "Эльбан",
    "path": "Россия / Хабаровский край / Эльбан",
    "country": "Россия",
    "searchString": "эльбан россия / хабаровский край / эльбан"
  },
  "5277": {
    "id": "5277",
    "name": "Хор (Хабаровский край)",
    "path": "Россия / Хабаровский край / Хор (Хабаровский край)",
    "country": "Россия",
    "searchString": "хор (хабаровский край) россия / хабаровский край / хор (хабаровский край)"
  },
  "5278": {
    "id": "5278",
    "name": "Князе-Волконское",
    "path": "Россия / Хабаровский край / Князе-Волконское",
    "country": "Россия",
    "searchString": "князе-волконское россия / хабаровский край / князе-волконское"
  },
  "5279": {
    "id": "5279",
    "name": "Заветы Ильича (Хабаровский край)",
    "path": "Россия / Хабаровский край / Заветы Ильича (Хабаровский край)",
    "country": "Россия",
    "searchString": "заветы ильича (хабаровский край) россия / хабаровский край / заветы ильича (хабаровский край)"
  },
  "5280": {
    "id": "5280",
    "name": "Переяславка",
    "path": "Россия / Хабаровский край / Переяславка",
    "country": "Россия",
    "searchString": "переяславка россия / хабаровский край / переяславка"
  },
  "5281": {
    "id": "5281",
    "name": "Новый Ургал",
    "path": "Россия / Хабаровский край / Новый Ургал",
    "country": "Россия",
    "searchString": "новый ургал россия / хабаровский край / новый ургал"
  },
  "5282": {
    "id": "5282",
    "name": "Хурба",
    "path": "Россия / Хабаровский край / Хурба",
    "country": "Россия",
    "searchString": "хурба россия / хабаровский край / хурба"
  },
  "5283": {
    "id": "5283",
    "name": "Октябрьский (Хабаровский край)",
    "path": "Россия / Хабаровский край / Октябрьский (Хабаровский край)",
    "country": "Россия",
    "searchString": "октябрьский (хабаровский край) россия / хабаровский край / октябрьский (хабаровский край)"
  },
  "5284": {
    "id": "5284",
    "name": "Корфовский",
    "path": "Россия / Хабаровский край / Корфовский",
    "country": "Россия",
    "searchString": "корфовский россия / хабаровский край / корфовский"
  },
  "5285": {
    "id": "5285",
    "name": "Берёзовый (Хабаровский край)",
    "path": "Россия / Хабаровский край / Берёзовый (Хабаровский край)",
    "country": "Россия",
    "searchString": "берёзовый (хабаровский край) россия / хабаровский край / берёзовый (хабаровский край)"
  },
  "5286": {
    "id": "5286",
    "name": "Угольные Копи",
    "path": "Россия / Чукотский АО / Угольные Копи",
    "country": "Россия",
    "searchString": "угольные копи россия / чукотский ао / угольные копи"
  },
  "5287": {
    "id": "5287",
    "name": "Эгвекинот",
    "path": "Россия / Чукотский АО / Эгвекинот",
    "country": "Россия",
    "searchString": "эгвекинот россия / чукотский ао / эгвекинот"
  },
  "5288": {
    "id": "5288",
    "name": "Провидения",
    "path": "Россия / Чукотский АО / Провидения",
    "country": "Россия",
    "searchString": "провидения россия / чукотский ао / провидения"
  },
  "5289": {
    "id": "5289",
    "name": "Лаврентия",
    "path": "Россия / Чукотский АО / Лаврентия",
    "country": "Россия",
    "searchString": "лаврентия россия / чукотский ао / лаврентия"
  },
  "5290": {
    "id": "5290",
    "name": "Мыс Шмидта",
    "path": "Россия / Чукотский АО / Мыс Шмидта",
    "country": "Россия",
    "searchString": "мыс шмидта россия / чукотский ао / мыс шмидта"
  },
  "5291": {
    "id": "5291",
    "name": "Лорино (Чукотский АО)",
    "path": "Россия / Чукотский АО / Лорино (Чукотский АО)",
    "country": "Россия",
    "searchString": "лорино (чукотский ао) россия / чукотский ао / лорино (чукотский ао)"
  },
  "5292": {
    "id": "5292",
    "name": "Нагорный (Камчатский край)",
    "path": "Россия / Камчатский край / Нагорный (Камчатский край)",
    "country": "Россия",
    "searchString": "нагорный (камчатский край) россия / камчатский край / нагорный (камчатский край)"
  },
  "5293": {
    "id": "5293",
    "name": "Сунтар",
    "path": "Россия / Республика Саха (Якутия) / Сунтар",
    "country": "Россия",
    "searchString": "сунтар россия / республика саха (якутия) / сунтар"
  },
  "5294": {
    "id": "5294",
    "name": "Намцы",
    "path": "Россия / Республика Саха (Якутия) / Намцы",
    "country": "Россия",
    "searchString": "намцы россия / республика саха (якутия) / намцы"
  },
  "5295": {
    "id": "5295",
    "name": "Чурапча",
    "path": "Россия / Республика Саха (Якутия) / Чурапча",
    "country": "Россия",
    "searchString": "чурапча россия / республика саха (якутия) / чурапча"
  },
  "5296": {
    "id": "5296",
    "name": "Жатай",
    "path": "Россия / Республика Саха (Якутия) / Жатай",
    "country": "Россия",
    "searchString": "жатай россия / республика саха (якутия) / жатай"
  },
  "5297": {
    "id": "5297",
    "name": "Чульман",
    "path": "Россия / Республика Саха (Якутия) / Чульман",
    "country": "Россия",
    "searchString": "чульман россия / республика саха (якутия) / чульман"
  },
  "5298": {
    "id": "5298",
    "name": "Майя",
    "path": "Россия / Республика Саха (Якутия) / Майя",
    "country": "Россия",
    "searchString": "майя россия / республика саха (якутия) / майя"
  },
  "5299": {
    "id": "5299",
    "name": "Южный (Ростовская область)",
    "path": "Россия / Ростовская область / Южный (Ростовская область)",
    "country": "Россия",
    "searchString": "южный (ростовская область) россия / ростовская область / южный (ростовская область)"
  },
  "5300": {
    "id": "5300",
    "name": "Крым (Ростовская область)",
    "path": "Россия / Ростовская область / Крым (Ростовская область)",
    "country": "Россия",
    "searchString": "крым (ростовская область) россия / ростовская область / крым (ростовская область)"
  },
  "5301": {
    "id": "5301",
    "name": "Советская (Ростовская область)",
    "path": "Россия / Ростовская область / Советская (Ростовская область)",
    "country": "Россия",
    "searchString": "советская (ростовская область) россия / ростовская область / советская (ростовская область)"
  },
  "5302": {
    "id": "5302",
    "name": "Красноярская (Ростовская область)",
    "path": "Россия / Ростовская область / Красноярская (Ростовская область)",
    "country": "Россия",
    "searchString": "красноярская (ростовская область) россия / ростовская область / красноярская (ростовская область)"
  },
  "5303": {
    "id": "5303",
    "name": "Горный (Ростовская область)",
    "path": "Россия / Ростовская область / Горный (Ростовская область)",
    "country": "Россия",
    "searchString": "горный (ростовская область) россия / ростовская область / горный (ростовская область)"
  },
  "5304": {
    "id": "5304",
    "name": "Рябовский",
    "path": "Россия / Волгоградская область / Рябовский",
    "country": "Россия",
    "searchString": "рябовский россия / волгоградская область / рябовский"
  },
  "5305": {
    "id": "5305",
    "name": "Медведицкий",
    "path": "Россия / Волгоградская область / Медведицкий",
    "country": "Россия",
    "searchString": "медведицкий россия / волгоградская область / медведицкий"
  },
  "5306": {
    "id": "5306",
    "name": "Зензеватка",
    "path": "Россия / Волгоградская область / Зензеватка",
    "country": "Россия",
    "searchString": "зензеватка россия / волгоградская область / зензеватка"
  },
  "5307": {
    "id": "5307",
    "name": "Образцы",
    "path": "Россия / Волгоградская область / Образцы",
    "country": "Россия",
    "searchString": "образцы россия / волгоградская область / образцы"
  },
  "5308": {
    "id": "5308",
    "name": "Большой Лычак",
    "path": "Россия / Волгоградская область / Большой Лычак",
    "country": "Россия",
    "searchString": "большой лычак россия / волгоградская область / большой лычак"
  },
  "5309": {
    "id": "5309",
    "name": "Пригородный (Волгоградская область)",
    "path": "Россия / Волгоградская область / Пригородный (Волгоградская область)",
    "country": "Россия",
    "searchString": "пригородный (волгоградская область) россия / волгоградская область / пригородный (волгоградская область)"
  },
  "5310": {
    "id": "5310",
    "name": "Шуруповский",
    "path": "Россия / Волгоградская область / Шуруповский",
    "country": "Россия",
    "searchString": "шуруповский россия / волгоградская область / шуруповский"
  },
  "5311": {
    "id": "5311",
    "name": "Рубёжный",
    "path": "Россия / Волгоградская область / Рубёжный",
    "country": "Россия",
    "searchString": "рубёжный россия / волгоградская область / рубёжный"
  },
  "5312": {
    "id": "5312",
    "name": "Ветютнев",
    "path": "Россия / Волгоградская область / Ветютнев",
    "country": "Россия",
    "searchString": "ветютнев россия / волгоградская область / ветютнев"
  },
  "5313": {
    "id": "5313",
    "name": "Гуляевка (Волгоградская область)",
    "path": "Россия / Волгоградская область / Гуляевка (Волгоградская область)",
    "country": "Россия",
    "searchString": "гуляевка (волгоградская область) россия / волгоградская область / гуляевка (волгоградская область)"
  },
  "5314": {
    "id": "5314",
    "name": "Колобродов",
    "path": "Россия / Волгоградская область / Колобродов",
    "country": "Россия",
    "searchString": "колобродов россия / волгоградская область / колобродов"
  },
  "5315": {
    "id": "5315",
    "name": "Новая Паника",
    "path": "Россия / Волгоградская область / Новая Паника",
    "country": "Россия",
    "searchString": "новая паника россия / волгоградская область / новая паника"
  },
  "5316": {
    "id": "5316",
    "name": "Школьный (Волгоградская область)",
    "path": "Россия / Волгоградская область / Школьный (Волгоградская область)",
    "country": "Россия",
    "searchString": "школьный (волгоградская область) россия / волгоградская область / школьный (волгоградская область)"
  },
  "5317": {
    "id": "5317",
    "name": "Дудаченский",
    "path": "Россия / Волгоградская область / Дудаченский",
    "country": "Россия",
    "searchString": "дудаченский россия / волгоградская область / дудаченский"
  },
  "5318": {
    "id": "5318",
    "name": "Красные Липки",
    "path": "Россия / Волгоградская область / Красные Липки",
    "country": "Россия",
    "searchString": "красные липки россия / волгоградская область / красные липки"
  },
  "5319": {
    "id": "5319",
    "name": "Лычак",
    "path": "Россия / Волгоградская область / Лычак",
    "country": "Россия",
    "searchString": "лычак россия / волгоградская область / лычак"
  },
  "5320": {
    "id": "5320",
    "name": "Малодельская",
    "path": "Россия / Волгоградская область / Малодельская",
    "country": "Россия",
    "searchString": "малодельская россия / волгоградская область / малодельская"
  },
  "5321": {
    "id": "5321",
    "name": "Кирпичный (Волгоградская область)",
    "path": "Россия / Волгоградская область / Кирпичный (Волгоградская область)",
    "country": "Россия",
    "searchString": "кирпичный (волгоградская область) россия / волгоградская область / кирпичный (волгоградская область)"
  },
  "5322": {
    "id": "5322",
    "name": "Писарёвка (Волгоградская область)",
    "path": "Россия / Волгоградская область / Писарёвка (Волгоградская область)",
    "country": "Россия",
    "searchString": "писарёвка (волгоградская область) россия / волгоградская область / писарёвка (волгоградская область)"
  },
  "5323": {
    "id": "5323",
    "name": "Улан-Хол",
    "path": "Россия / Республика Калмыкия / Улан-Хол",
    "country": "Россия",
    "searchString": "улан-хол россия / республика калмыкия / улан-хол"
  },
  "5324": {
    "id": "5324",
    "name": "Артезиан",
    "path": "Россия / Республика Калмыкия / Артезиан",
    "country": "Россия",
    "searchString": "артезиан россия / республика калмыкия / артезиан"
  },
  "5325": {
    "id": "5325",
    "name": "Солёное (Калмыкия)",
    "path": "Россия / Республика Калмыкия / Солёное (Калмыкия)",
    "country": "Россия",
    "searchString": "солёное (калмыкия) россия / республика калмыкия / солёное (калмыкия)"
  },
  "5326": {
    "id": "5326",
    "name": "Виноградное (Калмыкия)",
    "path": "Россия / Республика Калмыкия / Виноградное (Калмыкия)",
    "country": "Россия",
    "searchString": "виноградное (калмыкия) россия / республика калмыкия / виноградное (калмыкия)"
  },
  "5327": {
    "id": "5327",
    "name": "Болхуны",
    "path": "Россия / Астраханская область / Болхуны",
    "country": "Россия",
    "searchString": "болхуны россия / астраханская область / болхуны"
  },
  "5328": {
    "id": "5328",
    "name": "Золотуха (Астраханская область)",
    "path": "Россия / Астраханская область / Золотуха (Астраханская область)",
    "country": "Россия",
    "searchString": "золотуха (астраханская область) россия / астраханская область / золотуха (астраханская область)"
  },
  "5329": {
    "id": "5329",
    "name": "Ново-Николаевка (Астраханская область)",
    "path": "Россия / Астраханская область / Ново-Николаевка (Астраханская область)",
    "country": "Россия",
    "searchString": "ново-николаевка (астраханская область) россия / астраханская область / ново-николаевка (астраханская область)"
  },
  "5330": {
    "id": "5330",
    "name": "Тумак (Астраханская область)",
    "path": "Россия / Астраханская область / Тумак (Астраханская область)",
    "country": "Россия",
    "searchString": "тумак (астраханская область) россия / астраханская область / тумак (астраханская область)"
  },
  "5331": {
    "id": "5331",
    "name": "Волжский (Астраханская область)",
    "path": "Россия / Астраханская область / Волжский (Астраханская область)",
    "country": "Россия",
    "searchString": "волжский (астраханская область) россия / астраханская область / волжский (астраханская область)"
  },
  "5332": {
    "id": "5332",
    "name": "Бахтемир",
    "path": "Россия / Астраханская область / Бахтемир",
    "country": "Россия",
    "searchString": "бахтемир россия / астраханская область / бахтемир"
  },
  "5333": {
    "id": "5333",
    "name": "Житное (Астраханская область)",
    "path": "Россия / Астраханская область / Житное (Астраханская область)",
    "country": "Россия",
    "searchString": "житное (астраханская область) россия / астраханская область / житное (астраханская область)"
  },
  "5334": {
    "id": "5334",
    "name": "Мумра",
    "path": "Россия / Астраханская область / Мумра",
    "country": "Россия",
    "searchString": "мумра россия / астраханская область / мумра"
  },
  "5335": {
    "id": "5335",
    "name": "Трудфронт",
    "path": "Россия / Астраханская область / Трудфронт",
    "country": "Россия",
    "searchString": "трудфронт россия / астраханская область / трудфронт"
  },
  "5336": {
    "id": "5336",
    "name": "Волго-Каспийский",
    "path": "Россия / Астраханская область / Волго-Каспийский",
    "country": "Россия",
    "searchString": "волго-каспийский россия / астраханская область / волго-каспийский"
  },
  "5337": {
    "id": "5337",
    "name": "Кировский (Астраханская область)",
    "path": "Россия / Астраханская область / Кировский (Астраханская область)",
    "country": "Россия",
    "searchString": "кировский (астраханская область) россия / астраханская область / кировский (астраханская область)"
  },
  "5338": {
    "id": "5338",
    "name": "Тузуклей",
    "path": "Россия / Астраханская область / Тузуклей",
    "country": "Россия",
    "searchString": "тузуклей россия / астраханская область / тузуклей"
  },
  "5339": {
    "id": "5339",
    "name": "Образцово-Травино",
    "path": "Россия / Астраханская область / Образцово-Травино",
    "country": "Россия",
    "searchString": "образцово-травино россия / астраханская область / образцово-травино"
  },
  "5340": {
    "id": "5340",
    "name": "Байбек",
    "path": "Россия / Астраханская область / Байбек",
    "country": "Россия",
    "searchString": "байбек россия / астраханская область / байбек"
  },
  "5341": {
    "id": "5341",
    "name": "Буруны (Астраханская область)",
    "path": "Россия / Астраханская область / Буруны (Астраханская область)",
    "country": "Россия",
    "searchString": "буруны (астраханская область) россия / астраханская область / буруны (астраханская область)"
  },
  "5342": {
    "id": "5342",
    "name": "Волжское (Астраханская область)",
    "path": "Россия / Астраханская область / Волжское (Астраханская область)",
    "country": "Россия",
    "searchString": "волжское (астраханская область) россия / астраханская область / волжское (астраханская область)"
  },
  "5343": {
    "id": "5343",
    "name": "Килинчи",
    "path": "Россия / Астраханская область / Килинчи",
    "country": "Россия",
    "searchString": "килинчи россия / астраханская область / килинчи"
  },
  "5344": {
    "id": "5344",
    "name": "Карагали",
    "path": "Россия / Астраханская область / Карагали",
    "country": "Россия",
    "searchString": "карагали россия / астраханская область / карагали"
  },
  "5345": {
    "id": "5345",
    "name": "Осыпной Бугор",
    "path": "Россия / Астраханская область / Осыпной Бугор",
    "country": "Россия",
    "searchString": "осыпной бугор россия / астраханская область / осыпной бугор"
  },
  "5346": {
    "id": "5346",
    "name": "Растопуловка",
    "path": "Россия / Астраханская область / Растопуловка",
    "country": "Россия",
    "searchString": "растопуловка россия / астраханская область / растопуловка"
  },
  "5347": {
    "id": "5347",
    "name": "Татарская Башмаковка",
    "path": "Россия / Астраханская область / Татарская Башмаковка",
    "country": "Россия",
    "searchString": "татарская башмаковка россия / астраханская область / татарская башмаковка"
  },
  "5348": {
    "id": "5348",
    "name": "Солёное Займище (Астраханская область)",
    "path": "Россия / Астраханская область / Солёное Займище (Астраханская область)",
    "country": "Россия",
    "searchString": "солёное займище (астраханская область) россия / астраханская область / солёное займище (астраханская область)"
  },
  "5349": {
    "id": "5349",
    "name": "Ушаковка (Астраханская область)",
    "path": "Россия / Астраханская область / Ушаковка (Астраханская область)",
    "country": "Россия",
    "searchString": "ушаковка (астраханская область) россия / астраханская область / ушаковка (астраханская область)"
  },
  "5350": {
    "id": "5350",
    "name": "Старица (Астраханская область)",
    "path": "Россия / Астраханская область / Старица (Астраханская область)",
    "country": "Россия",
    "searchString": "старица (астраханская область) россия / астраханская область / старица (астраханская область)"
  },
  "5351": {
    "id": "5351",
    "name": "Селитренное",
    "path": "Россия / Астраханская область / Селитренное",
    "country": "Россия",
    "searchString": "селитренное россия / астраханская область / селитренное"
  },
  "5352": {
    "id": "5352",
    "name": "Хошеутово",
    "path": "Россия / Астраханская область / Хошеутово",
    "country": "Россия",
    "searchString": "хошеутово россия / астраханская область / хошеутово"
  },
  "5353": {
    "id": "5353",
    "name": "Кочковатка (Астраханская область)",
    "path": "Россия / Астраханская область / Кочковатка (Астраханская область)",
    "country": "Россия",
    "searchString": "кочковатка (астраханская область) россия / астраханская область / кочковатка (астраханская область)"
  },
  "5354": {
    "id": "5354",
    "name": "Вольное (Астраханская область)",
    "path": "Россия / Астраханская область / Вольное (Астраханская область)",
    "country": "Россия",
    "searchString": "вольное (астраханская область) россия / астраханская область / вольное (астраханская область)"
  },
  "5355": {
    "id": "5355",
    "name": "Солодники",
    "path": "Россия / Астраханская область / Солодники",
    "country": "Россия",
    "searchString": "солодники россия / астраханская область / солодники"
  },
  "5356": {
    "id": "5356",
    "name": "Три Протока",
    "path": "Россия / Астраханская область / Три Протока",
    "country": "Россия",
    "searchString": "три протока россия / астраханская область / три протока"
  },
  "5357": {
    "id": "5357",
    "name": "Бирюковка (Астраханская область)",
    "path": "Россия / Астраханская область / Бирюковка (Астраханская область)",
    "country": "Россия",
    "searchString": "бирюковка (астраханская область) россия / астраханская область / бирюковка (астраханская область)"
  },
  "5358": {
    "id": "5358",
    "name": "Разночиновка",
    "path": "Россия / Астраханская область / Разночиновка",
    "country": "Россия",
    "searchString": "разночиновка россия / астраханская область / разночиновка"
  },
  "5359": {
    "id": "5359",
    "name": "Прикаспийский",
    "path": "Россия / Астраханская область / Прикаспийский",
    "country": "Россия",
    "searchString": "прикаспийский россия / астраханская область / прикаспийский"
  },
  "5360": {
    "id": "5360",
    "name": "Кожва",
    "path": "Россия / Республика Коми / Кожва",
    "country": "Россия",
    "searchString": "кожва россия / республика коми / кожва"
  },
  "5361": {
    "id": "5361",
    "name": "Путеец (Коми)",
    "path": "Россия / Республика Коми / Путеец (Коми)",
    "country": "Россия",
    "searchString": "путеец (коми) россия / республика коми / путеец (коми)"
  },
  "5362": {
    "id": "5362",
    "name": "Войвож",
    "path": "Россия / Республика Коми / Войвож",
    "country": "Россия",
    "searchString": "войвож россия / республика коми / войвож"
  },
  "5363": {
    "id": "5363",
    "name": "Нижний Одес",
    "path": "Россия / Республика Коми / Нижний Одес",
    "country": "Россия",
    "searchString": "нижний одес россия / республика коми / нижний одес"
  },
  "5364": {
    "id": "5364",
    "name": "Троицко-Печорск",
    "path": "Россия / Республика Коми / Троицко-Печорск",
    "country": "Россия",
    "searchString": "троицко-печорск россия / республика коми / троицко-печорск"
  },
  "5365": {
    "id": "5365",
    "name": "Жешарт",
    "path": "Россия / Республика Коми / Жешарт",
    "country": "Россия",
    "searchString": "жешарт россия / республика коми / жешарт"
  },
  "5366": {
    "id": "5366",
    "name": "Усогорск",
    "path": "Россия / Республика Коми / Усогорск",
    "country": "Россия",
    "searchString": "усогорск россия / республика коми / усогорск"
  },
  "5367": {
    "id": "5367",
    "name": "Междуреченск (Коми)",
    "path": "Россия / Республика Коми / Междуреченск (Коми)",
    "country": "Россия",
    "searchString": "междуреченск (коми) россия / республика коми / междуреченск (коми)"
  },
  "5368": {
    "id": "5368",
    "name": "Благоево (Коми)",
    "path": "Россия / Республика Коми / Благоево (Коми)",
    "country": "Россия",
    "searchString": "благоево (коми) россия / республика коми / благоево (коми)"
  },
  "5369": {
    "id": "5369",
    "name": "Синдор",
    "path": "Россия / Республика Коми / Синдор",
    "country": "Россия",
    "searchString": "синдор россия / республика коми / синдор"
  },
  "5370": {
    "id": "5370",
    "name": "Поддорье",
    "path": "Россия / Новгородская область / Поддорье",
    "country": "Россия",
    "searchString": "поддорье россия / новгородская область / поддорье"
  },
  "5371": {
    "id": "5371",
    "name": "Мошенское (Новгородская область)",
    "path": "Россия / Новгородская область / Мошенское (Новгородская область)",
    "country": "Россия",
    "searchString": "мошенское (новгородская область) россия / новгородская область / мошенское (новгородская область)"
  },
  "5372": {
    "id": "5372",
    "name": "Марёво",
    "path": "Россия / Новгородская область / Марёво",
    "country": "Россия",
    "searchString": "марёво россия / новгородская область / марёво"
  },
  "5373": {
    "id": "5373",
    "name": "Волот (Новгородская область)",
    "path": "Россия / Новгородская область / Волот (Новгородская область)",
    "country": "Россия",
    "searchString": "волот (новгородская область) россия / новгородская область / волот (новгородская область)"
  },
  "5374": {
    "id": "5374",
    "name": "Батецкий",
    "path": "Россия / Новгородская область / Батецкий",
    "country": "Россия",
    "searchString": "батецкий россия / новгородская область / батецкий"
  },
  "5375": {
    "id": "5375",
    "name": "Поселок Искателей",
    "path": "Россия / Ненецкий АО / Поселок Искателей",
    "country": "Россия",
    "searchString": "поселок искателей россия / ненецкий ао / поселок искателей"
  },
  "5376": {
    "id": "5376",
    "name": "Ома (Ненецкий АО)",
    "path": "Россия / Ненецкий АО / Ома (Ненецкий АО)",
    "country": "Россия",
    "searchString": "ома (ненецкий ао) россия / ненецкий ао / ома (ненецкий ао)"
  },
  "5377": {
    "id": "5377",
    "name": "Индига",
    "path": "Россия / Ненецкий АО / Индига",
    "country": "Россия",
    "searchString": "индига россия / ненецкий ао / индига"
  },
  "5378": {
    "id": "5378",
    "name": "Амдерма",
    "path": "Россия / Ненецкий АО / Амдерма",
    "country": "Россия",
    "searchString": "амдерма россия / ненецкий ао / амдерма"
  },
  "5379": {
    "id": "5379",
    "name": "Усть-Кара",
    "path": "Россия / Ненецкий АО / Усть-Кара",
    "country": "Россия",
    "searchString": "усть-кара россия / ненецкий ао / усть-кара"
  },
  "5380": {
    "id": "5380",
    "name": "Каратайка",
    "path": "Россия / Ненецкий АО / Каратайка",
    "country": "Россия",
    "searchString": "каратайка россия / ненецкий ао / каратайка"
  },
  "5381": {
    "id": "5381",
    "name": "Бугрино (Ненецкий АО)",
    "path": "Россия / Ненецкий АО / Бугрино (Ненецкий АО)",
    "country": "Россия",
    "searchString": "бугрино (ненецкий ао) россия / ненецкий ао / бугрино (ненецкий ао)"
  },
  "5382": {
    "id": "5382",
    "name": "Хорей-Вер",
    "path": "Россия / Ненецкий АО / Хорей-Вер",
    "country": "Россия",
    "searchString": "хорей-вер россия / ненецкий ао / хорей-вер"
  },
  "5383": {
    "id": "5383",
    "name": "Несь",
    "path": "Россия / Ненецкий АО / Несь",
    "country": "Россия",
    "searchString": "несь россия / ненецкий ао / несь"
  },
  "5384": {
    "id": "5384",
    "name": "Африканда",
    "path": "Россия / Мурманская область / Африканда",
    "country": "Россия",
    "searchString": "африканда россия / мурманская область / африканда"
  },
  "5385": {
    "id": "5385",
    "name": "Белое Море",
    "path": "Россия / Мурманская область / Белое Море",
    "country": "Россия",
    "searchString": "белое море россия / мурманская область / белое море"
  },
  "5386": {
    "id": "5386",
    "name": "Варзуга",
    "path": "Россия / Мурманская область / Варзуга",
    "country": "Россия",
    "searchString": "варзуга россия / мурманская область / варзуга"
  },
  "5387": {
    "id": "5387",
    "name": "Видяево",
    "path": "Россия / Мурманская область / Видяево",
    "country": "Россия",
    "searchString": "видяево россия / мурманская область / видяево"
  },
  "5388": {
    "id": "5388",
    "name": "Ёнский",
    "path": "Россия / Мурманская область / Ёнский",
    "country": "Россия",
    "searchString": "ёнский россия / мурманская область / ёнский"
  },
  "5389": {
    "id": "5389",
    "name": "Зашеек (Мурманская область)",
    "path": "Россия / Мурманская область / Зашеек (Мурманская область)",
    "country": "Россия",
    "searchString": "зашеек (мурманская область) россия / мурманская область / зашеек (мурманская область)"
  },
  "5390": {
    "id": "5390",
    "name": "Коашва",
    "path": "Россия / Мурманская область / Коашва",
    "country": "Россия",
    "searchString": "коашва россия / мурманская область / коашва"
  },
  "5391": {
    "id": "5391",
    "name": "Корзуново",
    "path": "Россия / Мурманская область / Корзуново",
    "country": "Россия",
    "searchString": "корзуново россия / мурманская область / корзуново"
  },
  "5392": {
    "id": "5392",
    "name": "Лейпи",
    "path": "Россия / Мурманская область / Лейпи",
    "country": "Россия",
    "searchString": "лейпи россия / мурманская область / лейпи"
  },
  "5393": {
    "id": "5393",
    "name": "Лиинахамари",
    "path": "Россия / Мурманская область / Лиинахамари",
    "country": "Россия",
    "searchString": "лиинахамари россия / мурманская область / лиинахамари"
  },
  "5394": {
    "id": "5394",
    "name": "Ловозеро",
    "path": "Россия / Мурманская область / Ловозеро",
    "country": "Россия",
    "searchString": "ловозеро россия / мурманская область / ловозеро"
  },
  "5395": {
    "id": "5395",
    "name": "Луостари",
    "path": "Россия / Мурманская область / Луостари",
    "country": "Россия",
    "searchString": "луостари россия / мурманская область / луостари"
  },
  "5396": {
    "id": "5396",
    "name": "Междуречье (Мурманская область)",
    "path": "Россия / Мурманская область / Междуречье (Мурманская область)",
    "country": "Россия",
    "searchString": "междуречье (мурманская область) россия / мурманская область / междуречье (мурманская область)"
  },
  "5397": {
    "id": "5397",
    "name": "Мишуково (Мурманская область)",
    "path": "Россия / Мурманская область / Мишуково (Мурманская область)",
    "country": "Россия",
    "searchString": "мишуково (мурманская область) россия / мурманская область / мишуково (мурманская область)"
  },
  "5398": {
    "id": "5398",
    "name": "Пояконда",
    "path": "Россия / Мурманская область / Пояконда",
    "country": "Россия",
    "searchString": "пояконда россия / мурманская область / пояконда"
  },
  "5399": {
    "id": "5399",
    "name": "Пушной (Мурманская область)",
    "path": "Россия / Мурманская область / Пушной (Мурманская область)",
    "country": "Россия",
    "searchString": "пушной (мурманская область) россия / мурманская область / пушной (мурманская область)"
  },
  "5400": {
    "id": "5400",
    "name": "Раякоски",
    "path": "Россия / Мурманская область / Раякоски",
    "country": "Россия",
    "searchString": "раякоски россия / мурманская область / раякоски"
  },
  "5401": {
    "id": "5401",
    "name": "Сосновка (Мурманская область)",
    "path": "Россия / Мурманская область / Сосновка (Мурманская область)",
    "country": "Россия",
    "searchString": "сосновка (мурманская область) россия / мурманская область / сосновка (мурманская область)"
  },
  "5402": {
    "id": "5402",
    "name": "Териберка",
    "path": "Россия / Мурманская область / Териберка",
    "country": "Россия",
    "searchString": "териберка россия / мурманская область / териберка"
  },
  "5403": {
    "id": "5403",
    "name": "Титан (Мурманская область)",
    "path": "Россия / Мурманская область / Титан (Мурманская область)",
    "country": "Россия",
    "searchString": "титан (мурманская область) россия / мурманская область / титан (мурманская область)"
  },
  "5404": {
    "id": "5404",
    "name": "Тулома",
    "path": "Россия / Мурманская область / Тулома",
    "country": "Россия",
    "searchString": "тулома россия / мурманская область / тулома"
  },
  "5405": {
    "id": "5405",
    "name": "Ура-Губа",
    "path": "Россия / Мурманская область / Ура-Губа",
    "country": "Россия",
    "searchString": "ура-губа россия / мурманская область / ура-губа"
  },
  "5406": {
    "id": "5406",
    "name": "Шонгуй",
    "path": "Россия / Мурманская область / Шонгуй",
    "country": "Россия",
    "searchString": "шонгуй россия / мурманская область / шонгуй"
  },
  "5407": {
    "id": "5407",
    "name": "Щукозеро",
    "path": "Россия / Мурманская область / Щукозеро",
    "country": "Россия",
    "searchString": "щукозеро россия / мурманская область / щукозеро"
  },
  "5408": {
    "id": "5408",
    "name": "Агалатово",
    "path": "Россия / Ленинградская область / Агалатово",
    "country": "Россия",
    "searchString": "агалатово россия / ленинградская область / агалатово"
  },
  "5409": {
    "id": "5409",
    "name": "Аннино (Ленинградская область)",
    "path": "Россия / Ленинградская область / Аннино (Ленинградская область)",
    "country": "Россия",
    "searchString": "аннино (ленинградская область) россия / ленинградская область / аннино (ленинградская область)"
  },
  "5410": {
    "id": "5410",
    "name": "Бегуницы",
    "path": "Россия / Ленинградская область / Бегуницы",
    "country": "Россия",
    "searchString": "бегуницы россия / ленинградская область / бегуницы"
  },
  "5411": {
    "id": "5411",
    "name": "Большая Вруда",
    "path": "Россия / Ленинградская область / Большая Вруда",
    "country": "Россия",
    "searchString": "большая вруда россия / ленинградская область / большая вруда"
  },
  "5412": {
    "id": "5412",
    "name": "Большие Колпаны",
    "path": "Россия / Ленинградская область / Большие Колпаны",
    "country": "Россия",
    "searchString": "большие колпаны россия / ленинградская область / большие колпаны"
  },
  "5413": {
    "id": "5413",
    "name": "Важины",
    "path": "Россия / Ленинградская область / Важины",
    "country": "Россия",
    "searchString": "важины россия / ленинградская область / важины"
  },
  "5414": {
    "id": "5414",
    "name": "Виллози",
    "path": "Россия / Ленинградская область / Виллози",
    "country": "Россия",
    "searchString": "виллози россия / ленинградская область / виллози"
  },
  "5415": {
    "id": "5415",
    "name": "Винницы",
    "path": "Россия / Ленинградская область / Винницы",
    "country": "Россия",
    "searchString": "винницы россия / ленинградская область / винницы"
  },
  "5416": {
    "id": "5416",
    "name": "Вознесенье (Ленинградская область)",
    "path": "Россия / Ленинградская область / Вознесенье (Ленинградская область)",
    "country": "Россия",
    "searchString": "вознесенье (ленинградская область) россия / ленинградская область / вознесенье (ленинградская область)"
  },
  "5417": {
    "id": "5417",
    "name": "Войскорово",
    "path": "Россия / Ленинградская область / Войскорово",
    "country": "Россия",
    "searchString": "войскорово россия / ленинградская область / войскорово"
  },
  "5418": {
    "id": "5418",
    "name": "Глажево",
    "path": "Россия / Ленинградская область / Глажево",
    "country": "Россия",
    "searchString": "глажево россия / ленинградская область / глажево"
  },
  "5419": {
    "id": "5419",
    "name": "Гостилицы",
    "path": "Россия / Ленинградская область / Гостилицы",
    "country": "Россия",
    "searchString": "гостилицы россия / ленинградская область / гостилицы"
  },
  "5420": {
    "id": "5420",
    "name": "Дружная Горка (Ленинградская область)",
    "path": "Россия / Ленинградская область / Дружная Горка (Ленинградская область)",
    "country": "Россия",
    "searchString": "дружная горка (ленинградская область) россия / ленинградская область / дружная горка (ленинградская область)"
  },
  "5421": {
    "id": "5421",
    "name": "Елизаветино (Ленинградская область)",
    "path": "Россия / Ленинградская область / Елизаветино (Ленинградская область)",
    "country": "Россия",
    "searchString": "елизаветино (ленинградская область) россия / ленинградская область / елизаветино (ленинградская область)"
  },
  "5422": {
    "id": "5422",
    "name": "Ефимовский",
    "path": "Россия / Ленинградская область / Ефимовский",
    "country": "Россия",
    "searchString": "ефимовский россия / ленинградская область / ефимовский"
  },
  "5423": {
    "id": "5423",
    "name": "Заклинье (Ленинградская область)",
    "path": "Россия / Ленинградская область / Заклинье (Ленинградская область)",
    "country": "Россия",
    "searchString": "заклинье (ленинградская область) россия / ленинградская область / заклинье (ленинградская область)"
  },
  "5424": {
    "id": "5424",
    "name": "Кипень",
    "path": "Россия / Ленинградская область / Кипень",
    "country": "Россия",
    "searchString": "кипень россия / ленинградская область / кипень"
  },
  "5425": {
    "id": "5425",
    "name": "Кобралово",
    "path": "Россия / Ленинградская область / Кобралово",
    "country": "Россия",
    "searchString": "кобралово россия / ленинградская область / кобралово"
  },
  "5426": {
    "id": "5426",
    "name": "Колчаново",
    "path": "Россия / Ленинградская область / Колчаново",
    "country": "Россия",
    "searchString": "колчаново россия / ленинградская область / колчаново"
  },
  "5427": {
    "id": "5427",
    "name": "Котельский",
    "path": "Россия / Ленинградская область / Котельский",
    "country": "Россия",
    "searchString": "котельский россия / ленинградская область / котельский"
  },
  "5428": {
    "id": "5428",
    "name": "Красный Бор (Ленинградская область)",
    "path": "Россия / Ленинградская область / Красный Бор (Ленинградская область)",
    "country": "Россия",
    "searchString": "красный бор (ленинградская область) россия / ленинградская область / красный бор (ленинградская область)"
  },
  "5429": {
    "id": "5429",
    "name": "Кузнечное",
    "path": "Россия / Ленинградская область / Кузнечное",
    "country": "Россия",
    "searchString": "кузнечное россия / ленинградская область / кузнечное"
  },
  "5430": {
    "id": "5430",
    "name": "Лаголово",
    "path": "Россия / Ленинградская область / Лаголово",
    "country": "Россия",
    "searchString": "лаголово россия / ленинградская область / лаголово"
  },
  "5431": {
    "id": "5431",
    "name": "Лесколово",
    "path": "Россия / Ленинградская область / Лесколово",
    "country": "Россия",
    "searchString": "лесколово россия / ленинградская область / лесколово"
  },
  "5432": {
    "id": "5432",
    "name": "Лесогорский",
    "path": "Россия / Ленинградская область / Лесогорский",
    "country": "Россия",
    "searchString": "лесогорский россия / ленинградская область / лесогорский"
  },
  "5433": {
    "id": "5433",
    "name": "Малое Верево",
    "path": "Россия / Ленинградская область / Малое Верево",
    "country": "Россия",
    "searchString": "малое верево россия / ленинградская область / малое верево"
  },
  "5434": {
    "id": "5434",
    "name": "Малое Карлино",
    "path": "Россия / Ленинградская область / Малое Карлино",
    "country": "Россия",
    "searchString": "малое карлино россия / ленинградская область / малое карлино"
  },
  "5435": {
    "id": "5435",
    "name": "Назия",
    "path": "Россия / Ленинградская область / Назия",
    "country": "Россия",
    "searchString": "назия россия / ленинградская область / назия"
  },
  "5436": {
    "id": "5436",
    "name": "Низино (Ленинградская область)",
    "path": "Россия / Ленинградская область / Низино (Ленинградская область)",
    "country": "Россия",
    "searchString": "низино (ленинградская область) россия / ленинградская область / низино (ленинградская область)"
  },
  "5437": {
    "id": "5437",
    "name": "Никольский (Ленинградская область)",
    "path": "Россия / Ленинградская область / Никольский (Ленинградская область)",
    "country": "Россия",
    "searchString": "никольский (ленинградская область) россия / ленинградская область / никольский (ленинградская область)"
  },
  "5438": {
    "id": "5438",
    "name": "Новоселье (Ленинградская область)",
    "path": "Россия / Ленинградская область / Новоселье (Ленинградская область)",
    "country": "Россия",
    "searchString": "новоселье (ленинградская область) россия / ленинградская область / новоселье (ленинградская область)"
  },
  "5439": {
    "id": "5439",
    "name": "Новый Учхоз",
    "path": "Россия / Ленинградская область / Новый Учхоз",
    "country": "Россия",
    "searchString": "новый учхоз россия / ленинградская область / новый учхоз"
  },
  "5440": {
    "id": "5440",
    "name": "Нурма (Ленинградская область)",
    "path": "Россия / Ленинградская область / Нурма (Ленинградская область)",
    "country": "Россия",
    "searchString": "нурма (ленинградская область) россия / ленинградская область / нурма (ленинградская область)"
  },
  "5441": {
    "id": "5441",
    "name": "Оредеж",
    "path": "Россия / Ленинградская область / Оредеж",
    "country": "Россия",
    "searchString": "оредеж россия / ленинградская область / оредеж"
  },
  "5442": {
    "id": "5442",
    "name": "Оржицы",
    "path": "Россия / Ленинградская область / Оржицы",
    "country": "Россия",
    "searchString": "оржицы россия / ленинградская область / оржицы"
  },
  "5443": {
    "id": "5443",
    "name": "Паша",
    "path": "Россия / Ленинградская область / Паша",
    "country": "Россия",
    "searchString": "паша россия / ленинградская область / паша"
  },
  "5444": {
    "id": "5444",
    "name": "Первомайское (Ленинградская область)",
    "path": "Россия / Ленинградская область / Первомайское (Ленинградская область)",
    "country": "Россия",
    "searchString": "первомайское (ленинградская область) россия / ленинградская область / первомайское (ленинградская область)"
  },
  "5445": {
    "id": "5445",
    "name": "Пудомяги",
    "path": "Россия / Ленинградская область / Пудомяги",
    "country": "Россия",
    "searchString": "пудомяги россия / ленинградская область / пудомяги"
  },
  "5446": {
    "id": "5446",
    "name": "Разметелево",
    "path": "Россия / Ленинградская область / Разметелево",
    "country": "Россия",
    "searchString": "разметелево россия / ленинградская область / разметелево"
  },
  "5447": {
    "id": "5447",
    "name": "Рахья",
    "path": "Россия / Ленинградская область / Рахья",
    "country": "Россия",
    "searchString": "рахья россия / ленинградская область / рахья"
  },
  "5448": {
    "id": "5448",
    "name": "Ромашкинское сельское поселение (Ленинградская область)",
    "path": "Россия / Ленинградская область / Ромашкинское сельское поселение (Ленинградская область)",
    "country": "Россия",
    "searchString": "ромашкинское сельское поселение (ленинградская область) россия / ленинградская область / ромашкинское сельское поселение (ленинградская область)"
  },
  "5449": {
    "id": "5449",
    "name": "Русско-Высоцкое",
    "path": "Россия / Ленинградская область / Русско-Высоцкое",
    "country": "Россия",
    "searchString": "русско-высоцкое россия / ленинградская область / русско-высоцкое"
  },
  "5450": {
    "id": "5450",
    "name": "Рябово (Ленинградская область)",
    "path": "Россия / Ленинградская область / Рябово (Ленинградская область)",
    "country": "Россия",
    "searchString": "рябово (ленинградская область) россия / ленинградская область / рябово (ленинградская область)"
  },
  "5451": {
    "id": "5451",
    "name": "Селезнёво (Ленинградская область)",
    "path": "Россия / Ленинградская область / Селезнёво (Ленинградская область)",
    "country": "Россия",
    "searchString": "селезнёво (ленинградская область) россия / ленинградская область / селезнёво (ленинградская область)"
  },
  "5452": {
    "id": "5452",
    "name": "Сельцо (посёлок, Волосовский район)",
    "path": "Россия / Ленинградская область / Сельцо (посёлок, Волосовский район)",
    "country": "Россия",
    "searchString": "сельцо (посёлок, волосовский район) россия / ленинградская область / сельцо (посёлок, волосовский район)"
  },
  "5453": {
    "id": "5453",
    "name": "Семрино",
    "path": "Россия / Ленинградская область / Семрино",
    "country": "Россия",
    "searchString": "семрино россия / ленинградская область / семрино"
  },
  "5454": {
    "id": "5454",
    "name": "Старая Ладога",
    "path": "Россия / Ленинградская область / Старая Ладога",
    "country": "Россия",
    "searchString": "старая ладога россия / ленинградская область / старая ладога"
  },
  "5455": {
    "id": "5455",
    "name": "Сусанино (Ленинградская область)",
    "path": "Россия / Ленинградская область / Сусанино (Ленинградская область)",
    "country": "Россия",
    "searchString": "сусанино (ленинградская область) россия / ленинградская область / сусанино (ленинградская область)"
  },
  "5456": {
    "id": "5456",
    "name": "Суходолье (Ленинградская область)",
    "path": "Россия / Ленинградская область / Суходолье (Ленинградская область)",
    "country": "Россия",
    "searchString": "суходолье (ленинградская область) россия / ленинградская область / суходолье (ленинградская область)"
  },
  "5457": {
    "id": "5457",
    "name": "Тайцы",
    "path": "Россия / Ленинградская область / Тайцы",
    "country": "Россия",
    "searchString": "тайцы россия / ленинградская область / тайцы"
  },
  "5458": {
    "id": "5458",
    "name": "Толмачёво (Ленинградская область)",
    "path": "Россия / Ленинградская область / Толмачёво (Ленинградская область)",
    "country": "Россия",
    "searchString": "толмачёво (ленинградская область) россия / ленинградская область / толмачёво (ленинградская область)"
  },
  "5459": {
    "id": "5459",
    "name": "Усть-Луга",
    "path": "Россия / Ленинградская область / Усть-Луга",
    "country": "Россия",
    "searchString": "усть-луга россия / ленинградская область / усть-луга"
  },
  "5460": {
    "id": "5460",
    "name": "Форносово",
    "path": "Россия / Ленинградская область / Форносово",
    "country": "Россия",
    "searchString": "форносово россия / ленинградская область / форносово"
  },
  "5461": {
    "id": "5461",
    "name": "Янино-1",
    "path": "Россия / Ленинградская область / Янино-1",
    "country": "Россия",
    "searchString": "янино-1 россия / ленинградская область / янино-1"
  },
  "5462": {
    "id": "5462",
    "name": "Алтуд",
    "path": "Россия / Кабардино-Балкарская республика / Алтуд",
    "country": "Россия",
    "searchString": "алтуд россия / кабардино-балкарская республика / алтуд"
  },
  "5463": {
    "id": "5463",
    "name": "Анзорей",
    "path": "Россия / Кабардино-Балкарская республика / Анзорей",
    "country": "Россия",
    "searchString": "анзорей россия / кабардино-балкарская республика / анзорей"
  },
  "5464": {
    "id": "5464",
    "name": "Аргудан",
    "path": "Россия / Кабардино-Балкарская республика / Аргудан",
    "country": "Россия",
    "searchString": "аргудан россия / кабардино-балкарская республика / аргудан"
  },
  "5465": {
    "id": "5465",
    "name": "Баксаненок",
    "path": "Россия / Кабардино-Балкарская республика / Баксаненок",
    "country": "Россия",
    "searchString": "баксаненок россия / кабардино-балкарская республика / баксаненок"
  },
  "5466": {
    "id": "5466",
    "name": "Дыгулыбгей",
    "path": "Россия / Кабардино-Балкарская республика / Дыгулыбгей",
    "country": "Россия",
    "searchString": "дыгулыбгей россия / кабардино-балкарская республика / дыгулыбгей"
  },
  "5467": {
    "id": "5467",
    "name": "Екатериноградская",
    "path": "Россия / Кабардино-Балкарская республика / Екатериноградская",
    "country": "Россия",
    "searchString": "екатериноградская россия / кабардино-балкарская республика / екатериноградская"
  },
  "5468": {
    "id": "5468",
    "name": "Залукокоаже",
    "path": "Россия / Кабардино-Балкарская республика / Залукокоаже",
    "country": "Россия",
    "searchString": "залукокоаже россия / кабардино-балкарская республика / залукокоаже"
  },
  "5469": {
    "id": "5469",
    "name": "Заюково",
    "path": "Россия / Кабардино-Балкарская республика / Заюково",
    "country": "Россия",
    "searchString": "заюково россия / кабардино-балкарская республика / заюково"
  },
  "5470": {
    "id": "5470",
    "name": "Исламей",
    "path": "Россия / Кабардино-Балкарская республика / Исламей",
    "country": "Россия",
    "searchString": "исламей россия / кабардино-балкарская республика / исламей"
  },
  "5471": {
    "id": "5471",
    "name": "Каменка (Кабардино-Балкария)",
    "path": "Россия / Кабардино-Балкарская республика / Каменка (Кабардино-Балкария)",
    "country": "Россия",
    "searchString": "каменка (кабардино-балкария) россия / кабардино-балкарская республика / каменка (кабардино-балкария)"
  },
  "5472": {
    "id": "5472",
    "name": "Карагач (Кабардино-Балкария)",
    "path": "Россия / Кабардино-Балкарская республика / Карагач (Кабардино-Балкария)",
    "country": "Россия",
    "searchString": "карагач (кабардино-балкария) россия / кабардино-балкарская республика / карагач (кабардино-балкария)"
  },
  "5473": {
    "id": "5473",
    "name": "Кашхатау",
    "path": "Россия / Кабардино-Балкарская республика / Кашхатау",
    "country": "Россия",
    "searchString": "кашхатау россия / кабардино-балкарская республика / кашхатау"
  },
  "5474": {
    "id": "5474",
    "name": "Кенже",
    "path": "Россия / Кабардино-Балкарская республика / Кенже",
    "country": "Россия",
    "searchString": "кенже россия / кабардино-балкарская республика / кенже"
  },
  "5475": {
    "id": "5475",
    "name": "Кишпек",
    "path": "Россия / Кабардино-Балкарская республика / Кишпек",
    "country": "Россия",
    "searchString": "кишпек россия / кабардино-балкарская республика / кишпек"
  },
  "5476": {
    "id": "5476",
    "name": "Куба (Кабардино-Балкария)",
    "path": "Россия / Кабардино-Балкарская республика / Куба (Кабардино-Балкария)",
    "country": "Россия",
    "searchString": "куба (кабардино-балкария) россия / кабардино-балкарская республика / куба (кабардино-балкария)"
  },
  "5477": {
    "id": "5477",
    "name": "Малка",
    "path": "Россия / Кабардино-Балкарская республика / Малка",
    "country": "Россия",
    "searchString": "малка россия / кабардино-балкарская республика / малка"
  },
  "5478": {
    "id": "5478",
    "name": "Нартан",
    "path": "Россия / Кабардино-Балкарская республика / Нартан",
    "country": "Россия",
    "searchString": "нартан россия / кабардино-балкарская республика / нартан"
  },
  "5479": {
    "id": "5479",
    "name": "Сармаково",
    "path": "Россия / Кабардино-Балкарская республика / Сармаково",
    "country": "Россия",
    "searchString": "сармаково россия / кабардино-балкарская республика / сармаково"
  },
  "5480": {
    "id": "5480",
    "name": "Солдатская",
    "path": "Россия / Кабардино-Балкарская республика / Солдатская",
    "country": "Россия",
    "searchString": "солдатская россия / кабардино-балкарская республика / солдатская"
  },
  "5481": {
    "id": "5481",
    "name": "Хасанья",
    "path": "Россия / Кабардино-Балкарская республика / Хасанья",
    "country": "Россия",
    "searchString": "хасанья россия / кабардино-балкарская республика / хасанья"
  },
  "5482": {
    "id": "5482",
    "name": "Чегем Второй",
    "path": "Россия / Кабардино-Балкарская республика / Чегем Второй",
    "country": "Россия",
    "searchString": "чегем второй россия / кабардино-балкарская республика / чегем второй"
  },
  "5483": {
    "id": "5483",
    "name": "Шалушка",
    "path": "Россия / Кабардино-Балкарская республика / Шалушка",
    "country": "Россия",
    "searchString": "шалушка россия / кабардино-балкарская республика / шалушка"
  },
  "5484": {
    "id": "5484",
    "name": "Эльбрус (Кабардино-Балкария)",
    "path": "Россия / Кабардино-Балкарская республика / Эльбрус (Кабардино-Балкария)",
    "country": "Россия",
    "searchString": "эльбрус (кабардино-балкария) россия / кабардино-балкарская республика / эльбрус (кабардино-балкария)"
  },
  "5485": {
    "id": "5485",
    "name": "Адыге-Хабль",
    "path": "Россия / Карачаево-Черкесская Республика / Адыге-Хабль",
    "country": "Россия",
    "searchString": "адыге-хабль россия / карачаево-черкесская республика / адыге-хабль"
  },
  "5486": {
    "id": "5486",
    "name": "Али-Бердуковский",
    "path": "Россия / Карачаево-Черкесская Республика / Али-Бердуковский",
    "country": "Россия",
    "searchString": "али-бердуковский россия / карачаево-черкесская республика / али-бердуковский"
  },
  "5487": {
    "id": "5487",
    "name": "Зеленчукская",
    "path": "Россия / Карачаево-Черкесская Республика / Зеленчукская",
    "country": "Россия",
    "searchString": "зеленчукская россия / карачаево-черкесская республика / зеленчукская"
  },
  "5488": {
    "id": "5488",
    "name": "Икон-Халк",
    "path": "Россия / Карачаево-Черкесская Республика / Икон-Халк",
    "country": "Россия",
    "searchString": "икон-халк россия / карачаево-черкесская республика / икон-халк"
  },
  "5489": {
    "id": "5489",
    "name": "Кардоникская",
    "path": "Россия / Карачаево-Черкесская Республика / Кардоникская",
    "country": "Россия",
    "searchString": "кардоникская россия / карачаево-черкесская республика / кардоникская"
  },
  "5490": {
    "id": "5490",
    "name": "Красный Курган (Карачаево-Черкесия)",
    "path": "Россия / Карачаево-Черкесская Республика / Красный Курган (Карачаево-Черкесия)",
    "country": "Россия",
    "searchString": "красный курган (карачаево-черкесия) россия / карачаево-черкесская республика / красный курган (карачаево-черкесия)"
  },
  "5491": {
    "id": "5491",
    "name": "Кумыш",
    "path": "Россия / Карачаево-Черкесская Республика / Кумыш",
    "country": "Россия",
    "searchString": "кумыш россия / карачаево-черкесская республика / кумыш"
  },
  "5492": {
    "id": "5492",
    "name": "Курджиново",
    "path": "Россия / Карачаево-Черкесская Республика / Курджиново",
    "country": "Россия",
    "searchString": "курджиново россия / карачаево-черкесская республика / курджиново"
  },
  "5493": {
    "id": "5493",
    "name": "Медногорский",
    "path": "Россия / Карачаево-Черкесская Республика / Медногорский",
    "country": "Россия",
    "searchString": "медногорский россия / карачаево-черкесская республика / медногорский"
  },
  "5494": {
    "id": "5494",
    "name": "Орджоникидзевский",
    "path": "Россия / Карачаево-Черкесская Республика / Орджоникидзевский",
    "country": "Россия",
    "searchString": "орджоникидзевский россия / карачаево-черкесская республика / орджоникидзевский"
  },
  "5495": {
    "id": "5495",
    "name": "Первомайское (Карачаево-Черкесия)",
    "path": "Россия / Карачаево-Черкесская Республика / Первомайское (Карачаево-Черкесия)",
    "country": "Россия",
    "searchString": "первомайское (карачаево-черкесия) россия / карачаево-черкесская республика / первомайское (карачаево-черкесия)"
  },
  "5496": {
    "id": "5496",
    "name": "Преградная",
    "path": "Россия / Карачаево-Черкесская Республика / Преградная",
    "country": "Россия",
    "searchString": "преградная россия / карачаево-черкесская республика / преградная"
  },
  "5497": {
    "id": "5497",
    "name": "Псыж",
    "path": "Россия / Карачаево-Черкесская Республика / Псыж",
    "country": "Россия",
    "searchString": "псыж россия / карачаево-черкесская республика / псыж"
  },
  "5498": {
    "id": "5498",
    "name": "Сары-Тюз",
    "path": "Россия / Карачаево-Черкесская Республика / Сары-Тюз",
    "country": "Россия",
    "searchString": "сары-тюз россия / карачаево-черкесская республика / сары-тюз"
  },
  "5499": {
    "id": "5499",
    "name": "Сторожевая (Карачаево-Черкесия)",
    "path": "Россия / Карачаево-Черкесская Республика / Сторожевая (Карачаево-Черкесия)",
    "country": "Россия",
    "searchString": "сторожевая (карачаево-черкесия) россия / карачаево-черкесская республика / сторожевая (карачаево-черкесия)"
  },
  "5500": {
    "id": "5500",
    "name": "Терезе",
    "path": "Россия / Карачаево-Черкесская Республика / Терезе",
    "country": "Россия",
    "searchString": "терезе россия / карачаево-черкесская республика / терезе"
  },
  "5501": {
    "id": "5501",
    "name": "Учкекен",
    "path": "Россия / Карачаево-Черкесская Республика / Учкекен",
    "country": "Россия",
    "searchString": "учкекен россия / карачаево-черкесская республика / учкекен"
  },
  "5502": {
    "id": "5502",
    "name": "Хабез",
    "path": "Россия / Карачаево-Черкесская Республика / Хабез",
    "country": "Россия",
    "searchString": "хабез россия / карачаево-черкесская республика / хабез"
  },
  "5503": {
    "id": "5503",
    "name": "Чапаевское (Карачаево-Черкесия)",
    "path": "Россия / Карачаево-Черкесская Республика / Чапаевское (Карачаево-Черкесия)",
    "country": "Россия",
    "searchString": "чапаевское (карачаево-черкесия) россия / карачаево-черкесская республика / чапаевское (карачаево-черкесия)"
  },
  "5504": {
    "id": "5504",
    "name": "Эркен-Шахар",
    "path": "Россия / Карачаево-Черкесская Республика / Эркен-Шахар",
    "country": "Россия",
    "searchString": "эркен-шахар россия / карачаево-черкесская республика / эркен-шахар"
  },
  "5505": {
    "id": "5505",
    "name": "Исправная",
    "path": "Россия / Карачаево-Черкесская Республика / Исправная",
    "country": "Россия",
    "searchString": "исправная россия / карачаево-черкесская республика / исправная"
  },
  "5506": {
    "id": "5506",
    "name": "Адагум",
    "path": "Россия / Краснодарский край / Адагум",
    "country": "Россия",
    "searchString": "адагум россия / краснодарский край / адагум"
  },
  "5507": {
    "id": "5507",
    "name": "Александровская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Александровская (Краснодарский край)",
    "country": "Россия",
    "searchString": "александровская (краснодарский край) россия / краснодарский край / александровская (краснодарский край)"
  },
  "5508": {
    "id": "5508",
    "name": "Алексеевская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Алексеевская (Краснодарский край)",
    "country": "Россия",
    "searchString": "алексеевская (краснодарский край) россия / краснодарский край / алексеевская (краснодарский край)"
  },
  "5509": {
    "id": "5509",
    "name": "Андрюки",
    "path": "Россия / Краснодарский край / Андрюки",
    "country": "Россия",
    "searchString": "андрюки россия / краснодарский край / андрюки"
  },
  "5510": {
    "id": "5510",
    "name": "Ахтарский",
    "path": "Россия / Краснодарский край / Ахтарский",
    "country": "Россия",
    "searchString": "ахтарский россия / краснодарский край / ахтарский"
  },
  "5511": {
    "id": "5511",
    "name": "Баговская",
    "path": "Россия / Краснодарский край / Баговская",
    "country": "Россия",
    "searchString": "баговская россия / краснодарский край / баговская"
  },
  "5512": {
    "id": "5512",
    "name": "Берёзовый (Краснодарский край)",
    "path": "Россия / Краснодарский край / Берёзовый (Краснодарский край)",
    "country": "Россия",
    "searchString": "берёзовый (краснодарский край) россия / краснодарский край / берёзовый (краснодарский край)"
  },
  "5513": {
    "id": "5513",
    "name": "Весёлое (Краснодарский край)",
    "path": "Россия / Краснодарский край / Весёлое (Краснодарский край)",
    "country": "Россия",
    "searchString": "весёлое (краснодарский край) россия / краснодарский край / весёлое (краснодарский край)"
  },
  "5514": {
    "id": "5514",
    "name": "Владимирская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Владимирская (Краснодарский край)",
    "country": "Россия",
    "searchString": "владимирская (краснодарский край) россия / краснодарский край / владимирская (краснодарский край)"
  },
  "5515": {
    "id": "5515",
    "name": "Высокое (Краснодарский край)",
    "path": "Россия / Краснодарский край / Высокое (Краснодарский край)",
    "country": "Россия",
    "searchString": "высокое (краснодарский край) россия / краснодарский край / высокое (краснодарский край)"
  },
  "5516": {
    "id": "5516",
    "name": "Глебовка (Краснодарский край)",
    "path": "Россия / Краснодарский край / Глебовка (Краснодарский край)",
    "country": "Россия",
    "searchString": "глебовка (краснодарский край) россия / краснодарский край / глебовка (краснодарский край)"
  },
  "5517": {
    "id": "5517",
    "name": "Глубокий (Краснодарский край)",
    "path": "Россия / Краснодарский край / Глубокий (Краснодарский край)",
    "country": "Россия",
    "searchString": "глубокий (краснодарский край) россия / краснодарский край / глубокий (краснодарский край)"
  },
  "5518": {
    "id": "5518",
    "name": "Джигинка",
    "path": "Россия / Краснодарский край / Джигинка",
    "country": "Россия",
    "searchString": "джигинка россия / краснодарский край / джигинка"
  },
  "5519": {
    "id": "5519",
    "name": "Дмитриевская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Дмитриевская (Краснодарский край)",
    "country": "Россия",
    "searchString": "дмитриевская (краснодарский край) россия / краснодарский край / дмитриевская (краснодарский край)"
  },
  "5520": {
    "id": "5520",
    "name": "Днепровская",
    "path": "Россия / Краснодарский край / Днепровская",
    "country": "Россия",
    "searchString": "днепровская россия / краснодарский край / днепровская"
  },
  "5521": {
    "id": "5521",
    "name": "Дядьковская",
    "path": "Россия / Краснодарский край / Дядьковская",
    "country": "Россия",
    "searchString": "дядьковская россия / краснодарский край / дядьковская"
  },
  "5522": {
    "id": "5522",
    "name": "Екатериновка (Краснодарский край)",
    "path": "Россия / Краснодарский край / Екатериновка (Краснодарский край)",
    "country": "Россия",
    "searchString": "екатериновка (краснодарский край) россия / краснодарский край / екатериновка (краснодарский край)"
  },
  "5523": {
    "id": "5523",
    "name": "Заветный",
    "path": "Россия / Краснодарский край / Заветный",
    "country": "Россия",
    "searchString": "заветный россия / краснодарский край / заветный"
  },
  "5524": {
    "id": "5524",
    "name": "Индустриальный (Краснодарский край)",
    "path": "Россия / Краснодарский край / Индустриальный (Краснодарский край)",
    "country": "Россия",
    "searchString": "индустриальный (краснодарский край) россия / краснодарский край / индустриальный (краснодарский край)"
  },
  "5525": {
    "id": "5525",
    "name": "Калужская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Калужская (Краснодарский край)",
    "country": "Россия",
    "searchString": "калужская (краснодарский край) россия / краснодарский край / калужская (краснодарский край)"
  },
  "5526": {
    "id": "5526",
    "name": "Ковалевское (Краснодарский край)",
    "path": "Россия / Краснодарский край / Ковалевское (Краснодарский край)",
    "country": "Россия",
    "searchString": "ковалевское (краснодарский край) россия / краснодарский край / ковалевское (краснодарский край)"
  },
  "5527": {
    "id": "5527",
    "name": "Копанская",
    "path": "Россия / Краснодарский край / Копанская",
    "country": "Россия",
    "searchString": "копанская россия / краснодарский край / копанская"
  },
  "5528": {
    "id": "5528",
    "name": "Коржевский (Славянский район)",
    "path": "Россия / Краснодарский край / Коржевский (Славянский район)",
    "country": "Россия",
    "searchString": "коржевский (славянский район) россия / краснодарский край / коржевский (славянский район)"
  },
  "5529": {
    "id": "5529",
    "name": "Кубанский (Новопокровский район)",
    "path": "Россия / Краснодарский край / Кубанский (Новопокровский район)",
    "country": "Россия",
    "searchString": "кубанский (новопокровский район) россия / краснодарский край / кубанский (новопокровский район)"
  },
  "5530": {
    "id": "5530",
    "name": "Мирской (Кавказский район)",
    "path": "Россия / Краснодарский край / Мирской (Кавказский район)",
    "country": "Россия",
    "searchString": "мирской (кавказский район) россия / краснодарский край / мирской (кавказский район)"
  },
  "5531": {
    "id": "5531",
    "name": "Натухаевская",
    "path": "Россия / Краснодарский край / Натухаевская",
    "country": "Россия",
    "searchString": "натухаевская россия / краснодарский край / натухаевская"
  },
  "5532": {
    "id": "5532",
    "name": "Нефтегорск (Краснодарский край)",
    "path": "Россия / Краснодарский край / Нефтегорск (Краснодарский край)",
    "country": "Россия",
    "searchString": "нефтегорск (краснодарский край) россия / краснодарский край / нефтегорск (краснодарский край)"
  },
  "5533": {
    "id": "5533",
    "name": "Нижняя Шиловка",
    "path": "Россия / Краснодарский край / Нижняя Шиловка",
    "country": "Россия",
    "searchString": "нижняя шиловка россия / краснодарский край / нижняя шиловка"
  },
  "5534": {
    "id": "5534",
    "name": "Новоалексеевская",
    "path": "Россия / Краснодарский край / Новоалексеевская",
    "country": "Россия",
    "searchString": "новоалексеевская россия / краснодарский край / новоалексеевская"
  },
  "5535": {
    "id": "5535",
    "name": "Новобейсугская",
    "path": "Россия / Краснодарский край / Новобейсугская",
    "country": "Россия",
    "searchString": "новобейсугская россия / краснодарский край / новобейсугская"
  },
  "5536": {
    "id": "5536",
    "name": "Новониколаевская (Краснодарский край)",
    "path": "Россия / Краснодарский край / Новониколаевская (Краснодарский край)",
    "country": "Россия",
    "searchString": "новониколаевская (краснодарский край) россия / краснодарский край / новониколаевская (краснодарский край)"
  },
  "5537": {
    "id": "5537",
    "name": "Орел-Изумруд (Краснодарский край)",
    "path": "Россия / Краснодарский край / Орел-Изумруд (Краснодарский край)",
    "country": "Россия",
    "searchString": "орел-изумруд (краснодарский край) россия / краснодарский край / орел-изумруд (краснодарский край)"
  },
  "5538": {
    "id": "5538",
    "name": "Отрадо-Ольгинское",
    "path": "Россия / Краснодарский край / Отрадо-Ольгинское",
    "country": "Россия",
    "searchString": "отрадо-ольгинское россия / краснодарский край / отрадо-ольгинское"
  },
  "5539": {
    "id": "5539",
    "name": "Раздольная (Краснодарский край)",
    "path": "Россия / Краснодарский край / Раздольная (Краснодарский край)",
    "country": "Россия",
    "searchString": "раздольная (краснодарский край) россия / краснодарский край / раздольная (краснодарский край)"
  },
  "5540": {
    "id": "5540",
    "name": "Соколовское (Краснодарский край)",
    "path": "Россия / Краснодарский край / Соколовское (Краснодарский край)",
    "country": "Россия",
    "searchString": "соколовское (краснодарский край) россия / краснодарский край / соколовское (краснодарский край)"
  },
  "5541": {
    "id": "5541",
    "name": "Упорная",
    "path": "Россия / Краснодарский край / Упорная",
    "country": "Россия",
    "searchString": "упорная россия / краснодарский край / упорная"
  },
  "5542": {
    "id": "5542",
    "name": "Цибанобалка",
    "path": "Россия / Краснодарский край / Цибанобалка",
    "country": "Россия",
    "searchString": "цибанобалка россия / краснодарский край / цибанобалка"
  },
  "5543": {
    "id": "5543",
    "name": "Виноградный (муниципальное образование город-курорт Анапа)",
    "path": "Россия / Краснодарский край / Виноградный (муниципальное образование город-курорт Анапа)",
    "country": "Россия",
    "searchString": "виноградный (муниципальное образование город-курорт анапа) россия / краснодарский край / виноградный (муниципальное образование город-курорт анапа)"
  },
  "5544": {
    "id": "5544",
    "name": "Виноградный (Крымский район)",
    "path": "Россия / Краснодарский край / Виноградный (Крымский район)",
    "country": "Россия",
    "searchString": "виноградный (крымский район) россия / краснодарский край / виноградный (крымский район)"
  },
  "5545": {
    "id": "5545",
    "name": "Сабетта (Ямало-Ненецкий АО)",
    "path": "Россия / Ямало-Ненецкий АО / Сабетта (Ямало-Ненецкий АО)",
    "country": "Россия",
    "searchString": "сабетта (ямало-ненецкий ао) россия / ямало-ненецкий ао / сабетта (ямало-ненецкий ао)"
  },
  "5546": {
    "id": "5546",
    "name": "Абадзехская",
    "path": "Россия / Республика Адыгея / Абадзехская",
    "country": "Россия",
    "searchString": "абадзехская россия / республика адыгея / абадзехская"
  },
  "5547": {
    "id": "5547",
    "name": "Белое (Адыгея)",
    "path": "Россия / Республика Адыгея / Белое (Адыгея)",
    "country": "Россия",
    "searchString": "белое (адыгея) россия / республика адыгея / белое (адыгея)"
  },
  "5548": {
    "id": "5548",
    "name": "Блечепсин",
    "path": "Россия / Республика Адыгея / Блечепсин",
    "country": "Россия",
    "searchString": "блечепсин россия / республика адыгея / блечепсин"
  },
  "5549": {
    "id": "5549",
    "name": "Вольное (Адыгея)",
    "path": "Россия / Республика Адыгея / Вольное (Адыгея)",
    "country": "Россия",
    "searchString": "вольное (адыгея) россия / республика адыгея / вольное (адыгея)"
  },
  "5550": {
    "id": "5550",
    "name": "Дондуковская",
    "path": "Россия / Республика Адыгея / Дондуковская",
    "country": "Россия",
    "searchString": "дондуковская россия / республика адыгея / дондуковская"
  },
  "5551": {
    "id": "5551",
    "name": "Каменномостский",
    "path": "Россия / Республика Адыгея / Каменномостский",
    "country": "Россия",
    "searchString": "каменномостский россия / республика адыгея / каменномостский"
  },
  "5552": {
    "id": "5552",
    "name": "Кошехабль",
    "path": "Россия / Республика Адыгея / Кошехабль",
    "country": "Россия",
    "searchString": "кошехабль россия / республика адыгея / кошехабль"
  },
  "5553": {
    "id": "5553",
    "name": "Красногвардейское (Адыгея)",
    "path": "Россия / Республика Адыгея / Красногвардейское (Адыгея)",
    "country": "Россия",
    "searchString": "красногвардейское (адыгея) россия / республика адыгея / красногвардейское (адыгея)"
  },
  "5554": {
    "id": "5554",
    "name": "Краснооктябрьский (Адыгея)",
    "path": "Россия / Республика Адыгея / Краснооктябрьский (Адыгея)",
    "country": "Россия",
    "searchString": "краснооктябрьский (адыгея) россия / республика адыгея / краснооктябрьский (адыгея)"
  },
  "5555": {
    "id": "5555",
    "name": "Кужорская",
    "path": "Россия / Республика Адыгея / Кужорская",
    "country": "Россия",
    "searchString": "кужорская россия / республика адыгея / кужорская"
  },
  "5556": {
    "id": "5556",
    "name": "Натырбово",
    "path": "Россия / Республика Адыгея / Натырбово",
    "country": "Россия",
    "searchString": "натырбово россия / республика адыгея / натырбово"
  },
  "5557": {
    "id": "5557",
    "name": "Понежукай",
    "path": "Россия / Республика Адыгея / Понежукай",
    "country": "Россия",
    "searchString": "понежукай россия / республика адыгея / понежукай"
  },
  "5558": {
    "id": "5558",
    "name": "Северо-Восточные Сады",
    "path": "Россия / Республика Адыгея / Северо-Восточные Сады",
    "country": "Россия",
    "searchString": "северо-восточные сады россия / республика адыгея / северо-восточные сады"
  },
  "5559": {
    "id": "5559",
    "name": "Тахтамукай",
    "path": "Россия / Республика Адыгея / Тахтамукай",
    "country": "Россия",
    "searchString": "тахтамукай россия / республика адыгея / тахтамукай"
  },
  "5560": {
    "id": "5560",
    "name": "Тлюстенхабль",
    "path": "Россия / Республика Адыгея / Тлюстенхабль",
    "country": "Россия",
    "searchString": "тлюстенхабль россия / республика адыгея / тлюстенхабль"
  },
  "5561": {
    "id": "5561",
    "name": "Тульский (Адыгея)",
    "path": "Россия / Республика Адыгея / Тульский (Адыгея)",
    "country": "Россия",
    "searchString": "тульский (адыгея) россия / республика адыгея / тульский (адыгея)"
  },
  "5562": {
    "id": "5562",
    "name": "Хакуринохабль",
    "path": "Россия / Республика Адыгея / Хакуринохабль",
    "country": "Россия",
    "searchString": "хакуринохабль россия / республика адыгея / хакуринохабль"
  },
  "5563": {
    "id": "5563",
    "name": "Ханская",
    "path": "Россия / Республика Адыгея / Ханская",
    "country": "Россия",
    "searchString": "ханская россия / республика адыгея / ханская"
  },
  "5564": {
    "id": "5564",
    "name": "Хатукай",
    "path": "Россия / Республика Адыгея / Хатукай",
    "country": "Россия",
    "searchString": "хатукай россия / республика адыгея / хатукай"
  },
  "5565": {
    "id": "5565",
    "name": "Ходзь",
    "path": "Россия / Республика Адыгея / Ходзь",
    "country": "Россия",
    "searchString": "ходзь россия / республика адыгея / ходзь"
  },
  "5566": {
    "id": "5566",
    "name": "Аксай (Дагестан)",
    "path": "Россия / Республика Дагестан / Аксай (Дагестан)",
    "country": "Россия",
    "searchString": "аксай (дагестан) россия / республика дагестан / аксай (дагестан)"
  },
  "5567": {
    "id": "5567",
    "name": "Акуша",
    "path": "Россия / Республика Дагестан / Акуша",
    "country": "Россия",
    "searchString": "акуша россия / республика дагестан / акуша"
  },
  "5568": {
    "id": "5568",
    "name": "Альбурикент",
    "path": "Россия / Республика Дагестан / Альбурикент",
    "country": "Россия",
    "searchString": "альбурикент россия / республика дагестан / альбурикент"
  },
  "5569": {
    "id": "5569",
    "name": "Анди",
    "path": "Россия / Республика Дагестан / Анди",
    "country": "Россия",
    "searchString": "анди россия / республика дагестан / анди"
  },
  "5570": {
    "id": "5570",
    "name": "Ансалта",
    "path": "Россия / Республика Дагестан / Ансалта",
    "country": "Россия",
    "searchString": "ансалта россия / республика дагестан / ансалта"
  },
  "5571": {
    "id": "5571",
    "name": "Ахты",
    "path": "Россия / Республика Дагестан / Ахты",
    "country": "Россия",
    "searchString": "ахты россия / республика дагестан / ахты"
  },
  "5572": {
    "id": "5572",
    "name": "Бабаюрт",
    "path": "Россия / Республика Дагестан / Бабаюрт",
    "country": "Россия",
    "searchString": "бабаюрт россия / республика дагестан / бабаюрт"
  },
  "5573": {
    "id": "5573",
    "name": "Белиджи",
    "path": "Россия / Республика Дагестан / Белиджи",
    "country": "Россия",
    "searchString": "белиджи россия / республика дагестан / белиджи"
  },
  "5574": {
    "id": "5574",
    "name": "Ботлих",
    "path": "Россия / Республика Дагестан / Ботлих",
    "country": "Россия",
    "searchString": "ботлих россия / республика дагестан / ботлих"
  },
  "5575": {
    "id": "5575",
    "name": "Верхнее Казанище",
    "path": "Россия / Республика Дагестан / Верхнее Казанище",
    "country": "Россия",
    "searchString": "верхнее казанище россия / республика дагестан / верхнее казанище"
  },
  "5576": {
    "id": "5576",
    "name": "Геджух",
    "path": "Россия / Республика Дагестан / Геджух",
    "country": "Россия",
    "searchString": "геджух россия / республика дагестан / геджух"
  },
  "5577": {
    "id": "5577",
    "name": "Гергебиль",
    "path": "Россия / Республика Дагестан / Гергебиль",
    "country": "Россия",
    "searchString": "гергебиль россия / республика дагестан / гергебиль"
  },
  "5578": {
    "id": "5578",
    "name": "Губден",
    "path": "Россия / Республика Дагестан / Губден",
    "country": "Россия",
    "searchString": "губден россия / республика дагестан / губден"
  },
  "5579": {
    "id": "5579",
    "name": "Дубки (Дагестан)",
    "path": "Россия / Республика Дагестан / Дубки (Дагестан)",
    "country": "Россия",
    "searchString": "дубки (дагестан) россия / республика дагестан / дубки (дагестан)"
  },
  "5580": {
    "id": "5580",
    "name": "Дылым",
    "path": "Россия / Республика Дагестан / Дылым",
    "country": "Россия",
    "searchString": "дылым россия / республика дагестан / дылым"
  },
  "5581": {
    "id": "5581",
    "name": "Зубутли-Миатли",
    "path": "Россия / Республика Дагестан / Зубутли-Миатли",
    "country": "Россия",
    "searchString": "зубутли-миатли россия / республика дагестан / зубутли-миатли"
  },
  "5582": {
    "id": "5582",
    "name": "Кака-Шура",
    "path": "Россия / Республика Дагестан / Кака-Шура",
    "country": "Россия",
    "searchString": "кака-шура россия / республика дагестан / кака-шура"
  },
  "5583": {
    "id": "5583",
    "name": "Карабудахкент",
    "path": "Россия / Республика Дагестан / Карабудахкент",
    "country": "Россия",
    "searchString": "карабудахкент россия / республика дагестан / карабудахкент"
  },
  "5584": {
    "id": "5584",
    "name": "Касумкент",
    "path": "Россия / Республика Дагестан / Касумкент",
    "country": "Россия",
    "searchString": "касумкент россия / республика дагестан / касумкент"
  },
  "5585": {
    "id": "5585",
    "name": "Каякент",
    "path": "Россия / Республика Дагестан / Каякент",
    "country": "Россия",
    "searchString": "каякент россия / республика дагестан / каякент"
  },
  "5586": {
    "id": "5586",
    "name": "Комсомольское (Дагестан)",
    "path": "Россия / Республика Дагестан / Комсомольское (Дагестан)",
    "country": "Россия",
    "searchString": "комсомольское (дагестан) россия / республика дагестан / комсомольское (дагестан)"
  },
  "5587": {
    "id": "5587",
    "name": "Коркмаскала",
    "path": "Россия / Республика Дагестан / Коркмаскала",
    "country": "Россия",
    "searchString": "коркмаскала россия / республика дагестан / коркмаскала"
  },
  "5588": {
    "id": "5588",
    "name": "Кочубей (Дагестан)",
    "path": "Россия / Республика Дагестан / Кочубей (Дагестан)",
    "country": "Россия",
    "searchString": "кочубей (дагестан) россия / республика дагестан / кочубей (дагестан)"
  },
  "5589": {
    "id": "5589",
    "name": "Куруш (Хасавюртовский район)",
    "path": "Россия / Республика Дагестан / Куруш (Хасавюртовский район)",
    "country": "Россия",
    "searchString": "куруш (хасавюртовский район) россия / республика дагестан / куруш (хасавюртовский район)"
  },
  "5590": {
    "id": "5590",
    "name": "Кяхулай",
    "path": "Россия / Республика Дагестан / Кяхулай",
    "country": "Россия",
    "searchString": "кяхулай россия / республика дагестан / кяхулай"
  },
  "5591": {
    "id": "5591",
    "name": "Леваши (Дагестан)",
    "path": "Россия / Республика Дагестан / Леваши (Дагестан)",
    "country": "Россия",
    "searchString": "леваши (дагестан) россия / республика дагестан / леваши (дагестан)"
  },
  "5592": {
    "id": "5592",
    "name": "Ленинкент (Махачкала)",
    "path": "Россия / Республика Дагестан / Ленинкент (Махачкала)",
    "country": "Россия",
    "searchString": "ленинкент (махачкала) россия / республика дагестан / ленинкент (махачкала)"
  },
  "5593": {
    "id": "5593",
    "name": "Магарамкент",
    "path": "Россия / Республика Дагестан / Магарамкент",
    "country": "Россия",
    "searchString": "магарамкент россия / республика дагестан / магарамкент"
  },
  "5594": {
    "id": "5594",
    "name": "Маджалис",
    "path": "Россия / Республика Дагестан / Маджалис",
    "country": "Россия",
    "searchString": "маджалис россия / республика дагестан / маджалис"
  },
  "5595": {
    "id": "5595",
    "name": "Мамедкала",
    "path": "Россия / Республика Дагестан / Мамедкала",
    "country": "Россия",
    "searchString": "мамедкала россия / республика дагестан / мамедкала"
  },
  "5596": {
    "id": "5596",
    "name": "Манаскент",
    "path": "Россия / Республика Дагестан / Манаскент",
    "country": "Россия",
    "searchString": "манаскент россия / республика дагестан / манаскент"
  },
  "5597": {
    "id": "5597",
    "name": "Нечаевка (Дагестан)",
    "path": "Россия / Республика Дагестан / Нечаевка (Дагестан)",
    "country": "Россия",
    "searchString": "нечаевка (дагестан) россия / республика дагестан / нечаевка (дагестан)"
  },
  "5598": {
    "id": "5598",
    "name": "Нижнее Казанище",
    "path": "Россия / Республика Дагестан / Нижнее Казанище",
    "country": "Россия",
    "searchString": "нижнее казанище россия / республика дагестан / нижнее казанище"
  },
  "5599": {
    "id": "5599",
    "name": "Нижний Дженгутай",
    "path": "Россия / Республика Дагестан / Нижний Дженгутай",
    "country": "Россия",
    "searchString": "нижний дженгутай россия / республика дагестан / нижний дженгутай"
  },
  "5600": {
    "id": "5600",
    "name": "Новая Мака",
    "path": "Россия / Республика Дагестан / Новая Мака",
    "country": "Россия",
    "searchString": "новая мака россия / республика дагестан / новая мака"
  },
  "5601": {
    "id": "5601",
    "name": "Новокаякент",
    "path": "Россия / Республика Дагестан / Новокаякент",
    "country": "Россия",
    "searchString": "новокаякент россия / республика дагестан / новокаякент"
  },
  "5602": {
    "id": "5602",
    "name": "Новолакское",
    "path": "Россия / Республика Дагестан / Новолакское",
    "country": "Россия",
    "searchString": "новолакское россия / республика дагестан / новолакское"
  },
  "5603": {
    "id": "5603",
    "name": "Новый Кяхулай",
    "path": "Россия / Республика Дагестан / Новый Кяхулай",
    "country": "Россия",
    "searchString": "новый кяхулай россия / республика дагестан / новый кяхулай"
  },
  "5604": {
    "id": "5604",
    "name": "Новый Сулак",
    "path": "Россия / Республика Дагестан / Новый Сулак",
    "country": "Россия",
    "searchString": "новый сулак россия / республика дагестан / новый сулак"
  },
  "5605": {
    "id": "5605",
    "name": "Новый Хушет",
    "path": "Россия / Республика Дагестан / Новый Хушет",
    "country": "Россия",
    "searchString": "новый хушет россия / республика дагестан / новый хушет"
  },
  "5606": {
    "id": "5606",
    "name": "Новый Чиркей",
    "path": "Россия / Республика Дагестан / Новый Чиркей",
    "country": "Россия",
    "searchString": "новый чиркей россия / республика дагестан / новый чиркей"
  },
  "5607": {
    "id": "5607",
    "name": "Первомайское (Хасавюртовский район)",
    "path": "Россия / Республика Дагестан / Первомайское (Хасавюртовский район)",
    "country": "Россия",
    "searchString": "первомайское (хасавюртовский район) россия / республика дагестан / первомайское (хасавюртовский район)"
  },
  "5608": {
    "id": "5608",
    "name": "Семендер",
    "path": "Россия / Республика Дагестан / Семендер",
    "country": "Россия",
    "searchString": "семендер россия / республика дагестан / семендер"
  },
  "5609": {
    "id": "5609",
    "name": "Сергокала",
    "path": "Россия / Республика Дагестан / Сергокала",
    "country": "Россия",
    "searchString": "сергокала россия / республика дагестан / сергокала"
  },
  "5610": {
    "id": "5610",
    "name": "Сулак (Дагестан)",
    "path": "Россия / Республика Дагестан / Сулак (Дагестан)",
    "country": "Россия",
    "searchString": "сулак (дагестан) россия / республика дагестан / сулак (дагестан)"
  },
  "5611": {
    "id": "5611",
    "name": "Тарки",
    "path": "Россия / Республика Дагестан / Тарки",
    "country": "Россия",
    "searchString": "тарки россия / республика дагестан / тарки"
  },
  "5612": {
    "id": "5612",
    "name": "Тарумовка",
    "path": "Россия / Республика Дагестан / Тарумовка",
    "country": "Россия",
    "searchString": "тарумовка россия / республика дагестан / тарумовка"
  },
  "5613": {
    "id": "5613",
    "name": "Терекли-Мектеб",
    "path": "Россия / Республика Дагестан / Терекли-Мектеб",
    "country": "Россия",
    "searchString": "терекли-мектеб россия / республика дагестан / терекли-мектеб"
  },
  "5614": {
    "id": "5614",
    "name": "Тюбе",
    "path": "Россия / Республика Дагестан / Тюбе",
    "country": "Россия",
    "searchString": "тюбе россия / республика дагестан / тюбе"
  },
  "5615": {
    "id": "5615",
    "name": "Усиша",
    "path": "Россия / Республика Дагестан / Усиша",
    "country": "Россия",
    "searchString": "усиша россия / республика дагестан / усиша"
  },
  "5616": {
    "id": "5616",
    "name": "Чонтаул",
    "path": "Россия / Республика Дагестан / Чонтаул",
    "country": "Россия",
    "searchString": "чонтаул россия / республика дагестан / чонтаул"
  },
  "5617": {
    "id": "5617",
    "name": "Шамилькала",
    "path": "Россия / Республика Дагестан / Шамилькала",
    "country": "Россия",
    "searchString": "шамилькала россия / республика дагестан / шамилькала"
  },
  "5618": {
    "id": "5618",
    "name": "Шамхал-Термен",
    "path": "Россия / Республика Дагестан / Шамхал-Термен",
    "country": "Россия",
    "searchString": "шамхал-термен россия / республика дагестан / шамхал-термен"
  },
  "5619": {
    "id": "5619",
    "name": "Али-Юрт",
    "path": "Россия / Республика Ингушетия / Али-Юрт",
    "country": "Россия",
    "searchString": "али-юрт россия / республика ингушетия / али-юрт"
  },
  "5620": {
    "id": "5620",
    "name": "Барсуки (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Барсуки (Ингушетия)",
    "country": "Россия",
    "searchString": "барсуки (ингушетия) россия / республика ингушетия / барсуки (ингушетия)"
  },
  "5621": {
    "id": "5621",
    "name": "Верхние Ачалуки",
    "path": "Россия / Республика Ингушетия / Верхние Ачалуки",
    "country": "Россия",
    "searchString": "верхние ачалуки россия / республика ингушетия / верхние ачалуки"
  },
  "5622": {
    "id": "5622",
    "name": "Галашки",
    "path": "Россия / Республика Ингушетия / Галашки",
    "country": "Россия",
    "searchString": "галашки россия / республика ингушетия / галашки"
  },
  "5623": {
    "id": "5623",
    "name": "Долаково",
    "path": "Россия / Республика Ингушетия / Долаково",
    "country": "Россия",
    "searchString": "долаково россия / республика ингушетия / долаково"
  },
  "5624": {
    "id": "5624",
    "name": "Инарки",
    "path": "Россия / Республика Ингушетия / Инарки",
    "country": "Россия",
    "searchString": "инарки россия / республика ингушетия / инарки"
  },
  "5625": {
    "id": "5625",
    "name": "Кантышево",
    "path": "Россия / Республика Ингушетия / Кантышево",
    "country": "Россия",
    "searchString": "кантышево россия / республика ингушетия / кантышево"
  },
  "5626": {
    "id": "5626",
    "name": "Нестеровская (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Нестеровская (Ингушетия)",
    "country": "Россия",
    "searchString": "нестеровская (ингушетия) россия / республика ингушетия / нестеровская (ингушетия)"
  },
  "5627": {
    "id": "5627",
    "name": "Сунжа (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Сунжа (Ингушетия)",
    "country": "Россия",
    "searchString": "сунжа (ингушетия) россия / республика ингушетия / сунжа (ингушетия)"
  },
  "5628": {
    "id": "5628",
    "name": "Плиево",
    "path": "Россия / Республика Ингушетия / Плиево",
    "country": "Россия",
    "searchString": "плиево россия / республика ингушетия / плиево"
  },
  "5629": {
    "id": "5629",
    "name": "Сагопши",
    "path": "Россия / Республика Ингушетия / Сагопши",
    "country": "Россия",
    "searchString": "сагопши россия / республика ингушетия / сагопши"
  },
  "5630": {
    "id": "5630",
    "name": "Сурхахи",
    "path": "Россия / Республика Ингушетия / Сурхахи",
    "country": "Россия",
    "searchString": "сурхахи россия / республика ингушетия / сурхахи"
  },
  "5631": {
    "id": "5631",
    "name": "Троицкая (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Троицкая (Ингушетия)",
    "country": "Россия",
    "searchString": "троицкая (ингушетия) россия / республика ингушетия / троицкая (ингушетия)"
  },
  "5632": {
    "id": "5632",
    "name": "Экажево",
    "path": "Россия / Республика Ингушетия / Экажево",
    "country": "Россия",
    "searchString": "экажево россия / республика ингушетия / экажево"
  },
  "5633": {
    "id": "5633",
    "name": "Яндаре",
    "path": "Россия / Республика Ингушетия / Яндаре",
    "country": "Россия",
    "searchString": "яндаре россия / республика ингушетия / яндаре"
  },
  "5634": {
    "id": "5634",
    "name": "Грэсовский",
    "path": "Россия / Республика Крым / Грэсовский",
    "country": "Россия",
    "searchString": "грэсовский россия / республика крым / грэсовский"
  },
  "5635": {
    "id": "5635",
    "name": "Жаворонки (Крым)",
    "path": "Россия / Республика Крым / Жаворонки (Крым)",
    "country": "Россия",
    "searchString": "жаворонки (крым) россия / республика крым / жаворонки (крым)"
  },
  "5636": {
    "id": "5636",
    "name": "Кубанское",
    "path": "Россия / Республика Крым / Кубанское",
    "country": "Россия",
    "searchString": "кубанское россия / республика крым / кубанское"
  },
  "5637": {
    "id": "5637",
    "name": "Ореанда",
    "path": "Россия / Республика Крым / Ореанда",
    "country": "Россия",
    "searchString": "ореанда россия / республика крым / ореанда"
  },
  "5638": {
    "id": "5638",
    "name": "Симоненко",
    "path": "Россия / Республика Крым / Симоненко",
    "country": "Россия",
    "searchString": "симоненко россия / республика крым / симоненко"
  },
  "5639": {
    "id": "5639",
    "name": "Ферсманово",
    "path": "Россия / Республика Крым / Ферсманово",
    "country": "Россия",
    "searchString": "ферсманово россия / республика крым / ферсманово"
  },
  "5640": {
    "id": "5640",
    "name": "Архонская",
    "path": "Россия / Республика Северная Осетия-Алания / Архонская",
    "country": "Россия",
    "searchString": "архонская россия / республика северная осетия-алания / архонская"
  },
  "5641": {
    "id": "5641",
    "name": "Гизель",
    "path": "Россия / Республика Северная Осетия-Алания / Гизель",
    "country": "Россия",
    "searchString": "гизель россия / республика северная осетия-алания / гизель"
  },
  "5642": {
    "id": "5642",
    "name": "Заводской (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Заводской (Северная Осетия)",
    "country": "Россия",
    "searchString": "заводской (северная осетия) россия / республика северная осетия-алания / заводской (северная осетия)"
  },
  "5643": {
    "id": "5643",
    "name": "Змейская",
    "path": "Россия / Республика Северная Осетия-Алания / Змейская",
    "country": "Россия",
    "searchString": "змейская россия / республика северная осетия-алания / змейская"
  },
  "5644": {
    "id": "5644",
    "name": "Ир",
    "path": "Россия / Республика Северная Осетия-Алания / Ир",
    "country": "Россия",
    "searchString": "ир россия / республика северная осетия-алания / ир"
  },
  "5645": {
    "id": "5645",
    "name": "Камбилеевское",
    "path": "Россия / Республика Северная Осетия-Алания / Камбилеевское",
    "country": "Россия",
    "searchString": "камбилеевское россия / республика северная осетия-алания / камбилеевское"
  },
  "5646": {
    "id": "5646",
    "name": "Карджин",
    "path": "Россия / Республика Северная Осетия-Алания / Карджин",
    "country": "Россия",
    "searchString": "карджин россия / республика северная осетия-алания / карджин"
  },
  "5647": {
    "id": "5647",
    "name": "Кизляр (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Кизляр (Северная Осетия)",
    "country": "Россия",
    "searchString": "кизляр (северная осетия) россия / республика северная осетия-алания / кизляр (северная осетия)"
  },
  "5648": {
    "id": "5648",
    "name": "Луковская (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Луковская (Северная Осетия)",
    "country": "Россия",
    "searchString": "луковская (северная осетия) россия / республика северная осетия-алания / луковская (северная осетия)"
  },
  "5649": {
    "id": "5649",
    "name": "Майское (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Майское (Северная Осетия)",
    "country": "Россия",
    "searchString": "майское (северная осетия) россия / республика северная осетия-алания / майское (северная осетия)"
  },
  "5650": {
    "id": "5650",
    "name": "Михайловское (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Михайловское (Северная Осетия)",
    "country": "Россия",
    "searchString": "михайловское (северная осетия) россия / республика северная осетия-алания / михайловское (северная осетия)"
  },
  "5651": {
    "id": "5651",
    "name": "Ногир",
    "path": "Россия / Республика Северная Осетия-Алания / Ногир",
    "country": "Россия",
    "searchString": "ногир россия / республика северная осетия-алания / ногир"
  },
  "5652": {
    "id": "5652",
    "name": "Октябрьское (Пригородный район)",
    "path": "Россия / Республика Северная Осетия-Алания / Октябрьское (Пригородный район)",
    "country": "Россия",
    "searchString": "октябрьское (пригородный район) россия / республика северная осетия-алания / октябрьское (пригородный район)"
  },
  "5653": {
    "id": "5653",
    "name": "Ольгинское (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Ольгинское (Северная Осетия)",
    "country": "Россия",
    "searchString": "ольгинское (северная осетия) россия / республика северная осетия-алания / ольгинское (северная осетия)"
  },
  "5654": {
    "id": "5654",
    "name": "Павлодольская",
    "path": "Россия / Республика Северная Осетия-Алания / Павлодольская",
    "country": "Россия",
    "searchString": "павлодольская россия / республика северная осетия-алания / павлодольская"
  },
  "5655": {
    "id": "5655",
    "name": "Сунжа (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Сунжа (Северная Осетия)",
    "country": "Россия",
    "searchString": "сунжа (северная осетия) россия / республика северная осетия-алания / сунжа (северная осетия)"
  },
  "5656": {
    "id": "5656",
    "name": "Тарское",
    "path": "Россия / Республика Северная Осетия-Алания / Тарское",
    "country": "Россия",
    "searchString": "тарское россия / республика северная осетия-алания / тарское"
  },
  "5657": {
    "id": "5657",
    "name": "Терская",
    "path": "Россия / Республика Северная Осетия-Алания / Терская",
    "country": "Россия",
    "searchString": "терская россия / республика северная осетия-алания / терская"
  },
  "5658": {
    "id": "5658",
    "name": "Троицкое (Северная Осетия)",
    "path": "Россия / Республика Северная Осетия-Алания / Троицкое (Северная Осетия)",
    "country": "Россия",
    "searchString": "троицкое (северная осетия) россия / республика северная осетия-алания / троицкое (северная осетия)"
  },
  "5659": {
    "id": "5659",
    "name": "Хумалаг",
    "path": "Россия / Республика Северная Осетия-Алания / Хумалаг",
    "country": "Россия",
    "searchString": "хумалаг россия / республика северная осетия-алания / хумалаг"
  },
  "5660": {
    "id": "5660",
    "name": "Чермен",
    "path": "Россия / Республика Северная Осетия-Алания / Чермен",
    "country": "Россия",
    "searchString": "чермен россия / республика северная осетия-алания / чермен"
  },
  "5661": {
    "id": "5661",
    "name": "Чикола",
    "path": "Россия / Республика Северная Осетия-Алания / Чикола",
    "country": "Россия",
    "searchString": "чикола россия / республика северная осетия-алания / чикола"
  },
  "5662": {
    "id": "5662",
    "name": "Эльхотово",
    "path": "Россия / Республика Северная Осетия-Алания / Эльхотово",
    "country": "Россия",
    "searchString": "эльхотово россия / республика северная осетия-алания / эльхотово"
  },
  "5663": {
    "id": "5663",
    "name": "Анджиевский",
    "path": "Россия / Ставропольский край / Анджиевский",
    "country": "Россия",
    "searchString": "анджиевский россия / ставропольский край / анджиевский"
  },
  "5664": {
    "id": "5664",
    "name": "Большая Джалга",
    "path": "Россия / Ставропольский край / Большая Джалга",
    "country": "Россия",
    "searchString": "большая джалга россия / ставропольский край / большая джалга"
  },
  "5665": {
    "id": "5665",
    "name": "Бурлацкое (Ставропольский край)",
    "path": "Россия / Ставропольский край / Бурлацкое (Ставропольский край)",
    "country": "Россия",
    "searchString": "бурлацкое (ставропольский край) россия / ставропольский край / бурлацкое (ставропольский край)"
  },
  "5666": {
    "id": "5666",
    "name": "Высоцкое (Ставропольский край)",
    "path": "Россия / Ставропольский край / Высоцкое (Ставропольский край)",
    "country": "Россия",
    "searchString": "высоцкое (ставропольский край) россия / ставропольский край / высоцкое (ставропольский край)"
  },
  "5667": {
    "id": "5667",
    "name": "Гражданское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Гражданское (Ставропольский край)",
    "country": "Россия",
    "searchString": "гражданское (ставропольский край) россия / ставропольский край / гражданское (ставропольский край)"
  },
  "5668": {
    "id": "5668",
    "name": "Кара-Тюбе",
    "path": "Россия / Ставропольский край / Кара-Тюбе",
    "country": "Россия",
    "searchString": "кара-тюбе россия / ставропольский край / кара-тюбе"
  },
  "5669": {
    "id": "5669",
    "name": "Ладовская Балка",
    "path": "Россия / Ставропольский край / Ладовская Балка",
    "country": "Россия",
    "searchString": "ладовская балка россия / ставропольский край / ладовская балка"
  },
  "5670": {
    "id": "5670",
    "name": "Нагутское",
    "path": "Россия / Ставропольский край / Нагутское",
    "country": "Россия",
    "searchString": "нагутское россия / ставропольский край / нагутское"
  },
  "5671": {
    "id": "5671",
    "name": "Первомайское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Первомайское (Ставропольский край)",
    "country": "Россия",
    "searchString": "первомайское (ставропольский край) россия / ставропольский край / первомайское (ставропольский край)"
  },
  "5672": {
    "id": "5672",
    "name": "Прасковея",
    "path": "Россия / Ставропольский край / Прасковея",
    "country": "Россия",
    "searchString": "прасковея россия / ставропольский край / прасковея"
  },
  "5673": {
    "id": "5673",
    "name": "Северное (Ставропольский край)",
    "path": "Россия / Ставропольский край / Северное (Ставропольский край)",
    "country": "Россия",
    "searchString": "северное (ставропольский край) россия / ставропольский край / северное (ставропольский край)"
  },
  "5674": {
    "id": "5674",
    "name": "Солуно-Дмитриевское",
    "path": "Россия / Ставропольский край / Солуно-Дмитриевское",
    "country": "Россия",
    "searchString": "солуно-дмитриевское россия / ставропольский край / солуно-дмитриевское"
  },
  "5675": {
    "id": "5675",
    "name": "Сотниковское",
    "path": "Россия / Ставропольский край / Сотниковское",
    "country": "Россия",
    "searchString": "сотниковское россия / ставропольский край / сотниковское"
  },
  "5676": {
    "id": "5676",
    "name": "Старомарьевка (Ставропольский край)",
    "path": "Россия / Ставропольский край / Старомарьевка (Ставропольский край)",
    "country": "Россия",
    "searchString": "старомарьевка (ставропольский край) россия / ставропольский край / старомарьевка (ставропольский край)"
  },
  "5677": {
    "id": "5677",
    "name": "Темижбекский",
    "path": "Россия / Ставропольский край / Темижбекский",
    "country": "Россия",
    "searchString": "темижбекский россия / ставропольский край / темижбекский"
  },
  "5678": {
    "id": "5678",
    "name": "Тищенское",
    "path": "Россия / Ставропольский край / Тищенское",
    "country": "Россия",
    "searchString": "тищенское россия / ставропольский край / тищенское"
  },
  "5679": {
    "id": "5679",
    "name": "Автуры",
    "path": "Россия / Чеченская республика / Автуры",
    "country": "Россия",
    "searchString": "автуры россия / чеченская республика / автуры"
  },
  "5680": {
    "id": "5680",
    "name": "Аллерой (Курчалоевский район)",
    "path": "Россия / Чеченская республика / Аллерой (Курчалоевский район)",
    "country": "Россия",
    "searchString": "аллерой (курчалоевский район) россия / чеченская республика / аллерой (курчалоевский район)"
  },
  "5681": {
    "id": "5681",
    "name": "Алхан-Кала",
    "path": "Россия / Чеченская республика / Алхан-Кала",
    "country": "Россия",
    "searchString": "алхан-кала россия / чеченская республика / алхан-кала"
  },
  "5682": {
    "id": "5682",
    "name": "Ассиновская",
    "path": "Россия / Чеченская республика / Ассиновская",
    "country": "Россия",
    "searchString": "ассиновская россия / чеченская республика / ассиновская"
  },
  "5683": {
    "id": "5683",
    "name": "Ачхой-Мартан",
    "path": "Россия / Чеченская республика / Ачхой-Мартан",
    "country": "Россия",
    "searchString": "ачхой-мартан россия / чеченская республика / ачхой-мартан"
  },
  "5684": {
    "id": "5684",
    "name": "Бачи-Юрт",
    "path": "Россия / Чеченская республика / Бачи-Юрт",
    "country": "Россия",
    "searchString": "бачи-юрт россия / чеченская республика / бачи-юрт"
  },
  "5685": {
    "id": "5685",
    "name": "Гелдаган",
    "path": "Россия / Чеченская республика / Гелдаган",
    "country": "Россия",
    "searchString": "гелдаган россия / чеченская республика / гелдаган"
  },
  "5686": {
    "id": "5686",
    "name": "Герменчук",
    "path": "Россия / Чеченская республика / Герменчук",
    "country": "Россия",
    "searchString": "герменчук россия / чеченская республика / герменчук"
  },
  "5687": {
    "id": "5687",
    "name": "Гехи",
    "path": "Россия / Чеченская республика / Гехи",
    "country": "Россия",
    "searchString": "гехи россия / чеченская республика / гехи"
  },
  "5688": {
    "id": "5688",
    "name": "Гойты",
    "path": "Россия / Чеченская республика / Гойты",
    "country": "Россия",
    "searchString": "гойты россия / чеченская республика / гойты"
  },
  "5689": {
    "id": "5689",
    "name": "Знаменское (Чечня)",
    "path": "Россия / Чеченская республика / Знаменское (Чечня)",
    "country": "Россия",
    "searchString": "знаменское (чечня) россия / чеченская республика / знаменское (чечня)"
  },
  "5690": {
    "id": "5690",
    "name": "Катыр-Юрт",
    "path": "Россия / Чеченская республика / Катыр-Юрт",
    "country": "Россия",
    "searchString": "катыр-юрт россия / чеченская республика / катыр-юрт"
  },
  "5691": {
    "id": "5691",
    "name": "Курчалой",
    "path": "Россия / Чеченская республика / Курчалой",
    "country": "Россия",
    "searchString": "курчалой россия / чеченская республика / курчалой"
  },
  "5692": {
    "id": "5692",
    "name": "Майртуп",
    "path": "Россия / Чеченская республика / Майртуп",
    "country": "Россия",
    "searchString": "майртуп россия / чеченская республика / майртуп"
  },
  "5693": {
    "id": "5693",
    "name": "Мескер-Юрт",
    "path": "Россия / Чеченская республика / Мескер-Юрт",
    "country": "Россия",
    "searchString": "мескер-юрт россия / чеченская республика / мескер-юрт"
  },
  "5694": {
    "id": "5694",
    "name": "Наурская",
    "path": "Россия / Чеченская республика / Наурская",
    "country": "Россия",
    "searchString": "наурская россия / чеченская республика / наурская"
  },
  "5695": {
    "id": "5695",
    "name": "Ойсхара",
    "path": "Россия / Чеченская республика / Ойсхара",
    "country": "Россия",
    "searchString": "ойсхара россия / чеченская республика / ойсхара"
  },
  "5696": {
    "id": "5696",
    "name": "Самашки",
    "path": "Россия / Чеченская республика / Самашки",
    "country": "Россия",
    "searchString": "самашки россия / чеченская республика / самашки"
  },
  "5697": {
    "id": "5697",
    "name": "Серноводское",
    "path": "Россия / Чеченская республика / Серноводское",
    "country": "Россия",
    "searchString": "серноводское россия / чеченская республика / серноводское"
  },
  "5698": {
    "id": "5698",
    "name": "Старые Атаги",
    "path": "Россия / Чеченская республика / Старые Атаги",
    "country": "Россия",
    "searchString": "старые атаги россия / чеченская республика / старые атаги"
  },
  "5699": {
    "id": "5699",
    "name": "Цоци-Юрт",
    "path": "Россия / Чеченская республика / Цоци-Юрт",
    "country": "Россия",
    "searchString": "цоци-юрт россия / чеченская республика / цоци-юрт"
  },
  "5700": {
    "id": "5700",
    "name": "Червлённая",
    "path": "Россия / Чеченская республика / Червлённая",
    "country": "Россия",
    "searchString": "червлённая россия / чеченская республика / червлённая"
  },
  "5701": {
    "id": "5701",
    "name": "Шелковская",
    "path": "Россия / Чеченская республика / Шелковская",
    "country": "Россия",
    "searchString": "шелковская россия / чеченская республика / шелковская"
  },
  "5702": {
    "id": "5702",
    "name": "Визинга",
    "path": "Россия / Республика Коми / Визинга",
    "country": "Россия",
    "searchString": "визинга россия / республика коми / визинга"
  },
  "5703": {
    "id": "5703",
    "name": "Выльгорт",
    "path": "Россия / Республика Коми / Выльгорт",
    "country": "Россия",
    "searchString": "выльгорт россия / республика коми / выльгорт"
  },
  "5704": {
    "id": "5704",
    "name": "Ижма (Коми)",
    "path": "Россия / Республика Коми / Ижма (Коми)",
    "country": "Россия",
    "searchString": "ижма (коми) россия / республика коми / ижма (коми)"
  },
  "5705": {
    "id": "5705",
    "name": "Корткерос",
    "path": "Россия / Республика Коми / Корткерос",
    "country": "Россия",
    "searchString": "корткерос россия / республика коми / корткерос"
  },
  "5706": {
    "id": "5706",
    "name": "Усть-Кулом",
    "path": "Россия / Республика Коми / Усть-Кулом",
    "country": "Россия",
    "searchString": "усть-кулом россия / республика коми / усть-кулом"
  },
  "5707": {
    "id": "5707",
    "name": "Высокий (Мурманская область)",
    "path": "Россия / Мурманская область / Высокий (Мурманская область)",
    "country": "Россия",
    "searchString": "высокий (мурманская область) россия / мурманская область / высокий (мурманская область)"
  },
  "5708": {
    "id": "5708",
    "name": "Яренск",
    "path": "Россия / Архангельская область / Яренск",
    "country": "Россия",
    "searchString": "яренск россия / архангельская область / яренск"
  },
  "5709": {
    "id": "5709",
    "name": "Колтуши",
    "path": "Россия / Ленинградская область / Колтуши",
    "country": "Россия",
    "searchString": "колтуши россия / ленинградская область / колтуши"
  },
  "5710": {
    "id": "5710",
    "name": "Озерки (Всеволожский район)",
    "path": "Россия / Ленинградская область / Озерки (Всеволожский район)",
    "country": "Россия",
    "searchString": "озерки (всеволожский район) россия / ленинградская область / озерки (всеволожский район)"
  },
  "5711": {
    "id": "5711",
    "name": "Стрельна",
    "path": "Россия / Ленинградская область / Стрельна",
    "country": "Россия",
    "searchString": "стрельна россия / ленинградская область / стрельна"
  },
  "5712": {
    "id": "5712",
    "name": "Ям-Ижора",
    "path": "Россия / Ленинградская область / Ям-Ижора",
    "country": "Россия",
    "searchString": "ям-ижора россия / ленинградская область / ям-ижора"
  },
  "5713": {
    "id": "5713",
    "name": "Акбаш (Свердловская область)",
    "path": "Россия / Свердловская область / Акбаш (Свердловская область)",
    "country": "Россия",
    "searchString": "акбаш (свердловская область) россия / свердловская область / акбаш (свердловская область)"
  },
  "5714": {
    "id": "5714",
    "name": "Большебрусянское",
    "path": "Россия / Свердловская область / Большебрусянское",
    "country": "Россия",
    "searchString": "большебрусянское россия / свердловская область / большебрусянское"
  },
  "5715": {
    "id": "5715",
    "name": "Балтым",
    "path": "Россия / Свердловская область / Балтым",
    "country": "Россия",
    "searchString": "балтым россия / свердловская область / балтым"
  },
  "5716": {
    "id": "5716",
    "name": "Валериановск",
    "path": "Россия / Свердловская область / Валериановск",
    "country": "Россия",
    "searchString": "валериановск россия / свердловская область / валериановск"
  },
  "5717": {
    "id": "5717",
    "name": "Верхняя Сысерть",
    "path": "Россия / Свердловская область / Верхняя Сысерть",
    "country": "Россия",
    "searchString": "верхняя сысерть россия / свердловская область / верхняя сысерть"
  },
  "5718": {
    "id": "5718",
    "name": "Восточный (Свердловская область)",
    "path": "Россия / Свердловская область / Восточный (Свердловская область)",
    "country": "Россия",
    "searchString": "восточный (свердловская область) россия / свердловская область / восточный (свердловская область)"
  },
  "5719": {
    "id": "5719",
    "name": "Гари (Свердловская область)",
    "path": "Россия / Свердловская область / Гари (Свердловская область)",
    "country": "Россия",
    "searchString": "гари (свердловская область) россия / свердловская область / гари (свердловская область)"
  },
  "5720": {
    "id": "5720",
    "name": "Гилёва (Белоярский городской округ)",
    "path": "Россия / Свердловская область / Гилёва (Белоярский городской округ)",
    "country": "Россия",
    "searchString": "гилёва (белоярский городской округ) россия / свердловская область / гилёва (белоярский городской округ)"
  },
  "5721": {
    "id": "5721",
    "name": "Горный Щит",
    "path": "Россия / Свердловская область / Горный Щит",
    "country": "Россия",
    "searchString": "горный щит россия / свердловская область / горный щит"
  },
  "5722": {
    "id": "5722",
    "name": "Грязновское",
    "path": "Россия / Свердловская область / Грязновское",
    "country": "Россия",
    "searchString": "грязновское россия / свердловская область / грязновское"
  },
  "5723": {
    "id": "5723",
    "name": "Заводоуспенское",
    "path": "Россия / Свердловская область / Заводоуспенское",
    "country": "Россия",
    "searchString": "заводоуспенское россия / свердловская область / заводоуспенское"
  },
  "5724": {
    "id": "5724",
    "name": "Зайково (Свердловская область)",
    "path": "Россия / Свердловская область / Зайково (Свердловская область)",
    "country": "Россия",
    "searchString": "зайково (свердловская область) россия / свердловская область / зайково (свердловская область)"
  },
  "5725": {
    "id": "5725",
    "name": "Заря (муниципальное образование Алапаевское)",
    "path": "Россия / Свердловская область / Заря (муниципальное образование Алапаевское)",
    "country": "Россия",
    "searchString": "заря (муниципальное образование алапаевское) россия / свердловская область / заря (муниципальное образование алапаевское)"
  },
  "5726": {
    "id": "5726",
    "name": "Калиновка (Байкаловский район)",
    "path": "Россия / Свердловская область / Калиновка (Байкаловский район)",
    "country": "Россия",
    "searchString": "калиновка (байкаловский район) россия / свердловская область / калиновка (байкаловский район)"
  },
  "5727": {
    "id": "5727",
    "name": "Калья",
    "path": "Россия / Свердловская область / Калья",
    "country": "Россия",
    "searchString": "калья россия / свердловская область / калья"
  },
  "5728": {
    "id": "5728",
    "name": "Кашино (Свердловская область)",
    "path": "Россия / Свердловская область / Кашино (Свердловская область)",
    "country": "Россия",
    "searchString": "кашино (свердловская область) россия / свердловская область / кашино (свердловская область)"
  },
  "5729": {
    "id": "5729",
    "name": "Кедровое",
    "path": "Россия / Свердловская область / Кедровое",
    "country": "Россия",
    "searchString": "кедровое россия / свердловская область / кедровое"
  },
  "5730": {
    "id": "5730",
    "name": "Киселевка (Свердловская область)",
    "path": "Россия / Свердловская область / Киселевка (Свердловская область)",
    "country": "Россия",
    "searchString": "киселевка (свердловская область) россия / свердловская область / киселевка (свердловская область)"
  },
  "5731": {
    "id": "5731",
    "name": "Колюткино",
    "path": "Россия / Свердловская область / Колюткино",
    "country": "Россия",
    "searchString": "колюткино россия / свердловская область / колюткино"
  },
  "5732": {
    "id": "5732",
    "name": "Косулино (Свердловская область)",
    "path": "Россия / Свердловская область / Косулино (Свердловская область)",
    "country": "Россия",
    "searchString": "косулино (свердловская область) россия / свердловская область / косулино (свердловская область)"
  },
  "5733": {
    "id": "5733",
    "name": "Красногвардейский (Артёмовский городской округ)",
    "path": "Россия / Свердловская область / Красногвардейский (Артёмовский городской округ)",
    "country": "Россия",
    "searchString": "красногвардейский (артёмовский городской округ) россия / свердловская область / красногвардейский (артёмовский городской округ)"
  },
  "5734": {
    "id": "5734",
    "name": "Крылатовский",
    "path": "Россия / Свердловская область / Крылатовский",
    "country": "Россия",
    "searchString": "крылатовский россия / свердловская область / крылатовский"
  },
  "5735": {
    "id": "5735",
    "name": "Курьи",
    "path": "Россия / Свердловская область / Курьи",
    "country": "Россия",
    "searchString": "курьи россия / свердловская область / курьи"
  },
  "5736": {
    "id": "5736",
    "name": "Ленинский (Свердловская область)",
    "path": "Россия / Свердловская область / Ленинский (Свердловская область)",
    "country": "Россия",
    "searchString": "ленинский (свердловская область) россия / свердловская область / ленинский (свердловская область)"
  },
  "5737": {
    "id": "5737",
    "name": "Лосиный",
    "path": "Россия / Свердловская область / Лосиный",
    "country": "Россия",
    "searchString": "лосиный россия / свердловская область / лосиный"
  },
  "5738": {
    "id": "5738",
    "name": "Манчаж",
    "path": "Россия / Свердловская область / Манчаж",
    "country": "Россия",
    "searchString": "манчаж россия / свердловская область / манчаж"
  },
  "5739": {
    "id": "5739",
    "name": "Марамзино (Свердловская область)",
    "path": "Россия / Свердловская область / Марамзино (Свердловская область)",
    "country": "Россия",
    "searchString": "марамзино (свердловская область) россия / свердловская область / марамзино (свердловская область)"
  },
  "5740": {
    "id": "5740",
    "name": "Мартюш",
    "path": "Россия / Свердловская область / Мартюш",
    "country": "Россия",
    "searchString": "мартюш россия / свердловская область / мартюш"
  },
  "5741": {
    "id": "5741",
    "name": "Махнево",
    "path": "Россия / Свердловская область / Махнево",
    "country": "Россия",
    "searchString": "махнево россия / свердловская область / махнево"
  },
  "5742": {
    "id": "5742",
    "name": "Натальинск",
    "path": "Россия / Свердловская область / Натальинск",
    "country": "Россия",
    "searchString": "натальинск россия / свердловская область / натальинск"
  },
  "5743": {
    "id": "5743",
    "name": "Некрасово (Свердловская область)",
    "path": "Россия / Свердловская область / Некрасово (Свердловская область)",
    "country": "Россия",
    "searchString": "некрасово (свердловская область) россия / свердловская область / некрасово (свердловская область)"
  },
  "5744": {
    "id": "5744",
    "name": "Новая Рассоха (Свердловская область)",
    "path": "Россия / Свердловская область / Новая Рассоха (Свердловская область)",
    "country": "Россия",
    "searchString": "новая рассоха (свердловская область) россия / свердловская область / новая рассоха (свердловская область)"
  },
  "5745": {
    "id": "5745",
    "name": "Новоалексеевское (Свердловская область)",
    "path": "Россия / Свердловская область / Новоалексеевское (Свердловская область)",
    "country": "Россия",
    "searchString": "новоалексеевское (свердловская область) россия / свердловская область / новоалексеевское (свердловская область)"
  },
  "5746": {
    "id": "5746",
    "name": "Октябрьский (Сысертский городской округ)",
    "path": "Россия / Свердловская область / Октябрьский (Сысертский городской округ)",
    "country": "Россия",
    "searchString": "октябрьский (сысертский городской округ) россия / свердловская область / октябрьский (сысертский городской округ)"
  },
  "5747": {
    "id": "5747",
    "name": "Павда",
    "path": "Россия / Свердловская область / Павда",
    "country": "Россия",
    "searchString": "павда россия / свердловская область / павда"
  },
  "5748": {
    "id": "5748",
    "name": "Патруши (Свердловская область)",
    "path": "Россия / Свердловская область / Патруши (Свердловская область)",
    "country": "Россия",
    "searchString": "патруши (свердловская область) россия / свердловская область / патруши (свердловская область)"
  },
  "5749": {
    "id": "5749",
    "name": "Первомайский (Горноуральский городской округ)",
    "path": "Россия / Свердловская область / Первомайский (Горноуральский городской округ)",
    "country": "Россия",
    "searchString": "первомайский (горноуральский городской округ) россия / свердловская область / первомайский (горноуральский городской округ)"
  },
  "5750": {
    "id": "5750",
    "name": "Платоново (Свердловская область)",
    "path": "Россия / Свердловская область / Платоново (Свердловская область)",
    "country": "Россия",
    "searchString": "платоново (свердловская область) россия / свердловская область / платоново (свердловская область)"
  },
  "5751": {
    "id": "5751",
    "name": "Поварня (Свердловская область)",
    "path": "Россия / Свердловская область / Поварня (Свердловская область)",
    "country": "Россия",
    "searchString": "поварня (свердловская область) россия / свердловская область / поварня (свердловская область)"
  },
  "5752": {
    "id": "5752",
    "name": "Полеводство",
    "path": "Россия / Свердловская область / Полеводство",
    "country": "Россия",
    "searchString": "полеводство россия / свердловская область / полеводство"
  },
  "5753": {
    "id": "5753",
    "name": "Половинный (городской округ Верхний Тагил)",
    "path": "Россия / Свердловская область / Половинный (городской округ Верхний Тагил)",
    "country": "Россия",
    "searchString": "половинный (городской округ верхний тагил) россия / свердловская область / половинный (городской округ верхний тагил)"
  },
  "5754": {
    "id": "5754",
    "name": "Привокзальный (Свердловская область)",
    "path": "Россия / Свердловская область / Привокзальный (Свердловская область)",
    "country": "Россия",
    "searchString": "привокзальный (свердловская область) россия / свердловская область / привокзальный (свердловская область)"
  },
  "5755": {
    "id": "5755",
    "name": "Прохладный (Свердловская область)",
    "path": "Россия / Свердловская область / Прохладный (Свердловская область)",
    "country": "Россия",
    "searchString": "прохладный (свердловская область) россия / свердловская область / прохладный (свердловская область)"
  },
  "5756": {
    "id": "5756",
    "name": "Решёты (Свердловская область)",
    "path": "Россия / Свердловская область / Решёты (Свердловская область)",
    "country": "Россия",
    "searchString": "решёты (свердловская область) россия / свердловская область / решёты (свердловская область)"
  },
  "5757": {
    "id": "5757",
    "name": "Рудничный (Свердловская область)",
    "path": "Россия / Свердловская область / Рудничный (Свердловская область)",
    "country": "Россия",
    "searchString": "рудничный (свердловская область) россия / свердловская область / рудничный (свердловская область)"
  },
  "5758": {
    "id": "5758",
    "name": "Рудный (Свердловская область)",
    "path": "Россия / Свердловская область / Рудный (Свердловская область)",
    "country": "Россия",
    "searchString": "рудный (свердловская область) россия / свердловская область / рудный (свердловская область)"
  },
  "5759": {
    "id": "5759",
    "name": "Садовый (Свердловская область)",
    "path": "Россия / Свердловская область / Садовый (Свердловская область)",
    "country": "Россия",
    "searchString": "садовый (свердловская область) россия / свердловская область / садовый (свердловская область)"
  },
  "5760": {
    "id": "5760",
    "name": "Северка (Свердловская область)",
    "path": "Россия / Свердловская область / Северка (Свердловская область)",
    "country": "Россия",
    "searchString": "северка (свердловская область) россия / свердловская область / северка (свердловская область)"
  },
  "5761": {
    "id": "5761",
    "name": "Средний Бугалыш",
    "path": "Россия / Свердловская область / Средний Бугалыш",
    "country": "Россия",
    "searchString": "средний бугалыш россия / свердловская область / средний бугалыш"
  },
  "5762": {
    "id": "5762",
    "name": "Старопышминск",
    "path": "Россия / Свердловская область / Старопышминск",
    "country": "Россия",
    "searchString": "старопышминск россия / свердловская область / старопышминск"
  },
  "5763": {
    "id": "5763",
    "name": "Староуткинск",
    "path": "Россия / Свердловская область / Староуткинск",
    "country": "Россия",
    "searchString": "староуткинск россия / свердловская область / староуткинск"
  },
  "5764": {
    "id": "5764",
    "name": "Таборы (Таборинский район)",
    "path": "Россия / Свердловская область / Таборы (Таборинский район)",
    "country": "Россия",
    "searchString": "таборы (таборинский район) россия / свердловская область / таборы (таборинский район)"
  },
  "5765": {
    "id": "5765",
    "name": "Токарево (Свердловская область)",
    "path": "Россия / Свердловская область / Токарево (Свердловская область)",
    "country": "Россия",
    "searchString": "токарево (свердловская область) россия / свердловская область / токарево (свердловская область)"
  },
  "5766": {
    "id": "5766",
    "name": "Уралец",
    "path": "Россия / Свердловская область / Уралец",
    "country": "Россия",
    "searchString": "уралец россия / свердловская область / уралец"
  },
  "5767": {
    "id": "5767",
    "name": "Уральский (Свердловская область)",
    "path": "Россия / Свердловская область / Уральский (Свердловская область)",
    "country": "Россия",
    "searchString": "уральский (свердловская область) россия / свердловская область / уральский (свердловская область)"
  },
  "5768": {
    "id": "5768",
    "name": "Урмикеево",
    "path": "Россия / Свердловская область / Урмикеево",
    "country": "Россия",
    "searchString": "урмикеево россия / свердловская область / урмикеево"
  },
  "5769": {
    "id": "5769",
    "name": "Уфимский (Свердловская область)",
    "path": "Россия / Свердловская область / Уфимский (Свердловская область)",
    "country": "Россия",
    "searchString": "уфимский (свердловская область) россия / свердловская область / уфимский (свердловская область)"
  },
  "5770": {
    "id": "5770",
    "name": "Цементный (Свердловская область)",
    "path": "Россия / Свердловская область / Цементный (Свердловская область)",
    "country": "Россия",
    "searchString": "цементный (свердловская область) россия / свердловская область / цементный (свердловская область)"
  },
  "5771": {
    "id": "5771",
    "name": "Черданцево",
    "path": "Россия / Свердловская область / Черданцево",
    "country": "Россия",
    "searchString": "черданцево россия / свердловская область / черданцево"
  },
  "5773": {
    "id": "5773",
    "name": "Шайдурово (Свердловская область)",
    "path": "Россия / Свердловская область / Шайдурово (Свердловская область)",
    "country": "Россия",
    "searchString": "шайдурово (свердловская область) россия / свердловская область / шайдурово (свердловская область)"
  },
  "5774": {
    "id": "5774",
    "name": "Шамары (Свердловская область)",
    "path": "Россия / Свердловская область / Шамары (Свердловская область)",
    "country": "Россия",
    "searchString": "шамары (свердловская область) россия / свердловская область / шамары (свердловская область)"
  },
  "5775": {
    "id": "5775",
    "name": "Шиловка (Горноуральский городской округ)",
    "path": "Россия / Свердловская область / Шиловка (Горноуральский городской округ)",
    "country": "Россия",
    "searchString": "шиловка (горноуральский городской округ) россия / свердловская область / шиловка (горноуральский городской округ)"
  },
  "5776": {
    "id": "5776",
    "name": "Шувакиш",
    "path": "Россия / Свердловская область / Шувакиш",
    "country": "Россия",
    "searchString": "шувакиш россия / свердловская область / шувакиш"
  },
  "5777": {
    "id": "5777",
    "name": "Щелкун",
    "path": "Россия / Свердловская область / Щелкун",
    "country": "Россия",
    "searchString": "щелкун россия / свердловская область / щелкун"
  },
  "5778": {
    "id": "5778",
    "name": "Агаповка",
    "path": "Россия / Челябинская область / Агаповка",
    "country": "Россия",
    "searchString": "агаповка россия / челябинская область / агаповка"
  },
  "5779": {
    "id": "5779",
    "name": "Аргаяш",
    "path": "Россия / Челябинская область / Аргаяш",
    "country": "Россия",
    "searchString": "аргаяш россия / челябинская область / аргаяш"
  },
  "5780": {
    "id": "5780",
    "name": "Багаряк",
    "path": "Россия / Челябинская область / Багаряк",
    "country": "Россия",
    "searchString": "багаряк россия / челябинская область / багаряк"
  },
  "5781": {
    "id": "5781",
    "name": "Бердяуш",
    "path": "Россия / Челябинская область / Бердяуш",
    "country": "Россия",
    "searchString": "бердяуш россия / челябинская область / бердяуш"
  },
  "5782": {
    "id": "5782",
    "name": "Бобровка (Челябинская область)",
    "path": "Россия / Челябинская область / Бобровка (Челябинская область)",
    "country": "Россия",
    "searchString": "бобровка (челябинская область) россия / челябинская область / бобровка (челябинская область)"
  },
  "5783": {
    "id": "5783",
    "name": "Бродокалмак",
    "path": "Россия / Челябинская область / Бродокалмак",
    "country": "Россия",
    "searchString": "бродокалмак россия / челябинская область / бродокалмак"
  },
  "5784": {
    "id": "5784",
    "name": "Варна (Челябинская область)",
    "path": "Россия / Челябинская область / Варна (Челябинская область)",
    "country": "Россия",
    "searchString": "варна (челябинская область) россия / челябинская область / варна (челябинская область)"
  },
  "5785": {
    "id": "5785",
    "name": "Вишневогорск",
    "path": "Россия / Челябинская область / Вишневогорск",
    "country": "Россия",
    "searchString": "вишневогорск россия / челябинская область / вишневогорск"
  },
  "5786": {
    "id": "5786",
    "name": "Григорьевка (Челябинская область)",
    "path": "Россия / Челябинская область / Григорьевка (Челябинская область)",
    "country": "Россия",
    "searchString": "григорьевка (челябинская область) россия / челябинская область / григорьевка (челябинская область)"
  },
  "5787": {
    "id": "5787",
    "name": "Еманжелинка",
    "path": "Россия / Челябинская область / Еманжелинка",
    "country": "Россия",
    "searchString": "еманжелинка россия / челябинская область / еманжелинка"
  },
  "5788": {
    "id": "5788",
    "name": "Зауральский",
    "path": "Россия / Челябинская область / Зауральский",
    "country": "Россия",
    "searchString": "зауральский россия / челябинская область / зауральский"
  },
  "5789": {
    "id": "5789",
    "name": "Канашево",
    "path": "Россия / Челябинская область / Канашево",
    "country": "Россия",
    "searchString": "канашево россия / челябинская область / канашево"
  },
  "5790": {
    "id": "5790",
    "name": "Кизильское",
    "path": "Россия / Челябинская область / Кизильское",
    "country": "Россия",
    "searchString": "кизильское россия / челябинская область / кизильское"
  },
  "5791": {
    "id": "5791",
    "name": "Коелга",
    "path": "Россия / Челябинская область / Коелга",
    "country": "Россия",
    "searchString": "коелга россия / челябинская область / коелга"
  },
  "5792": {
    "id": "5792",
    "name": "Красногорский (Челябинская область)",
    "path": "Россия / Челябинская область / Красногорский (Челябинская область)",
    "country": "Россия",
    "searchString": "красногорский (челябинская область) россия / челябинская область / красногорский (челябинская область)"
  },
  "5793": {
    "id": "5793",
    "name": "Кременкуль",
    "path": "Россия / Челябинская область / Кременкуль",
    "country": "Россия",
    "searchString": "кременкуль россия / челябинская область / кременкуль"
  },
  "5794": {
    "id": "5794",
    "name": "Кропачево (Челябинская область)",
    "path": "Россия / Челябинская область / Кропачево (Челябинская область)",
    "country": "Россия",
    "searchString": "кропачево (челябинская область) россия / челябинская область / кропачево (челябинская область)"
  },
  "5795": {
    "id": "5795",
    "name": "Локомотивный (Челябинская область)",
    "path": "Россия / Челябинская область / Локомотивный (Челябинская область)",
    "country": "Россия",
    "searchString": "локомотивный (челябинская область) россия / челябинская область / локомотивный (челябинская область)"
  },
  "5796": {
    "id": "5796",
    "name": "Магнитка (Кусинский район)",
    "path": "Россия / Челябинская область / Магнитка (Кусинский район)",
    "country": "Россия",
    "searchString": "магнитка (кусинский район) россия / челябинская область / магнитка (кусинский район)"
  },
  "5797": {
    "id": "5797",
    "name": "Межевой (Саткинский район)",
    "path": "Россия / Челябинская область / Межевой (Саткинский район)",
    "country": "Россия",
    "searchString": "межевой (саткинский район) россия / челябинская область / межевой (саткинский район)"
  },
  "5798": {
    "id": "5798",
    "name": "Межозёрный (Челябинская область)",
    "path": "Россия / Челябинская область / Межозёрный (Челябинская область)",
    "country": "Россия",
    "searchString": "межозёрный (челябинская область) россия / челябинская область / межозёрный (челябинская область)"
  },
  "5799": {
    "id": "5799",
    "name": "Миасское",
    "path": "Россия / Челябинская область / Миасское",
    "country": "Россия",
    "searchString": "миасское россия / челябинская область / миасское"
  },
  "5800": {
    "id": "5800",
    "name": "Новогорный",
    "path": "Россия / Челябинская область / Новогорный",
    "country": "Россия",
    "searchString": "новогорный россия / челябинская область / новогорный"
  },
  "5801": {
    "id": "5801",
    "name": "Октябрьское (Челябинская область)",
    "path": "Россия / Челябинская область / Октябрьское (Челябинская область)",
    "country": "Россия",
    "searchString": "октябрьское (челябинская область) россия / челябинская область / октябрьское (челябинская область)"
  },
  "5802": {
    "id": "5802",
    "name": "Первомайский (Коркинский район)",
    "path": "Россия / Челябинская область / Первомайский (Коркинский район)",
    "country": "Россия",
    "searchString": "первомайский (коркинский район) россия / челябинская область / первомайский (коркинский район)"
  },
  "5803": {
    "id": "5803",
    "name": "Полетаево (Челябинская область)",
    "path": "Россия / Челябинская область / Полетаево (Челябинская область)",
    "country": "Россия",
    "searchString": "полетаево (челябинская область) россия / челябинская область / полетаево (челябинская область)"
  },
  "5804": {
    "id": "5804",
    "name": "Родники (Челябинская область)",
    "path": "Россия / Челябинская область / Родники (Челябинская область)",
    "country": "Россия",
    "searchString": "родники (челябинская область) россия / челябинская область / родники (челябинская область)"
  },
  "5805": {
    "id": "5805",
    "name": "Роза (Челябинская область)",
    "path": "Россия / Челябинская область / Роза (Челябинская область)",
    "country": "Россия",
    "searchString": "роза (челябинская область) россия / челябинская область / роза (челябинская область)"
  },
  "5806": {
    "id": "5806",
    "name": "Рощино (Челябинская область)",
    "path": "Россия / Челябинская область / Рощино (Челябинская область)",
    "country": "Россия",
    "searchString": "рощино (челябинская область) россия / челябинская область / рощино (челябинская область)"
  },
  "5807": {
    "id": "5807",
    "name": "Тимирязевский (Челябинская область)",
    "path": "Россия / Челябинская область / Тимирязевский (Челябинская область)",
    "country": "Россия",
    "searchString": "тимирязевский (челябинская область) россия / челябинская область / тимирязевский (челябинская область)"
  },
  "5808": {
    "id": "5808",
    "name": "Тургояк",
    "path": "Россия / Челябинская область / Тургояк",
    "country": "Россия",
    "searchString": "тургояк россия / челябинская область / тургояк"
  },
  "5809": {
    "id": "5809",
    "name": "Тюбук",
    "path": "Россия / Челябинская область / Тюбук",
    "country": "Россия",
    "searchString": "тюбук россия / челябинская область / тюбук"
  },
  "5810": {
    "id": "5810",
    "name": "Увельский",
    "path": "Россия / Челябинская область / Увельский",
    "country": "Россия",
    "searchString": "увельский россия / челябинская область / увельский"
  },
  "5811": {
    "id": "5811",
    "name": "Уйское (Челябинская область)",
    "path": "Россия / Челябинская область / Уйское (Челябинская область)",
    "country": "Россия",
    "searchString": "уйское (челябинская область) россия / челябинская область / уйское (челябинская область)"
  },
  "5812": {
    "id": "5812",
    "name": "Фершампенуаз (Челябинская область)",
    "path": "Россия / Челябинская область / Фершампенуаз (Челябинская область)",
    "country": "Россия",
    "searchString": "фершампенуаз (челябинская область) россия / челябинская область / фершампенуаз (челябинская область)"
  },
  "5813": {
    "id": "5813",
    "name": "Чесма",
    "path": "Россия / Челябинская область / Чесма",
    "country": "Россия",
    "searchString": "чесма россия / челябинская область / чесма"
  },
  "5814": {
    "id": "5814",
    "name": "Просвет (Курганская область)",
    "path": "Россия / Курганская область / Просвет (Курганская область)",
    "country": "Россия",
    "searchString": "просвет (курганская область) россия / курганская область / просвет (курганская область)"
  },
  "5815": {
    "id": "5815",
    "name": "Сиреневый (Курганская область)",
    "path": "Россия / Курганская область / Сиреневый (Курганская область)",
    "country": "Россия",
    "searchString": "сиреневый (курганская область) россия / курганская область / сиреневый (курганская область)"
  },
  "5816": {
    "id": "5816",
    "name": "Берёзовка (Берёзовский район, Пермский край)",
    "path": "Россия / Пермский край / Берёзовка (Берёзовский район, Пермский край)",
    "country": "Россия",
    "searchString": "берёзовка (берёзовский район, пермский край) россия / пермский край / берёзовка (берёзовский район, пермский край)"
  },
  "5817": {
    "id": "5817",
    "name": "Бершеть",
    "path": "Россия / Пермский край / Бершеть",
    "country": "Россия",
    "searchString": "бершеть россия / пермский край / бершеть"
  },
  "5818": {
    "id": "5818",
    "name": "Всеволодо-Вильва",
    "path": "Россия / Пермский край / Всеволодо-Вильва",
    "country": "Россия",
    "searchString": "всеволодо-вильва россия / пермский край / всеволодо-вильва"
  },
  "5819": {
    "id": "5819",
    "name": "Гайны (Пермский край)",
    "path": "Россия / Пермский край / Гайны (Пермский край)",
    "country": "Россия",
    "searchString": "гайны (пермский край) россия / пермский край / гайны (пермский край)"
  },
  "5820": {
    "id": "5820",
    "name": "Гамово (Пермский край)",
    "path": "Россия / Пермский край / Гамово (Пермский край)",
    "country": "Россия",
    "searchString": "гамово (пермский край) россия / пермский край / гамово (пермский край)"
  },
  "5821": {
    "id": "5821",
    "name": "Елово (Пермский край)",
    "path": "Россия / Пермский край / Елово (Пермский край)",
    "country": "Россия",
    "searchString": "елово (пермский край) россия / пермский край / елово (пермский край)"
  },
  "5822": {
    "id": "5822",
    "name": "Звёздный (Пермский край)",
    "path": "Россия / Пермский край / Звёздный (Пермский край)",
    "country": "Россия",
    "searchString": "звёздный (пермский край) россия / пермский край / звёздный (пермский край)"
  },
  "5823": {
    "id": "5823",
    "name": "Зюкайка",
    "path": "Россия / Пермский край / Зюкайка",
    "country": "Россия",
    "searchString": "зюкайка россия / пермский край / зюкайка"
  },
  "5824": {
    "id": "5824",
    "name": "Ильинский (Пермский край)",
    "path": "Россия / Пермский край / Ильинский (Пермский край)",
    "country": "Россия",
    "searchString": "ильинский (пермский край) россия / пермский край / ильинский (пермский край)"
  },
  "5825": {
    "id": "5825",
    "name": "Карагай (Пермский край)",
    "path": "Россия / Пермский край / Карагай (Пермский край)",
    "country": "Россия",
    "searchString": "карагай (пермский край) россия / пермский край / карагай (пермский край)"
  },
  "5826": {
    "id": "5826",
    "name": "Керчевский",
    "path": "Россия / Пермский край / Керчевский",
    "country": "Россия",
    "searchString": "керчевский россия / пермский край / керчевский"
  },
  "5827": {
    "id": "5827",
    "name": "Комсомольский (Кунгурский район, Пермский край)",
    "path": "Россия / Пермский край / Комсомольский (Кунгурский район, Пермский край)",
    "country": "Россия",
    "searchString": "комсомольский (кунгурский район, пермский край) россия / пермский край / комсомольский (кунгурский район, пермский край)"
  },
  "5828": {
    "id": "5828",
    "name": "Кондратово (Пермский край)",
    "path": "Россия / Пермский край / Кондратово (Пермский край)",
    "country": "Россия",
    "searchString": "кондратово (пермский край) россия / пермский край / кондратово (пермский край)"
  },
  "5829": {
    "id": "5829",
    "name": "Коса (Пермский край)",
    "path": "Россия / Пермский край / Коса (Пермский край)",
    "country": "Россия",
    "searchString": "коса (пермский край) россия / пермский край / коса (пермский край)"
  },
  "5830": {
    "id": "5830",
    "name": "Кочёво",
    "path": "Россия / Пермский край / Кочёво",
    "country": "Россия",
    "searchString": "кочёво россия / пермский край / кочёво"
  },
  "5831": {
    "id": "5831",
    "name": "Куеда",
    "path": "Россия / Пермский край / Куеда",
    "country": "Россия",
    "searchString": "куеда россия / пермский край / куеда"
  },
  "5832": {
    "id": "5832",
    "name": "Кукуштан",
    "path": "Россия / Пермский край / Кукуштан",
    "country": "Россия",
    "searchString": "кукуштан россия / пермский край / кукуштан"
  },
  "5833": {
    "id": "5833",
    "name": "Култаево",
    "path": "Россия / Пермский край / Култаево",
    "country": "Россия",
    "searchString": "култаево россия / пермский край / култаево"
  },
  "5834": {
    "id": "5834",
    "name": "Лобаново (Пермский край)",
    "path": "Россия / Пермский край / Лобаново (Пермский край)",
    "country": "Россия",
    "searchString": "лобаново (пермский край) россия / пермский край / лобаново (пермский край)"
  },
  "5835": {
    "id": "5835",
    "name": "Лямино (Пермский край)",
    "path": "Россия / Пермский край / Лямино (Пермский край)",
    "country": "Россия",
    "searchString": "лямино (пермский край) россия / пермский край / лямино (пермский край)"
  },
  "5836": {
    "id": "5836",
    "name": "Майкор",
    "path": "Россия / Пермский край / Майкор",
    "country": "Россия",
    "searchString": "майкор россия / пермский край / майкор"
  },
  "5837": {
    "id": "5837",
    "name": "Майский (Пермский край)",
    "path": "Россия / Пермский край / Майский (Пермский край)",
    "country": "Россия",
    "searchString": "майский (пермский край) россия / пермский край / майский (пермский край)"
  },
  "5838": {
    "id": "5838",
    "name": "Марковский (Пермский край)",
    "path": "Россия / Пермский край / Марковский (Пермский край)",
    "country": "Россия",
    "searchString": "марковский (пермский край) россия / пермский край / марковский (пермский край)"
  },
  "5839": {
    "id": "5839",
    "name": "Новоильинский (Пермский край)",
    "path": "Россия / Пермский край / Новоильинский (Пермский край)",
    "country": "Россия",
    "searchString": "новоильинский (пермский край) россия / пермский край / новоильинский (пермский край)"
  },
  "5840": {
    "id": "5840",
    "name": "Орда (Пермский край)",
    "path": "Россия / Пермский край / Орда (Пермский край)",
    "country": "Россия",
    "searchString": "орда (пермский край) россия / пермский край / орда (пермский край)"
  },
  "5841": {
    "id": "5841",
    "name": "Пашия",
    "path": "Россия / Пермский край / Пашия",
    "country": "Россия",
    "searchString": "пашия россия / пермский край / пашия"
  },
  "5842": {
    "id": "5842",
    "name": "Пожва",
    "path": "Россия / Пермский край / Пожва",
    "country": "Россия",
    "searchString": "пожва россия / пермский край / пожва"
  },
  "5843": {
    "id": "5843",
    "name": "Полазна",
    "path": "Россия / Пермский край / Полазна",
    "country": "Россия",
    "searchString": "полазна россия / пермский край / полазна"
  },
  "5844": {
    "id": "5844",
    "name": "Сарс",
    "path": "Россия / Пермский край / Сарс",
    "country": "Россия",
    "searchString": "сарс россия / пермский край / сарс"
  },
  "5845": {
    "id": "5845",
    "name": "Сива (Пермский край)",
    "path": "Россия / Пермский край / Сива (Пермский край)",
    "country": "Россия",
    "searchString": "сива (пермский край) россия / пермский край / сива (пермский край)"
  },
  "5846": {
    "id": "5846",
    "name": "Сылва (Пермский край)",
    "path": "Россия / Пермский край / Сылва (Пермский край)",
    "country": "Россия",
    "searchString": "сылва (пермский край) россия / пермский край / сылва (пермский край)"
  },
  "5847": {
    "id": "5847",
    "name": "Теплая Гора",
    "path": "Россия / Пермский край / Теплая Гора",
    "country": "Россия",
    "searchString": "теплая гора россия / пермский край / теплая гора"
  },
  "5848": {
    "id": "5848",
    "name": "Углеуральский",
    "path": "Россия / Пермский край / Углеуральский",
    "country": "Россия",
    "searchString": "углеуральский россия / пермский край / углеуральский"
  },
  "5849": {
    "id": "5849",
    "name": "Уинское",
    "path": "Россия / Пермский край / Уинское",
    "country": "Россия",
    "searchString": "уинское россия / пермский край / уинское"
  },
  "5850": {
    "id": "5850",
    "name": "Уральский (Пермский край)",
    "path": "Россия / Пермский край / Уральский (Пермский край)",
    "country": "Россия",
    "searchString": "уральский (пермский край) россия / пермский край / уральский (пермский край)"
  },
  "5851": {
    "id": "5851",
    "name": "Усть-Качка",
    "path": "Россия / Пермский край / Усть-Качка",
    "country": "Россия",
    "searchString": "усть-качка россия / пермский край / усть-качка"
  },
  "5852": {
    "id": "5852",
    "name": "Фоки",
    "path": "Россия / Пермский край / Фоки",
    "country": "Россия",
    "searchString": "фоки россия / пермский край / фоки"
  },
  "5853": {
    "id": "5853",
    "name": "Юрла",
    "path": "Россия / Пермский край / Юрла",
    "country": "Россия",
    "searchString": "юрла россия / пермский край / юрла"
  },
  "5854": {
    "id": "5854",
    "name": "Юсьва",
    "path": "Россия / Пермский край / Юсьва",
    "country": "Россия",
    "searchString": "юсьва россия / пермский край / юсьва"
  },
  "5855": {
    "id": "5855",
    "name": "Яйва",
    "path": "Россия / Пермский край / Яйва",
    "country": "Россия",
    "searchString": "яйва россия / пермский край / яйва"
  },
  "5856": {
    "id": "5856",
    "name": "Авдон",
    "path": "Россия / Республика Башкортостан / Авдон",
    "country": "Россия",
    "searchString": "авдон россия / республика башкортостан / авдон"
  },
  "5857": {
    "id": "5857",
    "name": "Акъяр (Хайбуллинский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Акъяр (Хайбуллинский район, Башкортостан)",
    "country": "Россия",
    "searchString": "акъяр (хайбуллинский район, башкортостан) россия / республика башкортостан / акъяр (хайбуллинский район, башкортостан)"
  },
  "5858": {
    "id": "5858",
    "name": "Алексеевка (Уфимский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Алексеевка (Уфимский район, Башкортостан)",
    "country": "Россия",
    "searchString": "алексеевка (уфимский район, башкортостан) россия / республика башкортостан / алексеевка (уфимский район, башкортостан)"
  },
  "5859": {
    "id": "5859",
    "name": "Алкино-2",
    "path": "Россия / Республика Башкортостан / Алкино-2",
    "country": "Россия",
    "searchString": "алкино-2 россия / республика башкортостан / алкино-2"
  },
  "5860": {
    "id": "5860",
    "name": "Амзя (Нефтекамск, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Амзя (Нефтекамск, Башкортостан)",
    "country": "Россия",
    "searchString": "амзя (нефтекамск, башкортостан) россия / республика башкортостан / амзя (нефтекамск, башкортостан)"
  },
  "5861": {
    "id": "5861",
    "name": "Дмитриевка (Уфимский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Дмитриевка (Уфимский район, Башкортостан)",
    "country": "Россия",
    "searchString": "дмитриевка (уфимский район, башкортостан) россия / республика башкортостан / дмитриевка (уфимский район, башкортостан)"
  },
  "5862": {
    "id": "5862",
    "name": "Дуван",
    "path": "Россия / Республика Башкортостан / Дуван",
    "country": "Россия",
    "searchString": "дуван россия / республика башкортостан / дуван"
  },
  "5863": {
    "id": "5863",
    "name": "Ермекеево",
    "path": "Россия / Республика Башкортостан / Ермекеево",
    "country": "Россия",
    "searchString": "ермекеево россия / республика башкортостан / ермекеево"
  },
  "5864": {
    "id": "5864",
    "name": "Ермолаево (Башкортостан)",
    "path": "Россия / Республика Башкортостан / Ермолаево (Башкортостан)",
    "country": "Россия",
    "searchString": "ермолаево (башкортостан) россия / республика башкортостан / ермолаево (башкортостан)"
  },
  "5865": {
    "id": "5865",
    "name": "Кабаково (Башкортостан)",
    "path": "Россия / Республика Башкортостан / Кабаково (Башкортостан)",
    "country": "Россия",
    "searchString": "кабаково (башкортостан) россия / республика башкортостан / кабаково (башкортостан)"
  },
  "5866": {
    "id": "5866",
    "name": "Калтасы (Калтасинский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Калтасы (Калтасинский район, Башкортостан)",
    "country": "Россия",
    "searchString": "калтасы (калтасинский район, башкортостан) россия / республика башкортостан / калтасы (калтасинский район, башкортостан)"
  },
  "5867": {
    "id": "5867",
    "name": "Красная Горка (Нуримановский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Красная Горка (Нуримановский район, Башкортостан)",
    "country": "Россия",
    "searchString": "красная горка (нуримановский район, башкортостан) россия / республика башкортостан / красная горка (нуримановский район, башкортостан)"
  },
  "5868": {
    "id": "5868",
    "name": "Куяново (Башкортостан)",
    "path": "Россия / Республика Башкортостан / Куяново (Башкортостан)",
    "country": "Россия",
    "searchString": "куяново (башкортостан) россия / республика башкортостан / куяново (башкортостан)"
  },
  "5869": {
    "id": "5869",
    "name": "Ломовка (Башкортостан)",
    "path": "Россия / Республика Башкортостан / Ломовка (Башкортостан)",
    "country": "Россия",
    "searchString": "ломовка (башкортостан) россия / республика башкортостан / ломовка (башкортостан)"
  },
  "5870": {
    "id": "5870",
    "name": "Мраково (Кугарчинский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Мраково (Кугарчинский район, Башкортостан)",
    "country": "Россия",
    "searchString": "мраково (кугарчинский район, башкортостан) россия / республика башкортостан / мраково (кугарчинский район, башкортостан)"
  },
  "5871": {
    "id": "5871",
    "name": "Маячный (Башкортостан)",
    "path": "Россия / Республика Башкортостан / Маячный (Башкортостан)",
    "country": "Россия",
    "searchString": "маячный (башкортостан) россия / республика башкортостан / маячный (башкортостан)"
  },
  "5872": {
    "id": "5872",
    "name": "Михайловка (Уфимский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Михайловка (Уфимский район, Башкортостан)",
    "country": "Россия",
    "searchString": "михайловка (уфимский район, башкортостан) россия / республика башкортостан / михайловка (уфимский район, башкортостан)"
  },
  "5873": {
    "id": "5873",
    "name": "Мишкино (Мишкинский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Мишкино (Мишкинский район, Башкортостан)",
    "country": "Россия",
    "searchString": "мишкино (мишкинский район, башкортостан) россия / республика башкортостан / мишкино (мишкинский район, башкортостан)"
  },
  "5874": {
    "id": "5874",
    "name": "Нижнетроицкий",
    "path": "Россия / Республика Башкортостан / Нижнетроицкий",
    "country": "Россия",
    "searchString": "нижнетроицкий россия / республика башкортостан / нижнетроицкий"
  },
  "5875": {
    "id": "5875",
    "name": "Николаевка (Благовещенский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Николаевка (Благовещенский район, Башкортостан)",
    "country": "Россия",
    "searchString": "николаевка (благовещенский район, башкортостан) россия / республика башкортостан / николаевка (благовещенский район, башкортостан)"
  },
  "5876": {
    "id": "5876",
    "name": "Николо-Березовка",
    "path": "Россия / Республика Башкортостан / Николо-Березовка",
    "country": "Россия",
    "searchString": "николо-березовка россия / республика башкортостан / николо-березовка"
  },
  "5877": {
    "id": "5877",
    "name": "Прогресс (Янаульский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Прогресс (Янаульский район, Башкортостан)",
    "country": "Россия",
    "searchString": "прогресс (янаульский район, башкортостан) россия / республика башкортостан / прогресс (янаульский район, башкортостан)"
  },
  "5878": {
    "id": "5878",
    "name": "Старосубхангулово",
    "path": "Россия / Республика Башкортостан / Старосубхангулово",
    "country": "Россия",
    "searchString": "старосубхангулово россия / республика башкортостан / старосубхангулово"
  },
  "5879": {
    "id": "5879",
    "name": "Темясово",
    "path": "Россия / Республика Башкортостан / Темясово",
    "country": "Россия",
    "searchString": "темясово россия / республика башкортостан / темясово"
  },
  "5880": {
    "id": "5880",
    "name": "Тирлянский",
    "path": "Россия / Республика Башкортостан / Тирлянский",
    "country": "Россия",
    "searchString": "тирлянский россия / республика башкортостан / тирлянский"
  },
  "5881": {
    "id": "5881",
    "name": "Улу-Теляк",
    "path": "Россия / Республика Башкортостан / Улу-Теляк",
    "country": "Россия",
    "searchString": "улу-теляк россия / республика башкортостан / улу-теляк"
  },
  "5882": {
    "id": "5882",
    "name": "Юмагузино (Кугарчинский район, Башкортостан)",
    "path": "Россия / Республика Башкортостан / Юмагузино (Кугарчинский район, Башкортостан)",
    "country": "Россия",
    "searchString": "юмагузино (кугарчинский район, башкортостан) россия / республика башкортостан / юмагузино (кугарчинский район, башкортостан)"
  },
  "5883": {
    "id": "5883",
    "name": "Андреевский (Тюменская область)",
    "path": "Россия / Тюменская область / Андреевский (Тюменская область)",
    "country": "Россия",
    "searchString": "андреевский (тюменская область) россия / тюменская область / андреевский (тюменская область)"
  },
  "5884": {
    "id": "5884",
    "name": "Демьянка (Тюменская область)",
    "path": "Россия / Тюменская область / Демьянка (Тюменская область)",
    "country": "Россия",
    "searchString": "демьянка (тюменская область) россия / тюменская область / демьянка (тюменская область)"
  },
  "5885": {
    "id": "5885",
    "name": "Мелиораторов (Тюменская область)",
    "path": "Россия / Тюменская область / Мелиораторов (Тюменская область)",
    "country": "Россия",
    "searchString": "мелиораторов (тюменская область) россия / тюменская область / мелиораторов (тюменская область)"
  },
  "5886": {
    "id": "5886",
    "name": "Новая Заимка",
    "path": "Россия / Тюменская область / Новая Заимка",
    "country": "Россия",
    "searchString": "новая заимка россия / тюменская область / новая заимка"
  },
  "5887": {
    "id": "5887",
    "name": "Новоселезнево",
    "path": "Россия / Тюменская область / Новоселезнево",
    "country": "Россия",
    "searchString": "новоселезнево россия / тюменская область / новоселезнево"
  },
  "5888": {
    "id": "5888",
    "name": "Петелино (Тюменская область)",
    "path": "Россия / Тюменская область / Петелино (Тюменская область)",
    "country": "Россия",
    "searchString": "петелино (тюменская область) россия / тюменская область / петелино (тюменская область)"
  },
  "5889": {
    "id": "5889",
    "name": "Сумкино (Тюменская область)",
    "path": "Россия / Тюменская область / Сумкино (Тюменская область)",
    "country": "Россия",
    "searchString": "сумкино (тюменская область) россия / тюменская область / сумкино (тюменская область)"
  },
  "5890": {
    "id": "5890",
    "name": "Тарманы",
    "path": "Россия / Тюменская область / Тарманы",
    "country": "Россия",
    "searchString": "тарманы россия / тюменская область / тарманы"
  },
  "5891": {
    "id": "5891",
    "name": "Локосово",
    "path": "Россия / Ханты-Мансийский АО - Югра / Локосово",
    "country": "Россия",
    "searchString": "локосово россия / ханты-мансийский ао - югра / локосово"
  },
  "5892": {
    "id": "5892",
    "name": "Мыс Каменный",
    "path": "Россия / Ямало-Ненецкий АО / Мыс Каменный",
    "country": "Россия",
    "searchString": "мыс каменный россия / ямало-ненецкий ао / мыс каменный"
  },
  "5893": {
    "id": "5893",
    "name": "Новый Порт",
    "path": "Россия / Ямало-Ненецкий АО / Новый Порт",
    "country": "Россия",
    "searchString": "новый порт россия / ямало-ненецкий ао / новый порт"
  },
  "5894": {
    "id": "5894",
    "name": "Ямбург (Ямало-Ненецкий АО)",
    "path": "Россия / Ямало-Ненецкий АО / Ямбург (Ямало-Ненецкий АО)",
    "country": "Россия",
    "searchString": "ямбург (ямало-ненецкий ао) россия / ямало-ненецкий ао / ямбург (ямало-ненецкий ао)"
  },
  "5895": {
    "id": "5895",
    "name": "Тулюшка",
    "path": "Россия / Иркутская область / Тулюшка",
    "country": "Россия",
    "searchString": "тулюшка россия / иркутская область / тулюшка"
  },
  "5896": {
    "id": "5896",
    "name": "Гусь-Железный",
    "path": "Россия / Рязанская область / Гусь-Железный",
    "country": "Россия",
    "searchString": "гусь-железный россия / рязанская область / гусь-железный"
  },
  "5897": {
    "id": "5897",
    "name": "Павелец",
    "path": "Россия / Рязанская область / Павелец",
    "country": "Россия",
    "searchString": "павелец россия / рязанская область / павелец"
  },
  "5898": {
    "id": "5898",
    "name": "Пителино",
    "path": "Россия / Рязанская область / Пителино",
    "country": "Россия",
    "searchString": "пителино россия / рязанская область / пителино"
  },
  "5899": {
    "id": "5899",
    "name": "Центральный (Рязанская область)",
    "path": "Россия / Рязанская область / Центральный (Рязанская область)",
    "country": "Россия",
    "searchString": "центральный (рязанская область) россия / рязанская область / центральный (рязанская область)"
  },
  "5900": {
    "id": "5900",
    "name": "Искра (Рязанский район)",
    "path": "Россия / Рязанская область / Искра (Рязанский район)",
    "country": "Россия",
    "searchString": "искра (рязанский район) россия / рязанская область / искра (рязанский район)"
  },
  "5901": {
    "id": "5901",
    "name": "Крутоярский (Рязанская область)",
    "path": "Россия / Рязанская область / Крутоярский (Рязанская область)",
    "country": "Россия",
    "searchString": "крутоярский (рязанская область) россия / рязанская область / крутоярский (рязанская область)"
  },
  "5902": {
    "id": "5902",
    "name": "Кустаревка (Рязанская область)",
    "path": "Россия / Рязанская область / Кустаревка (Рязанская область)",
    "country": "Россия",
    "searchString": "кустаревка (рязанская область) россия / рязанская область / кустаревка (рязанская область)"
  },
  "5903": {
    "id": "5903",
    "name": "Денежниково (Рязанская область)",
    "path": "Россия / Рязанская область / Денежниково (Рязанская область)",
    "country": "Россия",
    "searchString": "денежниково (рязанская область) россия / рязанская область / денежниково (рязанская область)"
  },
  "5904": {
    "id": "5904",
    "name": "Подвязье (Рязанская область)",
    "path": "Россия / Рязанская область / Подвязье (Рязанская область)",
    "country": "Россия",
    "searchString": "подвязье (рязанская область) россия / рязанская область / подвязье (рязанская область)"
  },
  "5905": {
    "id": "5905",
    "name": "Придорожный (Рязанская область)",
    "path": "Россия / Рязанская область / Придорожный (Рязанская область)",
    "country": "Россия",
    "searchString": "придорожный (рязанская область) россия / рязанская область / придорожный (рязанская область)"
  },
  "5906": {
    "id": "5906",
    "name": "Алёшино (Сасовский район)",
    "path": "Россия / Рязанская область / Алёшино (Сасовский район)",
    "country": "Россия",
    "searchString": "алёшино (сасовский район) россия / рязанская область / алёшино (сасовский район)"
  },
  "5907": {
    "id": "5907",
    "name": "Баграмово",
    "path": "Россия / Рязанская область / Баграмово",
    "country": "Россия",
    "searchString": "баграмово россия / рязанская область / баграмово"
  },
  "5908": {
    "id": "5908",
    "name": "Меньшие Можары",
    "path": "Россия / Рязанская область / Меньшие Можары",
    "country": "Россия",
    "searchString": "меньшие можары россия / рязанская область / меньшие можары"
  },
  "5909": {
    "id": "5909",
    "name": "Грязное (Рязанская область)",
    "path": "Россия / Рязанская область / Грязное (Рязанская область)",
    "country": "Россия",
    "searchString": "грязное (рязанская область) россия / рязанская область / грязное (рязанская область)"
  },
  "5910": {
    "id": "5910",
    "name": "Инякино",
    "path": "Россия / Рязанская область / Инякино",
    "country": "Россия",
    "searchString": "инякино россия / рязанская область / инякино"
  },
  "5911": {
    "id": "5911",
    "name": "Истье (Рязанская область)",
    "path": "Россия / Рязанская область / Истье (Рязанская область)",
    "country": "Россия",
    "searchString": "истье (рязанская область) россия / рязанская область / истье (рязанская область)"
  },
  "5912": {
    "id": "5912",
    "name": "Кирицы",
    "path": "Россия / Рязанская область / Кирицы",
    "country": "Россия",
    "searchString": "кирицы россия / рязанская область / кирицы"
  },
  "5913": {
    "id": "5913",
    "name": "Криуша (Рязанская область)",
    "path": "Россия / Рязанская область / Криуша (Рязанская область)",
    "country": "Россия",
    "searchString": "криуша (рязанская область) россия / рязанская область / криуша (рязанская область)"
  },
  "5914": {
    "id": "5914",
    "name": "Кузьминское (Рязанская область)",
    "path": "Россия / Рязанская область / Кузьминское (Рязанская область)",
    "country": "Россия",
    "searchString": "кузьминское (рязанская область) россия / рязанская область / кузьминское (рязанская область)"
  },
  "5915": {
    "id": "5915",
    "name": "Лакаш",
    "path": "Россия / Рязанская область / Лакаш",
    "country": "Россия",
    "searchString": "лакаш россия / рязанская область / лакаш"
  },
  "5916": {
    "id": "5916",
    "name": "Лесное Конобеево",
    "path": "Россия / Рязанская область / Лесное Конобеево",
    "country": "Россия",
    "searchString": "лесное конобеево россия / рязанская область / лесное конобеево"
  },
  "5917": {
    "id": "5917",
    "name": "Льгово (Рязанская область)",
    "path": "Россия / Рязанская область / Льгово (Рязанская область)",
    "country": "Россия",
    "searchString": "льгово (рязанская область) россия / рязанская область / льгово (рязанская область)"
  },
  "5918": {
    "id": "5918",
    "name": "Мосолово (Рязанская область, Шиловский район)",
    "path": "Россия / Рязанская область / Мосолово (Рязанская область, Шиловский район)",
    "country": "Россия",
    "searchString": "мосолово (рязанская область, шиловский район) россия / рязанская область / мосолово (рязанская область, шиловский район)"
  },
  "5919": {
    "id": "5919",
    "name": "Новый Киструс",
    "path": "Россия / Рязанская область / Новый Киструс",
    "country": "Россия",
    "searchString": "новый киструс россия / рязанская область / новый киструс"
  },
  "5920": {
    "id": "5920",
    "name": "Сасыкино",
    "path": "Россия / Рязанская область / Сасыкино",
    "country": "Россия",
    "searchString": "сасыкино россия / рязанская область / сасыкино"
  },
  "5921": {
    "id": "5921",
    "name": "Сотницыно",
    "path": "Россия / Рязанская область / Сотницыно",
    "country": "Россия",
    "searchString": "сотницыно россия / рязанская область / сотницыно"
  },
  "5922": {
    "id": "5922",
    "name": "Старое Березово",
    "path": "Россия / Рязанская область / Старое Березово",
    "country": "Россия",
    "searchString": "старое березово россия / рязанская область / старое березово"
  },
  "5923": {
    "id": "5923",
    "name": "Троица (Рязанская область)",
    "path": "Россия / Рязанская область / Троица (Рязанская область)",
    "country": "Россия",
    "searchString": "троица (рязанская область) россия / рязанская область / троица (рязанская область)"
  },
  "5924": {
    "id": "5924",
    "name": "Чернава (Рязанская область, Милославский район)",
    "path": "Россия / Рязанская область / Чернава (Рязанская область, Милославский район)",
    "country": "Россия",
    "searchString": "чернава (рязанская область, милославский район) россия / рязанская область / чернава (рязанская область, милославский район)"
  },
  "5925": {
    "id": "5925",
    "name": "Чулково (Рязанская область)",
    "path": "Россия / Рязанская область / Чулково (Рязанская область)",
    "country": "Россия",
    "searchString": "чулково (рязанская область) россия / рязанская область / чулково (рязанская область)"
  },
  "5926": {
    "id": "5926",
    "name": "Аргамаково (Рязанская область)",
    "path": "Россия / Рязанская область / Аргамаково (Рязанская область)",
    "country": "Россия",
    "searchString": "аргамаково (рязанская область) россия / рязанская область / аргамаково (рязанская область)"
  },
  "5927": {
    "id": "5927",
    "name": "Мирный (Брянская область, Гордеевский район)",
    "path": "Россия / Брянская область / Мирный (Брянская область, Гордеевский район)",
    "country": "Россия",
    "searchString": "мирный (брянская область, гордеевский район) россия / брянская область / мирный (брянская область, гордеевский район)"
  },
  "5928": {
    "id": "5928",
    "name": "Гобики",
    "path": "Россия / Брянская область / Гобики",
    "country": "Россия",
    "searchString": "гобики россия / брянская область / гобики"
  },
  "5929": {
    "id": "5929",
    "name": "Вышков (Брянская область)",
    "path": "Россия / Брянская область / Вышков (Брянская область)",
    "country": "Россия",
    "searchString": "вышков (брянская область) россия / брянская область / вышков (брянская область)"
  },
  "5930": {
    "id": "5930",
    "name": "Синезерки",
    "path": "Россия / Брянская область / Синезерки",
    "country": "Россия",
    "searchString": "синезерки россия / брянская область / синезерки"
  },
  "5931": {
    "id": "5931",
    "name": "Алтухово (Брянская область)",
    "path": "Россия / Брянская область / Алтухово (Брянская область)",
    "country": "Россия",
    "searchString": "алтухово (брянская область) россия / брянская область / алтухово (брянская область)"
  },
  "5932": {
    "id": "5932",
    "name": "Кокоревка",
    "path": "Россия / Брянская область / Кокоревка",
    "country": "Россия",
    "searchString": "кокоревка россия / брянская область / кокоревка"
  },
  "5933": {
    "id": "5933",
    "name": "Лопандино",
    "path": "Россия / Брянская область / Лопандино",
    "country": "Россия",
    "searchString": "лопандино россия / брянская область / лопандино"
  },
  "5934": {
    "id": "5934",
    "name": "Мичуринский (Брянская область)",
    "path": "Россия / Брянская область / Мичуринский (Брянская область)",
    "country": "Россия",
    "searchString": "мичуринский (брянская область) россия / брянская область / мичуринский (брянская область)"
  },
  "5935": {
    "id": "5935",
    "name": "Слободище (Брянская область)",
    "path": "Россия / Брянская область / Слободище (Брянская область)",
    "country": "Россия",
    "searchString": "слободище (брянская область) россия / брянская область / слободище (брянская область)"
  },
  "5936": {
    "id": "5936",
    "name": "Овстуг",
    "path": "Россия / Брянская область / Овстуг",
    "country": "Россия",
    "searchString": "овстуг россия / брянская область / овстуг"
  },
  "5937": {
    "id": "5937",
    "name": "Старые Бобовичи",
    "path": "Россия / Брянская область / Старые Бобовичи",
    "country": "Россия",
    "searchString": "старые бобовичи россия / брянская область / старые бобовичи"
  },
  "5938": {
    "id": "5938",
    "name": "Чуровичи",
    "path": "Россия / Брянская область / Чуровичи",
    "country": "Россия",
    "searchString": "чуровичи россия / брянская область / чуровичи"
  },
  "5939": {
    "id": "5939",
    "name": "Новый Ропск",
    "path": "Россия / Брянская область / Новый Ропск",
    "country": "Россия",
    "searchString": "новый ропск россия / брянская область / новый ропск"
  },
  "5940": {
    "id": "5940",
    "name": "Троебортное",
    "path": "Россия / Брянская область / Троебортное",
    "country": "Россия",
    "searchString": "троебортное россия / брянская область / троебортное"
  },
  "5941": {
    "id": "5941",
    "name": "Глоднево (Брянская область)",
    "path": "Россия / Брянская область / Глоднево (Брянская область)",
    "country": "Россия",
    "searchString": "глоднево (брянская область) россия / брянская область / глоднево (брянская область)"
  },
  "5942": {
    "id": "5942",
    "name": "Баклань (Брянская область)",
    "path": "Россия / Брянская область / Баклань (Брянская область)",
    "country": "Россия",
    "searchString": "баклань (брянская область) россия / брянская область / баклань (брянская область)"
  },
  "5943": {
    "id": "5943",
    "name": "Нивное (Брянская область)",
    "path": "Россия / Брянская область / Нивное (Брянская область)",
    "country": "Россия",
    "searchString": "нивное (брянская область) россия / брянская область / нивное (брянская область)"
  },
  "5944": {
    "id": "5944",
    "name": "Меленск",
    "path": "Россия / Брянская область / Меленск",
    "country": "Россия",
    "searchString": "меленск россия / брянская область / меленск"
  },
  "5945": {
    "id": "5945",
    "name": "Мишковка (Брянская область)",
    "path": "Россия / Брянская область / Мишковка (Брянская область)",
    "country": "Россия",
    "searchString": "мишковка (брянская область) россия / брянская область / мишковка (брянская область)"
  },
  "5946": {
    "id": "5946",
    "name": "Десятуха",
    "path": "Россия / Брянская область / Десятуха",
    "country": "Россия",
    "searchString": "десятуха россия / брянская область / десятуха"
  },
  "5947": {
    "id": "5947",
    "name": "Епифань",
    "path": "Россия / Тульская область / Епифань",
    "country": "Россия",
    "searchString": "епифань россия / тульская область / епифань"
  },
  "5948": {
    "id": "5948",
    "name": "Головеньковский",
    "path": "Россия / Тульская область / Головеньковский",
    "country": "Россия",
    "searchString": "головеньковский россия / тульская область / головеньковский"
  },
  "5949": {
    "id": "5949",
    "name": "Лазарево (Тульская область)",
    "path": "Россия / Тульская область / Лазарево (Тульская область)",
    "country": "Россия",
    "searchString": "лазарево (тульская область) россия / тульская область / лазарево (тульская область)"
  },
  "5950": {
    "id": "5950",
    "name": "Крапивна (Тульская область)",
    "path": "Россия / Тульская область / Крапивна (Тульская область)",
    "country": "Россия",
    "searchString": "крапивна (тульская область) россия / тульская область / крапивна (тульская область)"
  },
  "5951": {
    "id": "5951",
    "name": "Молочные Дворы",
    "path": "Россия / Тульская область / Молочные Дворы",
    "country": "Россия",
    "searchString": "молочные дворы россия / тульская область / молочные дворы"
  },
  "5952": {
    "id": "5952",
    "name": "Мордвес",
    "path": "Россия / Тульская область / Мордвес",
    "country": "Россия",
    "searchString": "мордвес россия / тульская область / мордвес"
  },
  "5953": {
    "id": "5953",
    "name": "Центральный (Тульская область, Суворовский район)",
    "path": "Россия / Тульская область / Центральный (Тульская область, Суворовский район)",
    "country": "Россия",
    "searchString": "центральный (тульская область, суворовский район) россия / тульская область / центральный (тульская область, суворовский район)"
  },
  "5954": {
    "id": "5954",
    "name": "Черепеть",
    "path": "Россия / Тульская область / Черепеть",
    "country": "Россия",
    "searchString": "черепеть россия / тульская область / черепеть"
  },
  "5955": {
    "id": "5955",
    "name": "Славный (Тульская область)",
    "path": "Россия / Тульская область / Славный (Тульская область)",
    "country": "Россия",
    "searchString": "славный (тульская область) россия / тульская область / славный (тульская область)"
  },
  "5956": {
    "id": "5956",
    "name": "Карамышево (Тульская область, Щёкинский район)",
    "path": "Россия / Тульская область / Карамышево (Тульская область, Щёкинский район)",
    "country": "Россия",
    "searchString": "карамышево (тульская область, щёкинский район) россия / тульская область / карамышево (тульская область, щёкинский район)"
  },
  "5957": {
    "id": "5957",
    "name": "Воскресенское (Тульская область, Дубенский район)",
    "path": "Россия / Тульская область / Воскресенское (Тульская область, Дубенский район)",
    "country": "Россия",
    "searchString": "воскресенское (тульская область, дубенский район) россия / тульская область / воскресенское (тульская область, дубенский район)"
  },
  "5958": {
    "id": "5958",
    "name": "Архангельское (Тульская область, Каменский район)",
    "path": "Россия / Тульская область / Архангельское (Тульская область, Каменский район)",
    "country": "Россия",
    "searchString": "архангельское (тульская область, каменский район) россия / тульская область / архангельское (тульская область, каменский район)"
  },
  "5959": {
    "id": "5959",
    "name": "Гремячее (Тульская область)",
    "path": "Россия / Тульская область / Гремячее (Тульская область)",
    "country": "Россия",
    "searchString": "гремячее (тульская область) россия / тульская область / гремячее (тульская область)"
  },
  "5960": {
    "id": "5960",
    "name": "Развилка (Московская область)",
    "path": "Россия / Московская область / Развилка (Московская область)",
    "country": "Россия",
    "searchString": "развилка (московская область) россия / московская область / развилка (московская область)"
  },
  "5961": {
    "id": "5961",
    "name": "Белоомут (Московская область)",
    "path": "Россия / Московская область / Белоомут (Московская область)",
    "country": "Россия",
    "searchString": "белоомут (московская область) россия / московская область / белоомут (московская область)"
  },
  "5962": {
    "id": "5962",
    "name": "Михнево (Московская область, Ступинский район)",
    "path": "Россия / Московская область / Михнево (Московская область, Ступинский район)",
    "country": "Россия",
    "searchString": "михнево (московская область, ступинский район) россия / московская область / михнево (московская область, ступинский район)"
  },
  "5963": {
    "id": "5963",
    "name": "Запрудня (Московская область)",
    "path": "Россия / Московская область / Запрудня (Московская область)",
    "country": "Россия",
    "searchString": "запрудня (московская область) россия / московская область / запрудня (московская область)"
  },
  "5964": {
    "id": "5964",
    "name": "посёлок Биокомбината (Московская область)",
    "path": "Россия / Московская область / посёлок Биокомбината (Московская область)",
    "country": "Россия",
    "searchString": "посёлок биокомбината (московская область) россия / московская область / посёлок биокомбината (московская область)"
  },
  "5965": {
    "id": "5965",
    "name": "Медвежьи Озёра (Московская область)",
    "path": "Россия / Московская область / Медвежьи Озёра (Московская область)",
    "country": "Россия",
    "searchString": "медвежьи озёра (московская область) россия / московская область / медвежьи озёра (московская область)"
  },
  "5966": {
    "id": "5966",
    "name": "Черкизово (Московская область, Пушкинский район)",
    "path": "Россия / Московская область / Черкизово (Московская область, Пушкинский район)",
    "country": "Россия",
    "searchString": "черкизово (московская область, пушкинский район) россия / московская область / черкизово (московская область, пушкинский район)"
  },
  "5967": {
    "id": "5967",
    "name": "Правдинский (Московская область)",
    "path": "Россия / Московская область / Правдинский (Московская область)",
    "country": "Россия",
    "searchString": "правдинский (московская область) россия / московская область / правдинский (московская область)"
  },
  "5968": {
    "id": "5968",
    "name": "Ашукино (Московская область)",
    "path": "Россия / Московская область / Ашукино (Московская область)",
    "country": "Россия",
    "searchString": "ашукино (московская область) россия / московская область / ашукино (московская область)"
  },
  "5969": {
    "id": "5969",
    "name": "Зверосовхоз (Московская область)",
    "path": "Россия / Московская область / Зверосовхоз (Московская область)",
    "country": "Россия",
    "searchString": "зверосовхоз (московская область) россия / московская область / зверосовхоз (московская область)"
  },
  "5970": {
    "id": "5970",
    "name": "Лесной (Московская область, Пушкинский район)",
    "path": "Россия / Московская область / Лесной (Московская область, Пушкинский район)",
    "country": "Россия",
    "searchString": "лесной (московская область, пушкинский район) россия / московская область / лесной (московская область, пушкинский район)"
  },
  "5971": {
    "id": "5971",
    "name": "Лесные Поляны (Московская область, Пушкинский район)",
    "path": "Россия / Московская область / Лесные Поляны (Московская область, Пушкинский район)",
    "country": "Россия",
    "searchString": "лесные поляны (московская область, пушкинский район) россия / московская область / лесные поляны (московская область, пушкинский район)"
  },
  "5972": {
    "id": "5972",
    "name": "Малаховка (Московская область)",
    "path": "Россия / Московская область / Малаховка (Московская область)",
    "country": "Россия",
    "searchString": "малаховка (московская область) россия / московская область / малаховка (московская область)"
  },
  "5973": {
    "id": "5973",
    "name": "Речицы (Московская область, Раменский район)",
    "path": "Россия / Московская область / Речицы (Московская область, Раменский район)",
    "country": "Россия",
    "searchString": "речицы (московская область, раменский район) россия / московская область / речицы (московская область, раменский район)"
  },
  "5974": {
    "id": "5974",
    "name": "Электроизолятор (Московская область)",
    "path": "Россия / Московская область / Электроизолятор (Московская область)",
    "country": "Россия",
    "searchString": "электроизолятор (московская область) россия / московская область / электроизолятор (московская область)"
  },
  "5975": {
    "id": "5975",
    "name": "Удельная (Московская область)",
    "path": "Россия / Московская область / Удельная (Московская область)",
    "country": "Россия",
    "searchString": "удельная (московская область) россия / московская область / удельная (московская область)"
  },
  "5976": {
    "id": "5976",
    "name": "Авсюнино (Московская область)",
    "path": "Россия / Московская область / Авсюнино (Московская область)",
    "country": "Россия",
    "searchString": "авсюнино (московская область) россия / московская область / авсюнино (московская область)"
  },
  "5977": {
    "id": "5977",
    "name": "Большие Дворы  (Московская область)",
    "path": "Россия / Московская область / Большие Дворы  (Московская область)",
    "country": "Россия",
    "searchString": "большие дворы  (московская область) россия / московская область / большие дворы  (московская область)"
  },
  "5978": {
    "id": "5978",
    "name": "Шувое (Московская область)",
    "path": "Россия / Московская область / Шувое (Московская область)",
    "country": "Россия",
    "searchString": "шувое (московская область) россия / московская область / шувое (московская область)"
  },
  "5979": {
    "id": "5979",
    "name": "Шатурторф (Московская область)",
    "path": "Россия / Московская область / Шатурторф (Московская область)",
    "country": "Россия",
    "searchString": "шатурторф (московская область) россия / московская область / шатурторф (московская область)"
  },
  "5980": {
    "id": "5980",
    "name": "Радовицкий (Московская область)",
    "path": "Россия / Московская область / Радовицкий (Московская область)",
    "country": "Россия",
    "searchString": "радовицкий (московская область) россия / московская область / радовицкий (московская область)"
  },
  "5981": {
    "id": "5981",
    "name": "Мишеронский (Московская область)",
    "path": "Россия / Московская область / Мишеронский (Московская область)",
    "country": "Россия",
    "searchString": "мишеронский (московская область) россия / московская область / мишеронский (московская область)"
  },
  "5982": {
    "id": "5982",
    "name": "Черусти (Московская область)",
    "path": "Россия / Московская область / Черусти (Московская область)",
    "country": "Россия",
    "searchString": "черусти (московская область) россия / московская область / черусти (московская область)"
  },
  "5983": {
    "id": "5983",
    "name": "Островцы (Московская область)",
    "path": "Россия / Московская область / Островцы (Московская область)",
    "country": "Россия",
    "searchString": "островцы (московская область) россия / московская область / островцы (московская область)"
  },
  "5984": {
    "id": "5984",
    "name": "Чёрное (Московская область)",
    "path": "Россия / Московская область / Чёрное (Московская область)",
    "country": "Россия",
    "searchString": "чёрное (московская область) россия / московская область / чёрное (московская область)"
  },
  "5985": {
    "id": "5985",
    "name": "Большое Буньково  (Московская область)",
    "path": "Россия / Московская область / Большое Буньково  (Московская область)",
    "country": "Россия",
    "searchString": "большое буньково  (московская область) россия / московская область / большое буньково  (московская область)"
  },
  "5986": {
    "id": "5986",
    "name": "Демихово (Московская область, Орехово-Зуевский район)",
    "path": "Россия / Московская область / Демихово (Московская область, Орехово-Зуевский район)",
    "country": "Россия",
    "searchString": "демихово (московская область, орехово-зуевский район) россия / московская область / демихово (московская область, орехово-зуевский район)"
  },
  "5987": {
    "id": "5987",
    "name": "Давыдово (Московская область, Орехово-Зуевский район)",
    "path": "Россия / Московская область / Давыдово (Московская область, Орехово-Зуевский район)",
    "country": "Россия",
    "searchString": "давыдово (московская область, орехово-зуевский район) россия / московская область / давыдово (московская область, орехово-зуевский район)"
  },
  "5988": {
    "id": "5988",
    "name": "Михали (Московская область, городской округ Егорьевск)",
    "path": "Россия / Московская область / Михали (Московская область, городской округ Егорьевск)",
    "country": "Россия",
    "searchString": "михали (московская область, городской округ егорьевск) россия / московская область / михали (московская область, городской округ егорьевск)"
  },
  "5989": {
    "id": "5989",
    "name": "Юрцово (Московская область, городской округ Егорьевск)",
    "path": "Россия / Московская область / Юрцово (Московская область, городской округ Егорьевск)",
    "country": "Россия",
    "searchString": "юрцово (московская область, городской округ егорьевск) россия / московская область / юрцово (московская область, городской округ егорьевск)"
  },
  "5990": {
    "id": "5990",
    "name": "Раменки (Московская область)",
    "path": "Россия / Московская область / Раменки (Московская область)",
    "country": "Россия",
    "searchString": "раменки (московская область) россия / московская область / раменки (московская область)"
  },
  "5991": {
    "id": "5991",
    "name": "Кривандино (Московская область)",
    "path": "Россия / Московская область / Кривандино (Московская область)",
    "country": "Россия",
    "searchString": "кривандино (московская область) россия / московская область / кривандино (московская область)"
  },
  "5992": {
    "id": "5992",
    "name": "Дмитровский Погост  (Московская область)",
    "path": "Россия / Московская область / Дмитровский Погост  (Московская область)",
    "country": "Россия",
    "searchString": "дмитровский погост  (московская область) россия / московская область / дмитровский погост  (московская область)"
  },
  "5993": {
    "id": "5993",
    "name": "Пышлицы (Московская область)",
    "path": "Россия / Московская область / Пышлицы (Московская область)",
    "country": "Россия",
    "searchString": "пышлицы (московская область) россия / московская область / пышлицы (московская область)"
  },
  "5994": {
    "id": "5994",
    "name": "Овощной (Ростовская область)",
    "path": "Россия / Ростовская область / Овощной (Ростовская область)",
    "country": "Россия",
    "searchString": "овощной (ростовская область) россия / ростовская область / овощной (ростовская область)"
  },
  "5995": {
    "id": "5995",
    "name": "Новониколаевка (Ростовская область, Азовский район)",
    "path": "Россия / Ростовская область / Новониколаевка (Ростовская область, Азовский район)",
    "country": "Россия",
    "searchString": "новониколаевка (ростовская область, азовский район) россия / ростовская область / новониколаевка (ростовская область, азовский район)"
  },
  "5996": {
    "id": "5996",
    "name": "Песчаный (Ростовская область)",
    "path": "Россия / Ростовская область / Песчаный (Ростовская область)",
    "country": "Россия",
    "searchString": "песчаный (ростовская область) россия / ростовская область / песчаный (ростовская область)"
  },
  "5997": {
    "id": "5997",
    "name": "Починки (Московская область, городской округ Егорьевск)",
    "path": "Россия / Московская область / Починки (Московская область, городской округ Егорьевск)",
    "country": "Россия",
    "searchString": "починки (московская область, городской округ егорьевск) россия / московская область / починки (московская область, городской округ егорьевск)"
  },
  "5998": {
    "id": "5998",
    "name": "Поповская (Московская область)",
    "path": "Россия / Московская область / Поповская (Московская область)",
    "country": "Россия",
    "searchString": "поповская (московская область) россия / московская область / поповская (московская область)"
  },
  "5999": {
    "id": "5999",
    "name": "Шатск",
    "path": "Россия / Тульская область / Шатск",
    "country": "Россия",
    "searchString": "шатск россия / тульская область / шатск"
  },
  "6000": {
    "id": "6000",
    "name": "Ясная Поляна (Тульская область)",
    "path": "Россия / Тульская область / Ясная Поляна (Тульская область)",
    "country": "Россия",
    "searchString": "ясная поляна (тульская область) россия / тульская область / ясная поляна (тульская область)"
  },
  "6001": {
    "id": "6001",
    "name": "Комсомольский (Республика Мордовия)",
    "path": "Россия / Республика Мордовия / Комсомольский (Республика Мордовия)",
    "country": "Россия",
    "searchString": "комсомольский (республика мордовия) россия / республика мордовия / комсомольский (республика мордовия)"
  },
  "6002": {
    "id": "6002",
    "name": "Новокуровка (Хабаровский край)",
    "path": "Россия / Хабаровский край / Новокуровка (Хабаровский край)",
    "country": "Россия",
    "searchString": "новокуровка (хабаровский край) россия / хабаровский край / новокуровка (хабаровский край)"
  },
  "6003": {
    "id": "6003",
    "name": "Чёрная Речка (Хабаровский край)",
    "path": "Россия / Хабаровский край / Чёрная Речка (Хабаровский край)",
    "country": "Россия",
    "searchString": "чёрная речка (хабаровский край) россия / хабаровский край / чёрная речка (хабаровский край)"
  },
  "6004": {
    "id": "6004",
    "name": "Большой Уссурийский",
    "path": "Россия / Хабаровский край / Большой Уссурийский",
    "country": "Россия",
    "searchString": "большой уссурийский россия / хабаровский край / большой уссурийский"
  },
  "6005": {
    "id": "6005",
    "name": "Кадино (Могилевская область)",
    "path": "Беларусь / Могилевская область / Кадино (Могилевская область)",
    "country": "Беларусь",
    "searchString": "кадино (могилевская область) беларусь / могилевская область / кадино (могилевская область)"
  },
  "6006": {
    "id": "6006",
    "name": "Лесной (Минская область)",
    "path": "Беларусь / Минская область / Лесной (Минская область)",
    "country": "Беларусь",
    "searchString": "лесной (минская область) беларусь / минская область / лесной (минская область)"
  },
  "6007": {
    "id": "6007",
    "name": "Телеханы",
    "path": "Беларусь / Брестская область / Телеханы",
    "country": "Беларусь",
    "searchString": "телеханы беларусь / брестская область / телеханы"
  },
  "6008": {
    "id": "6008",
    "name": "Ванавара",
    "path": "Россия / Красноярский край / Ванавара",
    "country": "Россия",
    "searchString": "ванавара россия / красноярский край / ванавара"
  },
  "6009": {
    "id": "6009",
    "name": "Волжский (Самарская область)",
    "path": "Россия / Самарская область / Волжский (Самарская область)",
    "country": "Россия",
    "searchString": "волжский (самарская область) россия / самарская область / волжский (самарская область)"
  },
  "6010": {
    "id": "6010",
    "name": "Багамские Острова",
    "path": "Другие регионы / Багамские Острова",
    "country": "Другие регионы",
    "searchString": "багамские острова другие регионы / багамские острова"
  },
  "6011": {
    "id": "6011",
    "name": "Путилково (Московская область)",
    "path": "Россия / Московская область / Путилково (Московская область)",
    "country": "Россия",
    "searchString": "путилково (московская область) россия / московская область / путилково (московская область)"
  },
  "6012": {
    "id": "6012",
    "name": "Чернышевский (Республика Саха (Якутия))",
    "path": "Россия / Республика Саха (Якутия) / Чернышевский (Республика Саха (Якутия))",
    "country": "Россия",
    "searchString": "чернышевский (республика саха (якутия)) россия / республика саха (якутия) / чернышевский (республика саха (якутия))"
  },
  "6013": {
    "id": "6013",
    "name": "Кичменгский Городок",
    "path": "Россия / Вологодская область / Кичменгский Городок",
    "country": "Россия",
    "searchString": "кичменгский городок россия / вологодская область / кичменгский городок"
  },
  "6014": {
    "id": "6014",
    "name": "Часцы (Московская область)",
    "path": "Россия / Московская область / Часцы (Московская область)",
    "country": "Россия",
    "searchString": "часцы (московская область) россия / московская область / часцы (московская область)"
  },
  "6015": {
    "id": "6015",
    "name": "Гавриловка Вторая",
    "path": "Россия / Тамбовская область / Гавриловка Вторая",
    "country": "Россия",
    "searchString": "гавриловка вторая россия / тамбовская область / гавриловка вторая"
  },
  "6016": {
    "id": "6016",
    "name": "Усть-Тарка",
    "path": "Россия / Новосибирская область / Усть-Тарка",
    "country": "Россия",
    "searchString": "усть-тарка россия / новосибирская область / усть-тарка"
  },
  "6017": {
    "id": "6017",
    "name": "Сарань",
    "path": "Казахстан / Сарань",
    "country": "Казахстан",
    "searchString": "сарань казахстан / сарань"
  },
  "6018": {
    "id": "6018",
    "name": "Среднецарицынский",
    "path": "Россия / Волгоградская область / Среднецарицынский",
    "country": "Россия",
    "searchString": "среднецарицынский россия / волгоградская область / среднецарицынский"
  },
  "6019": {
    "id": "6019",
    "name": "Лух",
    "path": "Россия / Ивановская область / Лух",
    "country": "Россия",
    "searchString": "лух россия / ивановская область / лух"
  },
  "6052": {
    "id": "6052",
    "name": "Новоспасское (Ульяновская область)",
    "path": "Россия / Ульяновская область / Новоспасское (Ульяновская область)",
    "country": "Россия",
    "searchString": "новоспасское (ульяновская область) россия / ульяновская область / новоспасское (ульяновская область)"
  },
  "6053": {
    "id": "6053",
    "name": "Бабяково",
    "path": "Россия / Воронежская область / Бабяково",
    "country": "Россия",
    "searchString": "бабяково россия / воронежская область / бабяково"
  },
  "6054": {
    "id": "6054",
    "name": "Михайловка (Приморский край)",
    "path": "Россия / Приморский край / Михайловка (Приморский край)",
    "country": "Россия",
    "searchString": "михайловка (приморский край) россия / приморский край / михайловка (приморский край)"
  },
  "6055": {
    "id": "6055",
    "name": "Радуга",
    "path": "Россия / Ставропольский край / Радуга",
    "country": "Россия",
    "searchString": "радуга россия / ставропольский край / радуга"
  },
  "6056": {
    "id": "6056",
    "name": "Знаменка (Тамбовская область)",
    "path": "Россия / Тамбовская область / Знаменка (Тамбовская область)",
    "country": "Россия",
    "searchString": "знаменка (тамбовская область) россия / тамбовская область / знаменка (тамбовская область)"
  },
  "6057": {
    "id": "6057",
    "name": "Подольск (Одесская область)",
    "path": "Украина / Одесская область / Подольск (Одесская область)",
    "country": "Украина",
    "searchString": "подольск (одесская область) украина / одесская область / подольск (одесская область)"
  },
  "6058": {
    "id": "6058",
    "name": "Объединенная Республика Танзания",
    "path": "Другие регионы / Объединенная Республика Танзания",
    "country": "Другие регионы",
    "searchString": "объединенная республика танзания другие регионы / объединенная республика танзания"
  },
  "6059": {
    "id": "6059",
    "name": "Кудрово",
    "path": "Россия / Ленинградская область / Кудрово",
    "country": "Россия",
    "searchString": "кудрово россия / ленинградская область / кудрово"
  },
  "6060": {
    "id": "6060",
    "name": "Сергеевка (Северо-Казахстанская область)",
    "path": "Казахстан / Сергеевка (Северо-Казахстанская область)",
    "country": "Казахстан",
    "searchString": "сергеевка (северо-казахстанская область) казахстан / сергеевка (северо-казахстанская область)"
  },
  "6061": {
    "id": "6061",
    "name": "Лешуконское",
    "path": "Россия / Архангельская область / Лешуконское",
    "country": "Россия",
    "searchString": "лешуконское россия / архангельская область / лешуконское"
  },
  "6062": {
    "id": "6062",
    "name": "Дергачи (Саратовская область)",
    "path": "Россия / Саратовская область / Дергачи (Саратовская область)",
    "country": "Россия",
    "searchString": "дергачи (саратовская область) россия / саратовская область / дергачи (саратовская область)"
  },
  "6063": {
    "id": "6063",
    "name": "Редкино (Тверская область)",
    "path": "Россия / Тверская область / Редкино (Тверская область)",
    "country": "Россия",
    "searchString": "редкино (тверская область) россия / тверская область / редкино (тверская область)"
  },
  "6064": {
    "id": "6064",
    "name": "Дубки (Саратовская область)",
    "path": "Россия / Саратовская область / Дубки (Саратовская область)",
    "country": "Россия",
    "searchString": "дубки (саратовская область) россия / саратовская область / дубки (саратовская область)"
  },
  "6065": {
    "id": "6065",
    "name": "Самойловка",
    "path": "Россия / Саратовская область / Самойловка",
    "country": "Россия",
    "searchString": "самойловка россия / саратовская область / самойловка"
  },
  "6066": {
    "id": "6066",
    "name": "Знамя Октября (Московская область)",
    "path": "Россия / Московская область / Знамя Октября (Московская область)",
    "country": "Россия",
    "searchString": "знамя октября (московская область) россия / московская область / знамя октября (московская область)"
  },
  "6067": {
    "id": "6067",
    "name": "Горки-10 (Московская область, Одинцовский район)",
    "path": "Россия / Московская область / Горки-10 (Московская область, Одинцовский район)",
    "country": "Россия",
    "searchString": "горки-10 (московская область, одинцовский район) россия / московская область / горки-10 (московская область, одинцовский район)"
  },
  "6068": {
    "id": "6068",
    "name": "Виноградный (Темрюкский район)",
    "path": "Россия / Краснодарский край / Виноградный (Темрюкский район)",
    "country": "Россия",
    "searchString": "виноградный (темрюкский район) россия / краснодарский край / виноградный (темрюкский район)"
  },
  "6069": {
    "id": "6069",
    "name": "Базарный Сызган",
    "path": "Россия / Ульяновская область / Базарный Сызган",
    "country": "Россия",
    "searchString": "базарный сызган россия / ульяновская область / базарный сызган"
  },
  "6070": {
    "id": "6070",
    "name": "Вешкайма",
    "path": "Россия / Ульяновская область / Вешкайма",
    "country": "Россия",
    "searchString": "вешкайма россия / ульяновская область / вешкайма"
  },
  "6071": {
    "id": "6071",
    "name": "Карсун",
    "path": "Россия / Ульяновская область / Карсун",
    "country": "Россия",
    "searchString": "карсун россия / ульяновская область / карсун"
  },
  "6072": {
    "id": "6072",
    "name": "Кузоватово",
    "path": "Россия / Ульяновская область / Кузоватово",
    "country": "Россия",
    "searchString": "кузоватово россия / ульяновская область / кузоватово"
  },
  "6073": {
    "id": "6073",
    "name": "Майна (Ульяновская область)",
    "path": "Россия / Ульяновская область / Майна (Ульяновская область)",
    "country": "Россия",
    "searchString": "майна (ульяновская область) россия / ульяновская область / майна (ульяновская область)"
  },
  "6074": {
    "id": "6074",
    "name": "Новая Малыкла",
    "path": "Россия / Ульяновская область / Новая Малыкла",
    "country": "Россия",
    "searchString": "новая малыкла россия / ульяновская область / новая малыкла"
  },
  "6075": {
    "id": "6075",
    "name": "Павловка (Павловский район Ульяновской области)",
    "path": "Россия / Ульяновская область / Павловка (Павловский район Ульяновской области)",
    "country": "Россия",
    "searchString": "павловка (павловский район ульяновской области) россия / ульяновская область / павловка (павловский район ульяновской области)"
  },
  "6076": {
    "id": "6076",
    "name": "Радищево (Ульяновская область)",
    "path": "Россия / Ульяновская область / Радищево (Ульяновская область)",
    "country": "Россия",
    "searchString": "радищево (ульяновская область) россия / ульяновская область / радищево (ульяновская область)"
  },
  "6077": {
    "id": "6077",
    "name": "Старая Кулатка",
    "path": "Россия / Ульяновская область / Старая Кулатка",
    "country": "Россия",
    "searchString": "старая кулатка россия / ульяновская область / старая кулатка"
  },
  "6078": {
    "id": "6078",
    "name": "Старая Майна",
    "path": "Россия / Ульяновская область / Старая Майна",
    "country": "Россия",
    "searchString": "старая майна россия / ульяновская область / старая майна"
  },
  "6079": {
    "id": "6079",
    "name": "Сурское (Ульяновская область)",
    "path": "Россия / Ульяновская область / Сурское (Ульяновская область)",
    "country": "Россия",
    "searchString": "сурское (ульяновская область) россия / ульяновская область / сурское (ульяновская область)"
  },
  "6080": {
    "id": "6080",
    "name": "Ишеевка (Ульяновская область)",
    "path": "Россия / Ульяновская область / Ишеевка (Ульяновская область)",
    "country": "Россия",
    "searchString": "ишеевка (ульяновская область) россия / ульяновская область / ишеевка (ульяновская область)"
  },
  "6081": {
    "id": "6081",
    "name": "Цильна",
    "path": "Россия / Ульяновская область / Цильна",
    "country": "Россия",
    "searchString": "цильна россия / ульяновская область / цильна"
  },
  "6101": {
    "id": "6101",
    "name": "Тамала",
    "path": "Россия / Пензенская область / Тамала",
    "country": "Россия",
    "searchString": "тамала россия / пензенская область / тамала"
  },
  "6102": {
    "id": "6102",
    "name": "Татищево (Саратовская область)",
    "path": "Россия / Саратовская область / Татищево (Саратовская область)",
    "country": "Россия",
    "searchString": "татищево (саратовская область) россия / саратовская область / татищево (саратовская область)"
  },
  "6103": {
    "id": "6103",
    "name": "Раздольное (Новосибирская область)",
    "path": "Россия / Новосибирская область / Раздольное (Новосибирская область)",
    "country": "Россия",
    "searchString": "раздольное (новосибирская область) россия / новосибирская область / раздольное (новосибирская область)"
  },
  "6104": {
    "id": "6104",
    "name": "Жаркент",
    "path": "Казахстан / Жаркент",
    "country": "Казахстан",
    "searchString": "жаркент казахстан / жаркент"
  },
  "6105": {
    "id": "6105",
    "name": "Дорохово (Московская область)",
    "path": "Россия / Московская область / Дорохово (Московская область)",
    "country": "Россия",
    "searchString": "дорохово (московская область) россия / московская область / дорохово (московская область)"
  },
  "6106": {
    "id": "6106",
    "name": "Репино",
    "path": "Россия / Ленинградская область / Репино",
    "country": "Россия",
    "searchString": "репино россия / ленинградская область / репино"
  },
  "6107": {
    "id": "6107",
    "name": "Лотошино (Московская область)",
    "path": "Россия / Московская область / Лотошино (Московская область)",
    "country": "Россия",
    "searchString": "лотошино (московская область) россия / московская область / лотошино (московская область)"
  },
  "6108": {
    "id": "6108",
    "name": "Шелек",
    "path": "Казахстан / Шелек",
    "country": "Казахстан",
    "searchString": "шелек казахстан / шелек"
  },
  "6109": {
    "id": "6109",
    "name": "Охотск",
    "path": "Россия / Хабаровский край / Охотск",
    "country": "Россия",
    "searchString": "охотск россия / хабаровский край / охотск"
  },
  "6110": {
    "id": "6110",
    "name": "Шаховская (Московская область)",
    "path": "Россия / Московская область / Шаховская (Московская область)",
    "country": "Россия",
    "searchString": "шаховская (московская область) россия / московская область / шаховская (московская область)"
  },
  "6143": {
    "id": "6143",
    "name": "Октябрьский (Московская область)",
    "path": "Россия / Московская область / Октябрьский (Московская область)",
    "country": "Россия",
    "searchString": "октябрьский (московская область) россия / московская область / октябрьский (московская область)"
  },
  "6176": {
    "id": "6176",
    "name": "Симеиз",
    "path": "Россия / Республика Крым / Симеиз",
    "country": "Россия",
    "searchString": "симеиз россия / республика крым / симеиз"
  },
  "6177": {
    "id": "6177",
    "name": "Луначарский (Самарская область)",
    "path": "Россия / Самарская область / Луначарский (Самарская область)",
    "country": "Россия",
    "searchString": "луначарский (самарская область) россия / самарская область / луначарский (самарская область)"
  },
  "6178": {
    "id": "6178",
    "name": "Сибирцево (Приморский край)",
    "path": "Россия / Приморский край / Сибирцево (Приморский край)",
    "country": "Россия",
    "searchString": "сибирцево (приморский край) россия / приморский край / сибирцево (приморский край)"
  },
  "6179": {
    "id": "6179",
    "name": "Елшанка (Воскресенский район, Саратовская область)",
    "path": "Россия / Саратовская область / Елшанка (Воскресенский район, Саратовская область)",
    "country": "Россия",
    "searchString": "елшанка (воскресенский район, саратовская область) россия / саратовская область / елшанка (воскресенский район, саратовская область)"
  },
  "6180": {
    "id": "6180",
    "name": "Ровеньки (Белгородская область)",
    "path": "Россия / Белгородская область / Ровеньки (Белгородская область)",
    "country": "Россия",
    "searchString": "ровеньки (белгородская область) россия / белгородская область / ровеньки (белгородская область)"
  },
  "6181": {
    "id": "6181",
    "name": "Шира",
    "path": "Россия / Республика Хакасия / Шира",
    "country": "Россия",
    "searchString": "шира россия / республика хакасия / шира"
  },
  "6182": {
    "id": "6182",
    "name": "Суходол (Самарская область)",
    "path": "Россия / Самарская область / Суходол (Самарская область)",
    "country": "Россия",
    "searchString": "суходол (самарская область) россия / самарская область / суходол (самарская область)"
  },
  "6183": {
    "id": "6183",
    "name": "Снежногорск (Красноярский край)",
    "path": "Россия / Красноярский край / Снежногорск (Красноярский край)",
    "country": "Россия",
    "searchString": "снежногорск (красноярский край) россия / красноярский край / снежногорск (красноярский край)"
  },
  "6184": {
    "id": "6184",
    "name": "Новозавидовский",
    "path": "Россия / Тверская область / Новозавидовский",
    "country": "Россия",
    "searchString": "новозавидовский россия / тверская область / новозавидовский"
  },
  "6185": {
    "id": "6185",
    "name": "Малино (Московская область)",
    "path": "Россия / Московская область / Малино (Московская область)",
    "country": "Россия",
    "searchString": "малино (московская область) россия / московская область / малино (московская область)"
  },
  "6186": {
    "id": "6186",
    "name": "Софиевка (Казахстан)",
    "path": "Казахстан / Софиевка (Казахстан)",
    "country": "Казахстан",
    "searchString": "софиевка (казахстан) казахстан / софиевка (казахстан)"
  },
  "6187": {
    "id": "6187",
    "name": "Усть-Вымский район",
    "path": "Россия / Республика Коми / Усть-Вымский район",
    "country": "Россия",
    "searchString": "усть-вымский район россия / республика коми / усть-вымский район"
  },
  "6188": {
    "id": "6188",
    "name": "Айкино",
    "path": "Россия / Республика Коми / Айкино",
    "country": "Россия",
    "searchString": "айкино россия / республика коми / айкино"
  },
  "6189": {
    "id": "6189",
    "name": "Стройкерамика",
    "path": "Россия / Самарская область / Стройкерамика",
    "country": "Россия",
    "searchString": "стройкерамика россия / самарская область / стройкерамика"
  },
  "6190": {
    "id": "6190",
    "name": "Степное (Саратовская область, Советский район)",
    "path": "Россия / Саратовская область / Степное (Саратовская область, Советский район)",
    "country": "Россия",
    "searchString": "степное (саратовская область, советский район) россия / саратовская область / степное (саратовская область, советский район)"
  },
  "6191": {
    "id": "6191",
    "name": "Новая Ляда",
    "path": "Россия / Тамбовская область / Новая Ляда",
    "country": "Россия",
    "searchString": "новая ляда россия / тамбовская область / новая ляда"
  },
  "6192": {
    "id": "6192",
    "name": "Александров Гай",
    "path": "Россия / Саратовская область / Александров Гай",
    "country": "Россия",
    "searchString": "александров гай россия / саратовская область / александров гай"
  },
  "6193": {
    "id": "6193",
    "name": "Екатериновка (Саратовская область)",
    "path": "Россия / Саратовская область / Екатериновка (Саратовская область)",
    "country": "Россия",
    "searchString": "екатериновка (саратовская область) россия / саратовская область / екатериновка (саратовская область)"
  },
  "6194": {
    "id": "6194",
    "name": "Ивантеевка (Саратовская область)",
    "path": "Россия / Саратовская область / Ивантеевка (Саратовская область)",
    "country": "Россия",
    "searchString": "ивантеевка (саратовская область) россия / саратовская область / ивантеевка (саратовская область)"
  },
  "6195": {
    "id": "6195",
    "name": "Лысые Горы",
    "path": "Россия / Саратовская область / Лысые Горы",
    "country": "Россия",
    "searchString": "лысые горы россия / саратовская область / лысые горы"
  },
  "6196": {
    "id": "6196",
    "name": "Новые Бурасы",
    "path": "Россия / Саратовская область / Новые Бурасы",
    "country": "Россия",
    "searchString": "новые бурасы россия / саратовская область / новые бурасы"
  },
  "6197": {
    "id": "6197",
    "name": "Ровное",
    "path": "Россия / Саратовская область / Ровное",
    "country": "Россия",
    "searchString": "ровное россия / саратовская область / ровное"
  },
  "6198": {
    "id": "6198",
    "name": "Турки",
    "path": "Россия / Саратовская область / Турки",
    "country": "Россия",
    "searchString": "турки россия / саратовская область / турки"
  },
  "6199": {
    "id": "6199",
    "name": "Кысыл-Сыр",
    "path": "Россия / Республика Саха (Якутия) / Кысыл-Сыр",
    "country": "Россия",
    "searchString": "кысыл-сыр россия / республика саха (якутия) / кысыл-сыр"
  },
  "6200": {
    "id": "6200",
    "name": "Чамзинка",
    "path": "Россия / Республика Мордовия / Чамзинка",
    "country": "Россия",
    "searchString": "чамзинка россия / республика мордовия / чамзинка"
  },
  "6201": {
    "id": "6201",
    "name": "Покровское (Орловская область)",
    "path": "Россия / Орловская область / Покровское (Орловская область)",
    "country": "Россия",
    "searchString": "покровское (орловская область) россия / орловская область / покровское (орловская область)"
  },
  "6202": {
    "id": "6202",
    "name": "Средний Баскунчак",
    "path": "Россия / Астраханская область / Средний Баскунчак",
    "country": "Россия",
    "searchString": "средний баскунчак россия / астраханская область / средний баскунчак"
  },
  "6203": {
    "id": "6203",
    "name": "Романовка (Саратовская область)",
    "path": "Россия / Саратовская область / Романовка (Саратовская область)",
    "country": "Россия",
    "searchString": "романовка (саратовская область) россия / саратовская область / романовка (саратовская область)"
  },
  "6204": {
    "id": "6204",
    "name": "Тепловка",
    "path": "Россия / Саратовская область / Тепловка",
    "country": "Россия",
    "searchString": "тепловка россия / саратовская область / тепловка"
  },
  "6205": {
    "id": "6205",
    "name": "Мельниково (Ленинградская область)",
    "path": "Россия / Ленинградская область / Мельниково (Ленинградская область)",
    "country": "Россия",
    "searchString": "мельниково (ленинградская область) россия / ленинградская область / мельниково (ленинградская область)"
  },
  "6206": {
    "id": "6206",
    "name": "Ножай-Юрт",
    "path": "Россия / Чеченская республика / Ножай-Юрт",
    "country": "Россия",
    "searchString": "ножай-юрт россия / чеченская республика / ножай-юрт"
  },
  "6207": {
    "id": "6207",
    "name": "Ая",
    "path": "Россия / Алтайский край / Ая",
    "country": "Россия",
    "searchString": "ая россия / алтайский край / ая"
  },
  "6240": {
    "id": "6240",
    "name": "Загорянский (Московская область)",
    "path": "Россия / Московская область / Загорянский (Московская область)",
    "country": "Россия",
    "searchString": "загорянский (московская область) россия / московская область / загорянский (московская область)"
  },
  "6241": {
    "id": "6241",
    "name": "Вершиина Тёи",
    "path": "Россия / Республика Хакасия / Вершиина Тёи",
    "country": "Россия",
    "searchString": "вершиина тёи россия / республика хакасия / вершиина тёи"
  },
  "6242": {
    "id": "6242",
    "name": "Убинское",
    "path": "Россия / Новосибирская область / Убинское",
    "country": "Россия",
    "searchString": "убинское россия / новосибирская область / убинское"
  },
  "6243": {
    "id": "6243",
    "name": "Мисайлово (Московская область)",
    "path": "Россия / Московская область / Мисайлово (Московская область)",
    "country": "Россия",
    "searchString": "мисайлово (московская область) россия / московская область / мисайлово (московская область)"
  },
  "6244": {
    "id": "6244",
    "name": "Мангистау",
    "path": "Казахстан / Мангистау",
    "country": "Казахстан",
    "searchString": "мангистау казахстан / мангистау"
  },
  "6245": {
    "id": "6245",
    "name": "Витим",
    "path": "Россия / Республика Саха (Якутия) / Витим",
    "country": "Россия",
    "searchString": "витим россия / республика саха (якутия) / витим"
  },
  "6246": {
    "id": "6246",
    "name": "Горный (Саратовская область)",
    "path": "Россия / Саратовская область / Горный (Саратовская область)",
    "country": "Россия",
    "searchString": "горный (саратовская область) россия / саратовская область / горный (саратовская область)"
  },
  "6247": {
    "id": "6247",
    "name": "Карпогоры",
    "path": "Россия / Архангельская область / Карпогоры",
    "country": "Россия",
    "searchString": "карпогоры россия / архангельская область / карпогоры"
  },
  "6248": {
    "id": "6248",
    "name": "Узынагаш",
    "path": "Казахстан / Узынагаш",
    "country": "Казахстан",
    "searchString": "узынагаш казахстан / узынагаш"
  },
  "6249": {
    "id": "6249",
    "name": "Баяндай",
    "path": "Россия / Иркутская область / Баяндай",
    "country": "Россия",
    "searchString": "баяндай россия / иркутская область / баяндай"
  },
  "6250": {
    "id": "6250",
    "name": "Уштобе",
    "path": "Казахстан / Уштобе",
    "country": "Казахстан",
    "searchString": "уштобе казахстан / уштобе"
  },
  "6251": {
    "id": "6251",
    "name": "Абай",
    "path": "Казахстан / Абай",
    "country": "Казахстан",
    "searchString": "абай казахстан / абай"
  },
  "6252": {
    "id": "6252",
    "name": "Славянка",
    "path": "Россия / Ленинградская область / Славянка",
    "country": "Россия",
    "searchString": "славянка россия / ленинградская область / славянка"
  },
  "6253": {
    "id": "6253",
    "name": "Бованенково",
    "path": "Россия / Ямало-Ненецкий АО / Бованенково",
    "country": "Россия",
    "searchString": "бованенково россия / ямало-ненецкий ао / бованенково"
  },
  "6254": {
    "id": "6254",
    "name": "Аксукент",
    "path": "Казахстан / Аксукент",
    "country": "Казахстан",
    "searchString": "аксукент казахстан / аксукент"
  },
  "6287": {
    "id": "6287",
    "name": "Есик",
    "path": "Казахстан / Есик",
    "country": "Казахстан",
    "searchString": "есик казахстан / есик"
  },
  "6288": {
    "id": "6288",
    "name": "Аскиз",
    "path": "Россия / Республика Хакасия / Аскиз",
    "country": "Россия",
    "searchString": "аскиз россия / республика хакасия / аскиз"
  },
  "6289": {
    "id": "6289",
    "name": "Врангель",
    "path": "Россия / Приморский край / Врангель",
    "country": "Россия",
    "searchString": "врангель россия / приморский край / врангель"
  },
  "6290": {
    "id": "6290",
    "name": "Шахтинск",
    "path": "Казахстан / Шахтинск",
    "country": "Казахстан",
    "searchString": "шахтинск казахстан / шахтинск"
  },
  "6291": {
    "id": "6291",
    "name": "Лесное (Тверская область)",
    "path": "Россия / Тверская область / Лесное (Тверская область)",
    "country": "Россия",
    "searchString": "лесное (тверская область) россия / тверская область / лесное (тверская область)"
  },
  "6292": {
    "id": "6292",
    "name": "Есиль",
    "path": "Казахстан / Есиль",
    "country": "Казахстан",
    "searchString": "есиль казахстан / есиль"
  },
  "6293": {
    "id": "6293",
    "name": "Село имени Бабушкина",
    "path": "Россия / Вологодская область / Село имени Бабушкина",
    "country": "Россия",
    "searchString": "село имени бабушкина россия / вологодская область / село имени бабушкина"
  },
  "6294": {
    "id": "6294",
    "name": "Заречье (рабочий посёлок, Одинцовский район, Московская область)",
    "path": "Россия / Московская область / Заречье (рабочий посёлок, Одинцовский район, Московская область)",
    "country": "Россия",
    "searchString": "заречье (рабочий посёлок, одинцовский район, московская область) россия / московская область / заречье (рабочий посёлок, одинцовский район, московская область)"
  },
  "6295": {
    "id": "6295",
    "name": "Тереньга",
    "path": "Россия / Ульяновская область / Тереньга",
    "country": "Россия",
    "searchString": "тереньга россия / ульяновская область / тереньга"
  },
  "6296": {
    "id": "6296",
    "name": "Ново-Талицы",
    "path": "Россия / Ивановская область / Ново-Талицы",
    "country": "Россия",
    "searchString": "ново-талицы россия / ивановская область / ново-талицы"
  },
  "6297": {
    "id": "6297",
    "name": "Лисаковск",
    "path": "Казахстан / Лисаковск",
    "country": "Казахстан",
    "searchString": "лисаковск казахстан / лисаковск"
  },
  "6298": {
    "id": "6298",
    "name": "Фряново (Московская область)",
    "path": "Россия / Московская область / Фряново (Московская область)",
    "country": "Россия",
    "searchString": "фряново (московская область) россия / московская область / фряново (московская область)"
  },
  "6299": {
    "id": "6299",
    "name": "Отеген-Батыр",
    "path": "Казахстан / Отеген-Батыр",
    "country": "Казахстан",
    "searchString": "отеген-батыр казахстан / отеген-батыр"
  },
  "6300": {
    "id": "6300",
    "name": "Арысь (Туркестанская область)",
    "path": "Казахстан / Арысь (Туркестанская область)",
    "country": "Казахстан",
    "searchString": "арысь (туркестанская область) казахстан / арысь (туркестанская область)"
  },
  "6301": {
    "id": "6301",
    "name": "Башмаково",
    "path": "Россия / Пензенская область / Башмаково",
    "country": "Россия",
    "searchString": "башмаково россия / пензенская область / башмаково"
  },
  "6302": {
    "id": "6302",
    "name": "Мокшан",
    "path": "Россия / Пензенская область / Мокшан",
    "country": "Россия",
    "searchString": "мокшан россия / пензенская область / мокшан"
  },
  "6303": {
    "id": "6303",
    "name": "Евлашево",
    "path": "Россия / Пензенская область / Евлашево",
    "country": "Россия",
    "searchString": "евлашево россия / пензенская область / евлашево"
  },
  "6304": {
    "id": "6304",
    "name": "Исса",
    "path": "Россия / Пензенская область / Исса",
    "country": "Россия",
    "searchString": "исса россия / пензенская область / исса"
  },
  "6305": {
    "id": "6305",
    "name": "Шемышейка",
    "path": "Россия / Пензенская область / Шемышейка",
    "country": "Россия",
    "searchString": "шемышейка россия / пензенская область / шемышейка"
  },
  "6306": {
    "id": "6306",
    "name": "Чаадаевка",
    "path": "Россия / Пензенская область / Чаадаевка",
    "country": "Россия",
    "searchString": "чаадаевка россия / пензенская область / чаадаевка"
  },
  "6307": {
    "id": "6307",
    "name": "Лунино (Пензенская область)",
    "path": "Россия / Пензенская область / Лунино (Пензенская область)",
    "country": "Россия",
    "searchString": "лунино (пензенская область) россия / пензенская область / лунино (пензенская область)"
  },
  "6308": {
    "id": "6308",
    "name": "Пачелма",
    "path": "Россия / Пензенская область / Пачелма",
    "country": "Россия",
    "searchString": "пачелма россия / пензенская область / пачелма"
  },
  "6309": {
    "id": "6309",
    "name": "Колышлей",
    "path": "Россия / Пензенская область / Колышлей",
    "country": "Россия",
    "searchString": "колышлей россия / пензенская область / колышлей"
  },
  "6310": {
    "id": "6310",
    "name": "Земетчино",
    "path": "Россия / Пензенская область / Земетчино",
    "country": "Россия",
    "searchString": "земетчино россия / пензенская область / земетчино"
  },
  "6311": {
    "id": "6311",
    "name": "Преображение",
    "path": "Россия / Приморский край / Преображение",
    "country": "Россия",
    "searchString": "преображение россия / приморский край / преображение"
  },
  "6312": {
    "id": "6312",
    "name": "Верхняя Тойма",
    "path": "Россия / Архангельская область / Верхняя Тойма",
    "country": "Россия",
    "searchString": "верхняя тойма россия / архангельская область / верхняя тойма"
  },
  "6313": {
    "id": "6313",
    "name": "Палех",
    "path": "Россия / Ивановская область / Палех",
    "country": "Россия",
    "searchString": "палех россия / ивановская область / палех"
  },
  "6314": {
    "id": "6314",
    "name": "Кизема",
    "path": "Россия / Архангельская область / Кизема",
    "country": "Россия",
    "searchString": "кизема россия / архангельская область / кизема"
  },
  "6315": {
    "id": "6315",
    "name": "Столбище",
    "path": "Россия / Республика Татарстан / Столбище",
    "country": "Россия",
    "searchString": "столбище россия / республика татарстан / столбище"
  },
  "6316": {
    "id": "6316",
    "name": "Нижний Бестях",
    "path": "Россия / Республика Саха (Якутия) / Нижний Бестях",
    "country": "Россия",
    "searchString": "нижний бестях россия / республика саха (якутия) / нижний бестях"
  },
  "6317": {
    "id": "6317",
    "name": "Сокуры",
    "path": "Россия / Республика Татарстан / Сокуры",
    "country": "Россия",
    "searchString": "сокуры россия / республика татарстан / сокуры"
  },
  "6318": {
    "id": "6318",
    "name": "Зуя",
    "path": "Россия / Республика Крым / Зуя",
    "country": "Россия",
    "searchString": "зуя россия / республика крым / зуя"
  },
  "6319": {
    "id": "6319",
    "name": "Хандыга",
    "path": "Россия / Республика Саха (Якутия) / Хандыга",
    "country": "Россия",
    "searchString": "хандыга россия / республика саха (якутия) / хандыга"
  },
  "6320": {
    "id": "6320",
    "name": "Копаткевичи",
    "path": "Беларусь / Гомельская область / Копаткевичи",
    "country": "Беларусь",
    "searchString": "копаткевичи беларусь / гомельская область / копаткевичи"
  },
  "6321": {
    "id": "6321",
    "name": "Радошковичи",
    "path": "Беларусь / Минская область / Радошковичи",
    "country": "Беларусь",
    "searchString": "радошковичи беларусь / минская область / радошковичи"
  },
  "6322": {
    "id": "6322",
    "name": "Житикара",
    "path": "Казахстан / Житикара",
    "country": "Казахстан",
    "searchString": "житикара казахстан / житикара"
  },
  "6323": {
    "id": "6323",
    "name": "Лаос",
    "path": "Другие регионы / Лаос",
    "country": "Другие регионы",
    "searchString": "лаос другие регионы / лаос"
  },
  "6324": {
    "id": "6324",
    "name": "Шиели",
    "path": "Казахстан / Шиели",
    "country": "Казахстан",
    "searchString": "шиели казахстан / шиели"
  },
  "6325": {
    "id": "6325",
    "name": "Талшик",
    "path": "Казахстан / Талшик",
    "country": "Казахстан",
    "searchString": "талшик казахстан / талшик"
  },
  "6326": {
    "id": "6326",
    "name": "Непал",
    "path": "Другие регионы / Непал",
    "country": "Другие регионы",
    "searchString": "непал другие регионы / непал"
  },
  "6327": {
    "id": "6327",
    "name": "Парагвай",
    "path": "Другие регионы / Парагвай",
    "country": "Другие регионы",
    "searchString": "парагвай другие регионы / парагвай"
  },
  "6328": {
    "id": "6328",
    "name": "Эритрея",
    "path": "Другие регионы / Эритрея",
    "country": "Другие регионы",
    "searchString": "эритрея другие регионы / эритрея"
  },
  "6329": {
    "id": "6329",
    "name": "Бруней Даруссалам",
    "path": "Другие регионы / Бруней Даруссалам",
    "country": "Другие регионы",
    "searchString": "бруней даруссалам другие регионы / бруней даруссалам"
  },
  "6330": {
    "id": "6330",
    "name": "Тоголезская Республика",
    "path": "Другие регионы / Тоголезская Республика",
    "country": "Другие регионы",
    "searchString": "тоголезская республика другие регионы / тоголезская республика"
  },
  "6331": {
    "id": "6331",
    "name": "Бердигестях",
    "path": "Россия / Республика Саха (Якутия) / Бердигестях",
    "country": "Россия",
    "searchString": "бердигестях россия / республика саха (якутия) / бердигестях"
  },
  "6332": {
    "id": "6332",
    "name": "Посёлок совхоза имени Ленина (Московская область)",
    "path": "Россия / Московская область / Посёлок совхоза имени Ленина (Московская область)",
    "country": "Россия",
    "searchString": "посёлок совхоза имени ленина (московская область) россия / московская область / посёлок совхоза имени ленина (московская область)"
  },
  "6333": {
    "id": "6333",
    "name": "Лычково",
    "path": "Россия / Новгородская область / Лычково",
    "country": "Россия",
    "searchString": "лычково россия / новгородская область / лычково"
  },
  "6334": {
    "id": "6334",
    "name": "Горки Ленинские (Московская область)",
    "path": "Россия / Московская область / Горки Ленинские (Московская область)",
    "country": "Россия",
    "searchString": "горки ленинские (московская область) россия / московская область / горки ленинские (московская область)"
  },
  "6336": {
    "id": "6336",
    "name": "Снегири (Московская область)",
    "path": "Россия / Московская область / Снегири (Московская область)",
    "country": "Россия",
    "searchString": "снегири (московская область) россия / московская область / снегири (московская область)"
  },
  "6337": {
    "id": "6337",
    "name": "Республика Малави",
    "path": "Другие регионы / Республика Малави",
    "country": "Другие регионы",
    "searchString": "республика малави другие регионы / республика малави"
  },
  "6338": {
    "id": "6338",
    "name": "Красные Ткачи",
    "path": "Россия / Ярославская область / Красные Ткачи",
    "country": "Россия",
    "searchString": "красные ткачи россия / ярославская область / красные ткачи"
  },
  "6339": {
    "id": "6339",
    "name": "Андреевка (Московская область)",
    "path": "Россия / Московская область / Андреевка (Московская область)",
    "country": "Россия",
    "searchString": "андреевка (московская область) россия / московская область / андреевка (московская область)"
  },
  "6340": {
    "id": "6340",
    "name": "Юго-Камский",
    "path": "Россия / Пермский край / Юго-Камский",
    "country": "Россия",
    "searchString": "юго-камский россия / пермский край / юго-камский"
  },
  "6341": {
    "id": "6341",
    "name": "Мокроус",
    "path": "Россия / Саратовская область / Мокроус",
    "country": "Россия",
    "searchString": "мокроус россия / саратовская область / мокроус"
  },
  "6342": {
    "id": "6342",
    "name": "Каркаралинск",
    "path": "Казахстан / Каркаралинск",
    "country": "Казахстан",
    "searchString": "каркаралинск казахстан / каркаралинск"
  },
  "6343": {
    "id": "6343",
    "name": "Жайрем",
    "path": "Казахстан / Жайрем",
    "country": "Казахстан",
    "searchString": "жайрем казахстан / жайрем"
  },
  "6344": {
    "id": "6344",
    "name": "Торетам",
    "path": "Казахстан / Торетам",
    "country": "Казахстан",
    "searchString": "торетам казахстан / торетам"
  },
  "6345": {
    "id": "6345",
    "name": "Ленино (Липецкая область)",
    "path": "Россия / Липецкая область / Ленино (Липецкая область)",
    "country": "Россия",
    "searchString": "ленино (липецкая область) россия / липецкая область / ленино (липецкая область)"
  },
  "6346": {
    "id": "6346",
    "name": "Жосалы (Кызылординская область)",
    "path": "Казахстан / Жосалы (Кызылординская область)",
    "country": "Казахстан",
    "searchString": "жосалы (кызылординская область) казахстан / жосалы (кызылординская область)"
  },
  "6347": {
    "id": "6347",
    "name": "Жалагаш",
    "path": "Казахстан / Жалагаш",
    "country": "Казахстан",
    "searchString": "жалагаш казахстан / жалагаш"
  },
  "6348": {
    "id": "6348",
    "name": "Шалкар",
    "path": "Казахстан / Шалкар",
    "country": "Казахстан",
    "searchString": "шалкар казахстан / шалкар"
  },
  "6349": {
    "id": "6349",
    "name": "Ушарал",
    "path": "Казахстан / Ушарал",
    "country": "Казахстан",
    "searchString": "ушарал казахстан / ушарал"
  },
  "6350": {
    "id": "6350",
    "name": "Республика Чад",
    "path": "Другие регионы / Республика Чад",
    "country": "Другие регионы",
    "searchString": "республика чад другие регионы / республика чад"
  },
  "6351": {
    "id": "6351",
    "name": "Атасу",
    "path": "Казахстан / Атасу",
    "country": "Казахстан",
    "searchString": "атасу казахстан / атасу"
  },
  "6352": {
    "id": "6352",
    "name": "Новое Ступино (Московская область)",
    "path": "Россия / Московская область / Новое Ступино (Московская область)",
    "country": "Россия",
    "searchString": "новое ступино (московская область) россия / московская область / новое ступино (московская область)"
  },
  "6353": {
    "id": "6353",
    "name": "Птичное (Московская область)",
    "path": "Россия / Московская область / Птичное (Московская область)",
    "country": "Россия",
    "searchString": "птичное (московская область) россия / московская область / птичное (московская область)"
  },
  "6354": {
    "id": "6354",
    "name": "Деденево (Московская область)",
    "path": "Россия / Московская область / Деденево (Московская область)",
    "country": "Россия",
    "searchString": "деденево (московская область) россия / московская область / деденево (московская область)"
  },
  "6355": {
    "id": "6355",
    "name": "Икша (Московская область)",
    "path": "Россия / Московская область / Икша (Московская область)",
    "country": "Россия",
    "searchString": "икша (московская область) россия / московская область / икша (московская область)"
  },
  "6356": {
    "id": "6356",
    "name": "Республика Эль-Сальвадор",
    "path": "Другие регионы / Республика Эль-Сальвадор",
    "country": "Другие регионы",
    "searchString": "республика эль-сальвадор другие регионы / республика эль-сальвадор"
  },
  "6357": {
    "id": "6357",
    "name": "Путёвка",
    "path": "Россия / Брянская область / Путёвка",
    "country": "Россия",
    "searchString": "путёвка россия / брянская область / путёвка"
  },
  "6358": {
    "id": "6358",
    "name": "Карабулак (Алматинская область)",
    "path": "Казахстан / Карабулак (Алматинская область)",
    "country": "Казахстан",
    "searchString": "карабулак (алматинская область) казахстан / карабулак (алматинская область)"
  },
  "6359": {
    "id": "6359",
    "name": "Барбадос",
    "path": "Другие регионы / Барбадос",
    "country": "Другие регионы",
    "searchString": "барбадос другие регионы / барбадос"
  },
  "6360": {
    "id": "6360",
    "name": "Клёново (Московская область)",
    "path": "Россия / Московская область / Клёново (Московская область)",
    "country": "Россия",
    "searchString": "клёново (московская область) россия / московская область / клёново (московская область)"
  },
  "6361": {
    "id": "6361",
    "name": "Щапово (Московская область)",
    "path": "Россия / Московская область / Щапово (Московская область)",
    "country": "Россия",
    "searchString": "щапово (московская область) россия / московская область / щапово (московская область)"
  },
  "6362": {
    "id": "6362",
    "name": "Новый (Приморский край)",
    "path": "Россия / Приморский край / Новый (Приморский край)",
    "country": "Россия",
    "searchString": "новый (приморский край) россия / приморский край / новый (приморский край)"
  },
  "6363": {
    "id": "6363",
    "name": "Вольно-Надеждинское",
    "path": "Россия / Приморский край / Вольно-Надеждинское",
    "country": "Россия",
    "searchString": "вольно-надеждинское россия / приморский край / вольно-надеждинское"
  },
  "6364": {
    "id": "6364",
    "name": "Мирный (Самарская область)",
    "path": "Россия / Самарская область / Мирный (Самарская область)",
    "country": "Россия",
    "searchString": "мирный (самарская область) россия / самарская область / мирный (самарская область)"
  },
  "6365": {
    "id": "6365",
    "name": "Актогай",
    "path": "Казахстан / Актогай",
    "country": "Казахстан",
    "searchString": "актогай казахстан / актогай"
  },
  "6366": {
    "id": "6366",
    "name": "Торткудук",
    "path": "Казахстан / Торткудук",
    "country": "Казахстан",
    "searchString": "торткудук казахстан / торткудук"
  },
  "6367": {
    "id": "6367",
    "name": "Замбия",
    "path": "Другие регионы / Замбия",
    "country": "Другие регионы",
    "searchString": "замбия другие регионы / замбия"
  },
  "6368": {
    "id": "6368",
    "name": "Большие Вязёмы  (Московская область)",
    "path": "Россия / Московская область / Большие Вязёмы  (Московская область)",
    "country": "Россия",
    "searchString": "большие вязёмы  (московская область) россия / московская область / большие вязёмы  (московская область)"
  },
  "6369": {
    "id": "6369",
    "name": "Кировский (Приморский край)",
    "path": "Россия / Приморский край / Кировский (Приморский край)",
    "country": "Россия",
    "searchString": "кировский (приморский край) россия / приморский край / кировский (приморский край)"
  },
  "6370": {
    "id": "6370",
    "name": "Борогонцы",
    "path": "Россия / Республика Саха (Якутия) / Борогонцы",
    "country": "Россия",
    "searchString": "борогонцы россия / республика саха (якутия) / борогонцы"
  },
  "6371": {
    "id": "6371",
    "name": "Беркакит",
    "path": "Россия / Республика Саха (Якутия) / Беркакит",
    "country": "Россия",
    "searchString": "беркакит россия / республика саха (якутия) / беркакит"
  },
  "6372": {
    "id": "6372",
    "name": "Спирово (Тверская область)",
    "path": "Россия / Тверская область / Спирово (Тверская область)",
    "country": "Россия",
    "searchString": "спирово (тверская область) россия / тверская область / спирово (тверская область)"
  },
  "6373": {
    "id": "6373",
    "name": "Октябрьский (Красноармейский район, Краснодарский край)",
    "path": "Россия / Краснодарский край / Октябрьский (Красноармейский район, Краснодарский край)",
    "country": "Россия",
    "searchString": "октябрьский (красноармейский район, краснодарский край) россия / краснодарский край / октябрьский (красноармейский район, краснодарский край)"
  },
  "6374": {
    "id": "6374",
    "name": "Софьино (Раменский район, Московская область)",
    "path": "Россия / Московская область / Софьино (Раменский район, Московская область)",
    "country": "Россия",
    "searchString": "софьино (раменский район, московская область) россия / московская область / софьино (раменский район, московская область)"
  },
  "6375": {
    "id": "6375",
    "name": "Мачулищи",
    "path": "Беларусь / Минская область / Мачулищи",
    "country": "Беларусь",
    "searchString": "мачулищи беларусь / минская область / мачулищи"
  },
  "6376": {
    "id": "6376",
    "name": "Юбилейный (Краснодарский край)",
    "path": "Россия / Краснодарский край / Юбилейный (Краснодарский край)",
    "country": "Россия",
    "searchString": "юбилейный (краснодарский край) россия / краснодарский край / юбилейный (краснодарский край)"
  },
  "6377": {
    "id": "6377",
    "name": "Республика Гаити",
    "path": "Другие регионы / Республика Гаити",
    "country": "Другие регионы",
    "searchString": "республика гаити другие регионы / республика гаити"
  },
  "6378": {
    "id": "6378",
    "name": "Свердловский (Московская область)",
    "path": "Россия / Московская область / Свердловский (Московская область)",
    "country": "Россия",
    "searchString": "свердловский (московская область) россия / московская область / свердловский (московская область)"
  },
  "6379": {
    "id": "6379",
    "name": "Панфилово (Волгоградская область)",
    "path": "Россия / Волгоградская область / Панфилово (Волгоградская область)",
    "country": "Россия",
    "searchString": "панфилово (волгоградская область) россия / волгоградская область / панфилово (волгоградская область)"
  },
  "6380": {
    "id": "6380",
    "name": "Уваровка (Московская область)",
    "path": "Россия / Московская область / Уваровка (Московская область)",
    "country": "Россия",
    "searchString": "уваровка (московская область) россия / московская область / уваровка (московская область)"
  },
  "6381": {
    "id": "6381",
    "name": "Вуадиль",
    "path": "Узбекистан / Вуадиль",
    "country": "Узбекистан",
    "searchString": "вуадиль узбекистан / вуадиль"
  },
  "6382": {
    "id": "6382",
    "name": "Советское (Алтайский край)",
    "path": "Россия / Алтайский край / Советское (Алтайский край)",
    "country": "Россия",
    "searchString": "советское (алтайский край) россия / алтайский край / советское (алтайский край)"
  },
  "6383": {
    "id": "6383",
    "name": "Соловьёвск",
    "path": "Россия / Амурская область / Соловьёвск",
    "country": "Россия",
    "searchString": "соловьёвск россия / амурская область / соловьёвск"
  },
  "6384": {
    "id": "6384",
    "name": "Старая Вичуга",
    "path": "Россия / Ивановская область / Старая Вичуга",
    "country": "Россия",
    "searchString": "старая вичуга россия / ивановская область / старая вичуга"
  },
  "6385": {
    "id": "6385",
    "name": "Поварово (Московская область)",
    "path": "Россия / Московская область / Поварово (Московская область)",
    "country": "Россия",
    "searchString": "поварово (московская область) россия / московская область / поварово (московская область)"
  },
  "6386": {
    "id": "6386",
    "name": "Батаюрт",
    "path": "Россия / Республика Дагестан / Батаюрт",
    "country": "Россия",
    "searchString": "батаюрт россия / республика дагестан / батаюрт"
  },
  "6387": {
    "id": "6387",
    "name": "Новосемейкино",
    "path": "Россия / Самарская область / Новосемейкино",
    "country": "Россия",
    "searchString": "новосемейкино россия / самарская область / новосемейкино"
  },
  "6388": {
    "id": "6388",
    "name": "Шардара",
    "path": "Казахстан / Шардара",
    "country": "Казахстан",
    "searchString": "шардара казахстан / шардара"
  },
  "6389": {
    "id": "6389",
    "name": "Новофёдоровка",
    "path": "Россия / Республика Крым / Новофёдоровка",
    "country": "Россия",
    "searchString": "новофёдоровка россия / республика крым / новофёдоровка"
  },
  "6390": {
    "id": "6390",
    "name": "Молоково (Московская область)",
    "path": "Россия / Московская область / Молоково (Московская область)",
    "country": "Россия",
    "searchString": "молоково (московская область) россия / московская область / молоково (московская область)"
  },
  "6391": {
    "id": "6391",
    "name": "Балтай",
    "path": "Россия / Саратовская область / Балтай",
    "country": "Россия",
    "searchString": "балтай россия / саратовская область / балтай"
  },
  "6392": {
    "id": "6392",
    "name": "Крыловская станица (Ленинградский район)",
    "path": "Россия / Краснодарский край / Крыловская станица (Ленинградский район)",
    "country": "Россия",
    "searchString": "крыловская станица (ленинградский район) россия / краснодарский край / крыловская станица (ленинградский район)"
  },
  "6393": {
    "id": "6393",
    "name": "Косшы",
    "path": "Казахстан / Косшы",
    "country": "Казахстан",
    "searchString": "косшы казахстан / косшы"
  },
  "6394": {
    "id": "6394",
    "name": "Медное (Тверская область)",
    "path": "Россия / Тверская область / Медное (Тверская область)",
    "country": "Россия",
    "searchString": "медное (тверская область) россия / тверская область / медное (тверская область)"
  },
  "6395": {
    "id": "6395",
    "name": "Приозёрск (Карагандинская область)",
    "path": "Казахстан / Приозёрск (Карагандинская область)",
    "country": "Казахстан",
    "searchString": "приозёрск (карагандинская область) казахстан / приозёрск (карагандинская область)"
  },
  "6396": {
    "id": "6396",
    "name": "Рогатая Балка",
    "path": "Россия / Ставропольский край / Рогатая Балка",
    "country": "Россия",
    "searchString": "рогатая балка россия / ставропольский край / рогатая балка"
  },
  "6429": {
    "id": "6429",
    "name": "Марфино (городской округ Мытищи,Московская область)",
    "path": "Россия / Московская область / Марфино (городской округ Мытищи,Московская область)",
    "country": "Россия",
    "searchString": "марфино (городской округ мытищи,московская область) россия / московская область / марфино (городской округ мытищи,московская область)"
  },
  "6430": {
    "id": "6430",
    "name": "Питерка",
    "path": "Россия / Саратовская область / Питерка",
    "country": "Россия",
    "searchString": "питерка россия / саратовская область / питерка"
  },
  "6431": {
    "id": "6431",
    "name": "Глубокое (Восточно-Казахстанская область)",
    "path": "Казахстан / Глубокое (Восточно-Казахстанская область)",
    "country": "Казахстан",
    "searchString": "глубокое (восточно-казахстанская область) казахстан / глубокое (восточно-казахстанская область)"
  },
  "6432": {
    "id": "6432",
    "name": "Койгородок",
    "path": "Россия / Республика Коми / Койгородок",
    "country": "Россия",
    "searchString": "койгородок россия / республика коми / койгородок"
  },
  "6433": {
    "id": "6433",
    "name": "Васильево",
    "path": "Россия / Республика Татарстан / Васильево",
    "country": "Россия",
    "searchString": "васильево россия / республика татарстан / васильево"
  },
  "6434": {
    "id": "6434",
    "name": "Петра Дубрава",
    "path": "Россия / Самарская область / Петра Дубрава",
    "country": "Россия",
    "searchString": "петра дубрава россия / самарская область / петра дубрава"
  },
  "6435": {
    "id": "6435",
    "name": "Малая Сердоба",
    "path": "Россия / Пензенская область / Малая Сердоба",
    "country": "Россия",
    "searchString": "малая сердоба россия / пензенская область / малая сердоба"
  },
  "6436": {
    "id": "6436",
    "name": "Емецк",
    "path": "Россия / Архангельская область / Емецк",
    "country": "Россия",
    "searchString": "емецк россия / архангельская область / емецк"
  },
  "6437": {
    "id": "6437",
    "name": "Катунино",
    "path": "Россия / Архангельская область / Катунино",
    "country": "Россия",
    "searchString": "катунино россия / архангельская область / катунино"
  },
  "6438": {
    "id": "6438",
    "name": "Конёво",
    "path": "Россия / Архангельская область / Конёво",
    "country": "Россия",
    "searchString": "конёво россия / архангельская область / конёво"
  },
  "6439": {
    "id": "6439",
    "name": "Пинега",
    "path": "Россия / Архангельская область / Пинега",
    "country": "Россия",
    "searchString": "пинега россия / архангельская область / пинега"
  },
  "6440": {
    "id": "6440",
    "name": "Уемский",
    "path": "Россия / Архангельская область / Уемский",
    "country": "Россия",
    "searchString": "уемский россия / архангельская область / уемский"
  },
  "6445": {
    "id": "6445",
    "name": "Партенит",
    "path": "Россия / Республика Крым / Партенит",
    "country": "Россия",
    "searchString": "партенит россия / республика крым / партенит"
  },
  "6446": {
    "id": "6446",
    "name": "Жанакорган",
    "path": "Казахстан / Жанакорган",
    "country": "Казахстан",
    "searchString": "жанакорган казахстан / жанакорган"
  },
  "6447": {
    "id": "6447",
    "name": "Асекеево",
    "path": "Россия / Оренбургская область / Асекеево",
    "country": "Россия",
    "searchString": "асекеево россия / оренбургская область / асекеево"
  },
  "6448": {
    "id": "6448",
    "name": "Центральноафриканская Республика",
    "path": "Другие регионы / Центральноафриканская Республика",
    "country": "Другие регионы",
    "searchString": "центральноафриканская республика другие регионы / центральноафриканская республика"
  },
  "6449": {
    "id": "6449",
    "name": "Оленино (Тверская область)",
    "path": "Россия / Тверская область / Оленино (Тверская область)",
    "country": "Россия",
    "searchString": "оленино (тверская область) россия / тверская область / оленино (тверская область)"
  },
  "6450": {
    "id": "6450",
    "name": "Жарковский (Тверская область)",
    "path": "Россия / Тверская область / Жарковский (Тверская область)",
    "country": "Россия",
    "searchString": "жарковский (тверская область) россия / тверская область / жарковский (тверская область)"
  },
  "6451": {
    "id": "6451",
    "name": "Фёдоровское (Ленинградская область)",
    "path": "Россия / Ленинградская область / Фёдоровское (Ленинградская область)",
    "country": "Россия",
    "searchString": "фёдоровское (ленинградская область) россия / ленинградская область / фёдоровское (ленинградская область)"
  },
  "6452": {
    "id": "6452",
    "name": "Манас",
    "path": "Россия / Республика Дагестан / Манас",
    "country": "Россия",
    "searchString": "манас россия / республика дагестан / манас"
  },
  "6453": {
    "id": "6453",
    "name": "Урджар",
    "path": "Казахстан / Урджар",
    "country": "Казахстан",
    "searchString": "урджар казахстан / урджар"
  },
  "6454": {
    "id": "6454",
    "name": "Радченко",
    "path": "Россия / Тверская область / Радченко",
    "country": "Россия",
    "searchString": "радченко россия / тверская область / радченко"
  },
  "6455": {
    "id": "6455",
    "name": "Яковлевка",
    "path": "Россия / Приморский край / Яковлевка",
    "country": "Россия",
    "searchString": "яковлевка россия / приморский край / яковлевка"
  },
  "6456": {
    "id": "6456",
    "name": "Стеклянный",
    "path": "Россия / Ленинградская область / Стеклянный",
    "country": "Россия",
    "searchString": "стеклянный россия / ленинградская область / стеклянный"
  },
  "6457": {
    "id": "6457",
    "name": "Васкелово",
    "path": "Россия / Ленинградская область / Васкелово",
    "country": "Россия",
    "searchString": "васкелово россия / ленинградская область / васкелово"
  },
  "6458": {
    "id": "6458",
    "name": "Сириус",
    "path": "Россия / Краснодарский край / Сириус",
    "country": "Россия",
    "searchString": "сириус россия / краснодарский край / сириус"
  },
  "6459": {
    "id": "6459",
    "name": "Сарыозек",
    "path": "Казахстан / Сарыозек",
    "country": "Казахстан",
    "searchString": "сарыозек казахстан / сарыозек"
  },
  "6460": {
    "id": "6460",
    "name": "Кабанбай",
    "path": "Казахстан / Кабанбай",
    "country": "Казахстан",
    "searchString": "кабанбай казахстан / кабанбай"
  },
  "6461": {
    "id": "6461",
    "name": "Каменское (Республика Крым)",
    "path": "Россия / Республика Крым / Каменское (Республика Крым)",
    "country": "Россия",
    "searchString": "каменское (республика крым) россия / республика крым / каменское (республика крым)"
  },
  "6462": {
    "id": "6462",
    "name": "Кутлу-Букаш",
    "path": "Россия / Республика Татарстан / Кутлу-Букаш",
    "country": "Россия",
    "searchString": "кутлу-букаш россия / республика татарстан / кутлу-букаш"
  },
  "6463": {
    "id": "6463",
    "name": "Большие Тарханы",
    "path": "Россия / Республика Татарстан / Большие Тарханы",
    "country": "Россия",
    "searchString": "большие тарханы россия / республика татарстан / большие тарханы"
  },
  "6464": {
    "id": "6464",
    "name": "Сёяха",
    "path": "Россия / Ямало-Ненецкий АО / Сёяха",
    "country": "Россия",
    "searchString": "сёяха россия / ямало-ненецкий ао / сёяха"
  },
  "6465": {
    "id": "6465",
    "name": "Усады",
    "path": "Россия / Республика Татарстан / Усады",
    "country": "Россия",
    "searchString": "усады россия / республика татарстан / усады"
  },
  "6466": {
    "id": "6466",
    "name": "Терволово",
    "path": "Россия / Ленинградская область / Терволово",
    "country": "Россия",
    "searchString": "терволово россия / ленинградская область / терволово"
  },
  "6467": {
    "id": "6467",
    "name": "Раздольное (Приморский край)",
    "path": "Россия / Приморский край / Раздольное (Приморский край)",
    "country": "Россия",
    "searchString": "раздольное (приморский край) россия / приморский край / раздольное (приморский край)"
  },
  "6468": {
    "id": "6468",
    "name": "Веселовка (Краснодарский край)",
    "path": "Россия / Краснодарский край / Веселовка (Краснодарский край)",
    "country": "Россия",
    "searchString": "веселовка (краснодарский край) россия / краснодарский край / веселовка (краснодарский край)"
  },
  "6469": {
    "id": "6469",
    "name": "Каменское (Камчатский край)",
    "path": "Россия / Камчатский край / Каменское (Камчатский край)",
    "country": "Россия",
    "searchString": "каменское (камчатский край) россия / камчатский край / каменское (камчатский край)"
  },
  "6470": {
    "id": "6470",
    "name": "Троицкое (Хабаровский край)",
    "path": "Россия / Хабаровский край / Троицкое (Хабаровский край)",
    "country": "Россия",
    "searchString": "троицкое (хабаровский край) россия / хабаровский край / троицкое (хабаровский край)"
  },
  "6471": {
    "id": "6471",
    "name": "Каражал",
    "path": "Казахстан / Каражал",
    "country": "Казахстан",
    "searchString": "каражал казахстан / каражал"
  },
  "6472": {
    "id": "6472",
    "name": "Чингирлау",
    "path": "Казахстан / Чингирлау",
    "country": "Казахстан",
    "searchString": "чингирлау казахстан / чингирлау"
  },
  "6473": {
    "id": "6473",
    "name": "Чапаево",
    "path": "Казахстан / Чапаево",
    "country": "Казахстан",
    "searchString": "чапаево казахстан / чапаево"
  },
  "6474": {
    "id": "6474",
    "name": "Таскала",
    "path": "Казахстан / Таскала",
    "country": "Казахстан",
    "searchString": "таскала казахстан / таскала"
  },
  "6475": {
    "id": "6475",
    "name": "Тайпак",
    "path": "Казахстан / Тайпак",
    "country": "Казахстан",
    "searchString": "тайпак казахстан / тайпак"
  },
  "6476": {
    "id": "6476",
    "name": "Сайхин",
    "path": "Казахстан / Сайхин",
    "country": "Казахстан",
    "searchString": "сайхин казахстан / сайхин"
  },
  "6477": {
    "id": "6477",
    "name": "Перемётное",
    "path": "Казахстан / Перемётное",
    "country": "Казахстан",
    "searchString": "перемётное казахстан / перемётное"
  },
  "6478": {
    "id": "6478",
    "name": "Каратобе",
    "path": "Казахстан / Каратобе",
    "country": "Казахстан",
    "searchString": "каратобе казахстан / каратобе"
  },
  "6479": {
    "id": "6479",
    "name": "Жымпиты",
    "path": "Казахстан / Жымпиты",
    "country": "Казахстан",
    "searchString": "жымпиты казахстан / жымпиты"
  },
  "6480": {
    "id": "6480",
    "name": "Солнечное (Глубоковский район)",
    "path": "Казахстан / Солнечное (Глубоковский район)",
    "country": "Казахстан",
    "searchString": "солнечное (глубоковский район) казахстан / солнечное (глубоковский район)"
  },
  "6481": {
    "id": "6481",
    "name": "Жанибек",
    "path": "Казахстан / Жанибек",
    "country": "Казахстан",
    "searchString": "жанибек казахстан / жанибек"
  },
  "6482": {
    "id": "6482",
    "name": "Жангала",
    "path": "Казахстан / Жангала",
    "country": "Казахстан",
    "searchString": "жангала казахстан / жангала"
  },
  "6483": {
    "id": "6483",
    "name": "Дарьинское",
    "path": "Казахстан / Дарьинское",
    "country": "Казахстан",
    "searchString": "дарьинское казахстан / дарьинское"
  },
  "6484": {
    "id": "6484",
    "name": "Сарыкемер",
    "path": "Казахстан / Сарыкемер",
    "country": "Казахстан",
    "searchString": "сарыкемер казахстан / сарыкемер"
  },
  "6485": {
    "id": "6485",
    "name": "Мойынкум",
    "path": "Казахстан / Мойынкум",
    "country": "Казахстан",
    "searchString": "мойынкум казахстан / мойынкум"
  },
  "6486": {
    "id": "6486",
    "name": "Мерке",
    "path": "Казахстан / Мерке",
    "country": "Казахстан",
    "searchString": "мерке казахстан / мерке"
  },
  "6487": {
    "id": "6487",
    "name": "Кулан",
    "path": "Казахстан / Кулан",
    "country": "Казахстан",
    "searchString": "кулан казахстан / кулан"
  },
  "6488": {
    "id": "6488",
    "name": "Бауыржан Момышулы",
    "path": "Казахстан / Бауыржан Момышулы",
    "country": "Казахстан",
    "searchString": "бауыржан момышулы казахстан / бауыржан момышулы"
  },
  "6489": {
    "id": "6489",
    "name": "Кореиз",
    "path": "Россия / Республика Крым / Кореиз",
    "country": "Россия",
    "searchString": "кореиз россия / республика крым / кореиз"
  },
  "6490": {
    "id": "6490",
    "name": "Никита (Республика Крым)",
    "path": "Россия / Республика Крым / Никита (Республика Крым)",
    "country": "Россия",
    "searchString": "никита (республика крым) россия / республика крым / никита (республика крым)"
  },
  "6491": {
    "id": "6491",
    "name": "Малокурильское",
    "path": "Россия / Сахалинская область / Малокурильское",
    "country": "Россия",
    "searchString": "малокурильское россия / сахалинская область / малокурильское"
  },
  "6492": {
    "id": "6492",
    "name": "Хунзах",
    "path": "Россия / Республика Дагестан / Хунзах",
    "country": "Россия",
    "searchString": "хунзах россия / республика дагестан / хунзах"
  },
  "6493": {
    "id": "6493",
    "name": "Аса",
    "path": "Казахстан / Аса",
    "country": "Казахстан",
    "searchString": "аса казахстан / аса"
  },
  "6494": {
    "id": "6494",
    "name": "Нарынкол",
    "path": "Казахстан / Нарынкол",
    "country": "Казахстан",
    "searchString": "нарынкол казахстан / нарынкол"
  },
  "6495": {
    "id": "6495",
    "name": "Кеген",
    "path": "Казахстан / Кеген",
    "country": "Казахстан",
    "searchString": "кеген казахстан / кеген"
  },
  "6496": {
    "id": "6496",
    "name": "Жансугуров",
    "path": "Казахстан / Жансугуров",
    "country": "Казахстан",
    "searchString": "жансугуров казахстан / жансугуров"
  },
  "6497": {
    "id": "6497",
    "name": "Балпык-Би",
    "path": "Казахстан / Балпык-Би",
    "country": "Казахстан",
    "searchString": "балпык-би казахстан / балпык-би"
  },
  "6498": {
    "id": "6498",
    "name": "Шолаккорган",
    "path": "Казахстан / Шолаккорган",
    "country": "Казахстан",
    "searchString": "шолаккорган казахстан / шолаккорган"
  },
  "6499": {
    "id": "6499",
    "name": "Шаян",
    "path": "Казахстан / Шаян",
    "country": "Казахстан",
    "searchString": "шаян казахстан / шаян"
  },
  "6500": {
    "id": "6500",
    "name": "Шаульдер",
    "path": "Казахстан / Шаульдер",
    "country": "Казахстан",
    "searchString": "шаульдер казахстан / шаульдер"
  },
  "6501": {
    "id": "6501",
    "name": "Рыскулово",
    "path": "Казахстан / Рыскулово",
    "country": "Казахстан",
    "searchString": "рыскулово казахстан / рыскулово"
  },
  "6502": {
    "id": "6502",
    "name": "Сайрам",
    "path": "Казахстан / Сайрам",
    "country": "Казахстан",
    "searchString": "сайрам казахстан / сайрам"
  },
  "6503": {
    "id": "6503",
    "name": "Мырзакент",
    "path": "Казахстан / Мырзакент",
    "country": "Казахстан",
    "searchString": "мырзакент казахстан / мырзакент"
  },
  "6504": {
    "id": "6504",
    "name": "Республика Сьерра-Леоне",
    "path": "Другие регионы / Республика Сьерра-Леоне",
    "country": "Другие регионы",
    "searchString": "республика сьерра-леоне другие регионы / республика сьерра-леоне"
  },
  "6505": {
    "id": "6505",
    "name": "Летка",
    "path": "Россия / Республика Коми / Летка",
    "country": "Россия",
    "searchString": "летка россия / республика коми / летка"
  },
  "6506": {
    "id": "6506",
    "name": "Светлогорск (Красноярский край)",
    "path": "Россия / Красноярский край / Светлогорск (Красноярский край)",
    "country": "Россия",
    "searchString": "светлогорск (красноярский край) россия / красноярский край / светлогорск (красноярский край)"
  },
  "6507": {
    "id": "6507",
    "name": "Октябрьский (Новосибирская область)",
    "path": "Россия / Новосибирская область / Октябрьский (Новосибирская область)",
    "country": "Россия",
    "searchString": "октябрьский (новосибирская область) россия / новосибирская область / октябрьский (новосибирская область)"
  },
  "6508": {
    "id": "6508",
    "name": "Левашово",
    "path": "Россия / Ярославская область / Левашово",
    "country": "Россия",
    "searchString": "левашово россия / ярославская область / левашово"
  },
  "6509": {
    "id": "6509",
    "name": "Казыгурт",
    "path": "Казахстан / Казыгурт",
    "country": "Казахстан",
    "searchString": "казыгурт казахстан / казыгурт"
  },
  "6510": {
    "id": "6510",
    "name": "Атакент",
    "path": "Казахстан / Атакент",
    "country": "Казахстан",
    "searchString": "атакент казахстан / атакент"
  },
  "6511": {
    "id": "6511",
    "name": "Асыката",
    "path": "Казахстан / Асыката",
    "country": "Казахстан",
    "searchString": "асыката казахстан / асыката"
  },
  "6512": {
    "id": "6512",
    "name": "Маканчи",
    "path": "Казахстан / Маканчи",
    "country": "Казахстан",
    "searchString": "маканчи казахстан / маканчи"
  },
  "6513": {
    "id": "6513",
    "name": "Кокпекты",
    "path": "Казахстан / Кокпекты",
    "country": "Казахстан",
    "searchString": "кокпекты казахстан / кокпекты"
  },
  "6514": {
    "id": "6514",
    "name": "Курск (Волосовский район, Ленинградская область)",
    "path": "Россия / Ленинградская область / Курск (Волосовский район, Ленинградская область)",
    "country": "Россия",
    "searchString": "курск (волосовский район, ленинградская область) россия / ленинградская область / курск (волосовский район, ленинградская область)"
  },
  "6515": {
    "id": "6515",
    "name": "Соузга",
    "path": "Россия / Алтайский край / Соузга",
    "country": "Россия",
    "searchString": "соузга россия / алтайский край / соузга"
  },
  "6516": {
    "id": "6516",
    "name": "Манжерок",
    "path": "Россия / Республика Алтай / Манжерок",
    "country": "Россия",
    "searchString": "манжерок россия / республика алтай / манжерок"
  },
  "6517": {
    "id": "6517",
    "name": "Джибути",
    "path": "Другие регионы / Джибути",
    "country": "Другие регионы",
    "searchString": "джибути другие регионы / джибути"
  },
  "6518": {
    "id": "6518",
    "name": "Мали",
    "path": "Другие регионы / Мали",
    "country": "Другие регионы",
    "searchString": "мали другие регионы / мали"
  },
  "6519": {
    "id": "6519",
    "name": "Смоленщина",
    "path": "Россия / Иркутская область / Смоленщина",
    "country": "Россия",
    "searchString": "смоленщина россия / иркутская область / смоленщина"
  },
  "6520": {
    "id": "6520",
    "name": "Зелёный (Московская область)",
    "path": "Россия / Московская область / Зелёный (Московская область)",
    "country": "Россия",
    "searchString": "зелёный (московская область) россия / московская область / зелёный (московская область)"
  },
  "6521": {
    "id": "6521",
    "name": "Острова Кайман",
    "path": "Другие регионы / Острова Кайман",
    "country": "Другие регионы",
    "searchString": "острова кайман другие регионы / острова кайман"
  },
  "6522": {
    "id": "6522",
    "name": "Покровское (городской округ Истра)",
    "path": "Россия / Московская область / Покровское (городской округ Истра)",
    "country": "Россия",
    "searchString": "покровское (городской округ истра) россия / московская область / покровское (городской округ истра)"
  },
  "6523": {
    "id": "6523",
    "name": "Ягодное (Самарская область)",
    "path": "Россия / Самарская область / Ягодное (Самарская область)",
    "country": "Россия",
    "searchString": "ягодное (самарская область) россия / самарская область / ягодное (самарская область)"
  },
  "6524": {
    "id": "6524",
    "name": "Шетпе",
    "path": "Казахстан / Шетпе",
    "country": "Казахстан",
    "searchString": "шетпе казахстан / шетпе"
  },
  "6525": {
    "id": "6525",
    "name": "Жетыбай (Мангистауская область)",
    "path": "Казахстан / Жетыбай (Мангистауская область)",
    "country": "Казахстан",
    "searchString": "жетыбай (мангистауская область) казахстан / жетыбай (мангистауская область)"
  },
  "6526": {
    "id": "6526",
    "name": "Вареновка",
    "path": "Россия / Ростовская область / Вареновка",
    "country": "Россия",
    "searchString": "вареновка россия / ростовская область / вареновка"
  },
  "6527": {
    "id": "6527",
    "name": "Воскресенское (Саратовская область)",
    "path": "Россия / Саратовская область / Воскресенское (Саратовская область)",
    "country": "Россия",
    "searchString": "воскресенское (саратовская область) россия / саратовская область / воскресенское (саратовская область)"
  },
  "6528": {
    "id": "6528",
    "name": "Калининец (Московская область)",
    "path": "Россия / Московская область / Калининец (Московская область)",
    "country": "Россия",
    "searchString": "калининец (московская область) россия / московская область / калининец (московская область)"
  },
  "6529": {
    "id": "6529",
    "name": "Астраханка",
    "path": "Казахстан / Астраханка",
    "country": "Казахстан",
    "searchString": "астраханка казахстан / астраханка"
  },
  "6530": {
    "id": "6530",
    "name": "Бея",
    "path": "Россия / Республика Хакасия / Бея",
    "country": "Россия",
    "searchString": "бея россия / республика хакасия / бея"
  },
  "6563": {
    "id": "6563",
    "name": "Милоградово",
    "path": "Россия / Приморский край / Милоградово",
    "country": "Россия",
    "searchString": "милоградово россия / приморский край / милоградово"
  },
  "6564": {
    "id": "6564",
    "name": "Кондоль",
    "path": "Россия / Пензенская область / Кондоль",
    "country": "Россия",
    "searchString": "кондоль россия / пензенская область / кондоль"
  },
  "6565": {
    "id": "6565",
    "name": "Махалино",
    "path": "Россия / Пензенская область / Махалино",
    "country": "Россия",
    "searchString": "махалино россия / пензенская область / махалино"
  },
  "6566": {
    "id": "6566",
    "name": "Дрожжино (Московская область)",
    "path": "Россия / Московская область / Дрожжино (Московская область)",
    "country": "Россия",
    "searchString": "дрожжино (московская область) россия / московская область / дрожжино (московская область)"
  },
  "6567": {
    "id": "6567",
    "name": "Ямкино (Московская область)",
    "path": "Россия / Московская область / Ямкино (Московская область)",
    "country": "Россия",
    "searchString": "ямкино (московская область) россия / московская область / ямкино (московская область)"
  },
  "6568": {
    "id": "6568",
    "name": "Городищи",
    "path": "Россия / Владимирская область / Городищи",
    "country": "Россия",
    "searchString": "городищи россия / владимирская область / городищи"
  },
  "6569": {
    "id": "6569",
    "name": "Черский",
    "path": "Россия / Республика Саха (Якутия) / Черский",
    "country": "Россия",
    "searchString": "черский россия / республика саха (якутия) / черский"
  },
  "6570": {
    "id": "6570",
    "name": "Молоково (Тверская область)",
    "path": "Россия / Тверская область / Молоково (Тверская область)",
    "country": "Россия",
    "searchString": "молоково (тверская область) россия / тверская область / молоково (тверская область)"
  },
  "6571": {
    "id": "6571",
    "name": "Шкотово",
    "path": "Россия / Приморский край / Шкотово",
    "country": "Россия",
    "searchString": "шкотово россия / приморский край / шкотово"
  },
  "6572": {
    "id": "6572",
    "name": "Прокудское",
    "path": "Россия / Новосибирская область / Прокудское",
    "country": "Россия",
    "searchString": "прокудское россия / новосибирская область / прокудское"
  },
  "6573": {
    "id": "6573",
    "name": "Евсино",
    "path": "Россия / Новосибирская область / Евсино",
    "country": "Россия",
    "searchString": "евсино россия / новосибирская область / евсино"
  },
  "6574": {
    "id": "6574",
    "name": "Барышево",
    "path": "Россия / Новосибирская область / Барышево",
    "country": "Россия",
    "searchString": "барышево россия / новосибирская область / барышево"
  },
  "6575": {
    "id": "6575",
    "name": "Мочище",
    "path": "Россия / Новосибирская область / Мочище",
    "country": "Россия",
    "searchString": "мочище россия / новосибирская область / мочище"
  },
  "6576": {
    "id": "6576",
    "name": "Смышляевка",
    "path": "Россия / Самарская область / Смышляевка",
    "country": "Россия",
    "searchString": "смышляевка россия / самарская область / смышляевка"
  },
  "6577": {
    "id": "6577",
    "name": "Усть-Кинельский",
    "path": "Россия / Самарская область / Усть-Кинельский",
    "country": "Россия",
    "searchString": "усть-кинельский россия / самарская область / усть-кинельский"
  },
  "6578": {
    "id": "6578",
    "name": "Солнечный (Красноярский край)",
    "path": "Россия / Красноярский край / Солнечный (Красноярский край)",
    "country": "Россия",
    "searchString": "солнечный (красноярский край) россия / красноярский край / солнечный (красноярский край)"
  },
  "6579": {
    "id": "6579",
    "name": "Ватутинки (Московская область)",
    "path": "Россия / Московская область / Ватутинки (Московская область)",
    "country": "Россия",
    "searchString": "ватутинки (московская область) россия / московская область / ватутинки (московская область)"
  },
  "6580": {
    "id": "6580",
    "name": "Кратово (Московская область)",
    "path": "Россия / Московская область / Кратово (Московская область)",
    "country": "Россия",
    "searchString": "кратово (московская область) россия / московская область / кратово (московская область)"
  },
  "6581": {
    "id": "6581",
    "name": "Курумоч",
    "path": "Россия / Самарская область / Курумоч",
    "country": "Россия",
    "searchString": "курумоч россия / самарская область / курумоч"
  },
  "6582": {
    "id": "6582",
    "name": "Садовое (Курганская область)",
    "path": "Россия / Курганская область / Садовое (Курганская область)",
    "country": "Россия",
    "searchString": "садовое (курганская область) россия / курганская область / садовое (курганская область)"
  },
  "6583": {
    "id": "6583",
    "name": "Рощинский",
    "path": "Россия / Самарская область / Рощинский",
    "country": "Россия",
    "searchString": "рощинский россия / самарская область / рощинский"
  },
  "6584": {
    "id": "6584",
    "name": "Отрадное (Республика Крым)",
    "path": "Россия / Республика Крым / Отрадное (Республика Крым)",
    "country": "Россия",
    "searchString": "отрадное (республика крым) россия / республика крым / отрадное (республика крым)"
  },
  "6585": {
    "id": "6585",
    "name": "Кольчугино (Республика Крым)",
    "path": "Россия / Республика Крым / Кольчугино (Республика Крым)",
    "country": "Россия",
    "searchString": "кольчугино (республика крым) россия / республика крым / кольчугино (республика крым)"
  },
  "6586": {
    "id": "6586",
    "name": "Металлплощадка",
    "path": "Россия / Кемеровская область / Металлплощадка",
    "country": "Россия",
    "searchString": "металлплощадка россия / кемеровская область / металлплощадка"
  },
  "6587": {
    "id": "6587",
    "name": "Лебедевка",
    "path": "Россия / Новосибирская область / Лебедевка",
    "country": "Россия",
    "searchString": "лебедевка россия / новосибирская область / лебедевка"
  },
  "6588": {
    "id": "6588",
    "name": "Глебовский  (Московская область)",
    "path": "Россия / Московская область / Глебовский  (Московская область)",
    "country": "Россия",
    "searchString": "глебовский  (московская область) россия / московская область / глебовский  (московская область)"
  },
  "6589": {
    "id": "6589",
    "name": "Столбовая (Московская область)",
    "path": "Россия / Московская область / Столбовая (Московская область)",
    "country": "Россия",
    "searchString": "столбовая (московская область) россия / московская область / столбовая (московская область)"
  },
  "6590": {
    "id": "6590",
    "name": "Кротовка",
    "path": "Россия / Самарская область / Кротовка",
    "country": "Россия",
    "searchString": "кротовка россия / самарская область / кротовка"
  },
  "6591": {
    "id": "6591",
    "name": "Богородское (Московская область)",
    "path": "Россия / Московская область / Богородское (Московская область)",
    "country": "Россия",
    "searchString": "богородское (московская область) россия / московская область / богородское (московская область)"
  },
  "6592": {
    "id": "6592",
    "name": "Ташкиново",
    "path": "Россия / Республика Башкортостан / Ташкиново",
    "country": "Россия",
    "searchString": "ташкиново россия / республика башкортостан / ташкиново"
  },
  "6593": {
    "id": "6593",
    "name": "Менделеево (Московская область)",
    "path": "Россия / Московская область / Менделеево (Московская область)",
    "country": "Россия",
    "searchString": "менделеево (московская область) россия / московская область / менделеево (московская область)"
  },
  "6594": {
    "id": "6594",
    "name": "Чернореченский",
    "path": "Россия / Новосибирская область / Чернореченский",
    "country": "Россия",
    "searchString": "чернореченский россия / новосибирская область / чернореченский"
  },
  "6595": {
    "id": "6595",
    "name": "Владимиро-Александровское",
    "path": "Россия / Приморский край / Владимиро-Александровское",
    "country": "Россия",
    "searchString": "владимиро-александровское россия / приморский край / владимиро-александровское"
  },
  "6596": {
    "id": "6596",
    "name": "Ленина (Краснодарский край)",
    "path": "Россия / Краснодарский край / Ленина (Краснодарский край)",
    "country": "Россия",
    "searchString": "ленина (краснодарский край) россия / краснодарский край / ленина (краснодарский край)"
  },
  "6597": {
    "id": "6597",
    "name": "Реммаш (Московская область)",
    "path": "Россия / Московская область / Реммаш (Московская область)",
    "country": "Россия",
    "searchString": "реммаш (московская область) россия / московская область / реммаш (московская область)"
  },
  "6598": {
    "id": "6598",
    "name": "Перово (Республика Крым)",
    "path": "Россия / Республика Крым / Перово (Республика Крым)",
    "country": "Россия",
    "searchString": "перово (республика крым) россия / республика крым / перово (республика крым)"
  },
  "6599": {
    "id": "6599",
    "name": "Хорлово (Московская область)",
    "path": "Россия / Московская область / Хорлово (Московская область)",
    "country": "Россия",
    "searchString": "хорлово (московская область) россия / московская область / хорлово (московская область)"
  },
  "6600": {
    "id": "6600",
    "name": "Никологоры",
    "path": "Россия / Владимирская область / Никологоры",
    "country": "Россия",
    "searchString": "никологоры россия / владимирская область / никологоры"
  },
  "6601": {
    "id": "6601",
    "name": "Мелехово (Владимирская область)",
    "path": "Россия / Владимирская область / Мелехово (Владимирская область)",
    "country": "Россия",
    "searchString": "мелехово (владимирская область) россия / владимирская область / мелехово (владимирская область)"
  },
  "6602": {
    "id": "6602",
    "name": "Рождествено",
    "path": "Россия / Самарская область / Рождествено",
    "country": "Россия",
    "searchString": "рождествено россия / самарская область / рождествено"
  },
  "6603": {
    "id": "6603",
    "name": "Новый Городок (Одинцовский район)",
    "path": "Россия / Московская область / Новый Городок (Одинцовский район)",
    "country": "Россия",
    "searchString": "новый городок (одинцовский район) россия / московская область / новый городок (одинцовский район)"
  },
  "6604": {
    "id": "6604",
    "name": "Сосновка (Кемеровская область)",
    "path": "Россия / Кемеровская область / Сосновка (Кемеровская область)",
    "country": "Россия",
    "searchString": "сосновка (кемеровская область) россия / кемеровская область / сосновка (кемеровская область)"
  },
  "6605": {
    "id": "6605",
    "name": "Восход (Республика Крым)",
    "path": "Россия / Республика Крым / Восход (Республика Крым)",
    "country": "Россия",
    "searchString": "восход (республика крым) россия / республика крым / восход (республика крым)"
  },
  "6606": {
    "id": "6606",
    "name": "Орджоникидзе (Республика Крым)",
    "path": "Россия / Республика Крым / Орджоникидзе (Республика Крым)",
    "country": "Россия",
    "searchString": "орджоникидзе (республика крым) россия / республика крым / орджоникидзе (республика крым)"
  },
  "6607": {
    "id": "6607",
    "name": "Казачьи Лагери",
    "path": "Россия / Ростовская область / Казачьи Лагери",
    "country": "Россия",
    "searchString": "казачьи лагери россия / ростовская область / казачьи лагери"
  },
  "6608": {
    "id": "6608",
    "name": "ЛМС (Московская область)",
    "path": "Россия / Московская область / ЛМС (Московская область)",
    "country": "Россия",
    "searchString": "лмс (московская область) россия / московская область / лмс (московская область)"
  },
  "6609": {
    "id": "6609",
    "name": "Гагарский",
    "path": "Россия / Свердловская область / Гагарский",
    "country": "Россия",
    "searchString": "гагарский россия / свердловская область / гагарский"
  },
  "6610": {
    "id": "6610",
    "name": "Екатериновка (Самарская область)",
    "path": "Россия / Самарская область / Екатериновка (Самарская область)",
    "country": "Россия",
    "searchString": "екатериновка (самарская область) россия / самарская область / екатериновка (самарская область)"
  },
  "6611": {
    "id": "6611",
    "name": "Полтавка (Республика Крым)",
    "path": "Россия / Республика Крым / Полтавка (Республика Крым)",
    "country": "Россия",
    "searchString": "полтавка (республика крым) россия / республика крым / полтавка (республика крым)"
  },
  "6612": {
    "id": "6612",
    "name": "Вилино",
    "path": "Россия / Республика Крым / Вилино",
    "country": "Россия",
    "searchString": "вилино россия / республика крым / вилино"
  },
  "6613": {
    "id": "6613",
    "name": "Доброе (Республика Крым)",
    "path": "Россия / Республика Крым / Доброе (Республика Крым)",
    "country": "Россия",
    "searchString": "доброе (республика крым) россия / республика крым / доброе (республика крым)"
  },
  "6614": {
    "id": "6614",
    "name": "Приветное (Кировский район)",
    "path": "Россия / Республика Крым / Приветное (Кировский район)",
    "country": "Россия",
    "searchString": "приветное (кировский район) россия / республика крым / приветное (кировский район)"
  },
  "6615": {
    "id": "6615",
    "name": "Советское (Республика Крым)",
    "path": "Россия / Республика Крым / Советское (Республика Крым)",
    "country": "Россия",
    "searchString": "советское (республика крым) россия / республика крым / советское (республика крым)"
  },
  "6616": {
    "id": "6616",
    "name": "Хантайское Озеро",
    "path": "Россия / Красноярский край / Хантайское Озеро",
    "country": "Россия",
    "searchString": "хантайское озеро россия / красноярский край / хантайское озеро"
  },
  "6617": {
    "id": "6617",
    "name": "Субханкулово",
    "path": "Россия / Республика Башкортостан / Субханкулово",
    "country": "Россия",
    "searchString": "субханкулово россия / республика башкортостан / субханкулово"
  },
  "6618": {
    "id": "6618",
    "name": "Спасское (Приморский край)",
    "path": "Россия / Приморский край / Спасское (Приморский край)",
    "country": "Россия",
    "searchString": "спасское (приморский край) россия / приморский край / спасское (приморский край)"
  },
  "6619": {
    "id": "6619",
    "name": "Утёвка (Самарская область)",
    "path": "Россия / Самарская область / Утёвка (Самарская область)",
    "country": "Россия",
    "searchString": "утёвка (самарская область) россия / самарская область / утёвка (самарская область)"
  },
  "6620": {
    "id": "6620",
    "name": "Скоропусковский (Московская область)",
    "path": "Россия / Московская область / Скоропусковский (Московская область)",
    "country": "Россия",
    "searchString": "скоропусковский (московская область) россия / московская область / скоропусковский (московская область)"
  },
  "6621": {
    "id": "6621",
    "name": "Кедровка (Свердловская область)",
    "path": "Россия / Свердловская область / Кедровка (Свердловская область)",
    "country": "Россия",
    "searchString": "кедровка (свердловская область) россия / свердловская область / кедровка (свердловская область)"
  },
  "6622": {
    "id": "6622",
    "name": "Усланка",
    "path": "Россия / Курская область / Усланка",
    "country": "Россия",
    "searchString": "усланка россия / курская область / усланка"
  },
  "6623": {
    "id": "6623",
    "name": "Витино",
    "path": "Россия / Республика Крым / Витино",
    "country": "Россия",
    "searchString": "витино россия / республика крым / витино"
  },
  "6624": {
    "id": "6624",
    "name": "Дунай",
    "path": "Россия / Приморский край / Дунай",
    "country": "Россия",
    "searchString": "дунай россия / приморский край / дунай"
  },
  "6625": {
    "id": "6625",
    "name": "Старый Городок (Одинцовский район)",
    "path": "Россия / Московская область / Старый Городок (Одинцовский район)",
    "country": "Россия",
    "searchString": "старый городок (одинцовский район) россия / московская область / старый городок (одинцовский район)"
  },
  "6626": {
    "id": "6626",
    "name": "Григорово",
    "path": "Россия / Новгородская область / Григорово",
    "country": "Россия",
    "searchString": "григорово россия / новгородская область / григорово"
  },
  "6627": {
    "id": "6627",
    "name": "Успенское (Московская область)",
    "path": "Россия / Московская область / Успенское (Московская область)",
    "country": "Россия",
    "searchString": "успенское (московская область) россия / московская область / успенское (московская область)"
  },
  "6628": {
    "id": "6628",
    "name": "Юкки",
    "path": "Россия / Ленинградская область / Юкки",
    "country": "Россия",
    "searchString": "юкки россия / ленинградская область / юкки"
  },
  "6629": {
    "id": "6629",
    "name": "Новосёловское",
    "path": "Россия / Республика Крым / Новосёловское",
    "country": "Россия",
    "searchString": "новосёловское россия / республика крым / новосёловское"
  },
  "6630": {
    "id": "6630",
    "name": "Орехово",
    "path": "Россия / Республика Крым / Орехово",
    "country": "Россия",
    "searchString": "орехово россия / республика крым / орехово"
  },
  "6631": {
    "id": "6631",
    "name": "Тамбовка (Республика Крым)",
    "path": "Россия / Республика Крым / Тамбовка (Республика Крым)",
    "country": "Россия",
    "searchString": "тамбовка (республика крым) россия / республика крым / тамбовка (республика крым)"
  },
  "6632": {
    "id": "6632",
    "name": "Мишкинская",
    "path": "Россия / Ростовская область / Мишкинская",
    "country": "Россия",
    "searchString": "мишкинская россия / ростовская область / мишкинская"
  },
  "6633": {
    "id": "6633",
    "name": "Соколовый",
    "path": "Россия / Саратовская область / Соколовый",
    "country": "Россия",
    "searchString": "соколовый россия / саратовская область / соколовый"
  },
  "6634": {
    "id": "6634",
    "name": "Стромынь (Московская область)",
    "path": "Россия / Московская область / Стромынь (Московская область)",
    "country": "Россия",
    "searchString": "стромынь (московская область) россия / московская область / стромынь (московская область)"
  },
  "6635": {
    "id": "6635",
    "name": "Сарга",
    "path": "Россия / Свердловская область / Сарга",
    "country": "Россия",
    "searchString": "сарга россия / свердловская область / сарга"
  },
  "6636": {
    "id": "6636",
    "name": "Половинное (Новосибирская область)",
    "path": "Россия / Новосибирская область / Половинное (Новосибирская область)",
    "country": "Россия",
    "searchString": "половинное (новосибирская область) россия / новосибирская область / половинное (новосибирская область)"
  },
  "6637": {
    "id": "6637",
    "name": "Красный Восток (Новосибирская область)",
    "path": "Россия / Новосибирская область / Красный Восток (Новосибирская область)",
    "country": "Россия",
    "searchString": "красный восток (новосибирская область) россия / новосибирская область / красный восток (новосибирская область)"
  },
  "6638": {
    "id": "6638",
    "name": "Григорьевское (Пермский край)",
    "path": "Россия / Пермский край / Григорьевское (Пермский край)",
    "country": "Россия",
    "searchString": "григорьевское (пермский край) россия / пермский край / григорьевское (пермский край)"
  },
  "6639": {
    "id": "6639",
    "name": "Колчедан",
    "path": "Россия / Свердловская область / Колчедан",
    "country": "Россия",
    "searchString": "колчедан россия / свердловская область / колчедан"
  },
  "6640": {
    "id": "6640",
    "name": "Менделеево (Пермский край)",
    "path": "Россия / Пермский край / Менделеево (Пермский край)",
    "country": "Россия",
    "searchString": "менделеево (пермский край) россия / пермский край / менделеево (пермский край)"
  },
  "6641": {
    "id": "6641",
    "name": "Пуровск",
    "path": "Россия / Ямало-Ненецкий АО / Пуровск",
    "country": "Россия",
    "searchString": "пуровск россия / ямало-ненецкий ао / пуровск"
  },
  "6642": {
    "id": "6642",
    "name": "Дубовый Умет",
    "path": "Россия / Самарская область / Дубовый Умет",
    "country": "Россия",
    "searchString": "дубовый умет россия / самарская область / дубовый умет"
  },
  "6643": {
    "id": "6643",
    "name": "Калиново",
    "path": "Россия / Свердловская область / Калиново",
    "country": "Россия",
    "searchString": "калиново россия / свердловская область / калиново"
  },
  "6644": {
    "id": "6644",
    "name": "Азовское",
    "path": "Россия / Республика Крым / Азовское",
    "country": "Россия",
    "searchString": "азовское россия / республика крым / азовское"
  },
  "6645": {
    "id": "6645",
    "name": "Желябовка",
    "path": "Россия / Республика Крым / Желябовка",
    "country": "Россия",
    "searchString": "желябовка россия / республика крым / желябовка"
  },
  "6646": {
    "id": "6646",
    "name": "Кача",
    "path": "Россия / Республика Крым / Кача",
    "country": "Россия",
    "searchString": "кача россия / республика крым / кача"
  },
  "6647": {
    "id": "6647",
    "name": "Комсомольское (Республика Крым)",
    "path": "Россия / Республика Крым / Комсомольское (Республика Крым)",
    "country": "Россия",
    "searchString": "комсомольское (республика крым) россия / республика крым / комсомольское (республика крым)"
  },
  "6648": {
    "id": "6648",
    "name": "Массандра",
    "path": "Россия / Республика Крым / Массандра",
    "country": "Россия",
    "searchString": "массандра россия / республика крым / массандра"
  },
  "6649": {
    "id": "6649",
    "name": "Понизовка",
    "path": "Россия / Республика Крым / Понизовка",
    "country": "Россия",
    "searchString": "понизовка россия / республика крым / понизовка"
  },
  "6650": {
    "id": "6650",
    "name": "Чкалово",
    "path": "Россия / Республика Крым / Чкалово",
    "country": "Россия",
    "searchString": "чкалово россия / республика крым / чкалово"
  },
  "6651": {
    "id": "6651",
    "name": "Придонской",
    "path": "Россия / Воронежская область / Придонской",
    "country": "Россия",
    "searchString": "придонской россия / воронежская область / придонской"
  },
  "6652": {
    "id": "6652",
    "name": "Заброды",
    "path": "Россия / Воронежская область / Заброды",
    "country": "Россия",
    "searchString": "заброды россия / воронежская область / заброды"
  },
  "6653": {
    "id": "6653",
    "name": "Сабик",
    "path": "Россия / Свердловская область / Сабик",
    "country": "Россия",
    "searchString": "сабик россия / свердловская область / сабик"
  },
  "6654": {
    "id": "6654",
    "name": "Илим",
    "path": "Россия / Свердловская область / Илим",
    "country": "Россия",
    "searchString": "илим россия / свердловская область / илим"
  },
  "6655": {
    "id": "6655",
    "name": "Елховка (Самарская область)",
    "path": "Россия / Самарская область / Елховка (Самарская область)",
    "country": "Россия",
    "searchString": "елховка (самарская область) россия / самарская область / елховка (самарская область)"
  },
  "6656": {
    "id": "6656",
    "name": "Элитный (Новосибирская область)",
    "path": "Россия / Новосибирская область / Элитный (Новосибирская область)",
    "country": "Россия",
    "searchString": "элитный (новосибирская область) россия / новосибирская область / элитный (новосибирская область)"
  },
  "6657": {
    "id": "6657",
    "name": "Введенщина",
    "path": "Россия / Иркутская область / Введенщина",
    "country": "Россия",
    "searchString": "введенщина россия / иркутская область / введенщина"
  },
  "6658": {
    "id": "6658",
    "name": "Родина",
    "path": "Россия / Псковская область / Родина",
    "country": "Россия",
    "searchString": "родина россия / псковская область / родина"
  },
  "6659": {
    "id": "6659",
    "name": "Аять",
    "path": "Россия / Свердловская область / Аять",
    "country": "Россия",
    "searchString": "аять россия / свердловская область / аять"
  },
  "6660": {
    "id": "6660",
    "name": "Хиттолово",
    "path": "Россия / Ленинградская область / Хиттолово",
    "country": "Россия",
    "searchString": "хиттолово россия / ленинградская область / хиттолово"
  },
  "6661": {
    "id": "6661",
    "name": "Геройское",
    "path": "Россия / Республика Крым / Геройское",
    "country": "Россия",
    "searchString": "геройское россия / республика крым / геройское"
  },
  "6662": {
    "id": "6662",
    "name": "Журавки",
    "path": "Россия / Республика Крым / Журавки",
    "country": "Россия",
    "searchString": "журавки россия / республика крым / журавки"
  },
  "6663": {
    "id": "6663",
    "name": "Кацивели",
    "path": "Россия / Республика Крым / Кацивели",
    "country": "Россия",
    "searchString": "кацивели россия / республика крым / кацивели"
  },
  "6664": {
    "id": "6664",
    "name": "Крымское",
    "path": "Россия / Республика Крым / Крымское",
    "country": "Россия",
    "searchString": "крымское россия / республика крым / крымское"
  },
  "6665": {
    "id": "6665",
    "name": "Межводное",
    "path": "Россия / Республика Крым / Межводное",
    "country": "Россия",
    "searchString": "межводное россия / республика крым / межводное"
  },
  "6666": {
    "id": "6666",
    "name": "Новоозерное",
    "path": "Россия / Республика Крым / Новоозерное",
    "country": "Россия",
    "searchString": "новоозерное россия / республика крым / новоозерное"
  },
  "6667": {
    "id": "6667",
    "name": "Новосельское",
    "path": "Россия / Республика Крым / Новосельское",
    "country": "Россия",
    "searchString": "новосельское россия / республика крым / новосельское"
  },
  "6668": {
    "id": "6668",
    "name": "Останино",
    "path": "Россия / Республика Крым / Останино",
    "country": "Россия",
    "searchString": "останино россия / республика крым / останино"
  },
  "6669": {
    "id": "6669",
    "name": "Песчаное",
    "path": "Россия / Республика Крым / Песчаное",
    "country": "Россия",
    "searchString": "песчаное россия / республика крым / песчаное"
  },
  "6670": {
    "id": "6670",
    "name": "Пионерское",
    "path": "Россия / Республика Крым / Пионерское",
    "country": "Россия",
    "searchString": "пионерское россия / республика крым / пионерское"
  },
  "6671": {
    "id": "6671",
    "name": "Прибрежное",
    "path": "Россия / Республика Крым / Прибрежное",
    "country": "Россия",
    "searchString": "прибрежное россия / республика крым / прибрежное"
  },
  "6672": {
    "id": "6672",
    "name": "Садовое (Республика Крым)",
    "path": "Россия / Республика Крым / Садовое (Республика Крым)",
    "country": "Россия",
    "searchString": "садовое (республика крым) россия / республика крым / садовое (республика крым)"
  },
  "6673": {
    "id": "6673",
    "name": "Топольное",
    "path": "Россия / Республика Крым / Топольное",
    "country": "Россия",
    "searchString": "топольное россия / республика крым / топольное"
  },
  "6674": {
    "id": "6674",
    "name": "Фонтаны",
    "path": "Россия / Республика Крым / Фонтаны",
    "country": "Россия",
    "searchString": "фонтаны россия / республика крым / фонтаны"
  },
  "6675": {
    "id": "6675",
    "name": "Чистополье",
    "path": "Россия / Республика Крым / Чистополье",
    "country": "Россия",
    "searchString": "чистополье россия / республика крым / чистополье"
  },
  "6676": {
    "id": "6676",
    "name": "Волочанка",
    "path": "Россия / Красноярский край / Волочанка",
    "country": "Россия",
    "searchString": "волочанка россия / красноярский край / волочанка"
  },
  "6677": {
    "id": "6677",
    "name": "Мессояха",
    "path": "Россия / Красноярский край / Мессояха",
    "country": "Россия",
    "searchString": "мессояха россия / красноярский край / мессояха"
  },
  "6678": {
    "id": "6678",
    "name": "Потапов",
    "path": "Россия / Ростовская область / Потапов",
    "country": "Россия",
    "searchString": "потапов россия / ростовская область / потапов"
  },
  "6679": {
    "id": "6679",
    "name": "Большевик (Московская область)",
    "path": "Россия / Московская область / Большевик (Московская область)",
    "country": "Россия",
    "searchString": "большевик (московская область) россия / московская область / большевик (московская область)"
  },
  "6680": {
    "id": "6680",
    "name": "Сывдарма",
    "path": "Россия / Ямало-Ненецкий АО / Сывдарма",
    "country": "Россия",
    "searchString": "сывдарма россия / ямало-ненецкий ао / сывдарма"
  },
  "6681": {
    "id": "6681",
    "name": "Спутник",
    "path": "Россия / Мурманская область / Спутник",
    "country": "Россия",
    "searchString": "спутник россия / мурманская область / спутник"
  },
  "6682": {
    "id": "6682",
    "name": "Балашейка",
    "path": "Россия / Самарская область / Балашейка",
    "country": "Россия",
    "searchString": "балашейка россия / самарская область / балашейка"
  },
  "6683": {
    "id": "6683",
    "name": "Осинки",
    "path": "Россия / Самарская область / Осинки",
    "country": "Россия",
    "searchString": "осинки россия / самарская область / осинки"
  },
  "6684": {
    "id": "6684",
    "name": "Верхняя Подстепновка",
    "path": "Россия / Самарская область / Верхняя Подстепновка",
    "country": "Россия",
    "searchString": "верхняя подстепновка россия / самарская область / верхняя подстепновка"
  },
  "6685": {
    "id": "6685",
    "name": "Васильевка (Самарская область)",
    "path": "Россия / Самарская область / Васильевка (Самарская область)",
    "country": "Россия",
    "searchString": "васильевка (самарская область) россия / самарская область / васильевка (самарская область)"
  },
  "6686": {
    "id": "6686",
    "name": "Иннолово",
    "path": "Россия / Ленинградская область / Иннолово",
    "country": "Россия",
    "searchString": "иннолово россия / ленинградская область / иннолово"
  },
  "6687": {
    "id": "6687",
    "name": "Бисер",
    "path": "Россия / Пермский край / Бисер",
    "country": "Россия",
    "searchString": "бисер россия / пермский край / бисер"
  },
  "6688": {
    "id": "6688",
    "name": "Умёт",
    "path": "Россия / Тамбовская область / Умёт",
    "country": "Россия",
    "searchString": "умёт россия / тамбовская область / умёт"
  },
  "6689": {
    "id": "6689",
    "name": "Таврово",
    "path": "Россия / Белгородская область / Таврово",
    "country": "Россия",
    "searchString": "таврово россия / белгородская область / таврово"
  },
  "6690": {
    "id": "6690",
    "name": "Таватуй",
    "path": "Россия / Свердловская область / Таватуй",
    "country": "Россия",
    "searchString": "таватуй россия / свердловская область / таватуй"
  },
  "6691": {
    "id": "6691",
    "name": "Мурзинка",
    "path": "Россия / Свердловская область / Мурзинка",
    "country": "Россия",
    "searchString": "мурзинка россия / свердловская область / мурзинка"
  },
  "6692": {
    "id": "6692",
    "name": "Аграрное",
    "path": "Россия / Республика Крым / Аграрное",
    "country": "Россия",
    "searchString": "аграрное россия / республика крым / аграрное"
  },
  "6693": {
    "id": "6693",
    "name": "Аэрофлотский",
    "path": "Россия / Республика Крым / Аэрофлотский",
    "country": "Россия",
    "searchString": "аэрофлотский россия / республика крым / аэрофлотский"
  },
  "6694": {
    "id": "6694",
    "name": "Багерово",
    "path": "Россия / Республика Крым / Багерово",
    "country": "Россия",
    "searchString": "багерово россия / республика крым / багерово"
  },
  "6695": {
    "id": "6695",
    "name": "Белоглинка",
    "path": "Россия / Республика Крым / Белоглинка",
    "country": "Россия",
    "searchString": "белоглинка россия / республика крым / белоглинка"
  },
  "6696": {
    "id": "6696",
    "name": "Ближнее",
    "path": "Россия / Республика Крым / Ближнее",
    "country": "Россия",
    "searchString": "ближнее россия / республика крым / ближнее"
  },
  "6697": {
    "id": "6697",
    "name": "Бондаренково",
    "path": "Россия / Республика Крым / Бондаренково",
    "country": "Россия",
    "searchString": "бондаренково россия / республика крым / бондаренково"
  },
  "6698": {
    "id": "6698",
    "name": "Верхнесадовое",
    "path": "Россия / Республика Крым / Верхнесадовое",
    "country": "Россия",
    "searchString": "верхнесадовое россия / республика крым / верхнесадовое"
  },
  "6699": {
    "id": "6699",
    "name": "Виноградное (Алушта)",
    "path": "Россия / Республика Крым / Виноградное (Алушта)",
    "country": "Россия",
    "searchString": "виноградное (алушта) россия / республика крым / виноградное (алушта)"
  },
  "6700": {
    "id": "6700",
    "name": "Войково",
    "path": "Россия / Республика Крым / Войково",
    "country": "Россия",
    "searchString": "войково россия / республика крым / войково"
  },
  "6701": {
    "id": "6701",
    "name": "Голубой Залив",
    "path": "Россия / Республика Крым / Голубой Залив",
    "country": "Россия",
    "searchString": "голубой залив россия / республика крым / голубой залив"
  },
  "6702": {
    "id": "6702",
    "name": "Далёкое",
    "path": "Россия / Республика Крым / Далёкое",
    "country": "Россия",
    "searchString": "далёкое россия / республика крым / далёкое"
  },
  "6703": {
    "id": "6703",
    "name": "Днепровка",
    "path": "Россия / Республика Крым / Днепровка",
    "country": "Россия",
    "searchString": "днепровка россия / республика крым / днепровка"
  },
  "6704": {
    "id": "6704",
    "name": "Донское (Республика Крым)",
    "path": "Россия / Республика Крым / Донское (Республика Крым)",
    "country": "Россия",
    "searchString": "донское (республика крым) россия / республика крым / донское (республика крым)"
  },
  "6705": {
    "id": "6705",
    "name": "Заозёрное",
    "path": "Россия / Республика Крым / Заозёрное",
    "country": "Россия",
    "searchString": "заозёрное россия / республика крым / заозёрное"
  },
  "6706": {
    "id": "6706",
    "name": "Калиновка (Республика Крым)",
    "path": "Россия / Республика Крым / Калиновка (Республика Крым)",
    "country": "Россия",
    "searchString": "калиновка (республика крым) россия / республика крым / калиновка (республика крым)"
  },
  "6707": {
    "id": "6707",
    "name": "Каменоломня",
    "path": "Россия / Республика Крым / Каменоломня",
    "country": "Россия",
    "searchString": "каменоломня россия / республика крым / каменоломня"
  },
  "6708": {
    "id": "6708",
    "name": "Карьерное",
    "path": "Россия / Республика Крым / Карьерное",
    "country": "Россия",
    "searchString": "карьерное россия / республика крым / карьерное"
  },
  "6709": {
    "id": "6709",
    "name": "Краснокаменка",
    "path": "Россия / Республика Крым / Краснокаменка",
    "country": "Россия",
    "searchString": "краснокаменка россия / республика крым / краснокаменка"
  },
  "6710": {
    "id": "6710",
    "name": "Куйбышево (Республика Крым)",
    "path": "Россия / Республика Крым / Куйбышево (Республика Крым)",
    "country": "Россия",
    "searchString": "куйбышево (республика крым) россия / республика крым / куйбышево (республика крым)"
  },
  "6711": {
    "id": "6711",
    "name": "Курпаты",
    "path": "Россия / Республика Крым / Курпаты",
    "country": "Россия",
    "searchString": "курпаты россия / республика крым / курпаты"
  },
  "6712": {
    "id": "6712",
    "name": "Ливадия (Республика Крым)",
    "path": "Россия / Республика Крым / Ливадия (Республика Крым)",
    "country": "Россия",
    "searchString": "ливадия (республика крым) россия / республика крым / ливадия (республика крым)"
  },
  "6713": {
    "id": "6713",
    "name": "Мазанка",
    "path": "Россия / Республика Крым / Мазанка",
    "country": "Россия",
    "searchString": "мазанка россия / республика крым / мазанка"
  },
  "6714": {
    "id": "6714",
    "name": "Малореченское",
    "path": "Россия / Республика Крым / Малореченское",
    "country": "Россия",
    "searchString": "малореченское россия / республика крым / малореченское"
  },
  "6715": {
    "id": "6715",
    "name": "Малый Маяк",
    "path": "Россия / Республика Крым / Малый Маяк",
    "country": "Россия",
    "searchString": "малый маяк россия / республика крым / малый маяк"
  },
  "6716": {
    "id": "6716",
    "name": "Марфовка",
    "path": "Россия / Республика Крым / Марфовка",
    "country": "Россия",
    "searchString": "марфовка россия / республика крым / марфовка"
  },
  "6717": {
    "id": "6717",
    "name": "Молодежное",
    "path": "Россия / Республика Крым / Молодежное",
    "country": "Россия",
    "searchString": "молодежное россия / республика крым / молодежное"
  },
  "6718": {
    "id": "6718",
    "name": "Мраморное",
    "path": "Россия / Республика Крым / Мраморное",
    "country": "Россия",
    "searchString": "мраморное россия / республика крым / мраморное"
  },
  "6719": {
    "id": "6719",
    "name": "Олива",
    "path": "Россия / Республика Крым / Олива",
    "country": "Россия",
    "searchString": "олива россия / республика крым / олива"
  },
  "6720": {
    "id": "6720",
    "name": "Парковое (Республика Крым)",
    "path": "Россия / Республика Крым / Парковое (Республика Крым)",
    "country": "Россия",
    "searchString": "парковое (республика крым) россия / республика крым / парковое (республика крым)"
  },
  "6721": {
    "id": "6721",
    "name": "Перевальное",
    "path": "Россия / Республика Крым / Перевальное",
    "country": "Россия",
    "searchString": "перевальное россия / республика крым / перевальное"
  },
  "6722": {
    "id": "6722",
    "name": "Петровка",
    "path": "Россия / Республика Крым / Петровка",
    "country": "Россия",
    "searchString": "петровка россия / республика крым / петровка"
  },
  "6723": {
    "id": "6723",
    "name": "Пожарское",
    "path": "Россия / Республика Крым / Пожарское",
    "country": "Россия",
    "searchString": "пожарское россия / республика крым / пожарское"
  },
  "6724": {
    "id": "6724",
    "name": "Почтовое",
    "path": "Россия / Республика Крым / Почтовое",
    "country": "Россия",
    "searchString": "почтовое россия / республика крым / почтовое"
  },
  "6725": {
    "id": "6725",
    "name": "Приозёрное",
    "path": "Россия / Республика Крым / Приозёрное",
    "country": "Россия",
    "searchString": "приозёрное россия / республика крым / приозёрное"
  },
  "6726": {
    "id": "6726",
    "name": "Родниково",
    "path": "Россия / Республика Крым / Родниково",
    "country": "Россия",
    "searchString": "родниково россия / республика крым / родниково"
  },
  "6727": {
    "id": "6727",
    "name": "Роздольное",
    "path": "Россия / Республика Крым / Роздольное",
    "country": "Россия",
    "searchString": "роздольное россия / республика крым / роздольное"
  },
  "6728": {
    "id": "6728",
    "name": "Сенокосное",
    "path": "Россия / Республика Крым / Сенокосное",
    "country": "Россия",
    "searchString": "сенокосное россия / республика крым / сенокосное"
  },
  "6729": {
    "id": "6729",
    "name": "Скалистое",
    "path": "Россия / Республика Крым / Скалистое",
    "country": "Россия",
    "searchString": "скалистое россия / республика крым / скалистое"
  },
  "6730": {
    "id": "6730",
    "name": "Скворцово (Республика Крым)",
    "path": "Россия / Республика Крым / Скворцово (Республика Крым)",
    "country": "Россия",
    "searchString": "скворцово (республика крым) россия / республика крым / скворцово (республика крым)"
  },
  "6731": {
    "id": "6731",
    "name": "Укромное",
    "path": "Россия / Республика Крым / Укромное",
    "country": "Россия",
    "searchString": "укромное россия / республика крым / укромное"
  },
  "6732": {
    "id": "6732",
    "name": "Чайкино (Республика Крым)",
    "path": "Россия / Республика Крым / Чайкино (Республика Крым)",
    "country": "Россия",
    "searchString": "чайкино (республика крым) россия / республика крым / чайкино (республика крым)"
  },
  "6733": {
    "id": "6733",
    "name": "Щебетовка",
    "path": "Россия / Республика Крым / Щебетовка",
    "country": "Россия",
    "searchString": "щебетовка россия / республика крым / щебетовка"
  },
  "6734": {
    "id": "6734",
    "name": "Янтарное",
    "path": "Россия / Республика Крым / Янтарное",
    "country": "Россия",
    "searchString": "янтарное россия / республика крым / янтарное"
  },
  "6735": {
    "id": "6735",
    "name": "Кумово",
    "path": "Россия / Республика Башкортостан / Кумово",
    "country": "Россия",
    "searchString": "кумово россия / республика башкортостан / кумово"
  },
  "6736": {
    "id": "6736",
    "name": "Потапово",
    "path": "Россия / Красноярский край / Потапово",
    "country": "Россия",
    "searchString": "потапово россия / красноярский край / потапово"
  },
  "6737": {
    "id": "6737",
    "name": "Усть-Кемь",
    "path": "Россия / Красноярский край / Усть-Кемь",
    "country": "Россия",
    "searchString": "усть-кемь россия / красноярский край / усть-кемь"
  },
  "6738": {
    "id": "6738",
    "name": "Воздвиженка",
    "path": "Россия / Приморский край / Воздвиженка",
    "country": "Россия",
    "searchString": "воздвиженка россия / приморский край / воздвиженка"
  },
  "6739": {
    "id": "6739",
    "name": "Алачково (Московская область)",
    "path": "Россия / Московская область / Алачково (Московская область)",
    "country": "Россия",
    "searchString": "алачково (московская область) россия / московская область / алачково (московская область)"
  },
  "6740": {
    "id": "6740",
    "name": "Петровский",
    "path": "Россия / Ивановская область / Петровский",
    "country": "Россия",
    "searchString": "петровский россия / ивановская область / петровский"
  },
  "6741": {
    "id": "6741",
    "name": "Алабуга (Челябинская область)",
    "path": "Россия / Челябинская область / Алабуга (Челябинская область)",
    "country": "Россия",
    "searchString": "алабуга (челябинская область) россия / челябинская область / алабуга (челябинская область)"
  },
  "6742": {
    "id": "6742",
    "name": "Сахтыш",
    "path": "Россия / Ивановская область / Сахтыш",
    "country": "Россия",
    "searchString": "сахтыш россия / ивановская область / сахтыш"
  },
  "6743": {
    "id": "6743",
    "name": "Майский (Тюменская область)",
    "path": "Россия / Тюменская область / Майский (Тюменская область)",
    "country": "Россия",
    "searchString": "майский (тюменская область) россия / тюменская область / майский (тюменская область)"
  },
  "6744": {
    "id": "6744",
    "name": "Бруснятское",
    "path": "Россия / Свердловская область / Бруснятское",
    "country": "Россия",
    "searchString": "бруснятское россия / свердловская область / бруснятское"
  },
  "6745": {
    "id": "6745",
    "name": "Брянка (Красноярский край)",
    "path": "Россия / Красноярский край / Брянка (Красноярский край)",
    "country": "Россия",
    "searchString": "брянка (красноярский край) россия / красноярский край / брянка (красноярский край)"
  },
  "6746": {
    "id": "6746",
    "name": "Верхнемарково",
    "path": "Россия / Иркутская область / Верхнемарково",
    "country": "Россия",
    "searchString": "верхнемарково россия / иркутская область / верхнемарково"
  },
  "6747": {
    "id": "6747",
    "name": "Междуреченск (Самарская область)",
    "path": "Россия / Самарская область / Междуреченск (Самарская область)",
    "country": "Россия",
    "searchString": "междуреченск (самарская область) россия / самарская область / междуреченск (самарская область)"
  },
  "6748": {
    "id": "6748",
    "name": "Ширяево (Самарская область)",
    "path": "Россия / Самарская область / Ширяево (Самарская область)",
    "country": "Россия",
    "searchString": "ширяево (самарская область) россия / самарская область / ширяево (самарская область)"
  },
  "6749": {
    "id": "6749",
    "name": "Малая Царевщина",
    "path": "Россия / Самарская область / Малая Царевщина",
    "country": "Россия",
    "searchString": "малая царевщина россия / самарская область / малая царевщина"
  },
  "6750": {
    "id": "6750",
    "name": "Пеники",
    "path": "Россия / Ленинградская область / Пеники",
    "country": "Россия",
    "searchString": "пеники россия / ленинградская область / пеники"
  },
  "6751": {
    "id": "6751",
    "name": "Разбегаево (Ленинградская область)",
    "path": "Россия / Ленинградская область / Разбегаево (Ленинградская область)",
    "country": "Россия",
    "searchString": "разбегаево (ленинградская область) россия / ленинградская область / разбегаево (ленинградская область)"
  },
  "6752": {
    "id": "6752",
    "name": "Заглядино",
    "path": "Россия / Оренбургская область / Заглядино",
    "country": "Россия",
    "searchString": "заглядино россия / оренбургская область / заглядино"
  },
  "6753": {
    "id": "6753",
    "name": "Новый Мултан",
    "path": "Россия / Удмуртская Республика / Новый Мултан",
    "country": "Россия",
    "searchString": "новый мултан россия / удмуртская республика / новый мултан"
  },
  "6754": {
    "id": "6754",
    "name": "Лонгъюган",
    "path": "Россия / Ямало-Ненецкий АО / Лонгъюган",
    "country": "Россия",
    "searchString": "лонгъюган россия / ямало-ненецкий ао / лонгъюган"
  },
  "6755": {
    "id": "6755",
    "name": "Новый Кременкуль",
    "path": "Россия / Челябинская область / Новый Кременкуль",
    "country": "Россия",
    "searchString": "новый кременкуль россия / челябинская область / новый кременкуль"
  },
  "6756": {
    "id": "6756",
    "name": "Сагра",
    "path": "Россия / Свердловская область / Сагра",
    "country": "Россия",
    "searchString": "сагра россия / свердловская область / сагра"
  },
  "6757": {
    "id": "6757",
    "name": "Газ-Сале",
    "path": "Россия / Ямало-Ненецкий АО / Газ-Сале",
    "country": "Россия",
    "searchString": "газ-сале россия / ямало-ненецкий ао / газ-сале"
  },
  "6758": {
    "id": "6758",
    "name": "Тикси",
    "path": "Россия / Республика Саха (Якутия) / Тикси",
    "country": "Россия",
    "searchString": "тикси россия / республика саха (якутия) / тикси"
  },
  "6759": {
    "id": "6759",
    "name": "Усть-Абакан",
    "path": "Россия / Республика Хакасия / Усть-Абакан",
    "country": "Россия",
    "searchString": "усть-абакан россия / республика хакасия / усть-абакан"
  },
  "6760": {
    "id": "6760",
    "name": "Мирный (Московская область, Люберецкий район)",
    "path": "Россия / Московская область / Мирный (Московская область, Люберецкий район)",
    "country": "Россия",
    "searchString": "мирный (московская область, люберецкий район) россия / московская область / мирный (московская область, люберецкий район)"
  },
  "6761": {
    "id": "6761",
    "name": "Панаевск",
    "path": "Россия / Ямало-Ненецкий АО / Панаевск",
    "country": "Россия",
    "searchString": "панаевск россия / ямало-ненецкий ао / панаевск"
  },
  "6762": {
    "id": "6762",
    "name": "Салемал",
    "path": "Россия / Ямало-Ненецкий АО / Салемал",
    "country": "Россия",
    "searchString": "салемал россия / ямало-ненецкий ао / салемал"
  },
  "6763": {
    "id": "6763",
    "name": "Мещерское (Московская область)",
    "path": "Россия / Московская область / Мещерское (Московская область)",
    "country": "Россия",
    "searchString": "мещерское (московская область) россия / московская область / мещерское (московская область)"
  },
  "6764": {
    "id": "6764",
    "name": "Таштып",
    "path": "Россия / Республика Хакасия / Таштып",
    "country": "Россия",
    "searchString": "таштып россия / республика хакасия / таштып"
  },
  "6765": {
    "id": "6765",
    "name": "Белый Яр (Республика Хакасия)",
    "path": "Россия / Республика Хакасия / Белый Яр (Республика Хакасия)",
    "country": "Россия",
    "searchString": "белый яр (республика хакасия) россия / республика хакасия / белый яр (республика хакасия)"
  },
  "6766": {
    "id": "6766",
    "name": "Романово (Пермский край)",
    "path": "Россия / Пермский край / Романово (Пермский край)",
    "country": "Россия",
    "searchString": "романово (пермский край) россия / пермский край / романово (пермский край)"
  },
  "6767": {
    "id": "6767",
    "name": "Нагаево",
    "path": "Россия / Республика Башкортостан / Нагаево",
    "country": "Россия",
    "searchString": "нагаево россия / республика башкортостан / нагаево"
  },
  "6768": {
    "id": "6768",
    "name": "Найстенъярви",
    "path": "Россия / Республика Карелия / Найстенъярви",
    "country": "Россия",
    "searchString": "найстенъярви россия / республика карелия / найстенъярви"
  },
  "6769": {
    "id": "6769",
    "name": "Дрокино",
    "path": "Россия / Красноярский край / Дрокино",
    "country": "Россия",
    "searchString": "дрокино россия / красноярский край / дрокино"
  },
  "6770": {
    "id": "6770",
    "name": "Галанино",
    "path": "Россия / Красноярский край / Галанино",
    "country": "Россия",
    "searchString": "галанино россия / красноярский край / галанино"
  },
  "6771": {
    "id": "6771",
    "name": "Семёновское (Московская область)",
    "path": "Россия / Московская область / Семёновское (Московская область)",
    "country": "Россия",
    "searchString": "семёновское (московская область) россия / московская область / семёновское (московская область)"
  },
  "6772": {
    "id": "6772",
    "name": "Михановичи",
    "path": "Беларусь / Минская область / Михановичи",
    "country": "Беларусь",
    "searchString": "михановичи беларусь / минская область / михановичи"
  },
  "6773": {
    "id": "6773",
    "name": "Андреевка (Хасанский район)",
    "path": "Россия / Приморский край / Андреевка (Хасанский район)",
    "country": "Россия",
    "searchString": "андреевка (хасанский район) россия / приморский край / андреевка (хасанский район)"
  },
  "6774": {
    "id": "6774",
    "name": "Батагай",
    "path": "Россия / Республика Саха (Якутия) / Батагай",
    "country": "Россия",
    "searchString": "батагай россия / республика саха (якутия) / батагай"
  },
  "6775": {
    "id": "6775",
    "name": "Объячево",
    "path": "Россия / Республика Коми / Объячево",
    "country": "Россия",
    "searchString": "объячево россия / республика коми / объячево"
  },
  "6776": {
    "id": "6776",
    "name": "Заволжское (Астраханская область)",
    "path": "Россия / Астраханская область / Заволжское (Астраханская область)",
    "country": "Россия",
    "searchString": "заволжское (астраханская область) россия / астраханская область / заволжское (астраханская область)"
  },
  "6777": {
    "id": "6777",
    "name": "Первомайское (Московская область)",
    "path": "Россия / Московская область / Первомайское (Московская область)",
    "country": "Россия",
    "searchString": "первомайское (московская область) россия / московская область / первомайское (московская область)"
  },
  "6778": {
    "id": "6778",
    "name": "Боровской",
    "path": "Казахстан / Боровской",
    "country": "Казахстан",
    "searchString": "боровской казахстан / боровской"
  },
  "6779": {
    "id": "6779",
    "name": "Сарыколь",
    "path": "Казахстан / Сарыколь",
    "country": "Казахстан",
    "searchString": "сарыколь казахстан / сарыколь"
  },
  "6780": {
    "id": "6780",
    "name": "Кушмурун",
    "path": "Казахстан / Кушмурун",
    "country": "Казахстан",
    "searchString": "кушмурун казахстан / кушмурун"
  },
  "6781": {
    "id": "6781",
    "name": "Фёдоровка",
    "path": "Казахстан / Фёдоровка",
    "country": "Казахстан",
    "searchString": "фёдоровка казахстан / фёдоровка"
  },
  "6782": {
    "id": "6782",
    "name": "Айет",
    "path": "Казахстан / Айет",
    "country": "Казахстан",
    "searchString": "айет казахстан / айет"
  },
  "6783": {
    "id": "6783",
    "name": "Братский",
    "path": "Россия / Краснодарский край / Братский",
    "country": "Россия",
    "searchString": "братский россия / краснодарский край / братский"
  },
  "6784": {
    "id": "6784",
    "name": "Кубринск",
    "path": "Россия / Ярославская область / Кубринск",
    "country": "Россия",
    "searchString": "кубринск россия / ярославская область / кубринск"
  },
  "6785": {
    "id": "6785",
    "name": "Стародворцовский",
    "path": "Россия / Ставропольский край / Стародворцовский",
    "country": "Россия",
    "searchString": "стародворцовский россия / ставропольский край / стародворцовский"
  },
  "6786": {
    "id": "6786",
    "name": "Катунки",
    "path": "Россия / Нижегородская область / Катунки",
    "country": "Россия",
    "searchString": "катунки россия / нижегородская область / катунки"
  },
  "6787": {
    "id": "6787",
    "name": "Тёмкино",
    "path": "Россия / Смоленская область / Тёмкино",
    "country": "Россия",
    "searchString": "тёмкино россия / смоленская область / тёмкино"
  },
  "6788": {
    "id": "6788",
    "name": "Бармино",
    "path": "Россия / Нижегородская область / Бармино",
    "country": "Россия",
    "searchString": "бармино россия / нижегородская область / бармино"
  },
  "6789": {
    "id": "6789",
    "name": "Новая Деревня (Ставропольский край)",
    "path": "Россия / Ставропольский край / Новая Деревня (Ставропольский край)",
    "country": "Россия",
    "searchString": "новая деревня (ставропольский край) россия / ставропольский край / новая деревня (ставропольский край)"
  },
  "6790": {
    "id": "6790",
    "name": "Божковка",
    "path": "Россия / Ростовская область / Божковка",
    "country": "Россия",
    "searchString": "божковка россия / ростовская область / божковка"
  },
  "6791": {
    "id": "6791",
    "name": "Курджипская",
    "path": "Россия / Республика Адыгея / Курджипская",
    "country": "Россия",
    "searchString": "курджипская россия / республика адыгея / курджипская"
  },
  "6792": {
    "id": "6792",
    "name": "Новозарянский",
    "path": "Россия / Ростовская область / Новозарянский",
    "country": "Россия",
    "searchString": "новозарянский россия / ростовская область / новозарянский"
  },
  "6793": {
    "id": "6793",
    "name": "Берендеево",
    "path": "Россия / Ярославская область / Берендеево",
    "country": "Россия",
    "searchString": "берендеево россия / ярославская область / берендеево"
  },
  "6794": {
    "id": "6794",
    "name": "Колобово (Ивановская область)",
    "path": "Россия / Ивановская область / Колобово (Ивановская область)",
    "country": "Россия",
    "searchString": "колобово (ивановская область) россия / ивановская область / колобово (ивановская область)"
  },
  "6795": {
    "id": "6795",
    "name": "Киреевка",
    "path": "Россия / Ростовская область / Киреевка",
    "country": "Россия",
    "searchString": "киреевка россия / ростовская область / киреевка"
  },
  "6796": {
    "id": "6796",
    "name": "Рахманово (Московская область)",
    "path": "Россия / Московская область / Рахманово (Московская область)",
    "country": "Россия",
    "searchString": "рахманово (московская область) россия / московская область / рахманово (московская область)"
  },
  "6797": {
    "id": "6797",
    "name": "Бессергеневская",
    "path": "Россия / Ростовская область / Бессергеневская",
    "country": "Россия",
    "searchString": "бессергеневская россия / ростовская область / бессергеневская"
  },
  "6798": {
    "id": "6798",
    "name": "Архиповка",
    "path": "Россия / Ивановская область / Архиповка",
    "country": "Россия",
    "searchString": "архиповка россия / ивановская область / архиповка"
  },
  "6799": {
    "id": "6799",
    "name": "Карпуниха",
    "path": "Россия / Нижегородская область / Карпуниха",
    "country": "Россия",
    "searchString": "карпуниха россия / нижегородская область / карпуниха"
  },
  "6800": {
    "id": "6800",
    "name": "Большое Череватово",
    "path": "Россия / Нижегородская область / Большое Череватово",
    "country": "Россия",
    "searchString": "большое череватово россия / нижегородская область / большое череватово"
  },
  "6801": {
    "id": "6801",
    "name": "Опенки",
    "path": "Россия / Ростовская область / Опенки",
    "country": "Россия",
    "searchString": "опенки россия / ростовская область / опенки"
  },
  "6802": {
    "id": "6802",
    "name": "Бетта",
    "path": "Россия / Краснодарский край / Бетта",
    "country": "Россия",
    "searchString": "бетта россия / краснодарский край / бетта"
  },
  "6803": {
    "id": "6803",
    "name": "Конезавод имени Буденного",
    "path": "Россия / Ростовская область / Конезавод имени Буденного",
    "country": "Россия",
    "searchString": "конезавод имени буденного россия / ростовская область / конезавод имени буденного"
  },
  "6804": {
    "id": "6804",
    "name": "Вербочки",
    "path": "Россия / Ростовская область / Вербочки",
    "country": "Россия",
    "searchString": "вербочки россия / ростовская область / вербочки"
  },
  "6805": {
    "id": "6805",
    "name": "Хрипуново",
    "path": "Россия / Нижегородская область / Хрипуново",
    "country": "Россия",
    "searchString": "хрипуново россия / нижегородская область / хрипуново"
  },
  "6806": {
    "id": "6806",
    "name": "Октябрьское (Рязанская область)",
    "path": "Россия / Рязанская область / Октябрьское (Рязанская область)",
    "country": "Россия",
    "searchString": "октябрьское (рязанская область) россия / рязанская область / октябрьское (рязанская область)"
  },
  "6807": {
    "id": "6807",
    "name": "Новопетровское (Московская область)",
    "path": "Россия / Московская область / Новопетровское (Московская область)",
    "country": "Россия",
    "searchString": "новопетровское (московская область) россия / московская область / новопетровское (московская область)"
  },
  "6808": {
    "id": "6808",
    "name": "Большая Аря",
    "path": "Россия / Нижегородская область / Большая Аря",
    "country": "Россия",
    "searchString": "большая аря россия / нижегородская область / большая аря"
  },
  "6809": {
    "id": "6809",
    "name": "Неверово",
    "path": "Россия / Нижегородская область / Неверово",
    "country": "Россия",
    "searchString": "неверово россия / нижегородская область / неверово"
  },
  "6810": {
    "id": "6810",
    "name": "Большое Судачье",
    "path": "Россия / Волгоградская область / Большое Судачье",
    "country": "Россия",
    "searchString": "большое судачье россия / волгоградская область / большое судачье"
  },
  "6811": {
    "id": "6811",
    "name": "Терса",
    "path": "Россия / Волгоградская область / Терса",
    "country": "Россия",
    "searchString": "терса россия / волгоградская область / терса"
  },
  "6812": {
    "id": "6812",
    "name": "Островская",
    "path": "Россия / Волгоградская область / Островская",
    "country": "Россия",
    "searchString": "островская россия / волгоградская область / островская"
  },
  "6813": {
    "id": "6813",
    "name": "Киреево (Волгоградская область)",
    "path": "Россия / Волгоградская область / Киреево (Волгоградская область)",
    "country": "Россия",
    "searchString": "киреево (волгоградская область) россия / волгоградская область / киреево (волгоградская область)"
  },
  "6814": {
    "id": "6814",
    "name": "Песковатка",
    "path": "Россия / Волгоградская область / Песковатка",
    "country": "Россия",
    "searchString": "песковатка россия / волгоградская область / песковатка"
  },
  "6815": {
    "id": "6815",
    "name": "Лозное",
    "path": "Россия / Волгоградская область / Лозное",
    "country": "Россия",
    "searchString": "лозное россия / волгоградская область / лозное"
  },
  "6816": {
    "id": "6816",
    "name": "Дубовое (Волгоградская область)",
    "path": "Россия / Волгоградская область / Дубовое (Волгоградская область)",
    "country": "Россия",
    "searchString": "дубовое (волгоградская область) россия / волгоградская область / дубовое (волгоградская область)"
  },
  "6817": {
    "id": "6817",
    "name": "Ляпичев",
    "path": "Россия / Волгоградская область / Ляпичев",
    "country": "Россия",
    "searchString": "ляпичев россия / волгоградская область / ляпичев"
  },
  "6818": {
    "id": "6818",
    "name": "Вязовка",
    "path": "Россия / Волгоградская область / Вязовка",
    "country": "Россия",
    "searchString": "вязовка россия / волгоградская область / вязовка"
  },
  "6819": {
    "id": "6819",
    "name": "Агуй-Шапсуг",
    "path": "Россия / Краснодарский край / Агуй-Шапсуг",
    "country": "Россия",
    "searchString": "агуй-шапсуг россия / краснодарский край / агуй-шапсуг"
  },
  "6820": {
    "id": "6820",
    "name": "Липицы (Московская область)",
    "path": "Россия / Московская область / Липицы (Московская область)",
    "country": "Россия",
    "searchString": "липицы (московская область) россия / московская область / липицы (московская область)"
  },
  "6821": {
    "id": "6821",
    "name": "Угодичи",
    "path": "Россия / Ярославская область / Угодичи",
    "country": "Россия",
    "searchString": "угодичи россия / ярославская область / угодичи"
  },
  "6822": {
    "id": "6822",
    "name": "Упорниковская",
    "path": "Россия / Волгоградская область / Упорниковская",
    "country": "Россия",
    "searchString": "упорниковская россия / волгоградская область / упорниковская"
  },
  "6823": {
    "id": "6823",
    "name": "Купанское",
    "path": "Россия / Ярославская область / Купанское",
    "country": "Россия",
    "searchString": "купанское россия / ярославская область / купанское"
  },
  "6824": {
    "id": "6824",
    "name": "Водный",
    "path": "Россия / Краснодарский край / Водный",
    "country": "Россия",
    "searchString": "водный россия / краснодарский край / водный"
  },
  "6825": {
    "id": "6825",
    "name": "Марьино",
    "path": "Россия / Краснодарский край / Марьино",
    "country": "Россия",
    "searchString": "марьино россия / краснодарский край / марьино"
  },
  "6826": {
    "id": "6826",
    "name": "Лосево (Краснодарский край)",
    "path": "Россия / Краснодарский край / Лосево (Краснодарский край)",
    "country": "Россия",
    "searchString": "лосево (краснодарский край) россия / краснодарский край / лосево (краснодарский край)"
  },
  "6827": {
    "id": "6827",
    "name": "Старочеркасская",
    "path": "Россия / Ростовская область / Старочеркасская",
    "country": "Россия",
    "searchString": "старочеркасская россия / ростовская область / старочеркасская"
  },
  "6828": {
    "id": "6828",
    "name": "Марьинский",
    "path": "Россия / Краснодарский край / Марьинский",
    "country": "Россия",
    "searchString": "марьинский россия / краснодарский край / марьинский"
  },
  "6829": {
    "id": "6829",
    "name": "Алексеевский",
    "path": "Россия / Краснодарский край / Алексеевский",
    "country": "Россия",
    "searchString": "алексеевский россия / краснодарский край / алексеевский"
  },
  "6830": {
    "id": "6830",
    "name": "Судай",
    "path": "Россия / Костромская область / Судай",
    "country": "Россия",
    "searchString": "судай россия / костромская область / судай"
  },
  "6831": {
    "id": "6831",
    "name": "Варегово",
    "path": "Россия / Ярославская область / Варегово",
    "country": "Россия",
    "searchString": "варегово россия / ярославская область / варегово"
  },
  "6832": {
    "id": "6832",
    "name": "Новоперсиановка",
    "path": "Россия / Ростовская область / Новоперсиановка",
    "country": "Россия",
    "searchString": "новоперсиановка россия / ростовская область / новоперсиановка"
  },
  "6833": {
    "id": "6833",
    "name": "Первомайский (Краснодарский край)",
    "path": "Россия / Краснодарский край / Первомайский (Краснодарский край)",
    "country": "Россия",
    "searchString": "первомайский (краснодарский край) россия / краснодарский край / первомайский (краснодарский край)"
  },
  "6834": {
    "id": "6834",
    "name": "Северный (Нижегородская область)",
    "path": "Россия / Нижегородская область / Северный (Нижегородская область)",
    "country": "Россия",
    "searchString": "северный (нижегородская область) россия / нижегородская область / северный (нижегородская область)"
  },
  "6835": {
    "id": "6835",
    "name": "Верхний Балыклей",
    "path": "Россия / Волгоградская область / Верхний Балыклей",
    "country": "Россия",
    "searchString": "верхний балыклей россия / волгоградская область / верхний балыклей"
  },
  "6836": {
    "id": "6836",
    "name": "Покровка (Волгоградская область)",
    "path": "Россия / Волгоградская область / Покровка (Волгоградская область)",
    "country": "Россия",
    "searchString": "покровка (волгоградская область) россия / волгоградская область / покровка (волгоградская область)"
  },
  "6837": {
    "id": "6837",
    "name": "Комсомольский (Краснодарский край)",
    "path": "Россия / Краснодарский край / Комсомольский (Краснодарский край)",
    "country": "Россия",
    "searchString": "комсомольский (краснодарский край) россия / краснодарский край / комсомольский (краснодарский край)"
  },
  "6838": {
    "id": "6838",
    "name": "Кременская",
    "path": "Россия / Волгоградская область / Кременская",
    "country": "Россия",
    "searchString": "кременская россия / волгоградская область / кременская"
  },
  "6839": {
    "id": "6839",
    "name": "Степной",
    "path": "Россия / Волгоградская область / Степной",
    "country": "Россия",
    "searchString": "степной россия / волгоградская область / степной"
  },
  "6840": {
    "id": "6840",
    "name": "Красногорняцкий",
    "path": "Россия / Ростовская область / Красногорняцкий",
    "country": "Россия",
    "searchString": "красногорняцкий россия / ростовская область / красногорняцкий"
  },
  "6841": {
    "id": "6841",
    "name": "Ветлужский (Нижегородская область)",
    "path": "Россия / Нижегородская область / Ветлужский (Нижегородская область)",
    "country": "Россия",
    "searchString": "ветлужский (нижегородская область) россия / нижегородская область / ветлужский (нижегородская область)"
  },
  "6842": {
    "id": "6842",
    "name": "Ляпино (Краснодарский край)",
    "path": "Россия / Краснодарский край / Ляпино (Краснодарский край)",
    "country": "Россия",
    "searchString": "ляпино (краснодарский край) россия / краснодарский край / ляпино (краснодарский край)"
  },
  "6843": {
    "id": "6843",
    "name": "Царев",
    "path": "Россия / Волгоградская область / Царев",
    "country": "Россия",
    "searchString": "царев россия / волгоградская область / царев"
  },
  "6844": {
    "id": "6844",
    "name": "Сергиевская",
    "path": "Россия / Волгоградская область / Сергиевская",
    "country": "Россия",
    "searchString": "сергиевская россия / волгоградская область / сергиевская"
  },
  "6845": {
    "id": "6845",
    "name": "Костино-Быстрянский",
    "path": "Россия / Ростовская область / Костино-Быстрянский",
    "country": "Россия",
    "searchString": "костино-быстрянский россия / ростовская область / костино-быстрянский"
  },
  "6846": {
    "id": "6846",
    "name": "Минское",
    "path": "Россия / Костромская область / Минское",
    "country": "Россия",
    "searchString": "минское россия / костромская область / минское"
  },
  "6847": {
    "id": "6847",
    "name": "Пролетарское",
    "path": "Россия / Кабардино-Балкарская республика / Пролетарское",
    "country": "Россия",
    "searchString": "пролетарское россия / кабардино-балкарская республика / пролетарское"
  },
  "6848": {
    "id": "6848",
    "name": "Раздольное (Республика Северная Осетия-Алания)",
    "path": "Россия / Республика Северная Осетия-Алания / Раздольное (Республика Северная Осетия-Алания)",
    "country": "Россия",
    "searchString": "раздольное (республика северная осетия-алания) россия / республика северная осетия-алания / раздольное (республика северная осетия-алания)"
  },
  "6849": {
    "id": "6849",
    "name": "Поречье (Московская область)",
    "path": "Россия / Московская область / Поречье (Московская область)",
    "country": "Россия",
    "searchString": "поречье (московская область) россия / московская область / поречье (московская область)"
  },
  "6850": {
    "id": "6850",
    "name": "Жуково-Татарский",
    "path": "Россия / Ростовская область / Жуково-Татарский",
    "country": "Россия",
    "searchString": "жуково-татарский россия / ростовская область / жуково-татарский"
  },
  "6851": {
    "id": "6851",
    "name": "Табачный",
    "path": "Россия / Республика Адыгея / Табачный",
    "country": "Россия",
    "searchString": "табачный россия / республика адыгея / табачный"
  },
  "6852": {
    "id": "6852",
    "name": "Манычская",
    "path": "Россия / Ростовская область / Манычская",
    "country": "Россия",
    "searchString": "манычская россия / ростовская область / манычская"
  },
  "6853": {
    "id": "6853",
    "name": "Логовский",
    "path": "Россия / Волгоградская область / Логовский",
    "country": "Россия",
    "searchString": "логовский россия / волгоградская область / логовский"
  },
  "6854": {
    "id": "6854",
    "name": "Арчединская",
    "path": "Россия / Волгоградская область / Арчединская",
    "country": "Россия",
    "searchString": "арчединская россия / волгоградская область / арчединская"
  },
  "6855": {
    "id": "6855",
    "name": "Шурскол",
    "path": "Россия / Ярославская область / Шурскол",
    "country": "Россия",
    "searchString": "шурскол россия / ярославская область / шурскол"
  },
  "6856": {
    "id": "6856",
    "name": "Керчик-Савров",
    "path": "Россия / Ростовская область / Керчик-Савров",
    "country": "Россия",
    "searchString": "керчик-савров россия / ростовская область / керчик-савров"
  },
  "6857": {
    "id": "6857",
    "name": "Нижнедонской",
    "path": "Россия / Ростовская область / Нижнедонской",
    "country": "Россия",
    "searchString": "нижнедонской россия / ростовская область / нижнедонской"
  },
  "6858": {
    "id": "6858",
    "name": "Алексеевка (Ростовская область)",
    "path": "Россия / Ростовская область / Алексеевка (Ростовская область)",
    "country": "Россия",
    "searchString": "алексеевка (ростовская область) россия / ростовская область / алексеевка (ростовская область)"
  },
  "6859": {
    "id": "6859",
    "name": "Стефанидинодар",
    "path": "Россия / Ростовская область / Стефанидинодар",
    "country": "Россия",
    "searchString": "стефанидинодар россия / ростовская область / стефанидинодар"
  },
  "6860": {
    "id": "6860",
    "name": "Глинка",
    "path": "Россия / Смоленская область / Глинка",
    "country": "Россия",
    "searchString": "глинка россия / смоленская область / глинка"
  },
  "6861": {
    "id": "6861",
    "name": "Конобеево (Московская область)",
    "path": "Россия / Московская область / Конобеево (Московская область)",
    "country": "Россия",
    "searchString": "конобеево (московская область) россия / московская область / конобеево (московская область)"
  },
  "6862": {
    "id": "6862",
    "name": "Молодёжный (Краснодарский край)",
    "path": "Россия / Краснодарский край / Молодёжный (Краснодарский край)",
    "country": "Россия",
    "searchString": "молодёжный (краснодарский край) россия / краснодарский край / молодёжный (краснодарский край)"
  },
  "6863": {
    "id": "6863",
    "name": "Беломечётская",
    "path": "Россия / Ставропольский край / Беломечётская",
    "country": "Россия",
    "searchString": "беломечётская россия / ставропольский край / беломечётская"
  },
  "6864": {
    "id": "6864",
    "name": "Румянцево (Московская область)",
    "path": "Россия / Московская область / Румянцево (Московская область)",
    "country": "Россия",
    "searchString": "румянцево (московская область) россия / московская область / румянцево (московская область)"
  },
  "6865": {
    "id": "6865",
    "name": "Курсаково (Московская область)",
    "path": "Россия / Московская область / Курсаково (Московская область)",
    "country": "Россия",
    "searchString": "курсаково (московская область) россия / московская область / курсаково (московская область)"
  },
  "6866": {
    "id": "6866",
    "name": "Лучинское (Московская область)",
    "path": "Россия / Московская область / Лучинское (Московская область)",
    "country": "Россия",
    "searchString": "лучинское (московская область) россия / московская область / лучинское (московская область)"
  },
  "6867": {
    "id": "6867",
    "name": "Агрогородок  (Московская область)",
    "path": "Россия / Московская область / Агрогородок  (Московская область)",
    "country": "Россия",
    "searchString": "агрогородок  (московская область) россия / московская область / агрогородок  (московская область)"
  },
  "6868": {
    "id": "6868",
    "name": "Другое",
    "path": "Другие регионы / Другое",
    "country": "Другие регионы",
    "searchString": "другое другие регионы / другое"
  },
  "6869": {
    "id": "6869",
    "name": "Миндерла",
    "path": "Россия / Красноярский край / Миндерла",
    "country": "Россия",
    "searchString": "миндерла россия / красноярский край / миндерла"
  },
  "6870": {
    "id": "6870",
    "name": "Газопроводск (Московская область)",
    "path": "Россия / Московская область / Газопроводск (Московская область)",
    "country": "Россия",
    "searchString": "газопроводск (московская область) россия / московская область / газопроводск (московская область)"
  },
  "6871": {
    "id": "6871",
    "name": "Барабаново (Московская область)",
    "path": "Россия / Московская область / Барабаново (Московская область)",
    "country": "Россия",
    "searchString": "барабаново (московская область) россия / московская область / барабаново (московская область)"
  },
  "6872": {
    "id": "6872",
    "name": "Новосёлки (городской округ Кашира, Московская область)",
    "path": "Россия / Московская область / Новосёлки (городской округ Кашира, Московская область)",
    "country": "Россия",
    "searchString": "новосёлки (городской округ кашира, московская область) россия / московская область / новосёлки (городской округ кашира, московская область)"
  },
  "6873": {
    "id": "6873",
    "name": "Мещерино (Московская область)",
    "path": "Россия / Московская область / Мещерино (Московская область)",
    "country": "Россия",
    "searchString": "мещерино (московская область) россия / московская область / мещерино (московская область)"
  },
  "6874": {
    "id": "6874",
    "name": "Березнецово (Московская область)",
    "path": "Россия / Московская область / Березнецово (Московская область)",
    "country": "Россия",
    "searchString": "березнецово (московская область) россия / московская область / березнецово (московская область)"
  },
  "6875": {
    "id": "6875",
    "name": "Жилёво (Московская область)",
    "path": "Россия / Московская область / Жилёво (Московская область)",
    "country": "Россия",
    "searchString": "жилёво (московская область) россия / московская область / жилёво (московская область)"
  },
  "6876": {
    "id": "6876",
    "name": "Ситне-Щелканово (Московская область)",
    "path": "Россия / Московская область / Ситне-Щелканово (Московская область)",
    "country": "Россия",
    "searchString": "ситне-щелканово (московская область) россия / московская область / ситне-щелканово (московская область)"
  },
  "6877": {
    "id": "6877",
    "name": "Вельяминово (Московская область)",
    "path": "Россия / Московская область / Вельяминово (Московская область)",
    "country": "Россия",
    "searchString": "вельяминово (московская область) россия / московская область / вельяминово (московская область)"
  },
  "6878": {
    "id": "6878",
    "name": "Татариново (Московская область)",
    "path": "Россия / Московская область / Татариново (Московская область)",
    "country": "Россия",
    "searchString": "татариново (московская область) россия / московская область / татариново (московская область)"
  },
  "6879": {
    "id": "6879",
    "name": "Барыбино (Московская область)",
    "path": "Россия / Московская область / Барыбино (Московская область)",
    "country": "Россия",
    "searchString": "барыбино (московская область) россия / московская область / барыбино (московская область)"
  },
  "6880": {
    "id": "6880",
    "name": "Растуново (Московская область)",
    "path": "Россия / Московская область / Растуново (Московская область)",
    "country": "Россия",
    "searchString": "растуново (московская область) россия / московская область / растуново (московская область)"
  },
  "6881": {
    "id": "6881",
    "name": "Житнево (Московская область)",
    "path": "Россия / Московская область / Житнево (Московская область)",
    "country": "Россия",
    "searchString": "житнево (московская область) россия / московская область / житнево (московская область)"
  },
  "6882": {
    "id": "6882",
    "name": "Красный Путь (Московская область)",
    "path": "Россия / Московская область / Красный Путь (Московская область)",
    "country": "Россия",
    "searchString": "красный путь (московская область) россия / московская область / красный путь (московская область)"
  },
  "6883": {
    "id": "6883",
    "name": "Посёлок санатория «Подмосковье» (Московская область)",
    "path": "Россия / Московская область / Посёлок санатория «Подмосковье» (Московская область)",
    "country": "Россия",
    "searchString": "посёлок санатория «подмосковье» (московская область) россия / московская область / посёлок санатория «подмосковье» (московская область)"
  },
  "6884": {
    "id": "6884",
    "name": "Павловское (городской округ Домодедово, Московская область)",
    "path": "Россия / Московская область / Павловское (городской округ Домодедово, Московская область)",
    "country": "Россия",
    "searchString": "павловское (городской округ домодедово, московская область) россия / московская область / павловское (городской округ домодедово, московская область)"
  },
  "6885": {
    "id": "6885",
    "name": "Домодедово (село, Московская область)",
    "path": "Россия / Московская область / Домодедово (село, Московская область)",
    "country": "Россия",
    "searchString": "домодедово (село, московская область) россия / московская область / домодедово (село, московская область)"
  },
  "6886": {
    "id": "6886",
    "name": "Ям (Московская область)",
    "path": "Россия / Московская область / Ям (Московская область)",
    "country": "Россия",
    "searchString": "ям (московская область) россия / московская область / ям (московская область)"
  },
  "6887": {
    "id": "6887",
    "name": "Горки (Московская область)",
    "path": "Россия / Московская область / Горки (Московская область)",
    "country": "Россия",
    "searchString": "горки (московская область) россия / московская область / горки (московская область)"
  },
  "6888": {
    "id": "6888",
    "name": "Чехов-7 (Московская область)",
    "path": "Россия / Московская область / Чехов-7 (Московская область)",
    "country": "Россия",
    "searchString": "чехов-7 (московская область) россия / московская область / чехов-7 (московская область)"
  },
  "6889": {
    "id": "6889",
    "name": "Новый Быт (Московская область)",
    "path": "Россия / Московская область / Новый Быт (Московская область)",
    "country": "Россия",
    "searchString": "новый быт (московская область) россия / московская область / новый быт (московская область)"
  },
  "6890": {
    "id": "6890",
    "name": "Крюково (Московская область)",
    "path": "Россия / Московская область / Крюково (Московская область)",
    "country": "Россия",
    "searchString": "крюково (московская область) россия / московская область / крюково (московская область)"
  },
  "6891": {
    "id": "6891",
    "name": "Верхние Белозёрки",
    "path": "Россия / Самарская область / Верхние Белозёрки",
    "country": "Россия",
    "searchString": "верхние белозёрки россия / самарская область / верхние белозёрки"
  },
  "6892": {
    "id": "6892",
    "name": "Хрящёвка",
    "path": "Россия / Самарская область / Хрящёвка",
    "country": "Россия",
    "searchString": "хрящёвка россия / самарская область / хрящёвка"
  },
  "6893": {
    "id": "6893",
    "name": "Новое Шигалиево",
    "path": "Россия / Республика Татарстан / Новое Шигалиево",
    "country": "Россия",
    "searchString": "новое шигалиево россия / республика татарстан / новое шигалиево"
  },
  "6894": {
    "id": "6894",
    "name": "Рыткучи",
    "path": "Россия / Чукотский АО / Рыткучи",
    "country": "Россия",
    "searchString": "рыткучи россия / чукотский ао / рыткучи"
  },
  "6895": {
    "id": "6895",
    "name": "Куюки",
    "path": "Россия / Республика Татарстан / Куюки",
    "country": "Россия",
    "searchString": "куюки россия / республика татарстан / куюки"
  },
  "6896": {
    "id": "6896",
    "name": "Новоширокинский",
    "path": "Россия / Забайкальский край / Новоширокинский",
    "country": "Россия",
    "searchString": "новоширокинский россия / забайкальский край / новоширокинский"
  },
  "6897": {
    "id": "6897",
    "name": "Татаурово",
    "path": "Россия / Республика Бурятия / Татаурово",
    "country": "Россия",
    "searchString": "татаурово россия / республика бурятия / татаурово"
  },
  "6898": {
    "id": "6898",
    "name": "Батагай-Алыта",
    "path": "Россия / Республика Саха (Якутия) / Батагай-Алыта",
    "country": "Россия",
    "searchString": "батагай-алыта россия / республика саха (якутия) / батагай-алыта"
  },
  "6899": {
    "id": "6899",
    "name": "Хатын-Сысы",
    "path": "Россия / Республика Саха (Якутия) / Хатын-Сысы",
    "country": "Россия",
    "searchString": "хатын-сысы россия / республика саха (якутия) / хатын-сысы"
  },
  "6900": {
    "id": "6900",
    "name": "Кюндяде",
    "path": "Россия / Республика Саха (Якутия) / Кюндяде",
    "country": "Россия",
    "searchString": "кюндяде россия / республика саха (якутия) / кюндяде"
  },
  "6901": {
    "id": "6901",
    "name": "Тюнгюлю",
    "path": "Россия / Республика Саха (Якутия) / Тюнгюлю",
    "country": "Россия",
    "searchString": "тюнгюлю россия / республика саха (якутия) / тюнгюлю"
  },
  "6902": {
    "id": "6902",
    "name": "Томтор",
    "path": "Россия / Республика Саха (Якутия) / Томтор",
    "country": "Россия",
    "searchString": "томтор россия / республика саха (якутия) / томтор"
  },
  "6903": {
    "id": "6903",
    "name": "Шея",
    "path": "Россия / Республика Саха (Якутия) / Шея",
    "country": "Россия",
    "searchString": "шея россия / республика саха (якутия) / шея"
  },
  "6904": {
    "id": "6904",
    "name": "Харбалах",
    "path": "Россия / Республика Саха (Якутия) / Харбалах",
    "country": "Россия",
    "searchString": "харбалах россия / республика саха (якутия) / харбалах"
  },
  "6905": {
    "id": "6905",
    "name": "Сватай",
    "path": "Россия / Республика Саха (Якутия) / Сватай",
    "country": "Россия",
    "searchString": "сватай россия / республика саха (якутия) / сватай"
  },
  "6906": {
    "id": "6906",
    "name": "Хонуу",
    "path": "Россия / Республика Саха (Якутия) / Хонуу",
    "country": "Россия",
    "searchString": "хонуу россия / республика саха (якутия) / хонуу"
  },
  "6907": {
    "id": "6907",
    "name": "Верхний Куранах",
    "path": "Россия / Республика Саха (Якутия) / Верхний Куранах",
    "country": "Россия",
    "searchString": "верхний куранах россия / республика саха (якутия) / верхний куранах"
  },
  "6908": {
    "id": "6908",
    "name": "Лебединый",
    "path": "Россия / Республика Саха (Якутия) / Лебединый",
    "country": "Россия",
    "searchString": "лебединый россия / республика саха (якутия) / лебединый"
  },
  "6909": {
    "id": "6909",
    "name": "Нижнеянск",
    "path": "Россия / Республика Саха (Якутия) / Нижнеянск",
    "country": "Россия",
    "searchString": "нижнеянск россия / республика саха (якутия) / нижнеянск"
  },
  "6910": {
    "id": "6910",
    "name": "Алмазный",
    "path": "Россия / Республика Саха (Якутия) / Алмазный",
    "country": "Россия",
    "searchString": "алмазный россия / республика саха (якутия) / алмазный"
  },
  "6911": {
    "id": "6911",
    "name": "Усть-Мая",
    "path": "Россия / Республика Саха (Якутия) / Усть-Мая",
    "country": "Россия",
    "searchString": "усть-мая россия / республика саха (якутия) / усть-мая"
  },
  "6912": {
    "id": "6912",
    "name": "Эльдикан",
    "path": "Россия / Республика Саха (Якутия) / Эльдикан",
    "country": "Россия",
    "searchString": "эльдикан россия / республика саха (якутия) / эльдикан"
  },
  "6913": {
    "id": "6913",
    "name": "Казачье",
    "path": "Россия / Республика Саха (Якутия) / Казачье",
    "country": "Россия",
    "searchString": "казачье россия / республика саха (якутия) / казачье"
  },
  "6914": {
    "id": "6914",
    "name": "Нюя",
    "path": "Россия / Республика Саха (Якутия) / Нюя",
    "country": "Россия",
    "searchString": "нюя россия / республика саха (якутия) / нюя"
  },
  "6915": {
    "id": "6915",
    "name": "Джебарики-Хая",
    "path": "Россия / Республика Саха (Якутия) / Джебарики-Хая",
    "country": "Россия",
    "searchString": "джебарики-хая россия / республика саха (якутия) / джебарики-хая"
  },
  "6916": {
    "id": "6916",
    "name": "Солнечный (Якутия)",
    "path": "Россия / Республика Саха (Якутия) / Солнечный (Якутия)",
    "country": "Россия",
    "searchString": "солнечный (якутия) россия / республика саха (якутия) / солнечный (якутия)"
  },
  "6917": {
    "id": "6917",
    "name": "Чокурдах",
    "path": "Россия / Республика Саха (Якутия) / Чокурдах",
    "country": "Россия",
    "searchString": "чокурдах россия / республика саха (якутия) / чокурдах"
  },
  "6918": {
    "id": "6918",
    "name": "Тосу",
    "path": "Россия / Республика Саха (Якутия) / Тосу",
    "country": "Россия",
    "searchString": "тосу россия / республика саха (якутия) / тосу"
  },
  "6919": {
    "id": "6919",
    "name": "Саскылах",
    "path": "Россия / Республика Саха (Якутия) / Саскылах",
    "country": "Россия",
    "searchString": "саскылах россия / республика саха (якутия) / саскылах"
  },
  "6920": {
    "id": "6920",
    "name": "Жиганск",
    "path": "Россия / Республика Саха (Якутия) / Жиганск",
    "country": "Россия",
    "searchString": "жиганск россия / республика саха (якутия) / жиганск"
  },
  "6921": {
    "id": "6921",
    "name": "Эльгяй",
    "path": "Россия / Республика Саха (Якутия) / Эльгяй",
    "country": "Россия",
    "searchString": "эльгяй россия / республика саха (якутия) / эльгяй"
  },
  "6922": {
    "id": "6922",
    "name": "Ытык-Кюель",
    "path": "Россия / Республика Саха (Якутия) / Ытык-Кюель",
    "country": "Россия",
    "searchString": "ытык-кюель россия / республика саха (якутия) / ытык-кюель"
  },
  "6923": {
    "id": "6923",
    "name": "Верхневилюйск",
    "path": "Россия / Республика Саха (Якутия) / Верхневилюйск",
    "country": "Россия",
    "searchString": "верхневилюйск россия / республика саха (якутия) / верхневилюйск"
  },
  "6924": {
    "id": "6924",
    "name": "Тополиное",
    "path": "Россия / Республика Саха (Якутия) / Тополиное",
    "country": "Россия",
    "searchString": "тополиное россия / республика саха (якутия) / тополиное"
  },
  "6925": {
    "id": "6925",
    "name": "Вертячий",
    "path": "Россия / Волгоградская область / Вертячий",
    "country": "Россия",
    "searchString": "вертячий россия / волгоградская область / вертячий"
  },
  "6926": {
    "id": "6926",
    "name": "Паньшино",
    "path": "Россия / Волгоградская область / Паньшино",
    "country": "Россия",
    "searchString": "паньшино россия / волгоградская область / паньшино"
  },
  "6927": {
    "id": "6927",
    "name": "Троицкое (Московская область)",
    "path": "Россия / Московская область / Троицкое (Московская область)",
    "country": "Россия",
    "searchString": "троицкое (московская область) россия / московская область / троицкое (московская область)"
  },
  "6928": {
    "id": "6928",
    "name": "Молоди (Московская область)",
    "path": "Россия / Московская область / Молоди (Московская область)",
    "country": "Россия",
    "searchString": "молоди (московская область) россия / московская область / молоди (московская область)"
  },
  "6929": {
    "id": "6929",
    "name": "Бутурлино (Московская область)",
    "path": "Россия / Московская область / Бутурлино (Московская область)",
    "country": "Россия",
    "searchString": "бутурлино (московская область) россия / московская область / бутурлино (московская область)"
  },
  "6930": {
    "id": "6930",
    "name": "Таширово (Московская область)",
    "path": "Россия / Московская область / Таширово (Московская область)",
    "country": "Россия",
    "searchString": "таширово (московская область) россия / московская область / таширово (московская область)"
  },
  "6931": {
    "id": "6931",
    "name": "Вороновское (Московская область)",
    "path": "Россия / Московская область / Вороновское (Московская область)",
    "country": "Россия",
    "searchString": "вороновское (московская область) россия / московская область / вороновское (московская область)"
  },
  "6932": {
    "id": "6932",
    "name": "Атепцево (Московская область)",
    "path": "Россия / Московская область / Атепцево (Московская область)",
    "country": "Россия",
    "searchString": "атепцево (московская область) россия / московская область / атепцево (московская область)"
  },
  "6933": {
    "id": "6933",
    "name": "Наровчат",
    "path": "Россия / Пензенская область / Наровчат",
    "country": "Россия",
    "searchString": "наровчат россия / пензенская область / наровчат"
  },
  "6934": {
    "id": "6934",
    "name": "Усть-Цильма",
    "path": "Россия / Республика Коми / Усть-Цильма",
    "country": "Россия",
    "searchString": "усть-цильма россия / республика коми / усть-цильма"
  },
  "6935": {
    "id": "6935",
    "name": "Улкен-Нарын",
    "path": "Казахстан / Улкен-Нарын",
    "country": "Казахстан",
    "searchString": "улкен-нарын казахстан / улкен-нарын"
  },
  "6936": {
    "id": "6936",
    "name": "Боровляны",
    "path": "Беларусь / Минская область / Боровляны",
    "country": "Беларусь",
    "searchString": "боровляны беларусь / минская область / боровляны"
  },
  "6937": {
    "id": "6937",
    "name": "Вяткино",
    "path": "Россия / Владимирская область / Вяткино",
    "country": "Россия",
    "searchString": "вяткино россия / владимирская область / вяткино"
  },
  "6938": {
    "id": "6938",
    "name": "Усть-Карск",
    "path": "Россия / Забайкальский край / Усть-Карск",
    "country": "Россия",
    "searchString": "усть-карск россия / забайкальский край / усть-карск"
  },
  "6939": {
    "id": "6939",
    "name": "Кадая",
    "path": "Россия / Забайкальский край / Кадая",
    "country": "Россия",
    "searchString": "кадая россия / забайкальский край / кадая"
  },
  "6940": {
    "id": "6940",
    "name": "Новоорловск",
    "path": "Россия / Забайкальский край / Новоорловск",
    "country": "Россия",
    "searchString": "новоорловск россия / забайкальский край / новоорловск"
  },
  "6941": {
    "id": "6941",
    "name": "Новопавловка",
    "path": "Россия / Забайкальский край / Новопавловка",
    "country": "Россия",
    "searchString": "новопавловка россия / забайкальский край / новопавловка"
  },
  "6942": {
    "id": "6942",
    "name": "Сбега",
    "path": "Россия / Забайкальский край / Сбега",
    "country": "Россия",
    "searchString": "сбега россия / забайкальский край / сбега"
  },
  "6943": {
    "id": "6943",
    "name": "Боголюбово",
    "path": "Россия / Владимирская область / Боголюбово",
    "country": "Россия",
    "searchString": "боголюбово россия / владимирская область / боголюбово"
  },
  "6944": {
    "id": "6944",
    "name": "Борзовая Заимка",
    "path": "Россия / Алтайский край / Борзовая Заимка",
    "country": "Россия",
    "searchString": "борзовая заимка россия / алтайский край / борзовая заимка"
  },
  "6945": {
    "id": "6945",
    "name": "Подберезье",
    "path": "Россия / Новгородская область / Подберезье",
    "country": "Россия",
    "searchString": "подберезье россия / новгородская область / подберезье"
  },
  "6946": {
    "id": "6946",
    "name": "Чечулино",
    "path": "Россия / Новгородская область / Чечулино",
    "country": "Россия",
    "searchString": "чечулино россия / новгородская область / чечулино"
  },
  "6947": {
    "id": "6947",
    "name": "Жем",
    "path": "Казахстан / Жем",
    "country": "Казахстан",
    "searchString": "жем казахстан / жем"
  },
  "6948": {
    "id": "6948",
    "name": "Эмба",
    "path": "Казахстан / Эмба",
    "country": "Казахстан",
    "searchString": "эмба казахстан / эмба"
  },
  "6949": {
    "id": "6949",
    "name": "Садовый (Новосибирская область)",
    "path": "Россия / Новосибирская область / Садовый (Новосибирская область)",
    "country": "Россия",
    "searchString": "садовый (новосибирская область) россия / новосибирская область / садовый (новосибирская область)"
  },
  "6950": {
    "id": "6950",
    "name": "Фирово",
    "path": "Россия / Тверская область / Фирово",
    "country": "Россия",
    "searchString": "фирово россия / тверская область / фирово"
  },
  "6951": {
    "id": "6951",
    "name": "Тёплый Ключ (Республика Саха)",
    "path": "Россия / Республика Саха (Якутия) / Тёплый Ключ (Республика Саха)",
    "country": "Россия",
    "searchString": "тёплый ключ (республика саха) россия / республика саха (якутия) / тёплый ключ (республика саха)"
  },
  "6952": {
    "id": "6952",
    "name": "Вершино-Шахтаминское",
    "path": "Россия / Забайкальский край / Вершино-Шахтаминское",
    "country": "Россия",
    "searchString": "вершино-шахтаминское россия / забайкальский край / вершино-шахтаминское"
  },
  "6953": {
    "id": "6953",
    "name": "Ильинка (Хабаровский край)",
    "path": "Россия / Хабаровский край / Ильинка (Хабаровский край)",
    "country": "Россия",
    "searchString": "ильинка (хабаровский край) россия / хабаровский край / ильинка (хабаровский край)"
  },
  "6954": {
    "id": "6954",
    "name": "Дружба (Хабаровский край)",
    "path": "Россия / Хабаровский край / Дружба (Хабаровский край)",
    "country": "Россия",
    "searchString": "дружба (хабаровский край) россия / хабаровский край / дружба (хабаровский край)"
  },
  "6955": {
    "id": "6955",
    "name": "Беликово (Московская область)",
    "path": "Россия / Московская область / Беликово (Московская область)",
    "country": "Россия",
    "searchString": "беликово (московская область) россия / московская область / беликово (московская область)"
  },
  "6956": {
    "id": "6956",
    "name": "Круглое (Ростовская область)",
    "path": "Россия / Ростовская область / Круглое (Ростовская область)",
    "country": "Россия",
    "searchString": "круглое (ростовская область) россия / ростовская область / круглое (ростовская область)"
  },
  "6989": {
    "id": "6989",
    "name": "Жезкент",
    "path": "Казахстан / Жезкент",
    "country": "Казахстан",
    "searchString": "жезкент казахстан / жезкент"
  },
  "6990": {
    "id": "6990",
    "name": "Богатищево (Московская область)",
    "path": "Россия / Московская область / Богатищево (Московская область)",
    "country": "Россия",
    "searchString": "богатищево (московская область) россия / московская область / богатищево (московская область)"
  },
  "6991": {
    "id": "6991",
    "name": "Садгород",
    "path": "Россия / Самарская область / Садгород",
    "country": "Россия",
    "searchString": "садгород россия / самарская область / садгород"
  },
  "6992": {
    "id": "6992",
    "name": "Семигорье",
    "path": "Россия / Ивановская область / Семигорье",
    "country": "Россия",
    "searchString": "семигорье россия / ивановская область / семигорье"
  },
  "6993": {
    "id": "6993",
    "name": "Новописцово",
    "path": "Россия / Ивановская область / Новописцово",
    "country": "Россия",
    "searchString": "новописцово россия / ивановская область / новописцово"
  },
  "6994": {
    "id": "6994",
    "name": "Каменка (Ивановская область)",
    "path": "Россия / Ивановская область / Каменка (Ивановская область)",
    "country": "Россия",
    "searchString": "каменка (ивановская область) россия / ивановская область / каменка (ивановская область)"
  },
  "6995": {
    "id": "6995",
    "name": "Назарьево (Московская область)",
    "path": "Россия / Московская область / Назарьево (Московская область)",
    "country": "Россия",
    "searchString": "назарьево (московская область) россия / московская область / назарьево (московская область)"
  },
  "6996": {
    "id": "6996",
    "name": "Барлакский",
    "path": "Россия / Новосибирская область / Барлакский",
    "country": "Россия",
    "searchString": "барлакский россия / новосибирская область / барлакский"
  },
  "6997": {
    "id": "6997",
    "name": "Посёлок имени Воровского (Московская область)",
    "path": "Россия / Московская область / Посёлок имени Воровского (Московская область)",
    "country": "Россия",
    "searchString": "посёлок имени воровского (московская область) россия / московская область / посёлок имени воровского (московская область)"
  },
  "6998": {
    "id": "6998",
    "name": "Чесноковка",
    "path": "Россия / Республика Башкортостан / Чесноковка",
    "country": "Россия",
    "searchString": "чесноковка россия / республика башкортостан / чесноковка"
  },
  "6999": {
    "id": "6999",
    "name": "Лопатино (Московская область)",
    "path": "Россия / Московская область / Лопатино (Московская область)",
    "country": "Россия",
    "searchString": "лопатино (московская область) россия / московская область / лопатино (московская область)"
  },
  "7000": {
    "id": "7000",
    "name": "Боброво (Московская область)",
    "path": "Россия / Московская область / Боброво (Московская область)",
    "country": "Россия",
    "searchString": "боброво (московская область) россия / московская область / боброво (московская область)"
  },
  "7001": {
    "id": "7001",
    "name": "Акташ",
    "path": "Россия / Республика Алтай / Акташ",
    "country": "Россия",
    "searchString": "акташ россия / республика алтай / акташ"
  },
  "7002": {
    "id": "7002",
    "name": "Ждановка",
    "path": "Россия / Донецкая Народная Республика / Ждановка",
    "country": "Россия",
    "searchString": "ждановка россия / донецкая народная республика / ждановка"
  },
  "7003": {
    "id": "7003",
    "name": "Тасты-Талды",
    "path": "Казахстан / Тасты-Талды",
    "country": "Казахстан",
    "searchString": "тасты-талды казахстан / тасты-талды"
  },
  "7004": {
    "id": "7004",
    "name": "Верхние Ачаки",
    "path": "Россия / Чувашская Республика / Верхние Ачаки",
    "country": "Россия",
    "searchString": "верхние ачаки россия / чувашская республика / верхние ачаки"
  },
  "7005": {
    "id": "7005",
    "name": "Яншихово-Челлы",
    "path": "Россия / Чувашская Республика / Яншихово-Челлы",
    "country": "Россия",
    "searchString": "яншихово-челлы россия / чувашская республика / яншихово-челлы"
  },
  "7006": {
    "id": "7006",
    "name": "Атабаево",
    "path": "Россия / Республика Татарстан / Атабаево",
    "country": "Россия",
    "searchString": "атабаево россия / республика татарстан / атабаево"
  },
  "7007": {
    "id": "7007",
    "name": "Большие Ключи",
    "path": "Россия / Республика Татарстан / Большие Ключи",
    "country": "Россия",
    "searchString": "большие ключи россия / республика татарстан / большие ключи"
  },
  "7008": {
    "id": "7008",
    "name": "Менил",
    "path": "Россия / Удмуртская Республика / Менил",
    "country": "Россия",
    "searchString": "менил россия / удмуртская республика / менил"
  },
  "7009": {
    "id": "7009",
    "name": "Нюрдор-Котья",
    "path": "Россия / Удмуртская Республика / Нюрдор-Котья",
    "country": "Россия",
    "searchString": "нюрдор-котья россия / удмуртская республика / нюрдор-котья"
  },
  "7010": {
    "id": "7010",
    "name": "Камский Леспромхоз",
    "path": "Россия / Республика Татарстан / Камский Леспромхоз",
    "country": "Россия",
    "searchString": "камский леспромхоз россия / республика татарстан / камский леспромхоз"
  },
  "7011": {
    "id": "7011",
    "name": "Коноваловка",
    "path": "Россия / Республика Татарстан / Коноваловка",
    "country": "Россия",
    "searchString": "коноваловка россия / республика татарстан / коноваловка"
  },
  "7012": {
    "id": "7012",
    "name": "Семеновка (Республика Марий Эл)",
    "path": "Россия / Республика Марий Эл / Семеновка (Республика Марий Эл)",
    "country": "Россия",
    "searchString": "семеновка (республика марий эл) россия / республика марий эл / семеновка (республика марий эл)"
  },
  "7013": {
    "id": "7013",
    "name": "Нижние Аты",
    "path": "Россия / Республика Татарстан / Нижние Аты",
    "country": "Россия",
    "searchString": "нижние аты россия / республика татарстан / нижние аты"
  },
  "7014": {
    "id": "7014",
    "name": "Якшур",
    "path": "Россия / Удмуртская Республика / Якшур",
    "country": "Россия",
    "searchString": "якшур россия / удмуртская республика / якшур"
  },
  "7015": {
    "id": "7015",
    "name": "Большая Выла",
    "path": "Россия / Чувашская Республика / Большая Выла",
    "country": "Россия",
    "searchString": "большая выла россия / чувашская республика / большая выла"
  },
  "7016": {
    "id": "7016",
    "name": "Учалле",
    "path": "Россия / Республика Татарстан / Учалле",
    "country": "Россия",
    "searchString": "учалле россия / республика татарстан / учалле"
  },
  "7017": {
    "id": "7017",
    "name": "Зай-Каратай",
    "path": "Россия / Республика Татарстан / Зай-Каратай",
    "country": "Россия",
    "searchString": "зай-каратай россия / республика татарстан / зай-каратай"
  },
  "7018": {
    "id": "7018",
    "name": "Деушево",
    "path": "Россия / Республика Татарстан / Деушево",
    "country": "Россия",
    "searchString": "деушево россия / республика татарстан / деушево"
  },
  "7019": {
    "id": "7019",
    "name": "Такталачук",
    "path": "Россия / Республика Татарстан / Такталачук",
    "country": "Россия",
    "searchString": "такталачук россия / республика татарстан / такталачук"
  },
  "7020": {
    "id": "7020",
    "name": "Кутемели",
    "path": "Россия / Республика Татарстан / Кутемели",
    "country": "Россия",
    "searchString": "кутемели россия / республика татарстан / кутемели"
  },
  "7021": {
    "id": "7021",
    "name": "Бураково",
    "path": "Россия / Республика Татарстан / Бураково",
    "country": "Россия",
    "searchString": "бураково россия / республика татарстан / бураково"
  },
  "7022": {
    "id": "7022",
    "name": "Тюрлема",
    "path": "Россия / Чувашская Республика / Тюрлема",
    "country": "Россия",
    "searchString": "тюрлема россия / чувашская республика / тюрлема"
  },
  "7023": {
    "id": "7023",
    "name": "Ковали",
    "path": "Россия / Чувашская Республика / Ковали",
    "country": "Россия",
    "searchString": "ковали россия / чувашская республика / ковали"
  },
  "7024": {
    "id": "7024",
    "name": "Новые Шимкусы",
    "path": "Россия / Чувашская Республика / Новые Шимкусы",
    "country": "Россия",
    "searchString": "новые шимкусы россия / чувашская республика / новые шимкусы"
  },
  "7025": {
    "id": "7025",
    "name": "Факел",
    "path": "Россия / Удмуртская Республика / Факел",
    "country": "Россия",
    "searchString": "факел россия / удмуртская республика / факел"
  },
  "7026": {
    "id": "7026",
    "name": "Асеево",
    "path": "Россия / Республика Татарстан / Асеево",
    "country": "Россия",
    "searchString": "асеево россия / республика татарстан / асеево"
  },
  "7027": {
    "id": "7027",
    "name": "Июльское",
    "path": "Россия / Удмуртская Республика / Июльское",
    "country": "Россия",
    "searchString": "июльское россия / удмуртская республика / июльское"
  },
  "7028": {
    "id": "7028",
    "name": "Мукши",
    "path": "Россия / Удмуртская Республика / Мукши",
    "country": "Россия",
    "searchString": "мукши россия / удмуртская республика / мукши"
  },
  "7029": {
    "id": "7029",
    "name": "Малая Таяба",
    "path": "Россия / Чувашская Республика / Малая Таяба",
    "country": "Россия",
    "searchString": "малая таяба россия / чувашская республика / малая таяба"
  },
  "7030": {
    "id": "7030",
    "name": "Нурлаты",
    "path": "Россия / Республика Татарстан / Нурлаты",
    "country": "Россия",
    "searchString": "нурлаты россия / республика татарстан / нурлаты"
  },
  "7031": {
    "id": "7031",
    "name": "Большая Турма",
    "path": "Россия / Республика Татарстан / Большая Турма",
    "country": "Россия",
    "searchString": "большая турма россия / республика татарстан / большая турма"
  },
  "7032": {
    "id": "7032",
    "name": "Иске-Рязап",
    "path": "Россия / Республика Татарстан / Иске-Рязап",
    "country": "Россия",
    "searchString": "иске-рязап россия / республика татарстан / иске-рязап"
  },
  "7033": {
    "id": "7033",
    "name": "Каенлы",
    "path": "Россия / Республика Татарстан / Каенлы",
    "country": "Россия",
    "searchString": "каенлы россия / республика татарстан / каенлы"
  },
  "7034": {
    "id": "7034",
    "name": "Ютаза",
    "path": "Россия / Республика Татарстан / Ютаза",
    "country": "Россия",
    "searchString": "ютаза россия / республика татарстан / ютаза"
  },
  "7035": {
    "id": "7035",
    "name": "Малая Шильна",
    "path": "Россия / Республика Татарстан / Малая Шильна",
    "country": "Россия",
    "searchString": "малая шильна россия / республика татарстан / малая шильна"
  },
  "7036": {
    "id": "7036",
    "name": "Большое Нуркеево",
    "path": "Россия / Республика Татарстан / Большое Нуркеево",
    "country": "Россия",
    "searchString": "большое нуркеево россия / республика татарстан / большое нуркеево"
  },
  "7037": {
    "id": "7037",
    "name": "Каргали",
    "path": "Россия / Республика Татарстан / Каргали",
    "country": "Россия",
    "searchString": "каргали россия / республика татарстан / каргали"
  },
  "7038": {
    "id": "7038",
    "name": "Орловское",
    "path": "Россия / Удмуртская Республика / Орловское",
    "country": "Россия",
    "searchString": "орловское россия / удмуртская республика / орловское"
  },
  "7039": {
    "id": "7039",
    "name": "Победа",
    "path": "Россия / Республика Татарстан / Победа",
    "country": "Россия",
    "searchString": "победа россия / республика татарстан / победа"
  },
  "7040": {
    "id": "7040",
    "name": "Лынга",
    "path": "Россия / Удмуртская Республика / Лынга",
    "country": "Россия",
    "searchString": "лынга россия / удмуртская республика / лынга"
  },
  "7041": {
    "id": "7041",
    "name": "Кыйлуд",
    "path": "Россия / Удмуртская Республика / Кыйлуд",
    "country": "Россия",
    "searchString": "кыйлуд россия / удмуртская республика / кыйлуд"
  },
  "7042": {
    "id": "7042",
    "name": "Старое Сафарово",
    "path": "Россия / Республика Татарстан / Старое Сафарово",
    "country": "Россия",
    "searchString": "старое сафарово россия / республика татарстан / старое сафарово"
  },
  "7043": {
    "id": "7043",
    "name": "Кият",
    "path": "Россия / Республика Татарстан / Кият",
    "country": "Россия",
    "searchString": "кият россия / республика татарстан / кият"
  },
  "7044": {
    "id": "7044",
    "name": "Нижнее Алькеево",
    "path": "Россия / Республика Татарстан / Нижнее Алькеево",
    "country": "Россия",
    "searchString": "нижнее алькеево россия / республика татарстан / нижнее алькеево"
  },
  "7045": {
    "id": "7045",
    "name": "Мочалище",
    "path": "Россия / Республика Марий Эл / Мочалище",
    "country": "Россия",
    "searchString": "мочалище россия / республика марий эл / мочалище"
  },
  "7046": {
    "id": "7046",
    "name": "Татарские Суксы",
    "path": "Россия / Республика Татарстан / Татарские Суксы",
    "country": "Россия",
    "searchString": "татарские суксы россия / республика татарстан / татарские суксы"
  },
  "7047": {
    "id": "7047",
    "name": "Светлое Озеро",
    "path": "Россия / Республика Татарстан / Светлое Озеро",
    "country": "Россия",
    "searchString": "светлое озеро россия / республика татарстан / светлое озеро"
  },
  "7048": {
    "id": "7048",
    "name": "Эльбарусово",
    "path": "Россия / Чувашская Республика / Эльбарусово",
    "country": "Россия",
    "searchString": "эльбарусово россия / чувашская республика / эльбарусово"
  },
  "7049": {
    "id": "7049",
    "name": "Какре-Елга",
    "path": "Россия / Республика Татарстан / Какре-Елга",
    "country": "Россия",
    "searchString": "какре-елга россия / республика татарстан / какре-елга"
  },
  "7050": {
    "id": "7050",
    "name": "Шипки",
    "path": "Россия / Республика Татарстан / Шипки",
    "country": "Россия",
    "searchString": "шипки россия / республика татарстан / шипки"
  },
  "7051": {
    "id": "7051",
    "name": "Кадыбаш",
    "path": "Россия / Республика Татарстан / Кадыбаш",
    "country": "Россия",
    "searchString": "кадыбаш россия / республика татарстан / кадыбаш"
  },
  "7052": {
    "id": "7052",
    "name": "Поселок станции Каратун",
    "path": "Россия / Республика Татарстан / Поселок станции Каратун",
    "country": "Россия",
    "searchString": "поселок станции каратун россия / республика татарстан / поселок станции каратун"
  },
  "7053": {
    "id": "7053",
    "name": "Турмыши",
    "path": "Россия / Чувашская Республика / Турмыши",
    "country": "Россия",
    "searchString": "турмыши россия / чувашская республика / турмыши"
  },
  "7054": {
    "id": "7054",
    "name": "Большой Сухояш",
    "path": "Россия / Республика Татарстан / Большой Сухояш",
    "country": "Россия",
    "searchString": "большой сухояш россия / республика татарстан / большой сухояш"
  },
  "7055": {
    "id": "7055",
    "name": "Хыркасы",
    "path": "Россия / Чувашская Республика / Хыркасы",
    "country": "Россия",
    "searchString": "хыркасы россия / чувашская республика / хыркасы"
  },
  "7056": {
    "id": "7056",
    "name": "Кулига",
    "path": "Россия / Удмуртская Республика / Кулига",
    "country": "Россия",
    "searchString": "кулига россия / удмуртская республика / кулига"
  },
  "7057": {
    "id": "7057",
    "name": "Арзамасцево",
    "path": "Россия / Удмуртская Республика / Арзамасцево",
    "country": "Россия",
    "searchString": "арзамасцево россия / удмуртская республика / арзамасцево"
  },
  "7058": {
    "id": "7058",
    "name": "Большое Волково",
    "path": "Россия / Удмуртская Республика / Большое Волково",
    "country": "Россия",
    "searchString": "большое волково россия / удмуртская республика / большое волково"
  },
  "7059": {
    "id": "7059",
    "name": "Кожары",
    "path": "Россия / Чувашская Республика / Кожары",
    "country": "Россия",
    "searchString": "кожары россия / чувашская республика / кожары"
  },
  "7060": {
    "id": "7060",
    "name": "Тюрнясево",
    "path": "Россия / Республика Татарстан / Тюрнясево",
    "country": "Россия",
    "searchString": "тюрнясево россия / республика татарстан / тюрнясево"
  },
  "7061": {
    "id": "7061",
    "name": "Большое Подберезье",
    "path": "Россия / Республика Татарстан / Большое Подберезье",
    "country": "Россия",
    "searchString": "большое подберезье россия / республика татарстан / большое подберезье"
  },
  "7062": {
    "id": "7062",
    "name": "Какмож",
    "path": "Россия / Удмуртская Республика / Какмож",
    "country": "Россия",
    "searchString": "какмож россия / удмуртская республика / какмож"
  },
  "7063": {
    "id": "7063",
    "name": "Билярск",
    "path": "Россия / Республика Татарстан / Билярск",
    "country": "Россия",
    "searchString": "билярск россия / республика татарстан / билярск"
  },
  "7064": {
    "id": "7064",
    "name": "Кузнецово",
    "path": "Россия / Республика Марий Эл / Кузнецово",
    "country": "Россия",
    "searchString": "кузнецово россия / республика марий эл / кузнецово"
  },
  "7065": {
    "id": "7065",
    "name": "Муртыш-Тамак",
    "path": "Россия / Республика Татарстан / Муртыш-Тамак",
    "country": "Россия",
    "searchString": "муртыш-тамак россия / республика татарстан / муртыш-тамак"
  },
  "7066": {
    "id": "7066",
    "name": "Чэчэкле",
    "path": "Россия / Республика Татарстан / Чэчэкле",
    "country": "Россия",
    "searchString": "чэчэкле россия / республика татарстан / чэчэкле"
  },
  "7067": {
    "id": "7067",
    "name": "Кильдюшево",
    "path": "Россия / Чувашская Республика / Кильдюшево",
    "country": "Россия",
    "searchString": "кильдюшево россия / чувашская республика / кильдюшево"
  },
  "7068": {
    "id": "7068",
    "name": "Елантово",
    "path": "Россия / Республика Татарстан / Елантово",
    "country": "Россия",
    "searchString": "елантово россия / республика татарстан / елантово"
  },
  "7069": {
    "id": "7069",
    "name": "Караталга",
    "path": "Россия / Республика Татарстан / Караталга",
    "country": "Россия",
    "searchString": "караталга россия / республика татарстан / караталга"
  },
  "7070": {
    "id": "7070",
    "name": "Елхово",
    "path": "Россия / Республика Татарстан / Елхово",
    "country": "Россия",
    "searchString": "елхово россия / республика татарстан / елхово"
  },
  "7071": {
    "id": "7071",
    "name": "Аю",
    "path": "Россия / Республика Татарстан / Аю",
    "country": "Россия",
    "searchString": "аю россия / республика татарстан / аю"
  },
  "7072": {
    "id": "7072",
    "name": "Рябово (Удмуртская Республика)",
    "path": "Россия / Удмуртская Республика / Рябово (Удмуртская Республика)",
    "country": "Россия",
    "searchString": "рябово (удмуртская республика) россия / удмуртская республика / рябово (удмуртская республика)"
  },
  "7073": {
    "id": "7073",
    "name": "Тенишево",
    "path": "Россия / Республика Татарстан / Тенишево",
    "country": "Россия",
    "searchString": "тенишево россия / республика татарстан / тенишево"
  },
  "7074": {
    "id": "7074",
    "name": "Карабай-Шемурша",
    "path": "Россия / Чувашская Республика / Карабай-Шемурша",
    "country": "Россия",
    "searchString": "карабай-шемурша россия / чувашская республика / карабай-шемурша"
  },
  "7075": {
    "id": "7075",
    "name": "Тойси",
    "path": "Россия / Чувашская Республика / Тойси",
    "country": "Россия",
    "searchString": "тойси россия / чувашская республика / тойси"
  },
  "7076": {
    "id": "7076",
    "name": "Торханы",
    "path": "Россия / Чувашская Республика / Торханы",
    "country": "Россия",
    "searchString": "торханы россия / чувашская республика / торханы"
  },
  "7077": {
    "id": "7077",
    "name": "Старые Зятцы",
    "path": "Россия / Удмуртская Республика / Старые Зятцы",
    "country": "Россия",
    "searchString": "старые зятцы россия / удмуртская республика / старые зятцы"
  },
  "7078": {
    "id": "7078",
    "name": "Новый Кинер",
    "path": "Россия / Республика Татарстан / Новый Кинер",
    "country": "Россия",
    "searchString": "новый кинер россия / республика татарстан / новый кинер"
  },
  "7079": {
    "id": "7079",
    "name": "Солдыбаево",
    "path": "Россия / Чувашская Республика / Солдыбаево",
    "country": "Россия",
    "searchString": "солдыбаево россия / чувашская республика / солдыбаево"
  },
  "7080": {
    "id": "7080",
    "name": "Мариец",
    "path": "Россия / Республика Марий Эл / Мариец",
    "country": "Россия",
    "searchString": "мариец россия / республика марий эл / мариец"
  },
  "7081": {
    "id": "7081",
    "name": "Поисево",
    "path": "Россия / Республика Татарстан / Поисево",
    "country": "Россия",
    "searchString": "поисево россия / республика татарстан / поисево"
  },
  "7082": {
    "id": "7082",
    "name": "Егоркино",
    "path": "Россия / Чувашская Республика / Егоркино",
    "country": "Россия",
    "searchString": "егоркино россия / чувашская республика / егоркино"
  },
  "7083": {
    "id": "7083",
    "name": "Старые Тиньгеши",
    "path": "Россия / Чувашская Республика / Старые Тиньгеши",
    "country": "Россия",
    "searchString": "старые тиньгеши россия / чувашская республика / старые тиньгеши"
  },
  "7084": {
    "id": "7084",
    "name": "Ципья",
    "path": "Россия / Республика Татарстан / Ципья",
    "country": "Россия",
    "searchString": "ципья россия / республика татарстан / ципья"
  },
  "7085": {
    "id": "7085",
    "name": "Пикшики",
    "path": "Россия / Чувашская Республика / Пикшики",
    "country": "Россия",
    "searchString": "пикшики россия / чувашская республика / пикшики"
  },
  "7086": {
    "id": "7086",
    "name": "Атнары",
    "path": "Россия / Чувашская Республика / Атнары",
    "country": "Россия",
    "searchString": "атнары россия / чувашская республика / атнары"
  },
  "7087": {
    "id": "7087",
    "name": "Конар",
    "path": "Россия / Чувашская Республика / Конар",
    "country": "Россия",
    "searchString": "конар россия / чувашская республика / конар"
  },
  "7088": {
    "id": "7088",
    "name": "Кама",
    "path": "Россия / Удмуртская Республика / Кама",
    "country": "Россия",
    "searchString": "кама россия / удмуртская республика / кама"
  },
  "7089": {
    "id": "7089",
    "name": "Первомайское (Чувашская Республика)",
    "path": "Россия / Чувашская Республика / Первомайское (Чувашская Республика)",
    "country": "Россия",
    "searchString": "первомайское (чувашская республика) россия / чувашская республика / первомайское (чувашская республика)"
  },
  "7090": {
    "id": "7090",
    "name": "Большое Афанасово",
    "path": "Россия / Республика Татарстан / Большое Афанасово",
    "country": "Россия",
    "searchString": "большое афанасово россия / республика татарстан / большое афанасово"
  },
  "7091": {
    "id": "7091",
    "name": "Шумшеваши",
    "path": "Россия / Чувашская Республика / Шумшеваши",
    "country": "Россия",
    "searchString": "шумшеваши россия / чувашская республика / шумшеваши"
  },
  "7092": {
    "id": "7092",
    "name": "Каркалай",
    "path": "Россия / Удмуртская Республика / Каркалай",
    "country": "Россия",
    "searchString": "каркалай россия / удмуртская республика / каркалай"
  },
  "7093": {
    "id": "7093",
    "name": "Алтышево",
    "path": "Россия / Чувашская Республика / Алтышево",
    "country": "Россия",
    "searchString": "алтышево россия / чувашская республика / алтышево"
  },
  "7094": {
    "id": "7094",
    "name": "Напольные Котяки",
    "path": "Россия / Чувашская Республика / Напольные Котяки",
    "country": "Россия",
    "searchString": "напольные котяки россия / чувашская республика / напольные котяки"
  },
  "7095": {
    "id": "7095",
    "name": "Красный Бор (Республика Татарстан)",
    "path": "Россия / Республика Татарстан / Красный Бор (Республика Татарстан)",
    "country": "Россия",
    "searchString": "красный бор (республика татарстан) россия / республика татарстан / красный бор (республика татарстан)"
  },
  "7096": {
    "id": "7096",
    "name": "Кадырово",
    "path": "Россия / Республика Татарстан / Кадырово",
    "country": "Россия",
    "searchString": "кадырово россия / республика татарстан / кадырово"
  },
  "7097": {
    "id": "7097",
    "name": "Мактама",
    "path": "Россия / Республика Татарстан / Мактама",
    "country": "Россия",
    "searchString": "мактама россия / республика татарстан / мактама"
  },
  "7098": {
    "id": "7098",
    "name": "Нылга",
    "path": "Россия / Удмуртская Республика / Нылга",
    "country": "Россия",
    "searchString": "нылга россия / удмуртская республика / нылга"
  },
  "7099": {
    "id": "7099",
    "name": "Шибылги",
    "path": "Россия / Чувашская Республика / Шибылги",
    "country": "Россия",
    "searchString": "шибылги россия / чувашская республика / шибылги"
  },
  "7100": {
    "id": "7100",
    "name": "Нечкино",
    "path": "Россия / Удмуртская Республика / Нечкино",
    "country": "Россия",
    "searchString": "нечкино россия / удмуртская республика / нечкино"
  },
  "7101": {
    "id": "7101",
    "name": "Тлянче-Тамак",
    "path": "Россия / Республика Татарстан / Тлянче-Тамак",
    "country": "Россия",
    "searchString": "тлянче-тамак россия / республика татарстан / тлянче-тамак"
  },
  "7102": {
    "id": "7102",
    "name": "Тузи-Сярмус",
    "path": "Россия / Чувашская Республика / Тузи-Сярмус",
    "country": "Россия",
    "searchString": "тузи-сярмус россия / чувашская республика / тузи-сярмус"
  },
  "7103": {
    "id": "7103",
    "name": "Старый Юраш",
    "path": "Россия / Республика Татарстан / Старый Юраш",
    "country": "Россия",
    "searchString": "старый юраш россия / республика татарстан / старый юраш"
  },
  "7104": {
    "id": "7104",
    "name": "Комсомолец (Чувашская Республика)",
    "path": "Россия / Чувашская Республика / Комсомолец (Чувашская Республика)",
    "country": "Россия",
    "searchString": "комсомолец (чувашская республика) россия / чувашская республика / комсомолец (чувашская республика)"
  },
  "7105": {
    "id": "7105",
    "name": "Каркаусь",
    "path": "Россия / Республика Татарстан / Каркаусь",
    "country": "Россия",
    "searchString": "каркаусь россия / республика татарстан / каркаусь"
  },
  "7106": {
    "id": "7106",
    "name": "Анаткасы",
    "path": "Россия / Чувашская Республика / Анаткасы",
    "country": "Россия",
    "searchString": "анаткасы россия / чувашская республика / анаткасы"
  },
  "7107": {
    "id": "7107",
    "name": "Кошноруй",
    "path": "Россия / Чувашская Республика / Кошноруй",
    "country": "Россия",
    "searchString": "кошноруй россия / чувашская республика / кошноруй"
  },
  "7108": {
    "id": "7108",
    "name": "Мазунино",
    "path": "Россия / Удмуртская Республика / Мазунино",
    "country": "Россия",
    "searchString": "мазунино россия / удмуртская республика / мазунино"
  },
  "7109": {
    "id": "7109",
    "name": "Теньки",
    "path": "Россия / Республика Татарстан / Теньки",
    "country": "Россия",
    "searchString": "теньки россия / республика татарстан / теньки"
  },
  "7110": {
    "id": "7110",
    "name": "Большая Уча",
    "path": "Россия / Удмуртская Республика / Большая Уча",
    "country": "Россия",
    "searchString": "большая уча россия / удмуртская республика / большая уча"
  },
  "7111": {
    "id": "7111",
    "name": "Новое Каширово",
    "path": "Россия / Республика Татарстан / Новое Каширово",
    "country": "Россия",
    "searchString": "новое каширово россия / республика татарстан / новое каширово"
  },
  "7112": {
    "id": "7112",
    "name": "Балезино-3",
    "path": "Россия / Удмуртская Республика / Балезино-3",
    "country": "Россия",
    "searchString": "балезино-3 россия / удмуртская республика / балезино-3"
  },
  "7113": {
    "id": "7113",
    "name": "Сурок",
    "path": "Россия / Республика Марий Эл / Сурок",
    "country": "Россия",
    "searchString": "сурок россия / республика марий эл / сурок"
  },
  "7114": {
    "id": "7114",
    "name": "Вутабоси",
    "path": "Россия / Чувашская Республика / Вутабоси",
    "country": "Россия",
    "searchString": "вутабоси россия / чувашская республика / вутабоси"
  },
  "7115": {
    "id": "7115",
    "name": "Шигали",
    "path": "Россия / Чувашская Республика / Шигали",
    "country": "Россия",
    "searchString": "шигали россия / чувашская республика / шигали"
  },
  "7116": {
    "id": "7116",
    "name": "Новые Мураты",
    "path": "Россия / Чувашская Республика / Новые Мураты",
    "country": "Россия",
    "searchString": "новые мураты россия / чувашская республика / новые мураты"
  },
  "7117": {
    "id": "7117",
    "name": "Зеленая Роща",
    "path": "Россия / Республика Татарстан / Зеленая Роща",
    "country": "Россия",
    "searchString": "зеленая роща россия / республика татарстан / зеленая роща"
  },
  "7118": {
    "id": "7118",
    "name": "Старый Кашир",
    "path": "Россия / Республика Татарстан / Старый Кашир",
    "country": "Россия",
    "searchString": "старый кашир россия / республика татарстан / старый кашир"
  },
  "7119": {
    "id": "7119",
    "name": "Никулино",
    "path": "Россия / Чувашская Республика / Никулино",
    "country": "Россия",
    "searchString": "никулино россия / чувашская республика / никулино"
  },
  "7120": {
    "id": "7120",
    "name": "Междуречье (Чувашская Республика)",
    "path": "Россия / Чувашская Республика / Междуречье (Чувашская Республика)",
    "country": "Россия",
    "searchString": "междуречье (чувашская республика) россия / чувашская республика / междуречье (чувашская республика)"
  },
  "7121": {
    "id": "7121",
    "name": "Богатырево",
    "path": "Россия / Чувашская Республика / Богатырево",
    "country": "Россия",
    "searchString": "богатырево россия / чувашская республика / богатырево"
  },
  "7122": {
    "id": "7122",
    "name": "Чутырь",
    "path": "Россия / Удмуртская Республика / Чутырь",
    "country": "Россия",
    "searchString": "чутырь россия / удмуртская республика / чутырь"
  },
  "7123": {
    "id": "7123",
    "name": "Сотнур",
    "path": "Россия / Республика Марий Эл / Сотнур",
    "country": "Россия",
    "searchString": "сотнур россия / республика марий эл / сотнур"
  },
  "7124": {
    "id": "7124",
    "name": "Новое Ибрайкино",
    "path": "Россия / Республика Татарстан / Новое Ибрайкино",
    "country": "Россия",
    "searchString": "новое ибрайкино россия / республика татарстан / новое ибрайкино"
  },
  "7125": {
    "id": "7125",
    "name": "Дубъязы",
    "path": "Россия / Республика Татарстан / Дубъязы",
    "country": "Россия",
    "searchString": "дубъязы россия / республика татарстан / дубъязы"
  },
  "7126": {
    "id": "7126",
    "name": "Старые Какси",
    "path": "Россия / Удмуртская Республика / Старые Какси",
    "country": "Россия",
    "searchString": "старые какси россия / удмуртская республика / старые какси"
  },
  "7127": {
    "id": "7127",
    "name": "Пандиково",
    "path": "Россия / Чувашская Республика / Пандиково",
    "country": "Россия",
    "searchString": "пандиково россия / чувашская республика / пандиково"
  },
  "7128": {
    "id": "7128",
    "name": "Малые Меми",
    "path": "Россия / Республика Татарстан / Малые Меми",
    "country": "Россия",
    "searchString": "малые меми россия / республика татарстан / малые меми"
  },
  "7129": {
    "id": "7129",
    "name": "Можарки",
    "path": "Россия / Чувашская Республика / Можарки",
    "country": "Россия",
    "searchString": "можарки россия / чувашская республика / можарки"
  },
  "7130": {
    "id": "7130",
    "name": "Хозесаново",
    "path": "Россия / Республика Татарстан / Хозесаново",
    "country": "Россия",
    "searchString": "хозесаново россия / республика татарстан / хозесаново"
  },
  "7131": {
    "id": "7131",
    "name": "Татарское Адельшино",
    "path": "Россия / Республика Татарстан / Татарское Адельшино",
    "country": "Россия",
    "searchString": "татарское адельшино россия / республика татарстан / татарское адельшино"
  },
  "7132": {
    "id": "7132",
    "name": "Янгорчино",
    "path": "Россия / Чувашская Республика / Янгорчино",
    "country": "Россия",
    "searchString": "янгорчино россия / чувашская республика / янгорчино"
  },
  "7133": {
    "id": "7133",
    "name": "Подшивалово",
    "path": "Россия / Удмуртская Республика / Подшивалово",
    "country": "Россия",
    "searchString": "подшивалово россия / удмуртская республика / подшивалово"
  },
  "7134": {
    "id": "7134",
    "name": "Ермошкино",
    "path": "Россия / Чувашская Республика / Ермошкино",
    "country": "Россия",
    "searchString": "ермошкино россия / чувашская республика / ермошкино"
  },
  "7135": {
    "id": "7135",
    "name": "Новочелны-Сюрбеево",
    "path": "Россия / Чувашская Республика / Новочелны-Сюрбеево",
    "country": "Россия",
    "searchString": "новочелны-сюрбеево россия / чувашская республика / новочелны-сюрбеево"
  },
  "7136": {
    "id": "7136",
    "name": "Петровский Завод",
    "path": "Россия / Республика Татарстан / Петровский Завод",
    "country": "Россия",
    "searchString": "петровский завод россия / республика татарстан / петровский завод"
  },
  "7137": {
    "id": "7137",
    "name": "Октябрьский (Удмуртская Республика)",
    "path": "Россия / Удмуртская Республика / Октябрьский (Удмуртская Республика)",
    "country": "Россия",
    "searchString": "октябрьский (удмуртская республика) россия / удмуртская республика / октябрьский (удмуртская республика)"
  },
  "7138": {
    "id": "7138",
    "name": "Большой Чекмак",
    "path": "Россия / Республика Татарстан / Большой Чекмак",
    "country": "Россия",
    "searchString": "большой чекмак россия / республика татарстан / большой чекмак"
  },
  "7139": {
    "id": "7139",
    "name": "Мюд",
    "path": "Россия / Республика Татарстан / Мюд",
    "country": "Россия",
    "searchString": "мюд россия / республика татарстан / мюд"
  },
  "7140": {
    "id": "7140",
    "name": "Старые Чукалы",
    "path": "Россия / Чувашская Республика / Старые Чукалы",
    "country": "Россия",
    "searchString": "старые чукалы россия / чувашская республика / старые чукалы"
  },
  "7141": {
    "id": "7141",
    "name": "Тобурданово",
    "path": "Россия / Чувашская Республика / Тобурданово",
    "country": "Россия",
    "searchString": "тобурданово россия / чувашская республика / тобурданово"
  },
  "7142": {
    "id": "7142",
    "name": "Пектубаево",
    "path": "Россия / Республика Марий Эл / Пектубаево",
    "country": "Россия",
    "searchString": "пектубаево россия / республика марий эл / пектубаево"
  },
  "7143": {
    "id": "7143",
    "name": "Чур",
    "path": "Россия / Удмуртская Республика / Чур",
    "country": "Россия",
    "searchString": "чур россия / удмуртская республика / чур"
  },
  "7144": {
    "id": "7144",
    "name": "Большие Катраси",
    "path": "Россия / Чувашская Республика / Большие Катраси",
    "country": "Россия",
    "searchString": "большие катраси россия / чувашская республика / большие катраси"
  },
  "7145": {
    "id": "7145",
    "name": "Тарханы",
    "path": "Россия / Чувашская Республика / Тарханы",
    "country": "Россия",
    "searchString": "тарханы россия / чувашская республика / тарханы"
  },
  "7146": {
    "id": "7146",
    "name": "Бухарай",
    "path": "Россия / Республика Татарстан / Бухарай",
    "country": "Россия",
    "searchString": "бухарай россия / республика татарстан / бухарай"
  },
  "7147": {
    "id": "7147",
    "name": "Куркачи",
    "path": "Россия / Республика Татарстан / Куркачи",
    "country": "Россия",
    "searchString": "куркачи россия / республика татарстан / куркачи"
  },
  "7148": {
    "id": "7148",
    "name": "Урюм",
    "path": "Россия / Республика Татарстан / Урюм",
    "country": "Россия",
    "searchString": "урюм россия / республика татарстан / урюм"
  },
  "7149": {
    "id": "7149",
    "name": "Мамыково",
    "path": "Россия / Республика Татарстан / Мамыково",
    "country": "Россия",
    "searchString": "мамыково россия / республика татарстан / мамыково"
  },
  "7150": {
    "id": "7150",
    "name": "Шингальчи",
    "path": "Россия / Республика Татарстан / Шингальчи",
    "country": "Россия",
    "searchString": "шингальчи россия / республика татарстан / шингальчи"
  },
  "7151": {
    "id": "7151",
    "name": "Урняк",
    "path": "Россия / Республика Татарстан / Урняк",
    "country": "Россия",
    "searchString": "урняк россия / республика татарстан / урняк"
  },
  "7152": {
    "id": "7152",
    "name": "Карсовай",
    "path": "Россия / Удмуртская Республика / Карсовай",
    "country": "Россия",
    "searchString": "карсовай россия / удмуртская республика / карсовай"
  },
  "7153": {
    "id": "7153",
    "name": "Полевые Бикшики",
    "path": "Россия / Чувашская Республика / Полевые Бикшики",
    "country": "Россия",
    "searchString": "полевые бикшики россия / чувашская республика / полевые бикшики"
  },
  "7154": {
    "id": "7154",
    "name": "Яган-Докья",
    "path": "Россия / Удмуртская Республика / Яган-Докья",
    "country": "Россия",
    "searchString": "яган-докья россия / удмуртская республика / яган-докья"
  },
  "7155": {
    "id": "7155",
    "name": "Дизьмино",
    "path": "Россия / Удмуртская Республика / Дизьмино",
    "country": "Россия",
    "searchString": "дизьмино россия / удмуртская республика / дизьмино"
  },
  "7156": {
    "id": "7156",
    "name": "Карабаши",
    "path": "Россия / Чувашская Республика / Карабаши",
    "country": "Россия",
    "searchString": "карабаши россия / чувашская республика / карабаши"
  },
  "7157": {
    "id": "7157",
    "name": "Кватчи",
    "path": "Россия / Удмуртская Республика / Кватчи",
    "country": "Россия",
    "searchString": "кватчи россия / удмуртская республика / кватчи"
  },
  "7158": {
    "id": "7158",
    "name": "Октябрьский (Республика Татарстан)",
    "path": "Россия / Республика Татарстан / Октябрьский (Республика Татарстан)",
    "country": "Россия",
    "searchString": "октябрьский (республика татарстан) россия / республика татарстан / октябрьский (республика татарстан)"
  },
  "7159": {
    "id": "7159",
    "name": "Поселок Бирюлинского Зверосовхоза",
    "path": "Россия / Республика Татарстан / Поселок Бирюлинского Зверосовхоза",
    "country": "Россия",
    "searchString": "поселок бирюлинского зверосовхоза россия / республика татарстан / поселок бирюлинского зверосовхоза"
  },
  "7160": {
    "id": "7160",
    "name": "Пугачево",
    "path": "Россия / Удмуртская Республика / Пугачево",
    "country": "Россия",
    "searchString": "пугачево россия / удмуртская республика / пугачево"
  },
  "7161": {
    "id": "7161",
    "name": "Шапши",
    "path": "Россия / Республика Татарстан / Шапши",
    "country": "Россия",
    "searchString": "шапши россия / республика татарстан / шапши"
  },
  "7162": {
    "id": "7162",
    "name": "Яншихово-Норваши",
    "path": "Россия / Чувашская Республика / Яншихово-Норваши",
    "country": "Россия",
    "searchString": "яншихово-норваши россия / чувашская республика / яншихово-норваши"
  },
  "7163": {
    "id": "7163",
    "name": "Камское",
    "path": "Россия / Удмуртская Республика / Камское",
    "country": "Россия",
    "searchString": "камское россия / удмуртская республика / камское"
  },
  "7164": {
    "id": "7164",
    "name": "Калмаш",
    "path": "Россия / Республика Татарстан / Калмаш",
    "country": "Россия",
    "searchString": "калмаш россия / республика татарстан / калмаш"
  },
  "7165": {
    "id": "7165",
    "name": "Укан",
    "path": "Россия / Удмуртская Республика / Укан",
    "country": "Россия",
    "searchString": "укан россия / удмуртская республика / укан"
  },
  "7166": {
    "id": "7166",
    "name": "Понино",
    "path": "Россия / Удмуртская Республика / Понино",
    "country": "Россия",
    "searchString": "понино россия / удмуртская республика / понино"
  },
  "7167": {
    "id": "7167",
    "name": "Кувакино",
    "path": "Россия / Чувашская Республика / Кувакино",
    "country": "Россия",
    "searchString": "кувакино россия / чувашская республика / кувакино"
  },
  "7168": {
    "id": "7168",
    "name": "Первое Чурашево",
    "path": "Россия / Чувашская Республика / Первое Чурашево",
    "country": "Россия",
    "searchString": "первое чурашево россия / чувашская республика / первое чурашево"
  },
  "7169": {
    "id": "7169",
    "name": "Чурачики",
    "path": "Россия / Чувашская Республика / Чурачики",
    "country": "Россия",
    "searchString": "чурачики россия / чувашская республика / чурачики"
  },
  "7170": {
    "id": "7170",
    "name": "Бичурга-Баишево",
    "path": "Россия / Чувашская Республика / Бичурга-Баишево",
    "country": "Россия",
    "searchString": "бичурга-баишево россия / чувашская республика / бичурга-баишево"
  },
  "7171": {
    "id": "7171",
    "name": "Яныши",
    "path": "Россия / Чувашская Республика / Яныши",
    "country": "Россия",
    "searchString": "яныши россия / чувашская республика / яныши"
  },
  "7172": {
    "id": "7172",
    "name": "Мокрые Курнали",
    "path": "Россия / Республика Татарстан / Мокрые Курнали",
    "country": "Россия",
    "searchString": "мокрые курнали россия / республика татарстан / мокрые курнали"
  },
  "7173": {
    "id": "7173",
    "name": "Большое Шигаево",
    "path": "Россия / Чувашская Республика / Большое Шигаево",
    "country": "Россия",
    "searchString": "большое шигаево россия / чувашская республика / большое шигаево"
  },
  "7174": {
    "id": "7174",
    "name": "Биклянь",
    "path": "Россия / Республика Татарстан / Биклянь",
    "country": "Россия",
    "searchString": "биклянь россия / республика татарстан / биклянь"
  },
  "7175": {
    "id": "7175",
    "name": "Кигбаево",
    "path": "Россия / Удмуртская Республика / Кигбаево",
    "country": "Россия",
    "searchString": "кигбаево россия / удмуртская республика / кигбаево"
  },
  "7176": {
    "id": "7176",
    "name": "Атрать",
    "path": "Россия / Чувашская Республика / Атрать",
    "country": "Россия",
    "searchString": "атрать россия / чувашская республика / атрать"
  },
  "7177": {
    "id": "7177",
    "name": "Нижние Мочары",
    "path": "Россия / Чувашская Республика / Нижние Мочары",
    "country": "Россия",
    "searchString": "нижние мочары россия / чувашская республика / нижние мочары"
  },
  "7178": {
    "id": "7178",
    "name": "Красный Стекловар",
    "path": "Россия / Республика Марий Эл / Красный Стекловар",
    "country": "Россия",
    "searchString": "красный стекловар россия / республика марий эл / красный стекловар"
  },
  "7179": {
    "id": "7179",
    "name": "Сулеево",
    "path": "Россия / Республика Татарстан / Сулеево",
    "country": "Россия",
    "searchString": "сулеево россия / республика татарстан / сулеево"
  },
  "7180": {
    "id": "7180",
    "name": "Стемасы",
    "path": "Россия / Чувашская Республика / Стемасы",
    "country": "Россия",
    "searchString": "стемасы россия / чувашская республика / стемасы"
  },
  "7181": {
    "id": "7181",
    "name": "Шушмабаш",
    "path": "Россия / Республика Татарстан / Шушмабаш",
    "country": "Россия",
    "searchString": "шушмабаш россия / республика татарстан / шушмабаш"
  },
  "7182": {
    "id": "7182",
    "name": "Большое Шемякино",
    "path": "Россия / Республика Татарстан / Большое Шемякино",
    "country": "Россия",
    "searchString": "большое шемякино россия / республика татарстан / большое шемякино"
  },
  "7183": {
    "id": "7183",
    "name": "Старое Альметьево",
    "path": "Россия / Республика Татарстан / Старое Альметьево",
    "country": "Россия",
    "searchString": "старое альметьево россия / республика татарстан / старое альметьево"
  },
  "7184": {
    "id": "7184",
    "name": "Пычас",
    "path": "Россия / Удмуртская Республика / Пычас",
    "country": "Россия",
    "searchString": "пычас россия / удмуртская республика / пычас"
  },
  "7185": {
    "id": "7185",
    "name": "Климово (Чувашская Республика)",
    "path": "Россия / Чувашская Республика / Климово (Чувашская Республика)",
    "country": "Россия",
    "searchString": "климово (чувашская республика) россия / чувашская республика / климово (чувашская республика)"
  },
  "7186": {
    "id": "7186",
    "name": "Тюмерево",
    "path": "Россия / Чувашская Республика / Тюмерево",
    "country": "Россия",
    "searchString": "тюмерево россия / чувашская республика / тюмерево"
  },
  "7187": {
    "id": "7187",
    "name": "Кляшево",
    "path": "Россия / Республика Татарстан / Кляшево",
    "country": "Россия",
    "searchString": "кляшево россия / республика татарстан / кляшево"
  },
  "7188": {
    "id": "7188",
    "name": "Сабанчино",
    "path": "Россия / Чувашская Республика / Сабанчино",
    "country": "Россия",
    "searchString": "сабанчино россия / чувашская республика / сабанчино"
  },
  "7189": {
    "id": "7189",
    "name": "Кварса",
    "path": "Россия / Удмуртская Республика / Кварса",
    "country": "Россия",
    "searchString": "кварса россия / удмуртская республика / кварса"
  },
  "7190": {
    "id": "7190",
    "name": "Николаевское",
    "path": "Россия / Чувашская Республика / Николаевское",
    "country": "Россия",
    "searchString": "николаевское россия / чувашская республика / николаевское"
  },
  "7191": {
    "id": "7191",
    "name": "Шоркистры",
    "path": "Россия / Чувашская Республика / Шоркистры",
    "country": "Россия",
    "searchString": "шоркистры россия / чувашская республика / шоркистры"
  },
  "7192": {
    "id": "7192",
    "name": "Ярославка",
    "path": "Россия / Чувашская Республика / Ярославка",
    "country": "Россия",
    "searchString": "ярославка россия / чувашская республика / ярославка"
  },
  "7193": {
    "id": "7193",
    "name": "Аккузово",
    "path": "Россия / Республика Татарстан / Аккузово",
    "country": "Россия",
    "searchString": "аккузово россия / республика татарстан / аккузово"
  },
  "7194": {
    "id": "7194",
    "name": "Верхний Такермен",
    "path": "Россия / Республика Татарстан / Верхний Такермен",
    "country": "Россия",
    "searchString": "верхний такермен россия / республика татарстан / верхний такермен"
  },
  "7195": {
    "id": "7195",
    "name": "Янгличи",
    "path": "Россия / Чувашская Республика / Янгличи",
    "country": "Россия",
    "searchString": "янгличи россия / чувашская республика / янгличи"
  },
  "7196": {
    "id": "7196",
    "name": "Тарасово",
    "path": "Россия / Удмуртская Республика / Тарасово",
    "country": "Россия",
    "searchString": "тарасово россия / удмуртская республика / тарасово"
  },
  "7197": {
    "id": "7197",
    "name": "Нармонка",
    "path": "Россия / Республика Татарстан / Нармонка",
    "country": "Россия",
    "searchString": "нармонка россия / республика татарстан / нармонка"
  },
  "7198": {
    "id": "7198",
    "name": "Анастасово",
    "path": "Россия / Чувашская Республика / Анастасово",
    "country": "Россия",
    "searchString": "анастасово россия / чувашская республика / анастасово"
  },
  "7199": {
    "id": "7199",
    "name": "Михайловка (Республика Марий Эл)",
    "path": "Россия / Республика Марий Эл / Михайловка (Республика Марий Эл)",
    "country": "Россия",
    "searchString": "михайловка (республика марий эл) россия / республика марий эл / михайловка (республика марий эл)"
  },
  "7200": {
    "id": "7200",
    "name": "Большие Яуши",
    "path": "Россия / Чувашская Республика / Большие Яуши",
    "country": "Россия",
    "searchString": "большие яуши россия / чувашская республика / большие яуши"
  },
  "7201": {
    "id": "7201",
    "name": "Лащ-Таяба",
    "path": "Россия / Чувашская Республика / Лащ-Таяба",
    "country": "Россия",
    "searchString": "лащ-таяба россия / чувашская республика / лащ-таяба"
  },
  "7202": {
    "id": "7202",
    "name": "Шеланга",
    "path": "Россия / Республика Татарстан / Шеланга",
    "country": "Россия",
    "searchString": "шеланга россия / республика татарстан / шеланга"
  },
  "7203": {
    "id": "7203",
    "name": "Чепчуги",
    "path": "Россия / Республика Татарстан / Чепчуги",
    "country": "Россия",
    "searchString": "чепчуги россия / республика татарстан / чепчуги"
  },
  "7204": {
    "id": "7204",
    "name": "Булай",
    "path": "Россия / Удмуртская Республика / Булай",
    "country": "Россия",
    "searchString": "булай россия / удмуртская республика / булай"
  },
  "7205": {
    "id": "7205",
    "name": "Чепкас-Никольское",
    "path": "Россия / Чувашская Республика / Чепкас-Никольское",
    "country": "Россия",
    "searchString": "чепкас-никольское россия / чувашская республика / чепкас-никольское"
  },
  "7206": {
    "id": "7206",
    "name": "Чутеево",
    "path": "Россия / Чувашская Республика / Чутеево",
    "country": "Россия",
    "searchString": "чутеево россия / чувашская республика / чутеево"
  },
  "7207": {
    "id": "7207",
    "name": "Пудем",
    "path": "Россия / Удмуртская Республика / Пудем",
    "country": "Россия",
    "searchString": "пудем россия / удмуртская республика / пудем"
  },
  "7208": {
    "id": "7208",
    "name": "Калинино",
    "path": "Россия / Чувашская Республика / Калинино",
    "country": "Россия",
    "searchString": "калинино россия / чувашская республика / калинино"
  },
  "7209": {
    "id": "7209",
    "name": "Нижний Каракитан",
    "path": "Россия / Республика Татарстан / Нижний Каракитан",
    "country": "Россия",
    "searchString": "нижний каракитан россия / республика татарстан / нижний каракитан"
  },
  "7210": {
    "id": "7210",
    "name": "Лубяны",
    "path": "Россия / Республика Татарстан / Лубяны",
    "country": "Россия",
    "searchString": "лубяны россия / республика татарстан / лубяны"
  },
  "7211": {
    "id": "7211",
    "name": "Старошешминск",
    "path": "Россия / Республика Татарстан / Старошешминск",
    "country": "Россия",
    "searchString": "старошешминск россия / республика татарстан / старошешминск"
  },
  "7212": {
    "id": "7212",
    "name": "Шереметьевка",
    "path": "Россия / Республика Татарстан / Шереметьевка",
    "country": "Россия",
    "searchString": "шереметьевка россия / республика татарстан / шереметьевка"
  },
  "7213": {
    "id": "7213",
    "name": "Советское (Чувашская Республика)",
    "path": "Россия / Чувашская Республика / Советское (Чувашская Республика)",
    "country": "Россия",
    "searchString": "советское (чувашская республика) россия / чувашская республика / советское (чувашская республика)"
  },
  "7214": {
    "id": "7214",
    "name": "Ерыкла",
    "path": "Россия / Республика Татарстан / Ерыкла",
    "country": "Россия",
    "searchString": "ерыкла россия / республика татарстан / ерыкла"
  },
  "7215": {
    "id": "7215",
    "name": "Старый Кувак",
    "path": "Россия / Республика Татарстан / Старый Кувак",
    "country": "Россия",
    "searchString": "старый кувак россия / республика татарстан / старый кувак"
  },
  "7216": {
    "id": "7216",
    "name": "Синьялы",
    "path": "Россия / Чувашская Республика / Синьялы",
    "country": "Россия",
    "searchString": "синьялы россия / чувашская республика / синьялы"
  },
  "7217": {
    "id": "7217",
    "name": "Песчаные Ковали",
    "path": "Россия / Республика Татарстан / Песчаные Ковали",
    "country": "Россия",
    "searchString": "песчаные ковали россия / республика татарстан / песчаные ковали"
  },
  "7218": {
    "id": "7218",
    "name": "Терси",
    "path": "Россия / Республика Татарстан / Терси",
    "country": "Россия",
    "searchString": "терси россия / республика татарстан / терси"
  },
  "7219": {
    "id": "7219",
    "name": "Тумутук",
    "path": "Россия / Республика Татарстан / Тумутук",
    "country": "Россия",
    "searchString": "тумутук россия / республика татарстан / тумутук"
  },
  "7220": {
    "id": "7220",
    "name": "Кузембетьево",
    "path": "Россия / Республика Татарстан / Кузембетьево",
    "country": "Россия",
    "searchString": "кузембетьево россия / республика татарстан / кузембетьево"
  },
  "7221": {
    "id": "7221",
    "name": "Чадукасы",
    "path": "Россия / Чувашская Республика / Чадукасы",
    "country": "Россия",
    "searchString": "чадукасы россия / чувашская республика / чадукасы"
  },
  "7222": {
    "id": "7222",
    "name": "Байряка",
    "path": "Россия / Республика Татарстан / Байряка",
    "country": "Россия",
    "searchString": "байряка россия / республика татарстан / байряка"
  },
  "7223": {
    "id": "7223",
    "name": "Старое Шаймурзино",
    "path": "Россия / Республика Татарстан / Старое Шаймурзино",
    "country": "Россия",
    "searchString": "старое шаймурзино россия / республика татарстан / старое шаймурзино"
  },
  "7224": {
    "id": "7224",
    "name": "Большие Алгаши",
    "path": "Россия / Чувашская Республика / Большие Алгаши",
    "country": "Россия",
    "searchString": "большие алгаши россия / чувашская республика / большие алгаши"
  },
  "7225": {
    "id": "7225",
    "name": "Юнга",
    "path": "Россия / Чувашская Республика / Юнга",
    "country": "Россия",
    "searchString": "юнга россия / чувашская республика / юнга"
  },
  "7226": {
    "id": "7226",
    "name": "Алманчиково",
    "path": "Россия / Чувашская Республика / Алманчиково",
    "country": "Россия",
    "searchString": "алманчиково россия / чувашская республика / алманчиково"
  },
  "7227": {
    "id": "7227",
    "name": "Средние Кибечи",
    "path": "Россия / Чувашская Республика / Средние Кибечи",
    "country": "Россия",
    "searchString": "средние кибечи россия / чувашская республика / средние кибечи"
  },
  "7228": {
    "id": "7228",
    "name": "Чалпы",
    "path": "Россия / Республика Татарстан / Чалпы",
    "country": "Россия",
    "searchString": "чалпы россия / республика татарстан / чалпы"
  },
  "7229": {
    "id": "7229",
    "name": "Сатламышево",
    "path": "Россия / Республика Татарстан / Сатламышево",
    "country": "Россия",
    "searchString": "сатламышево россия / республика татарстан / сатламышево"
  },
  "7230": {
    "id": "7230",
    "name": "Габишево",
    "path": "Россия / Республика Татарстан / Габишево",
    "country": "Россия",
    "searchString": "габишево россия / республика татарстан / габишево"
  },
  "7231": {
    "id": "7231",
    "name": "Именьково",
    "path": "Россия / Республика Татарстан / Именьково",
    "country": "Россия",
    "searchString": "именьково россия / республика татарстан / именьково"
  },
  "7232": {
    "id": "7232",
    "name": "Айбечи",
    "path": "Россия / Чувашская Республика / Айбечи",
    "country": "Россия",
    "searchString": "айбечи россия / чувашская республика / айбечи"
  },
  "7233": {
    "id": "7233",
    "name": "Водзимонье",
    "path": "Россия / Удмуртская Республика / Водзимонье",
    "country": "Россия",
    "searchString": "водзимонье россия / удмуртская республика / водзимонье"
  },
  "7234": {
    "id": "7234",
    "name": "Ходары",
    "path": "Россия / Чувашская Республика / Ходары",
    "country": "Россия",
    "searchString": "ходары россия / чувашская республика / ходары"
  },
  "7235": {
    "id": "7235",
    "name": "Совхоз Татарстан",
    "path": "Россия / Республика Татарстан / Совхоз Татарстан",
    "country": "Россия",
    "searchString": "совхоз татарстан россия / республика татарстан / совхоз татарстан"
  },
  "7236": {
    "id": "7236",
    "name": "Удугучин",
    "path": "Россия / Удмуртская Республика / Удугучин",
    "country": "Россия",
    "searchString": "удугучин россия / удмуртская республика / удугучин"
  },
  "7237": {
    "id": "7237",
    "name": "Шерауты",
    "path": "Россия / Чувашская Республика / Шерауты",
    "country": "Россия",
    "searchString": "шерауты россия / чувашская республика / шерауты"
  },
  "7238": {
    "id": "7238",
    "name": "Ленино-Кокушкино",
    "path": "Россия / Республика Татарстан / Ленино-Кокушкино",
    "country": "Россия",
    "searchString": "ленино-кокушкино россия / республика татарстан / ленино-кокушкино"
  },
  "7239": {
    "id": "7239",
    "name": "Карамышево (Чувашская Республика)",
    "path": "Россия / Чувашская Республика / Карамышево (Чувашская Республика)",
    "country": "Россия",
    "searchString": "карамышево (чувашская республика) россия / чувашская республика / карамышево (чувашская республика)"
  },
  "7240": {
    "id": "7240",
    "name": "Сугуты",
    "path": "Россия / Чувашская Республика / Сугуты",
    "country": "Россия",
    "searchString": "сугуты россия / чувашская республика / сугуты"
  },
  "7241": {
    "id": "7241",
    "name": "Елаур",
    "path": "Россия / Республика Татарстан / Елаур",
    "country": "Россия",
    "searchString": "елаур россия / республика татарстан / елаур"
  },
  "7242": {
    "id": "7242",
    "name": "Верхние Челны",
    "path": "Россия / Республика Татарстан / Верхние Челны",
    "country": "Россия",
    "searchString": "верхние челны россия / республика татарстан / верхние челны"
  },
  "7243": {
    "id": "7243",
    "name": "Кряш-Шуран",
    "path": "Россия / Республика Татарстан / Кряш-Шуран",
    "country": "Россия",
    "searchString": "кряш-шуран россия / республика татарстан / кряш-шуран"
  },
  "7244": {
    "id": "7244",
    "name": "Суслонгер",
    "path": "Россия / Республика Марий Эл / Суслонгер",
    "country": "Россия",
    "searchString": "суслонгер россия / республика марий эл / суслонгер"
  },
  "7245": {
    "id": "7245",
    "name": "Старые Карамалы",
    "path": "Россия / Республика Татарстан / Старые Карамалы",
    "country": "Россия",
    "searchString": "старые карамалы россия / республика татарстан / старые карамалы"
  },
  "7246": {
    "id": "7246",
    "name": "Татарские Ямалы",
    "path": "Россия / Республика Татарстан / Татарские Ямалы",
    "country": "Россия",
    "searchString": "татарские ямалы россия / республика татарстан / татарские ямалы"
  },
  "7247": {
    "id": "7247",
    "name": "Старые Челны",
    "path": "Россия / Республика Татарстан / Старые Челны",
    "country": "Россия",
    "searchString": "старые челны россия / республика татарстан / старые челны"
  },
  "7248": {
    "id": "7248",
    "name": "Кощаково",
    "path": "Россия / Республика Татарстан / Кощаково",
    "country": "Россия",
    "searchString": "кощаково россия / республика татарстан / кощаково"
  },
  "7249": {
    "id": "7249",
    "name": "Нижний Таканыш",
    "path": "Россия / Республика Татарстан / Нижний Таканыш",
    "country": "Россия",
    "searchString": "нижний таканыш россия / республика татарстан / нижний таканыш"
  },
  "7250": {
    "id": "7250",
    "name": "Старые Бугады",
    "path": "Россия / Республика Татарстан / Старые Бугады",
    "country": "Россия",
    "searchString": "старые бугады россия / республика татарстан / старые бугады"
  },
  "7251": {
    "id": "7251",
    "name": "Юхмачи",
    "path": "Россия / Республика Татарстан / Юхмачи",
    "country": "Россия",
    "searchString": "юхмачи россия / республика татарстан / юхмачи"
  },
  "7252": {
    "id": "7252",
    "name": "Татарский Сарсаз",
    "path": "Россия / Республика Татарстан / Татарский Сарсаз",
    "country": "Россия",
    "searchString": "татарский сарсаз россия / республика татарстан / татарский сарсаз"
  },
  "7253": {
    "id": "7253",
    "name": "Биляр-Озеро",
    "path": "Россия / Республика Татарстан / Биляр-Озеро",
    "country": "Россия",
    "searchString": "биляр-озеро россия / республика татарстан / биляр-озеро"
  },
  "7254": {
    "id": "7254",
    "name": "Макулово",
    "path": "Россия / Республика Татарстан / Макулово",
    "country": "Россия",
    "searchString": "макулово россия / республика татарстан / макулово"
  },
  "7255": {
    "id": "7255",
    "name": "Кулаево",
    "path": "Россия / Республика Татарстан / Кулаево",
    "country": "Россия",
    "searchString": "кулаево россия / республика татарстан / кулаево"
  },
  "7256": {
    "id": "7256",
    "name": "Бабино",
    "path": "Россия / Удмуртская Республика / Бабино",
    "country": "Россия",
    "searchString": "бабино россия / удмуртская республика / бабино"
  },
  "7257": {
    "id": "7257",
    "name": "Трехбалтаево",
    "path": "Россия / Чувашская Республика / Трехбалтаево",
    "country": "Россия",
    "searchString": "трехбалтаево россия / чувашская республика / трехбалтаево"
  },
  "7258": {
    "id": "7258",
    "name": "Испуханы",
    "path": "Россия / Чувашская Республика / Испуханы",
    "country": "Россия",
    "searchString": "испуханы россия / чувашская республика / испуханы"
  },
  "7259": {
    "id": "7259",
    "name": "Апазово",
    "path": "Россия / Республика Татарстан / Апазово",
    "country": "Россия",
    "searchString": "апазово россия / республика татарстан / апазово"
  },
  "7260": {
    "id": "7260",
    "name": "Силикатный",
    "path": "Россия / Республика Марий Эл / Силикатный",
    "country": "Россия",
    "searchString": "силикатный россия / республика марий эл / силикатный"
  },
  "7261": {
    "id": "7261",
    "name": "Шемалаково",
    "path": "Россия / Чувашская Республика / Шемалаково",
    "country": "Россия",
    "searchString": "шемалаково россия / чувашская республика / шемалаково"
  },
  "7262": {
    "id": "7262",
    "name": "Большое Яниково",
    "path": "Россия / Чувашская Республика / Большое Яниково",
    "country": "Россия",
    "searchString": "большое яниково россия / чувашская республика / большое яниково"
  },
  "7263": {
    "id": "7263",
    "name": "Кармалы",
    "path": "Россия / Республика Татарстан / Кармалы",
    "country": "Россия",
    "searchString": "кармалы россия / республика татарстан / кармалы"
  },
  "7264": {
    "id": "7264",
    "name": "Новые Шальтямы",
    "path": "Россия / Чувашская Республика / Новые Шальтямы",
    "country": "Россия",
    "searchString": "новые шальтямы россия / чувашская республика / новые шальтямы"
  },
  "7265": {
    "id": "7265",
    "name": "Старые Атаи",
    "path": "Россия / Чувашская Республика / Старые Атаи",
    "country": "Россия",
    "searchString": "старые атаи россия / чувашская республика / старые атаи"
  },
  "7266": {
    "id": "7266",
    "name": "Аксарино",
    "path": "Россия / Чувашская Республика / Аксарино",
    "country": "Россия",
    "searchString": "аксарино россия / чувашская республика / аксарино"
  },
  "7267": {
    "id": "7267",
    "name": "Тувси",
    "path": "Россия / Чувашская Республика / Тувси",
    "country": "Россия",
    "searchString": "тувси россия / чувашская республика / тувси"
  },
  "7268": {
    "id": "7268",
    "name": "Шоршелы",
    "path": "Россия / Чувашская Республика / Шоршелы",
    "country": "Россия",
    "searchString": "шоршелы россия / чувашская республика / шоршелы"
  },
  "7269": {
    "id": "7269",
    "name": "Челкасы",
    "path": "Россия / Чувашская Республика / Челкасы",
    "country": "Россия",
    "searchString": "челкасы россия / чувашская республика / челкасы"
  },
  "7270": {
    "id": "7270",
    "name": "Киря",
    "path": "Россия / Чувашская Республика / Киря",
    "country": "Россия",
    "searchString": "киря россия / чувашская республика / киря"
  },
  "7271": {
    "id": "7271",
    "name": "Чепца",
    "path": "Россия / Удмуртская Республика / Чепца",
    "country": "Россия",
    "searchString": "чепца россия / удмуртская республика / чепца"
  },
  "7272": {
    "id": "7272",
    "name": "Новая Бия",
    "path": "Россия / Удмуртская Республика / Новая Бия",
    "country": "Россия",
    "searchString": "новая бия россия / удмуртская республика / новая бия"
  },
  "7273": {
    "id": "7273",
    "name": "Жуково",
    "path": "Россия / Республика Татарстан / Жуково",
    "country": "Россия",
    "searchString": "жуково россия / республика татарстан / жуково"
  },
  "7274": {
    "id": "7274",
    "name": "Чувашские Тимяши",
    "path": "Россия / Чувашская Республика / Чувашские Тимяши",
    "country": "Россия",
    "searchString": "чувашские тимяши россия / чувашская республика / чувашские тимяши"
  },
  "7275": {
    "id": "7275",
    "name": "Саклов-Баш",
    "path": "Россия / Республика Татарстан / Саклов-Баш",
    "country": "Россия",
    "searchString": "саклов-баш россия / республика татарстан / саклов-баш"
  },
  "7276": {
    "id": "7276",
    "name": "Еметкино",
    "path": "Россия / Чувашская Республика / Еметкино",
    "country": "Россия",
    "searchString": "еметкино россия / чувашская республика / еметкино"
  },
  "7277": {
    "id": "7277",
    "name": "Исенбаево",
    "path": "Россия / Республика Татарстан / Исенбаево",
    "country": "Россия",
    "searchString": "исенбаево россия / республика татарстан / исенбаево"
  },
  "7278": {
    "id": "7278",
    "name": "Ишаки",
    "path": "Россия / Чувашская Республика / Ишаки",
    "country": "Россия",
    "searchString": "ишаки россия / чувашская республика / ишаки"
  },
  "7279": {
    "id": "7279",
    "name": "Иваньково-Ленино",
    "path": "Россия / Чувашская Республика / Иваньково-Ленино",
    "country": "Россия",
    "searchString": "иваньково-ленино россия / чувашская республика / иваньково-ленино"
  },
  "7280": {
    "id": "7280",
    "name": "Малое Янгорчино",
    "path": "Россия / Чувашская Республика / Малое Янгорчино",
    "country": "Россия",
    "searchString": "малое янгорчино россия / чувашская республика / малое янгорчино"
  },
  "7281": {
    "id": "7281",
    "name": "Малая Елга",
    "path": "Россия / Республика Татарстан / Малая Елга",
    "country": "Россия",
    "searchString": "малая елга россия / республика татарстан / малая елга"
  },
  "7282": {
    "id": "7282",
    "name": "Красный Ключ",
    "path": "Россия / Республика Татарстан / Красный Ключ",
    "country": "Россия",
    "searchString": "красный ключ россия / республика татарстан / красный ключ"
  },
  "7283": {
    "id": "7283",
    "name": "Юлтимерово",
    "path": "Россия / Республика Татарстан / Юлтимерово",
    "country": "Россия",
    "searchString": "юлтимерово россия / республика татарстан / юлтимерово"
  },
  "7284": {
    "id": "7284",
    "name": "Зура",
    "path": "Россия / Удмуртская Республика / Зура",
    "country": "Россия",
    "searchString": "зура россия / удмуртская республика / зура"
  },
  "7285": {
    "id": "7285",
    "name": "Уральский (Удмуртская Республика)",
    "path": "Россия / Удмуртская Республика / Уральский (Удмуртская Республика)",
    "country": "Россия",
    "searchString": "уральский (удмуртская республика) россия / удмуртская республика / уральский (удмуртская республика)"
  },
  "7286": {
    "id": "7286",
    "name": "Шимкусы",
    "path": "Россия / Чувашская Республика / Шимкусы",
    "country": "Россия",
    "searchString": "шимкусы россия / чувашская республика / шимкусы"
  },
  "7287": {
    "id": "7287",
    "name": "Мангут",
    "path": "Россия / Забайкальский край / Мангут",
    "country": "Россия",
    "searchString": "мангут россия / забайкальский край / мангут"
  },
  "7288": {
    "id": "7288",
    "name": "Машуковка",
    "path": "Россия / Красноярский край / Машуковка",
    "country": "Россия",
    "searchString": "машуковка россия / красноярский край / машуковка"
  },
  "7289": {
    "id": "7289",
    "name": "Эдучанка",
    "path": "Россия / Иркутская область / Эдучанка",
    "country": "Россия",
    "searchString": "эдучанка россия / иркутская область / эдучанка"
  },
  "7290": {
    "id": "7290",
    "name": "Чинеке",
    "path": "Россия / Республика Саха (Якутия) / Чинеке",
    "country": "Россия",
    "searchString": "чинеке россия / республика саха (якутия) / чинеке"
  },
  "7291": {
    "id": "7291",
    "name": "Жиндо",
    "path": "Россия / Забайкальский край / Жиндо",
    "country": "Россия",
    "searchString": "жиндо россия / забайкальский край / жиндо"
  },
  "7292": {
    "id": "7292",
    "name": "Седаново",
    "path": "Россия / Иркутская область / Седаново",
    "country": "Россия",
    "searchString": "седаново россия / иркутская область / седаново"
  },
  "7293": {
    "id": "7293",
    "name": "Кюсюр",
    "path": "Россия / Республика Саха (Якутия) / Кюсюр",
    "country": "Россия",
    "searchString": "кюсюр россия / республика саха (якутия) / кюсюр"
  },
  "7294": {
    "id": "7294",
    "name": "Давенда",
    "path": "Россия / Забайкальский край / Давенда",
    "country": "Россия",
    "searchString": "давенда россия / забайкальский край / давенда"
  },
  "7295": {
    "id": "7295",
    "name": "Большая Иня",
    "path": "Россия / Красноярский край / Большая Иня",
    "country": "Россия",
    "searchString": "большая иня россия / красноярский край / большая иня"
  },
  "7296": {
    "id": "7296",
    "name": "Российка",
    "path": "Россия / Красноярский край / Российка",
    "country": "Россия",
    "searchString": "российка россия / красноярский край / российка"
  },
  "7297": {
    "id": "7297",
    "name": "Золотореченск",
    "path": "Россия / Забайкальский край / Золотореченск",
    "country": "Россия",
    "searchString": "золотореченск россия / забайкальский край / золотореченск"
  },
  "7298": {
    "id": "7298",
    "name": "Урульга",
    "path": "Россия / Забайкальский край / Урульга",
    "country": "Россия",
    "searchString": "урульга россия / забайкальский край / урульга"
  },
  "7299": {
    "id": "7299",
    "name": "Кемпендяй",
    "path": "Россия / Республика Саха (Якутия) / Кемпендяй",
    "country": "Россия",
    "searchString": "кемпендяй россия / республика саха (якутия) / кемпендяй"
  },
  "7300": {
    "id": "7300",
    "name": "Кома",
    "path": "Россия / Республика Бурятия / Кома",
    "country": "Россия",
    "searchString": "кома россия / республика бурятия / кома"
  },
  "7301": {
    "id": "7301",
    "name": "Урлук",
    "path": "Россия / Забайкальский край / Урлук",
    "country": "Россия",
    "searchString": "урлук россия / забайкальский край / урлук"
  },
  "7302": {
    "id": "7302",
    "name": "Кюндядя",
    "path": "Россия / Республика Саха (Якутия) / Кюндядя",
    "country": "Россия",
    "searchString": "кюндядя россия / республика саха (якутия) / кюндядя"
  },
  "7303": {
    "id": "7303",
    "name": "Новая Кука",
    "path": "Россия / Забайкальский край / Новая Кука",
    "country": "Россия",
    "searchString": "новая кука россия / забайкальский край / новая кука"
  },
  "7304": {
    "id": "7304",
    "name": "Парная",
    "path": "Россия / Красноярский край / Парная",
    "country": "Россия",
    "searchString": "парная россия / красноярский край / парная"
  },
  "7305": {
    "id": "7305",
    "name": "Ксеньевка",
    "path": "Россия / Забайкальский край / Ксеньевка",
    "country": "Россия",
    "searchString": "ксеньевка россия / забайкальский край / ксеньевка"
  },
  "7306": {
    "id": "7306",
    "name": "Ангоя",
    "path": "Россия / Республика Бурятия / Ангоя",
    "country": "Россия",
    "searchString": "ангоя россия / республика бурятия / ангоя"
  },
  "7307": {
    "id": "7307",
    "name": "Усть-Миль",
    "path": "Россия / Республика Саха (Якутия) / Усть-Миль",
    "country": "Россия",
    "searchString": "усть-миль россия / республика саха (якутия) / усть-миль"
  },
  "7308": {
    "id": "7308",
    "name": "Тесь",
    "path": "Россия / Красноярский край / Тесь",
    "country": "Россия",
    "searchString": "тесь россия / красноярский край / тесь"
  },
  "7309": {
    "id": "7309",
    "name": "Альбитуй",
    "path": "Россия / Забайкальский край / Альбитуй",
    "country": "Россия",
    "searchString": "альбитуй россия / забайкальский край / альбитуй"
  },
  "7310": {
    "id": "7310",
    "name": "Усть-Куйга",
    "path": "Россия / Республика Саха (Якутия) / Усть-Куйга",
    "country": "Россия",
    "searchString": "усть-куйга россия / республика саха (якутия) / усть-куйга"
  },
  "7311": {
    "id": "7311",
    "name": "Ербогачен",
    "path": "Россия / Иркутская область / Ербогачен",
    "country": "Россия",
    "searchString": "ербогачен россия / иркутская область / ербогачен"
  },
  "7312": {
    "id": "7312",
    "name": "Аргахтах",
    "path": "Россия / Республика Саха (Якутия) / Аргахтах",
    "country": "Россия",
    "searchString": "аргахтах россия / республика саха (якутия) / аргахтах"
  },
  "7313": {
    "id": "7313",
    "name": "Сизая",
    "path": "Россия / Красноярский край / Сизая",
    "country": "Россия",
    "searchString": "сизая россия / красноярский край / сизая"
  },
  "7314": {
    "id": "7314",
    "name": "Хоронхой",
    "path": "Россия / Республика Бурятия / Хоронхой",
    "country": "Россия",
    "searchString": "хоронхой россия / республика бурятия / хоронхой"
  },
  "7315": {
    "id": "7315",
    "name": "Мохсоголлох",
    "path": "Россия / Республика Саха (Якутия) / Мохсоголлох",
    "country": "Россия",
    "searchString": "мохсоголлох россия / республика саха (якутия) / мохсоголлох"
  },
  "7316": {
    "id": "7316",
    "name": "Копьево",
    "path": "Россия / Республика Хакасия / Копьево",
    "country": "Россия",
    "searchString": "копьево россия / республика хакасия / копьево"
  },
  "7317": {
    "id": "7317",
    "name": "Боград",
    "path": "Россия / Республика Хакасия / Боград",
    "country": "Россия",
    "searchString": "боград россия / республика хакасия / боград"
  },
  "7318": {
    "id": "7318",
    "name": "Каа-Хем",
    "path": "Россия / Республика Тыва / Каа-Хем",
    "country": "Россия",
    "searchString": "каа-хем россия / республика тыва / каа-хем"
  },
  "7319": {
    "id": "7319",
    "name": "Бельтирское",
    "path": "Россия / Республика Хакасия / Бельтирское",
    "country": "Россия",
    "searchString": "бельтирское россия / республика хакасия / бельтирское"
  },
  "7320": {
    "id": "7320",
    "name": "Кобяй",
    "path": "Россия / Республика Саха (Якутия) / Кобяй",
    "country": "Россия",
    "searchString": "кобяй россия / республика саха (якутия) / кобяй"
  },
  "7321": {
    "id": "7321",
    "name": "Покосное",
    "path": "Россия / Иркутская область / Покосное",
    "country": "Россия",
    "searchString": "покосное россия / иркутская область / покосное"
  },
  "7322": {
    "id": "7322",
    "name": "Уян",
    "path": "Россия / Иркутская область / Уян",
    "country": "Россия",
    "searchString": "уян россия / иркутская область / уян"
  },
  "7323": {
    "id": "7323",
    "name": "Бискамжа",
    "path": "Россия / Республика Хакасия / Бискамжа",
    "country": "Россия",
    "searchString": "бискамжа россия / республика хакасия / бискамжа"
  },
  "7324": {
    "id": "7324",
    "name": "Кимильтей",
    "path": "Россия / Иркутская область / Кимильтей",
    "country": "Россия",
    "searchString": "кимильтей россия / иркутская область / кимильтей"
  },
  "7325": {
    "id": "7325",
    "name": "Амга",
    "path": "Россия / Республика Саха (Якутия) / Амга",
    "country": "Россия",
    "searchString": "амга россия / республика саха (якутия) / амга"
  },
  "7326": {
    "id": "7326",
    "name": "Тюльково",
    "path": "Россия / Красноярский край / Тюльково",
    "country": "Россия",
    "searchString": "тюльково россия / красноярский край / тюльково"
  },
  "7327": {
    "id": "7327",
    "name": "Мар",
    "path": "Россия / Республика Саха (Якутия) / Мар",
    "country": "Россия",
    "searchString": "мар россия / республика саха (якутия) / мар"
  },
  "7328": {
    "id": "7328",
    "name": "Филимоново",
    "path": "Россия / Красноярский край / Филимоново",
    "country": "Россия",
    "searchString": "филимоново россия / красноярский край / филимоново"
  },
  "7329": {
    "id": "7329",
    "name": "Листвянка",
    "path": "Россия / Иркутская область / Листвянка",
    "country": "Россия",
    "searchString": "листвянка россия / иркутская область / листвянка"
  },
  "7330": {
    "id": "7330",
    "name": "Сангар",
    "path": "Россия / Республика Саха (Якутия) / Сангар",
    "country": "Россия",
    "searchString": "сангар россия / республика саха (якутия) / сангар"
  },
  "7331": {
    "id": "7331",
    "name": "Пировское",
    "path": "Россия / Красноярский край / Пировское",
    "country": "Россия",
    "searchString": "пировское россия / красноярский край / пировское"
  },
  "7332": {
    "id": "7332",
    "name": "Подгорный",
    "path": "Россия / Красноярский край / Подгорный",
    "country": "Россия",
    "searchString": "подгорный россия / красноярский край / подгорный"
  },
  "7333": {
    "id": "7333",
    "name": "Чара",
    "path": "Россия / Забайкальский край / Чара",
    "country": "Россия",
    "searchString": "чара россия / забайкальский край / чара"
  },
  "7334": {
    "id": "7334",
    "name": "Букачача",
    "path": "Россия / Забайкальский край / Букачача",
    "country": "Россия",
    "searchString": "букачача россия / забайкальский край / букачача"
  },
  "7335": {
    "id": "7335",
    "name": "Тоора-Хем",
    "path": "Россия / Республика Тыва / Тоора-Хем",
    "country": "Россия",
    "searchString": "тоора-хем россия / республика тыва / тоора-хем"
  },
  "7336": {
    "id": "7336",
    "name": "Жирекен",
    "path": "Россия / Забайкальский край / Жирекен",
    "country": "Россия",
    "searchString": "жирекен россия / забайкальский край / жирекен"
  },
  "7337": {
    "id": "7337",
    "name": "Маринино",
    "path": "Россия / Красноярский край / Маринино",
    "country": "Россия",
    "searchString": "маринино россия / красноярский край / маринино"
  },
  "7338": {
    "id": "7338",
    "name": "Черемшанка",
    "path": "Россия / Красноярский край / Черемшанка",
    "country": "Россия",
    "searchString": "черемшанка россия / красноярский край / черемшанка"
  },
  "7339": {
    "id": "7339",
    "name": "Тойбохой",
    "path": "Россия / Республика Саха (Якутия) / Тойбохой",
    "country": "Россия",
    "searchString": "тойбохой россия / республика саха (якутия) / тойбохой"
  },
  "7340": {
    "id": "7340",
    "name": "Артемовский (Иркутская область)",
    "path": "Россия / Иркутская область / Артемовский (Иркутская область)",
    "country": "Россия",
    "searchString": "артемовский (иркутская область) россия / иркутская область / артемовский (иркутская область)"
  },
  "7341": {
    "id": "7341",
    "name": "Болугур",
    "path": "Россия / Республика Саха (Якутия) / Болугур",
    "country": "Россия",
    "searchString": "болугур россия / республика саха (якутия) / болугур"
  },
  "7342": {
    "id": "7342",
    "name": "Малыкай",
    "path": "Россия / Республика Саха (Якутия) / Малыкай",
    "country": "Россия",
    "searchString": "малыкай россия / республика саха (якутия) / малыкай"
  },
  "7343": {
    "id": "7343",
    "name": "Досатуй",
    "path": "Россия / Забайкальский край / Досатуй",
    "country": "Россия",
    "searchString": "досатуй россия / забайкальский край / досатуй"
  },
  "7344": {
    "id": "7344",
    "name": "Ильичево",
    "path": "Россия / Красноярский край / Ильичево",
    "country": "Россия",
    "searchString": "ильичево россия / красноярский край / ильичево"
  },
  "7345": {
    "id": "7345",
    "name": "Памяти 13 Борцов",
    "path": "Россия / Красноярский край / Памяти 13 Борцов",
    "country": "Россия",
    "searchString": "памяти 13 борцов россия / красноярский край / памяти 13 борцов"
  },
  "7346": {
    "id": "7346",
    "name": "Иенгра",
    "path": "Россия / Республика Саха (Якутия) / Иенгра",
    "country": "Россия",
    "searchString": "иенгра россия / республика саха (якутия) / иенгра"
  },
  "7347": {
    "id": "7347",
    "name": "Устинкино",
    "path": "Россия / Республика Хакасия / Устинкино",
    "country": "Россия",
    "searchString": "устинкино россия / республика хакасия / устинкино"
  },
  "7348": {
    "id": "7348",
    "name": "Каптырево",
    "path": "Россия / Красноярский край / Каптырево",
    "country": "Россия",
    "searchString": "каптырево россия / красноярский край / каптырево"
  },
  "7349": {
    "id": "7349",
    "name": "Янталь",
    "path": "Россия / Иркутская область / Янталь",
    "country": "Россия",
    "searchString": "янталь россия / иркутская область / янталь"
  },
  "7350": {
    "id": "7350",
    "name": "Шиткино",
    "path": "Россия / Иркутская область / Шиткино",
    "country": "Россия",
    "searchString": "шиткино россия / иркутская область / шиткино"
  },
  "7351": {
    "id": "7351",
    "name": "Видим",
    "path": "Россия / Иркутская область / Видим",
    "country": "Россия",
    "searchString": "видим россия / иркутская область / видим"
  },
  "7352": {
    "id": "7352",
    "name": "Новая Солянка",
    "path": "Россия / Красноярский край / Новая Солянка",
    "country": "Россия",
    "searchString": "новая солянка россия / красноярский край / новая солянка"
  },
  "7353": {
    "id": "7353",
    "name": "Красная Сопка",
    "path": "Россия / Красноярский край / Красная Сопка",
    "country": "Россия",
    "searchString": "красная сопка россия / красноярский край / красная сопка"
  },
  "7354": {
    "id": "7354",
    "name": "Подтесово",
    "path": "Россия / Красноярский край / Подтесово",
    "country": "Россия",
    "searchString": "подтесово россия / красноярский край / подтесово"
  },
  "7355": {
    "id": "7355",
    "name": "Маккавеево",
    "path": "Россия / Забайкальский край / Маккавеево",
    "country": "Россия",
    "searchString": "маккавеево россия / забайкальский край / маккавеево"
  },
  "7356": {
    "id": "7356",
    "name": "Хохотуй",
    "path": "Россия / Забайкальский край / Хохотуй",
    "country": "Россия",
    "searchString": "хохотуй россия / забайкальский край / хохотуй"
  },
  "7357": {
    "id": "7357",
    "name": "Шалоболино",
    "path": "Россия / Красноярский край / Шалоболино",
    "country": "Россия",
    "searchString": "шалоболино россия / красноярский край / шалоболино"
  },
  "7358": {
    "id": "7358",
    "name": "Курорт-Дарасун",
    "path": "Россия / Забайкальский край / Курорт-Дарасун",
    "country": "Россия",
    "searchString": "курорт-дарасун россия / забайкальский край / курорт-дарасун"
  },
  "7359": {
    "id": "7359",
    "name": "Зеленый Бор",
    "path": "Россия / Красноярский край / Зеленый Бор",
    "country": "Россия",
    "searchString": "зеленый бор россия / красноярский край / зеленый бор"
  },
  "7360": {
    "id": "7360",
    "name": "Эбях",
    "path": "Россия / Республика Саха (Якутия) / Эбях",
    "country": "Россия",
    "searchString": "эбях россия / республика саха (якутия) / эбях"
  },
  "7361": {
    "id": "7361",
    "name": "Тубинский",
    "path": "Россия / Иркутская область / Тубинский",
    "country": "Россия",
    "searchString": "тубинский россия / иркутская область / тубинский"
  },
  "7362": {
    "id": "7362",
    "name": "Карымск",
    "path": "Россия / Иркутская область / Карымск",
    "country": "Россия",
    "searchString": "карымск россия / иркутская область / карымск"
  },
  "7363": {
    "id": "7363",
    "name": "Первомайское (Республика Хакасия)",
    "path": "Россия / Республика Хакасия / Первомайское (Республика Хакасия)",
    "country": "Россия",
    "searchString": "первомайское (республика хакасия) россия / республика хакасия / первомайское (республика хакасия)"
  },
  "7364": {
    "id": "7364",
    "name": "Жипхеген",
    "path": "Россия / Забайкальский край / Жипхеген",
    "country": "Россия",
    "searchString": "жипхеген россия / забайкальский край / жипхеген"
  },
  "7365": {
    "id": "7365",
    "name": "Сарыг-Сеп",
    "path": "Россия / Республика Тыва / Сарыг-Сеп",
    "country": "Россия",
    "searchString": "сарыг-сеп россия / республика тыва / сарыг-сеп"
  },
  "7366": {
    "id": "7366",
    "name": "Южно-Енисейск",
    "path": "Россия / Красноярский край / Южно-Енисейск",
    "country": "Россия",
    "searchString": "южно-енисейск россия / красноярский край / южно-енисейск"
  },
  "7367": {
    "id": "7367",
    "name": "Раздолинск",
    "path": "Россия / Красноярский край / Раздолинск",
    "country": "Россия",
    "searchString": "раздолинск россия / красноярский край / раздолинск"
  },
  "7368": {
    "id": "7368",
    "name": "Гусиное Озеро",
    "path": "Россия / Республика Бурятия / Гусиное Озеро",
    "country": "Россия",
    "searchString": "гусиное озеро россия / республика бурятия / гусиное озеро"
  },
  "7369": {
    "id": "7369",
    "name": "Ангарский",
    "path": "Россия / Красноярский край / Ангарский",
    "country": "Россия",
    "searchString": "ангарский россия / красноярский край / ангарский"
  },
  "7370": {
    "id": "7370",
    "name": "Орлик",
    "path": "Россия / Республика Бурятия / Орлик",
    "country": "Россия",
    "searchString": "орлик россия / республика бурятия / орлик"
  },
  "7371": {
    "id": "7371",
    "name": "Аршан (Бурятия)",
    "path": "Россия / Республика Бурятия / Аршан (Бурятия)",
    "country": "Россия",
    "searchString": "аршан (бурятия) россия / республика бурятия / аршан (бурятия)"
  },
  "7372": {
    "id": "7372",
    "name": "Ленинский (Республика Саха (Якутия))",
    "path": "Россия / Республика Саха (Якутия) / Ленинский (Республика Саха (Якутия))",
    "country": "Россия",
    "searchString": "ленинский (республика саха (якутия)) россия / республика саха (якутия) / ленинский (республика саха (якутия))"
  },
  "7373": {
    "id": "7373",
    "name": "Тээли",
    "path": "Россия / Республика Тыва / Тээли",
    "country": "Россия",
    "searchString": "тээли россия / республика тыва / тээли"
  },
  "7374": {
    "id": "7374",
    "name": "Первомайск (Красноярский край)",
    "path": "Россия / Красноярский край / Первомайск (Красноярский край)",
    "country": "Россия",
    "searchString": "первомайск (красноярский край) россия / красноярский край / первомайск (красноярский край)"
  },
  "7375": {
    "id": "7375",
    "name": "Майна (Республика Хакасия)",
    "path": "Россия / Республика Хакасия / Майна (Республика Хакасия)",
    "country": "Россия",
    "searchString": "майна (республика хакасия) россия / республика хакасия / майна (республика хакасия)"
  },
  "7376": {
    "id": "7376",
    "name": "Большая Уря",
    "path": "Россия / Красноярский край / Большая Уря",
    "country": "Россия",
    "searchString": "большая уря россия / красноярский край / большая уря"
  },
  "7377": {
    "id": "7377",
    "name": "Бадар",
    "path": "Россия / Иркутская область / Бадар",
    "country": "Россия",
    "searchString": "бадар россия / иркутская область / бадар"
  },
  "7378": {
    "id": "7378",
    "name": "Речушка",
    "path": "Россия / Иркутская область / Речушка",
    "country": "Россия",
    "searchString": "речушка россия / иркутская область / речушка"
  },
  "7379": {
    "id": "7379",
    "name": "Златоруновск",
    "path": "Россия / Красноярский край / Златоруновск",
    "country": "Россия",
    "searchString": "златоруновск россия / красноярский край / златоруновск"
  },
  "7380": {
    "id": "7380",
    "name": "Депутатский",
    "path": "Россия / Республика Саха (Якутия) / Депутатский",
    "country": "Россия",
    "searchString": "депутатский россия / республика саха (якутия) / депутатский"
  },
  "7381": {
    "id": "7381",
    "name": "Абалаково",
    "path": "Россия / Красноярский край / Абалаково",
    "country": "Россия",
    "searchString": "абалаково россия / красноярский край / абалаково"
  },
  "7382": {
    "id": "7382",
    "name": "Усун",
    "path": "Россия / Республика Саха (Якутия) / Усун",
    "country": "Россия",
    "searchString": "усун россия / республика саха (якутия) / усун"
  },
  "7383": {
    "id": "7383",
    "name": "Кутана",
    "path": "Россия / Республика Саха (Якутия) / Кутана",
    "country": "Россия",
    "searchString": "кутана россия / республика саха (якутия) / кутана"
  },
  "7384": {
    "id": "7384",
    "name": "Сылгы-Ыытар",
    "path": "Россия / Республика Саха (Якутия) / Сылгы-Ыытар",
    "country": "Россия",
    "searchString": "сылгы-ыытар россия / республика саха (якутия) / сылгы-ыытар"
  },
  "7385": {
    "id": "7385",
    "name": "Самагалтай",
    "path": "Россия / Республика Тыва / Самагалтай",
    "country": "Россия",
    "searchString": "самагалтай россия / республика тыва / самагалтай"
  },
  "7386": {
    "id": "7386",
    "name": "Икей",
    "path": "Россия / Иркутская область / Икей",
    "country": "Россия",
    "searchString": "икей россия / иркутская область / икей"
  },
  "7387": {
    "id": "7387",
    "name": "Харик",
    "path": "Россия / Иркутская область / Харик",
    "country": "Россия",
    "searchString": "харик россия / иркутская область / харик"
  },
  "7388": {
    "id": "7388",
    "name": "Кордово",
    "path": "Россия / Красноярский край / Кордово",
    "country": "Россия",
    "searchString": "кордово россия / красноярский край / кордово"
  },
  "7389": {
    "id": "7389",
    "name": "Октемцы",
    "path": "Россия / Республика Саха (Якутия) / Октемцы",
    "country": "Россия",
    "searchString": "октемцы россия / республика саха (якутия) / октемцы"
  },
  "7390": {
    "id": "7390",
    "name": "Красногорьевский",
    "path": "Россия / Красноярский край / Красногорьевский",
    "country": "Россия",
    "searchString": "красногорьевский россия / красноярский край / красногорьевский"
  },
  "7391": {
    "id": "7391",
    "name": "Широкая",
    "path": "Россия / Забайкальский край / Широкая",
    "country": "Россия",
    "searchString": "широкая россия / забайкальский край / широкая"
  },
  "7392": {
    "id": "7392",
    "name": "Малета",
    "path": "Россия / Забайкальский край / Малета",
    "country": "Россия",
    "searchString": "малета россия / забайкальский край / малета"
  },
  "7393": {
    "id": "7393",
    "name": "Будагово",
    "path": "Россия / Иркутская область / Будагово",
    "country": "Россия",
    "searchString": "будагово россия / иркутская область / будагово"
  },
  "7394": {
    "id": "7394",
    "name": "Олонки",
    "path": "Россия / Иркутская область / Олонки",
    "country": "Россия",
    "searchString": "олонки россия / иркутская область / олонки"
  },
  "7395": {
    "id": "7395",
    "name": "Ук",
    "path": "Россия / Иркутская область / Ук",
    "country": "Россия",
    "searchString": "ук россия / иркутская область / ук"
  },
  "7396": {
    "id": "7396",
    "name": "Урал",
    "path": "Россия / Красноярский край / Урал",
    "country": "Россия",
    "searchString": "урал россия / красноярский край / урал"
  },
  "7397": {
    "id": "7397",
    "name": "Куанда",
    "path": "Россия / Забайкальский край / Куанда",
    "country": "Россия",
    "searchString": "куанда россия / забайкальский край / куанда"
  },
  "7398": {
    "id": "7398",
    "name": "Новокаргино",
    "path": "Россия / Красноярский край / Новокаргино",
    "country": "Россия",
    "searchString": "новокаргино россия / красноярский край / новокаргино"
  },
  "7399": {
    "id": "7399",
    "name": "Тупик",
    "path": "Россия / Забайкальский край / Тупик",
    "country": "Россия",
    "searchString": "тупик россия / забайкальский край / тупик"
  },
  "7400": {
    "id": "7400",
    "name": "Забитуй",
    "path": "Россия / Иркутская область / Забитуй",
    "country": "Россия",
    "searchString": "забитуй россия / иркутская область / забитуй"
  },
  "7401": {
    "id": "7401",
    "name": "Зырянка",
    "path": "Россия / Республика Саха (Якутия) / Зырянка",
    "country": "Россия",
    "searchString": "зырянка россия / республика саха (якутия) / зырянка"
  },
  "7402": {
    "id": "7402",
    "name": "Нижний Куранах",
    "path": "Россия / Республика Саха (Якутия) / Нижний Куранах",
    "country": "Россия",
    "searchString": "нижний куранах россия / республика саха (якутия) / нижний куранах"
  },
  "7403": {
    "id": "7403",
    "name": "Николаевское (Забайкальский край)",
    "path": "Россия / Забайкальский край / Николаевское (Забайкальский край)",
    "country": "Россия",
    "searchString": "николаевское (забайкальский край) россия / забайкальский край / николаевское (забайкальский край)"
  },
  "7404": {
    "id": "7404",
    "name": "Шумский",
    "path": "Россия / Иркутская область / Шумский",
    "country": "Россия",
    "searchString": "шумский россия / иркутская область / шумский"
  },
  "7405": {
    "id": "7405",
    "name": "Вангаш",
    "path": "Россия / Красноярский край / Вангаш",
    "country": "Россия",
    "searchString": "вангаш россия / красноярский край / вангаш"
  },
  "7406": {
    "id": "7406",
    "name": "Ключевский",
    "path": "Россия / Забайкальский край / Ключевский",
    "country": "Россия",
    "searchString": "ключевский россия / забайкальский край / ключевский"
  },
  "7407": {
    "id": "7407",
    "name": "Долгий Мост",
    "path": "Россия / Красноярский край / Долгий Мост",
    "country": "Россия",
    "searchString": "долгий мост россия / красноярский край / долгий мост"
  },
  "7408": {
    "id": "7408",
    "name": "Гуран",
    "path": "Россия / Иркутская область / Гуран",
    "country": "Россия",
    "searchString": "гуран россия / иркутская область / гуран"
  },
  "7409": {
    "id": "7409",
    "name": "Бестях",
    "path": "Россия / Республика Саха (Якутия) / Бестях",
    "country": "Россия",
    "searchString": "бестях россия / республика саха (якутия) / бестях"
  },
  "7410": {
    "id": "7410",
    "name": "Беллык",
    "path": "Россия / Красноярский край / Беллык",
    "country": "Россия",
    "searchString": "беллык россия / красноярский край / беллык"
  },
  "7411": {
    "id": "7411",
    "name": "Бирикчуль",
    "path": "Россия / Республика Хакасия / Бирикчуль",
    "country": "Россия",
    "searchString": "бирикчуль россия / республика хакасия / бирикчуль"
  },
  "7412": {
    "id": "7412",
    "name": "Устьянск",
    "path": "Россия / Красноярский край / Устьянск",
    "country": "Россия",
    "searchString": "устьянск россия / красноярский край / устьянск"
  },
  "7413": {
    "id": "7413",
    "name": "Тангуй",
    "path": "Россия / Иркутская область / Тангуй",
    "country": "Россия",
    "searchString": "тангуй россия / иркутская область / тангуй"
  },
  "7414": {
    "id": "7414",
    "name": "Шелехово",
    "path": "Россия / Иркутская область / Шелехово",
    "country": "Россия",
    "searchString": "шелехово россия / иркутская область / шелехово"
  },
  "7415": {
    "id": "7415",
    "name": "Унэгэтэй",
    "path": "Россия / Республика Бурятия / Унэгэтэй",
    "country": "Россия",
    "searchString": "унэгэтэй россия / республика бурятия / унэгэтэй"
  },
  "7416": {
    "id": "7416",
    "name": "Кангалассы",
    "path": "Россия / Республика Саха (Якутия) / Кангалассы",
    "country": "Россия",
    "searchString": "кангалассы россия / республика саха (якутия) / кангалассы"
  },
  "7417": {
    "id": "7417",
    "name": "Сасыр",
    "path": "Россия / Республика Саха (Якутия) / Сасыр",
    "country": "Россия",
    "searchString": "сасыр россия / республика саха (якутия) / сасыр"
  },
  "7418": {
    "id": "7418",
    "name": "Каразей",
    "path": "Россия / Иркутская область / Каразей",
    "country": "Россия",
    "searchString": "каразей россия / иркутская область / каразей"
  },
  "7419": {
    "id": "7419",
    "name": "Азей",
    "path": "Россия / Иркутская область / Азей",
    "country": "Россия",
    "searchString": "азей россия / иркутская область / азей"
  },
  "7420": {
    "id": "7420",
    "name": "Балахнинский",
    "path": "Россия / Иркутская область / Балахнинский",
    "country": "Россия",
    "searchString": "балахнинский россия / иркутская область / балахнинский"
  },
  "7421": {
    "id": "7421",
    "name": "Элита",
    "path": "Россия / Красноярский край / Элита",
    "country": "Россия",
    "searchString": "элита россия / красноярский край / элита"
  },
  "7422": {
    "id": "7422",
    "name": "Пинчуга",
    "path": "Россия / Красноярский край / Пинчуга",
    "country": "Россия",
    "searchString": "пинчуга россия / красноярский край / пинчуга"
  },
  "7423": {
    "id": "7423",
    "name": "Баляга",
    "path": "Россия / Забайкальский край / Баляга",
    "country": "Россия",
    "searchString": "баляга россия / забайкальский край / баляга"
  },
  "7424": {
    "id": "7424",
    "name": "Хову-Аксы",
    "path": "Россия / Республика Тыва / Хову-Аксы",
    "country": "Россия",
    "searchString": "хову-аксы россия / республика тыва / хову-аксы"
  },
  "7425": {
    "id": "7425",
    "name": "Березовское",
    "path": "Россия / Красноярский край / Березовское",
    "country": "Россия",
    "searchString": "березовское россия / красноярский край / березовское"
  },
  "7426": {
    "id": "7426",
    "name": "Кызыл-Мажалык",
    "path": "Россия / Республика Тыва / Кызыл-Мажалык",
    "country": "Россия",
    "searchString": "кызыл-мажалык россия / республика тыва / кызыл-мажалык"
  },
  "7427": {
    "id": "7427",
    "name": "Огородтах",
    "path": "Россия / Республика Саха (Якутия) / Огородтах",
    "country": "Россия",
    "searchString": "огородтах россия / республика саха (якутия) / огородтах"
  },
  "7428": {
    "id": "7428",
    "name": "Татарский Ключ",
    "path": "Россия / Республика Бурятия / Татарский Ключ",
    "country": "Россия",
    "searchString": "татарский ключ россия / республика бурятия / татарский ключ"
  },
  "7429": {
    "id": "7429",
    "name": "Бражное",
    "path": "Россия / Красноярский край / Бражное",
    "country": "Россия",
    "searchString": "бражное россия / красноярский край / бражное"
  },
  "7430": {
    "id": "7430",
    "name": "Лугавское",
    "path": "Россия / Красноярский край / Лугавское",
    "country": "Россия",
    "searchString": "лугавское россия / красноярский край / лугавское"
  },
  "7431": {
    "id": "7431",
    "name": "Мамакан",
    "path": "Россия / Иркутская область / Мамакан",
    "country": "Россия",
    "searchString": "мамакан россия / иркутская область / мамакан"
  },
  "7432": {
    "id": "7432",
    "name": "Предивинск",
    "path": "Россия / Красноярский край / Предивинск",
    "country": "Россия",
    "searchString": "предивинск россия / красноярский край / предивинск"
  },
  "7433": {
    "id": "7433",
    "name": "Осиновый Мыс",
    "path": "Россия / Красноярский край / Осиновый Мыс",
    "country": "Россия",
    "searchString": "осиновый мыс россия / красноярский край / осиновый мыс"
  },
  "7434": {
    "id": "7434",
    "name": "Момотово",
    "path": "Россия / Красноярский край / Момотово",
    "country": "Россия",
    "searchString": "момотово россия / красноярский край / момотово"
  },
  "7435": {
    "id": "7435",
    "name": "Тербяс",
    "path": "Россия / Республика Саха (Якутия) / Тербяс",
    "country": "Россия",
    "searchString": "тербяс россия / республика саха (якутия) / тербяс"
  },
  "7436": {
    "id": "7436",
    "name": "Кличка",
    "path": "Россия / Забайкальский край / Кличка",
    "country": "Россия",
    "searchString": "кличка россия / забайкальский край / кличка"
  },
  "7437": {
    "id": "7437",
    "name": "Абага",
    "path": "Россия / Республика Саха (Якутия) / Абага",
    "country": "Россия",
    "searchString": "абага россия / республика саха (якутия) / абага"
  },
  "7438": {
    "id": "7438",
    "name": "Кортуз",
    "path": "Россия / Красноярский край / Кортуз",
    "country": "Россия",
    "searchString": "кортуз россия / красноярский край / кортуз"
  },
  "7439": {
    "id": "7439",
    "name": "Эрзин",
    "path": "Россия / Республика Тыва / Эрзин",
    "country": "Россия",
    "searchString": "эрзин россия / республика тыва / эрзин"
  },
  "7440": {
    "id": "7440",
    "name": "Манзя",
    "path": "Россия / Красноярский край / Манзя",
    "country": "Россия",
    "searchString": "манзя россия / красноярский край / манзя"
  },
  "7441": {
    "id": "7441",
    "name": "Орджоникидзе (Красноярский край)",
    "path": "Россия / Красноярский край / Орджоникидзе (Красноярский край)",
    "country": "Россия",
    "searchString": "орджоникидзе (красноярский край) россия / красноярский край / орджоникидзе (красноярский край)"
  },
  "7442": {
    "id": "7442",
    "name": "Большая Речка",
    "path": "Россия / Иркутская область / Большая Речка",
    "country": "Россия",
    "searchString": "большая речка россия / иркутская область / большая речка"
  },
  "7443": {
    "id": "7443",
    "name": "Пеледуй",
    "path": "Россия / Республика Саха (Якутия) / Пеледуй",
    "country": "Россия",
    "searchString": "пеледуй россия / республика саха (якутия) / пеледуй"
  },
  "7444": {
    "id": "7444",
    "name": "Оленек",
    "path": "Россия / Республика Саха (Якутия) / Оленек",
    "country": "Россия",
    "searchString": "оленек россия / республика саха (якутия) / оленек"
  },
  "7445": {
    "id": "7445",
    "name": "Субботино",
    "path": "Россия / Красноярский край / Субботино",
    "country": "Россия",
    "searchString": "субботино россия / красноярский край / субботино"
  },
  "7446": {
    "id": "7446",
    "name": "Березняки",
    "path": "Россия / Иркутская область / Березняки",
    "country": "Россия",
    "searchString": "березняки россия / иркутская область / березняки"
  },
  "7447": {
    "id": "7447",
    "name": "Инголь",
    "path": "Россия / Красноярский край / Инголь",
    "country": "Россия",
    "searchString": "инголь россия / красноярский край / инголь"
  },
  "7448": {
    "id": "7448",
    "name": "Кожаны",
    "path": "Россия / Красноярский край / Кожаны",
    "country": "Россия",
    "searchString": "кожаны россия / красноярский край / кожаны"
  },
  "7449": {
    "id": "7449",
    "name": "Алгатуй",
    "path": "Россия / Иркутская область / Алгатуй",
    "country": "Россия",
    "searchString": "алгатуй россия / иркутская область / алгатуй"
  },
  "7450": {
    "id": "7450",
    "name": "Верх-Чита",
    "path": "Россия / Забайкальский край / Верх-Чита",
    "country": "Россия",
    "searchString": "верх-чита россия / забайкальский край / верх-чита"
  },
  "7451": {
    "id": "7451",
    "name": "Новоангарск",
    "path": "Россия / Красноярский край / Новоангарск",
    "country": "Россия",
    "searchString": "новоангарск россия / красноярский край / новоангарск"
  },
  "7452": {
    "id": "7452",
    "name": "Амазар",
    "path": "Россия / Забайкальский край / Амазар",
    "country": "Россия",
    "searchString": "амазар россия / забайкальский край / амазар"
  },
  "7453": {
    "id": "7453",
    "name": "Тинской",
    "path": "Россия / Красноярский край / Тинской",
    "country": "Россия",
    "searchString": "тинской россия / красноярский край / тинской"
  },
  "7454": {
    "id": "7454",
    "name": "Бада",
    "path": "Россия / Забайкальский край / Бада",
    "country": "Россия",
    "searchString": "бада россия / забайкальский край / бада"
  },
  "7455": {
    "id": "7455",
    "name": "Бай-Хаак",
    "path": "Россия / Республика Тыва / Бай-Хаак",
    "country": "Россия",
    "searchString": "бай-хаак россия / республика тыва / бай-хаак"
  },
  "7456": {
    "id": "7456",
    "name": "Дровяная",
    "path": "Россия / Забайкальский край / Дровяная",
    "country": "Россия",
    "searchString": "дровяная россия / забайкальский край / дровяная"
  },
  "7457": {
    "id": "7457",
    "name": "Георгиевка",
    "path": "Россия / Красноярский край / Георгиевка",
    "country": "Россия",
    "searchString": "георгиевка россия / красноярский край / георгиевка"
  },
  "7458": {
    "id": "7458",
    "name": "Детлово",
    "path": "Россия / Красноярский край / Детлово",
    "country": "Россия",
    "searchString": "детлово россия / красноярский край / детлово"
  },
  "7459": {
    "id": "7459",
    "name": "Кундуй",
    "path": "Россия / Иркутская область / Кундуй",
    "country": "Россия",
    "searchString": "кундуй россия / иркутская область / кундуй"
  },
  "7460": {
    "id": "7460",
    "name": "Ивановка (Республика Хакасия)",
    "path": "Россия / Республика Хакасия / Ивановка (Республика Хакасия)",
    "country": "Россия",
    "searchString": "ивановка (республика хакасия) россия / республика хакасия / ивановка (республика хакасия)"
  },
  "7461": {
    "id": "7461",
    "name": "Балгазын",
    "path": "Россия / Республика Тыва / Балгазын",
    "country": "Россия",
    "searchString": "балгазын россия / республика тыва / балгазын"
  },
  "7462": {
    "id": "7462",
    "name": "Белая Гора",
    "path": "Россия / Республика Саха (Якутия) / Белая Гора",
    "country": "Россия",
    "searchString": "белая гора россия / республика саха (якутия) / белая гора"
  },
  "7463": {
    "id": "7463",
    "name": "Краснореченский",
    "path": "Россия / Приморский край / Краснореченский",
    "country": "Россия",
    "searchString": "краснореченский россия / приморский край / краснореченский"
  },
  "7464": {
    "id": "7464",
    "name": "Липовцы",
    "path": "Россия / Приморский край / Липовцы",
    "country": "Россия",
    "searchString": "липовцы россия / приморский край / липовцы"
  },
  "7465": {
    "id": "7465",
    "name": "Волочаевка-2",
    "path": "Россия / Еврейская АО / Волочаевка-2",
    "country": "Россия",
    "searchString": "волочаевка-2 россия / еврейская ао / волочаевка-2"
  },
  "7466": {
    "id": "7466",
    "name": "Усть-Хайрюзово",
    "path": "Россия / Камчатский край / Усть-Хайрюзово",
    "country": "Россия",
    "searchString": "усть-хайрюзово россия / камчатский край / усть-хайрюзово"
  },
  "7467": {
    "id": "7467",
    "name": "Барабаш",
    "path": "Россия / Приморский край / Барабаш",
    "country": "Россия",
    "searchString": "барабаш россия / приморский край / барабаш"
  },
  "7468": {
    "id": "7468",
    "name": "Омолон",
    "path": "Россия / Чукотский АО / Омолон",
    "country": "Россия",
    "searchString": "омолон россия / чукотский ао / омолон"
  },
  "7469": {
    "id": "7469",
    "name": "Тыр",
    "path": "Россия / Хабаровский край / Тыр",
    "country": "Россия",
    "searchString": "тыр россия / хабаровский край / тыр"
  },
  "7470": {
    "id": "7470",
    "name": "Новокачалинск",
    "path": "Россия / Приморский край / Новокачалинск",
    "country": "Россия",
    "searchString": "новокачалинск россия / приморский край / новокачалинск"
  },
  "7471": {
    "id": "7471",
    "name": "Некрасовка (Сахалинская область)",
    "path": "Россия / Сахалинская область / Некрасовка (Сахалинская область)",
    "country": "Россия",
    "searchString": "некрасовка (сахалинская область) россия / сахалинская область / некрасовка (сахалинская область)"
  },
  "7472": {
    "id": "7472",
    "name": "Горное",
    "path": "Россия / Сахалинская область / Горное",
    "country": "Россия",
    "searchString": "горное россия / сахалинская область / горное"
  },
  "7473": {
    "id": "7473",
    "name": "Восточное",
    "path": "Россия / Хабаровский край / Восточное",
    "country": "Россия",
    "searchString": "восточное россия / хабаровский край / восточное"
  },
  "7474": {
    "id": "7474",
    "name": "Эворон",
    "path": "Россия / Хабаровский край / Эворон",
    "country": "Россия",
    "searchString": "эворон россия / хабаровский край / эворон"
  },
  "7475": {
    "id": "7475",
    "name": "Ивановка (Приморский край)",
    "path": "Россия / Приморский край / Ивановка (Приморский край)",
    "country": "Россия",
    "searchString": "ивановка (приморский край) россия / приморский край / ивановка (приморский край)"
  },
  "7476": {
    "id": "7476",
    "name": "Омчак",
    "path": "Россия / Магаданская область / Омчак",
    "country": "Россия",
    "searchString": "омчак россия / магаданская область / омчак"
  },
  "7477": {
    "id": "7477",
    "name": "Реттиховка",
    "path": "Россия / Приморский край / Реттиховка",
    "country": "Россия",
    "searchString": "реттиховка россия / приморский край / реттиховка"
  },
  "7478": {
    "id": "7478",
    "name": "Циммермановка",
    "path": "Россия / Хабаровский край / Циммермановка",
    "country": "Россия",
    "searchString": "циммермановка россия / хабаровский край / циммермановка"
  },
  "7479": {
    "id": "7479",
    "name": "Биджан",
    "path": "Россия / Еврейская АО / Биджан",
    "country": "Россия",
    "searchString": "биджан россия / еврейская ао / биджан"
  },
  "7480": {
    "id": "7480",
    "name": "Сергеевка (Пограничный район)",
    "path": "Россия / Приморский край / Сергеевка (Пограничный район)",
    "country": "Россия",
    "searchString": "сергеевка (пограничный район) россия / приморский край / сергеевка (пограничный район)"
  },
  "7481": {
    "id": "7481",
    "name": "Русский",
    "path": "Россия / Приморский край / Русский",
    "country": "Россия",
    "searchString": "русский россия / приморский край / русский"
  },
  "7482": {
    "id": "7482",
    "name": "Мухен",
    "path": "Россия / Хабаровский край / Мухен",
    "country": "Россия",
    "searchString": "мухен россия / хабаровский край / мухен"
  },
  "7483": {
    "id": "7483",
    "name": "Вострецово",
    "path": "Россия / Приморский край / Вострецово",
    "country": "Россия",
    "searchString": "вострецово россия / приморский край / вострецово"
  },
  "7484": {
    "id": "7484",
    "name": "Джонка",
    "path": "Россия / Хабаровский край / Джонка",
    "country": "Россия",
    "searchString": "джонка россия / хабаровский край / джонка"
  },
  "7485": {
    "id": "7485",
    "name": "Чумикан",
    "path": "Россия / Хабаровский край / Чумикан",
    "country": "Россия",
    "searchString": "чумикан россия / хабаровский край / чумикан"
  },
  "7486": {
    "id": "7486",
    "name": "Беринговский",
    "path": "Россия / Чукотский АО / Беринговский",
    "country": "Россия",
    "searchString": "беринговский россия / чукотский ао / беринговский"
  },
  "7487": {
    "id": "7487",
    "name": "Невер",
    "path": "Россия / Амурская область / Невер",
    "country": "Россия",
    "searchString": "невер россия / амурская область / невер"
  },
  "7488": {
    "id": "7488",
    "name": "Синегорск",
    "path": "Россия / Сахалинская область / Синегорск",
    "country": "Россия",
    "searchString": "синегорск россия / сахалинская область / синегорск"
  },
  "7489": {
    "id": "7489",
    "name": "Сита",
    "path": "Россия / Хабаровский край / Сита",
    "country": "Россия",
    "searchString": "сита россия / хабаровский край / сита"
  },
  "7490": {
    "id": "7490",
    "name": "Новошахтинский",
    "path": "Россия / Приморский край / Новошахтинский",
    "country": "Россия",
    "searchString": "новошахтинский россия / приморский край / новошахтинский"
  },
  "7491": {
    "id": "7491",
    "name": "Ливадия (Приморский край)",
    "path": "Россия / Приморский край / Ливадия (Приморский край)",
    "country": "Россия",
    "searchString": "ливадия (приморский край) россия / приморский край / ливадия (приморский край)"
  },
  "7492": {
    "id": "7492",
    "name": "Рейдово",
    "path": "Россия / Сахалинская область / Рейдово",
    "country": "Россия",
    "searchString": "рейдово россия / сахалинская область / рейдово"
  },
  "7493": {
    "id": "7493",
    "name": "Дормидонтовка",
    "path": "Россия / Хабаровский край / Дормидонтовка",
    "country": "Россия",
    "searchString": "дормидонтовка россия / хабаровский край / дормидонтовка"
  },
  "7494": {
    "id": "7494",
    "name": "Москальво",
    "path": "Россия / Сахалинская область / Москальво",
    "country": "Россия",
    "searchString": "москальво россия / сахалинская область / москальво"
  },
  "7495": {
    "id": "7495",
    "name": "Сулук",
    "path": "Россия / Хабаровский край / Сулук",
    "country": "Россия",
    "searchString": "сулук россия / хабаровский край / сулук"
  },
  "7496": {
    "id": "7496",
    "name": "Октябрьский (Амурская область)",
    "path": "Россия / Амурская область / Октябрьский (Амурская область)",
    "country": "Россия",
    "searchString": "октябрьский (амурская область) россия / амурская область / октябрьский (амурская область)"
  },
  "7497": {
    "id": "7497",
    "name": "Тыгда",
    "path": "Россия / Амурская область / Тыгда",
    "country": "Россия",
    "searchString": "тыгда россия / амурская область / тыгда"
  },
  "7498": {
    "id": "7498",
    "name": "Зарубино",
    "path": "Россия / Приморский край / Зарубино",
    "country": "Россия",
    "searchString": "зарубино россия / приморский край / зарубино"
  },
  "7499": {
    "id": "7499",
    "name": "Чкаловское",
    "path": "Россия / Приморский край / Чкаловское",
    "country": "Россия",
    "searchString": "чкаловское россия / приморский край / чкаловское"
  },
  "7500": {
    "id": "7500",
    "name": "Козьмодемьяновка",
    "path": "Россия / Амурская область / Козьмодемьяновка",
    "country": "Россия",
    "searchString": "козьмодемьяновка россия / амурская область / козьмодемьяновка"
  },
  "7501": {
    "id": "7501",
    "name": "Новорайчихинск",
    "path": "Россия / Амурская область / Новорайчихинск",
    "country": "Россия",
    "searchString": "новорайчихинск россия / амурская область / новорайчихинск"
  },
  "7502": {
    "id": "7502",
    "name": "Хурмули",
    "path": "Россия / Хабаровский край / Хурмули",
    "country": "Россия",
    "searchString": "хурмули россия / хабаровский край / хурмули"
  },
  "7503": {
    "id": "7503",
    "name": "Леонидово",
    "path": "Россия / Сахалинская область / Леонидово",
    "country": "Россия",
    "searchString": "леонидово россия / сахалинская область / леонидово"
  },
  "7504": {
    "id": "7504",
    "name": "Холодный",
    "path": "Россия / Магаданская область / Холодный",
    "country": "Россия",
    "searchString": "холодный россия / магаданская область / холодный"
  },
  "7505": {
    "id": "7505",
    "name": "Рудная Пристань",
    "path": "Россия / Приморский край / Рудная Пристань",
    "country": "Россия",
    "searchString": "рудная пристань россия / приморский край / рудная пристань"
  },
  "7506": {
    "id": "7506",
    "name": "Томское",
    "path": "Россия / Амурская область / Томское",
    "country": "Россия",
    "searchString": "томское россия / амурская область / томское"
  },
  "7507": {
    "id": "7507",
    "name": "Новосысоевка",
    "path": "Россия / Приморский край / Новосысоевка",
    "country": "Россия",
    "searchString": "новосысоевка россия / приморский край / новосысоевка"
  },
  "7508": {
    "id": "7508",
    "name": "Де-Кастри",
    "path": "Россия / Хабаровский край / Де-Кастри",
    "country": "Россия",
    "searchString": "де-кастри россия / хабаровский край / де-кастри"
  },
  "7509": {
    "id": "7509",
    "name": "Новокиевский Увал",
    "path": "Россия / Амурская область / Новокиевский Увал",
    "country": "Россия",
    "searchString": "новокиевский увал россия / амурская область / новокиевский увал"
  },
  "7510": {
    "id": "7510",
    "name": "Пахачи",
    "path": "Россия / Камчатский край / Пахачи",
    "country": "Россия",
    "searchString": "пахачи россия / камчатский край / пахачи"
  },
  "7511": {
    "id": "7511",
    "name": "Многовершинный",
    "path": "Россия / Хабаровский край / Многовершинный",
    "country": "Россия",
    "searchString": "многовершинный россия / хабаровский край / многовершинный"
  },
  "7512": {
    "id": "7512",
    "name": "Варваровка",
    "path": "Россия / Амурская область / Варваровка",
    "country": "Россия",
    "searchString": "варваровка россия / амурская область / варваровка"
  },
  "7513": {
    "id": "7513",
    "name": "Долиновка",
    "path": "Россия / Камчатский край / Долиновка",
    "country": "Россия",
    "searchString": "долиновка россия / камчатский край / долиновка"
  },
  "7514": {
    "id": "7514",
    "name": "Ариадное",
    "path": "Россия / Приморский край / Ариадное",
    "country": "Россия",
    "searchString": "ариадное россия / приморский край / ариадное"
  },
  "7515": {
    "id": "7515",
    "name": "Лермонтовка",
    "path": "Россия / Хабаровский край / Лермонтовка",
    "country": "Россия",
    "searchString": "лермонтовка россия / хабаровский край / лермонтовка"
  },
  "7516": {
    "id": "7516",
    "name": "Березовка (Амурская область)",
    "path": "Россия / Амурская область / Березовка (Амурская область)",
    "country": "Россия",
    "searchString": "березовка (амурская область) россия / амурская область / березовка (амурская область)"
  },
  "7517": {
    "id": "7517",
    "name": "Поселок ЦЭС",
    "path": "Россия / Хабаровский край / Поселок ЦЭС",
    "country": "Россия",
    "searchString": "поселок цэс россия / хабаровский край / поселок цэс"
  },
  "7518": {
    "id": "7518",
    "name": "Бычиха",
    "path": "Россия / Хабаровский край / Бычиха",
    "country": "Россия",
    "searchString": "бычиха россия / хабаровский край / бычиха"
  },
  "7519": {
    "id": "7519",
    "name": "Илирней",
    "path": "Россия / Чукотский АО / Илирней",
    "country": "Россия",
    "searchString": "илирней россия / чукотский ао / илирней"
  },
  "7520": {
    "id": "7520",
    "name": "Моряк-Рыболов",
    "path": "Россия / Приморский край / Моряк-Рыболов",
    "country": "Россия",
    "searchString": "моряк-рыболов россия / приморский край / моряк-рыболов"
  },
  "7521": {
    "id": "7521",
    "name": "Тахта",
    "path": "Россия / Хабаровский край / Тахта",
    "country": "Россия",
    "searchString": "тахта россия / хабаровский край / тахта"
  },
  "7522": {
    "id": "7522",
    "name": "Лесогорское",
    "path": "Россия / Сахалинская область / Лесогорское",
    "country": "Россия",
    "searchString": "лесогорское россия / сахалинская область / лесогорское"
  },
  "7523": {
    "id": "7523",
    "name": "Вахрушев",
    "path": "Россия / Сахалинская область / Вахрушев",
    "country": "Россия",
    "searchString": "вахрушев россия / сахалинская область / вахрушев"
  },
  "7524": {
    "id": "7524",
    "name": "Бира",
    "path": "Россия / Еврейская АО / Бира",
    "country": "Россия",
    "searchString": "бира россия / еврейская ао / бира"
  },
  "7525": {
    "id": "7525",
    "name": "Новостройка",
    "path": "Россия / Приморский край / Новостройка",
    "country": "Россия",
    "searchString": "новостройка россия / приморский край / новостройка"
  },
  "7526": {
    "id": "7526",
    "name": "Ярославский",
    "path": "Россия / Приморский край / Ярославский",
    "country": "Россия",
    "searchString": "ярославский россия / приморский край / ярославский"
  },
  "7527": {
    "id": "7527",
    "name": "Высокогорный",
    "path": "Россия / Хабаровский край / Высокогорный",
    "country": "Россия",
    "searchString": "высокогорный россия / хабаровский край / высокогорный"
  },
  "7528": {
    "id": "7528",
    "name": "Овсянка",
    "path": "Россия / Амурская область / Овсянка",
    "country": "Россия",
    "searchString": "овсянка россия / амурская область / овсянка"
  },
  "7529": {
    "id": "7529",
    "name": "Первомайск (Сахалинская область)",
    "path": "Россия / Сахалинская область / Первомайск (Сахалинская область)",
    "country": "Россия",
    "searchString": "первомайск (сахалинская область) россия / сахалинская область / первомайск (сахалинская область)"
  },
  "7530": {
    "id": "7530",
    "name": "Юктали",
    "path": "Россия / Амурская область / Юктали",
    "country": "Россия",
    "searchString": "юктали россия / амурская область / юктали"
  },
  "7531": {
    "id": "7531",
    "name": "Галенки",
    "path": "Россия / Приморский край / Галенки",
    "country": "Россия",
    "searchString": "галенки россия / приморский край / галенки"
  },
  "7532": {
    "id": "7532",
    "name": "Анавгай",
    "path": "Россия / Камчатский край / Анавгай",
    "country": "Россия",
    "searchString": "анавгай россия / камчатский край / анавгай"
  },
  "7533": {
    "id": "7533",
    "name": "Тырма",
    "path": "Россия / Хабаровский край / Тырма",
    "country": "Россия",
    "searchString": "тырма россия / хабаровский край / тырма"
  },
  "7534": {
    "id": "7534",
    "name": "Херпучи",
    "path": "Россия / Хабаровский край / Херпучи",
    "country": "Россия",
    "searchString": "херпучи россия / хабаровский край / херпучи"
  },
  "7535": {
    "id": "7535",
    "name": "Маяк",
    "path": "Россия / Хабаровский край / Маяк",
    "country": "Россия",
    "searchString": "маяк россия / хабаровский край / маяк"
  },
  "7536": {
    "id": "7536",
    "name": "Шаромы",
    "path": "Россия / Камчатский край / Шаромы",
    "country": "Россия",
    "searchString": "шаромы россия / камчатский край / шаромы"
  },
  "7537": {
    "id": "7537",
    "name": "Мариинское",
    "path": "Россия / Хабаровский край / Мариинское",
    "country": "Россия",
    "searchString": "мариинское россия / хабаровский край / мариинское"
  },
  "7538": {
    "id": "7538",
    "name": "Экимчан",
    "path": "Россия / Амурская область / Экимчан",
    "country": "Россия",
    "searchString": "экимчан россия / амурская область / экимчан"
  },
  "7539": {
    "id": "7539",
    "name": "Лазо (Дальнореченский округ)",
    "path": "Россия / Приморский край / Лазо (Дальнореченский округ)",
    "country": "Россия",
    "searchString": "лазо (дальнореченский округ) россия / приморский край / лазо (дальнореченский округ)"
  },
  "7540": {
    "id": "7540",
    "name": "Сергеевка (Партизанский район)",
    "path": "Россия / Приморский край / Сергеевка (Партизанский район)",
    "country": "Россия",
    "searchString": "сергеевка (партизанский район) россия / приморский край / сергеевка (партизанский район)"
  },
  "7541": {
    "id": "7541",
    "name": "Краснополье (Сахалинская область)",
    "path": "Россия / Сахалинская область / Краснополье (Сахалинская область)",
    "country": "Россия",
    "searchString": "краснополье (сахалинская область) россия / сахалинская область / краснополье (сахалинская область)"
  },
  "7542": {
    "id": "7542",
    "name": "Островное",
    "path": "Россия / Чукотский АО / Островное",
    "country": "Россия",
    "searchString": "островное россия / чукотский ао / островное"
  },
  "7543": {
    "id": "7543",
    "name": "Марково",
    "path": "Россия / Чукотский АО / Марково",
    "country": "Россия",
    "searchString": "марково россия / чукотский ао / марково"
  },
  "7544": {
    "id": "7544",
    "name": "Горин",
    "path": "Россия / Хабаровский край / Горин",
    "country": "Россия",
    "searchString": "горин россия / хабаровский край / горин"
  },
  "7545": {
    "id": "7545",
    "name": "Талая",
    "path": "Россия / Магаданская область / Талая",
    "country": "Россия",
    "searchString": "талая россия / магаданская область / талая"
  },
  "7546": {
    "id": "7546",
    "name": "Шебунино",
    "path": "Россия / Сахалинская область / Шебунино",
    "country": "Россия",
    "searchString": "шебунино россия / сахалинская область / шебунино"
  },
  "7547": {
    "id": "7547",
    "name": "Ракитное (Приморский край)",
    "path": "Россия / Приморский край / Ракитное (Приморский край)",
    "country": "Россия",
    "searchString": "ракитное (приморский край) россия / приморский край / ракитное (приморский край)"
  },
  "7548": {
    "id": "7548",
    "name": "Русское (Сахалинская область)",
    "path": "Россия / Сахалинская область / Русское (Сахалинская область)",
    "country": "Россия",
    "searchString": "русское (сахалинская область) россия / сахалинская область / русское (сахалинская область)"
  },
  "7549": {
    "id": "7549",
    "name": "Лазо (Лазовский район)",
    "path": "Россия / Приморский край / Лазо (Лазовский район)",
    "country": "Россия",
    "searchString": "лазо (лазовский район) россия / приморский край / лазо (лазовский район)"
  },
  "7550": {
    "id": "7550",
    "name": "Хаилино",
    "path": "Россия / Камчатский край / Хаилино",
    "country": "Россия",
    "searchString": "хаилино россия / камчатский край / хаилино"
  },
  "7551": {
    "id": "7551",
    "name": "Дебин",
    "path": "Россия / Магаданская область / Дебин",
    "country": "Россия",
    "searchString": "дебин россия / магаданская область / дебин"
  },
  "7552": {
    "id": "7552",
    "name": "Посьет",
    "path": "Россия / Приморский край / Посьет",
    "country": "Россия",
    "searchString": "посьет россия / приморский край / посьет"
  },
  "7553": {
    "id": "7553",
    "name": "Уруша",
    "path": "Россия / Амурская область / Уруша",
    "country": "Россия",
    "searchString": "уруша россия / амурская область / уруша"
  },
  "7554": {
    "id": "7554",
    "name": "Дуки",
    "path": "Россия / Хабаровский край / Дуки",
    "country": "Россия",
    "searchString": "дуки россия / хабаровский край / дуки"
  },
  "7555": {
    "id": "7555",
    "name": "Девица (Приморский край)",
    "path": "Россия / Приморский край / Девица (Приморский край)",
    "country": "Россия",
    "searchString": "девица (приморский край) россия / приморский край / девица (приморский край)"
  },
  "7556": {
    "id": "7556",
    "name": "Тунгор",
    "path": "Россия / Сахалинская область / Тунгор",
    "country": "Россия",
    "searchString": "тунгор россия / сахалинская область / тунгор"
  },
  "7557": {
    "id": "7557",
    "name": "Буссевка",
    "path": "Россия / Приморский край / Буссевка",
    "country": "Россия",
    "searchString": "буссевка россия / приморский край / буссевка"
  },
  "7558": {
    "id": "7558",
    "name": "Краскино",
    "path": "Россия / Приморский край / Краскино",
    "country": "Россия",
    "searchString": "краскино россия / приморский край / краскино"
  },
  "7559": {
    "id": "7559",
    "name": "Монгохто",
    "path": "Россия / Хабаровский край / Монгохто",
    "country": "Россия",
    "searchString": "монгохто россия / хабаровский край / монгохто"
  },
  "7560": {
    "id": "7560",
    "name": "Смоляниново",
    "path": "Россия / Приморский край / Смоляниново",
    "country": "Россия",
    "searchString": "смоляниново россия / приморский край / смоляниново"
  },
  "7561": {
    "id": "7561",
    "name": "Правда",
    "path": "Россия / Сахалинская область / Правда",
    "country": "Россия",
    "searchString": "правда россия / сахалинская область / правда"
  },
  "7562": {
    "id": "7562",
    "name": "Тавричанка",
    "path": "Россия / Приморский край / Тавричанка",
    "country": "Россия",
    "searchString": "тавричанка россия / приморский край / тавричанка"
  },
  "7563": {
    "id": "7563",
    "name": "Анюйск",
    "path": "Россия / Чукотский АО / Анюйск",
    "country": "Россия",
    "searchString": "анюйск россия / чукотский ао / анюйск"
  },
  "7564": {
    "id": "7564",
    "name": "Новоникольск",
    "path": "Россия / Приморский край / Новоникольск",
    "country": "Россия",
    "searchString": "новоникольск россия / приморский край / новоникольск"
  },
  "7565": {
    "id": "7565",
    "name": "Хрустальный",
    "path": "Россия / Приморский край / Хрустальный",
    "country": "Россия",
    "searchString": "хрустальный россия / приморский край / хрустальный"
  },
  "7566": {
    "id": "7566",
    "name": "Софийск",
    "path": "Россия / Хабаровский край / Софийск",
    "country": "Россия",
    "searchString": "софийск россия / хабаровский край / софийск"
  },
  "7567": {
    "id": "7567",
    "name": "Хоэ",
    "path": "Россия / Сахалинская область / Хоэ",
    "country": "Россия",
    "searchString": "хоэ россия / сахалинская область / хоэ"
  },
  "7568": {
    "id": "7568",
    "name": "Восток",
    "path": "Россия / Приморский край / Восток",
    "country": "Россия",
    "searchString": "восток россия / приморский край / восток"
  },
  "7569": {
    "id": "7569",
    "name": "Мгачи",
    "path": "Россия / Сахалинская область / Мгачи",
    "country": "Россия",
    "searchString": "мгачи россия / сахалинская область / мгачи"
  },
  "7570": {
    "id": "7570",
    "name": "Ольга",
    "path": "Россия / Приморский край / Ольга",
    "country": "Россия",
    "searchString": "ольга россия / приморский край / ольга"
  },
  "7571": {
    "id": "7571",
    "name": "Краснореченское",
    "path": "Россия / Хабаровский край / Краснореченское",
    "country": "Россия",
    "searchString": "краснореченское россия / хабаровский край / краснореченское"
  },
  "7572": {
    "id": "7572",
    "name": "Сиваки",
    "path": "Россия / Амурская область / Сиваки",
    "country": "Россия",
    "searchString": "сиваки россия / амурская область / сиваки"
  },
  "7573": {
    "id": "7573",
    "name": "Дипкун",
    "path": "Россия / Амурская область / Дипкун",
    "country": "Россия",
    "searchString": "дипкун россия / амурская область / дипкун"
  },
  "7574": {
    "id": "7574",
    "name": "Поздеевка",
    "path": "Россия / Амурская область / Поздеевка",
    "country": "Россия",
    "searchString": "поздеевка россия / амурская область / поздеевка"
  },
  "7575": {
    "id": "7575",
    "name": "Малиново",
    "path": "Россия / Приморский край / Малиново",
    "country": "Россия",
    "searchString": "малиново россия / приморский край / малиново"
  },
  "7576": {
    "id": "7576",
    "name": "Углекаменск",
    "path": "Россия / Приморский край / Углекаменск",
    "country": "Россия",
    "searchString": "углекаменск россия / приморский край / углекаменск"
  },
  "7577": {
    "id": "7577",
    "name": "Манилы",
    "path": "Россия / Камчатский край / Манилы",
    "country": "Россия",
    "searchString": "манилы россия / камчатский край / манилы"
  },
  "7578": {
    "id": "7578",
    "name": "Лазо",
    "path": "Россия / Камчатский край / Лазо",
    "country": "Россия",
    "searchString": "лазо россия / камчатский край / лазо"
  },
  "7579": {
    "id": "7579",
    "name": "Известковый",
    "path": "Россия / Еврейская АО / Известковый",
    "country": "Россия",
    "searchString": "известковый россия / еврейская ао / известковый"
  },
  "7580": {
    "id": "7580",
    "name": "Анучино",
    "path": "Россия / Приморский край / Анучино",
    "country": "Россия",
    "searchString": "анучино россия / приморский край / анучино"
  },
  "7581": {
    "id": "7581",
    "name": "Рощино (Приморский край)",
    "path": "Россия / Приморский край / Рощино (Приморский край)",
    "country": "Россия",
    "searchString": "рощино (приморский край) россия / приморский край / рощино (приморский край)"
  },
  "7582": {
    "id": "7582",
    "name": "Армань",
    "path": "Россия / Магаданская область / Армань",
    "country": "Россия",
    "searchString": "армань россия / магаданская область / армань"
  },
  "7583": {
    "id": "7583",
    "name": "Новопокровка",
    "path": "Россия / Приморский край / Новопокровка",
    "country": "Россия",
    "searchString": "новопокровка россия / приморский край / новопокровка"
  },
  "7584": {
    "id": "7584",
    "name": "Бошняково",
    "path": "Россия / Сахалинская область / Бошняково",
    "country": "Россия",
    "searchString": "бошняково россия / сахалинская область / бошняково"
  },
  "7585": {
    "id": "7585",
    "name": "Томичи",
    "path": "Россия / Амурская область / Томичи",
    "country": "Россия",
    "searchString": "томичи россия / амурская область / томичи"
  },
  "7586": {
    "id": "7586",
    "name": "Ушумун",
    "path": "Россия / Амурская область / Ушумун",
    "country": "Россия",
    "searchString": "ушумун россия / амурская область / ушумун"
  },
  "7587": {
    "id": "7587",
    "name": "Ивашка",
    "path": "Россия / Камчатский край / Ивашка",
    "country": "Россия",
    "searchString": "ивашка россия / камчатский край / ивашка"
  },
  "7588": {
    "id": "7588",
    "name": "Горные Ключи",
    "path": "Россия / Приморский край / Горные Ключи",
    "country": "Россия",
    "searchString": "горные ключи россия / приморский край / горные ключи"
  },
  "7589": {
    "id": "7589",
    "name": "Чля",
    "path": "Россия / Хабаровский край / Чля",
    "country": "Россия",
    "searchString": "чля россия / хабаровский край / чля"
  },
  "7590": {
    "id": "7590",
    "name": "Атласово",
    "path": "Россия / Камчатский край / Атласово",
    "country": "Россия",
    "searchString": "атласово россия / камчатский край / атласово"
  },
  "7591": {
    "id": "7591",
    "name": "Маго",
    "path": "Россия / Хабаровский край / Маго",
    "country": "Россия",
    "searchString": "маго россия / хабаровский край / маго"
  },
  "7592": {
    "id": "7592",
    "name": "Тополево",
    "path": "Россия / Хабаровский край / Тополево",
    "country": "Россия",
    "searchString": "тополево россия / хабаровский край / тополево"
  },
  "7593": {
    "id": "7593",
    "name": "Лазарев",
    "path": "Россия / Хабаровский край / Лазарев",
    "country": "Россия",
    "searchString": "лазарев россия / хабаровский край / лазарев"
  },
  "7594": {
    "id": "7594",
    "name": "Талдан",
    "path": "Россия / Амурская область / Талдан",
    "country": "Россия",
    "searchString": "талдан россия / амурская область / талдан"
  },
  "7595": {
    "id": "7595",
    "name": "Среднебелая",
    "path": "Россия / Амурская область / Среднебелая",
    "country": "Россия",
    "searchString": "среднебелая россия / амурская область / среднебелая"
  },
  "7596": {
    "id": "7596",
    "name": "Терней",
    "path": "Россия / Приморский край / Терней",
    "country": "Россия",
    "searchString": "терней россия / приморский край / терней"
  },
  "7597": {
    "id": "7597",
    "name": "Светлогорье",
    "path": "Россия / Приморский край / Светлогорье",
    "country": "Россия",
    "searchString": "светлогорье россия / приморский край / светлогорье"
  },
  "7598": {
    "id": "7598",
    "name": "Кепервеем",
    "path": "Россия / Чукотский АО / Кепервеем",
    "country": "Россия",
    "searchString": "кепервеем россия / чукотский ао / кепервеем"
  },
  "7599": {
    "id": "7599",
    "name": "Беласовка",
    "path": "Россия / Нижегородская область / Беласовка",
    "country": "Россия",
    "searchString": "беласовка россия / нижегородская область / беласовка"
  },
  "7600": {
    "id": "7600",
    "name": "Советский (Нижегородская область)",
    "path": "Россия / Нижегородская область / Советский (Нижегородская область)",
    "country": "Россия",
    "searchString": "советский (нижегородская область) россия / нижегородская область / советский (нижегородская область)"
  },
  "7601": {
    "id": "7601",
    "name": "Новодмитриевка",
    "path": "Россия / Нижегородская область / Новодмитриевка",
    "country": "Россия",
    "searchString": "новодмитриевка россия / нижегородская область / новодмитриевка"
  },
  "7602": {
    "id": "7602",
    "name": "Семьяны",
    "path": "Россия / Нижегородская область / Семьяны",
    "country": "Россия",
    "searchString": "семьяны россия / нижегородская область / семьяны"
  },
  "7603": {
    "id": "7603",
    "name": "Коршик",
    "path": "Россия / Кировская область / Коршик",
    "country": "Россия",
    "searchString": "коршик россия / кировская область / коршик"
  },
  "7604": {
    "id": "7604",
    "name": "Большой Рой",
    "path": "Россия / Кировская область / Большой Рой",
    "country": "Россия",
    "searchString": "большой рой россия / кировская область / большой рой"
  },
  "7605": {
    "id": "7605",
    "name": "Лазарево (Кировская область)",
    "path": "Россия / Кировская область / Лазарево (Кировская область)",
    "country": "Россия",
    "searchString": "лазарево (кировская область) россия / кировская область / лазарево (кировская область)"
  },
  "7606": {
    "id": "7606",
    "name": "Усть-Люга",
    "path": "Россия / Кировская область / Усть-Люга",
    "country": "Россия",
    "searchString": "усть-люга россия / кировская область / усть-люга"
  },
  "7607": {
    "id": "7607",
    "name": "Березовка (Нижегородская область)",
    "path": "Россия / Нижегородская область / Березовка (Нижегородская область)",
    "country": "Россия",
    "searchString": "березовка (нижегородская область) россия / нижегородская область / березовка (нижегородская область)"
  },
  "7608": {
    "id": "7608",
    "name": "Ошминское",
    "path": "Россия / Нижегородская область / Ошминское",
    "country": "Россия",
    "searchString": "ошминское россия / нижегородская область / ошминское"
  },
  "7609": {
    "id": "7609",
    "name": "Алферьево",
    "path": "Россия / Нижегородская область / Алферьево",
    "country": "Россия",
    "searchString": "алферьево россия / нижегородская область / алферьево"
  },
  "7610": {
    "id": "7610",
    "name": "Кулыги",
    "path": "Россия / Кировская область / Кулыги",
    "country": "Россия",
    "searchString": "кулыги россия / кировская область / кулыги"
  },
  "7611": {
    "id": "7611",
    "name": "Истомино",
    "path": "Россия / Нижегородская область / Истомино",
    "country": "Россия",
    "searchString": "истомино россия / нижегородская область / истомино"
  },
  "7612": {
    "id": "7612",
    "name": "Маромица",
    "path": "Россия / Кировская область / Маромица",
    "country": "Россия",
    "searchString": "маромица россия / кировская область / маромица"
  },
  "7613": {
    "id": "7613",
    "name": "Среднеивкино",
    "path": "Россия / Кировская область / Среднеивкино",
    "country": "Россия",
    "searchString": "среднеивкино россия / кировская область / среднеивкино"
  },
  "7614": {
    "id": "7614",
    "name": "Прокошево",
    "path": "Россия / Нижегородская область / Прокошево",
    "country": "Россия",
    "searchString": "прокошево россия / нижегородская область / прокошево"
  },
  "7615": {
    "id": "7615",
    "name": "Саврасово",
    "path": "Россия / Нижегородская область / Саврасово",
    "country": "Россия",
    "searchString": "саврасово россия / нижегородская область / саврасово"
  },
  "7616": {
    "id": "7616",
    "name": "Заря (Кировская область)",
    "path": "Россия / Кировская область / Заря (Кировская область)",
    "country": "Россия",
    "searchString": "заря (кировская область) россия / кировская область / заря (кировская область)"
  },
  "7617": {
    "id": "7617",
    "name": "Пинюг",
    "path": "Россия / Кировская область / Пинюг",
    "country": "Россия",
    "searchString": "пинюг россия / кировская область / пинюг"
  },
  "7618": {
    "id": "7618",
    "name": "Залазна",
    "path": "Россия / Кировская область / Залазна",
    "country": "Россия",
    "searchString": "залазна россия / кировская область / залазна"
  },
  "7619": {
    "id": "7619",
    "name": "Рожки",
    "path": "Россия / Кировская область / Рожки",
    "country": "Россия",
    "searchString": "рожки россия / кировская область / рожки"
  },
  "7620": {
    "id": "7620",
    "name": "Русский Турек",
    "path": "Россия / Кировская область / Русский Турек",
    "country": "Россия",
    "searchString": "русский турек россия / кировская область / русский турек"
  },
  "7621": {
    "id": "7621",
    "name": "Большие Можары",
    "path": "Россия / Рязанская область / Большие Можары",
    "country": "Россия",
    "searchString": "большие можары россия / рязанская область / большие можары"
  },
  "7622": {
    "id": "7622",
    "name": "Роженцово",
    "path": "Россия / Нижегородская область / Роженцово",
    "country": "Россия",
    "searchString": "роженцово россия / нижегородская область / роженцово"
  },
  "7623": {
    "id": "7623",
    "name": "Медведок",
    "path": "Россия / Кировская область / Медведок",
    "country": "Россия",
    "searchString": "медведок россия / кировская область / медведок"
  },
  "7624": {
    "id": "7624",
    "name": "Рабочий поселок им. Степана Разина",
    "path": "Россия / Нижегородская область / Рабочий поселок им. Степана Разина",
    "country": "Россия",
    "searchString": "рабочий поселок им. степана разина россия / нижегородская область / рабочий поселок им. степана разина"
  },
  "7625": {
    "id": "7625",
    "name": "Слизнево",
    "path": "Россия / Нижегородская область / Слизнево",
    "country": "Россия",
    "searchString": "слизнево россия / нижегородская область / слизнево"
  },
  "7626": {
    "id": "7626",
    "name": "Черная Холуница",
    "path": "Россия / Кировская область / Черная Холуница",
    "country": "Россия",
    "searchString": "черная холуница россия / кировская область / черная холуница"
  },
  "7627": {
    "id": "7627",
    "name": "Октябрьский (Нижегородская область)",
    "path": "Россия / Нижегородская область / Октябрьский (Нижегородская область)",
    "country": "Россия",
    "searchString": "октябрьский (нижегородская область) россия / нижегородская область / октябрьский (нижегородская область)"
  },
  "7628": {
    "id": "7628",
    "name": "Полховский Майдан",
    "path": "Россия / Нижегородская область / Полховский Майдан",
    "country": "Россия",
    "searchString": "полховский майдан россия / нижегородская область / полховский майдан"
  },
  "7629": {
    "id": "7629",
    "name": "Чулково (Нижегородская область)",
    "path": "Россия / Нижегородская область / Чулково (Нижегородская область)",
    "country": "Россия",
    "searchString": "чулково (нижегородская область) россия / нижегородская область / чулково (нижегородская область)"
  },
  "7630": {
    "id": "7630",
    "name": "Грудцино",
    "path": "Россия / Нижегородская область / Грудцино",
    "country": "Россия",
    "searchString": "грудцино россия / нижегородская область / грудцино"
  },
  "7631": {
    "id": "7631",
    "name": "Шурма",
    "path": "Россия / Кировская область / Шурма",
    "country": "Россия",
    "searchString": "шурма россия / кировская область / шурма"
  },
  "7632": {
    "id": "7632",
    "name": "Ближне-Песочное",
    "path": "Россия / Нижегородская область / Ближне-Песочное",
    "country": "Россия",
    "searchString": "ближне-песочное россия / нижегородская область / ближне-песочное"
  },
  "7633": {
    "id": "7633",
    "name": "Большое Пикино",
    "path": "Россия / Нижегородская область / Большое Пикино",
    "country": "Россия",
    "searchString": "большое пикино россия / нижегородская область / большое пикино"
  },
  "7634": {
    "id": "7634",
    "name": "Водоватово",
    "path": "Россия / Нижегородская область / Водоватово",
    "country": "Россия",
    "searchString": "водоватово россия / нижегородская область / водоватово"
  },
  "7635": {
    "id": "7635",
    "name": "Белавка",
    "path": "Россия / Нижегородская область / Белавка",
    "country": "Россия",
    "searchString": "белавка россия / нижегородская область / белавка"
  },
  "7636": {
    "id": "7636",
    "name": "Красное (Нижегородская область)",
    "path": "Россия / Нижегородская область / Красное (Нижегородская область)",
    "country": "Россия",
    "searchString": "красное (нижегородская область) россия / нижегородская область / красное (нижегородская область)"
  },
  "7637": {
    "id": "7637",
    "name": "Гавриловка",
    "path": "Россия / Нижегородская область / Гавриловка",
    "country": "Россия",
    "searchString": "гавриловка россия / нижегородская область / гавриловка"
  },
  "7638": {
    "id": "7638",
    "name": "Нижнеивкино",
    "path": "Россия / Кировская область / Нижнеивкино",
    "country": "Россия",
    "searchString": "нижнеивкино россия / кировская область / нижнеивкино"
  },
  "7639": {
    "id": "7639",
    "name": "Аркуль",
    "path": "Россия / Кировская область / Аркуль",
    "country": "Россия",
    "searchString": "аркуль россия / кировская область / аркуль"
  },
  "7640": {
    "id": "7640",
    "name": "Сомовка",
    "path": "Россия / Нижегородская область / Сомовка",
    "country": "Россия",
    "searchString": "сомовка россия / нижегородская область / сомовка"
  },
  "7641": {
    "id": "7641",
    "name": "Останкино",
    "path": "Россия / Нижегородская область / Останкино",
    "country": "Россия",
    "searchString": "останкино россия / нижегородская область / останкино"
  },
  "7642": {
    "id": "7642",
    "name": "Гостовский",
    "path": "Россия / Кировская область / Гостовский",
    "country": "Россия",
    "searchString": "гостовский россия / кировская область / гостовский"
  },
  "7643": {
    "id": "7643",
    "name": "Бокино",
    "path": "Россия / Рязанская область / Бокино",
    "country": "Россия",
    "searchString": "бокино россия / рязанская область / бокино"
  },
  "7644": {
    "id": "7644",
    "name": "Наруксово",
    "path": "Россия / Нижегородская область / Наруксово",
    "country": "Россия",
    "searchString": "наруксово россия / нижегородская область / наруксово"
  },
  "7645": {
    "id": "7645",
    "name": "Большое Туманово",
    "path": "Россия / Нижегородская область / Большое Туманово",
    "country": "Россия",
    "searchString": "большое туманово россия / нижегородская область / большое туманово"
  },
  "7646": {
    "id": "7646",
    "name": "Старая Рудка",
    "path": "Россия / Нижегородская область / Старая Рудка",
    "country": "Россия",
    "searchString": "старая рудка россия / нижегородская область / старая рудка"
  },
  "7647": {
    "id": "7647",
    "name": "Высокий Оселок",
    "path": "Россия / Нижегородская область / Высокий Оселок",
    "country": "Россия",
    "searchString": "высокий оселок россия / нижегородская область / высокий оселок"
  },
  "7648": {
    "id": "7648",
    "name": "Теша",
    "path": "Россия / Нижегородская область / Теша",
    "country": "Россия",
    "searchString": "теша россия / нижегородская область / теша"
  },
  "7649": {
    "id": "7649",
    "name": "Шатовка",
    "path": "Россия / Нижегородская область / Шатовка",
    "country": "Россия",
    "searchString": "шатовка россия / нижегородская область / шатовка"
  },
  "7650": {
    "id": "7650",
    "name": "Кантаурово",
    "path": "Россия / Нижегородская область / Кантаурово",
    "country": "Россия",
    "searchString": "кантаурово россия / нижегородская область / кантаурово"
  },
  "7651": {
    "id": "7651",
    "name": "Саконы",
    "path": "Россия / Нижегородская область / Саконы",
    "country": "Россия",
    "searchString": "саконы россия / нижегородская область / саконы"
  },
  "7652": {
    "id": "7652",
    "name": "Петряксы",
    "path": "Россия / Нижегородская область / Петряксы",
    "country": "Россия",
    "searchString": "петряксы россия / нижегородская область / петряксы"
  },
  "7653": {
    "id": "7653",
    "name": "Редькино",
    "path": "Россия / Нижегородская область / Редькино",
    "country": "Россия",
    "searchString": "редькино россия / нижегородская область / редькино"
  },
  "7654": {
    "id": "7654",
    "name": "Байково",
    "path": "Россия / Нижегородская область / Байково",
    "country": "Россия",
    "searchString": "байково россия / нижегородская область / байково"
  },
  "7655": {
    "id": "7655",
    "name": "Новинки",
    "path": "Россия / Нижегородская область / Новинки",
    "country": "Россия",
    "searchString": "новинки россия / нижегородская область / новинки"
  },
  "7656": {
    "id": "7656",
    "name": "Теплово",
    "path": "Россия / Нижегородская область / Теплово",
    "country": "Россия",
    "searchString": "теплово россия / нижегородская область / теплово"
  },
  "7657": {
    "id": "7657",
    "name": "Черновское",
    "path": "Россия / Нижегородская область / Черновское",
    "country": "Россия",
    "searchString": "черновское россия / нижегородская область / черновское"
  },
  "7658": {
    "id": "7658",
    "name": "Воздвиженское",
    "path": "Россия / Нижегородская область / Воздвиженское",
    "country": "Россия",
    "searchString": "воздвиженское россия / нижегородская область / воздвиженское"
  },
  "7659": {
    "id": "7659",
    "name": "Дружный",
    "path": "Россия / Нижегородская область / Дружный",
    "country": "Россия",
    "searchString": "дружный россия / нижегородская область / дружный"
  },
  "7660": {
    "id": "7660",
    "name": "Бисерово",
    "path": "Россия / Кировская область / Бисерово",
    "country": "Россия",
    "searchString": "бисерово россия / кировская область / бисерово"
  },
  "7661": {
    "id": "7661",
    "name": "Мотовилово",
    "path": "Россия / Нижегородская область / Мотовилово",
    "country": "Россия",
    "searchString": "мотовилово россия / нижегородская область / мотовилово"
  },
  "7662": {
    "id": "7662",
    "name": "Поселок Селекционной Станции",
    "path": "Россия / Нижегородская область / Поселок Селекционной Станции",
    "country": "Россия",
    "searchString": "поселок селекционной станции россия / нижегородская область / поселок селекционной станции"
  },
  "7663": {
    "id": "7663",
    "name": "Мухино",
    "path": "Россия / Кировская область / Мухино",
    "country": "Россия",
    "searchString": "мухино россия / кировская область / мухино"
  },
  "7664": {
    "id": "7664",
    "name": "Суна",
    "path": "Россия / Кировская область / Суна",
    "country": "Россия",
    "searchString": "суна россия / кировская область / суна"
  },
  "7665": {
    "id": "7665",
    "name": "Архангельское (Кировская область)",
    "path": "Россия / Кировская область / Архангельское (Кировская область)",
    "country": "Россия",
    "searchString": "архангельское (кировская область) россия / кировская область / архангельское (кировская область)"
  },
  "7666": {
    "id": "7666",
    "name": "Юбилейный (Нижегородская область)",
    "path": "Россия / Нижегородская область / Юбилейный (Нижегородская область)",
    "country": "Россия",
    "searchString": "юбилейный (нижегородская область) россия / нижегородская область / юбилейный (нижегородская область)"
  },
  "7667": {
    "id": "7667",
    "name": "Вазьянка",
    "path": "Россия / Нижегородская область / Вазьянка",
    "country": "Россия",
    "searchString": "вазьянка россия / нижегородская область / вазьянка"
  },
  "7668": {
    "id": "7668",
    "name": "Большая Арать",
    "path": "Россия / Нижегородская область / Большая Арать",
    "country": "Россия",
    "searchString": "большая арать россия / нижегородская область / большая арать"
  },
  "7669": {
    "id": "7669",
    "name": "Семино",
    "path": "Россия / Нижегородская область / Семино",
    "country": "Россия",
    "searchString": "семино россия / нижегородская область / семино"
  },
  "7670": {
    "id": "7670",
    "name": "Сухоноска",
    "path": "Россия / Нижегородская область / Сухоноска",
    "country": "Россия",
    "searchString": "сухоноска россия / нижегородская область / сухоноска"
  },
  "7671": {
    "id": "7671",
    "name": "Пруды",
    "path": "Россия / Нижегородская область / Пруды",
    "country": "Россия",
    "searchString": "пруды россия / нижегородская область / пруды"
  },
  "7672": {
    "id": "7672",
    "name": "Арефино",
    "path": "Россия / Нижегородская область / Арефино",
    "country": "Россия",
    "searchString": "арефино россия / нижегородская область / арефино"
  },
  "7673": {
    "id": "7673",
    "name": "Яново",
    "path": "Россия / Нижегородская область / Яново",
    "country": "Россия",
    "searchString": "яново россия / нижегородская область / яново"
  },
  "7674": {
    "id": "7674",
    "name": "Лесные Поляны (Кировская область)",
    "path": "Россия / Кировская область / Лесные Поляны (Кировская область)",
    "country": "Россия",
    "searchString": "лесные поляны (кировская область) россия / кировская область / лесные поляны (кировская область)"
  },
  "7675": {
    "id": "7675",
    "name": "Запрудное",
    "path": "Россия / Нижегородская область / Запрудное",
    "country": "Россия",
    "searchString": "запрудное россия / нижегородская область / запрудное"
  },
  "7676": {
    "id": "7676",
    "name": "Крюковка",
    "path": "Россия / Нижегородская область / Крюковка",
    "country": "Россия",
    "searchString": "крюковка россия / нижегородская область / крюковка"
  },
  "7677": {
    "id": "7677",
    "name": "Абабково",
    "path": "Россия / Нижегородская область / Абабково",
    "country": "Россия",
    "searchString": "абабково россия / нижегородская область / абабково"
  },
  "7678": {
    "id": "7678",
    "name": "Ужовка",
    "path": "Россия / Нижегородская область / Ужовка",
    "country": "Россия",
    "searchString": "ужовка россия / нижегородская область / ужовка"
  },
  "7679": {
    "id": "7679",
    "name": "Шагаево",
    "path": "Россия / Нижегородская область / Шагаево",
    "country": "Россия",
    "searchString": "шагаево россия / нижегородская область / шагаево"
  },
  "7680": {
    "id": "7680",
    "name": "Лаж",
    "path": "Россия / Кировская область / Лаж",
    "country": "Россия",
    "searchString": "лаж россия / кировская область / лаж"
  },
  "7681": {
    "id": "7681",
    "name": "Конново",
    "path": "Россия / Нижегородская область / Конново",
    "country": "Россия",
    "searchString": "конново россия / нижегородская область / конново"
  },
  "7682": {
    "id": "7682",
    "name": "Шестаково",
    "path": "Россия / Кировская область / Шестаково",
    "country": "Россия",
    "searchString": "шестаково россия / кировская область / шестаково"
  },
  "7683": {
    "id": "7683",
    "name": "Суворово",
    "path": "Россия / Нижегородская область / Суворово",
    "country": "Россия",
    "searchString": "суворово россия / нижегородская область / суворово"
  },
  "7684": {
    "id": "7684",
    "name": "Швариха",
    "path": "Россия / Кировская область / Швариха",
    "country": "Россия",
    "searchString": "швариха россия / кировская область / швариха"
  },
  "7685": {
    "id": "7685",
    "name": "Каменки",
    "path": "Россия / Нижегородская область / Каменки",
    "country": "Россия",
    "searchString": "каменки россия / нижегородская область / каменки"
  },
  "7686": {
    "id": "7686",
    "name": "Новоликеево",
    "path": "Россия / Нижегородская область / Новоликеево",
    "country": "Россия",
    "searchString": "новоликеево россия / нижегородская область / новоликеево"
  },
  "7687": {
    "id": "7687",
    "name": "Стулово",
    "path": "Россия / Кировская область / Стулово",
    "country": "Россия",
    "searchString": "стулово россия / кировская область / стулово"
  },
  "7688": {
    "id": "7688",
    "name": "Поздняково",
    "path": "Россия / Нижегородская область / Поздняково",
    "country": "Россия",
    "searchString": "поздняково россия / нижегородская область / поздняково"
  },
  "7689": {
    "id": "7689",
    "name": "Пурех",
    "path": "Россия / Нижегородская область / Пурех",
    "country": "Россия",
    "searchString": "пурех россия / нижегородская область / пурех"
  },
  "7690": {
    "id": "7690",
    "name": "Кстинино",
    "path": "Россия / Кировская область / Кстинино",
    "country": "Россия",
    "searchString": "кстинино россия / кировская область / кстинино"
  },
  "7691": {
    "id": "7691",
    "name": "Ярымово",
    "path": "Россия / Нижегородская область / Ярымово",
    "country": "Россия",
    "searchString": "ярымово россия / нижегородская область / ярымово"
  },
  "7692": {
    "id": "7692",
    "name": "Чистое Борское",
    "path": "Россия / Нижегородская область / Чистое Борское",
    "country": "Россия",
    "searchString": "чистое борское россия / нижегородская область / чистое борское"
  },
  "7693": {
    "id": "7693",
    "name": "Шандрово",
    "path": "Россия / Нижегородская область / Шандрово",
    "country": "Россия",
    "searchString": "шандрово россия / нижегородская область / шандрово"
  },
  "7694": {
    "id": "7694",
    "name": "Средние Шуни",
    "path": "Россия / Кировская область / Средние Шуни",
    "country": "Россия",
    "searchString": "средние шуни россия / кировская область / средние шуни"
  },
  "7695": {
    "id": "7695",
    "name": "Салганы",
    "path": "Россия / Нижегородская область / Салганы",
    "country": "Россия",
    "searchString": "салганы россия / нижегородская область / салганы"
  },
  "7696": {
    "id": "7696",
    "name": "Юрьево",
    "path": "Россия / Нижегородская область / Юрьево",
    "country": "Россия",
    "searchString": "юрьево россия / нижегородская область / юрьево"
  },
  "7697": {
    "id": "7697",
    "name": "Таремское",
    "path": "Россия / Нижегородская область / Таремское",
    "country": "Россия",
    "searchString": "таремское россия / нижегородская область / таремское"
  },
  "7698": {
    "id": "7698",
    "name": "Безбожник",
    "path": "Россия / Кировская область / Безбожник",
    "country": "Россия",
    "searchString": "безбожник россия / кировская область / безбожник"
  },
  "7699": {
    "id": "7699",
    "name": "Уста",
    "path": "Россия / Нижегородская область / Уста",
    "country": "Россия",
    "searchString": "уста россия / нижегородская область / уста"
  },
  "7700": {
    "id": "7700",
    "name": "Октябрьский (Кировская область)",
    "path": "Россия / Кировская область / Октябрьский (Кировская область)",
    "country": "Россия",
    "searchString": "октябрьский (кировская область) россия / кировская область / октябрьский (кировская область)"
  },
  "7701": {
    "id": "7701",
    "name": "Верхосунье",
    "path": "Россия / Кировская область / Верхосунье",
    "country": "Россия",
    "searchString": "верхосунье россия / кировская область / верхосунье"
  },
  "7702": {
    "id": "7702",
    "name": "Бебяево",
    "path": "Россия / Нижегородская область / Бебяево",
    "country": "Россия",
    "searchString": "бебяево россия / нижегородская область / бебяево"
  },
  "7703": {
    "id": "7703",
    "name": "Буреполом",
    "path": "Россия / Нижегородская область / Буреполом",
    "country": "Россия",
    "searchString": "буреполом россия / нижегородская область / буреполом"
  },
  "7704": {
    "id": "7704",
    "name": "Валтово",
    "path": "Россия / Нижегородская область / Валтово",
    "country": "Россия",
    "searchString": "валтово россия / нижегородская область / валтово"
  },
  "7705": {
    "id": "7705",
    "name": "Вичевщина",
    "path": "Россия / Кировская область / Вичевщина",
    "country": "Россия",
    "searchString": "вичевщина россия / кировская область / вичевщина"
  },
  "7706": {
    "id": "7706",
    "name": "Пасегово",
    "path": "Россия / Кировская область / Пасегово",
    "country": "Россия",
    "searchString": "пасегово россия / кировская область / пасегово"
  },
  "7707": {
    "id": "7707",
    "name": "Плотинка",
    "path": "Россия / Нижегородская область / Плотинка",
    "country": "Россия",
    "searchString": "плотинка россия / нижегородская область / плотинка"
  },
  "7708": {
    "id": "7708",
    "name": "Ломовка (Нижегородская область)",
    "path": "Россия / Нижегородская область / Ломовка (Нижегородская область)",
    "country": "Россия",
    "searchString": "ломовка (нижегородская область) россия / нижегородская область / ломовка (нижегородская область)"
  },
  "7709": {
    "id": "7709",
    "name": "Медяна",
    "path": "Россия / Нижегородская область / Медяна",
    "country": "Россия",
    "searchString": "медяна россия / нижегородская область / медяна"
  },
  "7710": {
    "id": "7710",
    "name": "Васильсурск",
    "path": "Россия / Нижегородская область / Васильсурск",
    "country": "Россия",
    "searchString": "васильсурск россия / нижегородская область / васильсурск"
  },
  "7711": {
    "id": "7711",
    "name": "Работки",
    "path": "Россия / Нижегородская область / Работки",
    "country": "Россия",
    "searchString": "работки россия / нижегородская область / работки"
  },
  "7712": {
    "id": "7712",
    "name": "Селитьба",
    "path": "Россия / Нижегородская область / Селитьба",
    "country": "Россия",
    "searchString": "селитьба россия / нижегородская область / селитьба"
  },
  "7713": {
    "id": "7713",
    "name": "Кочкурово",
    "path": "Россия / Нижегородская область / Кочкурово",
    "country": "Россия",
    "searchString": "кочкурово россия / нижегородская область / кочкурово"
  },
  "7714": {
    "id": "7714",
    "name": "Карино",
    "path": "Россия / Кировская область / Карино",
    "country": "Россия",
    "searchString": "карино россия / кировская область / карино"
  },
  "7715": {
    "id": "7715",
    "name": "Верхнее Талызино",
    "path": "Россия / Нижегородская область / Верхнее Талызино",
    "country": "Россия",
    "searchString": "верхнее талызино россия / нижегородская область / верхнее талызино"
  },
  "7716": {
    "id": "7716",
    "name": "Мурзицы",
    "path": "Россия / Нижегородская область / Мурзицы",
    "country": "Россия",
    "searchString": "мурзицы россия / нижегородская область / мурзицы"
  },
  "7717": {
    "id": "7717",
    "name": "Первое Мая",
    "path": "Россия / Нижегородская область / Первое Мая",
    "country": "Россия",
    "searchString": "первое мая россия / нижегородская область / первое мая"
  },
  "7718": {
    "id": "7718",
    "name": "Гордино",
    "path": "Россия / Кировская область / Гордино",
    "country": "Россия",
    "searchString": "гордино россия / кировская область / гордино"
  },
  "7719": {
    "id": "7719",
    "name": "Кочуново",
    "path": "Россия / Нижегородская область / Кочуново",
    "country": "Россия",
    "searchString": "кочуново россия / нижегородская область / кочуново"
  },
  "7720": {
    "id": "7720",
    "name": "Созимский",
    "path": "Россия / Кировская область / Созимский",
    "country": "Россия",
    "searchString": "созимский россия / кировская область / созимский"
  },
  "7721": {
    "id": "7721",
    "name": "Кочетовка",
    "path": "Россия / Нижегородская область / Кочетовка",
    "country": "Россия",
    "searchString": "кочетовка россия / нижегородская область / кочетовка"
  },
  "7722": {
    "id": "7722",
    "name": "Ушаково",
    "path": "Россия / Нижегородская область / Ушаково",
    "country": "Россия",
    "searchString": "ушаково россия / нижегородская область / ушаково"
  },
  "7723": {
    "id": "7723",
    "name": "Хмелевицы",
    "path": "Россия / Нижегородская область / Хмелевицы",
    "country": "Россия",
    "searchString": "хмелевицы россия / нижегородская область / хмелевицы"
  },
  "7724": {
    "id": "7724",
    "name": "Абрамово",
    "path": "Россия / Нижегородская область / Абрамово",
    "country": "Россия",
    "searchString": "абрамово россия / нижегородская область / абрамово"
  },
  "7725": {
    "id": "7725",
    "name": "Ленинская Искра",
    "path": "Россия / Кировская область / Ленинская Искра",
    "country": "Россия",
    "searchString": "ленинская искра россия / кировская область / ленинская искра"
  },
  "7726": {
    "id": "7726",
    "name": "Филинское",
    "path": "Россия / Нижегородская область / Филинское",
    "country": "Россия",
    "searchString": "филинское россия / нижегородская область / филинское"
  },
  "7727": {
    "id": "7727",
    "name": "Смолино",
    "path": "Россия / Нижегородская область / Смолино",
    "country": "Россия",
    "searchString": "смолино россия / нижегородская область / смолино"
  },
  "7728": {
    "id": "7728",
    "name": "Красный Ватрас",
    "path": "Россия / Нижегородская область / Красный Ватрас",
    "country": "Россия",
    "searchString": "красный ватрас россия / нижегородская область / красный ватрас"
  },
  "7729": {
    "id": "7729",
    "name": "Полом",
    "path": "Россия / Кировская область / Полом",
    "country": "Россия",
    "searchString": "полом россия / кировская область / полом"
  },
  "7730": {
    "id": "7730",
    "name": "Деяново",
    "path": "Россия / Нижегородская область / Деяново",
    "country": "Россия",
    "searchString": "деяново россия / нижегородская область / деяново"
  },
  "7731": {
    "id": "7731",
    "name": "Новая Слобода",
    "path": "Россия / Нижегородская область / Новая Слобода",
    "country": "Россия",
    "searchString": "новая слобода россия / нижегородская область / новая слобода"
  },
  "7732": {
    "id": "7732",
    "name": "Уразовка",
    "path": "Россия / Нижегородская область / Уразовка",
    "country": "Россия",
    "searchString": "уразовка россия / нижегородская область / уразовка"
  },
  "7733": {
    "id": "7733",
    "name": "Мотызлей",
    "path": "Россия / Нижегородская область / Мотызлей",
    "country": "Россия",
    "searchString": "мотызлей россия / нижегородская область / мотызлей"
  },
  "7734": {
    "id": "7734",
    "name": "Смиркино",
    "path": "Россия / Нижегородская область / Смиркино",
    "country": "Россия",
    "searchString": "смиркино россия / нижегородская область / смиркино"
  },
  "7735": {
    "id": "7735",
    "name": "Синегорье (Кировская область)",
    "path": "Россия / Кировская область / Синегорье (Кировская область)",
    "country": "Россия",
    "searchString": "синегорье (кировская область) россия / кировская область / синегорье (кировская область)"
  },
  "7736": {
    "id": "7736",
    "name": "Тарасиха",
    "path": "Россия / Нижегородская область / Тарасиха",
    "country": "Россия",
    "searchString": "тарасиха россия / нижегородская область / тарасиха"
  },
  "7737": {
    "id": "7737",
    "name": "Азрапино",
    "path": "Россия / Нижегородская область / Азрапино",
    "country": "Россия",
    "searchString": "азрапино россия / нижегородская область / азрапино"
  },
  "7738": {
    "id": "7738",
    "name": "Окский",
    "path": "Россия / Рязанская область / Окский",
    "country": "Россия",
    "searchString": "окский россия / рязанская область / окский"
  },
  "7739": {
    "id": "7739",
    "name": "Натальино",
    "path": "Россия / Нижегородская область / Натальино",
    "country": "Россия",
    "searchString": "натальино россия / нижегородская область / натальино"
  },
  "7740": {
    "id": "7740",
    "name": "Косино",
    "path": "Россия / Кировская область / Косино",
    "country": "Россия",
    "searchString": "косино россия / кировская область / косино"
  },
  "7741": {
    "id": "7741",
    "name": "Ясенцы",
    "path": "Россия / Нижегородская область / Ясенцы",
    "country": "Россия",
    "searchString": "ясенцы россия / нижегородская область / ясенцы"
  },
  "7742": {
    "id": "7742",
    "name": "Неклюдово",
    "path": "Россия / Нижегородская область / Неклюдово",
    "country": "Россия",
    "searchString": "неклюдово россия / нижегородская область / неклюдово"
  },
  "7743": {
    "id": "7743",
    "name": "Мошкино",
    "path": "Россия / Нижегородская область / Мошкино",
    "country": "Россия",
    "searchString": "мошкино россия / нижегородская область / мошкино"
  },
  "7744": {
    "id": "7744",
    "name": "Боголюбовка",
    "path": "Россия / Омская область / Боголюбовка",
    "country": "Россия",
    "searchString": "боголюбовка россия / омская область / боголюбовка"
  },
  "7745": {
    "id": "7745",
    "name": "Гуселетово",
    "path": "Россия / Алтайский край / Гуселетово",
    "country": "Россия",
    "searchString": "гуселетово россия / алтайский край / гуселетово"
  },
  "7746": {
    "id": "7746",
    "name": "Зеркалы",
    "path": "Россия / Алтайский край / Зеркалы",
    "country": "Россия",
    "searchString": "зеркалы россия / алтайский край / зеркалы"
  },
  "7747": {
    "id": "7747",
    "name": "Тумановка",
    "path": "Россия / Омская область / Тумановка",
    "country": "Россия",
    "searchString": "тумановка россия / омская область / тумановка"
  },
  "7748": {
    "id": "7748",
    "name": "Малоенисейское",
    "path": "Россия / Алтайский край / Малоенисейское",
    "country": "Россия",
    "searchString": "малоенисейское россия / алтайский край / малоенисейское"
  },
  "7749": {
    "id": "7749",
    "name": "Гилев-Лог",
    "path": "Россия / Алтайский край / Гилев-Лог",
    "country": "Россия",
    "searchString": "гилев-лог россия / алтайский край / гилев-лог"
  },
  "7750": {
    "id": "7750",
    "name": "Куяган",
    "path": "Россия / Алтайский край / Куяган",
    "country": "Россия",
    "searchString": "куяган россия / алтайский край / куяган"
  },
  "7751": {
    "id": "7751",
    "name": "Решеты (Новосибирская область)",
    "path": "Россия / Новосибирская область / Решеты (Новосибирская область)",
    "country": "Россия",
    "searchString": "решеты (новосибирская область) россия / новосибирская область / решеты (новосибирская область)"
  },
  "7752": {
    "id": "7752",
    "name": "Усятское",
    "path": "Россия / Алтайский край / Усятское",
    "country": "Россия",
    "searchString": "усятское россия / алтайский край / усятское"
  },
  "7753": {
    "id": "7753",
    "name": "Дружино",
    "path": "Россия / Омская область / Дружино",
    "country": "Россия",
    "searchString": "дружино россия / омская область / дружино"
  },
  "7754": {
    "id": "7754",
    "name": "Санниково",
    "path": "Россия / Алтайский край / Санниково",
    "country": "Россия",
    "searchString": "санниково россия / алтайский край / санниково"
  },
  "7755": {
    "id": "7755",
    "name": "Быстровка",
    "path": "Россия / Новосибирская область / Быстровка",
    "country": "Россия",
    "searchString": "быстровка россия / новосибирская область / быстровка"
  },
  "7756": {
    "id": "7756",
    "name": "Мангут (Омская область)",
    "path": "Россия / Омская область / Мангут (Омская область)",
    "country": "Россия",
    "searchString": "мангут (омская область) россия / омская область / мангут (омская область)"
  },
  "7757": {
    "id": "7757",
    "name": "Окунево",
    "path": "Россия / Кемеровская область / Окунево",
    "country": "Россия",
    "searchString": "окунево россия / кемеровская область / окунево"
  },
  "7758": {
    "id": "7758",
    "name": "Украинский",
    "path": "Россия / Алтайский край / Украинский",
    "country": "Россия",
    "searchString": "украинский россия / алтайский край / украинский"
  },
  "7759": {
    "id": "7759",
    "name": "Казачий Мыс",
    "path": "Россия / Новосибирская область / Казачий Мыс",
    "country": "Россия",
    "searchString": "казачий мыс россия / новосибирская область / казачий мыс"
  },
  "7760": {
    "id": "7760",
    "name": "Металлургов",
    "path": "Россия / Кемеровская область / Металлургов",
    "country": "Россия",
    "searchString": "металлургов россия / кемеровская область / металлургов"
  },
  "7761": {
    "id": "7761",
    "name": "Пещерка",
    "path": "Россия / Алтайский край / Пещерка",
    "country": "Россия",
    "searchString": "пещерка россия / алтайский край / пещерка"
  },
  "7762": {
    "id": "7762",
    "name": "Заковряжино",
    "path": "Россия / Новосибирская область / Заковряжино",
    "country": "Россия",
    "searchString": "заковряжино россия / новосибирская область / заковряжино"
  },
  "7763": {
    "id": "7763",
    "name": "Битки",
    "path": "Россия / Новосибирская область / Битки",
    "country": "Россия",
    "searchString": "битки россия / новосибирская область / битки"
  },
  "7764": {
    "id": "7764",
    "name": "Подсосново",
    "path": "Россия / Алтайский край / Подсосново",
    "country": "Россия",
    "searchString": "подсосново россия / алтайский край / подсосново"
  },
  "7765": {
    "id": "7765",
    "name": "Ракиты (Михайловский район)",
    "path": "Россия / Алтайский край / Ракиты (Михайловский район)",
    "country": "Россия",
    "searchString": "ракиты (михайловский район) россия / алтайский край / ракиты (михайловский район)"
  },
  "7766": {
    "id": "7766",
    "name": "Борисовское",
    "path": "Россия / Омская область / Борисовское",
    "country": "Россия",
    "searchString": "борисовское россия / омская область / борисовское"
  },
  "7767": {
    "id": "7767",
    "name": "Студеное",
    "path": "Россия / Новосибирская область / Студеное",
    "country": "Россия",
    "searchString": "студеное россия / новосибирская область / студеное"
  },
  "7768": {
    "id": "7768",
    "name": "Алабота",
    "path": "Россия / Омская область / Алабота",
    "country": "Россия",
    "searchString": "алабота россия / омская область / алабота"
  },
  "7769": {
    "id": "7769",
    "name": "Проскоково",
    "path": "Россия / Кемеровская область / Проскоково",
    "country": "Россия",
    "searchString": "проскоково россия / кемеровская область / проскоково"
  },
  "7770": {
    "id": "7770",
    "name": "Лежанка",
    "path": "Россия / Омская область / Лежанка",
    "country": "Россия",
    "searchString": "лежанка россия / омская область / лежанка"
  },
  "7771": {
    "id": "7771",
    "name": "Усть-Каменка",
    "path": "Россия / Новосибирская область / Усть-Каменка",
    "country": "Россия",
    "searchString": "усть-каменка россия / новосибирская область / усть-каменка"
  },
  "7772": {
    "id": "7772",
    "name": "Буняковка",
    "path": "Россия / Омская область / Буняковка",
    "country": "Россия",
    "searchString": "буняковка россия / омская область / буняковка"
  },
  "7773": {
    "id": "7773",
    "name": "Веселовское",
    "path": "Россия / Новосибирская область / Веселовское",
    "country": "Россия",
    "searchString": "веселовское россия / новосибирская область / веселовское"
  },
  "7774": {
    "id": "7774",
    "name": "Мохнатый Лог",
    "path": "Россия / Новосибирская область / Мохнатый Лог",
    "country": "Россия",
    "searchString": "мохнатый лог россия / новосибирская область / мохнатый лог"
  },
  "7775": {
    "id": "7775",
    "name": "Волчно-Бурлинская",
    "path": "Россия / Алтайский край / Волчно-Бурлинская",
    "country": "Россия",
    "searchString": "волчно-бурлинская россия / алтайский край / волчно-бурлинская"
  },
  "7776": {
    "id": "7776",
    "name": "Малая Салаирка",
    "path": "Россия / Кемеровская область / Малая Салаирка",
    "country": "Россия",
    "searchString": "малая салаирка россия / кемеровская область / малая салаирка"
  },
  "7777": {
    "id": "7777",
    "name": "Новоярки",
    "path": "Россия / Алтайский край / Новоярки",
    "country": "Россия",
    "searchString": "новоярки россия / алтайский край / новоярки"
  },
  "7778": {
    "id": "7778",
    "name": "Бобровка (Шипуновский район)",
    "path": "Россия / Алтайский край / Бобровка (Шипуновский район)",
    "country": "Россия",
    "searchString": "бобровка (шипуновский район) россия / алтайский край / бобровка (шипуновский район)"
  },
  "7779": {
    "id": "7779",
    "name": "Солоновка (Волчихинский район)",
    "path": "Россия / Алтайский край / Солоновка (Волчихинский район)",
    "country": "Россия",
    "searchString": "солоновка (волчихинский район) россия / алтайский край / солоновка (волчихинский район)"
  },
  "7780": {
    "id": "7780",
    "name": "Желанное",
    "path": "Россия / Омская область / Желанное",
    "country": "Россия",
    "searchString": "желанное россия / омская область / желанное"
  },
  "7781": {
    "id": "7781",
    "name": "Буканское",
    "path": "Россия / Алтайский край / Буканское",
    "country": "Россия",
    "searchString": "буканское россия / алтайский край / буканское"
  },
  "7782": {
    "id": "7782",
    "name": "Рогозиха",
    "path": "Россия / Алтайский край / Рогозиха",
    "country": "Россия",
    "searchString": "рогозиха россия / алтайский край / рогозиха"
  },
  "7783": {
    "id": "7783",
    "name": "Бобринка",
    "path": "Россия / Омская область / Бобринка",
    "country": "Россия",
    "searchString": "бобринка россия / омская область / бобринка"
  },
  "7784": {
    "id": "7784",
    "name": "Катайга",
    "path": "Россия / Томская область / Катайга",
    "country": "Россия",
    "searchString": "катайга россия / томская область / катайга"
  },
  "7785": {
    "id": "7785",
    "name": "Закладное",
    "path": "Россия / Алтайский край / Закладное",
    "country": "Россия",
    "searchString": "закладное россия / алтайский край / закладное"
  },
  "7786": {
    "id": "7786",
    "name": "Шипуниха",
    "path": "Россия / Алтайский край / Шипуниха",
    "country": "Россия",
    "searchString": "шипуниха россия / алтайский край / шипуниха"
  },
  "7787": {
    "id": "7787",
    "name": "Поперечное",
    "path": "Россия / Алтайский край / Поперечное",
    "country": "Россия",
    "searchString": "поперечное россия / алтайский край / поперечное"
  },
  "7788": {
    "id": "7788",
    "name": "Шурыгино",
    "path": "Россия / Новосибирская область / Шурыгино",
    "country": "Россия",
    "searchString": "шурыгино россия / новосибирская область / шурыгино"
  },
  "7789": {
    "id": "7789",
    "name": "Гонохово (Завьяловский район)",
    "path": "Россия / Алтайский край / Гонохово (Завьяловский район)",
    "country": "Россия",
    "searchString": "гонохово (завьяловский район) россия / алтайский край / гонохово (завьяловский район)"
  },
  "7790": {
    "id": "7790",
    "name": "Чумай",
    "path": "Россия / Кемеровская область / Чумай",
    "country": "Россия",
    "searchString": "чумай россия / кемеровская область / чумай"
  },
  "7791": {
    "id": "7791",
    "name": "Нововознесенка",
    "path": "Россия / Алтайский край / Нововознесенка",
    "country": "Россия",
    "searchString": "нововознесенка россия / алтайский край / нововознесенка"
  },
  "7792": {
    "id": "7792",
    "name": "Берикульский",
    "path": "Россия / Кемеровская область / Берикульский",
    "country": "Россия",
    "searchString": "берикульский россия / кемеровская область / берикульский"
  },
  "7793": {
    "id": "7793",
    "name": "Новокремлевское",
    "path": "Россия / Новосибирская область / Новокремлевское",
    "country": "Россия",
    "searchString": "новокремлевское россия / новосибирская область / новокремлевское"
  },
  "7794": {
    "id": "7794",
    "name": "Паново",
    "path": "Россия / Алтайский край / Паново",
    "country": "Россия",
    "searchString": "паново россия / алтайский край / паново"
  },
  "7795": {
    "id": "7795",
    "name": "Озеро Карачи",
    "path": "Россия / Новосибирская область / Озеро Карачи",
    "country": "Россия",
    "searchString": "озеро карачи россия / новосибирская область / озеро карачи"
  },
  "7796": {
    "id": "7796",
    "name": "Сараса",
    "path": "Россия / Алтайский край / Сараса",
    "country": "Россия",
    "searchString": "сараса россия / алтайский край / сараса"
  },
  "7797": {
    "id": "7797",
    "name": "Новомихайловка",
    "path": "Россия / Новосибирская область / Новомихайловка",
    "country": "Россия",
    "searchString": "новомихайловка россия / новосибирская область / новомихайловка"
  },
  "7798": {
    "id": "7798",
    "name": "Вьюны",
    "path": "Россия / Новосибирская область / Вьюны",
    "country": "Россия",
    "searchString": "вьюны россия / новосибирская область / вьюны"
  },
  "7799": {
    "id": "7799",
    "name": "Гилевка",
    "path": "Россия / Алтайский край / Гилевка",
    "country": "Россия",
    "searchString": "гилевка россия / алтайский край / гилевка"
  },
  "7800": {
    "id": "7800",
    "name": "Новотроицк (Нижнеомский район)",
    "path": "Россия / Омская область / Новотроицк (Нижнеомский район)",
    "country": "Россия",
    "searchString": "новотроицк (нижнеомский район) россия / омская область / новотроицк (нижнеомский район)"
  },
  "7801": {
    "id": "7801",
    "name": "Улу-Юл",
    "path": "Россия / Томская область / Улу-Юл",
    "country": "Россия",
    "searchString": "улу-юл россия / томская область / улу-юл"
  },
  "7802": {
    "id": "7802",
    "name": "Дупленская",
    "path": "Россия / Новосибирская область / Дупленская",
    "country": "Россия",
    "searchString": "дупленская россия / новосибирская область / дупленская"
  },
  "7803": {
    "id": "7803",
    "name": "Зятькова Речка",
    "path": "Россия / Алтайский край / Зятькова Речка",
    "country": "Россия",
    "searchString": "зятькова речка россия / алтайский край / зятькова речка"
  },
  "7804": {
    "id": "7804",
    "name": "Шабаново",
    "path": "Россия / Кемеровская область / Шабаново",
    "country": "Россия",
    "searchString": "шабаново россия / кемеровская область / шабаново"
  },
  "7805": {
    "id": "7805",
    "name": "Долганка",
    "path": "Россия / Алтайский край / Долганка",
    "country": "Россия",
    "searchString": "долганка россия / алтайский край / долганка"
  },
  "7806": {
    "id": "7806",
    "name": "Верх-Суетка",
    "path": "Россия / Алтайский край / Верх-Суетка",
    "country": "Россия",
    "searchString": "верх-суетка россия / алтайский край / верх-суетка"
  },
  "7807": {
    "id": "7807",
    "name": "Шагалово",
    "path": "Россия / Новосибирская область / Шагалово",
    "country": "Россия",
    "searchString": "шагалово россия / новосибирская область / шагалово"
  },
  "7808": {
    "id": "7808",
    "name": "Устьянка",
    "path": "Россия / Алтайский край / Устьянка",
    "country": "Россия",
    "searchString": "устьянка россия / алтайский край / устьянка"
  },
  "7809": {
    "id": "7809",
    "name": "Терентьевское",
    "path": "Россия / Кемеровская область / Терентьевское",
    "country": "Россия",
    "searchString": "терентьевское россия / кемеровская область / терентьевское"
  },
  "7810": {
    "id": "7810",
    "name": "Нижнекаменка",
    "path": "Россия / Новосибирская область / Нижнекаменка",
    "country": "Россия",
    "searchString": "нижнекаменка россия / новосибирская область / нижнекаменка"
  },
  "7811": {
    "id": "7811",
    "name": "Антоньевка",
    "path": "Россия / Алтайский край / Антоньевка",
    "country": "Россия",
    "searchString": "антоньевка россия / алтайский край / антоньевка"
  },
  "7812": {
    "id": "7812",
    "name": "Шарчино",
    "path": "Россия / Алтайский край / Шарчино",
    "country": "Россия",
    "searchString": "шарчино россия / алтайский край / шарчино"
  },
  "7813": {
    "id": "7813",
    "name": "Серебряное",
    "path": "Россия / Омская область / Серебряное",
    "country": "Россия",
    "searchString": "серебряное россия / омская область / серебряное"
  },
  "7814": {
    "id": "7814",
    "name": "Поповичи",
    "path": "Россия / Алтайский край / Поповичи",
    "country": "Россия",
    "searchString": "поповичи россия / алтайский край / поповичи"
  },
  "7815": {
    "id": "7815",
    "name": "Рожнев Лог",
    "path": "Россия / Алтайский край / Рожнев Лог",
    "country": "Россия",
    "searchString": "рожнев лог россия / алтайский край / рожнев лог"
  },
  "7816": {
    "id": "7816",
    "name": "Новопервомайское",
    "path": "Россия / Новосибирская область / Новопервомайское",
    "country": "Россия",
    "searchString": "новопервомайское россия / новосибирская область / новопервомайское"
  },
  "7817": {
    "id": "7817",
    "name": "Подстепное",
    "path": "Россия / Алтайский край / Подстепное",
    "country": "Россия",
    "searchString": "подстепное россия / алтайский край / подстепное"
  },
  "7818": {
    "id": "7818",
    "name": "Вторая Каменка",
    "path": "Россия / Алтайский край / Вторая Каменка",
    "country": "Россия",
    "searchString": "вторая каменка россия / алтайский край / вторая каменка"
  },
  "7819": {
    "id": "7819",
    "name": "Березовка (Первомайский район)",
    "path": "Россия / Алтайский край / Березовка (Первомайский район)",
    "country": "Россия",
    "searchString": "березовка (первомайский район) россия / алтайский край / березовка (первомайский район)"
  },
  "7820": {
    "id": "7820",
    "name": "Сейка",
    "path": "Россия / Республика Алтай / Сейка",
    "country": "Россия",
    "searchString": "сейка россия / республика алтай / сейка"
  },
  "7821": {
    "id": "7821",
    "name": "Зубково",
    "path": "Россия / Новосибирская область / Зубково",
    "country": "Россия",
    "searchString": "зубково россия / новосибирская область / зубково"
  },
  "7822": {
    "id": "7822",
    "name": "Батурино",
    "path": "Россия / Томская область / Батурино",
    "country": "Россия",
    "searchString": "батурино россия / томская область / батурино"
  },
  "7823": {
    "id": "7823",
    "name": "Пермяки",
    "path": "Россия / Кемеровская область / Пермяки",
    "country": "Россия",
    "searchString": "пермяки россия / кемеровская область / пермяки"
  },
  "7824": {
    "id": "7824",
    "name": "Колыбелька",
    "path": "Россия / Новосибирская область / Колыбелька",
    "country": "Россия",
    "searchString": "колыбелька россия / новосибирская область / колыбелька"
  },
  "7825": {
    "id": "7825",
    "name": "Колыванск",
    "path": "Россия / Алтайский край / Колыванск",
    "country": "Россия",
    "searchString": "колыванск россия / алтайский край / колыванск"
  },
  "7826": {
    "id": "7826",
    "name": "Краснодарское",
    "path": "Россия / Алтайский край / Краснодарское",
    "country": "Россия",
    "searchString": "краснодарское россия / алтайский край / краснодарское"
  },
  "7827": {
    "id": "7827",
    "name": "Степное (Родинский район)",
    "path": "Россия / Алтайский край / Степное (Родинский район)",
    "country": "Россия",
    "searchString": "степное (родинский район) россия / алтайский край / степное (родинский район)"
  },
  "7828": {
    "id": "7828",
    "name": "Ситниково",
    "path": "Россия / Омская область / Ситниково",
    "country": "Россия",
    "searchString": "ситниково россия / омская область / ситниково"
  },
  "7829": {
    "id": "7829",
    "name": "Утичье",
    "path": "Россия / Омская область / Утичье",
    "country": "Россия",
    "searchString": "утичье россия / омская область / утичье"
  },
  "7830": {
    "id": "7830",
    "name": "Панфилово (Кемеровская область)",
    "path": "Россия / Кемеровская область / Панфилово (Кемеровская область)",
    "country": "Россия",
    "searchString": "панфилово (кемеровская область) россия / кемеровская область / панфилово (кемеровская область)"
  },
  "7831": {
    "id": "7831",
    "name": "Шульгинка",
    "path": "Россия / Алтайский край / Шульгинка",
    "country": "Россия",
    "searchString": "шульгинка россия / алтайский край / шульгинка"
  },
  "7832": {
    "id": "7832",
    "name": "Солоновка (Новичихинский район)",
    "path": "Россия / Алтайский край / Солоновка (Новичихинский район)",
    "country": "Россия",
    "searchString": "солоновка (новичихинский район) россия / алтайский край / солоновка (новичихинский район)"
  },
  "7833": {
    "id": "7833",
    "name": "Киприно",
    "path": "Россия / Алтайский край / Киприно",
    "country": "Россия",
    "searchString": "киприно россия / алтайский край / киприно"
  },
  "7834": {
    "id": "7834",
    "name": "Корчино",
    "path": "Россия / Алтайский край / Корчино",
    "country": "Россия",
    "searchString": "корчино россия / алтайский край / корчино"
  },
  "7835": {
    "id": "7835",
    "name": "Гордеевский",
    "path": "Россия / Алтайский край / Гордеевский",
    "country": "Россия",
    "searchString": "гордеевский россия / алтайский край / гордеевский"
  },
  "7836": {
    "id": "7836",
    "name": "Смазнево",
    "path": "Россия / Алтайский край / Смазнево",
    "country": "Россия",
    "searchString": "смазнево россия / алтайский край / смазнево"
  },
  "7837": {
    "id": "7837",
    "name": "Зеленая Поляна",
    "path": "Россия / Алтайский край / Зеленая Поляна",
    "country": "Россия",
    "searchString": "зеленая поляна россия / алтайский край / зеленая поляна"
  },
  "7838": {
    "id": "7838",
    "name": "Шубенка",
    "path": "Россия / Алтайский край / Шубенка",
    "country": "Россия",
    "searchString": "шубенка россия / алтайский край / шубенка"
  },
  "7839": {
    "id": "7839",
    "name": "Линевский",
    "path": "Россия / Алтайский край / Линевский",
    "country": "Россия",
    "searchString": "линевский россия / алтайский край / линевский"
  },
  "7840": {
    "id": "7840",
    "name": "Маршанское",
    "path": "Россия / Новосибирская область / Маршанское",
    "country": "Россия",
    "searchString": "маршанское россия / новосибирская область / маршанское"
  },
  "7841": {
    "id": "7841",
    "name": "Новобураново",
    "path": "Россия / Алтайский край / Новобураново",
    "country": "Россия",
    "searchString": "новобураново россия / алтайский край / новобураново"
  },
  "7842": {
    "id": "7842",
    "name": "Пушкино (Омская область)",
    "path": "Россия / Омская область / Пушкино (Омская область)",
    "country": "Россия",
    "searchString": "пушкино (омская область) россия / омская область / пушкино (омская область)"
  },
  "7843": {
    "id": "7843",
    "name": "Баррикада",
    "path": "Россия / Омская область / Баррикада",
    "country": "Россия",
    "searchString": "баррикада россия / омская область / баррикада"
  },
  "7844": {
    "id": "7844",
    "name": "Суворовка",
    "path": "Россия / Алтайский край / Суворовка",
    "country": "Россия",
    "searchString": "суворовка россия / алтайский край / суворовка"
  },
  "7845": {
    "id": "7845",
    "name": "Элита (Омская область)",
    "path": "Россия / Омская область / Элита (Омская область)",
    "country": "Россия",
    "searchString": "элита (омская область) россия / омская область / элита (омская область)"
  },
  "7846": {
    "id": "7846",
    "name": "Кызыл-Озек",
    "path": "Россия / Республика Алтай / Кызыл-Озек",
    "country": "Россия",
    "searchString": "кызыл-озек россия / республика алтай / кызыл-озек"
  },
  "7847": {
    "id": "7847",
    "name": "Заводское",
    "path": "Россия / Алтайский край / Заводское",
    "country": "Россия",
    "searchString": "заводское россия / алтайский край / заводское"
  },
  "7848": {
    "id": "7848",
    "name": "Травное",
    "path": "Россия / Новосибирская область / Травное",
    "country": "Россия",
    "searchString": "травное россия / новосибирская область / травное"
  },
  "7849": {
    "id": "7849",
    "name": "Путь Социализма",
    "path": "Россия / Омская область / Путь Социализма",
    "country": "Россия",
    "searchString": "путь социализма россия / омская область / путь социализма"
  },
  "7850": {
    "id": "7850",
    "name": "Верх-Урюм",
    "path": "Россия / Новосибирская область / Верх-Урюм",
    "country": "Россия",
    "searchString": "верх-урюм россия / новосибирская область / верх-урюм"
  },
  "7851": {
    "id": "7851",
    "name": "Горскино",
    "path": "Россия / Кемеровская область / Горскино",
    "country": "Россия",
    "searchString": "горскино россия / кемеровская область / горскино"
  },
  "7852": {
    "id": "7852",
    "name": "Тебисское",
    "path": "Россия / Новосибирская область / Тебисское",
    "country": "Россия",
    "searchString": "тебисское россия / новосибирская область / тебисское"
  },
  "7853": {
    "id": "7853",
    "name": "Парфеново",
    "path": "Россия / Алтайский край / Парфеново",
    "country": "Россия",
    "searchString": "парфеново россия / алтайский край / парфеново"
  },
  "7854": {
    "id": "7854",
    "name": "Первомайское (Бийский район)",
    "path": "Россия / Алтайский край / Первомайское (Бийский район)",
    "country": "Россия",
    "searchString": "первомайское (бийский район) россия / алтайский край / первомайское (бийский район)"
  },
  "7855": {
    "id": "7855",
    "name": "Боровское",
    "path": "Россия / Алтайский край / Боровское",
    "country": "Россия",
    "searchString": "боровское россия / алтайский край / боровское"
  },
  "7856": {
    "id": "7856",
    "name": "Новый Шарап",
    "path": "Россия / Новосибирская область / Новый Шарап",
    "country": "Россия",
    "searchString": "новый шарап россия / новосибирская область / новый шарап"
  },
  "7857": {
    "id": "7857",
    "name": "Новоивановский",
    "path": "Россия / Кемеровская область / Новоивановский",
    "country": "Россия",
    "searchString": "новоивановский россия / кемеровская область / новоивановский"
  },
  "7858": {
    "id": "7858",
    "name": "Бобровка (Новосибирская область)",
    "path": "Россия / Новосибирская область / Бобровка (Новосибирская область)",
    "country": "Россия",
    "searchString": "бобровка (новосибирская область) россия / новосибирская область / бобровка (новосибирская область)"
  },
  "7859": {
    "id": "7859",
    "name": "Большепесчанка",
    "path": "Россия / Омская область / Большепесчанка",
    "country": "Россия",
    "searchString": "большепесчанка россия / омская область / большепесчанка"
  },
  "7860": {
    "id": "7860",
    "name": "Полуторник",
    "path": "Россия / Кемеровская область / Полуторник",
    "country": "Россия",
    "searchString": "полуторник россия / кемеровская область / полуторник"
  },
  "7861": {
    "id": "7861",
    "name": "Старые Карачи",
    "path": "Россия / Новосибирская область / Старые Карачи",
    "country": "Россия",
    "searchString": "старые карачи россия / новосибирская область / старые карачи"
  },
  "7862": {
    "id": "7862",
    "name": "Вольное (Омская область)",
    "path": "Россия / Омская область / Вольное (Омская область)",
    "country": "Россия",
    "searchString": "вольное (омская область) россия / омская область / вольное (омская область)"
  },
  "7863": {
    "id": "7863",
    "name": "Ачаирский",
    "path": "Россия / Омская область / Ачаирский",
    "country": "Россия",
    "searchString": "ачаирский россия / омская область / ачаирский"
  },
  "7864": {
    "id": "7864",
    "name": "Сереброполь",
    "path": "Россия / Алтайский край / Сереброполь",
    "country": "Россия",
    "searchString": "сереброполь россия / алтайский край / сереброполь"
  },
  "7865": {
    "id": "7865",
    "name": "Каип",
    "path": "Россия / Алтайский край / Каип",
    "country": "Россия",
    "searchString": "каип россия / алтайский край / каип"
  },
  "7866": {
    "id": "7866",
    "name": "Овечкино",
    "path": "Россия / Алтайский край / Овечкино",
    "country": "Россия",
    "searchString": "овечкино россия / алтайский край / овечкино"
  },
  "7867": {
    "id": "7867",
    "name": "Екатеринославка (Омская область)",
    "path": "Россия / Омская область / Екатеринославка (Омская область)",
    "country": "Россия",
    "searchString": "екатеринославка (омская область) россия / омская область / екатеринославка (омская область)"
  },
  "7868": {
    "id": "7868",
    "name": "Зимари",
    "path": "Россия / Алтайский край / Зимари",
    "country": "Россия",
    "searchString": "зимари россия / алтайский край / зимари"
  },
  "7869": {
    "id": "7869",
    "name": "Коурак",
    "path": "Россия / Новосибирская область / Коурак",
    "country": "Россия",
    "searchString": "коурак россия / новосибирская область / коурак"
  },
  "7870": {
    "id": "7870",
    "name": "Боевой",
    "path": "Россия / Омская область / Боевой",
    "country": "Россия",
    "searchString": "боевой россия / омская область / боевой"
  },
  "7871": {
    "id": "7871",
    "name": "Еланка",
    "path": "Россия / Новосибирская область / Еланка",
    "country": "Россия",
    "searchString": "еланка россия / новосибирская область / еланка"
  },
  "7872": {
    "id": "7872",
    "name": "Нечунаево",
    "path": "Россия / Алтайский край / Нечунаево",
    "country": "Россия",
    "searchString": "нечунаево россия / алтайский край / нечунаево"
  },
  "7873": {
    "id": "7873",
    "name": "Шалап",
    "path": "Россия / Алтайский край / Шалап",
    "country": "Россия",
    "searchString": "шалап россия / алтайский край / шалап"
  },
  "7874": {
    "id": "7874",
    "name": "Табулга",
    "path": "Россия / Новосибирская область / Табулга",
    "country": "Россия",
    "searchString": "табулга россия / новосибирская область / табулга"
  },
  "7875": {
    "id": "7875",
    "name": "Козиха",
    "path": "Россия / Новосибирская область / Козиха",
    "country": "Россия",
    "searchString": "козиха россия / новосибирская область / козиха"
  },
  "7876": {
    "id": "7876",
    "name": "Хомутинка",
    "path": "Россия / Омская область / Хомутинка",
    "country": "Россия",
    "searchString": "хомутинка россия / омская область / хомутинка"
  },
  "7877": {
    "id": "7877",
    "name": "Яман",
    "path": "Россия / Омская область / Яман",
    "country": "Россия",
    "searchString": "яман россия / омская область / яман"
  },
  "7878": {
    "id": "7878",
    "name": "Хлопуново",
    "path": "Россия / Алтайский край / Хлопуново",
    "country": "Россия",
    "searchString": "хлопуново россия / алтайский край / хлопуново"
  },
  "7879": {
    "id": "7879",
    "name": "Верх-Каргат",
    "path": "Россия / Новосибирская область / Верх-Каргат",
    "country": "Россия",
    "searchString": "верх-каргат россия / новосибирская область / верх-каргат"
  },
  "7880": {
    "id": "7880",
    "name": "Тулата",
    "path": "Россия / Алтайский край / Тулата",
    "country": "Россия",
    "searchString": "тулата россия / алтайский край / тулата"
  },
  "7881": {
    "id": "7881",
    "name": "Старобелокуриха",
    "path": "Россия / Алтайский край / Старобелокуриха",
    "country": "Россия",
    "searchString": "старобелокуриха россия / алтайский край / старобелокуриха"
  },
  "7882": {
    "id": "7882",
    "name": "Кучук",
    "path": "Россия / Алтайский край / Кучук",
    "country": "Россия",
    "searchString": "кучук россия / алтайский край / кучук"
  },
  "7883": {
    "id": "7883",
    "name": "Родная Долина",
    "path": "Россия / Омская область / Родная Долина",
    "country": "Россия",
    "searchString": "родная долина россия / омская область / родная долина"
  },
  "7884": {
    "id": "7884",
    "name": "Свердловское",
    "path": "Россия / Алтайский край / Свердловское",
    "country": "Россия",
    "searchString": "свердловское россия / алтайский край / свердловское"
  },
  "7885": {
    "id": "7885",
    "name": "Паутово",
    "path": "Россия / Алтайский край / Паутово",
    "country": "Россия",
    "searchString": "паутово россия / алтайский край / паутово"
  },
  "7886": {
    "id": "7886",
    "name": "Поспелихинский",
    "path": "Россия / Алтайский край / Поспелихинский",
    "country": "Россия",
    "searchString": "поспелихинский россия / алтайский край / поспелихинский"
  },
  "7887": {
    "id": "7887",
    "name": "Осокино",
    "path": "Россия / Омская область / Осокино",
    "country": "Россия",
    "searchString": "осокино россия / омская область / осокино"
  },
  "7888": {
    "id": "7888",
    "name": "Дмитро-Титово",
    "path": "Россия / Алтайский край / Дмитро-Титово",
    "country": "Россия",
    "searchString": "дмитро-титово россия / алтайский край / дмитро-титово"
  },
  "7889": {
    "id": "7889",
    "name": "Велижанка",
    "path": "Россия / Алтайский край / Велижанка",
    "country": "Россия",
    "searchString": "велижанка россия / алтайский край / велижанка"
  },
  "7890": {
    "id": "7890",
    "name": "Малоугренево",
    "path": "Россия / Алтайский край / Малоугренево",
    "country": "Россия",
    "searchString": "малоугренево россия / алтайский край / малоугренево"
  },
  "7891": {
    "id": "7891",
    "name": "Карповка",
    "path": "Россия / Омская область / Карповка",
    "country": "Россия",
    "searchString": "карповка россия / омская область / карповка"
  },
  "7892": {
    "id": "7892",
    "name": "Сыропятское",
    "path": "Россия / Омская область / Сыропятское",
    "country": "Россия",
    "searchString": "сыропятское россия / омская область / сыропятское"
  },
  "7893": {
    "id": "7893",
    "name": "Ингалы",
    "path": "Россия / Омская область / Ингалы",
    "country": "Россия",
    "searchString": "ингалы россия / омская область / ингалы"
  },
  "7894": {
    "id": "7894",
    "name": "Подойниково",
    "path": "Россия / Алтайский край / Подойниково",
    "country": "Россия",
    "searchString": "подойниково россия / алтайский край / подойниково"
  },
  "7895": {
    "id": "7895",
    "name": "Прыганка",
    "path": "Россия / Алтайский край / Прыганка",
    "country": "Россия",
    "searchString": "прыганка россия / алтайский край / прыганка"
  },
  "7896": {
    "id": "7896",
    "name": "Атаманово",
    "path": "Россия / Кемеровская область / Атаманово",
    "country": "Россия",
    "searchString": "атаманово россия / кемеровская область / атаманово"
  },
  "7897": {
    "id": "7897",
    "name": "Харламово",
    "path": "Россия / Омская область / Харламово",
    "country": "Россия",
    "searchString": "харламово россия / омская область / харламово"
  },
  "7898": {
    "id": "7898",
    "name": "Цветнополье",
    "path": "Россия / Омская область / Цветнополье",
    "country": "Россия",
    "searchString": "цветнополье россия / омская область / цветнополье"
  },
  "7899": {
    "id": "7899",
    "name": "Зеленовский",
    "path": "Россия / Кемеровская область / Зеленовский",
    "country": "Россия",
    "searchString": "зеленовский россия / кемеровская область / зеленовский"
  },
  "7900": {
    "id": "7900",
    "name": "Иртышский",
    "path": "Россия / Омская область / Иртышский",
    "country": "Россия",
    "searchString": "иртышский россия / омская область / иртышский"
  },
  "7901": {
    "id": "7901",
    "name": "Ключики",
    "path": "Россия / Новосибирская область / Ключики",
    "country": "Россия",
    "searchString": "ключики россия / новосибирская область / ключики"
  },
  "7902": {
    "id": "7902",
    "name": "Комариха",
    "path": "Россия / Алтайский край / Комариха",
    "country": "Россия",
    "searchString": "комариха россия / алтайский край / комариха"
  },
  "7903": {
    "id": "7903",
    "name": "Пойменное",
    "path": "Россия / Новосибирская область / Пойменное",
    "country": "Россия",
    "searchString": "пойменное россия / новосибирская область / пойменное"
  },
  "7904": {
    "id": "7904",
    "name": "Порожнее",
    "path": "Россия / Алтайский край / Порожнее",
    "country": "Россия",
    "searchString": "порожнее россия / алтайский край / порожнее"
  },
  "7905": {
    "id": "7905",
    "name": "Зюзя",
    "path": "Россия / Новосибирская область / Зюзя",
    "country": "Россия",
    "searchString": "зюзя россия / новосибирская область / зюзя"
  },
  "7906": {
    "id": "7906",
    "name": "Степановка",
    "path": "Россия / Томская область / Степановка",
    "country": "Россия",
    "searchString": "степановка россия / томская область / степановка"
  },
  "7907": {
    "id": "7907",
    "name": "Быстрянка",
    "path": "Россия / Алтайский край / Быстрянка",
    "country": "Россия",
    "searchString": "быстрянка россия / алтайский край / быстрянка"
  },
  "7908": {
    "id": "7908",
    "name": "Солнцевка",
    "path": "Россия / Омская область / Солнцевка",
    "country": "Россия",
    "searchString": "солнцевка россия / омская область / солнцевка"
  },
  "7909": {
    "id": "7909",
    "name": "Хлебодаровка",
    "path": "Россия / Омская область / Хлебодаровка",
    "country": "Россия",
    "searchString": "хлебодаровка россия / омская область / хлебодаровка"
  },
  "7910": {
    "id": "7910",
    "name": "Южно-Подольск",
    "path": "Россия / Омская область / Южно-Подольск",
    "country": "Россия",
    "searchString": "южно-подольск россия / омская область / южно-подольск"
  },
  "7911": {
    "id": "7911",
    "name": "Маловолчанка",
    "path": "Россия / Алтайский край / Маловолчанка",
    "country": "Россия",
    "searchString": "маловолчанка россия / алтайский край / маловолчанка"
  },
  "7912": {
    "id": "7912",
    "name": "Новоцарицыно",
    "path": "Россия / Омская область / Новоцарицыно",
    "country": "Россия",
    "searchString": "новоцарицыно россия / омская область / новоцарицыно"
  },
  "7913": {
    "id": "7913",
    "name": "Менчереп",
    "path": "Россия / Кемеровская область / Менчереп",
    "country": "Россия",
    "searchString": "менчереп россия / кемеровская область / менчереп"
  },
  "7914": {
    "id": "7914",
    "name": "Глядень",
    "path": "Россия / Алтайский край / Глядень",
    "country": "Россия",
    "searchString": "глядень россия / алтайский край / глядень"
  },
  "7915": {
    "id": "7915",
    "name": "Золотая Нива",
    "path": "Россия / Омская область / Золотая Нива",
    "country": "Россия",
    "searchString": "золотая нива россия / омская область / золотая нива"
  },
  "7916": {
    "id": "7916",
    "name": "Новорождественка",
    "path": "Россия / Омская область / Новорождественка",
    "country": "Россия",
    "searchString": "новорождественка россия / омская область / новорождественка"
  },
  "7917": {
    "id": "7917",
    "name": "Щербаково",
    "path": "Россия / Новосибирская область / Щербаково",
    "country": "Россия",
    "searchString": "щербаково россия / новосибирская область / щербаково"
  },
  "7918": {
    "id": "7918",
    "name": "Мартовка",
    "path": "Россия / Алтайский край / Мартовка",
    "country": "Россия",
    "searchString": "мартовка россия / алтайский край / мартовка"
  },
  "7919": {
    "id": "7919",
    "name": "Усть-Заостровка",
    "path": "Россия / Омская область / Усть-Заостровка",
    "country": "Россия",
    "searchString": "усть-заостровка россия / омская область / усть-заостровка"
  },
  "7920": {
    "id": "7920",
    "name": "Покровка (Алтайский край)",
    "path": "Россия / Алтайский край / Покровка (Алтайский край)",
    "country": "Россия",
    "searchString": "покровка (алтайский край) россия / алтайский край / покровка (алтайский край)"
  },
  "7921": {
    "id": "7921",
    "name": "Шумановка",
    "path": "Россия / Алтайский край / Шумановка",
    "country": "Россия",
    "searchString": "шумановка россия / алтайский край / шумановка"
  },
  "7922": {
    "id": "7922",
    "name": "Дергаусово",
    "path": "Россия / Новосибирская область / Дергаусово",
    "country": "Россия",
    "searchString": "дергаусово россия / новосибирская область / дергаусово"
  },
  "7923": {
    "id": "7923",
    "name": "Орехов Лог",
    "path": "Россия / Новосибирская область / Орехов Лог",
    "country": "Россия",
    "searchString": "орехов лог россия / новосибирская область / орехов лог"
  },
  "7924": {
    "id": "7924",
    "name": "Бастан",
    "path": "Россия / Алтайский край / Бастан",
    "country": "Россия",
    "searchString": "бастан россия / алтайский край / бастан"
  },
  "7925": {
    "id": "7925",
    "name": "Блюдчанское",
    "path": "Россия / Новосибирская область / Блюдчанское",
    "country": "Россия",
    "searchString": "блюдчанское россия / новосибирская область / блюдчанское"
  },
  "7926": {
    "id": "7926",
    "name": "Новоильинка",
    "path": "Россия / Алтайский край / Новоильинка",
    "country": "Россия",
    "searchString": "новоильинка россия / алтайский край / новоильинка"
  },
  "7927": {
    "id": "7927",
    "name": "Елунино",
    "path": "Россия / Алтайский край / Елунино",
    "country": "Россия",
    "searchString": "елунино россия / алтайский край / елунино"
  },
  "7928": {
    "id": "7928",
    "name": "Моховское",
    "path": "Россия / Алтайский край / Моховское",
    "country": "Россия",
    "searchString": "моховское россия / алтайский край / моховское"
  },
  "7929": {
    "id": "7929",
    "name": "Усть-Луковка",
    "path": "Россия / Новосибирская область / Усть-Луковка",
    "country": "Россия",
    "searchString": "усть-луковка россия / новосибирская область / усть-луковка"
  },
  "7930": {
    "id": "7930",
    "name": "Сросты",
    "path": "Россия / Алтайский край / Сросты",
    "country": "Россия",
    "searchString": "сросты россия / алтайский край / сросты"
  },
  "7931": {
    "id": "7931",
    "name": "Кашкарагаиха",
    "path": "Россия / Алтайский край / Кашкарагаиха",
    "country": "Россия",
    "searchString": "кашкарагаиха россия / алтайский край / кашкарагаиха"
  },
  "7932": {
    "id": "7932",
    "name": "Новотырышкино",
    "path": "Россия / Алтайский край / Новотырышкино",
    "country": "Россия",
    "searchString": "новотырышкино россия / алтайский край / новотырышкино"
  },
  "7933": {
    "id": "7933",
    "name": "Шахта",
    "path": "Россия / Новосибирская область / Шахта",
    "country": "Россия",
    "searchString": "шахта россия / новосибирская область / шахта"
  },
  "7934": {
    "id": "7934",
    "name": "Победа (Алтайский край)",
    "path": "Россия / Алтайский край / Победа (Алтайский край)",
    "country": "Россия",
    "searchString": "победа (алтайский край) россия / алтайский край / победа (алтайский край)"
  },
  "7935": {
    "id": "7935",
    "name": "Чернокурья",
    "path": "Россия / Новосибирская область / Чернокурья",
    "country": "Россия",
    "searchString": "чернокурья россия / новосибирская область / чернокурья"
  },
  "7936": {
    "id": "7936",
    "name": "Нарга",
    "path": "Россия / Томская область / Нарга",
    "country": "Россия",
    "searchString": "нарга россия / томская область / нарга"
  },
  "7937": {
    "id": "7937",
    "name": "Усть-Таловка",
    "path": "Россия / Алтайский край / Усть-Таловка",
    "country": "Россия",
    "searchString": "усть-таловка россия / алтайский край / усть-таловка"
  },
  "7938": {
    "id": "7938",
    "name": "Казаткуль",
    "path": "Россия / Новосибирская область / Казаткуль",
    "country": "Россия",
    "searchString": "казаткуль россия / новосибирская область / казаткуль"
  },
  "7939": {
    "id": "7939",
    "name": "Гришенское",
    "path": "Россия / Алтайский край / Гришенское",
    "country": "Россия",
    "searchString": "гришенское россия / алтайский край / гришенское"
  },
  "7940": {
    "id": "7940",
    "name": "Златополь",
    "path": "Россия / Алтайский край / Златополь",
    "country": "Россия",
    "searchString": "златополь россия / алтайский край / златополь"
  },
  "7941": {
    "id": "7941",
    "name": "Ужаниха",
    "path": "Россия / Новосибирская область / Ужаниха",
    "country": "Россия",
    "searchString": "ужаниха россия / новосибирская область / ужаниха"
  },
  "7942": {
    "id": "7942",
    "name": "Центрально-Любинский",
    "path": "Россия / Омская область / Центрально-Любинский",
    "country": "Россия",
    "searchString": "центрально-любинский россия / омская область / центрально-любинский"
  },
  "7943": {
    "id": "7943",
    "name": "Майское (Новосибирская область)",
    "path": "Россия / Новосибирская область / Майское (Новосибирская область)",
    "country": "Россия",
    "searchString": "майское (новосибирская область) россия / новосибирская область / майское (новосибирская область)"
  },
  "7944": {
    "id": "7944",
    "name": "Большегривский",
    "path": "Россия / Омская область / Большегривский",
    "country": "Россия",
    "searchString": "большегривский россия / омская область / большегривский"
  },
  "7945": {
    "id": "7945",
    "name": "Бурмистрово",
    "path": "Россия / Новосибирская область / Бурмистрово",
    "country": "Россия",
    "searchString": "бурмистрово россия / новосибирская область / бурмистрово"
  },
  "7946": {
    "id": "7946",
    "name": "Ганновка",
    "path": "Россия / Омская область / Ганновка",
    "country": "Россия",
    "searchString": "ганновка россия / омская область / ганновка"
  },
  "7947": {
    "id": "7947",
    "name": "Калинкино",
    "path": "Россия / Кемеровская область / Калинкино",
    "country": "Россия",
    "searchString": "калинкино россия / кемеровская область / калинкино"
  },
  "7948": {
    "id": "7948",
    "name": "Шимолино",
    "path": "Россия / Алтайский край / Шимолино",
    "country": "Россия",
    "searchString": "шимолино россия / алтайский край / шимолино"
  },
  "7949": {
    "id": "7949",
    "name": "Полуямки",
    "path": "Россия / Алтайский край / Полуямки",
    "country": "Россия",
    "searchString": "полуямки россия / алтайский край / полуямки"
  },
  "7950": {
    "id": "7950",
    "name": "Чернолучинский",
    "path": "Россия / Омская область / Чернолучинский",
    "country": "Россия",
    "searchString": "чернолучинский россия / омская область / чернолучинский"
  },
  "7951": {
    "id": "7951",
    "name": "Карпово Второе",
    "path": "Россия / Алтайский край / Карпово Второе",
    "country": "Россия",
    "searchString": "карпово второе россия / алтайский край / карпово второе"
  },
  "7952": {
    "id": "7952",
    "name": "Селекционное",
    "path": "Россия / Алтайский край / Селекционное",
    "country": "Россия",
    "searchString": "селекционное россия / алтайский край / селекционное"
  },
  "7953": {
    "id": "7953",
    "name": "Еланда",
    "path": "Россия / Алтайский край / Еланда",
    "country": "Россия",
    "searchString": "еланда россия / алтайский край / еланда"
  },
  "7954": {
    "id": "7954",
    "name": "Переясловка",
    "path": "Россия / Алтайский край / Переясловка",
    "country": "Россия",
    "searchString": "переясловка россия / алтайский край / переясловка"
  },
  "7955": {
    "id": "7955",
    "name": "Верх-Кучук",
    "path": "Россия / Алтайский край / Верх-Кучук",
    "country": "Россия",
    "searchString": "верх-кучук россия / алтайский край / верх-кучук"
  },
  "7956": {
    "id": "7956",
    "name": "Крутишка",
    "path": "Россия / Алтайский край / Крутишка",
    "country": "Россия",
    "searchString": "крутишка россия / алтайский край / крутишка"
  },
  "7957": {
    "id": "7957",
    "name": "Кусак",
    "path": "Россия / Алтайский край / Кусак",
    "country": "Россия",
    "searchString": "кусак россия / алтайский край / кусак"
  },
  "7958": {
    "id": "7958",
    "name": "Ракиты (Рубцовский район)",
    "path": "Россия / Алтайский край / Ракиты (Рубцовский район)",
    "country": "Россия",
    "searchString": "ракиты (рубцовский район) россия / алтайский край / ракиты (рубцовский район)"
  },
  "7959": {
    "id": "7959",
    "name": "Полойка",
    "path": "Россия / Новосибирская область / Полойка",
    "country": "Россия",
    "searchString": "полойка россия / новосибирская область / полойка"
  },
  "7960": {
    "id": "7960",
    "name": "Чистово",
    "path": "Россия / Омская область / Чистово",
    "country": "Россия",
    "searchString": "чистово россия / омская область / чистово"
  },
  "7961": {
    "id": "7961",
    "name": "Белосток",
    "path": "Россия / Омская область / Белосток",
    "country": "Россия",
    "searchString": "белосток россия / омская область / белосток"
  },
  "7962": {
    "id": "7962",
    "name": "Прииртышье",
    "path": "Россия / Омская область / Прииртышье",
    "country": "Россия",
    "searchString": "прииртышье россия / омская область / прииртышье"
  },
  "7963": {
    "id": "7963",
    "name": "Аксеново",
    "path": "Россия / Омская область / Аксеново",
    "country": "Россия",
    "searchString": "аксеново россия / омская область / аксеново"
  },
  "7964": {
    "id": "7964",
    "name": "Увальское",
    "path": "Россия / Новосибирская область / Увальское",
    "country": "Россия",
    "searchString": "увальское россия / новосибирская область / увальское"
  },
  "7965": {
    "id": "7965",
    "name": "Корболиха",
    "path": "Россия / Алтайский край / Корболиха",
    "country": "Россия",
    "searchString": "корболиха россия / алтайский край / корболиха"
  },
  "7966": {
    "id": "7966",
    "name": "Ремовский",
    "path": "Россия / Алтайский край / Ремовский",
    "country": "Россия",
    "searchString": "ремовский россия / алтайский край / ремовский"
  },
  "7967": {
    "id": "7967",
    "name": "Калинино (Омская область)",
    "path": "Россия / Омская область / Калинино (Омская область)",
    "country": "Россия",
    "searchString": "калинино (омская область) россия / омская область / калинино (омская область)"
  },
  "7968": {
    "id": "7968",
    "name": "Лянино",
    "path": "Россия / Новосибирская область / Лянино",
    "country": "Россия",
    "searchString": "лянино россия / новосибирская область / лянино"
  },
  "7969": {
    "id": "7969",
    "name": "Веселоярск",
    "path": "Россия / Алтайский край / Веселоярск",
    "country": "Россия",
    "searchString": "веселоярск россия / алтайский край / веселоярск"
  },
  "7970": {
    "id": "7970",
    "name": "Черемшанка (Алтайский край)",
    "path": "Россия / Алтайский край / Черемшанка (Алтайский край)",
    "country": "Россия",
    "searchString": "черемшанка (алтайский край) россия / алтайский край / черемшанка (алтайский край)"
  },
  "7971": {
    "id": "7971",
    "name": "Жуланка",
    "path": "Россия / Новосибирская область / Жуланка",
    "country": "Россия",
    "searchString": "жуланка россия / новосибирская область / жуланка"
  },
  "7972": {
    "id": "7972",
    "name": "Урлапово",
    "path": "Россия / Алтайский край / Урлапово",
    "country": "Россия",
    "searchString": "урлапово россия / алтайский край / урлапово"
  },
  "7973": {
    "id": "7973",
    "name": "Новостройка (Кемеровская область)",
    "path": "Россия / Кемеровская область / Новостройка (Кемеровская область)",
    "country": "Россия",
    "searchString": "новостройка (кемеровская область) россия / кемеровская область / новостройка (кемеровская область)"
  },
  "7974": {
    "id": "7974",
    "name": "Медяково",
    "path": "Россия / Новосибирская область / Медяково",
    "country": "Россия",
    "searchString": "медяково россия / новосибирская область / медяково"
  },
  "7975": {
    "id": "7975",
    "name": "Брусенцево",
    "path": "Россия / Алтайский край / Брусенцево",
    "country": "Россия",
    "searchString": "брусенцево россия / алтайский край / брусенцево"
  },
  "7976": {
    "id": "7976",
    "name": "Новополтава",
    "path": "Россия / Алтайский край / Новополтава",
    "country": "Россия",
    "searchString": "новополтава россия / алтайский край / новополтава"
  },
  "7977": {
    "id": "7977",
    "name": "Костенково",
    "path": "Россия / Кемеровская область / Костенково",
    "country": "Россия",
    "searchString": "костенково россия / кемеровская область / костенково"
  },
  "7978": {
    "id": "7978",
    "name": "Моховой Привал",
    "path": "Россия / Омская область / Моховой Привал",
    "country": "Россия",
    "searchString": "моховой привал россия / омская область / моховой привал"
  },
  "7979": {
    "id": "7979",
    "name": "Камышенка",
    "path": "Россия / Алтайский край / Камышенка",
    "country": "Россия",
    "searchString": "камышенка россия / алтайский край / камышенка"
  },
  "7980": {
    "id": "7980",
    "name": "Краснояры",
    "path": "Россия / Алтайский край / Краснояры",
    "country": "Россия",
    "searchString": "краснояры россия / алтайский край / краснояры"
  },
  "7981": {
    "id": "7981",
    "name": "Кубитет",
    "path": "Россия / Кемеровская область / Кубитет",
    "country": "Россия",
    "searchString": "кубитет россия / кемеровская область / кубитет"
  },
  "7982": {
    "id": "7982",
    "name": "Кожурла",
    "path": "Россия / Новосибирская область / Кожурла",
    "country": "Россия",
    "searchString": "кожурла россия / новосибирская область / кожурла"
  },
  "7983": {
    "id": "7983",
    "name": "Бобровка (Первомайский район)",
    "path": "Россия / Алтайский край / Бобровка (Первомайский район)",
    "country": "Россия",
    "searchString": "бобровка (первомайский район) россия / алтайский край / бобровка (первомайский район)"
  },
  "7984": {
    "id": "7984",
    "name": "Могильно-Посельское",
    "path": "Россия / Омская область / Могильно-Посельское",
    "country": "Россия",
    "searchString": "могильно-посельское россия / омская область / могильно-посельское"
  },
  "7985": {
    "id": "7985",
    "name": "Артын",
    "path": "Россия / Омская область / Артын",
    "country": "Россия",
    "searchString": "артын россия / омская область / артын"
  },
  "7986": {
    "id": "7986",
    "name": "Лукьяновка",
    "path": "Россия / Омская область / Лукьяновка",
    "country": "Россия",
    "searchString": "лукьяновка россия / омская область / лукьяновка"
  },
  "7987": {
    "id": "7987",
    "name": "Пихтовка",
    "path": "Россия / Новосибирская область / Пихтовка",
    "country": "Россия",
    "searchString": "пихтовка россия / новосибирская область / пихтовка"
  },
  "7988": {
    "id": "7988",
    "name": "Безрукавка",
    "path": "Россия / Алтайский край / Безрукавка",
    "country": "Россия",
    "searchString": "безрукавка россия / алтайский край / безрукавка"
  },
  "7989": {
    "id": "7989",
    "name": "Неверовка",
    "path": "Россия / Омская область / Неверовка",
    "country": "Россия",
    "searchString": "неверовка россия / омская область / неверовка"
  },
  "7990": {
    "id": "7990",
    "name": "Победитель",
    "path": "Россия / Омская область / Победитель",
    "country": "Россия",
    "searchString": "победитель россия / омская область / победитель"
  },
  "7991": {
    "id": "7991",
    "name": "Елыкаево",
    "path": "Россия / Кемеровская область / Елыкаево",
    "country": "Россия",
    "searchString": "елыкаево россия / кемеровская область / елыкаево"
  },
  "7992": {
    "id": "7992",
    "name": "Шахи",
    "path": "Россия / Алтайский край / Шахи",
    "country": "Россия",
    "searchString": "шахи россия / алтайский край / шахи"
  },
  "7993": {
    "id": "7993",
    "name": "Большеромановка",
    "path": "Россия / Алтайский край / Большеромановка",
    "country": "Россия",
    "searchString": "большеромановка россия / алтайский край / большеромановка"
  },
  "7994": {
    "id": "7994",
    "name": "Станция Арлюк",
    "path": "Россия / Кемеровская область / Станция Арлюк",
    "country": "Россия",
    "searchString": "станция арлюк россия / кемеровская область / станция арлюк"
  },
  "7995": {
    "id": "7995",
    "name": "Карамышево (Алтайский край)",
    "path": "Россия / Алтайский край / Карамышево (Алтайский край)",
    "country": "Россия",
    "searchString": "карамышево (алтайский край) россия / алтайский край / карамышево (алтайский край)"
  },
  "7996": {
    "id": "7996",
    "name": "Зубовка",
    "path": "Россия / Новосибирская область / Зубовка",
    "country": "Россия",
    "searchString": "зубовка россия / новосибирская область / зубовка"
  },
  "7997": {
    "id": "7997",
    "name": "Маралиха",
    "path": "Россия / Алтайский край / Маралиха",
    "country": "Россия",
    "searchString": "маралиха россия / алтайский край / маралиха"
  },
  "7998": {
    "id": "7998",
    "name": "Буян",
    "path": "Россия / Алтайский край / Буян",
    "country": "Россия",
    "searchString": "буян россия / алтайский край / буян"
  },
  "7999": {
    "id": "7999",
    "name": "Островное (Алтайский край)",
    "path": "Россия / Алтайский край / Островное (Алтайский край)",
    "country": "Россия",
    "searchString": "островное (алтайский край) россия / алтайский край / островное (алтайский край)"
  },
  "8000": {
    "id": "8000",
    "name": "Новая Шараповка",
    "path": "Россия / Омская область / Новая Шараповка",
    "country": "Россия",
    "searchString": "новая шараповка россия / омская область / новая шараповка"
  },
  "8001": {
    "id": "8001",
    "name": "Белоглазово",
    "path": "Россия / Алтайский край / Белоглазово",
    "country": "Россия",
    "searchString": "белоглазово россия / алтайский край / белоглазово"
  },
  "8002": {
    "id": "8002",
    "name": "Новобачаты",
    "path": "Россия / Кемеровская область / Новобачаты",
    "country": "Россия",
    "searchString": "новобачаты россия / кемеровская область / новобачаты"
  },
  "8003": {
    "id": "8003",
    "name": "Тарасово (Кемеровская область)",
    "path": "Россия / Кемеровская область / Тарасово (Кемеровская область)",
    "country": "Россия",
    "searchString": "тарасово (кемеровская область) россия / кемеровская область / тарасово (кемеровская область)"
  },
  "8004": {
    "id": "8004",
    "name": "Ярославцев Лог",
    "path": "Россия / Алтайский край / Ярославцев Лог",
    "country": "Россия",
    "searchString": "ярославцев лог россия / алтайский край / ярославцев лог"
  },
  "8005": {
    "id": "8005",
    "name": "Красные Орлы",
    "path": "Россия / Кемеровская область / Красные Орлы",
    "country": "Россия",
    "searchString": "красные орлы россия / кемеровская область / красные орлы"
  },
  "8006": {
    "id": "8006",
    "name": "Георгиевка (Омская область)",
    "path": "Россия / Омская область / Георгиевка (Омская область)",
    "country": "Россия",
    "searchString": "георгиевка (омская область) россия / омская область / георгиевка (омская область)"
  },
  "8007": {
    "id": "8007",
    "name": "Верх-Камышенка",
    "path": "Россия / Алтайский край / Верх-Камышенка",
    "country": "Россия",
    "searchString": "верх-камышенка россия / алтайский край / верх-камышенка"
  },
  "8008": {
    "id": "8008",
    "name": "Преображенка",
    "path": "Россия / Кемеровская область / Преображенка",
    "country": "Россия",
    "searchString": "преображенка россия / кемеровская область / преображенка"
  },
  "8009": {
    "id": "8009",
    "name": "Согорное",
    "path": "Россия / Новосибирская область / Согорное",
    "country": "Россия",
    "searchString": "согорное россия / новосибирская область / согорное"
  },
  "8010": {
    "id": "8010",
    "name": "Луговское",
    "path": "Россия / Алтайский край / Луговское",
    "country": "Россия",
    "searchString": "луговское россия / алтайский край / луговское"
  },
  "8011": {
    "id": "8011",
    "name": "Тамбовский",
    "path": "Россия / Алтайский край / Тамбовский",
    "country": "Россия",
    "searchString": "тамбовский россия / алтайский край / тамбовский"
  },
  "8012": {
    "id": "8012",
    "name": "Новокарасук",
    "path": "Россия / Омская область / Новокарасук",
    "country": "Россия",
    "searchString": "новокарасук россия / омская область / новокарасук"
  },
  "8013": {
    "id": "8013",
    "name": "Воеводское",
    "path": "Россия / Алтайский край / Воеводское",
    "country": "Россия",
    "searchString": "воеводское россия / алтайский край / воеводское"
  },
  "8014": {
    "id": "8014",
    "name": "Хорошее",
    "path": "Россия / Новосибирская область / Хорошее",
    "country": "Россия",
    "searchString": "хорошее россия / новосибирская область / хорошее"
  },
  "8015": {
    "id": "8015",
    "name": "Гилево",
    "path": "Россия / Алтайский край / Гилево",
    "country": "Россия",
    "searchString": "гилево россия / алтайский край / гилево"
  },
  "8016": {
    "id": "8016",
    "name": "ЗАТО Сибирский",
    "path": "Россия / Алтайский край / ЗАТО Сибирский",
    "country": "Россия",
    "searchString": "зато сибирский россия / алтайский край / зато сибирский"
  },
  "8017": {
    "id": "8017",
    "name": "Новокулундинка",
    "path": "Россия / Алтайский край / Новокулундинка",
    "country": "Россия",
    "searchString": "новокулундинка россия / алтайский край / новокулундинка"
  },
  "8018": {
    "id": "8018",
    "name": "Ворониха",
    "path": "Россия / Алтайский край / Ворониха",
    "country": "Россия",
    "searchString": "ворониха россия / алтайский край / ворониха"
  },
  "8019": {
    "id": "8019",
    "name": "Сорочий Лог",
    "path": "Россия / Алтайский край / Сорочий Лог",
    "country": "Россия",
    "searchString": "сорочий лог россия / алтайский край / сорочий лог"
  },
  "8020": {
    "id": "8020",
    "name": "Ачаир",
    "path": "Россия / Омская область / Ачаир",
    "country": "Россия",
    "searchString": "ачаир россия / омская область / ачаир"
  },
  "8021": {
    "id": "8021",
    "name": "Спирино",
    "path": "Россия / Новосибирская область / Спирино",
    "country": "Россия",
    "searchString": "спирино россия / новосибирская область / спирино"
  },
  "8022": {
    "id": "8022",
    "name": "Вылково",
    "path": "Россия / Алтайский край / Вылково",
    "country": "Россия",
    "searchString": "вылково россия / алтайский край / вылково"
  },
  "8023": {
    "id": "8023",
    "name": "Ирбизино",
    "path": "Россия / Новосибирская область / Ирбизино",
    "country": "Россия",
    "searchString": "ирбизино россия / новосибирская область / ирбизино"
  },
  "8024": {
    "id": "8024",
    "name": "Голуха",
    "path": "Россия / Алтайский край / Голуха",
    "country": "Россия",
    "searchString": "голуха россия / алтайский край / голуха"
  },
  "8025": {
    "id": "8025",
    "name": "Усть-Козлуха",
    "path": "Россия / Алтайский край / Усть-Козлуха",
    "country": "Россия",
    "searchString": "усть-козлуха россия / алтайский край / усть-козлуха"
  },
  "8026": {
    "id": "8026",
    "name": "Первокаменка",
    "path": "Россия / Алтайский край / Первокаменка",
    "country": "Россия",
    "searchString": "первокаменка россия / алтайский край / первокаменка"
  },
  "8027": {
    "id": "8027",
    "name": "Клочки",
    "path": "Россия / Алтайский край / Клочки",
    "country": "Россия",
    "searchString": "клочки россия / алтайский край / клочки"
  },
  "8028": {
    "id": "8028",
    "name": "Луговое",
    "path": "Россия / Омская область / Луговое",
    "country": "Россия",
    "searchString": "луговое россия / омская область / луговое"
  },
  "8029": {
    "id": "8029",
    "name": "Тугозвоново",
    "path": "Россия / Алтайский край / Тугозвоново",
    "country": "Россия",
    "searchString": "тугозвоново россия / алтайский край / тугозвоново"
  },
  "8030": {
    "id": "8030",
    "name": "Аллак",
    "path": "Россия / Алтайский край / Аллак",
    "country": "Россия",
    "searchString": "аллак россия / алтайский край / аллак"
  },
  "8031": {
    "id": "8031",
    "name": "Новообинка",
    "path": "Россия / Алтайский край / Новообинка",
    "country": "Россия",
    "searchString": "новообинка россия / алтайский край / новообинка"
  },
  "8032": {
    "id": "8032",
    "name": "Харитоново",
    "path": "Россия / Алтайский край / Харитоново",
    "country": "Россия",
    "searchString": "харитоново россия / алтайский край / харитоново"
  },
  "8033": {
    "id": "8033",
    "name": "Карабинка",
    "path": "Россия / Алтайский край / Карабинка",
    "country": "Россия",
    "searchString": "карабинка россия / алтайский край / карабинка"
  },
  "8034": {
    "id": "8034",
    "name": "Сидоровка",
    "path": "Россия / Алтайский край / Сидоровка",
    "country": "Россия",
    "searchString": "сидоровка россия / алтайский край / сидоровка"
  },
  "8035": {
    "id": "8035",
    "name": "Зимино",
    "path": "Россия / Алтайский край / Зимино",
    "country": "Россия",
    "searchString": "зимино россия / алтайский край / зимино"
  },
  "8036": {
    "id": "8036",
    "name": "Безголосово",
    "path": "Россия / Алтайский край / Безголосово",
    "country": "Россия",
    "searchString": "безголосово россия / алтайский край / безголосово"
  },
  "8037": {
    "id": "8037",
    "name": "Иртыш",
    "path": "Россия / Омская область / Иртыш",
    "country": "Россия",
    "searchString": "иртыш россия / омская область / иртыш"
  },
  "8038": {
    "id": "8038",
    "name": "Октябрьский (Алтайский край)",
    "path": "Россия / Алтайский край / Октябрьский (Алтайский край)",
    "country": "Россия",
    "searchString": "октябрьский (алтайский край) россия / алтайский край / октябрьский (алтайский край)"
  },
  "8039": {
    "id": "8039",
    "name": "Маргенау",
    "path": "Россия / Омская область / Маргенау",
    "country": "Россия",
    "searchString": "маргенау россия / омская область / маргенау"
  },
  "8040": {
    "id": "8040",
    "name": "Побочино",
    "path": "Россия / Омская область / Побочино",
    "country": "Россия",
    "searchString": "побочино россия / омская область / побочино"
  },
  "8041": {
    "id": "8041",
    "name": "Боровлянка",
    "path": "Россия / Алтайский край / Боровлянка",
    "country": "Россия",
    "searchString": "боровлянка россия / алтайский край / боровлянка"
  },
  "8042": {
    "id": "8042",
    "name": "Чингис",
    "path": "Россия / Новосибирская область / Чингис",
    "country": "Россия",
    "searchString": "чингис россия / новосибирская область / чингис"
  },
  "8043": {
    "id": "8043",
    "name": "Краснинское",
    "path": "Россия / Кемеровская область / Краснинское",
    "country": "Россия",
    "searchString": "краснинское россия / кемеровская область / краснинское"
  },
  "8044": {
    "id": "8044",
    "name": "Редкая Дубрава",
    "path": "Россия / Алтайский край / Редкая Дубрава",
    "country": "Россия",
    "searchString": "редкая дубрава россия / алтайский край / редкая дубрава"
  },
  "8045": {
    "id": "8045",
    "name": "Корнилово",
    "path": "Россия / Алтайский край / Корнилово",
    "country": "Россия",
    "searchString": "корнилово россия / алтайский край / корнилово"
  },
  "8046": {
    "id": "8046",
    "name": "Новоперуново",
    "path": "Россия / Алтайский край / Новоперуново",
    "country": "Россия",
    "searchString": "новоперуново россия / алтайский край / новоперуново"
  },
  "8047": {
    "id": "8047",
    "name": "Полевое",
    "path": "Россия / Алтайский край / Полевое",
    "country": "Россия",
    "searchString": "полевое россия / алтайский край / полевое"
  },
  "8048": {
    "id": "8048",
    "name": "Харлово",
    "path": "Россия / Алтайский край / Харлово",
    "country": "Россия",
    "searchString": "харлово россия / алтайский край / харлово"
  },
  "8049": {
    "id": "8049",
    "name": "Паутовка",
    "path": "Россия / Омская область / Паутовка",
    "country": "Россия",
    "searchString": "паутовка россия / омская область / паутовка"
  },
  "8050": {
    "id": "8050",
    "name": "Поломошное",
    "path": "Россия / Кемеровская область / Поломошное",
    "country": "Россия",
    "searchString": "поломошное россия / кемеровская область / поломошное"
  },
  "8051": {
    "id": "8051",
    "name": "Урожайное (Алтайский край)",
    "path": "Россия / Алтайский край / Урожайное (Алтайский край)",
    "country": "Россия",
    "searchString": "урожайное (алтайский край) россия / алтайский край / урожайное (алтайский край)"
  },
  "8052": {
    "id": "8052",
    "name": "Евтино",
    "path": "Россия / Кемеровская область / Евтино",
    "country": "Россия",
    "searchString": "евтино россия / кемеровская область / евтино"
  },
  "8053": {
    "id": "8053",
    "name": "Дегтярка",
    "path": "Россия / Алтайский край / Дегтярка",
    "country": "Россия",
    "searchString": "дегтярка россия / алтайский край / дегтярка"
  },
  "8054": {
    "id": "8054",
    "name": "Филиппово",
    "path": "Россия / Новосибирская область / Филиппово",
    "country": "Россия",
    "searchString": "филиппово россия / новосибирская область / филиппово"
  },
  "8055": {
    "id": "8055",
    "name": "Кабаново",
    "path": "Россия / Алтайский край / Кабаново",
    "country": "Россия",
    "searchString": "кабаново россия / алтайский край / кабаново"
  },
  "8056": {
    "id": "8056",
    "name": "Ивановка (Алтайский край)",
    "path": "Россия / Алтайский край / Ивановка (Алтайский край)",
    "country": "Россия",
    "searchString": "ивановка (алтайский край) россия / алтайский край / ивановка (алтайский край)"
  },
  "8057": {
    "id": "8057",
    "name": "Марушка",
    "path": "Россия / Алтайский край / Марушка",
    "country": "Россия",
    "searchString": "марушка россия / алтайский край / марушка"
  },
  "8058": {
    "id": "8058",
    "name": "Безменово",
    "path": "Россия / Новосибирская область / Безменово",
    "country": "Россия",
    "searchString": "безменово россия / новосибирская область / безменово"
  },
  "8059": {
    "id": "8059",
    "name": "Усть-Серта",
    "path": "Россия / Кемеровская область / Усть-Серта",
    "country": "Россия",
    "searchString": "усть-серта россия / кемеровская область / усть-серта"
  },
  "8060": {
    "id": "8060",
    "name": "Верх-Ануйское",
    "path": "Россия / Алтайский край / Верх-Ануйское",
    "country": "Россия",
    "searchString": "верх-ануйское россия / алтайский край / верх-ануйское"
  },
  "8061": {
    "id": "8061",
    "name": "Семеновка (Алтайский край)",
    "path": "Россия / Алтайский край / Семеновка (Алтайский край)",
    "country": "Россия",
    "searchString": "семеновка (алтайский край) россия / алтайский край / семеновка (алтайский край)"
  },
  "8062": {
    "id": "8062",
    "name": "Прутской",
    "path": "Россия / Алтайский край / Прутской",
    "country": "Россия",
    "searchString": "прутской россия / алтайский край / прутской"
  },
  "8063": {
    "id": "8063",
    "name": "Хлебороб",
    "path": "Россия / Алтайский край / Хлебороб",
    "country": "Россия",
    "searchString": "хлебороб россия / алтайский край / хлебороб"
  },
  "8064": {
    "id": "8064",
    "name": "Новиково",
    "path": "Россия / Алтайский край / Новиково",
    "country": "Россия",
    "searchString": "новиково россия / алтайский край / новиково"
  },
  "8065": {
    "id": "8065",
    "name": "Солоновка (Смоленский район)",
    "path": "Россия / Алтайский край / Солоновка (Смоленский район)",
    "country": "Россия",
    "searchString": "солоновка (смоленский район) россия / алтайский край / солоновка (смоленский район)"
  },
  "8066": {
    "id": "8066",
    "name": "Карасево",
    "path": "Россия / Новосибирская область / Карасево",
    "country": "Россия",
    "searchString": "карасево россия / новосибирская область / карасево"
  },
  "8067": {
    "id": "8067",
    "name": "Еремеевка",
    "path": "Россия / Омская область / Еремеевка",
    "country": "Россия",
    "searchString": "еремеевка россия / омская область / еремеевка"
  },
  "8068": {
    "id": "8068",
    "name": "Александровское (Омская область)",
    "path": "Россия / Омская область / Александровское (Омская область)",
    "country": "Россия",
    "searchString": "александровское (омская область) россия / омская область / александровское (омская область)"
  },
  "8069": {
    "id": "8069",
    "name": "Анисимово",
    "path": "Россия / Алтайский край / Анисимово",
    "country": "Россия",
    "searchString": "анисимово россия / алтайский край / анисимово"
  },
  "8070": {
    "id": "8070",
    "name": "Ольгино",
    "path": "Россия / Омская область / Ольгино",
    "country": "Россия",
    "searchString": "ольгино россия / омская область / ольгино"
  },
  "8071": {
    "id": "8071",
    "name": "Клепечиха",
    "path": "Россия / Алтайский край / Клепечиха",
    "country": "Россия",
    "searchString": "клепечиха россия / алтайский край / клепечиха"
  },
  "8072": {
    "id": "8072",
    "name": "Чкаловский",
    "path": "Россия / Кемеровская область / Чкаловский",
    "country": "Россия",
    "searchString": "чкаловский россия / кемеровская область / чкаловский"
  },
  "8073": {
    "id": "8073",
    "name": "Саввушка",
    "path": "Россия / Алтайский край / Саввушка",
    "country": "Россия",
    "searchString": "саввушка россия / алтайский край / саввушка"
  },
  "8074": {
    "id": "8074",
    "name": "Киик",
    "path": "Россия / Новосибирская область / Киик",
    "country": "Россия",
    "searchString": "киик россия / новосибирская область / киик"
  },
  "8075": {
    "id": "8075",
    "name": "Усть-Мосиха",
    "path": "Россия / Алтайский край / Усть-Мосиха",
    "country": "Россия",
    "searchString": "усть-мосиха россия / алтайский край / усть-мосиха"
  },
  "8076": {
    "id": "8076",
    "name": "Новоуральский",
    "path": "Россия / Омская область / Новоуральский",
    "country": "Россия",
    "searchString": "новоуральский россия / омская область / новоуральский"
  },
  "8077": {
    "id": "8077",
    "name": "Такмык",
    "path": "Россия / Омская область / Такмык",
    "country": "Россия",
    "searchString": "такмык россия / омская область / такмык"
  },
  "8078": {
    "id": "8078",
    "name": "Советский (Новосибирская область)",
    "path": "Россия / Новосибирская область / Советский (Новосибирская область)",
    "country": "Россия",
    "searchString": "советский (новосибирская область) россия / новосибирская область / советский (новосибирская область)"
  },
  "8079": {
    "id": "8079",
    "name": "Костин Лог",
    "path": "Россия / Алтайский край / Костин Лог",
    "country": "Россия",
    "searchString": "костин лог россия / алтайский край / костин лог"
  },
  "8080": {
    "id": "8080",
    "name": "Юргинский",
    "path": "Россия / Кемеровская область / Юргинский",
    "country": "Россия",
    "searchString": "юргинский россия / кемеровская область / юргинский"
  },
  "8081": {
    "id": "8081",
    "name": "Мирный (Зональный район)",
    "path": "Россия / Алтайский край / Мирный (Зональный район)",
    "country": "Россия",
    "searchString": "мирный (зональный район) россия / алтайский край / мирный (зональный район)"
  },
  "8082": {
    "id": "8082",
    "name": "Кутузовка",
    "path": "Россия / Омская область / Кутузовка",
    "country": "Россия",
    "searchString": "кутузовка россия / омская область / кутузовка"
  },
  "8083": {
    "id": "8083",
    "name": "Зеленый Дол",
    "path": "Россия / Алтайский край / Зеленый Дол",
    "country": "Россия",
    "searchString": "зеленый дол россия / алтайский край / зеленый дол"
  },
  "8084": {
    "id": "8084",
    "name": "Новообинцево",
    "path": "Россия / Алтайский край / Новообинцево",
    "country": "Россия",
    "searchString": "новообинцево россия / алтайский край / новообинцево"
  },
  "8085": {
    "id": "8085",
    "name": "Кокши",
    "path": "Россия / Алтайский край / Кокши",
    "country": "Россия",
    "searchString": "кокши россия / алтайский край / кокши"
  },
  "8086": {
    "id": "8086",
    "name": "Бакшеево",
    "path": "Россия / Омская область / Бакшеево",
    "country": "Россия",
    "searchString": "бакшеево россия / омская область / бакшеево"
  },
  "8087": {
    "id": "8087",
    "name": "Яготино",
    "path": "Россия / Алтайский край / Яготино",
    "country": "Россия",
    "searchString": "яготино россия / алтайский край / яготино"
  },
  "8088": {
    "id": "8088",
    "name": "Поселок Имени Мамонтова",
    "path": "Россия / Алтайский край / Поселок Имени Мамонтова",
    "country": "Россия",
    "searchString": "поселок имени мамонтова россия / алтайский край / поселок имени мамонтова"
  },
  "8089": {
    "id": "8089",
    "name": "Логовское",
    "path": "Россия / Алтайский край / Логовское",
    "country": "Россия",
    "searchString": "логовское россия / алтайский край / логовское"
  },
  "8090": {
    "id": "8090",
    "name": "Ермак",
    "path": "Россия / Омская область / Ермак",
    "country": "Россия",
    "searchString": "ермак россия / омская область / ермак"
  },
  "8091": {
    "id": "8091",
    "name": "Михайловка (Бурлинский район)",
    "path": "Россия / Алтайский край / Михайловка (Бурлинский район)",
    "country": "Россия",
    "searchString": "михайловка (бурлинский район) россия / алтайский край / михайловка (бурлинский район)"
  },
  "8092": {
    "id": "8092",
    "name": "Черная Курья",
    "path": "Россия / Алтайский край / Черная Курья",
    "country": "Россия",
    "searchString": "черная курья россия / алтайский край / черная курья"
  },
  "8093": {
    "id": "8093",
    "name": "Михайловка (Усть-Калманский район)",
    "path": "Россия / Алтайский край / Михайловка (Усть-Калманский район)",
    "country": "Россия",
    "searchString": "михайловка (усть-калманский район) россия / алтайский край / михайловка (усть-калманский район)"
  },
  "8094": {
    "id": "8094",
    "name": "Березиково",
    "path": "Россия / Новосибирская область / Березиково",
    "country": "Россия",
    "searchString": "березиково россия / новосибирская область / березиково"
  },
  "8095": {
    "id": "8095",
    "name": "Новороманово",
    "path": "Россия / Алтайский край / Новороманово",
    "country": "Россия",
    "searchString": "новороманово россия / алтайский край / новороманово"
  },
  "8096": {
    "id": "8096",
    "name": "Никитинский",
    "path": "Россия / Кемеровская область / Никитинский",
    "country": "Россия",
    "searchString": "никитинский россия / кемеровская область / никитинский"
  },
  "8097": {
    "id": "8097",
    "name": "Тимирязевское",
    "path": "Россия / Томская область / Тимирязевское",
    "country": "Россия",
    "searchString": "тимирязевское россия / томская область / тимирязевское"
  },
  "8098": {
    "id": "8098",
    "name": "Нижне-Чуманка",
    "path": "Россия / Алтайский край / Нижне-Чуманка",
    "country": "Россия",
    "searchString": "нижне-чуманка россия / алтайский край / нижне-чуманка"
  },
  "8099": {
    "id": "8099",
    "name": "Калмыцкие Мысы",
    "path": "Россия / Алтайский край / Калмыцкие Мысы",
    "country": "Россия",
    "searchString": "калмыцкие мысы россия / алтайский край / калмыцкие мысы"
  },
  "8100": {
    "id": "8100",
    "name": "Шумилиха",
    "path": "Россия / Алтайский край / Шумилиха",
    "country": "Россия",
    "searchString": "шумилиха россия / алтайский край / шумилиха"
  },
  "8101": {
    "id": "8101",
    "name": "Колычево",
    "path": "Россия / Кемеровская область / Колычево",
    "country": "Россия",
    "searchString": "колычево россия / кемеровская область / колычево"
  },
  "8102": {
    "id": "8102",
    "name": "Большой Атмас",
    "path": "Россия / Омская область / Большой Атмас",
    "country": "Россия",
    "searchString": "большой атмас россия / омская область / большой атмас"
  },
  "8103": {
    "id": "8103",
    "name": "Медвежье",
    "path": "Россия / Омская область / Медвежье",
    "country": "Россия",
    "searchString": "медвежье россия / омская область / медвежье"
  },
  "8104": {
    "id": "8104",
    "name": "Соловьевка",
    "path": "Россия / Омская область / Соловьевка",
    "country": "Россия",
    "searchString": "соловьевка россия / омская область / соловьевка"
  },
  "8105": {
    "id": "8105",
    "name": "Новопесчаное",
    "path": "Россия / Алтайский край / Новопесчаное",
    "country": "Россия",
    "searchString": "новопесчаное россия / алтайский край / новопесчаное"
  },
  "8106": {
    "id": "8106",
    "name": "Малопесчанка",
    "path": "Россия / Кемеровская область / Малопесчанка",
    "country": "Россия",
    "searchString": "малопесчанка россия / кемеровская область / малопесчанка"
  },
  "8107": {
    "id": "8107",
    "name": "Кашино (Алтайский край)",
    "path": "Россия / Алтайский край / Кашино (Алтайский край)",
    "country": "Россия",
    "searchString": "кашино (алтайский край) россия / алтайский край / кашино (алтайский край)"
  },
  "8108": {
    "id": "8108",
    "name": "Цветочное",
    "path": "Россия / Омская область / Цветочное",
    "country": "Россия",
    "searchString": "цветочное россия / омская область / цветочное"
  },
  "8109": {
    "id": "8109",
    "name": "Нижне-Озерное",
    "path": "Россия / Алтайский край / Нижне-Озерное",
    "country": "Россия",
    "searchString": "нижне-озерное россия / алтайский край / нижне-озерное"
  },
  "8110": {
    "id": "8110",
    "name": "Иогач",
    "path": "Россия / Республика Алтай / Иогач",
    "country": "Россия",
    "searchString": "иогач россия / республика алтай / иогач"
  },
  "8111": {
    "id": "8111",
    "name": "Ларичиха",
    "path": "Россия / Алтайский край / Ларичиха",
    "country": "Россия",
    "searchString": "ларичиха россия / алтайский край / ларичиха"
  },
  "8112": {
    "id": "8112",
    "name": "Черга",
    "path": "Россия / Республика Алтай / Черга",
    "country": "Россия",
    "searchString": "черга россия / республика алтай / черга"
  },
  "8113": {
    "id": "8113",
    "name": "Черемушкино",
    "path": "Россия / Алтайский край / Черемушкино",
    "country": "Россия",
    "searchString": "черемушкино россия / алтайский край / черемушкино"
  },
  "8114": {
    "id": "8114",
    "name": "Белое (Новосибирская область)",
    "path": "Россия / Новосибирская область / Белое (Новосибирская область)",
    "country": "Россия",
    "searchString": "белое (новосибирская область) россия / новосибирская область / белое (новосибирская область)"
  },
  "8115": {
    "id": "8115",
    "name": "Стуково",
    "path": "Россия / Алтайский край / Стуково",
    "country": "Россия",
    "searchString": "стуково россия / алтайский край / стуково"
  },
  "8116": {
    "id": "8116",
    "name": "Сухое",
    "path": "Россия / Омская область / Сухое",
    "country": "Россия",
    "searchString": "сухое россия / омская область / сухое"
  },
  "8117": {
    "id": "8117",
    "name": "Палецкое",
    "path": "Россия / Новосибирская область / Палецкое",
    "country": "Россия",
    "searchString": "палецкое россия / новосибирская область / палецкое"
  },
  "8118": {
    "id": "8118",
    "name": "Пришиб",
    "path": "Россия / Омская область / Пришиб",
    "country": "Россия",
    "searchString": "пришиб россия / омская область / пришиб"
  },
  "8119": {
    "id": "8119",
    "name": "Елизаветинка",
    "path": "Россия / Омская область / Елизаветинка",
    "country": "Россия",
    "searchString": "елизаветинка россия / омская область / елизаветинка"
  },
  "8120": {
    "id": "8120",
    "name": "Баженово",
    "path": "Россия / Омская область / Баженово",
    "country": "Россия",
    "searchString": "баженово россия / омская область / баженово"
  },
  "8121": {
    "id": "8121",
    "name": "Хортицы",
    "path": "Россия / Омская область / Хортицы",
    "country": "Россия",
    "searchString": "хортицы россия / омская область / хортицы"
  },
  "8122": {
    "id": "8122",
    "name": "Старомалиновка",
    "path": "Россия / Омская область / Старомалиновка",
    "country": "Россия",
    "searchString": "старомалиновка россия / омская область / старомалиновка"
  },
  "8123": {
    "id": "8123",
    "name": "Мышланка",
    "path": "Россия / Новосибирская область / Мышланка",
    "country": "Россия",
    "searchString": "мышланка россия / новосибирская область / мышланка"
  },
  "8124": {
    "id": "8124",
    "name": "Суслово",
    "path": "Россия / Алтайский край / Суслово",
    "country": "Россия",
    "searchString": "суслово россия / алтайский край / суслово"
  },
  "8125": {
    "id": "8125",
    "name": "Ваганово",
    "path": "Россия / Кемеровская область / Ваганово",
    "country": "Россия",
    "searchString": "ваганово россия / кемеровская область / ваганово"
  },
  "8126": {
    "id": "8126",
    "name": "Новопичугово",
    "path": "Россия / Новосибирская область / Новопичугово",
    "country": "Россия",
    "searchString": "новопичугово россия / новосибирская область / новопичугово"
  },
  "8127": {
    "id": "8127",
    "name": "Среднесибирский",
    "path": "Россия / Алтайский край / Среднесибирский",
    "country": "Россия",
    "searchString": "среднесибирский россия / алтайский край / среднесибирский"
  },
  "8128": {
    "id": "8128",
    "name": "Улыбино",
    "path": "Россия / Новосибирская область / Улыбино",
    "country": "Россия",
    "searchString": "улыбино россия / новосибирская область / улыбино"
  },
  "8129": {
    "id": "8129",
    "name": "Мохово",
    "path": "Россия / Кемеровская область / Мохово",
    "country": "Россия",
    "searchString": "мохово россия / кемеровская область / мохово"
  },
  "8130": {
    "id": "8130",
    "name": "Кузьминка",
    "path": "Россия / Алтайский край / Кузьминка",
    "country": "Россия",
    "searchString": "кузьминка россия / алтайский край / кузьминка"
  },
  "8131": {
    "id": "8131",
    "name": "Буготак",
    "path": "Россия / Новосибирская область / Буготак",
    "country": "Россия",
    "searchString": "буготак россия / новосибирская область / буготак"
  },
  "8132": {
    "id": "8132",
    "name": "Огни",
    "path": "Россия / Алтайский край / Огни",
    "country": "Россия",
    "searchString": "огни россия / алтайский край / огни"
  },
  "8133": {
    "id": "8133",
    "name": "Вознесенка",
    "path": "Россия / Новосибирская область / Вознесенка",
    "country": "Россия",
    "searchString": "вознесенка россия / новосибирская область / вознесенка"
  },
  "8134": {
    "id": "8134",
    "name": "Пикетное",
    "path": "Россия / Омская область / Пикетное",
    "country": "Россия",
    "searchString": "пикетное россия / омская область / пикетное"
  },
  "8135": {
    "id": "8135",
    "name": "Протасово",
    "path": "Россия / Алтайский край / Протасово",
    "country": "Россия",
    "searchString": "протасово россия / алтайский край / протасово"
  },
  "8136": {
    "id": "8136",
    "name": "Крестьянка",
    "path": "Россия / Алтайский край / Крестьянка",
    "country": "Россия",
    "searchString": "крестьянка россия / алтайский край / крестьянка"
  },
  "8137": {
    "id": "8137",
    "name": "Красный Партизан",
    "path": "Россия / Алтайский край / Красный Партизан",
    "country": "Россия",
    "searchString": "красный партизан россия / алтайский край / красный партизан"
  },
  "8138": {
    "id": "8138",
    "name": "Соляное",
    "path": "Россия / Омская область / Соляное",
    "country": "Россия",
    "searchString": "соляное россия / омская область / соляное"
  },
  "8139": {
    "id": "8139",
    "name": "Кабаково (Алтайский край)",
    "path": "Россия / Алтайский край / Кабаково (Алтайский край)",
    "country": "Россия",
    "searchString": "кабаково (алтайский край) россия / алтайский край / кабаково (алтайский край)"
  },
  "8140": {
    "id": "8140",
    "name": "Коробейниково",
    "path": "Россия / Алтайский край / Коробейниково",
    "country": "Россия",
    "searchString": "коробейниково россия / алтайский край / коробейниково"
  },
  "8141": {
    "id": "8141",
    "name": "Гальбштадт",
    "path": "Россия / Алтайский край / Гальбштадт",
    "country": "Россия",
    "searchString": "гальбштадт россия / алтайский край / гальбштадт"
  },
  "8142": {
    "id": "8142",
    "name": "Репинка",
    "path": "Россия / Омская область / Репинка",
    "country": "Россия",
    "searchString": "репинка россия / омская область / репинка"
  },
  "8143": {
    "id": "8143",
    "name": "Масальский",
    "path": "Россия / Алтайский край / Масальский",
    "country": "Россия",
    "searchString": "масальский россия / алтайский край / масальский"
  },
  "8144": {
    "id": "8144",
    "name": "Марьяновский",
    "path": "Россия / Омская область / Марьяновский",
    "country": "Россия",
    "searchString": "марьяновский россия / омская область / марьяновский"
  },
  "8145": {
    "id": "8145",
    "name": "Петропавловка 2-я",
    "path": "Россия / Новосибирская область / Петропавловка 2-я",
    "country": "Россия",
    "searchString": "петропавловка 2-я россия / новосибирская область / петропавловка 2-я"
  },
  "8146": {
    "id": "8146",
    "name": "Заковряшино",
    "path": "Россия / Алтайский край / Заковряшино",
    "country": "Россия",
    "searchString": "заковряшино россия / алтайский край / заковряшино"
  },
  "8147": {
    "id": "8147",
    "name": "Плешково",
    "path": "Россия / Алтайский край / Плешково",
    "country": "Россия",
    "searchString": "плешково россия / алтайский край / плешково"
  },
  "8148": {
    "id": "8148",
    "name": "Добровольск",
    "path": "Россия / Омская область / Добровольск",
    "country": "Россия",
    "searchString": "добровольск россия / омская область / добровольск"
  },
  "8149": {
    "id": "8149",
    "name": "Буланиха",
    "path": "Россия / Алтайский край / Буланиха",
    "country": "Россия",
    "searchString": "буланиха россия / алтайский край / буланиха"
  },
  "8150": {
    "id": "8150",
    "name": "Пашково",
    "path": "Россия / Кемеровская область / Пашково",
    "country": "Россия",
    "searchString": "пашково россия / кемеровская область / пашково"
  },
  "8151": {
    "id": "8151",
    "name": "Лаптев Лог",
    "path": "Россия / Алтайский край / Лаптев Лог",
    "country": "Россия",
    "searchString": "лаптев лог россия / алтайский край / лаптев лог"
  },
  "8152": {
    "id": "8152",
    "name": "Зайцево",
    "path": "Россия / Алтайский край / Зайцево",
    "country": "Россия",
    "searchString": "зайцево россия / алтайский край / зайцево"
  },
  "8153": {
    "id": "8153",
    "name": "Комарье",
    "path": "Россия / Новосибирская область / Комарье",
    "country": "Россия",
    "searchString": "комарье россия / новосибирская область / комарье"
  },
  "8154": {
    "id": "8154",
    "name": "Тамбар",
    "path": "Россия / Кемеровская область / Тамбар",
    "country": "Россия",
    "searchString": "тамбар россия / кемеровская область / тамбар"
  },
  "8155": {
    "id": "8155",
    "name": "Малый Бащелак",
    "path": "Россия / Алтайский край / Малый Бащелак",
    "country": "Россия",
    "searchString": "малый бащелак россия / алтайский край / малый бащелак"
  },
  "8156": {
    "id": "8156",
    "name": "Кадниково",
    "path": "Россия / Алтайский край / Кадниково",
    "country": "Россия",
    "searchString": "кадниково россия / алтайский край / кадниково"
  },
  "8157": {
    "id": "8157",
    "name": "Бураново",
    "path": "Россия / Алтайский край / Бураново",
    "country": "Россия",
    "searchString": "бураново россия / алтайский край / бураново"
  },
  "8158": {
    "id": "8158",
    "name": "Гришковка",
    "path": "Россия / Алтайский край / Гришковка",
    "country": "Россия",
    "searchString": "гришковка россия / алтайский край / гришковка"
  },
  "8159": {
    "id": "8159",
    "name": "Жилино",
    "path": "Россия / Алтайский край / Жилино",
    "country": "Россия",
    "searchString": "жилино россия / алтайский край / жилино"
  },
  "8160": {
    "id": "8160",
    "name": "Осколково",
    "path": "Россия / Алтайский край / Осколково",
    "country": "Россия",
    "searchString": "осколково россия / алтайский край / осколково"
  },
  "8161": {
    "id": "8161",
    "name": "Комсомольск (Томская область)",
    "path": "Россия / Томская область / Комсомольск (Томская область)",
    "country": "Россия",
    "searchString": "комсомольск (томская область) россия / томская область / комсомольск (томская область)"
  },
  "8162": {
    "id": "8162",
    "name": "Верх-Чик",
    "path": "Россия / Новосибирская область / Верх-Чик",
    "country": "Россия",
    "searchString": "верх-чик россия / новосибирская область / верх-чик"
  },
  "8163": {
    "id": "8163",
    "name": "Енисейское",
    "path": "Россия / Алтайский край / Енисейское",
    "country": "Россия",
    "searchString": "енисейское россия / алтайский край / енисейское"
  },
  "8164": {
    "id": "8164",
    "name": "Москаленский",
    "path": "Россия / Омская область / Москаленский",
    "country": "Россия",
    "searchString": "москаленский россия / омская область / москаленский"
  },
  "8165": {
    "id": "8165",
    "name": "Гонохово (Каменский район)",
    "path": "Россия / Алтайский край / Гонохово (Каменский район)",
    "country": "Россия",
    "searchString": "гонохово (каменский район) россия / алтайский край / гонохово (каменский район)"
  },
  "8166": {
    "id": "8166",
    "name": "Мирный (Родинский район)",
    "path": "Россия / Алтайский край / Мирный (Родинский район)",
    "country": "Россия",
    "searchString": "мирный (родинский район) россия / алтайский край / мирный (родинский район)"
  },
  "8167": {
    "id": "8167",
    "name": "Красноселье",
    "path": "Россия / Новосибирская область / Красноселье",
    "country": "Россия",
    "searchString": "красноселье россия / новосибирская область / красноселье"
  },
  "8168": {
    "id": "8168",
    "name": "Краснознаменка",
    "path": "Россия / Алтайский край / Краснознаменка",
    "country": "Россия",
    "searchString": "краснознаменка россия / алтайский край / краснознаменка"
  },
  "8169": {
    "id": "8169",
    "name": "Урюпино",
    "path": "Россия / Алтайский край / Урюпино",
    "country": "Россия",
    "searchString": "урюпино россия / алтайский край / урюпино"
  },
  "8170": {
    "id": "8170",
    "name": "Станция Озерки (Тальменский район)",
    "path": "Россия / Алтайский край / Станция Озерки (Тальменский район)",
    "country": "Россия",
    "searchString": "станция озерки (тальменский район) россия / алтайский край / станция озерки (тальменский район)"
  },
  "8171": {
    "id": "8171",
    "name": "Комсомольск (Кемеровская область)",
    "path": "Россия / Кемеровская область / Комсомольск (Кемеровская область)",
    "country": "Россия",
    "searchString": "комсомольск (кемеровская область) россия / кемеровская область / комсомольск (кемеровская область)"
  },
  "8172": {
    "id": "8172",
    "name": "Самсоново",
    "path": "Россия / Алтайский край / Самсоново",
    "country": "Россия",
    "searchString": "самсоново россия / алтайский край / самсоново"
  },
  "8173": {
    "id": "8173",
    "name": "Екатерининское",
    "path": "Россия / Алтайский край / Екатерининское",
    "country": "Россия",
    "searchString": "екатерининское россия / алтайский край / екатерининское"
  },
  "8174": {
    "id": "8174",
    "name": "Сетовка",
    "path": "Россия / Алтайский край / Сетовка",
    "country": "Россия",
    "searchString": "сетовка россия / алтайский край / сетовка"
  },
  "8175": {
    "id": "8175",
    "name": "Ивановка (Омская область)",
    "path": "Россия / Омская область / Ивановка (Омская область)",
    "country": "Россия",
    "searchString": "ивановка (омская область) россия / омская область / ивановка (омская область)"
  },
  "8176": {
    "id": "8176",
    "name": "Новошипуново",
    "path": "Россия / Алтайский край / Новошипуново",
    "country": "Россия",
    "searchString": "новошипуново россия / алтайский край / новошипуново"
  },
  "8177": {
    "id": "8177",
    "name": "Нижняя Суетка",
    "path": "Россия / Алтайский край / Нижняя Суетка",
    "country": "Россия",
    "searchString": "нижняя суетка россия / алтайский край / нижняя суетка"
  },
  "8178": {
    "id": "8178",
    "name": "Благодаровка",
    "path": "Россия / Омская область / Благодаровка",
    "country": "Россия",
    "searchString": "благодаровка россия / омская область / благодаровка"
  },
  "8179": {
    "id": "8179",
    "name": "Горшково (Московская область)",
    "path": "Россия / Московская область / Горшково (Московская область)",
    "country": "Россия",
    "searchString": "горшково (московская область) россия / московская область / горшково (московская область)"
  },
  "8180": {
    "id": "8180",
    "name": "Воздвиженское (Московская область)",
    "path": "Россия / Московская область / Воздвиженское (Московская область)",
    "country": "Россия",
    "searchString": "воздвиженское (московская область) россия / московская область / воздвиженское (московская область)"
  },
  "8181": {
    "id": "8181",
    "name": "Астапово (Московская область)",
    "path": "Россия / Московская область / Астапово (Московская область)",
    "country": "Россия",
    "searchString": "астапово (московская область) россия / московская область / астапово (московская область)"
  },
  "8182": {
    "id": "8182",
    "name": "Зарудня (Московская область)",
    "path": "Россия / Московская область / Зарудня (Московская область)",
    "country": "Россия",
    "searchString": "зарудня (московская область) россия / московская область / зарудня (московская область)"
  },
  "8183": {
    "id": "8183",
    "name": "Летний отдых (Московская область)",
    "path": "Россия / Московская область / Летний отдых (Московская область)",
    "country": "Россия",
    "searchString": "летний отдых (московская область) россия / московская область / летний отдых (московская область)"
  },
  "8184": {
    "id": "8184",
    "name": "Колюбакино (Московская область)",
    "path": "Россия / Московская область / Колюбакино (Московская область)",
    "country": "Россия",
    "searchString": "колюбакино (московская область) россия / московская область / колюбакино (московская область)"
  },
  "8185": {
    "id": "8185",
    "name": "Красная Пойма (Московская область)",
    "path": "Россия / Московская область / Красная Пойма (Московская область)",
    "country": "Россия",
    "searchString": "красная пойма (московская область) россия / московская область / красная пойма (московская область)"
  },
  "8186": {
    "id": "8186",
    "name": "Новоклемово (Московская область)",
    "path": "Россия / Московская область / Новоклемово (Московская область)",
    "country": "Россия",
    "searchString": "новоклемово (московская область) россия / московская область / новоклемово (московская область)"
  },
  "8187": {
    "id": "8187",
    "name": "Колычево (Московская область)",
    "path": "Россия / Московская область / Колычево (Московская область)",
    "country": "Россия",
    "searchString": "колычево (московская область) россия / московская область / колычево (московская область)"
  },
  "8188": {
    "id": "8188",
    "name": "Яковлевское (Московская область)",
    "path": "Россия / Московская область / Яковлевское (Московская область)",
    "country": "Россия",
    "searchString": "яковлевское (московская область) россия / московская область / яковлевское (московская область)"
  },
  "8189": {
    "id": "8189",
    "name": "Саввино (Московская область)",
    "path": "Россия / Московская область / Саввино (Московская область)",
    "country": "Россия",
    "searchString": "саввино (московская область) россия / московская область / саввино (московская область)"
  },
  "8190": {
    "id": "8190",
    "name": "Алпатьево (Московская область)",
    "path": "Россия / Московская область / Алпатьево (Московская область)",
    "country": "Россия",
    "searchString": "алпатьево (московская область) россия / московская область / алпатьево (московская область)"
  },
  "8191": {
    "id": "8191",
    "name": "Внуковское (Московская область)",
    "path": "Россия / Московская область / Внуковское (Московская область)",
    "country": "Россия",
    "searchString": "внуковское (московская область) россия / московская область / внуковское (московская область)"
  },
  "8192": {
    "id": "8192",
    "name": "Каринское (Московская область)",
    "path": "Россия / Московская область / Каринское (Московская область)",
    "country": "Россия",
    "searchString": "каринское (московская область) россия / московская область / каринское (московская область)"
  },
  "8193": {
    "id": "8193",
    "name": "Нестерово (Московская область)",
    "path": "Россия / Московская область / Нестерово (Московская область)",
    "country": "Россия",
    "searchString": "нестерово (московская область) россия / московская область / нестерово (московская область)"
  },
  "8194": {
    "id": "8194",
    "name": "Нарынка (Московская область)",
    "path": "Россия / Московская область / Нарынка (Московская область)",
    "country": "Россия",
    "searchString": "нарынка (московская область) россия / московская область / нарынка (московская область)"
  },
  "8195": {
    "id": "8195",
    "name": "Нижне-Маслово (Московская область)",
    "path": "Россия / Московская область / Нижне-Маслово (Московская область)",
    "country": "Россия",
    "searchString": "нижне-маслово (московская область) россия / московская область / нижне-маслово (московская область)"
  },
  "8196": {
    "id": "8196",
    "name": "Поселок им.Цюрупы (Московская область)",
    "path": "Россия / Московская область / Поселок им.Цюрупы (Московская область)",
    "country": "Россия",
    "searchString": "поселок им.цюрупы (московская область) россия / московская область / поселок им.цюрупы (московская область)"
  },
  "8197": {
    "id": "8197",
    "name": "Рязановский (Московская область)",
    "path": "Россия / Московская область / Рязановский (Московская область)",
    "country": "Россия",
    "searchString": "рязановский (московская область) россия / московская область / рязановский (московская область)"
  },
  "8198": {
    "id": "8198",
    "name": "Сергиевский (Московская область)",
    "path": "Россия / Московская область / Сергиевский (Московская область)",
    "country": "Россия",
    "searchString": "сергиевский (московская область) россия / московская область / сергиевский (московская область)"
  },
  "8199": {
    "id": "8199",
    "name": "Цветковский (Московская область)",
    "path": "Россия / Московская область / Цветковский (Московская область)",
    "country": "Россия",
    "searchString": "цветковский (московская область) россия / московская область / цветковский (московская область)"
  },
  "8200": {
    "id": "8200",
    "name": "Сычево (Московская область)",
    "path": "Россия / Московская область / Сычево (Московская область)",
    "country": "Россия",
    "searchString": "сычево (московская область) россия / московская область / сычево (московская область)"
  },
  "8201": {
    "id": "8201",
    "name": "Измайлово (Московская область)",
    "path": "Россия / Московская область / Измайлово (Московская область)",
    "country": "Россия",
    "searchString": "измайлово (московская область) россия / московская область / измайлово (московская область)"
  },
  "8202": {
    "id": "8202",
    "name": "Узуново (Московская область)",
    "path": "Россия / Московская область / Узуново (Московская область)",
    "country": "Россия",
    "searchString": "узуново (московская область) россия / московская область / узуново (московская область)"
  },
  "8203": {
    "id": "8203",
    "name": "Подосинки (Московская область)",
    "path": "Россия / Московская область / Подосинки (Московская область)",
    "country": "Россия",
    "searchString": "подосинки (московская область) россия / московская область / подосинки (московская область)"
  },
  "8204": {
    "id": "8204",
    "name": "Ржавки (Московская область)",
    "path": "Россия / Московская область / Ржавки (Московская область)",
    "country": "Россия",
    "searchString": "ржавки (московская область) россия / московская область / ржавки (московская область)"
  },
  "8205": {
    "id": "8205",
    "name": "Орево (Московская область)",
    "path": "Россия / Московская область / Орево (Московская область)",
    "country": "Россия",
    "searchString": "орево (московская область) россия / московская область / орево (московская область)"
  },
  "8206": {
    "id": "8206",
    "name": "Поваровка (Московская область)",
    "path": "Россия / Московская область / Поваровка (Московская область)",
    "country": "Россия",
    "searchString": "поваровка (московская область) россия / московская область / поваровка (московская область)"
  },
  "8207": {
    "id": "8207",
    "name": "Дединово (Московская область)",
    "path": "Россия / Московская область / Дединово (Московская область)",
    "country": "Россия",
    "searchString": "дединово (московская область) россия / московская область / дединово (московская область)"
  },
  "8208": {
    "id": "8208",
    "name": "Сосенское (Московская область)",
    "path": "Россия / Московская область / Сосенское (Московская область)",
    "country": "Россия",
    "searchString": "сосенское (московская область) россия / московская область / сосенское (московская область)"
  },
  "8209": {
    "id": "8209",
    "name": "Теряево (Московская область)",
    "path": "Россия / Московская область / Теряево (Московская область)",
    "country": "Россия",
    "searchString": "теряево (московская область) россия / московская область / теряево (московская область)"
  },
  "8210": {
    "id": "8210",
    "name": "Фруктовая (Московская область)",
    "path": "Россия / Московская область / Фруктовая (Московская область)",
    "country": "Россия",
    "searchString": "фруктовая (московская область) россия / московская область / фруктовая (московская область)"
  },
  "8211": {
    "id": "8211",
    "name": "Григорьевское (Московская область)",
    "path": "Россия / Московская область / Григорьевское (Московская область)",
    "country": "Россия",
    "searchString": "григорьевское (московская область) россия / московская область / григорьевское (московская область)"
  },
  "8212": {
    "id": "8212",
    "name": "Красное (Московская область)",
    "path": "Россия / Московская область / Красное (Московская область)",
    "country": "Россия",
    "searchString": "красное (московская область) россия / московская область / красное (московская область)"
  },
  "8213": {
    "id": "8213",
    "name": "Микулино (Московская область)",
    "path": "Россия / Московская область / Микулино (Московская область)",
    "country": "Россия",
    "searchString": "микулино (московская область) россия / московская область / микулино (московская область)"
  },
  "8214": {
    "id": "8214",
    "name": "Трехгорка (Московская область)",
    "path": "Россия / Московская область / Трехгорка (Московская область)",
    "country": "Россия",
    "searchString": "трехгорка (московская область) россия / московская область / трехгорка (московская область)"
  },
  "8215": {
    "id": "8215",
    "name": "Володарского (Московская область)",
    "path": "Россия / Московская область / Володарского (Московская область)",
    "country": "Россия",
    "searchString": "володарского (московская область) россия / московская область / володарского (московская область)"
  },
  "8216": {
    "id": "8216",
    "name": "Новое Гришино (Московская область)",
    "path": "Россия / Московская область / Новое Гришино (Московская область)",
    "country": "Россия",
    "searchString": "новое гришино (московская область) россия / московская область / новое гришино (московская область)"
  },
  "8217": {
    "id": "8217",
    "name": "Любучаны (Московская область)",
    "path": "Россия / Московская область / Любучаны (Московская область)",
    "country": "Россия",
    "searchString": "любучаны (московская область) россия / московская область / любучаны (московская область)"
  },
  "8218": {
    "id": "8218",
    "name": "Скуратово (Московская область)",
    "path": "Россия / Московская область / Скуратово (Московская область)",
    "country": "Россия",
    "searchString": "скуратово (московская область) россия / московская область / скуратово (московская область)"
  },
  "8219": {
    "id": "8219",
    "name": "Шевляково (Московская область)",
    "path": "Россия / Московская область / Шевляково (Московская область)",
    "country": "Россия",
    "searchString": "шевляково (московская область) россия / московская область / шевляково (московская область)"
  },
  "8220": {
    "id": "8220",
    "name": "Алфимово (Московская область)",
    "path": "Россия / Московская область / Алфимово (Московская область)",
    "country": "Россия",
    "searchString": "алфимово (московская область) россия / московская область / алфимово (московская область)"
  },
  "8221": {
    "id": "8221",
    "name": "Новое (Московская область)",
    "path": "Россия / Московская область / Новое (Московская область)",
    "country": "Россия",
    "searchString": "новое (московская область) россия / московская область / новое (московская область)"
  },
  "8222": {
    "id": "8222",
    "name": "Решетниково (Московская область)",
    "path": "Россия / Московская область / Решетниково (Московская область)",
    "country": "Россия",
    "searchString": "решетниково (московская область) россия / московская область / решетниково (московская область)"
  },
  "8223": {
    "id": "8223",
    "name": "Лоза (Московская область)",
    "path": "Россия / Московская область / Лоза (Московская область)",
    "country": "Россия",
    "searchString": "лоза (московская область) россия / московская область / лоза (московская область)"
  },
  "8224": {
    "id": "8224",
    "name": "Шугарово (Московская область)",
    "path": "Россия / Московская область / Шугарово (Московская область)",
    "country": "Россия",
    "searchString": "шугарово (московская область) россия / московская область / шугарово (московская область)"
  },
  "8225": {
    "id": "8225",
    "name": "Крутч-Байгора (Московская область)",
    "path": "Россия / Московская область / Крутч-Байгора (Московская область)",
    "country": "Россия",
    "searchString": "крутч-байгора (московская область) россия / московская область / крутч-байгора (московская область)"
  },
  "8226": {
    "id": "8226",
    "name": "Космодемьянский (Московская область)",
    "path": "Россия / Московская область / Космодемьянский (Московская область)",
    "country": "Россия",
    "searchString": "космодемьянский (московская область) россия / московская область / космодемьянский (московская область)"
  },
  "8227": {
    "id": "8227",
    "name": "Кожино (Московская область)",
    "path": "Россия / Московская область / Кожино (Московская область)",
    "country": "Россия",
    "searchString": "кожино (московская область) россия / московская область / кожино (московская область)"
  },
  "8228": {
    "id": "8228",
    "name": "Мосрентген (Московская область)",
    "path": "Россия / Московская область / Мосрентген (Московская область)",
    "country": "Россия",
    "searchString": "мосрентген (московская область) россия / московская область / мосрентген (московская область)"
  },
  "8229": {
    "id": "8229",
    "name": "Архангельское (Московская область)",
    "path": "Россия / Московская область / Архангельское (Московская область)",
    "country": "Россия",
    "searchString": "архангельское (московская область) россия / московская область / архангельское (московская область)"
  },
  "8230": {
    "id": "8230",
    "name": "Осташево (Московская область)",
    "path": "Россия / Московская область / Осташево (Московская область)",
    "country": "Россия",
    "searchString": "осташево (московская область) россия / московская область / осташево (московская область)"
  },
  "8231": {
    "id": "8231",
    "name": "Радумля (Московская область)",
    "path": "Россия / Московская область / Радумля (Московская область)",
    "country": "Россия",
    "searchString": "радумля (московская область) россия / московская область / радумля (московская область)"
  },
  "8232": {
    "id": "8232",
    "name": "Шеметово (Московская область)",
    "path": "Россия / Московская область / Шеметово (Московская область)",
    "country": "Россия",
    "searchString": "шеметово (московская область) россия / московская область / шеметово (московская область)"
  },
  "8233": {
    "id": "8233",
    "name": "Ловцы (Московская область)",
    "path": "Россия / Московская область / Ловцы (Московская область)",
    "country": "Россия",
    "searchString": "ловцы (московская область) россия / московская область / ловцы (московская область)"
  },
  "8234": {
    "id": "8234",
    "name": "Ленинский (Московская область)",
    "path": "Россия / Московская область / Ленинский (Московская область)",
    "country": "Россия",
    "searchString": "ленинский (московская область) россия / московская область / ленинский (московская область)"
  },
  "8235": {
    "id": "8235",
    "name": "Десеновское (Московская область)",
    "path": "Россия / Московская область / Десеновское (Московская область)",
    "country": "Россия",
    "searchString": "десеновское (московская область) россия / московская область / десеновское (московская область)"
  },
  "8236": {
    "id": "8236",
    "name": "Дмитриевское (Московская область)",
    "path": "Россия / Московская область / Дмитриевское (Московская область)",
    "country": "Россия",
    "searchString": "дмитриевское (московская область) россия / московская область / дмитриевское (московская область)"
  },
  "8237": {
    "id": "8237",
    "name": "Хатунь (Московская область)",
    "path": "Россия / Московская область / Хатунь (Московская область)",
    "country": "Россия",
    "searchString": "хатунь (московская область) россия / московская область / хатунь (московская область)"
  },
  "8238": {
    "id": "8238",
    "name": "Куликово (Московская область)",
    "path": "Россия / Московская область / Куликово (Московская область)",
    "country": "Россия",
    "searchString": "куликово (московская область) россия / московская область / куликово (московская область)"
  },
  "8239": {
    "id": "8239",
    "name": "Ново-Синьково (Московская область)",
    "path": "Россия / Московская область / Ново-Синьково (Московская область)",
    "country": "Россия",
    "searchString": "ново-синьково (московская область) россия / московская область / ново-синьково (московская область)"
  },
  "8240": {
    "id": "8240",
    "name": "Новинки (Московская область)",
    "path": "Россия / Московская область / Новинки (Московская область)",
    "country": "Россия",
    "searchString": "новинки (московская область) россия / московская область / новинки (московская область)"
  },
  "8241": {
    "id": "8241",
    "name": "Красная Пахра (Московская область)",
    "path": "Россия / Московская область / Красная Пахра (Московская область)",
    "country": "Россия",
    "searchString": "красная пахра (московская область) россия / московская область / красная пахра (московская область)"
  },
  "8242": {
    "id": "8242",
    "name": "Непецино (Московская область)",
    "path": "Россия / Московская область / Непецино (Московская область)",
    "country": "Россия",
    "searchString": "непецино (московская область) россия / московская область / непецино (московская область)"
  },
  "8243": {
    "id": "8243",
    "name": "Степаново (Московская область)",
    "path": "Россия / Московская область / Степаново (Московская область)",
    "country": "Россия",
    "searchString": "степаново (московская область) россия / московская область / степаново (московская область)"
  },
  "8244": {
    "id": "8244",
    "name": "Успенский (Московская область)",
    "path": "Россия / Московская область / Успенский (Московская область)",
    "country": "Россия",
    "searchString": "успенский (московская область) россия / московская область / успенский (московская область)"
  },
  "8245": {
    "id": "8245",
    "name": "Озеро Белое (Московская область)",
    "path": "Россия / Московская область / Озеро Белое (Московская область)",
    "country": "Россия",
    "searchString": "озеро белое (московская область) россия / московская область / озеро белое (московская область)"
  },
  "8246": {
    "id": "8246",
    "name": "Рочегда",
    "path": "Россия / Архангельская область / Рочегда",
    "country": "Россия",
    "searchString": "рочегда россия / архангельская область / рочегда"
  },
  "8247": {
    "id": "8247",
    "name": "Пожеревицы",
    "path": "Россия / Псковская область / Пожеревицы",
    "country": "Россия",
    "searchString": "пожеревицы россия / псковская область / пожеревицы"
  },
  "8248": {
    "id": "8248",
    "name": "Сторожевск",
    "path": "Россия / Республика Коми / Сторожевск",
    "country": "Россия",
    "searchString": "сторожевск россия / республика коми / сторожевск"
  },
  "8249": {
    "id": "8249",
    "name": "Седью",
    "path": "Россия / Республика Коми / Седью",
    "country": "Россия",
    "searchString": "седью россия / республика коми / седью"
  },
  "8250": {
    "id": "8250",
    "name": "Ледмозеро",
    "path": "Россия / Республика Карелия / Ледмозеро",
    "country": "Россия",
    "searchString": "ледмозеро россия / республика карелия / ледмозеро"
  },
  "8251": {
    "id": "8251",
    "name": "Усть-Ухта",
    "path": "Россия / Республика Коми / Усть-Ухта",
    "country": "Россия",
    "searchString": "усть-ухта россия / республика коми / усть-ухта"
  },
  "8252": {
    "id": "8252",
    "name": "Свирьстрой",
    "path": "Россия / Ленинградская область / Свирьстрой",
    "country": "Россия",
    "searchString": "свирьстрой россия / ленинградская область / свирьстрой"
  },
  "8253": {
    "id": "8253",
    "name": "Казлук",
    "path": "Россия / Республика Коми / Казлук",
    "country": "Россия",
    "searchString": "казлук россия / республика коми / казлук"
  },
  "8254": {
    "id": "8254",
    "name": "Большая Пустомержа",
    "path": "Россия / Ленинградская область / Большая Пустомержа",
    "country": "Россия",
    "searchString": "большая пустомержа россия / ленинградская область / большая пустомержа"
  },
  "8255": {
    "id": "8255",
    "name": "Войсковицы",
    "path": "Россия / Ленинградская область / Войсковицы",
    "country": "Россия",
    "searchString": "войсковицы россия / ленинградская область / войсковицы"
  },
  "8256": {
    "id": "8256",
    "name": "Авнюгский",
    "path": "Россия / Архангельская область / Авнюгский",
    "country": "Россия",
    "searchString": "авнюгский россия / архангельская область / авнюгский"
  },
  "8257": {
    "id": "8257",
    "name": "Славковичи",
    "path": "Россия / Псковская область / Славковичи",
    "country": "Россия",
    "searchString": "славковичи россия / псковская область / славковичи"
  },
  "8258": {
    "id": "8258",
    "name": "Ямм",
    "path": "Россия / Псковская область / Ямм",
    "country": "Россия",
    "searchString": "ямм россия / псковская область / ямм"
  },
  "8259": {
    "id": "8259",
    "name": "Чупа",
    "path": "Россия / Республика Карелия / Чупа",
    "country": "Россия",
    "searchString": "чупа россия / республика карелия / чупа"
  },
  "8260": {
    "id": "8260",
    "name": "Сура",
    "path": "Россия / Архангельская область / Сура",
    "country": "Россия",
    "searchString": "сура россия / архангельская область / сура"
  },
  "8261": {
    "id": "8261",
    "name": "Соловецкий",
    "path": "Россия / Архангельская область / Соловецкий",
    "country": "Россия",
    "searchString": "соловецкий россия / архангельская область / соловецкий"
  },
  "8262": {
    "id": "8262",
    "name": "Пяльма",
    "path": "Россия / Республика Карелия / Пяльма",
    "country": "Россия",
    "searchString": "пяльма россия / республика карелия / пяльма"
  },
  "8263": {
    "id": "8263",
    "name": "Усть-Пинега",
    "path": "Россия / Архангельская область / Усть-Пинега",
    "country": "Россия",
    "searchString": "усть-пинега россия / архангельская область / усть-пинега"
  },
  "8264": {
    "id": "8264",
    "name": "Новый Бор",
    "path": "Россия / Республика Коми / Новый Бор",
    "country": "Россия",
    "searchString": "новый бор россия / республика коми / новый бор"
  },
  "8265": {
    "id": "8265",
    "name": "Кикерино",
    "path": "Россия / Ленинградская область / Кикерино",
    "country": "Россия",
    "searchString": "кикерино россия / ленинградская область / кикерино"
  },
  "8266": {
    "id": "8266",
    "name": "Ладва",
    "path": "Россия / Республика Карелия / Ладва",
    "country": "Россия",
    "searchString": "ладва россия / республика карелия / ладва"
  },
  "8267": {
    "id": "8267",
    "name": "Комсомольск-на-Печоре",
    "path": "Россия / Республика Коми / Комсомольск-на-Печоре",
    "country": "Россия",
    "searchString": "комсомольск-на-печоре россия / республика коми / комсомольск-на-печоре"
  },
  "8268": {
    "id": "8268",
    "name": "Пиндуши",
    "path": "Россия / Республика Карелия / Пиндуши",
    "country": "Россия",
    "searchString": "пиндуши россия / республика карелия / пиндуши"
  },
  "8269": {
    "id": "8269",
    "name": "Югыдъяг",
    "path": "Россия / Республика Коми / Югыдъяг",
    "country": "Россия",
    "searchString": "югыдъяг россия / республика коми / югыдъяг"
  },
  "8270": {
    "id": "8270",
    "name": "Понтонный",
    "path": "Россия / Ленинградская область / Понтонный",
    "country": "Россия",
    "searchString": "понтонный россия / ленинградская область / понтонный"
  },
  "8271": {
    "id": "8271",
    "name": "Митрофан-Дикост",
    "path": "Россия / Республика Коми / Митрофан-Дикост",
    "country": "Россия",
    "searchString": "митрофан-дикост россия / республика коми / митрофан-дикост"
  },
  "8272": {
    "id": "8272",
    "name": "Осьмино",
    "path": "Россия / Ленинградская область / Осьмино",
    "country": "Россия",
    "searchString": "осьмино россия / ленинградская область / осьмино"
  },
  "8273": {
    "id": "8273",
    "name": "Вежью",
    "path": "Россия / Республика Коми / Вежью",
    "country": "Россия",
    "searchString": "вежью россия / республика коми / вежью"
  },
  "8274": {
    "id": "8274",
    "name": "Нивский",
    "path": "Россия / Мурманская область / Нивский",
    "country": "Россия",
    "searchString": "нивский россия / мурманская область / нивский"
  },
  "8275": {
    "id": "8275",
    "name": "Тракт",
    "path": "Россия / Республика Коми / Тракт",
    "country": "Россия",
    "searchString": "тракт россия / республика коми / тракт"
  },
  "8276": {
    "id": "8276",
    "name": "Пола",
    "path": "Россия / Новгородская область / Пола",
    "country": "Россия",
    "searchString": "пола россия / новгородская область / пола"
  },
  "8277": {
    "id": "8277",
    "name": "Трусово",
    "path": "Россия / Республика Коми / Трусово",
    "country": "Россия",
    "searchString": "трусово россия / республика коми / трусово"
  },
  "8278": {
    "id": "8278",
    "name": "Лендеры",
    "path": "Россия / Республика Карелия / Лендеры",
    "country": "Россия",
    "searchString": "лендеры россия / республика карелия / лендеры"
  },
  "8279": {
    "id": "8279",
    "name": "Алакуртти",
    "path": "Россия / Мурманская область / Алакуртти",
    "country": "Россия",
    "searchString": "алакуртти россия / мурманская область / алакуртти"
  },
  "8280": {
    "id": "8280",
    "name": "Едрово",
    "path": "Россия / Новгородская область / Едрово",
    "country": "Россия",
    "searchString": "едрово россия / новгородская область / едрово"
  },
  "8281": {
    "id": "8281",
    "name": "Кривцы",
    "path": "Россия / Республика Карелия / Кривцы",
    "country": "Россия",
    "searchString": "кривцы россия / республика карелия / кривцы"
  },
  "8282": {
    "id": "8282",
    "name": "Верхнеижемский",
    "path": "Россия / Республика Коми / Верхнеижемский",
    "country": "Россия",
    "searchString": "верхнеижемский россия / республика коми / верхнеижемский"
  },
  "8283": {
    "id": "8283",
    "name": "Беседа",
    "path": "Россия / Ленинградская область / Беседа",
    "country": "Россия",
    "searchString": "беседа россия / ленинградская область / беседа"
  },
  "8284": {
    "id": "8284",
    "name": "Громово",
    "path": "Россия / Ленинградская область / Громово",
    "country": "Россия",
    "searchString": "громово россия / ленинградская область / громово"
  },
  "8285": {
    "id": "8285",
    "name": "Кингисеппский",
    "path": "Россия / Ленинградская область / Кингисеппский",
    "country": "Россия",
    "searchString": "кингисеппский россия / ленинградская область / кингисеппский"
  },
  "8286": {
    "id": "8286",
    "name": "Краснофарфорный",
    "path": "Россия / Новгородская область / Краснофарфорный",
    "country": "Россия",
    "searchString": "краснофарфорный россия / новгородская область / краснофарфорный"
  },
  "8287": {
    "id": "8287",
    "name": "Шальский",
    "path": "Россия / Республика Карелия / Шальский",
    "country": "Россия",
    "searchString": "шальский россия / республика карелия / шальский"
  },
  "8288": {
    "id": "8288",
    "name": "Ивантеево",
    "path": "Россия / Новгородская область / Ивантеево",
    "country": "Россия",
    "searchString": "ивантеево россия / новгородская область / ивантеево"
  },
  "8289": {
    "id": "8289",
    "name": "Помоздино",
    "path": "Россия / Республика Коми / Помоздино",
    "country": "Россия",
    "searchString": "помоздино россия / республика коми / помоздино"
  },
  "8290": {
    "id": "8290",
    "name": "Яжелбицы",
    "path": "Россия / Новгородская область / Яжелбицы",
    "country": "Россия",
    "searchString": "яжелбицы россия / новгородская область / яжелбицы"
  },
  "8291": {
    "id": "8291",
    "name": "Полоное",
    "path": "Россия / Псковская область / Полоное",
    "country": "Россия",
    "searchString": "полоное россия / псковская область / полоное"
  },
  "8292": {
    "id": "8292",
    "name": "Даурия",
    "path": "Россия / Смоленская область / Даурия",
    "country": "Россия",
    "searchString": "даурия россия / смоленская область / даурия"
  },
  "8293": {
    "id": "8293",
    "name": "Красная Долина",
    "path": "Россия / Ленинградская область / Красная Долина",
    "country": "Россия",
    "searchString": "красная долина россия / ленинградская область / красная долина"
  },
  "8294": {
    "id": "8294",
    "name": "Мадмас",
    "path": "Россия / Республика Коми / Мадмас",
    "country": "Россия",
    "searchString": "мадмас россия / республика коми / мадмас"
  },
  "8295": {
    "id": "8295",
    "name": "Песочный",
    "path": "Россия / Ленинградская область / Песочный",
    "country": "Россия",
    "searchString": "песочный россия / ленинградская область / песочный"
  },
  "8296": {
    "id": "8296",
    "name": "Полново",
    "path": "Россия / Новгородская область / Полново",
    "country": "Россия",
    "searchString": "полново россия / новгородская область / полново"
  },
  "8297": {
    "id": "8297",
    "name": "Шугозеро",
    "path": "Россия / Ленинградская область / Шугозеро",
    "country": "Россия",
    "searchString": "шугозеро россия / ленинградская область / шугозеро"
  },
  "8298": {
    "id": "8298",
    "name": "Карамышево (Псковская область)",
    "path": "Россия / Псковская область / Карамышево (Псковская область)",
    "country": "Россия",
    "searchString": "карамышево (псковская область) россия / псковская область / карамышево (псковская область)"
  },
  "8299": {
    "id": "8299",
    "name": "Выскатка",
    "path": "Россия / Ленинградская область / Выскатка",
    "country": "Россия",
    "searchString": "выскатка россия / ленинградская область / выскатка"
  },
  "8300": {
    "id": "8300",
    "name": "Большаково",
    "path": "Россия / Калининградская область / Большаково",
    "country": "Россия",
    "searchString": "большаково россия / калининградская область / большаково"
  },
  "8301": {
    "id": "8301",
    "name": "Шелтозеро",
    "path": "Россия / Республика Карелия / Шелтозеро",
    "country": "Россия",
    "searchString": "шелтозеро россия / республика карелия / шелтозеро"
  },
  "8302": {
    "id": "8302",
    "name": "Гладкое",
    "path": "Россия / Ленинградская область / Гладкое",
    "country": "Россия",
    "searchString": "гладкое россия / ленинградская область / гладкое"
  },
  "8303": {
    "id": "8303",
    "name": "Середка",
    "path": "Россия / Псковская область / Середка",
    "country": "Россия",
    "searchString": "середка россия / псковская область / середка"
  },
  "8304": {
    "id": "8304",
    "name": "Суккозеро",
    "path": "Россия / Республика Карелия / Суккозеро",
    "country": "Россия",
    "searchString": "суккозеро россия / республика карелия / суккозеро"
  },
  "8305": {
    "id": "8305",
    "name": "Васильково",
    "path": "Россия / Калининградская область / Васильково",
    "country": "Россия",
    "searchString": "васильково россия / калининградская область / васильково"
  },
  "8306": {
    "id": "8306",
    "name": "Каменный Бор",
    "path": "Россия / Республика Карелия / Каменный Бор",
    "country": "Россия",
    "searchString": "каменный бор россия / республика карелия / каменный бор"
  },
  "8307": {
    "id": "8307",
    "name": "Салми",
    "path": "Россия / Республика Карелия / Салми",
    "country": "Россия",
    "searchString": "салми россия / республика карелия / салми"
  },
  "8308": {
    "id": "8308",
    "name": "Опеченский Посад",
    "path": "Россия / Новгородская область / Опеченский Посад",
    "country": "Россия",
    "searchString": "опеченский посад россия / новгородская область / опеченский посад"
  },
  "8309": {
    "id": "8309",
    "name": "Ушаки",
    "path": "Россия / Ленинградская область / Ушаки",
    "country": "Россия",
    "searchString": "ушаки россия / ленинградская область / ушаки"
  },
  "8310": {
    "id": "8310",
    "name": "Шелоховская",
    "path": "Россия / Архангельская область / Шелоховская",
    "country": "Россия",
    "searchString": "шелоховская россия / архангельская область / шелоховская"
  },
  "8311": {
    "id": "8311",
    "name": "Саперное",
    "path": "Россия / Ленинградская область / Саперное",
    "country": "Россия",
    "searchString": "саперное россия / ленинградская область / саперное"
  },
  "8312": {
    "id": "8312",
    "name": "Белогорский",
    "path": "Россия / Архангельская область / Белогорский",
    "country": "Россия",
    "searchString": "белогорский россия / архангельская область / белогорский"
  },
  "8313": {
    "id": "8313",
    "name": "Кослан",
    "path": "Россия / Республика Коми / Кослан",
    "country": "Россия",
    "searchString": "кослан россия / республика коми / кослан"
  },
  "8314": {
    "id": "8314",
    "name": "Фалилеево",
    "path": "Россия / Ленинградская область / Фалилеево",
    "country": "Россия",
    "searchString": "фалилеево россия / ленинградская область / фалилеево"
  },
  "8315": {
    "id": "8315",
    "name": "Шум",
    "path": "Россия / Ленинградская область / Шум",
    "country": "Россия",
    "searchString": "шум россия / ленинградская область / шум"
  },
  "8316": {
    "id": "8316",
    "name": "Вяртсиля",
    "path": "Россия / Республика Карелия / Вяртсиля",
    "country": "Россия",
    "searchString": "вяртсиля россия / республика карелия / вяртсиля"
  },
  "8317": {
    "id": "8317",
    "name": "Тесово-Нетыльский",
    "path": "Россия / Новгородская область / Тесово-Нетыльский",
    "country": "Россия",
    "searchString": "тесово-нетыльский россия / новгородская область / тесово-нетыльский"
  },
  "8318": {
    "id": "8318",
    "name": "Пчевжа",
    "path": "Россия / Ленинградская область / Пчевжа",
    "country": "Россия",
    "searchString": "пчевжа россия / ленинградская область / пчевжа"
  },
  "8319": {
    "id": "8319",
    "name": "Жижица",
    "path": "Россия / Псковская область / Жижица",
    "country": "Россия",
    "searchString": "жижица россия / псковская область / жижица"
  },
  "8320": {
    "id": "8320",
    "name": "Кузьель",
    "path": "Россия / Республика Коми / Кузьель",
    "country": "Россия",
    "searchString": "кузьель россия / республика коми / кузьель"
  },
  "8321": {
    "id": "8321",
    "name": "Чиньяворык",
    "path": "Россия / Республика Коми / Чиньяворык",
    "country": "Россия",
    "searchString": "чиньяворык россия / республика коми / чиньяворык"
  },
  "8322": {
    "id": "8322",
    "name": "Залучье",
    "path": "Россия / Новгородская область / Залучье",
    "country": "Россия",
    "searchString": "залучье россия / новгородская область / залучье"
  },
  "8323": {
    "id": "8323",
    "name": "Глобицы",
    "path": "Россия / Ленинградская область / Глобицы",
    "country": "Россия",
    "searchString": "глобицы россия / ленинградская область / глобицы"
  },
  "8324": {
    "id": "8324",
    "name": "Новый Изборск",
    "path": "Россия / Псковская область / Новый Изборск",
    "country": "Россия",
    "searchString": "новый изборск россия / псковская область / новый изборск"
  },
  "8325": {
    "id": "8325",
    "name": "Тарасово (Ленинградская область)",
    "path": "Россия / Ленинградская область / Тарасово (Ленинградская область)",
    "country": "Россия",
    "searchString": "тарасово (ленинградская область) россия / ленинградская область / тарасово (ленинградская область)"
  },
  "8326": {
    "id": "8326",
    "name": "Кневицы",
    "path": "Россия / Новгородская область / Кневицы",
    "country": "Россия",
    "searchString": "кневицы россия / новгородская область / кневицы"
  },
  "8327": {
    "id": "8327",
    "name": "Вындин Остров",
    "path": "Россия / Ленинградская область / Вындин Остров",
    "country": "Россия",
    "searchString": "вындин остров россия / ленинградская область / вындин остров"
  },
  "8328": {
    "id": "8328",
    "name": "Большой Сабск",
    "path": "Россия / Ленинградская область / Большой Сабск",
    "country": "Россия",
    "searchString": "большой сабск россия / ленинградская область / большой сабск"
  },
  "8329": {
    "id": "8329",
    "name": "Щеглово",
    "path": "Россия / Ленинградская область / Щеглово",
    "country": "Россия",
    "searchString": "щеглово россия / ленинградская область / щеглово"
  },
  "8330": {
    "id": "8330",
    "name": "Важгорт",
    "path": "Россия / Республика Коми / Важгорт",
    "country": "Россия",
    "searchString": "важгорт россия / республика коми / важгорт"
  },
  "8331": {
    "id": "8331",
    "name": "Щельяюр",
    "path": "Россия / Республика Коми / Щельяюр",
    "country": "Россия",
    "searchString": "щельяюр россия / республика коми / щельяюр"
  },
  "8332": {
    "id": "8332",
    "name": "Мшинская",
    "path": "Россия / Ленинградская область / Мшинская",
    "country": "Россия",
    "searchString": "мшинская россия / ленинградская область / мшинская"
  },
  "8333": {
    "id": "8333",
    "name": "Сяськелево",
    "path": "Россия / Ленинградская область / Сяськелево",
    "country": "Россия",
    "searchString": "сяськелево россия / ленинградская область / сяськелево"
  },
  "8334": {
    "id": "8334",
    "name": "Шалакуша",
    "path": "Россия / Архангельская область / Шалакуша",
    "country": "Россия",
    "searchString": "шалакуша россия / архангельская область / шалакуша"
  },
  "8335": {
    "id": "8335",
    "name": "Элисенваара",
    "path": "Россия / Республика Карелия / Элисенваара",
    "country": "Россия",
    "searchString": "элисенваара россия / республика карелия / элисенваара"
  },
  "8336": {
    "id": "8336",
    "name": "Луковецкий",
    "path": "Россия / Архангельская область / Луковецкий",
    "country": "Россия",
    "searchString": "луковецкий россия / архангельская область / луковецкий"
  },
  "8337": {
    "id": "8337",
    "name": "Мохча",
    "path": "Россия / Республика Коми / Мохча",
    "country": "Россия",
    "searchString": "мохча россия / республика коми / мохча"
  },
  "8338": {
    "id": "8338",
    "name": "Лойма",
    "path": "Россия / Республика Коми / Лойма",
    "country": "Россия",
    "searchString": "лойма россия / республика коми / лойма"
  },
  "8339": {
    "id": "8339",
    "name": "Зеленец",
    "path": "Россия / Республика Коми / Зеленец",
    "country": "Россия",
    "searchString": "зеленец россия / республика коми / зеленец"
  },
  "8340": {
    "id": "8340",
    "name": "Седкыркещ",
    "path": "Россия / Республика Коми / Седкыркещ",
    "country": "Россия",
    "searchString": "седкыркещ россия / республика коми / седкыркещ"
  },
  "8341": {
    "id": "8341",
    "name": "Дуброво",
    "path": "Россия / Новгородская область / Дуброво",
    "country": "Россия",
    "searchString": "дуброво россия / новгородская область / дуброво"
  },
  "8342": {
    "id": "8342",
    "name": "Первомайский (Смоленская область)",
    "path": "Россия / Смоленская область / Первомайский (Смоленская область)",
    "country": "Россия",
    "searchString": "первомайский (смоленская область) россия / смоленская область / первомайский (смоленская область)"
  },
  "8343": {
    "id": "8343",
    "name": "Приморье",
    "path": "Россия / Калининградская область / Приморье",
    "country": "Россия",
    "searchString": "приморье россия / калининградская область / приморье"
  },
  "8344": {
    "id": "8344",
    "name": "Ополье",
    "path": "Россия / Ленинградская область / Ополье",
    "country": "Россия",
    "searchString": "ополье россия / ленинградская область / ополье"
  },
  "8345": {
    "id": "8345",
    "name": "Калитино",
    "path": "Россия / Ленинградская область / Калитино",
    "country": "Россия",
    "searchString": "калитино россия / ленинградская область / калитино"
  },
  "8346": {
    "id": "8346",
    "name": "Новохованск",
    "path": "Россия / Псковская область / Новохованск",
    "country": "Россия",
    "searchString": "новохованск россия / псковская область / новохованск"
  },
  "8347": {
    "id": "8347",
    "name": "Сия",
    "path": "Россия / Архангельская область / Сия",
    "country": "Россия",
    "searchString": "сия россия / архангельская область / сия"
  },
  "8348": {
    "id": "8348",
    "name": "Уторгош",
    "path": "Россия / Новгородская область / Уторгош",
    "country": "Россия",
    "searchString": "уторгош россия / новгородская область / уторгош"
  },
  "8349": {
    "id": "8349",
    "name": "Янтарный",
    "path": "Россия / Калининградская область / Янтарный",
    "country": "Россия",
    "searchString": "янтарный россия / калининградская область / янтарный"
  },
  "8350": {
    "id": "8350",
    "name": "Ярега",
    "path": "Россия / Республика Коми / Ярега",
    "country": "Россия",
    "searchString": "ярега россия / республика коми / ярега"
  },
  "8351": {
    "id": "8351",
    "name": "Ям-Тесово",
    "path": "Россия / Ленинградская область / Ям-Тесово",
    "country": "Россия",
    "searchString": "ям-тесово россия / ленинградская область / ям-тесово"
  },
  "8352": {
    "id": "8352",
    "name": "Рускеала",
    "path": "Россия / Республика Карелия / Рускеала",
    "country": "Россия",
    "searchString": "рускеала россия / республика карелия / рускеала"
  },
  "8353": {
    "id": "8353",
    "name": "Южный-1",
    "path": "Россия / Калининградская область / Южный-1",
    "country": "Россия",
    "searchString": "южный-1 россия / калининградская область / южный-1"
  },
  "8354": {
    "id": "8354",
    "name": "Спаспоруб",
    "path": "Россия / Республика Коми / Спаспоруб",
    "country": "Россия",
    "searchString": "спаспоруб россия / республика коми / спаспоруб"
  },
  "8355": {
    "id": "8355",
    "name": "Чикшино",
    "path": "Россия / Республика Коми / Чикшино",
    "country": "Россия",
    "searchString": "чикшино россия / республика коми / чикшино"
  },
  "8356": {
    "id": "8356",
    "name": "Повенец",
    "path": "Россия / Республика Карелия / Повенец",
    "country": "Россия",
    "searchString": "повенец россия / республика карелия / повенец"
  },
  "8357": {
    "id": "8357",
    "name": "Подюга",
    "path": "Россия / Архангельская область / Подюга",
    "country": "Россия",
    "searchString": "подюга россия / архангельская область / подюга"
  },
  "8358": {
    "id": "8358",
    "name": "Межадор",
    "path": "Россия / Республика Коми / Межадор",
    "country": "Россия",
    "searchString": "межадор россия / республика коми / межадор"
  },
  "8359": {
    "id": "8359",
    "name": "Усть-Долыссы",
    "path": "Россия / Псковская область / Усть-Долыссы",
    "country": "Россия",
    "searchString": "усть-долыссы россия / псковская область / усть-долыссы"
  },
  "8360": {
    "id": "8360",
    "name": "Юбилейный (Новгородская область)",
    "path": "Россия / Новгородская область / Юбилейный (Новгородская область)",
    "country": "Россия",
    "searchString": "юбилейный (новгородская область) россия / новгородская область / юбилейный (новгородская область)"
  },
  "8361": {
    "id": "8361",
    "name": "Гарболово",
    "path": "Россия / Ленинградская область / Гарболово",
    "country": "Россия",
    "searchString": "гарболово россия / ленинградская область / гарболово"
  },
  "8362": {
    "id": "8362",
    "name": "Поросозеро",
    "path": "Россия / Республика Карелия / Поросозеро",
    "country": "Россия",
    "searchString": "поросозеро россия / республика карелия / поросозеро"
  },
  "8363": {
    "id": "8363",
    "name": "Зимитицы",
    "path": "Россия / Ленинградская область / Зимитицы",
    "country": "Россия",
    "searchString": "зимитицы россия / ленинградская область / зимитицы"
  },
  "8364": {
    "id": "8364",
    "name": "Семиозерье",
    "path": "Россия / Ленинградская область / Семиозерье",
    "country": "Россия",
    "searchString": "семиозерье россия / ленинградская область / семиозерье"
  },
  "8365": {
    "id": "8365",
    "name": "Кодино",
    "path": "Россия / Архангельская область / Кодино",
    "country": "Россия",
    "searchString": "кодино россия / архангельская область / кодино"
  },
  "8366": {
    "id": "8366",
    "name": "Воргашор",
    "path": "Россия / Республика Коми / Воргашор",
    "country": "Россия",
    "searchString": "воргашор россия / республика коми / воргашор"
  },
  "8367": {
    "id": "8367",
    "name": "Енский",
    "path": "Россия / Мурманская область / Енский",
    "country": "Россия",
    "searchString": "енский россия / мурманская область / енский"
  },
  "8368": {
    "id": "8368",
    "name": "Краснобор",
    "path": "Россия / Республика Коми / Краснобор",
    "country": "Россия",
    "searchString": "краснобор россия / республика коми / краснобор"
  },
  "8369": {
    "id": "8369",
    "name": "Куликово (Архангельская область)",
    "path": "Россия / Архангельская область / Куликово (Архангельская область)",
    "country": "Россия",
    "searchString": "куликово (архангельская область) россия / архангельская область / куликово (архангельская область)"
  },
  "8370": {
    "id": "8370",
    "name": "Каджером",
    "path": "Россия / Республика Коми / Каджером",
    "country": "Россия",
    "searchString": "каджером россия / республика коми / каджером"
  },
  "8371": {
    "id": "8371",
    "name": "Лопухинка",
    "path": "Россия / Ленинградская область / Лопухинка",
    "country": "Россия",
    "searchString": "лопухинка россия / ленинградская область / лопухинка"
  },
  "8372": {
    "id": "8372",
    "name": "Хелюля",
    "path": "Россия / Республика Карелия / Хелюля",
    "country": "Россия",
    "searchString": "хелюля россия / республика карелия / хелюля"
  },
  "8373": {
    "id": "8373",
    "name": "Подчерье",
    "path": "Россия / Республика Коми / Подчерье",
    "country": "Россия",
    "searchString": "подчерье россия / республика коми / подчерье"
  },
  "8374": {
    "id": "8374",
    "name": "Боровенка",
    "path": "Россия / Новгородская область / Боровенка",
    "country": "Россия",
    "searchString": "боровенка россия / новгородская область / боровенка"
  },
  "8375": {
    "id": "8375",
    "name": "Дутово",
    "path": "Россия / Республика Коми / Дутово",
    "country": "Россия",
    "searchString": "дутово россия / республика коми / дутово"
  },
  "8376": {
    "id": "8376",
    "name": "Нижняя Омра",
    "path": "Россия / Республика Коми / Нижняя Омра",
    "country": "Россия",
    "searchString": "нижняя омра россия / республика коми / нижняя омра"
  },
  "8377": {
    "id": "8377",
    "name": "Брин-Наволок",
    "path": "Россия / Архангельская область / Брин-Наволок",
    "country": "Россия",
    "searchString": "брин-наволок россия / архангельская область / брин-наволок"
  },
  "8378": {
    "id": "8378",
    "name": "Усть-Волма",
    "path": "Россия / Новгородская область / Усть-Волма",
    "country": "Россия",
    "searchString": "усть-волма россия / новгородская область / усть-волма"
  },
  "8379": {
    "id": "8379",
    "name": "Шудаяг",
    "path": "Россия / Республика Коми / Шудаяг",
    "country": "Россия",
    "searchString": "шудаяг россия / республика коми / шудаяг"
  },
  "8380": {
    "id": "8380",
    "name": "Медведь",
    "path": "Россия / Новгородская область / Медведь",
    "country": "Россия",
    "searchString": "медведь россия / новгородская область / медведь"
  },
  "8381": {
    "id": "8381",
    "name": "Зарубино (Новгородская область)",
    "path": "Россия / Новгородская область / Зарубино (Новгородская область)",
    "country": "Россия",
    "searchString": "зарубино (новгородская область) россия / новгородская область / зарубино (новгородская область)"
  },
  "8382": {
    "id": "8382",
    "name": "Дзержинского",
    "path": "Россия / Ленинградская область / Дзержинского",
    "country": "Россия",
    "searchString": "дзержинского россия / ленинградская область / дзержинского"
  },
  "8383": {
    "id": "8383",
    "name": "Плодовое",
    "path": "Россия / Ленинградская область / Плодовое",
    "country": "Россия",
    "searchString": "плодовое россия / ленинградская область / плодовое"
  },
  "8384": {
    "id": "8384",
    "name": "Койдин",
    "path": "Россия / Республика Коми / Койдин",
    "country": "Россия",
    "searchString": "койдин россия / республика коми / койдин"
  },
  "8385": {
    "id": "8385",
    "name": "Краснозатонский",
    "path": "Россия / Республика Коми / Краснозатонский",
    "country": "Россия",
    "searchString": "краснозатонский россия / республика коми / краснозатонский"
  },
  "8386": {
    "id": "8386",
    "name": "Глебычево",
    "path": "Россия / Ленинградская область / Глебычево",
    "country": "Россия",
    "searchString": "глебычево россия / ленинградская область / глебычево"
  },
  "8387": {
    "id": "8387",
    "name": "Черемуховка",
    "path": "Россия / Республика Коми / Черемуховка",
    "country": "Россия",
    "searchString": "черемуховка россия / республика коми / черемуховка"
  },
  "8388": {
    "id": "8388",
    "name": "Харлу",
    "path": "Россия / Республика Карелия / Харлу",
    "country": "Россия",
    "searchString": "харлу россия / республика карелия / харлу"
  },
  "8389": {
    "id": "8389",
    "name": "Удимский",
    "path": "Россия / Архангельская область / Удимский",
    "country": "Россия",
    "searchString": "удимский россия / архангельская область / удимский"
  },
  "8390": {
    "id": "8390",
    "name": "Кожмудор",
    "path": "Россия / Республика Коми / Кожмудор",
    "country": "Россия",
    "searchString": "кожмудор россия / республика коми / кожмудор"
  },
  "8391": {
    "id": "8391",
    "name": "Том",
    "path": "Россия / Республика Коми / Том",
    "country": "Россия",
    "searchString": "том россия / республика коми / том"
  },
  "8392": {
    "id": "8392",
    "name": "Верхний Мост",
    "path": "Россия / Псковская область / Верхний Мост",
    "country": "Россия",
    "searchString": "верхний мост россия / псковская область / верхний мост"
  },
  "8393": {
    "id": "8393",
    "name": "Сосновец",
    "path": "Россия / Республика Карелия / Сосновец",
    "country": "Россия",
    "searchString": "сосновец россия / республика карелия / сосновец"
  },
  "8394": {
    "id": "8394",
    "name": "Краснощелье",
    "path": "Россия / Мурманская область / Краснощелье",
    "country": "Россия",
    "searchString": "краснощелье россия / мурманская область / краснощелье"
  },
  "8395": {
    "id": "8395",
    "name": "Замежная",
    "path": "Россия / Республика Коми / Замежная",
    "country": "Россия",
    "searchString": "замежная россия / республика коми / замежная"
  },
  "8396": {
    "id": "8396",
    "name": "Борки",
    "path": "Россия / Новгородская область / Борки",
    "country": "Россия",
    "searchString": "борки россия / новгородская область / борки"
  },
  "8397": {
    "id": "8397",
    "name": "Волома",
    "path": "Россия / Республика Карелия / Волома",
    "country": "Россия",
    "searchString": "волома россия / республика карелия / волома"
  },
  "8398": {
    "id": "8398",
    "name": "Родовое",
    "path": "Россия / Псковская область / Родовое",
    "country": "Россия",
    "searchString": "родовое россия / псковская область / родовое"
  },
  "8399": {
    "id": "8399",
    "name": "Пригорское",
    "path": "Россия / Смоленская область / Пригорское",
    "country": "Россия",
    "searchString": "пригорское россия / смоленская область / пригорское"
  },
  "8400": {
    "id": "8400",
    "name": "Абезь",
    "path": "Россия / Республика Коми / Абезь",
    "country": "Россия",
    "searchString": "абезь россия / республика коми / абезь"
  },
  "8401": {
    "id": "8401",
    "name": "Шангалы",
    "path": "Россия / Архангельская область / Шангалы",
    "country": "Россия",
    "searchString": "шангалы россия / архангельская область / шангалы"
  },
  "8402": {
    "id": "8402",
    "name": "Чихачево",
    "path": "Россия / Псковская область / Чихачево",
    "country": "Россия",
    "searchString": "чихачево россия / псковская область / чихачево"
  },
  "8403": {
    "id": "8403",
    "name": "Верхняя Инта",
    "path": "Россия / Республика Коми / Верхняя Инта",
    "country": "Россия",
    "searchString": "верхняя инта россия / республика коми / верхняя инта"
  },
  "8404": {
    "id": "8404",
    "name": "Верхняя Максаковка",
    "path": "Россия / Республика Коми / Верхняя Максаковка",
    "country": "Россия",
    "searchString": "верхняя максаковка россия / республика коми / верхняя максаковка"
  },
  "8405": {
    "id": "8405",
    "name": "Большая Вишера",
    "path": "Россия / Новгородская область / Большая Вишера",
    "country": "Россия",
    "searchString": "большая вишера россия / новгородская область / большая вишера"
  },
  "8406": {
    "id": "8406",
    "name": "Старополье",
    "path": "Россия / Ленинградская область / Старополье",
    "country": "Россия",
    "searchString": "старополье россия / ленинградская область / старополье"
  },
  "8407": {
    "id": "8407",
    "name": "Вистино",
    "path": "Россия / Ленинградская область / Вистино",
    "country": "Россия",
    "searchString": "вистино россия / ленинградская область / вистино"
  },
  "8408": {
    "id": "8408",
    "name": "Нагово",
    "path": "Россия / Новгородская область / Нагово",
    "country": "Россия",
    "searchString": "нагово россия / новгородская область / нагово"
  },
  "8409": {
    "id": "8409",
    "name": "Лавры",
    "path": "Россия / Псковская область / Лавры",
    "country": "Россия",
    "searchString": "лавры россия / псковская область / лавры"
  },
  "8410": {
    "id": "8410",
    "name": "Кисельня",
    "path": "Россия / Ленинградская область / Кисельня",
    "country": "Россия",
    "searchString": "кисельня россия / ленинградская область / кисельня"
  },
  "8411": {
    "id": "8411",
    "name": "Пенинга",
    "path": "Россия / Республика Карелия / Пенинга",
    "country": "Россия",
    "searchString": "пенинга россия / республика карелия / пенинга"
  },
  "8412": {
    "id": "8412",
    "name": "Большое Куземкино",
    "path": "Россия / Ленинградская область / Большое Куземкино",
    "country": "Россия",
    "searchString": "большое куземкино россия / ленинградская область / большое куземкино"
  },
  "8413": {
    "id": "8413",
    "name": "Пудость",
    "path": "Россия / Ленинградская область / Пудость",
    "country": "Россия",
    "searchString": "пудость россия / ленинградская область / пудость"
  },
  "8414": {
    "id": "8414",
    "name": "Первомайский (Республика Коми)",
    "path": "Россия / Республика Коми / Первомайский (Республика Коми)",
    "country": "Россия",
    "searchString": "первомайский (республика коми) россия / республика коми / первомайский (республика коми)"
  },
  "8415": {
    "id": "8415",
    "name": "Ношуль",
    "path": "Россия / Республика Коми / Ношуль",
    "country": "Россия",
    "searchString": "ношуль россия / республика коми / ношуль"
  },
  "8416": {
    "id": "8416",
    "name": "Красноторовка",
    "path": "Россия / Калининградская область / Красноторовка",
    "country": "Россия",
    "searchString": "красноторовка россия / калининградская область / красноторовка"
  },
  "8417": {
    "id": "8417",
    "name": "Пажга",
    "path": "Россия / Республика Коми / Пажга",
    "country": "Россия",
    "searchString": "пажга россия / республика коми / пажга"
  },
  "8418": {
    "id": "8418",
    "name": "Хилово",
    "path": "Россия / Псковская область / Хилово",
    "country": "Россия",
    "searchString": "хилово россия / псковская область / хилово"
  },
  "8419": {
    "id": "8419",
    "name": "Карманово",
    "path": "Россия / Смоленская область / Карманово",
    "country": "Россия",
    "searchString": "карманово россия / смоленская область / карманово"
  },
  "8420": {
    "id": "8420",
    "name": "Ерцево",
    "path": "Россия / Архангельская область / Ерцево",
    "country": "Россия",
    "searchString": "ерцево россия / архангельская область / ерцево"
  },
  "8421": {
    "id": "8421",
    "name": "Черевково",
    "path": "Россия / Архангельская область / Черевково",
    "country": "Россия",
    "searchString": "черевково россия / архангельская область / черевково"
  },
  "8422": {
    "id": "8422",
    "name": "Запорожское",
    "path": "Россия / Ленинградская область / Запорожское",
    "country": "Россия",
    "searchString": "запорожское россия / ленинградская область / запорожское"
  },
  "8423": {
    "id": "8423",
    "name": "Садовый (Ленинградская область)",
    "path": "Россия / Ленинградская область / Садовый (Ленинградская область)",
    "country": "Россия",
    "searchString": "садовый (ленинградская область) россия / ленинградская область / садовый (ленинградская область)"
  },
  "8424": {
    "id": "8424",
    "name": "Якша",
    "path": "Россия / Республика Коми / Якша",
    "country": "Россия",
    "searchString": "якша россия / республика коми / якша"
  },
  "8425": {
    "id": "8425",
    "name": "Павы",
    "path": "Россия / Псковская область / Павы",
    "country": "Россия",
    "searchString": "павы россия / псковская область / павы"
  },
  "8426": {
    "id": "8426",
    "name": "Зимстан",
    "path": "Россия / Республика Коми / Зимстан",
    "country": "Россия",
    "searchString": "зимстан россия / республика коми / зимстан"
  },
  "8427": {
    "id": "8427",
    "name": "Гаврово",
    "path": "Россия / Псковская область / Гаврово",
    "country": "Россия",
    "searchString": "гаврово россия / псковская область / гаврово"
  },
  "8428": {
    "id": "8428",
    "name": "Сосновый",
    "path": "Россия / Республика Карелия / Сосновый",
    "country": "Россия",
    "searchString": "сосновый россия / республика карелия / сосновый"
  },
  "8429": {
    "id": "8429",
    "name": "Извара",
    "path": "Россия / Ленинградская область / Извара",
    "country": "Россия",
    "searchString": "извара россия / ленинградская область / извара"
  },
  "8430": {
    "id": "8430",
    "name": "Лахколампи",
    "path": "Россия / Республика Карелия / Лахколампи",
    "country": "Россия",
    "searchString": "лахколампи россия / республика карелия / лахколампи"
  },
  "8431": {
    "id": "8431",
    "name": "Мичуринское",
    "path": "Россия / Ленинградская область / Мичуринское",
    "country": "Россия",
    "searchString": "мичуринское россия / ленинградская область / мичуринское"
  },
  "8432": {
    "id": "8432",
    "name": "Чална",
    "path": "Россия / Республика Карелия / Чална",
    "country": "Россия",
    "searchString": "чална россия / республика карелия / чална"
  },
  "8433": {
    "id": "8433",
    "name": "Качаново",
    "path": "Россия / Псковская область / Качаново",
    "country": "Россия",
    "searchString": "качаново россия / псковская область / качаново"
  },
  "8434": {
    "id": "8434",
    "name": "Изъяю",
    "path": "Россия / Республика Коми / Изъяю",
    "country": "Россия",
    "searchString": "изъяю россия / республика коми / изъяю"
  },
  "8435": {
    "id": "8435",
    "name": "Боровой",
    "path": "Россия / Республика Коми / Боровой",
    "country": "Россия",
    "searchString": "боровой россия / республика коми / боровой"
  },
  "8436": {
    "id": "8436",
    "name": "Ретюнь",
    "path": "Россия / Ленинградская область / Ретюнь",
    "country": "Россия",
    "searchString": "ретюнь россия / ленинградская область / ретюнь"
  },
  "8437": {
    "id": "8437",
    "name": "Алеховщина",
    "path": "Россия / Ленинградская область / Алеховщина",
    "country": "Россия",
    "searchString": "алеховщина россия / ленинградская область / алеховщина"
  },
  "8438": {
    "id": "8438",
    "name": "Белогорка",
    "path": "Россия / Ленинградская область / Белогорка",
    "country": "Россия",
    "searchString": "белогорка россия / ленинградская область / белогорка"
  },
  "8439": {
    "id": "8439",
    "name": "Ляскеля",
    "path": "Россия / Республика Карелия / Ляскеля",
    "country": "Россия",
    "searchString": "ляскеля россия / республика карелия / ляскеля"
  },
  "8440": {
    "id": "8440",
    "name": "Храброво",
    "path": "Россия / Калининградская область / Храброво",
    "country": "Россия",
    "searchString": "храброво россия / калининградская область / храброво"
  },
  "8441": {
    "id": "8441",
    "name": "Ильинский (Республика Карелия)",
    "path": "Россия / Республика Карелия / Ильинский (Республика Карелия)",
    "country": "Россия",
    "searchString": "ильинский (республика карелия) россия / республика карелия / ильинский (республика карелия)"
  },
  "8442": {
    "id": "8442",
    "name": "Хабариха",
    "path": "Россия / Республика Коми / Хабариха",
    "country": "Россия",
    "searchString": "хабариха россия / республика коми / хабариха"
  },
  "8443": {
    "id": "8443",
    "name": "Пяозерский",
    "path": "Россия / Республика Карелия / Пяозерский",
    "country": "Россия",
    "searchString": "пяозерский россия / республика карелия / пяозерский"
  },
  "8444": {
    "id": "8444",
    "name": "Торковичи",
    "path": "Россия / Ленинградская область / Торковичи",
    "country": "Россия",
    "searchString": "торковичи россия / ленинградская область / торковичи"
  },
  "8445": {
    "id": "8445",
    "name": "Гурьевка",
    "path": "Россия / Республика Коми / Гурьевка",
    "country": "Россия",
    "searchString": "гурьевка россия / республика коми / гурьевка"
  },
  "8446": {
    "id": "8446",
    "name": "Подзь",
    "path": "Россия / Республика Коми / Подзь",
    "country": "Россия",
    "searchString": "подзь россия / республика коми / подзь"
  },
  "8447": {
    "id": "8447",
    "name": "Кобринское",
    "path": "Россия / Ленинградская область / Кобринское",
    "country": "Россия",
    "searchString": "кобринское россия / ленинградская область / кобринское"
  },
  "8448": {
    "id": "8448",
    "name": "Великая Губа",
    "path": "Россия / Республика Карелия / Великая Губа",
    "country": "Россия",
    "searchString": "великая губа россия / республика карелия / великая губа"
  },
  "8449": {
    "id": "8449",
    "name": "Изоплит",
    "path": "Россия / Тверская область / Изоплит",
    "country": "Россия",
    "searchString": "изоплит россия / тверская область / изоплит"
  },
  "8450": {
    "id": "8450",
    "name": "Покровское (Ярославская область)",
    "path": "Россия / Ярославская область / Покровское (Ярославская область)",
    "country": "Россия",
    "searchString": "покровское (ярославская область) россия / ярославская область / покровское (ярославская область)"
  },
  "8451": {
    "id": "8451",
    "name": "Чебсара",
    "path": "Россия / Вологодская область / Чебсара",
    "country": "Россия",
    "searchString": "чебсара россия / вологодская область / чебсара"
  },
  "8452": {
    "id": "8452",
    "name": "Дуляпино",
    "path": "Россия / Ивановская область / Дуляпино",
    "country": "Россия",
    "searchString": "дуляпино россия / ивановская область / дуляпино"
  },
  "8453": {
    "id": "8453",
    "name": "Горчуха",
    "path": "Россия / Костромская область / Горчуха",
    "country": "Россия",
    "searchString": "горчуха россия / костромская область / горчуха"
  },
  "8454": {
    "id": "8454",
    "name": "Завражье",
    "path": "Россия / Костромская область / Завражье",
    "country": "Россия",
    "searchString": "завражье россия / костромская область / завражье"
  },
  "8455": {
    "id": "8455",
    "name": "Октябрьский (Владимирская область)",
    "path": "Россия / Владимирская область / Октябрьский (Владимирская область)",
    "country": "Россия",
    "searchString": "октябрьский (владимирская область) россия / владимирская область / октябрьский (владимирская область)"
  },
  "8456": {
    "id": "8456",
    "name": "Куженкино",
    "path": "Россия / Тверская область / Куженкино",
    "country": "Россия",
    "searchString": "куженкино россия / тверская область / куженкино"
  },
  "8457": {
    "id": "8457",
    "name": "Каменники",
    "path": "Россия / Ярославская область / Каменники",
    "country": "Россия",
    "searchString": "каменники россия / ярославская область / каменники"
  },
  "8458": {
    "id": "8458",
    "name": "Девятины",
    "path": "Россия / Вологодская область / Девятины",
    "country": "Россия",
    "searchString": "девятины россия / вологодская область / девятины"
  },
  "8459": {
    "id": "8459",
    "name": "Грибково",
    "path": "Россия / Вологодская область / Грибково",
    "country": "Россия",
    "searchString": "грибково россия / вологодская область / грибково"
  },
  "8460": {
    "id": "8460",
    "name": "Булатниково",
    "path": "Россия / Владимирская область / Булатниково",
    "country": "Россия",
    "searchString": "булатниково россия / владимирская область / булатниково"
  },
  "8461": {
    "id": "8461",
    "name": "Добрятино",
    "path": "Россия / Владимирская область / Добрятино",
    "country": "Россия",
    "searchString": "добрятино россия / владимирская область / добрятино"
  },
  "8462": {
    "id": "8462",
    "name": "Эсино",
    "path": "Россия / Владимирская область / Эсино",
    "country": "Россия",
    "searchString": "эсино россия / владимирская область / эсино"
  },
  "8463": {
    "id": "8463",
    "name": "Туношна",
    "path": "Россия / Ярославская область / Туношна",
    "country": "Россия",
    "searchString": "туношна россия / ярославская область / туношна"
  },
  "8464": {
    "id": "8464",
    "name": "Старая Торопа",
    "path": "Россия / Тверская область / Старая Торопа",
    "country": "Россия",
    "searchString": "старая торопа россия / тверская область / старая торопа"
  },
  "8465": {
    "id": "8465",
    "name": "Великое",
    "path": "Россия / Ярославская область / Великое",
    "country": "Россия",
    "searchString": "великое россия / ярославская область / великое"
  },
  "8466": {
    "id": "8466",
    "name": "Октябрь",
    "path": "Россия / Ярославская область / Октябрь",
    "country": "Россия",
    "searchString": "октябрь россия / ярославская область / октябрь"
  },
  "8467": {
    "id": "8467",
    "name": "Анопино",
    "path": "Россия / Владимирская область / Анопино",
    "country": "Россия",
    "searchString": "анопино россия / владимирская область / анопино"
  },
  "8468": {
    "id": "8468",
    "name": "Советское (Владимирская область)",
    "path": "Россия / Владимирская область / Советское (Владимирская область)",
    "country": "Россия",
    "searchString": "советское (владимирская область) россия / владимирская область / советское (владимирская область)"
  },
  "8469": {
    "id": "8469",
    "name": "Малыгино",
    "path": "Россия / Владимирская область / Малыгино",
    "country": "Россия",
    "searchString": "малыгино россия / владимирская область / малыгино"
  },
  "8470": {
    "id": "8470",
    "name": "Ивановское (Ярославская область)",
    "path": "Россия / Ярославская область / Ивановское (Ярославская область)",
    "country": "Россия",
    "searchString": "ивановское (ярославская область) россия / ярославская область / ивановское (ярославская область)"
  },
  "8471": {
    "id": "8471",
    "name": "Дмитриевы Горы",
    "path": "Россия / Владимирская область / Дмитриевы Горы",
    "country": "Россия",
    "searchString": "дмитриевы горы россия / владимирская область / дмитриевы горы"
  },
  "8472": {
    "id": "8472",
    "name": "Рослятино",
    "path": "Россия / Вологодская область / Рослятино",
    "country": "Россия",
    "searchString": "рослятино россия / вологодская область / рослятино"
  },
  "8473": {
    "id": "8473",
    "name": "Панфилово (Владимирская область)",
    "path": "Россия / Владимирская область / Панфилово (Владимирская область)",
    "country": "Россия",
    "searchString": "панфилово (владимирская область) россия / владимирская область / панфилово (владимирская область)"
  },
  "8474": {
    "id": "8474",
    "name": "Сергеиха",
    "path": "Россия / Владимирская область / Сергеиха",
    "country": "Россия",
    "searchString": "сергеиха россия / владимирская область / сергеиха"
  },
  "8475": {
    "id": "8475",
    "name": "Стогинское",
    "path": "Россия / Ярославская область / Стогинское",
    "country": "Россия",
    "searchString": "стогинское россия / ярославская область / стогинское"
  },
  "8476": {
    "id": "8476",
    "name": "Фоминки",
    "path": "Россия / Владимирская область / Фоминки",
    "country": "Россия",
    "searchString": "фоминки россия / владимирская область / фоминки"
  },
  "8477": {
    "id": "8477",
    "name": "Анашкино",
    "path": "Россия / Вологодская область / Анашкино",
    "country": "Россия",
    "searchString": "анашкино россия / вологодская область / анашкино"
  },
  "8478": {
    "id": "8478",
    "name": "Талицы",
    "path": "Россия / Вологодская область / Талицы",
    "country": "Россия",
    "searchString": "талицы россия / вологодская область / талицы"
  },
  "8479": {
    "id": "8479",
    "name": "Якиманская Слобода",
    "path": "Россия / Владимирская область / Якиманская Слобода",
    "country": "Россия",
    "searchString": "якиманская слобода россия / владимирская область / якиманская слобода"
  },
  "8480": {
    "id": "8480",
    "name": "Садовый (Владимирская область)",
    "path": "Россия / Владимирская область / Садовый (Владимирская область)",
    "country": "Россия",
    "searchString": "садовый (владимирская область) россия / владимирская область / садовый (владимирская область)"
  },
  "8481": {
    "id": "8481",
    "name": "Красный Профинтерн",
    "path": "Россия / Ярославская область / Красный Профинтерн",
    "country": "Россия",
    "searchString": "красный профинтерн россия / ярославская область / красный профинтерн"
  },
  "8482": {
    "id": "8482",
    "name": "Рязанцево",
    "path": "Россия / Ярославская область / Рязанцево",
    "country": "Россия",
    "searchString": "рязанцево россия / ярославская область / рязанцево"
  },
  "8483": {
    "id": "8483",
    "name": "Георгиевское",
    "path": "Россия / Костромская область / Георгиевское",
    "country": "Россия",
    "searchString": "георгиевское россия / костромская область / георгиевское"
  },
  "8484": {
    "id": "8484",
    "name": "Подозерский",
    "path": "Россия / Ивановская область / Подозерский",
    "country": "Россия",
    "searchString": "подозерский россия / ивановская область / подозерский"
  },
  "8485": {
    "id": "8485",
    "name": "Филино",
    "path": "Россия / Ивановская область / Филино",
    "country": "Россия",
    "searchString": "филино россия / ивановская область / филино"
  },
  "8486": {
    "id": "8486",
    "name": "Карла Маркса",
    "path": "Россия / Владимирская область / Карла Маркса",
    "country": "Россия",
    "searchString": "карла маркса россия / владимирская область / карла маркса"
  },
  "8487": {
    "id": "8487",
    "name": "Хохлово",
    "path": "Россия / Вологодская область / Хохлово",
    "country": "Россия",
    "searchString": "хохлово россия / вологодская область / хохлово"
  },
  "8488": {
    "id": "8488",
    "name": "Мокеевское",
    "path": "Россия / Ярославская область / Мокеевское",
    "country": "Россия",
    "searchString": "мокеевское россия / ярославская область / мокеевское"
  },
  "8489": {
    "id": "8489",
    "name": "Китово",
    "path": "Россия / Ивановская область / Китово",
    "country": "Россия",
    "searchString": "китово россия / ивановская область / китово"
  },
  "8490": {
    "id": "8490",
    "name": "Писцово",
    "path": "Россия / Ивановская область / Писцово",
    "country": "Россия",
    "searchString": "писцово россия / ивановская область / писцово"
  },
  "8491": {
    "id": "8491",
    "name": "Покровка (Вологодская область)",
    "path": "Россия / Вологодская область / Покровка (Вологодская область)",
    "country": "Россия",
    "searchString": "покровка (вологодская область) россия / вологодская область / покровка (вологодская область)"
  },
  "8492": {
    "id": "8492",
    "name": "Зебляки",
    "path": "Россия / Костромская область / Зебляки",
    "country": "Россия",
    "searchString": "зебляки россия / костромская область / зебляки"
  },
  "8493": {
    "id": "8493",
    "name": "Усть-Алексеево",
    "path": "Россия / Вологодская область / Усть-Алексеево",
    "country": "Россия",
    "searchString": "усть-алексеево россия / вологодская область / усть-алексеево"
  },
  "8494": {
    "id": "8494",
    "name": "Кузнечиха",
    "path": "Россия / Ярославская область / Кузнечиха",
    "country": "Россия",
    "searchString": "кузнечиха россия / ярославская область / кузнечиха"
  },
  "8495": {
    "id": "8495",
    "name": "Новленское",
    "path": "Россия / Вологодская область / Новленское",
    "country": "Россия",
    "searchString": "новленское россия / вологодская область / новленское"
  },
  "8496": {
    "id": "8496",
    "name": "Шопша",
    "path": "Россия / Ярославская область / Шопша",
    "country": "Россия",
    "searchString": "шопша россия / ярославская область / шопша"
  },
  "8497": {
    "id": "8497",
    "name": "Муромский",
    "path": "Россия / Владимирская область / Муромский",
    "country": "Россия",
    "searchString": "муромский россия / владимирская область / муромский"
  },
  "8498": {
    "id": "8498",
    "name": "Нижний Енангск",
    "path": "Россия / Вологодская область / Нижний Енангск",
    "country": "Россия",
    "searchString": "нижний енангск россия / вологодская область / нижний енангск"
  },
  "8499": {
    "id": "8499",
    "name": "Устье",
    "path": "Россия / Вологодская область / Устье",
    "country": "Россия",
    "searchString": "устье россия / вологодская область / устье"
  },
  "8500": {
    "id": "8500",
    "name": "Октябрьский (Ярославская область)",
    "path": "Россия / Ярославская область / Октябрьский (Ярославская область)",
    "country": "Россия",
    "searchString": "октябрьский (ярославская область) россия / ярославская область / октябрьский (ярославская область)"
  },
  "8501": {
    "id": "8501",
    "name": "Торопово",
    "path": "Россия / Вологодская область / Торопово",
    "country": "Россия",
    "searchString": "торопово россия / вологодская область / торопово"
  },
  "8502": {
    "id": "8502",
    "name": "Второво",
    "path": "Россия / Владимирская область / Второво",
    "country": "Россия",
    "searchString": "второво россия / владимирская область / второво"
  },
  "8503": {
    "id": "8503",
    "name": "Новлянка",
    "path": "Россия / Владимирская область / Новлянка",
    "country": "Россия",
    "searchString": "новлянка россия / владимирская область / новлянка"
  },
  "8504": {
    "id": "8504",
    "name": "Максима Горького",
    "path": "Россия / Владимирская область / Максима Горького",
    "country": "Россия",
    "searchString": "максима горького россия / владимирская область / максима горького"
  },
  "8505": {
    "id": "8505",
    "name": "Волга",
    "path": "Россия / Ярославская область / Волга",
    "country": "Россия",
    "searchString": "волга россия / ярославская область / волга"
  },
  "8506": {
    "id": "8506",
    "name": "Пронино",
    "path": "Россия / Костромская область / Пронино",
    "country": "Россия",
    "searchString": "пронино россия / костромская область / пронино"
  },
  "8507": {
    "id": "8507",
    "name": "Мокшино",
    "path": "Россия / Тверская область / Мокшино",
    "country": "Россия",
    "searchString": "мокшино россия / тверская область / мокшино"
  },
  "8508": {
    "id": "8508",
    "name": "Ботово",
    "path": "Россия / Вологодская область / Ботово",
    "country": "Россия",
    "searchString": "ботово россия / вологодская область / ботово"
  },
  "8509": {
    "id": "8509",
    "name": "Новки",
    "path": "Россия / Владимирская область / Новки",
    "country": "Россия",
    "searchString": "новки россия / владимирская область / новки"
  },
  "8510": {
    "id": "8510",
    "name": "Старый Двор",
    "path": "Россия / Владимирская область / Старый Двор",
    "country": "Россия",
    "searchString": "старый двор россия / владимирская область / старый двор"
  },
  "8511": {
    "id": "8511",
    "name": "Хорошево",
    "path": "Россия / Вологодская область / Хорошево",
    "country": "Россия",
    "searchString": "хорошево россия / вологодская область / хорошево"
  },
  "8512": {
    "id": "8512",
    "name": "Михайловский",
    "path": "Россия / Ярославская область / Михайловский",
    "country": "Россия",
    "searchString": "михайловский россия / ярославская область / михайловский"
  },
  "8513": {
    "id": "8513",
    "name": "Парское",
    "path": "Россия / Ивановская область / Парское",
    "country": "Россия",
    "searchString": "парское россия / ивановская область / парское"
  },
  "8514": {
    "id": "8514",
    "name": "Сухоногово",
    "path": "Россия / Костромская область / Сухоногово",
    "country": "Россия",
    "searchString": "сухоногово россия / костромская область / сухоногово"
  },
  "8515": {
    "id": "8515",
    "name": "Заречный (Ивановская область)",
    "path": "Россия / Ивановская область / Заречный (Ивановская область)",
    "country": "Россия",
    "searchString": "заречный (ивановская область) россия / ивановская область / заречный (ивановская область)"
  },
  "8516": {
    "id": "8516",
    "name": "Городищна",
    "path": "Россия / Вологодская область / Городищна",
    "country": "Россия",
    "searchString": "городищна россия / вологодская область / городищна"
  },
  "8517": {
    "id": "8517",
    "name": "Шекшово",
    "path": "Россия / Ивановская область / Шекшово",
    "country": "Россия",
    "searchString": "шекшово россия / ивановская область / шекшово"
  },
  "8518": {
    "id": "8518",
    "name": "Бавлены",
    "path": "Россия / Владимирская область / Бавлены",
    "country": "Россия",
    "searchString": "бавлены россия / владимирская область / бавлены"
  },
  "8519": {
    "id": "8519",
    "name": "Иванищи",
    "path": "Россия / Владимирская область / Иванищи",
    "country": "Россия",
    "searchString": "иванищи россия / владимирская область / иванищи"
  },
  "8520": {
    "id": "8520",
    "name": "Колпь",
    "path": "Россия / Владимирская область / Колпь",
    "country": "Россия",
    "searchString": "колпь россия / владимирская область / колпь"
  },
  "8521": {
    "id": "8521",
    "name": "Шухободь",
    "path": "Россия / Вологодская область / Шухободь",
    "country": "Россия",
    "searchString": "шухободь россия / вологодская область / шухободь"
  },
  "8522": {
    "id": "8522",
    "name": "Шоша",
    "path": "Россия / Тверская область / Шоша",
    "country": "Россия",
    "searchString": "шоша россия / тверская область / шоша"
  },
  "8523": {
    "id": "8523",
    "name": "Заозерье",
    "path": "Россия / Ярославская область / Заозерье",
    "country": "Россия",
    "searchString": "заозерье россия / ярославская область / заозерье"
  },
  "8524": {
    "id": "8524",
    "name": "Пестрецово",
    "path": "Россия / Ярославская область / Пестрецово",
    "country": "Россия",
    "searchString": "пестрецово россия / ярославская область / пестрецово"
  },
  "8525": {
    "id": "8525",
    "name": "Балахта (Тверская область)",
    "path": "Россия / Тверская область / Балахта (Тверская область)",
    "country": "Россия",
    "searchString": "балахта (тверская область) россия / тверская область / балахта (тверская область)"
  },
  "8526": {
    "id": "8526",
    "name": "Уршельский",
    "path": "Россия / Владимирская область / Уршельский",
    "country": "Россия",
    "searchString": "уршельский россия / владимирская область / уршельский"
  },
  "8527": {
    "id": "8527",
    "name": "Григорьево",
    "path": "Россия / Владимирская область / Григорьево",
    "country": "Россия",
    "searchString": "григорьево россия / владимирская область / григорьево"
  },
  "8528": {
    "id": "8528",
    "name": "Борисово-Судское",
    "path": "Россия / Вологодская область / Борисово-Судское",
    "country": "Россия",
    "searchString": "борисово-судское россия / вологодская область / борисово-судское"
  },
  "8529": {
    "id": "8529",
    "name": "Березайка",
    "path": "Россия / Тверская область / Березайка",
    "country": "Россия",
    "searchString": "березайка россия / тверская область / березайка"
  },
  "8530": {
    "id": "8530",
    "name": "Октябрьская (Владимирская область)",
    "path": "Россия / Владимирская область / Октябрьская (Владимирская область)",
    "country": "Россия",
    "searchString": "октябрьская (владимирская область) россия / владимирская область / октябрьская (владимирская область)"
  },
  "8531": {
    "id": "8531",
    "name": "Середа",
    "path": "Россия / Ярославская область / Середа",
    "country": "Россия",
    "searchString": "середа россия / ярославская область / середа"
  },
  "8532": {
    "id": "8532",
    "name": "Шулма",
    "path": "Россия / Вологодская область / Шулма",
    "country": "Россия",
    "searchString": "шулма россия / вологодская область / шулма"
  },
  "8533": {
    "id": "8533",
    "name": "Дюдьково",
    "path": "Россия / Ярославская область / Дюдьково",
    "country": "Россия",
    "searchString": "дюдьково россия / ярославская область / дюдьково"
  },
  "8534": {
    "id": "8534",
    "name": "Киево",
    "path": "Россия / Ярославская область / Киево",
    "country": "Россия",
    "searchString": "киево россия / ярославская область / киево"
  },
  "8535": {
    "id": "8535",
    "name": "Гремячий",
    "path": "Россия / Вологодская область / Гремячий",
    "country": "Россия",
    "searchString": "гремячий россия / вологодская область / гремячий"
  },
  "8536": {
    "id": "8536",
    "name": "Бурмакино",
    "path": "Россия / Ярославская область / Бурмакино",
    "country": "Россия",
    "searchString": "бурмакино россия / ярославская область / бурмакино"
  },
  "8537": {
    "id": "8537",
    "name": "Дмитриановское",
    "path": "Россия / Ярославская область / Дмитриановское",
    "country": "Россия",
    "searchString": "дмитриановское россия / ярославская область / дмитриановское"
  },
  "8538": {
    "id": "8538",
    "name": "Бережное",
    "path": "Россия / Вологодская область / Бережное",
    "country": "Россия",
    "searchString": "бережное россия / вологодская область / бережное"
  },
  "8539": {
    "id": "8539",
    "name": "Великодворский",
    "path": "Россия / Владимирская область / Великодворский",
    "country": "Россия",
    "searchString": "великодворский россия / владимирская область / великодворский"
  },
  "8540": {
    "id": "8540",
    "name": "Каминский",
    "path": "Россия / Ивановская область / Каминский",
    "country": "Россия",
    "searchString": "каминский россия / ивановская область / каминский"
  },
  "8541": {
    "id": "8541",
    "name": "Паустово",
    "path": "Россия / Владимирская область / Паустово",
    "country": "Россия",
    "searchString": "паустово россия / владимирская область / паустово"
  },
  "8542": {
    "id": "8542",
    "name": "Лесная Поляна",
    "path": "Россия / Ярославская область / Лесная Поляна",
    "country": "Россия",
    "searchString": "лесная поляна россия / ярославская область / лесная поляна"
  },
  "8543": {
    "id": "8543",
    "name": "Шихобалово",
    "path": "Россия / Владимирская область / Шихобалово",
    "country": "Россия",
    "searchString": "шихобалово россия / владимирская область / шихобалово"
  },
  "8544": {
    "id": "8544",
    "name": "Семенково",
    "path": "Россия / Вологодская область / Семенково",
    "country": "Россия",
    "searchString": "семенково россия / вологодская область / семенково"
  },
  "8545": {
    "id": "8545",
    "name": "Филисово",
    "path": "Россия / Ивановская область / Филисово",
    "country": "Россия",
    "searchString": "филисово россия / ивановская область / филисово"
  },
  "8546": {
    "id": "8546",
    "name": "Красное Эхо",
    "path": "Россия / Владимирская область / Красное Эхо",
    "country": "Россия",
    "searchString": "красное эхо россия / владимирская область / красное эхо"
  },
  "8547": {
    "id": "8547",
    "name": "Красномайский",
    "path": "Россия / Тверская область / Красномайский",
    "country": "Россия",
    "searchString": "красномайский россия / тверская область / красномайский"
  },
  "8548": {
    "id": "8548",
    "name": "Новое Леушино",
    "path": "Россия / Ивановская область / Новое Леушино",
    "country": "Россия",
    "searchString": "новое леушино россия / ивановская область / новое леушино"
  },
  "8549": {
    "id": "8549",
    "name": "Семеновское (Ярославская область)",
    "path": "Россия / Ярославская область / Семеновское (Ярославская область)",
    "country": "Россия",
    "searchString": "семеновское (ярославская область) россия / ярославская область / семеновское (ярославская область)"
  },
  "8550": {
    "id": "8550",
    "name": "Песочное",
    "path": "Россия / Ярославская область / Песочное",
    "country": "Россия",
    "searchString": "песочное россия / ярославская область / песочное"
  },
  "8551": {
    "id": "8551",
    "name": "Илькино",
    "path": "Россия / Владимирская область / Илькино",
    "country": "Россия",
    "searchString": "илькино россия / владимирская область / илькино"
  },
  "8552": {
    "id": "8552",
    "name": "Воробьево",
    "path": "Россия / Вологодская область / Воробьево",
    "country": "Россия",
    "searchString": "воробьево россия / вологодская область / воробьево"
  },
  "8553": {
    "id": "8553",
    "name": "База",
    "path": "Россия / Вологодская область / База",
    "country": "Россия",
    "searchString": "база россия / вологодская область / база"
  },
  "8554": {
    "id": "8554",
    "name": "Луговое (Ивановская область)",
    "path": "Россия / Ивановская область / Луговое (Ивановская область)",
    "country": "Россия",
    "searchString": "луговое (ивановская область) россия / ивановская область / луговое (ивановская область)"
  },
  "8555": {
    "id": "8555",
    "name": "Чушевицы",
    "path": "Россия / Вологодская область / Чушевицы",
    "country": "Россия",
    "searchString": "чушевицы россия / вологодская область / чушевицы"
  },
  "8556": {
    "id": "8556",
    "name": "Тихменево",
    "path": "Россия / Ярославская область / Тихменево",
    "country": "Россия",
    "searchString": "тихменево россия / ярославская область / тихменево"
  },
  "8557": {
    "id": "8557",
    "name": "Мошок",
    "path": "Россия / Владимирская область / Мошок",
    "country": "Россия",
    "searchString": "мошок россия / владимирская область / мошок"
  },
  "8558": {
    "id": "8558",
    "name": "Ляхи",
    "path": "Россия / Владимирская область / Ляхи",
    "country": "Россия",
    "searchString": "ляхи россия / владимирская область / ляхи"
  },
  "8559": {
    "id": "8559",
    "name": "Коротово",
    "path": "Россия / Вологодская область / Коротово",
    "country": "Россия",
    "searchString": "коротово россия / вологодская область / коротово"
  },
  "8560": {
    "id": "8560",
    "name": "Бурашево",
    "path": "Россия / Тверская область / Бурашево",
    "country": "Россия",
    "searchString": "бурашево россия / тверская область / бурашево"
  },
  "8561": {
    "id": "8561",
    "name": "Никульское",
    "path": "Россия / Ярославская область / Никульское",
    "country": "Россия",
    "searchString": "никульское россия / ярославская область / никульское"
  },
  "8562": {
    "id": "8562",
    "name": "Ломоватка",
    "path": "Россия / Вологодская область / Ломоватка",
    "country": "Россия",
    "searchString": "ломоватка россия / вологодская область / ломоватка"
  },
  "8563": {
    "id": "8563",
    "name": "Суда",
    "path": "Россия / Вологодская область / Суда",
    "country": "Россия",
    "searchString": "суда россия / вологодская область / суда"
  },
  "8564": {
    "id": "8564",
    "name": "Кукобой",
    "path": "Россия / Ярославская область / Кукобой",
    "country": "Россия",
    "searchString": "кукобой россия / ярославская область / кукобой"
  },
  "8565": {
    "id": "8565",
    "name": "Озерный (Тверская область)",
    "path": "Россия / Тверская область / Озерный (Тверская область)",
    "country": "Россия",
    "searchString": "озерный (тверская область) россия / тверская область / озерный (тверская область)"
  },
  "8566": {
    "id": "8566",
    "name": "Белый Городок",
    "path": "Россия / Тверская область / Белый Городок",
    "country": "Россия",
    "searchString": "белый городок россия / тверская область / белый городок"
  },
  "8567": {
    "id": "8567",
    "name": "Станция Мстера (Вязниковский район)",
    "path": "Россия / Владимирская область / Станция Мстера (Вязниковский район)",
    "country": "Россия",
    "searchString": "станция мстера (вязниковский район) россия / владимирская область / станция мстера (вязниковский район)"
  },
  "8568": {
    "id": "8568",
    "name": "Поселок фабрики им. Войкова",
    "path": "Россия / Владимирская область / Поселок фабрики им. Войкова",
    "country": "Россия",
    "searchString": "поселок фабрики им. войкова россия / владимирская область / поселок фабрики им. войкова"
  },
  "8569": {
    "id": "8569",
    "name": "Можайское",
    "path": "Россия / Вологодская область / Можайское",
    "country": "Россия",
    "searchString": "можайское россия / вологодская область / можайское"
  },
  "8570": {
    "id": "8570",
    "name": "Курба",
    "path": "Россия / Ярославская область / Курба",
    "country": "Россия",
    "searchString": "курба россия / ярославская область / курба"
  },
  "8571": {
    "id": "8571",
    "name": "Аньково",
    "path": "Россия / Ивановская область / Аньково",
    "country": "Россия",
    "searchString": "аньково россия / ивановская область / аньково"
  },
  "8572": {
    "id": "8572",
    "name": "Мякса",
    "path": "Россия / Вологодская область / Мякса",
    "country": "Россия",
    "searchString": "мякса россия / вологодская область / мякса"
  },
  "8573": {
    "id": "8573",
    "name": "Дубровское",
    "path": "Россия / Вологодская область / Дубровское",
    "country": "Россия",
    "searchString": "дубровское россия / вологодская область / дубровское"
  },
  "8574": {
    "id": "8574",
    "name": "Решма",
    "path": "Россия / Ивановская область / Решма",
    "country": "Россия",
    "searchString": "решма россия / ивановская область / решма"
  },
  "8575": {
    "id": "8575",
    "name": "Золотково",
    "path": "Россия / Владимирская область / Золотково",
    "country": "Россия",
    "searchString": "золотково россия / владимирская область / золотково"
  },
  "8576": {
    "id": "8576",
    "name": "Чулково (Владимирская область)",
    "path": "Россия / Владимирская область / Чулково (Владимирская область)",
    "country": "Россия",
    "searchString": "чулково (владимирская область) россия / владимирская область / чулково (владимирская область)"
  },
  "8577": {
    "id": "8577",
    "name": "Гусевский",
    "path": "Россия / Владимирская область / Гусевский",
    "country": "Россия",
    "searchString": "гусевский россия / владимирская область / гусевский"
  },
  "8578": {
    "id": "8578",
    "name": "Ермаково",
    "path": "Россия / Вологодская область / Ермаково",
    "country": "Россия",
    "searchString": "ермаково россия / вологодская область / ермаково"
  },
  "8579": {
    "id": "8579",
    "name": "Рождественское",
    "path": "Россия / Костромская область / Рождественское",
    "country": "Россия",
    "searchString": "рождественское россия / костромская область / рождественское"
  },
  "8580": {
    "id": "8580",
    "name": "Чаадаево",
    "path": "Россия / Владимирская область / Чаадаево",
    "country": "Россия",
    "searchString": "чаадаево россия / владимирская область / чаадаево"
  },
  "8581": {
    "id": "8581",
    "name": "Зубово",
    "path": "Россия / Вологодская область / Зубово",
    "country": "Россия",
    "searchString": "зубово россия / вологодская область / зубово"
  },
  "8582": {
    "id": "8582",
    "name": "Белая Речка",
    "path": "Россия / Владимирская область / Белая Речка",
    "country": "Россия",
    "searchString": "белая речка россия / владимирская область / белая речка"
  },
  "8583": {
    "id": "8583",
    "name": "Новые Горки",
    "path": "Россия / Ивановская область / Новые Горки",
    "country": "Россия",
    "searchString": "новые горки россия / ивановская область / новые горки"
  },
  "8584": {
    "id": "8584",
    "name": "Чаромское",
    "path": "Россия / Вологодская область / Чаромское",
    "country": "Россия",
    "searchString": "чаромское россия / вологодская область / чаромское"
  },
  "8585": {
    "id": "8585",
    "name": "Бутылицы",
    "path": "Россия / Владимирская область / Бутылицы",
    "country": "Россия",
    "searchString": "бутылицы россия / владимирская область / бутылицы"
  },
  "8586": {
    "id": "8586",
    "name": "Осановец",
    "path": "Россия / Ивановская область / Осановец",
    "country": "Россия",
    "searchString": "осановец россия / ивановская область / осановец"
  },
  "8587": {
    "id": "8587",
    "name": "Николо-Полома",
    "path": "Россия / Костромская область / Николо-Полома",
    "country": "Россия",
    "searchString": "николо-полома россия / костромская область / николо-полома"
  },
  "8588": {
    "id": "8588",
    "name": "Марково (Ивановская область)",
    "path": "Россия / Ивановская область / Марково (Ивановская область)",
    "country": "Россия",
    "searchString": "марково (ивановская область) россия / ивановская область / марково (ивановская область)"
  },
  "8589": {
    "id": "8589",
    "name": "Глебовское",
    "path": "Россия / Ярославская область / Глебовское",
    "country": "Россия",
    "searchString": "глебовское россия / ярославская область / глебовское"
  },
  "8590": {
    "id": "8590",
    "name": "Зименки",
    "path": "Россия / Владимирская область / Зименки",
    "country": "Россия",
    "searchString": "зименки россия / владимирская область / зименки"
  },
  "8591": {
    "id": "8591",
    "name": "Белогостицы",
    "path": "Россия / Ярославская область / Белогостицы",
    "country": "Россия",
    "searchString": "белогостицы россия / ярославская область / белогостицы"
  },
  "8592": {
    "id": "8592",
    "name": "Нифантово",
    "path": "Россия / Вологодская область / Нифантово",
    "country": "Россия",
    "searchString": "нифантово россия / вологодская область / нифантово"
  },
  "8593": {
    "id": "8593",
    "name": "Верхний Ландех",
    "path": "Россия / Ивановская область / Верхний Ландех",
    "country": "Россия",
    "searchString": "верхний ландех россия / ивановская область / верхний ландех"
  },
  "8594": {
    "id": "8594",
    "name": "Степанцево",
    "path": "Россия / Владимирская область / Степанцево",
    "country": "Россия",
    "searchString": "степанцево россия / владимирская область / степанцево"
  },
  "8595": {
    "id": "8595",
    "name": "Огарково",
    "path": "Россия / Вологодская область / Огарково",
    "country": "Россия",
    "searchString": "огарково россия / вологодская область / огарково"
  },
  "8596": {
    "id": "8596",
    "name": "Дубки (Ярославская область)",
    "path": "Россия / Ярославская область / Дубки (Ярославская область)",
    "country": "Россия",
    "searchString": "дубки (ярославская область) россия / ярославская область / дубки (ярославская область)"
  },
  "8597": {
    "id": "8597",
    "name": "Вятское",
    "path": "Россия / Ярославская область / Вятское",
    "country": "Россия",
    "searchString": "вятское россия / ярославская область / вятское"
  },
  "8598": {
    "id": "8598",
    "name": "Ивняки",
    "path": "Россия / Ярославская область / Ивняки",
    "country": "Россия",
    "searchString": "ивняки россия / ярославская область / ивняки"
  },
  "8599": {
    "id": "8599",
    "name": "Аргуново",
    "path": "Россия / Вологодская область / Аргуново",
    "country": "Россия",
    "searchString": "аргуново россия / вологодская область / аргуново"
  },
  "8600": {
    "id": "8600",
    "name": "Васильевское",
    "path": "Россия / Вологодская область / Васильевское",
    "country": "Россия",
    "searchString": "васильевское россия / вологодская область / васильевское"
  },
  "8601": {
    "id": "8601",
    "name": "Нагорье",
    "path": "Россия / Ярославская область / Нагорье",
    "country": "Россия",
    "searchString": "нагорье россия / ярославская область / нагорье"
  },
  "8602": {
    "id": "8602",
    "name": "Сурково",
    "path": "Россия / Вологодская область / Сурково",
    "country": "Россия",
    "searchString": "сурково россия / вологодская область / сурково"
  },
  "8603": {
    "id": "8603",
    "name": "Майдаково",
    "path": "Россия / Ивановская область / Майдаково",
    "country": "Россия",
    "searchString": "майдаково россия / ивановская область / майдаково"
  },
  "8604": {
    "id": "8604",
    "name": "Малышево",
    "path": "Россия / Владимирская область / Малышево",
    "country": "Россия",
    "searchString": "малышево россия / владимирская область / малышево"
  },
  "8605": {
    "id": "8605",
    "name": "Борок",
    "path": "Россия / Вологодская область / Борок",
    "country": "Россия",
    "searchString": "борок россия / вологодская область / борок"
  },
  "8606": {
    "id": "8606",
    "name": "Мстера (Вязниковский район)",
    "path": "Россия / Владимирская область / Мстера (Вязниковский район)",
    "country": "Россия",
    "searchString": "мстера (вязниковский район) россия / владимирская область / мстера (вязниковский район)"
  },
  "8607": {
    "id": "8607",
    "name": "Нерль",
    "path": "Россия / Ивановская область / Нерль",
    "country": "Россия",
    "searchString": "нерль россия / ивановская область / нерль"
  },
  "8608": {
    "id": "8608",
    "name": "Остахово",
    "path": "Россия / Вологодская область / Остахово",
    "country": "Россия",
    "searchString": "остахово россия / вологодская область / остахово"
  },
  "8609": {
    "id": "8609",
    "name": "Пяжелка",
    "path": "Россия / Вологодская область / Пяжелка",
    "country": "Россия",
    "searchString": "пяжелка россия / вологодская область / пяжелка"
  },
  "8610": {
    "id": "8610",
    "name": "Мезиновский",
    "path": "Россия / Владимирская область / Мезиновский",
    "country": "Россия",
    "searchString": "мезиновский россия / владимирская область / мезиновский"
  },
  "8611": {
    "id": "8611",
    "name": "Юрово",
    "path": "Россия / Вологодская область / Юрово",
    "country": "Россия",
    "searchString": "юрово россия / вологодская область / юрово"
  },
  "8612": {
    "id": "8612",
    "name": "Октябрьский (Ивановская область)",
    "path": "Россия / Ивановская область / Октябрьский (Ивановская область)",
    "country": "Россия",
    "searchString": "октябрьский (ивановская область) россия / ивановская область / октябрьский (ивановская область)"
  },
  "8613": {
    "id": "8613",
    "name": "Достижение",
    "path": "Россия / Владимирская область / Достижение",
    "country": "Россия",
    "searchString": "достижение россия / владимирская область / достижение"
  },
  "8614": {
    "id": "8614",
    "name": "Небылое",
    "path": "Россия / Владимирская область / Небылое",
    "country": "Россия",
    "searchString": "небылое россия / владимирская область / небылое"
  },
  "8615": {
    "id": "8615",
    "name": "Сазоново",
    "path": "Россия / Вологодская область / Сазоново",
    "country": "Россия",
    "searchString": "сазоново россия / вологодская область / сазоново"
  },
  "8616": {
    "id": "8616",
    "name": "Кесова Гора",
    "path": "Россия / Тверская область / Кесова Гора",
    "country": "Россия",
    "searchString": "кесова гора россия / тверская область / кесова гора"
  },
  "8617": {
    "id": "8617",
    "name": "Климатино",
    "path": "Россия / Ярославская область / Климатино",
    "country": "Россия",
    "searchString": "климатино россия / ярославская область / климатино"
  },
  "8618": {
    "id": "8618",
    "name": "Сима",
    "path": "Россия / Владимирская область / Сима",
    "country": "Россия",
    "searchString": "сима россия / владимирская область / сима"
  },
  "8619": {
    "id": "8619",
    "name": "Сандово",
    "path": "Россия / Тверская область / Сандово",
    "country": "Россия",
    "searchString": "сандово россия / тверская область / сандово"
  },
  "8620": {
    "id": "8620",
    "name": "Кокшарка",
    "path": "Россия / Вологодская область / Кокшарка",
    "country": "Россия",
    "searchString": "кокшарка россия / вологодская область / кокшарка"
  },
  "8621": {
    "id": "8621",
    "name": "Удачное",
    "path": "Россия / Астраханская область / Удачное",
    "country": "Россия",
    "searchString": "удачное россия / астраханская область / удачное"
  },
  "8622": {
    "id": "8622",
    "name": "Кринично-Лугский",
    "path": "Россия / Ростовская область / Кринично-Лугский",
    "country": "Россия",
    "searchString": "кринично-лугский россия / ростовская область / кринично-лугский"
  },
  "8623": {
    "id": "8623",
    "name": "Мирный (Ростовская область)",
    "path": "Россия / Ростовская область / Мирный (Ростовская область)",
    "country": "Россия",
    "searchString": "мирный (ростовская область) россия / ростовская область / мирный (ростовская область)"
  },
  "8624": {
    "id": "8624",
    "name": "Журавка",
    "path": "Россия / Волгоградская область / Журавка",
    "country": "Россия",
    "searchString": "журавка россия / волгоградская область / журавка"
  },
  "8625": {
    "id": "8625",
    "name": "Малокирсановка",
    "path": "Россия / Ростовская область / Малокирсановка",
    "country": "Россия",
    "searchString": "малокирсановка россия / ростовская область / малокирсановка"
  },
  "8626": {
    "id": "8626",
    "name": "Можаевка",
    "path": "Россия / Ростовская область / Можаевка",
    "country": "Россия",
    "searchString": "можаевка россия / ростовская область / можаевка"
  },
  "8627": {
    "id": "8627",
    "name": "Поселок совхоза АМО",
    "path": "Россия / Волгоградская область / Поселок совхоза АМО",
    "country": "Россия",
    "searchString": "поселок совхоза амо россия / волгоградская область / поселок совхоза амо"
  },
  "8628": {
    "id": "8628",
    "name": "Верхняя Бузиновка",
    "path": "Россия / Волгоградская область / Верхняя Бузиновка",
    "country": "Россия",
    "searchString": "верхняя бузиновка россия / волгоградская область / верхняя бузиновка"
  },
  "8629": {
    "id": "8629",
    "name": "Харьковка",
    "path": "Россия / Волгоградская область / Харьковка",
    "country": "Россия",
    "searchString": "харьковка россия / волгоградская область / харьковка"
  },
  "8630": {
    "id": "8630",
    "name": "Деминский",
    "path": "Россия / Волгоградская область / Деминский",
    "country": "Россия",
    "searchString": "деминский россия / волгоградская область / деминский"
  },
  "8631": {
    "id": "8631",
    "name": "Красное Знамя",
    "path": "Россия / Ростовская область / Красное Знамя",
    "country": "Россия",
    "searchString": "красное знамя россия / ростовская область / красное знамя"
  },
  "8632": {
    "id": "8632",
    "name": "Салтово",
    "path": "Россия / Волгоградская область / Салтово",
    "country": "Россия",
    "searchString": "салтово россия / волгоградская область / салтово"
  },
  "8633": {
    "id": "8633",
    "name": "Калининский",
    "path": "Россия / Ростовская область / Калининский",
    "country": "Россия",
    "searchString": "калининский россия / ростовская область / калининский"
  },
  "8634": {
    "id": "8634",
    "name": "Селивановская",
    "path": "Россия / Ростовская область / Селивановская",
    "country": "Россия",
    "searchString": "селивановская россия / ростовская область / селивановская"
  },
  "8635": {
    "id": "8635",
    "name": "Семибалки",
    "path": "Россия / Ростовская область / Семибалки",
    "country": "Россия",
    "searchString": "семибалки россия / ростовская область / семибалки"
  },
  "8636": {
    "id": "8636",
    "name": "Светлоречное",
    "path": "Россия / Ростовская область / Светлоречное",
    "country": "Россия",
    "searchString": "светлоречное россия / ростовская область / светлоречное"
  },
  "8637": {
    "id": "8637",
    "name": "Атамановка (Волгоградская область)",
    "path": "Россия / Волгоградская область / Атамановка (Волгоградская область)",
    "country": "Россия",
    "searchString": "атамановка (волгоградская область) россия / волгоградская область / атамановка (волгоградская область)"
  },
  "8638": {
    "id": "8638",
    "name": "Маркин",
    "path": "Россия / Ростовская область / Маркин",
    "country": "Россия",
    "searchString": "маркин россия / ростовская область / маркин"
  },
  "8639": {
    "id": "8639",
    "name": "Золотари",
    "path": "Россия / Волгоградская область / Золотари",
    "country": "Россия",
    "searchString": "золотари россия / волгоградская область / золотари"
  },
  "8640": {
    "id": "8640",
    "name": "Рябичев",
    "path": "Россия / Ростовская область / Рябичев",
    "country": "Россия",
    "searchString": "рябичев россия / ростовская область / рябичев"
  },
  "8641": {
    "id": "8641",
    "name": "Криворожье",
    "path": "Россия / Ростовская область / Криворожье",
    "country": "Россия",
    "searchString": "криворожье россия / ростовская область / криворожье"
  },
  "8642": {
    "id": "8642",
    "name": "Шелестово",
    "path": "Россия / Волгоградская область / Шелестово",
    "country": "Россия",
    "searchString": "шелестово россия / волгоградская область / шелестово"
  },
  "8643": {
    "id": "8643",
    "name": "Искра (Волгоградская область)",
    "path": "Россия / Волгоградская область / Искра (Волгоградская область)",
    "country": "Россия",
    "searchString": "искра (волгоградская область) россия / волгоградская область / искра (волгоградская область)"
  },
  "8644": {
    "id": "8644",
    "name": "Ольховый Рог",
    "path": "Россия / Ростовская область / Ольховый Рог",
    "country": "Россия",
    "searchString": "ольховый рог россия / ростовская область / ольховый рог"
  },
  "8645": {
    "id": "8645",
    "name": "Верхнесоленый",
    "path": "Россия / Ростовская область / Верхнесоленый",
    "country": "Россия",
    "searchString": "верхнесоленый россия / ростовская область / верхнесоленый"
  },
  "8646": {
    "id": "8646",
    "name": "Денисов",
    "path": "Россия / Ростовская область / Денисов",
    "country": "Россия",
    "searchString": "денисов россия / ростовская область / денисов"
  },
  "8647": {
    "id": "8647",
    "name": "Федоровка (Астраханская область)",
    "path": "Россия / Астраханская область / Федоровка (Астраханская область)",
    "country": "Россия",
    "searchString": "федоровка (астраханская область) россия / астраханская область / федоровка (астраханская область)"
  },
  "8648": {
    "id": "8648",
    "name": "Тростянка",
    "path": "Россия / Волгоградская область / Тростянка",
    "country": "Россия",
    "searchString": "тростянка россия / волгоградская область / тростянка"
  },
  "8649": {
    "id": "8649",
    "name": "Гмелинка",
    "path": "Россия / Волгоградская область / Гмелинка",
    "country": "Россия",
    "searchString": "гмелинка россия / волгоградская область / гмелинка"
  },
  "8650": {
    "id": "8650",
    "name": "Камышев",
    "path": "Россия / Ростовская область / Камышев",
    "country": "Россия",
    "searchString": "камышев россия / ростовская область / камышев"
  },
  "8651": {
    "id": "8651",
    "name": "Верхнегрушевский",
    "path": "Россия / Ростовская область / Верхнегрушевский",
    "country": "Россия",
    "searchString": "верхнегрушевский россия / ростовская область / верхнегрушевский"
  },
  "8652": {
    "id": "8652",
    "name": "Котлубань",
    "path": "Россия / Волгоградская область / Котлубань",
    "country": "Россия",
    "searchString": "котлубань россия / волгоградская область / котлубань"
  },
  "8653": {
    "id": "8653",
    "name": "Нижнеяблочный",
    "path": "Россия / Волгоградская область / Нижнеяблочный",
    "country": "Россия",
    "searchString": "нижнеяблочный россия / волгоградская область / нижнеяблочный"
  },
  "8654": {
    "id": "8654",
    "name": "Васильево-Шамшево",
    "path": "Россия / Ростовская область / Васильево-Шамшево",
    "country": "Россия",
    "searchString": "васильево-шамшево россия / ростовская область / васильево-шамшево"
  },
  "8655": {
    "id": "8655",
    "name": "Сорговый",
    "path": "Россия / Ростовская область / Сорговый",
    "country": "Россия",
    "searchString": "сорговый россия / ростовская область / сорговый"
  },
  "8656": {
    "id": "8656",
    "name": "Чирский",
    "path": "Россия / Ростовская область / Чирский",
    "country": "Россия",
    "searchString": "чирский россия / ростовская область / чирский"
  },
  "8657": {
    "id": "8657",
    "name": "Оля",
    "path": "Россия / Астраханская область / Оля",
    "country": "Россия",
    "searchString": "оля россия / астраханская область / оля"
  },
  "8658": {
    "id": "8658",
    "name": "Мигулинская",
    "path": "Россия / Ростовская область / Мигулинская",
    "country": "Россия",
    "searchString": "мигулинская россия / ростовская область / мигулинская"
  },
  "8659": {
    "id": "8659",
    "name": "Сохрановка",
    "path": "Россия / Ростовская область / Сохрановка",
    "country": "Россия",
    "searchString": "сохрановка россия / ростовская область / сохрановка"
  },
  "8660": {
    "id": "8660",
    "name": "Верхний Митякин",
    "path": "Россия / Ростовская область / Верхний Митякин",
    "country": "Россия",
    "searchString": "верхний митякин россия / ростовская область / верхний митякин"
  },
  "8661": {
    "id": "8661",
    "name": "Аксай (Волгоградская область)",
    "path": "Россия / Волгоградская область / Аксай (Волгоградская область)",
    "country": "Россия",
    "searchString": "аксай (волгоградская область) россия / волгоградская область / аксай (волгоградская область)"
  },
  "8662": {
    "id": "8662",
    "name": "Чернолагутинский",
    "path": "Россия / Волгоградская область / Чернолагутинский",
    "country": "Россия",
    "searchString": "чернолагутинский россия / волгоградская область / чернолагутинский"
  },
  "8663": {
    "id": "8663",
    "name": "Гусевка",
    "path": "Россия / Волгоградская область / Гусевка",
    "country": "Россия",
    "searchString": "гусевка россия / волгоградская область / гусевка"
  },
  "8664": {
    "id": "8664",
    "name": "Гашун",
    "path": "Россия / Ростовская область / Гашун",
    "country": "Россия",
    "searchString": "гашун россия / ростовская область / гашун"
  },
  "8665": {
    "id": "8665",
    "name": "Чапаев",
    "path": "Россия / Ростовская область / Чапаев",
    "country": "Россия",
    "searchString": "чапаев россия / ростовская область / чапаев"
  },
  "8666": {
    "id": "8666",
    "name": "Ленинаван",
    "path": "Россия / Ростовская область / Ленинаван",
    "country": "Россия",
    "searchString": "ленинаван россия / ростовская область / ленинаван"
  },
  "8667": {
    "id": "8667",
    "name": "Кленовка",
    "path": "Россия / Волгоградская область / Кленовка",
    "country": "Россия",
    "searchString": "кленовка россия / волгоградская область / кленовка"
  },
  "8668": {
    "id": "8668",
    "name": "Зимняцкий",
    "path": "Россия / Волгоградская область / Зимняцкий",
    "country": "Россия",
    "searchString": "зимняцкий россия / волгоградская область / зимняцкий"
  },
  "8669": {
    "id": "8669",
    "name": "Ивановка (Ростовская область)",
    "path": "Россия / Ростовская область / Ивановка (Ростовская область)",
    "country": "Россия",
    "searchString": "ивановка (ростовская область) россия / ростовская область / ивановка (ростовская область)"
  },
  "8670": {
    "id": "8670",
    "name": "Индустриальный (Ростовская область)",
    "path": "Россия / Ростовская область / Индустриальный (Ростовская область)",
    "country": "Россия",
    "searchString": "индустриальный (ростовская область) россия / ростовская область / индустриальный (ростовская область)"
  },
  "8671": {
    "id": "8671",
    "name": "Нижне-Кундрюченская",
    "path": "Россия / Ростовская область / Нижне-Кундрюченская",
    "country": "Россия",
    "searchString": "нижне-кундрюченская россия / ростовская область / нижне-кундрюченская"
  },
  "8672": {
    "id": "8672",
    "name": "Солонецкий",
    "path": "Россия / Ростовская область / Солонецкий",
    "country": "Россия",
    "searchString": "солонецкий россия / ростовская область / солонецкий"
  },
  "8673": {
    "id": "8673",
    "name": "Раздорская",
    "path": "Россия / Ростовская область / Раздорская",
    "country": "Россия",
    "searchString": "раздорская россия / ростовская область / раздорская"
  },
  "8674": {
    "id": "8674",
    "name": "Роговский",
    "path": "Россия / Ростовская область / Роговский",
    "country": "Россия",
    "searchString": "роговский россия / ростовская область / роговский"
  },
  "8675": {
    "id": "8675",
    "name": "Салтынский",
    "path": "Россия / Волгоградская область / Салтынский",
    "country": "Россия",
    "searchString": "салтынский россия / волгоградская область / салтынский"
  },
  "8676": {
    "id": "8676",
    "name": "Богураев",
    "path": "Россия / Ростовская область / Богураев",
    "country": "Россия",
    "searchString": "богураев россия / ростовская область / богураев"
  },
  "8677": {
    "id": "8677",
    "name": "Голубинская",
    "path": "Россия / Волгоградская область / Голубинская",
    "country": "Россия",
    "searchString": "голубинская россия / волгоградская область / голубинская"
  },
  "8678": {
    "id": "8678",
    "name": "Отрадовка",
    "path": "Россия / Ростовская область / Отрадовка",
    "country": "Россия",
    "searchString": "отрадовка россия / ростовская область / отрадовка"
  },
  "8679": {
    "id": "8679",
    "name": "Зубовка (Астраханская область)",
    "path": "Россия / Астраханская область / Зубовка (Астраханская область)",
    "country": "Россия",
    "searchString": "зубовка (астраханская область) россия / астраханская область / зубовка (астраханская область)"
  },
  "8680": {
    "id": "8680",
    "name": "Сиротинская",
    "path": "Россия / Волгоградская область / Сиротинская",
    "country": "Россия",
    "searchString": "сиротинская россия / волгоградская область / сиротинская"
  },
  "8681": {
    "id": "8681",
    "name": "Новороговская",
    "path": "Россия / Ростовская область / Новороговская",
    "country": "Россия",
    "searchString": "новороговская россия / ростовская область / новороговская"
  },
  "8682": {
    "id": "8682",
    "name": "Двуречье",
    "path": "Россия / Ростовская область / Двуречье",
    "country": "Россия",
    "searchString": "двуречье россия / ростовская область / двуречье"
  },
  "8683": {
    "id": "8683",
    "name": "Лозной",
    "path": "Россия / Ростовская область / Лозной",
    "country": "Россия",
    "searchString": "лозной россия / ростовская область / лозной"
  },
  "8684": {
    "id": "8684",
    "name": "Зеленолугский",
    "path": "Россия / Ростовская область / Зеленолугский",
    "country": "Россия",
    "searchString": "зеленолугский россия / ростовская область / зеленолугский"
  },
  "8685": {
    "id": "8685",
    "name": "Малоорловский",
    "path": "Россия / Ростовская область / Малоорловский",
    "country": "Россия",
    "searchString": "малоорловский россия / ростовская область / малоорловский"
  },
  "8686": {
    "id": "8686",
    "name": "Реконструкция",
    "path": "Россия / Волгоградская область / Реконструкция",
    "country": "Россия",
    "searchString": "реконструкция россия / волгоградская область / реконструкция"
  },
  "8687": {
    "id": "8687",
    "name": "Савоськин",
    "path": "Россия / Ростовская область / Савоськин",
    "country": "Россия",
    "searchString": "савоськин россия / ростовская область / савоськин"
  },
  "8688": {
    "id": "8688",
    "name": "Привольный",
    "path": "Россия / Волгоградская область / Привольный",
    "country": "Россия",
    "searchString": "привольный россия / волгоградская область / привольный"
  },
  "8689": {
    "id": "8689",
    "name": "Верхнегнутов",
    "path": "Россия / Волгоградская область / Верхнегнутов",
    "country": "Россия",
    "searchString": "верхнегнутов россия / волгоградская область / верхнегнутов"
  },
  "8690": {
    "id": "8690",
    "name": "Углегорский",
    "path": "Россия / Ростовская область / Углегорский",
    "country": "Россия",
    "searchString": "углегорский россия / ростовская область / углегорский"
  },
  "8691": {
    "id": "8691",
    "name": "Мещеряковский",
    "path": "Россия / Ростовская область / Мещеряковский",
    "country": "Россия",
    "searchString": "мещеряковский россия / ростовская область / мещеряковский"
  },
  "8692": {
    "id": "8692",
    "name": "Нижнегнутов",
    "path": "Россия / Волгоградская область / Нижнегнутов",
    "country": "Россия",
    "searchString": "нижнегнутов россия / волгоградская область / нижнегнутов"
  },
  "8693": {
    "id": "8693",
    "name": "Колундаевский",
    "path": "Россия / Ростовская область / Колундаевский",
    "country": "Россия",
    "searchString": "колундаевский россия / ростовская область / колундаевский"
  },
  "8694": {
    "id": "8694",
    "name": "Интернациональный",
    "path": "Россия / Ростовская область / Интернациональный",
    "country": "Россия",
    "searchString": "интернациональный россия / ростовская область / интернациональный"
  },
  "8695": {
    "id": "8695",
    "name": "Верхний Бузан",
    "path": "Россия / Астраханская область / Верхний Бузан",
    "country": "Россия",
    "searchString": "верхний бузан россия / астраханская область / верхний бузан"
  },
  "8696": {
    "id": "8696",
    "name": "Большекрепинская",
    "path": "Россия / Ростовская область / Большекрепинская",
    "country": "Россия",
    "searchString": "большекрепинская россия / ростовская область / большекрепинская"
  },
  "8697": {
    "id": "8697",
    "name": "Золотаревка",
    "path": "Россия / Ростовская область / Золотаревка",
    "country": "Россия",
    "searchString": "золотаревка россия / ростовская область / золотаревка"
  },
  "8698": {
    "id": "8698",
    "name": "Липовка",
    "path": "Россия / Волгоградская область / Липовка",
    "country": "Россия",
    "searchString": "липовка россия / волгоградская область / липовка"
  },
  "8699": {
    "id": "8699",
    "name": "Россошинский",
    "path": "Россия / Волгоградская область / Россошинский",
    "country": "Россия",
    "searchString": "россошинский россия / волгоградская область / россошинский"
  },
  "8700": {
    "id": "8700",
    "name": "Солонка",
    "path": "Россия / Волгоградская область / Солонка",
    "country": "Россия",
    "searchString": "солонка россия / волгоградская область / солонка"
  },
  "8701": {
    "id": "8701",
    "name": "Верхнеподпольный",
    "path": "Россия / Ростовская область / Верхнеподпольный",
    "country": "Россия",
    "searchString": "верхнеподпольный россия / ростовская область / верхнеподпольный"
  },
  "8702": {
    "id": "8702",
    "name": "Дубенцовская",
    "path": "Россия / Ростовская область / Дубенцовская",
    "country": "Россия",
    "searchString": "дубенцовская россия / ростовская область / дубенцовская"
  },
  "8703": {
    "id": "8703",
    "name": "Камышевка",
    "path": "Россия / Ростовская область / Камышевка",
    "country": "Россия",
    "searchString": "камышевка россия / ростовская область / камышевка"
  },
  "8704": {
    "id": "8704",
    "name": "Новомирский",
    "path": "Россия / Ростовская область / Новомирский",
    "country": "Россия",
    "searchString": "новомирский россия / ростовская область / новомирский"
  },
  "8705": {
    "id": "8705",
    "name": "Ольховчик",
    "path": "Россия / Ростовская область / Ольховчик",
    "country": "Россия",
    "searchString": "ольховчик россия / ростовская область / ольховчик"
  },
  "8706": {
    "id": "8706",
    "name": "Тишково",
    "path": "Россия / Астраханская область / Тишково",
    "country": "Россия",
    "searchString": "тишково россия / астраханская область / тишково"
  },
  "8707": {
    "id": "8707",
    "name": "Ильевка",
    "path": "Россия / Волгоградская область / Ильевка",
    "country": "Россия",
    "searchString": "ильевка россия / волгоградская область / ильевка"
  },
  "8708": {
    "id": "8708",
    "name": "Покрово-Марфино",
    "path": "Россия / Ростовская область / Покрово-Марфино",
    "country": "Россия",
    "searchString": "покрово-марфино россия / ростовская область / покрово-марфино"
  },
  "8709": {
    "id": "8709",
    "name": "Восток (Астраханская область)",
    "path": "Россия / Астраханская область / Восток (Астраханская область)",
    "country": "Россия",
    "searchString": "восток (астраханская область) россия / астраханская область / восток (астраханская область)"
  },
  "8710": {
    "id": "8710",
    "name": "Абганерово",
    "path": "Россия / Волгоградская область / Абганерово",
    "country": "Россия",
    "searchString": "абганерово россия / волгоградская область / абганерово"
  },
  "8711": {
    "id": "8711",
    "name": "Зеленга",
    "path": "Россия / Астраханская область / Зеленга",
    "country": "Россия",
    "searchString": "зеленга россия / астраханская область / зеленга"
  },
  "8712": {
    "id": "8712",
    "name": "Бережновка",
    "path": "Россия / Волгоградская область / Бережновка",
    "country": "Россия",
    "searchString": "бережновка россия / волгоградская область / бережновка"
  },
  "8713": {
    "id": "8713",
    "name": "Горьковский",
    "path": "Россия / Волгоградская область / Горьковский",
    "country": "Россия",
    "searchString": "горьковский россия / волгоградская область / горьковский"
  },
  "8714": {
    "id": "8714",
    "name": "Крепинский",
    "path": "Россия / Волгоградская область / Крепинский",
    "country": "Россия",
    "searchString": "крепинский россия / волгоградская область / крепинский"
  },
  "8715": {
    "id": "8715",
    "name": "Кругловка",
    "path": "Россия / Волгоградская область / Кругловка",
    "country": "Россия",
    "searchString": "кругловка россия / волгоградская область / кругловка"
  },
  "8716": {
    "id": "8716",
    "name": "Буденновская",
    "path": "Россия / Ростовская область / Буденновская",
    "country": "Россия",
    "searchString": "буденновская россия / ростовская область / буденновская"
  },
  "8717": {
    "id": "8717",
    "name": "Пухляковский",
    "path": "Россия / Ростовская область / Пухляковский",
    "country": "Россия",
    "searchString": "пухляковский россия / ростовская область / пухляковский"
  },
  "8718": {
    "id": "8718",
    "name": "Маньково-Березовская",
    "path": "Россия / Ростовская область / Маньково-Березовская",
    "country": "Россия",
    "searchString": "маньково-березовская россия / ростовская область / маньково-березовская"
  },
  "8719": {
    "id": "8719",
    "name": "Большая Кирсановка",
    "path": "Россия / Ростовская область / Большая Кирсановка",
    "country": "Россия",
    "searchString": "большая кирсановка россия / ростовская область / большая кирсановка"
  },
  "8720": {
    "id": "8720",
    "name": "Красноталовский",
    "path": "Россия / Волгоградская область / Красноталовский",
    "country": "Россия",
    "searchString": "красноталовский россия / волгоградская область / красноталовский"
  },
  "8721": {
    "id": "8721",
    "name": "Перекопка",
    "path": "Россия / Волгоградская область / Перекопка",
    "country": "Россия",
    "searchString": "перекопка россия / волгоградская область / перекопка"
  },
  "8722": {
    "id": "8722",
    "name": "Весело-Вознесенка",
    "path": "Россия / Ростовская область / Весело-Вознесенка",
    "country": "Россия",
    "searchString": "весело-вознесенка россия / ростовская область / весело-вознесенка"
  },
  "8723": {
    "id": "8723",
    "name": "Сетраки",
    "path": "Россия / Ростовская область / Сетраки",
    "country": "Россия",
    "searchString": "сетраки россия / ростовская область / сетраки"
  },
  "8724": {
    "id": "8724",
    "name": "Литвиновка",
    "path": "Россия / Ростовская область / Литвиновка",
    "country": "Россия",
    "searchString": "литвиновка россия / ростовская область / литвиновка"
  },
  "8725": {
    "id": "8725",
    "name": "Таганрогский",
    "path": "Россия / Ростовская область / Таганрогский",
    "country": "Россия",
    "searchString": "таганрогский россия / ростовская область / таганрогский"
  },
  "8726": {
    "id": "8726",
    "name": "Барило-Крепинская",
    "path": "Россия / Ростовская область / Барило-Крепинская",
    "country": "Россия",
    "searchString": "барило-крепинская россия / ростовская область / барило-крепинская"
  },
  "8727": {
    "id": "8727",
    "name": "Глазуновская",
    "path": "Россия / Волгоградская область / Глазуновская",
    "country": "Россия",
    "searchString": "глазуновская россия / волгоградская область / глазуновская"
  },
  "8728": {
    "id": "8728",
    "name": "Пришиб (Астраханская область)",
    "path": "Россия / Астраханская область / Пришиб (Астраханская область)",
    "country": "Россия",
    "searchString": "пришиб (астраханская область) россия / астраханская область / пришиб (астраханская область)"
  },
  "8729": {
    "id": "8729",
    "name": "Усть-Бузулукская",
    "path": "Россия / Волгоградская область / Усть-Бузулукская",
    "country": "Россия",
    "searchString": "усть-бузулукская россия / волгоградская область / усть-бузулукская"
  },
  "8730": {
    "id": "8730",
    "name": "Ежовка",
    "path": "Россия / Волгоградская область / Ежовка",
    "country": "Россия",
    "searchString": "ежовка россия / волгоградская область / ежовка"
  },
  "8731": {
    "id": "8731",
    "name": "Перелазовский",
    "path": "Россия / Волгоградская область / Перелазовский",
    "country": "Россия",
    "searchString": "перелазовский россия / волгоградская область / перелазовский"
  },
  "8732": {
    "id": "8732",
    "name": "Путь Ильича (Ленинский район)",
    "path": "Россия / Волгоградская область / Путь Ильича (Ленинский район)",
    "country": "Россия",
    "searchString": "путь ильича (ленинский район) россия / волгоградская область / путь ильича (ленинский район)"
  },
  "8733": {
    "id": "8733",
    "name": "Мешковская",
    "path": "Россия / Ростовская область / Мешковская",
    "country": "Россия",
    "searchString": "мешковская россия / ростовская область / мешковская"
  },
  "8734": {
    "id": "8734",
    "name": "Волгодонской",
    "path": "Россия / Волгоградская область / Волгодонской",
    "country": "Россия",
    "searchString": "волгодонской россия / волгоградская область / волгодонской"
  },
  "8735": {
    "id": "8735",
    "name": "Сиротский",
    "path": "Россия / Ростовская область / Сиротский",
    "country": "Россия",
    "searchString": "сиротский россия / ростовская область / сиротский"
  },
  "8736": {
    "id": "8736",
    "name": "Кавалерский",
    "path": "Россия / Ростовская область / Кавалерский",
    "country": "Россия",
    "searchString": "кавалерский россия / ростовская область / кавалерский"
  },
  "8737": {
    "id": "8737",
    "name": "Екатериновка (Сальский район)",
    "path": "Россия / Ростовская область / Екатериновка (Сальский район)",
    "country": "Россия",
    "searchString": "екатериновка (сальский район) россия / ростовская область / екатериновка (сальский район)"
  },
  "8738": {
    "id": "8738",
    "name": "Усть-Хоперская",
    "path": "Россия / Волгоградская область / Усть-Хоперская",
    "country": "Россия",
    "searchString": "усть-хоперская россия / волгоградская область / усть-хоперская"
  },
  "8739": {
    "id": "8739",
    "name": "Солодча",
    "path": "Россия / Волгоградская область / Солодча",
    "country": "Россия",
    "searchString": "солодча россия / волгоградская область / солодча"
  },
  "8740": {
    "id": "8740",
    "name": "Верхнечеренский",
    "path": "Россия / Волгоградская область / Верхнечеренский",
    "country": "Россия",
    "searchString": "верхнечеренский россия / волгоградская область / верхнечеренский"
  },
  "8741": {
    "id": "8741",
    "name": "Цаца",
    "path": "Россия / Волгоградская область / Цаца",
    "country": "Россия",
    "searchString": "цаца россия / волгоградская область / цаца"
  },
  "8742": {
    "id": "8742",
    "name": "Политотдельское",
    "path": "Россия / Ростовская область / Политотдельское",
    "country": "Россия",
    "searchString": "политотдельское россия / ростовская область / политотдельское"
  },
  "8743": {
    "id": "8743",
    "name": "Табунщиково",
    "path": "Россия / Ростовская область / Табунщиково",
    "country": "Россия",
    "searchString": "табунщиково россия / ростовская область / табунщиково"
  },
  "8744": {
    "id": "8744",
    "name": "Экспериментальный",
    "path": "Россия / Ростовская область / Экспериментальный",
    "country": "Россия",
    "searchString": "экспериментальный россия / ростовская область / экспериментальный"
  },
  "8745": {
    "id": "8745",
    "name": "Филоновская",
    "path": "Россия / Волгоградская область / Филоновская",
    "country": "Россия",
    "searchString": "филоновская россия / волгоградская область / филоновская"
  },
  "8746": {
    "id": "8746",
    "name": "Михайловка (Астраханская область)",
    "path": "Россия / Астраханская область / Михайловка (Астраханская область)",
    "country": "Россия",
    "searchString": "михайловка (астраханская область) россия / астраханская область / михайловка (астраханская область)"
  },
  "8747": {
    "id": "8747",
    "name": "Волошино",
    "path": "Россия / Ростовская область / Волошино",
    "country": "Россия",
    "searchString": "волошино россия / ростовская область / волошино"
  },
  "8748": {
    "id": "8748",
    "name": "Латоново",
    "path": "Россия / Ростовская область / Латоново",
    "country": "Россия",
    "searchString": "латоново россия / ростовская область / латоново"
  },
  "8749": {
    "id": "8749",
    "name": "Тормосин",
    "path": "Россия / Волгоградская область / Тормосин",
    "country": "Россия",
    "searchString": "тормосин россия / волгоградская область / тормосин"
  },
  "8750": {
    "id": "8750",
    "name": "Басакин",
    "path": "Россия / Волгоградская область / Басакин",
    "country": "Россия",
    "searchString": "басакин россия / волгоградская область / басакин"
  },
  "8751": {
    "id": "8751",
    "name": "Базковская",
    "path": "Россия / Ростовская область / Базковская",
    "country": "Россия",
    "searchString": "базковская россия / ростовская область / базковская"
  },
  "8752": {
    "id": "8752",
    "name": "Бузиновка",
    "path": "Россия / Волгоградская область / Бузиновка",
    "country": "Россия",
    "searchString": "бузиновка россия / волгоградская область / бузиновка"
  },
  "8753": {
    "id": "8753",
    "name": "Каменный Яр",
    "path": "Россия / Астраханская область / Каменный Яр",
    "country": "Россия",
    "searchString": "каменный яр россия / астраханская область / каменный яр"
  },
  "8754": {
    "id": "8754",
    "name": "Шумилинская",
    "path": "Россия / Ростовская область / Шумилинская",
    "country": "Россия",
    "searchString": "шумилинская россия / ростовская область / шумилинская"
  },
  "8755": {
    "id": "8755",
    "name": "Березовка (Ростовская область)",
    "path": "Россия / Ростовская область / Березовка (Ростовская область)",
    "country": "Россия",
    "searchString": "березовка (ростовская область) россия / ростовская область / березовка (ростовская область)"
  },
  "8756": {
    "id": "8756",
    "name": "Николаевский 2-й",
    "path": "Россия / Ростовская область / Николаевский 2-й",
    "country": "Россия",
    "searchString": "николаевский 2-й россия / ростовская область / николаевский 2-й"
  },
  "8757": {
    "id": "8757",
    "name": "Самофаловка",
    "path": "Россия / Волгоградская область / Самофаловка",
    "country": "Россия",
    "searchString": "самофаловка россия / волгоградская область / самофаловка"
  },
  "8758": {
    "id": "8758",
    "name": "Роднички",
    "path": "Россия / Волгоградская область / Роднички",
    "country": "Россия",
    "searchString": "роднички россия / волгоградская область / роднички"
  },
  "8759": {
    "id": "8759",
    "name": "Лопанка",
    "path": "Россия / Ростовская область / Лопанка",
    "country": "Россия",
    "searchString": "лопанка россия / ростовская область / лопанка"
  },
  "8760": {
    "id": "8760",
    "name": "Авило-Успенка",
    "path": "Россия / Ростовская область / Авило-Успенка",
    "country": "Россия",
    "searchString": "авило-успенка россия / ростовская область / авило-успенка"
  },
  "8761": {
    "id": "8761",
    "name": "Самбек",
    "path": "Россия / Ростовская область / Самбек",
    "country": "Россия",
    "searchString": "самбек россия / ростовская область / самбек"
  },
  "8762": {
    "id": "8762",
    "name": "Краснокоротковский",
    "path": "Россия / Волгоградская область / Краснокоротковский",
    "country": "Россия",
    "searchString": "краснокоротковский россия / волгоградская область / краснокоротковский"
  },
  "8763": {
    "id": "8763",
    "name": "Позднеевка",
    "path": "Россия / Ростовская область / Позднеевка",
    "country": "Россия",
    "searchString": "позднеевка россия / ростовская область / позднеевка"
  },
  "8764": {
    "id": "8764",
    "name": "Верхняковский",
    "path": "Россия / Ростовская область / Верхняковский",
    "country": "Россия",
    "searchString": "верхняковский россия / ростовская область / верхняковский"
  },
  "8765": {
    "id": "8765",
    "name": "Новомаксимовский",
    "path": "Россия / Волгоградская область / Новомаксимовский",
    "country": "Россия",
    "searchString": "новомаксимовский россия / волгоградская область / новомаксимовский"
  },
  "8766": {
    "id": "8766",
    "name": "Калмыковский",
    "path": "Россия / Волгоградская область / Калмыковский",
    "country": "Россия",
    "searchString": "калмыковский россия / волгоградская область / калмыковский"
  },
  "8767": {
    "id": "8767",
    "name": "Ленинский (Ростовская область)",
    "path": "Россия / Ростовская область / Ленинский (Ростовская область)",
    "country": "Россия",
    "searchString": "ленинский (ростовская область) россия / ростовская область / ленинский (ростовская область)"
  },
  "8768": {
    "id": "8768",
    "name": "Алексеево-Лозовское",
    "path": "Россия / Ростовская область / Алексеево-Лозовское",
    "country": "Россия",
    "searchString": "алексеево-лозовское россия / ростовская область / алексеево-лозовское"
  },
  "8769": {
    "id": "8769",
    "name": "Хуторской",
    "path": "Россия / Ростовская область / Хуторской",
    "country": "Россия",
    "searchString": "хуторской россия / ростовская область / хуторской"
  },
  "8770": {
    "id": "8770",
    "name": "Кружилинский",
    "path": "Россия / Ростовская область / Кружилинский",
    "country": "Россия",
    "searchString": "кружилинский россия / ростовская область / кружилинский"
  },
  "8771": {
    "id": "8771",
    "name": "Пятиморск",
    "path": "Россия / Волгоградская область / Пятиморск",
    "country": "Россия",
    "searchString": "пятиморск россия / волгоградская область / пятиморск"
  },
  "8772": {
    "id": "8772",
    "name": "Меркуловский",
    "path": "Россия / Ростовская область / Меркуловский",
    "country": "Россия",
    "searchString": "меркуловский россия / ростовская область / меркуловский"
  },
  "8773": {
    "id": "8773",
    "name": "Чистоозерный",
    "path": "Россия / Ростовская область / Чистоозерный",
    "country": "Россия",
    "searchString": "чистоозерный россия / ростовская область / чистоозерный"
  },
  "8774": {
    "id": "8774",
    "name": "Двойновский",
    "path": "Россия / Волгоградская область / Двойновский",
    "country": "Россия",
    "searchString": "двойновский россия / волгоградская область / двойновский"
  },
  "8775": {
    "id": "8775",
    "name": "Сулин",
    "path": "Россия / Ростовская область / Сулин",
    "country": "Россия",
    "searchString": "сулин россия / ростовская область / сулин"
  },
  "8776": {
    "id": "8776",
    "name": "Жуковское",
    "path": "Россия / Ростовская область / Жуковское",
    "country": "Россия",
    "searchString": "жуковское россия / ростовская область / жуковское"
  },
  "8777": {
    "id": "8777",
    "name": "Порт-Катон",
    "path": "Россия / Ростовская область / Порт-Катон",
    "country": "Россия",
    "searchString": "порт-катон россия / ростовская область / порт-катон"
  },
  "8778": {
    "id": "8778",
    "name": "Победа (Волгодонский район)",
    "path": "Россия / Ростовская область / Победа (Волгодонский район)",
    "country": "Россия",
    "searchString": "победа (волгодонский район) россия / ростовская область / победа (волгодонский район)"
  },
  "8779": {
    "id": "8779",
    "name": "Нижняя Добринка",
    "path": "Россия / Волгоградская область / Нижняя Добринка",
    "country": "Россия",
    "searchString": "нижняя добринка россия / волгоградская область / нижняя добринка"
  },
  "8780": {
    "id": "8780",
    "name": "Распопинская",
    "path": "Россия / Волгоградская область / Распопинская",
    "country": "Россия",
    "searchString": "распопинская россия / волгоградская область / распопинская"
  },
  "8781": {
    "id": "8781",
    "name": "Октябрьский (Ростовская область)",
    "path": "Россия / Ростовская область / Октябрьский (Ростовская область)",
    "country": "Россия",
    "searchString": "октябрьский (ростовская область) россия / ростовская область / октябрьский (ростовская область)"
  },
  "8782": {
    "id": "8782",
    "name": "Объединенный",
    "path": "Россия / Ростовская область / Объединенный",
    "country": "Россия",
    "searchString": "объединенный россия / ростовская область / объединенный"
  },
  "8783": {
    "id": "8783",
    "name": "Клюев",
    "path": "Россия / Ростовская область / Клюев",
    "country": "Россия",
    "searchString": "клюев россия / ростовская область / клюев"
  },
  "8784": {
    "id": "8784",
    "name": "Тополевый",
    "path": "Россия / Ростовская область / Тополевый",
    "country": "Россия",
    "searchString": "тополевый россия / ростовская область / тополевый"
  },
  "8785": {
    "id": "8785",
    "name": "Журавлевка",
    "path": "Россия / Ростовская область / Журавлевка",
    "country": "Россия",
    "searchString": "журавлевка россия / ростовская область / журавлевка"
  },
  "8786": {
    "id": "8786",
    "name": "Захаров",
    "path": "Россия / Волгоградская область / Захаров",
    "country": "Россия",
    "searchString": "захаров россия / волгоградская область / захаров"
  },
  "8787": {
    "id": "8787",
    "name": "Задонно-Кагальницкая",
    "path": "Россия / Ростовская область / Задонно-Кагальницкая",
    "country": "Россия",
    "searchString": "задонно-кагальницкая россия / ростовская область / задонно-кагальницкая"
  },
  "8788": {
    "id": "8788",
    "name": "Макаровская",
    "path": "Россия / Астраханская область / Макаровская",
    "country": "Россия",
    "searchString": "макаровская россия / астраханская область / макаровская"
  },
  "8789": {
    "id": "8789",
    "name": "Эльтон",
    "path": "Россия / Волгоградская область / Эльтон",
    "country": "Россия",
    "searchString": "эльтон россия / волгоградская область / эльтон"
  },
  "8790": {
    "id": "8790",
    "name": "Владимировская",
    "path": "Россия / Ростовская область / Владимировская",
    "country": "Россия",
    "searchString": "владимировская россия / ростовская область / владимировская"
  },
  "8791": {
    "id": "8791",
    "name": "Мокрый Батай",
    "path": "Россия / Ростовская область / Мокрый Батай",
    "country": "Россия",
    "searchString": "мокрый батай россия / ростовская область / мокрый батай"
  },
  "8792": {
    "id": "8792",
    "name": "Каралат",
    "path": "Россия / Астраханская область / Каралат",
    "country": "Россия",
    "searchString": "каралат россия / астраханская область / каралат"
  },
  "8793": {
    "id": "8793",
    "name": "Недвиговка",
    "path": "Россия / Ростовская область / Недвиговка",
    "country": "Россия",
    "searchString": "недвиговка россия / ростовская область / недвиговка"
  },
  "8794": {
    "id": "8794",
    "name": "Жуковская",
    "path": "Россия / Ростовская область / Жуковская",
    "country": "Россия",
    "searchString": "жуковская россия / ростовская область / жуковская"
  },
  "8795": {
    "id": "8795",
    "name": "Красный Десант",
    "path": "Россия / Ростовская область / Красный Десант",
    "country": "Россия",
    "searchString": "красный десант россия / ростовская область / красный десант"
  },
  "8796": {
    "id": "8796",
    "name": "Дворянское",
    "path": "Россия / Волгоградская область / Дворянское",
    "country": "Россия",
    "searchString": "дворянское россия / волгоградская область / дворянское"
  },
  "8797": {
    "id": "8797",
    "name": "Балко-Грузский",
    "path": "Россия / Ростовская область / Балко-Грузский",
    "country": "Россия",
    "searchString": "балко-грузский россия / ростовская область / балко-грузский"
  },
  "8798": {
    "id": "8798",
    "name": "Победа (Азовский район)",
    "path": "Россия / Ростовская область / Победа (Азовский район)",
    "country": "Россия",
    "searchString": "победа (азовский район) россия / ростовская область / победа (азовский район)"
  },
  "8799": {
    "id": "8799",
    "name": "Парамонов",
    "path": "Россия / Ростовская область / Парамонов",
    "country": "Россия",
    "searchString": "парамонов россия / ростовская область / парамонов"
  },
  "8800": {
    "id": "8800",
    "name": "Мокрый Гашун",
    "path": "Россия / Ростовская область / Мокрый Гашун",
    "country": "Россия",
    "searchString": "мокрый гашун россия / ростовская область / мокрый гашун"
  },
  "8801": {
    "id": "8801",
    "name": "Бурлук",
    "path": "Россия / Волгоградская область / Бурлук",
    "country": "Россия",
    "searchString": "бурлук россия / волгоградская область / бурлук"
  },
  "8802": {
    "id": "8802",
    "name": "Шептуховка",
    "path": "Россия / Ростовская область / Шептуховка",
    "country": "Россия",
    "searchString": "шептуховка россия / ростовская область / шептуховка"
  },
  "8803": {
    "id": "8803",
    "name": "Елизаветовка",
    "path": "Россия / Ростовская область / Елизаветовка",
    "country": "Россия",
    "searchString": "елизаветовка россия / ростовская область / елизаветовка"
  },
  "8804": {
    "id": "8804",
    "name": "Сухой",
    "path": "Россия / Ростовская область / Сухой",
    "country": "Россия",
    "searchString": "сухой россия / ростовская область / сухой"
  },
  "8805": {
    "id": "8805",
    "name": "Раздор",
    "path": "Россия / Астраханская область / Раздор",
    "country": "Россия",
    "searchString": "раздор россия / астраханская область / раздор"
  },
  "8806": {
    "id": "8806",
    "name": "Большой Морец",
    "path": "Россия / Волгоградская область / Большой Морец",
    "country": "Россия",
    "searchString": "большой морец россия / волгоградская область / большой морец"
  },
  "8807": {
    "id": "8807",
    "name": "Кугейский",
    "path": "Россия / Ростовская область / Кугейский",
    "country": "Россия",
    "searchString": "кугейский россия / ростовская область / кугейский"
  },
  "8808": {
    "id": "8808",
    "name": "Дегтево",
    "path": "Россия / Ростовская область / Дегтево",
    "country": "Россия",
    "searchString": "дегтево россия / ростовская область / дегтево"
  },
  "8809": {
    "id": "8809",
    "name": "Жутово 2-е",
    "path": "Россия / Волгоградская область / Жутово 2-е",
    "country": "Россия",
    "searchString": "жутово 2-е россия / волгоградская область / жутово 2-е"
  },
  "8810": {
    "id": "8810",
    "name": "Андреево-Мелентьево",
    "path": "Россия / Ростовская область / Андреево-Мелентьево",
    "country": "Россия",
    "searchString": "андреево-мелентьево россия / ростовская область / андреево-мелентьево"
  },
  "8811": {
    "id": "8811",
    "name": "Займо-Обрыв",
    "path": "Россия / Ростовская область / Займо-Обрыв",
    "country": "Россия",
    "searchString": "займо-обрыв россия / ростовская область / займо-обрыв"
  },
  "8812": {
    "id": "8812",
    "name": "Григорьевка (Ростовская область)",
    "path": "Россия / Ростовская область / Григорьевка (Ростовская область)",
    "country": "Россия",
    "searchString": "григорьевка (ростовская область) россия / ростовская область / григорьевка (ростовская область)"
  },
  "8813": {
    "id": "8813",
    "name": "Матышево",
    "path": "Россия / Волгоградская область / Матышево",
    "country": "Россия",
    "searchString": "матышево россия / волгоградская область / матышево"
  },
  "8814": {
    "id": "8814",
    "name": "Маргаритово",
    "path": "Россия / Ростовская область / Маргаритово",
    "country": "Россия",
    "searchString": "маргаритово россия / ростовская область / маргаритово"
  },
  "8815": {
    "id": "8815",
    "name": "Калиновский",
    "path": "Россия / Волгоградская область / Калиновский",
    "country": "Россия",
    "searchString": "калиновский россия / волгоградская область / калиновский"
  },
  "8816": {
    "id": "8816",
    "name": "Дубовский",
    "path": "Россия / Волгоградская область / Дубовский",
    "country": "Россия",
    "searchString": "дубовский россия / волгоградская область / дубовский"
  },
  "8817": {
    "id": "8817",
    "name": "Гуляй-Борисовка",
    "path": "Россия / Ростовская область / Гуляй-Борисовка",
    "country": "Россия",
    "searchString": "гуляй-борисовка россия / ростовская область / гуляй-борисовка"
  },
  "8818": {
    "id": "8818",
    "name": "Сокрутовка",
    "path": "Россия / Астраханская область / Сокрутовка",
    "country": "Россия",
    "searchString": "сокрутовка россия / астраханская область / сокрутовка"
  },
  "8819": {
    "id": "8819",
    "name": "Терновое",
    "path": "Россия / Волгоградская область / Терновое",
    "country": "Россия",
    "searchString": "терновое россия / волгоградская область / терновое"
  },
  "8820": {
    "id": "8820",
    "name": "Путь Правды",
    "path": "Россия / Ростовская область / Путь Правды",
    "country": "Россия",
    "searchString": "путь правды россия / ростовская область / путь правды"
  },
  "8821": {
    "id": "8821",
    "name": "Каргинская",
    "path": "Россия / Ростовская область / Каргинская",
    "country": "Россия",
    "searchString": "каргинская россия / ростовская область / каргинская"
  },
  "8822": {
    "id": "8822",
    "name": "Колодези",
    "path": "Россия / Ростовская область / Колодези",
    "country": "Россия",
    "searchString": "колодези россия / ростовская область / колодези"
  },
  "8823": {
    "id": "8823",
    "name": "Екатериновка (Матвеево-Курганский район)",
    "path": "Россия / Ростовская область / Екатериновка (Матвеево-Курганский район)",
    "country": "Россия",
    "searchString": "екатериновка (матвеево-курганский район) россия / ростовская область / екатериновка (матвеево-курганский район)"
  },
  "8824": {
    "id": "8824",
    "name": "Заплавская",
    "path": "Россия / Ростовская область / Заплавская",
    "country": "Россия",
    "searchString": "заплавская россия / ростовская область / заплавская"
  },
  "8825": {
    "id": "8825",
    "name": "Мачеха",
    "path": "Россия / Волгоградская область / Мачеха",
    "country": "Россия",
    "searchString": "мачеха россия / волгоградская область / мачеха"
  },
  "8826": {
    "id": "8826",
    "name": "Новая Надежда",
    "path": "Россия / Ростовская область / Новая Надежда",
    "country": "Россия",
    "searchString": "новая надежда россия / ростовская область / новая надежда"
  },
  "8827": {
    "id": "8827",
    "name": "Новоселовка",
    "path": "Россия / Ростовская область / Новоселовка",
    "country": "Россия",
    "searchString": "новоселовка россия / ростовская область / новоселовка"
  },
  "8828": {
    "id": "8828",
    "name": "Первомайское (Ростовская область)",
    "path": "Россия / Ростовская область / Первомайское (Ростовская область)",
    "country": "Россия",
    "searchString": "первомайское (ростовская область) россия / ростовская область / первомайское (ростовская область)"
  },
  "8829": {
    "id": "8829",
    "name": "Верхнекардаильский",
    "path": "Россия / Волгоградская область / Верхнекардаильский",
    "country": "Россия",
    "searchString": "верхнекардаильский россия / волгоградская область / верхнекардаильский"
  },
  "8830": {
    "id": "8830",
    "name": "Березовская",
    "path": "Россия / Волгоградская область / Березовская",
    "country": "Россия",
    "searchString": "березовская россия / волгоградская область / березовская"
  },
  "8831": {
    "id": "8831",
    "name": "Горный Балыклей",
    "path": "Россия / Волгоградская область / Горный Балыклей",
    "country": "Россия",
    "searchString": "горный балыклей россия / волгоградская область / горный балыклей"
  },
  "8832": {
    "id": "8832",
    "name": "Марфинка",
    "path": "Россия / Ростовская область / Марфинка",
    "country": "Россия",
    "searchString": "марфинка россия / ростовская область / марфинка"
  },
  "8833": {
    "id": "8833",
    "name": "Маркинская",
    "path": "Россия / Ростовская область / Маркинская",
    "country": "Россия",
    "searchString": "маркинская россия / ростовская область / маркинская"
  },
  "8834": {
    "id": "8834",
    "name": "Митякинская",
    "path": "Россия / Ростовская область / Митякинская",
    "country": "Россия",
    "searchString": "митякинская россия / ростовская область / митякинская"
  },
  "8835": {
    "id": "8835",
    "name": "Апаринский",
    "path": "Россия / Ростовская область / Апаринский",
    "country": "Россия",
    "searchString": "апаринский россия / ростовская область / апаринский"
  },
  "8836": {
    "id": "8836",
    "name": "Войнов",
    "path": "Россия / Ростовская область / Войнов",
    "country": "Россия",
    "searchString": "войнов россия / ростовская область / войнов"
  },
  "8837": {
    "id": "8837",
    "name": "Нижнецепляевский",
    "path": "Россия / Волгоградская область / Нижнецепляевский",
    "country": "Россия",
    "searchString": "нижнецепляевский россия / волгоградская область / нижнецепляевский"
  },
  "8838": {
    "id": "8838",
    "name": "Михайлово-Александровка",
    "path": "Россия / Ростовская область / Михайлово-Александровка",
    "country": "Россия",
    "searchString": "михайлово-александровка россия / ростовская область / михайлово-александровка"
  },
  "8839": {
    "id": "8839",
    "name": "Анастасиевка",
    "path": "Россия / Ростовская область / Анастасиевка",
    "country": "Россия",
    "searchString": "анастасиевка россия / ростовская область / анастасиевка"
  },
  "8840": {
    "id": "8840",
    "name": "Краишево",
    "path": "Россия / Волгоградская область / Краишево",
    "country": "Россия",
    "searchString": "краишево россия / волгоградская область / краишево"
  },
  "8841": {
    "id": "8841",
    "name": "Морец",
    "path": "Россия / Волгоградская область / Морец",
    "country": "Россия",
    "searchString": "морец россия / волгоградская область / морец"
  },
  "8842": {
    "id": "8842",
    "name": "Юловский",
    "path": "Россия / Ростовская область / Юловский",
    "country": "Россия",
    "searchString": "юловский россия / ростовская область / юловский"
  },
  "8843": {
    "id": "8843",
    "name": "Качалино",
    "path": "Россия / Волгоградская область / Качалино",
    "country": "Россия",
    "searchString": "качалино россия / волгоградская область / качалино"
  },
  "8844": {
    "id": "8844",
    "name": "Ряженое",
    "path": "Россия / Ростовская область / Ряженое",
    "country": "Россия",
    "searchString": "ряженое россия / ростовская область / ряженое"
  },
  "8845": {
    "id": "8845",
    "name": "Путь Ильича (Николаевский район)",
    "path": "Россия / Волгоградская область / Путь Ильича (Николаевский район)",
    "country": "Россия",
    "searchString": "путь ильича (николаевский район) россия / волгоградская область / путь ильича (николаевский район)"
  },
  "8846": {
    "id": "8846",
    "name": "Бурковский",
    "path": "Россия / Волгоградская область / Бурковский",
    "country": "Россия",
    "searchString": "бурковский россия / волгоградская область / бурковский"
  },
  "8847": {
    "id": "8847",
    "name": "Кульбаково",
    "path": "Россия / Ростовская область / Кульбаково",
    "country": "Россия",
    "searchString": "кульбаково россия / ростовская область / кульбаково"
  },
  "8848": {
    "id": "8848",
    "name": "Каменная Балка",
    "path": "Россия / Ростовская область / Каменная Балка",
    "country": "Россия",
    "searchString": "каменная балка россия / ростовская область / каменная балка"
  },
  "8849": {
    "id": "8849",
    "name": "Вислый",
    "path": "Россия / Ростовская область / Вислый",
    "country": "Россия",
    "searchString": "вислый россия / ростовская область / вислый"
  },
  "8850": {
    "id": "8850",
    "name": "Кугей",
    "path": "Россия / Ростовская область / Кугей",
    "country": "Россия",
    "searchString": "кугей россия / ростовская область / кугей"
  },
  "8851": {
    "id": "8851",
    "name": "Верхнемакеевка",
    "path": "Россия / Ростовская область / Верхнемакеевка",
    "country": "Россия",
    "searchString": "верхнемакеевка россия / ростовская область / верхнемакеевка"
  },
  "8852": {
    "id": "8852",
    "name": "Новоцимлянская",
    "path": "Россия / Ростовская область / Новоцимлянская",
    "country": "Россия",
    "searchString": "новоцимлянская россия / ростовская область / новоцимлянская"
  },
  "8853": {
    "id": "8853",
    "name": "Замьяны",
    "path": "Россия / Астраханская область / Замьяны",
    "country": "Россия",
    "searchString": "замьяны россия / астраханская область / замьяны"
  },
  "8854": {
    "id": "8854",
    "name": "Лысогорка",
    "path": "Россия / Ростовская область / Лысогорка",
    "country": "Россия",
    "searchString": "лысогорка россия / ростовская область / лысогорка"
  },
  "8855": {
    "id": "8855",
    "name": "Черкесовский",
    "path": "Россия / Волгоградская область / Черкесовский",
    "country": "Россия",
    "searchString": "черкесовский россия / волгоградская область / черкесовский"
  },
  "8856": {
    "id": "8856",
    "name": "Рахинка",
    "path": "Россия / Волгоградская область / Рахинка",
    "country": "Россия",
    "searchString": "рахинка россия / волгоградская область / рахинка"
  },
  "8857": {
    "id": "8857",
    "name": "Большая Таловая",
    "path": "Россия / Ростовская область / Большая Таловая",
    "country": "Россия",
    "searchString": "большая таловая россия / ростовская область / большая таловая"
  },
  "8858": {
    "id": "8858",
    "name": "Скосырская",
    "path": "Россия / Ростовская область / Скосырская",
    "country": "Россия",
    "searchString": "скосырская россия / ростовская область / скосырская"
  },
  "8859": {
    "id": "8859",
    "name": "Октябрьский (Октябрьский район)",
    "path": "Россия / Волгоградская область / Октябрьский (Октябрьский район)",
    "country": "Россия",
    "searchString": "октябрьский (октябрьский район) россия / волгоградская область / октябрьский (октябрьский район)"
  },
  "8860": {
    "id": "8860",
    "name": "Сидоры",
    "path": "Россия / Волгоградская область / Сидоры",
    "country": "Россия",
    "searchString": "сидоры россия / волгоградская область / сидоры"
  },
  "8861": {
    "id": "8861",
    "name": "Чернышевка",
    "path": "Россия / Ростовская область / Чернышевка",
    "country": "Россия",
    "searchString": "чернышевка россия / ростовская область / чернышевка"
  },
  "8862": {
    "id": "8862",
    "name": "Дубровский",
    "path": "Россия / Ростовская область / Дубровский",
    "country": "Россия",
    "searchString": "дубровский россия / ростовская область / дубровский"
  },
  "8863": {
    "id": "8863",
    "name": "Крученная Балка",
    "path": "Россия / Ростовская область / Крученная Балка",
    "country": "Россия",
    "searchString": "крученная балка россия / ростовская область / крученная балка"
  },
  "8864": {
    "id": "8864",
    "name": "Поповка",
    "path": "Россия / Ростовская область / Поповка",
    "country": "Россия",
    "searchString": "поповка россия / ростовская область / поповка"
  },
  "8865": {
    "id": "8865",
    "name": "Миловка",
    "path": "Россия / Республика Башкортостан / Миловка",
    "country": "Россия",
    "searchString": "миловка россия / республика башкортостан / миловка"
  },
  "8866": {
    "id": "8866",
    "name": "Шеркалы",
    "path": "Россия / Ханты-Мансийский АО - Югра / Шеркалы",
    "country": "Россия",
    "searchString": "шеркалы россия / ханты-мансийский ао - югра / шеркалы"
  },
  "8867": {
    "id": "8867",
    "name": "Боровлянка (Тюменская область)",
    "path": "Россия / Тюменская область / Боровлянка (Тюменская область)",
    "country": "Россия",
    "searchString": "боровлянка (тюменская область) россия / тюменская область / боровлянка (тюменская область)"
  },
  "8868": {
    "id": "8868",
    "name": "Нижние Муллы",
    "path": "Россия / Пермский край / Нижние Муллы",
    "country": "Россия",
    "searchString": "нижние муллы россия / пермский край / нижние муллы"
  },
  "8869": {
    "id": "8869",
    "name": "Обуховское",
    "path": "Россия / Свердловская область / Обуховское",
    "country": "Россия",
    "searchString": "обуховское россия / свердловская область / обуховское"
  },
  "8870": {
    "id": "8870",
    "name": "Аспа",
    "path": "Россия / Пермский край / Аспа",
    "country": "Россия",
    "searchString": "аспа россия / пермский край / аспа"
  },
  "8871": {
    "id": "8871",
    "name": "Карача-Елга",
    "path": "Россия / Республика Башкортостан / Карача-Елга",
    "country": "Россия",
    "searchString": "карача-елга россия / республика башкортостан / карача-елга"
  },
  "8872": {
    "id": "8872",
    "name": "Исанбаево",
    "path": "Россия / Республика Башкортостан / Исанбаево",
    "country": "Россия",
    "searchString": "исанбаево россия / республика башкортостан / исанбаево"
  },
  "8873": {
    "id": "8873",
    "name": "Баранникова",
    "path": "Россия / Свердловская область / Баранникова",
    "country": "Россия",
    "searchString": "баранникова россия / свердловская область / баранникова"
  },
  "8874": {
    "id": "8874",
    "name": "Северный Коспашский",
    "path": "Россия / Пермский край / Северный Коспашский",
    "country": "Россия",
    "searchString": "северный коспашский россия / пермский край / северный коспашский"
  },
  "8875": {
    "id": "8875",
    "name": "Юксеево",
    "path": "Россия / Пермский край / Юксеево",
    "country": "Россия",
    "searchString": "юксеево россия / пермский край / юксеево"
  },
  "8876": {
    "id": "8876",
    "name": "Коптелово",
    "path": "Россия / Свердловская область / Коптелово",
    "country": "Россия",
    "searchString": "коптелово россия / свердловская область / коптелово"
  },
  "8877": {
    "id": "8877",
    "name": "Затеченское",
    "path": "Россия / Курганская область / Затеченское",
    "country": "Россия",
    "searchString": "затеченское россия / курганская область / затеченское"
  },
  "8878": {
    "id": "8878",
    "name": "Тайняшево",
    "path": "Россия / Республика Башкортостан / Тайняшево",
    "country": "Россия",
    "searchString": "тайняшево россия / республика башкортостан / тайняшево"
  },
  "8879": {
    "id": "8879",
    "name": "Усть-Черная",
    "path": "Россия / Пермский край / Усть-Черная",
    "country": "Россия",
    "searchString": "усть-черная россия / пермский край / усть-черная"
  },
  "8880": {
    "id": "8880",
    "name": "Стариково",
    "path": "Россия / Курганская область / Стариково",
    "country": "Россия",
    "searchString": "стариково россия / курганская область / стариково"
  },
  "8881": {
    "id": "8881",
    "name": "Дуброво (Пермский край)",
    "path": "Россия / Пермский край / Дуброво (Пермский край)",
    "country": "Россия",
    "searchString": "дуброво (пермский край) россия / пермский край / дуброво (пермский край)"
  },
  "8882": {
    "id": "8882",
    "name": "Скальный",
    "path": "Россия / Пермский край / Скальный",
    "country": "Россия",
    "searchString": "скальный россия / пермский край / скальный"
  },
  "8883": {
    "id": "8883",
    "name": "Красная Звезда",
    "path": "Россия / Курганская область / Красная Звезда",
    "country": "Россия",
    "searchString": "красная звезда россия / курганская область / красная звезда"
  },
  "8884": {
    "id": "8884",
    "name": "Каширино",
    "path": "Россия / Курганская область / Каширино",
    "country": "Россия",
    "searchString": "каширино россия / курганская область / каширино"
  },
  "8885": {
    "id": "8885",
    "name": "Нижний Лып",
    "path": "Россия / Пермский край / Нижний Лып",
    "country": "Россия",
    "searchString": "нижний лып россия / пермский край / нижний лып"
  },
  "8886": {
    "id": "8886",
    "name": "Большое Просеково",
    "path": "Россия / Курганская область / Большое Просеково",
    "country": "Россия",
    "searchString": "большое просеково россия / курганская область / большое просеково"
  },
  "8887": {
    "id": "8887",
    "name": "Кутерем",
    "path": "Россия / Республика Башкортостан / Кутерем",
    "country": "Россия",
    "searchString": "кутерем россия / республика башкортостан / кутерем"
  },
  "8888": {
    "id": "8888",
    "name": "Копей-Кубово",
    "path": "Россия / Республика Башкортостан / Копей-Кубово",
    "country": "Россия",
    "searchString": "копей-кубово россия / республика башкортостан / копей-кубово"
  },
  "8889": {
    "id": "8889",
    "name": "Октябрьский (Челябинская область)",
    "path": "Россия / Челябинская область / Октябрьский (Челябинская область)",
    "country": "Россия",
    "searchString": "октябрьский (челябинская область) россия / челябинская область / октябрьский (челябинская область)"
  },
  "8890": {
    "id": "8890",
    "name": "Буб",
    "path": "Россия / Пермский край / Буб",
    "country": "Россия",
    "searchString": "буб россия / пермский край / буб"
  },
  "8891": {
    "id": "8891",
    "name": "Татар-Улканово",
    "path": "Россия / Республика Башкортостан / Татар-Улканово",
    "country": "Россия",
    "searchString": "татар-улканово россия / республика башкортостан / татар-улканово"
  },
  "8892": {
    "id": "8892",
    "name": "Мальково",
    "path": "Россия / Тюменская область / Мальково",
    "country": "Россия",
    "searchString": "мальково россия / тюменская область / мальково"
  },
  "8893": {
    "id": "8893",
    "name": "Макан",
    "path": "Россия / Республика Башкортостан / Макан",
    "country": "Россия",
    "searchString": "макан россия / республика башкортостан / макан"
  },
  "8894": {
    "id": "8894",
    "name": "Черемшанка (Челябинская область)",
    "path": "Россия / Челябинская область / Черемшанка (Челябинская область)",
    "country": "Россия",
    "searchString": "черемшанка (челябинская область) россия / челябинская область / черемшанка (челябинская область)"
  },
  "8895": {
    "id": "8895",
    "name": "Гладилово",
    "path": "Россия / Тюменская область / Гладилово",
    "country": "Россия",
    "searchString": "гладилово россия / тюменская область / гладилово"
  },
  "8896": {
    "id": "8896",
    "name": "Новые Чебенки",
    "path": "Россия / Республика Башкортостан / Новые Чебенки",
    "country": "Россия",
    "searchString": "новые чебенки россия / республика башкортостан / новые чебенки"
  },
  "8897": {
    "id": "8897",
    "name": "Исмайлово",
    "path": "Россия / Республика Башкортостан / Исмайлово",
    "country": "Россия",
    "searchString": "исмайлово россия / республика башкортостан / исмайлово"
  },
  "8898": {
    "id": "8898",
    "name": "Третий Северный",
    "path": "Россия / Свердловская область / Третий Северный",
    "country": "Россия",
    "searchString": "третий северный россия / свердловская область / третий северный"
  },
  "8899": {
    "id": "8899",
    "name": "Лопатки",
    "path": "Россия / Курганская область / Лопатки",
    "country": "Россия",
    "searchString": "лопатки россия / курганская область / лопатки"
  },
  "8900": {
    "id": "8900",
    "name": "Серпиевка",
    "path": "Россия / Челябинская область / Серпиевка",
    "country": "Россия",
    "searchString": "серпиевка россия / челябинская область / серпиевка"
  },
  "8901": {
    "id": "8901",
    "name": "Байназарово",
    "path": "Россия / Республика Башкортостан / Байназарово",
    "country": "Россия",
    "searchString": "байназарово россия / республика башкортостан / байназарово"
  },
  "8902": {
    "id": "8902",
    "name": "Башкирское",
    "path": "Россия / Курганская область / Башкирское",
    "country": "Россия",
    "searchString": "башкирское россия / курганская область / башкирское"
  },
  "8903": {
    "id": "8903",
    "name": "Шадейка",
    "path": "Россия / Пермский край / Шадейка",
    "country": "Россия",
    "searchString": "шадейка россия / пермский край / шадейка"
  },
  "8904": {
    "id": "8904",
    "name": "Краснослободское",
    "path": "Россия / Свердловская область / Краснослободское",
    "country": "Россия",
    "searchString": "краснослободское россия / свердловская область / краснослободское"
  },
  "8905": {
    "id": "8905",
    "name": "Болчары",
    "path": "Россия / Ханты-Мансийский АО - Югра / Болчары",
    "country": "Россия",
    "searchString": "болчары россия / ханты-мансийский ао - югра / болчары"
  },
  "8906": {
    "id": "8906",
    "name": "Кодское",
    "path": "Россия / Курганская область / Кодское",
    "country": "Россия",
    "searchString": "кодское россия / курганская область / кодское"
  },
  "8907": {
    "id": "8907",
    "name": "Сеяха (Тюменская область)",
    "path": "Россия / Тюменская область / Сеяха (Тюменская область)",
    "country": "Россия",
    "searchString": "сеяха (тюменская область) россия / тюменская область / сеяха (тюменская область)"
  },
  "8908": {
    "id": "8908",
    "name": "Правохеттинский",
    "path": "Россия / Ямало-Ненецкий АО / Правохеттинский",
    "country": "Россия",
    "searchString": "правохеттинский россия / ямало-ненецкий ао / правохеттинский"
  },
  "8909": {
    "id": "8909",
    "name": "Красный Берег",
    "path": "Россия / Пермский край / Красный Берег",
    "country": "Россия",
    "searchString": "красный берег россия / пермский край / красный берег"
  },
  "8910": {
    "id": "8910",
    "name": "Халясавэй",
    "path": "Россия / Ямало-Ненецкий АО / Халясавэй",
    "country": "Россия",
    "searchString": "халясавэй россия / ямало-ненецкий ао / халясавэй"
  },
  "8911": {
    "id": "8911",
    "name": "Нижнее",
    "path": "Россия / Курганская область / Нижнее",
    "country": "Россия",
    "searchString": "нижнее россия / курганская область / нижнее"
  },
  "8912": {
    "id": "8912",
    "name": "Дияшево",
    "path": "Россия / Республика Башкортостан / Дияшево",
    "country": "Россия",
    "searchString": "дияшево россия / республика башкортостан / дияшево"
  },
  "8913": {
    "id": "8913",
    "name": "Новые Ляды",
    "path": "Россия / Пермский край / Новые Ляды",
    "country": "Россия",
    "searchString": "новые ляды россия / пермский край / новые ляды"
  },
  "8914": {
    "id": "8914",
    "name": "Коврига",
    "path": "Россия / Курганская область / Коврига",
    "country": "Россия",
    "searchString": "коврига россия / курганская область / коврига"
  },
  "8915": {
    "id": "8915",
    "name": "Ильино-Поляна",
    "path": "Россия / Республика Башкортостан / Ильино-Поляна",
    "country": "Россия",
    "searchString": "ильино-поляна россия / республика башкортостан / ильино-поляна"
  },
  "8916": {
    "id": "8916",
    "name": "Свердловское (Свердловская область)",
    "path": "Россия / Свердловская область / Свердловское (Свердловская область)",
    "country": "Россия",
    "searchString": "свердловское (свердловская область) россия / свердловская область / свердловское (свердловская область)"
  },
  "8917": {
    "id": "8917",
    "name": "Нижнетобольное",
    "path": "Россия / Курганская область / Нижнетобольное",
    "country": "Россия",
    "searchString": "нижнетобольное россия / курганская область / нижнетобольное"
  },
  "8918": {
    "id": "8918",
    "name": "Байны",
    "path": "Россия / Свердловская область / Байны",
    "country": "Россия",
    "searchString": "байны россия / свердловская область / байны"
  },
  "8919": {
    "id": "8919",
    "name": "Мулянка",
    "path": "Россия / Пермский край / Мулянка",
    "country": "Россия",
    "searchString": "мулянка россия / пермский край / мулянка"
  },
  "8920": {
    "id": "8920",
    "name": "Зюзельский",
    "path": "Россия / Свердловская область / Зюзельский",
    "country": "Россия",
    "searchString": "зюзельский россия / свердловская область / зюзельский"
  },
  "8921": {
    "id": "8921",
    "name": "Калмашбашево",
    "path": "Россия / Республика Башкортостан / Калмашбашево",
    "country": "Россия",
    "searchString": "калмашбашево россия / республика башкортостан / калмашбашево"
  },
  "8922": {
    "id": "8922",
    "name": "Шугур",
    "path": "Россия / Ханты-Мансийский АО - Югра / Шугур",
    "country": "Россия",
    "searchString": "шугур россия / ханты-мансийский ао - югра / шугур"
  },
  "8923": {
    "id": "8923",
    "name": "Асово",
    "path": "Россия / Пермский край / Асово",
    "country": "Россия",
    "searchString": "асово россия / пермский край / асово"
  },
  "8924": {
    "id": "8924",
    "name": "Чураево",
    "path": "Россия / Республика Башкортостан / Чураево",
    "country": "Россия",
    "searchString": "чураево россия / республика башкортостан / чураево"
  },
  "8925": {
    "id": "8925",
    "name": "Заозерное (Челябинская область)",
    "path": "Россия / Челябинская область / Заозерное (Челябинская область)",
    "country": "Россия",
    "searchString": "заозерное (челябинская область) россия / челябинская область / заозерное (челябинская область)"
  },
  "8926": {
    "id": "8926",
    "name": "Бырма",
    "path": "Россия / Пермский край / Бырма",
    "country": "Россия",
    "searchString": "бырма россия / пермский край / бырма"
  },
  "8927": {
    "id": "8927",
    "name": "Буньково",
    "path": "Россия / Тюменская область / Буньково",
    "country": "Россия",
    "searchString": "буньково россия / тюменская область / буньково"
  },
  "8928": {
    "id": "8928",
    "name": "Калинино (Пермский край)",
    "path": "Россия / Пермский край / Калинино (Пермский край)",
    "country": "Россия",
    "searchString": "калинино (пермский край) россия / пермский край / калинино (пермский край)"
  },
  "8929": {
    "id": "8929",
    "name": "Рынки",
    "path": "Россия / Курганская область / Рынки",
    "country": "Россия",
    "searchString": "рынки россия / курганская область / рынки"
  },
  "8930": {
    "id": "8930",
    "name": "Песчано-Коледино",
    "path": "Россия / Курганская область / Песчано-Коледино",
    "country": "Россия",
    "searchString": "песчано-коледино россия / курганская область / песчано-коледино"
  },
  "8931": {
    "id": "8931",
    "name": "Арка",
    "path": "Россия / Республика Башкортостан / Арка",
    "country": "Россия",
    "searchString": "арка россия / республика башкортостан / арка"
  },
  "8932": {
    "id": "8932",
    "name": "Нагайбакский",
    "path": "Россия / Челябинская область / Нагайбакский",
    "country": "Россия",
    "searchString": "нагайбакский россия / челябинская область / нагайбакский"
  },
  "8933": {
    "id": "8933",
    "name": "Рухтино",
    "path": "Россия / Республика Башкортостан / Рухтино",
    "country": "Россия",
    "searchString": "рухтино россия / республика башкортостан / рухтино"
  },
  "8934": {
    "id": "8934",
    "name": "Басьяновский",
    "path": "Россия / Свердловская область / Басьяновский",
    "country": "Россия",
    "searchString": "басьяновский россия / свердловская область / басьяновский"
  },
  "8935": {
    "id": "8935",
    "name": "Егва",
    "path": "Россия / Пермский край / Егва",
    "country": "Россия",
    "searchString": "егва россия / пермский край / егва"
  },
  "8936": {
    "id": "8936",
    "name": "Каратабан",
    "path": "Россия / Челябинская область / Каратабан",
    "country": "Россия",
    "searchString": "каратабан россия / челябинская область / каратабан"
  },
  "8937": {
    "id": "8937",
    "name": "Старые Богады",
    "path": "Россия / Республика Башкортостан / Старые Богады",
    "country": "Россия",
    "searchString": "старые богады россия / республика башкортостан / старые богады"
  },
  "8938": {
    "id": "8938",
    "name": "Спасо-Барда",
    "path": "Россия / Пермский край / Спасо-Барда",
    "country": "Россия",
    "searchString": "спасо-барда россия / пермский край / спасо-барда"
  },
  "8939": {
    "id": "8939",
    "name": "Рятамак",
    "path": "Россия / Республика Башкортостан / Рятамак",
    "country": "Россия",
    "searchString": "рятамак россия / республика башкортостан / рятамак"
  },
  "8940": {
    "id": "8940",
    "name": "Ургала",
    "path": "Россия / Республика Башкортостан / Ургала",
    "country": "Россия",
    "searchString": "ургала россия / республика башкортостан / ургала"
  },
  "8941": {
    "id": "8941",
    "name": "Окуневское",
    "path": "Россия / Курганская область / Окуневское",
    "country": "Россия",
    "searchString": "окуневское россия / курганская область / окуневское"
  },
  "8942": {
    "id": "8942",
    "name": "Юбилейный (Пермский край)",
    "path": "Россия / Пермский край / Юбилейный (Пермский край)",
    "country": "Россия",
    "searchString": "юбилейный (пермский край) россия / пермский край / юбилейный (пермский край)"
  },
  "8943": {
    "id": "8943",
    "name": "Алтай (Ханты-Мансийский АО - Югра)",
    "path": "Россия / Ханты-Мансийский АО - Югра / Алтай (Ханты-Мансийский АО - Югра)",
    "country": "Россия",
    "searchString": "алтай (ханты-мансийский ао - югра) россия / ханты-мансийский ао - югра / алтай (ханты-мансийский ао - югра)"
  },
  "8944": {
    "id": "8944",
    "name": "Восточное (Курганская область)",
    "path": "Россия / Курганская область / Восточное (Курганская область)",
    "country": "Россия",
    "searchString": "восточное (курганская область) россия / курганская область / восточное (курганская область)"
  },
  "8945": {
    "id": "8945",
    "name": "Боровское (Курганская область)",
    "path": "Россия / Курганская область / Боровское (Курганская область)",
    "country": "Россия",
    "searchString": "боровское (курганская область) россия / курганская область / боровское (курганская область)"
  },
  "8946": {
    "id": "8946",
    "name": "Калино",
    "path": "Россия / Пермский край / Калино",
    "country": "Россия",
    "searchString": "калино россия / пермский край / калино"
  },
  "8947": {
    "id": "8947",
    "name": "Кулуево",
    "path": "Россия / Челябинская область / Кулуево",
    "country": "Россия",
    "searchString": "кулуево россия / челябинская область / кулуево"
  },
  "8948": {
    "id": "8948",
    "name": "Митино",
    "path": "Россия / Курганская область / Митино",
    "country": "Россия",
    "searchString": "митино россия / курганская область / митино"
  },
  "8949": {
    "id": "8949",
    "name": "Верхний Авзян",
    "path": "Россия / Республика Башкортостан / Верхний Авзян",
    "country": "Россия",
    "searchString": "верхний авзян россия / республика башкортостан / верхний авзян"
  },
  "8950": {
    "id": "8950",
    "name": "Саранпауль",
    "path": "Россия / Ханты-Мансийский АО - Югра / Саранпауль",
    "country": "Россия",
    "searchString": "саранпауль россия / ханты-мансийский ао - югра / саранпауль"
  },
  "8951": {
    "id": "8951",
    "name": "Узян",
    "path": "Россия / Республика Башкортостан / Узян",
    "country": "Россия",
    "searchString": "узян россия / республика башкортостан / узян"
  },
  "8952": {
    "id": "8952",
    "name": "Чантырья",
    "path": "Россия / Ханты-Мансийский АО - Югра / Чантырья",
    "country": "Россия",
    "searchString": "чантырья россия / ханты-мансийский ао - югра / чантырья"
  },
  "8953": {
    "id": "8953",
    "name": "Ишкарово",
    "path": "Россия / Республика Башкортостан / Ишкарово",
    "country": "Россия",
    "searchString": "ишкарово россия / республика башкортостан / ишкарово"
  },
  "8954": {
    "id": "8954",
    "name": "Рябки",
    "path": "Россия / Пермский край / Рябки",
    "country": "Россия",
    "searchString": "рябки россия / пермский край / рябки"
  },
  "8955": {
    "id": "8955",
    "name": "Михайловка (Абзелиловский район)",
    "path": "Россия / Республика Башкортостан / Михайловка (Абзелиловский район)",
    "country": "Россия",
    "searchString": "михайловка (абзелиловский район) россия / республика башкортостан / михайловка (абзелиловский район)"
  },
  "8956": {
    "id": "8956",
    "name": "Силантьево",
    "path": "Россия / Республика Башкортостан / Силантьево",
    "country": "Россия",
    "searchString": "силантьево россия / республика башкортостан / силантьево"
  },
  "8957": {
    "id": "8957",
    "name": "Моховое",
    "path": "Россия / Пермский край / Моховое",
    "country": "Россия",
    "searchString": "моховое россия / пермский край / моховое"
  },
  "8958": {
    "id": "8958",
    "name": "Тауш",
    "path": "Россия / Пермский край / Тауш",
    "country": "Россия",
    "searchString": "тауш россия / пермский край / тауш"
  },
  "8959": {
    "id": "8959",
    "name": "Трун",
    "path": "Россия / Пермский край / Трун",
    "country": "Россия",
    "searchString": "трун россия / пермский край / трун"
  },
  "8960": {
    "id": "8960",
    "name": "Осинцево",
    "path": "Россия / Пермский край / Осинцево",
    "country": "Россия",
    "searchString": "осинцево россия / пермский край / осинцево"
  },
  "8961": {
    "id": "8961",
    "name": "Чайковская",
    "path": "Россия / Пермский край / Чайковская",
    "country": "Россия",
    "searchString": "чайковская россия / пермский край / чайковская"
  },
  "8962": {
    "id": "8962",
    "name": "Шорохово",
    "path": "Россия / Тюменская область / Шорохово",
    "country": "Россия",
    "searchString": "шорохово россия / тюменская область / шорохово"
  },
  "8963": {
    "id": "8963",
    "name": "Село 1-е Туркменево",
    "path": "Россия / Республика Башкортостан / Село 1-е Туркменево",
    "country": "Россия",
    "searchString": "село 1-е туркменево россия / республика башкортостан / село 1-е туркменево"
  },
  "8964": {
    "id": "8964",
    "name": "Новопетропавловское",
    "path": "Россия / Курганская область / Новопетропавловское",
    "country": "Россия",
    "searchString": "новопетропавловское россия / курганская область / новопетропавловское"
  },
  "8965": {
    "id": "8965",
    "name": "Рождественск",
    "path": "Россия / Пермский край / Рождественск",
    "country": "Россия",
    "searchString": "рождественск россия / пермский край / рождественск"
  },
  "8966": {
    "id": "8966",
    "name": "Резяпово",
    "path": "Россия / Республика Башкортостан / Резяпово",
    "country": "Россия",
    "searchString": "резяпово россия / республика башкортостан / резяпово"
  },
  "8967": {
    "id": "8967",
    "name": "Кленовка (Пермский край)",
    "path": "Россия / Пермский край / Кленовка (Пермский край)",
    "country": "Россия",
    "searchString": "кленовка (пермский край) россия / пермский край / кленовка (пермский край)"
  },
  "8968": {
    "id": "8968",
    "name": "Самбург",
    "path": "Россия / Ямало-Ненецкий АО / Самбург",
    "country": "Россия",
    "searchString": "самбург россия / ямало-ненецкий ао / самбург"
  },
  "8969": {
    "id": "8969",
    "name": "Верхнечусовские Городки",
    "path": "Россия / Пермский край / Верхнечусовские Городки",
    "country": "Россия",
    "searchString": "верхнечусовские городки россия / пермский край / верхнечусовские городки"
  },
  "8970": {
    "id": "8970",
    "name": "Сыртинский",
    "path": "Россия / Челябинская область / Сыртинский",
    "country": "Россия",
    "searchString": "сыртинский россия / челябинская область / сыртинский"
  },
  "8971": {
    "id": "8971",
    "name": "Караси",
    "path": "Россия / Курганская область / Караси",
    "country": "Россия",
    "searchString": "караси россия / курганская область / караси"
  },
  "8972": {
    "id": "8972",
    "name": "Долговка",
    "path": "Россия / Курганская область / Долговка",
    "country": "Россия",
    "searchString": "долговка россия / курганская область / долговка"
  },
  "8973": {
    "id": "8973",
    "name": "Михайловка (Бижбуклякский район)",
    "path": "Россия / Республика Башкортостан / Михайловка (Бижбуклякский район)",
    "country": "Россия",
    "searchString": "михайловка (бижбуклякский район) россия / республика башкортостан / михайловка (бижбуклякский район)"
  },
  "8974": {
    "id": "8974",
    "name": "Аксаково",
    "path": "Россия / Республика Башкортостан / Аксаково",
    "country": "Россия",
    "searchString": "аксаково россия / республика башкортостан / аксаково"
  },
  "8975": {
    "id": "8975",
    "name": "Чистопрудное",
    "path": "Россия / Курганская область / Чистопрудное",
    "country": "Россия",
    "searchString": "чистопрудное россия / курганская область / чистопрудное"
  },
  "8976": {
    "id": "8976",
    "name": "Кичигино",
    "path": "Россия / Челябинская область / Кичигино",
    "country": "Россия",
    "searchString": "кичигино россия / челябинская область / кичигино"
  },
  "8977": {
    "id": "8977",
    "name": "Пашково (Курганская область)",
    "path": "Россия / Курганская область / Пашково (Курганская область)",
    "country": "Россия",
    "searchString": "пашково (курганская область) россия / курганская область / пашково (курганская область)"
  },
  "8978": {
    "id": "8978",
    "name": "Коровье",
    "path": "Россия / Курганская область / Коровье",
    "country": "Россия",
    "searchString": "коровье россия / курганская область / коровье"
  },
  "8979": {
    "id": "8979",
    "name": "Бузатово",
    "path": "Россия / Республика Башкортостан / Бузатово",
    "country": "Россия",
    "searchString": "бузатово россия / республика башкортостан / бузатово"
  },
  "8980": {
    "id": "8980",
    "name": "Большой Гондыр",
    "path": "Россия / Пермский край / Большой Гондыр",
    "country": "Россия",
    "searchString": "большой гондыр россия / пермский край / большой гондыр"
  },
  "8981": {
    "id": "8981",
    "name": "Кальтовка",
    "path": "Россия / Республика Башкортостан / Кальтовка",
    "country": "Россия",
    "searchString": "кальтовка россия / республика башкортостан / кальтовка"
  },
  "8982": {
    "id": "8982",
    "name": "Ермолкино",
    "path": "Россия / Республика Башкортостан / Ермолкино",
    "country": "Россия",
    "searchString": "ермолкино россия / республика башкортостан / ермолкино"
  },
  "8983": {
    "id": "8983",
    "name": "Старобазаново",
    "path": "Россия / Республика Башкортостан / Старобазаново",
    "country": "Россия",
    "searchString": "старобазаново россия / республика башкортостан / старобазаново"
  },
  "8984": {
    "id": "8984",
    "name": "Филатовское",
    "path": "Россия / Свердловская область / Филатовское",
    "country": "Россия",
    "searchString": "филатовское россия / свердловская область / филатовское"
  },
  "8985": {
    "id": "8985",
    "name": "Маслянский",
    "path": "Россия / Тюменская область / Маслянский",
    "country": "Россия",
    "searchString": "маслянский россия / тюменская область / маслянский"
  },
  "8986": {
    "id": "8986",
    "name": "Волостновка",
    "path": "Россия / Республика Башкортостан / Волостновка",
    "country": "Россия",
    "searchString": "волостновка россия / республика башкортостан / волостновка"
  },
  "8987": {
    "id": "8987",
    "name": "Верх-Язьва",
    "path": "Россия / Пермский край / Верх-Язьва",
    "country": "Россия",
    "searchString": "верх-язьва россия / пермский край / верх-язьва"
  },
  "8988": {
    "id": "8988",
    "name": "Ариево",
    "path": "Россия / Республика Башкортостан / Ариево",
    "country": "Россия",
    "searchString": "ариево россия / республика башкортостан / ариево"
  },
  "8989": {
    "id": "8989",
    "name": "Верхнеказымский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Верхнеказымский",
    "country": "Россия",
    "searchString": "верхнеказымский россия / ханты-мансийский ао - югра / верхнеказымский"
  },
  "8990": {
    "id": "8990",
    "name": "Ларино",
    "path": "Россия / Челябинская область / Ларино",
    "country": "Россия",
    "searchString": "ларино россия / челябинская область / ларино"
  },
  "8991": {
    "id": "8991",
    "name": "Перегребное",
    "path": "Россия / Ханты-Мансийский АО - Югра / Перегребное",
    "country": "Россия",
    "searchString": "перегребное россия / ханты-мансийский ао - югра / перегребное"
  },
  "8992": {
    "id": "8992",
    "name": "Новомурапталово",
    "path": "Россия / Республика Башкортостан / Новомурапталово",
    "country": "Россия",
    "searchString": "новомурапталово россия / республика башкортостан / новомурапталово"
  },
  "8993": {
    "id": "8993",
    "name": "Чазево",
    "path": "Россия / Пермский край / Чазево",
    "country": "Россия",
    "searchString": "чазево россия / пермский край / чазево"
  },
  "8994": {
    "id": "8994",
    "name": "Малый Атлым",
    "path": "Россия / Ханты-Мансийский АО - Югра / Малый Атлым",
    "country": "Россия",
    "searchString": "малый атлым россия / ханты-мансийский ао - югра / малый атлым"
  },
  "8995": {
    "id": "8995",
    "name": "Сараны",
    "path": "Россия / Пермский край / Сараны",
    "country": "Россия",
    "searchString": "сараны россия / пермский край / сараны"
  },
  "8996": {
    "id": "8996",
    "name": "Гремяча",
    "path": "Россия / Пермский край / Гремяча",
    "country": "Россия",
    "searchString": "гремяча россия / пермский край / гремяча"
  },
  "8997": {
    "id": "8997",
    "name": "Сарана",
    "path": "Россия / Свердловская область / Сарана",
    "country": "Россия",
    "searchString": "сарана россия / свердловская область / сарана"
  },
  "8998": {
    "id": "8998",
    "name": "Ефремкино",
    "path": "Россия / Республика Башкортостан / Ефремкино",
    "country": "Россия",
    "searchString": "ефремкино россия / республика башкортостан / ефремкино"
  },
  "8999": {
    "id": "8999",
    "name": "Актабан",
    "path": "Россия / Курганская область / Актабан",
    "country": "Россия",
    "searchString": "актабан россия / курганская область / актабан"
  },
  "9000": {
    "id": "9000",
    "name": "Шингак-Куль",
    "path": "Россия / Республика Башкортостан / Шингак-Куль",
    "country": "Россия",
    "searchString": "шингак-куль россия / республика башкортостан / шингак-куль"
  },
  "9001": {
    "id": "9001",
    "name": "Северный Колчим",
    "path": "Россия / Пермский край / Северный Колчим",
    "country": "Россия",
    "searchString": "северный колчим россия / пермский край / северный колчим"
  },
  "9002": {
    "id": "9002",
    "name": "Ургаза",
    "path": "Россия / Республика Башкортостан / Ургаза",
    "country": "Россия",
    "searchString": "ургаза россия / республика башкортостан / ургаза"
  },
  "9003": {
    "id": "9003",
    "name": "Маминское",
    "path": "Россия / Свердловская область / Маминское",
    "country": "Россия",
    "searchString": "маминское россия / свердловская область / маминское"
  },
  "9004": {
    "id": "9004",
    "name": "Верх-Юсьва",
    "path": "Россия / Пермский край / Верх-Юсьва",
    "country": "Россия",
    "searchString": "верх-юсьва россия / пермский край / верх-юсьва"
  },
  "9005": {
    "id": "9005",
    "name": "Пуксиб",
    "path": "Россия / Пермский край / Пуксиб",
    "country": "Россия",
    "searchString": "пуксиб россия / пермский край / пуксиб"
  },
  "9006": {
    "id": "9006",
    "name": "Емуртла",
    "path": "Россия / Тюменская область / Емуртла",
    "country": "Россия",
    "searchString": "емуртла россия / тюменская область / емуртла"
  },
  "9007": {
    "id": "9007",
    "name": "Кузнецовский",
    "path": "Россия / Свердловская область / Кузнецовский",
    "country": "Россия",
    "searchString": "кузнецовский россия / свердловская область / кузнецовский"
  },
  "9008": {
    "id": "9008",
    "name": "Восход (Свердловская область)",
    "path": "Россия / Свердловская область / Восход (Свердловская область)",
    "country": "Россия",
    "searchString": "восход (свердловская область) россия / свердловская область / восход (свердловская область)"
  },
  "9009": {
    "id": "9009",
    "name": "Канаши",
    "path": "Россия / Курганская область / Канаши",
    "country": "Россия",
    "searchString": "канаши россия / курганская область / канаши"
  },
  "9010": {
    "id": "9010",
    "name": "Подовинное",
    "path": "Россия / Челябинская область / Подовинное",
    "country": "Россия",
    "searchString": "подовинное россия / челябинская область / подовинное"
  },
  "9011": {
    "id": "9011",
    "name": "Белоево",
    "path": "Россия / Пермский край / Белоево",
    "country": "Россия",
    "searchString": "белоево россия / пермский край / белоево"
  },
  "9012": {
    "id": "9012",
    "name": "Сулея",
    "path": "Россия / Челябинская область / Сулея",
    "country": "Россия",
    "searchString": "сулея россия / челябинская область / сулея"
  },
  "9013": {
    "id": "9013",
    "name": "Тарасково",
    "path": "Россия / Свердловская область / Тарасково",
    "country": "Россия",
    "searchString": "тарасково россия / свердловская область / тарасково"
  },
  "9014": {
    "id": "9014",
    "name": "Русский Сарс",
    "path": "Россия / Пермский край / Русский Сарс",
    "country": "Россия",
    "searchString": "русский сарс россия / пермский край / русский сарс"
  },
  "9015": {
    "id": "9015",
    "name": "Бедеева Поляна",
    "path": "Россия / Республика Башкортостан / Бедеева Поляна",
    "country": "Россия",
    "searchString": "бедеева поляна россия / республика башкортостан / бедеева поляна"
  },
  "9016": {
    "id": "9016",
    "name": "Новые Карьявды",
    "path": "Россия / Республика Башкортостан / Новые Карьявды",
    "country": "Россия",
    "searchString": "новые карьявды россия / республика башкортостан / новые карьявды"
  },
  "9017": {
    "id": "9017",
    "name": "Новонагаево",
    "path": "Россия / Республика Башкортостан / Новонагаево",
    "country": "Россия",
    "searchString": "новонагаево россия / республика башкортостан / новонагаево"
  },
  "9018": {
    "id": "9018",
    "name": "Птичье (Курганская область)",
    "path": "Россия / Курганская область / Птичье (Курганская область)",
    "country": "Россия",
    "searchString": "птичье (курганская область) россия / курганская область / птичье (курганская область)"
  },
  "9019": {
    "id": "9019",
    "name": "Барино",
    "path": "Россия / Курганская область / Барино",
    "country": "Россия",
    "searchString": "барино россия / курганская область / барино"
  },
  "9020": {
    "id": "9020",
    "name": "Бичурино",
    "path": "Россия / Пермский край / Бичурино",
    "country": "Россия",
    "searchString": "бичурино россия / пермский край / бичурино"
  },
  "9021": {
    "id": "9021",
    "name": "Магинск",
    "path": "Россия / Республика Башкортостан / Магинск",
    "country": "Россия",
    "searchString": "магинск россия / республика башкортостан / магинск"
  },
  "9022": {
    "id": "9022",
    "name": "Новорождественское",
    "path": "Россия / Пермский край / Новорождественское",
    "country": "Россия",
    "searchString": "новорождественское россия / пермский край / новорождественское"
  },
  "9023": {
    "id": "9023",
    "name": "Осиновка",
    "path": "Россия / Республика Башкортостан / Осиновка",
    "country": "Россия",
    "searchString": "осиновка россия / республика башкортостан / осиновка"
  },
  "9024": {
    "id": "9024",
    "name": "Селезян",
    "path": "Россия / Челябинская область / Селезян",
    "country": "Россия",
    "searchString": "селезян россия / челябинская область / селезян"
  },
  "9025": {
    "id": "9025",
    "name": "Красноглинный",
    "path": "Россия / Свердловская область / Красноглинный",
    "country": "Россия",
    "searchString": "красноглинный россия / свердловская область / красноглинный"
  },
  "9026": {
    "id": "9026",
    "name": "Оус",
    "path": "Россия / Свердловская область / Оус",
    "country": "Россия",
    "searchString": "оус россия / свердловская область / оус"
  },
  "9027": {
    "id": "9027",
    "name": "Нагорское",
    "path": "Россия / Курганская область / Нагорское",
    "country": "Россия",
    "searchString": "нагорское россия / курганская область / нагорское"
  },
  "9028": {
    "id": "9028",
    "name": "Павловский",
    "path": "Россия / Пермский край / Павловский",
    "country": "Россия",
    "searchString": "павловский россия / пермский край / павловский"
  },
  "9029": {
    "id": "9029",
    "name": "Серебрянка",
    "path": "Россия / Пермский край / Серебрянка",
    "country": "Россия",
    "searchString": "серебрянка россия / пермский край / серебрянка"
  },
  "9030": {
    "id": "9030",
    "name": "Старокуручево",
    "path": "Россия / Республика Башкортостан / Старокуручево",
    "country": "Россия",
    "searchString": "старокуручево россия / республика башкортостан / старокуручево"
  },
  "9031": {
    "id": "9031",
    "name": "Пятково",
    "path": "Россия / Тюменская область / Пятково",
    "country": "Россия",
    "searchString": "пятково россия / тюменская область / пятково"
  },
  "9032": {
    "id": "9032",
    "name": "Сараши",
    "path": "Россия / Пермский край / Сараши",
    "country": "Россия",
    "searchString": "сараши россия / пермский край / сараши"
  },
  "9033": {
    "id": "9033",
    "name": "Старокалмашево",
    "path": "Россия / Республика Башкортостан / Старокалмашево",
    "country": "Россия",
    "searchString": "старокалмашево россия / республика башкортостан / старокалмашево"
  },
  "9034": {
    "id": "9034",
    "name": "Бердышево",
    "path": "Россия / Пермский край / Бердышево",
    "country": "Россия",
    "searchString": "бердышево россия / пермский край / бердышево"
  },
  "9035": {
    "id": "9035",
    "name": "Угут",
    "path": "Россия / Ханты-Мансийский АО - Югра / Угут",
    "country": "Россия",
    "searchString": "угут россия / ханты-мансийский ао - югра / угут"
  },
  "9036": {
    "id": "9036",
    "name": "Суда (Пермский край)",
    "path": "Россия / Пермский край / Суда (Пермский край)",
    "country": "Россия",
    "searchString": "суда (пермский край) россия / пермский край / суда (пермский край)"
  },
  "9037": {
    "id": "9037",
    "name": "Керос",
    "path": "Россия / Пермский край / Керос",
    "country": "Россия",
    "searchString": "керос россия / пермский край / керос"
  },
  "9038": {
    "id": "9038",
    "name": "Обручевка",
    "path": "Россия / Челябинская область / Обручевка",
    "country": "Россия",
    "searchString": "обручевка россия / челябинская область / обручевка"
  },
  "9039": {
    "id": "9039",
    "name": "Ключевск",
    "path": "Россия / Свердловская область / Ключевск",
    "country": "Россия",
    "searchString": "ключевск россия / свердловская область / ключевск"
  },
  "9040": {
    "id": "9040",
    "name": "Северо-Плетнево",
    "path": "Россия / Тюменская область / Северо-Плетнево",
    "country": "Россия",
    "searchString": "северо-плетнево россия / тюменская область / северо-плетнево"
  },
  "9041": {
    "id": "9041",
    "name": "Село Центральной усадьбы племзавода имени Максима Горького",
    "path": "Россия / Республика Башкортостан / Село Центральной усадьбы племзавода имени Максима Горького",
    "country": "Россия",
    "searchString": "село центральной усадьбы племзавода имени максима горького россия / республика башкортостан / село центральной усадьбы племзавода имени максима горького"
  },
  "9042": {
    "id": "9042",
    "name": "Новодостовалово",
    "path": "Россия / Курганская область / Новодостовалово",
    "country": "Россия",
    "searchString": "новодостовалово россия / курганская область / новодостовалово"
  },
  "9043": {
    "id": "9043",
    "name": "Юговское",
    "path": "Россия / Пермский край / Юговское",
    "country": "Россия",
    "searchString": "юговское россия / пермский край / юговское"
  },
  "9044": {
    "id": "9044",
    "name": "Петропавловский",
    "path": "Россия / Челябинская область / Петропавловский",
    "country": "Россия",
    "searchString": "петропавловский россия / челябинская область / петропавловский"
  },
  "9045": {
    "id": "9045",
    "name": "Быньги",
    "path": "Россия / Свердловская область / Быньги",
    "country": "Россия",
    "searchString": "быньги россия / свердловская область / быньги"
  },
  "9046": {
    "id": "9046",
    "name": "Зуевский",
    "path": "Россия / Пермский край / Зуевский",
    "country": "Россия",
    "searchString": "зуевский россия / пермский край / зуевский"
  },
  "9047": {
    "id": "9047",
    "name": "Охлебинино",
    "path": "Россия / Республика Башкортостан / Охлебинино",
    "country": "Россия",
    "searchString": "охлебинино россия / республика башкортостан / охлебинино"
  },
  "9048": {
    "id": "9048",
    "name": "Большой Куганак",
    "path": "Россия / Республика Башкортостан / Большой Куганак",
    "country": "Россия",
    "searchString": "большой куганак россия / республика башкортостан / большой куганак"
  },
  "9049": {
    "id": "9049",
    "name": "Полетаево-1",
    "path": "Россия / Челябинская область / Полетаево-1",
    "country": "Россия",
    "searchString": "полетаево-1 россия / челябинская область / полетаево-1"
  },
  "9050": {
    "id": "9050",
    "name": "Деменево",
    "path": "Россия / Пермский край / Деменево",
    "country": "Россия",
    "searchString": "деменево россия / пермский край / деменево"
  },
  "9051": {
    "id": "9051",
    "name": "Аксеново (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Аксеново (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "аксеново (республика башкортостан) россия / республика башкортостан / аксеново (республика башкортостан)"
  },
  "9052": {
    "id": "9052",
    "name": "Галкино",
    "path": "Россия / Курганская область / Галкино",
    "country": "Россия",
    "searchString": "галкино россия / курганская область / галкино"
  },
  "9053": {
    "id": "9053",
    "name": "Щербаковка",
    "path": "Россия / Челябинская область / Щербаковка",
    "country": "Россия",
    "searchString": "щербаковка россия / челябинская область / щербаковка"
  },
  "9054": {
    "id": "9054",
    "name": "Усть-Уйское",
    "path": "Россия / Курганская область / Усть-Уйское",
    "country": "Россия",
    "searchString": "усть-уйское россия / курганская область / усть-уйское"
  },
  "9055": {
    "id": "9055",
    "name": "Рсаево",
    "path": "Россия / Республика Башкортостан / Рсаево",
    "country": "Россия",
    "searchString": "рсаево россия / республика башкортостан / рсаево"
  },
  "9056": {
    "id": "9056",
    "name": "Варшавка",
    "path": "Россия / Челябинская область / Варшавка",
    "country": "Россия",
    "searchString": "варшавка россия / челябинская область / варшавка"
  },
  "9057": {
    "id": "9057",
    "name": "Харута",
    "path": "Россия / Ямало-Ненецкий АО / Харута",
    "country": "Россия",
    "searchString": "харута россия / ямало-ненецкий ао / харута"
  },
  "9058": {
    "id": "9058",
    "name": "Обвинск",
    "path": "Россия / Пермский край / Обвинск",
    "country": "Россия",
    "searchString": "обвинск россия / пермский край / обвинск"
  },
  "9059": {
    "id": "9059",
    "name": "Великопетровка",
    "path": "Россия / Челябинская область / Великопетровка",
    "country": "Россия",
    "searchString": "великопетровка россия / челябинская область / великопетровка"
  },
  "9060": {
    "id": "9060",
    "name": "Целинный",
    "path": "Россия / Республика Башкортостан / Целинный",
    "country": "Россия",
    "searchString": "целинный россия / республика башкортостан / целинный"
  },
  "9061": {
    "id": "9061",
    "name": "Бондюг",
    "path": "Россия / Пермский край / Бондюг",
    "country": "Россия",
    "searchString": "бондюг россия / пермский край / бондюг"
  },
  "9062": {
    "id": "9062",
    "name": "Питяково",
    "path": "Россия / Республика Башкортостан / Питяково",
    "country": "Россия",
    "searchString": "питяково россия / республика башкортостан / питяково"
  },
  "9063": {
    "id": "9063",
    "name": "Кананикольское",
    "path": "Россия / Республика Башкортостан / Кананикольское",
    "country": "Россия",
    "searchString": "кананикольское россия / республика башкортостан / кананикольское"
  },
  "9064": {
    "id": "9064",
    "name": "Криулино",
    "path": "Россия / Свердловская область / Криулино",
    "country": "Россия",
    "searchString": "криулино россия / свердловская область / криулино"
  },
  "9065": {
    "id": "9065",
    "name": "Вассята",
    "path": "Россия / Пермский край / Вассята",
    "country": "Россия",
    "searchString": "вассята россия / пермский край / вассята"
  },
  "9066": {
    "id": "9066",
    "name": "Казаркино",
    "path": "Россия / Курганская область / Казаркино",
    "country": "Россия",
    "searchString": "казаркино россия / курганская область / казаркино"
  },
  "9067": {
    "id": "9067",
    "name": "Нижние Бишинды",
    "path": "Россия / Республика Башкортостан / Нижние Бишинды",
    "country": "Россия",
    "searchString": "нижние бишинды россия / республика башкортостан / нижние бишинды"
  },
  "9068": {
    "id": "9068",
    "name": "Погорелка",
    "path": "Россия / Курганская область / Погорелка",
    "country": "Россия",
    "searchString": "погорелка россия / курганская область / погорелка"
  },
  "9069": {
    "id": "9069",
    "name": "Нордовка",
    "path": "Россия / Республика Башкортостан / Нордовка",
    "country": "Россия",
    "searchString": "нордовка россия / республика башкортостан / нордовка"
  },
  "9070": {
    "id": "9070",
    "name": "Нялинское",
    "path": "Россия / Ханты-Мансийский АО - Югра / Нялинское",
    "country": "Россия",
    "searchString": "нялинское россия / ханты-мансийский ао - югра / нялинское"
  },
  "9071": {
    "id": "9071",
    "name": "Кленовское",
    "path": "Россия / Свердловская область / Кленовское",
    "country": "Россия",
    "searchString": "кленовское россия / свердловская область / кленовское"
  },
  "9072": {
    "id": "9072",
    "name": "Усть-Язьва",
    "path": "Россия / Пермский край / Усть-Язьва",
    "country": "Россия",
    "searchString": "усть-язьва россия / пермский край / усть-язьва"
  },
  "9073": {
    "id": "9073",
    "name": "Половодово",
    "path": "Россия / Пермский край / Половодово",
    "country": "Россия",
    "searchString": "половодово россия / пермский край / половодово"
  },
  "9074": {
    "id": "9074",
    "name": "Комарихинский",
    "path": "Россия / Пермский край / Комарихинский",
    "country": "Россия",
    "searchString": "комарихинский россия / пермский край / комарихинский"
  },
  "9075": {
    "id": "9075",
    "name": "Урзайбаш",
    "path": "Россия / Республика Башкортостан / Урзайбаш",
    "country": "Россия",
    "searchString": "урзайбаш россия / республика башкортостан / урзайбаш"
  },
  "9076": {
    "id": "9076",
    "name": "Кислянка",
    "path": "Россия / Курганская область / Кислянка",
    "country": "Россия",
    "searchString": "кислянка россия / курганская область / кислянка"
  },
  "9077": {
    "id": "9077",
    "name": "Левиха",
    "path": "Россия / Свердловская область / Левиха",
    "country": "Россия",
    "searchString": "левиха россия / свердловская область / левиха"
  },
  "9078": {
    "id": "9078",
    "name": "Мурсалимкино",
    "path": "Россия / Республика Башкортостан / Мурсалимкино",
    "country": "Россия",
    "searchString": "мурсалимкино россия / республика башкортостан / мурсалимкино"
  },
  "9079": {
    "id": "9079",
    "name": "Обутковское",
    "path": "Россия / Курганская область / Обутковское",
    "country": "Россия",
    "searchString": "обутковское россия / курганская область / обутковское"
  },
  "9080": {
    "id": "9080",
    "name": "Вознесенка (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Вознесенка (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "вознесенка (республика башкортостан) россия / республика башкортостан / вознесенка (республика башкортостан)"
  },
  "9081": {
    "id": "9081",
    "name": "Покровское (Артемовский район)",
    "path": "Россия / Свердловская область / Покровское (Артемовский район)",
    "country": "Россия",
    "searchString": "покровское (артемовский район) россия / свердловская область / покровское (артемовский район)"
  },
  "9082": {
    "id": "9082",
    "name": "Цингалы",
    "path": "Россия / Ханты-Мансийский АО - Югра / Цингалы",
    "country": "Россия",
    "searchString": "цингалы россия / ханты-мансийский ао - югра / цингалы"
  },
  "9083": {
    "id": "9083",
    "name": "Путь Октября",
    "path": "Россия / Челябинская область / Путь Октября",
    "country": "Россия",
    "searchString": "путь октября россия / челябинская область / путь октября"
  },
  "9084": {
    "id": "9084",
    "name": "Тюш",
    "path": "Россия / Пермский край / Тюш",
    "country": "Россия",
    "searchString": "тюш россия / пермский край / тюш"
  },
  "9085": {
    "id": "9085",
    "name": "Ошиб",
    "path": "Россия / Пермский край / Ошиб",
    "country": "Россия",
    "searchString": "ошиб россия / пермский край / ошиб"
  },
  "9086": {
    "id": "9086",
    "name": "Сепыч",
    "path": "Россия / Пермский край / Сепыч",
    "country": "Россия",
    "searchString": "сепыч россия / пермский край / сепыч"
  },
  "9087": {
    "id": "9087",
    "name": "Кандаковка",
    "path": "Россия / Республика Башкортостан / Кандаковка",
    "country": "Россия",
    "searchString": "кандаковка россия / республика башкортостан / кандаковка"
  },
  "9088": {
    "id": "9088",
    "name": "Карлыханово",
    "path": "Россия / Республика Башкортостан / Карлыханово",
    "country": "Россия",
    "searchString": "карлыханово россия / республика башкортостан / карлыханово"
  },
  "9089": {
    "id": "9089",
    "name": "Рябинино",
    "path": "Россия / Пермский край / Рябинино",
    "country": "Россия",
    "searchString": "рябинино россия / пермский край / рябинино"
  },
  "9090": {
    "id": "9090",
    "name": "Масали",
    "path": "Россия / Тюменская область / Масали",
    "country": "Россия",
    "searchString": "масали россия / тюменская область / масали"
  },
  "9091": {
    "id": "9091",
    "name": "Тубинский (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Тубинский (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "тубинский (республика башкортостан) россия / республика башкортостан / тубинский (республика башкортостан)"
  },
  "9092": {
    "id": "9092",
    "name": "Пермякова",
    "path": "Россия / Пермский край / Пермякова",
    "country": "Россия",
    "searchString": "пермякова россия / пермский край / пермякова"
  },
  "9093": {
    "id": "9093",
    "name": "Горохово",
    "path": "Россия / Курганская область / Горохово",
    "country": "Россия",
    "searchString": "горохово россия / курганская область / горохово"
  },
  "9094": {
    "id": "9094",
    "name": "Ергач",
    "path": "Россия / Пермский край / Ергач",
    "country": "Россия",
    "searchString": "ергач россия / пермский край / ергач"
  },
  "9095": {
    "id": "9095",
    "name": "Кольцово (Свердловская область)",
    "path": "Россия / Свердловская область / Кольцово (Свердловская область)",
    "country": "Россия",
    "searchString": "кольцово (свердловская область) россия / свердловская область / кольцово (свердловская область)"
  },
  "9096": {
    "id": "9096",
    "name": "Бородулино",
    "path": "Россия / Пермский край / Бородулино",
    "country": "Россия",
    "searchString": "бородулино россия / пермский край / бородулино"
  },
  "9097": {
    "id": "9097",
    "name": "Вперед",
    "path": "Россия / Республика Башкортостан / Вперед",
    "country": "Россия",
    "searchString": "вперед россия / республика башкортостан / вперед"
  },
  "9098": {
    "id": "9098",
    "name": "Урман",
    "path": "Россия / Республика Башкортостан / Урман",
    "country": "Россия",
    "searchString": "урман россия / республика башкортостан / урман"
  },
  "9099": {
    "id": "9099",
    "name": "Голубковское",
    "path": "Россия / Свердловская область / Голубковское",
    "country": "Россия",
    "searchString": "голубковское россия / свердловская область / голубковское"
  },
  "9100": {
    "id": "9100",
    "name": "Юмас",
    "path": "Россия / Ханты-Мансийский АО - Югра / Юмас",
    "country": "Россия",
    "searchString": "юмас россия / ханты-мансийский ао - югра / юмас"
  },
  "9101": {
    "id": "9101",
    "name": "Бараба",
    "path": "Россия / Свердловская область / Бараба",
    "country": "Россия",
    "searchString": "бараба россия / свердловская область / бараба"
  },
  "9102": {
    "id": "9102",
    "name": "Красноленинский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Красноленинский",
    "country": "Россия",
    "searchString": "красноленинский россия / ханты-мансийский ао - югра / красноленинский"
  },
  "9103": {
    "id": "9103",
    "name": "Нижнебалтачево",
    "path": "Россия / Республика Башкортостан / Нижнебалтачево",
    "country": "Россия",
    "searchString": "нижнебалтачево россия / республика башкортостан / нижнебалтачево"
  },
  "9104": {
    "id": "9104",
    "name": "Самково",
    "path": "Россия / Пермский край / Самково",
    "country": "Россия",
    "searchString": "самково россия / пермский край / самково"
  },
  "9105": {
    "id": "9105",
    "name": "Пешнигорт",
    "path": "Россия / Пермский край / Пешнигорт",
    "country": "Россия",
    "searchString": "пешнигорт россия / пермский край / пешнигорт"
  },
  "9106": {
    "id": "9106",
    "name": "Аятское",
    "path": "Россия / Свердловская область / Аятское",
    "country": "Россия",
    "searchString": "аятское россия / свердловская область / аятское"
  },
  "9107": {
    "id": "9107",
    "name": "Красномыльское",
    "path": "Россия / Курганская область / Красномыльское",
    "country": "Россия",
    "searchString": "красномыльское россия / курганская область / красномыльское"
  },
  "9108": {
    "id": "9108",
    "name": "Крохалево",
    "path": "Россия / Пермский край / Крохалево",
    "country": "Россия",
    "searchString": "крохалево россия / пермский край / крохалево"
  },
  "9109": {
    "id": "9109",
    "name": "Калтыманово",
    "path": "Россия / Республика Башкортостан / Калтыманово",
    "country": "Россия",
    "searchString": "калтыманово россия / республика башкортостан / калтыманово"
  },
  "9110": {
    "id": "9110",
    "name": "Ножовка",
    "path": "Россия / Пермский край / Ножовка",
    "country": "Россия",
    "searchString": "ножовка россия / пермский край / ножовка"
  },
  "9111": {
    "id": "9111",
    "name": "Гагарье",
    "path": "Россия / Курганская область / Гагарье",
    "country": "Россия",
    "searchString": "гагарье россия / курганская область / гагарье"
  },
  "9112": {
    "id": "9112",
    "name": "Зириклы",
    "path": "Россия / Республика Башкортостан / Зириклы",
    "country": "Россия",
    "searchString": "зириклы россия / республика башкортостан / зириклы"
  },
  "9113": {
    "id": "9113",
    "name": "Ларьяк",
    "path": "Россия / Ханты-Мансийский АО - Югра / Ларьяк",
    "country": "Россия",
    "searchString": "ларьяк россия / ханты-мансийский ао - югра / ларьяк"
  },
  "9114": {
    "id": "9114",
    "name": "Подольск (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Подольск (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "подольск (республика башкортостан) россия / республика башкортостан / подольск (республика башкортостан)"
  },
  "9115": {
    "id": "9115",
    "name": "Сытомино",
    "path": "Россия / Ханты-Мансийский АО - Югра / Сытомино",
    "country": "Россия",
    "searchString": "сытомино россия / ханты-мансийский ао - югра / сытомино"
  },
  "9116": {
    "id": "9116",
    "name": "Дуслык",
    "path": "Россия / Республика Башкортостан / Дуслык",
    "country": "Россия",
    "searchString": "дуслык россия / республика башкортостан / дуслык"
  },
  "9117": {
    "id": "9117",
    "name": "Висим",
    "path": "Россия / Свердловская область / Висим",
    "country": "Россия",
    "searchString": "висим россия / свердловская область / висим"
  },
  "9118": {
    "id": "9118",
    "name": "Медведка",
    "path": "Россия / Пермский край / Медведка",
    "country": "Россия",
    "searchString": "медведка россия / пермский край / медведка"
  },
  "9119": {
    "id": "9119",
    "name": "Ялым",
    "path": "Россия / Курганская область / Ялым",
    "country": "Россия",
    "searchString": "ялым россия / курганская область / ялым"
  },
  "9120": {
    "id": "9120",
    "name": "Айлино",
    "path": "Россия / Челябинская область / Айлино",
    "country": "Россия",
    "searchString": "айлино россия / челябинская область / айлино"
  },
  "9121": {
    "id": "9121",
    "name": "Боровлянка (Курганская область)",
    "path": "Россия / Курганская область / Боровлянка (Курганская область)",
    "country": "Россия",
    "searchString": "боровлянка (курганская область) россия / курганская область / боровлянка (курганская область)"
  },
  "9122": {
    "id": "9122",
    "name": "Полоцкое",
    "path": "Россия / Челябинская область / Полоцкое",
    "country": "Россия",
    "searchString": "полоцкое россия / челябинская область / полоцкое"
  },
  "9123": {
    "id": "9123",
    "name": "Ваньки",
    "path": "Россия / Пермский край / Ваньки",
    "country": "Россия",
    "searchString": "ваньки россия / пермский край / ваньки"
  },
  "9124": {
    "id": "9124",
    "name": "Кордон",
    "path": "Россия / Пермский край / Кордон",
    "country": "Россия",
    "searchString": "кордон россия / пермский край / кордон"
  },
  "9125": {
    "id": "9125",
    "name": "Сухмень",
    "path": "Россия / Курганская область / Сухмень",
    "country": "Россия",
    "searchString": "сухмень россия / курганская область / сухмень"
  },
  "9126": {
    "id": "9126",
    "name": "Большая Коча",
    "path": "Россия / Пермский край / Большая Коча",
    "country": "Россия",
    "searchString": "большая коча россия / пермский край / большая коча"
  },
  "9127": {
    "id": "9127",
    "name": "Острожка",
    "path": "Россия / Пермский край / Острожка",
    "country": "Россия",
    "searchString": "острожка россия / пермский край / острожка"
  },
  "9128": {
    "id": "9128",
    "name": "Артакуль",
    "path": "Россия / Республика Башкортостан / Артакуль",
    "country": "Россия",
    "searchString": "артакуль россия / республика башкортостан / артакуль"
  },
  "9129": {
    "id": "9129",
    "name": "Жуково (Курганская область)",
    "path": "Россия / Курганская область / Жуково (Курганская область)",
    "country": "Россия",
    "searchString": "жуково (курганская область) россия / курганская область / жуково (курганская область)"
  },
  "9130": {
    "id": "9130",
    "name": "Староакбулатово",
    "path": "Россия / Республика Башкортостан / Староакбулатово",
    "country": "Россия",
    "searchString": "староакбулатово россия / республика башкортостан / староакбулатово"
  },
  "9131": {
    "id": "9131",
    "name": "Ульт-Ягун",
    "path": "Россия / Ханты-Мансийский АО - Югра / Ульт-Ягун",
    "country": "Россия",
    "searchString": "ульт-ягун россия / ханты-мансийский ао - югра / ульт-ягун"
  },
  "9132": {
    "id": "9132",
    "name": "Конево (Свердловская область)",
    "path": "Россия / Свердловская область / Конево (Свердловская область)",
    "country": "Россия",
    "searchString": "конево (свердловская область) россия / свердловская область / конево (свердловская область)"
  },
  "9133": {
    "id": "9133",
    "name": "Полуночное",
    "path": "Россия / Свердловская область / Полуночное",
    "country": "Россия",
    "searchString": "полуночное россия / свердловская область / полуночное"
  },
  "9134": {
    "id": "9134",
    "name": "Береговой",
    "path": "Россия / Челябинская область / Береговой",
    "country": "Россия",
    "searchString": "береговой россия / челябинская область / береговой"
  },
  "9135": {
    "id": "9135",
    "name": "Кальтяево",
    "path": "Россия / Республика Башкортостан / Кальтяево",
    "country": "Россия",
    "searchString": "кальтяево россия / республика башкортостан / кальтяево"
  },
  "9136": {
    "id": "9136",
    "name": "Южный (Челябинская область)",
    "path": "Россия / Челябинская область / Южный (Челябинская область)",
    "country": "Россия",
    "searchString": "южный (челябинская область) россия / челябинская область / южный (челябинская область)"
  },
  "9137": {
    "id": "9137",
    "name": "Кага",
    "path": "Россия / Республика Башкортостан / Кага",
    "country": "Россия",
    "searchString": "кага россия / республика башкортостан / кага"
  },
  "9138": {
    "id": "9138",
    "name": "Вознесенское (Пермский край)",
    "path": "Россия / Пермский край / Вознесенское (Пермский край)",
    "country": "Россия",
    "searchString": "вознесенское (пермский край) россия / пермский край / вознесенское (пермский край)"
  },
  "9139": {
    "id": "9139",
    "name": "Верхнее",
    "path": "Россия / Курганская область / Верхнее",
    "country": "Россия",
    "searchString": "верхнее россия / курганская область / верхнее"
  },
  "9140": {
    "id": "9140",
    "name": "Сладковское",
    "path": "Россия / Свердловская область / Сладковское",
    "country": "Россия",
    "searchString": "сладковское россия / свердловская область / сладковское"
  },
  "9141": {
    "id": "9141",
    "name": "Спасский",
    "path": "Россия / Челябинская область / Спасский",
    "country": "Россия",
    "searchString": "спасский россия / челябинская область / спасский"
  },
  "9142": {
    "id": "9142",
    "name": "Сетовное",
    "path": "Россия / Курганская область / Сетовное",
    "country": "Россия",
    "searchString": "сетовное россия / курганская область / сетовное"
  },
  "9143": {
    "id": "9143",
    "name": "Северный Коммунар",
    "path": "Россия / Пермский край / Северный Коммунар",
    "country": "Россия",
    "searchString": "северный коммунар россия / пермский край / северный коммунар"
  },
  "9144": {
    "id": "9144",
    "name": "Дюмеево",
    "path": "Россия / Республика Башкортостан / Дюмеево",
    "country": "Россия",
    "searchString": "дюмеево россия / республика башкортостан / дюмеево"
  },
  "9145": {
    "id": "9145",
    "name": "Париж",
    "path": "Россия / Челябинская область / Париж",
    "country": "Россия",
    "searchString": "париж россия / челябинская область / париж"
  },
  "9146": {
    "id": "9146",
    "name": "Мараты",
    "path": "Россия / Пермский край / Мараты",
    "country": "Россия",
    "searchString": "мараты россия / пермский край / мараты"
  },
  "9147": {
    "id": "9147",
    "name": "Миндяк",
    "path": "Россия / Республика Башкортостан / Миндяк",
    "country": "Россия",
    "searchString": "миндяк россия / республика башкортостан / миндяк"
  },
  "9148": {
    "id": "9148",
    "name": "Карымкары",
    "path": "Россия / Ханты-Мансийский АО - Югра / Карымкары",
    "country": "Россия",
    "searchString": "карымкары россия / ханты-мансийский ао - югра / карымкары"
  },
  "9149": {
    "id": "9149",
    "name": "Комарово",
    "path": "Россия / Пермский край / Комарово",
    "country": "Россия",
    "searchString": "комарово россия / пермский край / комарово"
  },
  "9150": {
    "id": "9150",
    "name": "Кыласово",
    "path": "Россия / Пермский край / Кыласово",
    "country": "Россия",
    "searchString": "кыласово россия / пермский край / кыласово"
  },
  "9151": {
    "id": "9151",
    "name": "Максютово",
    "path": "Россия / Республика Башкортостан / Максютово",
    "country": "Россия",
    "searchString": "максютово россия / республика башкортостан / максютово"
  },
  "9152": {
    "id": "9152",
    "name": "Полдневая",
    "path": "Россия / Свердловская область / Полдневая",
    "country": "Россия",
    "searchString": "полдневая россия / свердловская область / полдневая"
  },
  "9153": {
    "id": "9153",
    "name": "Центральная усадьба 3-го Госконезавода",
    "path": "Россия / Пермский край / Центральная усадьба 3-го Госконезавода",
    "country": "Россия",
    "searchString": "центральная усадьба 3-го госконезавода россия / пермский край / центральная усадьба 3-го госконезавода"
  },
  "9154": {
    "id": "9154",
    "name": "Краснознаменское",
    "path": "Россия / Курганская область / Краснознаменское",
    "country": "Россия",
    "searchString": "краснознаменское россия / курганская область / краснознаменское"
  },
  "9155": {
    "id": "9155",
    "name": "Посад (Пермский край, Кишертский муниципальный округ)",
    "path": "Россия / Пермский край / Посад (Пермский край, Кишертский муниципальный округ)",
    "country": "Россия",
    "searchString": "посад (пермский край, кишертский муниципальный округ) россия / пермский край / посад (пермский край, кишертский муниципальный округ)"
  },
  "9156": {
    "id": "9156",
    "name": "Усть-Юган",
    "path": "Россия / Ханты-Мансийский АО - Югра / Усть-Юган",
    "country": "Россия",
    "searchString": "усть-юган россия / ханты-мансийский ао - югра / усть-юган"
  },
  "9157": {
    "id": "9157",
    "name": "Верхнее Калино",
    "path": "Россия / Пермский край / Верхнее Калино",
    "country": "Россия",
    "searchString": "верхнее калино россия / пермский край / верхнее калино"
  },
  "9158": {
    "id": "9158",
    "name": "Новый Мир",
    "path": "Россия / Курганская область / Новый Мир",
    "country": "Россия",
    "searchString": "новый мир россия / курганская область / новый мир"
  },
  "9159": {
    "id": "9159",
    "name": "Журавлево",
    "path": "Россия / Курганская область / Журавлево",
    "country": "Россия",
    "searchString": "журавлево россия / курганская область / журавлево"
  },
  "9160": {
    "id": "9160",
    "name": "Месели",
    "path": "Россия / Республика Башкортостан / Месели",
    "country": "Россия",
    "searchString": "месели россия / республика башкортостан / месели"
  },
  "9161": {
    "id": "9161",
    "name": "Огневское",
    "path": "Россия / Челябинская область / Огневское",
    "country": "Россия",
    "searchString": "огневское россия / челябинская область / огневское"
  },
  "9162": {
    "id": "9162",
    "name": "Вая",
    "path": "Россия / Пермский край / Вая",
    "country": "Россия",
    "searchString": "вая россия / пермский край / вая"
  },
  "9163": {
    "id": "9163",
    "name": "Янгантау",
    "path": "Россия / Республика Башкортостан / Янгантау",
    "country": "Россия",
    "searchString": "янгантау россия / республика башкортостан / янгантау"
  },
  "9164": {
    "id": "9164",
    "name": "Песчанское",
    "path": "Россия / Курганская область / Песчанское",
    "country": "Россия",
    "searchString": "песчанское россия / курганская область / песчанское"
  },
  "9165": {
    "id": "9165",
    "name": "Юг",
    "path": "Россия / Пермский край / Юг",
    "country": "Россия",
    "searchString": "юг россия / пермский край / юг"
  },
  "9166": {
    "id": "9166",
    "name": "Бала-Четырман",
    "path": "Россия / Республика Башкортостан / Бала-Четырман",
    "country": "Россия",
    "searchString": "бала-четырман россия / республика башкортостан / бала-четырман"
  },
  "9167": {
    "id": "9167",
    "name": "Поташка",
    "path": "Россия / Свердловская область / Поташка",
    "country": "Россия",
    "searchString": "поташка россия / свердловская область / поташка"
  },
  "9168": {
    "id": "9168",
    "name": "Долговское",
    "path": "Россия / Курганская область / Долговское",
    "country": "Россия",
    "searchString": "долговское россия / курганская область / долговское"
  },
  "9169": {
    "id": "9169",
    "name": "Лямина",
    "path": "Россия / Ханты-Мансийский АО - Югра / Лямина",
    "country": "Россия",
    "searchString": "лямина россия / ханты-мансийский ао - югра / лямина"
  },
  "9170": {
    "id": "9170",
    "name": "Аитово",
    "path": "Россия / Республика Башкортостан / Аитово",
    "country": "Россия",
    "searchString": "аитово россия / республика башкортостан / аитово"
  },
  "9171": {
    "id": "9171",
    "name": "Юм",
    "path": "Россия / Пермский край / Юм",
    "country": "Россия",
    "searchString": "юм россия / пермский край / юм"
  },
  "9172": {
    "id": "9172",
    "name": "Курорта",
    "path": "Россия / Республика Башкортостан / Курорта",
    "country": "Россия",
    "searchString": "курорта россия / республика башкортостан / курорта"
  },
  "9173": {
    "id": "9173",
    "name": "Ферма",
    "path": "Россия / Пермский край / Ферма",
    "country": "Россия",
    "searchString": "ферма россия / пермский край / ферма"
  },
  "9174": {
    "id": "9174",
    "name": "Зуята",
    "path": "Россия / Пермский край / Зуята",
    "country": "Россия",
    "searchString": "зуята россия / пермский край / зуята"
  },
  "9175": {
    "id": "9175",
    "name": "Мирный (Челябинская область)",
    "path": "Россия / Челябинская область / Мирный (Челябинская область)",
    "country": "Россия",
    "searchString": "мирный (челябинская область) россия / челябинская область / мирный (челябинская область)"
  },
  "9176": {
    "id": "9176",
    "name": "Новоасбест",
    "path": "Россия / Свердловская область / Новоасбест",
    "country": "Россия",
    "searchString": "новоасбест россия / свердловская область / новоасбест"
  },
  "9177": {
    "id": "9177",
    "name": "Стряпунята",
    "path": "Россия / Пермский край / Стряпунята",
    "country": "Россия",
    "searchString": "стряпунята россия / пермский край / стряпунята"
  },
  "9178": {
    "id": "9178",
    "name": "Архангельское (Пермский край)",
    "path": "Россия / Пермский край / Архангельское (Пермский край)",
    "country": "Россия",
    "searchString": "архангельское (пермский край) россия / пермский край / архангельское (пермский край)"
  },
  "9179": {
    "id": "9179",
    "name": "Писклово",
    "path": "Россия / Челябинская область / Писклово",
    "country": "Россия",
    "searchString": "писклово россия / челябинская область / писклово"
  },
  "9180": {
    "id": "9180",
    "name": "Старые Туймазы",
    "path": "Россия / Республика Башкортостан / Старые Туймазы",
    "country": "Россия",
    "searchString": "старые туймазы россия / республика башкортостан / старые туймазы"
  },
  "9181": {
    "id": "9181",
    "name": "Юсупово",
    "path": "Россия / Республика Башкортостан / Юсупово",
    "country": "Россия",
    "searchString": "юсупово россия / республика башкортостан / юсупово"
  },
  "9182": {
    "id": "9182",
    "name": "Антипаюта",
    "path": "Россия / Ямало-Ненецкий АО / Антипаюта",
    "country": "Россия",
    "searchString": "антипаюта россия / ямало-ненецкий ао / антипаюта"
  },
  "9183": {
    "id": "9183",
    "name": "Тюндюк",
    "path": "Россия / Пермский край / Тюндюк",
    "country": "Россия",
    "searchString": "тюндюк россия / пермский край / тюндюк"
  },
  "9184": {
    "id": "9184",
    "name": "Басмановское",
    "path": "Россия / Свердловская область / Басмановское",
    "country": "Россия",
    "searchString": "басмановское россия / свердловская область / басмановское"
  },
  "9185": {
    "id": "9185",
    "name": "Прикамский",
    "path": "Россия / Пермский край / Прикамский",
    "country": "Россия",
    "searchString": "прикамский россия / пермский край / прикамский"
  },
  "9186": {
    "id": "9186",
    "name": "Ваныш-Алпаутово",
    "path": "Россия / Республика Башкортостан / Ваныш-Алпаутово",
    "country": "Россия",
    "searchString": "ваныш-алпаутово россия / республика башкортостан / ваныш-алпаутово"
  },
  "9187": {
    "id": "9187",
    "name": "Овгорт",
    "path": "Россия / Ямало-Ненецкий АО / Овгорт",
    "country": "Россия",
    "searchString": "овгорт россия / ямало-ненецкий ао / овгорт"
  },
  "9188": {
    "id": "9188",
    "name": "Осиновское",
    "path": "Россия / Курганская область / Осиновское",
    "country": "Россия",
    "searchString": "осиновское россия / курганская область / осиновское"
  },
  "9189": {
    "id": "9189",
    "name": "Старый Курдым",
    "path": "Россия / Республика Башкортостан / Старый Курдым",
    "country": "Россия",
    "searchString": "старый курдым россия / республика башкортостан / старый курдым"
  },
  "9190": {
    "id": "9190",
    "name": "Ургуш",
    "path": "Россия / Республика Башкортостан / Ургуш",
    "country": "Россия",
    "searchString": "ургуш россия / республика башкортостан / ургуш"
  },
  "9191": {
    "id": "9191",
    "name": "Падун",
    "path": "Россия / Тюменская область / Падун",
    "country": "Россия",
    "searchString": "падун россия / тюменская область / падун"
  },
  "9192": {
    "id": "9192",
    "name": "Старобаширово",
    "path": "Россия / Республика Башкортостан / Старобаширово",
    "country": "Россия",
    "searchString": "старобаширово россия / республика башкортостан / старобаширово"
  },
  "9193": {
    "id": "9193",
    "name": "Карамалы-Губеево",
    "path": "Россия / Республика Башкортостан / Карамалы-Губеево",
    "country": "Россия",
    "searchString": "карамалы-губеево россия / республика башкортостан / карамалы-губеево"
  },
  "9194": {
    "id": "9194",
    "name": "Большая Ока",
    "path": "Россия / Республика Башкортостан / Большая Ока",
    "country": "Россия",
    "searchString": "большая ока россия / республика башкортостан / большая ока"
  },
  "9195": {
    "id": "9195",
    "name": "Аксаитово",
    "path": "Россия / Республика Башкортостан / Аксаитово",
    "country": "Россия",
    "searchString": "аксаитово россия / республика башкортостан / аксаитово"
  },
  "9196": {
    "id": "9196",
    "name": "Сажино",
    "path": "Россия / Свердловская область / Сажино",
    "country": "Россия",
    "searchString": "сажино россия / свердловская область / сажино"
  },
  "9197": {
    "id": "9197",
    "name": "Лазурный",
    "path": "Россия / Челябинская область / Лазурный",
    "country": "Россия",
    "searchString": "лазурный россия / челябинская область / лазурный"
  },
  "9198": {
    "id": "9198",
    "name": "Горы (Пермский край, Осинский район)",
    "path": "Россия / Пермский край / Горы (Пермский край, Осинский район)",
    "country": "Россия",
    "searchString": "горы (пермский край, осинский район) россия / пермский край / горы (пермский край, осинский район)"
  },
  "9199": {
    "id": "9199",
    "name": "Ницинское",
    "path": "Россия / Свердловская область / Ницинское",
    "country": "Россия",
    "searchString": "ницинское россия / свердловская область / ницинское"
  },
  "9200": {
    "id": "9200",
    "name": "Серга",
    "path": "Россия / Пермский край / Серга",
    "country": "Россия",
    "searchString": "серга россия / пермский край / серга"
  },
  "9201": {
    "id": "9201",
    "name": "Усьва",
    "path": "Россия / Пермский край / Усьва",
    "country": "Россия",
    "searchString": "усьва россия / пермский край / усьва"
  },
  "9202": {
    "id": "9202",
    "name": "Спартак",
    "path": "Россия / Республика Башкортостан / Спартак",
    "country": "Россия",
    "searchString": "спартак россия / республика башкортостан / спартак"
  },
  "9203": {
    "id": "9203",
    "name": "Платошино",
    "path": "Россия / Пермский край / Платошино",
    "country": "Россия",
    "searchString": "платошино россия / пермский край / платошино"
  },
  "9204": {
    "id": "9204",
    "name": "Шабурово",
    "path": "Россия / Челябинская область / Шабурово",
    "country": "Россия",
    "searchString": "шабурово россия / челябинская область / шабурово"
  },
  "9205": {
    "id": "9205",
    "name": "Печеркино",
    "path": "Россия / Свердловская область / Печеркино",
    "country": "Россия",
    "searchString": "печеркино россия / свердловская область / печеркино"
  },
  "9206": {
    "id": "9206",
    "name": "Идельбаково",
    "path": "Россия / Республика Башкортостан / Идельбаково",
    "country": "Россия",
    "searchString": "идельбаково россия / республика башкортостан / идельбаково"
  },
  "9207": {
    "id": "9207",
    "name": "Саитбаба",
    "path": "Россия / Республика Башкортостан / Саитбаба",
    "country": "Россия",
    "searchString": "саитбаба россия / республика башкортостан / саитбаба"
  },
  "9208": {
    "id": "9208",
    "name": "Путино",
    "path": "Россия / Пермский край / Путино",
    "country": "Россия",
    "searchString": "путино россия / пермский край / путино"
  },
  "9209": {
    "id": "9209",
    "name": "Краснинский",
    "path": "Россия / Челябинская область / Краснинский",
    "country": "Россия",
    "searchString": "краснинский россия / челябинская область / краснинский"
  },
  "9210": {
    "id": "9210",
    "name": "Юмашево",
    "path": "Россия / Республика Башкортостан / Юмашево",
    "country": "Россия",
    "searchString": "юмашево россия / республика башкортостан / юмашево"
  },
  "9211": {
    "id": "9211",
    "name": "Перемское",
    "path": "Россия / Пермский край / Перемское",
    "country": "Россия",
    "searchString": "перемское россия / пермский край / перемское"
  },
  "9212": {
    "id": "9212",
    "name": "Ома (Ямало-Ненецкий АО)",
    "path": "Россия / Ямало-Ненецкий АО / Ома (Ямало-Ненецкий АО)",
    "country": "Россия",
    "searchString": "ома (ямало-ненецкий ао) россия / ямало-ненецкий ао / ома (ямало-ненецкий ао)"
  },
  "9213": {
    "id": "9213",
    "name": "Большое-Курейное",
    "path": "Россия / Курганская область / Большое-Курейное",
    "country": "Россия",
    "searchString": "большое-курейное россия / курганская область / большое-курейное"
  },
  "9214": {
    "id": "9214",
    "name": "Речкалова",
    "path": "Россия / Свердловская область / Речкалова",
    "country": "Россия",
    "searchString": "речкалова россия / свердловская область / речкалова"
  },
  "9215": {
    "id": "9215",
    "name": "Новобурино",
    "path": "Россия / Челябинская область / Новобурино",
    "country": "Россия",
    "searchString": "новобурино россия / челябинская область / новобурино"
  },
  "9216": {
    "id": "9216",
    "name": "Вилкино",
    "path": "Россия / Курганская область / Вилкино",
    "country": "Россия",
    "searchString": "вилкино россия / курганская область / вилкино"
  },
  "9217": {
    "id": "9217",
    "name": "Костино",
    "path": "Россия / Свердловская область / Костино",
    "country": "Россия",
    "searchString": "костино россия / свердловская область / костино"
  },
  "9218": {
    "id": "9218",
    "name": "Килачевское",
    "path": "Россия / Свердловская область / Килачевское",
    "country": "Россия",
    "searchString": "килачевское россия / свердловская область / килачевское"
  },
  "9219": {
    "id": "9219",
    "name": "Филькино",
    "path": "Россия / Свердловская область / Филькино",
    "country": "Россия",
    "searchString": "филькино россия / свердловская область / филькино"
  },
  "9220": {
    "id": "9220",
    "name": "Красная Нива",
    "path": "Россия / Курганская область / Красная Нива",
    "country": "Россия",
    "searchString": "красная нива россия / курганская область / красная нива"
  },
  "9221": {
    "id": "9221",
    "name": "Матраево",
    "path": "Россия / Республика Башкортостан / Матраево",
    "country": "Россия",
    "searchString": "матраево россия / республика башкортостан / матраево"
  },
  "9222": {
    "id": "9222",
    "name": "Усть-Ницинское",
    "path": "Россия / Свердловская область / Усть-Ницинское",
    "country": "Россия",
    "searchString": "усть-ницинское россия / свердловская область / усть-ницинское"
  },
  "9223": {
    "id": "9223",
    "name": "Прорывное",
    "path": "Россия / Курганская область / Прорывное",
    "country": "Россия",
    "searchString": "прорывное россия / курганская область / прорывное"
  },
  "9224": {
    "id": "9224",
    "name": "Нигаматово",
    "path": "Россия / Республика Башкортостан / Нигаматово",
    "country": "Россия",
    "searchString": "нигаматово россия / республика башкортостан / нигаматово"
  },
  "9225": {
    "id": "9225",
    "name": "Чаши",
    "path": "Россия / Курганская область / Чаши",
    "country": "Россия",
    "searchString": "чаши россия / курганская область / чаши"
  },
  "9226": {
    "id": "9226",
    "name": "Троельга",
    "path": "Россия / Пермский край / Троельга",
    "country": "Россия",
    "searchString": "троельга россия / пермский край / троельга"
  },
  "9227": {
    "id": "9227",
    "name": "Юнусово",
    "path": "Россия / Республика Башкортостан / Юнусово",
    "country": "Россия",
    "searchString": "юнусово россия / республика башкортостан / юнусово"
  },
  "9228": {
    "id": "9228",
    "name": "Курашим",
    "path": "Россия / Пермский край / Курашим",
    "country": "Россия",
    "searchString": "курашим россия / пермский край / курашим"
  },
  "9229": {
    "id": "9229",
    "name": "Новокутово",
    "path": "Россия / Республика Башкортостан / Новокутово",
    "country": "Россия",
    "searchString": "новокутово россия / республика башкортостан / новокутово"
  },
  "9230": {
    "id": "9230",
    "name": "Михалево",
    "path": "Россия / Курганская область / Михалево",
    "country": "Россия",
    "searchString": "михалево россия / курганская область / михалево"
  },
  "9231": {
    "id": "9231",
    "name": "Ташбулатово",
    "path": "Россия / Республика Башкортостан / Ташбулатово",
    "country": "Россия",
    "searchString": "ташбулатово россия / республика башкортостан / ташбулатово"
  },
  "9232": {
    "id": "9232",
    "name": "Малый Ашап",
    "path": "Россия / Пермский край / Малый Ашап",
    "country": "Россия",
    "searchString": "малый ашап россия / пермский край / малый ашап"
  },
  "9233": {
    "id": "9233",
    "name": "Брюхово",
    "path": "Россия / Пермский край / Брюхово",
    "country": "Россия",
    "searchString": "брюхово россия / пермский край / брюхово"
  },
  "9234": {
    "id": "9234",
    "name": "Мариинский",
    "path": "Россия / Республика Башкортостан / Мариинский",
    "country": "Россия",
    "searchString": "мариинский россия / республика башкортостан / мариинский"
  },
  "9235": {
    "id": "9235",
    "name": "Старый Шагирт",
    "path": "Россия / Пермский край / Старый Шагирт",
    "country": "Россия",
    "searchString": "старый шагирт россия / пермский край / старый шагирт"
  },
  "9236": {
    "id": "9236",
    "name": "Исимово",
    "path": "Россия / Республика Башкортостан / Исимово",
    "country": "Россия",
    "searchString": "исимово россия / республика башкортостан / исимово"
  },
  "9237": {
    "id": "9237",
    "name": "Шулганово",
    "path": "Россия / Республика Башкортостан / Шулганово",
    "country": "Россия",
    "searchString": "шулганово россия / республика башкортостан / шулганово"
  },
  "9238": {
    "id": "9238",
    "name": "Черновское (Пермский край)",
    "path": "Россия / Пермский край / Черновское (Пермский край)",
    "country": "Россия",
    "searchString": "черновское (пермский край) россия / пермский край / черновское (пермский край)"
  },
  "9239": {
    "id": "9239",
    "name": "Позариха",
    "path": "Россия / Свердловская область / Позариха",
    "country": "Россия",
    "searchString": "позариха россия / свердловская область / позариха"
  },
  "9240": {
    "id": "9240",
    "name": "Карьер Известняк",
    "path": "Россия / Пермский край / Карьер Известняк",
    "country": "Россия",
    "searchString": "карьер известняк россия / пермский край / карьер известняк"
  },
  "9241": {
    "id": "9241",
    "name": "Новопышминское",
    "path": "Россия / Свердловская область / Новопышминское",
    "country": "Россия",
    "searchString": "новопышминское россия / свердловская область / новопышминское"
  },
  "9242": {
    "id": "9242",
    "name": "Травники",
    "path": "Россия / Челябинская область / Травники",
    "country": "Россия",
    "searchString": "травники россия / челябинская область / травники"
  },
  "9243": {
    "id": "9243",
    "name": "Русскинская",
    "path": "Россия / Ханты-Мансийский АО - Югра / Русскинская",
    "country": "Россия",
    "searchString": "русскинская россия / ханты-мансийский ао - югра / русскинская"
  },
  "9244": {
    "id": "9244",
    "name": "Старый Просвет",
    "path": "Россия / Курганская область / Старый Просвет",
    "country": "Россия",
    "searchString": "старый просвет россия / курганская область / старый просвет"
  },
  "9245": {
    "id": "9245",
    "name": "Большие Кусты",
    "path": "Россия / Пермский край / Большие Кусты",
    "country": "Россия",
    "searchString": "большие кусты россия / пермский край / большие кусты"
  },
  "9246": {
    "id": "9246",
    "name": "Кош-Елга",
    "path": "Россия / Республика Башкортостан / Кош-Елга",
    "country": "Россия",
    "searchString": "кош-елга россия / республика башкортостан / кош-елга"
  },
  "9247": {
    "id": "9247",
    "name": "Половинка",
    "path": "Россия / Ханты-Мансийский АО - Югра / Половинка",
    "country": "Россия",
    "searchString": "половинка россия / ханты-мансийский ао - югра / половинка"
  },
  "9248": {
    "id": "9248",
    "name": "Квашнинское",
    "path": "Россия / Свердловская область / Квашнинское",
    "country": "Россия",
    "searchString": "квашнинское россия / свердловская область / квашнинское"
  },
  "9249": {
    "id": "9249",
    "name": "Велва-База",
    "path": "Россия / Пермский край / Велва-База",
    "country": "Россия",
    "searchString": "велва-база россия / пермский край / велва-база"
  },
  "9250": {
    "id": "9250",
    "name": "Бузовьязы",
    "path": "Россия / Республика Башкортостан / Бузовьязы",
    "country": "Россия",
    "searchString": "бузовьязы россия / республика башкортостан / бузовьязы"
  },
  "9251": {
    "id": "9251",
    "name": "Зильдярово",
    "path": "Россия / Республика Башкортостан / Зильдярово",
    "country": "Россия",
    "searchString": "зильдярово россия / республика башкортостан / зильдярово"
  },
  "9252": {
    "id": "9252",
    "name": "Насадка",
    "path": "Россия / Пермский край / Насадка",
    "country": "Россия",
    "searchString": "насадка россия / пермский край / насадка"
  },
  "9253": {
    "id": "9253",
    "name": "Приполярный",
    "path": "Россия / Ханты-Мансийский АО - Югра / Приполярный",
    "country": "Россия",
    "searchString": "приполярный россия / ханты-мансийский ао - югра / приполярный"
  },
  "9254": {
    "id": "9254",
    "name": "Медведское",
    "path": "Россия / Курганская область / Медведское",
    "country": "Россия",
    "searchString": "медведское россия / курганская область / медведское"
  },
  "9255": {
    "id": "9255",
    "name": "Станционный-Полевской",
    "path": "Россия / Свердловская область / Станционный-Полевской",
    "country": "Россия",
    "searchString": "станционный-полевской россия / свердловская область / станционный-полевской"
  },
  "9256": {
    "id": "9256",
    "name": "Кирово",
    "path": "Россия / Курганская область / Кирово",
    "country": "Россия",
    "searchString": "кирово россия / курганская область / кирово"
  },
  "9257": {
    "id": "9257",
    "name": "Байрамгулово",
    "path": "Россия / Челябинская область / Байрамгулово",
    "country": "Россия",
    "searchString": "байрамгулово россия / челябинская область / байрамгулово"
  },
  "9258": {
    "id": "9258",
    "name": "Метели",
    "path": "Россия / Республика Башкортостан / Метели",
    "country": "Россия",
    "searchString": "метели россия / республика башкортостан / метели"
  },
  "9259": {
    "id": "9259",
    "name": "Старокуктово",
    "path": "Россия / Республика Башкортостан / Старокуктово",
    "country": "Россия",
    "searchString": "старокуктово россия / республика башкортостан / старокуктово"
  },
  "9260": {
    "id": "9260",
    "name": "Ныроб",
    "path": "Россия / Пермский край / Ныроб",
    "country": "Россия",
    "searchString": "ныроб россия / пермский край / ныроб"
  },
  "9261": {
    "id": "9261",
    "name": "Янгельское",
    "path": "Россия / Республика Башкортостан / Янгельское",
    "country": "Россия",
    "searchString": "янгельское россия / республика башкортостан / янгельское"
  },
  "9262": {
    "id": "9262",
    "name": "Большая Уса",
    "path": "Россия / Пермский край / Большая Уса",
    "country": "Россия",
    "searchString": "большая уса россия / пермский край / большая уса"
  },
  "9263": {
    "id": "9263",
    "name": "Таймеево",
    "path": "Россия / Республика Башкортостан / Таймеево",
    "country": "Россия",
    "searchString": "таймеево россия / республика башкортостан / таймеево"
  },
  "9264": {
    "id": "9264",
    "name": "Краснояр-1",
    "path": "Россия / Пермский край / Краснояр-1",
    "country": "Россия",
    "searchString": "краснояр-1 россия / пермский край / краснояр-1"
  },
  "9265": {
    "id": "9265",
    "name": "Кировское (Свердловская область)",
    "path": "Россия / Свердловская область / Кировское (Свердловская область)",
    "country": "Россия",
    "searchString": "кировское (свердловская область) россия / свердловская область / кировское (свердловская область)"
  },
  "9266": {
    "id": "9266",
    "name": "Белоярское",
    "path": "Россия / Курганская область / Белоярское",
    "country": "Россия",
    "searchString": "белоярское россия / курганская область / белоярское"
  },
  "9267": {
    "id": "9267",
    "name": "Андреево",
    "path": "Россия / Пермский край / Андреево",
    "country": "Россия",
    "searchString": "андреево россия / пермский край / андреево"
  },
  "9268": {
    "id": "9268",
    "name": "Екатерининское (Пермский край)",
    "path": "Россия / Пермский край / Екатерининское (Пермский край)",
    "country": "Россия",
    "searchString": "екатерининское (пермский край) россия / пермский край / екатерининское (пермский край)"
  },
  "9269": {
    "id": "9269",
    "name": "Кривское",
    "path": "Россия / Курганская область / Кривское",
    "country": "Россия",
    "searchString": "кривское россия / курганская область / кривское"
  },
  "9270": {
    "id": "9270",
    "name": "Емаши",
    "path": "Россия / Республика Башкортостан / Емаши",
    "country": "Россия",
    "searchString": "емаши россия / республика башкортостан / емаши"
  },
  "9271": {
    "id": "9271",
    "name": "Южный Коспашский",
    "path": "Россия / Пермский край / Южный Коспашский",
    "country": "Россия",
    "searchString": "южный коспашский россия / пермский край / южный коспашский"
  },
  "9272": {
    "id": "9272",
    "name": "Суккулово",
    "path": "Россия / Республика Башкортостан / Суккулово",
    "country": "Россия",
    "searchString": "суккулово россия / республика башкортостан / суккулово"
  },
  "9273": {
    "id": "9273",
    "name": "Кулевчи",
    "path": "Россия / Челябинская область / Кулевчи",
    "country": "Россия",
    "searchString": "кулевчи россия / челябинская область / кулевчи"
  },
  "9274": {
    "id": "9274",
    "name": "Покровск-Уральский",
    "path": "Россия / Свердловская область / Покровск-Уральский",
    "country": "Россия",
    "searchString": "покровск-уральский россия / свердловская область / покровск-уральский"
  },
  "9275": {
    "id": "9275",
    "name": "Рудянское",
    "path": "Россия / Свердловская область / Рудянское",
    "country": "Россия",
    "searchString": "рудянское россия / свердловская область / рудянское"
  },
  "9276": {
    "id": "9276",
    "name": "Шумихинский",
    "path": "Россия / Пермский край / Шумихинский",
    "country": "Россия",
    "searchString": "шумихинский россия / пермский край / шумихинский"
  },
  "9277": {
    "id": "9277",
    "name": "Сергеевский",
    "path": "Россия / Пермский край / Сергеевский",
    "country": "Россия",
    "searchString": "сергеевский россия / пермский край / сергеевский"
  },
  "9278": {
    "id": "9278",
    "name": "Филатово",
    "path": "Россия / Пермский край / Филатово",
    "country": "Россия",
    "searchString": "филатово россия / пермский край / филатово"
  },
  "9279": {
    "id": "9279",
    "name": "Нижнеполевское",
    "path": "Россия / Курганская область / Нижнеполевское",
    "country": "Россия",
    "searchString": "нижнеполевское россия / курганская область / нижнеполевское"
  },
  "9280": {
    "id": "9280",
    "name": "Минино",
    "path": "Россия / Тюменская область / Минино",
    "country": "Россия",
    "searchString": "минино россия / тюменская область / минино"
  },
  "9281": {
    "id": "9281",
    "name": "Паль",
    "path": "Россия / Пермский край / Паль",
    "country": "Россия",
    "searchString": "паль россия / пермский край / паль"
  },
  "9282": {
    "id": "9282",
    "name": "Пурпе-1",
    "path": "Россия / Ямало-Ненецкий АО / Пурпе-1",
    "country": "Россия",
    "searchString": "пурпе-1 россия / ямало-ненецкий ао / пурпе-1"
  },
  "9283": {
    "id": "9283",
    "name": "Красный Ключ (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Красный Ключ (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "красный ключ (республика башкортостан) россия / республика башкортостан / красный ключ (республика башкортостан)"
  },
  "9284": {
    "id": "9284",
    "name": "Курорт Озеро",
    "path": "Россия / Курганская область / Курорт Озеро",
    "country": "Россия",
    "searchString": "курорт озеро россия / курганская область / курорт озеро"
  },
  "9285": {
    "id": "9285",
    "name": "Верх-Иньва",
    "path": "Россия / Пермский край / Верх-Иньва",
    "country": "Россия",
    "searchString": "верх-иньва россия / пермский край / верх-иньва"
  },
  "9286": {
    "id": "9286",
    "name": "Сретенское",
    "path": "Россия / Пермский край / Сретенское",
    "country": "Россия",
    "searchString": "сретенское россия / пермский край / сретенское"
  },
  "9287": {
    "id": "9287",
    "name": "Село Иткулово 1-е",
    "path": "Россия / Республика Башкортостан / Село Иткулово 1-е",
    "country": "Россия",
    "searchString": "село иткулово 1-е россия / республика башкортостан / село иткулово 1-е"
  },
  "9288": {
    "id": "9288",
    "name": "Исмагилово",
    "path": "Россия / Республика Башкортостан / Исмагилово",
    "country": "Россия",
    "searchString": "исмагилово россия / республика башкортостан / исмагилово"
  },
  "9289": {
    "id": "9289",
    "name": "Высокий Мыс",
    "path": "Россия / Ханты-Мансийский АО - Югра / Высокий Мыс",
    "country": "Россия",
    "searchString": "высокий мыс россия / ханты-мансийский ао - югра / высокий мыс"
  },
  "9290": {
    "id": "9290",
    "name": "Кислянское",
    "path": "Россия / Курганская область / Кислянское",
    "country": "Россия",
    "searchString": "кислянское россия / курганская область / кислянское"
  },
  "9291": {
    "id": "9291",
    "name": "Батурино (Курганская область)",
    "path": "Россия / Курганская область / Батурино (Курганская область)",
    "country": "Россия",
    "searchString": "батурино (курганская область) россия / курганская область / батурино (курганская область)"
  },
  "9292": {
    "id": "9292",
    "name": "Большой Куяш",
    "path": "Россия / Челябинская область / Большой Куяш",
    "country": "Россия",
    "searchString": "большой куяш россия / челябинская область / большой куяш"
  },
  "9293": {
    "id": "9293",
    "name": "Елпачиха",
    "path": "Россия / Пермский край / Елпачиха",
    "country": "Россия",
    "searchString": "елпачиха россия / пермский край / елпачиха"
  },
  "9294": {
    "id": "9294",
    "name": "Октябрьский (Тюменская область)",
    "path": "Россия / Тюменская область / Октябрьский (Тюменская область)",
    "country": "Россия",
    "searchString": "октябрьский (тюменская область) россия / тюменская область / октябрьский (тюменская область)"
  },
  "9295": {
    "id": "9295",
    "name": "Косой Брод",
    "path": "Россия / Свердловская область / Косой Брод",
    "country": "Россия",
    "searchString": "косой брод россия / свердловская область / косой брод"
  },
  "9296": {
    "id": "9296",
    "name": "Метлино",
    "path": "Россия / Челябинская область / Метлино",
    "country": "Россия",
    "searchString": "метлино россия / челябинская область / метлино"
  },
  "9297": {
    "id": "9297",
    "name": "Первомайский (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Первомайский (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "первомайский (республика башкортостан) россия / республика башкортостан / первомайский (республика башкортостан)"
  },
  "9298": {
    "id": "9298",
    "name": "Лопатково",
    "path": "Россия / Свердловская область / Лопатково",
    "country": "Россия",
    "searchString": "лопатково россия / свердловская область / лопатково"
  },
  "9299": {
    "id": "9299",
    "name": "Новогеоргиевка 2-я",
    "path": "Россия / Курганская область / Новогеоргиевка 2-я",
    "country": "Россия",
    "searchString": "новогеоргиевка 2-я россия / курганская область / новогеоргиевка 2-я"
  },
  "9300": {
    "id": "9300",
    "name": "Тавричанка (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Тавричанка (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "тавричанка (республика башкортостан) россия / республика башкортостан / тавричанка (республика башкортостан)"
  },
  "9301": {
    "id": "9301",
    "name": "Гранитный",
    "path": "Россия / Челябинская область / Гранитный",
    "country": "Россия",
    "searchString": "гранитный россия / челябинская область / гранитный"
  },
  "9302": {
    "id": "9302",
    "name": "Мальцево",
    "path": "Россия / Курганская область / Мальцево",
    "country": "Россия",
    "searchString": "мальцево россия / курганская область / мальцево"
  },
  "9303": {
    "id": "9303",
    "name": "Лыхма",
    "path": "Россия / Ханты-Мансийский АО - Югра / Лыхма",
    "country": "Россия",
    "searchString": "лыхма россия / ханты-мансийский ао - югра / лыхма"
  },
  "9304": {
    "id": "9304",
    "name": "Гыда",
    "path": "Россия / Ямало-Ненецкий АО / Гыда",
    "country": "Россия",
    "searchString": "гыда россия / ямало-ненецкий ао / гыда"
  },
  "9305": {
    "id": "9305",
    "name": "Каркатеевы",
    "path": "Россия / Ханты-Мансийский АО - Югра / Каркатеевы",
    "country": "Россия",
    "searchString": "каркатеевы россия / ханты-мансийский ао - югра / каркатеевы"
  },
  "9306": {
    "id": "9306",
    "name": "Калинники",
    "path": "Россия / Республика Башкортостан / Калинники",
    "country": "Россия",
    "searchString": "калинники россия / республика башкортостан / калинники"
  },
  "9307": {
    "id": "9307",
    "name": "Ошья",
    "path": "Россия / Пермский край / Ошья",
    "country": "Россия",
    "searchString": "ошья россия / пермский край / ошья"
  },
  "9308": {
    "id": "9308",
    "name": "Новобалтачево",
    "path": "Россия / Республика Башкортостан / Новобалтачево",
    "country": "Россия",
    "searchString": "новобалтачево россия / республика башкортостан / новобалтачево"
  },
  "9309": {
    "id": "9309",
    "name": "Ключевское",
    "path": "Россия / Курганская область / Ключевское",
    "country": "Россия",
    "searchString": "ключевское россия / курганская область / ключевское"
  },
  "9310": {
    "id": "9310",
    "name": "Буренка",
    "path": "Россия / Пермский край / Буренка",
    "country": "Россия",
    "searchString": "буренка россия / пермский край / буренка"
  },
  "9311": {
    "id": "9311",
    "name": "Кузнецкое",
    "path": "Россия / Челябинская область / Кузнецкое",
    "country": "Россия",
    "searchString": "кузнецкое россия / челябинская область / кузнецкое"
  },
  "9312": {
    "id": "9312",
    "name": "Верхнесуерское",
    "path": "Россия / Курганская область / Верхнесуерское",
    "country": "Россия",
    "searchString": "верхнесуерское россия / курганская область / верхнесуерское"
  },
  "9313": {
    "id": "9313",
    "name": "Горки (Ямало-Ненецкий АО)",
    "path": "Россия / Ямало-Ненецкий АО / Горки (Ямало-Ненецкий АО)",
    "country": "Россия",
    "searchString": "горки (ямало-ненецкий ао) россия / ямало-ненецкий ао / горки (ямало-ненецкий ао)"
  },
  "9314": {
    "id": "9314",
    "name": "Антипина",
    "path": "Россия / Пермский край / Антипина",
    "country": "Россия",
    "searchString": "антипина россия / пермский край / антипина"
  },
  "9315": {
    "id": "9315",
    "name": "Ярославка (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Ярославка (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "ярославка (республика башкортостан) россия / республика башкортостан / ярославка (республика башкортостан)"
  },
  "9316": {
    "id": "9316",
    "name": "Серменево",
    "path": "Россия / Республика Башкортостан / Серменево",
    "country": "Россия",
    "searchString": "серменево россия / республика башкортостан / серменево"
  },
  "9317": {
    "id": "9317",
    "name": "Медянка",
    "path": "Россия / Пермский край / Медянка",
    "country": "Россия",
    "searchString": "медянка россия / пермский край / медянка"
  },
  "9318": {
    "id": "9318",
    "name": "Нижний Катарач",
    "path": "Россия / Свердловская область / Нижний Катарач",
    "country": "Россия",
    "searchString": "нижний катарач россия / свердловская область / нижний катарач"
  },
  "9319": {
    "id": "9319",
    "name": "Раскатиха",
    "path": "Россия / Курганская область / Раскатиха",
    "country": "Россия",
    "searchString": "раскатиха россия / курганская область / раскатиха"
  },
  "9320": {
    "id": "9320",
    "name": "Крутая Горка",
    "path": "Россия / Курганская область / Крутая Горка",
    "country": "Россия",
    "searchString": "крутая горка россия / курганская область / крутая горка"
  },
  "9321": {
    "id": "9321",
    "name": "Измайловский",
    "path": "Россия / Челябинская область / Измайловский",
    "country": "Россия",
    "searchString": "измайловский россия / челябинская область / измайловский"
  },
  "9322": {
    "id": "9322",
    "name": "Курорт Самоцвет",
    "path": "Россия / Свердловская область / Курорт Самоцвет",
    "country": "Россия",
    "searchString": "курорт самоцвет россия / свердловская область / курорт самоцвет"
  },
  "9323": {
    "id": "9323",
    "name": "Никифарово",
    "path": "Россия / Республика Башкортостан / Никифарово",
    "country": "Россия",
    "searchString": "никифарово россия / республика башкортостан / никифарово"
  },
  "9324": {
    "id": "9324",
    "name": "Имянликулево",
    "path": "Россия / Республика Башкортостан / Имянликулево",
    "country": "Россия",
    "searchString": "имянликулево россия / республика башкортостан / имянликулево"
  },
  "9325": {
    "id": "9325",
    "name": "Кын",
    "path": "Россия / Пермский край / Кын",
    "country": "Россия",
    "searchString": "кын россия / пермский край / кын"
  },
  "9326": {
    "id": "9326",
    "name": "Нижнечерекулево",
    "path": "Россия / Республика Башкортостан / Нижнечерекулево",
    "country": "Россия",
    "searchString": "нижнечерекулево россия / республика башкортостан / нижнечерекулево"
  },
  "9327": {
    "id": "9327",
    "name": "Карагайский",
    "path": "Россия / Челябинская область / Карагайский",
    "country": "Россия",
    "searchString": "карагайский россия / челябинская область / карагайский"
  },
  "9328": {
    "id": "9328",
    "name": "Ныда",
    "path": "Россия / Ямало-Ненецкий АО / Ныда",
    "country": "Россия",
    "searchString": "ныда россия / ямало-ненецкий ао / ныда"
  },
  "9329": {
    "id": "9329",
    "name": "Марсяты",
    "path": "Россия / Свердловская область / Марсяты",
    "country": "Россия",
    "searchString": "марсяты россия / свердловская область / марсяты"
  },
  "9330": {
    "id": "9330",
    "name": "Косолапово",
    "path": "Россия / Курганская область / Косолапово",
    "country": "Россия",
    "searchString": "косолапово россия / курганская область / косолапово"
  },
  "9331": {
    "id": "9331",
    "name": "Новосинеглазово",
    "path": "Россия / Челябинская область / Новосинеглазово",
    "country": "Россия",
    "searchString": "новосинеглазово россия / челябинская область / новосинеглазово"
  },
  "9332": {
    "id": "9332",
    "name": "Лагерево",
    "path": "Россия / Республика Башкортостан / Лагерево",
    "country": "Россия",
    "searchString": "лагерево россия / республика башкортостан / лагерево"
  },
  "9333": {
    "id": "9333",
    "name": "Малышенка",
    "path": "Россия / Тюменская область / Малышенка",
    "country": "Россия",
    "searchString": "малышенка россия / тюменская область / малышенка"
  },
  "9334": {
    "id": "9334",
    "name": "Искателей",
    "path": "Россия / Ямало-Ненецкий АО / Искателей",
    "country": "Россия",
    "searchString": "искателей россия / ямало-ненецкий ао / искателей"
  },
  "9335": {
    "id": "9335",
    "name": "Леуза",
    "path": "Россия / Республика Башкортостан / Леуза",
    "country": "Россия",
    "searchString": "леуза россия / республика башкортостан / леуза"
  },
  "9336": {
    "id": "9336",
    "name": "Казым",
    "path": "Россия / Ханты-Мансийский АО - Югра / Казым",
    "country": "Россия",
    "searchString": "казым россия / ханты-мансийский ао - югра / казым"
  },
  "9337": {
    "id": "9337",
    "name": "Филимоново (Челябинская область)",
    "path": "Россия / Челябинская область / Филимоново (Челябинская область)",
    "country": "Россия",
    "searchString": "филимоново (челябинская область) россия / челябинская область / филимоново (челябинская область)"
  },
  "9338": {
    "id": "9338",
    "name": "Есаульский",
    "path": "Россия / Челябинская область / Есаульский",
    "country": "Россия",
    "searchString": "есаульский россия / челябинская область / есаульский"
  },
  "9339": {
    "id": "9339",
    "name": "Памятное",
    "path": "Россия / Курганская область / Памятное",
    "country": "Россия",
    "searchString": "памятное россия / курганская область / памятное"
  },
  "9340": {
    "id": "9340",
    "name": "Оверята",
    "path": "Россия / Пермский край / Оверята",
    "country": "Россия",
    "searchString": "оверята россия / пермский край / оверята"
  },
  "9341": {
    "id": "9341",
    "name": "Зыряновский",
    "path": "Россия / Свердловская область / Зыряновский",
    "country": "Россия",
    "searchString": "зыряновский россия / свердловская область / зыряновский"
  },
  "9342": {
    "id": "9342",
    "name": "Кормовище",
    "path": "Россия / Пермский край / Кормовище",
    "country": "Россия",
    "searchString": "кормовище россия / пермский край / кормовище"
  },
  "9343": {
    "id": "9343",
    "name": "Падеринское",
    "path": "Россия / Курганская область / Падеринское",
    "country": "Россия",
    "searchString": "падеринское россия / курганская область / падеринское"
  },
  "9344": {
    "id": "9344",
    "name": "Степное (Курганская область)",
    "path": "Россия / Курганская область / Степное (Курганская область)",
    "country": "Россия",
    "searchString": "степное (курганская область) россия / курганская область / степное (курганская область)"
  },
  "9345": {
    "id": "9345",
    "name": "Верховино",
    "path": "Россия / Свердловская область / Верховино",
    "country": "Россия",
    "searchString": "верховино россия / свердловская область / верховино"
  },
  "9346": {
    "id": "9346",
    "name": "Камаган",
    "path": "Россия / Курганская область / Камаган",
    "country": "Россия",
    "searchString": "камаган россия / курганская область / камаган"
  },
  "9347": {
    "id": "9347",
    "name": "Красная Башкирия",
    "path": "Россия / Республика Башкортостан / Красная Башкирия",
    "country": "Россия",
    "searchString": "красная башкирия россия / республика башкортостан / красная башкирия"
  },
  "9348": {
    "id": "9348",
    "name": "Урманаево",
    "path": "Россия / Республика Башкортостан / Урманаево",
    "country": "Россия",
    "searchString": "урманаево россия / республика башкортостан / урманаево"
  },
  "9349": {
    "id": "9349",
    "name": "Нердва",
    "path": "Россия / Пермский край / Нердва",
    "country": "Россия",
    "searchString": "нердва россия / пермский край / нердва"
  },
  "9350": {
    "id": "9350",
    "name": "Алябьевский",
    "path": "Россия / Ханты-Мансийский АО - Югра / Алябьевский",
    "country": "Россия",
    "searchString": "алябьевский россия / ханты-мансийский ао - югра / алябьевский"
  },
  "9351": {
    "id": "9351",
    "name": "Усть-Турка",
    "path": "Россия / Пермский край / Усть-Турка",
    "country": "Россия",
    "searchString": "усть-турка россия / пермский край / усть-турка"
  },
  "9352": {
    "id": "9352",
    "name": "Москово",
    "path": "Россия / Республика Башкортостан / Москово",
    "country": "Россия",
    "searchString": "москово россия / республика башкортостан / москово"
  },
  "9353": {
    "id": "9353",
    "name": "Черновское (Свердловская область)",
    "path": "Россия / Свердловская область / Черновское (Свердловская область)",
    "country": "Россия",
    "searchString": "черновское (свердловская область) россия / свердловская область / черновское (свердловская область)"
  },
  "9354": {
    "id": "9354",
    "name": "Белянка",
    "path": "Россия / Республика Башкортостан / Белянка",
    "country": "Россия",
    "searchString": "белянка россия / республика башкортостан / белянка"
  },
  "9355": {
    "id": "9355",
    "name": "Кужанак",
    "path": "Россия / Республика Башкортостан / Кужанак",
    "country": "Россия",
    "searchString": "кужанак россия / республика башкортостан / кужанак"
  },
  "9356": {
    "id": "9356",
    "name": "Суерка",
    "path": "Россия / Тюменская область / Суерка",
    "country": "Россия",
    "searchString": "суерка россия / тюменская область / суерка"
  },
  "9357": {
    "id": "9357",
    "name": "Зарубино (Пермский край)",
    "path": "Россия / Пермский край / Зарубино (Пермский край)",
    "country": "Россия",
    "searchString": "зарубино (пермский край) россия / пермский край / зарубино (пермский край)"
  },
  "9358": {
    "id": "9358",
    "name": "Нейво-Шайтанский",
    "path": "Россия / Свердловская область / Нейво-Шайтанский",
    "country": "Россия",
    "searchString": "нейво-шайтанский россия / свердловская область / нейво-шайтанский"
  },
  "9359": {
    "id": "9359",
    "name": "Верхняя Теча",
    "path": "Россия / Курганская область / Верхняя Теча",
    "country": "Россия",
    "searchString": "верхняя теча россия / курганская область / верхняя теча"
  },
  "9360": {
    "id": "9360",
    "name": "Черемисское",
    "path": "Россия / Свердловская область / Черемисское",
    "country": "Россия",
    "searchString": "черемисское россия / свердловская область / черемисское"
  },
  "9361": {
    "id": "9361",
    "name": "Сергино",
    "path": "Россия / Ханты-Мансийский АО - Югра / Сергино",
    "country": "Россия",
    "searchString": "сергино россия / ханты-мансийский ао - югра / сергино"
  },
  "9362": {
    "id": "9362",
    "name": "Хулимсунт",
    "path": "Россия / Ханты-Мансийский АО - Югра / Хулимсунт",
    "country": "Россия",
    "searchString": "хулимсунт россия / ханты-мансийский ао - югра / хулимсунт"
  },
  "9363": {
    "id": "9363",
    "name": "Ягодная",
    "path": "Россия / Курганская область / Ягодная",
    "country": "Россия",
    "searchString": "ягодная россия / курганская область / ягодная"
  },
  "9364": {
    "id": "9364",
    "name": "Белоярка 1-я",
    "path": "Россия / Курганская область / Белоярка 1-я",
    "country": "Россия",
    "searchString": "белоярка 1-я россия / курганская область / белоярка 1-я"
  },
  "9365": {
    "id": "9365",
    "name": "Верхнетавлыкаево",
    "path": "Россия / Республика Башкортостан / Верхнетавлыкаево",
    "country": "Россия",
    "searchString": "верхнетавлыкаево россия / республика башкортостан / верхнетавлыкаево"
  },
  "9366": {
    "id": "9366",
    "name": "Шастово",
    "path": "Россия / Курганская область / Шастово",
    "country": "Россия",
    "searchString": "шастово россия / курганская область / шастово"
  },
  "9367": {
    "id": "9367",
    "name": "Дивья",
    "path": "Россия / Пермский край / Дивья",
    "country": "Россия",
    "searchString": "дивья россия / пермский край / дивья"
  },
  "9368": {
    "id": "9368",
    "name": "Теплая",
    "path": "Россия / Пермский край / Теплая",
    "country": "Россия",
    "searchString": "теплая россия / пермский край / теплая"
  },
  "9369": {
    "id": "9369",
    "name": "Комсомольск (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Комсомольск (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "комсомольск (республика башкортостан) россия / республика башкортостан / комсомольск (республика башкортостан)"
  },
  "9370": {
    "id": "9370",
    "name": "Крылово",
    "path": "Россия / Пермский край / Крылово",
    "country": "Россия",
    "searchString": "крылово россия / пермский край / крылово"
  },
  "9371": {
    "id": "9371",
    "name": "Демский",
    "path": "Россия / Республика Башкортостан / Демский",
    "country": "Россия",
    "searchString": "демский россия / республика башкортостан / демский"
  },
  "9372": {
    "id": "9372",
    "name": "Куть-Ях",
    "path": "Россия / Ханты-Мансийский АО - Югра / Куть-Ях",
    "country": "Россия",
    "searchString": "куть-ях россия / ханты-мансийский ао - югра / куть-ях"
  },
  "9373": {
    "id": "9373",
    "name": "Кидыш",
    "path": "Россия / Челябинская область / Кидыш",
    "country": "Россия",
    "searchString": "кидыш россия / челябинская область / кидыш"
  },
  "9374": {
    "id": "9374",
    "name": "Пришиб (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Пришиб (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "пришиб (республика башкортостан) россия / республика башкортостан / пришиб (республика башкортостан)"
  },
  "9375": {
    "id": "9375",
    "name": "Ларьковка",
    "path": "Россия / Свердловская область / Ларьковка",
    "country": "Россия",
    "searchString": "ларьковка россия / свердловская область / ларьковка"
  },
  "9376": {
    "id": "9376",
    "name": "Асяново",
    "path": "Россия / Республика Башкортостан / Асяново",
    "country": "Россия",
    "searchString": "асяново россия / республика башкортостан / асяново"
  },
  "9377": {
    "id": "9377",
    "name": "Рождественское (Пермский край)",
    "path": "Россия / Пермский край / Рождественское (Пермский край)",
    "country": "Россия",
    "searchString": "рождественское (пермский край) россия / пермский край / рождественское (пермский край)"
  },
  "9378": {
    "id": "9378",
    "name": "Урметово",
    "path": "Россия / Республика Башкортостан / Урметово",
    "country": "Россия",
    "searchString": "урметово россия / республика башкортостан / урметово"
  },
  "9379": {
    "id": "9379",
    "name": "Чумляк",
    "path": "Россия / Курганская область / Чумляк",
    "country": "Россия",
    "searchString": "чумляк россия / курганская область / чумляк"
  },
  "9380": {
    "id": "9380",
    "name": "Харино",
    "path": "Россия / Пермский край / Харино",
    "country": "Россия",
    "searchString": "харино россия / пермский край / харино"
  },
  "9381": {
    "id": "9381",
    "name": "Варламово",
    "path": "Россия / Челябинская область / Варламово",
    "country": "Россия",
    "searchString": "варламово россия / челябинская область / варламово"
  },
  "9382": {
    "id": "9382",
    "name": "Полноват",
    "path": "Россия / Ханты-Мансийский АО - Югра / Полноват",
    "country": "Россия",
    "searchString": "полноват россия / ханты-мансийский ао - югра / полноват"
  },
  "9383": {
    "id": "9383",
    "name": "Остроленский",
    "path": "Россия / Челябинская область / Остроленский",
    "country": "Россия",
    "searchString": "остроленский россия / челябинская область / остроленский"
  },
  "9384": {
    "id": "9384",
    "name": "Метевбаш",
    "path": "Россия / Республика Башкортостан / Метевбаш",
    "country": "Россия",
    "searchString": "метевбаш россия / республика башкортостан / метевбаш"
  },
  "9385": {
    "id": "9385",
    "name": "Ертарский",
    "path": "Россия / Свердловская область / Ертарский",
    "country": "Россия",
    "searchString": "ертарский россия / свердловская область / ертарский"
  },
  "9386": {
    "id": "9386",
    "name": "Сухоречка",
    "path": "Россия / Республика Башкортостан / Сухоречка",
    "country": "Россия",
    "searchString": "сухоречка россия / республика башкортостан / сухоречка"
  },
  "9387": {
    "id": "9387",
    "name": "Таборы (Пермский край)",
    "path": "Россия / Пермский край / Таборы (Пермский край)",
    "country": "Россия",
    "searchString": "таборы (пермский край) россия / пермский край / таборы (пермский край)"
  },
  "9388": {
    "id": "9388",
    "name": "Кипель",
    "path": "Россия / Курганская область / Кипель",
    "country": "Россия",
    "searchString": "кипель россия / курганская область / кипель"
  },
  "9389": {
    "id": "9389",
    "name": "Сорум",
    "path": "Россия / Ханты-Мансийский АО - Югра / Сорум",
    "country": "Россия",
    "searchString": "сорум россия / ханты-мансийский ао - югра / сорум"
  },
  "9390": {
    "id": "9390",
    "name": "Большая Рига",
    "path": "Россия / Курганская область / Большая Рига",
    "country": "Россия",
    "searchString": "большая рига россия / курганская область / большая рига"
  },
  "9391": {
    "id": "9391",
    "name": "Уральское",
    "path": "Россия / Пермский край / Уральское",
    "country": "Россия",
    "searchString": "уральское россия / пермский край / уральское"
  },
  "9392": {
    "id": "9392",
    "name": "Макарово",
    "path": "Россия / Республика Башкортостан / Макарово",
    "country": "Россия",
    "searchString": "макарово россия / республика башкортостан / макарово"
  },
  "9393": {
    "id": "9393",
    "name": "Вильва",
    "path": "Россия / Пермский край / Вильва",
    "country": "Россия",
    "searchString": "вильва россия / пермский край / вильва"
  },
  "9394": {
    "id": "9394",
    "name": "Сикияз",
    "path": "Россия / Республика Башкортостан / Сикияз",
    "country": "Россия",
    "searchString": "сикияз россия / республика башкортостан / сикияз"
  },
  "9395": {
    "id": "9395",
    "name": "Нижние Киги",
    "path": "Россия / Республика Башкортостан / Нижние Киги",
    "country": "Россия",
    "searchString": "нижние киги россия / республика башкортостан / нижние киги"
  },
  "9396": {
    "id": "9396",
    "name": "Ражево",
    "path": "Россия / Тюменская область / Ражево",
    "country": "Россия",
    "searchString": "ражево россия / тюменская область / ражево"
  },
  "9397": {
    "id": "9397",
    "name": "Новотарманский",
    "path": "Россия / Тюменская область / Новотарманский",
    "country": "Россия",
    "searchString": "новотарманский россия / тюменская область / новотарманский"
  },
  "9398": {
    "id": "9398",
    "name": "Халилово",
    "path": "Россия / Республика Башкортостан / Халилово",
    "country": "Россия",
    "searchString": "халилово россия / республика башкортостан / халилово"
  },
  "9399": {
    "id": "9399",
    "name": "Корнеевка",
    "path": "Россия / Республика Башкортостан / Корнеевка",
    "country": "Россия",
    "searchString": "корнеевка россия / республика башкортостан / корнеевка"
  },
  "9400": {
    "id": "9400",
    "name": "Богдановское",
    "path": "Россия / Челябинская область / Богдановское",
    "country": "Россия",
    "searchString": "богдановское россия / челябинская область / богдановское"
  },
  "9401": {
    "id": "9401",
    "name": "Скоблино",
    "path": "Россия / Курганская область / Скоблино",
    "country": "Россия",
    "searchString": "скоблино россия / курганская область / скоблино"
  },
  "9402": {
    "id": "9402",
    "name": "Альняш",
    "path": "Россия / Пермский край / Альняш",
    "country": "Россия",
    "searchString": "альняш россия / пермский край / альняш"
  },
  "9403": {
    "id": "9403",
    "name": "Абзаново",
    "path": "Россия / Республика Башкортостан / Абзаново",
    "country": "Россия",
    "searchString": "абзаново россия / республика башкортостан / абзаново"
  },
  "9404": {
    "id": "9404",
    "name": "Сейва",
    "path": "Россия / Пермский край / Сейва",
    "country": "Россия",
    "searchString": "сейва россия / пермский край / сейва"
  },
  "9405": {
    "id": "9405",
    "name": "Юлдыбаево",
    "path": "Россия / Республика Башкортостан / Юлдыбаево",
    "country": "Россия",
    "searchString": "юлдыбаево россия / республика башкортостан / юлдыбаево"
  },
  "9406": {
    "id": "9406",
    "name": "Ангасяк",
    "path": "Россия / Республика Башкортостан / Ангасяк",
    "country": "Россия",
    "searchString": "ангасяк россия / республика башкортостан / ангасяк"
  },
  "9407": {
    "id": "9407",
    "name": "Маслянское",
    "path": "Россия / Курганская область / Маслянское",
    "country": "Россия",
    "searchString": "маслянское россия / курганская область / маслянское"
  },
  "9408": {
    "id": "9408",
    "name": "Ашап",
    "path": "Россия / Пермский край / Ашап",
    "country": "Россия",
    "searchString": "ашап россия / пермский край / ашап"
  },
  "9409": {
    "id": "9409",
    "name": "Аблаево",
    "path": "Россия / Республика Башкортостан / Аблаево",
    "country": "Россия",
    "searchString": "аблаево россия / республика башкортостан / аблаево"
  },
  "9410": {
    "id": "9410",
    "name": "Кусье-Александровский",
    "path": "Россия / Пермский край / Кусье-Александровский",
    "country": "Россия",
    "searchString": "кусье-александровский россия / пермский край / кусье-александровский"
  },
  "9411": {
    "id": "9411",
    "name": "Тюлькино",
    "path": "Россия / Пермский край / Тюлькино",
    "country": "Россия",
    "searchString": "тюлькино россия / пермский край / тюлькино"
  },
  "9412": {
    "id": "9412",
    "name": "Тазларово",
    "path": "Россия / Республика Башкортостан / Тазларово",
    "country": "Россия",
    "searchString": "тазларово россия / республика башкортостан / тазларово"
  },
  "9413": {
    "id": "9413",
    "name": "Кудеевский",
    "path": "Россия / Республика Башкортостан / Кудеевский",
    "country": "Россия",
    "searchString": "кудеевский россия / республика башкортостан / кудеевский"
  },
  "9414": {
    "id": "9414",
    "name": "Новый Арта",
    "path": "Россия / Республика Башкортостан / Новый Арта",
    "country": "Россия",
    "searchString": "новый арта россия / республика башкортостан / новый арта"
  },
  "9415": {
    "id": "9415",
    "name": "Старотавларово",
    "path": "Россия / Республика Башкортостан / Старотавларово",
    "country": "Россия",
    "searchString": "старотавларово россия / республика башкортостан / старотавларово"
  },
  "9416": {
    "id": "9416",
    "name": "Рождественка",
    "path": "Россия / Челябинская область / Рождественка",
    "country": "Россия",
    "searchString": "рождественка россия / челябинская область / рождественка"
  },
  "9417": {
    "id": "9417",
    "name": "Купрос",
    "path": "Россия / Пермский край / Купрос",
    "country": "Россия",
    "searchString": "купрос россия / пермский край / купрос"
  },
  "9418": {
    "id": "9418",
    "name": "Тятер-Арасланово",
    "path": "Россия / Республика Башкортостан / Тятер-Арасланово",
    "country": "Россия",
    "searchString": "тятер-арасланово россия / республика башкортостан / тятер-арасланово"
  },
  "9419": {
    "id": "9419",
    "name": "Глинское",
    "path": "Россия / Свердловская область / Глинское",
    "country": "Россия",
    "searchString": "глинское россия / свердловская область / глинское"
  },
  "9420": {
    "id": "9420",
    "name": "Голдыревский",
    "path": "Россия / Пермский край / Голдыревский",
    "country": "Россия",
    "searchString": "голдыревский россия / пермский край / голдыревский"
  },
  "9421": {
    "id": "9421",
    "name": "Щучье Озеро",
    "path": "Россия / Пермский край / Щучье Озеро",
    "country": "Россия",
    "searchString": "щучье озеро россия / пермский край / щучье озеро"
  },
  "9422": {
    "id": "9422",
    "name": "Дурасово",
    "path": "Россия / Республика Башкортостан / Дурасово",
    "country": "Россия",
    "searchString": "дурасово россия / республика башкортостан / дурасово"
  },
  "9423": {
    "id": "9423",
    "name": "Менщиково",
    "path": "Россия / Курганская область / Менщиково",
    "country": "Россия",
    "searchString": "менщиково россия / курганская область / менщиково"
  },
  "9424": {
    "id": "9424",
    "name": "Сенькино",
    "path": "Россия / Пермский край / Сенькино",
    "country": "Россия",
    "searchString": "сенькино россия / пермский край / сенькино"
  },
  "9425": {
    "id": "9425",
    "name": "Маядык",
    "path": "Россия / Республика Башкортостан / Маядык",
    "country": "Россия",
    "searchString": "маядык россия / республика башкортостан / маядык"
  },
  "9426": {
    "id": "9426",
    "name": "Костыгин Лог",
    "path": "Россия / Курганская область / Костыгин Лог",
    "country": "Россия",
    "searchString": "костыгин лог россия / курганская область / костыгин лог"
  },
  "9427": {
    "id": "9427",
    "name": "Карьево",
    "path": "Россия / Пермский край / Карьево",
    "country": "Россия",
    "searchString": "карьево россия / пермский край / карьево"
  },
  "9428": {
    "id": "9428",
    "name": "Демьянское",
    "path": "Россия / Тюменская область / Демьянское",
    "country": "Россия",
    "searchString": "демьянское россия / тюменская область / демьянское"
  },
  "9429": {
    "id": "9429",
    "name": "Нижний Уфалей",
    "path": "Россия / Челябинская область / Нижний Уфалей",
    "country": "Россия",
    "searchString": "нижний уфалей россия / челябинская область / нижний уфалей"
  },
  "9430": {
    "id": "9430",
    "name": "Трошково",
    "path": "Россия / Свердловская область / Трошково",
    "country": "Россия",
    "searchString": "трошково россия / свердловская область / трошково"
  },
  "9431": {
    "id": "9431",
    "name": "Бурибай",
    "path": "Россия / Республика Башкортостан / Бурибай",
    "country": "Россия",
    "searchString": "бурибай россия / республика башкортостан / бурибай"
  },
  "9432": {
    "id": "9432",
    "name": "Тохтуева",
    "path": "Россия / Пермский край / Тохтуева",
    "country": "Россия",
    "searchString": "тохтуева россия / пермский край / тохтуева"
  },
  "9433": {
    "id": "9433",
    "name": "Белоносово",
    "path": "Россия / Челябинская область / Белоносово",
    "country": "Россия",
    "searchString": "белоносово россия / челябинская область / белоносово"
  },
  "9434": {
    "id": "9434",
    "name": "Касиб",
    "path": "Россия / Пермский край / Касиб",
    "country": "Россия",
    "searchString": "касиб россия / пермский край / касиб"
  },
  "9435": {
    "id": "9435",
    "name": "Тюрюшля",
    "path": "Россия / Республика Башкортостан / Тюрюшля",
    "country": "Россия",
    "searchString": "тюрюшля россия / республика башкортостан / тюрюшля"
  },
  "9436": {
    "id": "9436",
    "name": "Первомайское (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Первомайское (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "первомайское (республика башкортостан) россия / республика башкортостан / первомайское (республика башкортостан)"
  },
  "9437": {
    "id": "9437",
    "name": "Ункурда",
    "path": "Россия / Челябинская область / Ункурда",
    "country": "Россия",
    "searchString": "ункурда россия / челябинская область / ункурда"
  },
  "9438": {
    "id": "9438",
    "name": "Толька",
    "path": "Россия / Ямало-Ненецкий АО / Толька",
    "country": "Россия",
    "searchString": "толька россия / ямало-ненецкий ао / толька"
  },
  "9439": {
    "id": "9439",
    "name": "Заполье",
    "path": "Россия / Пермский край / Заполье",
    "country": "Россия",
    "searchString": "заполье россия / пермский край / заполье"
  },
  "9440": {
    "id": "9440",
    "name": "Тарказы",
    "path": "Россия / Республика Башкортостан / Тарказы",
    "country": "Россия",
    "searchString": "тарказы россия / республика башкортостан / тарказы"
  },
  "9441": {
    "id": "9441",
    "name": "Урняк (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Урняк (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "урняк (республика башкортостан) россия / республика башкортостан / урняк (республика башкортостан)"
  },
  "9442": {
    "id": "9442",
    "name": "Красный Ясыл",
    "path": "Россия / Пермский край / Красный Ясыл",
    "country": "Россия",
    "searchString": "красный ясыл россия / пермский край / красный ясыл"
  },
  "9443": {
    "id": "9443",
    "name": "Миякитамак",
    "path": "Россия / Республика Башкортостан / Миякитамак",
    "country": "Россия",
    "searchString": "миякитамак россия / республика башкортостан / миякитамак"
  },
  "9444": {
    "id": "9444",
    "name": "Тукан",
    "path": "Россия / Республика Башкортостан / Тукан",
    "country": "Россия",
    "searchString": "тукан россия / республика башкортостан / тукан"
  },
  "9445": {
    "id": "9445",
    "name": "Юматово",
    "path": "Россия / Республика Башкортостан / Юматово",
    "country": "Россия",
    "searchString": "юматово россия / республика башкортостан / юматово"
  },
  "9446": {
    "id": "9446",
    "name": "Боровое",
    "path": "Россия / Челябинская область / Боровое",
    "country": "Россия",
    "searchString": "боровое россия / челябинская область / боровое"
  },
  "9447": {
    "id": "9447",
    "name": "Яныбаево",
    "path": "Россия / Республика Башкортостан / Яныбаево",
    "country": "Россия",
    "searchString": "яныбаево россия / республика башкортостан / яныбаево"
  },
  "9448": {
    "id": "9448",
    "name": "Рапатово",
    "path": "Россия / Республика Башкортостан / Рапатово",
    "country": "Россия",
    "searchString": "рапатово россия / республика башкортостан / рапатово"
  },
  "9449": {
    "id": "9449",
    "name": "Заманилки",
    "path": "Россия / Курганская область / Заманилки",
    "country": "Россия",
    "searchString": "заманилки россия / курганская область / заманилки"
  },
  "9450": {
    "id": "9450",
    "name": "Шмаково",
    "path": "Россия / Курганская область / Шмаково",
    "country": "Россия",
    "searchString": "шмаково россия / курганская область / шмаково"
  },
  "9451": {
    "id": "9451",
    "name": "Бабка",
    "path": "Россия / Пермский край / Бабка",
    "country": "Россия",
    "searchString": "бабка россия / пермский край / бабка"
  },
  "9452": {
    "id": "9452",
    "name": "Нейво-Рудянка",
    "path": "Россия / Свердловская область / Нейво-Рудянка",
    "country": "Россия",
    "searchString": "нейво-рудянка россия / свердловская область / нейво-рудянка"
  },
  "9453": {
    "id": "9453",
    "name": "Усень-Ивановское",
    "path": "Россия / Республика Башкортостан / Усень-Ивановское",
    "country": "Россия",
    "searchString": "усень-ивановское россия / республика башкортостан / усень-ивановское"
  },
  "9454": {
    "id": "9454",
    "name": "Слудка",
    "path": "Россия / Пермский край / Слудка",
    "country": "Россия",
    "searchString": "слудка россия / пермский край / слудка"
  },
  "9455": {
    "id": "9455",
    "name": "Тузлукушево",
    "path": "Россия / Республика Башкортостан / Тузлукушево",
    "country": "Россия",
    "searchString": "тузлукушево россия / республика башкортостан / тузлукушево"
  },
  "9456": {
    "id": "9456",
    "name": "Мостовское",
    "path": "Россия / Курганская область / Мостовское",
    "country": "Россия",
    "searchString": "мостовское россия / курганская область / мостовское"
  },
  "9457": {
    "id": "9457",
    "name": "Брюзли",
    "path": "Россия / Пермский край / Брюзли",
    "country": "Россия",
    "searchString": "брюзли россия / пермский край / брюзли"
  },
  "9458": {
    "id": "9458",
    "name": "Наумовка",
    "path": "Россия / Республика Башкортостан / Наумовка",
    "country": "Россия",
    "searchString": "наумовка россия / республика башкортостан / наумовка"
  },
  "9459": {
    "id": "9459",
    "name": "Травное (Курганская область)",
    "path": "Россия / Курганская область / Травное (Курганская область)",
    "country": "Россия",
    "searchString": "травное (курганская область) россия / курганская область / травное (курганская область)"
  },
  "9460": {
    "id": "9460",
    "name": "Шафраново",
    "path": "Россия / Республика Башкортостан / Шафраново",
    "country": "Россия",
    "searchString": "шафраново россия / республика башкортостан / шафраново"
  },
  "9461": {
    "id": "9461",
    "name": "Гречанная Балка",
    "path": "Россия / Краснодарский край / Гречанная Балка",
    "country": "Россия",
    "searchString": "гречанная балка россия / краснодарский край / гречанная балка"
  },
  "9462": {
    "id": "9462",
    "name": "Яникой",
    "path": "Россия / Кабардино-Балкарская республика / Яникой",
    "country": "Россия",
    "searchString": "яникой россия / кабардино-балкарская республика / яникой"
  },
  "9463": {
    "id": "9463",
    "name": "Ачуево",
    "path": "Россия / Краснодарский край / Ачуево",
    "country": "Россия",
    "searchString": "ачуево россия / краснодарский край / ачуево"
  },
  "9464": {
    "id": "9464",
    "name": "Новоалексеевское (Краснодарский край)",
    "path": "Россия / Краснодарский край / Новоалексеевское (Краснодарский край)",
    "country": "Россия",
    "searchString": "новоалексеевское (краснодарский край) россия / краснодарский край / новоалексеевское (краснодарский край)"
  },
  "9465": {
    "id": "9465",
    "name": "Родниковское",
    "path": "Россия / Ставропольский край / Родниковское",
    "country": "Россия",
    "searchString": "родниковское россия / ставропольский край / родниковское"
  },
  "9466": {
    "id": "9466",
    "name": "Саукдере",
    "path": "Россия / Краснодарский край / Саукдере",
    "country": "Россия",
    "searchString": "саукдере россия / краснодарский край / саукдере"
  },
  "9467": {
    "id": "9467",
    "name": "Поселок имени Кирова",
    "path": "Россия / Ставропольский край / Поселок имени Кирова",
    "country": "Россия",
    "searchString": "поселок имени кирова россия / ставропольский край / поселок имени кирова"
  },
  "9468": {
    "id": "9468",
    "name": "Алексее-Тенгинская",
    "path": "Россия / Краснодарский край / Алексее-Тенгинская",
    "country": "Россия",
    "searchString": "алексее-тенгинская россия / краснодарский край / алексее-тенгинская"
  },
  "9469": {
    "id": "9469",
    "name": "Красное (Ставропольский край)",
    "path": "Россия / Ставропольский край / Красное (Ставропольский край)",
    "country": "Россия",
    "searchString": "красное (ставропольский край) россия / ставропольский край / красное (ставропольский край)"
  },
  "9470": {
    "id": "9470",
    "name": "Первореченское",
    "path": "Россия / Краснодарский край / Первореченское",
    "country": "Россия",
    "searchString": "первореченское россия / краснодарский край / первореченское"
  },
  "9471": {
    "id": "9471",
    "name": "Павловский (Краснодарский край)",
    "path": "Россия / Краснодарский край / Павловский (Краснодарский край)",
    "country": "Россия",
    "searchString": "павловский (краснодарский край) россия / краснодарский край / павловский (краснодарский край)"
  },
  "9472": {
    "id": "9472",
    "name": "Новокумский",
    "path": "Россия / Ставропольский край / Новокумский",
    "country": "Россия",
    "searchString": "новокумский россия / ставропольский край / новокумский"
  },
  "9473": {
    "id": "9473",
    "name": "Первомайский (Ленинградский район)",
    "path": "Россия / Краснодарский край / Первомайский (Ленинградский район)",
    "country": "Россия",
    "searchString": "первомайский (ленинградский район) россия / краснодарский край / первомайский (ленинградский район)"
  },
  "9474": {
    "id": "9474",
    "name": "Таманский",
    "path": "Россия / Краснодарский край / Таманский",
    "country": "Россия",
    "searchString": "таманский россия / краснодарский край / таманский"
  },
  "9475": {
    "id": "9475",
    "name": "Бабугент",
    "path": "Россия / Кабардино-Балкарская республика / Бабугент",
    "country": "Россия",
    "searchString": "бабугент россия / кабардино-балкарская республика / бабугент"
  },
  "9476": {
    "id": "9476",
    "name": "Надежная",
    "path": "Россия / Краснодарский край / Надежная",
    "country": "Россия",
    "searchString": "надежная россия / краснодарский край / надежная"
  },
  "9477": {
    "id": "9477",
    "name": "Тенгинка",
    "path": "Россия / Краснодарский край / Тенгинка",
    "country": "Россия",
    "searchString": "тенгинка россия / краснодарский край / тенгинка"
  },
  "9478": {
    "id": "9478",
    "name": "Новая Жизнь",
    "path": "Россия / Ставропольский край / Новая Жизнь",
    "country": "Россия",
    "searchString": "новая жизнь россия / ставропольский край / новая жизнь"
  },
  "9479": {
    "id": "9479",
    "name": "Кучерла",
    "path": "Россия / Ставропольский край / Кучерла",
    "country": "Россия",
    "searchString": "кучерла россия / ставропольский край / кучерла"
  },
  "9480": {
    "id": "9480",
    "name": "Новопластуновская",
    "path": "Россия / Краснодарский край / Новопластуновская",
    "country": "Россия",
    "searchString": "новопластуновская россия / краснодарский край / новопластуновская"
  },
  "9481": {
    "id": "9481",
    "name": "Сергиевское",
    "path": "Россия / Ставропольский край / Сергиевское",
    "country": "Россия",
    "searchString": "сергиевское россия / ставропольский край / сергиевское"
  },
  "9482": {
    "id": "9482",
    "name": "Новоивановская",
    "path": "Россия / Краснодарский край / Новоивановская",
    "country": "Россия",
    "searchString": "новоивановская россия / краснодарский край / новоивановская"
  },
  "9483": {
    "id": "9483",
    "name": "Трехсельское",
    "path": "Россия / Краснодарский край / Трехсельское",
    "country": "Россия",
    "searchString": "трехсельское россия / краснодарский край / трехсельское"
  },
  "9484": {
    "id": "9484",
    "name": "Каменная балка (Благодарненский район)",
    "path": "Россия / Ставропольский край / Каменная балка (Благодарненский район)",
    "country": "Россия",
    "searchString": "каменная балка (благодарненский район) россия / ставропольский край / каменная балка (благодарненский район)"
  },
  "9485": {
    "id": "9485",
    "name": "Глафировка",
    "path": "Россия / Краснодарский край / Глафировка",
    "country": "Россия",
    "searchString": "глафировка россия / краснодарский край / глафировка"
  },
  "9486": {
    "id": "9486",
    "name": "Щербиновский",
    "path": "Россия / Краснодарский край / Щербиновский",
    "country": "Россия",
    "searchString": "щербиновский россия / краснодарский край / щербиновский"
  },
  "9487": {
    "id": "9487",
    "name": "Казгулак",
    "path": "Россия / Ставропольский край / Казгулак",
    "country": "Россия",
    "searchString": "казгулак россия / ставропольский край / казгулак"
  },
  "9488": {
    "id": "9488",
    "name": "Горьковский (Ставропольский край)",
    "path": "Россия / Ставропольский край / Горьковский (Ставропольский край)",
    "country": "Россия",
    "searchString": "горьковский (ставропольский край) россия / ставропольский край / горьковский (ставропольский край)"
  },
  "9489": {
    "id": "9489",
    "name": "Хутор Южный (Курганинский район)",
    "path": "Россия / Краснодарский край / Хутор Южный (Курганинский район)",
    "country": "Россия",
    "searchString": "хутор южный (курганинский район) россия / краснодарский край / хутор южный (курганинский район)"
  },
  "9490": {
    "id": "9490",
    "name": "Дукмасов",
    "path": "Россия / Республика Адыгея / Дукмасов",
    "country": "Россия",
    "searchString": "дукмасов россия / республика адыгея / дукмасов"
  },
  "9491": {
    "id": "9491",
    "name": "Кендже-Кулак",
    "path": "Россия / Ставропольский край / Кендже-Кулак",
    "country": "Россия",
    "searchString": "кендже-кулак россия / ставропольский край / кендже-кулак"
  },
  "9492": {
    "id": "9492",
    "name": "Тамбовский (Республика Адыгея)",
    "path": "Россия / Республика Адыгея / Тамбовский (Республика Адыгея)",
    "country": "Россия",
    "searchString": "тамбовский (республика адыгея) россия / республика адыгея / тамбовский (республика адыгея)"
  },
  "9493": {
    "id": "9493",
    "name": "Костромская",
    "path": "Россия / Краснодарский край / Костромская",
    "country": "Россия",
    "searchString": "костромская россия / краснодарский край / костромская"
  },
  "9494": {
    "id": "9494",
    "name": "Пшада",
    "path": "Россия / Краснодарский край / Пшада",
    "country": "Россия",
    "searchString": "пшада россия / краснодарский край / пшада"
  },
  "9495": {
    "id": "9495",
    "name": "Зарево",
    "path": "Россия / Республика Адыгея / Зарево",
    "country": "Россия",
    "searchString": "зарево россия / республика адыгея / зарево"
  },
  "9496": {
    "id": "9496",
    "name": "Крым-Гиреевское",
    "path": "Россия / Ставропольский край / Крым-Гиреевское",
    "country": "Россия",
    "searchString": "крым-гиреевское россия / ставропольский край / крым-гиреевское"
  },
  "9497": {
    "id": "9497",
    "name": "Новоромановское",
    "path": "Россия / Ставропольский край / Новоромановское",
    "country": "Россия",
    "searchString": "новоромановское россия / ставропольский край / новоромановское"
  },
  "9498": {
    "id": "9498",
    "name": "Водораздел",
    "path": "Россия / Ставропольский край / Водораздел",
    "country": "Россия",
    "searchString": "водораздел россия / ставропольский край / водораздел"
  },
  "9499": {
    "id": "9499",
    "name": "Танцура Крамаренко",
    "path": "Россия / Краснодарский край / Танцура Крамаренко",
    "country": "Россия",
    "searchString": "танцура крамаренко россия / краснодарский край / танцура крамаренко"
  },
  "9500": {
    "id": "9500",
    "name": "Каменомостское",
    "path": "Россия / Кабардино-Балкарская республика / Каменомостское",
    "country": "Россия",
    "searchString": "каменомостское россия / кабардино-балкарская республика / каменомостское"
  },
  "9501": {
    "id": "9501",
    "name": "Киевка",
    "path": "Россия / Ставропольский край / Киевка",
    "country": "Россия",
    "searchString": "киевка россия / ставропольский край / киевка"
  },
  "9502": {
    "id": "9502",
    "name": "Кугоейская",
    "path": "Россия / Краснодарский край / Кугоейская",
    "country": "Россия",
    "searchString": "кугоейская россия / краснодарский край / кугоейская"
  },
  "9503": {
    "id": "9503",
    "name": "Дербетовка",
    "path": "Россия / Ставропольский край / Дербетовка",
    "country": "Россия",
    "searchString": "дербетовка россия / ставропольский край / дербетовка"
  },
  "9504": {
    "id": "9504",
    "name": "Су-Псех",
    "path": "Россия / Краснодарский край / Су-Псех",
    "country": "Россия",
    "searchString": "су-псех россия / краснодарский край / су-псех"
  },
  "9505": {
    "id": "9505",
    "name": "Журавское",
    "path": "Россия / Ставропольский край / Журавское",
    "country": "Россия",
    "searchString": "журавское россия / ставропольский край / журавское"
  },
  "9506": {
    "id": "9506",
    "name": "Староизобильная",
    "path": "Россия / Ставропольский край / Староизобильная",
    "country": "Россия",
    "searchString": "староизобильная россия / ставропольский край / староизобильная"
  },
  "9507": {
    "id": "9507",
    "name": "Бараниковский",
    "path": "Россия / Краснодарский край / Бараниковский",
    "country": "Россия",
    "searchString": "бараниковский россия / краснодарский край / бараниковский"
  },
  "9508": {
    "id": "9508",
    "name": "Вревское",
    "path": "Россия / Ставропольский край / Вревское",
    "country": "Россия",
    "searchString": "вревское россия / ставропольский край / вревское"
  },
  "9509": {
    "id": "9509",
    "name": "Куршава",
    "path": "Россия / Ставропольский край / Куршава",
    "country": "Россия",
    "searchString": "куршава россия / ставропольский край / куршава"
  },
  "9510": {
    "id": "9510",
    "name": "Калиновское",
    "path": "Россия / Ставропольский край / Калиновское",
    "country": "Россия",
    "searchString": "калиновское россия / ставропольский край / калиновское"
  },
  "9511": {
    "id": "9511",
    "name": "Гражданский",
    "path": "Россия / Краснодарский край / Гражданский",
    "country": "Россия",
    "searchString": "гражданский россия / краснодарский край / гражданский"
  },
  "9512": {
    "id": "9512",
    "name": "Рисовый",
    "path": "Россия / Краснодарский край / Рисовый",
    "country": "Россия",
    "searchString": "рисовый россия / краснодарский край / рисовый"
  },
  "9513": {
    "id": "9513",
    "name": "Уманский",
    "path": "Россия / Краснодарский край / Уманский",
    "country": "Россия",
    "searchString": "уманский россия / краснодарский край / уманский"
  },
  "9514": {
    "id": "9514",
    "name": "Тюменский",
    "path": "Россия / Краснодарский край / Тюменский",
    "country": "Россия",
    "searchString": "тюменский россия / краснодарский край / тюменский"
  },
  "9515": {
    "id": "9515",
    "name": "Ольгинский",
    "path": "Россия / Краснодарский край / Ольгинский",
    "country": "Россия",
    "searchString": "ольгинский россия / краснодарский край / ольгинский"
  },
  "9516": {
    "id": "9516",
    "name": "Каменная Балка (Арзгирский район)",
    "path": "Россия / Ставропольский край / Каменная Балка (Арзгирский район)",
    "country": "Россия",
    "searchString": "каменная балка (арзгирский район) россия / ставропольский край / каменная балка (арзгирский район)"
  },
  "9517": {
    "id": "9517",
    "name": "Овощи",
    "path": "Россия / Ставропольский край / Овощи",
    "country": "Россия",
    "searchString": "овощи россия / ставропольский край / овощи"
  },
  "9518": {
    "id": "9518",
    "name": "Октябрьский (Павловский район)",
    "path": "Россия / Краснодарский край / Октябрьский (Павловский район)",
    "country": "Россия",
    "searchString": "октябрьский (павловский район) россия / краснодарский край / октябрьский (павловский район)"
  },
  "9519": {
    "id": "9519",
    "name": "Придорожная",
    "path": "Россия / Краснодарский край / Придорожная",
    "country": "Россия",
    "searchString": "придорожная россия / краснодарский край / придорожная"
  },
  "9520": {
    "id": "9520",
    "name": "Александровский",
    "path": "Россия / Краснодарский край / Александровский",
    "country": "Россия",
    "searchString": "александровский россия / краснодарский край / александровский"
  },
  "9521": {
    "id": "9521",
    "name": "Ново-Ивановское",
    "path": "Россия / Кабардино-Балкарская республика / Ново-Ивановское",
    "country": "Россия",
    "searchString": "ново-ивановское россия / кабардино-балкарская республика / ново-ивановское"
  },
  "9522": {
    "id": "9522",
    "name": "Бейсуг",
    "path": "Россия / Краснодарский край / Бейсуг",
    "country": "Россия",
    "searchString": "бейсуг россия / краснодарский край / бейсуг"
  },
  "9523": {
    "id": "9523",
    "name": "Ленинский (Краснодарский край)",
    "path": "Россия / Краснодарский край / Ленинский (Краснодарский край)",
    "country": "Россия",
    "searchString": "ленинский (краснодарский край) россия / краснодарский край / ленинский (краснодарский край)"
  },
  "9524": {
    "id": "9524",
    "name": "Томузловское",
    "path": "Россия / Ставропольский край / Томузловское",
    "country": "Россия",
    "searchString": "томузловское россия / ставропольский край / томузловское"
  },
  "9525": {
    "id": "9525",
    "name": "Архангельское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Архангельское (Ставропольский край)",
    "country": "Россия",
    "searchString": "архангельское (ставропольский край) россия / ставропольский край / архангельское (ставропольский край)"
  },
  "9526": {
    "id": "9526",
    "name": "Советский (Ейский район)",
    "path": "Россия / Краснодарский край / Советский (Ейский район)",
    "country": "Россия",
    "searchString": "советский (ейский район) россия / краснодарский край / советский (ейский район)"
  },
  "9527": {
    "id": "9527",
    "name": "Стодеревская",
    "path": "Россия / Ставропольский край / Стодеревская",
    "country": "Россия",
    "searchString": "стодеревская россия / ставропольский край / стодеревская"
  },
  "9528": {
    "id": "9528",
    "name": "Плоская",
    "path": "Россия / Краснодарский край / Плоская",
    "country": "Россия",
    "searchString": "плоская россия / краснодарский край / плоская"
  },
  "9529": {
    "id": "9529",
    "name": "Веселая",
    "path": "Россия / Краснодарский край / Веселая",
    "country": "Россия",
    "searchString": "веселая россия / краснодарский край / веселая"
  },
  "9530": {
    "id": "9530",
    "name": "Арани",
    "path": "Россия / Республика Дагестан / Арани",
    "country": "Россия",
    "searchString": "арани россия / республика дагестан / арани"
  },
  "9531": {
    "id": "9531",
    "name": "Николина Балка",
    "path": "Россия / Ставропольский край / Николина Балка",
    "country": "Россия",
    "searchString": "николина балка россия / ставропольский край / николина балка"
  },
  "9532": {
    "id": "9532",
    "name": "Черниговское",
    "path": "Россия / Краснодарский край / Черниговское",
    "country": "Россия",
    "searchString": "черниговское россия / краснодарский край / черниговское"
  },
  "9533": {
    "id": "9533",
    "name": "Сенгилеевское",
    "path": "Россия / Ставропольский край / Сенгилеевское",
    "country": "Россия",
    "searchString": "сенгилеевское россия / ставропольский край / сенгилеевское"
  },
  "9534": {
    "id": "9534",
    "name": "Ирклиевская",
    "path": "Россия / Краснодарский край / Ирклиевская",
    "country": "Россия",
    "searchString": "ирклиевская россия / краснодарский край / ирклиевская"
  },
  "9535": {
    "id": "9535",
    "name": "Красночервонный",
    "path": "Россия / Ставропольский край / Красночервонный",
    "country": "Россия",
    "searchString": "красночервонный россия / ставропольский край / красночервонный"
  },
  "9536": {
    "id": "9536",
    "name": "Пшичо",
    "path": "Россия / Республика Адыгея / Пшичо",
    "country": "Россия",
    "searchString": "пшичо россия / республика адыгея / пшичо"
  },
  "9537": {
    "id": "9537",
    "name": "Коммаяк",
    "path": "Россия / Ставропольский край / Коммаяк",
    "country": "Россия",
    "searchString": "коммаяк россия / ставропольский край / коммаяк"
  },
  "9538": {
    "id": "9538",
    "name": "Вознесеновское",
    "path": "Россия / Ставропольский край / Вознесеновское",
    "country": "Россия",
    "searchString": "вознесеновское россия / ставропольский край / вознесеновское"
  },
  "9539": {
    "id": "9539",
    "name": "Привольное",
    "path": "Россия / Ставропольский край / Привольное",
    "country": "Россия",
    "searchString": "привольное россия / ставропольский край / привольное"
  },
  "9540": {
    "id": "9540",
    "name": "Ореховка",
    "path": "Россия / Ставропольский край / Ореховка",
    "country": "Россия",
    "searchString": "ореховка россия / ставропольский край / ореховка"
  },
  "9541": {
    "id": "9541",
    "name": "Полтавское",
    "path": "Россия / Ставропольский край / Полтавское",
    "country": "Россия",
    "searchString": "полтавское россия / ставропольский край / полтавское"
  },
  "9542": {
    "id": "9542",
    "name": "Зассовская",
    "path": "Россия / Краснодарский край / Зассовская",
    "country": "Россия",
    "searchString": "зассовская россия / краснодарский край / зассовская"
  },
  "9543": {
    "id": "9543",
    "name": "Успенская",
    "path": "Россия / Краснодарский край / Успенская",
    "country": "Россия",
    "searchString": "успенская россия / краснодарский край / успенская"
  },
  "9544": {
    "id": "9544",
    "name": "Горнозаводское",
    "path": "Россия / Ставропольский край / Горнозаводское",
    "country": "Россия",
    "searchString": "горнозаводское россия / ставропольский край / горнозаводское"
  },
  "9545": {
    "id": "9545",
    "name": "Восход (Краснодарский край)",
    "path": "Россия / Краснодарский край / Восход (Краснодарский край)",
    "country": "Россия",
    "searchString": "восход (краснодарский край) россия / краснодарский край / восход (краснодарский край)"
  },
  "9546": {
    "id": "9546",
    "name": "Новый Янкуль",
    "path": "Россия / Ставропольский край / Новый Янкуль",
    "country": "Россия",
    "searchString": "новый янкуль россия / ставропольский край / новый янкуль"
  },
  "9547": {
    "id": "9547",
    "name": "Александровская (Кабардино-Балкарская республика)",
    "path": "Россия / Кабардино-Балкарская республика / Александровская (Кабардино-Балкарская республика)",
    "country": "Россия",
    "searchString": "александровская (кабардино-балкарская республика) россия / кабардино-балкарская республика / александровская (кабардино-балкарская республика)"
  },
  "9548": {
    "id": "9548",
    "name": "Ейское Укрепление",
    "path": "Россия / Краснодарский край / Ейское Укрепление",
    "country": "Россия",
    "searchString": "ейское укрепление россия / краснодарский край / ейское укрепление"
  },
  "9549": {
    "id": "9549",
    "name": "Первая Синюха",
    "path": "Россия / Краснодарский край / Первая Синюха",
    "country": "Россия",
    "searchString": "первая синюха россия / краснодарский край / первая синюха"
  },
  "9550": {
    "id": "9550",
    "name": "Прикалаусский",
    "path": "Россия / Ставропольский край / Прикалаусский",
    "country": "Россия",
    "searchString": "прикалаусский россия / ставропольский край / прикалаусский"
  },
  "9551": {
    "id": "9551",
    "name": "Султан",
    "path": "Россия / Ставропольский край / Султан",
    "country": "Россия",
    "searchString": "султан россия / ставропольский край / султан"
  },
  "9552": {
    "id": "9552",
    "name": "Брюховецкая",
    "path": "Россия / Краснодарский край / Брюховецкая",
    "country": "Россия",
    "searchString": "брюховецкая россия / краснодарский край / брюховецкая"
  },
  "9553": {
    "id": "9553",
    "name": "Канеловская",
    "path": "Россия / Краснодарский край / Канеловская",
    "country": "Россия",
    "searchString": "канеловская россия / краснодарский край / канеловская"
  },
  "9554": {
    "id": "9554",
    "name": "Грушевское",
    "path": "Россия / Ставропольский край / Грушевское",
    "country": "Россия",
    "searchString": "грушевское россия / ставропольский край / грушевское"
  },
  "9555": {
    "id": "9555",
    "name": "Фельдмаршальский",
    "path": "Россия / Ставропольский край / Фельдмаршальский",
    "country": "Россия",
    "searchString": "фельдмаршальский россия / ставропольский край / фельдмаршальский"
  },
  "9556": {
    "id": "9556",
    "name": "Казинка (Шпаковский район)",
    "path": "Россия / Ставропольский край / Казинка (Шпаковский район)",
    "country": "Россия",
    "searchString": "казинка (шпаковский район) россия / ставропольский край / казинка (шпаковский район)"
  },
  "9557": {
    "id": "9557",
    "name": "Роте-Фане",
    "path": "Россия / Краснодарский край / Роте-Фане",
    "country": "Россия",
    "searchString": "роте-фане россия / краснодарский край / роте-фане"
  },
  "9558": {
    "id": "9558",
    "name": "Кременчуг-Константиновское",
    "path": "Россия / Кабардино-Балкарская республика / Кременчуг-Константиновское",
    "country": "Россия",
    "searchString": "кременчуг-константиновское россия / кабардино-балкарская республика / кременчуг-константиновское"
  },
  "9559": {
    "id": "9559",
    "name": "Донская Балка",
    "path": "Россия / Ставропольский край / Донская Балка",
    "country": "Россия",
    "searchString": "донская балка россия / ставропольский край / донская балка"
  },
  "9560": {
    "id": "9560",
    "name": "Терскол",
    "path": "Россия / Кабардино-Балкарская республика / Терскол",
    "country": "Россия",
    "searchString": "терскол россия / кабардино-балкарская республика / терскол"
  },
  "9561": {
    "id": "9561",
    "name": "Надеждино",
    "path": "Россия / Краснодарский край / Надеждино",
    "country": "Россия",
    "searchString": "надеждино россия / краснодарский край / надеждино"
  },
  "9562": {
    "id": "9562",
    "name": "Новосергиевская",
    "path": "Россия / Краснодарский край / Новосергиевская",
    "country": "Россия",
    "searchString": "новосергиевская россия / краснодарский край / новосергиевская"
  },
  "9563": {
    "id": "9563",
    "name": "Бакинская",
    "path": "Россия / Краснодарский край / Бакинская",
    "country": "Россия",
    "searchString": "бакинская россия / краснодарский край / бакинская"
  },
  "9564": {
    "id": "9564",
    "name": "Унароково",
    "path": "Россия / Краснодарский край / Унароково",
    "country": "Россия",
    "searchString": "унароково россия / краснодарский край / унароково"
  },
  "9565": {
    "id": "9565",
    "name": "Янкуль",
    "path": "Россия / Ставропольский край / Янкуль",
    "country": "Россия",
    "searchString": "янкуль россия / ставропольский край / янкуль"
  },
  "9566": {
    "id": "9566",
    "name": "Газырь",
    "path": "Россия / Краснодарский край / Газырь",
    "country": "Россия",
    "searchString": "газырь россия / краснодарский край / газырь"
  },
  "9567": {
    "id": "9567",
    "name": "Кубань",
    "path": "Россия / Краснодарский край / Кубань",
    "country": "Россия",
    "searchString": "кубань россия / краснодарский край / кубань"
  },
  "9568": {
    "id": "9568",
    "name": "Болгов",
    "path": "Россия / Краснодарский край / Болгов",
    "country": "Россия",
    "searchString": "болгов россия / краснодарский край / болгов"
  },
  "9569": {
    "id": "9569",
    "name": "Камбулат",
    "path": "Россия / Ставропольский край / Камбулат",
    "country": "Россия",
    "searchString": "камбулат россия / ставропольский край / камбулат"
  },
  "9570": {
    "id": "9570",
    "name": "Ситниково (Ставропольский край)",
    "path": "Россия / Ставропольский край / Ситниково (Ставропольский край)",
    "country": "Россия",
    "searchString": "ситниково (ставропольский край) россия / ставропольский край / ситниково (ставропольский край)"
  },
  "9571": {
    "id": "9571",
    "name": "Кубанская",
    "path": "Россия / Краснодарский край / Кубанская",
    "country": "Россия",
    "searchString": "кубанская россия / краснодарский край / кубанская"
  },
  "9572": {
    "id": "9572",
    "name": "Девица (Ставропольский край)",
    "path": "Россия / Ставропольский край / Девица (Ставропольский край)",
    "country": "Россия",
    "searchString": "девица (ставропольский край) россия / ставропольский край / девица (ставропольский край)"
  },
  "9573": {
    "id": "9573",
    "name": "Поселок Южный (Усть-Лабинский район)",
    "path": "Россия / Краснодарский край / Поселок Южный (Усть-Лабинский район)",
    "country": "Россия",
    "searchString": "поселок южный (усть-лабинский район) россия / краснодарский край / поселок южный (усть-лабинский район)"
  },
  "9574": {
    "id": "9574",
    "name": "Поселок имени Максима Горького",
    "path": "Россия / Краснодарский край / Поселок имени Максима Горького",
    "country": "Россия",
    "searchString": "поселок имени максима горького россия / краснодарский край / поселок имени максима горького"
  },
  "9575": {
    "id": "9575",
    "name": "Бесленеевская",
    "path": "Россия / Краснодарский край / Бесленеевская",
    "country": "Россия",
    "searchString": "бесленеевская россия / краснодарский край / бесленеевская"
  },
  "9576": {
    "id": "9576",
    "name": "Кущевская",
    "path": "Россия / Краснодарский край / Кущевская",
    "country": "Россия",
    "searchString": "кущевская россия / краснодарский край / кущевская"
  },
  "9577": {
    "id": "9577",
    "name": "Мерчанское",
    "path": "Россия / Краснодарский край / Мерчанское",
    "country": "Россия",
    "searchString": "мерчанское россия / краснодарский край / мерчанское"
  },
  "9578": {
    "id": "9578",
    "name": "Джумайловка",
    "path": "Россия / Краснодарский край / Джумайловка",
    "country": "Россия",
    "searchString": "джумайловка россия / краснодарский край / джумайловка"
  },
  "9579": {
    "id": "9579",
    "name": "Апанасенковское",
    "path": "Россия / Ставропольский край / Апанасенковское",
    "country": "Россия",
    "searchString": "апанасенковское россия / ставропольский край / апанасенковское"
  },
  "9580": {
    "id": "9580",
    "name": "Манычское",
    "path": "Россия / Ставропольский край / Манычское",
    "country": "Россия",
    "searchString": "манычское россия / ставропольский край / манычское"
  },
  "9581": {
    "id": "9581",
    "name": "Воздвиженская",
    "path": "Россия / Краснодарский край / Воздвиженская",
    "country": "Россия",
    "searchString": "воздвиженская россия / краснодарский край / воздвиженская"
  },
  "9582": {
    "id": "9582",
    "name": "Новопокровский",
    "path": "Россия / Краснодарский край / Новопокровский",
    "country": "Россия",
    "searchString": "новопокровский россия / краснодарский край / новопокровский"
  },
  "9583": {
    "id": "9583",
    "name": "Красный Маныч",
    "path": "Россия / Ставропольский край / Красный Маныч",
    "country": "Россия",
    "searchString": "красный маныч россия / ставропольский край / красный маныч"
  },
  "9584": {
    "id": "9584",
    "name": "Передовой",
    "path": "Россия / Ставропольский край / Передовой",
    "country": "Россия",
    "searchString": "передовой россия / ставропольский край / передовой"
  },
  "9585": {
    "id": "9585",
    "name": "Жемтала",
    "path": "Россия / Кабардино-Балкарская республика / Жемтала",
    "country": "Россия",
    "searchString": "жемтала россия / кабардино-балкарская республика / жемтала"
  },
  "9586": {
    "id": "9586",
    "name": "Серафимовское",
    "path": "Россия / Ставропольский край / Серафимовское",
    "country": "Россия",
    "searchString": "серафимовское россия / ставропольский край / серафимовское"
  },
  "9587": {
    "id": "9587",
    "name": "Октябрьский (Ленинградский район)",
    "path": "Россия / Краснодарский край / Октябрьский (Ленинградский район)",
    "country": "Россия",
    "searchString": "октябрьский (ленинградский район) россия / краснодарский край / октябрьский (ленинградский район)"
  },
  "9588": {
    "id": "9588",
    "name": "Убеженская",
    "path": "Россия / Краснодарский край / Убеженская",
    "country": "Россия",
    "searchString": "убеженская россия / краснодарский край / убеженская"
  },
  "9589": {
    "id": "9589",
    "name": "Шведино",
    "path": "Россия / Ставропольский край / Шведино",
    "country": "Россия",
    "searchString": "шведино россия / ставропольский край / шведино"
  },
  "9590": {
    "id": "9590",
    "name": "Средний Челбас",
    "path": "Россия / Краснодарский край / Средний Челбас",
    "country": "Россия",
    "searchString": "средний челбас россия / краснодарский край / средний челбас"
  },
  "9591": {
    "id": "9591",
    "name": "Коржи",
    "path": "Россия / Краснодарский край / Коржи",
    "country": "Россия",
    "searchString": "коржи россия / краснодарский край / коржи"
  },
  "9592": {
    "id": "9592",
    "name": "Лебеди",
    "path": "Россия / Краснодарский край / Лебеди",
    "country": "Россия",
    "searchString": "лебеди россия / краснодарский край / лебеди"
  },
  "9593": {
    "id": "9593",
    "name": "Октябрьский (Курганинский район)",
    "path": "Россия / Краснодарский край / Октябрьский (Курганинский район)",
    "country": "Россия",
    "searchString": "октябрьский (курганинский район) россия / краснодарский край / октябрьский (курганинский район)"
  },
  "9594": {
    "id": "9594",
    "name": "Приреченский",
    "path": "Россия / Краснодарский край / Приреченский",
    "country": "Россия",
    "searchString": "приреченский россия / краснодарский край / приреченский"
  },
  "9595": {
    "id": "9595",
    "name": "Малая Джалга",
    "path": "Россия / Ставропольский край / Малая Джалга",
    "country": "Россия",
    "searchString": "малая джалга россия / ставропольский край / малая джалга"
  },
  "9596": {
    "id": "9596",
    "name": "Октябрьский (Ейский район)",
    "path": "Россия / Краснодарский край / Октябрьский (Ейский район)",
    "country": "Россия",
    "searchString": "октябрьский (ейский район) россия / краснодарский край / октябрьский (ейский район)"
  },
  "9597": {
    "id": "9597",
    "name": "Рагули",
    "path": "Россия / Ставропольский край / Рагули",
    "country": "Россия",
    "searchString": "рагули россия / ставропольский край / рагули"
  },
  "9598": {
    "id": "9598",
    "name": "Приазовская",
    "path": "Россия / Краснодарский край / Приазовская",
    "country": "Россия",
    "searchString": "приазовская россия / краснодарский край / приазовская"
  },
  "9599": {
    "id": "9599",
    "name": "Первомайский (Республика Адыгея)",
    "path": "Россия / Республика Адыгея / Первомайский (Республика Адыгея)",
    "country": "Россия",
    "searchString": "первомайский (республика адыгея) россия / республика адыгея / первомайский (республика адыгея)"
  },
  "9600": {
    "id": "9600",
    "name": "Северин",
    "path": "Россия / Краснодарский край / Северин",
    "country": "Россия",
    "searchString": "северин россия / краснодарский край / северин"
  },
  "9601": {
    "id": "9601",
    "name": "Ахметовская",
    "path": "Россия / Краснодарский край / Ахметовская",
    "country": "Россия",
    "searchString": "ахметовская россия / краснодарский край / ахметовская"
  },
  "9602": {
    "id": "9602",
    "name": "Притеречный",
    "path": "Россия / Республика Северная Осетия-Алания / Притеречный",
    "country": "Россия",
    "searchString": "притеречный россия / республика северная осетия-алания / притеречный"
  },
  "9603": {
    "id": "9603",
    "name": "Верхнестепной",
    "path": "Россия / Ставропольский край / Верхнестепной",
    "country": "Россия",
    "searchString": "верхнестепной россия / ставропольский край / верхнестепной"
  },
  "9604": {
    "id": "9604",
    "name": "Мартанская",
    "path": "Россия / Краснодарский край / Мартанская",
    "country": "Россия",
    "searchString": "мартанская россия / краснодарский край / мартанская"
  },
  "9605": {
    "id": "9605",
    "name": "Меклета",
    "path": "Россия / Краснодарский край / Меклета",
    "country": "Россия",
    "searchString": "меклета россия / краснодарский край / меклета"
  },
  "9606": {
    "id": "9606",
    "name": "Новомарьевская",
    "path": "Россия / Ставропольский край / Новомарьевская",
    "country": "Россия",
    "searchString": "новомарьевская россия / ставропольский край / новомарьевская"
  },
  "9607": {
    "id": "9607",
    "name": "Подгорная",
    "path": "Россия / Краснодарский край / Подгорная",
    "country": "Россия",
    "searchString": "подгорная россия / краснодарский край / подгорная"
  },
  "9608": {
    "id": "9608",
    "name": "Зункарь",
    "path": "Россия / Ставропольский край / Зункарь",
    "country": "Россия",
    "searchString": "зункарь россия / ставропольский край / зункарь"
  },
  "9609": {
    "id": "9609",
    "name": "Шабельское",
    "path": "Россия / Краснодарский край / Шабельское",
    "country": "Россия",
    "searchString": "шабельское россия / краснодарский край / шабельское"
  },
  "9610": {
    "id": "9610",
    "name": "Нововладимировская",
    "path": "Россия / Краснодарский край / Нововладимировская",
    "country": "Россия",
    "searchString": "нововладимировская россия / краснодарский край / нововладимировская"
  },
  "9611": {
    "id": "9611",
    "name": "Чернореченская",
    "path": "Россия / Краснодарский край / Чернореченская",
    "country": "Россия",
    "searchString": "чернореченская россия / краснодарский край / чернореченская"
  },
  "9612": {
    "id": "9612",
    "name": "Золотаревка (Ставропольский край)",
    "path": "Россия / Ставропольский край / Золотаревка (Ставропольский край)",
    "country": "Россия",
    "searchString": "золотаревка (ставропольский край) россия / ставропольский край / золотаревка (ставропольский край)"
  },
  "9613": {
    "id": "9613",
    "name": "Бейсужек Второй",
    "path": "Россия / Краснодарский край / Бейсужек Второй",
    "country": "Россия",
    "searchString": "бейсужек второй россия / краснодарский край / бейсужек второй"
  },
  "9614": {
    "id": "9614",
    "name": "Кавказский",
    "path": "Россия / Карачаево-Черкесская Республика / Кавказский",
    "country": "Россия",
    "searchString": "кавказский россия / карачаево-черкесская республика / кавказский"
  },
  "9615": {
    "id": "9615",
    "name": "Гришковское",
    "path": "Россия / Краснодарский край / Гришковское",
    "country": "Россия",
    "searchString": "гришковское россия / краснодарский край / гришковское"
  },
  "9616": {
    "id": "9616",
    "name": "Советский (Тимашевский район)",
    "path": "Россия / Краснодарский край / Советский (Тимашевский район)",
    "country": "Россия",
    "searchString": "советский (тимашевский район) россия / краснодарский край / советский (тимашевский район)"
  },
  "9617": {
    "id": "9617",
    "name": "Владимировка",
    "path": "Россия / Ставропольский край / Владимировка",
    "country": "Россия",
    "searchString": "владимировка россия / ставропольский край / владимировка"
  },
  "9618": {
    "id": "9618",
    "name": "Вин-Сады",
    "path": "Россия / Ставропольский край / Вин-Сады",
    "country": "Россия",
    "searchString": "вин-сады россия / ставропольский край / вин-сады"
  },
  "9619": {
    "id": "9619",
    "name": "Турксад",
    "path": "Россия / Ставропольский край / Турксад",
    "country": "Россия",
    "searchString": "турксад россия / ставропольский край / турксад"
  },
  "9620": {
    "id": "9620",
    "name": "Благовещенская",
    "path": "Россия / Краснодарский край / Благовещенская",
    "country": "Россия",
    "searchString": "благовещенская россия / краснодарский край / благовещенская"
  },
  "9621": {
    "id": "9621",
    "name": "Железный",
    "path": "Россия / Краснодарский край / Железный",
    "country": "Россия",
    "searchString": "железный россия / краснодарский край / железный"
  },
  "9622": {
    "id": "9622",
    "name": "Малокубанский",
    "path": "Россия / Краснодарский край / Малокубанский",
    "country": "Россия",
    "searchString": "малокубанский россия / краснодарский край / малокубанский"
  },
  "9623": {
    "id": "9623",
    "name": "Лоо",
    "path": "Россия / Краснодарский край / Лоо",
    "country": "Россия",
    "searchString": "лоо россия / краснодарский край / лоо"
  },
  "9624": {
    "id": "9624",
    "name": "Протичка",
    "path": "Россия / Краснодарский край / Протичка",
    "country": "Россия",
    "searchString": "протичка россия / краснодарский край / протичка"
  },
  "9625": {
    "id": "9625",
    "name": "Тенгинская",
    "path": "Россия / Краснодарский край / Тенгинская",
    "country": "Россия",
    "searchString": "тенгинская россия / краснодарский край / тенгинская"
  },
  "9626": {
    "id": "9626",
    "name": "Хоперская",
    "path": "Россия / Краснодарский край / Хоперская",
    "country": "Россия",
    "searchString": "хоперская россия / краснодарский край / хоперская"
  },
  "9627": {
    "id": "9627",
    "name": "Безлесный",
    "path": "Россия / Краснодарский край / Безлесный",
    "country": "Россия",
    "searchString": "безлесный россия / краснодарский край / безлесный"
  },
  "9628": {
    "id": "9628",
    "name": "Котляревская",
    "path": "Россия / Кабардино-Балкарская республика / Котляревская",
    "country": "Россия",
    "searchString": "котляревская россия / кабардино-балкарская республика / котляревская"
  },
  "9629": {
    "id": "9629",
    "name": "Федоровская",
    "path": "Россия / Краснодарский край / Федоровская",
    "country": "Россия",
    "searchString": "федоровская россия / краснодарский край / федоровская"
  },
  "9630": {
    "id": "9630",
    "name": "Бузиновская",
    "path": "Россия / Краснодарский край / Бузиновская",
    "country": "Россия",
    "searchString": "бузиновская россия / краснодарский край / бузиновская"
  },
  "9631": {
    "id": "9631",
    "name": "Саблинское",
    "path": "Россия / Ставропольский край / Саблинское",
    "country": "Россия",
    "searchString": "саблинское россия / ставропольский край / саблинское"
  },
  "9632": {
    "id": "9632",
    "name": "Гайкодзор",
    "path": "Россия / Краснодарский край / Гайкодзор",
    "country": "Россия",
    "searchString": "гайкодзор россия / краснодарский край / гайкодзор"
  },
  "9633": {
    "id": "9633",
    "name": "Кучугуры",
    "path": "Россия / Краснодарский край / Кучугуры",
    "country": "Россия",
    "searchString": "кучугуры россия / краснодарский край / кучугуры"
  },
  "9634": {
    "id": "9634",
    "name": "Советское Руно",
    "path": "Россия / Ставропольский край / Советское Руно",
    "country": "Россия",
    "searchString": "советское руно россия / ставропольский край / советское руно"
  },
  "9635": {
    "id": "9635",
    "name": "Домбай",
    "path": "Россия / Карачаево-Черкесская Республика / Домбай",
    "country": "Россия",
    "searchString": "домбай россия / карачаево-черкесская республика / домбай"
  },
  "9636": {
    "id": "9636",
    "name": "Орловка (Кировский район)",
    "path": "Россия / Ставропольский край / Орловка (Кировский район)",
    "country": "Россия",
    "searchString": "орловка (кировский район) россия / ставропольский край / орловка (кировский район)"
  },
  "9637": {
    "id": "9637",
    "name": "Песчаный (Краснодарский край)",
    "path": "Россия / Краснодарский край / Песчаный (Краснодарский край)",
    "country": "Россия",
    "searchString": "песчаный (краснодарский край) россия / краснодарский край / песчаный (краснодарский край)"
  },
  "9638": {
    "id": "9638",
    "name": "Тимирязева",
    "path": "Россия / Республика Адыгея / Тимирязева",
    "country": "Россия",
    "searchString": "тимирязева россия / республика адыгея / тимирязева"
  },
  "9639": {
    "id": "9639",
    "name": "Кубанская степь",
    "path": "Россия / Краснодарский край / Кубанская степь",
    "country": "Россия",
    "searchString": "кубанская степь россия / краснодарский край / кубанская степь"
  },
  "9640": {
    "id": "9640",
    "name": "Степная",
    "path": "Россия / Краснодарский край / Степная",
    "country": "Россия",
    "searchString": "степная россия / краснодарский край / степная"
  },
  "9641": {
    "id": "9641",
    "name": "Шаумянский",
    "path": "Россия / Ставропольский край / Шаумянский",
    "country": "Россия",
    "searchString": "шаумянский россия / ставропольский край / шаумянский"
  },
  "9642": {
    "id": "9642",
    "name": "Новосвободная",
    "path": "Россия / Республика Адыгея / Новосвободная",
    "country": "Россия",
    "searchString": "новосвободная россия / республика адыгея / новосвободная"
  },
  "9643": {
    "id": "9643",
    "name": "Заря (Краснодарский край)",
    "path": "Россия / Краснодарский край / Заря (Краснодарский край)",
    "country": "Россия",
    "searchString": "заря (краснодарский край) россия / краснодарский край / заря (краснодарский край)"
  },
  "9644": {
    "id": "9644",
    "name": "Прогресс (Республика Адыгея)",
    "path": "Россия / Республика Адыгея / Прогресс (Республика Адыгея)",
    "country": "Россия",
    "searchString": "прогресс (республика адыгея) россия / республика адыгея / прогресс (республика адыгея)"
  },
  "9645": {
    "id": "9645",
    "name": "Китаевское",
    "path": "Россия / Ставропольский край / Китаевское",
    "country": "Россия",
    "searchString": "китаевское россия / ставропольский край / китаевское"
  },
  "9646": {
    "id": "9646",
    "name": "Молдаванское",
    "path": "Россия / Краснодарский край / Молдаванское",
    "country": "Россия",
    "searchString": "молдаванское россия / краснодарский край / молдаванское"
  },
  "9647": {
    "id": "9647",
    "name": "Еленовское",
    "path": "Россия / Республика Адыгея / Еленовское",
    "country": "Россия",
    "searchString": "еленовское россия / республика адыгея / еленовское"
  },
  "9648": {
    "id": "9648",
    "name": "Воровсколесская",
    "path": "Россия / Ставропольский край / Воровсколесская",
    "country": "Россия",
    "searchString": "воровсколесская россия / ставропольский край / воровсколесская"
  },
  "9649": {
    "id": "9649",
    "name": "Беноково",
    "path": "Россия / Краснодарский край / Беноково",
    "country": "Россия",
    "searchString": "беноково россия / краснодарский край / беноково"
  },
  "9650": {
    "id": "9650",
    "name": "Балтийский",
    "path": "Россия / Ставропольский край / Балтийский",
    "country": "Россия",
    "searchString": "балтийский россия / ставропольский край / балтийский"
  },
  "9651": {
    "id": "9651",
    "name": "Черный Ерик",
    "path": "Россия / Краснодарский край / Черный Ерик",
    "country": "Россия",
    "searchString": "черный ерик россия / краснодарский край / черный ерик"
  },
  "9652": {
    "id": "9652",
    "name": "Кутаис",
    "path": "Россия / Краснодарский край / Кутаис",
    "country": "Россия",
    "searchString": "кутаис россия / краснодарский край / кутаис"
  },
  "9653": {
    "id": "9653",
    "name": "Новокавказский",
    "path": "Россия / Ставропольский край / Новокавказский",
    "country": "Россия",
    "searchString": "новокавказский россия / ставропольский край / новокавказский"
  },
  "9654": {
    "id": "9654",
    "name": "Ольгино (Ставропольский край)",
    "path": "Россия / Ставропольский край / Ольгино (Ставропольский край)",
    "country": "Россия",
    "searchString": "ольгино (ставропольский край) россия / ставропольский край / ольгино (ставропольский край)"
  },
  "9655": {
    "id": "9655",
    "name": "Новолокинская",
    "path": "Россия / Краснодарский край / Новолокинская",
    "country": "Россия",
    "searchString": "новолокинская россия / краснодарский край / новолокинская"
  },
  "9656": {
    "id": "9656",
    "name": "Большой Бейсуг",
    "path": "Россия / Краснодарский край / Большой Бейсуг",
    "country": "Россия",
    "searchString": "большой бейсуг россия / краснодарский край / большой бейсуг"
  },
  "9657": {
    "id": "9657",
    "name": "Светлогорское",
    "path": "Россия / Краснодарский край / Светлогорское",
    "country": "Россия",
    "searchString": "светлогорское россия / краснодарский край / светлогорское"
  },
  "9658": {
    "id": "9658",
    "name": "Даховская",
    "path": "Россия / Республика Адыгея / Даховская",
    "country": "Россия",
    "searchString": "даховская россия / республика адыгея / даховская"
  },
  "9659": {
    "id": "9659",
    "name": "Красносельское",
    "path": "Россия / Краснодарский край / Красносельское",
    "country": "Россия",
    "searchString": "красносельское россия / краснодарский край / красносельское"
  },
  "9660": {
    "id": "9660",
    "name": "Нижний Чегем",
    "path": "Россия / Кабардино-Балкарская республика / Нижний Чегем",
    "country": "Россия",
    "searchString": "нижний чегем россия / кабардино-балкарская республика / нижний чегем"
  },
  "9661": {
    "id": "9661",
    "name": "Чебургольская",
    "path": "Россия / Краснодарский край / Чебургольская",
    "country": "Россия",
    "searchString": "чебургольская россия / краснодарский край / чебургольская"
  },
  "9662": {
    "id": "9662",
    "name": "Бичевой",
    "path": "Россия / Краснодарский край / Бичевой",
    "country": "Россия",
    "searchString": "бичевой россия / краснодарский край / бичевой"
  },
  "9663": {
    "id": "9663",
    "name": "Темнолесская",
    "path": "Россия / Ставропольский край / Темнолесская",
    "country": "Россия",
    "searchString": "темнолесская россия / ставропольский край / темнолесская"
  },
  "9664": {
    "id": "9664",
    "name": "Еремизино-Борисовская",
    "path": "Россия / Краснодарский край / Еремизино-Борисовская",
    "country": "Россия",
    "searchString": "еремизино-борисовская россия / краснодарский край / еремизино-борисовская"
  },
  "9665": {
    "id": "9665",
    "name": "Приозерское",
    "path": "Россия / Ставропольский край / Приозерское",
    "country": "Россия",
    "searchString": "приозерское россия / ставропольский край / приозерское"
  },
  "9666": {
    "id": "9666",
    "name": "Красноярское",
    "path": "Россия / Ставропольский край / Красноярское",
    "country": "Россия",
    "searchString": "красноярское россия / ставропольский край / красноярское"
  },
  "9667": {
    "id": "9667",
    "name": "Андрее-Дмитриевская",
    "path": "Россия / Краснодарский край / Андрее-Дмитриевская",
    "country": "Россия",
    "searchString": "андрее-дмитриевская россия / краснодарский край / андрее-дмитриевская"
  },
  "9668": {
    "id": "9668",
    "name": "Головинка",
    "path": "Россия / Краснодарский край / Головинка",
    "country": "Россия",
    "searchString": "головинка россия / краснодарский край / головинка"
  },
  "9669": {
    "id": "9669",
    "name": "Беднягина",
    "path": "Россия / Краснодарский край / Беднягина",
    "country": "Россия",
    "searchString": "беднягина россия / краснодарский край / беднягина"
  },
  "9670": {
    "id": "9670",
    "name": "Урупский (Успенский район)",
    "path": "Россия / Краснодарский край / Урупский (Успенский район)",
    "country": "Россия",
    "searchString": "урупский (успенский район) россия / краснодарский край / урупский (успенский район)"
  },
  "9671": {
    "id": "9671",
    "name": "Краснозоринский",
    "path": "Россия / Ставропольский край / Краснозоринский",
    "country": "Россия",
    "searchString": "краснозоринский россия / ставропольский край / краснозоринский"
  },
  "9672": {
    "id": "9672",
    "name": "Кумская Долина",
    "path": "Россия / Ставропольский край / Кумская Долина",
    "country": "Россия",
    "searchString": "кумская долина россия / ставропольский край / кумская долина"
  },
  "9673": {
    "id": "9673",
    "name": "Ванновское",
    "path": "Россия / Краснодарский край / Ванновское",
    "country": "Россия",
    "searchString": "ванновское россия / краснодарский край / ванновское"
  },
  "9674": {
    "id": "9674",
    "name": "Казинка (Андроповский район)",
    "path": "Россия / Ставропольский край / Казинка (Андроповский район)",
    "country": "Россия",
    "searchString": "казинка (андроповский район) россия / ставропольский край / казинка (андроповский район)"
  },
  "9675": {
    "id": "9675",
    "name": "Восточная",
    "path": "Россия / Краснодарский край / Восточная",
    "country": "Россия",
    "searchString": "восточная россия / краснодарский край / восточная"
  },
  "9676": {
    "id": "9676",
    "name": "Уляп",
    "path": "Россия / Республика Адыгея / Уляп",
    "country": "Россия",
    "searchString": "уляп россия / республика адыгея / уляп"
  },
  "9677": {
    "id": "9677",
    "name": "Графский",
    "path": "Россия / Ставропольский край / Графский",
    "country": "Россия",
    "searchString": "графский россия / ставропольский край / графский"
  },
  "9678": {
    "id": "9678",
    "name": "Первомайский (Горячий Ключ)",
    "path": "Россия / Краснодарский край / Первомайский (Горячий Ключ)",
    "country": "Россия",
    "searchString": "первомайский (горячий ключ) россия / краснодарский край / первомайский (горячий ключ)"
  },
  "9679": {
    "id": "9679",
    "name": "Светлый Путь",
    "path": "Россия / Краснодарский край / Светлый Путь",
    "country": "Россия",
    "searchString": "светлый путь россия / краснодарский край / светлый путь"
  },
  "9680": {
    "id": "9680",
    "name": "Воздвиженское (Ставропольский край)",
    "path": "Россия / Ставропольский край / Воздвиженское (Ставропольский край)",
    "country": "Россия",
    "searchString": "воздвиженское (ставропольский край) россия / ставропольский край / воздвиженское (ставропольский край)"
  },
  "9681": {
    "id": "9681",
    "name": "Зимняя Ставка",
    "path": "Россия / Ставропольский край / Зимняя Ставка",
    "country": "Россия",
    "searchString": "зимняя ставка россия / ставропольский край / зимняя ставка"
  },
  "9682": {
    "id": "9682",
    "name": "Тверская",
    "path": "Россия / Краснодарский край / Тверская",
    "country": "Россия",
    "searchString": "тверская россия / краснодарский край / тверская"
  },
  "9683": {
    "id": "9683",
    "name": "Тугулук",
    "path": "Россия / Ставропольский край / Тугулук",
    "country": "Россия",
    "searchString": "тугулук россия / ставропольский край / тугулук"
  },
  "9684": {
    "id": "9684",
    "name": "Марьины Колодцы",
    "path": "Россия / Ставропольский край / Марьины Колодцы",
    "country": "Россия",
    "searchString": "марьины колодцы россия / ставропольский край / марьины колодцы"
  },
  "9685": {
    "id": "9685",
    "name": "Мирный (Ставропольский край)",
    "path": "Россия / Ставропольский край / Мирный (Ставропольский край)",
    "country": "Россия",
    "searchString": "мирный (ставропольский край) россия / ставропольский край / мирный (ставропольский край)"
  },
  "9686": {
    "id": "9686",
    "name": "Аушигер",
    "path": "Россия / Кабардино-Балкарская республика / Аушигер",
    "country": "Россия",
    "searchString": "аушигер россия / кабардино-балкарская республика / аушигер"
  },
  "9687": {
    "id": "9687",
    "name": "Ростовановское",
    "path": "Россия / Ставропольский край / Ростовановское",
    "country": "Россия",
    "searchString": "ростовановское россия / ставропольский край / ростовановское"
  },
  "9688": {
    "id": "9688",
    "name": "Сукко",
    "path": "Россия / Краснодарский край / Сукко",
    "country": "Россия",
    "searchString": "сукко россия / краснодарский край / сукко"
  },
  "9689": {
    "id": "9689",
    "name": "Келермесская",
    "path": "Россия / Республика Адыгея / Келермесская",
    "country": "Россия",
    "searchString": "келермесская россия / республика адыгея / келермесская"
  },
  "9690": {
    "id": "9690",
    "name": "Суворовское",
    "path": "Россия / Краснодарский край / Суворовское",
    "country": "Россия",
    "searchString": "суворовское россия / краснодарский край / суворовское"
  },
  "9691": {
    "id": "9691",
    "name": "Красочный",
    "path": "Россия / Ставропольский край / Красочный",
    "country": "Россия",
    "searchString": "красочный россия / ставропольский край / красочный"
  },
  "9692": {
    "id": "9692",
    "name": "Николенское",
    "path": "Россия / Краснодарский край / Николенское",
    "country": "Россия",
    "searchString": "николенское россия / краснодарский край / николенское"
  },
  "9693": {
    "id": "9693",
    "name": "Прогресс (Краснодарский край)",
    "path": "Россия / Краснодарский край / Прогресс (Краснодарский край)",
    "country": "Россия",
    "searchString": "прогресс (краснодарский край) россия / краснодарский край / прогресс (краснодарский край)"
  },
  "9694": {
    "id": "9694",
    "name": "Большесидоровское",
    "path": "Россия / Республика Адыгея / Большесидоровское",
    "country": "Россия",
    "searchString": "большесидоровское россия / республика адыгея / большесидоровское"
  },
  "9695": {
    "id": "9695",
    "name": "Галицын",
    "path": "Россия / Краснодарский край / Галицын",
    "country": "Россия",
    "searchString": "галицын россия / краснодарский край / галицын"
  },
  "9696": {
    "id": "9696",
    "name": "Просянка",
    "path": "Россия / Ставропольский край / Просянка",
    "country": "Россия",
    "searchString": "просянка россия / ставропольский край / просянка"
  },
  "9697": {
    "id": "9697",
    "name": "Горькая  Балка",
    "path": "Россия / Ставропольский край / Горькая  Балка",
    "country": "Россия",
    "searchString": "горькая  балка россия / ставропольский край / горькая  балка"
  },
  "9698": {
    "id": "9698",
    "name": "Кармалиновская",
    "path": "Россия / Ставропольский край / Кармалиновская",
    "country": "Россия",
    "searchString": "кармалиновская россия / ставропольский край / кармалиновская"
  },
  "9699": {
    "id": "9699",
    "name": "Малые Ягуры",
    "path": "Россия / Ставропольский край / Малые Ягуры",
    "country": "Россия",
    "searchString": "малые ягуры россия / ставропольский край / малые ягуры"
  },
  "9700": {
    "id": "9700",
    "name": "Верхняя Балкария",
    "path": "Россия / Кабардино-Балкарская республика / Верхняя Балкария",
    "country": "Россия",
    "searchString": "верхняя балкария россия / кабардино-балкарская республика / верхняя балкария"
  },
  "9701": {
    "id": "9701",
    "name": "Каменнобродская",
    "path": "Россия / Ставропольский край / Каменнобродская",
    "country": "Россия",
    "searchString": "каменнобродская россия / ставропольский край / каменнобродская"
  },
  "9702": {
    "id": "9702",
    "name": "Запорожская",
    "path": "Россия / Краснодарский край / Запорожская",
    "country": "Россия",
    "searchString": "запорожская россия / краснодарский край / запорожская"
  },
  "9703": {
    "id": "9703",
    "name": "Кенделен",
    "path": "Россия / Кабардино-Балкарская республика / Кенделен",
    "country": "Россия",
    "searchString": "кенделен россия / кабардино-балкарская республика / кенделен"
  },
  "9704": {
    "id": "9704",
    "name": "Горькая Балка",
    "path": "Россия / Краснодарский край / Горькая Балка",
    "country": "Россия",
    "searchString": "горькая балка россия / краснодарский край / горькая балка"
  },
  "9705": {
    "id": "9705",
    "name": "Фонталовская",
    "path": "Россия / Краснодарский край / Фонталовская",
    "country": "Россия",
    "searchString": "фонталовская россия / краснодарский край / фонталовская"
  },
  "9706": {
    "id": "9706",
    "name": "Махошевская",
    "path": "Россия / Краснодарский край / Махошевская",
    "country": "Россия",
    "searchString": "махошевская россия / краснодарский край / махошевская"
  },
  "9707": {
    "id": "9707",
    "name": "Ильич",
    "path": "Россия / Краснодарский край / Ильич",
    "country": "Россия",
    "searchString": "ильич россия / краснодарский край / ильич"
  },
  "9708": {
    "id": "9708",
    "name": "Каладжинская",
    "path": "Россия / Краснодарский край / Каладжинская",
    "country": "Россия",
    "searchString": "каладжинская россия / краснодарский край / каладжинская"
  },
  "9709": {
    "id": "9709",
    "name": "Бурукшун",
    "path": "Россия / Ставропольский край / Бурукшун",
    "country": "Россия",
    "searchString": "бурукшун россия / ставропольский край / бурукшун"
  },
  "9710": {
    "id": "9710",
    "name": "Прикумское",
    "path": "Россия / Ставропольский край / Прикумское",
    "country": "Россия",
    "searchString": "прикумское россия / ставропольский край / прикумское"
  },
  "9711": {
    "id": "9711",
    "name": "Подлесное",
    "path": "Россия / Ставропольский край / Подлесное",
    "country": "Россия",
    "searchString": "подлесное россия / ставропольский край / подлесное"
  },
  "9712": {
    "id": "9712",
    "name": "Образцовый",
    "path": "Россия / Краснодарский край / Образцовый",
    "country": "Россия",
    "searchString": "образцовый россия / краснодарский край / образцовый"
  },
  "9713": {
    "id": "9713",
    "name": "Николо-Александровское",
    "path": "Россия / Ставропольский край / Николо-Александровское",
    "country": "Россия",
    "searchString": "николо-александровское россия / ставропольский край / николо-александровское"
  },
  "9714": {
    "id": "9714",
    "name": "Прималкинское",
    "path": "Россия / Кабардино-Балкарская республика / Прималкинское",
    "country": "Россия",
    "searchString": "прималкинское россия / кабардино-балкарская республика / прималкинское"
  },
  "9715": {
    "id": "9715",
    "name": "Чепигинская",
    "path": "Россия / Краснодарский край / Чепигинская",
    "country": "Россия",
    "searchString": "чепигинская россия / краснодарский край / чепигинская"
  },
  "9716": {
    "id": "9716",
    "name": "Урупский (Отрадненский район)",
    "path": "Россия / Краснодарский край / Урупский (Отрадненский район)",
    "country": "Россия",
    "searchString": "урупский (отрадненский район) россия / краснодарский край / урупский (отрадненский район)"
  },
  "9717": {
    "id": "9717",
    "name": "Ново-Березанский",
    "path": "Россия / Краснодарский край / Ново-Березанский",
    "country": "Россия",
    "searchString": "ново-березанский россия / краснодарский край / ново-березанский"
  },
  "9718": {
    "id": "9718",
    "name": "Бойкопонура",
    "path": "Россия / Краснодарский край / Бойкопонура",
    "country": "Россия",
    "searchString": "бойкопонура россия / краснодарский край / бойкопонура"
  },
  "9719": {
    "id": "9719",
    "name": "Тахта (Ставропольский край)",
    "path": "Россия / Ставропольский край / Тахта (Ставропольский край)",
    "country": "Россия",
    "searchString": "тахта (ставропольский край) россия / ставропольский край / тахта (ставропольский край)"
  },
  "9720": {
    "id": "9720",
    "name": "Первомайский (Кущевский район)",
    "path": "Россия / Краснодарский край / Первомайский (Кущевский район)",
    "country": "Россия",
    "searchString": "первомайский (кущевский район) россия / краснодарский край / первомайский (кущевский район)"
  },
  "9721": {
    "id": "9721",
    "name": "Благодарное",
    "path": "Россия / Краснодарский край / Благодарное",
    "country": "Россия",
    "searchString": "благодарное россия / краснодарский край / благодарное"
  },
  "9722": {
    "id": "9722",
    "name": "Сладкий",
    "path": "Россия / Краснодарский край / Сладкий",
    "country": "Россия",
    "searchString": "сладкий россия / краснодарский край / сладкий"
  },
  "9723": {
    "id": "9723",
    "name": "Куликовский",
    "path": "Россия / Краснодарский край / Куликовский",
    "country": "Россия",
    "searchString": "куликовский россия / краснодарский край / куликовский"
  },
  "9724": {
    "id": "9724",
    "name": "Новопашковская",
    "path": "Россия / Краснодарский край / Новопашковская",
    "country": "Россия",
    "searchString": "новопашковская россия / краснодарский край / новопашковская"
  },
  "10101": {
    "id": "10101",
    "name": "Хохол-Тростянка",
    "path": "Россия / Воронежская область / Хохол-Тростянка",
    "country": "Россия",
    "searchString": "хохол-тростянка россия / воронежская область / хохол-тростянка"
  },
  "10102": {
    "id": "10102",
    "name": "Староивановка",
    "path": "Россия / Белгородская область / Староивановка",
    "country": "Россия",
    "searchString": "староивановка россия / белгородская область / староивановка"
  },
  "10103": {
    "id": "10103",
    "name": "Краснофлотское",
    "path": "Россия / Воронежская область / Краснофлотское",
    "country": "Россия",
    "searchString": "краснофлотское россия / воронежская область / краснофлотское"
  },
  "10104": {
    "id": "10104",
    "name": "Березичский Стеклозавод",
    "path": "Россия / Калужская область / Березичский Стеклозавод",
    "country": "Россия",
    "searchString": "березичский стеклозавод россия / калужская область / березичский стеклозавод"
  },
  "10105": {
    "id": "10105",
    "name": "Новоуколово",
    "path": "Россия / Белгородская область / Новоуколово",
    "country": "Россия",
    "searchString": "новоуколово россия / белгородская область / новоуколово"
  },
  "10106": {
    "id": "10106",
    "name": "Воронец",
    "path": "Россия / Липецкая область / Воронец",
    "country": "Россия",
    "searchString": "воронец россия / липецкая область / воронец"
  },
  "10107": {
    "id": "10107",
    "name": "Дроздово",
    "path": "Россия / Воронежская область / Дроздово",
    "country": "Россия",
    "searchString": "дроздово россия / воронежская область / дроздово"
  },
  "10108": {
    "id": "10108",
    "name": "Коршево",
    "path": "Россия / Воронежская область / Коршево",
    "country": "Россия",
    "searchString": "коршево россия / воронежская область / коршево"
  },
  "10109": {
    "id": "10109",
    "name": "Новенькое",
    "path": "Россия / Белгородская область / Новенькое",
    "country": "Россия",
    "searchString": "новенькое россия / белгородская область / новенькое"
  },
  "10110": {
    "id": "10110",
    "name": "Краснолесный",
    "path": "Россия / Воронежская область / Краснолесный",
    "country": "Россия",
    "searchString": "краснолесный россия / воронежская область / краснолесный"
  },
  "10111": {
    "id": "10111",
    "name": "Орлик (Белгородская область)",
    "path": "Россия / Белгородская область / Орлик (Белгородская область)",
    "country": "Россия",
    "searchString": "орлик (белгородская область) россия / белгородская область / орлик (белгородская область)"
  },
  "10112": {
    "id": "10112",
    "name": "Радьковка",
    "path": "Россия / Белгородская область / Радьковка",
    "country": "Россия",
    "searchString": "радьковка россия / белгородская область / радьковка"
  },
  "10113": {
    "id": "10113",
    "name": "Вислая Поляна",
    "path": "Россия / Липецкая область / Вислая Поляна",
    "country": "Россия",
    "searchString": "вислая поляна россия / липецкая область / вислая поляна"
  },
  "10114": {
    "id": "10114",
    "name": "Морозовка",
    "path": "Россия / Воронежская область / Морозовка",
    "country": "Россия",
    "searchString": "морозовка россия / воронежская область / морозовка"
  },
  "10115": {
    "id": "10115",
    "name": "1-я Семеновка",
    "path": "Россия / Курская область / 1-я Семеновка",
    "country": "Россия",
    "searchString": "1-я семеновка россия / курская область / 1-я семеновка"
  },
  "10116": {
    "id": "10116",
    "name": "1-я Михайловка",
    "path": "Россия / Воронежская область / 1-я Михайловка",
    "country": "Россия",
    "searchString": "1-я михайловка россия / воронежская область / 1-я михайловка"
  },
  "10117": {
    "id": "10117",
    "name": "Березово (Воронежская область)",
    "path": "Россия / Воронежская область / Березово (Воронежская область)",
    "country": "Россия",
    "searchString": "березово (воронежская область) россия / воронежская область / березово (воронежская область)"
  },
  "10118": {
    "id": "10118",
    "name": "Великоархангельское",
    "path": "Россия / Воронежская область / Великоархангельское",
    "country": "Россия",
    "searchString": "великоархангельское россия / воронежская область / великоархангельское"
  },
  "10119": {
    "id": "10119",
    "name": "Коротояк",
    "path": "Россия / Воронежская область / Коротояк",
    "country": "Россия",
    "searchString": "коротояк россия / воронежская область / коротояк"
  },
  "10120": {
    "id": "10120",
    "name": "Кощеево",
    "path": "Россия / Белгородская область / Кощеево",
    "country": "Россия",
    "searchString": "кощеево россия / белгородская область / кощеево"
  },
  "10121": {
    "id": "10121",
    "name": "Верхняя Маза",
    "path": "Россия / Воронежская область / Верхняя Маза",
    "country": "Россия",
    "searchString": "верхняя маза россия / воронежская область / верхняя маза"
  },
  "10122": {
    "id": "10122",
    "name": "Нижняя Ведуга",
    "path": "Россия / Воронежская область / Нижняя Ведуга",
    "country": "Россия",
    "searchString": "нижняя ведуга россия / воронежская область / нижняя ведуга"
  },
  "10123": {
    "id": "10123",
    "name": "Новотроицкий",
    "path": "Россия / Воронежская область / Новотроицкий",
    "country": "Россия",
    "searchString": "новотроицкий россия / воронежская область / новотроицкий"
  },
  "10124": {
    "id": "10124",
    "name": "Шапкино",
    "path": "Россия / Тамбовская область / Шапкино",
    "country": "Россия",
    "searchString": "шапкино россия / тамбовская область / шапкино"
  },
  "10125": {
    "id": "10125",
    "name": "Верхняя Матренка",
    "path": "Россия / Липецкая область / Верхняя Матренка",
    "country": "Россия",
    "searchString": "верхняя матренка россия / липецкая область / верхняя матренка"
  },
  "10126": {
    "id": "10126",
    "name": "Пятницкое",
    "path": "Россия / Белгородская область / Пятницкое",
    "country": "Россия",
    "searchString": "пятницкое россия / белгородская область / пятницкое"
  },
  "10127": {
    "id": "10127",
    "name": "Свобода",
    "path": "Россия / Курская область / Свобода",
    "country": "Россия",
    "searchString": "свобода россия / курская область / свобода"
  },
  "10128": {
    "id": "10128",
    "name": "Партизан",
    "path": "Россия / Тульская область / Партизан",
    "country": "Россия",
    "searchString": "партизан россия / тульская область / партизан"
  },
  "10129": {
    "id": "10129",
    "name": "Студенок",
    "path": "Россия / Курская область / Студенок",
    "country": "Россия",
    "searchString": "студенок россия / курская область / студенок"
  },
  "10130": {
    "id": "10130",
    "name": "Малая Локня",
    "path": "Россия / Курская область / Малая Локня",
    "country": "Россия",
    "searchString": "малая локня россия / курская область / малая локня"
  },
  "10131": {
    "id": "10131",
    "name": "Кривоносово",
    "path": "Россия / Воронежская область / Кривоносово",
    "country": "Россия",
    "searchString": "кривоносово россия / воронежская область / кривоносово"
  },
  "10132": {
    "id": "10132",
    "name": "Озерки (Тамбовская область)",
    "path": "Россия / Тамбовская область / Озерки (Тамбовская область)",
    "country": "Россия",
    "searchString": "озерки (тамбовская область) россия / тамбовская область / озерки (тамбовская область)"
  },
  "10133": {
    "id": "10133",
    "name": "Мощеное",
    "path": "Россия / Белгородская область / Мощеное",
    "country": "Россия",
    "searchString": "мощеное россия / белгородская область / мощеное"
  },
  "10134": {
    "id": "10134",
    "name": "Лофицкое",
    "path": "Россия / Воронежская область / Лофицкое",
    "country": "Россия",
    "searchString": "лофицкое россия / воронежская область / лофицкое"
  },
  "10135": {
    "id": "10135",
    "name": "Первомайское (Воронежская область)",
    "path": "Россия / Воронежская область / Первомайское (Воронежская область)",
    "country": "Россия",
    "searchString": "первомайское (воронежская область) россия / воронежская область / первомайское (воронежская область)"
  },
  "10136": {
    "id": "10136",
    "name": "Волчья Александровка",
    "path": "Россия / Белгородская область / Волчья Александровка",
    "country": "Россия",
    "searchString": "волчья александровка россия / белгородская область / волчья александровка"
  },
  "10137": {
    "id": "10137",
    "name": "Новомарковка",
    "path": "Россия / Воронежская область / Новомарковка",
    "country": "Россия",
    "searchString": "новомарковка россия / воронежская область / новомарковка"
  },
  "10138": {
    "id": "10138",
    "name": "Студеное (Воронежская область)",
    "path": "Россия / Воронежская область / Студеное (Воронежская область)",
    "country": "Россия",
    "searchString": "студеное (воронежская область) россия / воронежская область / студеное (воронежская область)"
  },
  "10139": {
    "id": "10139",
    "name": "Матрено-Гезово",
    "path": "Россия / Белгородская область / Матрено-Гезово",
    "country": "Россия",
    "searchString": "матрено-гезово россия / белгородская область / матрено-гезово"
  },
  "10140": {
    "id": "10140",
    "name": "Мосоловка",
    "path": "Россия / Воронежская область / Мосоловка",
    "country": "Россия",
    "searchString": "мосоловка россия / воронежская область / мосоловка"
  },
  "10141": {
    "id": "10141",
    "name": "Красный Куст",
    "path": "Россия / Тамбовская область / Красный Куст",
    "country": "Россия",
    "searchString": "красный куст россия / тамбовская область / красный куст"
  },
  "10142": {
    "id": "10142",
    "name": "Дорогощь",
    "path": "Россия / Белгородская область / Дорогощь",
    "country": "Россия",
    "searchString": "дорогощь россия / белгородская область / дорогощь"
  },
  "10143": {
    "id": "10143",
    "name": "Ломово",
    "path": "Россия / Белгородская область / Ломово",
    "country": "Россия",
    "searchString": "ломово россия / белгородская область / ломово"
  },
  "10144": {
    "id": "10144",
    "name": "Дмитряшевка",
    "path": "Россия / Липецкая область / Дмитряшевка",
    "country": "Россия",
    "searchString": "дмитряшевка россия / липецкая область / дмитряшевка"
  },
  "10145": {
    "id": "10145",
    "name": "Луговое (Воронежская область)",
    "path": "Россия / Воронежская область / Луговое (Воронежская область)",
    "country": "Россия",
    "searchString": "луговое (воронежская область) россия / воронежская область / луговое (воронежская область)"
  },
  "10146": {
    "id": "10146",
    "name": "Илек Кошары",
    "path": "Россия / Белгородская область / Илек Кошары",
    "country": "Россия",
    "searchString": "илек кошары россия / белгородская область / илек кошары"
  },
  "10147": {
    "id": "10147",
    "name": "Березовка (Липецкая область)",
    "path": "Россия / Липецкая область / Березовка (Липецкая область)",
    "country": "Россия",
    "searchString": "березовка (липецкая область) россия / липецкая область / березовка (липецкая область)"
  },
  "10148": {
    "id": "10148",
    "name": "Береговое-Второе",
    "path": "Россия / Белгородская область / Береговое-Второе",
    "country": "Россия",
    "searchString": "береговое-второе россия / белгородская область / береговое-второе"
  },
  "10149": {
    "id": "10149",
    "name": "Подсереднее",
    "path": "Россия / Белгородская область / Подсереднее",
    "country": "Россия",
    "searchString": "подсереднее россия / белгородская область / подсереднее"
  },
  "10150": {
    "id": "10150",
    "name": "Новая Безгинка",
    "path": "Россия / Белгородская область / Новая Безгинка",
    "country": "Россия",
    "searchString": "новая безгинка россия / белгородская область / новая безгинка"
  },
  "10151": {
    "id": "10151",
    "name": "Нижняя Байгора",
    "path": "Россия / Воронежская область / Нижняя Байгора",
    "country": "Россия",
    "searchString": "нижняя байгора россия / воронежская область / нижняя байгора"
  },
  "10152": {
    "id": "10152",
    "name": "Газопровод",
    "path": "Россия / Липецкая область / Газопровод",
    "country": "Россия",
    "searchString": "газопровод россия / липецкая область / газопровод"
  },
  "10153": {
    "id": "10153",
    "name": "Лапыгино",
    "path": "Россия / Белгородская область / Лапыгино",
    "country": "Россия",
    "searchString": "лапыгино россия / белгородская область / лапыгино"
  },
  "10154": {
    "id": "10154",
    "name": "Залужное",
    "path": "Россия / Воронежская область / Залужное",
    "country": "Россия",
    "searchString": "залужное россия / воронежская область / залужное"
  },
  "10155": {
    "id": "10155",
    "name": "Краснолипие",
    "path": "Россия / Воронежская область / Краснолипие",
    "country": "Россия",
    "searchString": "краснолипие россия / воронежская область / краснолипие"
  },
  "10156": {
    "id": "10156",
    "name": "Навесное",
    "path": "Россия / Орловская область / Навесное",
    "country": "Россия",
    "searchString": "навесное россия / орловская область / навесное"
  },
  "10157": {
    "id": "10157",
    "name": "Селекционный",
    "path": "Россия / Курская область / Селекционный",
    "country": "Россия",
    "searchString": "селекционный россия / курская область / селекционный"
  },
  "10158": {
    "id": "10158",
    "name": "Елизаветино (Воронежская область)",
    "path": "Россия / Воронежская область / Елизаветино (Воронежская область)",
    "country": "Россия",
    "searchString": "елизаветино (воронежская область) россия / воронежская область / елизаветино (воронежская область)"
  },
  "10159": {
    "id": "10159",
    "name": "Малотроицкое",
    "path": "Россия / Белгородская область / Малотроицкое",
    "country": "Россия",
    "searchString": "малотроицкое россия / белгородская область / малотроицкое"
  },
  "10160": {
    "id": "10160",
    "name": "Марки",
    "path": "Россия / Воронежская область / Марки",
    "country": "Россия",
    "searchString": "марки россия / воронежская область / марки"
  },
  "10161": {
    "id": "10161",
    "name": "Чакино-1",
    "path": "Россия / Тамбовская область / Чакино-1",
    "country": "Россия",
    "searchString": "чакино-1 россия / тамбовская область / чакино-1"
  },
  "10162": {
    "id": "10162",
    "name": "Великомихайловка",
    "path": "Россия / Белгородская область / Великомихайловка",
    "country": "Россия",
    "searchString": "великомихайловка россия / белгородская область / великомихайловка"
  },
  "10163": {
    "id": "10163",
    "name": "Октябрьский (Воронежская область)",
    "path": "Россия / Воронежская область / Октябрьский (Воронежская область)",
    "country": "Россия",
    "searchString": "октябрьский (воронежская область) россия / воронежская область / октябрьский (воронежская область)"
  },
  "10164": {
    "id": "10164",
    "name": "Новоюрьево",
    "path": "Россия / Тамбовская область / Новоюрьево",
    "country": "Россия",
    "searchString": "новоюрьево россия / тамбовская область / новоюрьево"
  },
  "10165": {
    "id": "10165",
    "name": "Кузьмина-Гать",
    "path": "Россия / Тамбовская область / Кузьмина-Гать",
    "country": "Россия",
    "searchString": "кузьмина-гать россия / тамбовская область / кузьмина-гать"
  },
  "10166": {
    "id": "10166",
    "name": "Екатеринино",
    "path": "Россия / Тамбовская область / Екатеринино",
    "country": "Россия",
    "searchString": "екатеринино россия / тамбовская область / екатеринино"
  },
  "10167": {
    "id": "10167",
    "name": "Гороховка",
    "path": "Россия / Воронежская область / Гороховка",
    "country": "Россия",
    "searchString": "гороховка россия / воронежская область / гороховка"
  },
  "10168": {
    "id": "10168",
    "name": "Ростоши",
    "path": "Россия / Воронежская область / Ростоши",
    "country": "Россия",
    "searchString": "ростоши россия / воронежская область / ростоши"
  },
  "10169": {
    "id": "10169",
    "name": "Никаноровка",
    "path": "Россия / Белгородская область / Никаноровка",
    "country": "Россия",
    "searchString": "никаноровка россия / белгородская область / никаноровка"
  },
  "10170": {
    "id": "10170",
    "name": "Веретье",
    "path": "Россия / Воронежская область / Веретье",
    "country": "Россия",
    "searchString": "веретье россия / воронежская область / веретье"
  },
  "10171": {
    "id": "10171",
    "name": "Ближняя Полубянка",
    "path": "Россия / Воронежская область / Ближняя Полубянка",
    "country": "Россия",
    "searchString": "ближняя полубянка россия / воронежская область / ближняя полубянка"
  },
  "10172": {
    "id": "10172",
    "name": "Тельчье",
    "path": "Россия / Орловская область / Тельчье",
    "country": "Россия",
    "searchString": "тельчье россия / орловская область / тельчье"
  },
  "10173": {
    "id": "10173",
    "name": "Горелое",
    "path": "Россия / Тамбовская область / Горелое",
    "country": "Россия",
    "searchString": "горелое россия / тамбовская область / горелое"
  },
  "10174": {
    "id": "10174",
    "name": "Казинка (Белгородская область)",
    "path": "Россия / Белгородская область / Казинка (Белгородская область)",
    "country": "Россия",
    "searchString": "казинка (белгородская область) россия / белгородская область / казинка (белгородская область)"
  },
  "10175": {
    "id": "10175",
    "name": "Рогачевка",
    "path": "Россия / Воронежская область / Рогачевка",
    "country": "Россия",
    "searchString": "рогачевка россия / воронежская область / рогачевка"
  },
  "10176": {
    "id": "10176",
    "name": "Ратчино",
    "path": "Россия / Липецкая область / Ратчино",
    "country": "Россия",
    "searchString": "ратчино россия / липецкая область / ратчино"
  },
  "10177": {
    "id": "10177",
    "name": "Карпенково",
    "path": "Россия / Воронежская область / Карпенково",
    "country": "Россия",
    "searchString": "карпенково россия / воронежская область / карпенково"
  },
  "10178": {
    "id": "10178",
    "name": "Столовое",
    "path": "Россия / Тамбовская область / Столовое",
    "country": "Россия",
    "searchString": "столовое россия / тамбовская область / столовое"
  },
  "10179": {
    "id": "10179",
    "name": "Ржевка",
    "path": "Россия / Белгородская область / Ржевка",
    "country": "Россия",
    "searchString": "ржевка россия / белгородская область / ржевка"
  },
  "10180": {
    "id": "10180",
    "name": "Солдатское",
    "path": "Россия / Белгородская область / Солдатское",
    "country": "Россия",
    "searchString": "солдатское россия / белгородская область / солдатское"
  },
  "10181": {
    "id": "10181",
    "name": "Хлебородное",
    "path": "Россия / Воронежская область / Хлебородное",
    "country": "Россия",
    "searchString": "хлебородное россия / воронежская область / хлебородное"
  },
  "10182": {
    "id": "10182",
    "name": "Вторые Тербуны",
    "path": "Россия / Липецкая область / Вторые Тербуны",
    "country": "Россия",
    "searchString": "вторые тербуны россия / липецкая область / вторые тербуны"
  },
  "10183": {
    "id": "10183",
    "name": "Платоновка",
    "path": "Россия / Тамбовская область / Платоновка",
    "country": "Россия",
    "searchString": "платоновка россия / тамбовская область / платоновка"
  },
  "10184": {
    "id": "10184",
    "name": "Покровка (Воронежская область)",
    "path": "Россия / Воронежская область / Покровка (Воронежская область)",
    "country": "Россия",
    "searchString": "покровка (воронежская область) россия / воронежская область / покровка (воронежская область)"
  },
  "10185": {
    "id": "10185",
    "name": "Краснослободский",
    "path": "Россия / Тамбовская область / Краснослободский",
    "country": "Россия",
    "searchString": "краснослободский россия / тамбовская область / краснослободский"
  },
  "10186": {
    "id": "10186",
    "name": "Большое Городище",
    "path": "Россия / Белгородская область / Большое Городище",
    "country": "Россия",
    "searchString": "большое городище россия / белгородская область / большое городище"
  },
  "10187": {
    "id": "10187",
    "name": "Большие Липяги",
    "path": "Россия / Белгородская область / Большие Липяги",
    "country": "Россия",
    "searchString": "большие липяги россия / белгородская область / большие липяги"
  },
  "10188": {
    "id": "10188",
    "name": "Гостищево",
    "path": "Россия / Белгородская область / Гостищево",
    "country": "Россия",
    "searchString": "гостищево россия / белгородская область / гостищево"
  },
  "10189": {
    "id": "10189",
    "name": "Тойда 1-я",
    "path": "Россия / Воронежская область / Тойда 1-я",
    "country": "Россия",
    "searchString": "тойда 1-я россия / воронежская область / тойда 1-я"
  },
  "10190": {
    "id": "10190",
    "name": "Ракша",
    "path": "Россия / Тамбовская область / Ракша",
    "country": "Россия",
    "searchString": "ракша россия / тамбовская область / ракша"
  },
  "10191": {
    "id": "10191",
    "name": "Семидесятное",
    "path": "Россия / Воронежская область / Семидесятное",
    "country": "Россия",
    "searchString": "семидесятное россия / воронежская область / семидесятное"
  },
  "10192": {
    "id": "10192",
    "name": "Новый Лиман",
    "path": "Россия / Воронежская область / Новый Лиман",
    "country": "Россия",
    "searchString": "новый лиман россия / воронежская область / новый лиман"
  },
  "10193": {
    "id": "10193",
    "name": "Камызино",
    "path": "Россия / Белгородская область / Камызино",
    "country": "Россия",
    "searchString": "камызино россия / белгородская область / камызино"
  },
  "10194": {
    "id": "10194",
    "name": "Шелаево",
    "path": "Россия / Белгородская область / Шелаево",
    "country": "Россия",
    "searchString": "шелаево россия / белгородская область / шелаево"
  },
  "10195": {
    "id": "10195",
    "name": "Архангельское (Белгородская область)",
    "path": "Россия / Белгородская область / Архангельское (Белгородская область)",
    "country": "Россия",
    "searchString": "архангельское (белгородская область) россия / белгородская область / архангельское (белгородская область)"
  },
  "10196": {
    "id": "10196",
    "name": "Калачеевский",
    "path": "Россия / Воронежская область / Калачеевский",
    "country": "Россия",
    "searchString": "калачеевский россия / воронежская область / калачеевский"
  },
  "10197": {
    "id": "10197",
    "name": "Золотуха (Липецкая область)",
    "path": "Россия / Липецкая область / Золотуха (Липецкая область)",
    "country": "Россия",
    "searchString": "золотуха (липецкая область) россия / липецкая область / золотуха (липецкая область)"
  },
  "10198": {
    "id": "10198",
    "name": "Завальное",
    "path": "Россия / Липецкая область / Завальное",
    "country": "Россия",
    "searchString": "завальное россия / липецкая область / завальное"
  },
  "10199": {
    "id": "10199",
    "name": "Перелешино",
    "path": "Россия / Воронежская область / Перелешино",
    "country": "Россия",
    "searchString": "перелешино россия / воронежская область / перелешино"
  },
  "10200": {
    "id": "10200",
    "name": "Боево",
    "path": "Россия / Воронежская область / Боево",
    "country": "Россия",
    "searchString": "боево россия / воронежская область / боево"
  },
  "10201": {
    "id": "10201",
    "name": "Студенки",
    "path": "Россия / Липецкая область / Студенки",
    "country": "Россия",
    "searchString": "студенки россия / липецкая область / студенки"
  },
  "10202": {
    "id": "10202",
    "name": "Данково",
    "path": "Россия / Воронежская область / Данково",
    "country": "Россия",
    "searchString": "данково россия / воронежская область / данково"
  },
  "10203": {
    "id": "10203",
    "name": "Сагуны (Подгоренский район, Сагуновское поселение)",
    "path": "Россия / Воронежская область / Сагуны (Подгоренский район, Сагуновское поселение)",
    "country": "Россия",
    "searchString": "сагуны (подгоренский район, сагуновское поселение) россия / воронежская область / сагуны (подгоренский район, сагуновское поселение)"
  },
  "10204": {
    "id": "10204",
    "name": "Сторожевое",
    "path": "Россия / Воронежская область / Сторожевое",
    "country": "Россия",
    "searchString": "сторожевое россия / воронежская область / сторожевое"
  },
  "10205": {
    "id": "10205",
    "name": "Старая Криуша",
    "path": "Россия / Воронежская область / Старая Криуша",
    "country": "Россия",
    "searchString": "старая криуша россия / воронежская область / старая криуша"
  },
  "10206": {
    "id": "10206",
    "name": "Криничное",
    "path": "Россия / Воронежская область / Криничное",
    "country": "Россия",
    "searchString": "криничное россия / воронежская область / криничное"
  },
  "10207": {
    "id": "10207",
    "name": "Частая Дубрава",
    "path": "Россия / Липецкая область / Частая Дубрава",
    "country": "Россия",
    "searchString": "частая дубрава россия / липецкая область / частая дубрава"
  },
  "10208": {
    "id": "10208",
    "name": "Елань-Коленовский",
    "path": "Россия / Воронежская область / Елань-Коленовский",
    "country": "Россия",
    "searchString": "елань-коленовский россия / воронежская область / елань-коленовский"
  },
  "10209": {
    "id": "10209",
    "name": "Владимировка (Воронежская область)",
    "path": "Россия / Воронежская область / Владимировка (Воронежская область)",
    "country": "Россия",
    "searchString": "владимировка (воронежская область) россия / воронежская область / владимировка (воронежская область)"
  },
  "10210": {
    "id": "10210",
    "name": "Красноселовка",
    "path": "Россия / Воронежская область / Красноселовка",
    "country": "Россия",
    "searchString": "красноселовка россия / воронежская область / красноселовка"
  },
  "10211": {
    "id": "10211",
    "name": "Яковлево",
    "path": "Россия / Белгородская область / Яковлево",
    "country": "Россия",
    "searchString": "яковлево россия / белгородская область / яковлево"
  },
  "10212": {
    "id": "10212",
    "name": "Усть-Муравлянка",
    "path": "Россия / Воронежская область / Усть-Муравлянка",
    "country": "Россия",
    "searchString": "усть-муравлянка россия / воронежская область / усть-муравлянка"
  },
  "10213": {
    "id": "10213",
    "name": "Грузское",
    "path": "Россия / Белгородская область / Грузское",
    "country": "Россия",
    "searchString": "грузское россия / белгородская область / грузское"
  },
  "10214": {
    "id": "10214",
    "name": "Старая Тойда",
    "path": "Россия / Воронежская область / Старая Тойда",
    "country": "Россия",
    "searchString": "старая тойда россия / воронежская область / старая тойда"
  },
  "10215": {
    "id": "10215",
    "name": "Верхопенье",
    "path": "Россия / Белгородская область / Верхопенье",
    "country": "Россия",
    "searchString": "верхопенье россия / белгородская область / верхопенье"
  },
  "10216": {
    "id": "10216",
    "name": "Нижнеспасское",
    "path": "Россия / Тамбовская область / Нижнеспасское",
    "country": "Россия",
    "searchString": "нижнеспасское россия / тамбовская область / нижнеспасское"
  },
  "10217": {
    "id": "10217",
    "name": "Верхняя Ярославка",
    "path": "Россия / Тамбовская область / Верхняя Ярославка",
    "country": "Россия",
    "searchString": "верхняя ярославка россия / тамбовская область / верхняя ярославка"
  },
  "10218": {
    "id": "10218",
    "name": "Новая Деревня (Липецкая область)",
    "path": "Россия / Липецкая область / Новая Деревня (Липецкая область)",
    "country": "Россия",
    "searchString": "новая деревня (липецкая область) россия / липецкая область / новая деревня (липецкая область)"
  },
  "10219": {
    "id": "10219",
    "name": "Льва Толстого",
    "path": "Россия / Калужская область / Льва Толстого",
    "country": "Россия",
    "searchString": "льва толстого россия / калужская область / льва толстого"
  },
  "10220": {
    "id": "10220",
    "name": "Масловка",
    "path": "Россия / Белгородская область / Масловка",
    "country": "Россия",
    "searchString": "масловка россия / белгородская область / масловка"
  },
  "10221": {
    "id": "10221",
    "name": "Солонцы",
    "path": "Россия / Воронежская область / Солонцы",
    "country": "Россия",
    "searchString": "солонцы россия / воронежская область / солонцы"
  },
  "10222": {
    "id": "10222",
    "name": "Агроном (Липецкая область)",
    "path": "Россия / Липецкая область / Агроном (Липецкая область)",
    "country": "Россия",
    "searchString": "агроном (липецкая область) россия / липецкая область / агроном (липецкая область)"
  },
  "10223": {
    "id": "10223",
    "name": "Пановы Кусты",
    "path": "Россия / Тамбовская область / Пановы Кусты",
    "country": "Россия",
    "searchString": "пановы кусты россия / тамбовская область / пановы кусты"
  },
  "10224": {
    "id": "10224",
    "name": "Дьяченково",
    "path": "Россия / Воронежская область / Дьяченково",
    "country": "Россия",
    "searchString": "дьяченково россия / воронежская область / дьяченково"
  },
  "10225": {
    "id": "10225",
    "name": "Пчелиновка",
    "path": "Россия / Воронежская область / Пчелиновка",
    "country": "Россия",
    "searchString": "пчелиновка россия / воронежская область / пчелиновка"
  },
  "10226": {
    "id": "10226",
    "name": "Сторожевские Хутора",
    "path": "Россия / Липецкая область / Сторожевские Хутора",
    "country": "Россия",
    "searchString": "сторожевские хутора россия / липецкая область / сторожевские хутора"
  },
  "10227": {
    "id": "10227",
    "name": "Стрелец",
    "path": "Россия / Липецкая область / Стрелец",
    "country": "Россия",
    "searchString": "стрелец россия / липецкая область / стрелец"
  },
  "10228": {
    "id": "10228",
    "name": "Казаки",
    "path": "Россия / Липецкая область / Казаки",
    "country": "Россия",
    "searchString": "казаки россия / липецкая область / казаки"
  },
  "10229": {
    "id": "10229",
    "name": "Нижний Шибряй",
    "path": "Россия / Тамбовская область / Нижний Шибряй",
    "country": "Россия",
    "searchString": "нижний шибряй россия / тамбовская область / нижний шибряй"
  },
  "10230": {
    "id": "10230",
    "name": "Ивановское (Курская область)",
    "path": "Россия / Курская область / Ивановское (Курская область)",
    "country": "Россия",
    "searchString": "ивановское (курская область) россия / курская область / ивановское (курская область)"
  },
  "10231": {
    "id": "10231",
    "name": "Опыт",
    "path": "Россия / Воронежская область / Опыт",
    "country": "Россия",
    "searchString": "опыт россия / воронежская область / опыт"
  },
  "10232": {
    "id": "10232",
    "name": "Хоботово",
    "path": "Россия / Тамбовская область / Хоботово",
    "country": "Россия",
    "searchString": "хоботово россия / тамбовская область / хоботово"
  },
  "10233": {
    "id": "10233",
    "name": "Есипово",
    "path": "Россия / Воронежская область / Есипово",
    "country": "Россия",
    "searchString": "есипово россия / воронежская область / есипово"
  },
  "10234": {
    "id": "10234",
    "name": "Ярки",
    "path": "Россия / Воронежская область / Ярки",
    "country": "Россия",
    "searchString": "ярки россия / воронежская область / ярки"
  },
  "10235": {
    "id": "10235",
    "name": "Коротыш",
    "path": "Россия / Орловская область / Коротыш",
    "country": "Россия",
    "searchString": "коротыш россия / орловская область / коротыш"
  },
  "10236": {
    "id": "10236",
    "name": "Радченское",
    "path": "Россия / Воронежская область / Радченское",
    "country": "Россия",
    "searchString": "радченское россия / воронежская область / радченское"
  },
  "10237": {
    "id": "10237",
    "name": "Мятлево",
    "path": "Россия / Калужская область / Мятлево",
    "country": "Россия",
    "searchString": "мятлево россия / калужская область / мятлево"
  },
  "10238": {
    "id": "10238",
    "name": "Рыжевка",
    "path": "Россия / Курская область / Рыжевка",
    "country": "Россия",
    "searchString": "рыжевка россия / курская область / рыжевка"
  },
  "10239": {
    "id": "10239",
    "name": "Сагуны (Подгоренский район, Березовское поселение)",
    "path": "Россия / Воронежская область / Сагуны (Подгоренский район, Березовское поселение)",
    "country": "Россия",
    "searchString": "сагуны (подгоренский район, березовское поселение) россия / воронежская область / сагуны (подгоренский район, березовское поселение)"
  },
  "10240": {
    "id": "10240",
    "name": "Бобровы Дворы",
    "path": "Россия / Белгородская область / Бобровы Дворы",
    "country": "Россия",
    "searchString": "бобровы дворы россия / белгородская область / бобровы дворы"
  },
  "10241": {
    "id": "10241",
    "name": "Татарино",
    "path": "Россия / Воронежская область / Татарино",
    "country": "Россия",
    "searchString": "татарино россия / воронежская область / татарино"
  },
  "10242": {
    "id": "10242",
    "name": "Гвазда",
    "path": "Россия / Воронежская область / Гвазда",
    "country": "Россия",
    "searchString": "гвазда россия / воронежская область / гвазда"
  },
  "10243": {
    "id": "10243",
    "name": "Малый Снежеток",
    "path": "Россия / Тамбовская область / Малый Снежеток",
    "country": "Россия",
    "searchString": "малый снежеток россия / тамбовская область / малый снежеток"
  },
  "10244": {
    "id": "10244",
    "name": "Луки",
    "path": "Россия / Воронежская область / Луки",
    "country": "Россия",
    "searchString": "луки россия / воронежская область / луки"
  },
  "10245": {
    "id": "10245",
    "name": "Старая Меловая",
    "path": "Россия / Воронежская область / Старая Меловая",
    "country": "Россия",
    "searchString": "старая меловая россия / воронежская область / старая меловая"
  },
  "10246": {
    "id": "10246",
    "name": "Старая Хворостань",
    "path": "Россия / Воронежская область / Старая Хворостань",
    "country": "Россия",
    "searchString": "старая хворостань россия / воронежская область / старая хворостань"
  },
  "10247": {
    "id": "10247",
    "name": "Пересыпкино 1-е",
    "path": "Россия / Тамбовская область / Пересыпкино 1-е",
    "country": "Россия",
    "searchString": "пересыпкино 1-е россия / тамбовская область / пересыпкино 1-е"
  },
  "10248": {
    "id": "10248",
    "name": "Ковалево",
    "path": "Россия / Воронежская область / Ковалево",
    "country": "Россия",
    "searchString": "ковалево россия / воронежская область / ковалево"
  },
  "10249": {
    "id": "10249",
    "name": "Талицкий Чамлык",
    "path": "Россия / Липецкая область / Талицкий Чамлык",
    "country": "Россия",
    "searchString": "талицкий чамлык россия / липецкая область / талицкий чамлык"
  },
  "10250": {
    "id": "10250",
    "name": "Тулиновка",
    "path": "Россия / Тамбовская область / Тулиновка",
    "country": "Россия",
    "searchString": "тулиновка россия / тамбовская область / тулиновка"
  },
  "10251": {
    "id": "10251",
    "name": "Ярославка (Тамбовская область)",
    "path": "Россия / Тамбовская область / Ярославка (Тамбовская область)",
    "country": "Россия",
    "searchString": "ярославка (тамбовская область) россия / тамбовская область / ярославка (тамбовская область)"
  },
  "10252": {
    "id": "10252",
    "name": "Фощеватово",
    "path": "Россия / Белгородская область / Фощеватово",
    "country": "Россия",
    "searchString": "фощеватово россия / белгородская область / фощеватово"
  },
  "10253": {
    "id": "10253",
    "name": "Булановка",
    "path": "Россия / Белгородская область / Булановка",
    "country": "Россия",
    "searchString": "булановка россия / белгородская область / булановка"
  },
  "10254": {
    "id": "10254",
    "name": "Рамонье",
    "path": "Россия / Воронежская область / Рамонье",
    "country": "Россия",
    "searchString": "рамонье россия / воронежская область / рамонье"
  },
  "10255": {
    "id": "10255",
    "name": "Вторые Левые Ламки",
    "path": "Россия / Тамбовская область / Вторые Левые Ламки",
    "country": "Россия",
    "searchString": "вторые левые ламки россия / тамбовская область / вторые левые ламки"
  },
  "10256": {
    "id": "10256",
    "name": "Новоживотинное",
    "path": "Россия / Воронежская область / Новоживотинное",
    "country": "Россия",
    "searchString": "новоживотинное россия / воронежская область / новоживотинное"
  },
  "10257": {
    "id": "10257",
    "name": "Дегтянка",
    "path": "Россия / Тамбовская область / Дегтянка",
    "country": "Россия",
    "searchString": "дегтянка россия / тамбовская область / дегтянка"
  },
  "10258": {
    "id": "10258",
    "name": "Новая Жизнь (Воронежская область)",
    "path": "Россия / Воронежская область / Новая Жизнь (Воронежская область)",
    "country": "Россия",
    "searchString": "новая жизнь (воронежская область) россия / воронежская область / новая жизнь (воронежская область)"
  },
  "10259": {
    "id": "10259",
    "name": "Дуплято-Маслово",
    "path": "Россия / Тамбовская область / Дуплято-Маслово",
    "country": "Россия",
    "searchString": "дуплято-маслово россия / тамбовская область / дуплято-маслово"
  },
  "10260": {
    "id": "10260",
    "name": "Бебелево",
    "path": "Россия / Калужская область / Бебелево",
    "country": "Россия",
    "searchString": "бебелево россия / калужская область / бебелево"
  },
  "10261": {
    "id": "10261",
    "name": "Стрелецкий",
    "path": "Россия / Орловская область / Стрелецкий",
    "country": "Россия",
    "searchString": "стрелецкий россия / орловская область / стрелецкий"
  },
  "10262": {
    "id": "10262",
    "name": "Двулучное",
    "path": "Россия / Белгородская область / Двулучное",
    "country": "Россия",
    "searchString": "двулучное россия / белгородская область / двулучное"
  },
  "10263": {
    "id": "10263",
    "name": "Большие Базы",
    "path": "Россия / Воронежская область / Большие Базы",
    "country": "Россия",
    "searchString": "большие базы россия / воронежская область / большие базы"
  },
  "10264": {
    "id": "10264",
    "name": "Калаис",
    "path": "Россия / Тамбовская область / Калаис",
    "country": "Россия",
    "searchString": "калаис россия / тамбовская область / калаис"
  },
  "10265": {
    "id": "10265",
    "name": "Большие Ясырки",
    "path": "Россия / Воронежская область / Большие Ясырки",
    "country": "Россия",
    "searchString": "большие ясырки россия / воронежская область / большие ясырки"
  },
  "10266": {
    "id": "10266",
    "name": "Дерезовка",
    "path": "Россия / Воронежская область / Дерезовка",
    "country": "Россия",
    "searchString": "дерезовка россия / воронежская область / дерезовка"
  },
  "10267": {
    "id": "10267",
    "name": "Курбатово",
    "path": "Россия / Воронежская область / Курбатово",
    "country": "Россия",
    "searchString": "курбатово россия / воронежская область / курбатово"
  },
  "10268": {
    "id": "10268",
    "name": "Поддубровка",
    "path": "Россия / Липецкая область / Поддубровка",
    "country": "Россия",
    "searchString": "поддубровка россия / липецкая область / поддубровка"
  },
  "10269": {
    "id": "10269",
    "name": "Здоровец",
    "path": "Россия / Орловская область / Здоровец",
    "country": "Россия",
    "searchString": "здоровец россия / орловская область / здоровец"
  },
  "10270": {
    "id": "10270",
    "name": "Народное",
    "path": "Россия / Воронежская область / Народное",
    "country": "Россия",
    "searchString": "народное россия / воронежская область / народное"
  },
  "10271": {
    "id": "10271",
    "name": "Анновка",
    "path": "Россия / Белгородская область / Анновка",
    "country": "Россия",
    "searchString": "анновка россия / белгородская область / анновка"
  },
  "10272": {
    "id": "10272",
    "name": "Холодное",
    "path": "Россия / Белгородская область / Холодное",
    "country": "Россия",
    "searchString": "холодное россия / белгородская область / холодное"
  },
  "10273": {
    "id": "10273",
    "name": "Хмелинец",
    "path": "Россия / Липецкая область / Хмелинец",
    "country": "Россия",
    "searchString": "хмелинец россия / липецкая область / хмелинец"
  },
  "10274": {
    "id": "10274",
    "name": "Алгасово",
    "path": "Россия / Тамбовская область / Алгасово",
    "country": "Россия",
    "searchString": "алгасово россия / тамбовская область / алгасово"
  },
  "10275": {
    "id": "10275",
    "name": "Сорокино",
    "path": "Россия / Белгородская область / Сорокино",
    "country": "Россия",
    "searchString": "сорокино россия / белгородская область / сорокино"
  },
  "10276": {
    "id": "10276",
    "name": "Пушкарное",
    "path": "Россия / Курская область / Пушкарное",
    "country": "Россия",
    "searchString": "пушкарное россия / курская область / пушкарное"
  },
  "10277": {
    "id": "10277",
    "name": "Бершаково",
    "path": "Россия / Белгородская область / Бершаково",
    "country": "Россия",
    "searchString": "бершаково россия / белгородская область / бершаково"
  },
  "10278": {
    "id": "10278",
    "name": "Бондарево",
    "path": "Россия / Воронежская область / Бондарево",
    "country": "Россия",
    "searchString": "бондарево россия / воронежская область / бондарево"
  },
  "10279": {
    "id": "10279",
    "name": "Новая Криуша",
    "path": "Россия / Воронежская область / Новая Криуша",
    "country": "Россия",
    "searchString": "новая криуша россия / воронежская область / новая криуша"
  },
  "10280": {
    "id": "10280",
    "name": "Южный (Тульская область)",
    "path": "Россия / Тульская область / Южный (Тульская область)",
    "country": "Россия",
    "searchString": "южный (тульская область) россия / тульская область / южный (тульская область)"
  },
  "10281": {
    "id": "10281",
    "name": "Граждановка",
    "path": "Россия / Тамбовская область / Граждановка",
    "country": "Россия",
    "searchString": "граждановка россия / тамбовская область / граждановка"
  },
  "10282": {
    "id": "10282",
    "name": "Старая Ведуга",
    "path": "Россия / Воронежская область / Старая Ведуга",
    "country": "Россия",
    "searchString": "старая ведуга россия / воронежская область / старая ведуга"
  },
  "10283": {
    "id": "10283",
    "name": "Верхососна",
    "path": "Россия / Белгородская область / Верхососна",
    "country": "Россия",
    "searchString": "верхососна россия / белгородская область / верхососна"
  },
  "10284": {
    "id": "10284",
    "name": "Новосильское",
    "path": "Россия / Воронежская область / Новосильское",
    "country": "Россия",
    "searchString": "новосильское россия / воронежская область / новосильское"
  },
  "10285": {
    "id": "10285",
    "name": "Русская Буйловка",
    "path": "Россия / Воронежская область / Русская Буйловка",
    "country": "Россия",
    "searchString": "русская буйловка россия / воронежская область / русская буйловка"
  },
  "10286": {
    "id": "10286",
    "name": "Нижний Икорец",
    "path": "Россия / Воронежская область / Нижний Икорец",
    "country": "Россия",
    "searchString": "нижний икорец россия / воронежская область / нижний икорец"
  },
  "10287": {
    "id": "10287",
    "name": "Козьмодемьяновка (Белгородская область)",
    "path": "Россия / Белгородская область / Козьмодемьяновка (Белгородская область)",
    "country": "Россия",
    "searchString": "козьмодемьяновка (белгородская область) россия / белгородская область / козьмодемьяновка (белгородская область)"
  },
  "10288": {
    "id": "10288",
    "name": "Гаврильск",
    "path": "Россия / Воронежская область / Гаврильск",
    "country": "Россия",
    "searchString": "гаврильск россия / воронежская область / гаврильск"
  },
  "10289": {
    "id": "10289",
    "name": "Платава",
    "path": "Россия / Воронежская область / Платава",
    "country": "Россия",
    "searchString": "платава россия / воронежская область / платава"
  },
  "10290": {
    "id": "10290",
    "name": "Клеповка",
    "path": "Россия / Воронежская область / Клеповка",
    "country": "Россия",
    "searchString": "клеповка россия / воронежская область / клеповка"
  },
  "10291": {
    "id": "10291",
    "name": "Верхняя Покровка",
    "path": "Россия / Белгородская область / Верхняя Покровка",
    "country": "Россия",
    "searchString": "верхняя покровка россия / белгородская область / верхняя покровка"
  },
  "10292": {
    "id": "10292",
    "name": "Сухая Березовка",
    "path": "Россия / Воронежская область / Сухая Березовка",
    "country": "Россия",
    "searchString": "сухая березовка россия / воронежская область / сухая березовка"
  },
  "10293": {
    "id": "10293",
    "name": "Тройня",
    "path": "Россия / Воронежская область / Тройня",
    "country": "Россия",
    "searchString": "тройня россия / воронежская область / тройня"
  },
  "10294": {
    "id": "10294",
    "name": "Изосимово",
    "path": "Россия / Тамбовская область / Изосимово",
    "country": "Россия",
    "searchString": "изосимово россия / тамбовская область / изосимово"
  },
  "10295": {
    "id": "10295",
    "name": "Сергеевка (Воронежская область)",
    "path": "Россия / Воронежская область / Сергеевка (Воронежская область)",
    "country": "Россия",
    "searchString": "сергеевка (воронежская область) россия / воронежская область / сергеевка (воронежская область)"
  },
  "10296": {
    "id": "10296",
    "name": "Русская Журавка",
    "path": "Россия / Воронежская область / Русская Журавка",
    "country": "Россия",
    "searchString": "русская журавка россия / воронежская область / русская журавка"
  },
  "10297": {
    "id": "10297",
    "name": "Пахотный Угол",
    "path": "Россия / Тамбовская область / Пахотный Угол",
    "country": "Россия",
    "searchString": "пахотный угол россия / тамбовская область / пахотный угол"
  },
  "10298": {
    "id": "10298",
    "name": "Русаново",
    "path": "Россия / Воронежская область / Русаново",
    "country": "Россия",
    "searchString": "русаново россия / воронежская область / русаново"
  },
  "10299": {
    "id": "10299",
    "name": "Шишовка",
    "path": "Россия / Воронежская область / Шишовка",
    "country": "Россия",
    "searchString": "шишовка россия / воронежская область / шишовка"
  },
  "10300": {
    "id": "10300",
    "name": "Маяк (Липецкая область)",
    "path": "Россия / Липецкая область / Маяк (Липецкая область)",
    "country": "Россия",
    "searchString": "маяк (липецкая область) россия / липецкая область / маяк (липецкая область)"
  },
  "10301": {
    "id": "10301",
    "name": "Ясенки",
    "path": "Россия / Воронежская область / Ясенки",
    "country": "Россия",
    "searchString": "ясенки россия / воронежская область / ясенки"
  },
  "10302": {
    "id": "10302",
    "name": "Макарово (Липецкая область)",
    "path": "Россия / Липецкая область / Макарово (Липецкая область)",
    "country": "Россия",
    "searchString": "макарово (липецкая область) россия / липецкая область / макарово (липецкая область)"
  },
  "10303": {
    "id": "10303",
    "name": "Верхний Студенец",
    "path": "Россия / Липецкая область / Верхний Студенец",
    "country": "Россия",
    "searchString": "верхний студенец россия / липецкая область / верхний студенец"
  },
  "10304": {
    "id": "10304",
    "name": "Красный Лиман 2-й",
    "path": "Россия / Воронежская область / Красный Лиман 2-й",
    "country": "Россия",
    "searchString": "красный лиман 2-й россия / воронежская область / красный лиман 2-й"
  },
  "10305": {
    "id": "10305",
    "name": "Большая Халань",
    "path": "Россия / Белгородская область / Большая Халань",
    "country": "Россия",
    "searchString": "большая халань россия / белгородская область / большая халань"
  },
  "10306": {
    "id": "10306",
    "name": "Костино-Отделец",
    "path": "Россия / Воронежская область / Костино-Отделец",
    "country": "Россия",
    "searchString": "костино-отделец россия / воронежская область / костино-отделец"
  },
  "10307": {
    "id": "10307",
    "name": "Успенское (Орловская область)",
    "path": "Россия / Орловская область / Успенское (Орловская область)",
    "country": "Россия",
    "searchString": "успенское (орловская область) россия / орловская область / успенское (орловская область)"
  },
  "10308": {
    "id": "10308",
    "name": "Верхний Любаж",
    "path": "Россия / Курская область / Верхний Любаж",
    "country": "Россия",
    "searchString": "верхний любаж россия / курская область / верхний любаж"
  },
  "10309": {
    "id": "10309",
    "name": "Большая Ржакса",
    "path": "Россия / Тамбовская область / Большая Ржакса",
    "country": "Россия",
    "searchString": "большая ржакса россия / тамбовская область / большая ржакса"
  },
  "10310": {
    "id": "10310",
    "name": "Красненькая",
    "path": "Россия / Тамбовская область / Красненькая",
    "country": "Россия",
    "searchString": "красненькая россия / тамбовская область / красненькая"
  },
  "10311": {
    "id": "10311",
    "name": "Вернадовка",
    "path": "Россия / Тамбовская область / Вернадовка",
    "country": "Россия",
    "searchString": "вернадовка россия / тамбовская область / вернадовка"
  },
  "10312": {
    "id": "10312",
    "name": "Чесменка",
    "path": "Россия / Воронежская область / Чесменка",
    "country": "Россия",
    "searchString": "чесменка россия / воронежская область / чесменка"
  },
  "10313": {
    "id": "10313",
    "name": "Сахзаводской",
    "path": "Россия / Орловская область / Сахзаводской",
    "country": "Россия",
    "searchString": "сахзаводской россия / орловская область / сахзаводской"
  },
  "10314": {
    "id": "10314",
    "name": "Подборки",
    "path": "Россия / Калужская область / Подборки",
    "country": "Россия",
    "searchString": "подборки россия / калужская область / подборки"
  },
  "10315": {
    "id": "10315",
    "name": "Большая Поляна",
    "path": "Россия / Липецкая область / Большая Поляна",
    "country": "Россия",
    "searchString": "большая поляна россия / липецкая область / большая поляна"
  },
  "10316": {
    "id": "10316",
    "name": "Дрязги",
    "path": "Россия / Липецкая область / Дрязги",
    "country": "Россия",
    "searchString": "дрязги россия / липецкая область / дрязги"
  },
  "10317": {
    "id": "10317",
    "name": "Рождественская Хава",
    "path": "Россия / Воронежская область / Рождественская Хава",
    "country": "Россия",
    "searchString": "рождественская хава россия / воронежская область / рождественская хава"
  },
  "10318": {
    "id": "10318",
    "name": "Староникольское",
    "path": "Россия / Воронежская область / Староникольское",
    "country": "Россия",
    "searchString": "староникольское россия / воронежская область / староникольское"
  },
  "10319": {
    "id": "10319",
    "name": "Первомайское (Липецкая область)",
    "path": "Россия / Липецкая область / Первомайское (Липецкая область)",
    "country": "Россия",
    "searchString": "первомайское (липецкая область) россия / липецкая область / первомайское (липецкая область)"
  },
  "10320": {
    "id": "10320",
    "name": "Фащевка",
    "path": "Россия / Липецкая область / Фащевка",
    "country": "Россия",
    "searchString": "фащевка россия / липецкая область / фащевка"
  },
  "10321": {
    "id": "10321",
    "name": "Михайловка (Курская область)",
    "path": "Россия / Курская область / Михайловка (Курская область)",
    "country": "Россия",
    "searchString": "михайловка (курская область) россия / курская область / михайловка (курская область)"
  },
  "10322": {
    "id": "10322",
    "name": "Пузево",
    "path": "Россия / Воронежская область / Пузево",
    "country": "Россия",
    "searchString": "пузево россия / воронежская область / пузево"
  },
  "10323": {
    "id": "10323",
    "name": "Шайковка",
    "path": "Россия / Калужская область / Шайковка",
    "country": "Россия",
    "searchString": "шайковка россия / калужская область / шайковка"
  },
  "10324": {
    "id": "10324",
    "name": "Дерябкино",
    "path": "Россия / Воронежская область / Дерябкино",
    "country": "Россия",
    "searchString": "дерябкино россия / воронежская область / дерябкино"
  },
  "10325": {
    "id": "10325",
    "name": "Березовка (Тамбовская область)",
    "path": "Россия / Тамбовская область / Березовка (Тамбовская область)",
    "country": "Россия",
    "searchString": "березовка (тамбовская область) россия / тамбовская область / березовка (тамбовская область)"
  },
  "10326": {
    "id": "10326",
    "name": "Бобрава",
    "path": "Россия / Белгородская область / Бобрава",
    "country": "Россия",
    "searchString": "бобрава россия / белгородская область / бобрава"
  },
  "10327": {
    "id": "10327",
    "name": "Ладомировка",
    "path": "Россия / Белгородская область / Ладомировка",
    "country": "Россия",
    "searchString": "ладомировка россия / белгородская область / ладомировка"
  },
  "10328": {
    "id": "10328",
    "name": "Призначное",
    "path": "Россия / Белгородская область / Призначное",
    "country": "Россия",
    "searchString": "призначное россия / белгородская область / призначное"
  },
  "10329": {
    "id": "10329",
    "name": "Липовка (Тамбовская область)",
    "path": "Россия / Тамбовская область / Липовка (Тамбовская область)",
    "country": "Россия",
    "searchString": "липовка (тамбовская область) россия / тамбовская область / липовка (тамбовская область)"
  },
  "10330": {
    "id": "10330",
    "name": "Журавка (Воронежская область)",
    "path": "Россия / Воронежская область / Журавка (Воронежская область)",
    "country": "Россия",
    "searchString": "журавка (воронежская область) россия / воронежская область / журавка (воронежская область)"
  },
  "10331": {
    "id": "10331",
    "name": "Талы",
    "path": "Россия / Воронежская область / Талы",
    "country": "Россия",
    "searchString": "талы россия / воронежская область / талы"
  },
  "10332": {
    "id": "10332",
    "name": "Березнеговатка",
    "path": "Россия / Липецкая область / Березнеговатка",
    "country": "Россия",
    "searchString": "березнеговатка россия / липецкая область / березнеговатка"
  },
  "10333": {
    "id": "10333",
    "name": "Амосовка",
    "path": "Россия / Курская область / Амосовка",
    "country": "Россия",
    "searchString": "амосовка россия / курская область / амосовка"
  },
  "10334": {
    "id": "10334",
    "name": "Кулябовка",
    "path": "Россия / Тамбовская область / Кулябовка",
    "country": "Россия",
    "searchString": "кулябовка россия / тамбовская область / кулябовка"
  },
  "10335": {
    "id": "10335",
    "name": "Закутское",
    "path": "Россия / Белгородская область / Закутское",
    "country": "Россия",
    "searchString": "закутское россия / белгородская область / закутское"
  },
  "10336": {
    "id": "10336",
    "name": "Озерки (Воронежская область)",
    "path": "Россия / Воронежская область / Озерки (Воронежская область)",
    "country": "Россия",
    "searchString": "озерки (воронежская область) россия / воронежская область / озерки (воронежская область)"
  },
  "10337": {
    "id": "10337",
    "name": "Рождественское (Воронежская область)",
    "path": "Россия / Воронежская область / Рождественское (Воронежская область)",
    "country": "Россия",
    "searchString": "рождественское (воронежская область) россия / воронежская область / рождественское (воронежская область)"
  },
  "10338": {
    "id": "10338",
    "name": "Насоново",
    "path": "Россия / Белгородская область / Насоново",
    "country": "Россия",
    "searchString": "насоново россия / белгородская область / насоново"
  },
  "10339": {
    "id": "10339",
    "name": "Ламское",
    "path": "Россия / Липецкая область / Ламское",
    "country": "Россия",
    "searchString": "ламское россия / липецкая область / ламское"
  },
  "10340": {
    "id": "10340",
    "name": "Русская Халань",
    "path": "Россия / Белгородская область / Русская Халань",
    "country": "Россия",
    "searchString": "русская халань россия / белгородская область / русская халань"
  },
  "10341": {
    "id": "10341",
    "name": "Мечетка",
    "path": "Россия / Воронежская область / Мечетка",
    "country": "Россия",
    "searchString": "мечетка россия / воронежская область / мечетка"
  },
  "10342": {
    "id": "10342",
    "name": "Лесково",
    "path": "Россия / Воронежская область / Лесково",
    "country": "Россия",
    "searchString": "лесково россия / воронежская область / лесково"
  },
  "10343": {
    "id": "10343",
    "name": "Бродовое",
    "path": "Россия / Воронежская область / Бродовое",
    "country": "Россия",
    "searchString": "бродовое россия / воронежская область / бродовое"
  },
  "10344": {
    "id": "10344",
    "name": "Архангельское (Воронежская область)",
    "path": "Россия / Воронежская область / Архангельское (Воронежская область)",
    "country": "Россия",
    "searchString": "архангельское (воронежская область) россия / воронежская область / архангельское (воронежская область)"
  },
  "10345": {
    "id": "10345",
    "name": "Шаталовка",
    "path": "Россия / Белгородская область / Шаталовка",
    "country": "Россия",
    "searchString": "шаталовка россия / белгородская область / шаталовка"
  },
  "10346": {
    "id": "10346",
    "name": "Иванино",
    "path": "Россия / Курская область / Иванино",
    "country": "Россия",
    "searchString": "иванино россия / курская область / иванино"
  },
  "10347": {
    "id": "10347",
    "name": "Вирятино",
    "path": "Россия / Тамбовская область / Вирятино",
    "country": "Россия",
    "searchString": "вирятино россия / тамбовская область / вирятино"
  },
  "10348": {
    "id": "10348",
    "name": "Никитовка",
    "path": "Россия / Белгородская область / Никитовка",
    "country": "Россия",
    "searchString": "никитовка россия / белгородская область / никитовка"
  },
  "10349": {
    "id": "10349",
    "name": "Федосеевка",
    "path": "Россия / Белгородская область / Федосеевка",
    "country": "Россия",
    "searchString": "федосеевка россия / белгородская область / федосеевка"
  },
  "10350": {
    "id": "10350",
    "name": "Поселок им.Куйбышева",
    "path": "Россия / Курская область / Поселок им.Куйбышева",
    "country": "Россия",
    "searchString": "поселок им.куйбышева россия / курская область / поселок им.куйбышева"
  },
  "10351": {
    "id": "10351",
    "name": "Яблоново",
    "path": "Россия / Белгородская область / Яблоново",
    "country": "Россия",
    "searchString": "яблоново россия / белгородская область / яблоново"
  },
  "10352": {
    "id": "10352",
    "name": "Казинка (Липецкая область)",
    "path": "Россия / Липецкая область / Казинка (Липецкая область)",
    "country": "Россия",
    "searchString": "казинка (липецкая область) россия / липецкая область / казинка (липецкая область)"
  },
  "10353": {
    "id": "10353",
    "name": "Чигорак",
    "path": "Россия / Воронежская область / Чигорак",
    "country": "Россия",
    "searchString": "чигорак россия / воронежская область / чигорак"
  },
  "10354": {
    "id": "10354",
    "name": "Мухоудеровка",
    "path": "Россия / Белгородская область / Мухоудеровка",
    "country": "Россия",
    "searchString": "мухоудеровка россия / белгородская область / мухоудеровка"
  },
  "10355": {
    "id": "10355",
    "name": "1-й Воин",
    "path": "Россия / Орловская область / 1-й Воин",
    "country": "Россия",
    "searchString": "1-й воин россия / орловская область / 1-й воин"
  },
  "10356": {
    "id": "10356",
    "name": "Покровка (Белгородская область)",
    "path": "Россия / Белгородская область / Покровка (Белгородская область)",
    "country": "Россия",
    "searchString": "покровка (белгородская область) россия / белгородская область / покровка (белгородская область)"
  },
  "10357": {
    "id": "10357",
    "name": "Кустовое",
    "path": "Россия / Белгородская область / Кустовое",
    "country": "Россия",
    "searchString": "кустовое россия / белгородская область / кустовое"
  },
  "10358": {
    "id": "10358",
    "name": "Сапрыкино",
    "path": "Россия / Белгородская область / Сапрыкино",
    "country": "Россия",
    "searchString": "сапрыкино россия / белгородская область / сапрыкино"
  },
  "10359": {
    "id": "10359",
    "name": "Новый Курлак",
    "path": "Россия / Воронежская область / Новый Курлак",
    "country": "Россия",
    "searchString": "новый курлак россия / воронежская область / новый курлак"
  },
  "10360": {
    "id": "10360",
    "name": "Начало",
    "path": "Россия / Воронежская область / Начало",
    "country": "Россия",
    "searchString": "начало россия / воронежская область / начало"
  },
  "10361": {
    "id": "10361",
    "name": "Красное (Воронежская область)",
    "path": "Россия / Воронежская область / Красное (Воронежская область)",
    "country": "Россия",
    "searchString": "красное (воронежская область) россия / воронежская область / красное (воронежская область)"
  },
  "10362": {
    "id": "10362",
    "name": "Дунайка",
    "path": "Россия / Белгородская область / Дунайка",
    "country": "Россия",
    "searchString": "дунайка россия / белгородская область / дунайка"
  },
  "10363": {
    "id": "10363",
    "name": "Марьевка",
    "path": "Россия / Воронежская область / Марьевка",
    "country": "Россия",
    "searchString": "марьевка россия / воронежская область / марьевка"
  },
  "10364": {
    "id": "10364",
    "name": "Кривополянье",
    "path": "Россия / Липецкая область / Кривополянье",
    "country": "Россия",
    "searchString": "кривополянье россия / липецкая область / кривополянье"
  },
  "10365": {
    "id": "10365",
    "name": "Заречье (Калужская область)",
    "path": "Россия / Калужская область / Заречье (Калужская область)",
    "country": "Россия",
    "searchString": "заречье (калужская область) россия / калужская область / заречье (калужская область)"
  },
  "10366": {
    "id": "10366",
    "name": "Коломыцево",
    "path": "Россия / Воронежская область / Коломыцево",
    "country": "Россия",
    "searchString": "коломыцево россия / воронежская область / коломыцево"
  },
  "10367": {
    "id": "10367",
    "name": "Новоречье",
    "path": "Россия / Белгородская область / Новоречье",
    "country": "Россия",
    "searchString": "новоречье россия / белгородская область / новоречье"
  },
  "10368": {
    "id": "10368",
    "name": "Бигильдино",
    "path": "Россия / Липецкая область / Бигильдино",
    "country": "Россия",
    "searchString": "бигильдино россия / липецкая область / бигильдино"
  },
  "10369": {
    "id": "10369",
    "name": "Подколодновка",
    "path": "Россия / Воронежская область / Подколодновка",
    "country": "Россия",
    "searchString": "подколодновка россия / воронежская область / подколодновка"
  },
  "10370": {
    "id": "10370",
    "name": "Костово",
    "path": "Россия / Воронежская область / Костово",
    "country": "Россия",
    "searchString": "костово россия / воронежская область / костово"
  },
  "10371": {
    "id": "10371",
    "name": "Кулеватово",
    "path": "Россия / Тамбовская область / Кулеватово",
    "country": "Россия",
    "searchString": "кулеватово россия / тамбовская область / кулеватово"
  },
  "10372": {
    "id": "10372",
    "name": "Нагорье (Белгородская область)",
    "path": "Россия / Белгородская область / Нагорье (Белгородская область)",
    "country": "Россия",
    "searchString": "нагорье (белгородская область) россия / белгородская область / нагорье (белгородская область)"
  },
  "10373": {
    "id": "10373",
    "name": "Вяжли",
    "path": "Россия / Тамбовская область / Вяжли",
    "country": "Россия",
    "searchString": "вяжли россия / тамбовская область / вяжли"
  },
  "10374": {
    "id": "10374",
    "name": "Первомайский (Воронежская область)",
    "path": "Россия / Воронежская область / Первомайский (Воронежская область)",
    "country": "Россия",
    "searchString": "первомайский (воронежская область) россия / воронежская область / первомайский (воронежская область)"
  },
  "10375": {
    "id": "10375",
    "name": "Бодеевка",
    "path": "Россия / Воронежская область / Бодеевка",
    "country": "Россия",
    "searchString": "бодеевка россия / воронежская область / бодеевка"
  },
  "10376": {
    "id": "10376",
    "name": "Братки",
    "path": "Россия / Воронежская область / Братки",
    "country": "Россия",
    "searchString": "братки россия / воронежская область / братки"
  },
  "10377": {
    "id": "10377",
    "name": "Смаглеевка",
    "path": "Россия / Воронежская область / Смаглеевка",
    "country": "Россия",
    "searchString": "смаглеевка россия / воронежская область / смаглеевка"
  },
  "10378": {
    "id": "10378",
    "name": "Максим Горький",
    "path": "Россия / Тамбовская область / Максим Горький",
    "country": "Россия",
    "searchString": "максим горький россия / тамбовская область / максим горький"
  },
  "10379": {
    "id": "10379",
    "name": "Летошники",
    "path": "Россия / Брянская область / Летошники",
    "country": "Россия",
    "searchString": "летошники россия / брянская область / летошники"
  },
  "10380": {
    "id": "10380",
    "name": "Манино",
    "path": "Россия / Воронежская область / Манино",
    "country": "Россия",
    "searchString": "манино россия / воронежская область / манино"
  },
  "10381": {
    "id": "10381",
    "name": "Поповка (Белгородская область)",
    "path": "Россия / Белгородская область / Поповка (Белгородская область)",
    "country": "Россия",
    "searchString": "поповка (белгородская область) россия / белгородская область / поповка (белгородская область)"
  },
  "10382": {
    "id": "10382",
    "name": "Ясные Зори",
    "path": "Россия / Белгородская область / Ясные Зори",
    "country": "Россия",
    "searchString": "ясные зори россия / белгородская область / ясные зори"
  },
  "10383": {
    "id": "10383",
    "name": "Верхняя Тишанка",
    "path": "Россия / Воронежская область / Верхняя Тишанка",
    "country": "Россия",
    "searchString": "верхняя тишанка россия / воронежская область / верхняя тишанка"
  },
  "10384": {
    "id": "10384",
    "name": "Селявное",
    "path": "Россия / Воронежская область / Селявное",
    "country": "Россия",
    "searchString": "селявное россия / воронежская область / селявное"
  },
  "10385": {
    "id": "10385",
    "name": "Пушкино (Липецкая область)",
    "path": "Россия / Липецкая область / Пушкино (Липецкая область)",
    "country": "Россия",
    "searchString": "пушкино (липецкая область) россия / липецкая область / пушкино (липецкая область)"
  },
  "10386": {
    "id": "10386",
    "name": "Троекурово",
    "path": "Россия / Липецкая область / Троекурово",
    "country": "Россия",
    "searchString": "троекурово россия / липецкая область / троекурово"
  },
  "10387": {
    "id": "10387",
    "name": "Покрово-Пригородное",
    "path": "Россия / Тамбовская область / Покрово-Пригородное",
    "country": "Россия",
    "searchString": "покрово-пригородное россия / тамбовская область / покрово-пригородное"
  },
  "10388": {
    "id": "10388",
    "name": "Первомайское (Тамбовская область)",
    "path": "Россия / Тамбовская область / Первомайское (Тамбовская область)",
    "country": "Россия",
    "searchString": "первомайское (тамбовская область) россия / тамбовская область / первомайское (тамбовская область)"
  },
  "10389": {
    "id": "10389",
    "name": "Герасимовка",
    "path": "Россия / Белгородская область / Герасимовка",
    "country": "Россия",
    "searchString": "герасимовка россия / белгородская область / герасимовка"
  },
  "10390": {
    "id": "10390",
    "name": "Шараповка",
    "path": "Россия / Белгородская область / Шараповка",
    "country": "Россия",
    "searchString": "шараповка россия / белгородская область / шараповка"
  },
  "10391": {
    "id": "10391",
    "name": "Кривцово",
    "path": "Россия / Тульская область / Кривцово",
    "country": "Россия",
    "searchString": "кривцово россия / тульская область / кривцово"
  },
  "10392": {
    "id": "10392",
    "name": "Семеновка (Воронежская область)",
    "path": "Россия / Воронежская область / Семеновка (Воронежская область)",
    "country": "Россия",
    "searchString": "семеновка (воронежская область) россия / воронежская область / семеновка (воронежская область)"
  },
  "10393": {
    "id": "10393",
    "name": "Почепское",
    "path": "Россия / Воронежская область / Почепское",
    "country": "Россия",
    "searchString": "почепское россия / воронежская область / почепское"
  },
  "10394": {
    "id": "10394",
    "name": "Верхняя Тойда",
    "path": "Россия / Воронежская область / Верхняя Тойда",
    "country": "Россия",
    "searchString": "верхняя тойда россия / воронежская область / верхняя тойда"
  },
  "10395": {
    "id": "10395",
    "name": "Козинка",
    "path": "Россия / Белгородская область / Козинка",
    "country": "Россия",
    "searchString": "козинка россия / белгородская область / козинка"
  },
  "10396": {
    "id": "10396",
    "name": "Новонадежденский",
    "path": "Россия / Воронежская область / Новонадежденский",
    "country": "Россия",
    "searchString": "новонадежденский россия / воронежская область / новонадежденский"
  },
  "10397": {
    "id": "10397",
    "name": "Чернава (Липецкая область)",
    "path": "Россия / Липецкая область / Чернава (Липецкая область)",
    "country": "Россия",
    "searchString": "чернава (липецкая область) россия / липецкая область / чернава (липецкая область)"
  },
  "10398": {
    "id": "10398",
    "name": "Новомеловатка",
    "path": "Россия / Воронежская область / Новомеловатка",
    "country": "Россия",
    "searchString": "новомеловатка россия / воронежская область / новомеловатка"
  },
  "10399": {
    "id": "10399",
    "name": "Коробовка",
    "path": "Россия / Липецкая область / Коробовка",
    "country": "Россия",
    "searchString": "коробовка россия / липецкая область / коробовка"
  },
  "10400": {
    "id": "10400",
    "name": "Заболотовка",
    "path": "Россия / Воронежская область / Заболотовка",
    "country": "Россия",
    "searchString": "заболотовка россия / воронежская область / заболотовка"
  },
  "10401": {
    "id": "10401",
    "name": "Гирьи",
    "path": "Россия / Курская область / Гирьи",
    "country": "Россия",
    "searchString": "гирьи россия / курская область / гирьи"
  },
  "10402": {
    "id": "10402",
    "name": "Елецкая Лозовка",
    "path": "Россия / Липецкая область / Елецкая Лозовка",
    "country": "Россия",
    "searchString": "елецкая лозовка россия / липецкая область / елецкая лозовка"
  },
  "10403": {
    "id": "10403",
    "name": "Сухиновка",
    "path": "Россия / Курская область / Сухиновка",
    "country": "Россия",
    "searchString": "сухиновка россия / курская область / сухиновка"
  },
  "10404": {
    "id": "10404",
    "name": "Дичня",
    "path": "Россия / Курская область / Дичня",
    "country": "Россия",
    "searchString": "дичня россия / курская область / дичня"
  },
  "10405": {
    "id": "10405",
    "name": "Погромец",
    "path": "Россия / Белгородская область / Погромец",
    "country": "Россия",
    "searchString": "погромец россия / белгородская область / погромец"
  },
  "10406": {
    "id": "10406",
    "name": "Белянка (Белгородская область)",
    "path": "Россия / Белгородская область / Белянка (Белгородская область)",
    "country": "Россия",
    "searchString": "белянка (белгородская область) россия / белгородская область / белянка (белгородская область)"
  },
  "10407": {
    "id": "10407",
    "name": "Юрловка",
    "path": "Россия / Тамбовская область / Юрловка",
    "country": "Россия",
    "searchString": "юрловка россия / тамбовская область / юрловка"
  },
  "10408": {
    "id": "10408",
    "name": "Новогольелань",
    "path": "Россия / Воронежская область / Новогольелань",
    "country": "Россия",
    "searchString": "новогольелань россия / воронежская область / новогольелань"
  },
  "10409": {
    "id": "10409",
    "name": "Перелешинский",
    "path": "Россия / Воронежская область / Перелешинский",
    "country": "Россия",
    "searchString": "перелешинский россия / воронежская область / перелешинский"
  },
  "10410": {
    "id": "10410",
    "name": "Лещаное",
    "path": "Россия / Воронежская область / Лещаное",
    "country": "Россия",
    "searchString": "лещаное россия / воронежская область / лещаное"
  },
  "10411": {
    "id": "10411",
    "name": "Еленский",
    "path": "Россия / Калужская область / Еленский",
    "country": "Россия",
    "searchString": "еленский россия / калужская область / еленский"
  },
  "10412": {
    "id": "10412",
    "name": "Старая Безгинка",
    "path": "Россия / Белгородская область / Старая Безгинка",
    "country": "Россия",
    "searchString": "старая безгинка россия / белгородская область / старая безгинка"
  },
  "10413": {
    "id": "10413",
    "name": "Паревка",
    "path": "Россия / Тамбовская область / Паревка",
    "country": "Россия",
    "searchString": "паревка россия / тамбовская область / паревка"
  },
  "10414": {
    "id": "10414",
    "name": "Титаревка",
    "path": "Россия / Воронежская область / Титаревка",
    "country": "Россия",
    "searchString": "титаревка россия / воронежская область / титаревка"
  },
  "10415": {
    "id": "10415",
    "name": "Любимовка",
    "path": "Россия / Курская область / Любимовка",
    "country": "Россия",
    "searchString": "любимовка россия / курская область / любимовка"
  },
  "10416": {
    "id": "10416",
    "name": "Ярское",
    "path": "Россия / Белгородская область / Ярское",
    "country": "Россия",
    "searchString": "ярское россия / белгородская область / ярское"
  },
  "10417": {
    "id": "10417",
    "name": "Лозовое",
    "path": "Россия / Воронежская область / Лозовое",
    "country": "Россия",
    "searchString": "лозовое россия / воронежская область / лозовое"
  },
  "10418": {
    "id": "10418",
    "name": "Иловка",
    "path": "Россия / Белгородская область / Иловка",
    "country": "Россия",
    "searchString": "иловка россия / белгородская область / иловка"
  },
  "10419": {
    "id": "10419",
    "name": "Ведное",
    "path": "Россия / Липецкая область / Ведное",
    "country": "Россия",
    "searchString": "ведное россия / липецкая область / ведное"
  },
  "10420": {
    "id": "10420",
    "name": "Беленихино",
    "path": "Россия / Белгородская область / Беленихино",
    "country": "Россия",
    "searchString": "беленихино россия / белгородская область / беленихино"
  },
  "10421": {
    "id": "10421",
    "name": "Чуево",
    "path": "Россия / Белгородская область / Чуево",
    "country": "Россия",
    "searchString": "чуево россия / белгородская область / чуево"
  },
  "10422": {
    "id": "10422",
    "name": "Политово",
    "path": "Россия / Липецкая область / Политово",
    "country": "Россия",
    "searchString": "политово россия / липецкая область / политово"
  },
  "10423": {
    "id": "10423",
    "name": "Демшинка",
    "path": "Россия / Липецкая область / Демшинка",
    "country": "Россия",
    "searchString": "демшинка россия / липецкая область / демшинка"
  },
  "10424": {
    "id": "10424",
    "name": "Березовка (Белгородская область)",
    "path": "Россия / Белгородская область / Березовка (Белгородская область)",
    "country": "Россия",
    "searchString": "березовка (белгородская область) россия / белгородская область / березовка (белгородская область)"
  },
  "10425": {
    "id": "10425",
    "name": "Черкасское Поречное",
    "path": "Россия / Курская область / Черкасское Поречное",
    "country": "Россия",
    "searchString": "черкасское поречное россия / курская область / черкасское поречное"
  },
  "10426": {
    "id": "10426",
    "name": "Красносвободное",
    "path": "Россия / Тамбовская область / Красносвободное",
    "country": "Россия",
    "searchString": "красносвободное россия / тамбовская область / красносвободное"
  },
  "10427": {
    "id": "10427",
    "name": "Раздорное",
    "path": "Россия / Белгородская область / Раздорное",
    "country": "Россия",
    "searchString": "раздорное россия / белгородская область / раздорное"
  },
  "10428": {
    "id": "10428",
    "name": "Сабуро-Покровское",
    "path": "Россия / Тамбовская область / Сабуро-Покровское",
    "country": "Россия",
    "searchString": "сабуро-покровское россия / тамбовская область / сабуро-покровское"
  },
  "10429": {
    "id": "10429",
    "name": "Белый Колодезь",
    "path": "Россия / Белгородская область / Белый Колодезь",
    "country": "Россия",
    "searchString": "белый колодезь россия / белгородская область / белый колодезь"
  },
  "10430": {
    "id": "10430",
    "name": "Ново-Дубовое",
    "path": "Россия / Липецкая область / Ново-Дубовое",
    "country": "Россия",
    "searchString": "ново-дубовое россия / липецкая область / ново-дубовое"
  },
  "10431": {
    "id": "10431",
    "name": "Варваровка (Белгородская область)",
    "path": "Россия / Белгородская область / Варваровка (Белгородская область)",
    "country": "Россия",
    "searchString": "варваровка (белгородская область) россия / белгородская область / варваровка (белгородская область)"
  },
  "10432": {
    "id": "10432",
    "name": "Костенки",
    "path": "Россия / Воронежская область / Костенки",
    "country": "Россия",
    "searchString": "костенки россия / воронежская область / костенки"
  },
  "10433": {
    "id": "10433",
    "name": "Сериково",
    "path": "Россия / Воронежская область / Сериково",
    "country": "Россия",
    "searchString": "сериково россия / воронежская область / сериково"
  },
  "10434": {
    "id": "10434",
    "name": "Вязноватовка",
    "path": "Россия / Воронежская область / Вязноватовка",
    "country": "Россия",
    "searchString": "вязноватовка россия / воронежская область / вязноватовка"
  },
  "10435": {
    "id": "10435",
    "name": "Скорняково",
    "path": "Россия / Липецкая область / Скорняково",
    "country": "Россия",
    "searchString": "скорняково россия / липецкая область / скорняково"
  },
  "10436": {
    "id": "10436",
    "name": "Лесно-Уколово",
    "path": "Россия / Белгородская область / Лесно-Уколово",
    "country": "Россия",
    "searchString": "лесно-уколово россия / белгородская область / лесно-уколово"
  },
  "10437": {
    "id": "10437",
    "name": "Колыбелка",
    "path": "Россия / Воронежская область / Колыбелка",
    "country": "Россия",
    "searchString": "колыбелка россия / воронежская область / колыбелка"
  },
  "10438": {
    "id": "10438",
    "name": "Верхнее Кузькино",
    "path": "Россия / Белгородская область / Верхнее Кузькино",
    "country": "Россия",
    "searchString": "верхнее кузькино россия / белгородская область / верхнее кузькино"
  },
  "10439": {
    "id": "10439",
    "name": "Синие Липяги",
    "path": "Россия / Воронежская область / Синие Липяги",
    "country": "Россия",
    "searchString": "синие липяги россия / воронежская область / синие липяги"
  },
  "10440": {
    "id": "10440",
    "name": "Бутово",
    "path": "Россия / Белгородская область / Бутово",
    "country": "Россия",
    "searchString": "бутово россия / белгородская область / бутово"
  },
  "10441": {
    "id": "10441",
    "name": "Новопетровка",
    "path": "Россия / Белгородская область / Новопетровка",
    "country": "Россия",
    "searchString": "новопетровка россия / белгородская область / новопетровка"
  },
  "10442": {
    "id": "10442",
    "name": "Никольское 2-е",
    "path": "Россия / Воронежская область / Никольское 2-е",
    "country": "Россия",
    "searchString": "никольское 2-е россия / воронежская область / никольское 2-е"
  },
  "10443": {
    "id": "10443",
    "name": "Верхний Ломовец",
    "path": "Россия / Липецкая область / Верхний Ломовец",
    "country": "Россия",
    "searchString": "верхний ломовец россия / липецкая область / верхний ломовец"
  },
  "10444": {
    "id": "10444",
    "name": "Монаково",
    "path": "Россия / Белгородская область / Монаково",
    "country": "Россия",
    "searchString": "монаково россия / белгородская область / монаково"
  },
  "10445": {
    "id": "10445",
    "name": "Становой Колодезь",
    "path": "Россия / Орловская область / Становой Колодезь",
    "country": "Россия",
    "searchString": "становой колодезь россия / орловская область / становой колодезь"
  },
  "10446": {
    "id": "10446",
    "name": "Бычок",
    "path": "Россия / Воронежская область / Бычок",
    "country": "Россия",
    "searchString": "бычок россия / воронежская область / бычок"
  },
  "10447": {
    "id": "10447",
    "name": "Нижний Мамон",
    "path": "Россия / Воронежская область / Нижний Мамон",
    "country": "Россия",
    "searchString": "нижний мамон россия / воронежская область / нижний мамон"
  },
  "10448": {
    "id": "10448",
    "name": "Мамоновка",
    "path": "Россия / Воронежская область / Мамоновка",
    "country": "Россия",
    "searchString": "мамоновка россия / воронежская область / мамоновка"
  },
  "10449": {
    "id": "10449",
    "name": "Лизиновка",
    "path": "Россия / Воронежская область / Лизиновка",
    "country": "Россия",
    "searchString": "лизиновка россия / воронежская область / лизиновка"
  },
  "10450": {
    "id": "10450",
    "name": "Березняги",
    "path": "Россия / Воронежская область / Березняги",
    "country": "Россия",
    "searchString": "березняги россия / воронежская область / березняги"
  },
  "10451": {
    "id": "10451",
    "name": "Графовка",
    "path": "Россия / Белгородская область / Графовка",
    "country": "Россия",
    "searchString": "графовка россия / белгородская область / графовка"
  },
  "10452": {
    "id": "10452",
    "name": "Липовка (Воронежская область)",
    "path": "Россия / Воронежская область / Липовка (Воронежская область)",
    "country": "Россия",
    "searchString": "липовка (воронежская область) россия / воронежская область / липовка (воронежская область)"
  },
  "10453": {
    "id": "10453",
    "name": "Гарбузово",
    "path": "Россия / Белгородская область / Гарбузово",
    "country": "Россия",
    "searchString": "гарбузово россия / белгородская область / гарбузово"
  },
  "10454": {
    "id": "10454",
    "name": "Слобода",
    "path": "Россия / Воронежская область / Слобода",
    "country": "Россия",
    "searchString": "слобода россия / воронежская область / слобода"
  },
  "10455": {
    "id": "10455",
    "name": "Жерновное",
    "path": "Россия / Липецкая область / Жерновное",
    "country": "Россия",
    "searchString": "жерновное россия / липецкая область / жерновное"
  },
  "10456": {
    "id": "10456",
    "name": "Михайловка (Воронежская область)",
    "path": "Россия / Воронежская область / Михайловка (Воронежская область)",
    "country": "Россия",
    "searchString": "михайловка (воронежская область) россия / воронежская область / михайловка (воронежская область)"
  },
  "10457": {
    "id": "10457",
    "name": "Троицкие Росляи",
    "path": "Россия / Тамбовская область / Троицкие Росляи",
    "country": "Россия",
    "searchString": "троицкие росляи россия / тамбовская область / троицкие росляи"
  },
  "10458": {
    "id": "10458",
    "name": "Валуйчик",
    "path": "Россия / Белгородская область / Валуйчик",
    "country": "Россия",
    "searchString": "валуйчик россия / белгородская область / валуйчик"
  },
  "10459": {
    "id": "10459",
    "name": "Стригуны",
    "path": "Россия / Белгородская область / Стригуны",
    "country": "Россия",
    "searchString": "стригуны россия / белгородская область / стригуны"
  },
  "10460": {
    "id": "10460",
    "name": "Евстратовка",
    "path": "Россия / Воронежская область / Евстратовка",
    "country": "Россия",
    "searchString": "евстратовка россия / воронежская область / евстратовка"
  },
  "10461": {
    "id": "10461",
    "name": "Шаблыкино",
    "path": "Россия / Орловская область / Шаблыкино",
    "country": "Россия",
    "searchString": "шаблыкино россия / орловская область / шаблыкино"
  },
  "10462": {
    "id": "10462",
    "name": "Кудиново",
    "path": "Россия / Калужская область / Кудиново",
    "country": "Россия",
    "searchString": "кудиново россия / калужская область / кудиново"
  },
  "10463": {
    "id": "10463",
    "name": "Рождественское (Тамбовская область)",
    "path": "Россия / Тамбовская область / Рождественское (Тамбовская область)",
    "country": "Россия",
    "searchString": "рождественское (тамбовская область) россия / тамбовская область / рождественское (тамбовская область)"
  },
  "10464": {
    "id": "10464",
    "name": "Вознесеновка (Воронежская область)",
    "path": "Россия / Воронежская область / Вознесеновка (Воронежская область)",
    "country": "Россия",
    "searchString": "вознесеновка (воронежская область) россия / воронежская область / вознесеновка (воронежская область)"
  },
  "10465": {
    "id": "10465",
    "name": "Нижний Ольшан",
    "path": "Россия / Воронежская область / Нижний Ольшан",
    "country": "Россия",
    "searchString": "нижний ольшан россия / воронежская область / нижний ольшан"
  },
  "10466": {
    "id": "10466",
    "name": "Старая Чигла",
    "path": "Россия / Воронежская область / Старая Чигла",
    "country": "Россия",
    "searchString": "старая чигла россия / воронежская область / старая чигла"
  },
  "10467": {
    "id": "10467",
    "name": "Вихляево",
    "path": "Россия / Калужская область / Вихляево",
    "country": "Россия",
    "searchString": "вихляево россия / калужская область / вихляево"
  },
  "10468": {
    "id": "10468",
    "name": "Кривское (Калужская область)",
    "path": "Россия / Калужская область / Кривское (Калужская область)",
    "country": "Россия",
    "searchString": "кривское (калужская область) россия / калужская область / кривское (калужская область)"
  },
  "10469": {
    "id": "10469",
    "name": "Шидловка",
    "path": "Россия / Белгородская область / Шидловка",
    "country": "Россия",
    "searchString": "шидловка россия / белгородская область / шидловка"
  },
  "10470": {
    "id": "10470",
    "name": "Вишневка",
    "path": "Россия / Воронежская область / Вишневка",
    "country": "Россия",
    "searchString": "вишневка россия / воронежская область / вишневка"
  },
  "10471": {
    "id": "10471",
    "name": "Нижний Реутец",
    "path": "Россия / Курская область / Нижний Реутец",
    "country": "Россия",
    "searchString": "нижний реутец россия / курская область / нижний реутец"
  },
  "10472": {
    "id": "10472",
    "name": "Большетроицкое",
    "path": "Россия / Белгородская область / Большетроицкое",
    "country": "Россия",
    "searchString": "большетроицкое россия / белгородская область / большетроицкое"
  },
  "10473": {
    "id": "10473",
    "name": "Хворостянка (Липецкая область)",
    "path": "Россия / Липецкая область / Хворостянка (Липецкая область)",
    "country": "Россия",
    "searchString": "хворостянка (липецкая область) россия / липецкая область / хворостянка (липецкая область)"
  },
  "10474": {
    "id": "10474",
    "name": "Алейниково",
    "path": "Россия / Белгородская область / Алейниково",
    "country": "Россия",
    "searchString": "алейниково россия / белгородская область / алейниково"
  },
  "10475": {
    "id": "10475",
    "name": "Колыбельское",
    "path": "Россия / Липецкая область / Колыбельское",
    "country": "Россия",
    "searchString": "колыбельское россия / липецкая область / колыбельское"
  },
  "10476": {
    "id": "10476",
    "name": "Лискинское",
    "path": "Россия / Воронежская область / Лискинское",
    "country": "Россия",
    "searchString": "лискинское россия / воронежская область / лискинское"
  },
  "10477": {
    "id": "10477",
    "name": "Беломестная Двойня",
    "path": "Россия / Тамбовская область / Беломестная Двойня",
    "country": "Россия",
    "searchString": "беломестная двойня россия / тамбовская область / беломестная двойня"
  },
  "10478": {
    "id": "10478",
    "name": "Поповка (Воронежская область)",
    "path": "Россия / Воронежская область / Поповка (Воронежская область)",
    "country": "Россия",
    "searchString": "поповка (воронежская область) россия / воронежская область / поповка (воронежская область)"
  },
  "10479": {
    "id": "10479",
    "name": "Званное",
    "path": "Россия / Курская область / Званное",
    "country": "Россия",
    "searchString": "званное россия / курская область / званное"
  },
  "10480": {
    "id": "10480",
    "name": "Каменецкий",
    "path": "Россия / Тульская область / Каменецкий",
    "country": "Россия",
    "searchString": "каменецкий россия / тульская область / каменецкий"
  },
  "10481": {
    "id": "10481",
    "name": "Веселая Лопань",
    "path": "Россия / Белгородская область / Веселая Лопань",
    "country": "Россия",
    "searchString": "веселая лопань россия / белгородская область / веселая лопань"
  },
  "10482": {
    "id": "10482",
    "name": "Расховец",
    "path": "Россия / Белгородская область / Расховец",
    "country": "Россия",
    "searchString": "расховец россия / белгородская область / расховец"
  },
  "10483": {
    "id": "10483",
    "name": "Стариково (Белгородская область)",
    "path": "Россия / Белгородская область / Стариково (Белгородская область)",
    "country": "Россия",
    "searchString": "стариково (белгородская область) россия / белгородская область / стариково (белгородская область)"
  },
  "10484": {
    "id": "10484",
    "name": "Урыв-Покровка",
    "path": "Россия / Воронежская область / Урыв-Покровка",
    "country": "Россия",
    "searchString": "урыв-покровка россия / воронежская область / урыв-покровка"
  },
  "10485": {
    "id": "10485",
    "name": "Готовье",
    "path": "Россия / Белгородская область / Готовье",
    "country": "Россия",
    "searchString": "готовье россия / белгородская область / готовье"
  },
  "10486": {
    "id": "10486",
    "name": "Середейский",
    "path": "Россия / Калужская область / Середейский",
    "country": "Россия",
    "searchString": "середейский россия / калужская область / середейский"
  },
  "10487": {
    "id": "10487",
    "name": "Иловай Бригадирское",
    "path": "Россия / Тамбовская область / Иловай Бригадирское",
    "country": "Россия",
    "searchString": "иловай бригадирское россия / тамбовская область / иловай бригадирское"
  },
  "10488": {
    "id": "10488",
    "name": "Ярлуково",
    "path": "Россия / Липецкая область / Ярлуково",
    "country": "Россия",
    "searchString": "ярлуково россия / липецкая область / ярлуково"
  },
  "10489": {
    "id": "10489",
    "name": "Беломестное",
    "path": "Россия / Белгородская область / Беломестное",
    "country": "Россия",
    "searchString": "беломестное россия / белгородская область / беломестное"
  },
  "10490": {
    "id": "10490",
    "name": "Мешковое",
    "path": "Россия / Белгородская область / Мешковое",
    "country": "Россия",
    "searchString": "мешковое россия / белгородская область / мешковое"
  },
  "10491": {
    "id": "10491",
    "name": "Колбино",
    "path": "Россия / Воронежская область / Колбино",
    "country": "Россия",
    "searchString": "колбино россия / воронежская область / колбино"
  },
  "10492": {
    "id": "10492",
    "name": "Моховое (Орловская область)",
    "path": "Россия / Орловская область / Моховое (Орловская область)",
    "country": "Россия",
    "searchString": "моховое (орловская область) россия / орловская область / моховое (орловская область)"
  },
  "10493": {
    "id": "10493",
    "name": "Юдановка",
    "path": "Россия / Воронежская область / Юдановка",
    "country": "Россия",
    "searchString": "юдановка россия / воронежская область / юдановка"
  },
  "10494": {
    "id": "10494",
    "name": "Иващенково",
    "path": "Россия / Белгородская область / Иващенково",
    "country": "Россия",
    "searchString": "иващенково россия / белгородская область / иващенково"
  },
  "10495": {
    "id": "10495",
    "name": "Дедилово",
    "path": "Россия / Тульская область / Дедилово",
    "country": "Россия",
    "searchString": "дедилово россия / тульская область / дедилово"
  },
  "10496": {
    "id": "10496",
    "name": "Семено-Александровка",
    "path": "Россия / Воронежская область / Семено-Александровка",
    "country": "Россия",
    "searchString": "семено-александровка россия / воронежская область / семено-александровка"
  },
  "10497": {
    "id": "10497",
    "name": "Принцевка",
    "path": "Россия / Белгородская область / Принцевка",
    "country": "Россия",
    "searchString": "принцевка россия / белгородская область / принцевка"
  },
  "10498": {
    "id": "10498",
    "name": "Паршиновка",
    "path": "Россия / Липецкая область / Паршиновка",
    "country": "Россия",
    "searchString": "паршиновка россия / липецкая область / паршиновка"
  },
  "10499": {
    "id": "10499",
    "name": "Малакеево",
    "path": "Россия / Белгородская область / Малакеево",
    "country": "Россия",
    "searchString": "малакеево россия / белгородская область / малакеево"
  },
  "10500": {
    "id": "10500",
    "name": "Маринки",
    "path": "Россия / Калужская область / Маринки",
    "country": "Россия",
    "searchString": "маринки россия / калужская область / маринки"
  },
  "10501": {
    "id": "10501",
    "name": "Гатище",
    "path": "Россия / Липецкая область / Гатище",
    "country": "Россия",
    "searchString": "гатище россия / липецкая область / гатище"
  },
  "10502": {
    "id": "10502",
    "name": "Жуково (Белгородская область)",
    "path": "Россия / Белгородская область / Жуково (Белгородская область)",
    "country": "Россия",
    "searchString": "жуково (белгородская область) россия / белгородская область / жуково (белгородская область)"
  },
  "10503": {
    "id": "10503",
    "name": "Большая Липовица",
    "path": "Россия / Тамбовская область / Большая Липовица",
    "country": "Россия",
    "searchString": "большая липовица россия / тамбовская область / большая липовица"
  },
  "10504": {
    "id": "10504",
    "name": "Сергиевское (Орловская область)",
    "path": "Россия / Орловская область / Сергиевское (Орловская область)",
    "country": "Россия",
    "searchString": "сергиевское (орловская область) россия / орловская область / сергиевское (орловская область)"
  },
  "10505": {
    "id": "10505",
    "name": "Урицкое",
    "path": "Россия / Липецкая область / Урицкое",
    "country": "Россия",
    "searchString": "урицкое россия / липецкая область / урицкое"
  },
  "10506": {
    "id": "10506",
    "name": "Апальково",
    "path": "Россия / Орловская область / Апальково",
    "country": "Россия",
    "searchString": "апальково россия / орловская область / апальково"
  },
  "10507": {
    "id": "10507",
    "name": "Гумны",
    "path": "Россия / Тамбовская область / Гумны",
    "country": "Россия",
    "searchString": "гумны россия / тамбовская область / гумны"
  },
  "10508": {
    "id": "10508",
    "name": "Журавка-Первая",
    "path": "Россия / Белгородская область / Журавка-Первая",
    "country": "Россия",
    "searchString": "журавка-первая россия / белгородская область / журавка-первая"
  },
  "10509": {
    "id": "10509",
    "name": "Новогремяченское",
    "path": "Россия / Воронежская область / Новогремяченское",
    "country": "Россия",
    "searchString": "новогремяченское россия / воронежская область / новогремяченское"
  },
  "10510": {
    "id": "10510",
    "name": "Венгеровка",
    "path": "Россия / Белгородская область / Венгеровка",
    "country": "Россия",
    "searchString": "венгеровка россия / белгородская область / венгеровка"
  },
  "10511": {
    "id": "10511",
    "name": "Кучеряевка",
    "path": "Россия / Воронежская область / Кучеряевка",
    "country": "Россия",
    "searchString": "кучеряевка россия / воронежская область / кучеряевка"
  },
  "10512": {
    "id": "10512",
    "name": "Нагольное",
    "path": "Россия / Белгородская область / Нагольное",
    "country": "Россия",
    "searchString": "нагольное россия / белгородская область / нагольное"
  },
  "10513": {
    "id": "10513",
    "name": "Ширинский",
    "path": "Россия / Тульская область / Ширинский",
    "country": "Россия",
    "searchString": "ширинский россия / тульская область / ширинский"
  },
  "10514": {
    "id": "10514",
    "name": "Листопадовка",
    "path": "Россия / Воронежская область / Листопадовка",
    "country": "Россия",
    "searchString": "листопадовка россия / воронежская область / листопадовка"
  },
  "10515": {
    "id": "10515",
    "name": "Криуша (Воронежская область)",
    "path": "Россия / Воронежская область / Криуша (Воронежская область)",
    "country": "Россия",
    "searchString": "криуша (воронежская область) россия / воронежская область / криуша (воронежская область)"
  },
  "10516": {
    "id": "10516",
    "name": "Тростянец (Белгородская область)",
    "path": "Россия / Белгородская область / Тростянец (Белгородская область)",
    "country": "Россия",
    "searchString": "тростянец (белгородская область) россия / белгородская область / тростянец (белгородская область)"
  },
  "10517": {
    "id": "10517",
    "name": "Красное (Калужская область)",
    "path": "Россия / Калужская область / Красное (Калужская область)",
    "country": "Россия",
    "searchString": "красное (калужская область) россия / калужская область / красное (калужская область)"
  },
  "10518": {
    "id": "10518",
    "name": "Филиппенково",
    "path": "Россия / Воронежская область / Филиппенково",
    "country": "Россия",
    "searchString": "филиппенково россия / воронежская область / филиппенково"
  },
  "10519": {
    "id": "10519",
    "name": "Коровяковка",
    "path": "Россия / Курская область / Коровяковка",
    "country": "Россия",
    "searchString": "коровяковка россия / курская область / коровяковка"
  },
  "10520": {
    "id": "10520",
    "name": "Хлевище",
    "path": "Россия / Белгородская область / Хлевище",
    "country": "Россия",
    "searchString": "хлевище россия / белгородская область / хлевище"
  },
  "10521": {
    "id": "10521",
    "name": "Шубное",
    "path": "Россия / Воронежская область / Шубное",
    "country": "Россия",
    "searchString": "шубное россия / воронежская область / шубное"
  },
  "10522": {
    "id": "10522",
    "name": "Ямное",
    "path": "Россия / Воронежская область / Ямное",
    "country": "Россия",
    "searchString": "ямное россия / воронежская область / ямное"
  },
  "10523": {
    "id": "10523",
    "name": "Пашково (Липецкая область)",
    "path": "Россия / Липецкая область / Пашково (Липецкая область)",
    "country": "Россия",
    "searchString": "пашково (липецкая область) россия / липецкая область / пашково (липецкая область)"
  },
  "10524": {
    "id": "10524",
    "name": "Огибное",
    "path": "Россия / Белгородская область / Огибное",
    "country": "Россия",
    "searchString": "огибное россия / белгородская область / огибное"
  },
  "10525": {
    "id": "10525",
    "name": "Магнитный",
    "path": "Россия / Курская область / Магнитный",
    "country": "Россия",
    "searchString": "магнитный россия / курская область / магнитный"
  },
  "10526": {
    "id": "10526",
    "name": "Кошлаково",
    "path": "Россия / Белгородская область / Кошлаково",
    "country": "Россия",
    "searchString": "кошлаково россия / белгородская область / кошлаково"
  },
  "10527": {
    "id": "10527",
    "name": "Тресоруково",
    "path": "Россия / Воронежская область / Тресоруково",
    "country": "Россия",
    "searchString": "тресоруково россия / воронежская область / тресоруково"
  },
  "10528": {
    "id": "10528",
    "name": "Трехстенки",
    "path": "Россия / Воронежская область / Трехстенки",
    "country": "Россия",
    "searchString": "трехстенки россия / воронежская область / трехстенки"
  },
  "10529": {
    "id": "10529",
    "name": "Карай-Салтыково",
    "path": "Россия / Тамбовская область / Карай-Салтыково",
    "country": "Россия",
    "searchString": "карай-салтыково россия / тамбовская область / карай-салтыково"
  },
  "10530": {
    "id": "10530",
    "name": "Старо-Хмелевое",
    "path": "Россия / Тамбовская область / Старо-Хмелевое",
    "country": "Россия",
    "searchString": "старо-хмелевое россия / тамбовская область / старо-хмелевое"
  },
  "10531": {
    "id": "10531",
    "name": "Верхний Карачан",
    "path": "Россия / Воронежская область / Верхний Карачан",
    "country": "Россия",
    "searchString": "верхний карачан россия / воронежская область / верхний карачан"
  },
  "10532": {
    "id": "10532",
    "name": "Куликово (Липецкая область)",
    "path": "Россия / Липецкая область / Куликово (Липецкая область)",
    "country": "Россия",
    "searchString": "куликово (липецкая область) россия / липецкая область / куликово (липецкая область)"
  },
  "10533": {
    "id": "10533",
    "name": "Истобное",
    "path": "Россия / Белгородская область / Истобное",
    "country": "Россия",
    "searchString": "истобное россия / белгородская область / истобное"
  },
  "10534": {
    "id": "10534",
    "name": "Тимоново",
    "path": "Россия / Белгородская область / Тимоново",
    "country": "Россия",
    "searchString": "тимоново россия / белгородская область / тимоново"
  },
  "10535": {
    "id": "10535",
    "name": "Сампур",
    "path": "Россия / Тамбовская область / Сампур",
    "country": "Россия",
    "searchString": "сампур россия / тамбовская область / сампур"
  },
  "10536": {
    "id": "10536",
    "name": "Шапошниковка",
    "path": "Россия / Воронежская область / Шапошниковка",
    "country": "Россия",
    "searchString": "шапошниковка россия / воронежская область / шапошниковка"
  },
  "10537": {
    "id": "10537",
    "name": "Кондрашкино",
    "path": "Россия / Воронежская область / Кондрашкино",
    "country": "Россия",
    "searchString": "кондрашкино россия / воронежская область / кондрашкино"
  },
  "10538": {
    "id": "10538",
    "name": "Третьи Левые Ламки",
    "path": "Россия / Тамбовская область / Третьи Левые Ламки",
    "country": "Россия",
    "searchString": "третьи левые ламки россия / тамбовская область / третьи левые ламки"
  },
  "10539": {
    "id": "10539",
    "name": "Орловка (Воронежская область)",
    "path": "Россия / Воронежская область / Орловка (Воронежская область)",
    "country": "Россия",
    "searchString": "орловка (воронежская область) россия / воронежская область / орловка (воронежская область)"
  },
  "10540": {
    "id": "10540",
    "name": "Русский Брод",
    "path": "Россия / Орловская область / Русский Брод",
    "country": "Россия",
    "searchString": "русский брод россия / орловская область / русский брод"
  },
  "10541": {
    "id": "10541",
    "name": "Тишанка",
    "path": "Россия / Белгородская область / Тишанка",
    "country": "Россия",
    "searchString": "тишанка россия / белгородская область / тишанка"
  },
  "10542": {
    "id": "10542",
    "name": "Харьковское",
    "path": "Россия / Белгородская область / Харьковское",
    "country": "Россия",
    "searchString": "харьковское россия / белгородская область / харьковское"
  },
  "10543": {
    "id": "10543",
    "name": "Перво-Эртиль",
    "path": "Россия / Воронежская область / Перво-Эртиль",
    "country": "Россия",
    "searchString": "перво-эртиль россия / воронежская область / перво-эртиль"
  },
  "10544": {
    "id": "10544",
    "name": "Стегаловка",
    "path": "Россия / Липецкая область / Стегаловка",
    "country": "Россия",
    "searchString": "стегаловка россия / липецкая область / стегаловка"
  },
  "10545": {
    "id": "10545",
    "name": "Новое Грязное",
    "path": "Россия / Тамбовская область / Новое Грязное",
    "country": "Россия",
    "searchString": "новое грязное россия / тамбовская область / новое грязное"
  },
  "10546": {
    "id": "10546",
    "name": "Нижняя Матренка",
    "path": "Россия / Липецкая область / Нижняя Матренка",
    "country": "Россия",
    "searchString": "нижняя матренка россия / липецкая область / нижняя матренка"
  },
  "10547": {
    "id": "10547",
    "name": "Зенино",
    "path": "Россия / Белгородская область / Зенино",
    "country": "Россия",
    "searchString": "зенино россия / белгородская область / зенино"
  },
  "10548": {
    "id": "10548",
    "name": "Верхнее Турово",
    "path": "Россия / Воронежская область / Верхнее Турово",
    "country": "Россия",
    "searchString": "верхнее турово россия / воронежская область / верхнее турово"
  },
  "10549": {
    "id": "10549",
    "name": "Синявка",
    "path": "Россия / Воронежская область / Синявка",
    "country": "Россия",
    "searchString": "синявка россия / воронежская область / синявка"
  },
  "10550": {
    "id": "10550",
    "name": "Трубетчино",
    "path": "Россия / Липецкая область / Трубетчино",
    "country": "Россия",
    "searchString": "трубетчино россия / липецкая область / трубетчино"
  },
  "10551": {
    "id": "10551",
    "name": "Дросково",
    "path": "Россия / Орловская область / Дросково",
    "country": "Россия",
    "searchString": "дросково россия / орловская область / дросково"
  },
  "10552": {
    "id": "10552",
    "name": "Старосеславино",
    "path": "Россия / Тамбовская область / Старосеславино",
    "country": "Россия",
    "searchString": "старосеславино россия / тамбовская область / старосеславино"
  },
  "10553": {
    "id": "10553",
    "name": "Ездочное",
    "path": "Россия / Белгородская область / Ездочное",
    "country": "Россия",
    "searchString": "ездочное россия / белгородская область / ездочное"
  },
  "10554": {
    "id": "10554",
    "name": "Серповое",
    "path": "Россия / Тамбовская область / Серповое",
    "country": "Россия",
    "searchString": "серповое россия / тамбовская область / серповое"
  },
  "10555": {
    "id": "10555",
    "name": "Караяшник",
    "path": "Россия / Воронежская область / Караяшник",
    "country": "Россия",
    "searchString": "караяшник россия / воронежская область / караяшник"
  },
  "10556": {
    "id": "10556",
    "name": "Беленькое",
    "path": "Россия / Белгородская область / Беленькое",
    "country": "Россия",
    "searchString": "беленькое россия / белгородская область / беленькое"
  },
  "10557": {
    "id": "10557",
    "name": "Большой Самовец",
    "path": "Россия / Воронежская область / Большой Самовец",
    "country": "Россия",
    "searchString": "большой самовец россия / воронежская область / большой самовец"
  },
  "10558": {
    "id": "10558",
    "name": "Сейм",
    "path": "Россия / Курская область / Сейм",
    "country": "Россия",
    "searchString": "сейм россия / курская область / сейм"
  },
  "10559": {
    "id": "10559",
    "name": "Клименки",
    "path": "Россия / Белгородская область / Клименки",
    "country": "Россия",
    "searchString": "клименки россия / белгородская область / клименки"
  },
  "10560": {
    "id": "10560",
    "name": "Чащино",
    "path": "Россия / Тамбовская область / Чащино",
    "country": "Россия",
    "searchString": "чащино россия / тамбовская область / чащино"
  },
  "10561": {
    "id": "10561",
    "name": "Знаменка-1",
    "path": "Россия / Тульская область / Знаменка-1",
    "country": "Россия",
    "searchString": "знаменка-1 россия / тульская область / знаменка-1"
  },
  "10562": {
    "id": "10562",
    "name": "Возы",
    "path": "Россия / Курская область / Возы",
    "country": "Россия",
    "searchString": "возы россия / курская область / возы"
  },
  "10563": {
    "id": "10563",
    "name": "Нижний Карачан",
    "path": "Россия / Воронежская область / Нижний Карачан",
    "country": "Россия",
    "searchString": "нижний карачан россия / воронежская область / нижний карачан"
  },
  "10564": {
    "id": "10564",
    "name": "Алейский",
    "path": "Россия / Калужская область / Алейский",
    "country": "Россия",
    "searchString": "алейский россия / калужская область / алейский"
  },
  "10565": {
    "id": "10565",
    "name": "Черемошны",
    "path": "Россия / Орловская область / Черемошны",
    "country": "Россия",
    "searchString": "черемошны россия / орловская область / черемошны"
  },
  "10566": {
    "id": "10566",
    "name": "Никольское-1-е",
    "path": "Россия / Воронежская область / Никольское-1-е",
    "country": "Россия",
    "searchString": "никольское-1-е россия / воронежская область / никольское-1-е"
  },
  "10567": {
    "id": "10567",
    "name": "Роговатое",
    "path": "Россия / Белгородская область / Роговатое",
    "country": "Россия",
    "searchString": "роговатое россия / белгородская область / роговатое"
  },
  "10568": {
    "id": "10568",
    "name": "Победа (Калужская область)",
    "path": "Россия / Калужская область / Победа (Калужская область)",
    "country": "Россия",
    "searchString": "победа (калужская область) россия / калужская область / победа (калужская область)"
  },
  "10569": {
    "id": "10569",
    "name": "Ивановка (Белгородская область)",
    "path": "Россия / Белгородская область / Ивановка (Белгородская область)",
    "country": "Россия",
    "searchString": "ивановка (белгородская область) россия / белгородская область / ивановка (белгородская область)"
  },
  "10570": {
    "id": "10570",
    "name": "Щучинские-Пески",
    "path": "Россия / Воронежская область / Щучинские-Пески",
    "country": "Россия",
    "searchString": "щучинские-пески россия / воронежская область / щучинские-пески"
  },
  "10571": {
    "id": "10571",
    "name": "Первоавгустовский",
    "path": "Россия / Курская область / Первоавгустовский",
    "country": "Россия",
    "searchString": "первоавгустовский россия / курская область / первоавгустовский"
  },
  "10572": {
    "id": "10572",
    "name": "Куймань",
    "path": "Россия / Липецкая область / Куймань",
    "country": "Россия",
    "searchString": "куймань россия / липецкая область / куймань"
  },
  "10573": {
    "id": "10573",
    "name": "Оскольское",
    "path": "Россия / Белгородская область / Оскольское",
    "country": "Россия",
    "searchString": "оскольское россия / белгородская область / оскольское"
  },
  "10574": {
    "id": "10574",
    "name": "Шестаково (Воронежская область)",
    "path": "Россия / Воронежская область / Шестаково (Воронежская область)",
    "country": "Россия",
    "searchString": "шестаково (воронежская область) россия / воронежская область / шестаково (воронежская область)"
  },
  "10575": {
    "id": "10575",
    "name": "Гуево",
    "path": "Россия / Курская область / Гуево",
    "country": "Россия",
    "searchString": "гуево россия / курская область / гуево"
  },
  "10576": {
    "id": "10576",
    "name": "Верхне-Спасское",
    "path": "Россия / Тамбовская область / Верхне-Спасское",
    "country": "Россия",
    "searchString": "верхне-спасское россия / тамбовская область / верхне-спасское"
  },
  "10577": {
    "id": "10577",
    "name": "Викторополь",
    "path": "Россия / Белгородская область / Викторополь",
    "country": "Россия",
    "searchString": "викторополь россия / белгородская область / викторополь"
  },
  "10578": {
    "id": "10578",
    "name": "Малые Кулики",
    "path": "Россия / Тамбовская область / Малые Кулики",
    "country": "Россия",
    "searchString": "малые кулики россия / тамбовская область / малые кулики"
  },
  "10579": {
    "id": "10579",
    "name": "Новобелая",
    "path": "Россия / Воронежская область / Новобелая",
    "country": "Россия",
    "searchString": "новобелая россия / воронежская область / новобелая"
  },
  "10580": {
    "id": "10580",
    "name": "Копыл",
    "path": "Россия / Воронежская область / Копыл",
    "country": "Россия",
    "searchString": "копыл россия / воронежская область / копыл"
  },
  "10581": {
    "id": "10581",
    "name": "Касьяновка",
    "path": "Россия / Воронежская область / Касьяновка",
    "country": "Россия",
    "searchString": "касьяновка россия / воронежская область / касьяновка"
  },
  "10582": {
    "id": "10582",
    "name": "Новокасторное",
    "path": "Россия / Курская область / Новокасторное",
    "country": "Россия",
    "searchString": "новокасторное россия / курская область / новокасторное"
  },
  "10583": {
    "id": "10583",
    "name": "Березовка (Воронежская область)",
    "path": "Россия / Воронежская область / Березовка (Воронежская область)",
    "country": "Россия",
    "searchString": "березовка (воронежская область) россия / воронежская область / березовка (воронежская область)"
  },
  "10584": {
    "id": "10584",
    "name": "Глазок",
    "path": "Россия / Тамбовская область / Глазок",
    "country": "Россия",
    "searchString": "глазок россия / тамбовская область / глазок"
  },
  "10585": {
    "id": "10585",
    "name": "Засосна",
    "path": "Россия / Белгородская область / Засосна",
    "country": "Россия",
    "searchString": "засосна россия / белгородская область / засосна"
  },
  "10586": {
    "id": "10586",
    "name": "Красное (Белгородская область)",
    "path": "Россия / Белгородская область / Красное (Белгородская область)",
    "country": "Россия",
    "searchString": "красное (белгородская область) россия / белгородская область / красное (белгородская область)"
  },
  "10587": {
    "id": "10587",
    "name": "Новосолдатка",
    "path": "Россия / Воронежская область / Новосолдатка",
    "country": "Россия",
    "searchString": "новосолдатка россия / воронежская область / новосолдатка"
  },
  "10588": {
    "id": "10588",
    "name": "Бахарево",
    "path": "Россия / Тамбовская область / Бахарево",
    "country": "Россия",
    "searchString": "бахарево россия / тамбовская область / бахарево"
  },
  "10589": {
    "id": "10589",
    "name": "Афанасово",
    "path": "Россия / Белгородская область / Афанасово",
    "country": "Россия",
    "searchString": "афанасово россия / белгородская область / афанасово"
  },
  "10590": {
    "id": "10590",
    "name": "Высокиничи",
    "path": "Россия / Калужская область / Высокиничи",
    "country": "Россия",
    "searchString": "высокиничи россия / калужская область / высокиничи"
  },
  "10591": {
    "id": "10591",
    "name": "2-я Гавриловка",
    "path": "Россия / Тамбовская область / 2-я Гавриловка",
    "country": "Россия",
    "searchString": "2-я гавриловка россия / тамбовская область / 2-я гавриловка"
  },
  "10592": {
    "id": "10592",
    "name": "Октябрьский (Белгородская область)",
    "path": "Россия / Белгородская область / Октябрьский (Белгородская область)",
    "country": "Россия",
    "searchString": "октябрьский (белгородская область) россия / белгородская область / октябрьский (белгородская область)"
  },
  "10593": {
    "id": "10593",
    "name": "Верхняя Мосоловка",
    "path": "Россия / Липецкая область / Верхняя Мосоловка",
    "country": "Россия",
    "searchString": "верхняя мосоловка россия / липецкая область / верхняя мосоловка"
  },
  "10594": {
    "id": "10594",
    "name": "Искра (Калужская область)",
    "path": "Россия / Калужская область / Искра (Калужская область)",
    "country": "Россия",
    "searchString": "искра (калужская область) россия / калужская область / искра (калужская область)"
  },
  "10595": {
    "id": "10595",
    "name": "Верхний Икорец",
    "path": "Россия / Воронежская область / Верхний Икорец",
    "country": "Россия",
    "searchString": "верхний икорец россия / воронежская область / верхний икорец"
  },
  "10596": {
    "id": "10596",
    "name": "Росстани",
    "path": "Россия / Орловская область / Росстани",
    "country": "Россия",
    "searchString": "росстани россия / орловская область / росстани"
  },
  "10597": {
    "id": "10597",
    "name": "Мужичье",
    "path": "Россия / Воронежская область / Мужичье",
    "country": "Россия",
    "searchString": "мужичье россия / воронежская область / мужичье"
  },
  "10598": {
    "id": "10598",
    "name": "Новая Калитва",
    "path": "Россия / Воронежская область / Новая Калитва",
    "country": "Россия",
    "searchString": "новая калитва россия / воронежская область / новая калитва"
  },
  "10599": {
    "id": "10599",
    "name": "Александровка Донская",
    "path": "Россия / Воронежская область / Александровка Донская",
    "country": "Россия",
    "searchString": "александровка донская россия / воронежская область / александровка донская"
  },
  "10600": {
    "id": "10600",
    "name": "Байчурово",
    "path": "Россия / Воронежская область / Байчурово",
    "country": "Россия",
    "searchString": "байчурово россия / воронежская область / байчурово"
  },
  "10601": {
    "id": "10601",
    "name": "Сосково",
    "path": "Россия / Орловская область / Сосково",
    "country": "Россия",
    "searchString": "сосково россия / орловская область / сосково"
  },
  "10602": {
    "id": "10602",
    "name": "Волотово",
    "path": "Россия / Белгородская область / Волотово",
    "country": "Россия",
    "searchString": "волотово россия / белгородская область / волотово"
  },
  "10603": {
    "id": "10603",
    "name": "Хреновое",
    "path": "Россия / Воронежская область / Хреновое",
    "country": "Россия",
    "searchString": "хреновое россия / воронежская область / хреновое"
  },
  "10604": {
    "id": "10604",
    "name": "Стрельцы",
    "path": "Россия / Тамбовская область / Стрельцы",
    "country": "Россия",
    "searchString": "стрельцы россия / тамбовская область / стрельцы"
  },
  "10605": {
    "id": "10605",
    "name": "Старая Калитва",
    "path": "Россия / Воронежская область / Старая Калитва",
    "country": "Россия",
    "searchString": "старая калитва россия / воронежская область / старая калитва"
  },
  "10606": {
    "id": "10606",
    "name": "Моисеево-Алабушка",
    "path": "Россия / Тамбовская область / Моисеево-Алабушка",
    "country": "Россия",
    "searchString": "моисеево-алабушка россия / тамбовская область / моисеево-алабушка"
  },
  "10607": {
    "id": "10607",
    "name": "Конь-Колодезь",
    "path": "Россия / Липецкая область / Конь-Колодезь",
    "country": "Россия",
    "searchString": "конь-колодезь россия / липецкая область / конь-колодезь"
  },
  "10608": {
    "id": "10608",
    "name": "Карайчевка",
    "path": "Россия / Воронежская область / Карайчевка",
    "country": "Россия",
    "searchString": "карайчевка россия / воронежская область / карайчевка"
  },
  "10609": {
    "id": "10609",
    "name": "Марково (Орловская область)",
    "path": "Россия / Орловская область / Марково (Орловская область)",
    "country": "Россия",
    "searchString": "марково (орловская область) россия / орловская область / марково (орловская область)"
  },
  "10610": {
    "id": "10610",
    "name": "Средняя Матренка",
    "path": "Россия / Липецкая область / Средняя Матренка",
    "country": "Россия",
    "searchString": "средняя матренка россия / липецкая область / средняя матренка"
  },
  "10611": {
    "id": "10611",
    "name": "Новоалександровка",
    "path": "Россия / Белгородская область / Новоалександровка",
    "country": "Россия",
    "searchString": "новоалександровка россия / белгородская область / новоалександровка"
  },
  "10612": {
    "id": "10612",
    "name": "Новая Таволжанка",
    "path": "Россия / Белгородская область / Новая Таволжанка",
    "country": "Россия",
    "searchString": "новая таволжанка россия / белгородская область / новая таволжанка"
  },
  "10613": {
    "id": "10613",
    "name": "Олымский",
    "path": "Россия / Курская область / Олымский",
    "country": "Россия",
    "searchString": "олымский россия / курская область / олымский"
  },
  "10614": {
    "id": "10614",
    "name": "Большебыково",
    "path": "Россия / Белгородская область / Большебыково",
    "country": "Россия",
    "searchString": "большебыково россия / белгородская область / большебыково"
  },
  "10615": {
    "id": "10615",
    "name": "Бехтеевка",
    "path": "Россия / Белгородская область / Бехтеевка",
    "country": "Россия",
    "searchString": "бехтеевка россия / белгородская область / бехтеевка"
  },
  "10616": {
    "id": "10616",
    "name": "Новая Чигла",
    "path": "Россия / Воронежская область / Новая Чигла",
    "country": "Россия",
    "searchString": "новая чигла россия / воронежская область / новая чигла"
  },
  "10617": {
    "id": "10617",
    "name": "Писаревка (Воронежская область)",
    "path": "Россия / Воронежская область / Писаревка (Воронежская область)",
    "country": "Россия",
    "searchString": "писаревка (воронежская область) россия / воронежская область / писаревка (воронежская область)"
  },
  "10618": {
    "id": "10618",
    "name": "Возрождение",
    "path": "Россия / Саратовская область / Возрождение",
    "country": "Россия",
    "searchString": "возрождение россия / саратовская область / возрождение"
  },
  "10619": {
    "id": "10619",
    "name": "Мичурино",
    "path": "Россия / Республика Мордовия / Мичурино",
    "country": "Россия",
    "searchString": "мичурино россия / республика мордовия / мичурино"
  },
  "10620": {
    "id": "10620",
    "name": "Лабазы",
    "path": "Россия / Оренбургская область / Лабазы",
    "country": "Россия",
    "searchString": "лабазы россия / оренбургская область / лабазы"
  },
  "10621": {
    "id": "10621",
    "name": "Рамзай",
    "path": "Россия / Пензенская область / Рамзай",
    "country": "Россия",
    "searchString": "рамзай россия / пензенская область / рамзай"
  },
  "10622": {
    "id": "10622",
    "name": "Красный Текстильщик",
    "path": "Россия / Саратовская область / Красный Текстильщик",
    "country": "Россия",
    "searchString": "красный текстильщик россия / саратовская область / красный текстильщик"
  },
  "10623": {
    "id": "10623",
    "name": "Баевка",
    "path": "Россия / Ульяновская область / Баевка",
    "country": "Россия",
    "searchString": "баевка россия / ульяновская область / баевка"
  },
  "10624": {
    "id": "10624",
    "name": "Куриловка",
    "path": "Россия / Саратовская область / Куриловка",
    "country": "Россия",
    "searchString": "куриловка россия / саратовская область / куриловка"
  },
  "10625": {
    "id": "10625",
    "name": "Шилан",
    "path": "Россия / Самарская область / Шилан",
    "country": "Россия",
    "searchString": "шилан россия / самарская область / шилан"
  },
  "10626": {
    "id": "10626",
    "name": "Березовка (Саратовская область)",
    "path": "Россия / Саратовская область / Березовка (Саратовская область)",
    "country": "Россия",
    "searchString": "березовка (саратовская область) россия / саратовская область / березовка (саратовская область)"
  },
  "10627": {
    "id": "10627",
    "name": "Красная Глинка",
    "path": "Россия / Самарская область / Красная Глинка",
    "country": "Россия",
    "searchString": "красная глинка россия / самарская область / красная глинка"
  },
  "10628": {
    "id": "10628",
    "name": "Сабур-Мачкасы",
    "path": "Россия / Республика Мордовия / Сабур-Мачкасы",
    "country": "Россия",
    "searchString": "сабур-мачкасы россия / республика мордовия / сабур-мачкасы"
  },
  "10629": {
    "id": "10629",
    "name": "Шняево",
    "path": "Россия / Саратовская область / Шняево",
    "country": "Россия",
    "searchString": "шняево россия / саратовская область / шняево"
  },
  "10630": {
    "id": "10630",
    "name": "Коржевка",
    "path": "Россия / Ульяновская область / Коржевка",
    "country": "Россия",
    "searchString": "коржевка россия / ульяновская область / коржевка"
  },
  "10631": {
    "id": "10631",
    "name": "Славкино",
    "path": "Россия / Ульяновская область / Славкино",
    "country": "Россия",
    "searchString": "славкино россия / ульяновская область / славкино"
  },
  "10632": {
    "id": "10632",
    "name": "Хилково",
    "path": "Россия / Самарская область / Хилково",
    "country": "Россия",
    "searchString": "хилково россия / самарская область / хилково"
  },
  "10633": {
    "id": "10633",
    "name": "Черновский",
    "path": "Россия / Самарская область / Черновский",
    "country": "Россия",
    "searchString": "черновский россия / самарская область / черновский"
  },
  "10634": {
    "id": "10634",
    "name": "Корсаевка",
    "path": "Россия / Пензенская область / Корсаевка",
    "country": "Россия",
    "searchString": "корсаевка россия / пензенская область / корсаевка"
  },
  "10635": {
    "id": "10635",
    "name": "Ардатово",
    "path": "Россия / Республика Мордовия / Ардатово",
    "country": "Россия",
    "searchString": "ардатово россия / республика мордовия / ардатово"
  },
  "10636": {
    "id": "10636",
    "name": "Старомукменево",
    "path": "Россия / Оренбургская область / Старомукменево",
    "country": "Россия",
    "searchString": "старомукменево россия / оренбургская область / старомукменево"
  },
  "10637": {
    "id": "10637",
    "name": "Казачка",
    "path": "Россия / Саратовская область / Казачка",
    "country": "Россия",
    "searchString": "казачка россия / саратовская область / казачка"
  },
  "10638": {
    "id": "10638",
    "name": "Гамалеевка-1",
    "path": "Россия / Оренбургская область / Гамалеевка-1",
    "country": "Россия",
    "searchString": "гамалеевка-1 россия / оренбургская область / гамалеевка-1"
  },
  "10639": {
    "id": "10639",
    "name": "Наскафтым",
    "path": "Россия / Пензенская область / Наскафтым",
    "country": "Россия",
    "searchString": "наскафтым россия / пензенская область / наскафтым"
  },
  "10640": {
    "id": "10640",
    "name": "Куракино",
    "path": "Россия / Пензенская область / Куракино",
    "country": "Россия",
    "searchString": "куракино россия / пензенская область / куракино"
  },
  "10641": {
    "id": "10641",
    "name": "Красный Строитель",
    "path": "Россия / Самарская область / Красный Строитель",
    "country": "Россия",
    "searchString": "красный строитель россия / самарская область / красный строитель"
  },
  "10642": {
    "id": "10642",
    "name": "Ртищевский",
    "path": "Россия / Саратовская область / Ртищевский",
    "country": "Россия",
    "searchString": "ртищевский россия / саратовская область / ртищевский"
  },
  "10643": {
    "id": "10643",
    "name": "Второе Имангулово",
    "path": "Россия / Оренбургская область / Второе Имангулово",
    "country": "Россия",
    "searchString": "второе имангулово россия / оренбургская область / второе имангулово"
  },
  "10644": {
    "id": "10644",
    "name": "Подстепки",
    "path": "Россия / Самарская область / Подстепки",
    "country": "Россия",
    "searchString": "подстепки россия / самарская область / подстепки"
  },
  "10645": {
    "id": "10645",
    "name": "Сухой Карабулак",
    "path": "Россия / Саратовская область / Сухой Карабулак",
    "country": "Россия",
    "searchString": "сухой карабулак россия / саратовская область / сухой карабулак"
  },
  "10646": {
    "id": "10646",
    "name": "Кемля",
    "path": "Россия / Республика Мордовия / Кемля",
    "country": "Россия",
    "searchString": "кемля россия / республика мордовия / кемля"
  },
  "10647": {
    "id": "10647",
    "name": "Луховка",
    "path": "Россия / Республика Мордовия / Луховка",
    "country": "Россия",
    "searchString": "луховка россия / республика мордовия / луховка"
  },
  "10648": {
    "id": "10648",
    "name": "Маис",
    "path": "Россия / Пензенская область / Маис",
    "country": "Россия",
    "searchString": "маис россия / пензенская область / маис"
  },
  "10649": {
    "id": "10649",
    "name": "Аксаково (Оренбургская область)",
    "path": "Россия / Оренбургская область / Аксаково (Оренбургская область)",
    "country": "Россия",
    "searchString": "аксаково (оренбургская область) россия / оренбургская область / аксаково (оренбургская область)"
  },
  "10650": {
    "id": "10650",
    "name": "Ильмино",
    "path": "Россия / Пензенская область / Ильмино",
    "country": "Россия",
    "searchString": "ильмино россия / пензенская область / ильмино"
  },
  "10651": {
    "id": "10651",
    "name": "Фабричные Выселки",
    "path": "Россия / Ульяновская область / Фабричные Выселки",
    "country": "Россия",
    "searchString": "фабричные выселки россия / ульяновская область / фабричные выселки"
  },
  "10652": {
    "id": "10652",
    "name": "Береговые Сыреси",
    "path": "Россия / Республика Мордовия / Береговые Сыреси",
    "country": "Россия",
    "searchString": "береговые сыреси россия / республика мордовия / береговые сыреси"
  },
  "10653": {
    "id": "10653",
    "name": "Богатырь",
    "path": "Россия / Самарская область / Богатырь",
    "country": "Россия",
    "searchString": "богатырь россия / самарская область / богатырь"
  },
  "10654": {
    "id": "10654",
    "name": "Узморье",
    "path": "Россия / Саратовская область / Узморье",
    "country": "Россия",
    "searchString": "узморье россия / саратовская область / узморье"
  },
  "10655": {
    "id": "10655",
    "name": "Криуши",
    "path": "Россия / Ульяновская область / Криуши",
    "country": "Россия",
    "searchString": "криуши россия / ульяновская область / криуши"
  },
  "10656": {
    "id": "10656",
    "name": "Первокрасное",
    "path": "Россия / Оренбургская область / Первокрасное",
    "country": "Россия",
    "searchString": "первокрасное россия / оренбургская область / первокрасное"
  },
  "10657": {
    "id": "10657",
    "name": "Озерное",
    "path": "Россия / Саратовская область / Озерное",
    "country": "Россия",
    "searchString": "озерное россия / саратовская область / озерное"
  },
  "10658": {
    "id": "10658",
    "name": "Крестово-Городище",
    "path": "Россия / Ульяновская область / Крестово-Городище",
    "country": "Россия",
    "searchString": "крестово-городище россия / ульяновская область / крестово-городище"
  },
  "10659": {
    "id": "10659",
    "name": "Новое Якушкино",
    "path": "Россия / Самарская область / Новое Якушкино",
    "country": "Россия",
    "searchString": "новое якушкино россия / самарская область / новое якушкино"
  },
  "10660": {
    "id": "10660",
    "name": "Лермонтово",
    "path": "Россия / Пензенская область / Лермонтово",
    "country": "Россия",
    "searchString": "лермонтово россия / пензенская область / лермонтово"
  },
  "10661": {
    "id": "10661",
    "name": "Новокуровка (Самарская область)",
    "path": "Россия / Самарская область / Новокуровка (Самарская область)",
    "country": "Россия",
    "searchString": "новокуровка (самарская область) россия / самарская область / новокуровка (самарская область)"
  },
  "10662": {
    "id": "10662",
    "name": "Колояр",
    "path": "Россия / Саратовская область / Колояр",
    "country": "Россия",
    "searchString": "колояр россия / саратовская область / колояр"
  },
  "10663": {
    "id": "10663",
    "name": "Дубровки",
    "path": "Россия / Пензенская область / Дубровки",
    "country": "Россия",
    "searchString": "дубровки россия / пензенская область / дубровки"
  },
  "10664": {
    "id": "10664",
    "name": "Саловка",
    "path": "Россия / Пензенская область / Саловка",
    "country": "Россия",
    "searchString": "саловка россия / пензенская область / саловка"
  },
  "10665": {
    "id": "10665",
    "name": "Пригородное",
    "path": "Россия / Пензенская область / Пригородное",
    "country": "Россия",
    "searchString": "пригородное россия / пензенская область / пригородное"
  },
  "10666": {
    "id": "10666",
    "name": "Большой Карай",
    "path": "Россия / Саратовская область / Большой Карай",
    "country": "Россия",
    "searchString": "большой карай россия / саратовская область / большой карай"
  },
  "10667": {
    "id": "10667",
    "name": "Динамовский",
    "path": "Россия / Саратовская область / Динамовский",
    "country": "Россия",
    "searchString": "динамовский россия / саратовская область / динамовский"
  },
  "10668": {
    "id": "10668",
    "name": "Большие Ремезенки",
    "path": "Россия / Республика Мордовия / Большие Ремезенки",
    "country": "Россия",
    "searchString": "большие ремезенки россия / республика мордовия / большие ремезенки"
  },
  "10669": {
    "id": "10669",
    "name": "Ива",
    "path": "Россия / Пензенская область / Ива",
    "country": "Россия",
    "searchString": "ива россия / пензенская область / ива"
  },
  "10670": {
    "id": "10670",
    "name": "Большая Рязань",
    "path": "Россия / Самарская область / Большая Рязань",
    "country": "Россия",
    "searchString": "большая рязань россия / самарская область / большая рязань"
  },
  "10671": {
    "id": "10671",
    "name": "Богословка",
    "path": "Россия / Пензенская область / Богословка",
    "country": "Россия",
    "searchString": "богословка россия / пензенская область / богословка"
  },
  "10672": {
    "id": "10672",
    "name": "Масленниково",
    "path": "Россия / Самарская область / Масленниково",
    "country": "Россия",
    "searchString": "масленниково россия / самарская область / масленниково"
  },
  "10673": {
    "id": "10673",
    "name": "Новоникольское",
    "path": "Россия / Оренбургская область / Новоникольское",
    "country": "Россия",
    "searchString": "новоникольское россия / оренбургская область / новоникольское"
  },
  "10674": {
    "id": "10674",
    "name": "Домашка",
    "path": "Россия / Самарская область / Домашка",
    "country": "Россия",
    "searchString": "домашка россия / самарская область / домашка"
  },
  "10675": {
    "id": "10675",
    "name": "Черкасское",
    "path": "Россия / Пензенская область / Черкасское",
    "country": "Россия",
    "searchString": "черкасское россия / пензенская область / черкасское"
  },
  "10676": {
    "id": "10676",
    "name": "Грабово",
    "path": "Россия / Пензенская область / Грабово",
    "country": "Россия",
    "searchString": "грабово россия / пензенская область / грабово"
  },
  "10677": {
    "id": "10677",
    "name": "Новодевичье",
    "path": "Россия / Самарская область / Новодевичье",
    "country": "Россия",
    "searchString": "новодевичье россия / самарская область / новодевичье"
  },
  "10678": {
    "id": "10678",
    "name": "Шкуновка",
    "path": "Россия / Оренбургская область / Шкуновка",
    "country": "Россия",
    "searchString": "шкуновка россия / оренбургская область / шкуновка"
  },
  "10679": {
    "id": "10679",
    "name": "Нестеровка",
    "path": "Россия / Оренбургская область / Нестеровка",
    "country": "Россия",
    "searchString": "нестеровка россия / оренбургская область / нестеровка"
  },
  "10680": {
    "id": "10680",
    "name": "Приуральский",
    "path": "Россия / Оренбургская область / Приуральский",
    "country": "Россия",
    "searchString": "приуральский россия / оренбургская область / приуральский"
  },
  "10681": {
    "id": "10681",
    "name": "Уральский (Оренбургская область)",
    "path": "Россия / Оренбургская область / Уральский (Оренбургская область)",
    "country": "Россия",
    "searchString": "уральский (оренбургская область) россия / оренбургская область / уральский (оренбургская область)"
  },
  "10682": {
    "id": "10682",
    "name": "Кинельский",
    "path": "Россия / Оренбургская область / Кинельский",
    "country": "Россия",
    "searchString": "кинельский россия / оренбургская область / кинельский"
  },
  "10683": {
    "id": "10683",
    "name": "Ялга",
    "path": "Россия / Республика Мордовия / Ялга",
    "country": "Россия",
    "searchString": "ялга россия / республика мордовия / ялга"
  },
  "10684": {
    "id": "10684",
    "name": "Студенка",
    "path": "Россия / Пензенская область / Студенка",
    "country": "Россия",
    "searchString": "студенка россия / пензенская область / студенка"
  },
  "10685": {
    "id": "10685",
    "name": "Леплей",
    "path": "Россия / Республика Мордовия / Леплей",
    "country": "Россия",
    "searchString": "леплей россия / республика мордовия / леплей"
  },
  "10686": {
    "id": "10686",
    "name": "Серноводск",
    "path": "Россия / Самарская область / Серноводск",
    "country": "Россия",
    "searchString": "серноводск россия / самарская область / серноводск"
  },
  "10687": {
    "id": "10687",
    "name": "Канадей",
    "path": "Россия / Ульяновская область / Канадей",
    "country": "Россия",
    "searchString": "канадей россия / ульяновская область / канадей"
  },
  "10688": {
    "id": "10688",
    "name": "Аниховка",
    "path": "Россия / Оренбургская область / Аниховка",
    "country": "Россия",
    "searchString": "аниховка россия / оренбургская область / аниховка"
  },
  "10689": {
    "id": "10689",
    "name": "Артемьевка",
    "path": "Россия / Оренбургская область / Артемьевка",
    "country": "Россия",
    "searchString": "артемьевка россия / оренбургская область / артемьевка"
  },
  "10690": {
    "id": "10690",
    "name": "Ширингуши",
    "path": "Россия / Республика Мордовия / Ширингуши",
    "country": "Россия",
    "searchString": "ширингуши россия / республика мордовия / ширингуши"
  },
  "10691": {
    "id": "10691",
    "name": "Кирюшкино",
    "path": "Россия / Оренбургская область / Кирюшкино",
    "country": "Россия",
    "searchString": "кирюшкино россия / оренбургская область / кирюшкино"
  },
  "10692": {
    "id": "10692",
    "name": "Степановка (Переволоцкий район)",
    "path": "Россия / Оренбургская область / Степановка (Переволоцкий район)",
    "country": "Россия",
    "searchString": "степановка (переволоцкий район) россия / оренбургская область / степановка (переволоцкий район)"
  },
  "10693": {
    "id": "10693",
    "name": "Верхний Ломов",
    "path": "Россия / Пензенская область / Верхний Ломов",
    "country": "Россия",
    "searchString": "верхний ломов россия / пензенская область / верхний ломов"
  },
  "10694": {
    "id": "10694",
    "name": "Новопушкинское",
    "path": "Россия / Саратовская область / Новопушкинское",
    "country": "Россия",
    "searchString": "новопушкинское россия / саратовская область / новопушкинское"
  },
  "10695": {
    "id": "10695",
    "name": "Белозерье",
    "path": "Россия / Ульяновская область / Белозерье",
    "country": "Россия",
    "searchString": "белозерье россия / ульяновская область / белозерье"
  },
  "10696": {
    "id": "10696",
    "name": "Большое Маресево",
    "path": "Россия / Республика Мордовия / Большое Маресево",
    "country": "Россия",
    "searchString": "большое маресево россия / республика мордовия / большое маресево"
  },
  "10697": {
    "id": "10697",
    "name": "Красный Гуляй",
    "path": "Россия / Ульяновская область / Красный Гуляй",
    "country": "Россия",
    "searchString": "красный гуляй россия / ульяновская область / красный гуляй"
  },
  "10698": {
    "id": "10698",
    "name": "Лапаз",
    "path": "Россия / Оренбургская область / Лапаз",
    "country": "Россия",
    "searchString": "лапаз россия / оренбургская область / лапаз"
  },
  "10699": {
    "id": "10699",
    "name": "Тепляковка",
    "path": "Россия / Саратовская область / Тепляковка",
    "country": "Россия",
    "searchString": "тепляковка россия / саратовская область / тепляковка"
  },
  "10700": {
    "id": "10700",
    "name": "Ключевка",
    "path": "Россия / Оренбургская область / Ключевка",
    "country": "Россия",
    "searchString": "ключевка россия / оренбургская область / ключевка"
  },
  "10701": {
    "id": "10701",
    "name": "Степановка Вторая",
    "path": "Россия / Оренбургская область / Степановка Вторая",
    "country": "Россия",
    "searchString": "степановка вторая россия / оренбургская область / степановка вторая"
  },
  "10702": {
    "id": "10702",
    "name": "Нижняя Банновка",
    "path": "Россия / Саратовская область / Нижняя Банновка",
    "country": "Россия",
    "searchString": "нижняя банновка россия / саратовская область / нижняя банновка"
  },
  "10703": {
    "id": "10703",
    "name": "Денискино",
    "path": "Россия / Самарская область / Денискино",
    "country": "Россия",
    "searchString": "денискино россия / самарская область / денискино"
  },
  "10704": {
    "id": "10704",
    "name": "Чуфарово",
    "path": "Россия / Ульяновская область / Чуфарово",
    "country": "Россия",
    "searchString": "чуфарово россия / ульяновская область / чуфарово"
  },
  "10705": {
    "id": "10705",
    "name": "Каменский",
    "path": "Россия / Саратовская область / Каменский",
    "country": "Россия",
    "searchString": "каменский россия / саратовская область / каменский"
  },
  "10706": {
    "id": "10706",
    "name": "Нижняя Павловка",
    "path": "Россия / Оренбургская область / Нижняя Павловка",
    "country": "Россия",
    "searchString": "нижняя павловка россия / оренбургская область / нижняя павловка"
  },
  "10707": {
    "id": "10707",
    "name": "Ясашная Ташла",
    "path": "Россия / Ульяновская область / Ясашная Ташла",
    "country": "Россия",
    "searchString": "ясашная ташла россия / ульяновская область / ясашная ташла"
  },
  "10708": {
    "id": "10708",
    "name": "Ольгино (Самарская область)",
    "path": "Россия / Самарская область / Ольгино (Самарская область)",
    "country": "Россия",
    "searchString": "ольгино (самарская область) россия / самарская область / ольгино (самарская область)"
  },
  "10709": {
    "id": "10709",
    "name": "Старое Синдрово",
    "path": "Россия / Республика Мордовия / Старое Синдрово",
    "country": "Россия",
    "searchString": "старое синдрово россия / республика мордовия / старое синдрово"
  },
  "10710": {
    "id": "10710",
    "name": "Колтубанка",
    "path": "Россия / Оренбургская область / Колтубанка",
    "country": "Россия",
    "searchString": "колтубанка россия / оренбургская область / колтубанка"
  },
  "10711": {
    "id": "10711",
    "name": "Девлезеркино",
    "path": "Россия / Самарская область / Девлезеркино",
    "country": "Россия",
    "searchString": "девлезеркино россия / самарская область / девлезеркино"
  },
  "10712": {
    "id": "10712",
    "name": "Державино",
    "path": "Россия / Оренбургская область / Державино",
    "country": "Россия",
    "searchString": "державино россия / оренбургская область / державино"
  },
  "10713": {
    "id": "10713",
    "name": "Подбельск",
    "path": "Россия / Самарская область / Подбельск",
    "country": "Россия",
    "searchString": "подбельск россия / самарская область / подбельск"
  },
  "10714": {
    "id": "10714",
    "name": "Сенной (Саратовская область)",
    "path": "Россия / Саратовская область / Сенной (Саратовская область)",
    "country": "Россия",
    "searchString": "сенной (саратовская область) россия / саратовская область / сенной (саратовская область)"
  },
  "10715": {
    "id": "10715",
    "name": "Емельяновка",
    "path": "Россия / Оренбургская область / Емельяновка",
    "country": "Россия",
    "searchString": "емельяновка россия / оренбургская область / емельяновка"
  },
  "10716": {
    "id": "10716",
    "name": "Пинеровка",
    "path": "Россия / Саратовская область / Пинеровка",
    "country": "Россия",
    "searchString": "пинеровка россия / саратовская область / пинеровка"
  },
  "10717": {
    "id": "10717",
    "name": "Петрохерсонец",
    "path": "Россия / Оренбургская область / Петрохерсонец",
    "country": "Россия",
    "searchString": "петрохерсонец россия / оренбургская область / петрохерсонец"
  },
  "10718": {
    "id": "10718",
    "name": "Пушкинский",
    "path": "Россия / Оренбургская область / Пушкинский",
    "country": "Россия",
    "searchString": "пушкинский россия / оренбургская область / пушкинский"
  },
  "10719": {
    "id": "10719",
    "name": "Новая Кармала",
    "path": "Россия / Самарская область / Новая Кармала",
    "country": "Россия",
    "searchString": "новая кармала россия / самарская область / новая кармала"
  },
  "10720": {
    "id": "10720",
    "name": "Засечное",
    "path": "Россия / Пензенская область / Засечное",
    "country": "Россия",
    "searchString": "засечное россия / пензенская область / засечное"
  },
  "10721": {
    "id": "10721",
    "name": "Бурлыкский",
    "path": "Россия / Оренбургская область / Бурлыкский",
    "country": "Россия",
    "searchString": "бурлыкский россия / оренбургская область / бурлыкский"
  },
  "10722": {
    "id": "10722",
    "name": "Брыковка",
    "path": "Россия / Саратовская область / Брыковка",
    "country": "Россия",
    "searchString": "брыковка россия / саратовская область / брыковка"
  },
  "10723": {
    "id": "10723",
    "name": "Новое Усманово",
    "path": "Россия / Самарская область / Новое Усманово",
    "country": "Россия",
    "searchString": "новое усманово россия / самарская область / новое усманово"
  },
  "10724": {
    "id": "10724",
    "name": "Коммунарский",
    "path": "Россия / Самарская область / Коммунарский",
    "country": "Россия",
    "searchString": "коммунарский россия / самарская область / коммунарский"
  },
  "10725": {
    "id": "10725",
    "name": "Барабановка",
    "path": "Россия / Оренбургская область / Барабановка",
    "country": "Россия",
    "searchString": "барабановка россия / оренбургская область / барабановка"
  },
  "10726": {
    "id": "10726",
    "name": "Ромашкино",
    "path": "Россия / Оренбургская область / Ромашкино",
    "country": "Россия",
    "searchString": "ромашкино россия / оренбургская область / ромашкино"
  },
  "10727": {
    "id": "10727",
    "name": "Большие Ключищи",
    "path": "Россия / Ульяновская область / Большие Ключищи",
    "country": "Россия",
    "searchString": "большие ключищи россия / ульяновская область / большие ключищи"
  },
  "10728": {
    "id": "10728",
    "name": "Новоспасский",
    "path": "Россия / Самарская область / Новоспасский",
    "country": "Россия",
    "searchString": "новоспасский россия / самарская область / новоспасский"
  },
  "10729": {
    "id": "10729",
    "name": "Юдинка",
    "path": "Россия / Оренбургская область / Юдинка",
    "country": "Россия",
    "searchString": "юдинка россия / оренбургская область / юдинка"
  },
  "10730": {
    "id": "10730",
    "name": "Каргино",
    "path": "Россия / Ульяновская область / Каргино",
    "country": "Россия",
    "searchString": "каргино россия / ульяновская область / каргино"
  },
  "10731": {
    "id": "10731",
    "name": "Чубовка",
    "path": "Россия / Самарская область / Чубовка",
    "country": "Россия",
    "searchString": "чубовка россия / самарская область / чубовка"
  },
  "10732": {
    "id": "10732",
    "name": "Шахтный",
    "path": "Россия / Оренбургская область / Шахтный",
    "country": "Россия",
    "searchString": "шахтный россия / оренбургская область / шахтный"
  },
  "10733": {
    "id": "10733",
    "name": "Ленина (Оренбургская область)",
    "path": "Россия / Оренбургская область / Ленина (Оренбургская область)",
    "country": "Россия",
    "searchString": "ленина (оренбургская область) россия / оренбургская область / ленина (оренбургская область)"
  },
  "10734": {
    "id": "10734",
    "name": "Сарай-Гир",
    "path": "Россия / Оренбургская область / Сарай-Гир",
    "country": "Россия",
    "searchString": "сарай-гир россия / оренбургская область / сарай-гир"
  },
  "10735": {
    "id": "10735",
    "name": "Япрынцево",
    "path": "Россия / Оренбургская область / Япрынцево",
    "country": "Россия",
    "searchString": "япрынцево россия / оренбургская область / япрынцево"
  },
  "10736": {
    "id": "10736",
    "name": "Аландское",
    "path": "Россия / Оренбургская область / Аландское",
    "country": "Россия",
    "searchString": "аландское россия / оренбургская область / аландское"
  },
  "10737": {
    "id": "10737",
    "name": "Урено-Карлинское",
    "path": "Россия / Ульяновская область / Урено-Карлинское",
    "country": "Россия",
    "searchString": "урено-карлинское россия / ульяновская область / урено-карлинское"
  },
  "10738": {
    "id": "10738",
    "name": "Лопатино (Пензенская область)",
    "path": "Россия / Пензенская область / Лопатино (Пензенская область)",
    "country": "Россия",
    "searchString": "лопатино (пензенская область) россия / пензенская область / лопатино (пензенская область)"
  },
  "10739": {
    "id": "10739",
    "name": "Ударный",
    "path": "Россия / Республика Мордовия / Ударный",
    "country": "Россия",
    "searchString": "ударный россия / республика мордовия / ударный"
  },
  "10740": {
    "id": "10740",
    "name": "Рощино (Пензенская область)",
    "path": "Россия / Пензенская область / Рощино (Пензенская область)",
    "country": "Россия",
    "searchString": "рощино (пензенская область) россия / пензенская область / рощино (пензенская область)"
  },
  "10741": {
    "id": "10741",
    "name": "Ельники",
    "path": "Россия / Республика Мордовия / Ельники",
    "country": "Россия",
    "searchString": "ельники россия / республика мордовия / ельники"
  },
  "10742": {
    "id": "10742",
    "name": "Струково",
    "path": "Россия / Оренбургская область / Струково",
    "country": "Россия",
    "searchString": "струково россия / оренбургская область / струково"
  },
  "10743": {
    "id": "10743",
    "name": "Шпановка",
    "path": "Россия / Самарская область / Шпановка",
    "country": "Россия",
    "searchString": "шпановка россия / самарская область / шпановка"
  },
  "10744": {
    "id": "10744",
    "name": "Татаро-Никольское",
    "path": "Россия / Пензенская область / Татаро-Никольское",
    "country": "Россия",
    "searchString": "татаро-никольское россия / пензенская область / татаро-никольское"
  },
  "10745": {
    "id": "10745",
    "name": "Новое Ганькино",
    "path": "Россия / Самарская область / Новое Ганькино",
    "country": "Россия",
    "searchString": "новое ганькино россия / самарская область / новое ганькино"
  },
  "10746": {
    "id": "10746",
    "name": "Верхнеигнашкино",
    "path": "Россия / Оренбургская область / Верхнеигнашкино",
    "country": "Россия",
    "searchString": "верхнеигнашкино россия / оренбургская область / верхнеигнашкино"
  },
  "10747": {
    "id": "10747",
    "name": "Никольское-на-Черемшане",
    "path": "Россия / Ульяновская область / Никольское-на-Черемшане",
    "country": "Россия",
    "searchString": "никольское-на-черемшане россия / ульяновская область / никольское-на-черемшане"
  },
  "10748": {
    "id": "10748",
    "name": "Пичевка",
    "path": "Россия / Пензенская область / Пичевка",
    "country": "Россия",
    "searchString": "пичевка россия / пензенская область / пичевка"
  },
  "10749": {
    "id": "10749",
    "name": "Солнечная Поляна",
    "path": "Россия / Самарская область / Солнечная Поляна",
    "country": "Россия",
    "searchString": "солнечная поляна россия / самарская область / солнечная поляна"
  },
  "10750": {
    "id": "10750",
    "name": "Студенец",
    "path": "Россия / Ульяновская область / Студенец",
    "country": "Россия",
    "searchString": "студенец россия / ульяновская область / студенец"
  },
  "10751": {
    "id": "10751",
    "name": "Красная Река",
    "path": "Россия / Ульяновская область / Красная Река",
    "country": "Россия",
    "searchString": "красная река россия / ульяновская область / красная река"
  },
  "10752": {
    "id": "10752",
    "name": "Старая Степановка",
    "path": "Россия / Пензенская область / Старая Степановка",
    "country": "Россия",
    "searchString": "старая степановка россия / пензенская область / старая степановка"
  },
  "10753": {
    "id": "10753",
    "name": "Озерки (Ульяновская область)",
    "path": "Россия / Ульяновская область / Озерки (Ульяновская область)",
    "country": "Россия",
    "searchString": "озерки (ульяновская область) россия / ульяновская область / озерки (ульяновская область)"
  },
  "10754": {
    "id": "10754",
    "name": "Чесноковка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Чесноковка (Оренбургская область)",
    "country": "Россия",
    "searchString": "чесноковка (оренбургская область) россия / оренбургская область / чесноковка (оренбургская область)"
  },
  "10755": {
    "id": "10755",
    "name": "Натальино (Саратовская область)",
    "path": "Россия / Саратовская область / Натальино (Саратовская область)",
    "country": "Россия",
    "searchString": "натальино (саратовская область) россия / саратовская область / натальино (саратовская область)"
  },
  "10756": {
    "id": "10756",
    "name": "Невежкино",
    "path": "Россия / Пензенская область / Невежкино",
    "country": "Россия",
    "searchString": "невежкино россия / пензенская область / невежкино"
  },
  "10757": {
    "id": "10757",
    "name": "Шаховское",
    "path": "Россия / Ульяновская область / Шаховское",
    "country": "Россия",
    "searchString": "шаховское россия / ульяновская область / шаховское"
  },
  "10758": {
    "id": "10758",
    "name": "Августовка",
    "path": "Россия / Самарская область / Августовка",
    "country": "Россия",
    "searchString": "августовка россия / самарская область / августовка"
  },
  "10759": {
    "id": "10759",
    "name": "Елшанка Первая",
    "path": "Россия / Оренбургская область / Елшанка Первая",
    "country": "Россия",
    "searchString": "елшанка первая россия / оренбургская область / елшанка первая"
  },
  "10760": {
    "id": "10760",
    "name": "Погромное",
    "path": "Россия / Оренбургская область / Погромное",
    "country": "Россия",
    "searchString": "погромное россия / оренбургская область / погромное"
  },
  "10761": {
    "id": "10761",
    "name": "Тетюшское",
    "path": "Россия / Ульяновская область / Тетюшское",
    "country": "Россия",
    "searchString": "тетюшское россия / ульяновская область / тетюшское"
  },
  "10762": {
    "id": "10762",
    "name": "Нижнеозерное",
    "path": "Россия / Оренбургская область / Нижнеозерное",
    "country": "Россия",
    "searchString": "нижнеозерное россия / оренбургская область / нижнеозерное"
  },
  "10763": {
    "id": "10763",
    "name": "Каракудук",
    "path": "Россия / Оренбургская область / Каракудук",
    "country": "Россия",
    "searchString": "каракудук россия / оренбургская область / каракудук"
  },
  "10764": {
    "id": "10764",
    "name": "Саполга",
    "path": "Россия / Пензенская область / Саполга",
    "country": "Россия",
    "searchString": "саполга россия / пензенская область / саполга"
  },
  "10765": {
    "id": "10765",
    "name": "Чкаловский (Оренбургская область)",
    "path": "Россия / Оренбургская область / Чкаловский (Оренбургская область)",
    "country": "Россия",
    "searchString": "чкаловский (оренбургская область) россия / оренбургская область / чкаловский (оренбургская область)"
  },
  "10766": {
    "id": "10766",
    "name": "Савруха",
    "path": "Россия / Самарская область / Савруха",
    "country": "Россия",
    "searchString": "савруха россия / самарская область / савруха"
  },
  "10767": {
    "id": "10767",
    "name": "Буранное",
    "path": "Россия / Оренбургская область / Буранное",
    "country": "Россия",
    "searchString": "буранное россия / оренбургская область / буранное"
  },
  "10768": {
    "id": "10768",
    "name": "Сухая Вязовка",
    "path": "Россия / Самарская область / Сухая Вязовка",
    "country": "Россия",
    "searchString": "сухая вязовка россия / самарская область / сухая вязовка"
  },
  "10769": {
    "id": "10769",
    "name": "Придорожный (Самарская область)",
    "path": "Россия / Самарская область / Придорожный (Самарская область)",
    "country": "Россия",
    "searchString": "придорожный (самарская область) россия / самарская область / придорожный (самарская область)"
  },
  "10770": {
    "id": "10770",
    "name": "Благодарное (Оренбургская область)",
    "path": "Россия / Оренбургская область / Благодарное (Оренбургская область)",
    "country": "Россия",
    "searchString": "благодарное (оренбургская область) россия / оренбургская область / благодарное (оренбургская область)"
  },
  "10771": {
    "id": "10771",
    "name": "Первомайское (Саратовская область)",
    "path": "Россия / Саратовская область / Первомайское (Саратовская область)",
    "country": "Россия",
    "searchString": "первомайское (саратовская область) россия / саратовская область / первомайское (саратовская область)"
  },
  "10772": {
    "id": "10772",
    "name": "Красная Горка (Пензенская область)",
    "path": "Россия / Пензенская область / Красная Горка (Пензенская область)",
    "country": "Россия",
    "searchString": "красная горка (пензенская область) россия / пензенская область / красная горка (пензенская область)"
  },
  "10773": {
    "id": "10773",
    "name": "Нижнесакмарский",
    "path": "Россия / Оренбургская область / Нижнесакмарский",
    "country": "Россия",
    "searchString": "нижнесакмарский россия / оренбургская область / нижнесакмарский"
  },
  "10774": {
    "id": "10774",
    "name": "Халилово (Оренбургская область)",
    "path": "Россия / Оренбургская область / Халилово (Оренбургская область)",
    "country": "Россия",
    "searchString": "халилово (оренбургская область) россия / оренбургская область / халилово (оренбургская область)"
  },
  "10775": {
    "id": "10775",
    "name": "Зольное",
    "path": "Россия / Самарская область / Зольное",
    "country": "Россия",
    "searchString": "зольное россия / самарская область / зольное"
  },
  "10776": {
    "id": "10776",
    "name": "Нижний Шкафт",
    "path": "Россия / Пензенская область / Нижний Шкафт",
    "country": "Россия",
    "searchString": "нижний шкафт россия / пензенская область / нижний шкафт"
  },
  "10777": {
    "id": "10777",
    "name": "Гуляево",
    "path": "Россия / Республика Мордовия / Гуляево",
    "country": "Россия",
    "searchString": "гуляево россия / республика мордовия / гуляево"
  },
  "10778": {
    "id": "10778",
    "name": "Свердлово",
    "path": "Россия / Оренбургская область / Свердлово",
    "country": "Россия",
    "searchString": "свердлово россия / оренбургская область / свердлово"
  },
  "10779": {
    "id": "10779",
    "name": "Звезда",
    "path": "Россия / Самарская область / Звезда",
    "country": "Россия",
    "searchString": "звезда россия / самарская область / звезда"
  },
  "10780": {
    "id": "10780",
    "name": "Старое Эштебенькино",
    "path": "Россия / Самарская область / Старое Эштебенькино",
    "country": "Россия",
    "searchString": "старое эштебенькино россия / самарская область / старое эштебенькино"
  },
  "10781": {
    "id": "10781",
    "name": "Выры",
    "path": "Россия / Ульяновская область / Выры",
    "country": "Россия",
    "searchString": "выры россия / ульяновская область / выры"
  },
  "10782": {
    "id": "10782",
    "name": "Родничок",
    "path": "Россия / Саратовская область / Родничок",
    "country": "Россия",
    "searchString": "родничок россия / саратовская область / родничок"
  },
  "10783": {
    "id": "10783",
    "name": "Сара",
    "path": "Россия / Ульяновская область / Сара",
    "country": "Россия",
    "searchString": "сара россия / ульяновская область / сара"
  },
  "10784": {
    "id": "10784",
    "name": "Ночка",
    "path": "Россия / Пензенская область / Ночка",
    "country": "Россия",
    "searchString": "ночка россия / пензенская область / ночка"
  },
  "10785": {
    "id": "10785",
    "name": "Измайлово (Ульяновская область)",
    "path": "Россия / Ульяновская область / Измайлово (Ульяновская область)",
    "country": "Россия",
    "searchString": "измайлово (ульяновская область) россия / ульяновская область / измайлово (ульяновская область)"
  },
  "10786": {
    "id": "10786",
    "name": "Первомайский (Оренбургский район)",
    "path": "Россия / Оренбургская область / Первомайский (Оренбургский район)",
    "country": "Россия",
    "searchString": "первомайский (оренбургский район) россия / оренбургская область / первомайский (оренбургский район)"
  },
  "10787": {
    "id": "10787",
    "name": "Казанская Арчада",
    "path": "Россия / Пензенская область / Казанская Арчада",
    "country": "Россия",
    "searchString": "казанская арчада россия / пензенская область / казанская арчада"
  },
  "10788": {
    "id": "10788",
    "name": "Жигули",
    "path": "Россия / Самарская область / Жигули",
    "country": "Россия",
    "searchString": "жигули россия / самарская область / жигули"
  },
  "10789": {
    "id": "10789",
    "name": "Верхняя Вязовка",
    "path": "Россия / Оренбургская область / Верхняя Вязовка",
    "country": "Россия",
    "searchString": "верхняя вязовка россия / оренбургская область / верхняя вязовка"
  },
  "10790": {
    "id": "10790",
    "name": "Михайловка (Саратовская область)",
    "path": "Россия / Саратовская область / Михайловка (Саратовская область)",
    "country": "Россия",
    "searchString": "михайловка (саратовская область) россия / саратовская область / михайловка (саратовская область)"
  },
  "10791": {
    "id": "10791",
    "name": "Столыпино",
    "path": "Россия / Пензенская область / Столыпино",
    "country": "Россия",
    "searchString": "столыпино россия / пензенская область / столыпино"
  },
  "10792": {
    "id": "10792",
    "name": "Мехзавод",
    "path": "Россия / Самарская область / Мехзавод",
    "country": "Россия",
    "searchString": "мехзавод россия / самарская область / мехзавод"
  },
  "10793": {
    "id": "10793",
    "name": "Заволжский",
    "path": "Россия / Саратовская область / Заволжский",
    "country": "Россия",
    "searchString": "заволжский россия / саратовская область / заволжский"
  },
  "10794": {
    "id": "10794",
    "name": "Бекетовка",
    "path": "Россия / Ульяновская область / Бекетовка",
    "country": "Россия",
    "searchString": "бекетовка россия / ульяновская область / бекетовка"
  },
  "10795": {
    "id": "10795",
    "name": "Кижеватово",
    "path": "Россия / Пензенская область / Кижеватово",
    "country": "Россия",
    "searchString": "кижеватово россия / пензенская область / кижеватово"
  },
  "10796": {
    "id": "10796",
    "name": "Кувак-Никольское",
    "path": "Россия / Пензенская область / Кувак-Никольское",
    "country": "Россия",
    "searchString": "кувак-никольское россия / пензенская область / кувак-никольское"
  },
  "10797": {
    "id": "10797",
    "name": "Кулагино",
    "path": "Россия / Оренбургская область / Кулагино",
    "country": "Россия",
    "searchString": "кулагино россия / оренбургская область / кулагино"
  },
  "10798": {
    "id": "10798",
    "name": "Большой Толкай",
    "path": "Россия / Самарская область / Большой Толкай",
    "country": "Россия",
    "searchString": "большой толкай россия / самарская область / большой толкай"
  },
  "10799": {
    "id": "10799",
    "name": "Анненково",
    "path": "Россия / Республика Мордовия / Анненково",
    "country": "Россия",
    "searchString": "анненково россия / республика мордовия / анненково"
  },
  "10800": {
    "id": "10800",
    "name": "Соколка",
    "path": "Россия / Пензенская область / Соколка",
    "country": "Россия",
    "searchString": "соколка россия / пензенская область / соколка"
  },
  "10801": {
    "id": "10801",
    "name": "Канаевка",
    "path": "Россия / Пензенская область / Канаевка",
    "country": "Россия",
    "searchString": "канаевка россия / пензенская область / канаевка"
  },
  "10802": {
    "id": "10802",
    "name": "Поселок им.Карла Маркса",
    "path": "Россия / Саратовская область / Поселок им.Карла Маркса",
    "country": "Россия",
    "searchString": "поселок им.карла маркса россия / саратовская область / поселок им.карла маркса"
  },
  "10803": {
    "id": "10803",
    "name": "Разномойка",
    "path": "Россия / Оренбургская область / Разномойка",
    "country": "Россия",
    "searchString": "разномойка россия / оренбургская область / разномойка"
  },
  "10804": {
    "id": "10804",
    "name": "Новомусино",
    "path": "Россия / Оренбургская область / Новомусино",
    "country": "Россия",
    "searchString": "новомусино россия / оренбургская область / новомусино"
  },
  "10805": {
    "id": "10805",
    "name": "Падовка",
    "path": "Россия / Самарская область / Падовка",
    "country": "Россия",
    "searchString": "падовка россия / самарская область / падовка"
  },
  "10806": {
    "id": "10806",
    "name": "Орлов Гай",
    "path": "Россия / Саратовская область / Орлов Гай",
    "country": "Россия",
    "searchString": "орлов гай россия / саратовская область / орлов гай"
  },
  "10807": {
    "id": "10807",
    "name": "Дубенский",
    "path": "Россия / Оренбургская область / Дубенский",
    "country": "Россия",
    "searchString": "дубенский россия / оренбургская область / дубенский"
  },
  "10808": {
    "id": "10808",
    "name": "Луганское",
    "path": "Россия / Саратовская область / Луганское",
    "country": "Россия",
    "searchString": "луганское россия / саратовская область / луганское"
  },
  "10809": {
    "id": "10809",
    "name": "Тушна",
    "path": "Россия / Ульяновская область / Тушна",
    "country": "Россия",
    "searchString": "тушна россия / ульяновская область / тушна"
  },
  "10810": {
    "id": "10810",
    "name": "Синенькие",
    "path": "Россия / Саратовская область / Синенькие",
    "country": "Россия",
    "searchString": "синенькие россия / саратовская область / синенькие"
  },
  "10811": {
    "id": "10811",
    "name": "Береговой (Самарская область)",
    "path": "Россия / Самарская область / Береговой (Самарская область)",
    "country": "Россия",
    "searchString": "береговой (самарская область) россия / самарская область / береговой (самарская область)"
  },
  "10812": {
    "id": "10812",
    "name": "Таллы",
    "path": "Россия / Оренбургская область / Таллы",
    "country": "Россия",
    "searchString": "таллы россия / оренбургская область / таллы"
  },
  "10813": {
    "id": "10813",
    "name": "Костино (Оренбургская область)",
    "path": "Россия / Оренбургская область / Костино (Оренбургская область)",
    "country": "Россия",
    "searchString": "костино (оренбургская область) россия / оренбургская область / костино (оренбургская область)"
  },
  "10814": {
    "id": "10814",
    "name": "Липовка (Саратовская область)",
    "path": "Россия / Саратовская область / Липовка (Саратовская область)",
    "country": "Россия",
    "searchString": "липовка (саратовская область) россия / саратовская область / липовка (саратовская область)"
  },
  "10815": {
    "id": "10815",
    "name": "Нижний Гумбет",
    "path": "Россия / Оренбургская область / Нижний Гумбет",
    "country": "Россия",
    "searchString": "нижний гумбет россия / оренбургская область / нижний гумбет"
  },
  "10816": {
    "id": "10816",
    "name": "Акшуат",
    "path": "Россия / Ульяновская область / Акшуат",
    "country": "Россия",
    "searchString": "акшуат россия / ульяновская область / акшуат"
  },
  "10817": {
    "id": "10817",
    "name": "Совхоз Коммунар",
    "path": "Россия / Республика Мордовия / Совхоз Коммунар",
    "country": "Россия",
    "searchString": "совхоз коммунар россия / республика мордовия / совхоз коммунар"
  },
  "10818": {
    "id": "10818",
    "name": "Ленинский (Самарская область)",
    "path": "Россия / Самарская область / Ленинский (Самарская область)",
    "country": "Россия",
    "searchString": "ленинский (самарская область) россия / самарская область / ленинский (самарская область)"
  },
  "10819": {
    "id": "10819",
    "name": "Карасай",
    "path": "Россия / Оренбургская область / Карасай",
    "country": "Россия",
    "searchString": "карасай россия / оренбургская область / карасай"
  },
  "10820": {
    "id": "10820",
    "name": "Дмитриево-Помряскино",
    "path": "Россия / Ульяновская область / Дмитриево-Помряскино",
    "country": "Россия",
    "searchString": "дмитриево-помряскино россия / ульяновская область / дмитриево-помряскино"
  },
  "10821": {
    "id": "10821",
    "name": "Поводимово",
    "path": "Россия / Республика Мордовия / Поводимово",
    "country": "Россия",
    "searchString": "поводимово россия / республика мордовия / поводимово"
  },
  "10822": {
    "id": "10822",
    "name": "Привольное (Оренбургская область)",
    "path": "Россия / Оренбургская область / Привольное (Оренбургская область)",
    "country": "Россия",
    "searchString": "привольное (оренбургская область) россия / оренбургская область / привольное (оренбургская область)"
  },
  "10823": {
    "id": "10823",
    "name": "Архангеловка",
    "path": "Россия / Оренбургская область / Архангеловка",
    "country": "Россия",
    "searchString": "архангеловка россия / оренбургская область / архангеловка"
  },
  "10824": {
    "id": "10824",
    "name": "Рысайкино",
    "path": "Россия / Самарская область / Рысайкино",
    "country": "Россия",
    "searchString": "рысайкино россия / самарская область / рысайкино"
  },
  "10825": {
    "id": "10825",
    "name": "Бороно-Михайловка",
    "path": "Россия / Саратовская область / Бороно-Михайловка",
    "country": "Россия",
    "searchString": "бороно-михайловка россия / саратовская область / бороно-михайловка"
  },
  "10826": {
    "id": "10826",
    "name": "Белогорное",
    "path": "Россия / Саратовская область / Белогорное",
    "country": "Россия",
    "searchString": "белогорное россия / саратовская область / белогорное"
  },
  "10827": {
    "id": "10827",
    "name": "Красносамарское",
    "path": "Россия / Самарская область / Красносамарское",
    "country": "Россия",
    "searchString": "красносамарское россия / самарская область / красносамарское"
  },
  "10828": {
    "id": "10828",
    "name": "Чернозерье",
    "path": "Россия / Пензенская область / Чернозерье",
    "country": "Россия",
    "searchString": "чернозерье россия / пензенская область / чернозерье"
  },
  "10829": {
    "id": "10829",
    "name": "Чкалов",
    "path": "Россия / Оренбургская область / Чкалов",
    "country": "Россия",
    "searchString": "чкалов россия / оренбургская область / чкалов"
  },
  "10830": {
    "id": "10830",
    "name": "Фрунзенский",
    "path": "Россия / Самарская область / Фрунзенский",
    "country": "Россия",
    "searchString": "фрунзенский россия / самарская область / фрунзенский"
  },
  "10831": {
    "id": "10831",
    "name": "Холстовка",
    "path": "Россия / Ульяновская область / Холстовка",
    "country": "Россия",
    "searchString": "холстовка россия / ульяновская область / холстовка"
  },
  "10832": {
    "id": "10832",
    "name": "Перевесинка",
    "path": "Россия / Саратовская область / Перевесинка",
    "country": "Россия",
    "searchString": "перевесинка россия / саратовская область / перевесинка"
  },
  "10833": {
    "id": "10833",
    "name": "Кочкурово (Республика Мордовия)",
    "path": "Россия / Республика Мордовия / Кочкурово (Республика Мордовия)",
    "country": "Россия",
    "searchString": "кочкурово (республика мордовия) россия / республика мордовия / кочкурово (республика мордовия)"
  },
  "10834": {
    "id": "10834",
    "name": "Донецкое",
    "path": "Россия / Оренбургская область / Донецкое",
    "country": "Россия",
    "searchString": "донецкое россия / оренбургская область / донецкое"
  },
  "10835": {
    "id": "10835",
    "name": "Пушкино (Саратовская область)",
    "path": "Россия / Саратовская область / Пушкино (Саратовская область)",
    "country": "Россия",
    "searchString": "пушкино (саратовская область) россия / саратовская область / пушкино (саратовская область)"
  },
  "10836": {
    "id": "10836",
    "name": "Просвет (Самарская область)",
    "path": "Россия / Самарская область / Просвет (Самарская область)",
    "country": "Россия",
    "searchString": "просвет (самарская область) россия / самарская область / просвет (самарская область)"
  },
  "10837": {
    "id": "10837",
    "name": "Головинщино",
    "path": "Россия / Пензенская область / Головинщино",
    "country": "Россия",
    "searchString": "головинщино россия / пензенская область / головинщино"
  },
  "10838": {
    "id": "10838",
    "name": "Болдово",
    "path": "Россия / Республика Мордовия / Болдово",
    "country": "Россия",
    "searchString": "болдово россия / республика мордовия / болдово"
  },
  "10839": {
    "id": "10839",
    "name": "Лопатино (Самарская область)",
    "path": "Россия / Самарская область / Лопатино (Самарская область)",
    "country": "Россия",
    "searchString": "лопатино (самарская область) россия / самарская область / лопатино (самарская область)"
  },
  "10840": {
    "id": "10840",
    "name": "Красносельское (Самарская область)",
    "path": "Россия / Самарская область / Красносельское (Самарская область)",
    "country": "Россия",
    "searchString": "красносельское (самарская область) россия / самарская область / красносельское (самарская область)"
  },
  "10841": {
    "id": "10841",
    "name": "Сагарчин",
    "path": "Россия / Оренбургская область / Сагарчин",
    "country": "Россия",
    "searchString": "сагарчин россия / оренбургская область / сагарчин"
  },
  "10842": {
    "id": "10842",
    "name": "Волжский Утес",
    "path": "Россия / Самарская область / Волжский Утес",
    "country": "Россия",
    "searchString": "волжский утес россия / самарская область / волжский утес"
  },
  "10843": {
    "id": "10843",
    "name": "Ждановка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Ждановка (Оренбургская область)",
    "country": "Россия",
    "searchString": "ждановка (оренбургская область) россия / оренбургская область / ждановка (оренбургская область)"
  },
  "10844": {
    "id": "10844",
    "name": "Подольск (Оренбургская область)",
    "path": "Россия / Оренбургская область / Подольск (Оренбургская область)",
    "country": "Россия",
    "searchString": "подольск (оренбургская область) россия / оренбургская область / подольск (оренбургская область)"
  },
  "10845": {
    "id": "10845",
    "name": "Каменноозерное",
    "path": "Россия / Оренбургская область / Каменноозерное",
    "country": "Россия",
    "searchString": "каменноозерное россия / оренбургская область / каменноозерное"
  },
  "10846": {
    "id": "10846",
    "name": "Зеленая Роща (Ульяновская область)",
    "path": "Россия / Ульяновская область / Зеленая Роща (Ульяновская область)",
    "country": "Россия",
    "searchString": "зеленая роща (ульяновская область) россия / ульяновская область / зеленая роща (ульяновская область)"
  },
  "10847": {
    "id": "10847",
    "name": "Рязаново",
    "path": "Россия / Ульяновская область / Рязаново",
    "country": "Россия",
    "searchString": "рязаново россия / ульяновская область / рязаново"
  },
  "10848": {
    "id": "10848",
    "name": "Широкий Буерак",
    "path": "Россия / Саратовская область / Широкий Буерак",
    "country": "Россия",
    "searchString": "широкий буерак россия / саратовская область / широкий буерак"
  },
  "10849": {
    "id": "10849",
    "name": "Зубочистка Первая",
    "path": "Россия / Оренбургская область / Зубочистка Первая",
    "country": "Россия",
    "searchString": "зубочистка первая россия / оренбургская область / зубочистка первая"
  },
  "10850": {
    "id": "10850",
    "name": "Мочегай",
    "path": "Россия / Оренбургская область / Мочегай",
    "country": "Россия",
    "searchString": "мочегай россия / оренбургская область / мочегай"
  },
  "10851": {
    "id": "10851",
    "name": "Апраксино",
    "path": "Россия / Республика Мордовия / Апраксино",
    "country": "Россия",
    "searchString": "апраксино россия / республика мордовия / апраксино"
  },
  "10852": {
    "id": "10852",
    "name": "Новорудный",
    "path": "Россия / Оренбургская область / Новорудный",
    "country": "Россия",
    "searchString": "новорудный россия / оренбургская область / новорудный"
  },
  "10853": {
    "id": "10853",
    "name": "Титово",
    "path": "Россия / Пензенская область / Титово",
    "country": "Россия",
    "searchString": "титово россия / пензенская область / титово"
  },
  "10854": {
    "id": "10854",
    "name": "Управленческий",
    "path": "Россия / Самарская область / Управленческий",
    "country": "Россия",
    "searchString": "управленческий россия / самарская область / управленческий"
  },
  "10855": {
    "id": "10855",
    "name": "Духовницкое",
    "path": "Россия / Саратовская область / Духовницкое",
    "country": "Россия",
    "searchString": "духовницкое россия / саратовская область / духовницкое"
  },
  "10856": {
    "id": "10856",
    "name": "Хуторка",
    "path": "Россия / Оренбургская область / Хуторка",
    "country": "Россия",
    "searchString": "хуторка россия / оренбургская область / хуторка"
  },
  "10857": {
    "id": "10857",
    "name": "Прибой",
    "path": "Россия / Самарская область / Прибой",
    "country": "Россия",
    "searchString": "прибой россия / самарская область / прибой"
  },
  "10858": {
    "id": "10858",
    "name": "Голубой Факел",
    "path": "Россия / Оренбургская область / Голубой Факел",
    "country": "Россия",
    "searchString": "голубой факел россия / оренбургская область / голубой факел"
  },
  "10859": {
    "id": "10859",
    "name": "Кезьмино",
    "path": "Россия / Ульяновская область / Кезьмино",
    "country": "Россия",
    "searchString": "кезьмино россия / ульяновская область / кезьмино"
  },
  "10860": {
    "id": "10860",
    "name": "Ефимовка",
    "path": "Россия / Оренбургская область / Ефимовка",
    "country": "Россия",
    "searchString": "ефимовка россия / оренбургская область / ефимовка"
  },
  "10861": {
    "id": "10861",
    "name": "Прогресс (Самарская область)",
    "path": "Россия / Самарская область / Прогресс (Самарская область)",
    "country": "Россия",
    "searchString": "прогресс (самарская область) россия / самарская область / прогресс (самарская область)"
  },
  "10862": {
    "id": "10862",
    "name": "Нововасильевка",
    "path": "Россия / Оренбургская область / Нововасильевка",
    "country": "Россия",
    "searchString": "нововасильевка россия / оренбургская область / нововасильевка"
  },
  "10863": {
    "id": "10863",
    "name": "Обшаровка",
    "path": "Россия / Самарская область / Обшаровка",
    "country": "Россия",
    "searchString": "обшаровка россия / самарская область / обшаровка"
  },
  "10864": {
    "id": "10864",
    "name": "Верхняя Маза (Ульяновская область)",
    "path": "Россия / Ульяновская область / Верхняя Маза (Ульяновская область)",
    "country": "Россия",
    "searchString": "верхняя маза (ульяновская область) россия / ульяновская область / верхняя маза (ульяновская область)"
  },
  "10865": {
    "id": "10865",
    "name": "Сосновый Солонец",
    "path": "Россия / Самарская область / Сосновый Солонец",
    "country": "Россия",
    "searchString": "сосновый солонец россия / самарская область / сосновый солонец"
  },
  "10866": {
    "id": "10866",
    "name": "Озерки (Саратовская область)",
    "path": "Россия / Саратовская область / Озерки (Саратовская область)",
    "country": "Россия",
    "searchString": "озерки (саратовская область) россия / саратовская область / озерки (саратовская область)"
  },
  "10867": {
    "id": "10867",
    "name": "Кардаилово",
    "path": "Россия / Оренбургская область / Кардаилово",
    "country": "Россия",
    "searchString": "кардаилово россия / оренбургская область / кардаилово"
  },
  "10868": {
    "id": "10868",
    "name": "Кряжлы",
    "path": "Россия / Оренбургская область / Кряжлы",
    "country": "Россия",
    "searchString": "кряжлы россия / оренбургская область / кряжлы"
  },
  "10869": {
    "id": "10869",
    "name": "Родничный Дол",
    "path": "Россия / Оренбургская область / Родничный Дол",
    "country": "Россия",
    "searchString": "родничный дол россия / оренбургская область / родничный дол"
  },
  "10870": {
    "id": "10870",
    "name": "Староалександровка",
    "path": "Россия / Оренбургская область / Староалександровка",
    "country": "Россия",
    "searchString": "староалександровка россия / оренбургская область / староалександровка"
  },
  "10871": {
    "id": "10871",
    "name": "Индерка",
    "path": "Россия / Пензенская область / Индерка",
    "country": "Россия",
    "searchString": "индерка россия / пензенская область / индерка"
  },
  "10872": {
    "id": "10872",
    "name": "Рубежинский",
    "path": "Россия / Оренбургская область / Рубежинский",
    "country": "Россия",
    "searchString": "рубежинский россия / оренбургская область / рубежинский"
  },
  "10873": {
    "id": "10873",
    "name": "Толкаевка",
    "path": "Россия / Оренбургская область / Толкаевка",
    "country": "Россия",
    "searchString": "толкаевка россия / оренбургская область / толкаевка"
  },
  "10874": {
    "id": "10874",
    "name": "Леонидовка",
    "path": "Россия / Пензенская область / Леонидовка",
    "country": "Россия",
    "searchString": "леонидовка россия / пензенская область / леонидовка"
  },
  "10875": {
    "id": "10875",
    "name": "Новый Буян",
    "path": "Россия / Самарская область / Новый Буян",
    "country": "Россия",
    "searchString": "новый буян россия / самарская область / новый буян"
  },
  "10876": {
    "id": "10876",
    "name": "Клейменовка",
    "path": "Россия / Пензенская область / Клейменовка",
    "country": "Россия",
    "searchString": "клейменовка россия / пензенская область / клейменовка"
  },
  "10877": {
    "id": "10877",
    "name": "Бобровка (Самарская область)",
    "path": "Россия / Самарская область / Бобровка (Самарская область)",
    "country": "Россия",
    "searchString": "бобровка (самарская область) россия / самарская область / бобровка (самарская область)"
  },
  "10878": {
    "id": "10878",
    "name": "Соседка",
    "path": "Россия / Пензенская область / Соседка",
    "country": "Россия",
    "searchString": "соседка россия / пензенская область / соседка"
  },
  "10879": {
    "id": "10879",
    "name": "Березовая Лука",
    "path": "Россия / Саратовская область / Березовая Лука",
    "country": "Россия",
    "searchString": "березовая лука россия / саратовская область / березовая лука"
  },
  "10880": {
    "id": "10880",
    "name": "Сосновая Маза",
    "path": "Россия / Саратовская область / Сосновая Маза",
    "country": "Россия",
    "searchString": "сосновая маза россия / саратовская область / сосновая маза"
  },
  "10881": {
    "id": "10881",
    "name": "Ушинка",
    "path": "Россия / Пензенская область / Ушинка",
    "country": "Россия",
    "searchString": "ушинка россия / пензенская область / ушинка"
  },
  "10882": {
    "id": "10882",
    "name": "Учебный",
    "path": "Россия / Саратовская область / Учебный",
    "country": "Россия",
    "searchString": "учебный россия / саратовская область / учебный"
  },
  "10883": {
    "id": "10883",
    "name": "Палимовка",
    "path": "Россия / Оренбургская область / Палимовка",
    "country": "Россия",
    "searchString": "палимовка россия / оренбургская область / палимовка"
  },
  "10884": {
    "id": "10884",
    "name": "Синодское",
    "path": "Россия / Саратовская область / Синодское",
    "country": "Россия",
    "searchString": "синодское россия / саратовская область / синодское"
  },
  "10885": {
    "id": "10885",
    "name": "Борискино Игар",
    "path": "Россия / Самарская область / Борискино Игар",
    "country": "Россия",
    "searchString": "борискино игар россия / самарская область / борискино игар"
  },
  "10886": {
    "id": "10886",
    "name": "Белое Озеро",
    "path": "Россия / Ульяновская область / Белое Озеро",
    "country": "Россия",
    "searchString": "белое озеро россия / ульяновская область / белое озеро"
  },
  "10887": {
    "id": "10887",
    "name": "Соцземледельский",
    "path": "Россия / Саратовская область / Соцземледельский",
    "country": "Россия",
    "searchString": "соцземледельский россия / саратовская область / соцземледельский"
  },
  "10888": {
    "id": "10888",
    "name": "Степановка (Ташлинский район)",
    "path": "Россия / Оренбургская область / Степановка (Ташлинский район)",
    "country": "Россия",
    "searchString": "степановка (ташлинский район) россия / оренбургская область / степановка (ташлинский район)"
  },
  "10889": {
    "id": "10889",
    "name": "Большая Ижмора",
    "path": "Россия / Пензенская область / Большая Ижмора",
    "country": "Россия",
    "searchString": "большая ижмора россия / пензенская область / большая ижмора"
  },
  "10890": {
    "id": "10890",
    "name": "Степановка (Пензенская область)",
    "path": "Россия / Пензенская область / Степановка (Пензенская область)",
    "country": "Россия",
    "searchString": "степановка (пензенская область) россия / пензенская область / степановка (пензенская область)"
  },
  "10891": {
    "id": "10891",
    "name": "Расково",
    "path": "Россия / Саратовская область / Расково",
    "country": "Россия",
    "searchString": "расково россия / саратовская область / расково"
  },
  "10892": {
    "id": "10892",
    "name": "Ратчино (Оренбургская область)",
    "path": "Россия / Оренбургская область / Ратчино (Оренбургская область)",
    "country": "Россия",
    "searchString": "ратчино (оренбургская область) россия / оренбургская область / ратчино (оренбургская область)"
  },
  "10893": {
    "id": "10893",
    "name": "Бакуры",
    "path": "Россия / Саратовская область / Бакуры",
    "country": "Россия",
    "searchString": "бакуры россия / саратовская область / бакуры"
  },
  "10894": {
    "id": "10894",
    "name": "Поим",
    "path": "Россия / Пензенская область / Поим",
    "country": "Россия",
    "searchString": "поим россия / пензенская область / поим"
  },
  "10895": {
    "id": "10895",
    "name": "Аксенкино",
    "path": "Россия / Оренбургская область / Аксенкино",
    "country": "Россия",
    "searchString": "аксенкино россия / оренбургская область / аксенкино"
  },
  "10896": {
    "id": "10896",
    "name": "Звонаревка",
    "path": "Россия / Саратовская область / Звонаревка",
    "country": "Россия",
    "searchString": "звонаревка россия / саратовская область / звонаревка"
  },
  "10897": {
    "id": "10897",
    "name": "Жадовка",
    "path": "Россия / Ульяновская область / Жадовка",
    "country": "Россия",
    "searchString": "жадовка россия / ульяновская область / жадовка"
  },
  "10898": {
    "id": "10898",
    "name": "Кандабулак",
    "path": "Россия / Самарская область / Кандабулак",
    "country": "Россия",
    "searchString": "кандабулак россия / самарская область / кандабулак"
  },
  "10899": {
    "id": "10899",
    "name": "Октябрьский (Чердаклинский район)",
    "path": "Россия / Ульяновская область / Октябрьский (Чердаклинский район)",
    "country": "Россия",
    "searchString": "октябрьский (чердаклинский район) россия / ульяновская область / октябрьский (чердаклинский район)"
  },
  "10900": {
    "id": "10900",
    "name": "Претория",
    "path": "Россия / Оренбургская область / Претория",
    "country": "Россия",
    "searchString": "претория россия / оренбургская область / претория"
  },
  "10901": {
    "id": "10901",
    "name": "Старый Аманак",
    "path": "Россия / Самарская область / Старый Аманак",
    "country": "Россия",
    "searchString": "старый аманак россия / самарская область / старый аманак"
  },
  "10902": {
    "id": "10902",
    "name": "Герасимовка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Герасимовка (Оренбургская область)",
    "country": "Россия",
    "searchString": "герасимовка (оренбургская область) россия / оренбургская область / герасимовка (оренбургская область)"
  },
  "10903": {
    "id": "10903",
    "name": "Большая Кандарать",
    "path": "Россия / Ульяновская область / Большая Кандарать",
    "country": "Россия",
    "searchString": "большая кандарать россия / ульяновская область / большая кандарать"
  },
  "10904": {
    "id": "10904",
    "name": "Ждамирово",
    "path": "Россия / Ульяновская область / Ждамирово",
    "country": "Россия",
    "searchString": "ждамирово россия / ульяновская область / ждамирово"
  },
  "10905": {
    "id": "10905",
    "name": "Покровская Арчада",
    "path": "Россия / Пензенская область / Покровская Арчада",
    "country": "Россия",
    "searchString": "покровская арчада россия / пензенская область / покровская арчада"
  },
  "10906": {
    "id": "10906",
    "name": "Никульевка",
    "path": "Россия / Пензенская область / Никульевка",
    "country": "Россия",
    "searchString": "никульевка россия / пензенская область / никульевка"
  },
  "10907": {
    "id": "10907",
    "name": "Лямбирь",
    "path": "Россия / Республика Мордовия / Лямбирь",
    "country": "Россия",
    "searchString": "лямбирь россия / республика мордовия / лямбирь"
  },
  "10908": {
    "id": "10908",
    "name": "Тугустемир",
    "path": "Россия / Оренбургская область / Тугустемир",
    "country": "Россия",
    "searchString": "тугустемир россия / оренбургская область / тугустемир"
  },
  "10909": {
    "id": "10909",
    "name": "Ясная Поляна (Оренбургская область)",
    "path": "Россия / Оренбургская область / Ясная Поляна (Оренбургская область)",
    "country": "Россия",
    "searchString": "ясная поляна (оренбургская область) россия / оренбургская область / ясная поляна (оренбургская область)"
  },
  "10910": {
    "id": "10910",
    "name": "Богдановка",
    "path": "Россия / Самарская область / Богдановка",
    "country": "Россия",
    "searchString": "богдановка россия / самарская область / богдановка"
  },
  "10911": {
    "id": "10911",
    "name": "Белоусовка",
    "path": "Россия / Оренбургская область / Белоусовка",
    "country": "Россия",
    "searchString": "белоусовка россия / оренбургская область / белоусовка"
  },
  "10912": {
    "id": "10912",
    "name": "Никитинка",
    "path": "Россия / Самарская область / Никитинка",
    "country": "Россия",
    "searchString": "никитинка россия / самарская область / никитинка"
  },
  "10913": {
    "id": "10913",
    "name": "Большая Елань",
    "path": "Россия / Пензенская область / Большая Елань",
    "country": "Россия",
    "searchString": "большая елань россия / пензенская область / большая елань"
  },
  "10914": {
    "id": "10914",
    "name": "Старая Жуковка",
    "path": "Россия / Саратовская область / Старая Жуковка",
    "country": "Россия",
    "searchString": "старая жуковка россия / саратовская область / старая жуковка"
  },
  "10915": {
    "id": "10915",
    "name": "Тагай",
    "path": "Россия / Ульяновская область / Тагай",
    "country": "Россия",
    "searchString": "тагай россия / ульяновская область / тагай"
  },
  "10916": {
    "id": "10916",
    "name": "Федоровка (Пензенская область)",
    "path": "Россия / Пензенская область / Федоровка (Пензенская область)",
    "country": "Россия",
    "searchString": "федоровка (пензенская область) россия / пензенская область / федоровка (пензенская область)"
  },
  "10917": {
    "id": "10917",
    "name": "Безымянное",
    "path": "Россия / Саратовская область / Безымянное",
    "country": "Россия",
    "searchString": "безымянное россия / саратовская область / безымянное"
  },
  "10918": {
    "id": "10918",
    "name": "Сура (Пензенская область)",
    "path": "Россия / Пензенская область / Сура (Пензенская область)",
    "country": "Россия",
    "searchString": "сура (пензенская область) россия / пензенская область / сура (пензенская область)"
  },
  "10919": {
    "id": "10919",
    "name": "Паницкая",
    "path": "Россия / Саратовская область / Паницкая",
    "country": "Россия",
    "searchString": "паницкая россия / саратовская область / паницкая"
  },
  "10920": {
    "id": "10920",
    "name": "Октябрьский (Радищевский район)",
    "path": "Россия / Ульяновская область / Октябрьский (Радищевский район)",
    "country": "Россия",
    "searchString": "октябрьский (радищевский район) россия / ульяновская область / октябрьский (радищевский район)"
  },
  "10921": {
    "id": "10921",
    "name": "Спиридоновка",
    "path": "Россия / Самарская область / Спиридоновка",
    "country": "Россия",
    "searchString": "спиридоновка россия / самарская область / спиридоновка"
  },
  "10922": {
    "id": "10922",
    "name": "Большие Озерки",
    "path": "Россия / Саратовская область / Большие Озерки",
    "country": "Россия",
    "searchString": "большие озерки россия / саратовская область / большие озерки"
  },
  "10923": {
    "id": "10923",
    "name": "Линевка",
    "path": "Россия / Оренбургская область / Линевка",
    "country": "Россия",
    "searchString": "линевка россия / оренбургская область / линевка"
  },
  "10924": {
    "id": "10924",
    "name": "Новокаменка",
    "path": "Россия / Оренбургская область / Новокаменка",
    "country": "Россия",
    "searchString": "новокаменка россия / оренбургская область / новокаменка"
  },
  "10925": {
    "id": "10925",
    "name": "Золотое",
    "path": "Россия / Саратовская область / Золотое",
    "country": "Россия",
    "searchString": "золотое россия / саратовская область / золотое"
  },
  "10926": {
    "id": "10926",
    "name": "Аргамаково (Пензенская область)",
    "path": "Россия / Пензенская область / Аргамаково (Пензенская область)",
    "country": "Россия",
    "searchString": "аргамаково (пензенская область) россия / пензенская область / аргамаково (пензенская область)"
  },
  "10927": {
    "id": "10927",
    "name": "Явлейка",
    "path": "Россия / Пензенская область / Явлейка",
    "country": "Россия",
    "searchString": "явлейка россия / пензенская область / явлейка"
  },
  "10928": {
    "id": "10928",
    "name": "Владимировка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Владимировка (Оренбургская область)",
    "country": "Россия",
    "searchString": "владимировка (оренбургская область) россия / оренбургская область / владимировка (оренбургская область)"
  },
  "10929": {
    "id": "10929",
    "name": "Панциревка",
    "path": "Россия / Ульяновская область / Панциревка",
    "country": "Россия",
    "searchString": "панциревка россия / ульяновская область / панциревка"
  },
  "10930": {
    "id": "10930",
    "name": "Тепличный",
    "path": "Россия / Саратовская область / Тепличный",
    "country": "Россия",
    "searchString": "тепличный россия / саратовская область / тепличный"
  },
  "10931": {
    "id": "10931",
    "name": "Первомайск (Республика Мордовия)",
    "path": "Россия / Республика Мордовия / Первомайск (Республика Мордовия)",
    "country": "Россия",
    "searchString": "первомайск (республика мордовия) россия / республика мордовия / первомайск (республика мордовия)"
  },
  "10932": {
    "id": "10932",
    "name": "Семеновка (Саратовская область)",
    "path": "Россия / Саратовская область / Семеновка (Саратовская область)",
    "country": "Россия",
    "searchString": "семеновка (саратовская область) россия / саратовская область / семеновка (саратовская область)"
  },
  "10933": {
    "id": "10933",
    "name": "Среднеуранский",
    "path": "Россия / Оренбургская область / Среднеуранский",
    "country": "Россия",
    "searchString": "среднеуранский россия / оренбургская область / среднеуранский"
  },
  "10934": {
    "id": "10934",
    "name": "Пугачевский",
    "path": "Россия / Оренбургская область / Пугачевский",
    "country": "Россия",
    "searchString": "пугачевский россия / оренбургская область / пугачевский"
  },
  "10935": {
    "id": "10935",
    "name": "Алабайтал",
    "path": "Россия / Оренбургская область / Алабайтал",
    "country": "Россия",
    "searchString": "алабайтал россия / оренбургская область / алабайтал"
  },
  "10936": {
    "id": "10936",
    "name": "Пилюгино",
    "path": "Россия / Оренбургская область / Пилюгино",
    "country": "Россия",
    "searchString": "пилюгино россия / оренбургская область / пилюгино"
  },
  "10937": {
    "id": "10937",
    "name": "Нижняя Елюзань",
    "path": "Россия / Пензенская область / Нижняя Елюзань",
    "country": "Россия",
    "searchString": "нижняя елюзань россия / пензенская область / нижняя елюзань"
  },
  "10938": {
    "id": "10938",
    "name": "Татарский Сайман",
    "path": "Россия / Ульяновская область / Татарский Сайман",
    "country": "Россия",
    "searchString": "татарский сайман россия / ульяновская область / татарский сайман"
  },
  "10939": {
    "id": "10939",
    "name": "Старое Шайгово",
    "path": "Россия / Республика Мордовия / Старое Шайгово",
    "country": "Россия",
    "searchString": "старое шайгово россия / республика мордовия / старое шайгово"
  },
  "10940": {
    "id": "10940",
    "name": "Желтое",
    "path": "Россия / Оренбургская область / Желтое",
    "country": "Россия",
    "searchString": "желтое россия / оренбургская область / желтое"
  },
  "10941": {
    "id": "10941",
    "name": "Большое Нагаткино",
    "path": "Россия / Ульяновская область / Большое Нагаткино",
    "country": "Россия",
    "searchString": "большое нагаткино россия / ульяновская область / большое нагаткино"
  },
  "10942": {
    "id": "10942",
    "name": "Подкуровка",
    "path": "Россия / Ульяновская область / Подкуровка",
    "country": "Россия",
    "searchString": "подкуровка россия / ульяновская область / подкуровка"
  },
  "10943": {
    "id": "10943",
    "name": "Советское (Саратовская область)",
    "path": "Россия / Саратовская область / Советское (Саратовская область)",
    "country": "Россия",
    "searchString": "советское (саратовская область) россия / саратовская область / советское (саратовская область)"
  },
  "10944": {
    "id": "10944",
    "name": "Станционно-Ояшинский",
    "path": "Россия / Новосибирская область / Станционно-Ояшинский",
    "country": "Россия",
    "searchString": "станционно-ояшинский россия / новосибирская область / станционно-ояшинский"
  },
  "10945": {
    "id": "10945",
    "name": "Татарский Калмаюр",
    "path": "Россия / Ульяновская область / Татарский Калмаюр",
    "country": "Россия",
    "searchString": "татарский калмаюр россия / ульяновская область / татарский калмаюр"
  },
  "10946": {
    "id": "10946",
    "name": "Студеное (Оренбургская область)",
    "path": "Россия / Оренбургская область / Студеное (Оренбургская область)",
    "country": "Россия",
    "searchString": "студеное (оренбургская область) россия / оренбургская область / студеное (оренбургская область)"
  },
  "10947": {
    "id": "10947",
    "name": "Новожедрино",
    "path": "Россия / Оренбургская область / Новожедрино",
    "country": "Россия",
    "searchString": "новожедрино россия / оренбургская область / новожедрино"
  },
  "10948": {
    "id": "10948",
    "name": "Майское (Самарская область)",
    "path": "Россия / Самарская область / Майское (Самарская область)",
    "country": "Россия",
    "searchString": "майское (самарская область) россия / самарская область / майское (самарская область)"
  },
  "10949": {
    "id": "10949",
    "name": "Колокольцовка",
    "path": "Россия / Саратовская область / Колокольцовка",
    "country": "Россия",
    "searchString": "колокольцовка россия / саратовская область / колокольцовка"
  },
  "10950": {
    "id": "10950",
    "name": "Сластуха",
    "path": "Россия / Саратовская область / Сластуха",
    "country": "Россия",
    "searchString": "сластуха россия / саратовская область / сластуха"
  },
  "10951": {
    "id": "10951",
    "name": "Кирово (Пензенская область)",
    "path": "Россия / Пензенская область / Кирово (Пензенская область)",
    "country": "Россия",
    "searchString": "кирово (пензенская область) россия / пензенская область / кирово (пензенская область)"
  },
  "10952": {
    "id": "10952",
    "name": "Кубанка",
    "path": "Россия / Оренбургская область / Кубанка",
    "country": "Россия",
    "searchString": "кубанка россия / оренбургская область / кубанка"
  },
  "10953": {
    "id": "10953",
    "name": "Покровка (Соль-Илецкий район)",
    "path": "Россия / Оренбургская область / Покровка (Соль-Илецкий район)",
    "country": "Россия",
    "searchString": "покровка (соль-илецкий район) россия / оренбургская область / покровка (соль-илецкий район)"
  },
  "10954": {
    "id": "10954",
    "name": "Нижнекристалка",
    "path": "Россия / Оренбургская область / Нижнекристалка",
    "country": "Россия",
    "searchString": "нижнекристалка россия / оренбургская область / нижнекристалка"
  },
  "10955": {
    "id": "10955",
    "name": "Караванный",
    "path": "Россия / Оренбургская область / Караванный",
    "country": "Россия",
    "searchString": "караванный россия / оренбургская область / караванный"
  },
  "10956": {
    "id": "10956",
    "name": "Покровка (Новосергиевский район)",
    "path": "Россия / Оренбургская область / Покровка (Новосергиевский район)",
    "country": "Россия",
    "searchString": "покровка (новосергиевский район) россия / оренбургская область / покровка (новосергиевский район)"
  },
  "10957": {
    "id": "10957",
    "name": "Старый Чирчим",
    "path": "Россия / Пензенская область / Старый Чирчим",
    "country": "Россия",
    "searchString": "старый чирчим россия / пензенская область / старый чирчим"
  },
  "10958": {
    "id": "10958",
    "name": "Подлесное (Саратовская область)",
    "path": "Россия / Саратовская область / Подлесное (Саратовская область)",
    "country": "Россия",
    "searchString": "подлесное (саратовская область) россия / саратовская область / подлесное (саратовская область)"
  },
  "10959": {
    "id": "10959",
    "name": "Новоякупово",
    "path": "Россия / Оренбургская область / Новоякупово",
    "country": "Россия",
    "searchString": "новоякупово россия / оренбургская область / новоякупово"
  },
  "10960": {
    "id": "10960",
    "name": "Вадинск",
    "path": "Россия / Пензенская область / Вадинск",
    "country": "Россия",
    "searchString": "вадинск россия / пензенская область / вадинск"
  },
  "10961": {
    "id": "10961",
    "name": "Ильмень",
    "path": "Россия / Самарская область / Ильмень",
    "country": "Россия",
    "searchString": "ильмень россия / самарская область / ильмень"
  },
  "10962": {
    "id": "10962",
    "name": "Сергиевка",
    "path": "Россия / Саратовская область / Сергиевка",
    "country": "Россия",
    "searchString": "сергиевка россия / саратовская область / сергиевка"
  },
  "10963": {
    "id": "10963",
    "name": "Черноречье",
    "path": "Россия / Оренбургская область / Черноречье",
    "country": "Россия",
    "searchString": "черноречье россия / оренбургская область / черноречье"
  },
  "10964": {
    "id": "10964",
    "name": "Новые-Выселки",
    "path": "Россия / Саратовская область / Новые-Выселки",
    "country": "Россия",
    "searchString": "новые-выселки россия / саратовская область / новые-выселки"
  },
  "10965": {
    "id": "10965",
    "name": "Черновка",
    "path": "Россия / Самарская область / Черновка",
    "country": "Россия",
    "searchString": "черновка россия / самарская область / черновка"
  },
  "10966": {
    "id": "10966",
    "name": "Труслейка",
    "path": "Россия / Ульяновская область / Труслейка",
    "country": "Россия",
    "searchString": "труслейка россия / ульяновская область / труслейка"
  },
  "10967": {
    "id": "10967",
    "name": "Междуречье (Пензенская область)",
    "path": "Россия / Пензенская область / Междуречье (Пензенская область)",
    "country": "Россия",
    "searchString": "междуречье (пензенская область) россия / пензенская область / междуречье (пензенская область)"
  },
  "10968": {
    "id": "10968",
    "name": "Троицк (Республика Мордовия)",
    "path": "Россия / Республика Мордовия / Троицк (Республика Мордовия)",
    "country": "Россия",
    "searchString": "троицк (республика мордовия) россия / республика мордовия / троицк (республика мордовия)"
  },
  "10969": {
    "id": "10969",
    "name": "Старотимошкино",
    "path": "Россия / Ульяновская область / Старотимошкино",
    "country": "Россия",
    "searchString": "старотимошкино россия / ульяновская область / старотимошкино"
  },
  "10970": {
    "id": "10970",
    "name": "Надеждинка",
    "path": "Россия / Оренбургская область / Надеждинка",
    "country": "Россия",
    "searchString": "надеждинка россия / оренбургская область / надеждинка"
  },
  "10971": {
    "id": "10971",
    "name": "Большая Лука",
    "path": "Россия / Пензенская область / Большая Лука",
    "country": "Россия",
    "searchString": "большая лука россия / пензенская область / большая лука"
  },
  "10972": {
    "id": "10972",
    "name": "Быков Отрог",
    "path": "Россия / Саратовская область / Быков Отрог",
    "country": "Россия",
    "searchString": "быков отрог россия / саратовская область / быков отрог"
  },
  "10973": {
    "id": "10973",
    "name": "Пашково (Пензенская область)",
    "path": "Россия / Пензенская область / Пашково (Пензенская область)",
    "country": "Россия",
    "searchString": "пашково (пензенская область) россия / пензенская область / пашково (пензенская область)"
  },
  "10974": {
    "id": "10974",
    "name": "Георгиевка (Самарская область)",
    "path": "Россия / Самарская область / Георгиевка (Самарская область)",
    "country": "Россия",
    "searchString": "георгиевка (самарская область) россия / самарская область / георгиевка (самарская область)"
  },
  "10975": {
    "id": "10975",
    "name": "Большой Мелик",
    "path": "Россия / Саратовская область / Большой Мелик",
    "country": "Россия",
    "searchString": "большой мелик россия / саратовская область / большой мелик"
  },
  "10976": {
    "id": "10976",
    "name": "Русский Кандыз",
    "path": "Россия / Оренбургская область / Русский Кандыз",
    "country": "Россия",
    "searchString": "русский кандыз россия / оренбургская область / русский кандыз"
  },
  "10977": {
    "id": "10977",
    "name": "Ефаево",
    "path": "Россия / Республика Мордовия / Ефаево",
    "country": "Россия",
    "searchString": "ефаево россия / республика мордовия / ефаево"
  },
  "10978": {
    "id": "10978",
    "name": "Кинзелька",
    "path": "Россия / Оренбургская область / Кинзелька",
    "country": "Россия",
    "searchString": "кинзелька россия / оренбургская область / кинзелька"
  },
  "10979": {
    "id": "10979",
    "name": "Яблоневый Овраг",
    "path": "Россия / Самарская область / Яблоневый Овраг",
    "country": "Россия",
    "searchString": "яблоневый овраг россия / самарская область / яблоневый овраг"
  },
  "10980": {
    "id": "10980",
    "name": "Родинский",
    "path": "Россия / Оренбургская область / Родинский",
    "country": "Россия",
    "searchString": "родинский россия / оренбургская область / родинский"
  },
  "10981": {
    "id": "10981",
    "name": "Сторожевка",
    "path": "Россия / Саратовская область / Сторожевка",
    "country": "Россия",
    "searchString": "сторожевка россия / саратовская область / сторожевка"
  },
  "10982": {
    "id": "10982",
    "name": "Воротнее",
    "path": "Россия / Самарская область / Воротнее",
    "country": "Россия",
    "searchString": "воротнее россия / самарская область / воротнее"
  },
  "10983": {
    "id": "10983",
    "name": "Большой Вьяс",
    "path": "Россия / Пензенская область / Большой Вьяс",
    "country": "Россия",
    "searchString": "большой вьяс россия / пензенская область / большой вьяс"
  },
  "10984": {
    "id": "10984",
    "name": "Зиянчурино",
    "path": "Россия / Оренбургская область / Зиянчурино",
    "country": "Россия",
    "searchString": "зиянчурино россия / оренбургская область / зиянчурино"
  },
  "10985": {
    "id": "10985",
    "name": "Теренсай",
    "path": "Россия / Оренбургская область / Теренсай",
    "country": "Россия",
    "searchString": "теренсай россия / оренбургская область / теренсай"
  },
  "10986": {
    "id": "10986",
    "name": "Лекаревка",
    "path": "Россия / Оренбургская область / Лекаревка",
    "country": "Россия",
    "searchString": "лекаревка россия / оренбургская область / лекаревка"
  },
  "10987": {
    "id": "10987",
    "name": "Акатная Маза",
    "path": "Россия / Саратовская область / Акатная Маза",
    "country": "Россия",
    "searchString": "акатная маза россия / саратовская область / акатная маза"
  },
  "10988": {
    "id": "10988",
    "name": "Новоселки (Ульяновская область)",
    "path": "Россия / Ульяновская область / Новоселки (Ульяновская область)",
    "country": "Россия",
    "searchString": "новоселки (ульяновская область) россия / ульяновская область / новоселки (ульяновская область)"
  },
  "10989": {
    "id": "10989",
    "name": "Подколки",
    "path": "Россия / Оренбургская область / Подколки",
    "country": "Россия",
    "searchString": "подколки россия / оренбургская область / подколки"
  },
  "10990": {
    "id": "10990",
    "name": "Кутузовский",
    "path": "Россия / Самарская область / Кутузовский",
    "country": "Россия",
    "searchString": "кутузовский россия / самарская область / кутузовский"
  },
  "10991": {
    "id": "10991",
    "name": "Ермоловка",
    "path": "Россия / Пензенская область / Ермоловка",
    "country": "Россия",
    "searchString": "ермоловка россия / пензенская область / ермоловка"
  },
  "10992": {
    "id": "10992",
    "name": "Шевыревка",
    "path": "Россия / Саратовская область / Шевыревка",
    "country": "Россия",
    "searchString": "шевыревка россия / саратовская область / шевыревка"
  },
  "10993": {
    "id": "10993",
    "name": "Колтовское",
    "path": "Россия / Пензенская область / Колтовское",
    "country": "Россия",
    "searchString": "колтовское россия / пензенская область / колтовское"
  },
  "10994": {
    "id": "10994",
    "name": "Марьевка (Самарская область)",
    "path": "Россия / Самарская область / Марьевка (Самарская область)",
    "country": "Россия",
    "searchString": "марьевка (самарская область) россия / самарская область / марьевка (самарская область)"
  },
  "10995": {
    "id": "10995",
    "name": "Свищевка",
    "path": "Россия / Пензенская область / Свищевка",
    "country": "Россия",
    "searchString": "свищевка россия / пензенская область / свищевка"
  },
  "10996": {
    "id": "10996",
    "name": "Новая Майна",
    "path": "Россия / Ульяновская область / Новая Майна",
    "country": "Россия",
    "searchString": "новая майна россия / ульяновская область / новая майна"
  },
  "10997": {
    "id": "10997",
    "name": "Ундоры",
    "path": "Россия / Ульяновская область / Ундоры",
    "country": "Россия",
    "searchString": "ундоры россия / ульяновская область / ундоры"
  },
  "10998": {
    "id": "10998",
    "name": "Тимирязево",
    "path": "Россия / Пензенская область / Тимирязево",
    "country": "Россия",
    "searchString": "тимирязево россия / пензенская область / тимирязево"
  },
  "10999": {
    "id": "10999",
    "name": "Новочеремшанск",
    "path": "Россия / Ульяновская область / Новочеремшанск",
    "country": "Россия",
    "searchString": "новочеремшанск россия / ульяновская область / новочеремшанск"
  },
  "11000": {
    "id": "11000",
    "name": "Кирсановка",
    "path": "Россия / Оренбургская область / Кирсановка",
    "country": "Россия",
    "searchString": "кирсановка россия / оренбургская область / кирсановка"
  },
  "11001": {
    "id": "11001",
    "name": "Хватовка",
    "path": "Россия / Саратовская область / Хватовка",
    "country": "Россия",
    "searchString": "хватовка россия / саратовская область / хватовка"
  },
  "11002": {
    "id": "11002",
    "name": "Южный (Самарская область)",
    "path": "Россия / Самарская область / Южный (Самарская область)",
    "country": "Россия",
    "searchString": "южный (самарская область) россия / самарская область / южный (самарская область)"
  },
  "11003": {
    "id": "11003",
    "name": "Старая Сахча",
    "path": "Россия / Ульяновская область / Старая Сахча",
    "country": "Россия",
    "searchString": "старая сахча россия / ульяновская область / старая сахча"
  },
  "11004": {
    "id": "11004",
    "name": "Верхняя Елюзань",
    "path": "Россия / Пензенская область / Верхняя Елюзань",
    "country": "Россия",
    "searchString": "верхняя елюзань россия / пензенская область / верхняя елюзань"
  },
  "11005": {
    "id": "11005",
    "name": "Глушицкий",
    "path": "Россия / Самарская область / Глушицкий",
    "country": "Россия",
    "searchString": "глушицкий россия / самарская область / глушицкий"
  },
  "11006": {
    "id": "11006",
    "name": "Силикатный (Ульяновская область)",
    "path": "Россия / Ульяновская область / Силикатный (Ульяновская область)",
    "country": "Россия",
    "searchString": "силикатный (ульяновская область) россия / ульяновская область / силикатный (ульяновская область)"
  },
  "11007": {
    "id": "11007",
    "name": "Оськино",
    "path": "Россия / Ульяновская область / Оськино",
    "country": "Россия",
    "searchString": "оськино россия / ульяновская область / оськино"
  },
  "11008": {
    "id": "11008",
    "name": "Донгуз",
    "path": "Россия / Саратовская область / Донгуз",
    "country": "Россия",
    "searchString": "донгуз россия / саратовская область / донгуз"
  },
  "11009": {
    "id": "11009",
    "name": "Суворовский",
    "path": "Россия / Оренбургская область / Суворовский",
    "country": "Россия",
    "searchString": "суворовский россия / оренбургская область / суворовский"
  },
  "11010": {
    "id": "11010",
    "name": "Стригай",
    "path": "Россия / Саратовская область / Стригай",
    "country": "Россия",
    "searchString": "стригай россия / саратовская область / стригай"
  },
  "11011": {
    "id": "11011",
    "name": "Ириклинский",
    "path": "Россия / Оренбургская область / Ириклинский",
    "country": "Россия",
    "searchString": "ириклинский россия / оренбургская область / ириклинский"
  },
  "11012": {
    "id": "11012",
    "name": "Валгуссы",
    "path": "Россия / Ульяновская область / Валгуссы",
    "country": "Россия",
    "searchString": "валгуссы россия / ульяновская область / валгуссы"
  },
  "11013": {
    "id": "11013",
    "name": "Тургенево",
    "path": "Россия / Республика Мордовия / Тургенево",
    "country": "Россия",
    "searchString": "тургенево россия / республика мордовия / тургенево"
  },
  "11014": {
    "id": "11014",
    "name": "Пады",
    "path": "Россия / Саратовская область / Пады",
    "country": "Россия",
    "searchString": "пады россия / саратовская область / пады"
  },
  "11015": {
    "id": "11015",
    "name": "Новоалександровка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Новоалександровка (Оренбургская область)",
    "country": "Россия",
    "searchString": "новоалександровка (оренбургская область) россия / оренбургская область / новоалександровка (оренбургская область)"
  },
  "11016": {
    "id": "11016",
    "name": "Чемодановка",
    "path": "Россия / Пензенская область / Чемодановка",
    "country": "Россия",
    "searchString": "чемодановка россия / пензенская область / чемодановка"
  },
  "11017": {
    "id": "11017",
    "name": "Большая Кандала",
    "path": "Россия / Ульяновская область / Большая Кандала",
    "country": "Россия",
    "searchString": "большая кандала россия / ульяновская область / большая кандала"
  },
  "11018": {
    "id": "11018",
    "name": "Алферьевка",
    "path": "Россия / Пензенская область / Алферьевка",
    "country": "Россия",
    "searchString": "алферьевка россия / пензенская область / алферьевка"
  },
  "11019": {
    "id": "11019",
    "name": "Красносельск",
    "path": "Россия / Ульяновская область / Красносельск",
    "country": "Россия",
    "searchString": "красносельск россия / ульяновская область / красносельск"
  },
  "11020": {
    "id": "11020",
    "name": "Золотаревка (Пензенская область)",
    "path": "Россия / Пензенская область / Золотаревка (Пензенская область)",
    "country": "Россия",
    "searchString": "золотаревка (пензенская область) россия / пензенская область / золотаревка (пензенская область)"
  },
  "11021": {
    "id": "11021",
    "name": "Нечаевка (Пензенская область)",
    "path": "Россия / Пензенская область / Нечаевка (Пензенская область)",
    "country": "Россия",
    "searchString": "нечаевка (пензенская область) россия / пензенская область / нечаевка (пензенская область)"
  },
  "11022": {
    "id": "11022",
    "name": "Мордовский Карай",
    "path": "Россия / Саратовская область / Мордовский Карай",
    "country": "Россия",
    "searchString": "мордовский карай россия / саратовская область / мордовский карай"
  },
  "11023": {
    "id": "11023",
    "name": "Мирный (Ульяновская область)",
    "path": "Россия / Ульяновская область / Мирный (Ульяновская область)",
    "country": "Россия",
    "searchString": "мирный (ульяновская область) россия / ульяновская область / мирный (ульяновская область)"
  },
  "11024": {
    "id": "11024",
    "name": "Большое Микушкино",
    "path": "Россия / Самарская область / Большое Микушкино",
    "country": "Россия",
    "searchString": "большое микушкино россия / самарская область / большое микушкино"
  },
  "11025": {
    "id": "11025",
    "name": "Малое Микушкино",
    "path": "Россия / Самарская область / Малое Микушкино",
    "country": "Россия",
    "searchString": "малое микушкино россия / самарская область / малое микушкино"
  },
  "11026": {
    "id": "11026",
    "name": "Казанла",
    "path": "Россия / Саратовская область / Казанла",
    "country": "Россия",
    "searchString": "казанла россия / саратовская область / казанла"
  },
  "11027": {
    "id": "11027",
    "name": "Буланово",
    "path": "Россия / Оренбургская область / Буланово",
    "country": "Россия",
    "searchString": "буланово россия / оренбургская область / буланово"
  },
  "11028": {
    "id": "11028",
    "name": "Большое Игнатово",
    "path": "Россия / Республика Мордовия / Большое Игнатово",
    "country": "Россия",
    "searchString": "большое игнатово россия / республика мордовия / большое игнатово"
  },
  "11029": {
    "id": "11029",
    "name": "Преображенка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Преображенка (Оренбургская область)",
    "country": "Россия",
    "searchString": "преображенка (оренбургская область) россия / оренбургская область / преображенка (оренбургская область)"
  },
  "11030": {
    "id": "11030",
    "name": "Кичкасс",
    "path": "Россия / Оренбургская область / Кичкасс",
    "country": "Россия",
    "searchString": "кичкасс россия / оренбургская область / кичкасс"
  },
  "11031": {
    "id": "11031",
    "name": "Рязановка",
    "path": "Россия / Оренбургская область / Рязановка",
    "country": "Россия",
    "searchString": "рязановка россия / оренбургская область / рязановка"
  },
  "11032": {
    "id": "11032",
    "name": "Маякское",
    "path": "Россия / Оренбургская область / Маякское",
    "country": "Россия",
    "searchString": "маякское россия / оренбургская область / маякское"
  },
  "11033": {
    "id": "11033",
    "name": "Верхозим",
    "path": "Россия / Пензенская область / Верхозим",
    "country": "Россия",
    "searchString": "верхозим россия / пензенская область / верхозим"
  },
  "11034": {
    "id": "11034",
    "name": "Вазерки",
    "path": "Россия / Пензенская область / Вазерки",
    "country": "Россия",
    "searchString": "вазерки россия / пензенская область / вазерки"
  },
  "11035": {
    "id": "11035",
    "name": "Тимирязевский (Ульяновская область)",
    "path": "Россия / Ульяновская область / Тимирязевский (Ульяновская область)",
    "country": "Россия",
    "searchString": "тимирязевский (ульяновская область) россия / ульяновская область / тимирязевский (ульяновская область)"
  },
  "11036": {
    "id": "11036",
    "name": "Григорьевка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Григорьевка (Оренбургская область)",
    "country": "Россия",
    "searchString": "григорьевка (оренбургская область) россия / оренбургская область / григорьевка (оренбургская область)"
  },
  "11037": {
    "id": "11037",
    "name": "Клинцовка",
    "path": "Россия / Саратовская область / Клинцовка",
    "country": "Россия",
    "searchString": "клинцовка россия / саратовская область / клинцовка"
  },
  "11038": {
    "id": "11038",
    "name": "Секретарка",
    "path": "Россия / Оренбургская область / Секретарка",
    "country": "Россия",
    "searchString": "секретарка россия / оренбургская область / секретарка"
  },
  "11039": {
    "id": "11039",
    "name": "Новопокровское",
    "path": "Россия / Саратовская область / Новопокровское",
    "country": "Россия",
    "searchString": "новопокровское россия / саратовская область / новопокровское"
  },
  "11040": {
    "id": "11040",
    "name": "Малая Малышевка",
    "path": "Россия / Самарская область / Малая Малышевка",
    "country": "Россия",
    "searchString": "малая малышевка россия / самарская область / малая малышевка"
  },
  "11041": {
    "id": "11041",
    "name": "Большая Елховка",
    "path": "Россия / Республика Мордовия / Большая Елховка",
    "country": "Россия",
    "searchString": "большая елховка россия / республика мордовия / большая елховка"
  },
  "11042": {
    "id": "11042",
    "name": "Салтыковка",
    "path": "Россия / Саратовская область / Салтыковка",
    "country": "Россия",
    "searchString": "салтыковка россия / саратовская область / салтыковка"
  },
  "11043": {
    "id": "11043",
    "name": "Черный Отрог",
    "path": "Россия / Оренбургская область / Черный Отрог",
    "country": "Россия",
    "searchString": "черный отрог россия / оренбургская область / черный отрог"
  },
  "11044": {
    "id": "11044",
    "name": "Большие Березники",
    "path": "Россия / Республика Мордовия / Большие Березники",
    "country": "Россия",
    "searchString": "большие березники россия / республика мордовия / большие березники"
  },
  "11045": {
    "id": "11045",
    "name": "Большой Сурмет",
    "path": "Россия / Оренбургская область / Большой Сурмет",
    "country": "Россия",
    "searchString": "большой сурмет россия / оренбургская область / большой сурмет"
  },
  "11046": {
    "id": "11046",
    "name": "Глотовка",
    "path": "Россия / Ульяновская область / Глотовка",
    "country": "Россия",
    "searchString": "глотовка россия / ульяновская область / глотовка"
  },
  "11047": {
    "id": "11047",
    "name": "Шильда",
    "path": "Россия / Оренбургская область / Шильда",
    "country": "Россия",
    "searchString": "шильда россия / оренбургская область / шильда"
  },
  "11048": {
    "id": "11048",
    "name": "Салейкино",
    "path": "Россия / Самарская область / Салейкино",
    "country": "Россия",
    "searchString": "салейкино россия / самарская область / салейкино"
  },
  "11049": {
    "id": "11049",
    "name": "Дубенки",
    "path": "Россия / Республика Мордовия / Дубенки",
    "country": "Россия",
    "searchString": "дубенки россия / республика мордовия / дубенки"
  },
  "11050": {
    "id": "11050",
    "name": "Тимашево",
    "path": "Россия / Самарская область / Тимашево",
    "country": "Россия",
    "searchString": "тимашево россия / самарская область / тимашево"
  },
  "11051": {
    "id": "11051",
    "name": "Анучино (Пензенская область)",
    "path": "Россия / Пензенская область / Анучино (Пензенская область)",
    "country": "Россия",
    "searchString": "анучино (пензенская область) россия / пензенская область / анучино (пензенская область)"
  },
  "11052": {
    "id": "11052",
    "name": "Ивановка (Оренбургская область)",
    "path": "Россия / Оренбургская область / Ивановка (Оренбургская область)",
    "country": "Россия",
    "searchString": "ивановка (оренбургская область) россия / оренбургская область / ивановка (оренбургская область)"
  },
  "11053": {
    "id": "11053",
    "name": "Игнатовка",
    "path": "Россия / Ульяновская область / Игнатовка",
    "country": "Россия",
    "searchString": "игнатовка россия / ульяновская область / игнатовка"
  },
  "11054": {
    "id": "11054",
    "name": "Село имени 9 января",
    "path": "Россия / Оренбургская область / Село имени 9 января",
    "country": "Россия",
    "searchString": "село имени 9 января россия / оренбургская область / село имени 9 января"
  },
  "11055": {
    "id": "11055",
    "name": "Астрадамовка",
    "path": "Россия / Ульяновская область / Астрадамовка",
    "country": "Россия",
    "searchString": "астрадамовка россия / ульяновская область / астрадамовка"
  },
  "11056": {
    "id": "11056",
    "name": "Кочелаево",
    "path": "Россия / Республика Мордовия / Кочелаево",
    "country": "Россия",
    "searchString": "кочелаево россия / республика мордовия / кочелаево"
  },
  "11057": {
    "id": "11057",
    "name": "Пушанино",
    "path": "Россия / Пензенская область / Пушанино",
    "country": "Россия",
    "searchString": "пушанино россия / пензенская область / пушанино"
  },
  "11058": {
    "id": "11058",
    "name": "Святославка",
    "path": "Россия / Саратовская область / Святославка",
    "country": "Россия",
    "searchString": "святославка россия / саратовская область / святославка"
  },
  "11059": {
    "id": "11059",
    "name": "Экспериментальный (Оренбургская область)",
    "path": "Россия / Оренбургская область / Экспериментальный (Оренбургская область)",
    "country": "Россия",
    "searchString": "экспериментальный (оренбургская область) россия / оренбургская область / экспериментальный (оренбургская область)"
  },
  "11060": {
    "id": "11060",
    "name": "Кабаево",
    "path": "Россия / Республика Мордовия / Кабаево",
    "country": "Россия",
    "searchString": "кабаево россия / республика мордовия / кабаево"
  },
  "11061": {
    "id": "11061",
    "name": "Старая Федоровка",
    "path": "Россия / Республика Мордовия / Старая Федоровка",
    "country": "Россия",
    "searchString": "старая федоровка россия / республика мордовия / старая федоровка"
  },
  "11062": {
    "id": "11062",
    "name": "Мустаево",
    "path": "Россия / Оренбургская область / Мустаево",
    "country": "Россия",
    "searchString": "мустаево россия / оренбургская область / мустаево"
  },
  "11063": {
    "id": "11063",
    "name": "Сосновоборское",
    "path": "Россия / Саратовская область / Сосновоборское",
    "country": "Россия",
    "searchString": "сосновоборское россия / саратовская область / сосновоборское"
  },
  "11064": {
    "id": "11064",
    "name": "Октябрьский Городок",
    "path": "Россия / Саратовская область / Октябрьский Городок",
    "country": "Россия",
    "searchString": "октябрьский городок россия / саратовская область / октябрьский городок"
  },
  "11065": {
    "id": "11065",
    "name": "Большие Хутора",
    "path": "Россия / Пензенская область / Большие Хутора",
    "country": "Россия",
    "searchString": "большие хутора россия / пензенская область / большие хутора"
  },
  "11066": {
    "id": "11066",
    "name": "Изобильное",
    "path": "Россия / Оренбургская область / Изобильное",
    "country": "Россия",
    "searchString": "изобильное россия / оренбургская область / изобильное"
  },
  "11067": {
    "id": "11067",
    "name": "Пионер",
    "path": "Россия / Пензенская область / Пионер",
    "country": "Россия",
    "searchString": "пионер россия / пензенская область / пионер"
  },
  "11068": {
    "id": "11068",
    "name": "Пронькино",
    "path": "Россия / Оренбургская область / Пронькино",
    "country": "Россия",
    "searchString": "пронькино россия / оренбургская область / пронькино"
  },
  "11069": {
    "id": "11069",
    "name": "Мулловка",
    "path": "Россия / Ульяновская область / Мулловка",
    "country": "Россия",
    "searchString": "мулловка россия / ульяновская область / мулловка"
  },
  "11070": {
    "id": "11070",
    "name": "Алёшня",
    "path": "Россия / Тульская область / Алёшня",
    "country": "Россия",
    "searchString": "алёшня россия / тульская область / алёшня"
  },
  "11071": {
    "id": "11071",
    "name": "Айтеке-Би",
    "path": "Казахстан / Айтеке-Би",
    "country": "Казахстан",
    "searchString": "айтеке-би казахстан / айтеке-би"
  },
  "11072": {
    "id": "11072",
    "name": "Карабулак (Сайрамский район)",
    "path": "Казахстан / Карабулак (Сайрамский район)",
    "country": "Казахстан",
    "searchString": "карабулак (сайрамский район) казахстан / карабулак (сайрамский район)"
  },
  "11073": {
    "id": "11073",
    "name": "Село имени Турара Рыскулова",
    "path": "Казахстан / Село имени Турара Рыскулова",
    "country": "Казахстан",
    "searchString": "село имени турара рыскулова казахстан / село имени турара рыскулова"
  },
  "11074": {
    "id": "11074",
    "name": "Рыбаки (Московская область)",
    "path": "Россия / Московская область / Рыбаки (Московская область)",
    "country": "Россия",
    "searchString": "рыбаки (московская область) россия / московская область / рыбаки (московская область)"
  },
  "11075": {
    "id": "11075",
    "name": "Доскино",
    "path": "Россия / Нижегородская область / Доскино",
    "country": "Россия",
    "searchString": "доскино россия / нижегородская область / доскино"
  },
  "11076": {
    "id": "11076",
    "name": "Державинск",
    "path": "Казахстан / Державинск",
    "country": "Казахстан",
    "searchString": "державинск казахстан / державинск"
  },
  "11077": {
    "id": "11077",
    "name": "Ягодный (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ягодный (Забайкальский край)",
    "country": "Россия",
    "searchString": "ягодный (забайкальский край) россия / забайкальский край / ягодный (забайкальский край)"
  },
  "11078": {
    "id": "11078",
    "name": "Карауылкельды",
    "path": "Казахстан / Карауылкельды",
    "country": "Казахстан",
    "searchString": "карауылкельды казахстан / карауылкельды"
  },
  "11079": {
    "id": "11079",
    "name": "Хатежино",
    "path": "Беларусь / Минская область / Хатежино",
    "country": "Беларусь",
    "searchString": "хатежино беларусь / минская область / хатежино"
  },
  "11080": {
    "id": "11080",
    "name": "Бисерово (Московская область)",
    "path": "Россия / Московская область / Бисерово (Московская область)",
    "country": "Россия",
    "searchString": "бисерово (московская область) россия / московская область / бисерово (московская область)"
  },
  "11081": {
    "id": "11081",
    "name": "Знаменский (Краснодарский край)",
    "path": "Россия / Краснодарский край / Знаменский (Краснодарский край)",
    "country": "Россия",
    "searchString": "знаменский (краснодарский край) россия / краснодарский край / знаменский (краснодарский край)"
  },
  "11082": {
    "id": "11082",
    "name": "Новая Бухтарма",
    "path": "Казахстан / Новая Бухтарма",
    "country": "Казахстан",
    "searchString": "новая бухтарма казахстан / новая бухтарма"
  },
  "11083": {
    "id": "11083",
    "name": "Аккистау",
    "path": "Казахстан / Аккистау",
    "country": "Казахстан",
    "searchString": "аккистау казахстан / аккистау"
  },
  "11084": {
    "id": "11084",
    "name": "Прохладное",
    "path": "Россия / Приморский край / Прохладное",
    "country": "Россия",
    "searchString": "прохладное россия / приморский край / прохладное"
  },
  "11085": {
    "id": "11085",
    "name": "Сосновоборск (Пензенская область)",
    "path": "Россия / Пензенская область / Сосновоборск (Пензенская область)",
    "country": "Россия",
    "searchString": "сосновоборск (пензенская область) россия / пензенская область / сосновоборск (пензенская область)"
  },
  "11086": {
    "id": "11086",
    "name": "Нарочь",
    "path": "Беларусь / Минская область / Нарочь",
    "country": "Беларусь",
    "searchString": "нарочь беларусь / минская область / нарочь"
  },
  "11087": {
    "id": "11087",
    "name": "Чисть",
    "path": "Беларусь / Минская область / Чисть",
    "country": "Беларусь",
    "searchString": "чисть беларусь / минская область / чисть"
  },
  "11088": {
    "id": "11088",
    "name": "Смиловичи",
    "path": "Беларусь / Минская область / Смиловичи",
    "country": "Беларусь",
    "searchString": "смиловичи беларусь / минская область / смиловичи"
  },
  "11089": {
    "id": "11089",
    "name": "Ивенец",
    "path": "Беларусь / Минская область / Ивенец",
    "country": "Беларусь",
    "searchString": "ивенец беларусь / минская область / ивенец"
  },
  "11090": {
    "id": "11090",
    "name": "Красная слобода",
    "path": "Беларусь / Минская область / Красная слобода",
    "country": "Беларусь",
    "searchString": "красная слобода беларусь / минская область / красная слобода"
  },
  "11091": {
    "id": "11091",
    "name": "Раков",
    "path": "Беларусь / Минская область / Раков",
    "country": "Беларусь",
    "searchString": "раков беларусь / минская область / раков"
  },
  "11092": {
    "id": "11092",
    "name": "Хотляны",
    "path": "Беларусь / Минская область / Хотляны",
    "country": "Беларусь",
    "searchString": "хотляны беларусь / минская область / хотляны"
  },
  "11093": {
    "id": "11093",
    "name": "Большое Стиклево",
    "path": "Беларусь / Минская область / Большое Стиклево",
    "country": "Беларусь",
    "searchString": "большое стиклево беларусь / минская область / большое стиклево"
  },
  "11094": {
    "id": "11094",
    "name": "Ратомка",
    "path": "Беларусь / Минская область / Ратомка",
    "country": "Беларусь",
    "searchString": "ратомка беларусь / минская область / ратомка"
  },
  "11095": {
    "id": "11095",
    "name": "Острошицкий Городок",
    "path": "Беларусь / Минская область / Острошицкий Городок",
    "country": "Беларусь",
    "searchString": "острошицкий городок беларусь / минская область / острошицкий городок"
  },
  "11096": {
    "id": "11096",
    "name": "Новоселье (Минский район)",
    "path": "Беларусь / Минская область / Новоселье (Минский район)",
    "country": "Беларусь",
    "searchString": "новоселье (минский район) беларусь / минская область / новоселье (минский район)"
  },
  "11097": {
    "id": "11097",
    "name": "Островы",
    "path": "Беларусь / Минская область / Островы",
    "country": "Беларусь",
    "searchString": "островы беларусь / минская область / островы"
  },
  "11098": {
    "id": "11098",
    "name": "Гацук",
    "path": "Беларусь / Минская область / Гацук",
    "country": "Беларусь",
    "searchString": "гацук беларусь / минская область / гацук"
  },
  "11099": {
    "id": "11099",
    "name": "Дукора",
    "path": "Беларусь / Минская область / Дукора",
    "country": "Беларусь",
    "searchString": "дукора беларусь / минская область / дукора"
  },
  "11100": {
    "id": "11100",
    "name": "Углы",
    "path": "Беларусь / Минская область / Углы",
    "country": "Беларусь",
    "searchString": "углы беларусь / минская область / углы"
  },
  "11101": {
    "id": "11101",
    "name": "Энергетиков",
    "path": "Беларусь / Минская область / Энергетиков",
    "country": "Беларусь",
    "searchString": "энергетиков беларусь / минская область / энергетиков"
  },
  "11102": {
    "id": "11102",
    "name": "Колодищи",
    "path": "Беларусь / Минская область / Колодищи",
    "country": "Беларусь",
    "searchString": "колодищи беларусь / минская область / колодищи"
  },
  "11103": {
    "id": "11103",
    "name": "Свислочь (Минская область)",
    "path": "Беларусь / Минская область / Свислочь (Минская область)",
    "country": "Беларусь",
    "searchString": "свислочь (минская область) беларусь / минская область / свислочь (минская область)"
  },
  "11104": {
    "id": "11104",
    "name": "Лошница",
    "path": "Беларусь / Минская область / Лошница",
    "country": "Беларусь",
    "searchString": "лошница беларусь / минская область / лошница"
  },
  "11105": {
    "id": "11105",
    "name": "Носилово",
    "path": "Беларусь / Минская область / Носилово",
    "country": "Беларусь",
    "searchString": "носилово беларусь / минская область / носилово"
  },
  "11106": {
    "id": "11106",
    "name": "Новосады",
    "path": "Беларусь / Минская область / Новосады",
    "country": "Беларусь",
    "searchString": "новосады беларусь / минская область / новосады"
  },
  "11107": {
    "id": "11107",
    "name": "Корзуны",
    "path": "Беларусь / Минская область / Корзуны",
    "country": "Беларусь",
    "searchString": "корзуны беларусь / минская область / корзуны"
  },
  "11108": {
    "id": "11108",
    "name": "Аксаковщина",
    "path": "Беларусь / Минская область / Аксаковщина",
    "country": "Беларусь",
    "searchString": "аксаковщина беларусь / минская область / аксаковщина"
  },
  "11109": {
    "id": "11109",
    "name": "Новый Свержень",
    "path": "Беларусь / Минская область / Новый Свержень",
    "country": "Беларусь",
    "searchString": "новый свержень беларусь / минская область / новый свержень"
  },
  "11110": {
    "id": "11110",
    "name": "Плещеницы",
    "path": "Беларусь / Минская область / Плещеницы",
    "country": "Беларусь",
    "searchString": "плещеницы беларусь / минская область / плещеницы"
  },
  "11111": {
    "id": "11111",
    "name": "Пуховичи",
    "path": "Беларусь / Минская область / Пуховичи",
    "country": "Беларусь",
    "searchString": "пуховичи беларусь / минская область / пуховичи"
  },
  "11112": {
    "id": "11112",
    "name": "Руденск",
    "path": "Беларусь / Минская область / Руденск",
    "country": "Беларусь",
    "searchString": "руденск беларусь / минская область / руденск"
  },
  "11113": {
    "id": "11113",
    "name": "Дружный (Минская область)",
    "path": "Беларусь / Минская область / Дружный (Минская область)",
    "country": "Беларусь",
    "searchString": "дружный (минская область) беларусь / минская область / дружный (минская область)"
  },
  "11114": {
    "id": "11114",
    "name": "Усяж",
    "path": "Беларусь / Минская область / Усяж",
    "country": "Беларусь",
    "searchString": "усяж беларусь / минская область / усяж"
  },
  "11115": {
    "id": "11115",
    "name": "Слобода ( Минская область)",
    "path": "Беларусь / Минская область / Слобода ( Минская область)",
    "country": "Беларусь",
    "searchString": "слобода ( минская область) беларусь / минская область / слобода ( минская область)"
  },
  "11116": {
    "id": "11116",
    "name": "Дричин",
    "path": "Беларусь / Минская область / Дричин",
    "country": "Беларусь",
    "searchString": "дричин беларусь / минская область / дричин"
  },
  "11117": {
    "id": "11117",
    "name": "Лапичи",
    "path": "Беларусь / Могилевская область / Лапичи",
    "country": "Беларусь",
    "searchString": "лапичи беларусь / могилевская область / лапичи"
  },
  "11118": {
    "id": "11118",
    "name": "Ленино  (Могилевская область)",
    "path": "Беларусь / Могилевская область / Ленино  (Могилевская область)",
    "country": "Беларусь",
    "searchString": "ленино  (могилевская область) беларусь / могилевская область / ленино  (могилевская область)"
  },
  "11119": {
    "id": "11119",
    "name": "Сосновый Бор (Гомельская область)",
    "path": "Беларусь / Гомельская область / Сосновый Бор (Гомельская область)",
    "country": "Беларусь",
    "searchString": "сосновый бор (гомельская область) беларусь / гомельская область / сосновый бор (гомельская область)"
  },
  "11120": {
    "id": "11120",
    "name": "Чёнки",
    "path": "Беларусь / Гомельская область / Чёнки",
    "country": "Беларусь",
    "searchString": "чёнки беларусь / гомельская область / чёнки"
  },
  "11121": {
    "id": "11121",
    "name": "Медков",
    "path": "Беларусь / Гомельская область / Медков",
    "country": "Беларусь",
    "searchString": "медков беларусь / гомельская область / медков"
  },
  "11122": {
    "id": "11122",
    "name": "Уваровичи",
    "path": "Беларусь / Гомельская область / Уваровичи",
    "country": "Беларусь",
    "searchString": "уваровичи беларусь / гомельская область / уваровичи"
  },
  "11123": {
    "id": "11123",
    "name": "Паричи",
    "path": "Беларусь / Гомельская область / Паричи",
    "country": "Беларусь",
    "searchString": "паричи беларусь / гомельская область / паричи"
  },
  "11124": {
    "id": "11124",
    "name": "Козенки",
    "path": "Беларусь / Гомельская область / Козенки",
    "country": "Беларусь",
    "searchString": "козенки беларусь / гомельская область / козенки"
  },
  "11125": {
    "id": "11125",
    "name": "Комарин",
    "path": "Беларусь / Гомельская область / Комарин",
    "country": "Беларусь",
    "searchString": "комарин беларусь / гомельская область / комарин"
  },
  "11126": {
    "id": "11126",
    "name": "Василевичи",
    "path": "Беларусь / Гомельская область / Василевичи",
    "country": "Беларусь",
    "searchString": "василевичи беларусь / гомельская область / василевичи"
  },
  "11127": {
    "id": "11127",
    "name": "Глушковичи",
    "path": "Беларусь / Гомельская область / Глушковичи",
    "country": "Беларусь",
    "searchString": "глушковичи беларусь / гомельская область / глушковичи"
  },
  "11128": {
    "id": "11128",
    "name": "Озерщина",
    "path": "Беларусь / Гомельская область / Озерщина",
    "country": "Беларусь",
    "searchString": "озерщина беларусь / гомельская область / озерщина"
  },
  "11129": {
    "id": "11129",
    "name": "Ружаны",
    "path": "Беларусь / Брестская область / Ружаны",
    "country": "Беларусь",
    "searchString": "ружаны беларусь / брестская область / ружаны"
  },
  "11130": {
    "id": "11130",
    "name": "Антополь",
    "path": "Беларусь / Брестская область / Антополь",
    "country": "Беларусь",
    "searchString": "антополь беларусь / брестская область / антополь"
  },
  "11131": {
    "id": "11131",
    "name": "Мотоль",
    "path": "Беларусь / Брестская область / Мотоль",
    "country": "Беларусь",
    "searchString": "мотоль беларусь / брестская область / мотоль"
  },
  "11132": {
    "id": "11132",
    "name": "Рубель",
    "path": "Беларусь / Брестская область / Рубель",
    "country": "Беларусь",
    "searchString": "рубель беларусь / брестская область / рубель"
  },
  "11133": {
    "id": "11133",
    "name": "Пинковичи",
    "path": "Беларусь / Брестская область / Пинковичи",
    "country": "Беларусь",
    "searchString": "пинковичи беларусь / брестская область / пинковичи"
  },
  "11134": {
    "id": "11134",
    "name": "Малеч",
    "path": "Беларусь / Брестская область / Малеч",
    "country": "Беларусь",
    "searchString": "малеч беларусь / брестская область / малеч"
  },
  "11135": {
    "id": "11135",
    "name": "Галево",
    "path": "Беларусь / Брестская область / Галево",
    "country": "Беларусь",
    "searchString": "галево беларусь / брестская область / галево"
  },
  "11136": {
    "id": "11136",
    "name": "Ленинский (Брестская область)",
    "path": "Беларусь / Брестская область / Ленинский (Брестская область)",
    "country": "Беларусь",
    "searchString": "ленинский (брестская область) беларусь / брестская область / ленинский (брестская область)"
  },
  "11137": {
    "id": "11137",
    "name": "Вишевичи",
    "path": "Беларусь / Брестская область / Вишевичи",
    "country": "Беларусь",
    "searchString": "вишевичи беларусь / брестская область / вишевичи"
  },
  "11138": {
    "id": "11138",
    "name": "Еремичи",
    "path": "Беларусь / Брестская область / Еремичи",
    "country": "Беларусь",
    "searchString": "еремичи беларусь / брестская область / еремичи"
  },
  "11139": {
    "id": "11139",
    "name": "Жемчужный",
    "path": "Беларусь / Брестская область / Жемчужный",
    "country": "Беларусь",
    "searchString": "жемчужный беларусь / брестская область / жемчужный"
  },
  "11140": {
    "id": "11140",
    "name": "Бабиничи",
    "path": "Беларусь / Витебская область / Бабиничи",
    "country": "Беларусь",
    "searchString": "бабиничи беларусь / витебская область / бабиничи"
  },
  "11141": {
    "id": "11141",
    "name": "Фариново",
    "path": "Беларусь / Витебская область / Фариново",
    "country": "Беларусь",
    "searchString": "фариново беларусь / витебская область / фариново"
  },
  "11142": {
    "id": "11142",
    "name": "Болбасово",
    "path": "Беларусь / Витебская область / Болбасово",
    "country": "Беларусь",
    "searchString": "болбасово беларусь / витебская область / болбасово"
  },
  "11143": {
    "id": "11143",
    "name": "Воропаево",
    "path": "Беларусь / Витебская область / Воропаево",
    "country": "Беларусь",
    "searchString": "воропаево беларусь / витебская область / воропаево"
  },
  "11144": {
    "id": "11144",
    "name": "Подсвилье",
    "path": "Беларусь / Витебская область / Подсвилье",
    "country": "Беларусь",
    "searchString": "подсвилье беларусь / витебская область / подсвилье"
  },
  "11145": {
    "id": "11145",
    "name": "Бегомль",
    "path": "Беларусь / Витебская область / Бегомль",
    "country": "Беларусь",
    "searchString": "бегомль беларусь / витебская область / бегомль"
  },
  "11146": {
    "id": "11146",
    "name": "Крулевщина",
    "path": "Беларусь / Витебская область / Крулевщина",
    "country": "Беларусь",
    "searchString": "крулевщина беларусь / витебская область / крулевщина"
  },
  "11147": {
    "id": "11147",
    "name": "Новка",
    "path": "Беларусь / Витебская область / Новка",
    "country": "Беларусь",
    "searchString": "новка беларусь / витебская область / новка"
  },
  "11148": {
    "id": "11148",
    "name": "Оболь",
    "path": "Беларусь / Витебская область / Оболь",
    "country": "Беларусь",
    "searchString": "оболь беларусь / витебская область / оболь"
  },
  "11149": {
    "id": "11149",
    "name": "Андреевщина",
    "path": "Беларусь / Витебская область / Андреевщина",
    "country": "Беларусь",
    "searchString": "андреевщина беларусь / витебская область / андреевщина"
  },
  "11150": {
    "id": "11150",
    "name": "Азино",
    "path": "Беларусь / Витебская область / Азино",
    "country": "Беларусь",
    "searchString": "азино беларусь / витебская область / азино"
  },
  "11151": {
    "id": "11151",
    "name": "Коханово",
    "path": "Беларусь / Витебская область / Коханово",
    "country": "Беларусь",
    "searchString": "коханово беларусь / витебская область / коханово"
  },
  "11152": {
    "id": "11152",
    "name": "Видзы",
    "path": "Беларусь / Витебская область / Видзы",
    "country": "Беларусь",
    "searchString": "видзы беларусь / витебская область / видзы"
  },
  "11153": {
    "id": "11153",
    "name": "Заслоново",
    "path": "Беларусь / Витебская область / Заслоново",
    "country": "Беларусь",
    "searchString": "заслоново беларусь / витебская область / заслоново"
  },
  "11154": {
    "id": "11154",
    "name": "Козловщина",
    "path": "Беларусь / Гродненская область / Козловщина",
    "country": "Беларусь",
    "searchString": "козловщина беларусь / гродненская область / козловщина"
  },
  "11155": {
    "id": "11155",
    "name": "Новоельня",
    "path": "Беларусь / Гродненская область / Новоельня",
    "country": "Беларусь",
    "searchString": "новоельня беларусь / гродненская область / новоельня"
  },
  "11156": {
    "id": "11156",
    "name": "Россь",
    "path": "Беларусь / Гродненская область / Россь",
    "country": "Беларусь",
    "searchString": "россь беларусь / гродненская область / россь"
  },
  "11157": {
    "id": "11157",
    "name": "Сопоцкин",
    "path": "Беларусь / Гродненская область / Сопоцкин",
    "country": "Беларусь",
    "searchString": "сопоцкин беларусь / гродненская область / сопоцкин"
  },
  "11158": {
    "id": "11158",
    "name": "Красносельский (Гродненская область)",
    "path": "Беларусь / Гродненская область / Красносельский (Гродненская область)",
    "country": "Беларусь",
    "searchString": "красносельский (гродненская область) беларусь / гродненская область / красносельский (гродненская область)"
  },
  "11159": {
    "id": "11159",
    "name": "Вертилишки",
    "path": "Беларусь / Гродненская область / Вертилишки",
    "country": "Беларусь",
    "searchString": "вертилишки беларусь / гродненская область / вертилишки"
  },
  "11160": {
    "id": "11160",
    "name": "Коробчицы",
    "path": "Беларусь / Гродненская область / Коробчицы",
    "country": "Беларусь",
    "searchString": "коробчицы беларусь / гродненская область / коробчицы"
  },
  "11161": {
    "id": "11161",
    "name": "Бенякони",
    "path": "Беларусь / Гродненская область / Бенякони",
    "country": "Беларусь",
    "searchString": "бенякони беларусь / гродненская область / бенякони"
  },
  "11162": {
    "id": "11162",
    "name": "Курык",
    "path": "Казахстан / Курык",
    "country": "Казахстан",
    "searchString": "курык казахстан / курык"
  },
  "11163": {
    "id": "11163",
    "name": "Калбатау",
    "path": "Казахстан / Калбатау",
    "country": "Казахстан",
    "searchString": "калбатау казахстан / калбатау"
  },
  "11164": {
    "id": "11164",
    "name": "Ольгинка",
    "path": "Россия / Краснодарский край / Ольгинка",
    "country": "Россия",
    "searchString": "ольгинка россия / краснодарский край / ольгинка"
  },
  "11165": {
    "id": "11165",
    "name": "Колосистый",
    "path": "Россия / Краснодарский край / Колосистый",
    "country": "Россия",
    "searchString": "колосистый россия / краснодарский край / колосистый"
  },
  "11166": {
    "id": "11166",
    "name": "Фролы",
    "path": "Россия / Пермский край / Фролы",
    "country": "Россия",
    "searchString": "фролы россия / пермский край / фролы"
  },
  "11167": {
    "id": "11167",
    "name": "Шахта (Пермский край)",
    "path": "Россия / Пермский край / Шахта (Пермский край)",
    "country": "Россия",
    "searchString": "шахта (пермский край) россия / пермский край / шахта (пермский край)"
  },
  "11168": {
    "id": "11168",
    "name": "Константиново (Раменский район, Московская область)",
    "path": "Россия / Московская область / Константиново (Раменский район, Московская область)",
    "country": "Россия",
    "searchString": "константиново (раменский район, московская область) россия / московская область / константиново (раменский район, московская область)"
  },
  "11169": {
    "id": "11169",
    "name": "Козет",
    "path": "Россия / Республика Адыгея / Козет",
    "country": "Россия",
    "searchString": "козет россия / республика адыгея / козет"
  },
  "11170": {
    "id": "11170",
    "name": "Архыз",
    "path": "Россия / Карачаево-Черкесская Республика / Архыз",
    "country": "Россия",
    "searchString": "архыз россия / карачаево-черкесская республика / архыз"
  },
  "11171": {
    "id": "11171",
    "name": "Пыскор",
    "path": "Россия / Пермский край / Пыскор",
    "country": "Россия",
    "searchString": "пыскор россия / пермский край / пыскор"
  },
  "11172": {
    "id": "11172",
    "name": "Пянтег",
    "path": "Россия / Пермский край / Пянтег",
    "country": "Россия",
    "searchString": "пянтег россия / пермский край / пянтег"
  },
  "11173": {
    "id": "11173",
    "name": "Чёрное (Пермский край)",
    "path": "Россия / Пермский край / Чёрное (Пермский край)",
    "country": "Россия",
    "searchString": "чёрное (пермский край) россия / пермский край / чёрное (пермский край)"
  },
  "11174": {
    "id": "11174",
    "name": "Пелым (Пермский край)",
    "path": "Россия / Пермский край / Пелым (Пермский край)",
    "country": "Россия",
    "searchString": "пелым (пермский край) россия / пермский край / пелым (пермский край)"
  },
  "11175": {
    "id": "11175",
    "name": "Ягуново",
    "path": "Россия / Кемеровская область / Ягуново",
    "country": "Россия",
    "searchString": "ягуново россия / кемеровская область / ягуново"
  },
  "11176": {
    "id": "11176",
    "name": "Мазурово",
    "path": "Россия / Кемеровская область / Мазурово",
    "country": "Россия",
    "searchString": "мазурово россия / кемеровская область / мазурово"
  },
  "11177": {
    "id": "11177",
    "name": "Сан-Томе и Принсипи",
    "path": "Другие регионы / Сан-Томе и Принсипи",
    "country": "Другие регионы",
    "searchString": "сан-томе и принсипи другие регионы / сан-томе и принсипи"
  },
  "11178": {
    "id": "11178",
    "name": "Радунь",
    "path": "Беларусь / Гродненская область / Радунь",
    "country": "Беларусь",
    "searchString": "радунь беларусь / гродненская область / радунь"
  },
  "11179": {
    "id": "11179",
    "name": "Прикубанский (Республика Адыгея)",
    "path": "Россия / Республика Адыгея / Прикубанский (Республика Адыгея)",
    "country": "Россия",
    "searchString": "прикубанский (республика адыгея) россия / республика адыгея / прикубанский (республика адыгея)"
  },
  "11180": {
    "id": "11180",
    "name": "Боралдай",
    "path": "Казахстан / Боралдай",
    "country": "Казахстан",
    "searchString": "боралдай казахстан / боралдай"
  },
  "11181": {
    "id": "11181",
    "name": "Сеница",
    "path": "Беларусь / Минская область / Сеница",
    "country": "Беларусь",
    "searchString": "сеница беларусь / минская область / сеница"
  },
  "11182": {
    "id": "11182",
    "name": "Копище",
    "path": "Беларусь / Минская область / Копище",
    "country": "Беларусь",
    "searchString": "копище беларусь / минская область / копище"
  },
  "11183": {
    "id": "11183",
    "name": "Зеренда",
    "path": "Казахстан / Зеренда",
    "country": "Казахстан",
    "searchString": "зеренда казахстан / зеренда"
  },
  "11184": {
    "id": "11184",
    "name": "Новогорелово",
    "path": "Россия / Ленинградская область / Новогорелово",
    "country": "Россия",
    "searchString": "новогорелово россия / ленинградская область / новогорелово"
  },
  "11185": {
    "id": "11185",
    "name": "Кизьва",
    "path": "Россия / Пермский край / Кизьва",
    "country": "Россия",
    "searchString": "кизьва россия / пермский край / кизьва"
  },
  "11186": {
    "id": "11186",
    "name": "Корчевня",
    "path": "Россия / Пермский край / Корчевня",
    "country": "Россия",
    "searchString": "корчевня россия / пермский край / корчевня"
  },
  "11187": {
    "id": "11187",
    "name": "Железнодорожный (Пермский край)",
    "path": "Россия / Пермский край / Железнодорожный (Пермский край)",
    "country": "Россия",
    "searchString": "железнодорожный (пермский край) россия / пермский край / железнодорожный (пермский край)"
  },
  "11188": {
    "id": "11188",
    "name": "Чулково (Московская область)",
    "path": "Россия / Московская область / Чулково (Московская область)",
    "country": "Россия",
    "searchString": "чулково (московская область) россия / московская область / чулково (московская область)"
  },
  "11189": {
    "id": "11189",
    "name": "Ольхон",
    "path": "Россия / Иркутская область / Ольхон",
    "country": "Россия",
    "searchString": "ольхон россия / иркутская область / ольхон"
  },
  "11190": {
    "id": "11190",
    "name": "Антоновка",
    "path": "Россия / Херсонская область / Антоновка",
    "country": "Россия",
    "searchString": "антоновка россия / херсонская область / антоновка"
  },
  "11191": {
    "id": "11191",
    "name": "Новый Двор",
    "path": "Беларусь / Минская область / Новый Двор",
    "country": "Беларусь",
    "searchString": "новый двор беларусь / минская область / новый двор"
  },
  "11192": {
    "id": "11192",
    "name": "Петровский (Тульская область)",
    "path": "Россия / Тульская область / Петровский (Тульская область)",
    "country": "Россия",
    "searchString": "петровский (тульская область) россия / тульская область / петровский (тульская область)"
  },
  "11193": {
    "id": "11193",
    "name": "Ждановичи",
    "path": "Беларусь / Минская область / Ждановичи",
    "country": "Беларусь",
    "searchString": "ждановичи беларусь / минская область / ждановичи"
  },
  "11194": {
    "id": "11194",
    "name": "Теренозек",
    "path": "Казахстан / Теренозек",
    "country": "Казахстан",
    "searchString": "теренозек казахстан / теренозек"
  },
  "11195": {
    "id": "11195",
    "name": "Гатово",
    "path": "Беларусь / Минская область / Гатово",
    "country": "Беларусь",
    "searchString": "гатово беларусь / минская область / гатово"
  },
  "11196": {
    "id": "11196",
    "name": "Комсомольский (Кинельский район)",
    "path": "Россия / Самарская область / Комсомольский (Кинельский район)",
    "country": "Россия",
    "searchString": "комсомольский (кинельский район) россия / самарская область / комсомольский (кинельский район)"
  },
  "11227": {
    "id": "11227",
    "name": "Самохваловичи",
    "path": "Беларусь / Минская область / Самохваловичи",
    "country": "Беларусь",
    "searchString": "самохваловичи беларусь / минская область / самохваловичи"
  },
  "11228": {
    "id": "11228",
    "name": "Тарасово (Минская область)",
    "path": "Беларусь / Минская область / Тарасово (Минская область)",
    "country": "Беларусь",
    "searchString": "тарасово (минская область) беларусь / минская область / тарасово (минская область)"
  },
  "11229": {
    "id": "11229",
    "name": "Остров (Ленинский район)",
    "path": "Россия / Московская область / Остров (Ленинский район)",
    "country": "Россия",
    "searchString": "остров (ленинский район) россия / московская область / остров (ленинский район)"
  },
  "11230": {
    "id": "11230",
    "name": "Кварцитный",
    "path": "Россия / Республика Карелия / Кварцитный",
    "country": "Россия",
    "searchString": "кварцитный россия / республика карелия / кварцитный"
  },
  "11231": {
    "id": "11231",
    "name": "Шамалган",
    "path": "Казахстан / Шамалган",
    "country": "Казахстан",
    "searchString": "шамалган казахстан / шамалган"
  },
  "11232": {
    "id": "11232",
    "name": "Увал",
    "path": "Россия / Курганская область / Увал",
    "country": "Россия",
    "searchString": "увал россия / курганская область / увал"
  },
  "11233": {
    "id": "11233",
    "name": "Харасавэй",
    "path": "Россия / Ямало-Ненецкий АО / Харасавэй",
    "country": "Россия",
    "searchString": "харасавэй россия / ямало-ненецкий ао / харасавэй"
  },
  "11234": {
    "id": "11234",
    "name": "Барановка (Хостинский район)",
    "path": "Россия / Краснодарский край / Барановка (Хостинский район)",
    "country": "Россия",
    "searchString": "барановка (хостинский район) россия / краснодарский край / барановка (хостинский район)"
  },
  "11235": {
    "id": "11235",
    "name": "Барановка (Лазаревский район)",
    "path": "Россия / Краснодарский край / Барановка (Лазаревский район)",
    "country": "Россия",
    "searchString": "барановка (лазаревский район) россия / краснодарский край / барановка (лазаревский район)"
  },
  "11236": {
    "id": "11236",
    "name": "Озерцо",
    "path": "Беларусь / Минская область / Озерцо",
    "country": "Беларусь",
    "searchString": "озерцо беларусь / минская область / озерцо"
  },
  "11237": {
    "id": "11237",
    "name": "Казцик",
    "path": "Казахстан / Казцик",
    "country": "Казахстан",
    "searchString": "казцик казахстан / казцик"
  },
  "11238": {
    "id": "11238",
    "name": "Междуреченское",
    "path": "Казахстан / Междуреченское",
    "country": "Казахстан",
    "searchString": "междуреченское казахстан / междуреченское"
  },
  "11239": {
    "id": "11239",
    "name": "Лидога",
    "path": "Россия / Хабаровский край / Лидога",
    "country": "Россия",
    "searchString": "лидога россия / хабаровский край / лидога"
  },
  "11240": {
    "id": "11240",
    "name": "Найхин",
    "path": "Россия / Хабаровский край / Найхин",
    "country": "Россия",
    "searchString": "найхин россия / хабаровский край / найхин"
  },
  "11241": {
    "id": "11241",
    "name": "Кукан",
    "path": "Россия / Хабаровский край / Кукан",
    "country": "Россия",
    "searchString": "кукан россия / хабаровский край / кукан"
  },
  "11242": {
    "id": "11242",
    "name": "Привольный (Минский район)",
    "path": "Беларусь / Минская область / Привольный (Минский район)",
    "country": "Беларусь",
    "searchString": "привольный (минский район) беларусь / минская область / привольный (минский район)"
  },
  "11243": {
    "id": "11243",
    "name": "Гжель (Московская область)",
    "path": "Россия / Московская область / Гжель (Московская область)",
    "country": "Россия",
    "searchString": "гжель (московская область) россия / московская область / гжель (московская область)"
  },
  "11244": {
    "id": "11244",
    "name": "Королёв Стан",
    "path": "Беларусь / Минская область / Королёв Стан",
    "country": "Беларусь",
    "searchString": "королёв стан беларусь / минская область / королёв стан"
  },
  "11245": {
    "id": "11245",
    "name": "Доброград",
    "path": "Россия / Владимирская область / Доброград",
    "country": "Россия",
    "searchString": "доброград россия / владимирская область / доброград"
  },
  "11246": {
    "id": "11246",
    "name": "Большое Грызлово (Московская область)",
    "path": "Россия / Московская область / Большое Грызлово (Московская область)",
    "country": "Россия",
    "searchString": "большое грызлово (московская область) россия / московская область / большое грызлово (московская область)"
  },
  "11247": {
    "id": "11247",
    "name": "Семёновское (Серпуховский район)",
    "path": "Россия / Московская область / Семёновское (Серпуховский район)",
    "country": "Россия",
    "searchString": "семёновское (серпуховский район) россия / московская область / семёновское (серпуховский район)"
  },
  "11248": {
    "id": "11248",
    "name": "Балково (Московская область)",
    "path": "Россия / Московская область / Балково (Московская область)",
    "country": "Россия",
    "searchString": "балково (московская область) россия / московская область / балково (московская область)"
  },
  "11249": {
    "id": "11249",
    "name": "Алфертищево (Московская область)",
    "path": "Россия / Московская область / Алфертищево (Московская область)",
    "country": "Россия",
    "searchString": "алфертищево (московская область) россия / московская область / алфертищево (московская область)"
  },
  "11250": {
    "id": "11250",
    "name": "Шепилово (Московская область)",
    "path": "Россия / Московская область / Шепилово (Московская область)",
    "country": "Россия",
    "searchString": "шепилово (московская область) россия / московская область / шепилово (московская область)"
  },
  "11251": {
    "id": "11251",
    "name": "Чулпаново (Московская область)",
    "path": "Россия / Московская область / Чулпаново (Московская область)",
    "country": "Россия",
    "searchString": "чулпаново (московская область) россия / московская область / чулпаново (московская область)"
  },
  "11252": {
    "id": "11252",
    "name": "Поливаново (Московская область)",
    "path": "Россия / Московская область / Поливаново (Московская область)",
    "country": "Россия",
    "searchString": "поливаново (московская область) россия / московская область / поливаново (московская область)"
  },
  "11253": {
    "id": "11253",
    "name": "Жуково (городской округ Домодедово)",
    "path": "Россия / Московская область / Жуково (городской округ Домодедово)",
    "country": "Россия",
    "searchString": "жуково (городской округ домодедово) россия / московская область / жуково (городской округ домодедово)"
  },
  "11254": {
    "id": "11254",
    "name": "Юсупово (Московская область)",
    "path": "Россия / Московская область / Юсупово (Московская область)",
    "country": "Россия",
    "searchString": "юсупово (московская область) россия / московская область / юсупово (московская область)"
  },
  "11255": {
    "id": "11255",
    "name": "Александровка (Московская область)",
    "path": "Россия / Московская область / Александровка (Московская область)",
    "country": "Россия",
    "searchString": "александровка (московская область) россия / московская область / александровка (московская область)"
  },
  "11256": {
    "id": "11256",
    "name": "Покров (Московская область)",
    "path": "Россия / Московская область / Покров (Московская область)",
    "country": "Россия",
    "searchString": "покров (московская область) россия / московская область / покров (московская область)"
  },
  "11257": {
    "id": "11257",
    "name": "Васькино (Московская область)",
    "path": "Россия / Московская область / Васькино (Московская область)",
    "country": "Россия",
    "searchString": "васькино (московская область) россия / московская область / васькино (московская область)"
  },
  "11258": {
    "id": "11258",
    "name": "Каргалы",
    "path": "Казахстан / Каргалы",
    "country": "Казахстан",
    "searchString": "каргалы казахстан / каргалы"
  },
  "11259": {
    "id": "11259",
    "name": "Солнышково (Московская область)",
    "path": "Россия / Московская область / Солнышково (Московская область)",
    "country": "Россия",
    "searchString": "солнышково (московская область) россия / московская область / солнышково (московская область)"
  },
  "11260": {
    "id": "11260",
    "name": "Паперня",
    "path": "Беларусь / Минская область / Паперня",
    "country": "Беларусь",
    "searchString": "паперня беларусь / минская область / паперня"
  },
  "11261": {
    "id": "11261",
    "name": "Беседы (Московская область)",
    "path": "Россия / Московская область / Беседы (Московская область)",
    "country": "Россия",
    "searchString": "беседы (московская область) россия / московская область / беседы (московская область)"
  },
  "11262": {
    "id": "11262",
    "name": "Плесенское (Московская область)",
    "path": "Россия / Московская область / Плесенское (Московская область)",
    "country": "Россия",
    "searchString": "плесенское (московская область) россия / московская область / плесенское (московская область)"
  },
  "11263": {
    "id": "11263",
    "name": "Зыкеево (Московская область)",
    "path": "Россия / Московская область / Зыкеево (Московская область)",
    "country": "Россия",
    "searchString": "зыкеево (московская область) россия / московская область / зыкеево (московская область)"
  },
  "11264": {
    "id": "11264",
    "name": "Пекша",
    "path": "Россия / Владимирская область / Пекша",
    "country": "Россия",
    "searchString": "пекша россия / владимирская область / пекша"
  },
  "11265": {
    "id": "11265",
    "name": "Леоново",
    "path": "Россия / Владимирская область / Леоново",
    "country": "Россия",
    "searchString": "леоново россия / владимирская область / леоново"
  },
  "11266": {
    "id": "11266",
    "name": "Темерницкий",
    "path": "Россия / Ростовская область / Темерницкий",
    "country": "Россия",
    "searchString": "темерницкий россия / ростовская область / темерницкий"
  },
  "11267": {
    "id": "11267",
    "name": "Щепкин",
    "path": "Россия / Ростовская область / Щепкин",
    "country": "Россия",
    "searchString": "щепкин россия / ростовская область / щепкин"
  },
  "11268": {
    "id": "11268",
    "name": "Бесленей",
    "path": "Россия / Карачаево-Черкесская Республика / Бесленей",
    "country": "Россия",
    "searchString": "бесленей россия / карачаево-черкесская республика / бесленей"
  },
  "11269": {
    "id": "11269",
    "name": "Глаголево (Московская область)",
    "path": "Россия / Московская область / Глаголево (Московская область)",
    "country": "Россия",
    "searchString": "глаголево (московская область) россия / московская область / глаголево (московская область)"
  },
  "11270": {
    "id": "11270",
    "name": "Каменка (Московская область)",
    "path": "Россия / Московская область / Каменка (Московская область)",
    "country": "Россия",
    "searchString": "каменка (московская область) россия / московская область / каменка (московская область)"
  },
  "11271": {
    "id": "11271",
    "name": "Рогово (Московская область)",
    "path": "Россия / Московская область / Рогово (Московская область)",
    "country": "Россия",
    "searchString": "рогово (московская область) россия / московская область / рогово (московская область)"
  },
  "11272": {
    "id": "11272",
    "name": "Нугуш",
    "path": "Россия / Республика Башкортостан / Нугуш",
    "country": "Россия",
    "searchString": "нугуш россия / республика башкортостан / нугуш"
  },
  "11273": {
    "id": "11273",
    "name": "Ставотино",
    "path": "Россия / Ярославская область / Ставотино",
    "country": "Россия",
    "searchString": "ставотино россия / ярославская область / ставотино"
  },
  "11274": {
    "id": "11274",
    "name": "Заринское",
    "path": "Россия / Кемеровская область / Заринское",
    "country": "Россия",
    "searchString": "заринское россия / кемеровская область / заринское"
  },
  "11275": {
    "id": "11275",
    "name": "Рассвет (Кызылжарский район)",
    "path": "Казахстан / Рассвет (Кызылжарский район)",
    "country": "Казахстан",
    "searchString": "рассвет (кызылжарский район) казахстан / рассвет (кызылжарский район)"
  },
  "11276": {
    "id": "11276",
    "name": "Рассвет (Староминский район)",
    "path": "Россия / Краснодарский край / Рассвет (Староминский район)",
    "country": "Россия",
    "searchString": "рассвет (староминский район) россия / краснодарский край / рассвет (староминский район)"
  },
  "11277": {
    "id": "11277",
    "name": "Новосёлки (городской округ Чехов)",
    "path": "Россия / Московская область / Новосёлки (городской округ Чехов)",
    "country": "Россия",
    "searchString": "новосёлки (городской округ чехов) россия / московская область / новосёлки (городской округ чехов)"
  },
  "11278": {
    "id": "11278",
    "name": "Карагайла",
    "path": "Россия / Кемеровская область / Карагайла",
    "country": "Россия",
    "searchString": "карагайла россия / кемеровская область / карагайла"
  },
  "11279": {
    "id": "11279",
    "name": "Отрадное (Городской округ Красногорск)",
    "path": "Россия / Московская область / Отрадное (Городской округ Красногорск)",
    "country": "Россия",
    "searchString": "отрадное (городской округ красногорск) россия / московская область / отрадное (городской округ красногорск)"
  },
  "11280": {
    "id": "11280",
    "name": "Ильинское-Усово (Московская область)",
    "path": "Россия / Московская область / Ильинское-Усово (Московская область)",
    "country": "Россия",
    "searchString": "ильинское-усово (московская область) россия / московская область / ильинское-усово (московская область)"
  },
  "11281": {
    "id": "11281",
    "name": "Чёрная (Московская область)",
    "path": "Россия / Московская область / Чёрная (Московская область)",
    "country": "Россия",
    "searchString": "чёрная (московская область) россия / московская область / чёрная (московская область)"
  },
  "11282": {
    "id": "11282",
    "name": "Кулаково (Московская область)",
    "path": "Россия / Московская область / Кулаково (Московская область)",
    "country": "Россия",
    "searchString": "кулаково (московская область) россия / московская область / кулаково (московская область)"
  },
  "11283": {
    "id": "11283",
    "name": "Глуховка (Московская область)",
    "path": "Россия / Московская область / Глуховка (Московская область)",
    "country": "Россия",
    "searchString": "глуховка (московская область) россия / московская область / глуховка (московская область)"
  },
  "11284": {
    "id": "11284",
    "name": "Железнодорожный (Правдинский муниципальный округ)",
    "path": "Россия / Калининградская область / Железнодорожный (Правдинский муниципальный округ)",
    "country": "Россия",
    "searchString": "железнодорожный (правдинский муниципальный округ) россия / калининградская область / железнодорожный (правдинский муниципальный округ)"
  },
  "11285": {
    "id": "11285",
    "name": "Тирасполь",
    "path": "Другие регионы / Молдова / Тирасполь",
    "country": "Другие регионы",
    "searchString": "тирасполь другие регионы / молдова / тирасполь"
  },
  "11286": {
    "id": "11286",
    "name": "Фирсово",
    "path": "Россия / Алтайский край / Фирсово",
    "country": "Россия",
    "searchString": "фирсово россия / алтайский край / фирсово"
  },
  "11287": {
    "id": "11287",
    "name": "Марушкино (Московская область)",
    "path": "Россия / Московская область / Марушкино (Московская область)",
    "country": "Россия",
    "searchString": "марушкино (московская область) россия / московская область / марушкино (московская область)"
  },
  "11288": {
    "id": "11288",
    "name": "Копцевы Хутора",
    "path": "Россия / Липецкая область / Копцевы Хутора",
    "country": "Россия",
    "searchString": "копцевы хутора россия / липецкая область / копцевы хутора"
  },
  "11289": {
    "id": "11289",
    "name": "Минино (Мининский сельсовет)",
    "path": "Россия / Красноярский край / Минино (Мининский сельсовет)",
    "country": "Россия",
    "searchString": "минино (мининский сельсовет) россия / красноярский край / минино (мининский сельсовет)"
  },
  "11290": {
    "id": "11290",
    "name": "Васьковичи",
    "path": "Россия / Брянская область / Васьковичи",
    "country": "Россия",
    "searchString": "васьковичи россия / брянская область / васьковичи"
  },
  "11291": {
    "id": "11291",
    "name": "Мартук (Актюбинская область)",
    "path": "Казахстан / Мартук (Актюбинская область)",
    "country": "Казахстан",
    "searchString": "мартук (актюбинская область) казахстан / мартук (актюбинская область)"
  },
  "11292": {
    "id": "11292",
    "name": "Макат (Атырауская область)",
    "path": "Казахстан / Макат (Атырауская область)",
    "country": "Казахстан",
    "searchString": "макат (атырауская область) казахстан / макат (атырауская область)"
  },
  "11293": {
    "id": "11293",
    "name": "Байсерке ( Алматинская область)",
    "path": "Казахстан / Байсерке ( Алматинская область)",
    "country": "Казахстан",
    "searchString": "байсерке ( алматинская область) казахстан / байсерке ( алматинская область)"
  },
  "11294": {
    "id": "11294",
    "name": "Иловайск",
    "path": "Россия / Донецкая Народная Республика / Иловайск",
    "country": "Россия",
    "searchString": "иловайск россия / донецкая народная республика / иловайск"
  },
  "11295": {
    "id": "11295",
    "name": "Ат-Баши",
    "path": "Кыргызстан / Ат-Баши",
    "country": "Кыргызстан",
    "searchString": "ат-баши кыргызстан / ат-баши"
  },
  "11296": {
    "id": "11296",
    "name": "Араван",
    "path": "Кыргызстан / Араван",
    "country": "Кыргызстан",
    "searchString": "араван кыргызстан / араван"
  },
  "11297": {
    "id": "11297",
    "name": "Ала-Бука",
    "path": "Кыргызстан / Ала-Бука",
    "country": "Кыргызстан",
    "searchString": "ала-бука кыргызстан / ала-бука"
  },
  "11298": {
    "id": "11298",
    "name": "Базар-Коргон",
    "path": "Кыргызстан / Базар-Коргон",
    "country": "Кыргызстан",
    "searchString": "базар-коргон кыргызстан / базар-коргон"
  },
  "11299": {
    "id": "11299",
    "name": "Беловодское (Чуйская область)",
    "path": "Кыргызстан / Беловодское (Чуйская область)",
    "country": "Кыргызстан",
    "searchString": "беловодское (чуйская область) кыргызстан / беловодское (чуйская область)"
  },
  "11300": {
    "id": "11300",
    "name": "Кара-Кульджа",
    "path": "Кыргызстан / Кара-Кульджа",
    "country": "Кыргызстан",
    "searchString": "кара-кульджа кыргызстан / кара-кульджа"
  },
  "11301": {
    "id": "11301",
    "name": "Гульча",
    "path": "Кыргызстан / Гульча",
    "country": "Кыргызстан",
    "searchString": "гульча кыргызстан / гульча"
  },
  "11302": {
    "id": "11302",
    "name": "Кызыл-Суу",
    "path": "Кыргызстан / Кызыл-Суу",
    "country": "Кыргызстан",
    "searchString": "кызыл-суу кыргызстан / кызыл-суу"
  },
  "11303": {
    "id": "11303",
    "name": "Кочкорка",
    "path": "Кыргызстан / Кочкорка",
    "country": "Кыргызстан",
    "searchString": "кочкорка кыргызстан / кочкорка"
  },
  "11304": {
    "id": "11304",
    "name": "Кемин",
    "path": "Кыргызстан / Кемин",
    "country": "Кыргызстан",
    "searchString": "кемин кыргызстан / кемин"
  },
  "11305": {
    "id": "11305",
    "name": "Сокулук",
    "path": "Кыргызстан / Сокулук",
    "country": "Кыргызстан",
    "searchString": "сокулук кыргызстан / сокулук"
  },
  "11306": {
    "id": "11306",
    "name": "Сузак",
    "path": "Кыргызстан / Сузак",
    "country": "Кыргызстан",
    "searchString": "сузак кыргызстан / сузак"
  },
  "11307": {
    "id": "11307",
    "name": "Романовка (Чуйская область)",
    "path": "Кыргызстан / Романовка (Чуйская область)",
    "country": "Кыргызстан",
    "searchString": "романовка (чуйская область) кыргызстан / романовка (чуйская область)"
  },
  "11308": {
    "id": "11308",
    "name": "Кара-Буура",
    "path": "Кыргызстан / Кара-Буура",
    "country": "Кыргызстан",
    "searchString": "кара-буура кыргызстан / кара-буура"
  },
  "11309": {
    "id": "11309",
    "name": "Куршаб",
    "path": "Кыргызстан / Куршаб",
    "country": "Кыргызстан",
    "searchString": "куршаб кыргызстан / куршаб"
  },
  "11310": {
    "id": "11310",
    "name": "Алай",
    "path": "Кыргызстан / Алай",
    "country": "Кыргызстан",
    "searchString": "алай кыргызстан / алай"
  },
  "11311": {
    "id": "11311",
    "name": "Лейлек",
    "path": "Кыргызстан / Лейлек",
    "country": "Кыргызстан",
    "searchString": "лейлек кыргызстан / лейлек"
  },
  "11312": {
    "id": "11312",
    "name": "Тюп",
    "path": "Кыргызстан / Тюп",
    "country": "Кыргызстан",
    "searchString": "тюп кыргызстан / тюп"
  },
  "11313": {
    "id": "11313",
    "name": "Чон-Алай",
    "path": "Кыргызстан / Чон-Алай",
    "country": "Кыргызстан",
    "searchString": "чон-алай кыргызстан / чон-алай"
  },
  "11314": {
    "id": "11314",
    "name": "Мырза-Аке",
    "path": "Кыргызстан / Мырза-Аке",
    "country": "Кыргызстан",
    "searchString": "мырза-аке кыргызстан / мырза-аке"
  },
  "11315": {
    "id": "11315",
    "name": "Тон",
    "path": "Кыргызстан / Тон",
    "country": "Кыргызстан",
    "searchString": "тон кыргызстан / тон"
  },
  "11316": {
    "id": "11316",
    "name": "Жуково (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Жуково (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "жуково (республика башкортостан) россия / республика башкортостан / жуково (республика башкортостан)"
  },
  "11317": {
    "id": "11317",
    "name": "Республика Гамбия",
    "path": "Другие регионы / Республика Гамбия",
    "country": "Другие регионы",
    "searchString": "республика гамбия другие регионы / республика гамбия"
  },
  "11318": {
    "id": "11318",
    "name": "Рогожкино (Ростовская область)",
    "path": "Россия / Ростовская область / Рогожкино (Ростовская область)",
    "country": "Россия",
    "searchString": "рогожкино (ростовская область) россия / ростовская область / рогожкино (ростовская область)"
  },
  "11319": {
    "id": "11319",
    "name": "Борщевое",
    "path": "Россия / Тульская область / Борщевое",
    "country": "Россия",
    "searchString": "борщевое россия / тульская область / борщевое"
  },
  "11320": {
    "id": "11320",
    "name": "Обуховка",
    "path": "Россия / Ростовская область / Обуховка",
    "country": "Россия",
    "searchString": "обуховка россия / ростовская область / обуховка"
  },
  "11321": {
    "id": "11321",
    "name": "Курган (Ростовская область)",
    "path": "Россия / Ростовская область / Курган (Ростовская область)",
    "country": "Россия",
    "searchString": "курган (ростовская область) россия / ростовская область / курган (ростовская область)"
  },
  "11322": {
    "id": "11322",
    "name": "Казачий Ерик",
    "path": "Россия / Ростовская область / Казачий Ерик",
    "country": "Россия",
    "searchString": "казачий ерик россия / ростовская область / казачий ерик"
  },
  "11323": {
    "id": "11323",
    "name": "Дугино",
    "path": "Россия / Ростовская область / Дугино",
    "country": "Россия",
    "searchString": "дугино россия / ростовская область / дугино"
  },
  "11324": {
    "id": "11324",
    "name": "Городище (Ростовская область)",
    "path": "Россия / Ростовская область / Городище (Ростовская область)",
    "country": "Россия",
    "searchString": "городище (ростовская область) россия / ростовская область / городище (ростовская область)"
  },
  "11325": {
    "id": "11325",
    "name": "Колузаево",
    "path": "Россия / Ростовская область / Колузаево",
    "country": "Россия",
    "searchString": "колузаево россия / ростовская область / колузаево"
  },
  "11326": {
    "id": "11326",
    "name": "Дефановка",
    "path": "Россия / Краснодарский край / Дефановка",
    "country": "Россия",
    "searchString": "дефановка россия / краснодарский край / дефановка"
  },
  "11327": {
    "id": "11327",
    "name": "Новопятницкое",
    "path": "Россия / Красноярский край / Новопятницкое",
    "country": "Россия",
    "searchString": "новопятницкое россия / красноярский край / новопятницкое"
  },
  "11328": {
    "id": "11328",
    "name": "Каштан",
    "path": "Россия / Красноярский край / Каштан",
    "country": "Россия",
    "searchString": "каштан россия / красноярский край / каштан"
  },
  "11329": {
    "id": "11329",
    "name": "Ельтай",
    "path": "Казахстан / Ельтай",
    "country": "Казахстан",
    "searchString": "ельтай казахстан / ельтай"
  },
  "11330": {
    "id": "11330",
    "name": "Жибек Жолы",
    "path": "Казахстан / Жибек Жолы",
    "country": "Казахстан",
    "searchString": "жибек жолы казахстан / жибек жолы"
  },
  "11331": {
    "id": "11331",
    "name": "Жетысу",
    "path": "Казахстан / Жетысу",
    "country": "Казахстан",
    "searchString": "жетысу казахстан / жетысу"
  },
  "11332": {
    "id": "11332",
    "name": "Иртышск",
    "path": "Казахстан / Иртышск",
    "country": "Казахстан",
    "searchString": "иртышск казахстан / иртышск"
  },
  "11333": {
    "id": "11333",
    "name": "Матай",
    "path": "Казахстан / Матай",
    "country": "Казахстан",
    "searchString": "матай казахстан / матай"
  },
  "11334": {
    "id": "11334",
    "name": "Завидово",
    "path": "Россия / Тверская область / Завидово",
    "country": "Россия",
    "searchString": "завидово россия / тверская область / завидово"
  },
  "11335": {
    "id": "11335",
    "name": "Кахун",
    "path": "Россия / Кабардино-Балкарская республика / Кахун",
    "country": "Россия",
    "searchString": "кахун россия / кабардино-балкарская республика / кахун"
  },
  "11336": {
    "id": "11336",
    "name": "Псыгансу",
    "path": "Россия / Кабардино-Балкарская республика / Псыгансу",
    "country": "Россия",
    "searchString": "псыгансу россия / кабардино-балкарская республика / псыгансу"
  },
  "11337": {
    "id": "11337",
    "name": "Старый Черек",
    "path": "Россия / Кабардино-Балкарская республика / Старый Черек",
    "country": "Россия",
    "searchString": "старый черек россия / кабардино-балкарская республика / старый черек"
  },
  "11338": {
    "id": "11338",
    "name": "Атажукино",
    "path": "Россия / Кабардино-Балкарская республика / Атажукино",
    "country": "Россия",
    "searchString": "атажукино россия / кабардино-балкарская республика / атажукино"
  },
  "11339": {
    "id": "11339",
    "name": "Урвань",
    "path": "Россия / Кабардино-Балкарская республика / Урвань",
    "country": "Россия",
    "searchString": "урвань россия / кабардино-балкарская республика / урвань"
  },
  "11340": {
    "id": "11340",
    "name": "Дейское",
    "path": "Россия / Кабардино-Балкарская республика / Дейское",
    "country": "Россия",
    "searchString": "дейское россия / кабардино-балкарская республика / дейское"
  },
  "11341": {
    "id": "11341",
    "name": "Лечинкай",
    "path": "Россия / Кабардино-Балкарская республика / Лечинкай",
    "country": "Россия",
    "searchString": "лечинкай россия / кабардино-балкарская республика / лечинкай"
  },
  "11342": {
    "id": "11342",
    "name": "Урух",
    "path": "Россия / Кабардино-Балкарская республика / Урух",
    "country": "Россия",
    "searchString": "урух россия / кабардино-балкарская республика / урух"
  },
  "11343": {
    "id": "11343",
    "name": "Герменчик (Кабардино-Балкарская Республика)",
    "path": "Россия / Кабардино-Балкарская республика / Герменчик (Кабардино-Балкарская Республика)",
    "country": "Россия",
    "searchString": "герменчик (кабардино-балкарская республика) россия / кабардино-балкарская республика / герменчик (кабардино-балкарская республика)"
  },
  "11344": {
    "id": "11344",
    "name": "Нижний Куркужин",
    "path": "Россия / Кабардино-Балкарская республика / Нижний Куркужин",
    "country": "Россия",
    "searchString": "нижний куркужин россия / кабардино-балкарская республика / нижний куркужин"
  },
  "11345": {
    "id": "11345",
    "name": "Хатуей",
    "path": "Россия / Кабардино-Балкарская республика / Хатуей",
    "country": "Россия",
    "searchString": "хатуей россия / кабардино-балкарская республика / хатуей"
  },
  "11346": {
    "id": "11346",
    "name": "Плановское",
    "path": "Россия / Кабардино-Балкарская республика / Плановское",
    "country": "Россия",
    "searchString": "плановское россия / кабардино-балкарская республика / плановское"
  },
  "11347": {
    "id": "11347",
    "name": "Белая Речка (Кабардино-Балкарская республика)",
    "path": "Россия / Кабардино-Балкарская республика / Белая Речка (Кабардино-Балкарская республика)",
    "country": "Россия",
    "searchString": "белая речка (кабардино-балкарская республика) россия / кабардино-балкарская республика / белая речка (кабардино-балкарская республика)"
  },
  "11348": {
    "id": "11348",
    "name": "Куба-Таба",
    "path": "Россия / Кабардино-Балкарская республика / Куба-Таба",
    "country": "Россия",
    "searchString": "куба-таба россия / кабардино-балкарская республика / куба-таба"
  },
  "11349": {
    "id": "11349",
    "name": "Верхний Куркужин",
    "path": "Россия / Кабардино-Балкарская республика / Верхний Куркужин",
    "country": "Россия",
    "searchString": "верхний куркужин россия / кабардино-балкарская республика / верхний куркужин"
  },
  "11350": {
    "id": "11350",
    "name": "Ромны (Амурская область)",
    "path": "Россия / Амурская область / Ромны (Амурская область)",
    "country": "Россия",
    "searchString": "ромны (амурская область) россия / амурская область / ромны (амурская область)"
  },
  "11351": {
    "id": "11351",
    "name": "Белогорье (Амурская область)",
    "path": "Россия / Амурская область / Белогорье (Амурская область)",
    "country": "Россия",
    "searchString": "белогорье (амурская область) россия / амурская область / белогорье (амурская область)"
  },
  "11352": {
    "id": "11352",
    "name": "Усть-Ивановка (Амурская область)",
    "path": "Россия / Амурская область / Усть-Ивановка (Амурская область)",
    "country": "Россия",
    "searchString": "усть-ивановка (амурская область) россия / амурская область / усть-ивановка (амурская область)"
  },
  "11353": {
    "id": "11353",
    "name": "Васильевка (Амурская область)",
    "path": "Россия / Амурская область / Васильевка (Амурская область)",
    "country": "Россия",
    "searchString": "васильевка (амурская область) россия / амурская область / васильевка (амурская область)"
  },
  "11354": {
    "id": "11354",
    "name": "Раздольное (Амурская область)",
    "path": "Россия / Амурская область / Раздольное (Амурская область)",
    "country": "Россия",
    "searchString": "раздольное (амурская область) россия / амурская область / раздольное (амурская область)"
  },
  "11355": {
    "id": "11355",
    "name": "Волково (Амурская область)",
    "path": "Россия / Амурская область / Волково (Амурская область)",
    "country": "Россия",
    "searchString": "волково (амурская область) россия / амурская область / волково (амурская область)"
  },
  "11356": {
    "id": "11356",
    "name": "Среднебелое (Амурская область)",
    "path": "Россия / Амурская область / Среднебелое (Амурская область)",
    "country": "Россия",
    "searchString": "среднебелое (амурская область) россия / амурская область / среднебелое (амурская область)"
  },
  "11357": {
    "id": "11357",
    "name": "Береговой (Амурская область)",
    "path": "Россия / Амурская область / Береговой (Амурская область)",
    "country": "Россия",
    "searchString": "береговой (амурская область) россия / амурская область / береговой (амурская область)"
  },
  "11358": {
    "id": "11358",
    "name": "Тахтамыгда (Амурская область)",
    "path": "Россия / Амурская область / Тахтамыгда (Амурская область)",
    "country": "Россия",
    "searchString": "тахтамыгда (амурская область) россия / амурская область / тахтамыгда (амурская область)"
  },
  "11359": {
    "id": "11359",
    "name": "Верхнезейск (Амурская область)",
    "path": "Россия / Амурская область / Верхнезейск (Амурская область)",
    "country": "Россия",
    "searchString": "верхнезейск (амурская область) россия / амурская область / верхнезейск (амурская область)"
  },
  "11360": {
    "id": "11360",
    "name": "Никольское (Амурская область)",
    "path": "Россия / Амурская область / Никольское (Амурская область)",
    "country": "Россия",
    "searchString": "никольское (амурская область) россия / амурская область / никольское (амурская область)"
  },
  "11361": {
    "id": "11361",
    "name": "Восточный (Амурская область)",
    "path": "Россия / Амурская область / Восточный (Амурская область)",
    "country": "Россия",
    "searchString": "восточный (амурская область) россия / амурская область / восточный (амурская область)"
  },
  "11362": {
    "id": "11362",
    "name": "Зельвино (Амурская область)",
    "path": "Россия / Амурская область / Зельвино (Амурская область)",
    "country": "Россия",
    "searchString": "зельвино (амурская область) россия / амурская область / зельвино (амурская область)"
  },
  "11363": {
    "id": "11363",
    "name": "Малая Сазанка (Амурская область)",
    "path": "Россия / Амурская область / Малая Сазанка (Амурская область)",
    "country": "Россия",
    "searchString": "малая сазанка (амурская область) россия / амурская область / малая сазанка (амурская область)"
  },
  "11364": {
    "id": "11364",
    "name": "Широкий (Амурская область)",
    "path": "Россия / Амурская область / Широкий (Амурская область)",
    "country": "Россия",
    "searchString": "широкий (амурская область) россия / амурская область / широкий (амурская область)"
  },
  "11365": {
    "id": "11365",
    "name": "Новоалександровка (Амурская область)",
    "path": "Россия / Амурская область / Новоалександровка (Амурская область)",
    "country": "Россия",
    "searchString": "новоалександровка (амурская область) россия / амурская область / новоалександровка (амурская область)"
  },
  "11366": {
    "id": "11366",
    "name": "Марково (Амурская область)",
    "path": "Россия / Амурская область / Марково (Амурская область)",
    "country": "Россия",
    "searchString": "марково (амурская область) россия / амурская область / марково (амурская область)"
  },
  "11367": {
    "id": "11367",
    "name": "Нижняя Полтавка (Амурская область)",
    "path": "Россия / Амурская область / Нижняя Полтавка (Амурская область)",
    "country": "Россия",
    "searchString": "нижняя полтавка (амурская область) россия / амурская область / нижняя полтавка (амурская область)"
  },
  "11368": {
    "id": "11368",
    "name": "Джалинда (Амурская область)",
    "path": "Россия / Амурская область / Джалинда (Амурская область)",
    "country": "Россия",
    "searchString": "джалинда (амурская область) россия / амурская область / джалинда (амурская область)"
  },
  "11369": {
    "id": "11369",
    "name": "Украинка (Амурская область)",
    "path": "Россия / Амурская область / Украинка (Амурская область)",
    "country": "Россия",
    "searchString": "украинка (амурская область) россия / амурская область / украинка (амурская область)"
  },
  "11370": {
    "id": "11370",
    "name": "Сергеевка (Амурская область)",
    "path": "Россия / Амурская область / Сергеевка (Амурская область)",
    "country": "Россия",
    "searchString": "сергеевка (амурская область) россия / амурская область / сергеевка (амурская область)"
  },
  "11371": {
    "id": "11371",
    "name": "Амурское (Амурская область)",
    "path": "Россия / Амурская область / Амурское (Амурская область)",
    "country": "Россия",
    "searchString": "амурское (амурская область) россия / амурская область / амурское (амурская область)"
  },
  "11372": {
    "id": "11372",
    "name": "Садовое (Амурская область)",
    "path": "Россия / Амурская область / Садовое (Амурская область)",
    "country": "Россия",
    "searchString": "садовое (амурская область) россия / амурская область / садовое (амурская область)"
  },
  "11373": {
    "id": "11373",
    "name": "Плодопитомник (Амурская область)",
    "path": "Россия / Амурская область / Плодопитомник (Амурская область)",
    "country": "Россия",
    "searchString": "плодопитомник (амурская область) россия / амурская область / плодопитомник (амурская область)"
  },
  "11374": {
    "id": "11374",
    "name": "Красноярово (Амурская область)",
    "path": "Россия / Амурская область / Красноярово (Амурская область)",
    "country": "Россия",
    "searchString": "красноярово (амурская область) россия / амурская область / красноярово (амурская область)"
  },
  "11375": {
    "id": "11375",
    "name": "Николаевка (Амурская область)",
    "path": "Россия / Амурская область / Николаевка (Амурская область)",
    "country": "Россия",
    "searchString": "николаевка (амурская область) россия / амурская область / николаевка (амурская область)"
  },
  "11376": {
    "id": "11376",
    "name": "Малиновка (Амурская область)",
    "path": "Россия / Амурская область / Малиновка (Амурская область)",
    "country": "Россия",
    "searchString": "малиновка (амурская область) россия / амурская область / малиновка (амурская область)"
  },
  "11377": {
    "id": "11377",
    "name": "Дмитриевка (Амурская область)",
    "path": "Россия / Амурская область / Дмитриевка (Амурская область)",
    "country": "Россия",
    "searchString": "дмитриевка (амурская область) россия / амурская область / дмитриевка (амурская область)"
  },
  "11378": {
    "id": "11378",
    "name": "Крестовоздвиженка (Амурская область)",
    "path": "Россия / Амурская область / Крестовоздвиженка (Амурская область)",
    "country": "Россия",
    "searchString": "крестовоздвиженка (амурская область) россия / амурская область / крестовоздвиженка (амурская область)"
  },
  "11379": {
    "id": "11379",
    "name": "Ага (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ага (Забайкальский край)",
    "country": "Россия",
    "searchString": "ага (забайкальский край) россия / забайкальский край / ага (забайкальский край)"
  },
  "11380": {
    "id": "11380",
    "name": "Ага-Хангил (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ага-Хангил (Забайкальский край)",
    "country": "Россия",
    "searchString": "ага-хангил (забайкальский край) россия / забайкальский край / ага-хангил (забайкальский край)"
  },
  "11381": {
    "id": "11381",
    "name": "Адриановка (Забайкальский край)",
    "path": "Россия / Забайкальский край / Адриановка (Забайкальский край)",
    "country": "Россия",
    "searchString": "адриановка (забайкальский край) россия / забайкальский край / адриановка (забайкальский край)"
  },
  "11382": {
    "id": "11382",
    "name": "Аксеново-Зиловское (Забайкальский край)",
    "path": "Россия / Забайкальский край / Аксеново-Зиловское (Забайкальский край)",
    "country": "Россия",
    "searchString": "аксеново-зиловское (забайкальский край) россия / забайкальский край / аксеново-зиловское (забайкальский край)"
  },
  "11383": {
    "id": "11383",
    "name": "Алеур (Забайкальский край)",
    "path": "Россия / Забайкальский край / Алеур (Забайкальский край)",
    "country": "Россия",
    "searchString": "алеур (забайкальский край) россия / забайкальский край / алеур (забайкальский край)"
  },
  "11384": {
    "id": "11384",
    "name": "Алханай (Забайкальский край)",
    "path": "Россия / Забайкальский край / Алханай (Забайкальский край)",
    "country": "Россия",
    "searchString": "алханай (забайкальский край) россия / забайкальский край / алханай (забайкальский край)"
  },
  "11385": {
    "id": "11385",
    "name": "Амитхаша (Забайкальский край)",
    "path": "Россия / Забайкальский край / Амитхаша (Забайкальский край)",
    "country": "Россия",
    "searchString": "амитхаша (забайкальский край) россия / забайкальский край / амитхаша (забайкальский край)"
  },
  "11386": {
    "id": "11386",
    "name": "Беклемишево (Забайкальский край)",
    "path": "Россия / Забайкальский край / Беклемишево (Забайкальский край)",
    "country": "Россия",
    "searchString": "беклемишево (забайкальский край) россия / забайкальский край / беклемишево (забайкальский край)"
  },
  "11387": {
    "id": "11387",
    "name": "Билитуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Билитуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "билитуй (забайкальский край) россия / забайкальский край / билитуй (забайкальский край)"
  },
  "11388": {
    "id": "11388",
    "name": "Большая Тура (Забайкальский край)",
    "path": "Россия / Забайкальский край / Большая Тура (Забайкальский край)",
    "country": "Россия",
    "searchString": "большая тура (забайкальский край) россия / забайкальский край / большая тура (забайкальский край)"
  },
  "11389": {
    "id": "11389",
    "name": "Боржигантай (Забайкальский край)",
    "path": "Россия / Забайкальский край / Боржигантай (Забайкальский край)",
    "country": "Россия",
    "searchString": "боржигантай (забайкальский край) россия / забайкальский край / боржигантай (забайкальский край)"
  },
  "11390": {
    "id": "11390",
    "name": "Бырка (Забайкальский край)",
    "path": "Россия / Забайкальский край / Бырка (Забайкальский край)",
    "country": "Россия",
    "searchString": "бырка (забайкальский край) россия / забайкальский край / бырка (забайкальский край)"
  },
  "11391": {
    "id": "11391",
    "name": "Вершино-Шахтаминский (Забайкальский край)",
    "path": "Россия / Забайкальский край / Вершино-Шахтаминский (Забайкальский край)",
    "country": "Россия",
    "searchString": "вершино-шахтаминский (забайкальский край) россия / забайкальский край / вершино-шахтаминский (забайкальский край)"
  },
  "11392": {
    "id": "11392",
    "name": "Горный Зерентуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Горный Зерентуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "горный зерентуй (забайкальский край) россия / забайкальский край / горный зерентуй (забайкальский край)"
  },
  "11393": {
    "id": "11393",
    "name": "Гунэй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Гунэй (Забайкальский край)",
    "country": "Россия",
    "searchString": "гунэй (забайкальский край) россия / забайкальский край / гунэй (забайкальский край)"
  },
  "11394": {
    "id": "11394",
    "name": "Даурия (Забайкальский край)",
    "path": "Россия / Забайкальский край / Даурия (Забайкальский край)",
    "country": "Россия",
    "searchString": "даурия (забайкальский край) россия / забайкальский край / даурия (забайкальский край)"
  },
  "11395": {
    "id": "11395",
    "name": "Дунаево (Забайкальский край)",
    "path": "Россия / Забайкальский край / Дунаево (Забайкальский край)",
    "country": "Россия",
    "searchString": "дунаево (забайкальский край) россия / забайкальский край / дунаево (забайкальский край)"
  },
  "11396": {
    "id": "11396",
    "name": "Засопка (Забайкальский край)",
    "path": "Россия / Забайкальский край / Засопка (Забайкальский край)",
    "country": "Россия",
    "searchString": "засопка (забайкальский край) россия / забайкальский край / засопка (забайкальский край)"
  },
  "11397": {
    "id": "11397",
    "name": "Нижний Черек",
    "path": "Россия / Кабардино-Балкарская республика / Нижний Черек",
    "country": "Россия",
    "searchString": "нижний черек россия / кабардино-балкарская республика / нижний черек"
  },
  "11398": {
    "id": "11398",
    "name": "Арик",
    "path": "Россия / Кабардино-Балкарская республика / Арик",
    "country": "Россия",
    "searchString": "арик россия / кабардино-балкарская республика / арик"
  },
  "11399": {
    "id": "11399",
    "name": "Псыхурей",
    "path": "Россия / Кабардино-Балкарская республика / Псыхурей",
    "country": "Россия",
    "searchString": "псыхурей россия / кабардино-балкарская республика / псыхурей"
  },
  "11400": {
    "id": "11400",
    "name": "Верхний Акбаш",
    "path": "Россия / Кабардино-Балкарская республика / Верхний Акбаш",
    "country": "Россия",
    "searchString": "верхний акбаш россия / кабардино-балкарская республика / верхний акбаш"
  },
  "11401": {
    "id": "11401",
    "name": "Чёрная Речка (Кабардино-Балкарская Республика)",
    "path": "Россия / Кабардино-Балкарская республика / Чёрная Речка (Кабардино-Балкарская Республика)",
    "country": "Россия",
    "searchString": "чёрная речка (кабардино-балкарская республика) россия / кабардино-балкарская республика / чёрная речка (кабардино-балкарская республика)"
  },
  "11402": {
    "id": "11402",
    "name": "Зугалай (Забайкальский край)",
    "path": "Россия / Забайкальский край / Зугалай (Забайкальский край)",
    "country": "Россия",
    "searchString": "зугалай (забайкальский край) россия / забайкальский край / зугалай (забайкальский край)"
  },
  "11403": {
    "id": "11403",
    "name": "Зуткулей (Забайкальский край)",
    "path": "Россия / Забайкальский край / Зуткулей (Забайкальский край)",
    "country": "Россия",
    "searchString": "зуткулей (забайкальский край) россия / забайкальский край / зуткулей (забайкальский край)"
  },
  "11404": {
    "id": "11404",
    "name": "Зюльзя (Забайкальский край)",
    "path": "Россия / Забайкальский край / Зюльзя (Забайкальский край)",
    "country": "Россия",
    "searchString": "зюльзя (забайкальский край) россия / забайкальский край / зюльзя (забайкальский край)"
  },
  "11405": {
    "id": "11405",
    "name": "Ингода (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ингода (Забайкальский край)",
    "country": "Россия",
    "searchString": "ингода (забайкальский край) россия / забайкальский край / ингода (забайкальский край)"
  },
  "11406": {
    "id": "11406",
    "name": "Кадахта (Забайкальский край)",
    "path": "Россия / Забайкальский край / Кадахта (Забайкальский край)",
    "country": "Россия",
    "searchString": "кадахта (забайкальский край) россия / забайкальский край / кадахта (забайкальский край)"
  },
  "11407": {
    "id": "11407",
    "name": "Казаново (Забайкальский край)",
    "path": "Россия / Забайкальский край / Казаново (Забайкальский край)",
    "country": "Россия",
    "searchString": "казаново (забайкальский край) россия / забайкальский край / казаново (забайкальский край)"
  },
  "11408": {
    "id": "11408",
    "name": "Калангуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Калангуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "калангуй (забайкальский край) россия / забайкальский край / калангуй (забайкальский край)"
  },
  "11409": {
    "id": "11409",
    "name": "Ковыли (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ковыли (Забайкальский край)",
    "country": "Россия",
    "searchString": "ковыли (забайкальский край) россия / забайкальский край / ковыли (забайкальский край)"
  },
  "11410": {
    "id": "11410",
    "name": "Кункур (Забайкальский край)",
    "path": "Россия / Забайкальский край / Кункур (Забайкальский край)",
    "country": "Россия",
    "searchString": "кункур (забайкальский край) россия / забайкальский край / кункур (забайкальский край)"
  },
  "11411": {
    "id": "11411",
    "name": "Кусоча (Забайкальский край)",
    "path": "Россия / Забайкальский край / Кусоча (Забайкальский край)",
    "country": "Россия",
    "searchString": "кусоча (забайкальский край) россия / забайкальский край / кусоча (забайкальский край)"
  },
  "11412": {
    "id": "11412",
    "name": "Лесной Городок (Забайкальский край)",
    "path": "Россия / Забайкальский край / Лесной Городок (Забайкальский край)",
    "country": "Россия",
    "searchString": "лесной городок (забайкальский край) россия / забайкальский край / лесной городок (забайкальский край)"
  },
  "11413": {
    "id": "11413",
    "name": "Линево Озеро (Забайкальский край)",
    "path": "Россия / Забайкальский край / Линево Озеро (Забайкальский край)",
    "country": "Россия",
    "searchString": "линево озеро (забайкальский край) россия / забайкальский край / линево озеро (забайкальский край)"
  },
  "11414": {
    "id": "11414",
    "name": "Маргуцек (Забайкальский край)",
    "path": "Россия / Забайкальский край / Маргуцек (Забайкальский край)",
    "country": "Россия",
    "searchString": "маргуцек (забайкальский край) россия / забайкальский край / маргуцек (забайкальский край)"
  },
  "11415": {
    "id": "11415",
    "name": "Мирная (Забайкальский край)",
    "path": "Россия / Забайкальский край / Мирная (Забайкальский край)",
    "country": "Россия",
    "searchString": "мирная (забайкальский край) россия / забайкальский край / мирная (забайкальский край)"
  },
  "11416": {
    "id": "11416",
    "name": "Могзон (Забайкальский край)",
    "path": "Россия / Забайкальский край / Могзон (Забайкальский край)",
    "country": "Россия",
    "searchString": "могзон (забайкальский край) россия / забайкальский край / могзон (забайкальский край)"
  },
  "11417": {
    "id": "11417",
    "name": "Молодежный (Забайкальский край)",
    "path": "Россия / Забайкальский край / Молодежный (Забайкальский край)",
    "country": "Россия",
    "searchString": "молодежный (забайкальский край) россия / забайкальский край / молодежный (забайкальский край)"
  },
  "11418": {
    "id": "11418",
    "name": "Новоцурухайтуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Новоцурухайтуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "новоцурухайтуй (забайкальский край) россия / забайкальский край / новоцурухайтуй (забайкальский край)"
  },
  "11419": {
    "id": "11419",
    "name": "Ононское (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ононское (Забайкальский край)",
    "country": "Россия",
    "searchString": "ононское (забайкальский край) россия / забайкальский край / ононское (забайкальский край)"
  },
  "11420": {
    "id": "11420",
    "name": "Орловский (Забайкальский край)",
    "path": "Россия / Забайкальский край / Орловский (Забайкальский край)",
    "country": "Россия",
    "searchString": "орловский (забайкальский край) россия / забайкальский край / орловский (забайкальский край)"
  },
  "11421": {
    "id": "11421",
    "name": "Ортуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ортуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "ортуй (забайкальский край) россия / забайкальский край / ортуй (забайкальский край)"
  },
  "11422": {
    "id": "11422",
    "name": "Приисковый (Забайкальский край)",
    "path": "Россия / Забайкальский край / Приисковый (Забайкальский край)",
    "country": "Россия",
    "searchString": "приисковый (забайкальский край) россия / забайкальский край / приисковый (забайкальский край)"
  },
  "11423": {
    "id": "11423",
    "name": "Сахюрта (Забайкальский край)",
    "path": "Россия / Забайкальский край / Сахюрта (Забайкальский край)",
    "country": "Россия",
    "searchString": "сахюрта (забайкальский край) россия / забайкальский край / сахюрта (забайкальский край)"
  },
  "11424": {
    "id": "11424",
    "name": "Семиозерный (Забайкальский край)",
    "path": "Россия / Забайкальский край / Семиозерный (Забайкальский край)",
    "country": "Россия",
    "searchString": "семиозерный (забайкальский край) россия / забайкальский край / семиозерный (забайкальский край)"
  },
  "11425": {
    "id": "11425",
    "name": "Смоленка (Забайкальский край)",
    "path": "Россия / Забайкальский край / Смоленка (Забайкальский край)",
    "country": "Россия",
    "searchString": "смоленка (забайкальский край) россия / забайкальский край / смоленка (забайкальский край)"
  },
  "11426": {
    "id": "11426",
    "name": "Сохондо (Забайкальский край)",
    "path": "Россия / Забайкальский край / Сохондо (Забайкальский край)",
    "country": "Россия",
    "searchString": "сохондо (забайкальский край) россия / забайкальский край / сохондо (забайкальский край)"
  },
  "11427": {
    "id": "11427",
    "name": "Степь (Забайкальский край)",
    "path": "Россия / Забайкальский край / Степь (Забайкальский край)",
    "country": "Россия",
    "searchString": "степь (забайкальский край) россия / забайкальский край / степь (забайкальский край)"
  },
  "11428": {
    "id": "11428",
    "name": "Судунтуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Судунтуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "судунтуй (забайкальский край) россия / забайкальский край / судунтуй (забайкальский край)"
  },
  "11429": {
    "id": "11429",
    "name": "Тарбагатай (Забайкальский край)",
    "path": "Россия / Забайкальский край / Тарбагатай (Забайкальский край)",
    "country": "Россия",
    "searchString": "тарбагатай (забайкальский край) россия / забайкальский край / тарбагатай (забайкальский край)"
  },
  "11430": {
    "id": "11430",
    "name": "Токчин (Забайкальский край)",
    "path": "Россия / Забайкальский край / Токчин (Забайкальский край)",
    "country": "Россия",
    "searchString": "токчин (забайкальский край) россия / забайкальский край / токчин (забайкальский край)"
  },
  "11431": {
    "id": "11431",
    "name": "Тыргетуй (Забайкальский край)",
    "path": "Россия / Забайкальский край / Тыргетуй (Забайкальский край)",
    "country": "Россия",
    "searchString": "тыргетуй (забайкальский край) россия / забайкальский край / тыргетуй (забайкальский край)"
  },
  "11432": {
    "id": "11432",
    "name": "Угдан (Забайкальский край)",
    "path": "Россия / Забайкальский край / Угдан (Забайкальский край)",
    "country": "Россия",
    "searchString": "угдан (забайкальский край) россия / забайкальский край / угдан (забайкальский край)"
  },
  "11433": {
    "id": "11433",
    "name": "Узон (Забайкальский край)",
    "path": "Россия / Забайкальский край / Узон (Забайкальский край)",
    "country": "Россия",
    "searchString": "узон (забайкальский край) россия / забайкальский край / узон (забайкальский край)"
  },
  "11434": {
    "id": "11434",
    "name": "Ундино-Поселье (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ундино-Поселье (Забайкальский край)",
    "country": "Россия",
    "searchString": "ундино-поселье (забайкальский край) россия / забайкальский край / ундино-поселье (забайкальский край)"
  },
  "11435": {
    "id": "11435",
    "name": "Второй Лескен",
    "path": "Россия / Кабардино-Балкарская республика / Второй Лескен",
    "country": "Россия",
    "searchString": "второй лескен россия / кабардино-балкарская республика / второй лескен"
  },
  "11436": {
    "id": "11436",
    "name": "Камлюково",
    "path": "Россия / Кабардино-Балкарская республика / Камлюково",
    "country": "Россия",
    "searchString": "камлюково россия / кабардино-балкарская республика / камлюково"
  },
  "11437": {
    "id": "11437",
    "name": "Былым",
    "path": "Россия / Кабардино-Балкарская республика / Былым",
    "country": "Россия",
    "searchString": "былым россия / кабардино-балкарская республика / былым"
  },
  "11438": {
    "id": "11438",
    "name": "Терекское",
    "path": "Россия / Кабардино-Балкарская республика / Терекское",
    "country": "Россия",
    "searchString": "терекское россия / кабардино-балкарская республика / терекское"
  },
  "11439": {
    "id": "11439",
    "name": "Урожайное",
    "path": "Россия / Кабардино-Балкарская республика / Урожайное",
    "country": "Россия",
    "searchString": "урожайное россия / кабардино-балкарская республика / урожайное"
  },
  "11440": {
    "id": "11440",
    "name": "Адиюх",
    "path": "Россия / Кабардино-Балкарская республика / Адиюх",
    "country": "Россия",
    "searchString": "адиюх россия / кабардино-балкарская республика / адиюх"
  },
  "11441": {
    "id": "11441",
    "name": "Приближная",
    "path": "Россия / Кабардино-Балкарская республика / Приближная",
    "country": "Россия",
    "searchString": "приближная россия / кабардино-балкарская республика / приближная"
  },
  "11442": {
    "id": "11442",
    "name": "Хамидие",
    "path": "Россия / Кабардино-Балкарская республика / Хамидие",
    "country": "Россия",
    "searchString": "хамидие россия / кабардино-балкарская республика / хамидие"
  },
  "11443": {
    "id": "11443",
    "name": "Полтавка (Приморский край)",
    "path": "Россия / Приморский край / Полтавка (Приморский край)",
    "country": "Россия",
    "searchString": "полтавка (приморский край) россия / приморский край / полтавка (приморский край)"
  },
  "11444": {
    "id": "11444",
    "name": "Урда-Ага (Забайкальский край)",
    "path": "Россия / Забайкальский край / Урда-Ага (Забайкальский край)",
    "country": "Россия",
    "searchString": "урда-ага (забайкальский край) россия / забайкальский край / урда-ага (забайкальский край)"
  },
  "11445": {
    "id": "11445",
    "name": "Утан (Забайкальский край)",
    "path": "Россия / Забайкальский край / Утан (Забайкальский край)",
    "country": "Россия",
    "searchString": "утан (забайкальский край) россия / забайкальский край / утан (забайкальский край)"
  },
  "11446": {
    "id": "11446",
    "name": "Ушарбай (Забайкальский край)",
    "path": "Россия / Забайкальский край / Ушарбай (Забайкальский край)",
    "country": "Россия",
    "searchString": "ушарбай (забайкальский край) россия / забайкальский край / ушарбай (забайкальский край)"
  },
  "11447": {
    "id": "11447",
    "name": "Хада-Булак (Забайкальский край)",
    "path": "Россия / Забайкальский край / Хада-Булак (Забайкальский край)",
    "country": "Россия",
    "searchString": "хада-булак (забайкальский край) россия / забайкальский край / хада-булак (забайкальский край)"
  },
  "11448": {
    "id": "11448",
    "name": "Харагун (Забайкальский край)",
    "path": "Россия / Забайкальский край / Харагун (Забайкальский край)",
    "country": "Россия",
    "searchString": "харагун (забайкальский край) россия / забайкальский край / харагун (забайкальский край)"
  },
  "11449": {
    "id": "11449",
    "name": "Харанор (Забайкальский край)",
    "path": "Россия / Забайкальский край / Харанор (Забайкальский край)",
    "country": "Россия",
    "searchString": "харанор (забайкальский край) россия / забайкальский край / харанор (забайкальский край)"
  },
  "11450": {
    "id": "11450",
    "name": "Хара-Шибирь (Забайкальский край)",
    "path": "Россия / Забайкальский край / Хара-Шибирь (Забайкальский край)",
    "country": "Россия",
    "searchString": "хара-шибирь (забайкальский край) россия / забайкальский край / хара-шибирь (забайкальский край)"
  },
  "11451": {
    "id": "11451",
    "name": "Хушенга (Забайкальский край)",
    "path": "Россия / Забайкальский край / Хушенга (Забайкальский край)",
    "country": "Россия",
    "searchString": "хушенга (забайкальский край) россия / забайкальский край / хушенга (забайкальский край)"
  },
  "11452": {
    "id": "11452",
    "name": "Цаган-Ола (Забайкальский край)",
    "path": "Россия / Забайкальский край / Цаган-Ола (Забайкальский край)",
    "country": "Россия",
    "searchString": "цаган-ола (забайкальский край) россия / забайкальский край / цаган-ола (забайкальский край)"
  },
  "11453": {
    "id": "11453",
    "name": "Цаган-Челутай (Забайкальский край)",
    "path": "Россия / Забайкальский край / Цаган-Челутай (Забайкальский край)",
    "country": "Россия",
    "searchString": "цаган-челутай (забайкальский край) россия / забайкальский край / цаган-челутай (забайкальский край)"
  },
  "11454": {
    "id": "11454",
    "name": "Целинный (Забайкальский край)",
    "path": "Россия / Забайкальский край / Целинный (Забайкальский край)",
    "country": "Россия",
    "searchString": "целинный (забайкальский край) россия / забайкальский край / целинный (забайкальский край)"
  },
  "11455": {
    "id": "11455",
    "name": "Цокто-Хангил (Забайкальский край)",
    "path": "Россия / Забайкальский край / Цокто-Хангил (Забайкальский край)",
    "country": "Россия",
    "searchString": "цокто-хангил (забайкальский край) россия / забайкальский край / цокто-хангил (забайкальский край)"
  },
  "11456": {
    "id": "11456",
    "name": "Чиндалей (Забайкальский край)",
    "path": "Россия / Забайкальский край / Чиндалей (Забайкальский край)",
    "country": "Россия",
    "searchString": "чиндалей (забайкальский край) россия / забайкальский край / чиндалей (забайкальский край)"
  },
  "11457": {
    "id": "11457",
    "name": "Шара-Горохон (Забайкальский край)",
    "path": "Россия / Забайкальский край / Шара-Горохон (Забайкальский край)",
    "country": "Россия",
    "searchString": "шара-горохон (забайкальский край) россия / забайкальский край / шара-горохон (забайкальский край)"
  },
  "11458": {
    "id": "11458",
    "name": "Шишкино (Забайкальский край)",
    "path": "Россия / Забайкальский край / Шишкино (Забайкальский край)",
    "country": "Россия",
    "searchString": "шишкино (забайкальский край) россия / забайкальский край / шишкино (забайкальский край)"
  },
  "11459": {
    "id": "11459",
    "name": "Пседах (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Пседах (Ингушетия)",
    "country": "Россия",
    "searchString": "пседах (ингушетия) россия / республика ингушетия / пседах (ингушетия)"
  },
  "11460": {
    "id": "11460",
    "name": "Нижние Ачалуки (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Нижние Ачалуки (Ингушетия)",
    "country": "Россия",
    "searchString": "нижние ачалуки (ингушетия) россия / республика ингушетия / нижние ачалуки (ингушетия)"
  },
  "11461": {
    "id": "11461",
    "name": "Зязиков-Юрт (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Зязиков-Юрт (Ингушетия)",
    "country": "Россия",
    "searchString": "зязиков-юрт (ингушетия) россия / республика ингушетия / зязиков-юрт (ингушетия)"
  },
  "11462": {
    "id": "11462",
    "name": "Алхасты (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Алхасты (Ингушетия)",
    "country": "Россия",
    "searchString": "алхасты (ингушетия) россия / республика ингушетия / алхасты (ингушетия)"
  },
  "11463": {
    "id": "11463",
    "name": "Новый Редант (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Новый Редант (Ингушетия)",
    "country": "Россия",
    "searchString": "новый редант (ингушетия) россия / республика ингушетия / новый редант (ингушетия)"
  },
  "11464": {
    "id": "11464",
    "name": "Средние Ачалуки (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Средние Ачалуки (Ингушетия)",
    "country": "Россия",
    "searchString": "средние ачалуки (ингушетия) россия / республика ингушетия / средние ачалуки (ингушетия)"
  },
  "11465": {
    "id": "11465",
    "name": "Мужичи (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Мужичи (Ингушетия)",
    "country": "Россия",
    "searchString": "мужичи (ингушетия) россия / республика ингушетия / мужичи (ингушетия)"
  },
  "11466": {
    "id": "11466",
    "name": "Вознесенская станица (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Вознесенская станица (Ингушетия)",
    "country": "Россия",
    "searchString": "вознесенская станица (ингушетия) россия / республика ингушетия / вознесенская станица (ингушетия)"
  },
  "11467": {
    "id": "11467",
    "name": "Гази-Юрт (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Гази-Юрт (Ингушетия)",
    "country": "Россия",
    "searchString": "гази-юрт (ингушетия) россия / республика ингушетия / гази-юрт (ингушетия)"
  },
  "11468": {
    "id": "11468",
    "name": "Джейрах (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Джейрах (Ингушетия)",
    "country": "Россия",
    "searchString": "джейрах (ингушетия) россия / республика ингушетия / джейрах (ингушетия)"
  },
  "11469": {
    "id": "11469",
    "name": "Аршты (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Аршты (Ингушетия)",
    "country": "Россия",
    "searchString": "аршты (ингушетия) россия / республика ингушетия / аршты (ингушетия)"
  },
  "11470": {
    "id": "11470",
    "name": "Аки-Юрт (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Аки-Юрт (Ингушетия)",
    "country": "Россия",
    "searchString": "аки-юрт (ингушетия) россия / республика ингушетия / аки-юрт (ингушетия)"
  },
  "11471": {
    "id": "11471",
    "name": "Алкун (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Алкун (Ингушетия)",
    "country": "Россия",
    "searchString": "алкун (ингушетия) россия / республика ингушетия / алкун (ингушетия)"
  },
  "11472": {
    "id": "11472",
    "name": "Чемульга (Ингушетия)",
    "path": "Россия / Республика Ингушетия / Чемульга (Ингушетия)",
    "country": "Россия",
    "searchString": "чемульга (ингушетия) россия / республика ингушетия / чемульга (ингушетия)"
  },
  "11473": {
    "id": "11473",
    "name": "Приветное (Сакский район)",
    "path": "Россия / Республика Крым / Приветное (Сакский район)",
    "country": "Россия",
    "searchString": "приветное (сакский район) россия / республика крым / приветное (сакский район)"
  },
  "11474": {
    "id": "11474",
    "name": "Приветное (Алушта)",
    "path": "Россия / Республика Крым / Приветное (Алушта)",
    "country": "Россия",
    "searchString": "приветное (алушта) россия / республика крым / приветное (алушта)"
  },
  "11475": {
    "id": "11475",
    "name": "Виноградное (Ленинский район)",
    "path": "Россия / Республика Крым / Виноградное (Ленинский район)",
    "country": "Россия",
    "searchString": "виноградное (ленинский район) россия / республика крым / виноградное (ленинский район)"
  },
  "11476": {
    "id": "11476",
    "name": "Звёздный (Кабардино-Балкарская Республика)",
    "path": "Россия / Кабардино-Балкарская республика / Звёздный (Кабардино-Балкарская Республика)",
    "country": "Россия",
    "searchString": "звёздный (кабардино-балкарская республика) россия / кабардино-балкарская республика / звёздный (кабардино-балкарская республика)"
  },
  "11477": {
    "id": "11477",
    "name": "Хабаз",
    "path": "Россия / Кабардино-Балкарская республика / Хабаз",
    "country": "Россия",
    "searchString": "хабаз россия / кабардино-балкарская республика / хабаз"
  },
  "11478": {
    "id": "11478",
    "name": "Зарагиж",
    "path": "Россия / Кабардино-Балкарская республика / Зарагиж",
    "country": "Россия",
    "searchString": "зарагиж россия / кабардино-балкарская республика / зарагиж"
  },
  "11479": {
    "id": "11479",
    "name": "Шордаково",
    "path": "Россия / Кабардино-Балкарская республика / Шордаково",
    "country": "Россия",
    "searchString": "шордаково россия / кабардино-балкарская республика / шордаково"
  },
  "11480": {
    "id": "11480",
    "name": "Ропша (Ленинградская область)",
    "path": "Россия / Ленинградская область / Ропша (Ленинградская область)",
    "country": "Россия",
    "searchString": "ропша (ленинградская область) россия / ленинградская область / ропша (ленинградская область)"
  },
  "11481": {
    "id": "11481",
    "name": "Бендеры",
    "path": "Другие регионы / Молдова / Бендеры",
    "country": "Другие регионы",
    "searchString": "бендеры другие регионы / молдова / бендеры"
  },
  "11482": {
    "id": "11482",
    "name": "Комрат",
    "path": "Другие регионы / Молдова / Комрат",
    "country": "Другие регионы",
    "searchString": "комрат другие регионы / молдова / комрат"
  },
  "11483": {
    "id": "11483",
    "name": "Единец",
    "path": "Другие регионы / Молдова / Единец",
    "country": "Другие регионы",
    "searchString": "единец другие регионы / молдова / единец"
  },
  "11484": {
    "id": "11484",
    "name": "Арташат",
    "path": "Казахстан / Арташат",
    "country": "Казахстан",
    "searchString": "арташат казахстан / арташат"
  },
  "11485": {
    "id": "11485",
    "name": "Мирное (Хабаровский край)",
    "path": "Россия / Хабаровский край / Мирное (Хабаровский край)",
    "country": "Россия",
    "searchString": "мирное (хабаровский край) россия / хабаровский край / мирное (хабаровский край)"
  },
  "11486": {
    "id": "11486",
    "name": "Аннолово",
    "path": "Россия / Ленинградская область / Аннолово",
    "country": "Россия",
    "searchString": "аннолово россия / ленинградская область / аннолово"
  },
  "11487": {
    "id": "11487",
    "name": "Баклаши",
    "path": "Россия / Иркутская область / Баклаши",
    "country": "Россия",
    "searchString": "баклаши россия / иркутская область / баклаши"
  },
  "11488": {
    "id": "11488",
    "name": "Мартыновка (Курганская область)",
    "path": "Россия / Курганская область / Мартыновка (Курганская область)",
    "country": "Россия",
    "searchString": "мартыновка (курганская область) россия / курганская область / мартыновка (курганская область)"
  },
  "11489": {
    "id": "11489",
    "name": "Лермонтово (Краснодарский край)",
    "path": "Россия / Краснодарский край / Лермонтово (Краснодарский край)",
    "country": "Россия",
    "searchString": "лермонтово (краснодарский край) россия / краснодарский край / лермонтово (краснодарский край)"
  },
  "11490": {
    "id": "11490",
    "name": "Новонежино (Приморский край)",
    "path": "Россия / Приморский край / Новонежино (Приморский край)",
    "country": "Россия",
    "searchString": "новонежино (приморский край) россия / приморский край / новонежино (приморский край)"
  },
  "11491": {
    "id": "11491",
    "name": "Чертовицы (Воронежская область)",
    "path": "Россия / Воронежская область / Чертовицы (Воронежская область)",
    "country": "Россия",
    "searchString": "чертовицы (воронежская область) россия / воронежская область / чертовицы (воронежская область)"
  },
  "11492": {
    "id": "11492",
    "name": "Кочугино (Московская область)",
    "path": "Россия / Московская область / Кочугино (Московская область)",
    "country": "Россия",
    "searchString": "кочугино (московская область) россия / московская область / кочугино (московская область)"
  },
  "11493": {
    "id": "11493",
    "name": "Битца (Ленинский городской округ, Московская область)",
    "path": "Россия / Московская область / Битца (Ленинский городской округ, Московская область)",
    "country": "Россия",
    "searchString": "битца (ленинский городской округ, московская область) россия / московская область / битца (ленинский городской округ, московская область)"
  },
  "11494": {
    "id": "11494",
    "name": "Липки (Минская область)",
    "path": "Беларусь / Минская область / Липки (Минская область)",
    "country": "Беларусь",
    "searchString": "липки (минская область) беларусь / минская область / липки (минская область)"
  },
  "11495": {
    "id": "11495",
    "name": "Вишнёвка",
    "path": "Беларусь / Минская область / Вишнёвка",
    "country": "Беларусь",
    "searchString": "вишнёвка беларусь / минская область / вишнёвка"
  },
  "11496": {
    "id": "11496",
    "name": "Заполье (Минская область)",
    "path": "Беларусь / Минская область / Заполье (Минская область)",
    "country": "Беларусь",
    "searchString": "заполье (минская область) беларусь / минская область / заполье (минская область)"
  },
  "11497": {
    "id": "11497",
    "name": "Горячинск",
    "path": "Россия / Республика Бурятия / Горячинск",
    "country": "Россия",
    "searchString": "горячинск россия / республика бурятия / горячинск"
  },
  "11498": {
    "id": "11498",
    "name": "Ишемгул",
    "path": "Россия / Республика Башкортостан / Ишемгул",
    "country": "Россия",
    "searchString": "ишемгул россия / республика башкортостан / ишемгул"
  },
  "11499": {
    "id": "11499",
    "name": "Агрогородок Гожа",
    "path": "Беларусь / Гродненская область / Агрогородок Гожа",
    "country": "Беларусь",
    "searchString": "агрогородок гожа беларусь / гродненская область / агрогородок гожа"
  },
  "11500": {
    "id": "11500",
    "name": "Аршан (Калмыкия)",
    "path": "Россия / Республика Калмыкия / Аршан (Калмыкия)",
    "country": "Россия",
    "searchString": "аршан (калмыкия) россия / республика калмыкия / аршан (калмыкия)"
  },
  "11501": {
    "id": "11501",
    "name": "Ульяновское",
    "path": "Россия / Республика Калмыкия / Ульяновское",
    "country": "Россия",
    "searchString": "ульяновское россия / республика калмыкия / ульяновское"
  },
  "11502": {
    "id": "11502",
    "name": "Вознесеновка (Калмыкия)",
    "path": "Россия / Республика Калмыкия / Вознесеновка (Калмыкия)",
    "country": "Россия",
    "searchString": "вознесеновка (калмыкия) россия / республика калмыкия / вознесеновка (калмыкия)"
  },
  "11503": {
    "id": "11503",
    "name": "Тундутово",
    "path": "Россия / Республика Калмыкия / Тундутово",
    "country": "Россия",
    "searchString": "тундутово россия / республика калмыкия / тундутово"
  },
  "11504": {
    "id": "11504",
    "name": "Эсто-Алтай",
    "path": "Россия / Республика Калмыкия / Эсто-Алтай",
    "country": "Россия",
    "searchString": "эсто-алтай россия / республика калмыкия / эсто-алтай"
  },
  "11505": {
    "id": "11505",
    "name": "Обильное (Калмыкия)",
    "path": "Россия / Республика Калмыкия / Обильное (Калмыкия)",
    "country": "Россия",
    "searchString": "обильное (калмыкия) россия / республика калмыкия / обильное (калмыкия)"
  },
  "11506": {
    "id": "11506",
    "name": "Шарнут",
    "path": "Россия / Республика Калмыкия / Шарнут",
    "country": "Россия",
    "searchString": "шарнут россия / республика калмыкия / шарнут"
  },
  "11507": {
    "id": "11507",
    "name": "Воробьевка (Калмыкия)",
    "path": "Россия / Республика Калмыкия / Воробьевка (Калмыкия)",
    "country": "Россия",
    "searchString": "воробьевка (калмыкия) россия / республика калмыкия / воробьевка (калмыкия)"
  },
  "11508": {
    "id": "11508",
    "name": "Красинское",
    "path": "Россия / Республика Калмыкия / Красинское",
    "country": "Россия",
    "searchString": "красинское россия / республика калмыкия / красинское"
  },
  "11509": {
    "id": "11509",
    "name": "Красномихайловское",
    "path": "Россия / Республика Калмыкия / Красномихайловское",
    "country": "Россия",
    "searchString": "красномихайловское россия / республика калмыкия / красномихайловское"
  },
  "11510": {
    "id": "11510",
    "name": "Джалыково",
    "path": "Россия / Республика Калмыкия / Джалыково",
    "country": "Россия",
    "searchString": "джалыково россия / республика калмыкия / джалыково"
  },
  "11511": {
    "id": "11511",
    "name": "Лазаревский",
    "path": "Россия / Республика Калмыкия / Лазаревский",
    "country": "Россия",
    "searchString": "лазаревский россия / республика калмыкия / лазаревский"
  },
  "11512": {
    "id": "11512",
    "name": "Северное (Калмыкия)",
    "path": "Россия / Республика Калмыкия / Северное (Калмыкия)",
    "country": "Россия",
    "searchString": "северное (калмыкия) россия / республика калмыкия / северное (калмыкия)"
  },
  "11513": {
    "id": "11513",
    "name": "Шуя (Республика Карелия)",
    "path": "Россия / Республика Карелия / Шуя (Республика Карелия)",
    "country": "Россия",
    "searchString": "шуя (республика карелия) россия / республика карелия / шуя (республика карелия)"
  },
  "11514": {
    "id": "11514",
    "name": "Погореловка",
    "path": "Россия / Белгородская область / Погореловка",
    "country": "Россия",
    "searchString": "погореловка россия / белгородская область / погореловка"
  },
  "11515": {
    "id": "11515",
    "name": "Беловское",
    "path": "Россия / Белгородская область / Беловское",
    "country": "Россия",
    "searchString": "беловское россия / белгородская область / беловское"
  },
  "11516": {
    "id": "11516",
    "name": "Гора-Подол",
    "path": "Россия / Белгородская область / Гора-Подол",
    "country": "Россия",
    "searchString": "гора-подол россия / белгородская область / гора-подол"
  },
  "11517": {
    "id": "11517",
    "name": "Курасовка",
    "path": "Россия / Белгородская область / Курасовка",
    "country": "Россия",
    "searchString": "курасовка россия / белгородская область / курасовка"
  },
  "11518": {
    "id": "11518",
    "name": "Незнамово",
    "path": "Россия / Белгородская область / Незнамово",
    "country": "Россия",
    "searchString": "незнамово россия / белгородская область / незнамово"
  },
  "11519": {
    "id": "11519",
    "name": "Казацкое",
    "path": "Россия / Белгородская область / Казацкое",
    "country": "Россия",
    "searchString": "казацкое россия / белгородская область / казацкое"
  },
  "11520": {
    "id": "11520",
    "name": "Зелёная Поляна",
    "path": "Россия / Белгородская область / Зелёная Поляна",
    "country": "Россия",
    "searchString": "зелёная поляна россия / белгородская область / зелёная поляна"
  },
  "11521": {
    "id": "11521",
    "name": "Афанасьевка",
    "path": "Россия / Белгородская область / Афанасьевка",
    "country": "Россия",
    "searchString": "афанасьевка россия / белгородская область / афанасьевка"
  },
  "11522": {
    "id": "11522",
    "name": "Каплино",
    "path": "Россия / Белгородская область / Каплино",
    "country": "Россия",
    "searchString": "каплино россия / белгородская область / каплино"
  },
  "11523": {
    "id": "11523",
    "name": "Серетино",
    "path": "Россия / Белгородская область / Серетино",
    "country": "Россия",
    "searchString": "серетино россия / белгородская область / серетино"
  },
  "11524": {
    "id": "11524",
    "name": "Алатау",
    "path": "Казахстан / Алатау",
    "country": "Казахстан",
    "searchString": "алатау казахстан / алатау"
  },
  "11525": {
    "id": "11525",
    "name": "Темирлановка",
    "path": "Казахстан / Темирлановка",
    "country": "Казахстан",
    "searchString": "темирлановка казахстан / темирлановка"
  },
  "11526": {
    "id": "11526",
    "name": "Капчалы",
    "path": "Россия / Республика Хакасия / Капчалы",
    "country": "Россия",
    "searchString": "капчалы россия / республика хакасия / капчалы"
  },
  "11527": {
    "id": "11527",
    "name": "Алаево",
    "path": "Россия / Кемеровская область / Алаево",
    "country": "Россия",
    "searchString": "алаево россия / кемеровская область / алаево"
  },
  "11528": {
    "id": "11528",
    "name": "Плотниково (Новосибирская область)",
    "path": "Россия / Новосибирская область / Плотниково (Новосибирская область)",
    "country": "Россия",
    "searchString": "плотниково (новосибирская область) россия / новосибирская область / плотниково (новосибирская область)"
  },
  "11529": {
    "id": "11529",
    "name": "Воронцовка (Ростовская область)",
    "path": "Россия / Ростовская область / Воронцовка (Ростовская область)",
    "country": "Россия",
    "searchString": "воронцовка (ростовская область) россия / ростовская область / воронцовка (ростовская область)"
  },
  "11530": {
    "id": "11530",
    "name": "Нежеголь",
    "path": "Россия / Белгородская область / Нежеголь",
    "country": "Россия",
    "searchString": "нежеголь россия / белгородская область / нежеголь"
  },
  "11531": {
    "id": "11531",
    "name": "Голубино",
    "path": "Россия / Белгородская область / Голубино",
    "country": "Россия",
    "searchString": "голубино россия / белгородская область / голубино"
  },
  "11532": {
    "id": "11532",
    "name": "Хотмыжск",
    "path": "Россия / Белгородская область / Хотмыжск",
    "country": "Россия",
    "searchString": "хотмыжск россия / белгородская область / хотмыжск"
  },
  "11533": {
    "id": "11533",
    "name": "Ближняя Игуменка",
    "path": "Россия / Белгородская область / Ближняя Игуменка",
    "country": "Россия",
    "searchString": "ближняя игуменка россия / белгородская область / ближняя игуменка"
  },
  "11534": {
    "id": "11534",
    "name": "Сетище",
    "path": "Россия / Белгородская область / Сетище",
    "country": "Россия",
    "searchString": "сетище россия / белгородская область / сетище"
  },
  "11535": {
    "id": "11535",
    "name": "Большое Полпино",
    "path": "Россия / Брянская область / Большое Полпино",
    "country": "Россия",
    "searchString": "большое полпино россия / брянская область / большое полпино"
  },
  "11536": {
    "id": "11536",
    "name": "Радица-Крыловка",
    "path": "Россия / Брянская область / Радица-Крыловка",
    "country": "Россия",
    "searchString": "радица-крыловка россия / брянская область / радица-крыловка"
  },
  "11537": {
    "id": "11537",
    "name": "Городцы",
    "path": "Россия / Брянская область / Городцы",
    "country": "Россия",
    "searchString": "городцы россия / брянская область / городцы"
  },
  "11538": {
    "id": "11538",
    "name": "Ардонь",
    "path": "Россия / Брянская область / Ардонь",
    "country": "Россия",
    "searchString": "ардонь россия / брянская область / ардонь"
  },
  "11539": {
    "id": "11539",
    "name": "Коржовка-Голубовка",
    "path": "Россия / Брянская область / Коржовка-Голубовка",
    "country": "Россия",
    "searchString": "коржовка-голубовка россия / брянская область / коржовка-голубовка"
  },
  "11540": {
    "id": "11540",
    "name": "Отрадное (Брянская область)",
    "path": "Россия / Брянская область / Отрадное (Брянская область)",
    "country": "Россия",
    "searchString": "отрадное (брянская область) россия / брянская область / отрадное (брянская область)"
  },
  "11541": {
    "id": "11541",
    "name": "Луговой (Приморский край)",
    "path": "Россия / Приморский край / Луговой (Приморский край)",
    "country": "Россия",
    "searchString": "луговой (приморский край) россия / приморский край / луговой (приморский край)"
  },
  "11542": {
    "id": "11542",
    "name": "Новые Дарковичи",
    "path": "Россия / Брянская область / Новые Дарковичи",
    "country": "Россия",
    "searchString": "новые дарковичи россия / брянская область / новые дарковичи"
  },
  "11543": {
    "id": "11543",
    "name": "Вельяминова",
    "path": "Россия / Брянская область / Вельяминова",
    "country": "Россия",
    "searchString": "вельяминова россия / брянская область / вельяминова"
  },
  "11544": {
    "id": "11544",
    "name": "Каменка (Брянская область)",
    "path": "Россия / Брянская область / Каменка (Брянская область)",
    "country": "Россия",
    "searchString": "каменка (брянская область) россия / брянская область / каменка (брянская область)"
  },
  "11545": {
    "id": "11545",
    "name": "Нетьинка",
    "path": "Россия / Брянская область / Нетьинка",
    "country": "Россия",
    "searchString": "нетьинка россия / брянская область / нетьинка"
  },
  "11546": {
    "id": "11546",
    "name": "Брасово",
    "path": "Россия / Брянская область / Брасово",
    "country": "Россия",
    "searchString": "брасово россия / брянская область / брасово"
  },
  "11547": {
    "id": "11547",
    "name": "Погребы",
    "path": "Россия / Брянская область / Погребы",
    "country": "Россия",
    "searchString": "погребы россия / брянская область / погребы"
  },
  "11548": {
    "id": "11548",
    "name": "Замишево",
    "path": "Россия / Брянская область / Замишево",
    "country": "Россия",
    "searchString": "замишево россия / брянская область / замишево"
  },
  "11549": {
    "id": "11549",
    "name": "Чемерна",
    "path": "Россия / Брянская область / Чемерна",
    "country": "Россия",
    "searchString": "чемерна россия / брянская область / чемерна"
  },
  "11550": {
    "id": "11550",
    "name": "Лопушь",
    "path": "Россия / Брянская область / Лопушь",
    "country": "Россия",
    "searchString": "лопушь россия / брянская область / лопушь"
  },
  "11551": {
    "id": "11551",
    "name": "Воронок (Брянская область)",
    "path": "Россия / Брянская область / Воронок (Брянская область)",
    "country": "Россия",
    "searchString": "воронок (брянская область) россия / брянская область / воронок (брянская область)"
  },
  "11552": {
    "id": "11552",
    "name": "Дарковичи",
    "path": "Россия / Брянская область / Дарковичи",
    "country": "Россия",
    "searchString": "дарковичи россия / брянская область / дарковичи"
  },
  "11553": {
    "id": "11553",
    "name": "Творишино",
    "path": "Россия / Брянская область / Творишино",
    "country": "Россия",
    "searchString": "творишино россия / брянская область / творишино"
  },
  "11554": {
    "id": "11554",
    "name": "Сачковичи (Брянская область)",
    "path": "Россия / Брянская область / Сачковичи (Брянская область)",
    "country": "Россия",
    "searchString": "сачковичи (брянская область) россия / брянская область / сачковичи (брянская область)"
  },
  "11555": {
    "id": "11555",
    "name": "Никольская Слобода",
    "path": "Россия / Брянская область / Никольская Слобода",
    "country": "Россия",
    "searchString": "никольская слобода россия / брянская область / никольская слобода"
  },
  "11556": {
    "id": "11556",
    "name": "Кузьмино",
    "path": "Россия / Брянская область / Кузьмино",
    "country": "Россия",
    "searchString": "кузьмино россия / брянская область / кузьмино"
  },
  "11557": {
    "id": "11557",
    "name": "Смотрова Буда",
    "path": "Россия / Брянская область / Смотрова Буда",
    "country": "Россия",
    "searchString": "смотрова буда россия / брянская область / смотрова буда"
  },
  "11558": {
    "id": "11558",
    "name": "Пальцо",
    "path": "Россия / Брянская область / Пальцо",
    "country": "Россия",
    "searchString": "пальцо россия / брянская область / пальцо"
  },
  "11559": {
    "id": "11559",
    "name": "Ущерпье",
    "path": "Россия / Брянская область / Ущерпье",
    "country": "Россия",
    "searchString": "ущерпье россия / брянская область / ущерпье"
  },
  "11560": {
    "id": "11560",
    "name": "Мстихино",
    "path": "Россия / Калужская область / Мстихино",
    "country": "Россия",
    "searchString": "мстихино россия / калужская область / мстихино"
  },
  "11561": {
    "id": "11561",
    "name": "Митяево",
    "path": "Россия / Калужская область / Митяево",
    "country": "Россия",
    "searchString": "митяево россия / калужская область / митяево"
  },
  "11562": {
    "id": "11562",
    "name": "Рыжково (Калужская область)",
    "path": "Россия / Калужская область / Рыжково (Калужская область)",
    "country": "Россия",
    "searchString": "рыжково (калужская область) россия / калужская область / рыжково (калужская область)"
  },
  "11563": {
    "id": "11563",
    "name": "Шопино",
    "path": "Россия / Калужская область / Шопино",
    "country": "Россия",
    "searchString": "шопино россия / калужская область / шопино"
  },
  "11564": {
    "id": "11564",
    "name": "Росва",
    "path": "Россия / Калужская область / Росва",
    "country": "Россия",
    "searchString": "росва россия / калужская область / росва"
  },
  "11565": {
    "id": "11565",
    "name": "Калужская опытная сельскохозяйственная станция",
    "path": "Россия / Калужская область / Калужская опытная сельскохозяйственная станция",
    "country": "Россия",
    "searchString": "калужская опытная сельскохозяйственная станция россия / калужская область / калужская опытная сельскохозяйственная станция"
  },
  "11566": {
    "id": "11566",
    "name": "Головтеево",
    "path": "Россия / Калужская область / Головтеево",
    "country": "Россия",
    "searchString": "головтеево россия / калужская область / головтеево"
  },
  "11567": {
    "id": "11567",
    "name": "Колюпаново",
    "path": "Россия / Калужская область / Колюпаново",
    "country": "Россия",
    "searchString": "колюпаново россия / калужская область / колюпаново"
  },
  "11568": {
    "id": "11568",
    "name": "Дворцы",
    "path": "Россия / Калужская область / Дворцы",
    "country": "Россия",
    "searchString": "дворцы россия / калужская область / дворцы"
  },
  "11569": {
    "id": "11569",
    "name": "Дешовки",
    "path": "Россия / Калужская область / Дешовки",
    "country": "Россия",
    "searchString": "дешовки россия / калужская область / дешовки"
  },
  "11570": {
    "id": "11570",
    "name": "Корекозево",
    "path": "Россия / Калужская область / Корекозево",
    "country": "Россия",
    "searchString": "корекозево россия / калужская область / корекозево"
  },
  "11571": {
    "id": "11571",
    "name": "Канищево",
    "path": "Россия / Калужская область / Канищево",
    "country": "Россия",
    "searchString": "канищево россия / калужская область / канищево"
  },
  "11572": {
    "id": "11572",
    "name": "Дзержинск (Иркутская область)",
    "path": "Россия / Иркутская область / Дзержинск (Иркутская область)",
    "country": "Россия",
    "searchString": "дзержинск (иркутская область) россия / иркутская область / дзержинск (иркутская область)"
  },
  "11573": {
    "id": "11573",
    "name": "Гончаровка",
    "path": "Россия / Курская область / Гончаровка",
    "country": "Россия",
    "searchString": "гончаровка россия / курская область / гончаровка"
  },
  "11574": {
    "id": "11574",
    "name": "Заолешенка",
    "path": "Россия / Курская область / Заолешенка",
    "country": "Россия",
    "searchString": "заолешенка россия / курская область / заолешенка"
  },
  "11575": {
    "id": "11575",
    "name": "Будановка",
    "path": "Россия / Курская область / Будановка",
    "country": "Россия",
    "searchString": "будановка россия / курская область / будановка"
  },
  "11576": {
    "id": "11576",
    "name": "1-я Моква",
    "path": "Россия / Курская область / 1-я Моква",
    "country": "Россия",
    "searchString": "1-я моква россия / курская область / 1-я моква"
  },
  "11577": {
    "id": "11577",
    "name": "Юбилейный (Курская область)",
    "path": "Россия / Курская область / Юбилейный (Курская область)",
    "country": "Россия",
    "searchString": "юбилейный (курская область) россия / курская область / юбилейный (курская область)"
  },
  "11578": {
    "id": "11578",
    "name": "Златоустовск",
    "path": "Россия / Амурская область / Златоустовск",
    "country": "Россия",
    "searchString": "златоустовск россия / амурская область / златоустовск"
  },
  "11579": {
    "id": "11579",
    "name": "Полевая",
    "path": "Россия / Курская область / Полевая",
    "country": "Россия",
    "searchString": "полевая россия / курская область / полевая"
  },
  "11580": {
    "id": "11580",
    "name": "Анахина",
    "path": "Россия / Курская область / Анахина",
    "country": "Россия",
    "searchString": "анахина россия / курская область / анахина"
  },
  "11581": {
    "id": "11581",
    "name": "Пригородняя",
    "path": "Россия / Курская область / Пригородняя",
    "country": "Россия",
    "searchString": "пригородняя россия / курская область / пригородняя"
  },
  "11582": {
    "id": "11582",
    "name": "Зорино",
    "path": "Россия / Курская область / Зорино",
    "country": "Россия",
    "searchString": "зорино россия / курская область / зорино"
  },
  "11583": {
    "id": "11583",
    "name": "Кобылки",
    "path": "Россия / Курская область / Кобылки",
    "country": "Россия",
    "searchString": "кобылки россия / курская область / кобылки"
  },
  "11584": {
    "id": "11584",
    "name": "Попово-Лежачи",
    "path": "Россия / Курская область / Попово-Лежачи",
    "country": "Россия",
    "searchString": "попово-лежачи россия / курская область / попово-лежачи"
  },
  "11585": {
    "id": "11585",
    "name": "Беседино",
    "path": "Россия / Курская область / Беседино",
    "country": "Россия",
    "searchString": "беседино россия / курская область / беседино"
  },
  "11586": {
    "id": "11586",
    "name": "1-е Цветово",
    "path": "Россия / Курская область / 1-е Цветово",
    "country": "Россия",
    "searchString": "1-е цветово россия / курская область / 1-е цветово"
  },
  "11587": {
    "id": "11587",
    "name": "Махновка",
    "path": "Россия / Курская область / Махновка",
    "country": "Россия",
    "searchString": "махновка россия / курская область / махновка"
  },
  "11588": {
    "id": "11588",
    "name": "Белица",
    "path": "Россия / Курская область / Белица",
    "country": "Россия",
    "searchString": "белица россия / курская область / белица"
  },
  "11589": {
    "id": "11589",
    "name": "Черёмушки (Курская область)",
    "path": "Россия / Курская область / Черёмушки (Курская область)",
    "country": "Россия",
    "searchString": "черёмушки (курская область) россия / курская область / черёмушки (курская область)"
  },
  "11590": {
    "id": "11590",
    "name": "Волжанец",
    "path": "Россия / Курская область / Волжанец",
    "country": "Россия",
    "searchString": "волжанец россия / курская область / волжанец"
  },
  "11591": {
    "id": "11591",
    "name": "Жилина",
    "path": "Россия / Орловская область / Жилина",
    "country": "Россия",
    "searchString": "жилина россия / орловская область / жилина"
  },
  "11592": {
    "id": "11592",
    "name": "Шахово",
    "path": "Россия / Орловская область / Шахово",
    "country": "Россия",
    "searchString": "шахово россия / орловская область / шахово"
  },
  "11593": {
    "id": "11593",
    "name": "Зареченский",
    "path": "Россия / Орловская область / Зареченский",
    "country": "Россия",
    "searchString": "зареченский россия / орловская область / зареченский"
  },
  "11594": {
    "id": "11594",
    "name": "Старцево",
    "path": "Россия / Орловская область / Старцево",
    "country": "Россия",
    "searchString": "старцево россия / орловская область / старцево"
  },
  "11595": {
    "id": "11595",
    "name": "Лаврово",
    "path": "Россия / Орловская область / Лаврово",
    "country": "Россия",
    "searchString": "лаврово россия / орловская область / лаврово"
  },
  "11596": {
    "id": "11596",
    "name": "Добрый",
    "path": "Россия / Орловская область / Добрый",
    "country": "Россия",
    "searchString": "добрый россия / орловская область / добрый"
  },
  "11597": {
    "id": "11597",
    "name": "Хардиково",
    "path": "Россия / Орловская область / Хардиково",
    "country": "Россия",
    "searchString": "хардиково россия / орловская область / хардиково"
  },
  "11598": {
    "id": "11598",
    "name": "Овсянниково",
    "path": "Россия / Орловская область / Овсянниково",
    "country": "Россия",
    "searchString": "овсянниково россия / орловская область / овсянниково"
  },
  "11599": {
    "id": "11599",
    "name": "Крутое",
    "path": "Россия / Орловская область / Крутое",
    "country": "Россия",
    "searchString": "крутое россия / орловская область / крутое"
  },
  "11600": {
    "id": "11600",
    "name": "Плещеево",
    "path": "Россия / Орловская область / Плещеево",
    "country": "Россия",
    "searchString": "плещеево россия / орловская область / плещеево"
  },
  "11601": {
    "id": "11601",
    "name": "Вожово",
    "path": "Россия / Орловская область / Вожово",
    "country": "Россия",
    "searchString": "вожово россия / орловская область / вожово"
  },
  "11602": {
    "id": "11602",
    "name": "Набережный",
    "path": "Россия / Орловская область / Набережный",
    "country": "Россия",
    "searchString": "набережный россия / орловская область / набережный"
  },
  "11603": {
    "id": "11603",
    "name": "Звягинки",
    "path": "Россия / Орловская область / Звягинки",
    "country": "Россия",
    "searchString": "звягинки россия / орловская область / звягинки"
  },
  "11604": {
    "id": "11604",
    "name": "Нижняя Лужна",
    "path": "Россия / Орловская область / Нижняя Лужна",
    "country": "Россия",
    "searchString": "нижняя лужна россия / орловская область / нижняя лужна"
  },
  "11605": {
    "id": "11605",
    "name": "Биофабрика",
    "path": "Россия / Орловская область / Биофабрика",
    "country": "Россия",
    "searchString": "биофабрика россия / орловская область / биофабрика"
  },
  "11606": {
    "id": "11606",
    "name": "Андрейково",
    "path": "Россия / Смоленская область / Андрейково",
    "country": "Россия",
    "searchString": "андрейково россия / смоленская область / андрейково"
  },
  "11607": {
    "id": "11607",
    "name": "Игоревская",
    "path": "Россия / Смоленская область / Игоревская",
    "country": "Россия",
    "searchString": "игоревская россия / смоленская область / игоревская"
  },
  "11608": {
    "id": "11608",
    "name": "Издешково",
    "path": "Россия / Смоленская область / Издешково",
    "country": "Россия",
    "searchString": "издешково россия / смоленская область / издешково"
  },
  "11609": {
    "id": "11609",
    "name": "Малые Кириллы",
    "path": "Россия / Смоленская область / Малые Кириллы",
    "country": "Россия",
    "searchString": "малые кириллы россия / смоленская область / малые кириллы"
  },
  "11610": {
    "id": "11610",
    "name": "Кощино",
    "path": "Россия / Смоленская область / Кощино",
    "country": "Россия",
    "searchString": "кощино россия / смоленская область / кощино"
  },
  "11611": {
    "id": "11611",
    "name": "Остёр",
    "path": "Россия / Смоленская область / Остёр",
    "country": "Россия",
    "searchString": "остёр россия / смоленская область / остёр"
  },
  "11612": {
    "id": "11612",
    "name": "Катынь",
    "path": "Россия / Смоленская область / Катынь",
    "country": "Россия",
    "searchString": "катынь россия / смоленская область / катынь"
  },
  "11613": {
    "id": "11613",
    "name": "Богородицкое",
    "path": "Россия / Смоленская область / Богородицкое",
    "country": "Россия",
    "searchString": "богородицкое россия / смоленская область / богородицкое"
  },
  "11614": {
    "id": "11614",
    "name": "Вадино",
    "path": "Россия / Смоленская область / Вадино",
    "country": "Россия",
    "searchString": "вадино россия / смоленская область / вадино"
  },
  "11615": {
    "id": "11615",
    "name": "Екимовичи",
    "path": "Россия / Смоленская область / Екимовичи",
    "country": "Россия",
    "searchString": "екимовичи россия / смоленская область / екимовичи"
  },
  "11616": {
    "id": "11616",
    "name": "Талашкино",
    "path": "Россия / Смоленская область / Талашкино",
    "country": "Россия",
    "searchString": "талашкино россия / смоленская область / талашкино"
  },
  "11617": {
    "id": "11617",
    "name": "Кайдаково",
    "path": "Россия / Смоленская область / Кайдаково",
    "country": "Россия",
    "searchString": "кайдаково россия / смоленская область / кайдаково"
  },
  "11618": {
    "id": "11618",
    "name": "Авторемзавод",
    "path": "Россия / Смоленская область / Авторемзавод",
    "country": "Россия",
    "searchString": "авторемзавод россия / смоленская область / авторемзавод"
  },
  "11619": {
    "id": "11619",
    "name": "Сметанино",
    "path": "Россия / Смоленская область / Сметанино",
    "country": "Россия",
    "searchString": "сметанино россия / смоленская область / сметанино"
  },
  "11620": {
    "id": "11620",
    "name": "Плоское",
    "path": "Россия / Смоленская область / Плоское",
    "country": "Россия",
    "searchString": "плоское россия / смоленская область / плоское"
  },
  "11621": {
    "id": "11621",
    "name": "Михейково",
    "path": "Россия / Смоленская область / Михейково",
    "country": "Россия",
    "searchString": "михейково россия / смоленская область / михейково"
  },
  "11622": {
    "id": "11622",
    "name": "Новые Батеки",
    "path": "Россия / Смоленская область / Новые Батеки",
    "country": "Россия",
    "searchString": "новые батеки россия / смоленская область / новые батеки"
  },
  "11623": {
    "id": "11623",
    "name": "Мансурово (Московская область)",
    "path": "Россия / Московская область / Мансурово (Московская область)",
    "country": "Россия",
    "searchString": "мансурово (московская область) россия / московская область / мансурово (московская область)"
  },
  "11624": {
    "id": "11624",
    "name": "Бутово (Московская область)",
    "path": "Россия / Московская область / Бутово (Московская область)",
    "country": "Россия",
    "searchString": "бутово (московская область) россия / московская область / бутово (московская область)"
  },
  "11625": {
    "id": "11625",
    "name": "Полежайки (Московская область)",
    "path": "Россия / Московская область / Полежайки (Московская область)",
    "country": "Россия",
    "searchString": "полежайки (московская область) россия / московская область / полежайки (московская область)"
  },
  "11626": {
    "id": "11626",
    "name": "Редино(Московская область)",
    "path": "Россия / Московская область / Редино(Московская область)",
    "country": "Россия",
    "searchString": "редино(московская область) россия / московская область / редино(московская область)"
  },
  "11627": {
    "id": "11627",
    "name": "Брёхово (городской округ Химки, Московская область)",
    "path": "Россия / Московская область / Брёхово (городской округ Химки, Московская область)",
    "country": "Россия",
    "searchString": "брёхово (городской округ химки, московская область) россия / московская область / брёхово (городской округ химки, московская область)"
  },
  "11628": {
    "id": "11628",
    "name": "Сабурово (Московская область)",
    "path": "Россия / Московская область / Сабурово (Московская область)",
    "country": "Россия",
    "searchString": "сабурово (московская область) россия / московская область / сабурово (московская область)"
  },
  "11629": {
    "id": "11629",
    "name": "Арсаки",
    "path": "Россия / Владимирская область / Арсаки",
    "country": "Россия",
    "searchString": "арсаки россия / владимирская область / арсаки"
  },
  "11630": {
    "id": "11630",
    "name": "Юркино (Московская область)",
    "path": "Россия / Московская область / Юркино (Московская область)",
    "country": "Россия",
    "searchString": "юркино (московская область) россия / московская область / юркино (московская область)"
  },
  "11631": {
    "id": "11631",
    "name": "Федорцово (Московская область)",
    "path": "Россия / Московская область / Федорцово (Московская область)",
    "country": "Россия",
    "searchString": "федорцово (московская область) россия / московская область / федорцово (московская область)"
  },
  "11632": {
    "id": "11632",
    "name": "Белоостров",
    "path": "Россия / Ленинградская область / Белоостров",
    "country": "Россия",
    "searchString": "белоостров россия / ленинградская область / белоостров"
  },
  "11633": {
    "id": "11633",
    "name": "Селково (Московская область)",
    "path": "Россия / Московская область / Селково (Московская область)",
    "country": "Россия",
    "searchString": "селково (московская область) россия / московская область / селково (московская область)"
  },
  "11634": {
    "id": "11634",
    "name": "Бужаниново (Московская область)",
    "path": "Россия / Московская область / Бужаниново (Московская область)",
    "country": "Россия",
    "searchString": "бужаниново (московская область) россия / московская область / бужаниново (московская область)"
  },
  "11635": {
    "id": "11635",
    "name": "Большое Алексеевское (Московская область)",
    "path": "Россия / Московская область / Большое Алексеевское (Московская область)",
    "country": "Россия",
    "searchString": "большое алексеевское (московская область) россия / московская область / большое алексеевское (московская область)"
  },
  "11636": {
    "id": "11636",
    "name": "Поселок Зверосовхоза (Московская область)",
    "path": "Россия / Московская область / Поселок Зверосовхоза (Московская область)",
    "country": "Россия",
    "searchString": "поселок зверосовхоза (московская область) россия / московская область / поселок зверосовхоза (московская область)"
  },
  "11637": {
    "id": "11637",
    "name": "Царёво (Московская область)",
    "path": "Россия / Московская область / Царёво (Московская область)",
    "country": "Россия",
    "searchString": "царёво (московская область) россия / московская область / царёво (московская область)"
  },
  "11638": {
    "id": "11638",
    "name": "Мостовик (Московская область)",
    "path": "Россия / Московская область / Мостовик (Московская область)",
    "country": "Россия",
    "searchString": "мостовик (московская область) россия / московская область / мостовик (московская область)"
  },
  "11639": {
    "id": "11639",
    "name": "Данилово (Московская область)",
    "path": "Россия / Московская область / Данилово (Московская область)",
    "country": "Россия",
    "searchString": "данилово (московская область) россия / московская область / данилово (московская область)"
  },
  "11640": {
    "id": "11640",
    "name": "Гимры",
    "path": "Россия / Республика Дагестан / Гимры",
    "country": "Россия",
    "searchString": "гимры россия / республика дагестан / гимры"
  },
  "11641": {
    "id": "11641",
    "name": "Унцукуль",
    "path": "Россия / Республика Дагестан / Унцукуль",
    "country": "Россия",
    "searchString": "унцукуль россия / республика дагестан / унцукуль"
  },
  "11642": {
    "id": "11642",
    "name": "Чиркей",
    "path": "Россия / Республика Дагестан / Чиркей",
    "country": "Россия",
    "searchString": "чиркей россия / республика дагестан / чиркей"
  },
  "11643": {
    "id": "11643",
    "name": "Карата",
    "path": "Россия / Республика Дагестан / Карата",
    "country": "Россия",
    "searchString": "карата россия / республика дагестан / карата"
  },
  "11644": {
    "id": "11644",
    "name": "Старое Фейзуллово",
    "path": "Россия / Самарская область / Старое Фейзуллово",
    "country": "Россия",
    "searchString": "старое фейзуллово россия / самарская область / старое фейзуллово"
  },
  "11645": {
    "id": "11645",
    "name": "Старая Ивановка",
    "path": "Россия / Самарская область / Старая Ивановка",
    "country": "Россия",
    "searchString": "старая ивановка россия / самарская область / старая ивановка"
  },
  "11646": {
    "id": "11646",
    "name": "Монастырище (Приморский край)",
    "path": "Россия / Приморский край / Монастырище (Приморский край)",
    "country": "Россия",
    "searchString": "монастырище (приморский край) россия / приморский край / монастырище (приморский край)"
  },
  "11647": {
    "id": "11647",
    "name": "Дуба-Юрт",
    "path": "Россия / Чеченская республика / Дуба-Юрт",
    "country": "Россия",
    "searchString": "дуба-юрт россия / чеченская республика / дуба-юрт"
  },
  "11648": {
    "id": "11648",
    "name": "Каменный Ключ (Кемеровская область)",
    "path": "Россия / Кемеровская область / Каменный Ключ (Кемеровская область)",
    "country": "Россия",
    "searchString": "каменный ключ (кемеровская область) россия / кемеровская область / каменный ключ (кемеровская область)"
  },
  "11649": {
    "id": "11649",
    "name": "Нуркеево",
    "path": "Россия / Республика Башкортостан / Нуркеево",
    "country": "Россия",
    "searchString": "нуркеево россия / республика башкортостан / нуркеево"
  },
  "11650": {
    "id": "11650",
    "name": "Кендектамак",
    "path": "Россия / Республика Башкортостан / Кендектамак",
    "country": "Россия",
    "searchString": "кендектамак россия / республика башкортостан / кендектамак"
  },
  "11651": {
    "id": "11651",
    "name": "Муцалаул",
    "path": "Россия / Республика Дагестан / Муцалаул",
    "country": "Россия",
    "searchString": "муцалаул россия / республика дагестан / муцалаул"
  },
  "11652": {
    "id": "11652",
    "name": "Камышкутан",
    "path": "Россия / Республика Дагестан / Камышкутан",
    "country": "Россия",
    "searchString": "камышкутан россия / республика дагестан / камышкутан"
  },
  "11653": {
    "id": "11653",
    "name": "Бичевая",
    "path": "Россия / Хабаровский край / Бичевая",
    "country": "Россия",
    "searchString": "бичевая россия / хабаровский край / бичевая"
  },
  "11654": {
    "id": "11654",
    "name": "Рождествено (Тверская область)",
    "path": "Россия / Тверская область / Рождествено (Тверская область)",
    "country": "Россия",
    "searchString": "рождествено (тверская область) россия / тверская область / рождествено (тверская область)"
  },
  "11655": {
    "id": "11655",
    "name": "Большой Порек",
    "path": "Россия / Кировская область / Большой Порек",
    "country": "Россия",
    "searchString": "большой порек россия / кировская область / большой порек"
  },
  "11656": {
    "id": "11656",
    "name": "Игнатовка (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Игнатовка (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "игнатовка (республика башкортостан) россия / республика башкортостан / игнатовка (республика башкортостан)"
  },
  "11657": {
    "id": "11657",
    "name": "Кара-Якупово",
    "path": "Россия / Республика Башкортостан / Кара-Якупово",
    "country": "Россия",
    "searchString": "кара-якупово россия / республика башкортостан / кара-якупово"
  },
  "11658": {
    "id": "11658",
    "name": "Среднехозятово",
    "path": "Россия / Республика Башкортостан / Среднехозятово",
    "country": "Россия",
    "searchString": "среднехозятово россия / республика башкортостан / среднехозятово"
  },
  "11659": {
    "id": "11659",
    "name": "Покровка",
    "path": "Россия / Республика Башкортостан / Покровка",
    "country": "Россия",
    "searchString": "покровка россия / республика башкортостан / покровка"
  },
  "11660": {
    "id": "11660",
    "name": "Вторые Вурманкасы",
    "path": "Россия / Чувашская Республика / Вторые Вурманкасы",
    "country": "Россия",
    "searchString": "вторые вурманкасы россия / чувашская республика / вторые вурманкасы"
  },
  "11661": {
    "id": "11661",
    "name": "Аюта",
    "path": "Россия / Ростовская область / Аюта",
    "country": "Россия",
    "searchString": "аюта россия / ростовская область / аюта"
  },
  "11662": {
    "id": "11662",
    "name": "Манойлин",
    "path": "Россия / Волгоградская область / Манойлин",
    "country": "Россия",
    "searchString": "манойлин россия / волгоградская область / манойлин"
  },
  "11663": {
    "id": "11663",
    "name": "Крылово (Калининградская область)",
    "path": "Россия / Калининградская область / Крылово (Калининградская область)",
    "country": "Россия",
    "searchString": "крылово (калининградская область) россия / калининградская область / крылово (калининградская область)"
  },
  "11664": {
    "id": "11664",
    "name": "Володаровка",
    "path": "Россия / Калининградская область / Володаровка",
    "country": "Россия",
    "searchString": "володаровка россия / калининградская область / володаровка"
  },
  "11665": {
    "id": "11665",
    "name": "Шевченко",
    "path": "Россия / Калининградская область / Шевченко",
    "country": "Россия",
    "searchString": "шевченко россия / калининградская область / шевченко"
  },
  "11666": {
    "id": "11666",
    "name": "Лепехинка",
    "path": "Россия / Самарская область / Лепехинка",
    "country": "Россия",
    "searchString": "лепехинка россия / самарская область / лепехинка"
  },
  "11667": {
    "id": "11667",
    "name": "Новотулка",
    "path": "Россия / Самарская область / Новотулка",
    "country": "Россия",
    "searchString": "новотулка россия / самарская область / новотулка"
  },
  "11668": {
    "id": "11668",
    "name": "Новотулка (Самарская область)",
    "path": "Россия / Самарская область / Новотулка (Самарская область)",
    "country": "Россия",
    "searchString": "новотулка (самарская область) россия / самарская область / новотулка (самарская область)"
  },
  "11669": {
    "id": "11669",
    "name": "Кирово (Саратовская область)",
    "path": "Россия / Саратовская область / Кирово (Саратовская область)",
    "country": "Россия",
    "searchString": "кирово (саратовская область) россия / саратовская область / кирово (саратовская область)"
  },
  "11670": {
    "id": "11670",
    "name": "Чёрновское (Свердловская область)",
    "path": "Россия / Свердловская область / Чёрновское (Свердловская область)",
    "country": "Россия",
    "searchString": "чёрновское (свердловская область) россия / свердловская область / чёрновское (свердловская область)"
  },
  "11671": {
    "id": "11671",
    "name": "Люблино",
    "path": "Россия / Калининградская область / Люблино",
    "country": "Россия",
    "searchString": "люблино россия / калининградская область / люблино"
  },
  "11672": {
    "id": "11672",
    "name": "Новотерское",
    "path": "Россия / Чеченская республика / Новотерское",
    "country": "Россия",
    "searchString": "новотерское россия / чеченская республика / новотерское"
  },
  "11673": {
    "id": "11673",
    "name": "Золотая Степь",
    "path": "Россия / Саратовская область / Золотая Степь",
    "country": "Россия",
    "searchString": "золотая степь россия / саратовская область / золотая степь"
  },
  "11674": {
    "id": "11674",
    "name": "Сигнальный",
    "path": "Россия / Свердловская область / Сигнальный",
    "country": "Россия",
    "searchString": "сигнальный россия / свердловская область / сигнальный"
  },
  "11675": {
    "id": "11675",
    "name": "Гаркуша",
    "path": "Россия / Краснодарский край / Гаркуша",
    "country": "Россия",
    "searchString": "гаркуша россия / краснодарский край / гаркуша"
  },
  "11676": {
    "id": "11676",
    "name": "Кечёво",
    "path": "Россия / Удмуртская Республика / Кечёво",
    "country": "Россия",
    "searchString": "кечёво россия / удмуртская республика / кечёво"
  },
  "11677": {
    "id": "11677",
    "name": "Среднее Кечёво",
    "path": "Россия / Удмуртская Республика / Среднее Кечёво",
    "country": "Россия",
    "searchString": "среднее кечёво россия / удмуртская республика / среднее кечёво"
  },
  "11678": {
    "id": "11678",
    "name": "Преображенское",
    "path": "Россия / Ставропольский край / Преображенское",
    "country": "Россия",
    "searchString": "преображенское россия / ставропольский край / преображенское"
  },
  "11679": {
    "id": "11679",
    "name": "Кшлау-Елга",
    "path": "Россия / Республика Башкортостан / Кшлау-Елга",
    "country": "Россия",
    "searchString": "кшлау-елга россия / республика башкортостан / кшлау-елга"
  },
  "11680": {
    "id": "11680",
    "name": "Кунгак",
    "path": "Россия / Республика Башкортостан / Кунгак",
    "country": "Россия",
    "searchString": "кунгак россия / республика башкортостан / кунгак"
  },
  "11681": {
    "id": "11681",
    "name": "Чернышевское",
    "path": "Россия / Калининградская область / Чернышевское",
    "country": "Россия",
    "searchString": "чернышевское россия / калининградская область / чернышевское"
  },
  "11682": {
    "id": "11682",
    "name": "Новоуральское",
    "path": "Россия / Калининградская область / Новоуральское",
    "country": "Россия",
    "searchString": "новоуральское россия / калининградская область / новоуральское"
  },
  "11683": {
    "id": "11683",
    "name": "Лемдяй",
    "path": "Россия / Республика Мордовия / Лемдяй",
    "country": "Россия",
    "searchString": "лемдяй россия / республика мордовия / лемдяй"
  },
  "11684": {
    "id": "11684",
    "name": "Котчиха",
    "path": "Россия / Кировская область / Котчиха",
    "country": "Россия",
    "searchString": "котчиха россия / кировская область / котчиха"
  },
  "11685": {
    "id": "11685",
    "name": "Красюковский",
    "path": "Россия / Воронежская область / Красюковский",
    "country": "Россия",
    "searchString": "красюковский россия / воронежская область / красюковский"
  },
  "11686": {
    "id": "11686",
    "name": "Рыкань",
    "path": "Россия / Воронежская область / Рыкань",
    "country": "Россия",
    "searchString": "рыкань россия / воронежская область / рыкань"
  },
  "11687": {
    "id": "11687",
    "name": "Чулок",
    "path": "Россия / Воронежская область / Чулок",
    "country": "Россия",
    "searchString": "чулок россия / воронежская область / чулок"
  },
  "11688": {
    "id": "11688",
    "name": "Купянка",
    "path": "Россия / Воронежская область / Купянка",
    "country": "Россия",
    "searchString": "купянка россия / воронежская область / купянка"
  },
  "11689": {
    "id": "11689",
    "name": "Коденцово",
    "path": "Россия / Воронежская область / Коденцово",
    "country": "Россия",
    "searchString": "коденцово россия / воронежская область / коденцово"
  },
  "11690": {
    "id": "11690",
    "name": "Валуевка (Омская область)",
    "path": "Россия / Омская область / Валуевка (Омская область)",
    "country": "Россия",
    "searchString": "валуевка (омская область) россия / омская область / валуевка (омская область)"
  },
  "11691": {
    "id": "11691",
    "name": "Рутул",
    "path": "Россия / Республика Дагестан / Рутул",
    "country": "Россия",
    "searchString": "рутул россия / республика дагестан / рутул"
  },
  "11692": {
    "id": "11692",
    "name": "Хучни",
    "path": "Россия / Республика Дагестан / Хучни",
    "country": "Россия",
    "searchString": "хучни россия / республика дагестан / хучни"
  },
  "11693": {
    "id": "11693",
    "name": "Абалак",
    "path": "Россия / Тюменская область / Абалак",
    "country": "Россия",
    "searchString": "абалак россия / тюменская область / абалак"
  },
  "11694": {
    "id": "11694",
    "name": "Курчеево",
    "path": "Россия / Республика Башкортостан / Курчеево",
    "country": "Россия",
    "searchString": "курчеево россия / республика башкортостан / курчеево"
  },
  "11695": {
    "id": "11695",
    "name": "Ушур",
    "path": "Россия / Удмуртская Республика / Ушур",
    "country": "Россия",
    "searchString": "ушур россия / удмуртская республика / ушур"
  },
  "11696": {
    "id": "11696",
    "name": "Хив",
    "path": "Россия / Республика Дагестан / Хив",
    "country": "Россия",
    "searchString": "хив россия / республика дагестан / хив"
  },
  "11697": {
    "id": "11697",
    "name": "Шахты Южная",
    "path": "Россия / Кемеровская область / Шахты Южная",
    "country": "Россия",
    "searchString": "шахты южная россия / кемеровская область / шахты южная"
  },
  "11698": {
    "id": "11698",
    "name": "Кафыр-Кумух",
    "path": "Россия / Республика Дагестан / Кафыр-Кумух",
    "country": "Россия",
    "searchString": "кафыр-кумух россия / республика дагестан / кафыр-кумух"
  },
  "11699": {
    "id": "11699",
    "name": "Тетеревятка",
    "path": "Россия / Вологодская область / Тетеревятка",
    "country": "Россия",
    "searchString": "тетеревятка россия / вологодская область / тетеревятка"
  },
  "11700": {
    "id": "11700",
    "name": "Кречетово",
    "path": "Россия / Архангельская область / Кречетово",
    "country": "Россия",
    "searchString": "кречетово россия / архангельская область / кречетово"
  },
  "11701": {
    "id": "11701",
    "name": "Хандагайты",
    "path": "Россия / Республика Тыва / Хандагайты",
    "country": "Россия",
    "searchString": "хандагайты россия / республика тыва / хандагайты"
  },
  "11702": {
    "id": "11702",
    "name": "Демьяс",
    "path": "Россия / Саратовская область / Демьяс",
    "country": "Россия",
    "searchString": "демьяс россия / саратовская область / демьяс"
  },
  "11703": {
    "id": "11703",
    "name": "Новозаволжский",
    "path": "Россия / Саратовская область / Новозаволжский",
    "country": "Россия",
    "searchString": "новозаволжский россия / саратовская область / новозаволжский"
  },
  "11704": {
    "id": "11704",
    "name": "Новоурусовка",
    "path": "Россия / Астраханская область / Новоурусовка",
    "country": "Россия",
    "searchString": "новоурусовка россия / астраханская область / новоурусовка"
  },
  "11705": {
    "id": "11705",
    "name": "Жуланово",
    "path": "Россия / Пермский край / Жуланово",
    "country": "Россия",
    "searchString": "жуланово россия / пермский край / жуланово"
  },
  "11706": {
    "id": "11706",
    "name": "Светлый Ключ",
    "path": "Россия / Самарская область / Светлый Ключ",
    "country": "Россия",
    "searchString": "светлый ключ россия / самарская область / светлый ключ"
  },
  "11707": {
    "id": "11707",
    "name": "Кривенковское",
    "path": "Россия / Краснодарский край / Кривенковское",
    "country": "Россия",
    "searchString": "кривенковское россия / краснодарский край / кривенковское"
  },
  "11708": {
    "id": "11708",
    "name": "Круглое Поле",
    "path": "Россия / Республика Татарстан / Круглое Поле",
    "country": "Россия",
    "searchString": "круглое поле россия / республика татарстан / круглое поле"
  },
  "11709": {
    "id": "11709",
    "name": "Хапо-Ое",
    "path": "Россия / Ленинградская область / Хапо-Ое",
    "country": "Россия",
    "searchString": "хапо-ое россия / ленинградская область / хапо-ое"
  },
  "11710": {
    "id": "11710",
    "name": "Новосаратовка",
    "path": "Россия / Ленинградская область / Новосаратовка",
    "country": "Россия",
    "searchString": "новосаратовка россия / ленинградская область / новосаратовка"
  },
  "11711": {
    "id": "11711",
    "name": "Страховский",
    "path": "Россия / Волгоградская область / Страховский",
    "country": "Россия",
    "searchString": "страховский россия / волгоградская область / страховский"
  },
  "11712": {
    "id": "11712",
    "name": "Теркин",
    "path": "Россия / Волгоградская область / Теркин",
    "country": "Россия",
    "searchString": "теркин россия / волгоградская область / теркин"
  },
  "11713": {
    "id": "11713",
    "name": "Ефремово",
    "path": "Россия / Владимирская область / Ефремово",
    "country": "Россия",
    "searchString": "ефремово россия / владимирская область / ефремово"
  },
  "11714": {
    "id": "11714",
    "name": "Першино",
    "path": "Россия / Владимирская область / Першино",
    "country": "Россия",
    "searchString": "першино россия / владимирская область / першино"
  },
  "11715": {
    "id": "11715",
    "name": "Старое Перепечино",
    "path": "Россия / Владимирская область / Старое Перепечино",
    "country": "Россия",
    "searchString": "старое перепечино россия / владимирская область / старое перепечино"
  },
  "11716": {
    "id": "11716",
    "name": "Польский",
    "path": "Россия / Ставропольский край / Польский",
    "country": "Россия",
    "searchString": "польский россия / ставропольский край / польский"
  },
  "11717": {
    "id": "11717",
    "name": "Колталово",
    "path": "Россия / Тверская область / Колталово",
    "country": "Россия",
    "searchString": "колталово россия / тверская область / колталово"
  },
  "11718": {
    "id": "11718",
    "name": "Мансурово (Башкортостан)",
    "path": "Россия / Республика Башкортостан / Мансурово (Башкортостан)",
    "country": "Россия",
    "searchString": "мансурово (башкортостан) россия / республика башкортостан / мансурово (башкортостан)"
  },
  "11719": {
    "id": "11719",
    "name": "Валерьяново (Минская область)",
    "path": "Беларусь / Минская область / Валерьяново (Минская область)",
    "country": "Беларусь",
    "searchString": "валерьяново (минская область) беларусь / минская область / валерьяново (минская область)"
  },
  "11720": {
    "id": "11720",
    "name": "Лунёво (городской округ Химки, Московская область)",
    "path": "Россия / Московская область / Лунёво (городской округ Химки, Московская область)",
    "country": "Россия",
    "searchString": "лунёво (городской округ химки, московская область) россия / московская область / лунёво (городской округ химки, московская область)"
  },
  "11721": {
    "id": "11721",
    "name": "Чёрная Грязь (городской округ Химки, Московская область)",
    "path": "Россия / Московская область / Чёрная Грязь (городской округ Химки, Московская область)",
    "country": "Россия",
    "searchString": "чёрная грязь (городской округ химки, московская область) россия / московская область / чёрная грязь (городской округ химки, московская область)"
  },
  "11722": {
    "id": "11722",
    "name": "Малобрусянское",
    "path": "Россия / Свердловская область / Малобрусянское",
    "country": "Россия",
    "searchString": "малобрусянское россия / свердловская область / малобрусянское"
  },
  "11723": {
    "id": "11723",
    "name": "Тобыл",
    "path": "Казахстан / Тобыл",
    "country": "Казахстан",
    "searchString": "тобыл казахстан / тобыл"
  },
  "11756": {
    "id": "11756",
    "name": "Акбердино",
    "path": "Россия / Республика Башкортостан / Акбердино",
    "country": "Россия",
    "searchString": "акбердино россия / республика башкортостан / акбердино"
  },
  "11757": {
    "id": "11757",
    "name": "Тыгиш",
    "path": "Россия / Свердловская область / Тыгиш",
    "country": "Россия",
    "searchString": "тыгиш россия / свердловская область / тыгиш"
  },
  "11758": {
    "id": "11758",
    "name": "агрогородок Синявка",
    "path": "Беларусь / Минская область / агрогородок Синявка",
    "country": "Беларусь",
    "searchString": "агрогородок синявка беларусь / минская область / агрогородок синявка"
  },
  "11759": {
    "id": "11759",
    "name": "агрогородок Лучники",
    "path": "Беларусь / Минская область / агрогородок Лучники",
    "country": "Беларусь",
    "searchString": "агрогородок лучники беларусь / минская область / агрогородок лучники"
  },
  "11760": {
    "id": "11760",
    "name": "агрогородок Зазерка",
    "path": "Беларусь / Минская область / агрогородок Зазерка",
    "country": "Беларусь",
    "searchString": "агрогородок зазерка беларусь / минская область / агрогородок зазерка"
  },
  "11761": {
    "id": "11761",
    "name": "Околица",
    "path": "Беларусь / Минская область / Околица",
    "country": "Беларусь",
    "searchString": "околица беларусь / минская область / околица"
  },
  "11762": {
    "id": "11762",
    "name": "агрогородок Крево",
    "path": "Беларусь / Гродненская область / агрогородок Крево",
    "country": "Беларусь",
    "searchString": "агрогородок крево беларусь / гродненская область / агрогородок крево"
  },
  "11763": {
    "id": "11763",
    "name": "агрогородок Вишнево",
    "path": "Беларусь / Гродненская область / агрогородок Вишнево",
    "country": "Беларусь",
    "searchString": "агрогородок вишнево беларусь / гродненская область / агрогородок вишнево"
  },
  "11764": {
    "id": "11764",
    "name": "Загородный",
    "path": "Россия / Республика Башкортостан / Загородный",
    "country": "Россия",
    "searchString": "загородный россия / республика башкортостан / загородный"
  },
  "11765": {
    "id": "11765",
    "name": "Борисовичи",
    "path": "Россия / Псковская область / Борисовичи",
    "country": "Россия",
    "searchString": "борисовичи россия / псковская область / борисовичи"
  },
  "11766": {
    "id": "11766",
    "name": "Писковичи",
    "path": "Россия / Псковская область / Писковичи",
    "country": "Россия",
    "searchString": "писковичи россия / псковская область / писковичи"
  },
  "11767": {
    "id": "11767",
    "name": "Уречье",
    "path": "Беларусь / Минская область / Уречье",
    "country": "Беларусь",
    "searchString": "уречье беларусь / минская область / уречье"
  },
  "11768": {
    "id": "11768",
    "name": "Кобда",
    "path": "Казахстан / Кобда",
    "country": "Казахстан",
    "searchString": "кобда казахстан / кобда"
  },
  "11769": {
    "id": "11769",
    "name": "агрогородок Негорелое",
    "path": "Беларусь / Минская область / агрогородок Негорелое",
    "country": "Беларусь",
    "searchString": "агрогородок негорелое беларусь / минская область / агрогородок негорелое"
  },
  "11770": {
    "id": "11770",
    "name": "Марусино",
    "path": "Россия / Новосибирская область / Марусино",
    "country": "Россия",
    "searchString": "марусино россия / новосибирская область / марусино"
  },
  "11771": {
    "id": "11771",
    "name": "Ромашково",
    "path": "Россия / Московская область / Ромашково",
    "country": "Россия",
    "searchString": "ромашково россия / московская область / ромашково"
  },
  "11772": {
    "id": "11772",
    "name": "Дубовляны",
    "path": "Беларусь / Минская область / Дубовляны",
    "country": "Беларусь",
    "searchString": "дубовляны беларусь / минская область / дубовляны"
  },
  "11773": {
    "id": "11773",
    "name": "Щомыслица",
    "path": "Беларусь / Минская область / Щомыслица",
    "country": "Беларусь",
    "searchString": "щомыслица беларусь / минская область / щомыслица"
  },
  "11805": {
    "id": "11805",
    "name": "Снов",
    "path": "Беларусь / Минская область / Снов",
    "country": "Беларусь",
    "searchString": "снов беларусь / минская область / снов"
  },
  "11806": {
    "id": "11806",
    "name": "Марфино (Одинцовский городской округ, Московская область)",
    "path": "Россия / Московская область / Марфино (Одинцовский городской округ, Московская область)",
    "country": "Россия",
    "searchString": "марфино (одинцовский городской округ, московская область) россия / московская область / марфино (одинцовский городской округ, московская область)"
  },
  "11807": {
    "id": "11807",
    "name": "Марфино (городской округ Клин, Московская область)",
    "path": "Россия / Московская область / Марфино (городской округ Клин, Московская область)",
    "country": "Россия",
    "searchString": "марфино (городской округ клин, московская область) россия / московская область / марфино (городской округ клин, московская область)"
  },
  "11808": {
    "id": "11808",
    "name": "Преображенский",
    "path": "Россия / Республика Мордовия / Преображенский",
    "country": "Россия",
    "searchString": "преображенский россия / республика мордовия / преображенский"
  },
  "11809": {
    "id": "11809",
    "name": "Нагорное",
    "path": "Россия / Московская область / Нагорное",
    "country": "Россия",
    "searchString": "нагорное россия / московская область / нагорное"
  },
  "11810": {
    "id": "11810",
    "name": "Филимонковское",
    "path": "Россия / Московская область / Филимонковское",
    "country": "Россия",
    "searchString": "филимонковское россия / московская область / филимонковское"
  },
  "11811": {
    "id": "11811",
    "name": "Коробово (Московская область)",
    "path": "Россия / Московская область / Коробово (Московская область)",
    "country": "Россия",
    "searchString": "коробово (московская область) россия / московская область / коробово (московская область)"
  },
  "11812": {
    "id": "11812",
    "name": "Алексино",
    "path": "Россия / Вологодская область / Алексино",
    "country": "Россия",
    "searchString": "алексино россия / вологодская область / алексино"
  },
  "11813": {
    "id": "11813",
    "name": "Новое Шигалеево (Татарстан)",
    "path": "Россия / Республика Татарстан / Новое Шигалеево (Татарстан)",
    "country": "Россия",
    "searchString": "новое шигалеево (татарстан) россия / республика татарстан / новое шигалеево (татарстан)"
  },
  "11814": {
    "id": "11814",
    "name": "Неелово",
    "path": "Россия / Псковская область / Неелово",
    "country": "Россия",
    "searchString": "неелово россия / псковская область / неелово"
  },
  "11815": {
    "id": "11815",
    "name": "Тарутино (Калужская область)",
    "path": "Россия / Калужская область / Тарутино (Калужская область)",
    "country": "Россия",
    "searchString": "тарутино (калужская область) россия / калужская область / тарутино (калужская область)"
  },
  "11816": {
    "id": "11816",
    "name": "Каракан",
    "path": "Россия / Кемеровская область / Каракан",
    "country": "Россия",
    "searchString": "каракан россия / кемеровская область / каракан"
  },
  "11817": {
    "id": "11817",
    "name": "Якты-Куль",
    "path": "Россия / Республика Башкортостан / Якты-Куль",
    "country": "Россия",
    "searchString": "якты-куль россия / республика башкортостан / якты-куль"
  },
  "11818": {
    "id": "11818",
    "name": "Киселёво",
    "path": "Россия / Ростовская область / Киселёво",
    "country": "Россия",
    "searchString": "киселёво россия / ростовская область / киселёво"
  },
  "11819": {
    "id": "11819",
    "name": "Залесье",
    "path": "Россия / Калининградская область / Залесье",
    "country": "Россия",
    "searchString": "залесье россия / калининградская область / залесье"
  },
  "11820": {
    "id": "11820",
    "name": "Авангард",
    "path": "Россия / Приморский край / Авангард",
    "country": "Россия",
    "searchString": "авангард россия / приморский край / авангард"
  },
  "11821": {
    "id": "11821",
    "name": "Кара-Хаак",
    "path": "Россия / Республика Тыва / Кара-Хаак",
    "country": "Россия",
    "searchString": "кара-хаак россия / республика тыва / кара-хаак"
  },
  "11822": {
    "id": "11822",
    "name": "Эрги-Барлык",
    "path": "Россия / Республика Тыва / Эрги-Барлык",
    "country": "Россия",
    "searchString": "эрги-барлык россия / республика тыва / эрги-барлык"
  },
  "11823": {
    "id": "11823",
    "name": "Чыраа-Бажы",
    "path": "Россия / Республика Тыва / Чыраа-Бажы",
    "country": "Россия",
    "searchString": "чыраа-бажы россия / республика тыва / чыраа-бажы"
  },
  "11824": {
    "id": "11824",
    "name": "Суг-Аксы",
    "path": "Россия / Республика Тыва / Суг-Аксы",
    "country": "Россия",
    "searchString": "суг-аксы россия / республика тыва / суг-аксы"
  },
  "11825": {
    "id": "11825",
    "name": "Чистое Поле",
    "path": "Россия / Нижегородская область / Чистое Поле",
    "country": "Россия",
    "searchString": "чистое поле россия / нижегородская область / чистое поле"
  },
  "11826": {
    "id": "11826",
    "name": "Бердыкель",
    "path": "Россия / Чеченская республика / Бердыкель",
    "country": "Россия",
    "searchString": "бердыкель россия / чеченская республика / бердыкель"
  },
  "11827": {
    "id": "11827",
    "name": "Проба",
    "path": "Россия / Ленинградская область / Проба",
    "country": "Россия",
    "searchString": "проба россия / ленинградская область / проба"
  },
  "11828": {
    "id": "11828",
    "name": "Академгородок (Новосибирская область)",
    "path": "Россия / Новосибирская область / Академгородок (Новосибирская область)",
    "country": "Россия",
    "searchString": "академгородок (новосибирская область) россия / новосибирская область / академгородок (новосибирская область)"
  },
  "11829": {
    "id": "11829",
    "name": "Тучково (Владимирская область)",
    "path": "Россия / Владимирская область / Тучково (Владимирская область)",
    "country": "Россия",
    "searchString": "тучково (владимирская область) россия / владимирская область / тучково (владимирская область)"
  },
  "11830": {
    "id": "11830",
    "name": "Побединское",
    "path": "Россия / Чеченская республика / Побединское",
    "country": "Россия",
    "searchString": "побединское россия / чеченская республика / побединское"
  },
  "11831": {
    "id": "11831",
    "name": "Тымовский",
    "path": "Россия / Сахалинская область / Тымовский",
    "country": "Россия",
    "searchString": "тымовский россия / сахалинская область / тымовский"
  },
  "11832": {
    "id": "11832",
    "name": "Русская Гвоздёвка",
    "path": "Россия / Воронежская область / Русская Гвоздёвка",
    "country": "Россия",
    "searchString": "русская гвоздёвка россия / воронежская область / русская гвоздёвка"
  },
  "11833": {
    "id": "11833",
    "name": "Чекрушево",
    "path": "Россия / Омская область / Чекрушево",
    "country": "Россия",
    "searchString": "чекрушево россия / омская область / чекрушево"
  },
  "11834": {
    "id": "11834",
    "name": "Терновка (Саратовская область)",
    "path": "Россия / Саратовская область / Терновка (Саратовская область)",
    "country": "Россия",
    "searchString": "терновка (саратовская область) россия / саратовская область / терновка (саратовская область)"
  },
  "11835": {
    "id": "11835",
    "name": "Атал",
    "path": "Россия / Астраханская область / Атал",
    "country": "Россия",
    "searchString": "атал россия / астраханская область / атал"
  },
  "11836": {
    "id": "11836",
    "name": "Нартовский",
    "path": "Россия / Астраханская область / Нартовский",
    "country": "Россия",
    "searchString": "нартовский россия / астраханская область / нартовский"
  },
  "11837": {
    "id": "11837",
    "name": "Старобабичево",
    "path": "Россия / Республика Башкортостан / Старобабичево",
    "country": "Россия",
    "searchString": "старобабичево россия / республика башкортостан / старобабичево"
  },
  "11838": {
    "id": "11838",
    "name": "Раскатово",
    "path": "Россия / Саратовская область / Раскатово",
    "country": "Россия",
    "searchString": "раскатово россия / саратовская область / раскатово"
  },
  "11839": {
    "id": "11839",
    "name": "Колос",
    "path": "Россия / Саратовская область / Колос",
    "country": "Россия",
    "searchString": "колос россия / саратовская область / колос"
  },
  "11840": {
    "id": "11840",
    "name": "Новозахаркино",
    "path": "Россия / Саратовская область / Новозахаркино",
    "country": "Россия",
    "searchString": "новозахаркино россия / саратовская область / новозахаркино"
  },
  "11841": {
    "id": "11841",
    "name": "Красное Пламя",
    "path": "Россия / Владимирская область / Красное Пламя",
    "country": "Россия",
    "searchString": "красное пламя россия / владимирская область / красное пламя"
  },
  "11842": {
    "id": "11842",
    "name": "Тигино",
    "path": "Россия / Красноярский край / Тигино",
    "country": "Россия",
    "searchString": "тигино россия / красноярский край / тигино"
  },
  "11843": {
    "id": "11843",
    "name": "Надтеречное",
    "path": "Россия / Чеченская республика / Надтеречное",
    "country": "Россия",
    "searchString": "надтеречное россия / чеченская республика / надтеречное"
  },
  "11844": {
    "id": "11844",
    "name": "Кошуки",
    "path": "Россия / Свердловская область / Кошуки",
    "country": "Россия",
    "searchString": "кошуки россия / свердловская область / кошуки"
  },
  "11845": {
    "id": "11845",
    "name": "Увал (Свердловская область)",
    "path": "Россия / Свердловская область / Увал (Свердловская область)",
    "country": "Россия",
    "searchString": "увал (свердловская область) россия / свердловская область / увал (свердловская область)"
  },
  "11846": {
    "id": "11846",
    "name": "Заветы Ильича",
    "path": "Россия / Алтайский край / Заветы Ильича",
    "country": "Россия",
    "searchString": "заветы ильича россия / алтайский край / заветы ильича"
  },
  "11847": {
    "id": "11847",
    "name": "Большепанюшево",
    "path": "Россия / Алтайский край / Большепанюшево",
    "country": "Россия",
    "searchString": "большепанюшево россия / алтайский край / большепанюшево"
  },
  "11848": {
    "id": "11848",
    "name": "Пуланколь",
    "path": "Россия / Республика Хакасия / Пуланколь",
    "country": "Россия",
    "searchString": "пуланколь россия / республика хакасия / пуланколь"
  },
  "11849": {
    "id": "11849",
    "name": "Большое Голоустное",
    "path": "Россия / Иркутская область / Большое Голоустное",
    "country": "Россия",
    "searchString": "большое голоустное россия / иркутская область / большое голоустное"
  },
  "11850": {
    "id": "11850",
    "name": "Архангельское",
    "path": "Россия / Челябинская область / Архангельское",
    "country": "Россия",
    "searchString": "архангельское россия / челябинская область / архангельское"
  },
  "11851": {
    "id": "11851",
    "name": "Коврово",
    "path": "Россия / Калининградская область / Коврово",
    "country": "Россия",
    "searchString": "коврово россия / калининградская область / коврово"
  },
  "11852": {
    "id": "11852",
    "name": "Дубовская",
    "path": "Россия / Чеченская республика / Дубовская",
    "country": "Россия",
    "searchString": "дубовская россия / чеченская республика / дубовская"
  },
  "11853": {
    "id": "11853",
    "name": "Шувалово",
    "path": "Россия / Костромская область / Шувалово",
    "country": "Россия",
    "searchString": "шувалово россия / костромская область / шувалово"
  },
  "11854": {
    "id": "11854",
    "name": "Солдатское (Воронежская область)",
    "path": "Россия / Воронежская область / Солдатское (Воронежская область)",
    "country": "Россия",
    "searchString": "солдатское (воронежская область) россия / воронежская область / солдатское (воронежская область)"
  },
  "11855": {
    "id": "11855",
    "name": "Дубовская (Чеченская республика)",
    "path": "Россия / Чеченская республика / Дубовская (Чеченская республика)",
    "country": "Россия",
    "searchString": "дубовская (чеченская республика) россия / чеченская республика / дубовская (чеченская республика)"
  },
  "11856": {
    "id": "11856",
    "name": "Ишалино (Челябинская область)",
    "path": "Россия / Челябинская область / Ишалино (Челябинская область)",
    "country": "Россия",
    "searchString": "ишалино (челябинская область) россия / челябинская область / ишалино (челябинская область)"
  },
  "11857": {
    "id": "11857",
    "name": "Пановка (Республика Татарстан)",
    "path": "Россия / Республика Татарстан / Пановка (Республика Татарстан)",
    "country": "Россия",
    "searchString": "пановка (республика татарстан) россия / республика татарстан / пановка (республика татарстан)"
  },
  "11858": {
    "id": "11858",
    "name": "Малая Златогорка",
    "path": "Россия / Кемеровская область / Малая Златогорка",
    "country": "Россия",
    "searchString": "малая златогорка россия / кемеровская область / малая златогорка"
  },
  "11859": {
    "id": "11859",
    "name": "Успенка (Кемеровская область)",
    "path": "Россия / Кемеровская область / Успенка (Кемеровская область)",
    "country": "Россия",
    "searchString": "успенка (кемеровская область) россия / кемеровская область / успенка (кемеровская область)"
  },
  "11860": {
    "id": "11860",
    "name": "Глухаринка",
    "path": "Россия / Кемеровская область / Глухаринка",
    "country": "Россия",
    "searchString": "глухаринка россия / кемеровская область / глухаринка"
  },
  "11861": {
    "id": "11861",
    "name": "Большие Лепесы",
    "path": "Беларусь / Брестская область / Большие Лепесы",
    "country": "Беларусь",
    "searchString": "большие лепесы беларусь / брестская область / большие лепесы"
  },
  "11862": {
    "id": "11862",
    "name": "Логишин",
    "path": "Беларусь / Брестская область / Логишин",
    "country": "Беларусь",
    "searchString": "логишин беларусь / брестская область / логишин"
  },
  "11863": {
    "id": "11863",
    "name": "Хомск",
    "path": "Беларусь / Брестская область / Хомск",
    "country": "Беларусь",
    "searchString": "хомск беларусь / брестская область / хомск"
  },
  "11864": {
    "id": "11864",
    "name": "Ветрино",
    "path": "Беларусь / Витебская область / Ветрино",
    "country": "Беларусь",
    "searchString": "ветрино беларусь / витебская область / ветрино"
  },
  "11865": {
    "id": "11865",
    "name": "Витьба",
    "path": "Беларусь / Витебская область / Витьба",
    "country": "Беларусь",
    "searchString": "витьба беларусь / витебская область / витьба"
  },
  "11866": {
    "id": "11866",
    "name": "Подъельцы",
    "path": "Беларусь / Витебская область / Подъельцы",
    "country": "Беларусь",
    "searchString": "подъельцы беларусь / витебская область / подъельцы"
  },
  "11867": {
    "id": "11867",
    "name": "Заречье (Гомельская область)",
    "path": "Беларусь / Гомельская область / Заречье (Гомельская область)",
    "country": "Беларусь",
    "searchString": "заречье (гомельская область) беларусь / гомельская область / заречье (гомельская область)"
  },
  "11868": {
    "id": "11868",
    "name": "Озёры",
    "path": "Беларусь / Гродненская область / Озёры",
    "country": "Беларусь",
    "searchString": "озёры беларусь / гродненская область / озёры"
  },
  "11869": {
    "id": "11869",
    "name": "Старобин",
    "path": "Беларусь / Минская область / Старобин",
    "country": "Беларусь",
    "searchString": "старобин беларусь / минская область / старобин"
  },
  "11870": {
    "id": "11870",
    "name": "Мышковичи",
    "path": "Беларусь / Могилевская область / Мышковичи",
    "country": "Беларусь",
    "searchString": "мышковичи беларусь / могилевская область / мышковичи"
  },
  "11871": {
    "id": "11871",
    "name": "Остромечево",
    "path": "Беларусь / Брестская область / Остромечево",
    "country": "Беларусь",
    "searchString": "остромечево беларусь / брестская область / остромечево"
  },
  "11872": {
    "id": "11872",
    "name": "Домачево",
    "path": "Беларусь / Брестская область / Домачево",
    "country": "Беларусь",
    "searchString": "домачево беларусь / брестская область / домачево"
  },
  "11873": {
    "id": "11873",
    "name": "Чернавчицы",
    "path": "Беларусь / Брестская область / Чернавчицы",
    "country": "Беларусь",
    "searchString": "чернавчицы беларусь / брестская область / чернавчицы"
  },
  "11874": {
    "id": "11874",
    "name": "Черни",
    "path": "Беларусь / Брестская область / Черни",
    "country": "Беларусь",
    "searchString": "черни беларусь / брестская область / черни"
  },
  "11875": {
    "id": "11875",
    "name": "Большие Мотыкалы",
    "path": "Беларусь / Брестская область / Большие Мотыкалы",
    "country": "Беларусь",
    "searchString": "большие мотыкалы беларусь / брестская область / большие мотыкалы"
  },
  "11876": {
    "id": "11876",
    "name": "Ведлозеро",
    "path": "Россия / Республика Карелия / Ведлозеро",
    "country": "Россия",
    "searchString": "ведлозеро россия / республика карелия / ведлозеро"
  },
  "11877": {
    "id": "11877",
    "name": "Ильич (Гомельская область)",
    "path": "Беларусь / Гомельская область / Ильич (Гомельская область)",
    "country": "Беларусь",
    "searchString": "ильич (гомельская область) беларусь / гомельская область / ильич (гомельская область)"
  },
  "11878": {
    "id": "11878",
    "name": "Коммунар (Гомельская область)",
    "path": "Беларусь / Гомельская область / Коммунар (Гомельская область)",
    "country": "Беларусь",
    "searchString": "коммунар (гомельская область) беларусь / гомельская область / коммунар (гомельская область)"
  },
  "11879": {
    "id": "11879",
    "name": "Урицкое (Гомельская область)",
    "path": "Беларусь / Гомельская область / Урицкое (Гомельская область)",
    "country": "Беларусь",
    "searchString": "урицкое (гомельская область) беларусь / гомельская область / урицкое (гомельская область)"
  },
  "11880": {
    "id": "11880",
    "name": "Зеленый Бор (Минская область)",
    "path": "Беларусь / Минская область / Зеленый Бор (Минская область)",
    "country": "Беларусь",
    "searchString": "зеленый бор (минская область) беларусь / минская область / зеленый бор (минская область)"
  },
  "11881": {
    "id": "11881",
    "name": "Елизово (Могилевская область)",
    "path": "Беларусь / Могилевская область / Елизово (Могилевская область)",
    "country": "Беларусь",
    "searchString": "елизово (могилевская область) беларусь / могилевская область / елизово (могилевская область)"
  },
  "11882": {
    "id": "11882",
    "name": "Головино",
    "path": "Россия / Владимирская область / Головино",
    "country": "Россия",
    "searchString": "головино россия / владимирская область / головино"
  },
  "11883": {
    "id": "11883",
    "name": "Шелангер",
    "path": "Россия / Республика Марий Эл / Шелангер",
    "country": "Россия",
    "searchString": "шелангер россия / республика марий эл / шелангер"
  },
  "11884": {
    "id": "11884",
    "name": "Большое Исаково",
    "path": "Россия / Калининградская область / Большое Исаково",
    "country": "Россия",
    "searchString": "большое исаково россия / калининградская область / большое исаково"
  },
  "11885": {
    "id": "11885",
    "name": "Красная Поляна (Донецкая Народная Республика)",
    "path": "Россия / Донецкая Народная Республика / Красная Поляна (Донецкая Народная Республика)",
    "country": "Россия",
    "searchString": "красная поляна (донецкая народная республика) россия / донецкая народная республика / красная поляна (донецкая народная республика)"
  },
  "11886": {
    "id": "11886",
    "name": "Соловей-Ключ (Приморский край)",
    "path": "Россия / Приморский край / Соловей-Ключ (Приморский край)",
    "country": "Россия",
    "searchString": "соловей-ключ (приморский край) россия / приморский край / соловей-ключ (приморский край)"
  },
  "11887": {
    "id": "11887",
    "name": "Заворово",
    "path": "Россия / Московская область / Заворово",
    "country": "Россия",
    "searchString": "заворово россия / московская область / заворово"
  },
  "11888": {
    "id": "11888",
    "name": "Красный Крым",
    "path": "Россия / Ростовская область / Красный Крым",
    "country": "Россия",
    "searchString": "красный крым россия / ростовская область / красный крым"
  },
  "11889": {
    "id": "11889",
    "name": "Ленинакан",
    "path": "Россия / Ростовская область / Ленинакан",
    "country": "Россия",
    "searchString": "ленинакан россия / ростовская область / ленинакан"
  },
  "11890": {
    "id": "11890",
    "name": "Рылеево",
    "path": "Россия / Московская область / Рылеево",
    "country": "Россия",
    "searchString": "рылеево россия / московская область / рылеево"
  },
  "11891": {
    "id": "11891",
    "name": "Ганусово",
    "path": "Россия / Московская область / Ганусово",
    "country": "Россия",
    "searchString": "ганусово россия / московская область / ганусово"
  },
  "11892": {
    "id": "11892",
    "name": "Малышево (Московская область)",
    "path": "Россия / Московская область / Малышево (Московская область)",
    "country": "Россия",
    "searchString": "малышево (московская область) россия / московская область / малышево (московская область)"
  },
  "11893": {
    "id": "11893",
    "name": "Юкковское сельское поселение",
    "path": "Россия / Ленинградская область / Юкковское сельское поселение",
    "country": "Россия",
    "searchString": "юкковское сельское поселение россия / ленинградская область / юкковское сельское поселение"
  },
  "11894": {
    "id": "11894",
    "name": "Тюшево  (Рязанская область)",
    "path": "Россия / Рязанская область / Тюшево  (Рязанская область)",
    "country": "Россия",
    "searchString": "тюшево  (рязанская область) россия / рязанская область / тюшево  (рязанская область)"
  },
  "11895": {
    "id": "11895",
    "name": "Губино (Московская область)",
    "path": "Россия / Московская область / Губино (Московская область)",
    "country": "Россия",
    "searchString": "губино (московская область) россия / московская область / губино (московская область)"
  },
  "11896": {
    "id": "11896",
    "name": "Заречный (Московская область)",
    "path": "Россия / Московская область / Заречный (Московская область)",
    "country": "Россия",
    "searchString": "заречный (московская область) россия / московская область / заречный (московская область)"
  },
  "11897": {
    "id": "11897",
    "name": "Самотовино (Московская область)",
    "path": "Россия / Московская область / Самотовино (Московская область)",
    "country": "Россия",
    "searchString": "самотовино (московская область) россия / московская область / самотовино (московская область)"
  },
  "11898": {
    "id": "11898",
    "name": "Бемыж",
    "path": "Россия / Удмуртская Республика / Бемыж",
    "country": "Россия",
    "searchString": "бемыж россия / удмуртская республика / бемыж"
  },
  "11899": {
    "id": "11899",
    "name": "Кролевцы",
    "path": "Россия / Приморский край / Кролевцы",
    "country": "Россия",
    "searchString": "кролевцы россия / приморский край / кролевцы"
  },
  "11900": {
    "id": "11900",
    "name": "Масаловка",
    "path": "Россия / Ростовская область / Масаловка",
    "country": "Россия",
    "searchString": "масаловка россия / ростовская область / масаловка"
  },
  "11901": {
    "id": "11901",
    "name": "Чаган",
    "path": "Россия / Астраханская область / Чаган",
    "country": "Россия",
    "searchString": "чаган россия / астраханская область / чаган"
  },
  "11902": {
    "id": "11902",
    "name": "Садовый (Саратовская область)",
    "path": "Россия / Саратовская область / Садовый (Саратовская область)",
    "country": "Россия",
    "searchString": "садовый (саратовская область) россия / саратовская область / садовый (саратовская область)"
  },
  "11903": {
    "id": "11903",
    "name": "Светлый (Саратовская область)",
    "path": "Россия / Саратовская область / Светлый (Саратовская область)",
    "country": "Россия",
    "searchString": "светлый (саратовская область) россия / саратовская область / светлый (саратовская область)"
  },
  "11904": {
    "id": "11904",
    "name": "Юрловка(Саратовская область)",
    "path": "Россия / Саратовская область / Юрловка(Саратовская область)",
    "country": "Россия",
    "searchString": "юрловка(саратовская область) россия / саратовская область / юрловка(саратовская область)"
  },
  "11905": {
    "id": "11905",
    "name": "Трегубово (Новгородская область)",
    "path": "Россия / Новгородская область / Трегубово (Новгородская область)",
    "country": "Россия",
    "searchString": "трегубово (новгородская область) россия / новгородская область / трегубово (новгородская область)"
  },
  "11906": {
    "id": "11906",
    "name": "Спасская Полисть",
    "path": "Россия / Новгородская область / Спасская Полисть",
    "country": "Россия",
    "searchString": "спасская полисть россия / новгородская область / спасская полисть"
  },
  "11907": {
    "id": "11907",
    "name": "Обидимо",
    "path": "Россия / Тульская область / Обидимо",
    "country": "Россия",
    "searchString": "обидимо россия / тульская область / обидимо"
  },
  "11908": {
    "id": "11908",
    "name": "Костромское",
    "path": "Россия / Сахалинская область / Костромское",
    "country": "Россия",
    "searchString": "костромское россия / сахалинская область / костромское"
  },
  "11909": {
    "id": "11909",
    "name": "Пионеры",
    "path": "Россия / Сахалинская область / Пионеры",
    "country": "Россия",
    "searchString": "пионеры россия / сахалинская область / пионеры"
  },
  "11910": {
    "id": "11910",
    "name": "Боробул",
    "path": "Россия / Республика Саха (Якутия) / Боробул",
    "country": "Россия",
    "searchString": "боробул россия / республика саха (якутия) / боробул"
  },
  "11911": {
    "id": "11911",
    "name": "Новоалексеевка (Херсонская область)",
    "path": "Россия / Херсонская область / Новоалексеевка (Херсонская область)",
    "country": "Россия",
    "searchString": "новоалексеевка (херсонская область) россия / херсонская область / новоалексеевка (херсонская область)"
  },
  "11912": {
    "id": "11912",
    "name": "Гвардейское (Калининградская область)",
    "path": "Россия / Калининградская область / Гвардейское (Калининградская область)",
    "country": "Россия",
    "searchString": "гвардейское (калининградская область) россия / калининградская область / гвардейское (калининградская область)"
  },
  "11913": {
    "id": "11913",
    "name": "Сосновый Бор (Ульяновская область)",
    "path": "Россия / Ульяновская область / Сосновый Бор (Ульяновская область)",
    "country": "Россия",
    "searchString": "сосновый бор (ульяновская область) россия / ульяновская область / сосновый бор (ульяновская область)"
  },
  "11914": {
    "id": "11914",
    "name": "Юбилейный (Вологодская область)",
    "path": "Россия / Вологодская область / Юбилейный (Вологодская область)",
    "country": "Россия",
    "searchString": "юбилейный (вологодская область) россия / вологодская область / юбилейный (вологодская область)"
  },
  "11915": {
    "id": "11915",
    "name": "Юбилейный (Вологодская область)",
    "path": "Россия / Вологодская область / Юбилейный (Вологодская область)",
    "country": "Россия",
    "searchString": "юбилейный (вологодская область) россия / вологодская область / юбилейный (вологодская область)"
  },
  "11916": {
    "id": "11916",
    "name": "Новотазларово (Республика Башкортостан)",
    "path": "Россия / Республика Башкортостан / Новотазларово (Республика Башкортостан)",
    "country": "Россия",
    "searchString": "новотазларово (республика башкортостан) россия / республика башкортостан / новотазларово (республика башкортостан)"
  },
  "11917": {
    "id": "11917",
    "name": "Новосергиевка (Ленинградская область)",
    "path": "Россия / Ленинградская область / Новосергиевка (Ленинградская область)",
    "country": "Россия",
    "searchString": "новосергиевка (ленинградская область) россия / ленинградская область / новосергиевка (ленинградская область)"
  },
  "11918": {
    "id": "11918",
    "name": "Беной",
    "path": "Россия / Чеченская республика / Беной",
    "country": "Россия",
    "searchString": "беной россия / чеченская республика / беной"
  },
  "11919": {
    "id": "11919",
    "name": "Дарго",
    "path": "Россия / Чеченская республика / Дарго",
    "country": "Россия",
    "searchString": "дарго россия / чеченская республика / дарго"
  },
  "11920": {
    "id": "11920",
    "name": "Голубево (Калининградская область)",
    "path": "Россия / Калининградская область / Голубево (Калининградская область)",
    "country": "Россия",
    "searchString": "голубево (калининградская область) россия / калининградская область / голубево (калининградская область)"
  },
  "11921": {
    "id": "11921",
    "name": "Голубево (Калининградская область)",
    "path": "Россия / Калининградская область / Голубево (Калининградская область)",
    "country": "Россия",
    "searchString": "голубево (калининградская область) россия / калининградская область / голубево (калининградская область)"
  },
  "11922": {
    "id": "11922",
    "name": "Светлое (Калининградская область)",
    "path": "Россия / Калининградская область / Светлое (Калининградская область)",
    "country": "Россия",
    "searchString": "светлое (калининградская область) россия / калининградская область / светлое (калининградская область)"
  },
  "11923": {
    "id": "11923",
    "name": "Тюнево (Тюменская область)",
    "path": "Россия / Тюменская область / Тюнево (Тюменская область)",
    "country": "Россия",
    "searchString": "тюнево (тюменская область) россия / тюменская область / тюнево (тюменская область)"
  },
  "11924": {
    "id": "11924",
    "name": "Шатой",
    "path": "Россия / Чеченская республика / Шатой",
    "country": "Россия",
    "searchString": "шатой россия / чеченская республика / шатой"
  },
  "11925": {
    "id": "11925",
    "name": "Суховерково (Тверская область)",
    "path": "Россия / Тверская область / Суховерково (Тверская область)",
    "country": "Россия",
    "searchString": "суховерково (тверская область) россия / тверская область / суховерково (тверская область)"
  },
  "11926": {
    "id": "11926",
    "name": "Верхние Липки (Волгоградская область)",
    "path": "Россия / Волгоградская область / Верхние Липки (Волгоградская область)",
    "country": "Россия",
    "searchString": "верхние липки (волгоградская область) россия / волгоградская область / верхние липки (волгоградская область)"
  },
  "11927": {
    "id": "11927",
    "name": "Хатассы",
    "path": "Россия / Республика Саха (Якутия) / Хатассы",
    "country": "Россия",
    "searchString": "хатассы россия / республика саха (якутия) / хатассы"
  },
  "11928": {
    "id": "11928",
    "name": "Прудбой",
    "path": "Россия / Волгоградская область / Прудбой",
    "country": "Россия",
    "searchString": "прудбой россия / волгоградская область / прудбой"
  },
  "11929": {
    "id": "11929",
    "name": "Нива",
    "path": "Россия / Нижегородская область / Нива",
    "country": "Россия",
    "searchString": "нива россия / нижегородская область / нива"
  },
  "11930": {
    "id": "11930",
    "name": "Каменное (Удмуртская Республика)",
    "path": "Россия / Удмуртская Республика / Каменное (Удмуртская Республика)",
    "country": "Россия",
    "searchString": "каменное (удмуртская республика) россия / удмуртская республика / каменное (удмуртская республика)"
  },
  "11931": {
    "id": "11931",
    "name": "Чечен-Аул",
    "path": "Россия / Чеченская республика / Чечен-Аул",
    "country": "Россия",
    "searchString": "чечен-аул россия / чеченская республика / чечен-аул"
  },
  "11932": {
    "id": "11932",
    "name": "Большие Кабаны",
    "path": "Россия / Республика Татарстан / Большие Кабаны",
    "country": "Россия",
    "searchString": "большие кабаны россия / республика татарстан / большие кабаны"
  },
  "11933": {
    "id": "11933",
    "name": "Нижний Саянтуй",
    "path": "Россия / Республика Бурятия / Нижний Саянтуй",
    "country": "Россия",
    "searchString": "нижний саянтуй россия / республика бурятия / нижний саянтуй"
  },
  "11934": {
    "id": "11934",
    "name": "Малая Верейка",
    "path": "Россия / Воронежская область / Малая Верейка",
    "country": "Россия",
    "searchString": "малая верейка россия / воронежская область / малая верейка"
  },
  "11935": {
    "id": "11935",
    "name": "Малая Верейка",
    "path": "Россия / Воронежская область / Малая Верейка",
    "country": "Россия",
    "searchString": "малая верейка россия / воронежская область / малая верейка"
  },
  "11936": {
    "id": "11936",
    "name": "Беляевка (Пермский край)",
    "path": "Россия / Пермский край / Беляевка (Пермский край)",
    "country": "Россия",
    "searchString": "беляевка (пермский край) россия / пермский край / беляевка (пермский край)"
  },
  "11937": {
    "id": "11937",
    "name": "Апалиха (Саратовская область)",
    "path": "Россия / Саратовская область / Апалиха (Саратовская область)",
    "country": "Россия",
    "searchString": "апалиха (саратовская область) россия / саратовская область / апалиха (саратовская область)"
  },
  "11938": {
    "id": "11938",
    "name": "Новополеводино (Саратовская область)",
    "path": "Россия / Саратовская область / Новополеводино (Саратовская область)",
    "country": "Россия",
    "searchString": "новополеводино (саратовская область) россия / саратовская область / новополеводино (саратовская область)"
  },
  "11939": {
    "id": "11939",
    "name": "Благодатный (Кемеровская область)",
    "path": "Россия / Кемеровская область / Благодатный (Кемеровская область)",
    "country": "Россия",
    "searchString": "благодатный (кемеровская область) россия / кемеровская область / благодатный (кемеровская область)"
  },
  "11940": {
    "id": "11940",
    "name": "Берёзово (Кемеровский район)",
    "path": "Россия / Кемеровская область / Берёзово (Кемеровский район)",
    "country": "Россия",
    "searchString": "берёзово (кемеровский район) россия / кемеровская область / берёзово (кемеровский район)"
  },
  "11941": {
    "id": "11941",
    "name": "Новое (Ярославская область)",
    "path": "Россия / Ярославская область / Новое (Ярославская область)",
    "country": "Россия",
    "searchString": "новое (ярославская область) россия / ярославская область / новое (ярославская область)"
  },
  "11942": {
    "id": "11942",
    "name": "Хомяковка (Саратовская область)",
    "path": "Россия / Саратовская область / Хомяковка (Саратовская область)",
    "country": "Россия",
    "searchString": "хомяковка (саратовская область) россия / саратовская область / хомяковка (саратовская область)"
  },
  "11943": {
    "id": "11943",
    "name": "Мирный (Саратовская область)",
    "path": "Россия / Саратовская область / Мирный (Саратовская область)",
    "country": "Россия",
    "searchString": "мирный (саратовская область) россия / саратовская область / мирный (саратовская область)"
  },
  "11944": {
    "id": "11944",
    "name": "Горагорский (Чеченская республика)",
    "path": "Россия / Чеченская республика / Горагорский (Чеченская республика)",
    "country": "Россия",
    "searchString": "горагорский (чеченская республика) россия / чеченская республика / горагорский (чеченская республика)"
  },
  "11945": {
    "id": "11945",
    "name": "Федоровка (Саратовская область)",
    "path": "Россия / Саратовская область / Федоровка (Саратовская область)",
    "country": "Россия",
    "searchString": "федоровка (саратовская область) россия / саратовская область / федоровка (саратовская область)"
  },
  "11946": {
    "id": "11946",
    "name": "Прудищи (Тульская область)",
    "path": "Россия / Тульская область / Прудищи (Тульская область)",
    "country": "Россия",
    "searchString": "прудищи (тульская область) россия / тульская область / прудищи (тульская область)"
  },
  "11947": {
    "id": "11947",
    "name": "Велижаны (Тюменская область)",
    "path": "Россия / Тюменская область / Велижаны (Тюменская область)",
    "country": "Россия",
    "searchString": "велижаны (тюменская область) россия / тюменская область / велижаны (тюменская область)"
  },
  "11948": {
    "id": "11948",
    "name": "Борзой (Чеченская республика)",
    "path": "Россия / Чеченская республика / Борзой (Чеченская республика)",
    "country": "Россия",
    "searchString": "борзой (чеченская республика) россия / чеченская республика / борзой (чеченская республика)"
  },
  "11949": {
    "id": "11949",
    "name": "Итум-Кали  (Чеченская республика)",
    "path": "Россия / Чеченская республика / Итум-Кали  (Чеченская республика)",
    "country": "Россия",
    "searchString": "итум-кали  (чеченская республика) россия / чеченская республика / итум-кали  (чеченская республика)"
  },
  "11950": {
    "id": "11950",
    "name": "Куркент (Республика Дагестан)",
    "path": "Россия / Республика Дагестан / Куркент (Республика Дагестан)",
    "country": "Россия",
    "searchString": "куркент (республика дагестан) россия / республика дагестан / куркент (республика дагестан)"
  },
  "11951": {
    "id": "11951",
    "name": "Кабир (Республика Дагестан)",
    "path": "Россия / Республика Дагестан / Кабир (Республика Дагестан)",
    "country": "Россия",
    "searchString": "кабир (республика дагестан) россия / республика дагестан / кабир (республика дагестан)"
  },
  "11952": {
    "id": "11952",
    "name": "Райконкоски (Республика Карелия)",
    "path": "Россия / Республика Карелия / Райконкоски (Республика Карелия)",
    "country": "Россия",
    "searchString": "райконкоски (республика карелия) россия / республика карелия / райконкоски (республика карелия)"
  },
  "11953": {
    "id": "11953",
    "name": "Ведено (Чеченская республика)",
    "path": "Россия / Чеченская республика / Ведено (Чеченская республика)",
    "country": "Россия",
    "searchString": "ведено (чеченская республика) россия / чеченская республика / ведено (чеченская республика)"
  },
  "11954": {
    "id": "11954",
    "name": "Дышне-Ведено (Чеченская республика)",
    "path": "Россия / Чеченская республика / Дышне-Ведено (Чеченская республика)",
    "country": "Россия",
    "searchString": "дышне-ведено (чеченская республика) россия / чеченская республика / дышне-ведено (чеченская республика)"
  },
  "11955": {
    "id": "11955",
    "name": "Агишбатой (Чеченская республика)",
    "path": "Россия / Чеченская республика / Агишбатой (Чеченская республика)",
    "country": "Россия",
    "searchString": "агишбатой (чеченская республика) россия / чеченская республика / агишбатой (чеченская республика)"
  },
  "11956": {
    "id": "11956",
    "name": "Толстой-Юрт (Чеченская республика)",
    "path": "Россия / Чеченская республика / Толстой-Юрт (Чеченская республика)",
    "country": "Россия",
    "searchString": "толстой-юрт (чеченская республика) россия / чеченская республика / толстой-юрт (чеченская республика)"
  },
  "11957": {
    "id": "11957",
    "name": "Первомайск (Луганская Народная Республика)",
    "path": "Россия / Луганская Народная Республика / Первомайск (Луганская Народная Республика)",
    "country": "Россия",
    "searchString": "первомайск (луганская народная республика) россия / луганская народная республика / первомайск (луганская народная республика)"
  },
  "11958": {
    "id": "11958",
    "name": "Руэм",
    "path": "Россия / Республика Марий Эл / Руэм",
    "country": "Россия",
    "searchString": "руэм россия / республика марий эл / руэм"
  },
  "11959": {
    "id": "11959",
    "name": "Дальнее",
    "path": "Россия / Сахалинская область / Дальнее",
    "country": "Россия",
    "searchString": "дальнее россия / сахалинская область / дальнее"
  },
  "11960": {
    "id": "11960",
    "name": "Бор (Красноярский край)",
    "path": "Россия / Красноярский край / Бор (Красноярский край)",
    "country": "Россия",
    "searchString": "бор (красноярский край) россия / красноярский край / бор (красноярский край)"
  },
  "11961": {
    "id": "11961",
    "name": "Сосновка (Пензенская область)",
    "path": "Россия / Пензенская область / Сосновка (Пензенская область)",
    "country": "Россия",
    "searchString": "сосновка (пензенская область) россия / пензенская область / сосновка (пензенская область)"
  },
  "11962": {
    "id": "11962",
    "name": "Новый (Пермский край)",
    "path": "Россия / Пермский край / Новый (Пермский край)",
    "country": "Россия",
    "searchString": "новый (пермский край) россия / пермский край / новый (пермский край)"
  },
  "11963": {
    "id": "11963",
    "name": "Каргала (Оренбургская область)",
    "path": "Россия / Оренбургская область / Каргала (Оренбургская область)",
    "country": "Россия",
    "searchString": "каргала (оренбургская область) россия / оренбургская область / каргала (оренбургская область)"
  },
  "11964": {
    "id": "11964",
    "name": "Козьмодемьянск (Ярославская область)",
    "path": "Россия / Ярославская область / Козьмодемьянск (Ярославская область)",
    "country": "Россия",
    "searchString": "козьмодемьянск (ярославская область) россия / ярославская область / козьмодемьянск (ярославская область)"
  },
  "11965": {
    "id": "11965",
    "name": "Станция Падунская",
    "path": "Россия / Кемеровская область / Станция Падунская",
    "country": "Россия",
    "searchString": "станция падунская россия / кемеровская область / станция падунская"
  },
  "11966": {
    "id": "11966",
    "name": "Котово (Новгородская область)",
    "path": "Россия / Новгородская область / Котово (Новгородская область)",
    "country": "Россия",
    "searchString": "котово (новгородская область) россия / новгородская область / котово (новгородская область)"
  },
  "11967": {
    "id": "11967",
    "name": "Раздольное (Краснодарский край)",
    "path": "Россия / Краснодарский край / Раздольное (Краснодарский край)",
    "country": "Россия",
    "searchString": "раздольное (краснодарский край) россия / краснодарский край / раздольное (краснодарский край)"
  },
  "11968": {
    "id": "11968",
    "name": "Белоусово (Челябинская область)",
    "path": "Россия / Челябинская область / Белоусово (Челябинская область)",
    "country": "Россия",
    "searchString": "белоусово (челябинская область) россия / челябинская область / белоусово (челябинская область)"
  },
  "11969": {
    "id": "11969",
    "name": "Пролетарский (Владимирская область)",
    "path": "Россия / Владимирская область / Пролетарский (Владимирская область)",
    "country": "Россия",
    "searchString": "пролетарский (владимирская область) россия / владимирская область / пролетарский (владимирская область)"
  },
  "11970": {
    "id": "11970",
    "name": "Майский (Тульская область)",
    "path": "Россия / Тульская область / Майский (Тульская область)",
    "country": "Россия",
    "searchString": "майский (тульская область) россия / тульская область / майский (тульская область)"
  },
  "11971": {
    "id": "11971",
    "name": "Скуратовский (Тульская область)",
    "path": "Россия / Тульская область / Скуратовский (Тульская область)",
    "country": "Россия",
    "searchString": "скуратовский (тульская область) россия / тульская область / скуратовский (тульская область)"
  },
  "11972": {
    "id": "11972",
    "name": "Восток (Сахалинская область)",
    "path": "Россия / Сахалинская область / Восток (Сахалинская область)",
    "country": "Россия",
    "searchString": "восток (сахалинская область) россия / сахалинская область / восток (сахалинская область)"
  },
  "11973": {
    "id": "11973",
    "name": "село имени Полины Осипенко",
    "path": "Россия / Хабаровский край / село имени Полины Осипенко",
    "country": "Россия",
    "searchString": "село имени полины осипенко россия / хабаровский край / село имени полины осипенко"
  },
  "11974": {
    "id": "11974",
    "name": "Победа (Омская область)",
    "path": "Россия / Омская область / Победа (Омская область)",
    "country": "Россия",
    "searchString": "победа (омская область) россия / омская область / победа (омская область)"
  },
  "11975": {
    "id": "11975",
    "name": "Алексеевка (Омская область)",
    "path": "Россия / Омская область / Алексеевка (Омская область)",
    "country": "Россия",
    "searchString": "алексеевка (омская область) россия / омская область / алексеевка (омская область)"
  },
  "11976": {
    "id": "11976",
    "name": "Ключи (Омская область)",
    "path": "Россия / Омская область / Ключи (Омская область)",
    "country": "Россия",
    "searchString": "ключи (омская область) россия / омская область / ключи (омская область)"
  },
  "11977": {
    "id": "11977",
    "name": "Орехово (Омская область)",
    "path": "Россия / Омская область / Орехово (Омская область)",
    "country": "Россия",
    "searchString": "орехово (омская область) россия / омская область / орехово (омская область)"
  },
  "11978": {
    "id": "11978",
    "name": "Новый (Республика Татарстан)",
    "path": "Россия / Республика Татарстан / Новый (Республика Татарстан)",
    "country": "Россия",
    "searchString": "новый (республика татарстан) россия / республика татарстан / новый (республика татарстан)"
  },
  "11979": {
    "id": "11979",
    "name": "Молодёжный (Иркутская область)",
    "path": "Россия / Иркутская область / Молодёжный (Иркутская область)",
    "country": "Россия",
    "searchString": "молодёжный (иркутская область) россия / иркутская область / молодёжный (иркутская область)"
  },
  "11980": {
    "id": "11980",
    "name": "Молодёжный (Иркутская область)",
    "path": "Россия / Иркутская область / Молодёжный (Иркутская область)",
    "country": "Россия",
    "searchString": "молодёжный (иркутская область) россия / иркутская область / молодёжный (иркутская область)"
  },
  "11981": {
    "id": "11981",
    "name": "Нижегородка",
    "path": "Россия / Республика Башкортостан / Нижегородка",
    "country": "Россия",
    "searchString": "нижегородка россия / республика башкортостан / нижегородка"
  },
  "11982": {
    "id": "11982",
    "name": "Красный Бор (Ярославская область)",
    "path": "Россия / Ярославская область / Красный Бор (Ярославская область)",
    "country": "Россия",
    "searchString": "красный бор (ярославская область) россия / ярославская область / красный бор (ярославская область)"
  },
  "11983": {
    "id": "11983",
    "name": "Маслова (Курская область)",
    "path": "Россия / Курская область / Маслова (Курская область)",
    "country": "Россия",
    "searchString": "маслова (курская область) россия / курская область / маслова (курская область)"
  },
  "11984": {
    "id": "11984",
    "name": "Жуков Луг (Минский район)",
    "path": "Беларусь / Минская область / Жуков Луг (Минский район)",
    "country": "Беларусь",
    "searchString": "жуков луг (минский район) беларусь / минская область / жуков луг (минский район)"
  },
  "11985": {
    "id": "11985",
    "name": "Приморский (Самарская область)",
    "path": "Россия / Самарская область / Приморский (Самарская область)",
    "country": "Россия",
    "searchString": "приморский (самарская область) россия / самарская область / приморский (самарская область)"
  },
  "11986": {
    "id": "11986",
    "name": "Волна",
    "path": "Россия / Краснодарский край / Волна",
    "country": "Россия",
    "searchString": "волна россия / краснодарский край / волна"
  },
  "11987": {
    "id": "11987",
    "name": "Гать",
    "path": "Россия / Орловская область / Гать",
    "country": "Россия",
    "searchString": "гать россия / орловская область / гать"
  },
  "11988": {
    "id": "11988",
    "name": "Новый Рычан (Астраханская область)",
    "path": "Россия / Астраханская область / Новый Рычан (Астраханская область)",
    "country": "Россия",
    "searchString": "новый рычан (астраханская область) россия / астраханская область / новый рычан (астраханская область)"
  }
};

// Type for city object
export interface City {
  id: string;
  name: string;
  path: string;
  country: string;
  searchString: string;
}

// Helper function for searching
export function searchCities(query: string, limit = 50): City[] {
  if (!query || query.length < 1) return [];

  const searchTerm = query.toLowerCase();
  const results: City[] = [];

  // Region keywords to exclude
  const regionKeywords = [
    'область', 'край', 'республика', 'округ', 'автономная область',
    'автономный округ', 'АО'
  ];

  const citiesTyped = HH_CITIES as Record<string, City>;

  for (const id in citiesTyped) {
    const city = citiesTyped[id];

    // Skip regions - check if name contains region keywords AND has only one "/" in path
    const slashCount = (city.path.match(/\//g) || []).length;
    if (slashCount === 1) { // Only one "/" means 2 parts (e.g., "Россия / Московская область")
      const nameLower = city.name.toLowerCase();
      const isRegion = regionKeywords.some(keyword => nameLower.includes(keyword));
      if (isRegion) {
        continue; // Skip regions
      }
    }

    if (city.searchString.includes(searchTerm)) {
      results.push(city);
      if (results.length >= limit) break;
    }
  }

  // Sort by relevance (exact match first, then by position in string)
  results.sort((a, b) => {
    const aExact = a.name.toLowerCase() === searchTerm;
    const bExact = b.name.toLowerCase() === searchTerm;
    if (aExact && !bExact) return -1;
    if (!aExact && bExact) return 1;

    const aIndex = a.searchString.indexOf(searchTerm);
    const bIndex = b.searchString.indexOf(searchTerm);
    return aIndex - bIndex;
  });

  return results;
}

// Get city by ID
export function getCityById(id: string | number): City | null {
  const citiesTyped = HH_CITIES as Record<string, City>;
  return citiesTyped[String(id)] || null;
}

// Get city ID by name (case-insensitive)
export function getCityIdByName(name: string): string | null {
  if (!name) return null;
  const nameLower = name.toLowerCase().trim();
  const citiesTyped = HH_CITIES as Record<string, City>;

  for (const id in citiesTyped) {
    if (citiesTyped[id].name.toLowerCase() === nameLower) {
      return id;
    }
  }
  return null;
}

// Get multiple cities by IDs
export function getCitiesByIds(ids: (string | number)[]): City[] {
  // Region keywords to exclude
  const regionKeywords = [
    'область', 'край', 'республика', 'округ', 'автономная область',
    'автономный округ', 'АО'
  ];

  const citiesTyped = HH_CITIES as Record<string, City>;

  return ids.map(id => citiesTyped[String(id)]).filter((city): city is City => {
    if (!city) return false;

    // Skip regions - check if name contains region keywords AND has only one "/" in path
    const slashCount = (city.path.match(/\//g) || []).length;
    if (slashCount === 1) { // Only one "/" means 2 parts (e.g., "Россия / Московская область")
      const nameLower = city.name.toLowerCase();
      const isRegion = regionKeywords.some(keyword => nameLower.includes(keyword));
      if (isRegion) {
        return false; // Skip regions
      }
    }

    return true;
  });
}

// Popular cities for quick access
export const POPULAR_CITIES = [
  { id: "1", name: "Москва" },
  { id: "2", name: "Санкт-Петербург" },
  { id: "3", name: "Екатеринбург" },
  { id: "4", name: "Новосибирск" },
  { id: "88", name: "Казань" },
  { id: "66", name: "Нижний Новгород" },
  { id: "104", name: "Челябинск" },
  { id: "68", name: "Омск" },
  { id: "78", name: "Самара" },
  { id: "76", name: "Ростов-на-Дону" },
  { id: "99", name: "Уфа" },
  { id: "54", name: "Красноярск" },
  { id: "72", name: "Пермь" },
  { id: "26", name: "Воронеж" },
  { id: "24", name: "Волгоград" }
];
